/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.common = (function() {

    /**
     * Namespace common.
     * @exports common
     * @namespace
     */
    var common = {};

    /**
     * SqlTier enum.
     * @name common.SqlTier
     * @enum {number}
     * @property {number} None=0 None value
     * @property {number} Zoom=1 Zoom value
     * @property {number} Small=2 Small value
     * @property {number} Medium=3 Medium value
     * @property {number} Large=4 Large value
     * @property {number} XLarge=5 XLarge value
     * @property {number} Enterprise=6 Enterprise value
     */
    common.SqlTier = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "None"] = 0;
        values[valuesById[1] = "Zoom"] = 1;
        values[valuesById[2] = "Small"] = 2;
        values[valuesById[3] = "Medium"] = 3;
        values[valuesById[4] = "Large"] = 4;
        values[valuesById[5] = "XLarge"] = 5;
        values[valuesById[6] = "Enterprise"] = 6;
        return values;
    })();

    common.AdditionalProperties = (function() {

        /**
         * Properties of an AdditionalProperties.
         * @memberof common
         * @interface IAdditionalProperties
         * @property {string|null} [TenantID] AdditionalProperties TenantID
         * @property {string|null} [Tabulaini] AdditionalProperties Tabulaini
         * @property {string|null} [Dname] AdditionalProperties Dname
         * @property {number|Long|null} [Language] AdditionalProperties Language
         * @property {boolean|null} [Debug] AdditionalProperties Debug
         * @property {string|null} [Userlogin] AdditionalProperties Userlogin
         */

        /**
         * Constructs a new AdditionalProperties.
         * @memberof common
         * @classdesc Represents an AdditionalProperties.
         * @implements IAdditionalProperties
         * @constructor
         * @param {common.IAdditionalProperties=} [properties] Properties to set
         */
        function AdditionalProperties(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * AdditionalProperties TenantID.
         * @member {string} TenantID
         * @memberof common.AdditionalProperties
         * @instance
         */
        AdditionalProperties.prototype.TenantID = "";

        /**
         * AdditionalProperties Tabulaini.
         * @member {string} Tabulaini
         * @memberof common.AdditionalProperties
         * @instance
         */
        AdditionalProperties.prototype.Tabulaini = "";

        /**
         * AdditionalProperties Dname.
         * @member {string} Dname
         * @memberof common.AdditionalProperties
         * @instance
         */
        AdditionalProperties.prototype.Dname = "";

        /**
         * AdditionalProperties Language.
         * @member {number|Long} Language
         * @memberof common.AdditionalProperties
         * @instance
         */
        AdditionalProperties.prototype.Language = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * AdditionalProperties Debug.
         * @member {boolean} Debug
         * @memberof common.AdditionalProperties
         * @instance
         */
        AdditionalProperties.prototype.Debug = false;

        /**
         * AdditionalProperties Userlogin.
         * @member {string} Userlogin
         * @memberof common.AdditionalProperties
         * @instance
         */
        AdditionalProperties.prototype.Userlogin = "";

        /**
         * Creates a new AdditionalProperties instance using the specified properties.
         * @function create
         * @memberof common.AdditionalProperties
         * @static
         * @param {common.IAdditionalProperties=} [properties] Properties to set
         * @returns {common.AdditionalProperties} AdditionalProperties instance
         */
        AdditionalProperties.create = function create(properties) {
            return new AdditionalProperties(properties);
        };

        /**
         * Encodes the specified AdditionalProperties message. Does not implicitly {@link common.AdditionalProperties.verify|verify} messages.
         * @function encode
         * @memberof common.AdditionalProperties
         * @static
         * @param {common.IAdditionalProperties} message AdditionalProperties message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdditionalProperties.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TenantID != null && Object.hasOwnProperty.call(message, "TenantID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.TenantID);
            if (message.Tabulaini != null && Object.hasOwnProperty.call(message, "Tabulaini"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Tabulaini);
            if (message.Dname != null && Object.hasOwnProperty.call(message, "Dname"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Dname);
            if (message.Language != null && Object.hasOwnProperty.call(message, "Language"))
                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.Language);
            if (message.Debug != null && Object.hasOwnProperty.call(message, "Debug"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.Debug);
            if (message.Userlogin != null && Object.hasOwnProperty.call(message, "Userlogin"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Userlogin);
            return writer;
        };

        /**
         * Encodes the specified AdditionalProperties message, length delimited. Does not implicitly {@link common.AdditionalProperties.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.AdditionalProperties
         * @static
         * @param {common.IAdditionalProperties} message AdditionalProperties message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        AdditionalProperties.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an AdditionalProperties message from the specified reader or buffer.
         * @function decode
         * @memberof common.AdditionalProperties
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.AdditionalProperties} AdditionalProperties
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdditionalProperties.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.AdditionalProperties();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TenantID = reader.string();
                    break;
                case 2:
                    message.Tabulaini = reader.string();
                    break;
                case 3:
                    message.Dname = reader.string();
                    break;
                case 4:
                    message.Language = reader.int64();
                    break;
                case 5:
                    message.Debug = reader.bool();
                    break;
                case 6:
                    message.Userlogin = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an AdditionalProperties message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.AdditionalProperties
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.AdditionalProperties} AdditionalProperties
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        AdditionalProperties.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an AdditionalProperties message.
         * @function verify
         * @memberof common.AdditionalProperties
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        AdditionalProperties.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                if (!$util.isString(message.TenantID))
                    return "TenantID: string expected";
            if (message.Tabulaini != null && message.hasOwnProperty("Tabulaini"))
                if (!$util.isString(message.Tabulaini))
                    return "Tabulaini: string expected";
            if (message.Dname != null && message.hasOwnProperty("Dname"))
                if (!$util.isString(message.Dname))
                    return "Dname: string expected";
            if (message.Language != null && message.hasOwnProperty("Language"))
                if (!$util.isInteger(message.Language) && !(message.Language && $util.isInteger(message.Language.low) && $util.isInteger(message.Language.high)))
                    return "Language: integer|Long expected";
            if (message.Debug != null && message.hasOwnProperty("Debug"))
                if (typeof message.Debug !== "boolean")
                    return "Debug: boolean expected";
            if (message.Userlogin != null && message.hasOwnProperty("Userlogin"))
                if (!$util.isString(message.Userlogin))
                    return "Userlogin: string expected";
            return null;
        };

        /**
         * Creates an AdditionalProperties message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.AdditionalProperties
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.AdditionalProperties} AdditionalProperties
         */
        AdditionalProperties.fromObject = function fromObject(object) {
            if (object instanceof $root.common.AdditionalProperties)
                return object;
            var message = new $root.common.AdditionalProperties();
            if (object.TenantID != null)
                message.TenantID = String(object.TenantID);
            if (object.Tabulaini != null)
                message.Tabulaini = String(object.Tabulaini);
            if (object.Dname != null)
                message.Dname = String(object.Dname);
            if (object.Language != null)
                if ($util.Long)
                    (message.Language = $util.Long.fromValue(object.Language)).unsigned = false;
                else if (typeof object.Language === "string")
                    message.Language = parseInt(object.Language, 10);
                else if (typeof object.Language === "number")
                    message.Language = object.Language;
                else if (typeof object.Language === "object")
                    message.Language = new $util.LongBits(object.Language.low >>> 0, object.Language.high >>> 0).toNumber();
            if (object.Debug != null)
                message.Debug = Boolean(object.Debug);
            if (object.Userlogin != null)
                message.Userlogin = String(object.Userlogin);
            return message;
        };

        /**
         * Creates a plain object from an AdditionalProperties message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.AdditionalProperties
         * @static
         * @param {common.AdditionalProperties} message AdditionalProperties
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        AdditionalProperties.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.TenantID = "";
                object.Tabulaini = "";
                object.Dname = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.Language = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Language = options.longs === String ? "0" : 0;
                object.Debug = false;
                object.Userlogin = "";
            }
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                object.TenantID = message.TenantID;
            if (message.Tabulaini != null && message.hasOwnProperty("Tabulaini"))
                object.Tabulaini = message.Tabulaini;
            if (message.Dname != null && message.hasOwnProperty("Dname"))
                object.Dname = message.Dname;
            if (message.Language != null && message.hasOwnProperty("Language"))
                if (typeof message.Language === "number")
                    object.Language = options.longs === String ? String(message.Language) : message.Language;
                else
                    object.Language = options.longs === String ? $util.Long.prototype.toString.call(message.Language) : options.longs === Number ? new $util.LongBits(message.Language.low >>> 0, message.Language.high >>> 0).toNumber() : message.Language;
            if (message.Debug != null && message.hasOwnProperty("Debug"))
                object.Debug = message.Debug;
            if (message.Userlogin != null && message.hasOwnProperty("Userlogin"))
                object.Userlogin = message.Userlogin;
            return object;
        };

        /**
         * Converts this AdditionalProperties to JSON.
         * @function toJSON
         * @memberof common.AdditionalProperties
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        AdditionalProperties.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AdditionalProperties;
    })();

    common.Bool = (function() {

        /**
         * Properties of a Bool.
         * @memberof common
         * @interface IBool
         * @property {boolean|null} [Value] Bool Value
         */

        /**
         * Constructs a new Bool.
         * @memberof common
         * @classdesc Represents a Bool.
         * @implements IBool
         * @constructor
         * @param {common.IBool=} [properties] Properties to set
         */
        function Bool(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Bool Value.
         * @member {boolean} Value
         * @memberof common.Bool
         * @instance
         */
        Bool.prototype.Value = false;

        /**
         * Creates a new Bool instance using the specified properties.
         * @function create
         * @memberof common.Bool
         * @static
         * @param {common.IBool=} [properties] Properties to set
         * @returns {common.Bool} Bool instance
         */
        Bool.create = function create(properties) {
            return new Bool(properties);
        };

        /**
         * Encodes the specified Bool message. Does not implicitly {@link common.Bool.verify|verify} messages.
         * @function encode
         * @memberof common.Bool
         * @static
         * @param {common.IBool} message Bool message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Bool.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Value);
            return writer;
        };

        /**
         * Encodes the specified Bool message, length delimited. Does not implicitly {@link common.Bool.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Bool
         * @static
         * @param {common.IBool} message Bool message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Bool.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Bool message from the specified reader or buffer.
         * @function decode
         * @memberof common.Bool
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Bool} Bool
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Bool.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Bool();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Value = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Bool message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Bool
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Bool} Bool
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Bool.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Bool message.
         * @function verify
         * @memberof common.Bool
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Bool.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Value != null && message.hasOwnProperty("Value"))
                if (typeof message.Value !== "boolean")
                    return "Value: boolean expected";
            return null;
        };

        /**
         * Creates a Bool message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Bool
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Bool} Bool
         */
        Bool.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Bool)
                return object;
            var message = new $root.common.Bool();
            if (object.Value != null)
                message.Value = Boolean(object.Value);
            return message;
        };

        /**
         * Creates a plain object from a Bool message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Bool
         * @static
         * @param {common.Bool} message Bool
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Bool.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.Value = false;
            if (message.Value != null && message.hasOwnProperty("Value"))
                object.Value = message.Value;
            return object;
        };

        /**
         * Converts this Bool to JSON.
         * @function toJSON
         * @memberof common.Bool
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Bool.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Bool;
    })();

    common.String = (function() {

        /**
         * Properties of a String.
         * @memberof common
         * @interface IString
         * @property {string|null} [Value] String Value
         */

        /**
         * Constructs a new String.
         * @memberof common
         * @classdesc Represents a String.
         * @implements IString
         * @constructor
         * @param {common.IString=} [properties] Properties to set
         */
        function String(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * String Value.
         * @member {string} Value
         * @memberof common.String
         * @instance
         */
        String.prototype.Value = "";

        /**
         * Creates a new String instance using the specified properties.
         * @function create
         * @memberof common.String
         * @static
         * @param {common.IString=} [properties] Properties to set
         * @returns {common.String} String instance
         */
        String.create = function create(properties) {
            return new String(properties);
        };

        /**
         * Encodes the specified String message. Does not implicitly {@link common.String.verify|verify} messages.
         * @function encode
         * @memberof common.String
         * @static
         * @param {common.IString} message String message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        String.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Value);
            return writer;
        };

        /**
         * Encodes the specified String message, length delimited. Does not implicitly {@link common.String.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.String
         * @static
         * @param {common.IString} message String message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        String.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a String message from the specified reader or buffer.
         * @function decode
         * @memberof common.String
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.String} String
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        String.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.String();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a String message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.String
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.String} String
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        String.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a String message.
         * @function verify
         * @memberof common.String
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        String.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Value != null && message.hasOwnProperty("Value"))
                if (!$util.isString(message.Value))
                    return "Value: string expected";
            return null;
        };

        /**
         * Creates a String message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.String
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.String} String
         */
        String.fromObject = function fromObject(object) {
            if (object instanceof $root.common.String)
                return object;
            var message = new $root.common.String();
            if (object.Value != null)
                message.Value = String(object.Value);
            return message;
        };

        /**
         * Creates a plain object from a String message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.String
         * @static
         * @param {common.String} message String
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        String.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.Value = "";
            if (message.Value != null && message.hasOwnProperty("Value"))
                object.Value = message.Value;
            return object;
        };

        /**
         * Converts this String to JSON.
         * @function toJSON
         * @memberof common.String
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        String.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return String;
    })();

    common.Strings = (function() {

        /**
         * Properties of a Strings.
         * @memberof common
         * @interface IStrings
         * @property {Array.<string>|null} [Values] Strings Values
         */

        /**
         * Constructs a new Strings.
         * @memberof common
         * @classdesc Represents a Strings.
         * @implements IStrings
         * @constructor
         * @param {common.IStrings=} [properties] Properties to set
         */
        function Strings(properties) {
            this.Values = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Strings Values.
         * @member {Array.<string>} Values
         * @memberof common.Strings
         * @instance
         */
        Strings.prototype.Values = $util.emptyArray;

        /**
         * Creates a new Strings instance using the specified properties.
         * @function create
         * @memberof common.Strings
         * @static
         * @param {common.IStrings=} [properties] Properties to set
         * @returns {common.Strings} Strings instance
         */
        Strings.create = function create(properties) {
            return new Strings(properties);
        };

        /**
         * Encodes the specified Strings message. Does not implicitly {@link common.Strings.verify|verify} messages.
         * @function encode
         * @memberof common.Strings
         * @static
         * @param {common.IStrings} message Strings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Strings.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Values != null && message.Values.length)
                for (var i = 0; i < message.Values.length; ++i)
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.Values[i]);
            return writer;
        };

        /**
         * Encodes the specified Strings message, length delimited. Does not implicitly {@link common.Strings.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Strings
         * @static
         * @param {common.IStrings} message Strings message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Strings.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Strings message from the specified reader or buffer.
         * @function decode
         * @memberof common.Strings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Strings} Strings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Strings.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Strings();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Values && message.Values.length))
                        message.Values = [];
                    message.Values.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Strings message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Strings
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Strings} Strings
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Strings.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Strings message.
         * @function verify
         * @memberof common.Strings
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Strings.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Values != null && message.hasOwnProperty("Values")) {
                if (!Array.isArray(message.Values))
                    return "Values: array expected";
                for (var i = 0; i < message.Values.length; ++i)
                    if (!$util.isString(message.Values[i]))
                        return "Values: string[] expected";
            }
            return null;
        };

        /**
         * Creates a Strings message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Strings
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Strings} Strings
         */
        Strings.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Strings)
                return object;
            var message = new $root.common.Strings();
            if (object.Values) {
                if (!Array.isArray(object.Values))
                    throw TypeError(".common.Strings.Values: array expected");
                message.Values = [];
                for (var i = 0; i < object.Values.length; ++i)
                    message.Values[i] = String(object.Values[i]);
            }
            return message;
        };

        /**
         * Creates a plain object from a Strings message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Strings
         * @static
         * @param {common.Strings} message Strings
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Strings.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.Values = [];
            if (message.Values && message.Values.length) {
                object.Values = [];
                for (var j = 0; j < message.Values.length; ++j)
                    object.Values[j] = message.Values[j];
            }
            return object;
        };

        /**
         * Converts this Strings to JSON.
         * @function toJSON
         * @memberof common.Strings
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Strings.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Strings;
    })();

    common.Empty = (function() {

        /**
         * Properties of an Empty.
         * @memberof common
         * @interface IEmpty
         */

        /**
         * Constructs a new Empty.
         * @memberof common
         * @classdesc Represents an Empty.
         * @implements IEmpty
         * @constructor
         * @param {common.IEmpty=} [properties] Properties to set
         */
        function Empty(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Empty instance using the specified properties.
         * @function create
         * @memberof common.Empty
         * @static
         * @param {common.IEmpty=} [properties] Properties to set
         * @returns {common.Empty} Empty instance
         */
        Empty.create = function create(properties) {
            return new Empty(properties);
        };

        /**
         * Encodes the specified Empty message. Does not implicitly {@link common.Empty.verify|verify} messages.
         * @function encode
         * @memberof common.Empty
         * @static
         * @param {common.IEmpty} message Empty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Empty.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified Empty message, length delimited. Does not implicitly {@link common.Empty.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Empty
         * @static
         * @param {common.IEmpty} message Empty message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Empty.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an Empty message from the specified reader or buffer.
         * @function decode
         * @memberof common.Empty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Empty} Empty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Empty.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Empty();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an Empty message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Empty
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Empty} Empty
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Empty.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an Empty message.
         * @function verify
         * @memberof common.Empty
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Empty.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates an Empty message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Empty
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Empty} Empty
         */
        Empty.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Empty)
                return object;
            return new $root.common.Empty();
        };

        /**
         * Creates a plain object from an Empty message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Empty
         * @static
         * @param {common.Empty} message Empty
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Empty.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this Empty to JSON.
         * @function toJSON
         * @memberof common.Empty
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Empty.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Empty;
    })();

    common.TimeOfDay = (function() {

        /**
         * Properties of a TimeOfDay.
         * @memberof common
         * @interface ITimeOfDay
         * @property {number|null} [hours] TimeOfDay hours
         * @property {number|null} [minutes] TimeOfDay minutes
         * @property {number|null} [seconds] TimeOfDay seconds
         */

        /**
         * Constructs a new TimeOfDay.
         * @memberof common
         * @classdesc Represents a TimeOfDay.
         * @implements ITimeOfDay
         * @constructor
         * @param {common.ITimeOfDay=} [properties] Properties to set
         */
        function TimeOfDay(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TimeOfDay hours.
         * @member {number} hours
         * @memberof common.TimeOfDay
         * @instance
         */
        TimeOfDay.prototype.hours = 0;

        /**
         * TimeOfDay minutes.
         * @member {number} minutes
         * @memberof common.TimeOfDay
         * @instance
         */
        TimeOfDay.prototype.minutes = 0;

        /**
         * TimeOfDay seconds.
         * @member {number} seconds
         * @memberof common.TimeOfDay
         * @instance
         */
        TimeOfDay.prototype.seconds = 0;

        /**
         * Creates a new TimeOfDay instance using the specified properties.
         * @function create
         * @memberof common.TimeOfDay
         * @static
         * @param {common.ITimeOfDay=} [properties] Properties to set
         * @returns {common.TimeOfDay} TimeOfDay instance
         */
        TimeOfDay.create = function create(properties) {
            return new TimeOfDay(properties);
        };

        /**
         * Encodes the specified TimeOfDay message. Does not implicitly {@link common.TimeOfDay.verify|verify} messages.
         * @function encode
         * @memberof common.TimeOfDay
         * @static
         * @param {common.ITimeOfDay} message TimeOfDay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeOfDay.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.hours != null && Object.hasOwnProperty.call(message, "hours"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.hours);
            if (message.minutes != null && Object.hasOwnProperty.call(message, "minutes"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minutes);
            if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.seconds);
            return writer;
        };

        /**
         * Encodes the specified TimeOfDay message, length delimited. Does not implicitly {@link common.TimeOfDay.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.TimeOfDay
         * @static
         * @param {common.ITimeOfDay} message TimeOfDay message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TimeOfDay.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TimeOfDay message from the specified reader or buffer.
         * @function decode
         * @memberof common.TimeOfDay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.TimeOfDay} TimeOfDay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeOfDay.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.TimeOfDay();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.hours = reader.int32();
                    break;
                case 2:
                    message.minutes = reader.int32();
                    break;
                case 3:
                    message.seconds = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TimeOfDay message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.TimeOfDay
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.TimeOfDay} TimeOfDay
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TimeOfDay.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TimeOfDay message.
         * @function verify
         * @memberof common.TimeOfDay
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TimeOfDay.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.hours != null && message.hasOwnProperty("hours"))
                if (!$util.isInteger(message.hours))
                    return "hours: integer expected";
            if (message.minutes != null && message.hasOwnProperty("minutes"))
                if (!$util.isInteger(message.minutes))
                    return "minutes: integer expected";
            if (message.seconds != null && message.hasOwnProperty("seconds"))
                if (!$util.isInteger(message.seconds))
                    return "seconds: integer expected";
            return null;
        };

        /**
         * Creates a TimeOfDay message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.TimeOfDay
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.TimeOfDay} TimeOfDay
         */
        TimeOfDay.fromObject = function fromObject(object) {
            if (object instanceof $root.common.TimeOfDay)
                return object;
            var message = new $root.common.TimeOfDay();
            if (object.hours != null)
                message.hours = object.hours | 0;
            if (object.minutes != null)
                message.minutes = object.minutes | 0;
            if (object.seconds != null)
                message.seconds = object.seconds | 0;
            return message;
        };

        /**
         * Creates a plain object from a TimeOfDay message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.TimeOfDay
         * @static
         * @param {common.TimeOfDay} message TimeOfDay
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TimeOfDay.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.hours = 0;
                object.minutes = 0;
                object.seconds = 0;
            }
            if (message.hours != null && message.hasOwnProperty("hours"))
                object.hours = message.hours;
            if (message.minutes != null && message.hasOwnProperty("minutes"))
                object.minutes = message.minutes;
            if (message.seconds != null && message.hasOwnProperty("seconds"))
                object.seconds = message.seconds;
            return object;
        };

        /**
         * Converts this TimeOfDay to JSON.
         * @function toJSON
         * @memberof common.TimeOfDay
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TimeOfDay.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TimeOfDay;
    })();

    common.Date = (function() {

        /**
         * Properties of a Date.
         * @memberof common
         * @interface IDate
         * @property {number|null} [year] Date year
         * @property {number|null} [month] Date month
         * @property {number|null} [day] Date day
         */

        /**
         * Constructs a new Date.
         * @memberof common
         * @classdesc Represents a Date.
         * @implements IDate
         * @constructor
         * @param {common.IDate=} [properties] Properties to set
         */
        function Date(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Date year.
         * @member {number} year
         * @memberof common.Date
         * @instance
         */
        Date.prototype.year = 0;

        /**
         * Date month.
         * @member {number} month
         * @memberof common.Date
         * @instance
         */
        Date.prototype.month = 0;

        /**
         * Date day.
         * @member {number} day
         * @memberof common.Date
         * @instance
         */
        Date.prototype.day = 0;

        /**
         * Creates a new Date instance using the specified properties.
         * @function create
         * @memberof common.Date
         * @static
         * @param {common.IDate=} [properties] Properties to set
         * @returns {common.Date} Date instance
         */
        Date.create = function create(properties) {
            return new Date(properties);
        };

        /**
         * Encodes the specified Date message. Does not implicitly {@link common.Date.verify|verify} messages.
         * @function encode
         * @memberof common.Date
         * @static
         * @param {common.IDate} message Date message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Date.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
            if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
            if (message.day != null && Object.hasOwnProperty.call(message, "day"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.day);
            return writer;
        };

        /**
         * Encodes the specified Date message, length delimited. Does not implicitly {@link common.Date.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Date
         * @static
         * @param {common.IDate} message Date message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Date.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Date message from the specified reader or buffer.
         * @function decode
         * @memberof common.Date
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Date} Date
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Date.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Date();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.year = reader.int32();
                    break;
                case 2:
                    message.month = reader.int32();
                    break;
                case 3:
                    message.day = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Date message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Date
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Date} Date
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Date.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Date message.
         * @function verify
         * @memberof common.Date
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Date.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.year != null && message.hasOwnProperty("year"))
                if (!$util.isInteger(message.year))
                    return "year: integer expected";
            if (message.month != null && message.hasOwnProperty("month"))
                if (!$util.isInteger(message.month))
                    return "month: integer expected";
            if (message.day != null && message.hasOwnProperty("day"))
                if (!$util.isInteger(message.day))
                    return "day: integer expected";
            return null;
        };

        /**
         * Creates a Date message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Date
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Date} Date
         */
        Date.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Date)
                return object;
            var message = new $root.common.Date();
            if (object.year != null)
                message.year = object.year | 0;
            if (object.month != null)
                message.month = object.month | 0;
            if (object.day != null)
                message.day = object.day | 0;
            return message;
        };

        /**
         * Creates a plain object from a Date message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Date
         * @static
         * @param {common.Date} message Date
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Date.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.year = 0;
                object.month = 0;
                object.day = 0;
            }
            if (message.year != null && message.hasOwnProperty("year"))
                object.year = message.year;
            if (message.month != null && message.hasOwnProperty("month"))
                object.month = message.month;
            if (message.day != null && message.hasOwnProperty("day"))
                object.day = message.day;
            return object;
        };

        /**
         * Converts this Date to JSON.
         * @function toJSON
         * @memberof common.Date
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Date.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Date;
    })();

    common.DateTime = (function() {

        /**
         * Properties of a DateTime.
         * @memberof common
         * @interface IDateTime
         * @property {number|null} [year] DateTime year
         * @property {number|null} [month] DateTime month
         * @property {number|null} [day] DateTime day
         * @property {number|null} [hours] DateTime hours
         * @property {number|null} [minutes] DateTime minutes
         * @property {number|null} [seconds] DateTime seconds
         */

        /**
         * Constructs a new DateTime.
         * @memberof common
         * @classdesc Represents a DateTime.
         * @implements IDateTime
         * @constructor
         * @param {common.IDateTime=} [properties] Properties to set
         */
        function DateTime(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DateTime year.
         * @member {number} year
         * @memberof common.DateTime
         * @instance
         */
        DateTime.prototype.year = 0;

        /**
         * DateTime month.
         * @member {number} month
         * @memberof common.DateTime
         * @instance
         */
        DateTime.prototype.month = 0;

        /**
         * DateTime day.
         * @member {number} day
         * @memberof common.DateTime
         * @instance
         */
        DateTime.prototype.day = 0;

        /**
         * DateTime hours.
         * @member {number} hours
         * @memberof common.DateTime
         * @instance
         */
        DateTime.prototype.hours = 0;

        /**
         * DateTime minutes.
         * @member {number} minutes
         * @memberof common.DateTime
         * @instance
         */
        DateTime.prototype.minutes = 0;

        /**
         * DateTime seconds.
         * @member {number} seconds
         * @memberof common.DateTime
         * @instance
         */
        DateTime.prototype.seconds = 0;

        /**
         * Creates a new DateTime instance using the specified properties.
         * @function create
         * @memberof common.DateTime
         * @static
         * @param {common.IDateTime=} [properties] Properties to set
         * @returns {common.DateTime} DateTime instance
         */
        DateTime.create = function create(properties) {
            return new DateTime(properties);
        };

        /**
         * Encodes the specified DateTime message. Does not implicitly {@link common.DateTime.verify|verify} messages.
         * @function encode
         * @memberof common.DateTime
         * @static
         * @param {common.IDateTime} message DateTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DateTime.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.year);
            if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.month);
            if (message.day != null && Object.hasOwnProperty.call(message, "day"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.day);
            if (message.hours != null && Object.hasOwnProperty.call(message, "hours"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.hours);
            if (message.minutes != null && Object.hasOwnProperty.call(message, "minutes"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.minutes);
            if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.seconds);
            return writer;
        };

        /**
         * Encodes the specified DateTime message, length delimited. Does not implicitly {@link common.DateTime.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.DateTime
         * @static
         * @param {common.IDateTime} message DateTime message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DateTime.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DateTime message from the specified reader or buffer.
         * @function decode
         * @memberof common.DateTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.DateTime} DateTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DateTime.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.DateTime();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.year = reader.int32();
                    break;
                case 2:
                    message.month = reader.int32();
                    break;
                case 3:
                    message.day = reader.int32();
                    break;
                case 4:
                    message.hours = reader.int32();
                    break;
                case 5:
                    message.minutes = reader.int32();
                    break;
                case 6:
                    message.seconds = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DateTime message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.DateTime
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.DateTime} DateTime
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DateTime.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DateTime message.
         * @function verify
         * @memberof common.DateTime
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DateTime.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.year != null && message.hasOwnProperty("year"))
                if (!$util.isInteger(message.year))
                    return "year: integer expected";
            if (message.month != null && message.hasOwnProperty("month"))
                if (!$util.isInteger(message.month))
                    return "month: integer expected";
            if (message.day != null && message.hasOwnProperty("day"))
                if (!$util.isInteger(message.day))
                    return "day: integer expected";
            if (message.hours != null && message.hasOwnProperty("hours"))
                if (!$util.isInteger(message.hours))
                    return "hours: integer expected";
            if (message.minutes != null && message.hasOwnProperty("minutes"))
                if (!$util.isInteger(message.minutes))
                    return "minutes: integer expected";
            if (message.seconds != null && message.hasOwnProperty("seconds"))
                if (!$util.isInteger(message.seconds))
                    return "seconds: integer expected";
            return null;
        };

        /**
         * Creates a DateTime message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.DateTime
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.DateTime} DateTime
         */
        DateTime.fromObject = function fromObject(object) {
            if (object instanceof $root.common.DateTime)
                return object;
            var message = new $root.common.DateTime();
            if (object.year != null)
                message.year = object.year | 0;
            if (object.month != null)
                message.month = object.month | 0;
            if (object.day != null)
                message.day = object.day | 0;
            if (object.hours != null)
                message.hours = object.hours | 0;
            if (object.minutes != null)
                message.minutes = object.minutes | 0;
            if (object.seconds != null)
                message.seconds = object.seconds | 0;
            return message;
        };

        /**
         * Creates a plain object from a DateTime message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.DateTime
         * @static
         * @param {common.DateTime} message DateTime
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DateTime.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.year = 0;
                object.month = 0;
                object.day = 0;
                object.hours = 0;
                object.minutes = 0;
                object.seconds = 0;
            }
            if (message.year != null && message.hasOwnProperty("year"))
                object.year = message.year;
            if (message.month != null && message.hasOwnProperty("month"))
                object.month = message.month;
            if (message.day != null && message.hasOwnProperty("day"))
                object.day = message.day;
            if (message.hours != null && message.hasOwnProperty("hours"))
                object.hours = message.hours;
            if (message.minutes != null && message.hasOwnProperty("minutes"))
                object.minutes = message.minutes;
            if (message.seconds != null && message.hasOwnProperty("seconds"))
                object.seconds = message.seconds;
            return object;
        };

        /**
         * Converts this DateTime to JSON.
         * @function toJSON
         * @memberof common.DateTime
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DateTime.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DateTime;
    })();

    common.File = (function() {

        /**
         * Properties of a File.
         * @memberof common
         * @interface IFile
         * @property {Uint8Array|null} [Data] File Data
         * @property {string|null} [MimeType] File MimeType
         * @property {string|null} [Extension] File Extension
         * @property {string|null} [Path] File Path
         */

        /**
         * Constructs a new File.
         * @memberof common
         * @classdesc Represents a File.
         * @implements IFile
         * @constructor
         * @param {common.IFile=} [properties] Properties to set
         */
        function File(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * File Data.
         * @member {Uint8Array} Data
         * @memberof common.File
         * @instance
         */
        File.prototype.Data = $util.newBuffer([]);

        /**
         * File MimeType.
         * @member {string} MimeType
         * @memberof common.File
         * @instance
         */
        File.prototype.MimeType = "";

        /**
         * File Extension.
         * @member {string} Extension
         * @memberof common.File
         * @instance
         */
        File.prototype.Extension = "";

        /**
         * File Path.
         * @member {string} Path
         * @memberof common.File
         * @instance
         */
        File.prototype.Path = "";

        /**
         * Creates a new File instance using the specified properties.
         * @function create
         * @memberof common.File
         * @static
         * @param {common.IFile=} [properties] Properties to set
         * @returns {common.File} File instance
         */
        File.create = function create(properties) {
            return new File(properties);
        };

        /**
         * Encodes the specified File message. Does not implicitly {@link common.File.verify|verify} messages.
         * @function encode
         * @memberof common.File
         * @static
         * @param {common.IFile} message File message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        File.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.Data);
            if (message.MimeType != null && Object.hasOwnProperty.call(message, "MimeType"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.MimeType);
            if (message.Extension != null && Object.hasOwnProperty.call(message, "Extension"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Extension);
            if (message.Path != null && Object.hasOwnProperty.call(message, "Path"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Path);
            return writer;
        };

        /**
         * Encodes the specified File message, length delimited. Does not implicitly {@link common.File.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.File
         * @static
         * @param {common.IFile} message File message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        File.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a File message from the specified reader or buffer.
         * @function decode
         * @memberof common.File
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.File} File
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        File.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.File();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Data = reader.bytes();
                    break;
                case 2:
                    message.MimeType = reader.string();
                    break;
                case 3:
                    message.Extension = reader.string();
                    break;
                case 4:
                    message.Path = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a File message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.File
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.File} File
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        File.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a File message.
         * @function verify
         * @memberof common.File
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        File.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Data != null && message.hasOwnProperty("Data"))
                if (!(message.Data && typeof message.Data.length === "number" || $util.isString(message.Data)))
                    return "Data: buffer expected";
            if (message.MimeType != null && message.hasOwnProperty("MimeType"))
                if (!$util.isString(message.MimeType))
                    return "MimeType: string expected";
            if (message.Extension != null && message.hasOwnProperty("Extension"))
                if (!$util.isString(message.Extension))
                    return "Extension: string expected";
            if (message.Path != null && message.hasOwnProperty("Path"))
                if (!$util.isString(message.Path))
                    return "Path: string expected";
            return null;
        };

        /**
         * Creates a File message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.File
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.File} File
         */
        File.fromObject = function fromObject(object) {
            if (object instanceof $root.common.File)
                return object;
            var message = new $root.common.File();
            if (object.Data != null)
                if (typeof object.Data === "string")
                    $util.base64.decode(object.Data, message.Data = $util.newBuffer($util.base64.length(object.Data)), 0);
                else if (object.Data.length)
                    message.Data = object.Data;
            if (object.MimeType != null)
                message.MimeType = String(object.MimeType);
            if (object.Extension != null)
                message.Extension = String(object.Extension);
            if (object.Path != null)
                message.Path = String(object.Path);
            return message;
        };

        /**
         * Creates a plain object from a File message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.File
         * @static
         * @param {common.File} message File
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        File.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if (options.bytes === String)
                    object.Data = "";
                else {
                    object.Data = [];
                    if (options.bytes !== Array)
                        object.Data = $util.newBuffer(object.Data);
                }
                object.MimeType = "";
                object.Extension = "";
                object.Path = "";
            }
            if (message.Data != null && message.hasOwnProperty("Data"))
                object.Data = options.bytes === String ? $util.base64.encode(message.Data, 0, message.Data.length) : options.bytes === Array ? Array.prototype.slice.call(message.Data) : message.Data;
            if (message.MimeType != null && message.hasOwnProperty("MimeType"))
                object.MimeType = message.MimeType;
            if (message.Extension != null && message.hasOwnProperty("Extension"))
                object.Extension = message.Extension;
            if (message.Path != null && message.hasOwnProperty("Path"))
                object.Path = message.Path;
            return object;
        };

        /**
         * Converts this File to JSON.
         * @function toJSON
         * @memberof common.File
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        File.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return File;
    })();

    common.Constant = (function() {

        /**
         * Properties of a Constant.
         * @memberof common
         * @interface IConstant
         * @property {number|Long|null} [Int] Constant Int
         * @property {number|null} [Real] Constant Real
         * @property {number|null} [Shifted] Constant Shifted
         * @property {string|null} [Str] Constant Str
         * @property {boolean|null} [Boolean] Constant Boolean
         * @property {common.IDate|null} [Date] Constant Date
         * @property {common.ITimeOfDay|null} [Time] Constant Time
         * @property {common.IDateTime|null} [DateTime] Constant DateTime
         * @property {common.IFile|null} [File] Constant File
         */

        /**
         * Constructs a new Constant.
         * @memberof common
         * @classdesc Represents a Constant.
         * @implements IConstant
         * @constructor
         * @param {common.IConstant=} [properties] Properties to set
         */
        function Constant(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Constant Int.
         * @member {number|Long|null|undefined} Int
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.Int = null;

        /**
         * Constant Real.
         * @member {number|null|undefined} Real
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.Real = null;

        /**
         * Constant Shifted.
         * @member {number|null|undefined} Shifted
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.Shifted = null;

        /**
         * Constant Str.
         * @member {string|null|undefined} Str
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.Str = null;

        /**
         * Constant Boolean.
         * @member {boolean|null|undefined} Boolean
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.Boolean = null;

        /**
         * Constant Date.
         * @member {common.IDate|null|undefined} Date
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.Date = null;

        /**
         * Constant Time.
         * @member {common.ITimeOfDay|null|undefined} Time
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.Time = null;

        /**
         * Constant DateTime.
         * @member {common.IDateTime|null|undefined} DateTime
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.DateTime = null;

        /**
         * Constant File.
         * @member {common.IFile|null|undefined} File
         * @memberof common.Constant
         * @instance
         */
        Constant.prototype.File = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * Constant Value.
         * @member {"Int"|"Real"|"Shifted"|"Str"|"Boolean"|"Date"|"Time"|"DateTime"|"File"|undefined} Value
         * @memberof common.Constant
         * @instance
         */
        Object.defineProperty(Constant.prototype, "Value", {
            get: $util.oneOfGetter($oneOfFields = ["Int", "Real", "Shifted", "Str", "Boolean", "Date", "Time", "DateTime", "File"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new Constant instance using the specified properties.
         * @function create
         * @memberof common.Constant
         * @static
         * @param {common.IConstant=} [properties] Properties to set
         * @returns {common.Constant} Constant instance
         */
        Constant.create = function create(properties) {
            return new Constant(properties);
        };

        /**
         * Encodes the specified Constant message. Does not implicitly {@link common.Constant.verify|verify} messages.
         * @function encode
         * @memberof common.Constant
         * @static
         * @param {common.IConstant} message Constant message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Constant.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Int != null && Object.hasOwnProperty.call(message, "Int"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Int);
            if (message.Real != null && Object.hasOwnProperty.call(message, "Real"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.Real);
            if (message.Shifted != null && Object.hasOwnProperty.call(message, "Shifted"))
                writer.uint32(/* id 3, wireType 1 =*/25).double(message.Shifted);
            if (message.Str != null && Object.hasOwnProperty.call(message, "Str"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Str);
            if (message.Boolean != null && Object.hasOwnProperty.call(message, "Boolean"))
                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.Boolean);
            if (message.Date != null && Object.hasOwnProperty.call(message, "Date"))
                $root.common.Date.encode(message.Date, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.Time != null && Object.hasOwnProperty.call(message, "Time"))
                $root.common.TimeOfDay.encode(message.Time, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            if (message.DateTime != null && Object.hasOwnProperty.call(message, "DateTime"))
                $root.common.DateTime.encode(message.DateTime, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
            if (message.File != null && Object.hasOwnProperty.call(message, "File"))
                $root.common.File.encode(message.File, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Constant message, length delimited. Does not implicitly {@link common.Constant.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Constant
         * @static
         * @param {common.IConstant} message Constant message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Constant.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Constant message from the specified reader or buffer.
         * @function decode
         * @memberof common.Constant
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Constant} Constant
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Constant.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Constant();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Int = reader.int64();
                    break;
                case 2:
                    message.Real = reader.double();
                    break;
                case 3:
                    message.Shifted = reader.double();
                    break;
                case 4:
                    message.Str = reader.string();
                    break;
                case 5:
                    message.Boolean = reader.bool();
                    break;
                case 6:
                    message.Date = $root.common.Date.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.Time = $root.common.TimeOfDay.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.DateTime = $root.common.DateTime.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.File = $root.common.File.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Constant message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Constant
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Constant} Constant
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Constant.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Constant message.
         * @function verify
         * @memberof common.Constant
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Constant.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            var properties = {};
            if (message.Int != null && message.hasOwnProperty("Int")) {
                properties.Value = 1;
                if (!$util.isInteger(message.Int) && !(message.Int && $util.isInteger(message.Int.low) && $util.isInteger(message.Int.high)))
                    return "Int: integer|Long expected";
            }
            if (message.Real != null && message.hasOwnProperty("Real")) {
                if (properties.Value === 1)
                    return "Value: multiple values";
                properties.Value = 1;
                if (typeof message.Real !== "number")
                    return "Real: number expected";
            }
            if (message.Shifted != null && message.hasOwnProperty("Shifted")) {
                if (properties.Value === 1)
                    return "Value: multiple values";
                properties.Value = 1;
                if (typeof message.Shifted !== "number")
                    return "Shifted: number expected";
            }
            if (message.Str != null && message.hasOwnProperty("Str")) {
                if (properties.Value === 1)
                    return "Value: multiple values";
                properties.Value = 1;
                if (!$util.isString(message.Str))
                    return "Str: string expected";
            }
            if (message.Boolean != null && message.hasOwnProperty("Boolean")) {
                if (properties.Value === 1)
                    return "Value: multiple values";
                properties.Value = 1;
                if (typeof message.Boolean !== "boolean")
                    return "Boolean: boolean expected";
            }
            if (message.Date != null && message.hasOwnProperty("Date")) {
                if (properties.Value === 1)
                    return "Value: multiple values";
                properties.Value = 1;
                {
                    var error = $root.common.Date.verify(message.Date);
                    if (error)
                        return "Date." + error;
                }
            }
            if (message.Time != null && message.hasOwnProperty("Time")) {
                if (properties.Value === 1)
                    return "Value: multiple values";
                properties.Value = 1;
                {
                    var error = $root.common.TimeOfDay.verify(message.Time);
                    if (error)
                        return "Time." + error;
                }
            }
            if (message.DateTime != null && message.hasOwnProperty("DateTime")) {
                if (properties.Value === 1)
                    return "Value: multiple values";
                properties.Value = 1;
                {
                    var error = $root.common.DateTime.verify(message.DateTime);
                    if (error)
                        return "DateTime." + error;
                }
            }
            if (message.File != null && message.hasOwnProperty("File")) {
                if (properties.Value === 1)
                    return "Value: multiple values";
                properties.Value = 1;
                {
                    var error = $root.common.File.verify(message.File);
                    if (error)
                        return "File." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Constant message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Constant
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Constant} Constant
         */
        Constant.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Constant)
                return object;
            var message = new $root.common.Constant();
            if (object.Int != null)
                if ($util.Long)
                    (message.Int = $util.Long.fromValue(object.Int)).unsigned = false;
                else if (typeof object.Int === "string")
                    message.Int = parseInt(object.Int, 10);
                else if (typeof object.Int === "number")
                    message.Int = object.Int;
                else if (typeof object.Int === "object")
                    message.Int = new $util.LongBits(object.Int.low >>> 0, object.Int.high >>> 0).toNumber();
            if (object.Real != null)
                message.Real = Number(object.Real);
            if (object.Shifted != null)
                message.Shifted = Number(object.Shifted);
            if (object.Str != null)
                message.Str = String(object.Str);
            if (object.Boolean != null)
                message.Boolean = Boolean(object.Boolean);
            if (object.Date != null) {
                if (typeof object.Date !== "object")
                    throw TypeError(".common.Constant.Date: object expected");
                message.Date = $root.common.Date.fromObject(object.Date);
            }
            if (object.Time != null) {
                if (typeof object.Time !== "object")
                    throw TypeError(".common.Constant.Time: object expected");
                message.Time = $root.common.TimeOfDay.fromObject(object.Time);
            }
            if (object.DateTime != null) {
                if (typeof object.DateTime !== "object")
                    throw TypeError(".common.Constant.DateTime: object expected");
                message.DateTime = $root.common.DateTime.fromObject(object.DateTime);
            }
            if (object.File != null) {
                if (typeof object.File !== "object")
                    throw TypeError(".common.Constant.File: object expected");
                message.File = $root.common.File.fromObject(object.File);
            }
            return message;
        };

        /**
         * Creates a plain object from a Constant message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Constant
         * @static
         * @param {common.Constant} message Constant
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Constant.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (message.Int != null && message.hasOwnProperty("Int")) {
                if (typeof message.Int === "number")
                    object.Int = options.longs === String ? String(message.Int) : message.Int;
                else
                    object.Int = options.longs === String ? $util.Long.prototype.toString.call(message.Int) : options.longs === Number ? new $util.LongBits(message.Int.low >>> 0, message.Int.high >>> 0).toNumber() : message.Int;
                if (options.oneofs)
                    object.Value = "Int";
            }
            if (message.Real != null && message.hasOwnProperty("Real")) {
                object.Real = options.json && !isFinite(message.Real) ? String(message.Real) : message.Real;
                if (options.oneofs)
                    object.Value = "Real";
            }
            if (message.Shifted != null && message.hasOwnProperty("Shifted")) {
                object.Shifted = options.json && !isFinite(message.Shifted) ? String(message.Shifted) : message.Shifted;
                if (options.oneofs)
                    object.Value = "Shifted";
            }
            if (message.Str != null && message.hasOwnProperty("Str")) {
                object.Str = message.Str;
                if (options.oneofs)
                    object.Value = "Str";
            }
            if (message.Boolean != null && message.hasOwnProperty("Boolean")) {
                object.Boolean = message.Boolean;
                if (options.oneofs)
                    object.Value = "Boolean";
            }
            if (message.Date != null && message.hasOwnProperty("Date")) {
                object.Date = $root.common.Date.toObject(message.Date, options);
                if (options.oneofs)
                    object.Value = "Date";
            }
            if (message.Time != null && message.hasOwnProperty("Time")) {
                object.Time = $root.common.TimeOfDay.toObject(message.Time, options);
                if (options.oneofs)
                    object.Value = "Time";
            }
            if (message.DateTime != null && message.hasOwnProperty("DateTime")) {
                object.DateTime = $root.common.DateTime.toObject(message.DateTime, options);
                if (options.oneofs)
                    object.Value = "DateTime";
            }
            if (message.File != null && message.hasOwnProperty("File")) {
                object.File = $root.common.File.toObject(message.File, options);
                if (options.oneofs)
                    object.Value = "File";
            }
            return object;
        };

        /**
         * Converts this Constant to JSON.
         * @function toJSON
         * @memberof common.Constant
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Constant.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Constant;
    })();

    common.TenantDetails = (function() {

        /**
         * Properties of a TenantDetails.
         * @memberof common
         * @interface ITenantDetails
         * @property {boolean|null} [Hosting] TenantDetails Hosting
         * @property {string|null} [LicenseID] TenantDetails LicenseID
         * @property {string|null} [TenantID] TenantDetails TenantID
         * @property {string|null} [GatewayURL] TenantDetails GatewayURL
         * @property {string|null} [PublicKeyID] TenantDetails PublicKeyID
         * @property {string|null} [PublicKeyData] TenantDetails PublicKeyData
         * @property {string|null} [WcfURL] TenantDetails WcfURL
         * @property {string|null} [RestURL] TenantDetails RestURL
         */

        /**
         * Constructs a new TenantDetails.
         * @memberof common
         * @classdesc Represents a TenantDetails.
         * @implements ITenantDetails
         * @constructor
         * @param {common.ITenantDetails=} [properties] Properties to set
         */
        function TenantDetails(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TenantDetails Hosting.
         * @member {boolean} Hosting
         * @memberof common.TenantDetails
         * @instance
         */
        TenantDetails.prototype.Hosting = false;

        /**
         * TenantDetails LicenseID.
         * @member {string} LicenseID
         * @memberof common.TenantDetails
         * @instance
         */
        TenantDetails.prototype.LicenseID = "";

        /**
         * TenantDetails TenantID.
         * @member {string} TenantID
         * @memberof common.TenantDetails
         * @instance
         */
        TenantDetails.prototype.TenantID = "";

        /**
         * TenantDetails GatewayURL.
         * @member {string} GatewayURL
         * @memberof common.TenantDetails
         * @instance
         */
        TenantDetails.prototype.GatewayURL = "";

        /**
         * TenantDetails PublicKeyID.
         * @member {string} PublicKeyID
         * @memberof common.TenantDetails
         * @instance
         */
        TenantDetails.prototype.PublicKeyID = "";

        /**
         * TenantDetails PublicKeyData.
         * @member {string} PublicKeyData
         * @memberof common.TenantDetails
         * @instance
         */
        TenantDetails.prototype.PublicKeyData = "";

        /**
         * TenantDetails WcfURL.
         * @member {string} WcfURL
         * @memberof common.TenantDetails
         * @instance
         */
        TenantDetails.prototype.WcfURL = "";

        /**
         * TenantDetails RestURL.
         * @member {string} RestURL
         * @memberof common.TenantDetails
         * @instance
         */
        TenantDetails.prototype.RestURL = "";

        /**
         * Creates a new TenantDetails instance using the specified properties.
         * @function create
         * @memberof common.TenantDetails
         * @static
         * @param {common.ITenantDetails=} [properties] Properties to set
         * @returns {common.TenantDetails} TenantDetails instance
         */
        TenantDetails.create = function create(properties) {
            return new TenantDetails(properties);
        };

        /**
         * Encodes the specified TenantDetails message. Does not implicitly {@link common.TenantDetails.verify|verify} messages.
         * @function encode
         * @memberof common.TenantDetails
         * @static
         * @param {common.ITenantDetails} message TenantDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantDetails.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Hosting != null && Object.hasOwnProperty.call(message, "Hosting"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Hosting);
            if (message.LicenseID != null && Object.hasOwnProperty.call(message, "LicenseID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.LicenseID);
            if (message.TenantID != null && Object.hasOwnProperty.call(message, "TenantID"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.TenantID);
            if (message.GatewayURL != null && Object.hasOwnProperty.call(message, "GatewayURL"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.GatewayURL);
            if (message.PublicKeyID != null && Object.hasOwnProperty.call(message, "PublicKeyID"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.PublicKeyID);
            if (message.PublicKeyData != null && Object.hasOwnProperty.call(message, "PublicKeyData"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.PublicKeyData);
            if (message.WcfURL != null && Object.hasOwnProperty.call(message, "WcfURL"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.WcfURL);
            if (message.RestURL != null && Object.hasOwnProperty.call(message, "RestURL"))
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.RestURL);
            return writer;
        };

        /**
         * Encodes the specified TenantDetails message, length delimited. Does not implicitly {@link common.TenantDetails.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.TenantDetails
         * @static
         * @param {common.ITenantDetails} message TenantDetails message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantDetails.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TenantDetails message from the specified reader or buffer.
         * @function decode
         * @memberof common.TenantDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.TenantDetails} TenantDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantDetails.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.TenantDetails();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Hosting = reader.bool();
                    break;
                case 2:
                    message.LicenseID = reader.string();
                    break;
                case 3:
                    message.TenantID = reader.string();
                    break;
                case 4:
                    message.GatewayURL = reader.string();
                    break;
                case 5:
                    message.PublicKeyID = reader.string();
                    break;
                case 6:
                    message.PublicKeyData = reader.string();
                    break;
                case 7:
                    message.WcfURL = reader.string();
                    break;
                case 8:
                    message.RestURL = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TenantDetails message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.TenantDetails
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.TenantDetails} TenantDetails
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantDetails.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TenantDetails message.
         * @function verify
         * @memberof common.TenantDetails
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TenantDetails.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Hosting != null && message.hasOwnProperty("Hosting"))
                if (typeof message.Hosting !== "boolean")
                    return "Hosting: boolean expected";
            if (message.LicenseID != null && message.hasOwnProperty("LicenseID"))
                if (!$util.isString(message.LicenseID))
                    return "LicenseID: string expected";
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                if (!$util.isString(message.TenantID))
                    return "TenantID: string expected";
            if (message.GatewayURL != null && message.hasOwnProperty("GatewayURL"))
                if (!$util.isString(message.GatewayURL))
                    return "GatewayURL: string expected";
            if (message.PublicKeyID != null && message.hasOwnProperty("PublicKeyID"))
                if (!$util.isString(message.PublicKeyID))
                    return "PublicKeyID: string expected";
            if (message.PublicKeyData != null && message.hasOwnProperty("PublicKeyData"))
                if (!$util.isString(message.PublicKeyData))
                    return "PublicKeyData: string expected";
            if (message.WcfURL != null && message.hasOwnProperty("WcfURL"))
                if (!$util.isString(message.WcfURL))
                    return "WcfURL: string expected";
            if (message.RestURL != null && message.hasOwnProperty("RestURL"))
                if (!$util.isString(message.RestURL))
                    return "RestURL: string expected";
            return null;
        };

        /**
         * Creates a TenantDetails message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.TenantDetails
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.TenantDetails} TenantDetails
         */
        TenantDetails.fromObject = function fromObject(object) {
            if (object instanceof $root.common.TenantDetails)
                return object;
            var message = new $root.common.TenantDetails();
            if (object.Hosting != null)
                message.Hosting = Boolean(object.Hosting);
            if (object.LicenseID != null)
                message.LicenseID = String(object.LicenseID);
            if (object.TenantID != null)
                message.TenantID = String(object.TenantID);
            if (object.GatewayURL != null)
                message.GatewayURL = String(object.GatewayURL);
            if (object.PublicKeyID != null)
                message.PublicKeyID = String(object.PublicKeyID);
            if (object.PublicKeyData != null)
                message.PublicKeyData = String(object.PublicKeyData);
            if (object.WcfURL != null)
                message.WcfURL = String(object.WcfURL);
            if (object.RestURL != null)
                message.RestURL = String(object.RestURL);
            return message;
        };

        /**
         * Creates a plain object from a TenantDetails message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.TenantDetails
         * @static
         * @param {common.TenantDetails} message TenantDetails
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TenantDetails.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.Hosting = false;
                object.LicenseID = "";
                object.TenantID = "";
                object.GatewayURL = "";
                object.PublicKeyID = "";
                object.PublicKeyData = "";
                object.WcfURL = "";
                object.RestURL = "";
            }
            if (message.Hosting != null && message.hasOwnProperty("Hosting"))
                object.Hosting = message.Hosting;
            if (message.LicenseID != null && message.hasOwnProperty("LicenseID"))
                object.LicenseID = message.LicenseID;
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                object.TenantID = message.TenantID;
            if (message.GatewayURL != null && message.hasOwnProperty("GatewayURL"))
                object.GatewayURL = message.GatewayURL;
            if (message.PublicKeyID != null && message.hasOwnProperty("PublicKeyID"))
                object.PublicKeyID = message.PublicKeyID;
            if (message.PublicKeyData != null && message.hasOwnProperty("PublicKeyData"))
                object.PublicKeyData = message.PublicKeyData;
            if (message.WcfURL != null && message.hasOwnProperty("WcfURL"))
                object.WcfURL = message.WcfURL;
            if (message.RestURL != null && message.hasOwnProperty("RestURL"))
                object.RestURL = message.RestURL;
            return object;
        };

        /**
         * Converts this TenantDetails to JSON.
         * @function toJSON
         * @memberof common.TenantDetails
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TenantDetails.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TenantDetails;
    })();

    common.GrpcError = (function() {

        /**
         * Properties of a GrpcError.
         * @memberof common
         * @interface IGrpcError
         * @property {string|null} [error] GrpcError error
         * @property {number|Long|null} [code] GrpcError code
         */

        /**
         * Constructs a new GrpcError.
         * @memberof common
         * @classdesc Represents a GrpcError.
         * @implements IGrpcError
         * @constructor
         * @param {common.IGrpcError=} [properties] Properties to set
         */
        function GrpcError(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * GrpcError error.
         * @member {string} error
         * @memberof common.GrpcError
         * @instance
         */
        GrpcError.prototype.error = "";

        /**
         * GrpcError code.
         * @member {number|Long} code
         * @memberof common.GrpcError
         * @instance
         */
        GrpcError.prototype.code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new GrpcError instance using the specified properties.
         * @function create
         * @memberof common.GrpcError
         * @static
         * @param {common.IGrpcError=} [properties] Properties to set
         * @returns {common.GrpcError} GrpcError instance
         */
        GrpcError.create = function create(properties) {
            return new GrpcError(properties);
        };

        /**
         * Encodes the specified GrpcError message. Does not implicitly {@link common.GrpcError.verify|verify} messages.
         * @function encode
         * @memberof common.GrpcError
         * @static
         * @param {common.IGrpcError} message GrpcError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GrpcError.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.error);
            if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.code);
            return writer;
        };

        /**
         * Encodes the specified GrpcError message, length delimited. Does not implicitly {@link common.GrpcError.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.GrpcError
         * @static
         * @param {common.IGrpcError} message GrpcError message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        GrpcError.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a GrpcError message from the specified reader or buffer.
         * @function decode
         * @memberof common.GrpcError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.GrpcError} GrpcError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GrpcError.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.GrpcError();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.error = reader.string();
                    break;
                case 2:
                    message.code = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a GrpcError message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.GrpcError
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.GrpcError} GrpcError
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        GrpcError.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a GrpcError message.
         * @function verify
         * @memberof common.GrpcError
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        GrpcError.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.error != null && message.hasOwnProperty("error"))
                if (!$util.isString(message.error))
                    return "error: string expected";
            if (message.code != null && message.hasOwnProperty("code"))
                if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                    return "code: integer|Long expected";
            return null;
        };

        /**
         * Creates a GrpcError message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.GrpcError
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.GrpcError} GrpcError
         */
        GrpcError.fromObject = function fromObject(object) {
            if (object instanceof $root.common.GrpcError)
                return object;
            var message = new $root.common.GrpcError();
            if (object.error != null)
                message.error = String(object.error);
            if (object.code != null)
                if ($util.Long)
                    (message.code = $util.Long.fromValue(object.code)).unsigned = false;
                else if (typeof object.code === "string")
                    message.code = parseInt(object.code, 10);
                else if (typeof object.code === "number")
                    message.code = object.code;
                else if (typeof object.code === "object")
                    message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a GrpcError message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.GrpcError
         * @static
         * @param {common.GrpcError} message GrpcError
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        GrpcError.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.error = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.code = options.longs === String ? "0" : 0;
            }
            if (message.error != null && message.hasOwnProperty("error"))
                object.error = message.error;
            if (message.code != null && message.hasOwnProperty("code"))
                if (typeof message.code === "number")
                    object.code = options.longs === String ? String(message.code) : message.code;
                else
                    object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber() : message.code;
            return object;
        };

        /**
         * Converts this GrpcError to JSON.
         * @function toJSON
         * @memberof common.GrpcError
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        GrpcError.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return GrpcError;
    })();

    common.CompanyData = (function() {

        /**
         * Properties of a CompanyData.
         * @memberof common
         * @interface ICompanyData
         * @property {string|null} [Dname] CompanyData Dname
         * @property {string|null} [Title] CompanyData Title
         * @property {boolean|null} [Active] CompanyData Active
         * @property {string|null} [PrettyName] CompanyData PrettyName
         */

        /**
         * Constructs a new CompanyData.
         * @memberof common
         * @classdesc Represents a CompanyData.
         * @implements ICompanyData
         * @constructor
         * @param {common.ICompanyData=} [properties] Properties to set
         */
        function CompanyData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompanyData Dname.
         * @member {string} Dname
         * @memberof common.CompanyData
         * @instance
         */
        CompanyData.prototype.Dname = "";

        /**
         * CompanyData Title.
         * @member {string} Title
         * @memberof common.CompanyData
         * @instance
         */
        CompanyData.prototype.Title = "";

        /**
         * CompanyData Active.
         * @member {boolean} Active
         * @memberof common.CompanyData
         * @instance
         */
        CompanyData.prototype.Active = false;

        /**
         * CompanyData PrettyName.
         * @member {string} PrettyName
         * @memberof common.CompanyData
         * @instance
         */
        CompanyData.prototype.PrettyName = "";

        /**
         * Creates a new CompanyData instance using the specified properties.
         * @function create
         * @memberof common.CompanyData
         * @static
         * @param {common.ICompanyData=} [properties] Properties to set
         * @returns {common.CompanyData} CompanyData instance
         */
        CompanyData.create = function create(properties) {
            return new CompanyData(properties);
        };

        /**
         * Encodes the specified CompanyData message. Does not implicitly {@link common.CompanyData.verify|verify} messages.
         * @function encode
         * @memberof common.CompanyData
         * @static
         * @param {common.ICompanyData} message CompanyData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Dname != null && Object.hasOwnProperty.call(message, "Dname"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Dname);
            if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
            if (message.Active != null && Object.hasOwnProperty.call(message, "Active"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.Active);
            if (message.PrettyName != null && Object.hasOwnProperty.call(message, "PrettyName"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.PrettyName);
            return writer;
        };

        /**
         * Encodes the specified CompanyData message, length delimited. Does not implicitly {@link common.CompanyData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.CompanyData
         * @static
         * @param {common.ICompanyData} message CompanyData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompanyData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompanyData message from the specified reader or buffer.
         * @function decode
         * @memberof common.CompanyData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.CompanyData} CompanyData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.CompanyData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Dname = reader.string();
                    break;
                case 2:
                    message.Title = reader.string();
                    break;
                case 3:
                    message.Active = reader.bool();
                    break;
                case 4:
                    message.PrettyName = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompanyData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.CompanyData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.CompanyData} CompanyData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompanyData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompanyData message.
         * @function verify
         * @memberof common.CompanyData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompanyData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Dname != null && message.hasOwnProperty("Dname"))
                if (!$util.isString(message.Dname))
                    return "Dname: string expected";
            if (message.Title != null && message.hasOwnProperty("Title"))
                if (!$util.isString(message.Title))
                    return "Title: string expected";
            if (message.Active != null && message.hasOwnProperty("Active"))
                if (typeof message.Active !== "boolean")
                    return "Active: boolean expected";
            if (message.PrettyName != null && message.hasOwnProperty("PrettyName"))
                if (!$util.isString(message.PrettyName))
                    return "PrettyName: string expected";
            return null;
        };

        /**
         * Creates a CompanyData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.CompanyData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.CompanyData} CompanyData
         */
        CompanyData.fromObject = function fromObject(object) {
            if (object instanceof $root.common.CompanyData)
                return object;
            var message = new $root.common.CompanyData();
            if (object.Dname != null)
                message.Dname = String(object.Dname);
            if (object.Title != null)
                message.Title = String(object.Title);
            if (object.Active != null)
                message.Active = Boolean(object.Active);
            if (object.PrettyName != null)
                message.PrettyName = String(object.PrettyName);
            return message;
        };

        /**
         * Creates a plain object from a CompanyData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.CompanyData
         * @static
         * @param {common.CompanyData} message CompanyData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompanyData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.Dname = "";
                object.Title = "";
                object.Active = false;
                object.PrettyName = "";
            }
            if (message.Dname != null && message.hasOwnProperty("Dname"))
                object.Dname = message.Dname;
            if (message.Title != null && message.hasOwnProperty("Title"))
                object.Title = message.Title;
            if (message.Active != null && message.hasOwnProperty("Active"))
                object.Active = message.Active;
            if (message.PrettyName != null && message.hasOwnProperty("PrettyName"))
                object.PrettyName = message.PrettyName;
            return object;
        };

        /**
         * Converts this CompanyData to JSON.
         * @function toJSON
         * @memberof common.CompanyData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompanyData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompanyData;
    })();

    common.CompaniesRq = (function() {

        /**
         * Properties of a CompaniesRq.
         * @memberof common
         * @interface ICompaniesRq
         * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] CompaniesRq Properties
         * @property {boolean|null} [OneOnly] CompaniesRq OneOnly
         */

        /**
         * Constructs a new CompaniesRq.
         * @memberof common
         * @classdesc Represents a CompaniesRq.
         * @implements ICompaniesRq
         * @constructor
         * @param {common.ICompaniesRq=} [properties] Properties to set
         */
        function CompaniesRq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompaniesRq Properties.
         * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
         * @memberof common.CompaniesRq
         * @instance
         */
        CompaniesRq.prototype.Properties = null;

        /**
         * CompaniesRq OneOnly.
         * @member {boolean} OneOnly
         * @memberof common.CompaniesRq
         * @instance
         */
        CompaniesRq.prototype.OneOnly = false;

        /**
         * Creates a new CompaniesRq instance using the specified properties.
         * @function create
         * @memberof common.CompaniesRq
         * @static
         * @param {common.ICompaniesRq=} [properties] Properties to set
         * @returns {common.CompaniesRq} CompaniesRq instance
         */
        CompaniesRq.create = function create(properties) {
            return new CompaniesRq(properties);
        };

        /**
         * Encodes the specified CompaniesRq message. Does not implicitly {@link common.CompaniesRq.verify|verify} messages.
         * @function encode
         * @memberof common.CompaniesRq
         * @static
         * @param {common.ICompaniesRq} message CompaniesRq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompaniesRq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.OneOnly != null && Object.hasOwnProperty.call(message, "OneOnly"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.OneOnly);
            return writer;
        };

        /**
         * Encodes the specified CompaniesRq message, length delimited. Does not implicitly {@link common.CompaniesRq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.CompaniesRq
         * @static
         * @param {common.ICompaniesRq} message CompaniesRq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompaniesRq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompaniesRq message from the specified reader or buffer.
         * @function decode
         * @memberof common.CompaniesRq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.CompaniesRq} CompaniesRq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompaniesRq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.CompaniesRq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.OneOnly = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompaniesRq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.CompaniesRq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.CompaniesRq} CompaniesRq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompaniesRq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompaniesRq message.
         * @function verify
         * @memberof common.CompaniesRq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompaniesRq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Properties != null && message.hasOwnProperty("Properties")) {
                var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                if (error)
                    return "Properties." + error;
            }
            if (message.OneOnly != null && message.hasOwnProperty("OneOnly"))
                if (typeof message.OneOnly !== "boolean")
                    return "OneOnly: boolean expected";
            return null;
        };

        /**
         * Creates a CompaniesRq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.CompaniesRq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.CompaniesRq} CompaniesRq
         */
        CompaniesRq.fromObject = function fromObject(object) {
            if (object instanceof $root.common.CompaniesRq)
                return object;
            var message = new $root.common.CompaniesRq();
            if (object.Properties != null) {
                if (typeof object.Properties !== "object")
                    throw TypeError(".common.CompaniesRq.Properties: object expected");
                message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
            }
            if (object.OneOnly != null)
                message.OneOnly = Boolean(object.OneOnly);
            return message;
        };

        /**
         * Creates a plain object from a CompaniesRq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.CompaniesRq
         * @static
         * @param {common.CompaniesRq} message CompaniesRq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompaniesRq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.Properties = null;
                object.OneOnly = false;
            }
            if (message.Properties != null && message.hasOwnProperty("Properties"))
                object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
            if (message.OneOnly != null && message.hasOwnProperty("OneOnly"))
                object.OneOnly = message.OneOnly;
            return object;
        };

        /**
         * Converts this CompaniesRq to JSON.
         * @function toJSON
         * @memberof common.CompaniesRq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompaniesRq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompaniesRq;
    })();

    common.CompaniesRs = (function() {

        /**
         * Properties of a CompaniesRs.
         * @memberof common
         * @interface ICompaniesRs
         * @property {Array.<common.ICompanyData>|null} [Companies] CompaniesRs Companies
         */

        /**
         * Constructs a new CompaniesRs.
         * @memberof common
         * @classdesc Represents a CompaniesRs.
         * @implements ICompaniesRs
         * @constructor
         * @param {common.ICompaniesRs=} [properties] Properties to set
         */
        function CompaniesRs(properties) {
            this.Companies = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CompaniesRs Companies.
         * @member {Array.<common.ICompanyData>} Companies
         * @memberof common.CompaniesRs
         * @instance
         */
        CompaniesRs.prototype.Companies = $util.emptyArray;

        /**
         * Creates a new CompaniesRs instance using the specified properties.
         * @function create
         * @memberof common.CompaniesRs
         * @static
         * @param {common.ICompaniesRs=} [properties] Properties to set
         * @returns {common.CompaniesRs} CompaniesRs instance
         */
        CompaniesRs.create = function create(properties) {
            return new CompaniesRs(properties);
        };

        /**
         * Encodes the specified CompaniesRs message. Does not implicitly {@link common.CompaniesRs.verify|verify} messages.
         * @function encode
         * @memberof common.CompaniesRs
         * @static
         * @param {common.ICompaniesRs} message CompaniesRs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompaniesRs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Companies != null && message.Companies.length)
                for (var i = 0; i < message.Companies.length; ++i)
                    $root.common.CompanyData.encode(message.Companies[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CompaniesRs message, length delimited. Does not implicitly {@link common.CompaniesRs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.CompaniesRs
         * @static
         * @param {common.ICompaniesRs} message CompaniesRs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CompaniesRs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CompaniesRs message from the specified reader or buffer.
         * @function decode
         * @memberof common.CompaniesRs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.CompaniesRs} CompaniesRs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompaniesRs.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.CompaniesRs();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Companies && message.Companies.length))
                        message.Companies = [];
                    message.Companies.push($root.common.CompanyData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CompaniesRs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.CompaniesRs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.CompaniesRs} CompaniesRs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CompaniesRs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CompaniesRs message.
         * @function verify
         * @memberof common.CompaniesRs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CompaniesRs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Companies != null && message.hasOwnProperty("Companies")) {
                if (!Array.isArray(message.Companies))
                    return "Companies: array expected";
                for (var i = 0; i < message.Companies.length; ++i) {
                    var error = $root.common.CompanyData.verify(message.Companies[i]);
                    if (error)
                        return "Companies." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CompaniesRs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.CompaniesRs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.CompaniesRs} CompaniesRs
         */
        CompaniesRs.fromObject = function fromObject(object) {
            if (object instanceof $root.common.CompaniesRs)
                return object;
            var message = new $root.common.CompaniesRs();
            if (object.Companies) {
                if (!Array.isArray(object.Companies))
                    throw TypeError(".common.CompaniesRs.Companies: array expected");
                message.Companies = [];
                for (var i = 0; i < object.Companies.length; ++i) {
                    if (typeof object.Companies[i] !== "object")
                        throw TypeError(".common.CompaniesRs.Companies: object expected");
                    message.Companies[i] = $root.common.CompanyData.fromObject(object.Companies[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CompaniesRs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.CompaniesRs
         * @static
         * @param {common.CompaniesRs} message CompaniesRs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CompaniesRs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.Companies = [];
            if (message.Companies && message.Companies.length) {
                object.Companies = [];
                for (var j = 0; j < message.Companies.length; ++j)
                    object.Companies[j] = $root.common.CompanyData.toObject(message.Companies[j], options);
            }
            return object;
        };

        /**
         * Converts this CompaniesRs to JSON.
         * @function toJSON
         * @memberof common.CompaniesRs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CompaniesRs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CompaniesRs;
    })();

    common.InternalServiceMetadata = (function() {

        /**
         * Properties of an InternalServiceMetadata.
         * @memberof common
         * @interface IInternalServiceMetadata
         * @property {string|null} [TenantID] InternalServiceMetadata TenantID
         * @property {string|null} [Prefix] InternalServiceMetadata Prefix
         */

        /**
         * Constructs a new InternalServiceMetadata.
         * @memberof common
         * @classdesc Represents an InternalServiceMetadata.
         * @implements IInternalServiceMetadata
         * @constructor
         * @param {common.IInternalServiceMetadata=} [properties] Properties to set
         */
        function InternalServiceMetadata(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * InternalServiceMetadata TenantID.
         * @member {string} TenantID
         * @memberof common.InternalServiceMetadata
         * @instance
         */
        InternalServiceMetadata.prototype.TenantID = "";

        /**
         * InternalServiceMetadata Prefix.
         * @member {string} Prefix
         * @memberof common.InternalServiceMetadata
         * @instance
         */
        InternalServiceMetadata.prototype.Prefix = "";

        /**
         * Creates a new InternalServiceMetadata instance using the specified properties.
         * @function create
         * @memberof common.InternalServiceMetadata
         * @static
         * @param {common.IInternalServiceMetadata=} [properties] Properties to set
         * @returns {common.InternalServiceMetadata} InternalServiceMetadata instance
         */
        InternalServiceMetadata.create = function create(properties) {
            return new InternalServiceMetadata(properties);
        };

        /**
         * Encodes the specified InternalServiceMetadata message. Does not implicitly {@link common.InternalServiceMetadata.verify|verify} messages.
         * @function encode
         * @memberof common.InternalServiceMetadata
         * @static
         * @param {common.IInternalServiceMetadata} message InternalServiceMetadata message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InternalServiceMetadata.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TenantID != null && Object.hasOwnProperty.call(message, "TenantID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.TenantID);
            if (message.Prefix != null && Object.hasOwnProperty.call(message, "Prefix"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Prefix);
            return writer;
        };

        /**
         * Encodes the specified InternalServiceMetadata message, length delimited. Does not implicitly {@link common.InternalServiceMetadata.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.InternalServiceMetadata
         * @static
         * @param {common.IInternalServiceMetadata} message InternalServiceMetadata message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        InternalServiceMetadata.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an InternalServiceMetadata message from the specified reader or buffer.
         * @function decode
         * @memberof common.InternalServiceMetadata
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.InternalServiceMetadata} InternalServiceMetadata
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InternalServiceMetadata.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.InternalServiceMetadata();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TenantID = reader.string();
                    break;
                case 2:
                    message.Prefix = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an InternalServiceMetadata message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.InternalServiceMetadata
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.InternalServiceMetadata} InternalServiceMetadata
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        InternalServiceMetadata.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an InternalServiceMetadata message.
         * @function verify
         * @memberof common.InternalServiceMetadata
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        InternalServiceMetadata.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                if (!$util.isString(message.TenantID))
                    return "TenantID: string expected";
            if (message.Prefix != null && message.hasOwnProperty("Prefix"))
                if (!$util.isString(message.Prefix))
                    return "Prefix: string expected";
            return null;
        };

        /**
         * Creates an InternalServiceMetadata message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.InternalServiceMetadata
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.InternalServiceMetadata} InternalServiceMetadata
         */
        InternalServiceMetadata.fromObject = function fromObject(object) {
            if (object instanceof $root.common.InternalServiceMetadata)
                return object;
            var message = new $root.common.InternalServiceMetadata();
            if (object.TenantID != null)
                message.TenantID = String(object.TenantID);
            if (object.Prefix != null)
                message.Prefix = String(object.Prefix);
            return message;
        };

        /**
         * Creates a plain object from an InternalServiceMetadata message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.InternalServiceMetadata
         * @static
         * @param {common.InternalServiceMetadata} message InternalServiceMetadata
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        InternalServiceMetadata.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.TenantID = "";
                object.Prefix = "";
            }
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                object.TenantID = message.TenantID;
            if (message.Prefix != null && message.hasOwnProperty("Prefix"))
                object.Prefix = message.Prefix;
            return object;
        };

        /**
         * Converts this InternalServiceMetadata to JSON.
         * @function toJSON
         * @memberof common.InternalServiceMetadata
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        InternalServiceMetadata.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return InternalServiceMetadata;
    })();

    common.TenantData = (function() {

        /**
         * Properties of a TenantData.
         * @memberof common
         * @interface ITenantData
         * @property {string|null} [LicenseID] TenantData LicenseID
         * @property {string|null} [TenantID] TenantData TenantID
         * @property {string|null} [Tabini] TenantData Tabini
         * @property {string|null} [Wcf] TenantData Wcf
         * @property {string|null} [Server] TenantData Server
         * @property {string|null} [Dname] TenantData Dname
         * @property {number|null} [Version] TenantData Version
         * @property {number|Long|null} [BasicLanguage] TenantData BasicLanguage
         * @property {string|null} [Webclient] TenantData Webclient
         * @property {boolean|null} [ExternalOnly] TenantData ExternalOnly
         * @property {number|Long|null} [Admode] TenantData Admode
         * @property {string|null} [DefaultPrettyName] TenantData DefaultPrettyName
         * @property {string|null} [Locktype] TenantData Locktype
         * @property {boolean|null} [TSDisabled] TenantData TSDisabled
         * @property {string|null} [Alert] TenantData Alert
         * @property {boolean|null} [IsRealCloud] TenantData IsRealCloud
         * @property {string|null} [Prefix] TenantData Prefix
         * @property {common.IMssqlInstance|null} [DB] TenantData DB
         * @property {common.SqlTier|null} [SqlTier] TenantData SqlTier
         */

        /**
         * Constructs a new TenantData.
         * @memberof common
         * @classdesc Represents a TenantData.
         * @implements ITenantData
         * @constructor
         * @param {common.ITenantData=} [properties] Properties to set
         */
        function TenantData(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TenantData LicenseID.
         * @member {string} LicenseID
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.LicenseID = "";

        /**
         * TenantData TenantID.
         * @member {string} TenantID
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.TenantID = "";

        /**
         * TenantData Tabini.
         * @member {string} Tabini
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Tabini = "";

        /**
         * TenantData Wcf.
         * @member {string} Wcf
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Wcf = "";

        /**
         * TenantData Server.
         * @member {string} Server
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Server = "";

        /**
         * TenantData Dname.
         * @member {string} Dname
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Dname = "";

        /**
         * TenantData Version.
         * @member {number} Version
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Version = 0;

        /**
         * TenantData BasicLanguage.
         * @member {number|Long} BasicLanguage
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.BasicLanguage = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TenantData Webclient.
         * @member {string} Webclient
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Webclient = "";

        /**
         * TenantData ExternalOnly.
         * @member {boolean} ExternalOnly
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.ExternalOnly = false;

        /**
         * TenantData Admode.
         * @member {number|Long} Admode
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Admode = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * TenantData DefaultPrettyName.
         * @member {string} DefaultPrettyName
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.DefaultPrettyName = "";

        /**
         * TenantData Locktype.
         * @member {string} Locktype
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Locktype = "";

        /**
         * TenantData TSDisabled.
         * @member {boolean} TSDisabled
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.TSDisabled = false;

        /**
         * TenantData Alert.
         * @member {string} Alert
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Alert = "";

        /**
         * TenantData IsRealCloud.
         * @member {boolean} IsRealCloud
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.IsRealCloud = false;

        /**
         * TenantData Prefix.
         * @member {string} Prefix
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.Prefix = "";

        /**
         * TenantData DB.
         * @member {common.IMssqlInstance|null|undefined} DB
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.DB = null;

        /**
         * TenantData SqlTier.
         * @member {common.SqlTier} SqlTier
         * @memberof common.TenantData
         * @instance
         */
        TenantData.prototype.SqlTier = 0;

        /**
         * Creates a new TenantData instance using the specified properties.
         * @function create
         * @memberof common.TenantData
         * @static
         * @param {common.ITenantData=} [properties] Properties to set
         * @returns {common.TenantData} TenantData instance
         */
        TenantData.create = function create(properties) {
            return new TenantData(properties);
        };

        /**
         * Encodes the specified TenantData message. Does not implicitly {@link common.TenantData.verify|verify} messages.
         * @function encode
         * @memberof common.TenantData
         * @static
         * @param {common.ITenantData} message TenantData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.LicenseID != null && Object.hasOwnProperty.call(message, "LicenseID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.LicenseID);
            if (message.TenantID != null && Object.hasOwnProperty.call(message, "TenantID"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.TenantID);
            if (message.Tabini != null && Object.hasOwnProperty.call(message, "Tabini"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Tabini);
            if (message.Wcf != null && Object.hasOwnProperty.call(message, "Wcf"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Wcf);
            if (message.Server != null && Object.hasOwnProperty.call(message, "Server"))
                writer.uint32(/* id 5, wireType 2 =*/42).string(message.Server);
            if (message.Dname != null && Object.hasOwnProperty.call(message, "Dname"))
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.Dname);
            if (message.Version != null && Object.hasOwnProperty.call(message, "Version"))
                writer.uint32(/* id 9, wireType 5 =*/77).float(message.Version);
            if (message.BasicLanguage != null && Object.hasOwnProperty.call(message, "BasicLanguage"))
                writer.uint32(/* id 10, wireType 0 =*/80).int64(message.BasicLanguage);
            if (message.Webclient != null && Object.hasOwnProperty.call(message, "Webclient"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.Webclient);
            if (message.ExternalOnly != null && Object.hasOwnProperty.call(message, "ExternalOnly"))
                writer.uint32(/* id 12, wireType 0 =*/96).bool(message.ExternalOnly);
            if (message.Admode != null && Object.hasOwnProperty.call(message, "Admode"))
                writer.uint32(/* id 13, wireType 0 =*/104).int64(message.Admode);
            if (message.DefaultPrettyName != null && Object.hasOwnProperty.call(message, "DefaultPrettyName"))
                writer.uint32(/* id 14, wireType 2 =*/114).string(message.DefaultPrettyName);
            if (message.Locktype != null && Object.hasOwnProperty.call(message, "Locktype"))
                writer.uint32(/* id 15, wireType 2 =*/122).string(message.Locktype);
            if (message.TSDisabled != null && Object.hasOwnProperty.call(message, "TSDisabled"))
                writer.uint32(/* id 16, wireType 0 =*/128).bool(message.TSDisabled);
            if (message.Alert != null && Object.hasOwnProperty.call(message, "Alert"))
                writer.uint32(/* id 17, wireType 2 =*/138).string(message.Alert);
            if (message.IsRealCloud != null && Object.hasOwnProperty.call(message, "IsRealCloud"))
                writer.uint32(/* id 18, wireType 0 =*/144).bool(message.IsRealCloud);
            if (message.Prefix != null && Object.hasOwnProperty.call(message, "Prefix"))
                writer.uint32(/* id 19, wireType 2 =*/154).string(message.Prefix);
            if (message.DB != null && Object.hasOwnProperty.call(message, "DB"))
                $root.common.MssqlInstance.encode(message.DB, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
            if (message.SqlTier != null && Object.hasOwnProperty.call(message, "SqlTier"))
                writer.uint32(/* id 21, wireType 0 =*/168).int32(message.SqlTier);
            return writer;
        };

        /**
         * Encodes the specified TenantData message, length delimited. Does not implicitly {@link common.TenantData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.TenantData
         * @static
         * @param {common.ITenantData} message TenantData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TenantData message from the specified reader or buffer.
         * @function decode
         * @memberof common.TenantData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.TenantData} TenantData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.TenantData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.LicenseID = reader.string();
                    break;
                case 2:
                    message.TenantID = reader.string();
                    break;
                case 3:
                    message.Tabini = reader.string();
                    break;
                case 4:
                    message.Wcf = reader.string();
                    break;
                case 5:
                    message.Server = reader.string();
                    break;
                case 6:
                    message.Dname = reader.string();
                    break;
                case 9:
                    message.Version = reader.float();
                    break;
                case 10:
                    message.BasicLanguage = reader.int64();
                    break;
                case 11:
                    message.Webclient = reader.string();
                    break;
                case 12:
                    message.ExternalOnly = reader.bool();
                    break;
                case 13:
                    message.Admode = reader.int64();
                    break;
                case 14:
                    message.DefaultPrettyName = reader.string();
                    break;
                case 15:
                    message.Locktype = reader.string();
                    break;
                case 16:
                    message.TSDisabled = reader.bool();
                    break;
                case 17:
                    message.Alert = reader.string();
                    break;
                case 18:
                    message.IsRealCloud = reader.bool();
                    break;
                case 19:
                    message.Prefix = reader.string();
                    break;
                case 20:
                    message.DB = $root.common.MssqlInstance.decode(reader, reader.uint32());
                    break;
                case 21:
                    message.SqlTier = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TenantData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.TenantData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.TenantData} TenantData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TenantData message.
         * @function verify
         * @memberof common.TenantData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TenantData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.LicenseID != null && message.hasOwnProperty("LicenseID"))
                if (!$util.isString(message.LicenseID))
                    return "LicenseID: string expected";
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                if (!$util.isString(message.TenantID))
                    return "TenantID: string expected";
            if (message.Tabini != null && message.hasOwnProperty("Tabini"))
                if (!$util.isString(message.Tabini))
                    return "Tabini: string expected";
            if (message.Wcf != null && message.hasOwnProperty("Wcf"))
                if (!$util.isString(message.Wcf))
                    return "Wcf: string expected";
            if (message.Server != null && message.hasOwnProperty("Server"))
                if (!$util.isString(message.Server))
                    return "Server: string expected";
            if (message.Dname != null && message.hasOwnProperty("Dname"))
                if (!$util.isString(message.Dname))
                    return "Dname: string expected";
            if (message.Version != null && message.hasOwnProperty("Version"))
                if (typeof message.Version !== "number")
                    return "Version: number expected";
            if (message.BasicLanguage != null && message.hasOwnProperty("BasicLanguage"))
                if (!$util.isInteger(message.BasicLanguage) && !(message.BasicLanguage && $util.isInteger(message.BasicLanguage.low) && $util.isInteger(message.BasicLanguage.high)))
                    return "BasicLanguage: integer|Long expected";
            if (message.Webclient != null && message.hasOwnProperty("Webclient"))
                if (!$util.isString(message.Webclient))
                    return "Webclient: string expected";
            if (message.ExternalOnly != null && message.hasOwnProperty("ExternalOnly"))
                if (typeof message.ExternalOnly !== "boolean")
                    return "ExternalOnly: boolean expected";
            if (message.Admode != null && message.hasOwnProperty("Admode"))
                if (!$util.isInteger(message.Admode) && !(message.Admode && $util.isInteger(message.Admode.low) && $util.isInteger(message.Admode.high)))
                    return "Admode: integer|Long expected";
            if (message.DefaultPrettyName != null && message.hasOwnProperty("DefaultPrettyName"))
                if (!$util.isString(message.DefaultPrettyName))
                    return "DefaultPrettyName: string expected";
            if (message.Locktype != null && message.hasOwnProperty("Locktype"))
                if (!$util.isString(message.Locktype))
                    return "Locktype: string expected";
            if (message.TSDisabled != null && message.hasOwnProperty("TSDisabled"))
                if (typeof message.TSDisabled !== "boolean")
                    return "TSDisabled: boolean expected";
            if (message.Alert != null && message.hasOwnProperty("Alert"))
                if (!$util.isString(message.Alert))
                    return "Alert: string expected";
            if (message.IsRealCloud != null && message.hasOwnProperty("IsRealCloud"))
                if (typeof message.IsRealCloud !== "boolean")
                    return "IsRealCloud: boolean expected";
            if (message.Prefix != null && message.hasOwnProperty("Prefix"))
                if (!$util.isString(message.Prefix))
                    return "Prefix: string expected";
            if (message.DB != null && message.hasOwnProperty("DB")) {
                var error = $root.common.MssqlInstance.verify(message.DB);
                if (error)
                    return "DB." + error;
            }
            if (message.SqlTier != null && message.hasOwnProperty("SqlTier"))
                switch (message.SqlTier) {
                default:
                    return "SqlTier: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            return null;
        };

        /**
         * Creates a TenantData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.TenantData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.TenantData} TenantData
         */
        TenantData.fromObject = function fromObject(object) {
            if (object instanceof $root.common.TenantData)
                return object;
            var message = new $root.common.TenantData();
            if (object.LicenseID != null)
                message.LicenseID = String(object.LicenseID);
            if (object.TenantID != null)
                message.TenantID = String(object.TenantID);
            if (object.Tabini != null)
                message.Tabini = String(object.Tabini);
            if (object.Wcf != null)
                message.Wcf = String(object.Wcf);
            if (object.Server != null)
                message.Server = String(object.Server);
            if (object.Dname != null)
                message.Dname = String(object.Dname);
            if (object.Version != null)
                message.Version = Number(object.Version);
            if (object.BasicLanguage != null)
                if ($util.Long)
                    (message.BasicLanguage = $util.Long.fromValue(object.BasicLanguage)).unsigned = false;
                else if (typeof object.BasicLanguage === "string")
                    message.BasicLanguage = parseInt(object.BasicLanguage, 10);
                else if (typeof object.BasicLanguage === "number")
                    message.BasicLanguage = object.BasicLanguage;
                else if (typeof object.BasicLanguage === "object")
                    message.BasicLanguage = new $util.LongBits(object.BasicLanguage.low >>> 0, object.BasicLanguage.high >>> 0).toNumber();
            if (object.Webclient != null)
                message.Webclient = String(object.Webclient);
            if (object.ExternalOnly != null)
                message.ExternalOnly = Boolean(object.ExternalOnly);
            if (object.Admode != null)
                if ($util.Long)
                    (message.Admode = $util.Long.fromValue(object.Admode)).unsigned = false;
                else if (typeof object.Admode === "string")
                    message.Admode = parseInt(object.Admode, 10);
                else if (typeof object.Admode === "number")
                    message.Admode = object.Admode;
                else if (typeof object.Admode === "object")
                    message.Admode = new $util.LongBits(object.Admode.low >>> 0, object.Admode.high >>> 0).toNumber();
            if (object.DefaultPrettyName != null)
                message.DefaultPrettyName = String(object.DefaultPrettyName);
            if (object.Locktype != null)
                message.Locktype = String(object.Locktype);
            if (object.TSDisabled != null)
                message.TSDisabled = Boolean(object.TSDisabled);
            if (object.Alert != null)
                message.Alert = String(object.Alert);
            if (object.IsRealCloud != null)
                message.IsRealCloud = Boolean(object.IsRealCloud);
            if (object.Prefix != null)
                message.Prefix = String(object.Prefix);
            if (object.DB != null) {
                if (typeof object.DB !== "object")
                    throw TypeError(".common.TenantData.DB: object expected");
                message.DB = $root.common.MssqlInstance.fromObject(object.DB);
            }
            switch (object.SqlTier) {
            case "None":
            case 0:
                message.SqlTier = 0;
                break;
            case "Zoom":
            case 1:
                message.SqlTier = 1;
                break;
            case "Small":
            case 2:
                message.SqlTier = 2;
                break;
            case "Medium":
            case 3:
                message.SqlTier = 3;
                break;
            case "Large":
            case 4:
                message.SqlTier = 4;
                break;
            case "XLarge":
            case 5:
                message.SqlTier = 5;
                break;
            case "Enterprise":
            case 6:
                message.SqlTier = 6;
                break;
            }
            return message;
        };

        /**
         * Creates a plain object from a TenantData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.TenantData
         * @static
         * @param {common.TenantData} message TenantData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TenantData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.LicenseID = "";
                object.TenantID = "";
                object.Tabini = "";
                object.Wcf = "";
                object.Server = "";
                object.Dname = "";
                object.Version = 0;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.BasicLanguage = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.BasicLanguage = options.longs === String ? "0" : 0;
                object.Webclient = "";
                object.ExternalOnly = false;
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.Admode = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.Admode = options.longs === String ? "0" : 0;
                object.DefaultPrettyName = "";
                object.Locktype = "";
                object.TSDisabled = false;
                object.Alert = "";
                object.IsRealCloud = false;
                object.Prefix = "";
                object.DB = null;
                object.SqlTier = options.enums === String ? "None" : 0;
            }
            if (message.LicenseID != null && message.hasOwnProperty("LicenseID"))
                object.LicenseID = message.LicenseID;
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                object.TenantID = message.TenantID;
            if (message.Tabini != null && message.hasOwnProperty("Tabini"))
                object.Tabini = message.Tabini;
            if (message.Wcf != null && message.hasOwnProperty("Wcf"))
                object.Wcf = message.Wcf;
            if (message.Server != null && message.hasOwnProperty("Server"))
                object.Server = message.Server;
            if (message.Dname != null && message.hasOwnProperty("Dname"))
                object.Dname = message.Dname;
            if (message.Version != null && message.hasOwnProperty("Version"))
                object.Version = options.json && !isFinite(message.Version) ? String(message.Version) : message.Version;
            if (message.BasicLanguage != null && message.hasOwnProperty("BasicLanguage"))
                if (typeof message.BasicLanguage === "number")
                    object.BasicLanguage = options.longs === String ? String(message.BasicLanguage) : message.BasicLanguage;
                else
                    object.BasicLanguage = options.longs === String ? $util.Long.prototype.toString.call(message.BasicLanguage) : options.longs === Number ? new $util.LongBits(message.BasicLanguage.low >>> 0, message.BasicLanguage.high >>> 0).toNumber() : message.BasicLanguage;
            if (message.Webclient != null && message.hasOwnProperty("Webclient"))
                object.Webclient = message.Webclient;
            if (message.ExternalOnly != null && message.hasOwnProperty("ExternalOnly"))
                object.ExternalOnly = message.ExternalOnly;
            if (message.Admode != null && message.hasOwnProperty("Admode"))
                if (typeof message.Admode === "number")
                    object.Admode = options.longs === String ? String(message.Admode) : message.Admode;
                else
                    object.Admode = options.longs === String ? $util.Long.prototype.toString.call(message.Admode) : options.longs === Number ? new $util.LongBits(message.Admode.low >>> 0, message.Admode.high >>> 0).toNumber() : message.Admode;
            if (message.DefaultPrettyName != null && message.hasOwnProperty("DefaultPrettyName"))
                object.DefaultPrettyName = message.DefaultPrettyName;
            if (message.Locktype != null && message.hasOwnProperty("Locktype"))
                object.Locktype = message.Locktype;
            if (message.TSDisabled != null && message.hasOwnProperty("TSDisabled"))
                object.TSDisabled = message.TSDisabled;
            if (message.Alert != null && message.hasOwnProperty("Alert"))
                object.Alert = message.Alert;
            if (message.IsRealCloud != null && message.hasOwnProperty("IsRealCloud"))
                object.IsRealCloud = message.IsRealCloud;
            if (message.Prefix != null && message.hasOwnProperty("Prefix"))
                object.Prefix = message.Prefix;
            if (message.DB != null && message.hasOwnProperty("DB"))
                object.DB = $root.common.MssqlInstance.toObject(message.DB, options);
            if (message.SqlTier != null && message.hasOwnProperty("SqlTier"))
                object.SqlTier = options.enums === String ? $root.common.SqlTier[message.SqlTier] : message.SqlTier;
            return object;
        };

        /**
         * Converts this TenantData to JSON.
         * @function toJSON
         * @memberof common.TenantData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TenantData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TenantData;
    })();

    common.Tenants = (function() {

        /**
         * Properties of a Tenants.
         * @memberof common
         * @interface ITenants
         * @property {Array.<common.ITenantData>|null} [Values] Tenants Values
         */

        /**
         * Constructs a new Tenants.
         * @memberof common
         * @classdesc Represents a Tenants.
         * @implements ITenants
         * @constructor
         * @param {common.ITenants=} [properties] Properties to set
         */
        function Tenants(properties) {
            this.Values = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Tenants Values.
         * @member {Array.<common.ITenantData>} Values
         * @memberof common.Tenants
         * @instance
         */
        Tenants.prototype.Values = $util.emptyArray;

        /**
         * Creates a new Tenants instance using the specified properties.
         * @function create
         * @memberof common.Tenants
         * @static
         * @param {common.ITenants=} [properties] Properties to set
         * @returns {common.Tenants} Tenants instance
         */
        Tenants.create = function create(properties) {
            return new Tenants(properties);
        };

        /**
         * Encodes the specified Tenants message. Does not implicitly {@link common.Tenants.verify|verify} messages.
         * @function encode
         * @memberof common.Tenants
         * @static
         * @param {common.ITenants} message Tenants message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Tenants.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Values != null && message.Values.length)
                for (var i = 0; i < message.Values.length; ++i)
                    $root.common.TenantData.encode(message.Values[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified Tenants message, length delimited. Does not implicitly {@link common.Tenants.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.Tenants
         * @static
         * @param {common.ITenants} message Tenants message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Tenants.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a Tenants message from the specified reader or buffer.
         * @function decode
         * @memberof common.Tenants
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.Tenants} Tenants
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Tenants.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.Tenants();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Values && message.Values.length))
                        message.Values = [];
                    message.Values.push($root.common.TenantData.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a Tenants message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.Tenants
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.Tenants} Tenants
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Tenants.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a Tenants message.
         * @function verify
         * @memberof common.Tenants
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        Tenants.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Values != null && message.hasOwnProperty("Values")) {
                if (!Array.isArray(message.Values))
                    return "Values: array expected";
                for (var i = 0; i < message.Values.length; ++i) {
                    var error = $root.common.TenantData.verify(message.Values[i]);
                    if (error)
                        return "Values." + error;
                }
            }
            return null;
        };

        /**
         * Creates a Tenants message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.Tenants
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.Tenants} Tenants
         */
        Tenants.fromObject = function fromObject(object) {
            if (object instanceof $root.common.Tenants)
                return object;
            var message = new $root.common.Tenants();
            if (object.Values) {
                if (!Array.isArray(object.Values))
                    throw TypeError(".common.Tenants.Values: array expected");
                message.Values = [];
                for (var i = 0; i < object.Values.length; ++i) {
                    if (typeof object.Values[i] !== "object")
                        throw TypeError(".common.Tenants.Values: object expected");
                    message.Values[i] = $root.common.TenantData.fromObject(object.Values[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a Tenants message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.Tenants
         * @static
         * @param {common.Tenants} message Tenants
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Tenants.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.Values = [];
            if (message.Values && message.Values.length) {
                object.Values = [];
                for (var j = 0; j < message.Values.length; ++j)
                    object.Values[j] = $root.common.TenantData.toObject(message.Values[j], options);
            }
            return object;
        };

        /**
         * Converts this Tenants to JSON.
         * @function toJSON
         * @memberof common.Tenants
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        Tenants.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Tenants;
    })();

    common.MssqlInstance = (function() {

        /**
         * Properties of a MssqlInstance.
         * @memberof common
         * @interface IMssqlInstance
         * @property {number|Long|null} [ID] MssqlInstance ID
         * @property {string|null} [Name] MssqlInstance Name
         * @property {string|null} [Collation] MssqlInstance Collation
         * @property {string|null} [Edition] MssqlInstance Edition
         * @property {number|null} [MemoryLimit] MssqlInstance MemoryLimit
         * @property {boolean|null} [Active] MssqlInstance Active
         * @property {string|null} [Host] MssqlInstance Host
         * @property {number|null} [MaxTenants] MssqlInstance MaxTenants
         * @property {string|null} [HostLocation] MssqlInstance HostLocation
         * @property {string|null} [SaPassword] MssqlInstance SaPassword
         * @property {string|null} [InstanceType] MssqlInstance InstanceType
         * @property {number|Long|null} [VolumeID] MssqlInstance VolumeID
         */

        /**
         * Constructs a new MssqlInstance.
         * @memberof common
         * @classdesc Represents a MssqlInstance.
         * @implements IMssqlInstance
         * @constructor
         * @param {common.IMssqlInstance=} [properties] Properties to set
         */
        function MssqlInstance(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MssqlInstance ID.
         * @member {number|Long} ID
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.ID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * MssqlInstance Name.
         * @member {string} Name
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.Name = "";

        /**
         * MssqlInstance Collation.
         * @member {string} Collation
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.Collation = "";

        /**
         * MssqlInstance Edition.
         * @member {string} Edition
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.Edition = "";

        /**
         * MssqlInstance MemoryLimit.
         * @member {number} MemoryLimit
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.MemoryLimit = 0;

        /**
         * MssqlInstance Active.
         * @member {boolean} Active
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.Active = false;

        /**
         * MssqlInstance Host.
         * @member {string} Host
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.Host = "";

        /**
         * MssqlInstance MaxTenants.
         * @member {number} MaxTenants
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.MaxTenants = 0;

        /**
         * MssqlInstance HostLocation.
         * @member {string} HostLocation
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.HostLocation = "";

        /**
         * MssqlInstance SaPassword.
         * @member {string} SaPassword
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.SaPassword = "";

        /**
         * MssqlInstance InstanceType.
         * @member {string} InstanceType
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.InstanceType = "";

        /**
         * MssqlInstance VolumeID.
         * @member {number|Long} VolumeID
         * @memberof common.MssqlInstance
         * @instance
         */
        MssqlInstance.prototype.VolumeID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

        /**
         * Creates a new MssqlInstance instance using the specified properties.
         * @function create
         * @memberof common.MssqlInstance
         * @static
         * @param {common.IMssqlInstance=} [properties] Properties to set
         * @returns {common.MssqlInstance} MssqlInstance instance
         */
        MssqlInstance.create = function create(properties) {
            return new MssqlInstance(properties);
        };

        /**
         * Encodes the specified MssqlInstance message. Does not implicitly {@link common.MssqlInstance.verify|verify} messages.
         * @function encode
         * @memberof common.MssqlInstance
         * @static
         * @param {common.IMssqlInstance} message MssqlInstance message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MssqlInstance.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ID);
            if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
            if (message.Collation != null && Object.hasOwnProperty.call(message, "Collation"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.Collation);
            if (message.Edition != null && Object.hasOwnProperty.call(message, "Edition"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.Edition);
            if (message.MemoryLimit != null && Object.hasOwnProperty.call(message, "MemoryLimit"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.MemoryLimit);
            if (message.Active != null && Object.hasOwnProperty.call(message, "Active"))
                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.Active);
            if (message.Host != null && Object.hasOwnProperty.call(message, "Host"))
                writer.uint32(/* id 7, wireType 2 =*/58).string(message.Host);
            if (message.MaxTenants != null && Object.hasOwnProperty.call(message, "MaxTenants"))
                writer.uint32(/* id 8, wireType 0 =*/64).int32(message.MaxTenants);
            if (message.HostLocation != null && Object.hasOwnProperty.call(message, "HostLocation"))
                writer.uint32(/* id 9, wireType 2 =*/74).string(message.HostLocation);
            if (message.SaPassword != null && Object.hasOwnProperty.call(message, "SaPassword"))
                writer.uint32(/* id 10, wireType 2 =*/82).string(message.SaPassword);
            if (message.InstanceType != null && Object.hasOwnProperty.call(message, "InstanceType"))
                writer.uint32(/* id 11, wireType 2 =*/90).string(message.InstanceType);
            if (message.VolumeID != null && Object.hasOwnProperty.call(message, "VolumeID"))
                writer.uint32(/* id 12, wireType 0 =*/96).int64(message.VolumeID);
            return writer;
        };

        /**
         * Encodes the specified MssqlInstance message, length delimited. Does not implicitly {@link common.MssqlInstance.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.MssqlInstance
         * @static
         * @param {common.IMssqlInstance} message MssqlInstance message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MssqlInstance.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a MssqlInstance message from the specified reader or buffer.
         * @function decode
         * @memberof common.MssqlInstance
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.MssqlInstance} MssqlInstance
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MssqlInstance.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.MssqlInstance();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.ID = reader.int64();
                    break;
                case 2:
                    message.Name = reader.string();
                    break;
                case 3:
                    message.Collation = reader.string();
                    break;
                case 4:
                    message.Edition = reader.string();
                    break;
                case 5:
                    message.MemoryLimit = reader.int32();
                    break;
                case 6:
                    message.Active = reader.bool();
                    break;
                case 7:
                    message.Host = reader.string();
                    break;
                case 8:
                    message.MaxTenants = reader.int32();
                    break;
                case 9:
                    message.HostLocation = reader.string();
                    break;
                case 10:
                    message.SaPassword = reader.string();
                    break;
                case 11:
                    message.InstanceType = reader.string();
                    break;
                case 12:
                    message.VolumeID = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a MssqlInstance message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.MssqlInstance
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.MssqlInstance} MssqlInstance
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MssqlInstance.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a MssqlInstance message.
         * @function verify
         * @memberof common.MssqlInstance
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        MssqlInstance.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (!$util.isInteger(message.ID) && !(message.ID && $util.isInteger(message.ID.low) && $util.isInteger(message.ID.high)))
                    return "ID: integer|Long expected";
            if (message.Name != null && message.hasOwnProperty("Name"))
                if (!$util.isString(message.Name))
                    return "Name: string expected";
            if (message.Collation != null && message.hasOwnProperty("Collation"))
                if (!$util.isString(message.Collation))
                    return "Collation: string expected";
            if (message.Edition != null && message.hasOwnProperty("Edition"))
                if (!$util.isString(message.Edition))
                    return "Edition: string expected";
            if (message.MemoryLimit != null && message.hasOwnProperty("MemoryLimit"))
                if (!$util.isInteger(message.MemoryLimit))
                    return "MemoryLimit: integer expected";
            if (message.Active != null && message.hasOwnProperty("Active"))
                if (typeof message.Active !== "boolean")
                    return "Active: boolean expected";
            if (message.Host != null && message.hasOwnProperty("Host"))
                if (!$util.isString(message.Host))
                    return "Host: string expected";
            if (message.MaxTenants != null && message.hasOwnProperty("MaxTenants"))
                if (!$util.isInteger(message.MaxTenants))
                    return "MaxTenants: integer expected";
            if (message.HostLocation != null && message.hasOwnProperty("HostLocation"))
                if (!$util.isString(message.HostLocation))
                    return "HostLocation: string expected";
            if (message.SaPassword != null && message.hasOwnProperty("SaPassword"))
                if (!$util.isString(message.SaPassword))
                    return "SaPassword: string expected";
            if (message.InstanceType != null && message.hasOwnProperty("InstanceType"))
                if (!$util.isString(message.InstanceType))
                    return "InstanceType: string expected";
            if (message.VolumeID != null && message.hasOwnProperty("VolumeID"))
                if (!$util.isInteger(message.VolumeID) && !(message.VolumeID && $util.isInteger(message.VolumeID.low) && $util.isInteger(message.VolumeID.high)))
                    return "VolumeID: integer|Long expected";
            return null;
        };

        /**
         * Creates a MssqlInstance message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.MssqlInstance
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.MssqlInstance} MssqlInstance
         */
        MssqlInstance.fromObject = function fromObject(object) {
            if (object instanceof $root.common.MssqlInstance)
                return object;
            var message = new $root.common.MssqlInstance();
            if (object.ID != null)
                if ($util.Long)
                    (message.ID = $util.Long.fromValue(object.ID)).unsigned = false;
                else if (typeof object.ID === "string")
                    message.ID = parseInt(object.ID, 10);
                else if (typeof object.ID === "number")
                    message.ID = object.ID;
                else if (typeof object.ID === "object")
                    message.ID = new $util.LongBits(object.ID.low >>> 0, object.ID.high >>> 0).toNumber();
            if (object.Name != null)
                message.Name = String(object.Name);
            if (object.Collation != null)
                message.Collation = String(object.Collation);
            if (object.Edition != null)
                message.Edition = String(object.Edition);
            if (object.MemoryLimit != null)
                message.MemoryLimit = object.MemoryLimit | 0;
            if (object.Active != null)
                message.Active = Boolean(object.Active);
            if (object.Host != null)
                message.Host = String(object.Host);
            if (object.MaxTenants != null)
                message.MaxTenants = object.MaxTenants | 0;
            if (object.HostLocation != null)
                message.HostLocation = String(object.HostLocation);
            if (object.SaPassword != null)
                message.SaPassword = String(object.SaPassword);
            if (object.InstanceType != null)
                message.InstanceType = String(object.InstanceType);
            if (object.VolumeID != null)
                if ($util.Long)
                    (message.VolumeID = $util.Long.fromValue(object.VolumeID)).unsigned = false;
                else if (typeof object.VolumeID === "string")
                    message.VolumeID = parseInt(object.VolumeID, 10);
                else if (typeof object.VolumeID === "number")
                    message.VolumeID = object.VolumeID;
                else if (typeof object.VolumeID === "object")
                    message.VolumeID = new $util.LongBits(object.VolumeID.low >>> 0, object.VolumeID.high >>> 0).toNumber();
            return message;
        };

        /**
         * Creates a plain object from a MssqlInstance message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.MssqlInstance
         * @static
         * @param {common.MssqlInstance} message MssqlInstance
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MssqlInstance.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.ID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.ID = options.longs === String ? "0" : 0;
                object.Name = "";
                object.Collation = "";
                object.Edition = "";
                object.MemoryLimit = 0;
                object.Active = false;
                object.Host = "";
                object.MaxTenants = 0;
                object.HostLocation = "";
                object.SaPassword = "";
                object.InstanceType = "";
                if ($util.Long) {
                    var long = new $util.Long(0, 0, false);
                    object.VolumeID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.VolumeID = options.longs === String ? "0" : 0;
            }
            if (message.ID != null && message.hasOwnProperty("ID"))
                if (typeof message.ID === "number")
                    object.ID = options.longs === String ? String(message.ID) : message.ID;
                else
                    object.ID = options.longs === String ? $util.Long.prototype.toString.call(message.ID) : options.longs === Number ? new $util.LongBits(message.ID.low >>> 0, message.ID.high >>> 0).toNumber() : message.ID;
            if (message.Name != null && message.hasOwnProperty("Name"))
                object.Name = message.Name;
            if (message.Collation != null && message.hasOwnProperty("Collation"))
                object.Collation = message.Collation;
            if (message.Edition != null && message.hasOwnProperty("Edition"))
                object.Edition = message.Edition;
            if (message.MemoryLimit != null && message.hasOwnProperty("MemoryLimit"))
                object.MemoryLimit = message.MemoryLimit;
            if (message.Active != null && message.hasOwnProperty("Active"))
                object.Active = message.Active;
            if (message.Host != null && message.hasOwnProperty("Host"))
                object.Host = message.Host;
            if (message.MaxTenants != null && message.hasOwnProperty("MaxTenants"))
                object.MaxTenants = message.MaxTenants;
            if (message.HostLocation != null && message.hasOwnProperty("HostLocation"))
                object.HostLocation = message.HostLocation;
            if (message.SaPassword != null && message.hasOwnProperty("SaPassword"))
                object.SaPassword = message.SaPassword;
            if (message.InstanceType != null && message.hasOwnProperty("InstanceType"))
                object.InstanceType = message.InstanceType;
            if (message.VolumeID != null && message.hasOwnProperty("VolumeID"))
                if (typeof message.VolumeID === "number")
                    object.VolumeID = options.longs === String ? String(message.VolumeID) : message.VolumeID;
                else
                    object.VolumeID = options.longs === String ? $util.Long.prototype.toString.call(message.VolumeID) : options.longs === Number ? new $util.LongBits(message.VolumeID.low >>> 0, message.VolumeID.high >>> 0).toNumber() : message.VolumeID;
            return object;
        };

        /**
         * Converts this MssqlInstance to JSON.
         * @function toJSON
         * @memberof common.MssqlInstance
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        MssqlInstance.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MssqlInstance;
    })();

    common.SessionStatus = (function() {

        /**
         * Properties of a SessionStatus.
         * @memberof common
         * @interface ISessionStatus
         * @property {common.SessionStatus.StatusType|null} [Type] SessionStatus Type
         * @property {string|null} [Message] SessionStatus Message
         * @property {boolean|null} [UpdateLine] SessionStatus UpdateLine
         * @property {boolean|null} [Final] SessionStatus Final
         * @property {common.IFileDownload|null} [FileD] SessionStatus FileD
         */

        /**
         * Constructs a new SessionStatus.
         * @memberof common
         * @classdesc Represents a SessionStatus.
         * @implements ISessionStatus
         * @constructor
         * @param {common.ISessionStatus=} [properties] Properties to set
         */
        function SessionStatus(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionStatus Type.
         * @member {common.SessionStatus.StatusType} Type
         * @memberof common.SessionStatus
         * @instance
         */
        SessionStatus.prototype.Type = 0;

        /**
         * SessionStatus Message.
         * @member {string} Message
         * @memberof common.SessionStatus
         * @instance
         */
        SessionStatus.prototype.Message = "";

        /**
         * SessionStatus UpdateLine.
         * @member {boolean} UpdateLine
         * @memberof common.SessionStatus
         * @instance
         */
        SessionStatus.prototype.UpdateLine = false;

        /**
         * SessionStatus Final.
         * @member {boolean} Final
         * @memberof common.SessionStatus
         * @instance
         */
        SessionStatus.prototype.Final = false;

        /**
         * SessionStatus FileD.
         * @member {common.IFileDownload|null|undefined} FileD
         * @memberof common.SessionStatus
         * @instance
         */
        SessionStatus.prototype.FileD = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * SessionStatus Data.
         * @member {"FileD"|undefined} Data
         * @memberof common.SessionStatus
         * @instance
         */
        Object.defineProperty(SessionStatus.prototype, "Data", {
            get: $util.oneOfGetter($oneOfFields = ["FileD"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new SessionStatus instance using the specified properties.
         * @function create
         * @memberof common.SessionStatus
         * @static
         * @param {common.ISessionStatus=} [properties] Properties to set
         * @returns {common.SessionStatus} SessionStatus instance
         */
        SessionStatus.create = function create(properties) {
            return new SessionStatus(properties);
        };

        /**
         * Encodes the specified SessionStatus message. Does not implicitly {@link common.SessionStatus.verify|verify} messages.
         * @function encode
         * @memberof common.SessionStatus
         * @static
         * @param {common.ISessionStatus} message SessionStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionStatus.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Type);
            if (message.Message != null && Object.hasOwnProperty.call(message, "Message"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Message);
            if (message.UpdateLine != null && Object.hasOwnProperty.call(message, "UpdateLine"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.UpdateLine);
            if (message.Final != null && Object.hasOwnProperty.call(message, "Final"))
                writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Final);
            if (message.FileD != null && Object.hasOwnProperty.call(message, "FileD"))
                $root.common.FileDownload.encode(message.FileD, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SessionStatus message, length delimited. Does not implicitly {@link common.SessionStatus.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.SessionStatus
         * @static
         * @param {common.ISessionStatus} message SessionStatus message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionStatus.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionStatus message from the specified reader or buffer.
         * @function decode
         * @memberof common.SessionStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.SessionStatus} SessionStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionStatus.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.SessionStatus();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Type = reader.int32();
                    break;
                case 2:
                    message.Message = reader.string();
                    break;
                case 3:
                    message.UpdateLine = reader.bool();
                    break;
                case 4:
                    message.Final = reader.bool();
                    break;
                case 5:
                    message.FileD = $root.common.FileDownload.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionStatus message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.SessionStatus
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.SessionStatus} SessionStatus
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionStatus.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionStatus message.
         * @function verify
         * @memberof common.SessionStatus
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionStatus.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            var properties = {};
            if (message.Type != null && message.hasOwnProperty("Type"))
                switch (message.Type) {
                default:
                    return "Type: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            if (message.Message != null && message.hasOwnProperty("Message"))
                if (!$util.isString(message.Message))
                    return "Message: string expected";
            if (message.UpdateLine != null && message.hasOwnProperty("UpdateLine"))
                if (typeof message.UpdateLine !== "boolean")
                    return "UpdateLine: boolean expected";
            if (message.Final != null && message.hasOwnProperty("Final"))
                if (typeof message.Final !== "boolean")
                    return "Final: boolean expected";
            if (message.FileD != null && message.hasOwnProperty("FileD")) {
                properties.Data = 1;
                {
                    var error = $root.common.FileDownload.verify(message.FileD);
                    if (error)
                        return "FileD." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SessionStatus message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.SessionStatus
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.SessionStatus} SessionStatus
         */
        SessionStatus.fromObject = function fromObject(object) {
            if (object instanceof $root.common.SessionStatus)
                return object;
            var message = new $root.common.SessionStatus();
            switch (object.Type) {
            case "Info":
            case 0:
                message.Type = 0;
                break;
            case "Error":
            case 1:
                message.Type = 1;
                break;
            case "CriticalError":
            case 2:
                message.Type = 2;
                break;
            }
            if (object.Message != null)
                message.Message = String(object.Message);
            if (object.UpdateLine != null)
                message.UpdateLine = Boolean(object.UpdateLine);
            if (object.Final != null)
                message.Final = Boolean(object.Final);
            if (object.FileD != null) {
                if (typeof object.FileD !== "object")
                    throw TypeError(".common.SessionStatus.FileD: object expected");
                message.FileD = $root.common.FileDownload.fromObject(object.FileD);
            }
            return message;
        };

        /**
         * Creates a plain object from a SessionStatus message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.SessionStatus
         * @static
         * @param {common.SessionStatus} message SessionStatus
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionStatus.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.Type = options.enums === String ? "Info" : 0;
                object.Message = "";
                object.UpdateLine = false;
                object.Final = false;
            }
            if (message.Type != null && message.hasOwnProperty("Type"))
                object.Type = options.enums === String ? $root.common.SessionStatus.StatusType[message.Type] : message.Type;
            if (message.Message != null && message.hasOwnProperty("Message"))
                object.Message = message.Message;
            if (message.UpdateLine != null && message.hasOwnProperty("UpdateLine"))
                object.UpdateLine = message.UpdateLine;
            if (message.Final != null && message.hasOwnProperty("Final"))
                object.Final = message.Final;
            if (message.FileD != null && message.hasOwnProperty("FileD")) {
                object.FileD = $root.common.FileDownload.toObject(message.FileD, options);
                if (options.oneofs)
                    object.Data = "FileD";
            }
            return object;
        };

        /**
         * Converts this SessionStatus to JSON.
         * @function toJSON
         * @memberof common.SessionStatus
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionStatus.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        /**
         * StatusType enum.
         * @name common.SessionStatus.StatusType
         * @enum {number}
         * @property {number} Info=0 Info value
         * @property {number} Error=1 Error value
         * @property {number} CriticalError=2 CriticalError value
         */
        SessionStatus.StatusType = (function() {
            var valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "Info"] = 0;
            values[valuesById[1] = "Error"] = 1;
            values[valuesById[2] = "CriticalError"] = 2;
            return values;
        })();

        return SessionStatus;
    })();

    common.FileDownload = (function() {

        /**
         * Properties of a FileDownload.
         * @memberof common
         * @interface IFileDownload
         * @property {string|null} [Url] FileDownload Url
         * @property {number|null} [FileSize] FileDownload FileSize
         */

        /**
         * Constructs a new FileDownload.
         * @memberof common
         * @classdesc Represents a FileDownload.
         * @implements IFileDownload
         * @constructor
         * @param {common.IFileDownload=} [properties] Properties to set
         */
        function FileDownload(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FileDownload Url.
         * @member {string} Url
         * @memberof common.FileDownload
         * @instance
         */
        FileDownload.prototype.Url = "";

        /**
         * FileDownload FileSize.
         * @member {number} FileSize
         * @memberof common.FileDownload
         * @instance
         */
        FileDownload.prototype.FileSize = 0;

        /**
         * Creates a new FileDownload instance using the specified properties.
         * @function create
         * @memberof common.FileDownload
         * @static
         * @param {common.IFileDownload=} [properties] Properties to set
         * @returns {common.FileDownload} FileDownload instance
         */
        FileDownload.create = function create(properties) {
            return new FileDownload(properties);
        };

        /**
         * Encodes the specified FileDownload message. Does not implicitly {@link common.FileDownload.verify|verify} messages.
         * @function encode
         * @memberof common.FileDownload
         * @static
         * @param {common.IFileDownload} message FileDownload message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileDownload.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Url != null && Object.hasOwnProperty.call(message, "Url"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Url);
            if (message.FileSize != null && Object.hasOwnProperty.call(message, "FileSize"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.FileSize);
            return writer;
        };

        /**
         * Encodes the specified FileDownload message, length delimited. Does not implicitly {@link common.FileDownload.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.FileDownload
         * @static
         * @param {common.IFileDownload} message FileDownload message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FileDownload.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FileDownload message from the specified reader or buffer.
         * @function decode
         * @memberof common.FileDownload
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.FileDownload} FileDownload
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileDownload.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.FileDownload();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Url = reader.string();
                    break;
                case 2:
                    message.FileSize = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FileDownload message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.FileDownload
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.FileDownload} FileDownload
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FileDownload.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FileDownload message.
         * @function verify
         * @memberof common.FileDownload
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FileDownload.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Url != null && message.hasOwnProperty("Url"))
                if (!$util.isString(message.Url))
                    return "Url: string expected";
            if (message.FileSize != null && message.hasOwnProperty("FileSize"))
                if (typeof message.FileSize !== "number")
                    return "FileSize: number expected";
            return null;
        };

        /**
         * Creates a FileDownload message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.FileDownload
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.FileDownload} FileDownload
         */
        FileDownload.fromObject = function fromObject(object) {
            if (object instanceof $root.common.FileDownload)
                return object;
            var message = new $root.common.FileDownload();
            if (object.Url != null)
                message.Url = String(object.Url);
            if (object.FileSize != null)
                message.FileSize = Number(object.FileSize);
            return message;
        };

        /**
         * Creates a plain object from a FileDownload message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.FileDownload
         * @static
         * @param {common.FileDownload} message FileDownload
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FileDownload.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.Url = "";
                object.FileSize = 0;
            }
            if (message.Url != null && message.hasOwnProperty("Url"))
                object.Url = message.Url;
            if (message.FileSize != null && message.hasOwnProperty("FileSize"))
                object.FileSize = options.json && !isFinite(message.FileSize) ? String(message.FileSize) : message.FileSize;
            return object;
        };

        /**
         * Converts this FileDownload to JSON.
         * @function toJSON
         * @memberof common.FileDownload
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FileDownload.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FileDownload;
    })();

    common.SessionRq = (function() {

        /**
         * Properties of a SessionRq.
         * @memberof common
         * @interface ISessionRq
         * @property {string|null} [Session] SessionRq Session
         */

        /**
         * Constructs a new SessionRq.
         * @memberof common
         * @classdesc Represents a SessionRq.
         * @implements ISessionRq
         * @constructor
         * @param {common.ISessionRq=} [properties] Properties to set
         */
        function SessionRq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionRq Session.
         * @member {string} Session
         * @memberof common.SessionRq
         * @instance
         */
        SessionRq.prototype.Session = "";

        /**
         * Creates a new SessionRq instance using the specified properties.
         * @function create
         * @memberof common.SessionRq
         * @static
         * @param {common.ISessionRq=} [properties] Properties to set
         * @returns {common.SessionRq} SessionRq instance
         */
        SessionRq.create = function create(properties) {
            return new SessionRq(properties);
        };

        /**
         * Encodes the specified SessionRq message. Does not implicitly {@link common.SessionRq.verify|verify} messages.
         * @function encode
         * @memberof common.SessionRq
         * @static
         * @param {common.ISessionRq} message SessionRq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionRq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Session);
            return writer;
        };

        /**
         * Encodes the specified SessionRq message, length delimited. Does not implicitly {@link common.SessionRq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.SessionRq
         * @static
         * @param {common.ISessionRq} message SessionRq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionRq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionRq message from the specified reader or buffer.
         * @function decode
         * @memberof common.SessionRq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.SessionRq} SessionRq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionRq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.SessionRq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Session = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionRq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.SessionRq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.SessionRq} SessionRq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionRq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionRq message.
         * @function verify
         * @memberof common.SessionRq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionRq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Session != null && message.hasOwnProperty("Session"))
                if (!$util.isString(message.Session))
                    return "Session: string expected";
            return null;
        };

        /**
         * Creates a SessionRq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.SessionRq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.SessionRq} SessionRq
         */
        SessionRq.fromObject = function fromObject(object) {
            if (object instanceof $root.common.SessionRq)
                return object;
            var message = new $root.common.SessionRq();
            if (object.Session != null)
                message.Session = String(object.Session);
            return message;
        };

        /**
         * Creates a plain object from a SessionRq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.SessionRq
         * @static
         * @param {common.SessionRq} message SessionRq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionRq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.Session = "";
            if (message.Session != null && message.hasOwnProperty("Session"))
                object.Session = message.Session;
            return object;
        };

        /**
         * Converts this SessionRq to JSON.
         * @function toJSON
         * @memberof common.SessionRq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionRq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SessionRq;
    })();

    common.SessionRs = (function() {

        /**
         * Properties of a SessionRs.
         * @memberof common
         * @interface ISessionRs
         * @property {Array.<common.ISessionStatus>|null} [Statuses] SessionRs Statuses
         */

        /**
         * Constructs a new SessionRs.
         * @memberof common
         * @classdesc Represents a SessionRs.
         * @implements ISessionRs
         * @constructor
         * @param {common.ISessionRs=} [properties] Properties to set
         */
        function SessionRs(properties) {
            this.Statuses = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionRs Statuses.
         * @member {Array.<common.ISessionStatus>} Statuses
         * @memberof common.SessionRs
         * @instance
         */
        SessionRs.prototype.Statuses = $util.emptyArray;

        /**
         * Creates a new SessionRs instance using the specified properties.
         * @function create
         * @memberof common.SessionRs
         * @static
         * @param {common.ISessionRs=} [properties] Properties to set
         * @returns {common.SessionRs} SessionRs instance
         */
        SessionRs.create = function create(properties) {
            return new SessionRs(properties);
        };

        /**
         * Encodes the specified SessionRs message. Does not implicitly {@link common.SessionRs.verify|verify} messages.
         * @function encode
         * @memberof common.SessionRs
         * @static
         * @param {common.ISessionRs} message SessionRs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionRs.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Statuses != null && message.Statuses.length)
                for (var i = 0; i < message.Statuses.length; ++i)
                    $root.common.SessionStatus.encode(message.Statuses[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SessionRs message, length delimited. Does not implicitly {@link common.SessionRs.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.SessionRs
         * @static
         * @param {common.ISessionRs} message SessionRs message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionRs.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionRs message from the specified reader or buffer.
         * @function decode
         * @memberof common.SessionRs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.SessionRs} SessionRs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionRs.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.SessionRs();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.Statuses && message.Statuses.length))
                        message.Statuses = [];
                    message.Statuses.push($root.common.SessionStatus.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionRs message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.SessionRs
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.SessionRs} SessionRs
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionRs.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionRs message.
         * @function verify
         * @memberof common.SessionRs
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionRs.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Statuses != null && message.hasOwnProperty("Statuses")) {
                if (!Array.isArray(message.Statuses))
                    return "Statuses: array expected";
                for (var i = 0; i < message.Statuses.length; ++i) {
                    var error = $root.common.SessionStatus.verify(message.Statuses[i]);
                    if (error)
                        return "Statuses." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SessionRs message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.SessionRs
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.SessionRs} SessionRs
         */
        SessionRs.fromObject = function fromObject(object) {
            if (object instanceof $root.common.SessionRs)
                return object;
            var message = new $root.common.SessionRs();
            if (object.Statuses) {
                if (!Array.isArray(object.Statuses))
                    throw TypeError(".common.SessionRs.Statuses: array expected");
                message.Statuses = [];
                for (var i = 0; i < object.Statuses.length; ++i) {
                    if (typeof object.Statuses[i] !== "object")
                        throw TypeError(".common.SessionRs.Statuses: object expected");
                    message.Statuses[i] = $root.common.SessionStatus.fromObject(object.Statuses[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SessionRs message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.SessionRs
         * @static
         * @param {common.SessionRs} message SessionRs
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionRs.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.Statuses = [];
            if (message.Statuses && message.Statuses.length) {
                object.Statuses = [];
                for (var j = 0; j < message.Statuses.length; ++j)
                    object.Statuses[j] = $root.common.SessionStatus.toObject(message.Statuses[j], options);
            }
            return object;
        };

        /**
         * Converts this SessionRs to JSON.
         * @function toJSON
         * @memberof common.SessionRs
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionRs.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SessionRs;
    })();

    common.SessionID = (function() {

        /**
         * Properties of a SessionID.
         * @memberof common
         * @interface ISessionID
         * @property {string|null} [SessionID] SessionID SessionID
         */

        /**
         * Constructs a new SessionID.
         * @memberof common
         * @classdesc Represents a SessionID.
         * @implements ISessionID
         * @constructor
         * @param {common.ISessionID=} [properties] Properties to set
         */
        function SessionID(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SessionID SessionID.
         * @member {string} SessionID
         * @memberof common.SessionID
         * @instance
         */
        SessionID.prototype.SessionID = "";

        /**
         * Creates a new SessionID instance using the specified properties.
         * @function create
         * @memberof common.SessionID
         * @static
         * @param {common.ISessionID=} [properties] Properties to set
         * @returns {common.SessionID} SessionID instance
         */
        SessionID.create = function create(properties) {
            return new SessionID(properties);
        };

        /**
         * Encodes the specified SessionID message. Does not implicitly {@link common.SessionID.verify|verify} messages.
         * @function encode
         * @memberof common.SessionID
         * @static
         * @param {common.ISessionID} message SessionID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionID.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.SessionID != null && Object.hasOwnProperty.call(message, "SessionID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.SessionID);
            return writer;
        };

        /**
         * Encodes the specified SessionID message, length delimited. Does not implicitly {@link common.SessionID.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.SessionID
         * @static
         * @param {common.ISessionID} message SessionID message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SessionID.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SessionID message from the specified reader or buffer.
         * @function decode
         * @memberof common.SessionID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.SessionID} SessionID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionID.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.SessionID();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.SessionID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SessionID message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.SessionID
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.SessionID} SessionID
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SessionID.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SessionID message.
         * @function verify
         * @memberof common.SessionID
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SessionID.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.SessionID != null && message.hasOwnProperty("SessionID"))
                if (!$util.isString(message.SessionID))
                    return "SessionID: string expected";
            return null;
        };

        /**
         * Creates a SessionID message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.SessionID
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.SessionID} SessionID
         */
        SessionID.fromObject = function fromObject(object) {
            if (object instanceof $root.common.SessionID)
                return object;
            var message = new $root.common.SessionID();
            if (object.SessionID != null)
                message.SessionID = String(object.SessionID);
            return message;
        };

        /**
         * Creates a plain object from a SessionID message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.SessionID
         * @static
         * @param {common.SessionID} message SessionID
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SessionID.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.SessionID = "";
            if (message.SessionID != null && message.hasOwnProperty("SessionID"))
                object.SessionID = message.SessionID;
            return object;
        };

        /**
         * Converts this SessionID to JSON.
         * @function toJSON
         * @memberof common.SessionID
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SessionID.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SessionID;
    })();

    common.TenantDynamoTable = (function() {

        /**
         * Properties of a TenantDynamoTable.
         * @memberof common
         * @interface ITenantDynamoTable
         * @property {string|null} [Tablename] TenantDynamoTable Tablename
         * @property {Uint8Array|null} [DataJson] TenantDynamoTable DataJson
         */

        /**
         * Constructs a new TenantDynamoTable.
         * @memberof common
         * @classdesc Represents a TenantDynamoTable.
         * @implements ITenantDynamoTable
         * @constructor
         * @param {common.ITenantDynamoTable=} [properties] Properties to set
         */
        function TenantDynamoTable(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TenantDynamoTable Tablename.
         * @member {string} Tablename
         * @memberof common.TenantDynamoTable
         * @instance
         */
        TenantDynamoTable.prototype.Tablename = "";

        /**
         * TenantDynamoTable DataJson.
         * @member {Uint8Array} DataJson
         * @memberof common.TenantDynamoTable
         * @instance
         */
        TenantDynamoTable.prototype.DataJson = $util.newBuffer([]);

        /**
         * Creates a new TenantDynamoTable instance using the specified properties.
         * @function create
         * @memberof common.TenantDynamoTable
         * @static
         * @param {common.ITenantDynamoTable=} [properties] Properties to set
         * @returns {common.TenantDynamoTable} TenantDynamoTable instance
         */
        TenantDynamoTable.create = function create(properties) {
            return new TenantDynamoTable(properties);
        };

        /**
         * Encodes the specified TenantDynamoTable message. Does not implicitly {@link common.TenantDynamoTable.verify|verify} messages.
         * @function encode
         * @memberof common.TenantDynamoTable
         * @static
         * @param {common.ITenantDynamoTable} message TenantDynamoTable message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantDynamoTable.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.Tablename != null && Object.hasOwnProperty.call(message, "Tablename"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.Tablename);
            if (message.DataJson != null && Object.hasOwnProperty.call(message, "DataJson"))
                writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.DataJson);
            return writer;
        };

        /**
         * Encodes the specified TenantDynamoTable message, length delimited. Does not implicitly {@link common.TenantDynamoTable.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.TenantDynamoTable
         * @static
         * @param {common.ITenantDynamoTable} message TenantDynamoTable message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantDynamoTable.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TenantDynamoTable message from the specified reader or buffer.
         * @function decode
         * @memberof common.TenantDynamoTable
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.TenantDynamoTable} TenantDynamoTable
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantDynamoTable.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.TenantDynamoTable();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.Tablename = reader.string();
                    break;
                case 2:
                    message.DataJson = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TenantDynamoTable message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.TenantDynamoTable
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.TenantDynamoTable} TenantDynamoTable
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantDynamoTable.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TenantDynamoTable message.
         * @function verify
         * @memberof common.TenantDynamoTable
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TenantDynamoTable.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.Tablename != null && message.hasOwnProperty("Tablename"))
                if (!$util.isString(message.Tablename))
                    return "Tablename: string expected";
            if (message.DataJson != null && message.hasOwnProperty("DataJson"))
                if (!(message.DataJson && typeof message.DataJson.length === "number" || $util.isString(message.DataJson)))
                    return "DataJson: buffer expected";
            return null;
        };

        /**
         * Creates a TenantDynamoTable message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.TenantDynamoTable
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.TenantDynamoTable} TenantDynamoTable
         */
        TenantDynamoTable.fromObject = function fromObject(object) {
            if (object instanceof $root.common.TenantDynamoTable)
                return object;
            var message = new $root.common.TenantDynamoTable();
            if (object.Tablename != null)
                message.Tablename = String(object.Tablename);
            if (object.DataJson != null)
                if (typeof object.DataJson === "string")
                    $util.base64.decode(object.DataJson, message.DataJson = $util.newBuffer($util.base64.length(object.DataJson)), 0);
                else if (object.DataJson.length)
                    message.DataJson = object.DataJson;
            return message;
        };

        /**
         * Creates a plain object from a TenantDynamoTable message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.TenantDynamoTable
         * @static
         * @param {common.TenantDynamoTable} message TenantDynamoTable
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TenantDynamoTable.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.Tablename = "";
                if (options.bytes === String)
                    object.DataJson = "";
                else {
                    object.DataJson = [];
                    if (options.bytes !== Array)
                        object.DataJson = $util.newBuffer(object.DataJson);
                }
            }
            if (message.Tablename != null && message.hasOwnProperty("Tablename"))
                object.Tablename = message.Tablename;
            if (message.DataJson != null && message.hasOwnProperty("DataJson"))
                object.DataJson = options.bytes === String ? $util.base64.encode(message.DataJson, 0, message.DataJson.length) : options.bytes === Array ? Array.prototype.slice.call(message.DataJson) : message.DataJson;
            return object;
        };

        /**
         * Converts this TenantDynamoTable to JSON.
         * @function toJSON
         * @memberof common.TenantDynamoTable
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TenantDynamoTable.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TenantDynamoTable;
    })();

    common.TenantDynamoData = (function() {

        /**
         * Properties of a TenantDynamoData.
         * @memberof common
         * @interface ITenantDynamoData
         * @property {Array.<common.ITenantDynamoTable>|null} [TablesData] TenantDynamoData TablesData
         */

        /**
         * Constructs a new TenantDynamoData.
         * @memberof common
         * @classdesc Represents a TenantDynamoData.
         * @implements ITenantDynamoData
         * @constructor
         * @param {common.ITenantDynamoData=} [properties] Properties to set
         */
        function TenantDynamoData(properties) {
            this.TablesData = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TenantDynamoData TablesData.
         * @member {Array.<common.ITenantDynamoTable>} TablesData
         * @memberof common.TenantDynamoData
         * @instance
         */
        TenantDynamoData.prototype.TablesData = $util.emptyArray;

        /**
         * Creates a new TenantDynamoData instance using the specified properties.
         * @function create
         * @memberof common.TenantDynamoData
         * @static
         * @param {common.ITenantDynamoData=} [properties] Properties to set
         * @returns {common.TenantDynamoData} TenantDynamoData instance
         */
        TenantDynamoData.create = function create(properties) {
            return new TenantDynamoData(properties);
        };

        /**
         * Encodes the specified TenantDynamoData message. Does not implicitly {@link common.TenantDynamoData.verify|verify} messages.
         * @function encode
         * @memberof common.TenantDynamoData
         * @static
         * @param {common.ITenantDynamoData} message TenantDynamoData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantDynamoData.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TablesData != null && message.TablesData.length)
                for (var i = 0; i < message.TablesData.length; ++i)
                    $root.common.TenantDynamoTable.encode(message.TablesData[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified TenantDynamoData message, length delimited. Does not implicitly {@link common.TenantDynamoData.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.TenantDynamoData
         * @static
         * @param {common.ITenantDynamoData} message TenantDynamoData message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantDynamoData.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TenantDynamoData message from the specified reader or buffer.
         * @function decode
         * @memberof common.TenantDynamoData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.TenantDynamoData} TenantDynamoData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantDynamoData.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.TenantDynamoData();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.TablesData && message.TablesData.length))
                        message.TablesData = [];
                    message.TablesData.push($root.common.TenantDynamoTable.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TenantDynamoData message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.TenantDynamoData
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.TenantDynamoData} TenantDynamoData
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantDynamoData.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TenantDynamoData message.
         * @function verify
         * @memberof common.TenantDynamoData
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TenantDynamoData.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TablesData != null && message.hasOwnProperty("TablesData")) {
                if (!Array.isArray(message.TablesData))
                    return "TablesData: array expected";
                for (var i = 0; i < message.TablesData.length; ++i) {
                    var error = $root.common.TenantDynamoTable.verify(message.TablesData[i]);
                    if (error)
                        return "TablesData." + error;
                }
            }
            return null;
        };

        /**
         * Creates a TenantDynamoData message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.TenantDynamoData
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.TenantDynamoData} TenantDynamoData
         */
        TenantDynamoData.fromObject = function fromObject(object) {
            if (object instanceof $root.common.TenantDynamoData)
                return object;
            var message = new $root.common.TenantDynamoData();
            if (object.TablesData) {
                if (!Array.isArray(object.TablesData))
                    throw TypeError(".common.TenantDynamoData.TablesData: array expected");
                message.TablesData = [];
                for (var i = 0; i < object.TablesData.length; ++i) {
                    if (typeof object.TablesData[i] !== "object")
                        throw TypeError(".common.TenantDynamoData.TablesData: object expected");
                    message.TablesData[i] = $root.common.TenantDynamoTable.fromObject(object.TablesData[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a TenantDynamoData message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.TenantDynamoData
         * @static
         * @param {common.TenantDynamoData} message TenantDynamoData
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TenantDynamoData.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.TablesData = [];
            if (message.TablesData && message.TablesData.length) {
                object.TablesData = [];
                for (var j = 0; j < message.TablesData.length; ++j)
                    object.TablesData[j] = $root.common.TenantDynamoTable.toObject(message.TablesData[j], options);
            }
            return object;
        };

        /**
         * Converts this TenantDynamoData to JSON.
         * @function toJSON
         * @memberof common.TenantDynamoData
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TenantDynamoData.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TenantDynamoData;
    })();

    common.TenantDynamoDataRq = (function() {

        /**
         * Properties of a TenantDynamoDataRq.
         * @memberof common
         * @interface ITenantDynamoDataRq
         * @property {string|null} [TenantID] TenantDynamoDataRq TenantID
         */

        /**
         * Constructs a new TenantDynamoDataRq.
         * @memberof common
         * @classdesc Represents a TenantDynamoDataRq.
         * @implements ITenantDynamoDataRq
         * @constructor
         * @param {common.ITenantDynamoDataRq=} [properties] Properties to set
         */
        function TenantDynamoDataRq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * TenantDynamoDataRq TenantID.
         * @member {string} TenantID
         * @memberof common.TenantDynamoDataRq
         * @instance
         */
        TenantDynamoDataRq.prototype.TenantID = "";

        /**
         * Creates a new TenantDynamoDataRq instance using the specified properties.
         * @function create
         * @memberof common.TenantDynamoDataRq
         * @static
         * @param {common.ITenantDynamoDataRq=} [properties] Properties to set
         * @returns {common.TenantDynamoDataRq} TenantDynamoDataRq instance
         */
        TenantDynamoDataRq.create = function create(properties) {
            return new TenantDynamoDataRq(properties);
        };

        /**
         * Encodes the specified TenantDynamoDataRq message. Does not implicitly {@link common.TenantDynamoDataRq.verify|verify} messages.
         * @function encode
         * @memberof common.TenantDynamoDataRq
         * @static
         * @param {common.ITenantDynamoDataRq} message TenantDynamoDataRq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantDynamoDataRq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.TenantID != null && Object.hasOwnProperty.call(message, "TenantID"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.TenantID);
            return writer;
        };

        /**
         * Encodes the specified TenantDynamoDataRq message, length delimited. Does not implicitly {@link common.TenantDynamoDataRq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof common.TenantDynamoDataRq
         * @static
         * @param {common.ITenantDynamoDataRq} message TenantDynamoDataRq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        TenantDynamoDataRq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a TenantDynamoDataRq message from the specified reader or buffer.
         * @function decode
         * @memberof common.TenantDynamoDataRq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {common.TenantDynamoDataRq} TenantDynamoDataRq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantDynamoDataRq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.common.TenantDynamoDataRq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.TenantID = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a TenantDynamoDataRq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof common.TenantDynamoDataRq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {common.TenantDynamoDataRq} TenantDynamoDataRq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        TenantDynamoDataRq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a TenantDynamoDataRq message.
         * @function verify
         * @memberof common.TenantDynamoDataRq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        TenantDynamoDataRq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                if (!$util.isString(message.TenantID))
                    return "TenantID: string expected";
            return null;
        };

        /**
         * Creates a TenantDynamoDataRq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof common.TenantDynamoDataRq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {common.TenantDynamoDataRq} TenantDynamoDataRq
         */
        TenantDynamoDataRq.fromObject = function fromObject(object) {
            if (object instanceof $root.common.TenantDynamoDataRq)
                return object;
            var message = new $root.common.TenantDynamoDataRq();
            if (object.TenantID != null)
                message.TenantID = String(object.TenantID);
            return message;
        };

        /**
         * Creates a plain object from a TenantDynamoDataRq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof common.TenantDynamoDataRq
         * @static
         * @param {common.TenantDynamoDataRq} message TenantDynamoDataRq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        TenantDynamoDataRq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.TenantID = "";
            if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                object.TenantID = message.TenantID;
            return object;
        };

        /**
         * Converts this TenantDynamoDataRq to JSON.
         * @function toJSON
         * @memberof common.TenantDynamoDataRq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        TenantDynamoDataRq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TenantDynamoDataRq;
    })();

    return common;
})();

$root.priority = (function() {

    /**
     * Namespace priority.
     * @exports priority
     * @namespace
     */
    var priority = {};

    priority.netitems = (function() {

        /**
         * Namespace netitems.
         * @memberof priority
         * @namespace
         */
        var netitems = {};

        netitems.form = (function() {

            /**
             * Namespace form.
             * @memberof priority.netitems
             * @namespace
             */
            var form = {};

            form.StartRq = (function() {

                /**
                 * Properties of a StartRq.
                 * @memberof priority.netitems.form
                 * @interface IStartRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] StartRq Properties
                 * @property {string|null} [Fname] StartRq Fname
                 * @property {string|null} [LinkFile] StartRq LinkFile
                 * @property {string|null} [LinkID] StartRq LinkID
                 * @property {boolean|null} [SendTitles] StartRq SendTitles
                 * @property {Array.<string>|null} [hiddenFields] StartRq hiddenFields
                 */

                /**
                 * Constructs a new StartRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a StartRq.
                 * @implements IStartRq
                 * @constructor
                 * @param {priority.netitems.form.IStartRq=} [properties] Properties to set
                 */
                function StartRq(properties) {
                    this.hiddenFields = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.StartRq
                 * @instance
                 */
                StartRq.prototype.Properties = null;

                /**
                 * StartRq Fname.
                 * @member {string} Fname
                 * @memberof priority.netitems.form.StartRq
                 * @instance
                 */
                StartRq.prototype.Fname = "";

                /**
                 * StartRq LinkFile.
                 * @member {string} LinkFile
                 * @memberof priority.netitems.form.StartRq
                 * @instance
                 */
                StartRq.prototype.LinkFile = "";

                /**
                 * StartRq LinkID.
                 * @member {string} LinkID
                 * @memberof priority.netitems.form.StartRq
                 * @instance
                 */
                StartRq.prototype.LinkID = "";

                /**
                 * StartRq SendTitles.
                 * @member {boolean} SendTitles
                 * @memberof priority.netitems.form.StartRq
                 * @instance
                 */
                StartRq.prototype.SendTitles = false;

                /**
                 * StartRq hiddenFields.
                 * @member {Array.<string>} hiddenFields
                 * @memberof priority.netitems.form.StartRq
                 * @instance
                 */
                StartRq.prototype.hiddenFields = $util.emptyArray;

                /**
                 * Creates a new StartRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.StartRq
                 * @static
                 * @param {priority.netitems.form.IStartRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.StartRq} StartRq instance
                 */
                StartRq.create = function create(properties) {
                    return new StartRq(properties);
                };

                /**
                 * Encodes the specified StartRq message. Does not implicitly {@link priority.netitems.form.StartRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.StartRq
                 * @static
                 * @param {priority.netitems.form.IStartRq} message StartRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Fname != null && Object.hasOwnProperty.call(message, "Fname"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Fname);
                    if (message.LinkFile != null && Object.hasOwnProperty.call(message, "LinkFile"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.LinkFile);
                    if (message.LinkID != null && Object.hasOwnProperty.call(message, "LinkID"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.LinkID);
                    if (message.SendTitles != null && Object.hasOwnProperty.call(message, "SendTitles"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.SendTitles);
                    if (message.hiddenFields != null && message.hiddenFields.length)
                        for (var i = 0; i < message.hiddenFields.length; ++i)
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.hiddenFields[i]);
                    return writer;
                };

                /**
                 * Encodes the specified StartRq message, length delimited. Does not implicitly {@link priority.netitems.form.StartRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.StartRq
                 * @static
                 * @param {priority.netitems.form.IStartRq} message StartRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.StartRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.StartRq} StartRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.StartRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Fname = reader.string();
                            break;
                        case 3:
                            message.LinkFile = reader.string();
                            break;
                        case 4:
                            message.LinkID = reader.string();
                            break;
                        case 6:
                            message.SendTitles = reader.bool();
                            break;
                        case 7:
                            if (!(message.hiddenFields && message.hiddenFields.length))
                                message.hiddenFields = [];
                            message.hiddenFields.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.StartRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.StartRq} StartRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartRq message.
                 * @function verify
                 * @memberof priority.netitems.form.StartRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        if (!$util.isString(message.Fname))
                            return "Fname: string expected";
                    if (message.LinkFile != null && message.hasOwnProperty("LinkFile"))
                        if (!$util.isString(message.LinkFile))
                            return "LinkFile: string expected";
                    if (message.LinkID != null && message.hasOwnProperty("LinkID"))
                        if (!$util.isString(message.LinkID))
                            return "LinkID: string expected";
                    if (message.SendTitles != null && message.hasOwnProperty("SendTitles"))
                        if (typeof message.SendTitles !== "boolean")
                            return "SendTitles: boolean expected";
                    if (message.hiddenFields != null && message.hasOwnProperty("hiddenFields")) {
                        if (!Array.isArray(message.hiddenFields))
                            return "hiddenFields: array expected";
                        for (var i = 0; i < message.hiddenFields.length; ++i)
                            if (!$util.isString(message.hiddenFields[i]))
                                return "hiddenFields: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a StartRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.StartRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.StartRq} StartRq
                 */
                StartRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.StartRq)
                        return object;
                    var message = new $root.priority.netitems.form.StartRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.StartRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Fname != null)
                        message.Fname = String(object.Fname);
                    if (object.LinkFile != null)
                        message.LinkFile = String(object.LinkFile);
                    if (object.LinkID != null)
                        message.LinkID = String(object.LinkID);
                    if (object.SendTitles != null)
                        message.SendTitles = Boolean(object.SendTitles);
                    if (object.hiddenFields) {
                        if (!Array.isArray(object.hiddenFields))
                            throw TypeError(".priority.netitems.form.StartRq.hiddenFields: array expected");
                        message.hiddenFields = [];
                        for (var i = 0; i < object.hiddenFields.length; ++i)
                            message.hiddenFields[i] = String(object.hiddenFields[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StartRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.StartRq
                 * @static
                 * @param {priority.netitems.form.StartRq} message StartRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.hiddenFields = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Fname = "";
                        object.LinkFile = "";
                        object.LinkID = "";
                        object.SendTitles = false;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        object.Fname = message.Fname;
                    if (message.LinkFile != null && message.hasOwnProperty("LinkFile"))
                        object.LinkFile = message.LinkFile;
                    if (message.LinkID != null && message.hasOwnProperty("LinkID"))
                        object.LinkID = message.LinkID;
                    if (message.SendTitles != null && message.hasOwnProperty("SendTitles"))
                        object.SendTitles = message.SendTitles;
                    if (message.hiddenFields && message.hiddenFields.length) {
                        object.hiddenFields = [];
                        for (var j = 0; j < message.hiddenFields.length; ++j)
                            object.hiddenFields[j] = message.hiddenFields[j];
                    }
                    return object;
                };

                /**
                 * Converts this StartRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.StartRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StartRq;
            })();

            form.StartRs = (function() {

                /**
                 * Properties of a StartRs.
                 * @memberof priority.netitems.form
                 * @interface IStartRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] StartRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] StartRs Messages
                 * @property {string|null} [Session] StartRs Session
                 * @property {string|null} [Title] StartRs Title
                 * @property {string|null} [BpmType] StartRs BpmType
                 * @property {number|Long|null} [Form] StartRs Form
                 * @property {boolean|null} [IsFavorite] StartRs IsFavorite
                 * @property {boolean|null} [Ishtml] StartRs Ishtml
                 * @property {number|Long|null} [ZoomField] StartRs ZoomField
                 * @property {boolean|null} [MultiComp] StartRs MultiComp
                 * @property {boolean|null} [OneLine] StartRs OneLine
                 * @property {boolean|null} [IsCustnotes] StartRs IsCustnotes
                 * @property {boolean|null} [HasMailinter] StartRs HasMailinter
                 * @property {boolean|null} [HasTaskUser] StartRs HasTaskUser
                 * @property {boolean|null} [DisableEditor] StartRs DisableEditor
                 * @property {boolean|null} [IsRecon] StartRs IsRecon
                 * @property {boolean|null} [Autoshow] StartRs Autoshow
                 * @property {boolean|null} [AppRefresh] StartRs AppRefresh
                 * @property {Array.<string>|null} [Dnames] StartRs Dnames
                 * @property {string|null} [DocName] StartRs DocName
                 * @property {boolean|null} [PicturePreview] StartRs PicturePreview
                 * @property {priority.netitems.form.StartRs.Priv|null} [Privileges] StartRs Privileges
                 * @property {number|Long|null} [Version] StartRs Version
                 * @property {string|null} [LockBy] StartRs LockBy
                 * @property {Object.<string,priority.netitems.form.RefreshLines>|null} [Refresh] StartRs Refresh
                 * @property {boolean|null} [MayDesignTabs] StartRs MayDesignTabs
                 * @property {boolean|null} [IsHtmlDisabled] StartRs IsHtmlDisabled
                 */

                /**
                 * Constructs a new StartRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a StartRs.
                 * @implements IStartRs
                 * @constructor
                 * @param {priority.netitems.form.IStartRs=} [properties] Properties to set
                 */
                function StartRs(properties) {
                    this.Messages = [];
                    this.Dnames = [];
                    this.Refresh = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StartRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Perf = null;

                /**
                 * StartRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Messages = $util.emptyArray;

                /**
                 * StartRs Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Session = "";

                /**
                 * StartRs Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Title = "";

                /**
                 * StartRs BpmType.
                 * @member {string} BpmType
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.BpmType = "";

                /**
                 * StartRs Form.
                 * @member {number|Long} Form
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Form = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * StartRs IsFavorite.
                 * @member {boolean} IsFavorite
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.IsFavorite = false;

                /**
                 * StartRs Ishtml.
                 * @member {boolean} Ishtml
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Ishtml = false;

                /**
                 * StartRs ZoomField.
                 * @member {number|Long} ZoomField
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.ZoomField = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * StartRs MultiComp.
                 * @member {boolean} MultiComp
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.MultiComp = false;

                /**
                 * StartRs OneLine.
                 * @member {boolean} OneLine
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.OneLine = false;

                /**
                 * StartRs IsCustnotes.
                 * @member {boolean} IsCustnotes
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.IsCustnotes = false;

                /**
                 * StartRs HasMailinter.
                 * @member {boolean} HasMailinter
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.HasMailinter = false;

                /**
                 * StartRs HasTaskUser.
                 * @member {boolean} HasTaskUser
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.HasTaskUser = false;

                /**
                 * StartRs DisableEditor.
                 * @member {boolean} DisableEditor
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.DisableEditor = false;

                /**
                 * StartRs IsRecon.
                 * @member {boolean} IsRecon
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.IsRecon = false;

                /**
                 * StartRs Autoshow.
                 * @member {boolean} Autoshow
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Autoshow = false;

                /**
                 * StartRs AppRefresh.
                 * @member {boolean} AppRefresh
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.AppRefresh = false;

                /**
                 * StartRs Dnames.
                 * @member {Array.<string>} Dnames
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Dnames = $util.emptyArray;

                /**
                 * StartRs DocName.
                 * @member {string} DocName
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.DocName = "";

                /**
                 * StartRs PicturePreview.
                 * @member {boolean} PicturePreview
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.PicturePreview = false;

                /**
                 * StartRs Privileges.
                 * @member {priority.netitems.form.StartRs.Priv} Privileges
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Privileges = 0;

                /**
                 * StartRs Version.
                 * @member {number|Long} Version
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Version = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * StartRs LockBy.
                 * @member {string} LockBy
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.LockBy = "";

                /**
                 * StartRs Refresh.
                 * @member {Object.<string,priority.netitems.form.RefreshLines>} Refresh
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.Refresh = $util.emptyObject;

                /**
                 * StartRs MayDesignTabs.
                 * @member {boolean} MayDesignTabs
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.MayDesignTabs = false;

                /**
                 * StartRs IsHtmlDisabled.
                 * @member {boolean} IsHtmlDisabled
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 */
                StartRs.prototype.IsHtmlDisabled = false;

                /**
                 * Creates a new StartRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.StartRs
                 * @static
                 * @param {priority.netitems.form.IStartRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.StartRs} StartRs instance
                 */
                StartRs.create = function create(properties) {
                    return new StartRs(properties);
                };

                /**
                 * Encodes the specified StartRs message. Does not implicitly {@link priority.netitems.form.StartRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.StartRs
                 * @static
                 * @param {priority.netitems.form.IStartRs} message StartRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Session);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Title);
                    if (message.BpmType != null && Object.hasOwnProperty.call(message, "BpmType"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.BpmType);
                    if (message.Form != null && Object.hasOwnProperty.call(message, "Form"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.Form);
                    if (message.IsFavorite != null && Object.hasOwnProperty.call(message, "IsFavorite"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.IsFavorite);
                    if (message.Ishtml != null && Object.hasOwnProperty.call(message, "Ishtml"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.Ishtml);
                    if (message.ZoomField != null && Object.hasOwnProperty.call(message, "ZoomField"))
                        writer.uint32(/* id 13, wireType 0 =*/104).int64(message.ZoomField);
                    if (message.MultiComp != null && Object.hasOwnProperty.call(message, "MultiComp"))
                        writer.uint32(/* id 14, wireType 0 =*/112).bool(message.MultiComp);
                    if (message.OneLine != null && Object.hasOwnProperty.call(message, "OneLine"))
                        writer.uint32(/* id 15, wireType 0 =*/120).bool(message.OneLine);
                    if (message.IsCustnotes != null && Object.hasOwnProperty.call(message, "IsCustnotes"))
                        writer.uint32(/* id 17, wireType 0 =*/136).bool(message.IsCustnotes);
                    if (message.HasMailinter != null && Object.hasOwnProperty.call(message, "HasMailinter"))
                        writer.uint32(/* id 18, wireType 0 =*/144).bool(message.HasMailinter);
                    if (message.HasTaskUser != null && Object.hasOwnProperty.call(message, "HasTaskUser"))
                        writer.uint32(/* id 19, wireType 0 =*/152).bool(message.HasTaskUser);
                    if (message.DisableEditor != null && Object.hasOwnProperty.call(message, "DisableEditor"))
                        writer.uint32(/* id 20, wireType 0 =*/160).bool(message.DisableEditor);
                    if (message.IsRecon != null && Object.hasOwnProperty.call(message, "IsRecon"))
                        writer.uint32(/* id 21, wireType 0 =*/168).bool(message.IsRecon);
                    if (message.Autoshow != null && Object.hasOwnProperty.call(message, "Autoshow"))
                        writer.uint32(/* id 22, wireType 0 =*/176).bool(message.Autoshow);
                    if (message.AppRefresh != null && Object.hasOwnProperty.call(message, "AppRefresh"))
                        writer.uint32(/* id 23, wireType 0 =*/184).bool(message.AppRefresh);
                    if (message.Dnames != null && message.Dnames.length)
                        for (var i = 0; i < message.Dnames.length; ++i)
                            writer.uint32(/* id 24, wireType 2 =*/194).string(message.Dnames[i]);
                    if (message.DocName != null && Object.hasOwnProperty.call(message, "DocName"))
                        writer.uint32(/* id 25, wireType 2 =*/202).string(message.DocName);
                    if (message.PicturePreview != null && Object.hasOwnProperty.call(message, "PicturePreview"))
                        writer.uint32(/* id 26, wireType 0 =*/208).bool(message.PicturePreview);
                    if (message.Privileges != null && Object.hasOwnProperty.call(message, "Privileges"))
                        writer.uint32(/* id 27, wireType 0 =*/216).int32(message.Privileges);
                    if (message.Version != null && Object.hasOwnProperty.call(message, "Version"))
                        writer.uint32(/* id 28, wireType 0 =*/224).int64(message.Version);
                    if (message.LockBy != null && Object.hasOwnProperty.call(message, "LockBy"))
                        writer.uint32(/* id 29, wireType 2 =*/234).string(message.LockBy);
                    if (message.Refresh != null && Object.hasOwnProperty.call(message, "Refresh"))
                        for (var keys = Object.keys(message.Refresh), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 30, wireType 2 =*/242).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.Refresh[keys[i]]).ldelim();
                    if (message.MayDesignTabs != null && Object.hasOwnProperty.call(message, "MayDesignTabs"))
                        writer.uint32(/* id 31, wireType 0 =*/248).bool(message.MayDesignTabs);
                    if (message.IsHtmlDisabled != null && Object.hasOwnProperty.call(message, "IsHtmlDisabled"))
                        writer.uint32(/* id 32, wireType 0 =*/256).bool(message.IsHtmlDisabled);
                    return writer;
                };

                /**
                 * Encodes the specified StartRs message, length delimited. Does not implicitly {@link priority.netitems.form.StartRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.StartRs
                 * @static
                 * @param {priority.netitems.form.IStartRs} message StartRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StartRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StartRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.StartRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.StartRs} StartRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.StartRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Session = reader.string();
                            break;
                        case 4:
                            message.Title = reader.string();
                            break;
                        case 5:
                            message.BpmType = reader.string();
                            break;
                        case 8:
                            message.Form = reader.int64();
                            break;
                        case 9:
                            message.IsFavorite = reader.bool();
                            break;
                        case 10:
                            message.Ishtml = reader.bool();
                            break;
                        case 13:
                            message.ZoomField = reader.int64();
                            break;
                        case 14:
                            message.MultiComp = reader.bool();
                            break;
                        case 15:
                            message.OneLine = reader.bool();
                            break;
                        case 17:
                            message.IsCustnotes = reader.bool();
                            break;
                        case 18:
                            message.HasMailinter = reader.bool();
                            break;
                        case 19:
                            message.HasTaskUser = reader.bool();
                            break;
                        case 20:
                            message.DisableEditor = reader.bool();
                            break;
                        case 21:
                            message.IsRecon = reader.bool();
                            break;
                        case 22:
                            message.Autoshow = reader.bool();
                            break;
                        case 23:
                            message.AppRefresh = reader.bool();
                            break;
                        case 24:
                            if (!(message.Dnames && message.Dnames.length))
                                message.Dnames = [];
                            message.Dnames.push(reader.string());
                            break;
                        case 25:
                            message.DocName = reader.string();
                            break;
                        case 26:
                            message.PicturePreview = reader.bool();
                            break;
                        case 27:
                            message.Privileges = reader.int32();
                            break;
                        case 28:
                            message.Version = reader.int64();
                            break;
                        case 29:
                            message.LockBy = reader.string();
                            break;
                        case 30:
                            if (message.Refresh === $util.emptyObject)
                                message.Refresh = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = 0;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.Refresh[key] = value;
                            break;
                        case 31:
                            message.MayDesignTabs = reader.bool();
                            break;
                        case 32:
                            message.IsHtmlDisabled = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StartRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.StartRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.StartRs} StartRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StartRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StartRs message.
                 * @function verify
                 * @memberof priority.netitems.form.StartRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StartRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.BpmType != null && message.hasOwnProperty("BpmType"))
                        if (!$util.isString(message.BpmType))
                            return "BpmType: string expected";
                    if (message.Form != null && message.hasOwnProperty("Form"))
                        if (!$util.isInteger(message.Form) && !(message.Form && $util.isInteger(message.Form.low) && $util.isInteger(message.Form.high)))
                            return "Form: integer|Long expected";
                    if (message.IsFavorite != null && message.hasOwnProperty("IsFavorite"))
                        if (typeof message.IsFavorite !== "boolean")
                            return "IsFavorite: boolean expected";
                    if (message.Ishtml != null && message.hasOwnProperty("Ishtml"))
                        if (typeof message.Ishtml !== "boolean")
                            return "Ishtml: boolean expected";
                    if (message.ZoomField != null && message.hasOwnProperty("ZoomField"))
                        if (!$util.isInteger(message.ZoomField) && !(message.ZoomField && $util.isInteger(message.ZoomField.low) && $util.isInteger(message.ZoomField.high)))
                            return "ZoomField: integer|Long expected";
                    if (message.MultiComp != null && message.hasOwnProperty("MultiComp"))
                        if (typeof message.MultiComp !== "boolean")
                            return "MultiComp: boolean expected";
                    if (message.OneLine != null && message.hasOwnProperty("OneLine"))
                        if (typeof message.OneLine !== "boolean")
                            return "OneLine: boolean expected";
                    if (message.IsCustnotes != null && message.hasOwnProperty("IsCustnotes"))
                        if (typeof message.IsCustnotes !== "boolean")
                            return "IsCustnotes: boolean expected";
                    if (message.HasMailinter != null && message.hasOwnProperty("HasMailinter"))
                        if (typeof message.HasMailinter !== "boolean")
                            return "HasMailinter: boolean expected";
                    if (message.HasTaskUser != null && message.hasOwnProperty("HasTaskUser"))
                        if (typeof message.HasTaskUser !== "boolean")
                            return "HasTaskUser: boolean expected";
                    if (message.DisableEditor != null && message.hasOwnProperty("DisableEditor"))
                        if (typeof message.DisableEditor !== "boolean")
                            return "DisableEditor: boolean expected";
                    if (message.IsRecon != null && message.hasOwnProperty("IsRecon"))
                        if (typeof message.IsRecon !== "boolean")
                            return "IsRecon: boolean expected";
                    if (message.Autoshow != null && message.hasOwnProperty("Autoshow"))
                        if (typeof message.Autoshow !== "boolean")
                            return "Autoshow: boolean expected";
                    if (message.AppRefresh != null && message.hasOwnProperty("AppRefresh"))
                        if (typeof message.AppRefresh !== "boolean")
                            return "AppRefresh: boolean expected";
                    if (message.Dnames != null && message.hasOwnProperty("Dnames")) {
                        if (!Array.isArray(message.Dnames))
                            return "Dnames: array expected";
                        for (var i = 0; i < message.Dnames.length; ++i)
                            if (!$util.isString(message.Dnames[i]))
                                return "Dnames: string[] expected";
                    }
                    if (message.DocName != null && message.hasOwnProperty("DocName"))
                        if (!$util.isString(message.DocName))
                            return "DocName: string expected";
                    if (message.PicturePreview != null && message.hasOwnProperty("PicturePreview"))
                        if (typeof message.PicturePreview !== "boolean")
                            return "PicturePreview: boolean expected";
                    if (message.Privileges != null && message.hasOwnProperty("Privileges"))
                        switch (message.Privileges) {
                        default:
                            return "Privileges: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.Version != null && message.hasOwnProperty("Version"))
                        if (!$util.isInteger(message.Version) && !(message.Version && $util.isInteger(message.Version.low) && $util.isInteger(message.Version.high)))
                            return "Version: integer|Long expected";
                    if (message.LockBy != null && message.hasOwnProperty("LockBy"))
                        if (!$util.isString(message.LockBy))
                            return "LockBy: string expected";
                    if (message.Refresh != null && message.hasOwnProperty("Refresh")) {
                        if (!$util.isObject(message.Refresh))
                            return "Refresh: object expected";
                        var key = Object.keys(message.Refresh);
                        for (var i = 0; i < key.length; ++i)
                            switch (message.Refresh[key[i]]) {
                            default:
                                return "Refresh: enum value{k:string} expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    if (message.MayDesignTabs != null && message.hasOwnProperty("MayDesignTabs"))
                        if (typeof message.MayDesignTabs !== "boolean")
                            return "MayDesignTabs: boolean expected";
                    if (message.IsHtmlDisabled != null && message.hasOwnProperty("IsHtmlDisabled"))
                        if (typeof message.IsHtmlDisabled !== "boolean")
                            return "IsHtmlDisabled: boolean expected";
                    return null;
                };

                /**
                 * Creates a StartRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.StartRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.StartRs} StartRs
                 */
                StartRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.StartRs)
                        return object;
                    var message = new $root.priority.netitems.form.StartRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.StartRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.StartRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.StartRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.BpmType != null)
                        message.BpmType = String(object.BpmType);
                    if (object.Form != null)
                        if ($util.Long)
                            (message.Form = $util.Long.fromValue(object.Form)).unsigned = false;
                        else if (typeof object.Form === "string")
                            message.Form = parseInt(object.Form, 10);
                        else if (typeof object.Form === "number")
                            message.Form = object.Form;
                        else if (typeof object.Form === "object")
                            message.Form = new $util.LongBits(object.Form.low >>> 0, object.Form.high >>> 0).toNumber();
                    if (object.IsFavorite != null)
                        message.IsFavorite = Boolean(object.IsFavorite);
                    if (object.Ishtml != null)
                        message.Ishtml = Boolean(object.Ishtml);
                    if (object.ZoomField != null)
                        if ($util.Long)
                            (message.ZoomField = $util.Long.fromValue(object.ZoomField)).unsigned = false;
                        else if (typeof object.ZoomField === "string")
                            message.ZoomField = parseInt(object.ZoomField, 10);
                        else if (typeof object.ZoomField === "number")
                            message.ZoomField = object.ZoomField;
                        else if (typeof object.ZoomField === "object")
                            message.ZoomField = new $util.LongBits(object.ZoomField.low >>> 0, object.ZoomField.high >>> 0).toNumber();
                    if (object.MultiComp != null)
                        message.MultiComp = Boolean(object.MultiComp);
                    if (object.OneLine != null)
                        message.OneLine = Boolean(object.OneLine);
                    if (object.IsCustnotes != null)
                        message.IsCustnotes = Boolean(object.IsCustnotes);
                    if (object.HasMailinter != null)
                        message.HasMailinter = Boolean(object.HasMailinter);
                    if (object.HasTaskUser != null)
                        message.HasTaskUser = Boolean(object.HasTaskUser);
                    if (object.DisableEditor != null)
                        message.DisableEditor = Boolean(object.DisableEditor);
                    if (object.IsRecon != null)
                        message.IsRecon = Boolean(object.IsRecon);
                    if (object.Autoshow != null)
                        message.Autoshow = Boolean(object.Autoshow);
                    if (object.AppRefresh != null)
                        message.AppRefresh = Boolean(object.AppRefresh);
                    if (object.Dnames) {
                        if (!Array.isArray(object.Dnames))
                            throw TypeError(".priority.netitems.form.StartRs.Dnames: array expected");
                        message.Dnames = [];
                        for (var i = 0; i < object.Dnames.length; ++i)
                            message.Dnames[i] = String(object.Dnames[i]);
                    }
                    if (object.DocName != null)
                        message.DocName = String(object.DocName);
                    if (object.PicturePreview != null)
                        message.PicturePreview = Boolean(object.PicturePreview);
                    switch (object.Privileges) {
                    case "Write":
                    case 0:
                        message.Privileges = 0;
                        break;
                    case "NoDelete":
                    case 1:
                        message.Privileges = 1;
                        break;
                    case "Read":
                    case 2:
                        message.Privileges = 2;
                        break;
                    }
                    if (object.Version != null)
                        if ($util.Long)
                            (message.Version = $util.Long.fromValue(object.Version)).unsigned = false;
                        else if (typeof object.Version === "string")
                            message.Version = parseInt(object.Version, 10);
                        else if (typeof object.Version === "number")
                            message.Version = object.Version;
                        else if (typeof object.Version === "object")
                            message.Version = new $util.LongBits(object.Version.low >>> 0, object.Version.high >>> 0).toNumber();
                    if (object.LockBy != null)
                        message.LockBy = String(object.LockBy);
                    if (object.Refresh) {
                        if (typeof object.Refresh !== "object")
                            throw TypeError(".priority.netitems.form.StartRs.Refresh: object expected");
                        message.Refresh = {};
                        for (var keys = Object.keys(object.Refresh), i = 0; i < keys.length; ++i)
                            switch (object.Refresh[keys[i]]) {
                            case "None":
                            case 0:
                                message.Refresh[keys[i]] = 0;
                                break;
                            case "ActiveRecord":
                            case 1:
                                message.Refresh[keys[i]] = 1;
                                break;
                            case "AllRecords":
                            case 2:
                                message.Refresh[keys[i]] = 2;
                                break;
                            }
                    }
                    if (object.MayDesignTabs != null)
                        message.MayDesignTabs = Boolean(object.MayDesignTabs);
                    if (object.IsHtmlDisabled != null)
                        message.IsHtmlDisabled = Boolean(object.IsHtmlDisabled);
                    return message;
                };

                /**
                 * Creates a plain object from a StartRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.StartRs
                 * @static
                 * @param {priority.netitems.form.StartRs} message StartRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StartRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.Dnames = [];
                    }
                    if (options.objects || options.defaults)
                        object.Refresh = {};
                    if (options.defaults) {
                        object.Perf = null;
                        object.Session = "";
                        object.Title = "";
                        object.BpmType = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Form = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Form = options.longs === String ? "0" : 0;
                        object.IsFavorite = false;
                        object.Ishtml = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ZoomField = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ZoomField = options.longs === String ? "0" : 0;
                        object.MultiComp = false;
                        object.OneLine = false;
                        object.IsCustnotes = false;
                        object.HasMailinter = false;
                        object.HasTaskUser = false;
                        object.DisableEditor = false;
                        object.IsRecon = false;
                        object.Autoshow = false;
                        object.AppRefresh = false;
                        object.DocName = "";
                        object.PicturePreview = false;
                        object.Privileges = options.enums === String ? "Write" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Version = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Version = options.longs === String ? "0" : 0;
                        object.LockBy = "";
                        object.MayDesignTabs = false;
                        object.IsHtmlDisabled = false;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.BpmType != null && message.hasOwnProperty("BpmType"))
                        object.BpmType = message.BpmType;
                    if (message.Form != null && message.hasOwnProperty("Form"))
                        if (typeof message.Form === "number")
                            object.Form = options.longs === String ? String(message.Form) : message.Form;
                        else
                            object.Form = options.longs === String ? $util.Long.prototype.toString.call(message.Form) : options.longs === Number ? new $util.LongBits(message.Form.low >>> 0, message.Form.high >>> 0).toNumber() : message.Form;
                    if (message.IsFavorite != null && message.hasOwnProperty("IsFavorite"))
                        object.IsFavorite = message.IsFavorite;
                    if (message.Ishtml != null && message.hasOwnProperty("Ishtml"))
                        object.Ishtml = message.Ishtml;
                    if (message.ZoomField != null && message.hasOwnProperty("ZoomField"))
                        if (typeof message.ZoomField === "number")
                            object.ZoomField = options.longs === String ? String(message.ZoomField) : message.ZoomField;
                        else
                            object.ZoomField = options.longs === String ? $util.Long.prototype.toString.call(message.ZoomField) : options.longs === Number ? new $util.LongBits(message.ZoomField.low >>> 0, message.ZoomField.high >>> 0).toNumber() : message.ZoomField;
                    if (message.MultiComp != null && message.hasOwnProperty("MultiComp"))
                        object.MultiComp = message.MultiComp;
                    if (message.OneLine != null && message.hasOwnProperty("OneLine"))
                        object.OneLine = message.OneLine;
                    if (message.IsCustnotes != null && message.hasOwnProperty("IsCustnotes"))
                        object.IsCustnotes = message.IsCustnotes;
                    if (message.HasMailinter != null && message.hasOwnProperty("HasMailinter"))
                        object.HasMailinter = message.HasMailinter;
                    if (message.HasTaskUser != null && message.hasOwnProperty("HasTaskUser"))
                        object.HasTaskUser = message.HasTaskUser;
                    if (message.DisableEditor != null && message.hasOwnProperty("DisableEditor"))
                        object.DisableEditor = message.DisableEditor;
                    if (message.IsRecon != null && message.hasOwnProperty("IsRecon"))
                        object.IsRecon = message.IsRecon;
                    if (message.Autoshow != null && message.hasOwnProperty("Autoshow"))
                        object.Autoshow = message.Autoshow;
                    if (message.AppRefresh != null && message.hasOwnProperty("AppRefresh"))
                        object.AppRefresh = message.AppRefresh;
                    if (message.Dnames && message.Dnames.length) {
                        object.Dnames = [];
                        for (var j = 0; j < message.Dnames.length; ++j)
                            object.Dnames[j] = message.Dnames[j];
                    }
                    if (message.DocName != null && message.hasOwnProperty("DocName"))
                        object.DocName = message.DocName;
                    if (message.PicturePreview != null && message.hasOwnProperty("PicturePreview"))
                        object.PicturePreview = message.PicturePreview;
                    if (message.Privileges != null && message.hasOwnProperty("Privileges"))
                        object.Privileges = options.enums === String ? $root.priority.netitems.form.StartRs.Priv[message.Privileges] : message.Privileges;
                    if (message.Version != null && message.hasOwnProperty("Version"))
                        if (typeof message.Version === "number")
                            object.Version = options.longs === String ? String(message.Version) : message.Version;
                        else
                            object.Version = options.longs === String ? $util.Long.prototype.toString.call(message.Version) : options.longs === Number ? new $util.LongBits(message.Version.low >>> 0, message.Version.high >>> 0).toNumber() : message.Version;
                    if (message.LockBy != null && message.hasOwnProperty("LockBy"))
                        object.LockBy = message.LockBy;
                    var keys2;
                    if (message.Refresh && (keys2 = Object.keys(message.Refresh)).length) {
                        object.Refresh = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.Refresh[keys2[j]] = options.enums === String ? $root.priority.netitems.form.RefreshLines[message.Refresh[keys2[j]]] : message.Refresh[keys2[j]];
                    }
                    if (message.MayDesignTabs != null && message.hasOwnProperty("MayDesignTabs"))
                        object.MayDesignTabs = message.MayDesignTabs;
                    if (message.IsHtmlDisabled != null && message.hasOwnProperty("IsHtmlDisabled"))
                        object.IsHtmlDisabled = message.IsHtmlDisabled;
                    return object;
                };

                /**
                 * Converts this StartRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.StartRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StartRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Priv enum.
                 * @name priority.netitems.form.StartRs.Priv
                 * @enum {number}
                 * @property {number} Write=0 Write value
                 * @property {number} NoDelete=1 NoDelete value
                 * @property {number} Read=2 Read value
                 */
                StartRs.Priv = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "Write"] = 0;
                    values[valuesById[1] = "NoDelete"] = 1;
                    values[valuesById[2] = "Read"] = 2;
                    return values;
                })();

                return StartRs;
            })();

            form.SystemConstantsRq = (function() {

                /**
                 * Properties of a SystemConstantsRq.
                 * @memberof priority.netitems.form
                 * @interface ISystemConstantsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SystemConstantsRq Properties
                 */

                /**
                 * Constructs a new SystemConstantsRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SystemConstantsRq.
                 * @implements ISystemConstantsRq
                 * @constructor
                 * @param {priority.netitems.form.ISystemConstantsRq=} [properties] Properties to set
                 */
                function SystemConstantsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemConstantsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @instance
                 */
                SystemConstantsRq.prototype.Properties = null;

                /**
                 * Creates a new SystemConstantsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @static
                 * @param {priority.netitems.form.ISystemConstantsRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SystemConstantsRq} SystemConstantsRq instance
                 */
                SystemConstantsRq.create = function create(properties) {
                    return new SystemConstantsRq(properties);
                };

                /**
                 * Encodes the specified SystemConstantsRq message. Does not implicitly {@link priority.netitems.form.SystemConstantsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @static
                 * @param {priority.netitems.form.ISystemConstantsRq} message SystemConstantsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemConstantsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SystemConstantsRq message, length delimited. Does not implicitly {@link priority.netitems.form.SystemConstantsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @static
                 * @param {priority.netitems.form.ISystemConstantsRq} message SystemConstantsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemConstantsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemConstantsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SystemConstantsRq} SystemConstantsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemConstantsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SystemConstantsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemConstantsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SystemConstantsRq} SystemConstantsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemConstantsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemConstantsRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemConstantsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SystemConstantsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SystemConstantsRq} SystemConstantsRq
                 */
                SystemConstantsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SystemConstantsRq)
                        return object;
                    var message = new $root.priority.netitems.form.SystemConstantsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SystemConstantsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemConstantsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @static
                 * @param {priority.netitems.form.SystemConstantsRq} message SystemConstantsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemConstantsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this SystemConstantsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SystemConstantsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemConstantsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SystemConstantsRq;
            })();

            form.SystemConstantsRs = (function() {

                /**
                 * Properties of a SystemConstantsRs.
                 * @memberof priority.netitems.form
                 * @interface ISystemConstantsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SystemConstantsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SystemConstantsRs Messages
                 * @property {Object.<string,common.IConstant>|null} [SystemConstants] SystemConstantsRs SystemConstants
                 */

                /**
                 * Constructs a new SystemConstantsRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SystemConstantsRs.
                 * @implements ISystemConstantsRs
                 * @constructor
                 * @param {priority.netitems.form.ISystemConstantsRs=} [properties] Properties to set
                 */
                function SystemConstantsRs(properties) {
                    this.Messages = [];
                    this.SystemConstants = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemConstantsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @instance
                 */
                SystemConstantsRs.prototype.Perf = null;

                /**
                 * SystemConstantsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @instance
                 */
                SystemConstantsRs.prototype.Messages = $util.emptyArray;

                /**
                 * SystemConstantsRs SystemConstants.
                 * @member {Object.<string,common.IConstant>} SystemConstants
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @instance
                 */
                SystemConstantsRs.prototype.SystemConstants = $util.emptyObject;

                /**
                 * Creates a new SystemConstantsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @static
                 * @param {priority.netitems.form.ISystemConstantsRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.SystemConstantsRs} SystemConstantsRs instance
                 */
                SystemConstantsRs.create = function create(properties) {
                    return new SystemConstantsRs(properties);
                };

                /**
                 * Encodes the specified SystemConstantsRs message. Does not implicitly {@link priority.netitems.form.SystemConstantsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @static
                 * @param {priority.netitems.form.ISystemConstantsRs} message SystemConstantsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemConstantsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.SystemConstants != null && Object.hasOwnProperty.call(message, "SystemConstants"))
                        for (var keys = Object.keys(message.SystemConstants), i = 0; i < keys.length; ++i) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                            $root.common.Constant.encode(message.SystemConstants[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                        }
                    return writer;
                };

                /**
                 * Encodes the specified SystemConstantsRs message, length delimited. Does not implicitly {@link priority.netitems.form.SystemConstantsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @static
                 * @param {priority.netitems.form.ISystemConstantsRs} message SystemConstantsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemConstantsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemConstantsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SystemConstantsRs} SystemConstantsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemConstantsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SystemConstantsRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (message.SystemConstants === $util.emptyObject)
                                message.SystemConstants = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.common.Constant.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.SystemConstants[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemConstantsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SystemConstantsRs} SystemConstantsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemConstantsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemConstantsRs message.
                 * @function verify
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemConstantsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.SystemConstants != null && message.hasOwnProperty("SystemConstants")) {
                        if (!$util.isObject(message.SystemConstants))
                            return "SystemConstants: object expected";
                        var key = Object.keys(message.SystemConstants);
                        for (var i = 0; i < key.length; ++i) {
                            var error = $root.common.Constant.verify(message.SystemConstants[key[i]]);
                            if (error)
                                return "SystemConstants." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SystemConstantsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SystemConstantsRs} SystemConstantsRs
                 */
                SystemConstantsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SystemConstantsRs)
                        return object;
                    var message = new $root.priority.netitems.form.SystemConstantsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.SystemConstantsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.SystemConstantsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.SystemConstantsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.SystemConstants) {
                        if (typeof object.SystemConstants !== "object")
                            throw TypeError(".priority.netitems.form.SystemConstantsRs.SystemConstants: object expected");
                        message.SystemConstants = {};
                        for (var keys = Object.keys(object.SystemConstants), i = 0; i < keys.length; ++i) {
                            if (typeof object.SystemConstants[keys[i]] !== "object")
                                throw TypeError(".priority.netitems.form.SystemConstantsRs.SystemConstants: object expected");
                            message.SystemConstants[keys[i]] = $root.common.Constant.fromObject(object.SystemConstants[keys[i]]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemConstantsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @static
                 * @param {priority.netitems.form.SystemConstantsRs} message SystemConstantsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemConstantsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.SystemConstants = {};
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    var keys2;
                    if (message.SystemConstants && (keys2 = Object.keys(message.SystemConstants)).length) {
                        object.SystemConstants = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.SystemConstants[keys2[j]] = $root.common.Constant.toObject(message.SystemConstants[keys2[j]], options);
                    }
                    return object;
                };

                /**
                 * Converts this SystemConstantsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SystemConstantsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemConstantsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SystemConstantsRs;
            })();

            form.ColumnsRq = (function() {

                /**
                 * Properties of a ColumnsRq.
                 * @memberof priority.netitems.form
                 * @interface IColumnsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ColumnsRq Properties
                 * @property {string|null} [Session] ColumnsRq Session
                 */

                /**
                 * Constructs a new ColumnsRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a ColumnsRq.
                 * @implements IColumnsRq
                 * @constructor
                 * @param {priority.netitems.form.IColumnsRq=} [properties] Properties to set
                 */
                function ColumnsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ColumnsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.ColumnsRq
                 * @instance
                 */
                ColumnsRq.prototype.Properties = null;

                /**
                 * ColumnsRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.ColumnsRq
                 * @instance
                 */
                ColumnsRq.prototype.Session = "";

                /**
                 * Creates a new ColumnsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ColumnsRq
                 * @static
                 * @param {priority.netitems.form.IColumnsRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.ColumnsRq} ColumnsRq instance
                 */
                ColumnsRq.create = function create(properties) {
                    return new ColumnsRq(properties);
                };

                /**
                 * Encodes the specified ColumnsRq message. Does not implicitly {@link priority.netitems.form.ColumnsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ColumnsRq
                 * @static
                 * @param {priority.netitems.form.IColumnsRq} message ColumnsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColumnsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified ColumnsRq message, length delimited. Does not implicitly {@link priority.netitems.form.ColumnsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ColumnsRq
                 * @static
                 * @param {priority.netitems.form.IColumnsRq} message ColumnsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColumnsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ColumnsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ColumnsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ColumnsRq} ColumnsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColumnsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ColumnsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ColumnsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ColumnsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ColumnsRq} ColumnsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColumnsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ColumnsRq message.
                 * @function verify
                 * @memberof priority.netitems.form.ColumnsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ColumnsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates a ColumnsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ColumnsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ColumnsRq} ColumnsRq
                 */
                ColumnsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ColumnsRq)
                        return object;
                    var message = new $root.priority.netitems.form.ColumnsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.ColumnsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from a ColumnsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ColumnsRq
                 * @static
                 * @param {priority.netitems.form.ColumnsRq} message ColumnsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ColumnsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this ColumnsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ColumnsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ColumnsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ColumnsRq;
            })();

            form.ColumnsRs = (function() {

                /**
                 * Properties of a ColumnsRs.
                 * @memberof priority.netitems.form
                 * @interface IColumnsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] ColumnsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ColumnsRs Messages
                 * @property {Array.<priority.netitems.form.IColumn>|null} [Columns] ColumnsRs Columns
                 */

                /**
                 * Constructs a new ColumnsRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a ColumnsRs.
                 * @implements IColumnsRs
                 * @constructor
                 * @param {priority.netitems.form.IColumnsRs=} [properties] Properties to set
                 */
                function ColumnsRs(properties) {
                    this.Messages = [];
                    this.Columns = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ColumnsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.ColumnsRs
                 * @instance
                 */
                ColumnsRs.prototype.Perf = null;

                /**
                 * ColumnsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.ColumnsRs
                 * @instance
                 */
                ColumnsRs.prototype.Messages = $util.emptyArray;

                /**
                 * ColumnsRs Columns.
                 * @member {Array.<priority.netitems.form.IColumn>} Columns
                 * @memberof priority.netitems.form.ColumnsRs
                 * @instance
                 */
                ColumnsRs.prototype.Columns = $util.emptyArray;

                /**
                 * Creates a new ColumnsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ColumnsRs
                 * @static
                 * @param {priority.netitems.form.IColumnsRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.ColumnsRs} ColumnsRs instance
                 */
                ColumnsRs.create = function create(properties) {
                    return new ColumnsRs(properties);
                };

                /**
                 * Encodes the specified ColumnsRs message. Does not implicitly {@link priority.netitems.form.ColumnsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ColumnsRs
                 * @static
                 * @param {priority.netitems.form.IColumnsRs} message ColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColumnsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Columns != null && message.Columns.length)
                        for (var i = 0; i < message.Columns.length; ++i)
                            $root.priority.netitems.form.Column.encode(message.Columns[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ColumnsRs message, length delimited. Does not implicitly {@link priority.netitems.form.ColumnsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ColumnsRs
                 * @static
                 * @param {priority.netitems.form.IColumnsRs} message ColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColumnsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ColumnsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ColumnsRs} ColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColumnsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ColumnsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.Columns && message.Columns.length))
                                message.Columns = [];
                            message.Columns.push($root.priority.netitems.form.Column.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ColumnsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ColumnsRs} ColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColumnsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ColumnsRs message.
                 * @function verify
                 * @memberof priority.netitems.form.ColumnsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ColumnsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (!Array.isArray(message.Columns))
                            return "Columns: array expected";
                        for (var i = 0; i < message.Columns.length; ++i) {
                            var error = $root.priority.netitems.form.Column.verify(message.Columns[i]);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ColumnsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ColumnsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ColumnsRs} ColumnsRs
                 */
                ColumnsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ColumnsRs)
                        return object;
                    var message = new $root.priority.netitems.form.ColumnsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.ColumnsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.ColumnsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.ColumnsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Columns) {
                        if (!Array.isArray(object.Columns))
                            throw TypeError(".priority.netitems.form.ColumnsRs.Columns: array expected");
                        message.Columns = [];
                        for (var i = 0; i < object.Columns.length; ++i) {
                            if (typeof object.Columns[i] !== "object")
                                throw TypeError(".priority.netitems.form.ColumnsRs.Columns: object expected");
                            message.Columns[i] = $root.priority.netitems.form.Column.fromObject(object.Columns[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ColumnsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ColumnsRs
                 * @static
                 * @param {priority.netitems.form.ColumnsRs} message ColumnsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ColumnsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.Columns = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Columns && message.Columns.length) {
                        object.Columns = [];
                        for (var j = 0; j < message.Columns.length; ++j)
                            object.Columns[j] = $root.priority.netitems.form.Column.toObject(message.Columns[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ColumnsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ColumnsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ColumnsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ColumnsRs;
            })();

            form.FetchRq = (function() {

                /**
                 * Properties of a FetchRq.
                 * @memberof priority.netitems.form
                 * @interface IFetchRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] FetchRq Properties
                 * @property {string|null} [Session] FetchRq Session
                 * @property {Array.<priority.netitems.form.IFilter>|null} [Filters] FetchRq Filters
                 * @property {priority.netitems.shared.LogicalOperator|null} [FiltersOp] FetchRq FiltersOp
                 * @property {Array.<priority.netitems.form.ISort>|null} [Sort] FetchRq Sort
                 * @property {number|Long|null} [Top] FetchRq Top
                 * @property {number|Long|null} [Skip] FetchRq Skip
                 * @property {Array.<number|Long>|null} [Select] FetchRq Select
                 * @property {priority.netitems.form.AttachmentOptions|null} [Attachments] FetchRq Attachments
                 * @property {priority.netitems.form.IImageOptions|null} [Images] FetchRq Images
                 */

                /**
                 * Constructs a new FetchRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FetchRq.
                 * @implements IFetchRq
                 * @constructor
                 * @param {priority.netitems.form.IFetchRq=} [properties] Properties to set
                 */
                function FetchRq(properties) {
                    this.Filters = [];
                    this.Sort = [];
                    this.Select = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FetchRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Properties = null;

                /**
                 * FetchRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Session = "";

                /**
                 * FetchRq Filters.
                 * @member {Array.<priority.netitems.form.IFilter>} Filters
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Filters = $util.emptyArray;

                /**
                 * FetchRq FiltersOp.
                 * @member {priority.netitems.shared.LogicalOperator} FiltersOp
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.FiltersOp = 0;

                /**
                 * FetchRq Sort.
                 * @member {Array.<priority.netitems.form.ISort>} Sort
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Sort = $util.emptyArray;

                /**
                 * FetchRq Top.
                 * @member {number|Long} Top
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Top = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * FetchRq Skip.
                 * @member {number|Long} Skip
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Skip = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * FetchRq Select.
                 * @member {Array.<number|Long>} Select
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Select = $util.emptyArray;

                /**
                 * FetchRq Attachments.
                 * @member {priority.netitems.form.AttachmentOptions} Attachments
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Attachments = 0;

                /**
                 * FetchRq Images.
                 * @member {priority.netitems.form.IImageOptions|null|undefined} Images
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 */
                FetchRq.prototype.Images = null;

                /**
                 * Creates a new FetchRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FetchRq
                 * @static
                 * @param {priority.netitems.form.IFetchRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.FetchRq} FetchRq instance
                 */
                FetchRq.create = function create(properties) {
                    return new FetchRq(properties);
                };

                /**
                 * Encodes the specified FetchRq message. Does not implicitly {@link priority.netitems.form.FetchRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FetchRq
                 * @static
                 * @param {priority.netitems.form.IFetchRq} message FetchRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FetchRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Filters != null && message.Filters.length)
                        for (var i = 0; i < message.Filters.length; ++i)
                            $root.priority.netitems.form.Filter.encode(message.Filters[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.FiltersOp != null && Object.hasOwnProperty.call(message, "FiltersOp"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.FiltersOp);
                    if (message.Sort != null && message.Sort.length)
                        for (var i = 0; i < message.Sort.length; ++i)
                            $root.priority.netitems.form.Sort.encode(message.Sort[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Top != null && Object.hasOwnProperty.call(message, "Top"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.Top);
                    if (message.Skip != null && Object.hasOwnProperty.call(message, "Skip"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.Skip);
                    if (message.Select != null && message.Select.length) {
                        writer.uint32(/* id 9, wireType 2 =*/74).fork();
                        for (var i = 0; i < message.Select.length; ++i)
                            writer.int64(message.Select[i]);
                        writer.ldelim();
                    }
                    if (message.Attachments != null && Object.hasOwnProperty.call(message, "Attachments"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int32(message.Attachments);
                    if (message.Images != null && Object.hasOwnProperty.call(message, "Images"))
                        $root.priority.netitems.form.ImageOptions.encode(message.Images, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FetchRq message, length delimited. Does not implicitly {@link priority.netitems.form.FetchRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FetchRq
                 * @static
                 * @param {priority.netitems.form.IFetchRq} message FetchRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FetchRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FetchRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FetchRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FetchRq} FetchRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FetchRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FetchRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            if (!(message.Filters && message.Filters.length))
                                message.Filters = [];
                            message.Filters.push($root.priority.netitems.form.Filter.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            message.FiltersOp = reader.int32();
                            break;
                        case 6:
                            if (!(message.Sort && message.Sort.length))
                                message.Sort = [];
                            message.Sort.push($root.priority.netitems.form.Sort.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            message.Top = reader.int64();
                            break;
                        case 8:
                            message.Skip = reader.int64();
                            break;
                        case 9:
                            if (!(message.Select && message.Select.length))
                                message.Select = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.Select.push(reader.int64());
                            } else
                                message.Select.push(reader.int64());
                            break;
                        case 10:
                            message.Attachments = reader.int32();
                            break;
                        case 11:
                            message.Images = $root.priority.netitems.form.ImageOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FetchRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FetchRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FetchRq} FetchRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FetchRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FetchRq message.
                 * @function verify
                 * @memberof priority.netitems.form.FetchRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FetchRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Filters != null && message.hasOwnProperty("Filters")) {
                        if (!Array.isArray(message.Filters))
                            return "Filters: array expected";
                        for (var i = 0; i < message.Filters.length; ++i) {
                            var error = $root.priority.netitems.form.Filter.verify(message.Filters[i]);
                            if (error)
                                return "Filters." + error;
                        }
                    }
                    if (message.FiltersOp != null && message.hasOwnProperty("FiltersOp"))
                        switch (message.FiltersOp) {
                        default:
                            return "FiltersOp: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.Sort != null && message.hasOwnProperty("Sort")) {
                        if (!Array.isArray(message.Sort))
                            return "Sort: array expected";
                        for (var i = 0; i < message.Sort.length; ++i) {
                            var error = $root.priority.netitems.form.Sort.verify(message.Sort[i]);
                            if (error)
                                return "Sort." + error;
                        }
                    }
                    if (message.Top != null && message.hasOwnProperty("Top"))
                        if (!$util.isInteger(message.Top) && !(message.Top && $util.isInteger(message.Top.low) && $util.isInteger(message.Top.high)))
                            return "Top: integer|Long expected";
                    if (message.Skip != null && message.hasOwnProperty("Skip"))
                        if (!$util.isInteger(message.Skip) && !(message.Skip && $util.isInteger(message.Skip.low) && $util.isInteger(message.Skip.high)))
                            return "Skip: integer|Long expected";
                    if (message.Select != null && message.hasOwnProperty("Select")) {
                        if (!Array.isArray(message.Select))
                            return "Select: array expected";
                        for (var i = 0; i < message.Select.length; ++i)
                            if (!$util.isInteger(message.Select[i]) && !(message.Select[i] && $util.isInteger(message.Select[i].low) && $util.isInteger(message.Select[i].high)))
                                return "Select: integer|Long[] expected";
                    }
                    if (message.Attachments != null && message.hasOwnProperty("Attachments"))
                        switch (message.Attachments) {
                        default:
                            return "Attachments: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.Images != null && message.hasOwnProperty("Images")) {
                        var error = $root.priority.netitems.form.ImageOptions.verify(message.Images);
                        if (error)
                            return "Images." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FetchRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FetchRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FetchRq} FetchRq
                 */
                FetchRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FetchRq)
                        return object;
                    var message = new $root.priority.netitems.form.FetchRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.FetchRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Filters) {
                        if (!Array.isArray(object.Filters))
                            throw TypeError(".priority.netitems.form.FetchRq.Filters: array expected");
                        message.Filters = [];
                        for (var i = 0; i < object.Filters.length; ++i) {
                            if (typeof object.Filters[i] !== "object")
                                throw TypeError(".priority.netitems.form.FetchRq.Filters: object expected");
                            message.Filters[i] = $root.priority.netitems.form.Filter.fromObject(object.Filters[i]);
                        }
                    }
                    switch (object.FiltersOp) {
                    case "And":
                    case 0:
                        message.FiltersOp = 0;
                        break;
                    case "Or":
                    case 1:
                        message.FiltersOp = 1;
                        break;
                    }
                    if (object.Sort) {
                        if (!Array.isArray(object.Sort))
                            throw TypeError(".priority.netitems.form.FetchRq.Sort: array expected");
                        message.Sort = [];
                        for (var i = 0; i < object.Sort.length; ++i) {
                            if (typeof object.Sort[i] !== "object")
                                throw TypeError(".priority.netitems.form.FetchRq.Sort: object expected");
                            message.Sort[i] = $root.priority.netitems.form.Sort.fromObject(object.Sort[i]);
                        }
                    }
                    if (object.Top != null)
                        if ($util.Long)
                            (message.Top = $util.Long.fromValue(object.Top)).unsigned = false;
                        else if (typeof object.Top === "string")
                            message.Top = parseInt(object.Top, 10);
                        else if (typeof object.Top === "number")
                            message.Top = object.Top;
                        else if (typeof object.Top === "object")
                            message.Top = new $util.LongBits(object.Top.low >>> 0, object.Top.high >>> 0).toNumber();
                    if (object.Skip != null)
                        if ($util.Long)
                            (message.Skip = $util.Long.fromValue(object.Skip)).unsigned = false;
                        else if (typeof object.Skip === "string")
                            message.Skip = parseInt(object.Skip, 10);
                        else if (typeof object.Skip === "number")
                            message.Skip = object.Skip;
                        else if (typeof object.Skip === "object")
                            message.Skip = new $util.LongBits(object.Skip.low >>> 0, object.Skip.high >>> 0).toNumber();
                    if (object.Select) {
                        if (!Array.isArray(object.Select))
                            throw TypeError(".priority.netitems.form.FetchRq.Select: array expected");
                        message.Select = [];
                        for (var i = 0; i < object.Select.length; ++i)
                            if ($util.Long)
                                (message.Select[i] = $util.Long.fromValue(object.Select[i])).unsigned = false;
                            else if (typeof object.Select[i] === "string")
                                message.Select[i] = parseInt(object.Select[i], 10);
                            else if (typeof object.Select[i] === "number")
                                message.Select[i] = object.Select[i];
                            else if (typeof object.Select[i] === "object")
                                message.Select[i] = new $util.LongBits(object.Select[i].low >>> 0, object.Select[i].high >>> 0).toNumber();
                    }
                    switch (object.Attachments) {
                    case "Attach_NoData":
                    case 0:
                        message.Attachments = 0;
                        break;
                    case "Attach_Data":
                    case 1:
                        message.Attachments = 1;
                        break;
                    }
                    if (object.Images != null) {
                        if (typeof object.Images !== "object")
                            throw TypeError(".priority.netitems.form.FetchRq.Images: object expected");
                        message.Images = $root.priority.netitems.form.ImageOptions.fromObject(object.Images);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FetchRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FetchRq
                 * @static
                 * @param {priority.netitems.form.FetchRq} message FetchRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FetchRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Filters = [];
                        object.Sort = [];
                        object.Select = [];
                    }
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.FiltersOp = options.enums === String ? "And" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Top = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Top = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Skip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Skip = options.longs === String ? "0" : 0;
                        object.Attachments = options.enums === String ? "Attach_NoData" : 0;
                        object.Images = null;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Filters && message.Filters.length) {
                        object.Filters = [];
                        for (var j = 0; j < message.Filters.length; ++j)
                            object.Filters[j] = $root.priority.netitems.form.Filter.toObject(message.Filters[j], options);
                    }
                    if (message.FiltersOp != null && message.hasOwnProperty("FiltersOp"))
                        object.FiltersOp = options.enums === String ? $root.priority.netitems.shared.LogicalOperator[message.FiltersOp] : message.FiltersOp;
                    if (message.Sort && message.Sort.length) {
                        object.Sort = [];
                        for (var j = 0; j < message.Sort.length; ++j)
                            object.Sort[j] = $root.priority.netitems.form.Sort.toObject(message.Sort[j], options);
                    }
                    if (message.Top != null && message.hasOwnProperty("Top"))
                        if (typeof message.Top === "number")
                            object.Top = options.longs === String ? String(message.Top) : message.Top;
                        else
                            object.Top = options.longs === String ? $util.Long.prototype.toString.call(message.Top) : options.longs === Number ? new $util.LongBits(message.Top.low >>> 0, message.Top.high >>> 0).toNumber() : message.Top;
                    if (message.Skip != null && message.hasOwnProperty("Skip"))
                        if (typeof message.Skip === "number")
                            object.Skip = options.longs === String ? String(message.Skip) : message.Skip;
                        else
                            object.Skip = options.longs === String ? $util.Long.prototype.toString.call(message.Skip) : options.longs === Number ? new $util.LongBits(message.Skip.low >>> 0, message.Skip.high >>> 0).toNumber() : message.Skip;
                    if (message.Select && message.Select.length) {
                        object.Select = [];
                        for (var j = 0; j < message.Select.length; ++j)
                            if (typeof message.Select[j] === "number")
                                object.Select[j] = options.longs === String ? String(message.Select[j]) : message.Select[j];
                            else
                                object.Select[j] = options.longs === String ? $util.Long.prototype.toString.call(message.Select[j]) : options.longs === Number ? new $util.LongBits(message.Select[j].low >>> 0, message.Select[j].high >>> 0).toNumber() : message.Select[j];
                    }
                    if (message.Attachments != null && message.hasOwnProperty("Attachments"))
                        object.Attachments = options.enums === String ? $root.priority.netitems.form.AttachmentOptions[message.Attachments] : message.Attachments;
                    if (message.Images != null && message.hasOwnProperty("Images"))
                        object.Images = $root.priority.netitems.form.ImageOptions.toObject(message.Images, options);
                    return object;
                };

                /**
                 * Converts this FetchRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FetchRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FetchRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FetchRq;
            })();

            form.FetchRs = (function() {

                /**
                 * Properties of a FetchRs.
                 * @memberof priority.netitems.form
                 * @interface IFetchRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] FetchRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] FetchRs Messages
                 * @property {Array.<priority.netitems.form.IRecord>|null} [Records] FetchRs Records
                 */

                /**
                 * Constructs a new FetchRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FetchRs.
                 * @implements IFetchRs
                 * @constructor
                 * @param {priority.netitems.form.IFetchRs=} [properties] Properties to set
                 */
                function FetchRs(properties) {
                    this.Messages = [];
                    this.Records = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FetchRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.FetchRs
                 * @instance
                 */
                FetchRs.prototype.Perf = null;

                /**
                 * FetchRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.FetchRs
                 * @instance
                 */
                FetchRs.prototype.Messages = $util.emptyArray;

                /**
                 * FetchRs Records.
                 * @member {Array.<priority.netitems.form.IRecord>} Records
                 * @memberof priority.netitems.form.FetchRs
                 * @instance
                 */
                FetchRs.prototype.Records = $util.emptyArray;

                /**
                 * Creates a new FetchRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FetchRs
                 * @static
                 * @param {priority.netitems.form.IFetchRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.FetchRs} FetchRs instance
                 */
                FetchRs.create = function create(properties) {
                    return new FetchRs(properties);
                };

                /**
                 * Encodes the specified FetchRs message. Does not implicitly {@link priority.netitems.form.FetchRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FetchRs
                 * @static
                 * @param {priority.netitems.form.IFetchRs} message FetchRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FetchRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Records != null && message.Records.length)
                        for (var i = 0; i < message.Records.length; ++i)
                            $root.priority.netitems.form.Record.encode(message.Records[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FetchRs message, length delimited. Does not implicitly {@link priority.netitems.form.FetchRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FetchRs
                 * @static
                 * @param {priority.netitems.form.IFetchRs} message FetchRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FetchRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FetchRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FetchRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FetchRs} FetchRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FetchRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FetchRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.Records && message.Records.length))
                                message.Records = [];
                            message.Records.push($root.priority.netitems.form.Record.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FetchRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FetchRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FetchRs} FetchRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FetchRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FetchRs message.
                 * @function verify
                 * @memberof priority.netitems.form.FetchRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FetchRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Records != null && message.hasOwnProperty("Records")) {
                        if (!Array.isArray(message.Records))
                            return "Records: array expected";
                        for (var i = 0; i < message.Records.length; ++i) {
                            var error = $root.priority.netitems.form.Record.verify(message.Records[i]);
                            if (error)
                                return "Records." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a FetchRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FetchRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FetchRs} FetchRs
                 */
                FetchRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FetchRs)
                        return object;
                    var message = new $root.priority.netitems.form.FetchRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.FetchRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.FetchRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.FetchRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Records) {
                        if (!Array.isArray(object.Records))
                            throw TypeError(".priority.netitems.form.FetchRs.Records: array expected");
                        message.Records = [];
                        for (var i = 0; i < object.Records.length; ++i) {
                            if (typeof object.Records[i] !== "object")
                                throw TypeError(".priority.netitems.form.FetchRs.Records: object expected");
                            message.Records[i] = $root.priority.netitems.form.Record.fromObject(object.Records[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FetchRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FetchRs
                 * @static
                 * @param {priority.netitems.form.FetchRs} message FetchRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FetchRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.Records = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Records && message.Records.length) {
                        object.Records = [];
                        for (var j = 0; j < message.Records.length; ++j)
                            object.Records[j] = $root.priority.netitems.form.Record.toObject(message.Records[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this FetchRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FetchRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FetchRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FetchRs;
            })();

            form.CountFetchRq = (function() {

                /**
                 * Properties of a CountFetchRq.
                 * @memberof priority.netitems.form
                 * @interface ICountFetchRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] CountFetchRq Properties
                 * @property {string|null} [Session] CountFetchRq Session
                 * @property {Array.<priority.netitems.form.IFilter>|null} [Filters] CountFetchRq Filters
                 * @property {priority.netitems.shared.LogicalOperator|null} [FiltersOp] CountFetchRq FiltersOp
                 */

                /**
                 * Constructs a new CountFetchRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a CountFetchRq.
                 * @implements ICountFetchRq
                 * @constructor
                 * @param {priority.netitems.form.ICountFetchRq=} [properties] Properties to set
                 */
                function CountFetchRq(properties) {
                    this.Filters = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CountFetchRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.CountFetchRq
                 * @instance
                 */
                CountFetchRq.prototype.Properties = null;

                /**
                 * CountFetchRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.CountFetchRq
                 * @instance
                 */
                CountFetchRq.prototype.Session = "";

                /**
                 * CountFetchRq Filters.
                 * @member {Array.<priority.netitems.form.IFilter>} Filters
                 * @memberof priority.netitems.form.CountFetchRq
                 * @instance
                 */
                CountFetchRq.prototype.Filters = $util.emptyArray;

                /**
                 * CountFetchRq FiltersOp.
                 * @member {priority.netitems.shared.LogicalOperator} FiltersOp
                 * @memberof priority.netitems.form.CountFetchRq
                 * @instance
                 */
                CountFetchRq.prototype.FiltersOp = 0;

                /**
                 * Creates a new CountFetchRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.CountFetchRq
                 * @static
                 * @param {priority.netitems.form.ICountFetchRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.CountFetchRq} CountFetchRq instance
                 */
                CountFetchRq.create = function create(properties) {
                    return new CountFetchRq(properties);
                };

                /**
                 * Encodes the specified CountFetchRq message. Does not implicitly {@link priority.netitems.form.CountFetchRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.CountFetchRq
                 * @static
                 * @param {priority.netitems.form.ICountFetchRq} message CountFetchRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CountFetchRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Filters != null && message.Filters.length)
                        for (var i = 0; i < message.Filters.length; ++i)
                            $root.priority.netitems.form.Filter.encode(message.Filters[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.FiltersOp != null && Object.hasOwnProperty.call(message, "FiltersOp"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.FiltersOp);
                    return writer;
                };

                /**
                 * Encodes the specified CountFetchRq message, length delimited. Does not implicitly {@link priority.netitems.form.CountFetchRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.CountFetchRq
                 * @static
                 * @param {priority.netitems.form.ICountFetchRq} message CountFetchRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CountFetchRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CountFetchRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.CountFetchRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.CountFetchRq} CountFetchRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CountFetchRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.CountFetchRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            if (!(message.Filters && message.Filters.length))
                                message.Filters = [];
                            message.Filters.push($root.priority.netitems.form.Filter.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            message.FiltersOp = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CountFetchRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.CountFetchRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.CountFetchRq} CountFetchRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CountFetchRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CountFetchRq message.
                 * @function verify
                 * @memberof priority.netitems.form.CountFetchRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CountFetchRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Filters != null && message.hasOwnProperty("Filters")) {
                        if (!Array.isArray(message.Filters))
                            return "Filters: array expected";
                        for (var i = 0; i < message.Filters.length; ++i) {
                            var error = $root.priority.netitems.form.Filter.verify(message.Filters[i]);
                            if (error)
                                return "Filters." + error;
                        }
                    }
                    if (message.FiltersOp != null && message.hasOwnProperty("FiltersOp"))
                        switch (message.FiltersOp) {
                        default:
                            return "FiltersOp: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a CountFetchRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.CountFetchRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.CountFetchRq} CountFetchRq
                 */
                CountFetchRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.CountFetchRq)
                        return object;
                    var message = new $root.priority.netitems.form.CountFetchRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.CountFetchRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Filters) {
                        if (!Array.isArray(object.Filters))
                            throw TypeError(".priority.netitems.form.CountFetchRq.Filters: array expected");
                        message.Filters = [];
                        for (var i = 0; i < object.Filters.length; ++i) {
                            if (typeof object.Filters[i] !== "object")
                                throw TypeError(".priority.netitems.form.CountFetchRq.Filters: object expected");
                            message.Filters[i] = $root.priority.netitems.form.Filter.fromObject(object.Filters[i]);
                        }
                    }
                    switch (object.FiltersOp) {
                    case "And":
                    case 0:
                        message.FiltersOp = 0;
                        break;
                    case "Or":
                    case 1:
                        message.FiltersOp = 1;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CountFetchRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.CountFetchRq
                 * @static
                 * @param {priority.netitems.form.CountFetchRq} message CountFetchRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CountFetchRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Filters = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.FiltersOp = options.enums === String ? "And" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Filters && message.Filters.length) {
                        object.Filters = [];
                        for (var j = 0; j < message.Filters.length; ++j)
                            object.Filters[j] = $root.priority.netitems.form.Filter.toObject(message.Filters[j], options);
                    }
                    if (message.FiltersOp != null && message.hasOwnProperty("FiltersOp"))
                        object.FiltersOp = options.enums === String ? $root.priority.netitems.shared.LogicalOperator[message.FiltersOp] : message.FiltersOp;
                    return object;
                };

                /**
                 * Converts this CountFetchRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.CountFetchRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CountFetchRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CountFetchRq;
            })();

            form.CountFetchRs = (function() {

                /**
                 * Properties of a CountFetchRs.
                 * @memberof priority.netitems.form
                 * @interface ICountFetchRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] CountFetchRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] CountFetchRs Messages
                 * @property {number|Long|null} [recordCount] CountFetchRs recordCount
                 */

                /**
                 * Constructs a new CountFetchRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a CountFetchRs.
                 * @implements ICountFetchRs
                 * @constructor
                 * @param {priority.netitems.form.ICountFetchRs=} [properties] Properties to set
                 */
                function CountFetchRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CountFetchRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.CountFetchRs
                 * @instance
                 */
                CountFetchRs.prototype.Perf = null;

                /**
                 * CountFetchRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.CountFetchRs
                 * @instance
                 */
                CountFetchRs.prototype.Messages = $util.emptyArray;

                /**
                 * CountFetchRs recordCount.
                 * @member {number|Long} recordCount
                 * @memberof priority.netitems.form.CountFetchRs
                 * @instance
                 */
                CountFetchRs.prototype.recordCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new CountFetchRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.CountFetchRs
                 * @static
                 * @param {priority.netitems.form.ICountFetchRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.CountFetchRs} CountFetchRs instance
                 */
                CountFetchRs.create = function create(properties) {
                    return new CountFetchRs(properties);
                };

                /**
                 * Encodes the specified CountFetchRs message. Does not implicitly {@link priority.netitems.form.CountFetchRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.CountFetchRs
                 * @static
                 * @param {priority.netitems.form.ICountFetchRs} message CountFetchRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CountFetchRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.recordCount != null && Object.hasOwnProperty.call(message, "recordCount"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.recordCount);
                    return writer;
                };

                /**
                 * Encodes the specified CountFetchRs message, length delimited. Does not implicitly {@link priority.netitems.form.CountFetchRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.CountFetchRs
                 * @static
                 * @param {priority.netitems.form.ICountFetchRs} message CountFetchRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CountFetchRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CountFetchRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.CountFetchRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.CountFetchRs} CountFetchRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CountFetchRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.CountFetchRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.recordCount = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CountFetchRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.CountFetchRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.CountFetchRs} CountFetchRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CountFetchRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CountFetchRs message.
                 * @function verify
                 * @memberof priority.netitems.form.CountFetchRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CountFetchRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.recordCount != null && message.hasOwnProperty("recordCount"))
                        if (!$util.isInteger(message.recordCount) && !(message.recordCount && $util.isInteger(message.recordCount.low) && $util.isInteger(message.recordCount.high)))
                            return "recordCount: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a CountFetchRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.CountFetchRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.CountFetchRs} CountFetchRs
                 */
                CountFetchRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.CountFetchRs)
                        return object;
                    var message = new $root.priority.netitems.form.CountFetchRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.CountFetchRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.CountFetchRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.CountFetchRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.recordCount != null)
                        if ($util.Long)
                            (message.recordCount = $util.Long.fromValue(object.recordCount)).unsigned = false;
                        else if (typeof object.recordCount === "string")
                            message.recordCount = parseInt(object.recordCount, 10);
                        else if (typeof object.recordCount === "number")
                            message.recordCount = object.recordCount;
                        else if (typeof object.recordCount === "object")
                            message.recordCount = new $util.LongBits(object.recordCount.low >>> 0, object.recordCount.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a CountFetchRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.CountFetchRs
                 * @static
                 * @param {priority.netitems.form.CountFetchRs} message CountFetchRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CountFetchRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.recordCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.recordCount = options.longs === String ? "0" : 0;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.recordCount != null && message.hasOwnProperty("recordCount"))
                        if (typeof message.recordCount === "number")
                            object.recordCount = options.longs === String ? String(message.recordCount) : message.recordCount;
                        else
                            object.recordCount = options.longs === String ? $util.Long.prototype.toString.call(message.recordCount) : options.longs === Number ? new $util.LongBits(message.recordCount.low >>> 0, message.recordCount.high >>> 0).toNumber() : message.recordCount;
                    return object;
                };

                /**
                 * Converts this CountFetchRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.CountFetchRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CountFetchRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CountFetchRs;
            })();

            form.FormToExcelRq = (function() {

                /**
                 * Properties of a FormToExcelRq.
                 * @memberof priority.netitems.form
                 * @interface IFormToExcelRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] FormToExcelRq Properties
                 * @property {string|null} [Session] FormToExcelRq Session
                 * @property {Array.<priority.netitems.form.IFilter>|null} [Filters] FormToExcelRq Filters
                 * @property {priority.netitems.shared.LogicalOperator|null} [FiltersOp] FormToExcelRq FiltersOp
                 * @property {Array.<priority.netitems.form.ISort>|null} [Sort] FormToExcelRq Sort
                 * @property {number|Long|null} [Top] FormToExcelRq Top
                 * @property {number|Long|null} [Skip] FormToExcelRq Skip
                 * @property {Array.<number|Long>|null} [Select] FormToExcelRq Select
                 * @property {Array.<priority.netitems.form.IRecord>|null} [Removed] FormToExcelRq Removed
                 * @property {priority.netitems.form.ETemplate|null} [ETemplate] FormToExcelRq ETemplate
                 * @property {number|Long|null} [SavedTemplate] FormToExcelRq SavedTemplate
                 * @property {boolean|null} [FullExport] FormToExcelRq FullExport
                 */

                /**
                 * Constructs a new FormToExcelRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FormToExcelRq.
                 * @implements IFormToExcelRq
                 * @constructor
                 * @param {priority.netitems.form.IFormToExcelRq=} [properties] Properties to set
                 */
                function FormToExcelRq(properties) {
                    this.Filters = [];
                    this.Sort = [];
                    this.Select = [];
                    this.Removed = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FormToExcelRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.Properties = null;

                /**
                 * FormToExcelRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.Session = "";

                /**
                 * FormToExcelRq Filters.
                 * @member {Array.<priority.netitems.form.IFilter>} Filters
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.Filters = $util.emptyArray;

                /**
                 * FormToExcelRq FiltersOp.
                 * @member {priority.netitems.shared.LogicalOperator} FiltersOp
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.FiltersOp = 0;

                /**
                 * FormToExcelRq Sort.
                 * @member {Array.<priority.netitems.form.ISort>} Sort
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.Sort = $util.emptyArray;

                /**
                 * FormToExcelRq Top.
                 * @member {number|Long} Top
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.Top = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * FormToExcelRq Skip.
                 * @member {number|Long} Skip
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.Skip = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * FormToExcelRq Select.
                 * @member {Array.<number|Long>} Select
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.Select = $util.emptyArray;

                /**
                 * FormToExcelRq Removed.
                 * @member {Array.<priority.netitems.form.IRecord>} Removed
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.Removed = $util.emptyArray;

                /**
                 * FormToExcelRq ETemplate.
                 * @member {priority.netitems.form.ETemplate|null|undefined} ETemplate
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.ETemplate = null;

                /**
                 * FormToExcelRq SavedTemplate.
                 * @member {number|Long|null|undefined} SavedTemplate
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.SavedTemplate = null;

                /**
                 * FormToExcelRq FullExport.
                 * @member {boolean} FullExport
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                FormToExcelRq.prototype.FullExport = false;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * FormToExcelRq Template.
                 * @member {"ETemplate"|"SavedTemplate"|undefined} Template
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 */
                Object.defineProperty(FormToExcelRq.prototype, "Template", {
                    get: $util.oneOfGetter($oneOfFields = ["ETemplate", "SavedTemplate"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new FormToExcelRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @static
                 * @param {priority.netitems.form.IFormToExcelRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.FormToExcelRq} FormToExcelRq instance
                 */
                FormToExcelRq.create = function create(properties) {
                    return new FormToExcelRq(properties);
                };

                /**
                 * Encodes the specified FormToExcelRq message. Does not implicitly {@link priority.netitems.form.FormToExcelRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @static
                 * @param {priority.netitems.form.IFormToExcelRq} message FormToExcelRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormToExcelRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Filters != null && message.Filters.length)
                        for (var i = 0; i < message.Filters.length; ++i)
                            $root.priority.netitems.form.Filter.encode(message.Filters[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.FiltersOp != null && Object.hasOwnProperty.call(message, "FiltersOp"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.FiltersOp);
                    if (message.Sort != null && message.Sort.length)
                        for (var i = 0; i < message.Sort.length; ++i)
                            $root.priority.netitems.form.Sort.encode(message.Sort[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Top != null && Object.hasOwnProperty.call(message, "Top"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.Top);
                    if (message.Skip != null && Object.hasOwnProperty.call(message, "Skip"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.Skip);
                    if (message.Select != null && message.Select.length) {
                        writer.uint32(/* id 9, wireType 2 =*/74).fork();
                        for (var i = 0; i < message.Select.length; ++i)
                            writer.int64(message.Select[i]);
                        writer.ldelim();
                    }
                    if (message.Removed != null && message.Removed.length)
                        for (var i = 0; i < message.Removed.length; ++i)
                            $root.priority.netitems.form.Record.encode(message.Removed[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.ETemplate != null && Object.hasOwnProperty.call(message, "ETemplate"))
                        writer.uint32(/* id 11, wireType 0 =*/88).int32(message.ETemplate);
                    if (message.SavedTemplate != null && Object.hasOwnProperty.call(message, "SavedTemplate"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int64(message.SavedTemplate);
                    if (message.FullExport != null && Object.hasOwnProperty.call(message, "FullExport"))
                        writer.uint32(/* id 13, wireType 0 =*/104).bool(message.FullExport);
                    return writer;
                };

                /**
                 * Encodes the specified FormToExcelRq message, length delimited. Does not implicitly {@link priority.netitems.form.FormToExcelRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @static
                 * @param {priority.netitems.form.IFormToExcelRq} message FormToExcelRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormToExcelRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FormToExcelRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FormToExcelRq} FormToExcelRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormToExcelRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FormToExcelRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            if (!(message.Filters && message.Filters.length))
                                message.Filters = [];
                            message.Filters.push($root.priority.netitems.form.Filter.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            message.FiltersOp = reader.int32();
                            break;
                        case 6:
                            if (!(message.Sort && message.Sort.length))
                                message.Sort = [];
                            message.Sort.push($root.priority.netitems.form.Sort.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            message.Top = reader.int64();
                            break;
                        case 8:
                            message.Skip = reader.int64();
                            break;
                        case 9:
                            if (!(message.Select && message.Select.length))
                                message.Select = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.Select.push(reader.int64());
                            } else
                                message.Select.push(reader.int64());
                            break;
                        case 10:
                            if (!(message.Removed && message.Removed.length))
                                message.Removed = [];
                            message.Removed.push($root.priority.netitems.form.Record.decode(reader, reader.uint32()));
                            break;
                        case 11:
                            message.ETemplate = reader.int32();
                            break;
                        case 12:
                            message.SavedTemplate = reader.int64();
                            break;
                        case 13:
                            message.FullExport = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FormToExcelRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FormToExcelRq} FormToExcelRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormToExcelRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FormToExcelRq message.
                 * @function verify
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FormToExcelRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Filters != null && message.hasOwnProperty("Filters")) {
                        if (!Array.isArray(message.Filters))
                            return "Filters: array expected";
                        for (var i = 0; i < message.Filters.length; ++i) {
                            var error = $root.priority.netitems.form.Filter.verify(message.Filters[i]);
                            if (error)
                                return "Filters." + error;
                        }
                    }
                    if (message.FiltersOp != null && message.hasOwnProperty("FiltersOp"))
                        switch (message.FiltersOp) {
                        default:
                            return "FiltersOp: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.Sort != null && message.hasOwnProperty("Sort")) {
                        if (!Array.isArray(message.Sort))
                            return "Sort: array expected";
                        for (var i = 0; i < message.Sort.length; ++i) {
                            var error = $root.priority.netitems.form.Sort.verify(message.Sort[i]);
                            if (error)
                                return "Sort." + error;
                        }
                    }
                    if (message.Top != null && message.hasOwnProperty("Top"))
                        if (!$util.isInteger(message.Top) && !(message.Top && $util.isInteger(message.Top.low) && $util.isInteger(message.Top.high)))
                            return "Top: integer|Long expected";
                    if (message.Skip != null && message.hasOwnProperty("Skip"))
                        if (!$util.isInteger(message.Skip) && !(message.Skip && $util.isInteger(message.Skip.low) && $util.isInteger(message.Skip.high)))
                            return "Skip: integer|Long expected";
                    if (message.Select != null && message.hasOwnProperty("Select")) {
                        if (!Array.isArray(message.Select))
                            return "Select: array expected";
                        for (var i = 0; i < message.Select.length; ++i)
                            if (!$util.isInteger(message.Select[i]) && !(message.Select[i] && $util.isInteger(message.Select[i].low) && $util.isInteger(message.Select[i].high)))
                                return "Select: integer|Long[] expected";
                    }
                    if (message.Removed != null && message.hasOwnProperty("Removed")) {
                        if (!Array.isArray(message.Removed))
                            return "Removed: array expected";
                        for (var i = 0; i < message.Removed.length; ++i) {
                            var error = $root.priority.netitems.form.Record.verify(message.Removed[i]);
                            if (error)
                                return "Removed." + error;
                        }
                    }
                    if (message.ETemplate != null && message.hasOwnProperty("ETemplate")) {
                        properties.Template = 1;
                        switch (message.ETemplate) {
                        default:
                            return "ETemplate: enum value expected";
                        case 0:
                        case -1:
                        case -2:
                            break;
                        }
                    }
                    if (message.SavedTemplate != null && message.hasOwnProperty("SavedTemplate")) {
                        if (properties.Template === 1)
                            return "Template: multiple values";
                        properties.Template = 1;
                        if (!$util.isInteger(message.SavedTemplate) && !(message.SavedTemplate && $util.isInteger(message.SavedTemplate.low) && $util.isInteger(message.SavedTemplate.high)))
                            return "SavedTemplate: integer|Long expected";
                    }
                    if (message.FullExport != null && message.hasOwnProperty("FullExport"))
                        if (typeof message.FullExport !== "boolean")
                            return "FullExport: boolean expected";
                    return null;
                };

                /**
                 * Creates a FormToExcelRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FormToExcelRq} FormToExcelRq
                 */
                FormToExcelRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FormToExcelRq)
                        return object;
                    var message = new $root.priority.netitems.form.FormToExcelRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.FormToExcelRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Filters) {
                        if (!Array.isArray(object.Filters))
                            throw TypeError(".priority.netitems.form.FormToExcelRq.Filters: array expected");
                        message.Filters = [];
                        for (var i = 0; i < object.Filters.length; ++i) {
                            if (typeof object.Filters[i] !== "object")
                                throw TypeError(".priority.netitems.form.FormToExcelRq.Filters: object expected");
                            message.Filters[i] = $root.priority.netitems.form.Filter.fromObject(object.Filters[i]);
                        }
                    }
                    switch (object.FiltersOp) {
                    case "And":
                    case 0:
                        message.FiltersOp = 0;
                        break;
                    case "Or":
                    case 1:
                        message.FiltersOp = 1;
                        break;
                    }
                    if (object.Sort) {
                        if (!Array.isArray(object.Sort))
                            throw TypeError(".priority.netitems.form.FormToExcelRq.Sort: array expected");
                        message.Sort = [];
                        for (var i = 0; i < object.Sort.length; ++i) {
                            if (typeof object.Sort[i] !== "object")
                                throw TypeError(".priority.netitems.form.FormToExcelRq.Sort: object expected");
                            message.Sort[i] = $root.priority.netitems.form.Sort.fromObject(object.Sort[i]);
                        }
                    }
                    if (object.Top != null)
                        if ($util.Long)
                            (message.Top = $util.Long.fromValue(object.Top)).unsigned = false;
                        else if (typeof object.Top === "string")
                            message.Top = parseInt(object.Top, 10);
                        else if (typeof object.Top === "number")
                            message.Top = object.Top;
                        else if (typeof object.Top === "object")
                            message.Top = new $util.LongBits(object.Top.low >>> 0, object.Top.high >>> 0).toNumber();
                    if (object.Skip != null)
                        if ($util.Long)
                            (message.Skip = $util.Long.fromValue(object.Skip)).unsigned = false;
                        else if (typeof object.Skip === "string")
                            message.Skip = parseInt(object.Skip, 10);
                        else if (typeof object.Skip === "number")
                            message.Skip = object.Skip;
                        else if (typeof object.Skip === "object")
                            message.Skip = new $util.LongBits(object.Skip.low >>> 0, object.Skip.high >>> 0).toNumber();
                    if (object.Select) {
                        if (!Array.isArray(object.Select))
                            throw TypeError(".priority.netitems.form.FormToExcelRq.Select: array expected");
                        message.Select = [];
                        for (var i = 0; i < object.Select.length; ++i)
                            if ($util.Long)
                                (message.Select[i] = $util.Long.fromValue(object.Select[i])).unsigned = false;
                            else if (typeof object.Select[i] === "string")
                                message.Select[i] = parseInt(object.Select[i], 10);
                            else if (typeof object.Select[i] === "number")
                                message.Select[i] = object.Select[i];
                            else if (typeof object.Select[i] === "object")
                                message.Select[i] = new $util.LongBits(object.Select[i].low >>> 0, object.Select[i].high >>> 0).toNumber();
                    }
                    if (object.Removed) {
                        if (!Array.isArray(object.Removed))
                            throw TypeError(".priority.netitems.form.FormToExcelRq.Removed: array expected");
                        message.Removed = [];
                        for (var i = 0; i < object.Removed.length; ++i) {
                            if (typeof object.Removed[i] !== "object")
                                throw TypeError(".priority.netitems.form.FormToExcelRq.Removed: object expected");
                            message.Removed[i] = $root.priority.netitems.form.Record.fromObject(object.Removed[i]);
                        }
                    }
                    switch (object.ETemplate) {
                    case "UNKOWN_ETEMPLATE":
                    case 0:
                        message.ETemplate = 0;
                        break;
                    case "NOTEMPLATE":
                    case -1:
                        message.ETemplate = -1;
                        break;
                    case "NEWTEMPLATE":
                    case -2:
                        message.ETemplate = -2;
                        break;
                    }
                    if (object.SavedTemplate != null)
                        if ($util.Long)
                            (message.SavedTemplate = $util.Long.fromValue(object.SavedTemplate)).unsigned = false;
                        else if (typeof object.SavedTemplate === "string")
                            message.SavedTemplate = parseInt(object.SavedTemplate, 10);
                        else if (typeof object.SavedTemplate === "number")
                            message.SavedTemplate = object.SavedTemplate;
                        else if (typeof object.SavedTemplate === "object")
                            message.SavedTemplate = new $util.LongBits(object.SavedTemplate.low >>> 0, object.SavedTemplate.high >>> 0).toNumber();
                    if (object.FullExport != null)
                        message.FullExport = Boolean(object.FullExport);
                    return message;
                };

                /**
                 * Creates a plain object from a FormToExcelRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @static
                 * @param {priority.netitems.form.FormToExcelRq} message FormToExcelRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FormToExcelRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Filters = [];
                        object.Sort = [];
                        object.Select = [];
                        object.Removed = [];
                    }
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.FiltersOp = options.enums === String ? "And" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Top = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Top = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Skip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Skip = options.longs === String ? "0" : 0;
                        object.FullExport = false;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Filters && message.Filters.length) {
                        object.Filters = [];
                        for (var j = 0; j < message.Filters.length; ++j)
                            object.Filters[j] = $root.priority.netitems.form.Filter.toObject(message.Filters[j], options);
                    }
                    if (message.FiltersOp != null && message.hasOwnProperty("FiltersOp"))
                        object.FiltersOp = options.enums === String ? $root.priority.netitems.shared.LogicalOperator[message.FiltersOp] : message.FiltersOp;
                    if (message.Sort && message.Sort.length) {
                        object.Sort = [];
                        for (var j = 0; j < message.Sort.length; ++j)
                            object.Sort[j] = $root.priority.netitems.form.Sort.toObject(message.Sort[j], options);
                    }
                    if (message.Top != null && message.hasOwnProperty("Top"))
                        if (typeof message.Top === "number")
                            object.Top = options.longs === String ? String(message.Top) : message.Top;
                        else
                            object.Top = options.longs === String ? $util.Long.prototype.toString.call(message.Top) : options.longs === Number ? new $util.LongBits(message.Top.low >>> 0, message.Top.high >>> 0).toNumber() : message.Top;
                    if (message.Skip != null && message.hasOwnProperty("Skip"))
                        if (typeof message.Skip === "number")
                            object.Skip = options.longs === String ? String(message.Skip) : message.Skip;
                        else
                            object.Skip = options.longs === String ? $util.Long.prototype.toString.call(message.Skip) : options.longs === Number ? new $util.LongBits(message.Skip.low >>> 0, message.Skip.high >>> 0).toNumber() : message.Skip;
                    if (message.Select && message.Select.length) {
                        object.Select = [];
                        for (var j = 0; j < message.Select.length; ++j)
                            if (typeof message.Select[j] === "number")
                                object.Select[j] = options.longs === String ? String(message.Select[j]) : message.Select[j];
                            else
                                object.Select[j] = options.longs === String ? $util.Long.prototype.toString.call(message.Select[j]) : options.longs === Number ? new $util.LongBits(message.Select[j].low >>> 0, message.Select[j].high >>> 0).toNumber() : message.Select[j];
                    }
                    if (message.Removed && message.Removed.length) {
                        object.Removed = [];
                        for (var j = 0; j < message.Removed.length; ++j)
                            object.Removed[j] = $root.priority.netitems.form.Record.toObject(message.Removed[j], options);
                    }
                    if (message.ETemplate != null && message.hasOwnProperty("ETemplate")) {
                        object.ETemplate = options.enums === String ? $root.priority.netitems.form.ETemplate[message.ETemplate] : message.ETemplate;
                        if (options.oneofs)
                            object.Template = "ETemplate";
                    }
                    if (message.SavedTemplate != null && message.hasOwnProperty("SavedTemplate")) {
                        if (typeof message.SavedTemplate === "number")
                            object.SavedTemplate = options.longs === String ? String(message.SavedTemplate) : message.SavedTemplate;
                        else
                            object.SavedTemplate = options.longs === String ? $util.Long.prototype.toString.call(message.SavedTemplate) : options.longs === Number ? new $util.LongBits(message.SavedTemplate.low >>> 0, message.SavedTemplate.high >>> 0).toNumber() : message.SavedTemplate;
                        if (options.oneofs)
                            object.Template = "SavedTemplate";
                    }
                    if (message.FullExport != null && message.hasOwnProperty("FullExport"))
                        object.FullExport = message.FullExport;
                    return object;
                };

                /**
                 * Converts this FormToExcelRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FormToExcelRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FormToExcelRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FormToExcelRq;
            })();

            form.FormToExcelRs = (function() {

                /**
                 * Properties of a FormToExcelRs.
                 * @memberof priority.netitems.form
                 * @interface IFormToExcelRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] FormToExcelRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] FormToExcelRs Messages
                 * @property {string|null} [file] FormToExcelRs file
                 */

                /**
                 * Constructs a new FormToExcelRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FormToExcelRs.
                 * @implements IFormToExcelRs
                 * @constructor
                 * @param {priority.netitems.form.IFormToExcelRs=} [properties] Properties to set
                 */
                function FormToExcelRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FormToExcelRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @instance
                 */
                FormToExcelRs.prototype.Perf = null;

                /**
                 * FormToExcelRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @instance
                 */
                FormToExcelRs.prototype.Messages = $util.emptyArray;

                /**
                 * FormToExcelRs file.
                 * @member {string} file
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @instance
                 */
                FormToExcelRs.prototype.file = "";

                /**
                 * Creates a new FormToExcelRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @static
                 * @param {priority.netitems.form.IFormToExcelRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.FormToExcelRs} FormToExcelRs instance
                 */
                FormToExcelRs.create = function create(properties) {
                    return new FormToExcelRs(properties);
                };

                /**
                 * Encodes the specified FormToExcelRs message. Does not implicitly {@link priority.netitems.form.FormToExcelRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @static
                 * @param {priority.netitems.form.IFormToExcelRs} message FormToExcelRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormToExcelRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.file != null && Object.hasOwnProperty.call(message, "file"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.file);
                    return writer;
                };

                /**
                 * Encodes the specified FormToExcelRs message, length delimited. Does not implicitly {@link priority.netitems.form.FormToExcelRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @static
                 * @param {priority.netitems.form.IFormToExcelRs} message FormToExcelRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormToExcelRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FormToExcelRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FormToExcelRs} FormToExcelRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormToExcelRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FormToExcelRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.file = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FormToExcelRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FormToExcelRs} FormToExcelRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormToExcelRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FormToExcelRs message.
                 * @function verify
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FormToExcelRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.file != null && message.hasOwnProperty("file"))
                        if (!$util.isString(message.file))
                            return "file: string expected";
                    return null;
                };

                /**
                 * Creates a FormToExcelRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FormToExcelRs} FormToExcelRs
                 */
                FormToExcelRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FormToExcelRs)
                        return object;
                    var message = new $root.priority.netitems.form.FormToExcelRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.FormToExcelRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.FormToExcelRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.FormToExcelRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.file != null)
                        message.file = String(object.file);
                    return message;
                };

                /**
                 * Creates a plain object from a FormToExcelRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @static
                 * @param {priority.netitems.form.FormToExcelRs} message FormToExcelRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FormToExcelRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.file = "";
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.file != null && message.hasOwnProperty("file"))
                        object.file = message.file;
                    return object;
                };

                /**
                 * Converts this FormToExcelRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FormToExcelRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FormToExcelRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FormToExcelRs;
            })();

            form.RecordEditRq = (function() {

                /**
                 * Properties of a RecordEditRq.
                 * @memberof priority.netitems.form
                 * @interface IRecordEditRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RecordEditRq Properties
                 * @property {string|null} [Session] RecordEditRq Session
                 * @property {Array.<priority.netitems.form.IField>|null} [Keys] RecordEditRq Keys
                 * @property {number|Long|null} [ScrLine] RecordEditRq ScrLine
                 * @property {priority.netitems.form.AttachmentOptions|null} [Attachments] RecordEditRq Attachments
                 */

                /**
                 * Constructs a new RecordEditRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordEditRq.
                 * @implements IRecordEditRq
                 * @constructor
                 * @param {priority.netitems.form.IRecordEditRq=} [properties] Properties to set
                 */
                function RecordEditRq(properties) {
                    this.Keys = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordEditRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RecordEditRq
                 * @instance
                 */
                RecordEditRq.prototype.Properties = null;

                /**
                 * RecordEditRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.RecordEditRq
                 * @instance
                 */
                RecordEditRq.prototype.Session = "";

                /**
                 * RecordEditRq Keys.
                 * @member {Array.<priority.netitems.form.IField>} Keys
                 * @memberof priority.netitems.form.RecordEditRq
                 * @instance
                 */
                RecordEditRq.prototype.Keys = $util.emptyArray;

                /**
                 * RecordEditRq ScrLine.
                 * @member {number|Long} ScrLine
                 * @memberof priority.netitems.form.RecordEditRq
                 * @instance
                 */
                RecordEditRq.prototype.ScrLine = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * RecordEditRq Attachments.
                 * @member {priority.netitems.form.AttachmentOptions} Attachments
                 * @memberof priority.netitems.form.RecordEditRq
                 * @instance
                 */
                RecordEditRq.prototype.Attachments = 0;

                /**
                 * Creates a new RecordEditRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordEditRq
                 * @static
                 * @param {priority.netitems.form.IRecordEditRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordEditRq} RecordEditRq instance
                 */
                RecordEditRq.create = function create(properties) {
                    return new RecordEditRq(properties);
                };

                /**
                 * Encodes the specified RecordEditRq message. Does not implicitly {@link priority.netitems.form.RecordEditRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordEditRq
                 * @static
                 * @param {priority.netitems.form.IRecordEditRq} message RecordEditRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordEditRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Keys != null && message.Keys.length)
                        for (var i = 0; i < message.Keys.length; ++i)
                            $root.priority.netitems.form.Field.encode(message.Keys[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.ScrLine != null && Object.hasOwnProperty.call(message, "ScrLine"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ScrLine);
                    if (message.Attachments != null && Object.hasOwnProperty.call(message, "Attachments"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.Attachments);
                    return writer;
                };

                /**
                 * Encodes the specified RecordEditRq message, length delimited. Does not implicitly {@link priority.netitems.form.RecordEditRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordEditRq
                 * @static
                 * @param {priority.netitems.form.IRecordEditRq} message RecordEditRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordEditRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordEditRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordEditRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordEditRq} RecordEditRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordEditRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordEditRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            if (!(message.Keys && message.Keys.length))
                                message.Keys = [];
                            message.Keys.push($root.priority.netitems.form.Field.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            message.ScrLine = reader.int64();
                            break;
                        case 5:
                            message.Attachments = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordEditRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordEditRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordEditRq} RecordEditRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordEditRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordEditRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordEditRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordEditRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Keys != null && message.hasOwnProperty("Keys")) {
                        if (!Array.isArray(message.Keys))
                            return "Keys: array expected";
                        for (var i = 0; i < message.Keys.length; ++i) {
                            var error = $root.priority.netitems.form.Field.verify(message.Keys[i]);
                            if (error)
                                return "Keys." + error;
                        }
                    }
                    if (message.ScrLine != null && message.hasOwnProperty("ScrLine"))
                        if (!$util.isInteger(message.ScrLine) && !(message.ScrLine && $util.isInteger(message.ScrLine.low) && $util.isInteger(message.ScrLine.high)))
                            return "ScrLine: integer|Long expected";
                    if (message.Attachments != null && message.hasOwnProperty("Attachments"))
                        switch (message.Attachments) {
                        default:
                            return "Attachments: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a RecordEditRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordEditRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordEditRq} RecordEditRq
                 */
                RecordEditRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordEditRq)
                        return object;
                    var message = new $root.priority.netitems.form.RecordEditRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RecordEditRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Keys) {
                        if (!Array.isArray(object.Keys))
                            throw TypeError(".priority.netitems.form.RecordEditRq.Keys: array expected");
                        message.Keys = [];
                        for (var i = 0; i < object.Keys.length; ++i) {
                            if (typeof object.Keys[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordEditRq.Keys: object expected");
                            message.Keys[i] = $root.priority.netitems.form.Field.fromObject(object.Keys[i]);
                        }
                    }
                    if (object.ScrLine != null)
                        if ($util.Long)
                            (message.ScrLine = $util.Long.fromValue(object.ScrLine)).unsigned = false;
                        else if (typeof object.ScrLine === "string")
                            message.ScrLine = parseInt(object.ScrLine, 10);
                        else if (typeof object.ScrLine === "number")
                            message.ScrLine = object.ScrLine;
                        else if (typeof object.ScrLine === "object")
                            message.ScrLine = new $util.LongBits(object.ScrLine.low >>> 0, object.ScrLine.high >>> 0).toNumber();
                    switch (object.Attachments) {
                    case "Attach_NoData":
                    case 0:
                        message.Attachments = 0;
                        break;
                    case "Attach_Data":
                    case 1:
                        message.Attachments = 1;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordEditRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordEditRq
                 * @static
                 * @param {priority.netitems.form.RecordEditRq} message RecordEditRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordEditRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Keys = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ScrLine = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ScrLine = options.longs === String ? "0" : 0;
                        object.Attachments = options.enums === String ? "Attach_NoData" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Keys && message.Keys.length) {
                        object.Keys = [];
                        for (var j = 0; j < message.Keys.length; ++j)
                            object.Keys[j] = $root.priority.netitems.form.Field.toObject(message.Keys[j], options);
                    }
                    if (message.ScrLine != null && message.hasOwnProperty("ScrLine"))
                        if (typeof message.ScrLine === "number")
                            object.ScrLine = options.longs === String ? String(message.ScrLine) : message.ScrLine;
                        else
                            object.ScrLine = options.longs === String ? $util.Long.prototype.toString.call(message.ScrLine) : options.longs === Number ? new $util.LongBits(message.ScrLine.low >>> 0, message.ScrLine.high >>> 0).toNumber() : message.ScrLine;
                    if (message.Attachments != null && message.hasOwnProperty("Attachments"))
                        object.Attachments = options.enums === String ? $root.priority.netitems.form.AttachmentOptions[message.Attachments] : message.Attachments;
                    return object;
                };

                /**
                 * Converts this RecordEditRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordEditRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordEditRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordEditRq;
            })();

            form.RecordEditRs = (function() {

                /**
                 * Properties of a RecordEditRs.
                 * @memberof priority.netitems.form
                 * @interface IRecordEditRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RecordEditRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RecordEditRs Messages
                 * @property {priority.netitems.form.IRecord|null} [Record] RecordEditRs Record
                 */

                /**
                 * Constructs a new RecordEditRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordEditRs.
                 * @implements IRecordEditRs
                 * @constructor
                 * @param {priority.netitems.form.IRecordEditRs=} [properties] Properties to set
                 */
                function RecordEditRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordEditRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RecordEditRs
                 * @instance
                 */
                RecordEditRs.prototype.Perf = null;

                /**
                 * RecordEditRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RecordEditRs
                 * @instance
                 */
                RecordEditRs.prototype.Messages = $util.emptyArray;

                /**
                 * RecordEditRs Record.
                 * @member {priority.netitems.form.IRecord|null|undefined} Record
                 * @memberof priority.netitems.form.RecordEditRs
                 * @instance
                 */
                RecordEditRs.prototype.Record = null;

                /**
                 * Creates a new RecordEditRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordEditRs
                 * @static
                 * @param {priority.netitems.form.IRecordEditRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordEditRs} RecordEditRs instance
                 */
                RecordEditRs.create = function create(properties) {
                    return new RecordEditRs(properties);
                };

                /**
                 * Encodes the specified RecordEditRs message. Does not implicitly {@link priority.netitems.form.RecordEditRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordEditRs
                 * @static
                 * @param {priority.netitems.form.IRecordEditRs} message RecordEditRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordEditRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
                        $root.priority.netitems.form.Record.encode(message.Record, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RecordEditRs message, length delimited. Does not implicitly {@link priority.netitems.form.RecordEditRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordEditRs
                 * @static
                 * @param {priority.netitems.form.IRecordEditRs} message RecordEditRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordEditRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordEditRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordEditRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordEditRs} RecordEditRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordEditRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordEditRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Record = $root.priority.netitems.form.Record.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordEditRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordEditRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordEditRs} RecordEditRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordEditRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordEditRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordEditRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordEditRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Record != null && message.hasOwnProperty("Record")) {
                        var error = $root.priority.netitems.form.Record.verify(message.Record);
                        if (error)
                            return "Record." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RecordEditRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordEditRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordEditRs} RecordEditRs
                 */
                RecordEditRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordEditRs)
                        return object;
                    var message = new $root.priority.netitems.form.RecordEditRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RecordEditRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RecordEditRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordEditRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Record != null) {
                        if (typeof object.Record !== "object")
                            throw TypeError(".priority.netitems.form.RecordEditRs.Record: object expected");
                        message.Record = $root.priority.netitems.form.Record.fromObject(object.Record);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordEditRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordEditRs
                 * @static
                 * @param {priority.netitems.form.RecordEditRs} message RecordEditRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordEditRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.Record = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Record != null && message.hasOwnProperty("Record"))
                        object.Record = $root.priority.netitems.form.Record.toObject(message.Record, options);
                    return object;
                };

                /**
                 * Converts this RecordEditRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordEditRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordEditRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordEditRs;
            })();

            form.FieldUpdateRq = (function() {

                /**
                 * Properties of a FieldUpdateRq.
                 * @memberof priority.netitems.form
                 * @interface IFieldUpdateRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] FieldUpdateRq Properties
                 * @property {string|null} [Session] FieldUpdateRq Session
                 * @property {priority.netitems.form.IField|null} [Field] FieldUpdateRq Field
                 */

                /**
                 * Constructs a new FieldUpdateRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FieldUpdateRq.
                 * @implements IFieldUpdateRq
                 * @constructor
                 * @param {priority.netitems.form.IFieldUpdateRq=} [properties] Properties to set
                 */
                function FieldUpdateRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FieldUpdateRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @instance
                 */
                FieldUpdateRq.prototype.Properties = null;

                /**
                 * FieldUpdateRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @instance
                 */
                FieldUpdateRq.prototype.Session = "";

                /**
                 * FieldUpdateRq Field.
                 * @member {priority.netitems.form.IField|null|undefined} Field
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @instance
                 */
                FieldUpdateRq.prototype.Field = null;

                /**
                 * Creates a new FieldUpdateRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @static
                 * @param {priority.netitems.form.IFieldUpdateRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.FieldUpdateRq} FieldUpdateRq instance
                 */
                FieldUpdateRq.create = function create(properties) {
                    return new FieldUpdateRq(properties);
                };

                /**
                 * Encodes the specified FieldUpdateRq message. Does not implicitly {@link priority.netitems.form.FieldUpdateRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @static
                 * @param {priority.netitems.form.IFieldUpdateRq} message FieldUpdateRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldUpdateRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Field != null && Object.hasOwnProperty.call(message, "Field"))
                        $root.priority.netitems.form.Field.encode(message.Field, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FieldUpdateRq message, length delimited. Does not implicitly {@link priority.netitems.form.FieldUpdateRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @static
                 * @param {priority.netitems.form.IFieldUpdateRq} message FieldUpdateRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldUpdateRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FieldUpdateRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FieldUpdateRq} FieldUpdateRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldUpdateRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FieldUpdateRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.Field = $root.priority.netitems.form.Field.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FieldUpdateRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FieldUpdateRq} FieldUpdateRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldUpdateRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FieldUpdateRq message.
                 * @function verify
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldUpdateRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Field != null && message.hasOwnProperty("Field")) {
                        var error = $root.priority.netitems.form.Field.verify(message.Field);
                        if (error)
                            return "Field." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FieldUpdateRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FieldUpdateRq} FieldUpdateRq
                 */
                FieldUpdateRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FieldUpdateRq)
                        return object;
                    var message = new $root.priority.netitems.form.FieldUpdateRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.FieldUpdateRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Field != null) {
                        if (typeof object.Field !== "object")
                            throw TypeError(".priority.netitems.form.FieldUpdateRq.Field: object expected");
                        message.Field = $root.priority.netitems.form.Field.fromObject(object.Field);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FieldUpdateRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @static
                 * @param {priority.netitems.form.FieldUpdateRq} message FieldUpdateRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldUpdateRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.Field = null;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Field != null && message.hasOwnProperty("Field"))
                        object.Field = $root.priority.netitems.form.Field.toObject(message.Field, options);
                    return object;
                };

                /**
                 * Converts this FieldUpdateRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FieldUpdateRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldUpdateRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FieldUpdateRq;
            })();

            form.FieldUpdateRs = (function() {

                /**
                 * Properties of a FieldUpdateRs.
                 * @memberof priority.netitems.form
                 * @interface IFieldUpdateRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] FieldUpdateRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] FieldUpdateRs Messages
                 * @property {priority.netitems.form.IRecord|null} [Record] FieldUpdateRs Record
                 */

                /**
                 * Constructs a new FieldUpdateRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FieldUpdateRs.
                 * @implements IFieldUpdateRs
                 * @constructor
                 * @param {priority.netitems.form.IFieldUpdateRs=} [properties] Properties to set
                 */
                function FieldUpdateRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FieldUpdateRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @instance
                 */
                FieldUpdateRs.prototype.Perf = null;

                /**
                 * FieldUpdateRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @instance
                 */
                FieldUpdateRs.prototype.Messages = $util.emptyArray;

                /**
                 * FieldUpdateRs Record.
                 * @member {priority.netitems.form.IRecord|null|undefined} Record
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @instance
                 */
                FieldUpdateRs.prototype.Record = null;

                /**
                 * Creates a new FieldUpdateRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @static
                 * @param {priority.netitems.form.IFieldUpdateRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.FieldUpdateRs} FieldUpdateRs instance
                 */
                FieldUpdateRs.create = function create(properties) {
                    return new FieldUpdateRs(properties);
                };

                /**
                 * Encodes the specified FieldUpdateRs message. Does not implicitly {@link priority.netitems.form.FieldUpdateRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @static
                 * @param {priority.netitems.form.IFieldUpdateRs} message FieldUpdateRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldUpdateRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
                        $root.priority.netitems.form.Record.encode(message.Record, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FieldUpdateRs message, length delimited. Does not implicitly {@link priority.netitems.form.FieldUpdateRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @static
                 * @param {priority.netitems.form.IFieldUpdateRs} message FieldUpdateRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldUpdateRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FieldUpdateRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FieldUpdateRs} FieldUpdateRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldUpdateRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FieldUpdateRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Record = $root.priority.netitems.form.Record.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FieldUpdateRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FieldUpdateRs} FieldUpdateRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldUpdateRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FieldUpdateRs message.
                 * @function verify
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldUpdateRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Record != null && message.hasOwnProperty("Record")) {
                        var error = $root.priority.netitems.form.Record.verify(message.Record);
                        if (error)
                            return "Record." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FieldUpdateRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FieldUpdateRs} FieldUpdateRs
                 */
                FieldUpdateRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FieldUpdateRs)
                        return object;
                    var message = new $root.priority.netitems.form.FieldUpdateRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.FieldUpdateRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.FieldUpdateRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.FieldUpdateRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Record != null) {
                        if (typeof object.Record !== "object")
                            throw TypeError(".priority.netitems.form.FieldUpdateRs.Record: object expected");
                        message.Record = $root.priority.netitems.form.Record.fromObject(object.Record);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FieldUpdateRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @static
                 * @param {priority.netitems.form.FieldUpdateRs} message FieldUpdateRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldUpdateRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.Record = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Record != null && message.hasOwnProperty("Record"))
                        object.Record = $root.priority.netitems.form.Record.toObject(message.Record, options);
                    return object;
                };

                /**
                 * Converts this FieldUpdateRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FieldUpdateRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldUpdateRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FieldUpdateRs;
            })();

            form.RecordSaveRq = (function() {

                /**
                 * Properties of a RecordSaveRq.
                 * @memberof priority.netitems.form
                 * @interface IRecordSaveRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RecordSaveRq Properties
                 * @property {string|null} [Session] RecordSaveRq Session
                 */

                /**
                 * Constructs a new RecordSaveRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordSaveRq.
                 * @implements IRecordSaveRq
                 * @constructor
                 * @param {priority.netitems.form.IRecordSaveRq=} [properties] Properties to set
                 */
                function RecordSaveRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordSaveRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @instance
                 */
                RecordSaveRq.prototype.Properties = null;

                /**
                 * RecordSaveRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @instance
                 */
                RecordSaveRq.prototype.Session = "";

                /**
                 * Creates a new RecordSaveRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @static
                 * @param {priority.netitems.form.IRecordSaveRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordSaveRq} RecordSaveRq instance
                 */
                RecordSaveRq.create = function create(properties) {
                    return new RecordSaveRq(properties);
                };

                /**
                 * Encodes the specified RecordSaveRq message. Does not implicitly {@link priority.netitems.form.RecordSaveRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @static
                 * @param {priority.netitems.form.IRecordSaveRq} message RecordSaveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordSaveRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified RecordSaveRq message, length delimited. Does not implicitly {@link priority.netitems.form.RecordSaveRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @static
                 * @param {priority.netitems.form.IRecordSaveRq} message RecordSaveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordSaveRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordSaveRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordSaveRq} RecordSaveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordSaveRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordSaveRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordSaveRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordSaveRq} RecordSaveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordSaveRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordSaveRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordSaveRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates a RecordSaveRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordSaveRq} RecordSaveRq
                 */
                RecordSaveRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordSaveRq)
                        return object;
                    var message = new $root.priority.netitems.form.RecordSaveRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RecordSaveRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from a RecordSaveRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @static
                 * @param {priority.netitems.form.RecordSaveRq} message RecordSaveRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordSaveRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this RecordSaveRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordSaveRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordSaveRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordSaveRq;
            })();

            form.RecordSaveRs = (function() {

                /**
                 * Properties of a RecordSaveRs.
                 * @memberof priority.netitems.form
                 * @interface IRecordSaveRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RecordSaveRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RecordSaveRs Messages
                 * @property {priority.netitems.form.IRecord|null} [Record] RecordSaveRs Record
                 * @property {Object.<string,priority.netitems.form.RefreshLines>|null} [Refresh] RecordSaveRs Refresh
                 */

                /**
                 * Constructs a new RecordSaveRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordSaveRs.
                 * @implements IRecordSaveRs
                 * @constructor
                 * @param {priority.netitems.form.IRecordSaveRs=} [properties] Properties to set
                 */
                function RecordSaveRs(properties) {
                    this.Messages = [];
                    this.Refresh = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordSaveRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @instance
                 */
                RecordSaveRs.prototype.Perf = null;

                /**
                 * RecordSaveRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @instance
                 */
                RecordSaveRs.prototype.Messages = $util.emptyArray;

                /**
                 * RecordSaveRs Record.
                 * @member {priority.netitems.form.IRecord|null|undefined} Record
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @instance
                 */
                RecordSaveRs.prototype.Record = null;

                /**
                 * RecordSaveRs Refresh.
                 * @member {Object.<string,priority.netitems.form.RefreshLines>} Refresh
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @instance
                 */
                RecordSaveRs.prototype.Refresh = $util.emptyObject;

                /**
                 * Creates a new RecordSaveRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @static
                 * @param {priority.netitems.form.IRecordSaveRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordSaveRs} RecordSaveRs instance
                 */
                RecordSaveRs.create = function create(properties) {
                    return new RecordSaveRs(properties);
                };

                /**
                 * Encodes the specified RecordSaveRs message. Does not implicitly {@link priority.netitems.form.RecordSaveRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @static
                 * @param {priority.netitems.form.IRecordSaveRs} message RecordSaveRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordSaveRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
                        $root.priority.netitems.form.Record.encode(message.Record, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Refresh != null && Object.hasOwnProperty.call(message, "Refresh"))
                        for (var keys = Object.keys(message.Refresh), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.Refresh[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RecordSaveRs message, length delimited. Does not implicitly {@link priority.netitems.form.RecordSaveRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @static
                 * @param {priority.netitems.form.IRecordSaveRs} message RecordSaveRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordSaveRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordSaveRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordSaveRs} RecordSaveRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordSaveRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordSaveRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Record = $root.priority.netitems.form.Record.decode(reader, reader.uint32());
                            break;
                        case 4:
                            if (message.Refresh === $util.emptyObject)
                                message.Refresh = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = 0;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.Refresh[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordSaveRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordSaveRs} RecordSaveRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordSaveRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordSaveRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordSaveRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Record != null && message.hasOwnProperty("Record")) {
                        var error = $root.priority.netitems.form.Record.verify(message.Record);
                        if (error)
                            return "Record." + error;
                    }
                    if (message.Refresh != null && message.hasOwnProperty("Refresh")) {
                        if (!$util.isObject(message.Refresh))
                            return "Refresh: object expected";
                        var key = Object.keys(message.Refresh);
                        for (var i = 0; i < key.length; ++i)
                            switch (message.Refresh[key[i]]) {
                            default:
                                return "Refresh: enum value{k:string} expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a RecordSaveRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordSaveRs} RecordSaveRs
                 */
                RecordSaveRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordSaveRs)
                        return object;
                    var message = new $root.priority.netitems.form.RecordSaveRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RecordSaveRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RecordSaveRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordSaveRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Record != null) {
                        if (typeof object.Record !== "object")
                            throw TypeError(".priority.netitems.form.RecordSaveRs.Record: object expected");
                        message.Record = $root.priority.netitems.form.Record.fromObject(object.Record);
                    }
                    if (object.Refresh) {
                        if (typeof object.Refresh !== "object")
                            throw TypeError(".priority.netitems.form.RecordSaveRs.Refresh: object expected");
                        message.Refresh = {};
                        for (var keys = Object.keys(object.Refresh), i = 0; i < keys.length; ++i)
                            switch (object.Refresh[keys[i]]) {
                            case "None":
                            case 0:
                                message.Refresh[keys[i]] = 0;
                                break;
                            case "ActiveRecord":
                            case 1:
                                message.Refresh[keys[i]] = 1;
                                break;
                            case "AllRecords":
                            case 2:
                                message.Refresh[keys[i]] = 2;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordSaveRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @static
                 * @param {priority.netitems.form.RecordSaveRs} message RecordSaveRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordSaveRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.Refresh = {};
                    if (options.defaults) {
                        object.Perf = null;
                        object.Record = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Record != null && message.hasOwnProperty("Record"))
                        object.Record = $root.priority.netitems.form.Record.toObject(message.Record, options);
                    var keys2;
                    if (message.Refresh && (keys2 = Object.keys(message.Refresh)).length) {
                        object.Refresh = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.Refresh[keys2[j]] = options.enums === String ? $root.priority.netitems.form.RefreshLines[message.Refresh[keys2[j]]] : message.Refresh[keys2[j]];
                    }
                    return object;
                };

                /**
                 * Converts this RecordSaveRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordSaveRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordSaveRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordSaveRs;
            })();

            form.RecordDeleteRq = (function() {

                /**
                 * Properties of a RecordDeleteRq.
                 * @memberof priority.netitems.form
                 * @interface IRecordDeleteRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RecordDeleteRq Properties
                 * @property {string|null} [Session] RecordDeleteRq Session
                 * @property {Array.<priority.netitems.form.IField>|null} [Keys] RecordDeleteRq Keys
                 * @property {number|Long|null} [ScrLine] RecordDeleteRq ScrLine
                 */

                /**
                 * Constructs a new RecordDeleteRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordDeleteRq.
                 * @implements IRecordDeleteRq
                 * @constructor
                 * @param {priority.netitems.form.IRecordDeleteRq=} [properties] Properties to set
                 */
                function RecordDeleteRq(properties) {
                    this.Keys = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordDeleteRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @instance
                 */
                RecordDeleteRq.prototype.Properties = null;

                /**
                 * RecordDeleteRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @instance
                 */
                RecordDeleteRq.prototype.Session = "";

                /**
                 * RecordDeleteRq Keys.
                 * @member {Array.<priority.netitems.form.IField>} Keys
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @instance
                 */
                RecordDeleteRq.prototype.Keys = $util.emptyArray;

                /**
                 * RecordDeleteRq ScrLine.
                 * @member {number|Long} ScrLine
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @instance
                 */
                RecordDeleteRq.prototype.ScrLine = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new RecordDeleteRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @static
                 * @param {priority.netitems.form.IRecordDeleteRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordDeleteRq} RecordDeleteRq instance
                 */
                RecordDeleteRq.create = function create(properties) {
                    return new RecordDeleteRq(properties);
                };

                /**
                 * Encodes the specified RecordDeleteRq message. Does not implicitly {@link priority.netitems.form.RecordDeleteRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @static
                 * @param {priority.netitems.form.IRecordDeleteRq} message RecordDeleteRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordDeleteRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Keys != null && message.Keys.length)
                        for (var i = 0; i < message.Keys.length; ++i)
                            $root.priority.netitems.form.Field.encode(message.Keys[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.ScrLine != null && Object.hasOwnProperty.call(message, "ScrLine"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ScrLine);
                    return writer;
                };

                /**
                 * Encodes the specified RecordDeleteRq message, length delimited. Does not implicitly {@link priority.netitems.form.RecordDeleteRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @static
                 * @param {priority.netitems.form.IRecordDeleteRq} message RecordDeleteRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordDeleteRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordDeleteRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordDeleteRq} RecordDeleteRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordDeleteRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordDeleteRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            if (!(message.Keys && message.Keys.length))
                                message.Keys = [];
                            message.Keys.push($root.priority.netitems.form.Field.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            message.ScrLine = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordDeleteRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordDeleteRq} RecordDeleteRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordDeleteRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordDeleteRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordDeleteRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Keys != null && message.hasOwnProperty("Keys")) {
                        if (!Array.isArray(message.Keys))
                            return "Keys: array expected";
                        for (var i = 0; i < message.Keys.length; ++i) {
                            var error = $root.priority.netitems.form.Field.verify(message.Keys[i]);
                            if (error)
                                return "Keys." + error;
                        }
                    }
                    if (message.ScrLine != null && message.hasOwnProperty("ScrLine"))
                        if (!$util.isInteger(message.ScrLine) && !(message.ScrLine && $util.isInteger(message.ScrLine.low) && $util.isInteger(message.ScrLine.high)))
                            return "ScrLine: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a RecordDeleteRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordDeleteRq} RecordDeleteRq
                 */
                RecordDeleteRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordDeleteRq)
                        return object;
                    var message = new $root.priority.netitems.form.RecordDeleteRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RecordDeleteRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Keys) {
                        if (!Array.isArray(object.Keys))
                            throw TypeError(".priority.netitems.form.RecordDeleteRq.Keys: array expected");
                        message.Keys = [];
                        for (var i = 0; i < object.Keys.length; ++i) {
                            if (typeof object.Keys[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordDeleteRq.Keys: object expected");
                            message.Keys[i] = $root.priority.netitems.form.Field.fromObject(object.Keys[i]);
                        }
                    }
                    if (object.ScrLine != null)
                        if ($util.Long)
                            (message.ScrLine = $util.Long.fromValue(object.ScrLine)).unsigned = false;
                        else if (typeof object.ScrLine === "string")
                            message.ScrLine = parseInt(object.ScrLine, 10);
                        else if (typeof object.ScrLine === "number")
                            message.ScrLine = object.ScrLine;
                        else if (typeof object.ScrLine === "object")
                            message.ScrLine = new $util.LongBits(object.ScrLine.low >>> 0, object.ScrLine.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a RecordDeleteRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @static
                 * @param {priority.netitems.form.RecordDeleteRq} message RecordDeleteRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordDeleteRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Keys = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ScrLine = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ScrLine = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Keys && message.Keys.length) {
                        object.Keys = [];
                        for (var j = 0; j < message.Keys.length; ++j)
                            object.Keys[j] = $root.priority.netitems.form.Field.toObject(message.Keys[j], options);
                    }
                    if (message.ScrLine != null && message.hasOwnProperty("ScrLine"))
                        if (typeof message.ScrLine === "number")
                            object.ScrLine = options.longs === String ? String(message.ScrLine) : message.ScrLine;
                        else
                            object.ScrLine = options.longs === String ? $util.Long.prototype.toString.call(message.ScrLine) : options.longs === Number ? new $util.LongBits(message.ScrLine.low >>> 0, message.ScrLine.high >>> 0).toNumber() : message.ScrLine;
                    return object;
                };

                /**
                 * Converts this RecordDeleteRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordDeleteRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordDeleteRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordDeleteRq;
            })();

            form.RecordDeleteRs = (function() {

                /**
                 * Properties of a RecordDeleteRs.
                 * @memberof priority.netitems.form
                 * @interface IRecordDeleteRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RecordDeleteRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RecordDeleteRs Messages
                 * @property {Object.<string,priority.netitems.form.RefreshLines>|null} [Refresh] RecordDeleteRs Refresh
                 */

                /**
                 * Constructs a new RecordDeleteRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordDeleteRs.
                 * @implements IRecordDeleteRs
                 * @constructor
                 * @param {priority.netitems.form.IRecordDeleteRs=} [properties] Properties to set
                 */
                function RecordDeleteRs(properties) {
                    this.Messages = [];
                    this.Refresh = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordDeleteRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @instance
                 */
                RecordDeleteRs.prototype.Perf = null;

                /**
                 * RecordDeleteRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @instance
                 */
                RecordDeleteRs.prototype.Messages = $util.emptyArray;

                /**
                 * RecordDeleteRs Refresh.
                 * @member {Object.<string,priority.netitems.form.RefreshLines>} Refresh
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @instance
                 */
                RecordDeleteRs.prototype.Refresh = $util.emptyObject;

                /**
                 * Creates a new RecordDeleteRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @static
                 * @param {priority.netitems.form.IRecordDeleteRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordDeleteRs} RecordDeleteRs instance
                 */
                RecordDeleteRs.create = function create(properties) {
                    return new RecordDeleteRs(properties);
                };

                /**
                 * Encodes the specified RecordDeleteRs message. Does not implicitly {@link priority.netitems.form.RecordDeleteRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @static
                 * @param {priority.netitems.form.IRecordDeleteRs} message RecordDeleteRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordDeleteRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Refresh != null && Object.hasOwnProperty.call(message, "Refresh"))
                        for (var keys = Object.keys(message.Refresh), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.Refresh[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RecordDeleteRs message, length delimited. Does not implicitly {@link priority.netitems.form.RecordDeleteRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @static
                 * @param {priority.netitems.form.IRecordDeleteRs} message RecordDeleteRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordDeleteRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordDeleteRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordDeleteRs} RecordDeleteRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordDeleteRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordDeleteRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (message.Refresh === $util.emptyObject)
                                message.Refresh = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = 0;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.Refresh[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordDeleteRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordDeleteRs} RecordDeleteRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordDeleteRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordDeleteRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordDeleteRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Refresh != null && message.hasOwnProperty("Refresh")) {
                        if (!$util.isObject(message.Refresh))
                            return "Refresh: object expected";
                        var key = Object.keys(message.Refresh);
                        for (var i = 0; i < key.length; ++i)
                            switch (message.Refresh[key[i]]) {
                            default:
                                return "Refresh: enum value{k:string} expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a RecordDeleteRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordDeleteRs} RecordDeleteRs
                 */
                RecordDeleteRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordDeleteRs)
                        return object;
                    var message = new $root.priority.netitems.form.RecordDeleteRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RecordDeleteRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RecordDeleteRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordDeleteRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Refresh) {
                        if (typeof object.Refresh !== "object")
                            throw TypeError(".priority.netitems.form.RecordDeleteRs.Refresh: object expected");
                        message.Refresh = {};
                        for (var keys = Object.keys(object.Refresh), i = 0; i < keys.length; ++i)
                            switch (object.Refresh[keys[i]]) {
                            case "None":
                            case 0:
                                message.Refresh[keys[i]] = 0;
                                break;
                            case "ActiveRecord":
                            case 1:
                                message.Refresh[keys[i]] = 1;
                                break;
                            case "AllRecords":
                            case 2:
                                message.Refresh[keys[i]] = 2;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordDeleteRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @static
                 * @param {priority.netitems.form.RecordDeleteRs} message RecordDeleteRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordDeleteRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.Refresh = {};
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    var keys2;
                    if (message.Refresh && (keys2 = Object.keys(message.Refresh)).length) {
                        object.Refresh = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.Refresh[keys2[j]] = options.enums === String ? $root.priority.netitems.form.RefreshLines[message.Refresh[keys2[j]]] : message.Refresh[keys2[j]];
                    }
                    return object;
                };

                /**
                 * Converts this RecordDeleteRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordDeleteRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordDeleteRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordDeleteRs;
            })();

            form.WarningApproveRq = (function() {

                /**
                 * Properties of a WarningApproveRq.
                 * @memberof priority.netitems.form
                 * @interface IWarningApproveRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] WarningApproveRq Properties
                 * @property {string|null} [Session] WarningApproveRq Session
                 */

                /**
                 * Constructs a new WarningApproveRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a WarningApproveRq.
                 * @implements IWarningApproveRq
                 * @constructor
                 * @param {priority.netitems.form.IWarningApproveRq=} [properties] Properties to set
                 */
                function WarningApproveRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * WarningApproveRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @instance
                 */
                WarningApproveRq.prototype.Properties = null;

                /**
                 * WarningApproveRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @instance
                 */
                WarningApproveRq.prototype.Session = "";

                /**
                 * Creates a new WarningApproveRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @static
                 * @param {priority.netitems.form.IWarningApproveRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.WarningApproveRq} WarningApproveRq instance
                 */
                WarningApproveRq.create = function create(properties) {
                    return new WarningApproveRq(properties);
                };

                /**
                 * Encodes the specified WarningApproveRq message. Does not implicitly {@link priority.netitems.form.WarningApproveRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @static
                 * @param {priority.netitems.form.IWarningApproveRq} message WarningApproveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WarningApproveRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified WarningApproveRq message, length delimited. Does not implicitly {@link priority.netitems.form.WarningApproveRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @static
                 * @param {priority.netitems.form.IWarningApproveRq} message WarningApproveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WarningApproveRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a WarningApproveRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.WarningApproveRq} WarningApproveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WarningApproveRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.WarningApproveRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a WarningApproveRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.WarningApproveRq} WarningApproveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WarningApproveRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a WarningApproveRq message.
                 * @function verify
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                WarningApproveRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates a WarningApproveRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.WarningApproveRq} WarningApproveRq
                 */
                WarningApproveRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.WarningApproveRq)
                        return object;
                    var message = new $root.priority.netitems.form.WarningApproveRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.WarningApproveRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from a WarningApproveRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @static
                 * @param {priority.netitems.form.WarningApproveRq} message WarningApproveRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                WarningApproveRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this WarningApproveRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.WarningApproveRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                WarningApproveRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return WarningApproveRq;
            })();

            form.WarningApproveRs = (function() {

                /**
                 * Properties of a WarningApproveRs.
                 * @memberof priority.netitems.form
                 * @interface IWarningApproveRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] WarningApproveRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] WarningApproveRs Messages
                 * @property {priority.netitems.form.IRecord|null} [Record] WarningApproveRs Record
                 * @property {Object.<string,priority.netitems.form.RefreshLines>|null} [Refresh] WarningApproveRs Refresh
                 */

                /**
                 * Constructs a new WarningApproveRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a WarningApproveRs.
                 * @implements IWarningApproveRs
                 * @constructor
                 * @param {priority.netitems.form.IWarningApproveRs=} [properties] Properties to set
                 */
                function WarningApproveRs(properties) {
                    this.Messages = [];
                    this.Refresh = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * WarningApproveRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @instance
                 */
                WarningApproveRs.prototype.Perf = null;

                /**
                 * WarningApproveRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @instance
                 */
                WarningApproveRs.prototype.Messages = $util.emptyArray;

                /**
                 * WarningApproveRs Record.
                 * @member {priority.netitems.form.IRecord|null|undefined} Record
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @instance
                 */
                WarningApproveRs.prototype.Record = null;

                /**
                 * WarningApproveRs Refresh.
                 * @member {Object.<string,priority.netitems.form.RefreshLines>} Refresh
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @instance
                 */
                WarningApproveRs.prototype.Refresh = $util.emptyObject;

                /**
                 * Creates a new WarningApproveRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @static
                 * @param {priority.netitems.form.IWarningApproveRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.WarningApproveRs} WarningApproveRs instance
                 */
                WarningApproveRs.create = function create(properties) {
                    return new WarningApproveRs(properties);
                };

                /**
                 * Encodes the specified WarningApproveRs message. Does not implicitly {@link priority.netitems.form.WarningApproveRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @static
                 * @param {priority.netitems.form.IWarningApproveRs} message WarningApproveRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WarningApproveRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
                        $root.priority.netitems.form.Record.encode(message.Record, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Refresh != null && Object.hasOwnProperty.call(message, "Refresh"))
                        for (var keys = Object.keys(message.Refresh), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.Refresh[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified WarningApproveRs message, length delimited. Does not implicitly {@link priority.netitems.form.WarningApproveRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @static
                 * @param {priority.netitems.form.IWarningApproveRs} message WarningApproveRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WarningApproveRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a WarningApproveRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.WarningApproveRs} WarningApproveRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WarningApproveRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.WarningApproveRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Record = $root.priority.netitems.form.Record.decode(reader, reader.uint32());
                            break;
                        case 4:
                            if (message.Refresh === $util.emptyObject)
                                message.Refresh = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = 0;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.Refresh[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a WarningApproveRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.WarningApproveRs} WarningApproveRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WarningApproveRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a WarningApproveRs message.
                 * @function verify
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                WarningApproveRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Record != null && message.hasOwnProperty("Record")) {
                        var error = $root.priority.netitems.form.Record.verify(message.Record);
                        if (error)
                            return "Record." + error;
                    }
                    if (message.Refresh != null && message.hasOwnProperty("Refresh")) {
                        if (!$util.isObject(message.Refresh))
                            return "Refresh: object expected";
                        var key = Object.keys(message.Refresh);
                        for (var i = 0; i < key.length; ++i)
                            switch (message.Refresh[key[i]]) {
                            default:
                                return "Refresh: enum value{k:string} expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a WarningApproveRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.WarningApproveRs} WarningApproveRs
                 */
                WarningApproveRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.WarningApproveRs)
                        return object;
                    var message = new $root.priority.netitems.form.WarningApproveRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.WarningApproveRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.WarningApproveRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.WarningApproveRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Record != null) {
                        if (typeof object.Record !== "object")
                            throw TypeError(".priority.netitems.form.WarningApproveRs.Record: object expected");
                        message.Record = $root.priority.netitems.form.Record.fromObject(object.Record);
                    }
                    if (object.Refresh) {
                        if (typeof object.Refresh !== "object")
                            throw TypeError(".priority.netitems.form.WarningApproveRs.Refresh: object expected");
                        message.Refresh = {};
                        for (var keys = Object.keys(object.Refresh), i = 0; i < keys.length; ++i)
                            switch (object.Refresh[keys[i]]) {
                            case "None":
                            case 0:
                                message.Refresh[keys[i]] = 0;
                                break;
                            case "ActiveRecord":
                            case 1:
                                message.Refresh[keys[i]] = 1;
                                break;
                            case "AllRecords":
                            case 2:
                                message.Refresh[keys[i]] = 2;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a WarningApproveRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @static
                 * @param {priority.netitems.form.WarningApproveRs} message WarningApproveRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                WarningApproveRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.Refresh = {};
                    if (options.defaults) {
                        object.Perf = null;
                        object.Record = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Record != null && message.hasOwnProperty("Record"))
                        object.Record = $root.priority.netitems.form.Record.toObject(message.Record, options);
                    var keys2;
                    if (message.Refresh && (keys2 = Object.keys(message.Refresh)).length) {
                        object.Refresh = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.Refresh[keys2[j]] = options.enums === String ? $root.priority.netitems.form.RefreshLines[message.Refresh[keys2[j]]] : message.Refresh[keys2[j]];
                    }
                    return object;
                };

                /**
                 * Converts this WarningApproveRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.WarningApproveRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                WarningApproveRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return WarningApproveRs;
            })();

            form.RecordUndoRq = (function() {

                /**
                 * Properties of a RecordUndoRq.
                 * @memberof priority.netitems.form
                 * @interface IRecordUndoRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RecordUndoRq Properties
                 * @property {string|null} [Session] RecordUndoRq Session
                 * @property {priority.netitems.form.AttachmentOptions|null} [Attachments] RecordUndoRq Attachments
                 */

                /**
                 * Constructs a new RecordUndoRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordUndoRq.
                 * @implements IRecordUndoRq
                 * @constructor
                 * @param {priority.netitems.form.IRecordUndoRq=} [properties] Properties to set
                 */
                function RecordUndoRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordUndoRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @instance
                 */
                RecordUndoRq.prototype.Properties = null;

                /**
                 * RecordUndoRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @instance
                 */
                RecordUndoRq.prototype.Session = "";

                /**
                 * RecordUndoRq Attachments.
                 * @member {priority.netitems.form.AttachmentOptions} Attachments
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @instance
                 */
                RecordUndoRq.prototype.Attachments = 0;

                /**
                 * Creates a new RecordUndoRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @static
                 * @param {priority.netitems.form.IRecordUndoRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordUndoRq} RecordUndoRq instance
                 */
                RecordUndoRq.create = function create(properties) {
                    return new RecordUndoRq(properties);
                };

                /**
                 * Encodes the specified RecordUndoRq message. Does not implicitly {@link priority.netitems.form.RecordUndoRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @static
                 * @param {priority.netitems.form.IRecordUndoRq} message RecordUndoRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordUndoRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Attachments != null && Object.hasOwnProperty.call(message, "Attachments"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Attachments);
                    return writer;
                };

                /**
                 * Encodes the specified RecordUndoRq message, length delimited. Does not implicitly {@link priority.netitems.form.RecordUndoRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @static
                 * @param {priority.netitems.form.IRecordUndoRq} message RecordUndoRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordUndoRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordUndoRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordUndoRq} RecordUndoRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordUndoRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordUndoRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.Attachments = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordUndoRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordUndoRq} RecordUndoRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordUndoRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordUndoRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordUndoRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Attachments != null && message.hasOwnProperty("Attachments"))
                        switch (message.Attachments) {
                        default:
                            return "Attachments: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a RecordUndoRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordUndoRq} RecordUndoRq
                 */
                RecordUndoRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordUndoRq)
                        return object;
                    var message = new $root.priority.netitems.form.RecordUndoRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RecordUndoRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    switch (object.Attachments) {
                    case "Attach_NoData":
                    case 0:
                        message.Attachments = 0;
                        break;
                    case "Attach_Data":
                    case 1:
                        message.Attachments = 1;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordUndoRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @static
                 * @param {priority.netitems.form.RecordUndoRq} message RecordUndoRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordUndoRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.Attachments = options.enums === String ? "Attach_NoData" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Attachments != null && message.hasOwnProperty("Attachments"))
                        object.Attachments = options.enums === String ? $root.priority.netitems.form.AttachmentOptions[message.Attachments] : message.Attachments;
                    return object;
                };

                /**
                 * Converts this RecordUndoRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordUndoRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordUndoRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordUndoRq;
            })();

            form.RecordUndoRs = (function() {

                /**
                 * Properties of a RecordUndoRs.
                 * @memberof priority.netitems.form
                 * @interface IRecordUndoRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RecordUndoRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RecordUndoRs Messages
                 * @property {priority.netitems.form.IRecord|null} [Record] RecordUndoRs Record
                 */

                /**
                 * Constructs a new RecordUndoRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordUndoRs.
                 * @implements IRecordUndoRs
                 * @constructor
                 * @param {priority.netitems.form.IRecordUndoRs=} [properties] Properties to set
                 */
                function RecordUndoRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordUndoRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @instance
                 */
                RecordUndoRs.prototype.Perf = null;

                /**
                 * RecordUndoRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @instance
                 */
                RecordUndoRs.prototype.Messages = $util.emptyArray;

                /**
                 * RecordUndoRs Record.
                 * @member {priority.netitems.form.IRecord|null|undefined} Record
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @instance
                 */
                RecordUndoRs.prototype.Record = null;

                /**
                 * Creates a new RecordUndoRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @static
                 * @param {priority.netitems.form.IRecordUndoRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordUndoRs} RecordUndoRs instance
                 */
                RecordUndoRs.create = function create(properties) {
                    return new RecordUndoRs(properties);
                };

                /**
                 * Encodes the specified RecordUndoRs message. Does not implicitly {@link priority.netitems.form.RecordUndoRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @static
                 * @param {priority.netitems.form.IRecordUndoRs} message RecordUndoRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordUndoRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
                        $root.priority.netitems.form.Record.encode(message.Record, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RecordUndoRs message, length delimited. Does not implicitly {@link priority.netitems.form.RecordUndoRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @static
                 * @param {priority.netitems.form.IRecordUndoRs} message RecordUndoRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordUndoRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordUndoRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordUndoRs} RecordUndoRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordUndoRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordUndoRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Record = $root.priority.netitems.form.Record.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordUndoRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordUndoRs} RecordUndoRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordUndoRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordUndoRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordUndoRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Record != null && message.hasOwnProperty("Record")) {
                        var error = $root.priority.netitems.form.Record.verify(message.Record);
                        if (error)
                            return "Record." + error;
                    }
                    return null;
                };

                /**
                 * Creates a RecordUndoRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordUndoRs} RecordUndoRs
                 */
                RecordUndoRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordUndoRs)
                        return object;
                    var message = new $root.priority.netitems.form.RecordUndoRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RecordUndoRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RecordUndoRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordUndoRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Record != null) {
                        if (typeof object.Record !== "object")
                            throw TypeError(".priority.netitems.form.RecordUndoRs.Record: object expected");
                        message.Record = $root.priority.netitems.form.Record.fromObject(object.Record);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordUndoRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @static
                 * @param {priority.netitems.form.RecordUndoRs} message RecordUndoRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordUndoRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.Record = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Record != null && message.hasOwnProperty("Record"))
                        object.Record = $root.priority.netitems.form.Record.toObject(message.Record, options);
                    return object;
                };

                /**
                 * Converts this RecordUndoRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordUndoRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordUndoRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordUndoRs;
            })();

            form.FieldUndoRq = (function() {

                /**
                 * Properties of a FieldUndoRq.
                 * @memberof priority.netitems.form
                 * @interface IFieldUndoRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] FieldUndoRq Properties
                 * @property {string|null} [Session] FieldUndoRq Session
                 */

                /**
                 * Constructs a new FieldUndoRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FieldUndoRq.
                 * @implements IFieldUndoRq
                 * @constructor
                 * @param {priority.netitems.form.IFieldUndoRq=} [properties] Properties to set
                 */
                function FieldUndoRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FieldUndoRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @instance
                 */
                FieldUndoRq.prototype.Properties = null;

                /**
                 * FieldUndoRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @instance
                 */
                FieldUndoRq.prototype.Session = "";

                /**
                 * Creates a new FieldUndoRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @static
                 * @param {priority.netitems.form.IFieldUndoRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.FieldUndoRq} FieldUndoRq instance
                 */
                FieldUndoRq.create = function create(properties) {
                    return new FieldUndoRq(properties);
                };

                /**
                 * Encodes the specified FieldUndoRq message. Does not implicitly {@link priority.netitems.form.FieldUndoRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @static
                 * @param {priority.netitems.form.IFieldUndoRq} message FieldUndoRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldUndoRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified FieldUndoRq message, length delimited. Does not implicitly {@link priority.netitems.form.FieldUndoRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @static
                 * @param {priority.netitems.form.IFieldUndoRq} message FieldUndoRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldUndoRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FieldUndoRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FieldUndoRq} FieldUndoRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldUndoRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FieldUndoRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FieldUndoRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FieldUndoRq} FieldUndoRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldUndoRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FieldUndoRq message.
                 * @function verify
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldUndoRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates a FieldUndoRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FieldUndoRq} FieldUndoRq
                 */
                FieldUndoRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FieldUndoRq)
                        return object;
                    var message = new $root.priority.netitems.form.FieldUndoRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.FieldUndoRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from a FieldUndoRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @static
                 * @param {priority.netitems.form.FieldUndoRq} message FieldUndoRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldUndoRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this FieldUndoRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FieldUndoRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldUndoRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FieldUndoRq;
            })();

            form.FieldUndoRs = (function() {

                /**
                 * Properties of a FieldUndoRs.
                 * @memberof priority.netitems.form
                 * @interface IFieldUndoRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] FieldUndoRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] FieldUndoRs Messages
                 * @property {priority.netitems.form.IField|null} [Field] FieldUndoRs Field
                 */

                /**
                 * Constructs a new FieldUndoRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FieldUndoRs.
                 * @implements IFieldUndoRs
                 * @constructor
                 * @param {priority.netitems.form.IFieldUndoRs=} [properties] Properties to set
                 */
                function FieldUndoRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FieldUndoRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @instance
                 */
                FieldUndoRs.prototype.Perf = null;

                /**
                 * FieldUndoRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @instance
                 */
                FieldUndoRs.prototype.Messages = $util.emptyArray;

                /**
                 * FieldUndoRs Field.
                 * @member {priority.netitems.form.IField|null|undefined} Field
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @instance
                 */
                FieldUndoRs.prototype.Field = null;

                /**
                 * Creates a new FieldUndoRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @static
                 * @param {priority.netitems.form.IFieldUndoRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.FieldUndoRs} FieldUndoRs instance
                 */
                FieldUndoRs.create = function create(properties) {
                    return new FieldUndoRs(properties);
                };

                /**
                 * Encodes the specified FieldUndoRs message. Does not implicitly {@link priority.netitems.form.FieldUndoRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @static
                 * @param {priority.netitems.form.IFieldUndoRs} message FieldUndoRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldUndoRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Field != null && Object.hasOwnProperty.call(message, "Field"))
                        $root.priority.netitems.form.Field.encode(message.Field, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FieldUndoRs message, length delimited. Does not implicitly {@link priority.netitems.form.FieldUndoRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @static
                 * @param {priority.netitems.form.IFieldUndoRs} message FieldUndoRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldUndoRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FieldUndoRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FieldUndoRs} FieldUndoRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldUndoRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FieldUndoRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Field = $root.priority.netitems.form.Field.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FieldUndoRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FieldUndoRs} FieldUndoRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldUndoRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FieldUndoRs message.
                 * @function verify
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldUndoRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Field != null && message.hasOwnProperty("Field")) {
                        var error = $root.priority.netitems.form.Field.verify(message.Field);
                        if (error)
                            return "Field." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FieldUndoRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FieldUndoRs} FieldUndoRs
                 */
                FieldUndoRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FieldUndoRs)
                        return object;
                    var message = new $root.priority.netitems.form.FieldUndoRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.FieldUndoRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.FieldUndoRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.FieldUndoRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Field != null) {
                        if (typeof object.Field !== "object")
                            throw TypeError(".priority.netitems.form.FieldUndoRs.Field: object expected");
                        message.Field = $root.priority.netitems.form.Field.fromObject(object.Field);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FieldUndoRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @static
                 * @param {priority.netitems.form.FieldUndoRs} message FieldUndoRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldUndoRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.Field = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Field != null && message.hasOwnProperty("Field"))
                        object.Field = $root.priority.netitems.form.Field.toObject(message.Field, options);
                    return object;
                };

                /**
                 * Converts this FieldUndoRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FieldUndoRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldUndoRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FieldUndoRs;
            })();

            form.EndRq = (function() {

                /**
                 * Properties of an EndRq.
                 * @memberof priority.netitems.form
                 * @interface IEndRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] EndRq Properties
                 * @property {string|null} [Session] EndRq Session
                 */

                /**
                 * Constructs a new EndRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an EndRq.
                 * @implements IEndRq
                 * @constructor
                 * @param {priority.netitems.form.IEndRq=} [properties] Properties to set
                 */
                function EndRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EndRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.EndRq
                 * @instance
                 */
                EndRq.prototype.Properties = null;

                /**
                 * EndRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.EndRq
                 * @instance
                 */
                EndRq.prototype.Session = "";

                /**
                 * Creates a new EndRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.EndRq
                 * @static
                 * @param {priority.netitems.form.IEndRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.EndRq} EndRq instance
                 */
                EndRq.create = function create(properties) {
                    return new EndRq(properties);
                };

                /**
                 * Encodes the specified EndRq message. Does not implicitly {@link priority.netitems.form.EndRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.EndRq
                 * @static
                 * @param {priority.netitems.form.IEndRq} message EndRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified EndRq message, length delimited. Does not implicitly {@link priority.netitems.form.EndRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.EndRq
                 * @static
                 * @param {priority.netitems.form.IEndRq} message EndRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EndRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.EndRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.EndRq} EndRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.EndRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EndRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.EndRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.EndRq} EndRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EndRq message.
                 * @function verify
                 * @memberof priority.netitems.form.EndRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EndRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates an EndRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.EndRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.EndRq} EndRq
                 */
                EndRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.EndRq)
                        return object;
                    var message = new $root.priority.netitems.form.EndRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.EndRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from an EndRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.EndRq
                 * @static
                 * @param {priority.netitems.form.EndRq} message EndRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EndRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this EndRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.EndRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EndRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return EndRq;
            })();

            form.EndRs = (function() {

                /**
                 * Properties of an EndRs.
                 * @memberof priority.netitems.form
                 * @interface IEndRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] EndRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] EndRs Messages
                 */

                /**
                 * Constructs a new EndRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an EndRs.
                 * @implements IEndRs
                 * @constructor
                 * @param {priority.netitems.form.IEndRs=} [properties] Properties to set
                 */
                function EndRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EndRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.EndRs
                 * @instance
                 */
                EndRs.prototype.Perf = null;

                /**
                 * EndRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.EndRs
                 * @instance
                 */
                EndRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new EndRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.EndRs
                 * @static
                 * @param {priority.netitems.form.IEndRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.EndRs} EndRs instance
                 */
                EndRs.create = function create(properties) {
                    return new EndRs(properties);
                };

                /**
                 * Encodes the specified EndRs message. Does not implicitly {@link priority.netitems.form.EndRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.EndRs
                 * @static
                 * @param {priority.netitems.form.IEndRs} message EndRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified EndRs message, length delimited. Does not implicitly {@link priority.netitems.form.EndRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.EndRs
                 * @static
                 * @param {priority.netitems.form.IEndRs} message EndRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EndRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EndRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.EndRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.EndRs} EndRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.EndRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EndRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.EndRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.EndRs} EndRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EndRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EndRs message.
                 * @function verify
                 * @memberof priority.netitems.form.EndRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EndRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an EndRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.EndRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.EndRs} EndRs
                 */
                EndRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.EndRs)
                        return object;
                    var message = new $root.priority.netitems.form.EndRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.EndRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.EndRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.EndRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an EndRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.EndRs
                 * @static
                 * @param {priority.netitems.form.EndRs} message EndRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EndRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this EndRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.EndRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EndRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return EndRs;
            })();

            form.SubformsRq = (function() {

                /**
                 * Properties of a SubformsRq.
                 * @memberof priority.netitems.form
                 * @interface ISubformsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SubformsRq Properties
                 * @property {string|null} [Session] SubformsRq Session
                 */

                /**
                 * Constructs a new SubformsRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SubformsRq.
                 * @implements ISubformsRq
                 * @constructor
                 * @param {priority.netitems.form.ISubformsRq=} [properties] Properties to set
                 */
                function SubformsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubformsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SubformsRq
                 * @instance
                 */
                SubformsRq.prototype.Properties = null;

                /**
                 * SubformsRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.SubformsRq
                 * @instance
                 */
                SubformsRq.prototype.Session = "";

                /**
                 * Creates a new SubformsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SubformsRq
                 * @static
                 * @param {priority.netitems.form.ISubformsRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SubformsRq} SubformsRq instance
                 */
                SubformsRq.create = function create(properties) {
                    return new SubformsRq(properties);
                };

                /**
                 * Encodes the specified SubformsRq message. Does not implicitly {@link priority.netitems.form.SubformsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SubformsRq
                 * @static
                 * @param {priority.netitems.form.ISubformsRq} message SubformsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified SubformsRq message, length delimited. Does not implicitly {@link priority.netitems.form.SubformsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SubformsRq
                 * @static
                 * @param {priority.netitems.form.ISubformsRq} message SubformsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubformsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SubformsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SubformsRq} SubformsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SubformsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubformsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SubformsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SubformsRq} SubformsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubformsRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SubformsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubformsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates a SubformsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SubformsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SubformsRq} SubformsRq
                 */
                SubformsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SubformsRq)
                        return object;
                    var message = new $root.priority.netitems.form.SubformsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SubformsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from a SubformsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SubformsRq
                 * @static
                 * @param {priority.netitems.form.SubformsRq} message SubformsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubformsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this SubformsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SubformsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubformsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SubformsRq;
            })();

            form.SubformsRs = (function() {

                /**
                 * Properties of a SubformsRs.
                 * @memberof priority.netitems.form
                 * @interface ISubformsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SubformsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SubformsRs Messages
                 * @property {Array.<priority.netitems.form.ISubform>|null} [SubForms] SubformsRs SubForms
                 */

                /**
                 * Constructs a new SubformsRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SubformsRs.
                 * @implements ISubformsRs
                 * @constructor
                 * @param {priority.netitems.form.ISubformsRs=} [properties] Properties to set
                 */
                function SubformsRs(properties) {
                    this.Messages = [];
                    this.SubForms = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubformsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.SubformsRs
                 * @instance
                 */
                SubformsRs.prototype.Perf = null;

                /**
                 * SubformsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.SubformsRs
                 * @instance
                 */
                SubformsRs.prototype.Messages = $util.emptyArray;

                /**
                 * SubformsRs SubForms.
                 * @member {Array.<priority.netitems.form.ISubform>} SubForms
                 * @memberof priority.netitems.form.SubformsRs
                 * @instance
                 */
                SubformsRs.prototype.SubForms = $util.emptyArray;

                /**
                 * Creates a new SubformsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SubformsRs
                 * @static
                 * @param {priority.netitems.form.ISubformsRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.SubformsRs} SubformsRs instance
                 */
                SubformsRs.create = function create(properties) {
                    return new SubformsRs(properties);
                };

                /**
                 * Encodes the specified SubformsRs message. Does not implicitly {@link priority.netitems.form.SubformsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SubformsRs
                 * @static
                 * @param {priority.netitems.form.ISubformsRs} message SubformsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.SubForms != null && message.SubForms.length)
                        for (var i = 0; i < message.SubForms.length; ++i)
                            $root.priority.netitems.form.Subform.encode(message.SubForms[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SubformsRs message, length delimited. Does not implicitly {@link priority.netitems.form.SubformsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SubformsRs
                 * @static
                 * @param {priority.netitems.form.ISubformsRs} message SubformsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubformsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SubformsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SubformsRs} SubformsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SubformsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.SubForms && message.SubForms.length))
                                message.SubForms = [];
                            message.SubForms.push($root.priority.netitems.form.Subform.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubformsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SubformsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SubformsRs} SubformsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubformsRs message.
                 * @function verify
                 * @memberof priority.netitems.form.SubformsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubformsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.SubForms != null && message.hasOwnProperty("SubForms")) {
                        if (!Array.isArray(message.SubForms))
                            return "SubForms: array expected";
                        for (var i = 0; i < message.SubForms.length; ++i) {
                            var error = $root.priority.netitems.form.Subform.verify(message.SubForms[i]);
                            if (error)
                                return "SubForms." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SubformsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SubformsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SubformsRs} SubformsRs
                 */
                SubformsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SubformsRs)
                        return object;
                    var message = new $root.priority.netitems.form.SubformsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.SubformsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.SubformsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.SubformsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.SubForms) {
                        if (!Array.isArray(object.SubForms))
                            throw TypeError(".priority.netitems.form.SubformsRs.SubForms: array expected");
                        message.SubForms = [];
                        for (var i = 0; i < object.SubForms.length; ++i) {
                            if (typeof object.SubForms[i] !== "object")
                                throw TypeError(".priority.netitems.form.SubformsRs.SubForms: object expected");
                            message.SubForms[i] = $root.priority.netitems.form.Subform.fromObject(object.SubForms[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SubformsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SubformsRs
                 * @static
                 * @param {priority.netitems.form.SubformsRs} message SubformsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubformsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.SubForms = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.SubForms && message.SubForms.length) {
                        object.SubForms = [];
                        for (var j = 0; j < message.SubForms.length; ++j)
                            object.SubForms[j] = $root.priority.netitems.form.Subform.toObject(message.SubForms[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SubformsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SubformsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubformsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SubformsRs;
            })();

            form.SubformRq = (function() {

                /**
                 * Properties of a SubformRq.
                 * @memberof priority.netitems.form
                 * @interface ISubformRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SubformRq Properties
                 * @property {string|null} [Session] SubformRq Session
                 * @property {Array.<priority.netitems.form.IField>|null} [Keys] SubformRq Keys
                 * @property {string|null} [Fname] SubformRq Fname
                 * @property {Array.<string>|null} [hiddenFields] SubformRq hiddenFields
                 */

                /**
                 * Constructs a new SubformRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SubformRq.
                 * @implements ISubformRq
                 * @constructor
                 * @param {priority.netitems.form.ISubformRq=} [properties] Properties to set
                 */
                function SubformRq(properties) {
                    this.Keys = [];
                    this.hiddenFields = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubformRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SubformRq
                 * @instance
                 */
                SubformRq.prototype.Properties = null;

                /**
                 * SubformRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.SubformRq
                 * @instance
                 */
                SubformRq.prototype.Session = "";

                /**
                 * SubformRq Keys.
                 * @member {Array.<priority.netitems.form.IField>} Keys
                 * @memberof priority.netitems.form.SubformRq
                 * @instance
                 */
                SubformRq.prototype.Keys = $util.emptyArray;

                /**
                 * SubformRq Fname.
                 * @member {string} Fname
                 * @memberof priority.netitems.form.SubformRq
                 * @instance
                 */
                SubformRq.prototype.Fname = "";

                /**
                 * SubformRq hiddenFields.
                 * @member {Array.<string>} hiddenFields
                 * @memberof priority.netitems.form.SubformRq
                 * @instance
                 */
                SubformRq.prototype.hiddenFields = $util.emptyArray;

                /**
                 * Creates a new SubformRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SubformRq
                 * @static
                 * @param {priority.netitems.form.ISubformRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SubformRq} SubformRq instance
                 */
                SubformRq.create = function create(properties) {
                    return new SubformRq(properties);
                };

                /**
                 * Encodes the specified SubformRq message. Does not implicitly {@link priority.netitems.form.SubformRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SubformRq
                 * @static
                 * @param {priority.netitems.form.ISubformRq} message SubformRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Keys != null && message.Keys.length)
                        for (var i = 0; i < message.Keys.length; ++i)
                            $root.priority.netitems.form.Field.encode(message.Keys[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Fname != null && Object.hasOwnProperty.call(message, "Fname"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Fname);
                    if (message.hiddenFields != null && message.hiddenFields.length)
                        for (var i = 0; i < message.hiddenFields.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.hiddenFields[i]);
                    return writer;
                };

                /**
                 * Encodes the specified SubformRq message, length delimited. Does not implicitly {@link priority.netitems.form.SubformRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SubformRq
                 * @static
                 * @param {priority.netitems.form.ISubformRq} message SubformRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubformRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SubformRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SubformRq} SubformRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SubformRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            if (!(message.Keys && message.Keys.length))
                                message.Keys = [];
                            message.Keys.push($root.priority.netitems.form.Field.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            message.Fname = reader.string();
                            break;
                        case 5:
                            if (!(message.hiddenFields && message.hiddenFields.length))
                                message.hiddenFields = [];
                            message.hiddenFields.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubformRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SubformRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SubformRq} SubformRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubformRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SubformRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubformRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Keys != null && message.hasOwnProperty("Keys")) {
                        if (!Array.isArray(message.Keys))
                            return "Keys: array expected";
                        for (var i = 0; i < message.Keys.length; ++i) {
                            var error = $root.priority.netitems.form.Field.verify(message.Keys[i]);
                            if (error)
                                return "Keys." + error;
                        }
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        if (!$util.isString(message.Fname))
                            return "Fname: string expected";
                    if (message.hiddenFields != null && message.hasOwnProperty("hiddenFields")) {
                        if (!Array.isArray(message.hiddenFields))
                            return "hiddenFields: array expected";
                        for (var i = 0; i < message.hiddenFields.length; ++i)
                            if (!$util.isString(message.hiddenFields[i]))
                                return "hiddenFields: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a SubformRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SubformRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SubformRq} SubformRq
                 */
                SubformRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SubformRq)
                        return object;
                    var message = new $root.priority.netitems.form.SubformRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SubformRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Keys) {
                        if (!Array.isArray(object.Keys))
                            throw TypeError(".priority.netitems.form.SubformRq.Keys: array expected");
                        message.Keys = [];
                        for (var i = 0; i < object.Keys.length; ++i) {
                            if (typeof object.Keys[i] !== "object")
                                throw TypeError(".priority.netitems.form.SubformRq.Keys: object expected");
                            message.Keys[i] = $root.priority.netitems.form.Field.fromObject(object.Keys[i]);
                        }
                    }
                    if (object.Fname != null)
                        message.Fname = String(object.Fname);
                    if (object.hiddenFields) {
                        if (!Array.isArray(object.hiddenFields))
                            throw TypeError(".priority.netitems.form.SubformRq.hiddenFields: array expected");
                        message.hiddenFields = [];
                        for (var i = 0; i < object.hiddenFields.length; ++i)
                            message.hiddenFields[i] = String(object.hiddenFields[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SubformRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SubformRq
                 * @static
                 * @param {priority.netitems.form.SubformRq} message SubformRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubformRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Keys = [];
                        object.hiddenFields = [];
                    }
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.Fname = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Keys && message.Keys.length) {
                        object.Keys = [];
                        for (var j = 0; j < message.Keys.length; ++j)
                            object.Keys[j] = $root.priority.netitems.form.Field.toObject(message.Keys[j], options);
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        object.Fname = message.Fname;
                    if (message.hiddenFields && message.hiddenFields.length) {
                        object.hiddenFields = [];
                        for (var j = 0; j < message.hiddenFields.length; ++j)
                            object.hiddenFields[j] = message.hiddenFields[j];
                    }
                    return object;
                };

                /**
                 * Converts this SubformRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SubformRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubformRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SubformRq;
            })();

            form.ActionsRq = (function() {

                /**
                 * Properties of an ActionsRq.
                 * @memberof priority.netitems.form
                 * @interface IActionsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ActionsRq Properties
                 * @property {string|null} [Session] ActionsRq Session
                 */

                /**
                 * Constructs a new ActionsRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ActionsRq.
                 * @implements IActionsRq
                 * @constructor
                 * @param {priority.netitems.form.IActionsRq=} [properties] Properties to set
                 */
                function ActionsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ActionsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.ActionsRq
                 * @instance
                 */
                ActionsRq.prototype.Properties = null;

                /**
                 * ActionsRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.ActionsRq
                 * @instance
                 */
                ActionsRq.prototype.Session = "";

                /**
                 * Creates a new ActionsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ActionsRq
                 * @static
                 * @param {priority.netitems.form.IActionsRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.ActionsRq} ActionsRq instance
                 */
                ActionsRq.create = function create(properties) {
                    return new ActionsRq(properties);
                };

                /**
                 * Encodes the specified ActionsRq message. Does not implicitly {@link priority.netitems.form.ActionsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ActionsRq
                 * @static
                 * @param {priority.netitems.form.IActionsRq} message ActionsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified ActionsRq message, length delimited. Does not implicitly {@link priority.netitems.form.ActionsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ActionsRq
                 * @static
                 * @param {priority.netitems.form.IActionsRq} message ActionsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ActionsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ActionsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ActionsRq} ActionsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ActionsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ActionsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ActionsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ActionsRq} ActionsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ActionsRq message.
                 * @function verify
                 * @memberof priority.netitems.form.ActionsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ActionsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates an ActionsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ActionsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ActionsRq} ActionsRq
                 */
                ActionsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ActionsRq)
                        return object;
                    var message = new $root.priority.netitems.form.ActionsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.ActionsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from an ActionsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ActionsRq
                 * @static
                 * @param {priority.netitems.form.ActionsRq} message ActionsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ActionsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this ActionsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ActionsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ActionsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ActionsRq;
            })();

            form.ActionsRs = (function() {

                /**
                 * Properties of an ActionsRs.
                 * @memberof priority.netitems.form
                 * @interface IActionsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] ActionsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ActionsRs Messages
                 * @property {Array.<priority.netitems.form.IAction>|null} [Actions] ActionsRs Actions
                 */

                /**
                 * Constructs a new ActionsRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ActionsRs.
                 * @implements IActionsRs
                 * @constructor
                 * @param {priority.netitems.form.IActionsRs=} [properties] Properties to set
                 */
                function ActionsRs(properties) {
                    this.Messages = [];
                    this.Actions = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ActionsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.ActionsRs
                 * @instance
                 */
                ActionsRs.prototype.Perf = null;

                /**
                 * ActionsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.ActionsRs
                 * @instance
                 */
                ActionsRs.prototype.Messages = $util.emptyArray;

                /**
                 * ActionsRs Actions.
                 * @member {Array.<priority.netitems.form.IAction>} Actions
                 * @memberof priority.netitems.form.ActionsRs
                 * @instance
                 */
                ActionsRs.prototype.Actions = $util.emptyArray;

                /**
                 * Creates a new ActionsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ActionsRs
                 * @static
                 * @param {priority.netitems.form.IActionsRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.ActionsRs} ActionsRs instance
                 */
                ActionsRs.create = function create(properties) {
                    return new ActionsRs(properties);
                };

                /**
                 * Encodes the specified ActionsRs message. Does not implicitly {@link priority.netitems.form.ActionsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ActionsRs
                 * @static
                 * @param {priority.netitems.form.IActionsRs} message ActionsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Actions != null && message.Actions.length)
                        for (var i = 0; i < message.Actions.length; ++i)
                            $root.priority.netitems.form.Action.encode(message.Actions[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ActionsRs message, length delimited. Does not implicitly {@link priority.netitems.form.ActionsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ActionsRs
                 * @static
                 * @param {priority.netitems.form.IActionsRs} message ActionsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ActionsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ActionsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ActionsRs} ActionsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ActionsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.Actions && message.Actions.length))
                                message.Actions = [];
                            message.Actions.push($root.priority.netitems.form.Action.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ActionsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ActionsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ActionsRs} ActionsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ActionsRs message.
                 * @function verify
                 * @memberof priority.netitems.form.ActionsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ActionsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Actions != null && message.hasOwnProperty("Actions")) {
                        if (!Array.isArray(message.Actions))
                            return "Actions: array expected";
                        for (var i = 0; i < message.Actions.length; ++i) {
                            var error = $root.priority.netitems.form.Action.verify(message.Actions[i]);
                            if (error)
                                return "Actions." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an ActionsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ActionsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ActionsRs} ActionsRs
                 */
                ActionsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ActionsRs)
                        return object;
                    var message = new $root.priority.netitems.form.ActionsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.ActionsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.ActionsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.ActionsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Actions) {
                        if (!Array.isArray(object.Actions))
                            throw TypeError(".priority.netitems.form.ActionsRs.Actions: array expected");
                        message.Actions = [];
                        for (var i = 0; i < object.Actions.length; ++i) {
                            if (typeof object.Actions[i] !== "object")
                                throw TypeError(".priority.netitems.form.ActionsRs.Actions: object expected");
                            message.Actions[i] = $root.priority.netitems.form.Action.fromObject(object.Actions[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ActionsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ActionsRs
                 * @static
                 * @param {priority.netitems.form.ActionsRs} message ActionsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ActionsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.Actions = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Actions && message.Actions.length) {
                        object.Actions = [];
                        for (var j = 0; j < message.Actions.length; ++j)
                            object.Actions[j] = $root.priority.netitems.form.Action.toObject(message.Actions[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ActionsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ActionsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ActionsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ActionsRs;
            })();

            form.ActionRq = (function() {

                /**
                 * Properties of an ActionRq.
                 * @memberof priority.netitems.form
                 * @interface IActionRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ActionRq Properties
                 * @property {string|null} [Session] ActionRq Session
                 * @property {Array.<priority.netitems.form.IField>|null} [Keys] ActionRq Keys
                 * @property {number|Long|null} [ScrLine] ActionRq ScrLine
                 * @property {number|Long|null} [Exec] ActionRq Exec
                 */

                /**
                 * Constructs a new ActionRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ActionRq.
                 * @implements IActionRq
                 * @constructor
                 * @param {priority.netitems.form.IActionRq=} [properties] Properties to set
                 */
                function ActionRq(properties) {
                    this.Keys = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ActionRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.ActionRq
                 * @instance
                 */
                ActionRq.prototype.Properties = null;

                /**
                 * ActionRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.ActionRq
                 * @instance
                 */
                ActionRq.prototype.Session = "";

                /**
                 * ActionRq Keys.
                 * @member {Array.<priority.netitems.form.IField>} Keys
                 * @memberof priority.netitems.form.ActionRq
                 * @instance
                 */
                ActionRq.prototype.Keys = $util.emptyArray;

                /**
                 * ActionRq ScrLine.
                 * @member {number|Long} ScrLine
                 * @memberof priority.netitems.form.ActionRq
                 * @instance
                 */
                ActionRq.prototype.ScrLine = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ActionRq Exec.
                 * @member {number|Long} Exec
                 * @memberof priority.netitems.form.ActionRq
                 * @instance
                 */
                ActionRq.prototype.Exec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new ActionRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ActionRq
                 * @static
                 * @param {priority.netitems.form.IActionRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.ActionRq} ActionRq instance
                 */
                ActionRq.create = function create(properties) {
                    return new ActionRq(properties);
                };

                /**
                 * Encodes the specified ActionRq message. Does not implicitly {@link priority.netitems.form.ActionRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ActionRq
                 * @static
                 * @param {priority.netitems.form.IActionRq} message ActionRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Keys != null && message.Keys.length)
                        for (var i = 0; i < message.Keys.length; ++i)
                            $root.priority.netitems.form.Field.encode(message.Keys[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.ScrLine != null && Object.hasOwnProperty.call(message, "ScrLine"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ScrLine);
                    if (message.Exec != null && Object.hasOwnProperty.call(message, "Exec"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Exec);
                    return writer;
                };

                /**
                 * Encodes the specified ActionRq message, length delimited. Does not implicitly {@link priority.netitems.form.ActionRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ActionRq
                 * @static
                 * @param {priority.netitems.form.IActionRq} message ActionRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ActionRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ActionRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ActionRq} ActionRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ActionRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            if (!(message.Keys && message.Keys.length))
                                message.Keys = [];
                            message.Keys.push($root.priority.netitems.form.Field.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            message.ScrLine = reader.int64();
                            break;
                        case 5:
                            message.Exec = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ActionRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ActionRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ActionRq} ActionRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ActionRq message.
                 * @function verify
                 * @memberof priority.netitems.form.ActionRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ActionRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Keys != null && message.hasOwnProperty("Keys")) {
                        if (!Array.isArray(message.Keys))
                            return "Keys: array expected";
                        for (var i = 0; i < message.Keys.length; ++i) {
                            var error = $root.priority.netitems.form.Field.verify(message.Keys[i]);
                            if (error)
                                return "Keys." + error;
                        }
                    }
                    if (message.ScrLine != null && message.hasOwnProperty("ScrLine"))
                        if (!$util.isInteger(message.ScrLine) && !(message.ScrLine && $util.isInteger(message.ScrLine.low) && $util.isInteger(message.ScrLine.high)))
                            return "ScrLine: integer|Long expected";
                    if (message.Exec != null && message.hasOwnProperty("Exec"))
                        if (!$util.isInteger(message.Exec) && !(message.Exec && $util.isInteger(message.Exec.low) && $util.isInteger(message.Exec.high)))
                            return "Exec: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an ActionRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ActionRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ActionRq} ActionRq
                 */
                ActionRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ActionRq)
                        return object;
                    var message = new $root.priority.netitems.form.ActionRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.ActionRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Keys) {
                        if (!Array.isArray(object.Keys))
                            throw TypeError(".priority.netitems.form.ActionRq.Keys: array expected");
                        message.Keys = [];
                        for (var i = 0; i < object.Keys.length; ++i) {
                            if (typeof object.Keys[i] !== "object")
                                throw TypeError(".priority.netitems.form.ActionRq.Keys: object expected");
                            message.Keys[i] = $root.priority.netitems.form.Field.fromObject(object.Keys[i]);
                        }
                    }
                    if (object.ScrLine != null)
                        if ($util.Long)
                            (message.ScrLine = $util.Long.fromValue(object.ScrLine)).unsigned = false;
                        else if (typeof object.ScrLine === "string")
                            message.ScrLine = parseInt(object.ScrLine, 10);
                        else if (typeof object.ScrLine === "number")
                            message.ScrLine = object.ScrLine;
                        else if (typeof object.ScrLine === "object")
                            message.ScrLine = new $util.LongBits(object.ScrLine.low >>> 0, object.ScrLine.high >>> 0).toNumber();
                    if (object.Exec != null)
                        if ($util.Long)
                            (message.Exec = $util.Long.fromValue(object.Exec)).unsigned = false;
                        else if (typeof object.Exec === "string")
                            message.Exec = parseInt(object.Exec, 10);
                        else if (typeof object.Exec === "number")
                            message.Exec = object.Exec;
                        else if (typeof object.Exec === "object")
                            message.Exec = new $util.LongBits(object.Exec.low >>> 0, object.Exec.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an ActionRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ActionRq
                 * @static
                 * @param {priority.netitems.form.ActionRq} message ActionRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ActionRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Keys = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ScrLine = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ScrLine = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Exec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Exec = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Keys && message.Keys.length) {
                        object.Keys = [];
                        for (var j = 0; j < message.Keys.length; ++j)
                            object.Keys[j] = $root.priority.netitems.form.Field.toObject(message.Keys[j], options);
                    }
                    if (message.ScrLine != null && message.hasOwnProperty("ScrLine"))
                        if (typeof message.ScrLine === "number")
                            object.ScrLine = options.longs === String ? String(message.ScrLine) : message.ScrLine;
                        else
                            object.ScrLine = options.longs === String ? $util.Long.prototype.toString.call(message.ScrLine) : options.longs === Number ? new $util.LongBits(message.ScrLine.low >>> 0, message.ScrLine.high >>> 0).toNumber() : message.ScrLine;
                    if (message.Exec != null && message.hasOwnProperty("Exec"))
                        if (typeof message.Exec === "number")
                            object.Exec = options.longs === String ? String(message.Exec) : message.Exec;
                        else
                            object.Exec = options.longs === String ? $util.Long.prototype.toString.call(message.Exec) : options.longs === Number ? new $util.LongBits(message.Exec.low >>> 0, message.Exec.high >>> 0).toNumber() : message.Exec;
                    return object;
                };

                /**
                 * Converts this ActionRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ActionRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ActionRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ActionRq;
            })();

            form.ActionRs = (function() {

                /**
                 * Properties of an ActionRs.
                 * @memberof priority.netitems.form
                 * @interface IActionRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] ActionRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ActionRs Messages
                 * @property {string|null} [LinkFile] ActionRs LinkFile
                 * @property {string|null} [LinkID] ActionRs LinkID
                 * @property {string|null} [Table] ActionRs Table
                 */

                /**
                 * Constructs a new ActionRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ActionRs.
                 * @implements IActionRs
                 * @constructor
                 * @param {priority.netitems.form.IActionRs=} [properties] Properties to set
                 */
                function ActionRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ActionRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.ActionRs
                 * @instance
                 */
                ActionRs.prototype.Perf = null;

                /**
                 * ActionRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.ActionRs
                 * @instance
                 */
                ActionRs.prototype.Messages = $util.emptyArray;

                /**
                 * ActionRs LinkFile.
                 * @member {string} LinkFile
                 * @memberof priority.netitems.form.ActionRs
                 * @instance
                 */
                ActionRs.prototype.LinkFile = "";

                /**
                 * ActionRs LinkID.
                 * @member {string} LinkID
                 * @memberof priority.netitems.form.ActionRs
                 * @instance
                 */
                ActionRs.prototype.LinkID = "";

                /**
                 * ActionRs Table.
                 * @member {string} Table
                 * @memberof priority.netitems.form.ActionRs
                 * @instance
                 */
                ActionRs.prototype.Table = "";

                /**
                 * Creates a new ActionRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ActionRs
                 * @static
                 * @param {priority.netitems.form.IActionRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.ActionRs} ActionRs instance
                 */
                ActionRs.create = function create(properties) {
                    return new ActionRs(properties);
                };

                /**
                 * Encodes the specified ActionRs message. Does not implicitly {@link priority.netitems.form.ActionRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ActionRs
                 * @static
                 * @param {priority.netitems.form.IActionRs} message ActionRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.LinkFile != null && Object.hasOwnProperty.call(message, "LinkFile"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.LinkFile);
                    if (message.LinkID != null && Object.hasOwnProperty.call(message, "LinkID"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.LinkID);
                    if (message.Table != null && Object.hasOwnProperty.call(message, "Table"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.Table);
                    return writer;
                };

                /**
                 * Encodes the specified ActionRs message, length delimited. Does not implicitly {@link priority.netitems.form.ActionRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ActionRs
                 * @static
                 * @param {priority.netitems.form.IActionRs} message ActionRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ActionRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ActionRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ActionRs} ActionRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ActionRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.LinkFile = reader.string();
                            break;
                        case 4:
                            message.LinkID = reader.string();
                            break;
                        case 5:
                            message.Table = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ActionRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ActionRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ActionRs} ActionRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ActionRs message.
                 * @function verify
                 * @memberof priority.netitems.form.ActionRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ActionRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.LinkFile != null && message.hasOwnProperty("LinkFile"))
                        if (!$util.isString(message.LinkFile))
                            return "LinkFile: string expected";
                    if (message.LinkID != null && message.hasOwnProperty("LinkID"))
                        if (!$util.isString(message.LinkID))
                            return "LinkID: string expected";
                    if (message.Table != null && message.hasOwnProperty("Table"))
                        if (!$util.isString(message.Table))
                            return "Table: string expected";
                    return null;
                };

                /**
                 * Creates an ActionRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ActionRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ActionRs} ActionRs
                 */
                ActionRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ActionRs)
                        return object;
                    var message = new $root.priority.netitems.form.ActionRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.ActionRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.ActionRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.ActionRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.LinkFile != null)
                        message.LinkFile = String(object.LinkFile);
                    if (object.LinkID != null)
                        message.LinkID = String(object.LinkID);
                    if (object.Table != null)
                        message.Table = String(object.Table);
                    return message;
                };

                /**
                 * Creates a plain object from an ActionRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ActionRs
                 * @static
                 * @param {priority.netitems.form.ActionRs} message ActionRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ActionRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.LinkFile = "";
                        object.LinkID = "";
                        object.Table = "";
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.LinkFile != null && message.hasOwnProperty("LinkFile"))
                        object.LinkFile = message.LinkFile;
                    if (message.LinkID != null && message.hasOwnProperty("LinkID"))
                        object.LinkID = message.LinkID;
                    if (message.Table != null && message.hasOwnProperty("Table"))
                        object.Table = message.Table;
                    return object;
                };

                /**
                 * Converts this ActionRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ActionRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ActionRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ActionRs;
            })();

            /**
             * RefreshLines enum.
             * @name priority.netitems.form.RefreshLines
             * @enum {number}
             * @property {number} None=0 None value
             * @property {number} ActiveRecord=1 ActiveRecord value
             * @property {number} AllRecords=2 AllRecords value
             */
            form.RefreshLines = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "None"] = 0;
                values[valuesById[1] = "ActiveRecord"] = 1;
                values[valuesById[2] = "AllRecords"] = 2;
                return values;
            })();

            form.ActionEndRq = (function() {

                /**
                 * Properties of an ActionEndRq.
                 * @memberof priority.netitems.form
                 * @interface IActionEndRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ActionEndRq Properties
                 * @property {string|null} [Session] ActionEndRq Session
                 */

                /**
                 * Constructs a new ActionEndRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ActionEndRq.
                 * @implements IActionEndRq
                 * @constructor
                 * @param {priority.netitems.form.IActionEndRq=} [properties] Properties to set
                 */
                function ActionEndRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ActionEndRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.ActionEndRq
                 * @instance
                 */
                ActionEndRq.prototype.Properties = null;

                /**
                 * ActionEndRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.ActionEndRq
                 * @instance
                 */
                ActionEndRq.prototype.Session = "";

                /**
                 * Creates a new ActionEndRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ActionEndRq
                 * @static
                 * @param {priority.netitems.form.IActionEndRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.ActionEndRq} ActionEndRq instance
                 */
                ActionEndRq.create = function create(properties) {
                    return new ActionEndRq(properties);
                };

                /**
                 * Encodes the specified ActionEndRq message. Does not implicitly {@link priority.netitems.form.ActionEndRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ActionEndRq
                 * @static
                 * @param {priority.netitems.form.IActionEndRq} message ActionEndRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionEndRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified ActionEndRq message, length delimited. Does not implicitly {@link priority.netitems.form.ActionEndRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ActionEndRq
                 * @static
                 * @param {priority.netitems.form.IActionEndRq} message ActionEndRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionEndRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ActionEndRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ActionEndRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ActionEndRq} ActionEndRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionEndRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ActionEndRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ActionEndRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ActionEndRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ActionEndRq} ActionEndRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionEndRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ActionEndRq message.
                 * @function verify
                 * @memberof priority.netitems.form.ActionEndRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ActionEndRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates an ActionEndRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ActionEndRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ActionEndRq} ActionEndRq
                 */
                ActionEndRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ActionEndRq)
                        return object;
                    var message = new $root.priority.netitems.form.ActionEndRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.ActionEndRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from an ActionEndRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ActionEndRq
                 * @static
                 * @param {priority.netitems.form.ActionEndRq} message ActionEndRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ActionEndRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this ActionEndRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ActionEndRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ActionEndRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ActionEndRq;
            })();

            form.ActionEndRs = (function() {

                /**
                 * Properties of an ActionEndRs.
                 * @memberof priority.netitems.form
                 * @interface IActionEndRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] ActionEndRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ActionEndRs Messages
                 * @property {priority.netitems.form.IRecord|null} [Record] ActionEndRs Record
                 * @property {Object.<string,priority.netitems.form.RefreshLines>|null} [Refresh] ActionEndRs Refresh
                 */

                /**
                 * Constructs a new ActionEndRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ActionEndRs.
                 * @implements IActionEndRs
                 * @constructor
                 * @param {priority.netitems.form.IActionEndRs=} [properties] Properties to set
                 */
                function ActionEndRs(properties) {
                    this.Messages = [];
                    this.Refresh = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ActionEndRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.ActionEndRs
                 * @instance
                 */
                ActionEndRs.prototype.Perf = null;

                /**
                 * ActionEndRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.ActionEndRs
                 * @instance
                 */
                ActionEndRs.prototype.Messages = $util.emptyArray;

                /**
                 * ActionEndRs Record.
                 * @member {priority.netitems.form.IRecord|null|undefined} Record
                 * @memberof priority.netitems.form.ActionEndRs
                 * @instance
                 */
                ActionEndRs.prototype.Record = null;

                /**
                 * ActionEndRs Refresh.
                 * @member {Object.<string,priority.netitems.form.RefreshLines>} Refresh
                 * @memberof priority.netitems.form.ActionEndRs
                 * @instance
                 */
                ActionEndRs.prototype.Refresh = $util.emptyObject;

                /**
                 * Creates a new ActionEndRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ActionEndRs
                 * @static
                 * @param {priority.netitems.form.IActionEndRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.ActionEndRs} ActionEndRs instance
                 */
                ActionEndRs.create = function create(properties) {
                    return new ActionEndRs(properties);
                };

                /**
                 * Encodes the specified ActionEndRs message. Does not implicitly {@link priority.netitems.form.ActionEndRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ActionEndRs
                 * @static
                 * @param {priority.netitems.form.IActionEndRs} message ActionEndRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionEndRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
                        $root.priority.netitems.form.Record.encode(message.Record, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Refresh != null && Object.hasOwnProperty.call(message, "Refresh"))
                        for (var keys = Object.keys(message.Refresh), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 4, wireType 2 =*/34).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.Refresh[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ActionEndRs message, length delimited. Does not implicitly {@link priority.netitems.form.ActionEndRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ActionEndRs
                 * @static
                 * @param {priority.netitems.form.IActionEndRs} message ActionEndRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionEndRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ActionEndRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ActionEndRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ActionEndRs} ActionEndRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionEndRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ActionEndRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Record = $root.priority.netitems.form.Record.decode(reader, reader.uint32());
                            break;
                        case 4:
                            if (message.Refresh === $util.emptyObject)
                                message.Refresh = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = 0;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.Refresh[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ActionEndRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ActionEndRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ActionEndRs} ActionEndRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionEndRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ActionEndRs message.
                 * @function verify
                 * @memberof priority.netitems.form.ActionEndRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ActionEndRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Record != null && message.hasOwnProperty("Record")) {
                        var error = $root.priority.netitems.form.Record.verify(message.Record);
                        if (error)
                            return "Record." + error;
                    }
                    if (message.Refresh != null && message.hasOwnProperty("Refresh")) {
                        if (!$util.isObject(message.Refresh))
                            return "Refresh: object expected";
                        var key = Object.keys(message.Refresh);
                        for (var i = 0; i < key.length; ++i)
                            switch (message.Refresh[key[i]]) {
                            default:
                                return "Refresh: enum value{k:string} expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates an ActionEndRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ActionEndRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ActionEndRs} ActionEndRs
                 */
                ActionEndRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ActionEndRs)
                        return object;
                    var message = new $root.priority.netitems.form.ActionEndRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.ActionEndRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.ActionEndRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.ActionEndRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Record != null) {
                        if (typeof object.Record !== "object")
                            throw TypeError(".priority.netitems.form.ActionEndRs.Record: object expected");
                        message.Record = $root.priority.netitems.form.Record.fromObject(object.Record);
                    }
                    if (object.Refresh) {
                        if (typeof object.Refresh !== "object")
                            throw TypeError(".priority.netitems.form.ActionEndRs.Refresh: object expected");
                        message.Refresh = {};
                        for (var keys = Object.keys(object.Refresh), i = 0; i < keys.length; ++i)
                            switch (object.Refresh[keys[i]]) {
                            case "None":
                            case 0:
                                message.Refresh[keys[i]] = 0;
                                break;
                            case "ActiveRecord":
                            case 1:
                                message.Refresh[keys[i]] = 1;
                                break;
                            case "AllRecords":
                            case 2:
                                message.Refresh[keys[i]] = 2;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ActionEndRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ActionEndRs
                 * @static
                 * @param {priority.netitems.form.ActionEndRs} message ActionEndRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ActionEndRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.Refresh = {};
                    if (options.defaults) {
                        object.Perf = null;
                        object.Record = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Record != null && message.hasOwnProperty("Record"))
                        object.Record = $root.priority.netitems.form.Record.toObject(message.Record, options);
                    var keys2;
                    if (message.Refresh && (keys2 = Object.keys(message.Refresh)).length) {
                        object.Refresh = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.Refresh[keys2[j]] = options.enums === String ? $root.priority.netitems.form.RefreshLines[message.Refresh[keys2[j]]] : message.Refresh[keys2[j]];
                    }
                    return object;
                };

                /**
                 * Converts this ActionEndRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ActionEndRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ActionEndRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ActionEndRs;
            })();

            form.OlapsRq = (function() {

                /**
                 * Properties of an OlapsRq.
                 * @memberof priority.netitems.form
                 * @interface IOlapsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] OlapsRq Properties
                 * @property {string|null} [Fname] OlapsRq Fname
                 */

                /**
                 * Constructs a new OlapsRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an OlapsRq.
                 * @implements IOlapsRq
                 * @constructor
                 * @param {priority.netitems.form.IOlapsRq=} [properties] Properties to set
                 */
                function OlapsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OlapsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.OlapsRq
                 * @instance
                 */
                OlapsRq.prototype.Properties = null;

                /**
                 * OlapsRq Fname.
                 * @member {string} Fname
                 * @memberof priority.netitems.form.OlapsRq
                 * @instance
                 */
                OlapsRq.prototype.Fname = "";

                /**
                 * Creates a new OlapsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.OlapsRq
                 * @static
                 * @param {priority.netitems.form.IOlapsRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.OlapsRq} OlapsRq instance
                 */
                OlapsRq.create = function create(properties) {
                    return new OlapsRq(properties);
                };

                /**
                 * Encodes the specified OlapsRq message. Does not implicitly {@link priority.netitems.form.OlapsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.OlapsRq
                 * @static
                 * @param {priority.netitems.form.IOlapsRq} message OlapsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OlapsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Fname != null && Object.hasOwnProperty.call(message, "Fname"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Fname);
                    return writer;
                };

                /**
                 * Encodes the specified OlapsRq message, length delimited. Does not implicitly {@link priority.netitems.form.OlapsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.OlapsRq
                 * @static
                 * @param {priority.netitems.form.IOlapsRq} message OlapsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OlapsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OlapsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.OlapsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.OlapsRq} OlapsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OlapsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.OlapsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Fname = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OlapsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.OlapsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.OlapsRq} OlapsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OlapsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OlapsRq message.
                 * @function verify
                 * @memberof priority.netitems.form.OlapsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OlapsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        if (!$util.isString(message.Fname))
                            return "Fname: string expected";
                    return null;
                };

                /**
                 * Creates an OlapsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.OlapsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.OlapsRq} OlapsRq
                 */
                OlapsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.OlapsRq)
                        return object;
                    var message = new $root.priority.netitems.form.OlapsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.OlapsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Fname != null)
                        message.Fname = String(object.Fname);
                    return message;
                };

                /**
                 * Creates a plain object from an OlapsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.OlapsRq
                 * @static
                 * @param {priority.netitems.form.OlapsRq} message OlapsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OlapsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Fname = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        object.Fname = message.Fname;
                    return object;
                };

                /**
                 * Converts this OlapsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.OlapsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OlapsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return OlapsRq;
            })();

            form.OlapsRs = (function() {

                /**
                 * Properties of an OlapsRs.
                 * @memberof priority.netitems.form
                 * @interface IOlapsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] OlapsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] OlapsRs Messages
                 * @property {Object.<string,priority.netitems.form.OlapsRs.IOlapsList>|null} [OlapsMap] OlapsRs OlapsMap
                 */

                /**
                 * Constructs a new OlapsRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an OlapsRs.
                 * @implements IOlapsRs
                 * @constructor
                 * @param {priority.netitems.form.IOlapsRs=} [properties] Properties to set
                 */
                function OlapsRs(properties) {
                    this.Messages = [];
                    this.OlapsMap = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * OlapsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.OlapsRs
                 * @instance
                 */
                OlapsRs.prototype.Perf = null;

                /**
                 * OlapsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.OlapsRs
                 * @instance
                 */
                OlapsRs.prototype.Messages = $util.emptyArray;

                /**
                 * OlapsRs OlapsMap.
                 * @member {Object.<string,priority.netitems.form.OlapsRs.IOlapsList>} OlapsMap
                 * @memberof priority.netitems.form.OlapsRs
                 * @instance
                 */
                OlapsRs.prototype.OlapsMap = $util.emptyObject;

                /**
                 * Creates a new OlapsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.OlapsRs
                 * @static
                 * @param {priority.netitems.form.IOlapsRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.OlapsRs} OlapsRs instance
                 */
                OlapsRs.create = function create(properties) {
                    return new OlapsRs(properties);
                };

                /**
                 * Encodes the specified OlapsRs message. Does not implicitly {@link priority.netitems.form.OlapsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.OlapsRs
                 * @static
                 * @param {priority.netitems.form.IOlapsRs} message OlapsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OlapsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.OlapsMap != null && Object.hasOwnProperty.call(message, "OlapsMap"))
                        for (var keys = Object.keys(message.OlapsMap), i = 0; i < keys.length; ++i) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 0 =*/8).uint32(keys[i]);
                            $root.priority.netitems.form.OlapsRs.OlapsList.encode(message.OlapsMap[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                        }
                    return writer;
                };

                /**
                 * Encodes the specified OlapsRs message, length delimited. Does not implicitly {@link priority.netitems.form.OlapsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.OlapsRs
                 * @static
                 * @param {priority.netitems.form.IOlapsRs} message OlapsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OlapsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an OlapsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.OlapsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.OlapsRs} OlapsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OlapsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.OlapsRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (message.OlapsMap === $util.emptyObject)
                                message.OlapsMap = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = 0;
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.uint32();
                                    break;
                                case 2:
                                    value = $root.priority.netitems.form.OlapsRs.OlapsList.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.OlapsMap[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an OlapsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.OlapsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.OlapsRs} OlapsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OlapsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an OlapsRs message.
                 * @function verify
                 * @memberof priority.netitems.form.OlapsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OlapsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.OlapsMap != null && message.hasOwnProperty("OlapsMap")) {
                        if (!$util.isObject(message.OlapsMap))
                            return "OlapsMap: object expected";
                        var key = Object.keys(message.OlapsMap);
                        for (var i = 0; i < key.length; ++i) {
                            if (!$util.key32Re.test(key[i]))
                                return "OlapsMap: integer key{k:uint32} expected";
                            {
                                var error = $root.priority.netitems.form.OlapsRs.OlapsList.verify(message.OlapsMap[key[i]]);
                                if (error)
                                    return "OlapsMap." + error;
                            }
                        }
                    }
                    return null;
                };

                /**
                 * Creates an OlapsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.OlapsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.OlapsRs} OlapsRs
                 */
                OlapsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.OlapsRs)
                        return object;
                    var message = new $root.priority.netitems.form.OlapsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.OlapsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.OlapsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.OlapsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.OlapsMap) {
                        if (typeof object.OlapsMap !== "object")
                            throw TypeError(".priority.netitems.form.OlapsRs.OlapsMap: object expected");
                        message.OlapsMap = {};
                        for (var keys = Object.keys(object.OlapsMap), i = 0; i < keys.length; ++i) {
                            if (typeof object.OlapsMap[keys[i]] !== "object")
                                throw TypeError(".priority.netitems.form.OlapsRs.OlapsMap: object expected");
                            message.OlapsMap[keys[i]] = $root.priority.netitems.form.OlapsRs.OlapsList.fromObject(object.OlapsMap[keys[i]]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an OlapsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.OlapsRs
                 * @static
                 * @param {priority.netitems.form.OlapsRs} message OlapsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OlapsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.OlapsMap = {};
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    var keys2;
                    if (message.OlapsMap && (keys2 = Object.keys(message.OlapsMap)).length) {
                        object.OlapsMap = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.OlapsMap[keys2[j]] = $root.priority.netitems.form.OlapsRs.OlapsList.toObject(message.OlapsMap[keys2[j]], options);
                    }
                    return object;
                };

                /**
                 * Converts this OlapsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.OlapsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OlapsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                OlapsRs.Olap = (function() {

                    /**
                     * Properties of an Olap.
                     * @memberof priority.netitems.form.OlapsRs
                     * @interface IOlap
                     * @property {string|null} [Title] Olap Title
                     * @property {string|null} [Url] Olap Url
                     */

                    /**
                     * Constructs a new Olap.
                     * @memberof priority.netitems.form.OlapsRs
                     * @classdesc Represents an Olap.
                     * @implements IOlap
                     * @constructor
                     * @param {priority.netitems.form.OlapsRs.IOlap=} [properties] Properties to set
                     */
                    function Olap(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Olap Title.
                     * @member {string} Title
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @instance
                     */
                    Olap.prototype.Title = "";

                    /**
                     * Olap Url.
                     * @member {string} Url
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @instance
                     */
                    Olap.prototype.Url = "";

                    /**
                     * Creates a new Olap instance using the specified properties.
                     * @function create
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @static
                     * @param {priority.netitems.form.OlapsRs.IOlap=} [properties] Properties to set
                     * @returns {priority.netitems.form.OlapsRs.Olap} Olap instance
                     */
                    Olap.create = function create(properties) {
                        return new Olap(properties);
                    };

                    /**
                     * Encodes the specified Olap message. Does not implicitly {@link priority.netitems.form.OlapsRs.Olap.verify|verify} messages.
                     * @function encode
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @static
                     * @param {priority.netitems.form.OlapsRs.IOlap} message Olap message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Olap.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
                        if (message.Url != null && Object.hasOwnProperty.call(message, "Url"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Url);
                        return writer;
                    };

                    /**
                     * Encodes the specified Olap message, length delimited. Does not implicitly {@link priority.netitems.form.OlapsRs.Olap.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @static
                     * @param {priority.netitems.form.OlapsRs.IOlap} message Olap message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Olap.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an Olap message from the specified reader or buffer.
                     * @function decode
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {priority.netitems.form.OlapsRs.Olap} Olap
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Olap.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.OlapsRs.Olap();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.Title = reader.string();
                                break;
                            case 2:
                                message.Url = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an Olap message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {priority.netitems.form.OlapsRs.Olap} Olap
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Olap.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an Olap message.
                     * @function verify
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Olap.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.Title != null && message.hasOwnProperty("Title"))
                            if (!$util.isString(message.Title))
                                return "Title: string expected";
                        if (message.Url != null && message.hasOwnProperty("Url"))
                            if (!$util.isString(message.Url))
                                return "Url: string expected";
                        return null;
                    };

                    /**
                     * Creates an Olap message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {priority.netitems.form.OlapsRs.Olap} Olap
                     */
                    Olap.fromObject = function fromObject(object) {
                        if (object instanceof $root.priority.netitems.form.OlapsRs.Olap)
                            return object;
                        var message = new $root.priority.netitems.form.OlapsRs.Olap();
                        if (object.Title != null)
                            message.Title = String(object.Title);
                        if (object.Url != null)
                            message.Url = String(object.Url);
                        return message;
                    };

                    /**
                     * Creates a plain object from an Olap message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @static
                     * @param {priority.netitems.form.OlapsRs.Olap} message Olap
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Olap.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.Title = "";
                            object.Url = "";
                        }
                        if (message.Title != null && message.hasOwnProperty("Title"))
                            object.Title = message.Title;
                        if (message.Url != null && message.hasOwnProperty("Url"))
                            object.Url = message.Url;
                        return object;
                    };

                    /**
                     * Converts this Olap to JSON.
                     * @function toJSON
                     * @memberof priority.netitems.form.OlapsRs.Olap
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Olap.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Olap;
                })();

                OlapsRs.OlapsList = (function() {

                    /**
                     * Properties of an OlapsList.
                     * @memberof priority.netitems.form.OlapsRs
                     * @interface IOlapsList
                     * @property {Array.<priority.netitems.form.OlapsRs.IOlap>|null} [OlapsList] OlapsList OlapsList
                     */

                    /**
                     * Constructs a new OlapsList.
                     * @memberof priority.netitems.form.OlapsRs
                     * @classdesc Represents an OlapsList.
                     * @implements IOlapsList
                     * @constructor
                     * @param {priority.netitems.form.OlapsRs.IOlapsList=} [properties] Properties to set
                     */
                    function OlapsList(properties) {
                        this.OlapsList = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * OlapsList OlapsList.
                     * @member {Array.<priority.netitems.form.OlapsRs.IOlap>} OlapsList
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @instance
                     */
                    OlapsList.prototype.OlapsList = $util.emptyArray;

                    /**
                     * Creates a new OlapsList instance using the specified properties.
                     * @function create
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @static
                     * @param {priority.netitems.form.OlapsRs.IOlapsList=} [properties] Properties to set
                     * @returns {priority.netitems.form.OlapsRs.OlapsList} OlapsList instance
                     */
                    OlapsList.create = function create(properties) {
                        return new OlapsList(properties);
                    };

                    /**
                     * Encodes the specified OlapsList message. Does not implicitly {@link priority.netitems.form.OlapsRs.OlapsList.verify|verify} messages.
                     * @function encode
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @static
                     * @param {priority.netitems.form.OlapsRs.IOlapsList} message OlapsList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OlapsList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.OlapsList != null && message.OlapsList.length)
                            for (var i = 0; i < message.OlapsList.length; ++i)
                                $root.priority.netitems.form.OlapsRs.Olap.encode(message.OlapsList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };

                    /**
                     * Encodes the specified OlapsList message, length delimited. Does not implicitly {@link priority.netitems.form.OlapsRs.OlapsList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @static
                     * @param {priority.netitems.form.OlapsRs.IOlapsList} message OlapsList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OlapsList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes an OlapsList message from the specified reader or buffer.
                     * @function decode
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {priority.netitems.form.OlapsRs.OlapsList} OlapsList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OlapsList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.OlapsRs.OlapsList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.OlapsList && message.OlapsList.length))
                                    message.OlapsList = [];
                                message.OlapsList.push($root.priority.netitems.form.OlapsRs.Olap.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes an OlapsList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {priority.netitems.form.OlapsRs.OlapsList} OlapsList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OlapsList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies an OlapsList message.
                     * @function verify
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    OlapsList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.OlapsList != null && message.hasOwnProperty("OlapsList")) {
                            if (!Array.isArray(message.OlapsList))
                                return "OlapsList: array expected";
                            for (var i = 0; i < message.OlapsList.length; ++i) {
                                var error = $root.priority.netitems.form.OlapsRs.Olap.verify(message.OlapsList[i]);
                                if (error)
                                    return "OlapsList." + error;
                            }
                        }
                        return null;
                    };

                    /**
                     * Creates an OlapsList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {priority.netitems.form.OlapsRs.OlapsList} OlapsList
                     */
                    OlapsList.fromObject = function fromObject(object) {
                        if (object instanceof $root.priority.netitems.form.OlapsRs.OlapsList)
                            return object;
                        var message = new $root.priority.netitems.form.OlapsRs.OlapsList();
                        if (object.OlapsList) {
                            if (!Array.isArray(object.OlapsList))
                                throw TypeError(".priority.netitems.form.OlapsRs.OlapsList.OlapsList: array expected");
                            message.OlapsList = [];
                            for (var i = 0; i < object.OlapsList.length; ++i) {
                                if (typeof object.OlapsList[i] !== "object")
                                    throw TypeError(".priority.netitems.form.OlapsRs.OlapsList.OlapsList: object expected");
                                message.OlapsList[i] = $root.priority.netitems.form.OlapsRs.Olap.fromObject(object.OlapsList[i]);
                            }
                        }
                        return message;
                    };

                    /**
                     * Creates a plain object from an OlapsList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @static
                     * @param {priority.netitems.form.OlapsRs.OlapsList} message OlapsList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    OlapsList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.OlapsList = [];
                        if (message.OlapsList && message.OlapsList.length) {
                            object.OlapsList = [];
                            for (var j = 0; j < message.OlapsList.length; ++j)
                                object.OlapsList[j] = $root.priority.netitems.form.OlapsRs.Olap.toObject(message.OlapsList[j], options);
                        }
                        return object;
                    };

                    /**
                     * Converts this OlapsList to JSON.
                     * @function toJSON
                     * @memberof priority.netitems.form.OlapsRs.OlapsList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    OlapsList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return OlapsList;
                })();

                return OlapsRs;
            })();

            form.ExplorerColumnsRs = (function() {

                /**
                 * Properties of an ExplorerColumnsRs.
                 * @memberof priority.netitems.form
                 * @interface IExplorerColumnsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] ExplorerColumnsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ExplorerColumnsRs Messages
                 * @property {Array.<string>|null} [cols] ExplorerColumnsRs cols
                 */

                /**
                 * Constructs a new ExplorerColumnsRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ExplorerColumnsRs.
                 * @implements IExplorerColumnsRs
                 * @constructor
                 * @param {priority.netitems.form.IExplorerColumnsRs=} [properties] Properties to set
                 */
                function ExplorerColumnsRs(properties) {
                    this.Messages = [];
                    this.cols = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ExplorerColumnsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @instance
                 */
                ExplorerColumnsRs.prototype.Perf = null;

                /**
                 * ExplorerColumnsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @instance
                 */
                ExplorerColumnsRs.prototype.Messages = $util.emptyArray;

                /**
                 * ExplorerColumnsRs cols.
                 * @member {Array.<string>} cols
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @instance
                 */
                ExplorerColumnsRs.prototype.cols = $util.emptyArray;

                /**
                 * Creates a new ExplorerColumnsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @static
                 * @param {priority.netitems.form.IExplorerColumnsRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.ExplorerColumnsRs} ExplorerColumnsRs instance
                 */
                ExplorerColumnsRs.create = function create(properties) {
                    return new ExplorerColumnsRs(properties);
                };

                /**
                 * Encodes the specified ExplorerColumnsRs message. Does not implicitly {@link priority.netitems.form.ExplorerColumnsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @static
                 * @param {priority.netitems.form.IExplorerColumnsRs} message ExplorerColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExplorerColumnsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.cols != null && message.cols.length)
                        for (var i = 0; i < message.cols.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.cols[i]);
                    return writer;
                };

                /**
                 * Encodes the specified ExplorerColumnsRs message, length delimited. Does not implicitly {@link priority.netitems.form.ExplorerColumnsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @static
                 * @param {priority.netitems.form.IExplorerColumnsRs} message ExplorerColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExplorerColumnsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ExplorerColumnsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ExplorerColumnsRs} ExplorerColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExplorerColumnsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ExplorerColumnsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.cols && message.cols.length))
                                message.cols = [];
                            message.cols.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ExplorerColumnsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ExplorerColumnsRs} ExplorerColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExplorerColumnsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ExplorerColumnsRs message.
                 * @function verify
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ExplorerColumnsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.cols != null && message.hasOwnProperty("cols")) {
                        if (!Array.isArray(message.cols))
                            return "cols: array expected";
                        for (var i = 0; i < message.cols.length; ++i)
                            if (!$util.isString(message.cols[i]))
                                return "cols: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates an ExplorerColumnsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ExplorerColumnsRs} ExplorerColumnsRs
                 */
                ExplorerColumnsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ExplorerColumnsRs)
                        return object;
                    var message = new $root.priority.netitems.form.ExplorerColumnsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.ExplorerColumnsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.ExplorerColumnsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.ExplorerColumnsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.cols) {
                        if (!Array.isArray(object.cols))
                            throw TypeError(".priority.netitems.form.ExplorerColumnsRs.cols: array expected");
                        message.cols = [];
                        for (var i = 0; i < object.cols.length; ++i)
                            message.cols[i] = String(object.cols[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ExplorerColumnsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @static
                 * @param {priority.netitems.form.ExplorerColumnsRs} message ExplorerColumnsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ExplorerColumnsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.cols = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.cols && message.cols.length) {
                        object.cols = [];
                        for (var j = 0; j < message.cols.length; ++j)
                            object.cols[j] = message.cols[j];
                    }
                    return object;
                };

                /**
                 * Converts this ExplorerColumnsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ExplorerColumnsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ExplorerColumnsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ExplorerColumnsRs;
            })();

            form.StatusesRq = (function() {

                /**
                 * Properties of a StatusesRq.
                 * @memberof priority.netitems.form
                 * @interface IStatusesRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] StatusesRq Properties
                 * @property {string|null} [Fname] StatusesRq Fname
                 */

                /**
                 * Constructs a new StatusesRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a StatusesRq.
                 * @implements IStatusesRq
                 * @constructor
                 * @param {priority.netitems.form.IStatusesRq=} [properties] Properties to set
                 */
                function StatusesRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusesRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.StatusesRq
                 * @instance
                 */
                StatusesRq.prototype.Properties = null;

                /**
                 * StatusesRq Fname.
                 * @member {string} Fname
                 * @memberof priority.netitems.form.StatusesRq
                 * @instance
                 */
                StatusesRq.prototype.Fname = "";

                /**
                 * Creates a new StatusesRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.StatusesRq
                 * @static
                 * @param {priority.netitems.form.IStatusesRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.StatusesRq} StatusesRq instance
                 */
                StatusesRq.create = function create(properties) {
                    return new StatusesRq(properties);
                };

                /**
                 * Encodes the specified StatusesRq message. Does not implicitly {@link priority.netitems.form.StatusesRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.StatusesRq
                 * @static
                 * @param {priority.netitems.form.IStatusesRq} message StatusesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusesRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Fname != null && Object.hasOwnProperty.call(message, "Fname"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Fname);
                    return writer;
                };

                /**
                 * Encodes the specified StatusesRq message, length delimited. Does not implicitly {@link priority.netitems.form.StatusesRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.StatusesRq
                 * @static
                 * @param {priority.netitems.form.IStatusesRq} message StatusesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusesRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusesRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.StatusesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.StatusesRq} StatusesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusesRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.StatusesRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Fname = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusesRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.StatusesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.StatusesRq} StatusesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusesRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusesRq message.
                 * @function verify
                 * @memberof priority.netitems.form.StatusesRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusesRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        if (!$util.isString(message.Fname))
                            return "Fname: string expected";
                    return null;
                };

                /**
                 * Creates a StatusesRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.StatusesRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.StatusesRq} StatusesRq
                 */
                StatusesRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.StatusesRq)
                        return object;
                    var message = new $root.priority.netitems.form.StatusesRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.StatusesRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Fname != null)
                        message.Fname = String(object.Fname);
                    return message;
                };

                /**
                 * Creates a plain object from a StatusesRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.StatusesRq
                 * @static
                 * @param {priority.netitems.form.StatusesRq} message StatusesRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusesRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Fname = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        object.Fname = message.Fname;
                    return object;
                };

                /**
                 * Converts this StatusesRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.StatusesRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusesRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StatusesRq;
            })();

            form.StatusesRs = (function() {

                /**
                 * Properties of a StatusesRs.
                 * @memberof priority.netitems.form
                 * @interface IStatusesRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] StatusesRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] StatusesRs Messages
                 * @property {Array.<priority.netitems.form.IStatus>|null} [Statuses] StatusesRs Statuses
                 */

                /**
                 * Constructs a new StatusesRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a StatusesRs.
                 * @implements IStatusesRs
                 * @constructor
                 * @param {priority.netitems.form.IStatusesRs=} [properties] Properties to set
                 */
                function StatusesRs(properties) {
                    this.Messages = [];
                    this.Statuses = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatusesRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.StatusesRs
                 * @instance
                 */
                StatusesRs.prototype.Perf = null;

                /**
                 * StatusesRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.StatusesRs
                 * @instance
                 */
                StatusesRs.prototype.Messages = $util.emptyArray;

                /**
                 * StatusesRs Statuses.
                 * @member {Array.<priority.netitems.form.IStatus>} Statuses
                 * @memberof priority.netitems.form.StatusesRs
                 * @instance
                 */
                StatusesRs.prototype.Statuses = $util.emptyArray;

                /**
                 * Creates a new StatusesRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.StatusesRs
                 * @static
                 * @param {priority.netitems.form.IStatusesRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.StatusesRs} StatusesRs instance
                 */
                StatusesRs.create = function create(properties) {
                    return new StatusesRs(properties);
                };

                /**
                 * Encodes the specified StatusesRs message. Does not implicitly {@link priority.netitems.form.StatusesRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.StatusesRs
                 * @static
                 * @param {priority.netitems.form.IStatusesRs} message StatusesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusesRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Statuses != null && message.Statuses.length)
                        for (var i = 0; i < message.Statuses.length; ++i)
                            $root.priority.netitems.form.Status.encode(message.Statuses[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified StatusesRs message, length delimited. Does not implicitly {@link priority.netitems.form.StatusesRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.StatusesRs
                 * @static
                 * @param {priority.netitems.form.IStatusesRs} message StatusesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatusesRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatusesRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.StatusesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.StatusesRs} StatusesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusesRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.StatusesRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.Statuses && message.Statuses.length))
                                message.Statuses = [];
                            message.Statuses.push($root.priority.netitems.form.Status.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatusesRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.StatusesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.StatusesRs} StatusesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatusesRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatusesRs message.
                 * @function verify
                 * @memberof priority.netitems.form.StatusesRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatusesRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Statuses != null && message.hasOwnProperty("Statuses")) {
                        if (!Array.isArray(message.Statuses))
                            return "Statuses: array expected";
                        for (var i = 0; i < message.Statuses.length; ++i) {
                            var error = $root.priority.netitems.form.Status.verify(message.Statuses[i]);
                            if (error)
                                return "Statuses." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a StatusesRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.StatusesRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.StatusesRs} StatusesRs
                 */
                StatusesRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.StatusesRs)
                        return object;
                    var message = new $root.priority.netitems.form.StatusesRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.StatusesRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.StatusesRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.StatusesRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Statuses) {
                        if (!Array.isArray(object.Statuses))
                            throw TypeError(".priority.netitems.form.StatusesRs.Statuses: array expected");
                        message.Statuses = [];
                        for (var i = 0; i < object.Statuses.length; ++i) {
                            if (typeof object.Statuses[i] !== "object")
                                throw TypeError(".priority.netitems.form.StatusesRs.Statuses: object expected");
                            message.Statuses[i] = $root.priority.netitems.form.Status.fromObject(object.Statuses[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a StatusesRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.StatusesRs
                 * @static
                 * @param {priority.netitems.form.StatusesRs} message StatusesRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatusesRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.Statuses = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Statuses && message.Statuses.length) {
                        object.Statuses = [];
                        for (var j = 0; j < message.Statuses.length; ++j)
                            object.Statuses[j] = $root.priority.netitems.form.Status.toObject(message.Statuses[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this StatusesRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.StatusesRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatusesRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StatusesRs;
            })();

            form.Status = (function() {

                /**
                 * Properties of a Status.
                 * @memberof priority.netitems.form
                 * @interface IStatus
                 * @property {string|null} [Statdes] Status Statdes
                 * @property {string|null} [Color] Status Color
                 */

                /**
                 * Constructs a new Status.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Status.
                 * @implements IStatus
                 * @constructor
                 * @param {priority.netitems.form.IStatus=} [properties] Properties to set
                 */
                function Status(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Status Statdes.
                 * @member {string} Statdes
                 * @memberof priority.netitems.form.Status
                 * @instance
                 */
                Status.prototype.Statdes = "";

                /**
                 * Status Color.
                 * @member {string} Color
                 * @memberof priority.netitems.form.Status
                 * @instance
                 */
                Status.prototype.Color = "";

                /**
                 * Creates a new Status instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Status
                 * @static
                 * @param {priority.netitems.form.IStatus=} [properties] Properties to set
                 * @returns {priority.netitems.form.Status} Status instance
                 */
                Status.create = function create(properties) {
                    return new Status(properties);
                };

                /**
                 * Encodes the specified Status message. Does not implicitly {@link priority.netitems.form.Status.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Status
                 * @static
                 * @param {priority.netitems.form.IStatus} message Status message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Status.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Statdes != null && Object.hasOwnProperty.call(message, "Statdes"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Statdes);
                    if (message.Color != null && Object.hasOwnProperty.call(message, "Color"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Color);
                    return writer;
                };

                /**
                 * Encodes the specified Status message, length delimited. Does not implicitly {@link priority.netitems.form.Status.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Status
                 * @static
                 * @param {priority.netitems.form.IStatus} message Status message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Status.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Status message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Status
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Status} Status
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Status.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Status();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Statdes = reader.string();
                            break;
                        case 2:
                            message.Color = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Status message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Status
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Status} Status
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Status.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Status message.
                 * @function verify
                 * @memberof priority.netitems.form.Status
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Status.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Statdes != null && message.hasOwnProperty("Statdes"))
                        if (!$util.isString(message.Statdes))
                            return "Statdes: string expected";
                    if (message.Color != null && message.hasOwnProperty("Color"))
                        if (!$util.isString(message.Color))
                            return "Color: string expected";
                    return null;
                };

                /**
                 * Creates a Status message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Status
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Status} Status
                 */
                Status.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Status)
                        return object;
                    var message = new $root.priority.netitems.form.Status();
                    if (object.Statdes != null)
                        message.Statdes = String(object.Statdes);
                    if (object.Color != null)
                        message.Color = String(object.Color);
                    return message;
                };

                /**
                 * Creates a plain object from a Status message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Status
                 * @static
                 * @param {priority.netitems.form.Status} message Status
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Status.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Statdes = "";
                        object.Color = "";
                    }
                    if (message.Statdes != null && message.hasOwnProperty("Statdes"))
                        object.Statdes = message.Statdes;
                    if (message.Color != null && message.hasOwnProperty("Color"))
                        object.Color = message.Color;
                    return object;
                };

                /**
                 * Converts this Status to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Status
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Status.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Status;
            })();

            form.Company = (function() {

                /**
                 * Properties of a Company.
                 * @memberof priority.netitems.form
                 * @interface ICompany
                 * @property {string|null} [Dname] Company Dname
                 * @property {string|null} [Title] Company Title
                 */

                /**
                 * Constructs a new Company.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Company.
                 * @implements ICompany
                 * @constructor
                 * @param {priority.netitems.form.ICompany=} [properties] Properties to set
                 */
                function Company(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Company Dname.
                 * @member {string} Dname
                 * @memberof priority.netitems.form.Company
                 * @instance
                 */
                Company.prototype.Dname = "";

                /**
                 * Company Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.Company
                 * @instance
                 */
                Company.prototype.Title = "";

                /**
                 * Creates a new Company instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Company
                 * @static
                 * @param {priority.netitems.form.ICompany=} [properties] Properties to set
                 * @returns {priority.netitems.form.Company} Company instance
                 */
                Company.create = function create(properties) {
                    return new Company(properties);
                };

                /**
                 * Encodes the specified Company message. Does not implicitly {@link priority.netitems.form.Company.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Company
                 * @static
                 * @param {priority.netitems.form.ICompany} message Company message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Company.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Dname != null && Object.hasOwnProperty.call(message, "Dname"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Dname);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    return writer;
                };

                /**
                 * Encodes the specified Company message, length delimited. Does not implicitly {@link priority.netitems.form.Company.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Company
                 * @static
                 * @param {priority.netitems.form.ICompany} message Company message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Company.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Company message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Company
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Company} Company
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Company.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Company();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Dname = reader.string();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Company message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Company
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Company} Company
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Company.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Company message.
                 * @function verify
                 * @memberof priority.netitems.form.Company
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Company.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Dname != null && message.hasOwnProperty("Dname"))
                        if (!$util.isString(message.Dname))
                            return "Dname: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    return null;
                };

                /**
                 * Creates a Company message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Company
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Company} Company
                 */
                Company.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Company)
                        return object;
                    var message = new $root.priority.netitems.form.Company();
                    if (object.Dname != null)
                        message.Dname = String(object.Dname);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    return message;
                };

                /**
                 * Creates a plain object from a Company message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Company
                 * @static
                 * @param {priority.netitems.form.Company} message Company
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Company.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Dname = "";
                        object.Title = "";
                    }
                    if (message.Dname != null && message.hasOwnProperty("Dname"))
                        object.Dname = message.Dname;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    return object;
                };

                /**
                 * Converts this Company to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Company
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Company.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Company;
            })();

            form.RecordColorsRq = (function() {

                /**
                 * Properties of a RecordColorsRq.
                 * @memberof priority.netitems.form
                 * @interface IRecordColorsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RecordColorsRq Properties
                 * @property {string|null} [Fname] RecordColorsRq Fname
                 */

                /**
                 * Constructs a new RecordColorsRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordColorsRq.
                 * @implements IRecordColorsRq
                 * @constructor
                 * @param {priority.netitems.form.IRecordColorsRq=} [properties] Properties to set
                 */
                function RecordColorsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordColorsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @instance
                 */
                RecordColorsRq.prototype.Properties = null;

                /**
                 * RecordColorsRq Fname.
                 * @member {string} Fname
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @instance
                 */
                RecordColorsRq.prototype.Fname = "";

                /**
                 * Creates a new RecordColorsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @static
                 * @param {priority.netitems.form.IRecordColorsRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordColorsRq} RecordColorsRq instance
                 */
                RecordColorsRq.create = function create(properties) {
                    return new RecordColorsRq(properties);
                };

                /**
                 * Encodes the specified RecordColorsRq message. Does not implicitly {@link priority.netitems.form.RecordColorsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @static
                 * @param {priority.netitems.form.IRecordColorsRq} message RecordColorsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordColorsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Fname != null && Object.hasOwnProperty.call(message, "Fname"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Fname);
                    return writer;
                };

                /**
                 * Encodes the specified RecordColorsRq message, length delimited. Does not implicitly {@link priority.netitems.form.RecordColorsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @static
                 * @param {priority.netitems.form.IRecordColorsRq} message RecordColorsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordColorsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordColorsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordColorsRq} RecordColorsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordColorsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordColorsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Fname = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordColorsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordColorsRq} RecordColorsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordColorsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordColorsRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordColorsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        if (!$util.isString(message.Fname))
                            return "Fname: string expected";
                    return null;
                };

                /**
                 * Creates a RecordColorsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordColorsRq} RecordColorsRq
                 */
                RecordColorsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordColorsRq)
                        return object;
                    var message = new $root.priority.netitems.form.RecordColorsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RecordColorsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Fname != null)
                        message.Fname = String(object.Fname);
                    return message;
                };

                /**
                 * Creates a plain object from a RecordColorsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @static
                 * @param {priority.netitems.form.RecordColorsRq} message RecordColorsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordColorsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Fname = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        object.Fname = message.Fname;
                    return object;
                };

                /**
                 * Converts this RecordColorsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordColorsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordColorsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordColorsRq;
            })();

            form.RecordColorsRs = (function() {

                /**
                 * Properties of a RecordColorsRs.
                 * @memberof priority.netitems.form
                 * @interface IRecordColorsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RecordColorsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RecordColorsRs Messages
                 * @property {Array.<priority.netitems.form.IRecordColor>|null} [RecordColors] RecordColorsRs RecordColors
                 */

                /**
                 * Constructs a new RecordColorsRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordColorsRs.
                 * @implements IRecordColorsRs
                 * @constructor
                 * @param {priority.netitems.form.IRecordColorsRs=} [properties] Properties to set
                 */
                function RecordColorsRs(properties) {
                    this.Messages = [];
                    this.RecordColors = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordColorsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @instance
                 */
                RecordColorsRs.prototype.Perf = null;

                /**
                 * RecordColorsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @instance
                 */
                RecordColorsRs.prototype.Messages = $util.emptyArray;

                /**
                 * RecordColorsRs RecordColors.
                 * @member {Array.<priority.netitems.form.IRecordColor>} RecordColors
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @instance
                 */
                RecordColorsRs.prototype.RecordColors = $util.emptyArray;

                /**
                 * Creates a new RecordColorsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @static
                 * @param {priority.netitems.form.IRecordColorsRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordColorsRs} RecordColorsRs instance
                 */
                RecordColorsRs.create = function create(properties) {
                    return new RecordColorsRs(properties);
                };

                /**
                 * Encodes the specified RecordColorsRs message. Does not implicitly {@link priority.netitems.form.RecordColorsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @static
                 * @param {priority.netitems.form.IRecordColorsRs} message RecordColorsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordColorsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.RecordColors != null && message.RecordColors.length)
                        for (var i = 0; i < message.RecordColors.length; ++i)
                            $root.priority.netitems.form.RecordColor.encode(message.RecordColors[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RecordColorsRs message, length delimited. Does not implicitly {@link priority.netitems.form.RecordColorsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @static
                 * @param {priority.netitems.form.IRecordColorsRs} message RecordColorsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordColorsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordColorsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordColorsRs} RecordColorsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordColorsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordColorsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.RecordColors && message.RecordColors.length))
                                message.RecordColors = [];
                            message.RecordColors.push($root.priority.netitems.form.RecordColor.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordColorsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordColorsRs} RecordColorsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordColorsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordColorsRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordColorsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.RecordColors != null && message.hasOwnProperty("RecordColors")) {
                        if (!Array.isArray(message.RecordColors))
                            return "RecordColors: array expected";
                        for (var i = 0; i < message.RecordColors.length; ++i) {
                            var error = $root.priority.netitems.form.RecordColor.verify(message.RecordColors[i]);
                            if (error)
                                return "RecordColors." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a RecordColorsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordColorsRs} RecordColorsRs
                 */
                RecordColorsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordColorsRs)
                        return object;
                    var message = new $root.priority.netitems.form.RecordColorsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RecordColorsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RecordColorsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordColorsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.RecordColors) {
                        if (!Array.isArray(object.RecordColors))
                            throw TypeError(".priority.netitems.form.RecordColorsRs.RecordColors: array expected");
                        message.RecordColors = [];
                        for (var i = 0; i < object.RecordColors.length; ++i) {
                            if (typeof object.RecordColors[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordColorsRs.RecordColors: object expected");
                            message.RecordColors[i] = $root.priority.netitems.form.RecordColor.fromObject(object.RecordColors[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordColorsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @static
                 * @param {priority.netitems.form.RecordColorsRs} message RecordColorsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordColorsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.RecordColors = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.RecordColors && message.RecordColors.length) {
                        object.RecordColors = [];
                        for (var j = 0; j < message.RecordColors.length; ++j)
                            object.RecordColors[j] = $root.priority.netitems.form.RecordColor.toObject(message.RecordColors[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this RecordColorsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordColorsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordColorsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordColorsRs;
            })();

            form.SetRecordColorRq = (function() {

                /**
                 * Properties of a SetRecordColorRq.
                 * @memberof priority.netitems.form
                 * @interface ISetRecordColorRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SetRecordColorRq Properties
                 * @property {string|null} [Fname] SetRecordColorRq Fname
                 * @property {priority.netitems.form.IRecordColor|null} [setRecordColor] SetRecordColorRq setRecordColor
                 */

                /**
                 * Constructs a new SetRecordColorRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SetRecordColorRq.
                 * @implements ISetRecordColorRq
                 * @constructor
                 * @param {priority.netitems.form.ISetRecordColorRq=} [properties] Properties to set
                 */
                function SetRecordColorRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetRecordColorRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @instance
                 */
                SetRecordColorRq.prototype.Properties = null;

                /**
                 * SetRecordColorRq Fname.
                 * @member {string} Fname
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @instance
                 */
                SetRecordColorRq.prototype.Fname = "";

                /**
                 * SetRecordColorRq setRecordColor.
                 * @member {priority.netitems.form.IRecordColor|null|undefined} setRecordColor
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @instance
                 */
                SetRecordColorRq.prototype.setRecordColor = null;

                /**
                 * Creates a new SetRecordColorRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @static
                 * @param {priority.netitems.form.ISetRecordColorRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SetRecordColorRq} SetRecordColorRq instance
                 */
                SetRecordColorRq.create = function create(properties) {
                    return new SetRecordColorRq(properties);
                };

                /**
                 * Encodes the specified SetRecordColorRq message. Does not implicitly {@link priority.netitems.form.SetRecordColorRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @static
                 * @param {priority.netitems.form.ISetRecordColorRq} message SetRecordColorRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetRecordColorRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Fname != null && Object.hasOwnProperty.call(message, "Fname"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Fname);
                    if (message.setRecordColor != null && Object.hasOwnProperty.call(message, "setRecordColor"))
                        $root.priority.netitems.form.RecordColor.encode(message.setRecordColor, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SetRecordColorRq message, length delimited. Does not implicitly {@link priority.netitems.form.SetRecordColorRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @static
                 * @param {priority.netitems.form.ISetRecordColorRq} message SetRecordColorRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetRecordColorRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetRecordColorRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SetRecordColorRq} SetRecordColorRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetRecordColorRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SetRecordColorRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Fname = reader.string();
                            break;
                        case 3:
                            message.setRecordColor = $root.priority.netitems.form.RecordColor.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetRecordColorRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SetRecordColorRq} SetRecordColorRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetRecordColorRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetRecordColorRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetRecordColorRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        if (!$util.isString(message.Fname))
                            return "Fname: string expected";
                    if (message.setRecordColor != null && message.hasOwnProperty("setRecordColor")) {
                        var error = $root.priority.netitems.form.RecordColor.verify(message.setRecordColor);
                        if (error)
                            return "setRecordColor." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SetRecordColorRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SetRecordColorRq} SetRecordColorRq
                 */
                SetRecordColorRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SetRecordColorRq)
                        return object;
                    var message = new $root.priority.netitems.form.SetRecordColorRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SetRecordColorRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Fname != null)
                        message.Fname = String(object.Fname);
                    if (object.setRecordColor != null) {
                        if (typeof object.setRecordColor !== "object")
                            throw TypeError(".priority.netitems.form.SetRecordColorRq.setRecordColor: object expected");
                        message.setRecordColor = $root.priority.netitems.form.RecordColor.fromObject(object.setRecordColor);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SetRecordColorRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @static
                 * @param {priority.netitems.form.SetRecordColorRq} message SetRecordColorRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetRecordColorRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Fname = "";
                        object.setRecordColor = null;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        object.Fname = message.Fname;
                    if (message.setRecordColor != null && message.hasOwnProperty("setRecordColor"))
                        object.setRecordColor = $root.priority.netitems.form.RecordColor.toObject(message.setRecordColor, options);
                    return object;
                };

                /**
                 * Converts this SetRecordColorRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SetRecordColorRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetRecordColorRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SetRecordColorRq;
            })();

            form.SetRecordColorRs = (function() {

                /**
                 * Properties of a SetRecordColorRs.
                 * @memberof priority.netitems.form
                 * @interface ISetRecordColorRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SetRecordColorRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SetRecordColorRs Messages
                 */

                /**
                 * Constructs a new SetRecordColorRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SetRecordColorRs.
                 * @implements ISetRecordColorRs
                 * @constructor
                 * @param {priority.netitems.form.ISetRecordColorRs=} [properties] Properties to set
                 */
                function SetRecordColorRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SetRecordColorRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @instance
                 */
                SetRecordColorRs.prototype.Perf = null;

                /**
                 * SetRecordColorRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @instance
                 */
                SetRecordColorRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new SetRecordColorRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @static
                 * @param {priority.netitems.form.ISetRecordColorRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.SetRecordColorRs} SetRecordColorRs instance
                 */
                SetRecordColorRs.create = function create(properties) {
                    return new SetRecordColorRs(properties);
                };

                /**
                 * Encodes the specified SetRecordColorRs message. Does not implicitly {@link priority.netitems.form.SetRecordColorRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @static
                 * @param {priority.netitems.form.ISetRecordColorRs} message SetRecordColorRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetRecordColorRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SetRecordColorRs message, length delimited. Does not implicitly {@link priority.netitems.form.SetRecordColorRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @static
                 * @param {priority.netitems.form.ISetRecordColorRs} message SetRecordColorRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SetRecordColorRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SetRecordColorRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SetRecordColorRs} SetRecordColorRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetRecordColorRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SetRecordColorRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SetRecordColorRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SetRecordColorRs} SetRecordColorRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SetRecordColorRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SetRecordColorRs message.
                 * @function verify
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SetRecordColorRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SetRecordColorRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SetRecordColorRs} SetRecordColorRs
                 */
                SetRecordColorRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SetRecordColorRs)
                        return object;
                    var message = new $root.priority.netitems.form.SetRecordColorRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.SetRecordColorRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.SetRecordColorRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.SetRecordColorRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SetRecordColorRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @static
                 * @param {priority.netitems.form.SetRecordColorRs} message SetRecordColorRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SetRecordColorRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SetRecordColorRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SetRecordColorRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SetRecordColorRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SetRecordColorRs;
            })();

            form.RemoveAllColorsRq = (function() {

                /**
                 * Properties of a RemoveAllColorsRq.
                 * @memberof priority.netitems.form
                 * @interface IRemoveAllColorsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RemoveAllColorsRq Properties
                 * @property {string|null} [Fname] RemoveAllColorsRq Fname
                 */

                /**
                 * Constructs a new RemoveAllColorsRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RemoveAllColorsRq.
                 * @implements IRemoveAllColorsRq
                 * @constructor
                 * @param {priority.netitems.form.IRemoveAllColorsRq=} [properties] Properties to set
                 */
                function RemoveAllColorsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RemoveAllColorsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @instance
                 */
                RemoveAllColorsRq.prototype.Properties = null;

                /**
                 * RemoveAllColorsRq Fname.
                 * @member {string} Fname
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @instance
                 */
                RemoveAllColorsRq.prototype.Fname = "";

                /**
                 * Creates a new RemoveAllColorsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @static
                 * @param {priority.netitems.form.IRemoveAllColorsRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RemoveAllColorsRq} RemoveAllColorsRq instance
                 */
                RemoveAllColorsRq.create = function create(properties) {
                    return new RemoveAllColorsRq(properties);
                };

                /**
                 * Encodes the specified RemoveAllColorsRq message. Does not implicitly {@link priority.netitems.form.RemoveAllColorsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @static
                 * @param {priority.netitems.form.IRemoveAllColorsRq} message RemoveAllColorsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RemoveAllColorsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Fname != null && Object.hasOwnProperty.call(message, "Fname"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Fname);
                    return writer;
                };

                /**
                 * Encodes the specified RemoveAllColorsRq message, length delimited. Does not implicitly {@link priority.netitems.form.RemoveAllColorsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @static
                 * @param {priority.netitems.form.IRemoveAllColorsRq} message RemoveAllColorsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RemoveAllColorsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RemoveAllColorsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RemoveAllColorsRq} RemoveAllColorsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RemoveAllColorsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RemoveAllColorsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Fname = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RemoveAllColorsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RemoveAllColorsRq} RemoveAllColorsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RemoveAllColorsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RemoveAllColorsRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RemoveAllColorsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        if (!$util.isString(message.Fname))
                            return "Fname: string expected";
                    return null;
                };

                /**
                 * Creates a RemoveAllColorsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RemoveAllColorsRq} RemoveAllColorsRq
                 */
                RemoveAllColorsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RemoveAllColorsRq)
                        return object;
                    var message = new $root.priority.netitems.form.RemoveAllColorsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RemoveAllColorsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Fname != null)
                        message.Fname = String(object.Fname);
                    return message;
                };

                /**
                 * Creates a plain object from a RemoveAllColorsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @static
                 * @param {priority.netitems.form.RemoveAllColorsRq} message RemoveAllColorsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RemoveAllColorsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Fname = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        object.Fname = message.Fname;
                    return object;
                };

                /**
                 * Converts this RemoveAllColorsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RemoveAllColorsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RemoveAllColorsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RemoveAllColorsRq;
            })();

            form.RemoveAllColorsRs = (function() {

                /**
                 * Properties of a RemoveAllColorsRs.
                 * @memberof priority.netitems.form
                 * @interface IRemoveAllColorsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RemoveAllColorsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RemoveAllColorsRs Messages
                 */

                /**
                 * Constructs a new RemoveAllColorsRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RemoveAllColorsRs.
                 * @implements IRemoveAllColorsRs
                 * @constructor
                 * @param {priority.netitems.form.IRemoveAllColorsRs=} [properties] Properties to set
                 */
                function RemoveAllColorsRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RemoveAllColorsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @instance
                 */
                RemoveAllColorsRs.prototype.Perf = null;

                /**
                 * RemoveAllColorsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @instance
                 */
                RemoveAllColorsRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new RemoveAllColorsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @static
                 * @param {priority.netitems.form.IRemoveAllColorsRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RemoveAllColorsRs} RemoveAllColorsRs instance
                 */
                RemoveAllColorsRs.create = function create(properties) {
                    return new RemoveAllColorsRs(properties);
                };

                /**
                 * Encodes the specified RemoveAllColorsRs message. Does not implicitly {@link priority.netitems.form.RemoveAllColorsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @static
                 * @param {priority.netitems.form.IRemoveAllColorsRs} message RemoveAllColorsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RemoveAllColorsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RemoveAllColorsRs message, length delimited. Does not implicitly {@link priority.netitems.form.RemoveAllColorsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @static
                 * @param {priority.netitems.form.IRemoveAllColorsRs} message RemoveAllColorsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RemoveAllColorsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RemoveAllColorsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RemoveAllColorsRs} RemoveAllColorsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RemoveAllColorsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RemoveAllColorsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RemoveAllColorsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RemoveAllColorsRs} RemoveAllColorsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RemoveAllColorsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RemoveAllColorsRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RemoveAllColorsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a RemoveAllColorsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RemoveAllColorsRs} RemoveAllColorsRs
                 */
                RemoveAllColorsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RemoveAllColorsRs)
                        return object;
                    var message = new $root.priority.netitems.form.RemoveAllColorsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RemoveAllColorsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RemoveAllColorsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RemoveAllColorsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RemoveAllColorsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @static
                 * @param {priority.netitems.form.RemoveAllColorsRs} message RemoveAllColorsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RemoveAllColorsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this RemoveAllColorsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RemoveAllColorsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RemoveAllColorsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RemoveAllColorsRs;
            })();

            form.HtmlSignatureRq = (function() {

                /**
                 * Properties of a HtmlSignatureRq.
                 * @memberof priority.netitems.form
                 * @interface IHtmlSignatureRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] HtmlSignatureRq Properties
                 */

                /**
                 * Constructs a new HtmlSignatureRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlSignatureRq.
                 * @implements IHtmlSignatureRq
                 * @constructor
                 * @param {priority.netitems.form.IHtmlSignatureRq=} [properties] Properties to set
                 */
                function HtmlSignatureRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlSignatureRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @instance
                 */
                HtmlSignatureRq.prototype.Properties = null;

                /**
                 * Creates a new HtmlSignatureRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlSignatureRq} HtmlSignatureRq instance
                 */
                HtmlSignatureRq.create = function create(properties) {
                    return new HtmlSignatureRq(properties);
                };

                /**
                 * Encodes the specified HtmlSignatureRq message. Does not implicitly {@link priority.netitems.form.HtmlSignatureRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureRq} message HtmlSignatureRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSignatureRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified HtmlSignatureRq message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlSignatureRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureRq} message HtmlSignatureRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSignatureRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlSignatureRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlSignatureRq} HtmlSignatureRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSignatureRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlSignatureRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlSignatureRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlSignatureRq} HtmlSignatureRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSignatureRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlSignatureRq message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlSignatureRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a HtmlSignatureRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlSignatureRq} HtmlSignatureRq
                 */
                HtmlSignatureRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlSignatureRq)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlSignatureRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.HtmlSignatureRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlSignatureRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @static
                 * @param {priority.netitems.form.HtmlSignatureRq} message HtmlSignatureRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlSignatureRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this HtmlSignatureRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlSignatureRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlSignatureRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlSignatureRq;
            })();

            form.HtmlSignatureRs = (function() {

                /**
                 * Properties of a HtmlSignatureRs.
                 * @memberof priority.netitems.form
                 * @interface IHtmlSignatureRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] HtmlSignatureRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] HtmlSignatureRs Messages
                 * @property {priority.netitems.form.IHtmlSignatureBase|null} [Signautre] HtmlSignatureRs Signautre
                 * @property {priority.netitems.form.IHtmlSignatureBase|null} [SignatureEng] HtmlSignatureRs SignatureEng
                 */

                /**
                 * Constructs a new HtmlSignatureRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlSignatureRs.
                 * @implements IHtmlSignatureRs
                 * @constructor
                 * @param {priority.netitems.form.IHtmlSignatureRs=} [properties] Properties to set
                 */
                function HtmlSignatureRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlSignatureRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @instance
                 */
                HtmlSignatureRs.prototype.Perf = null;

                /**
                 * HtmlSignatureRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @instance
                 */
                HtmlSignatureRs.prototype.Messages = $util.emptyArray;

                /**
                 * HtmlSignatureRs Signautre.
                 * @member {priority.netitems.form.IHtmlSignatureBase|null|undefined} Signautre
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @instance
                 */
                HtmlSignatureRs.prototype.Signautre = null;

                /**
                 * HtmlSignatureRs SignatureEng.
                 * @member {priority.netitems.form.IHtmlSignatureBase|null|undefined} SignatureEng
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @instance
                 */
                HtmlSignatureRs.prototype.SignatureEng = null;

                /**
                 * Creates a new HtmlSignatureRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlSignatureRs} HtmlSignatureRs instance
                 */
                HtmlSignatureRs.create = function create(properties) {
                    return new HtmlSignatureRs(properties);
                };

                /**
                 * Encodes the specified HtmlSignatureRs message. Does not implicitly {@link priority.netitems.form.HtmlSignatureRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureRs} message HtmlSignatureRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSignatureRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Signautre != null && Object.hasOwnProperty.call(message, "Signautre"))
                        $root.priority.netitems.form.HtmlSignatureBase.encode(message.Signautre, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.SignatureEng != null && Object.hasOwnProperty.call(message, "SignatureEng"))
                        $root.priority.netitems.form.HtmlSignatureBase.encode(message.SignatureEng, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified HtmlSignatureRs message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlSignatureRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureRs} message HtmlSignatureRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSignatureRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlSignatureRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlSignatureRs} HtmlSignatureRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSignatureRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlSignatureRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Signautre = $root.priority.netitems.form.HtmlSignatureBase.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.SignatureEng = $root.priority.netitems.form.HtmlSignatureBase.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlSignatureRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlSignatureRs} HtmlSignatureRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSignatureRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlSignatureRs message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlSignatureRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Signautre != null && message.hasOwnProperty("Signautre")) {
                        var error = $root.priority.netitems.form.HtmlSignatureBase.verify(message.Signautre);
                        if (error)
                            return "Signautre." + error;
                    }
                    if (message.SignatureEng != null && message.hasOwnProperty("SignatureEng")) {
                        var error = $root.priority.netitems.form.HtmlSignatureBase.verify(message.SignatureEng);
                        if (error)
                            return "SignatureEng." + error;
                    }
                    return null;
                };

                /**
                 * Creates a HtmlSignatureRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlSignatureRs} HtmlSignatureRs
                 */
                HtmlSignatureRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlSignatureRs)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlSignatureRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.HtmlSignatureRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.HtmlSignatureRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.HtmlSignatureRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Signautre != null) {
                        if (typeof object.Signautre !== "object")
                            throw TypeError(".priority.netitems.form.HtmlSignatureRs.Signautre: object expected");
                        message.Signautre = $root.priority.netitems.form.HtmlSignatureBase.fromObject(object.Signautre);
                    }
                    if (object.SignatureEng != null) {
                        if (typeof object.SignatureEng !== "object")
                            throw TypeError(".priority.netitems.form.HtmlSignatureRs.SignatureEng: object expected");
                        message.SignatureEng = $root.priority.netitems.form.HtmlSignatureBase.fromObject(object.SignatureEng);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlSignatureRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @static
                 * @param {priority.netitems.form.HtmlSignatureRs} message HtmlSignatureRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlSignatureRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.Signautre = null;
                        object.SignatureEng = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Signautre != null && message.hasOwnProperty("Signautre"))
                        object.Signautre = $root.priority.netitems.form.HtmlSignatureBase.toObject(message.Signautre, options);
                    if (message.SignatureEng != null && message.hasOwnProperty("SignatureEng"))
                        object.SignatureEng = $root.priority.netitems.form.HtmlSignatureBase.toObject(message.SignatureEng, options);
                    return object;
                };

                /**
                 * Converts this HtmlSignatureRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlSignatureRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlSignatureRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlSignatureRs;
            })();

            form.HtmlFetchRq = (function() {

                /**
                 * Properties of a HtmlFetchRq.
                 * @memberof priority.netitems.form
                 * @interface IHtmlFetchRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] HtmlFetchRq Properties
                 * @property {string|null} [Session] HtmlFetchRq Session
                 */

                /**
                 * Constructs a new HtmlFetchRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlFetchRq.
                 * @implements IHtmlFetchRq
                 * @constructor
                 * @param {priority.netitems.form.IHtmlFetchRq=} [properties] Properties to set
                 */
                function HtmlFetchRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlFetchRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @instance
                 */
                HtmlFetchRq.prototype.Properties = null;

                /**
                 * HtmlFetchRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @instance
                 */
                HtmlFetchRq.prototype.Session = "";

                /**
                 * Creates a new HtmlFetchRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @static
                 * @param {priority.netitems.form.IHtmlFetchRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlFetchRq} HtmlFetchRq instance
                 */
                HtmlFetchRq.create = function create(properties) {
                    return new HtmlFetchRq(properties);
                };

                /**
                 * Encodes the specified HtmlFetchRq message. Does not implicitly {@link priority.netitems.form.HtmlFetchRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @static
                 * @param {priority.netitems.form.IHtmlFetchRq} message HtmlFetchRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlFetchRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified HtmlFetchRq message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlFetchRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @static
                 * @param {priority.netitems.form.IHtmlFetchRq} message HtmlFetchRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlFetchRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlFetchRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlFetchRq} HtmlFetchRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlFetchRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlFetchRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlFetchRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlFetchRq} HtmlFetchRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlFetchRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlFetchRq message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlFetchRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates a HtmlFetchRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlFetchRq} HtmlFetchRq
                 */
                HtmlFetchRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlFetchRq)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlFetchRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.HtmlFetchRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlFetchRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @static
                 * @param {priority.netitems.form.HtmlFetchRq} message HtmlFetchRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlFetchRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this HtmlFetchRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlFetchRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlFetchRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlFetchRq;
            })();

            form.HtmlFetchRs = (function() {

                /**
                 * Properties of a HtmlFetchRs.
                 * @memberof priority.netitems.form
                 * @interface IHtmlFetchRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] HtmlFetchRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] HtmlFetchRs Messages
                 * @property {string|null} [Content] HtmlFetchRs Content
                 */

                /**
                 * Constructs a new HtmlFetchRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlFetchRs.
                 * @implements IHtmlFetchRs
                 * @constructor
                 * @param {priority.netitems.form.IHtmlFetchRs=} [properties] Properties to set
                 */
                function HtmlFetchRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlFetchRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @instance
                 */
                HtmlFetchRs.prototype.Perf = null;

                /**
                 * HtmlFetchRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @instance
                 */
                HtmlFetchRs.prototype.Messages = $util.emptyArray;

                /**
                 * HtmlFetchRs Content.
                 * @member {string} Content
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @instance
                 */
                HtmlFetchRs.prototype.Content = "";

                /**
                 * Creates a new HtmlFetchRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @static
                 * @param {priority.netitems.form.IHtmlFetchRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlFetchRs} HtmlFetchRs instance
                 */
                HtmlFetchRs.create = function create(properties) {
                    return new HtmlFetchRs(properties);
                };

                /**
                 * Encodes the specified HtmlFetchRs message. Does not implicitly {@link priority.netitems.form.HtmlFetchRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @static
                 * @param {priority.netitems.form.IHtmlFetchRs} message HtmlFetchRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlFetchRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Content != null && Object.hasOwnProperty.call(message, "Content"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Content);
                    return writer;
                };

                /**
                 * Encodes the specified HtmlFetchRs message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlFetchRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @static
                 * @param {priority.netitems.form.IHtmlFetchRs} message HtmlFetchRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlFetchRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlFetchRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlFetchRs} HtmlFetchRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlFetchRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlFetchRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Content = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlFetchRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlFetchRs} HtmlFetchRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlFetchRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlFetchRs message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlFetchRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Content != null && message.hasOwnProperty("Content"))
                        if (!$util.isString(message.Content))
                            return "Content: string expected";
                    return null;
                };

                /**
                 * Creates a HtmlFetchRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlFetchRs} HtmlFetchRs
                 */
                HtmlFetchRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlFetchRs)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlFetchRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.HtmlFetchRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.HtmlFetchRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.HtmlFetchRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Content != null)
                        message.Content = String(object.Content);
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlFetchRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @static
                 * @param {priority.netitems.form.HtmlFetchRs} message HtmlFetchRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlFetchRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.Content = "";
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Content != null && message.hasOwnProperty("Content"))
                        object.Content = message.Content;
                    return object;
                };

                /**
                 * Converts this HtmlFetchRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlFetchRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlFetchRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlFetchRs;
            })();

            form.HtmlSaveRq = (function() {

                /**
                 * Properties of a HtmlSaveRq.
                 * @memberof priority.netitems.form
                 * @interface IHtmlSaveRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] HtmlSaveRq Properties
                 * @property {string|null} [Session] HtmlSaveRq Session
                 * @property {string|null} [Content] HtmlSaveRq Content
                 */

                /**
                 * Constructs a new HtmlSaveRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlSaveRq.
                 * @implements IHtmlSaveRq
                 * @constructor
                 * @param {priority.netitems.form.IHtmlSaveRq=} [properties] Properties to set
                 */
                function HtmlSaveRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlSaveRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @instance
                 */
                HtmlSaveRq.prototype.Properties = null;

                /**
                 * HtmlSaveRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @instance
                 */
                HtmlSaveRq.prototype.Session = "";

                /**
                 * HtmlSaveRq Content.
                 * @member {string} Content
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @instance
                 */
                HtmlSaveRq.prototype.Content = "";

                /**
                 * Creates a new HtmlSaveRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @static
                 * @param {priority.netitems.form.IHtmlSaveRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlSaveRq} HtmlSaveRq instance
                 */
                HtmlSaveRq.create = function create(properties) {
                    return new HtmlSaveRq(properties);
                };

                /**
                 * Encodes the specified HtmlSaveRq message. Does not implicitly {@link priority.netitems.form.HtmlSaveRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @static
                 * @param {priority.netitems.form.IHtmlSaveRq} message HtmlSaveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSaveRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Content != null && Object.hasOwnProperty.call(message, "Content"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Content);
                    return writer;
                };

                /**
                 * Encodes the specified HtmlSaveRq message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlSaveRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @static
                 * @param {priority.netitems.form.IHtmlSaveRq} message HtmlSaveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSaveRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlSaveRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlSaveRq} HtmlSaveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSaveRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlSaveRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.Content = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlSaveRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlSaveRq} HtmlSaveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSaveRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlSaveRq message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlSaveRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Content != null && message.hasOwnProperty("Content"))
                        if (!$util.isString(message.Content))
                            return "Content: string expected";
                    return null;
                };

                /**
                 * Creates a HtmlSaveRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlSaveRq} HtmlSaveRq
                 */
                HtmlSaveRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlSaveRq)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlSaveRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.HtmlSaveRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Content != null)
                        message.Content = String(object.Content);
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlSaveRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @static
                 * @param {priority.netitems.form.HtmlSaveRq} message HtmlSaveRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlSaveRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.Content = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Content != null && message.hasOwnProperty("Content"))
                        object.Content = message.Content;
                    return object;
                };

                /**
                 * Converts this HtmlSaveRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlSaveRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlSaveRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlSaveRq;
            })();

            form.HtmlSaveRs = (function() {

                /**
                 * Properties of a HtmlSaveRs.
                 * @memberof priority.netitems.form
                 * @interface IHtmlSaveRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] HtmlSaveRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] HtmlSaveRs Messages
                 */

                /**
                 * Constructs a new HtmlSaveRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlSaveRs.
                 * @implements IHtmlSaveRs
                 * @constructor
                 * @param {priority.netitems.form.IHtmlSaveRs=} [properties] Properties to set
                 */
                function HtmlSaveRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlSaveRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @instance
                 */
                HtmlSaveRs.prototype.Perf = null;

                /**
                 * HtmlSaveRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @instance
                 */
                HtmlSaveRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new HtmlSaveRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @static
                 * @param {priority.netitems.form.IHtmlSaveRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlSaveRs} HtmlSaveRs instance
                 */
                HtmlSaveRs.create = function create(properties) {
                    return new HtmlSaveRs(properties);
                };

                /**
                 * Encodes the specified HtmlSaveRs message. Does not implicitly {@link priority.netitems.form.HtmlSaveRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @static
                 * @param {priority.netitems.form.IHtmlSaveRs} message HtmlSaveRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSaveRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified HtmlSaveRs message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlSaveRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @static
                 * @param {priority.netitems.form.IHtmlSaveRs} message HtmlSaveRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSaveRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlSaveRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlSaveRs} HtmlSaveRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSaveRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlSaveRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlSaveRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlSaveRs} HtmlSaveRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSaveRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlSaveRs message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlSaveRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a HtmlSaveRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlSaveRs} HtmlSaveRs
                 */
                HtmlSaveRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlSaveRs)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlSaveRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.HtmlSaveRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.HtmlSaveRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.HtmlSaveRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlSaveRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @static
                 * @param {priority.netitems.form.HtmlSaveRs} message HtmlSaveRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlSaveRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this HtmlSaveRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlSaveRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlSaveRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlSaveRs;
            })();

            form.HtmlUnlockRq = (function() {

                /**
                 * Properties of a HtmlUnlockRq.
                 * @memberof priority.netitems.form
                 * @interface IHtmlUnlockRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] HtmlUnlockRq Properties
                 * @property {string|null} [Session] HtmlUnlockRq Session
                 */

                /**
                 * Constructs a new HtmlUnlockRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlUnlockRq.
                 * @implements IHtmlUnlockRq
                 * @constructor
                 * @param {priority.netitems.form.IHtmlUnlockRq=} [properties] Properties to set
                 */
                function HtmlUnlockRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlUnlockRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @instance
                 */
                HtmlUnlockRq.prototype.Properties = null;

                /**
                 * HtmlUnlockRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @instance
                 */
                HtmlUnlockRq.prototype.Session = "";

                /**
                 * Creates a new HtmlUnlockRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @static
                 * @param {priority.netitems.form.IHtmlUnlockRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlUnlockRq} HtmlUnlockRq instance
                 */
                HtmlUnlockRq.create = function create(properties) {
                    return new HtmlUnlockRq(properties);
                };

                /**
                 * Encodes the specified HtmlUnlockRq message. Does not implicitly {@link priority.netitems.form.HtmlUnlockRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @static
                 * @param {priority.netitems.form.IHtmlUnlockRq} message HtmlUnlockRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlUnlockRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified HtmlUnlockRq message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlUnlockRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @static
                 * @param {priority.netitems.form.IHtmlUnlockRq} message HtmlUnlockRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlUnlockRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlUnlockRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlUnlockRq} HtmlUnlockRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlUnlockRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlUnlockRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlUnlockRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlUnlockRq} HtmlUnlockRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlUnlockRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlUnlockRq message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlUnlockRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates a HtmlUnlockRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlUnlockRq} HtmlUnlockRq
                 */
                HtmlUnlockRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlUnlockRq)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlUnlockRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.HtmlUnlockRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlUnlockRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @static
                 * @param {priority.netitems.form.HtmlUnlockRq} message HtmlUnlockRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlUnlockRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this HtmlUnlockRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlUnlockRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlUnlockRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlUnlockRq;
            })();

            form.HtmlUnlockRs = (function() {

                /**
                 * Properties of a HtmlUnlockRs.
                 * @memberof priority.netitems.form
                 * @interface IHtmlUnlockRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] HtmlUnlockRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] HtmlUnlockRs Messages
                 */

                /**
                 * Constructs a new HtmlUnlockRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlUnlockRs.
                 * @implements IHtmlUnlockRs
                 * @constructor
                 * @param {priority.netitems.form.IHtmlUnlockRs=} [properties] Properties to set
                 */
                function HtmlUnlockRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlUnlockRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @instance
                 */
                HtmlUnlockRs.prototype.Perf = null;

                /**
                 * HtmlUnlockRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @instance
                 */
                HtmlUnlockRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new HtmlUnlockRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @static
                 * @param {priority.netitems.form.IHtmlUnlockRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlUnlockRs} HtmlUnlockRs instance
                 */
                HtmlUnlockRs.create = function create(properties) {
                    return new HtmlUnlockRs(properties);
                };

                /**
                 * Encodes the specified HtmlUnlockRs message. Does not implicitly {@link priority.netitems.form.HtmlUnlockRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @static
                 * @param {priority.netitems.form.IHtmlUnlockRs} message HtmlUnlockRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlUnlockRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified HtmlUnlockRs message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlUnlockRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @static
                 * @param {priority.netitems.form.IHtmlUnlockRs} message HtmlUnlockRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlUnlockRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlUnlockRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlUnlockRs} HtmlUnlockRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlUnlockRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlUnlockRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlUnlockRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlUnlockRs} HtmlUnlockRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlUnlockRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlUnlockRs message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlUnlockRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a HtmlUnlockRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlUnlockRs} HtmlUnlockRs
                 */
                HtmlUnlockRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlUnlockRs)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlUnlockRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.HtmlUnlockRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.HtmlUnlockRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.HtmlUnlockRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlUnlockRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @static
                 * @param {priority.netitems.form.HtmlUnlockRs} message HtmlUnlockRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlUnlockRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this HtmlUnlockRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlUnlockRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlUnlockRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlUnlockRs;
            })();

            form.RecordZoomRq = (function() {

                /**
                 * Properties of a RecordZoomRq.
                 * @memberof priority.netitems.form
                 * @interface IRecordZoomRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RecordZoomRq Properties
                 * @property {string|null} [Session] RecordZoomRq Session
                 * @property {Array.<priority.netitems.form.IField>|null} [Keys] RecordZoomRq Keys
                 */

                /**
                 * Constructs a new RecordZoomRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordZoomRq.
                 * @implements IRecordZoomRq
                 * @constructor
                 * @param {priority.netitems.form.IRecordZoomRq=} [properties] Properties to set
                 */
                function RecordZoomRq(properties) {
                    this.Keys = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordZoomRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @instance
                 */
                RecordZoomRq.prototype.Properties = null;

                /**
                 * RecordZoomRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @instance
                 */
                RecordZoomRq.prototype.Session = "";

                /**
                 * RecordZoomRq Keys.
                 * @member {Array.<priority.netitems.form.IField>} Keys
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @instance
                 */
                RecordZoomRq.prototype.Keys = $util.emptyArray;

                /**
                 * Creates a new RecordZoomRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @static
                 * @param {priority.netitems.form.IRecordZoomRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordZoomRq} RecordZoomRq instance
                 */
                RecordZoomRq.create = function create(properties) {
                    return new RecordZoomRq(properties);
                };

                /**
                 * Encodes the specified RecordZoomRq message. Does not implicitly {@link priority.netitems.form.RecordZoomRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @static
                 * @param {priority.netitems.form.IRecordZoomRq} message RecordZoomRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordZoomRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Keys != null && message.Keys.length)
                        for (var i = 0; i < message.Keys.length; ++i)
                            $root.priority.netitems.form.Field.encode(message.Keys[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RecordZoomRq message, length delimited. Does not implicitly {@link priority.netitems.form.RecordZoomRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @static
                 * @param {priority.netitems.form.IRecordZoomRq} message RecordZoomRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordZoomRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordZoomRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordZoomRq} RecordZoomRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordZoomRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordZoomRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            if (!(message.Keys && message.Keys.length))
                                message.Keys = [];
                            message.Keys.push($root.priority.netitems.form.Field.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordZoomRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordZoomRq} RecordZoomRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordZoomRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordZoomRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordZoomRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Keys != null && message.hasOwnProperty("Keys")) {
                        if (!Array.isArray(message.Keys))
                            return "Keys: array expected";
                        for (var i = 0; i < message.Keys.length; ++i) {
                            var error = $root.priority.netitems.form.Field.verify(message.Keys[i]);
                            if (error)
                                return "Keys." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a RecordZoomRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordZoomRq} RecordZoomRq
                 */
                RecordZoomRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordZoomRq)
                        return object;
                    var message = new $root.priority.netitems.form.RecordZoomRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RecordZoomRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Keys) {
                        if (!Array.isArray(object.Keys))
                            throw TypeError(".priority.netitems.form.RecordZoomRq.Keys: array expected");
                        message.Keys = [];
                        for (var i = 0; i < object.Keys.length; ++i) {
                            if (typeof object.Keys[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordZoomRq.Keys: object expected");
                            message.Keys[i] = $root.priority.netitems.form.Field.fromObject(object.Keys[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordZoomRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @static
                 * @param {priority.netitems.form.RecordZoomRq} message RecordZoomRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordZoomRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Keys = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Keys && message.Keys.length) {
                        object.Keys = [];
                        for (var j = 0; j < message.Keys.length; ++j)
                            object.Keys[j] = $root.priority.netitems.form.Field.toObject(message.Keys[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this RecordZoomRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordZoomRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordZoomRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordZoomRq;
            })();

            form.RecordZoomRs = (function() {

                /**
                 * Properties of a RecordZoomRs.
                 * @memberof priority.netitems.form
                 * @interface IRecordZoomRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RecordZoomRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RecordZoomRs Messages
                 * @property {Object.<string,string>|null} [ColumnZoom] RecordZoomRs ColumnZoom
                 */

                /**
                 * Constructs a new RecordZoomRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordZoomRs.
                 * @implements IRecordZoomRs
                 * @constructor
                 * @param {priority.netitems.form.IRecordZoomRs=} [properties] Properties to set
                 */
                function RecordZoomRs(properties) {
                    this.Messages = [];
                    this.ColumnZoom = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordZoomRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @instance
                 */
                RecordZoomRs.prototype.Perf = null;

                /**
                 * RecordZoomRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @instance
                 */
                RecordZoomRs.prototype.Messages = $util.emptyArray;

                /**
                 * RecordZoomRs ColumnZoom.
                 * @member {Object.<string,string>} ColumnZoom
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @instance
                 */
                RecordZoomRs.prototype.ColumnZoom = $util.emptyObject;

                /**
                 * Creates a new RecordZoomRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @static
                 * @param {priority.netitems.form.IRecordZoomRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordZoomRs} RecordZoomRs instance
                 */
                RecordZoomRs.create = function create(properties) {
                    return new RecordZoomRs(properties);
                };

                /**
                 * Encodes the specified RecordZoomRs message. Does not implicitly {@link priority.netitems.form.RecordZoomRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @static
                 * @param {priority.netitems.form.IRecordZoomRs} message RecordZoomRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordZoomRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ColumnZoom != null && Object.hasOwnProperty.call(message, "ColumnZoom"))
                        for (var keys = Object.keys(message.ColumnZoom), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 0 =*/8).uint32(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.ColumnZoom[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RecordZoomRs message, length delimited. Does not implicitly {@link priority.netitems.form.RecordZoomRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @static
                 * @param {priority.netitems.form.IRecordZoomRs} message RecordZoomRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordZoomRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordZoomRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordZoomRs} RecordZoomRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordZoomRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordZoomRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (message.ColumnZoom === $util.emptyObject)
                                message.ColumnZoom = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = 0;
                            value = "";
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.uint32();
                                    break;
                                case 2:
                                    value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.ColumnZoom[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordZoomRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordZoomRs} RecordZoomRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordZoomRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordZoomRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordZoomRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.ColumnZoom != null && message.hasOwnProperty("ColumnZoom")) {
                        if (!$util.isObject(message.ColumnZoom))
                            return "ColumnZoom: object expected";
                        var key = Object.keys(message.ColumnZoom);
                        for (var i = 0; i < key.length; ++i) {
                            if (!$util.key32Re.test(key[i]))
                                return "ColumnZoom: integer key{k:uint32} expected";
                            if (!$util.isString(message.ColumnZoom[key[i]]))
                                return "ColumnZoom: string{k:uint32} expected";
                        }
                    }
                    return null;
                };

                /**
                 * Creates a RecordZoomRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordZoomRs} RecordZoomRs
                 */
                RecordZoomRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordZoomRs)
                        return object;
                    var message = new $root.priority.netitems.form.RecordZoomRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RecordZoomRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RecordZoomRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RecordZoomRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.ColumnZoom) {
                        if (typeof object.ColumnZoom !== "object")
                            throw TypeError(".priority.netitems.form.RecordZoomRs.ColumnZoom: object expected");
                        message.ColumnZoom = {};
                        for (var keys = Object.keys(object.ColumnZoom), i = 0; i < keys.length; ++i)
                            message.ColumnZoom[keys[i]] = String(object.ColumnZoom[keys[i]]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RecordZoomRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @static
                 * @param {priority.netitems.form.RecordZoomRs} message RecordZoomRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordZoomRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.ColumnZoom = {};
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    var keys2;
                    if (message.ColumnZoom && (keys2 = Object.keys(message.ColumnZoom)).length) {
                        object.ColumnZoom = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.ColumnZoom[keys2[j]] = message.ColumnZoom[keys2[j]];
                    }
                    return object;
                };

                /**
                 * Converts this RecordZoomRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordZoomRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordZoomRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordZoomRs;
            })();

            form.HelpRq = (function() {

                /**
                 * Properties of a HelpRq.
                 * @memberof priority.netitems.form
                 * @interface IHelpRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] HelpRq Properties
                 * @property {string|null} [Fname] HelpRq Fname
                 * @property {string|null} [ColName] HelpRq ColName
                 * @property {number|Long|null} [Exec] HelpRq Exec
                 */

                /**
                 * Constructs a new HelpRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HelpRq.
                 * @implements IHelpRq
                 * @constructor
                 * @param {priority.netitems.form.IHelpRq=} [properties] Properties to set
                 */
                function HelpRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HelpRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.HelpRq
                 * @instance
                 */
                HelpRq.prototype.Properties = null;

                /**
                 * HelpRq Fname.
                 * @member {string} Fname
                 * @memberof priority.netitems.form.HelpRq
                 * @instance
                 */
                HelpRq.prototype.Fname = "";

                /**
                 * HelpRq ColName.
                 * @member {string} ColName
                 * @memberof priority.netitems.form.HelpRq
                 * @instance
                 */
                HelpRq.prototype.ColName = "";

                /**
                 * HelpRq Exec.
                 * @member {number|Long} Exec
                 * @memberof priority.netitems.form.HelpRq
                 * @instance
                 */
                HelpRq.prototype.Exec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new HelpRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HelpRq
                 * @static
                 * @param {priority.netitems.form.IHelpRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.HelpRq} HelpRq instance
                 */
                HelpRq.create = function create(properties) {
                    return new HelpRq(properties);
                };

                /**
                 * Encodes the specified HelpRq message. Does not implicitly {@link priority.netitems.form.HelpRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HelpRq
                 * @static
                 * @param {priority.netitems.form.IHelpRq} message HelpRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HelpRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Fname != null && Object.hasOwnProperty.call(message, "Fname"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Fname);
                    if (message.ColName != null && Object.hasOwnProperty.call(message, "ColName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.ColName);
                    if (message.Exec != null && Object.hasOwnProperty.call(message, "Exec"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.Exec);
                    return writer;
                };

                /**
                 * Encodes the specified HelpRq message, length delimited. Does not implicitly {@link priority.netitems.form.HelpRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HelpRq
                 * @static
                 * @param {priority.netitems.form.IHelpRq} message HelpRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HelpRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HelpRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HelpRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HelpRq} HelpRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HelpRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HelpRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Fname = reader.string();
                            break;
                        case 3:
                            message.ColName = reader.string();
                            break;
                        case 4:
                            message.Exec = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HelpRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HelpRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HelpRq} HelpRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HelpRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HelpRq message.
                 * @function verify
                 * @memberof priority.netitems.form.HelpRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HelpRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        if (!$util.isString(message.Fname))
                            return "Fname: string expected";
                    if (message.ColName != null && message.hasOwnProperty("ColName"))
                        if (!$util.isString(message.ColName))
                            return "ColName: string expected";
                    if (message.Exec != null && message.hasOwnProperty("Exec"))
                        if (!$util.isInteger(message.Exec) && !(message.Exec && $util.isInteger(message.Exec.low) && $util.isInteger(message.Exec.high)))
                            return "Exec: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a HelpRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HelpRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HelpRq} HelpRq
                 */
                HelpRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HelpRq)
                        return object;
                    var message = new $root.priority.netitems.form.HelpRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.HelpRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Fname != null)
                        message.Fname = String(object.Fname);
                    if (object.ColName != null)
                        message.ColName = String(object.ColName);
                    if (object.Exec != null)
                        if ($util.Long)
                            (message.Exec = $util.Long.fromValue(object.Exec)).unsigned = false;
                        else if (typeof object.Exec === "string")
                            message.Exec = parseInt(object.Exec, 10);
                        else if (typeof object.Exec === "number")
                            message.Exec = object.Exec;
                        else if (typeof object.Exec === "object")
                            message.Exec = new $util.LongBits(object.Exec.low >>> 0, object.Exec.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a HelpRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HelpRq
                 * @static
                 * @param {priority.netitems.form.HelpRq} message HelpRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HelpRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Fname = "";
                        object.ColName = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Exec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Exec = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Fname != null && message.hasOwnProperty("Fname"))
                        object.Fname = message.Fname;
                    if (message.ColName != null && message.hasOwnProperty("ColName"))
                        object.ColName = message.ColName;
                    if (message.Exec != null && message.hasOwnProperty("Exec"))
                        if (typeof message.Exec === "number")
                            object.Exec = options.longs === String ? String(message.Exec) : message.Exec;
                        else
                            object.Exec = options.longs === String ? $util.Long.prototype.toString.call(message.Exec) : options.longs === Number ? new $util.LongBits(message.Exec.low >>> 0, message.Exec.high >>> 0).toNumber() : message.Exec;
                    return object;
                };

                /**
                 * Converts this HelpRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HelpRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HelpRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HelpRq;
            })();

            form.HelpRs = (function() {

                /**
                 * Properties of a HelpRs.
                 * @memberof priority.netitems.form
                 * @interface IHelpRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] HelpRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] HelpRs Messages
                 */

                /**
                 * Constructs a new HelpRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HelpRs.
                 * @implements IHelpRs
                 * @constructor
                 * @param {priority.netitems.form.IHelpRs=} [properties] Properties to set
                 */
                function HelpRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HelpRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.HelpRs
                 * @instance
                 */
                HelpRs.prototype.Perf = null;

                /**
                 * HelpRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.HelpRs
                 * @instance
                 */
                HelpRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new HelpRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HelpRs
                 * @static
                 * @param {priority.netitems.form.IHelpRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.HelpRs} HelpRs instance
                 */
                HelpRs.create = function create(properties) {
                    return new HelpRs(properties);
                };

                /**
                 * Encodes the specified HelpRs message. Does not implicitly {@link priority.netitems.form.HelpRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HelpRs
                 * @static
                 * @param {priority.netitems.form.IHelpRs} message HelpRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HelpRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified HelpRs message, length delimited. Does not implicitly {@link priority.netitems.form.HelpRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HelpRs
                 * @static
                 * @param {priority.netitems.form.IHelpRs} message HelpRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HelpRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HelpRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HelpRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HelpRs} HelpRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HelpRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HelpRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HelpRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HelpRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HelpRs} HelpRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HelpRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HelpRs message.
                 * @function verify
                 * @memberof priority.netitems.form.HelpRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HelpRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a HelpRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HelpRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HelpRs} HelpRs
                 */
                HelpRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HelpRs)
                        return object;
                    var message = new $root.priority.netitems.form.HelpRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.HelpRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.HelpRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.HelpRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HelpRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HelpRs
                 * @static
                 * @param {priority.netitems.form.HelpRs} message HelpRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HelpRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this HelpRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HelpRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HelpRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HelpRs;
            })();

            form.FieldSelectRq = (function() {

                /**
                 * Properties of a FieldSelectRq.
                 * @memberof priority.netitems.form
                 * @interface IFieldSelectRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] FieldSelectRq Properties
                 * @property {string|null} [Session] FieldSelectRq Session
                 * @property {number|Long|null} [ColumnID] FieldSelectRq ColumnID
                 * @property {string|null} [Pattern] FieldSelectRq Pattern
                 * @property {boolean|null} [IgnoreCase] FieldSelectRq IgnoreCase
                 * @property {boolean|null} [FromStart] FieldSelectRq FromStart
                 * @property {number|Long|null} [Page] FieldSelectRq Page
                 * @property {priority.netitems.shared.FieldSelectType|null} [Preferred] FieldSelectRq Preferred
                 */

                /**
                 * Constructs a new FieldSelectRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FieldSelectRq.
                 * @implements IFieldSelectRq
                 * @constructor
                 * @param {priority.netitems.form.IFieldSelectRq=} [properties] Properties to set
                 */
                function FieldSelectRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FieldSelectRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 */
                FieldSelectRq.prototype.Properties = null;

                /**
                 * FieldSelectRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 */
                FieldSelectRq.prototype.Session = "";

                /**
                 * FieldSelectRq ColumnID.
                 * @member {number|Long} ColumnID
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 */
                FieldSelectRq.prototype.ColumnID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * FieldSelectRq Pattern.
                 * @member {string} Pattern
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 */
                FieldSelectRq.prototype.Pattern = "";

                /**
                 * FieldSelectRq IgnoreCase.
                 * @member {boolean} IgnoreCase
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 */
                FieldSelectRq.prototype.IgnoreCase = false;

                /**
                 * FieldSelectRq FromStart.
                 * @member {boolean} FromStart
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 */
                FieldSelectRq.prototype.FromStart = false;

                /**
                 * FieldSelectRq Page.
                 * @member {number|Long} Page
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 */
                FieldSelectRq.prototype.Page = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * FieldSelectRq Preferred.
                 * @member {priority.netitems.shared.FieldSelectType} Preferred
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 */
                FieldSelectRq.prototype.Preferred = 0;

                /**
                 * Creates a new FieldSelectRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @static
                 * @param {priority.netitems.form.IFieldSelectRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.FieldSelectRq} FieldSelectRq instance
                 */
                FieldSelectRq.create = function create(properties) {
                    return new FieldSelectRq(properties);
                };

                /**
                 * Encodes the specified FieldSelectRq message. Does not implicitly {@link priority.netitems.form.FieldSelectRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @static
                 * @param {priority.netitems.form.IFieldSelectRq} message FieldSelectRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldSelectRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.ColumnID != null && Object.hasOwnProperty.call(message, "ColumnID"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ColumnID);
                    if (message.Pattern != null && Object.hasOwnProperty.call(message, "Pattern"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Pattern);
                    if (message.IgnoreCase != null && Object.hasOwnProperty.call(message, "IgnoreCase"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.IgnoreCase);
                    if (message.FromStart != null && Object.hasOwnProperty.call(message, "FromStart"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.FromStart);
                    if (message.Page != null && Object.hasOwnProperty.call(message, "Page"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.Page);
                    if (message.Preferred != null && Object.hasOwnProperty.call(message, "Preferred"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.Preferred);
                    return writer;
                };

                /**
                 * Encodes the specified FieldSelectRq message, length delimited. Does not implicitly {@link priority.netitems.form.FieldSelectRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @static
                 * @param {priority.netitems.form.IFieldSelectRq} message FieldSelectRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldSelectRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FieldSelectRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FieldSelectRq} FieldSelectRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldSelectRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FieldSelectRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.ColumnID = reader.int64();
                            break;
                        case 4:
                            message.Pattern = reader.string();
                            break;
                        case 5:
                            message.IgnoreCase = reader.bool();
                            break;
                        case 6:
                            message.FromStart = reader.bool();
                            break;
                        case 7:
                            message.Page = reader.int64();
                            break;
                        case 8:
                            message.Preferred = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FieldSelectRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FieldSelectRq} FieldSelectRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldSelectRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FieldSelectRq message.
                 * @function verify
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldSelectRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.ColumnID != null && message.hasOwnProperty("ColumnID"))
                        if (!$util.isInteger(message.ColumnID) && !(message.ColumnID && $util.isInteger(message.ColumnID.low) && $util.isInteger(message.ColumnID.high)))
                            return "ColumnID: integer|Long expected";
                    if (message.Pattern != null && message.hasOwnProperty("Pattern"))
                        if (!$util.isString(message.Pattern))
                            return "Pattern: string expected";
                    if (message.IgnoreCase != null && message.hasOwnProperty("IgnoreCase"))
                        if (typeof message.IgnoreCase !== "boolean")
                            return "IgnoreCase: boolean expected";
                    if (message.FromStart != null && message.hasOwnProperty("FromStart"))
                        if (typeof message.FromStart !== "boolean")
                            return "FromStart: boolean expected";
                    if (message.Page != null && message.hasOwnProperty("Page"))
                        if (!$util.isInteger(message.Page) && !(message.Page && $util.isInteger(message.Page.low) && $util.isInteger(message.Page.high)))
                            return "Page: integer|Long expected";
                    if (message.Preferred != null && message.hasOwnProperty("Preferred"))
                        switch (message.Preferred) {
                        default:
                            return "Preferred: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a FieldSelectRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FieldSelectRq} FieldSelectRq
                 */
                FieldSelectRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FieldSelectRq)
                        return object;
                    var message = new $root.priority.netitems.form.FieldSelectRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.FieldSelectRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.ColumnID != null)
                        if ($util.Long)
                            (message.ColumnID = $util.Long.fromValue(object.ColumnID)).unsigned = false;
                        else if (typeof object.ColumnID === "string")
                            message.ColumnID = parseInt(object.ColumnID, 10);
                        else if (typeof object.ColumnID === "number")
                            message.ColumnID = object.ColumnID;
                        else if (typeof object.ColumnID === "object")
                            message.ColumnID = new $util.LongBits(object.ColumnID.low >>> 0, object.ColumnID.high >>> 0).toNumber();
                    if (object.Pattern != null)
                        message.Pattern = String(object.Pattern);
                    if (object.IgnoreCase != null)
                        message.IgnoreCase = Boolean(object.IgnoreCase);
                    if (object.FromStart != null)
                        message.FromStart = Boolean(object.FromStart);
                    if (object.Page != null)
                        if ($util.Long)
                            (message.Page = $util.Long.fromValue(object.Page)).unsigned = false;
                        else if (typeof object.Page === "string")
                            message.Page = parseInt(object.Page, 10);
                        else if (typeof object.Page === "number")
                            message.Page = object.Page;
                        else if (typeof object.Page === "object")
                            message.Page = new $util.LongBits(object.Page.low >>> 0, object.Page.high >>> 0).toNumber();
                    switch (object.Preferred) {
                    case "Choose":
                    case 0:
                        message.Preferred = 0;
                        break;
                    case "SearchDes":
                    case 1:
                        message.Preferred = 1;
                        break;
                    case "SearchName":
                    case 2:
                        message.Preferred = 2;
                        break;
                    case "SearchEdes":
                    case 3:
                        message.Preferred = 3;
                        break;
                    case "SearchAll":
                    case 4:
                        message.Preferred = 4;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FieldSelectRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @static
                 * @param {priority.netitems.form.FieldSelectRq} message FieldSelectRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldSelectRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ColumnID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ColumnID = options.longs === String ? "0" : 0;
                        object.Pattern = "";
                        object.IgnoreCase = false;
                        object.FromStart = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Page = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Page = options.longs === String ? "0" : 0;
                        object.Preferred = options.enums === String ? "Choose" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.ColumnID != null && message.hasOwnProperty("ColumnID"))
                        if (typeof message.ColumnID === "number")
                            object.ColumnID = options.longs === String ? String(message.ColumnID) : message.ColumnID;
                        else
                            object.ColumnID = options.longs === String ? $util.Long.prototype.toString.call(message.ColumnID) : options.longs === Number ? new $util.LongBits(message.ColumnID.low >>> 0, message.ColumnID.high >>> 0).toNumber() : message.ColumnID;
                    if (message.Pattern != null && message.hasOwnProperty("Pattern"))
                        object.Pattern = message.Pattern;
                    if (message.IgnoreCase != null && message.hasOwnProperty("IgnoreCase"))
                        object.IgnoreCase = message.IgnoreCase;
                    if (message.FromStart != null && message.hasOwnProperty("FromStart"))
                        object.FromStart = message.FromStart;
                    if (message.Page != null && message.hasOwnProperty("Page"))
                        if (typeof message.Page === "number")
                            object.Page = options.longs === String ? String(message.Page) : message.Page;
                        else
                            object.Page = options.longs === String ? $util.Long.prototype.toString.call(message.Page) : options.longs === Number ? new $util.LongBits(message.Page.low >>> 0, message.Page.high >>> 0).toNumber() : message.Page;
                    if (message.Preferred != null && message.hasOwnProperty("Preferred"))
                        object.Preferred = options.enums === String ? $root.priority.netitems.shared.FieldSelectType[message.Preferred] : message.Preferred;
                    return object;
                };

                /**
                 * Converts this FieldSelectRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FieldSelectRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldSelectRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FieldSelectRq;
            })();

            form.FieldSelectRs = (function() {

                /**
                 * Properties of a FieldSelectRs.
                 * @memberof priority.netitems.form
                 * @interface IFieldSelectRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] FieldSelectRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] FieldSelectRs Messages
                 * @property {priority.netitems.shared.FieldSelectType|null} [Type] FieldSelectRs Type
                 * @property {boolean|null} [Multi] FieldSelectRs Multi
                 * @property {Array.<priority.netitems.form.ISelectValues>|null} [Values] FieldSelectRs Values
                 * @property {boolean|null} [HaveMore] FieldSelectRs HaveMore
                 */

                /**
                 * Constructs a new FieldSelectRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a FieldSelectRs.
                 * @implements IFieldSelectRs
                 * @constructor
                 * @param {priority.netitems.form.IFieldSelectRs=} [properties] Properties to set
                 */
                function FieldSelectRs(properties) {
                    this.Messages = [];
                    this.Values = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FieldSelectRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @instance
                 */
                FieldSelectRs.prototype.Perf = null;

                /**
                 * FieldSelectRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @instance
                 */
                FieldSelectRs.prototype.Messages = $util.emptyArray;

                /**
                 * FieldSelectRs Type.
                 * @member {priority.netitems.shared.FieldSelectType} Type
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @instance
                 */
                FieldSelectRs.prototype.Type = 0;

                /**
                 * FieldSelectRs Multi.
                 * @member {boolean} Multi
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @instance
                 */
                FieldSelectRs.prototype.Multi = false;

                /**
                 * FieldSelectRs Values.
                 * @member {Array.<priority.netitems.form.ISelectValues>} Values
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @instance
                 */
                FieldSelectRs.prototype.Values = $util.emptyArray;

                /**
                 * FieldSelectRs HaveMore.
                 * @member {boolean} HaveMore
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @instance
                 */
                FieldSelectRs.prototype.HaveMore = false;

                /**
                 * Creates a new FieldSelectRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @static
                 * @param {priority.netitems.form.IFieldSelectRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.FieldSelectRs} FieldSelectRs instance
                 */
                FieldSelectRs.create = function create(properties) {
                    return new FieldSelectRs(properties);
                };

                /**
                 * Encodes the specified FieldSelectRs message. Does not implicitly {@link priority.netitems.form.FieldSelectRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @static
                 * @param {priority.netitems.form.IFieldSelectRs} message FieldSelectRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldSelectRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Type);
                    if (message.Multi != null && Object.hasOwnProperty.call(message, "Multi"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Multi);
                    if (message.Values != null && message.Values.length)
                        for (var i = 0; i < message.Values.length; ++i)
                            $root.priority.netitems.form.SelectValues.encode(message.Values[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.HaveMore != null && Object.hasOwnProperty.call(message, "HaveMore"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.HaveMore);
                    return writer;
                };

                /**
                 * Encodes the specified FieldSelectRs message, length delimited. Does not implicitly {@link priority.netitems.form.FieldSelectRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @static
                 * @param {priority.netitems.form.IFieldSelectRs} message FieldSelectRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldSelectRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FieldSelectRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.FieldSelectRs} FieldSelectRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldSelectRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.FieldSelectRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Type = reader.int32();
                            break;
                        case 4:
                            message.Multi = reader.bool();
                            break;
                        case 5:
                            if (!(message.Values && message.Values.length))
                                message.Values = [];
                            message.Values.push($root.priority.netitems.form.SelectValues.decode(reader, reader.uint32()));
                            break;
                        case 6:
                            message.HaveMore = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FieldSelectRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.FieldSelectRs} FieldSelectRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldSelectRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FieldSelectRs message.
                 * @function verify
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldSelectRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        switch (message.Type) {
                        default:
                            return "Type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.Multi != null && message.hasOwnProperty("Multi"))
                        if (typeof message.Multi !== "boolean")
                            return "Multi: boolean expected";
                    if (message.Values != null && message.hasOwnProperty("Values")) {
                        if (!Array.isArray(message.Values))
                            return "Values: array expected";
                        for (var i = 0; i < message.Values.length; ++i) {
                            var error = $root.priority.netitems.form.SelectValues.verify(message.Values[i]);
                            if (error)
                                return "Values." + error;
                        }
                    }
                    if (message.HaveMore != null && message.hasOwnProperty("HaveMore"))
                        if (typeof message.HaveMore !== "boolean")
                            return "HaveMore: boolean expected";
                    return null;
                };

                /**
                 * Creates a FieldSelectRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.FieldSelectRs} FieldSelectRs
                 */
                FieldSelectRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.FieldSelectRs)
                        return object;
                    var message = new $root.priority.netitems.form.FieldSelectRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.FieldSelectRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.FieldSelectRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.FieldSelectRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    switch (object.Type) {
                    case "Choose":
                    case 0:
                        message.Type = 0;
                        break;
                    case "SearchDes":
                    case 1:
                        message.Type = 1;
                        break;
                    case "SearchName":
                    case 2:
                        message.Type = 2;
                        break;
                    case "SearchEdes":
                    case 3:
                        message.Type = 3;
                        break;
                    case "SearchAll":
                    case 4:
                        message.Type = 4;
                        break;
                    }
                    if (object.Multi != null)
                        message.Multi = Boolean(object.Multi);
                    if (object.Values) {
                        if (!Array.isArray(object.Values))
                            throw TypeError(".priority.netitems.form.FieldSelectRs.Values: array expected");
                        message.Values = [];
                        for (var i = 0; i < object.Values.length; ++i) {
                            if (typeof object.Values[i] !== "object")
                                throw TypeError(".priority.netitems.form.FieldSelectRs.Values: object expected");
                            message.Values[i] = $root.priority.netitems.form.SelectValues.fromObject(object.Values[i]);
                        }
                    }
                    if (object.HaveMore != null)
                        message.HaveMore = Boolean(object.HaveMore);
                    return message;
                };

                /**
                 * Creates a plain object from a FieldSelectRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @static
                 * @param {priority.netitems.form.FieldSelectRs} message FieldSelectRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldSelectRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.Values = [];
                    }
                    if (options.defaults) {
                        object.Perf = null;
                        object.Type = options.enums === String ? "Choose" : 0;
                        object.Multi = false;
                        object.HaveMore = false;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        object.Type = options.enums === String ? $root.priority.netitems.shared.FieldSelectType[message.Type] : message.Type;
                    if (message.Multi != null && message.hasOwnProperty("Multi"))
                        object.Multi = message.Multi;
                    if (message.Values && message.Values.length) {
                        object.Values = [];
                        for (var j = 0; j < message.Values.length; ++j)
                            object.Values[j] = $root.priority.netitems.form.SelectValues.toObject(message.Values[j], options);
                    }
                    if (message.HaveMore != null && message.hasOwnProperty("HaveMore"))
                        object.HaveMore = message.HaveMore;
                    return object;
                };

                /**
                 * Converts this FieldSelectRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.FieldSelectRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldSelectRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FieldSelectRs;
            })();

            form.BatchRq = (function() {

                /**
                 * Properties of a BatchRq.
                 * @memberof priority.netitems.form
                 * @interface IBatchRq
                 * @property {string|null} [Tabulaini] BatchRq Tabulaini
                 * @property {Array.<priority.netitems.form.IGrpc2Net>|null} [Tasks] BatchRq Tasks
                 */

                /**
                 * Constructs a new BatchRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a BatchRq.
                 * @implements IBatchRq
                 * @constructor
                 * @param {priority.netitems.form.IBatchRq=} [properties] Properties to set
                 */
                function BatchRq(properties) {
                    this.Tasks = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BatchRq Tabulaini.
                 * @member {string} Tabulaini
                 * @memberof priority.netitems.form.BatchRq
                 * @instance
                 */
                BatchRq.prototype.Tabulaini = "";

                /**
                 * BatchRq Tasks.
                 * @member {Array.<priority.netitems.form.IGrpc2Net>} Tasks
                 * @memberof priority.netitems.form.BatchRq
                 * @instance
                 */
                BatchRq.prototype.Tasks = $util.emptyArray;

                /**
                 * Creates a new BatchRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.BatchRq
                 * @static
                 * @param {priority.netitems.form.IBatchRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.BatchRq} BatchRq instance
                 */
                BatchRq.create = function create(properties) {
                    return new BatchRq(properties);
                };

                /**
                 * Encodes the specified BatchRq message. Does not implicitly {@link priority.netitems.form.BatchRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.BatchRq
                 * @static
                 * @param {priority.netitems.form.IBatchRq} message BatchRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BatchRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Tabulaini != null && Object.hasOwnProperty.call(message, "Tabulaini"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Tabulaini);
                    if (message.Tasks != null && message.Tasks.length)
                        for (var i = 0; i < message.Tasks.length; ++i)
                            $root.priority.netitems.form.Grpc2Net.encode(message.Tasks[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BatchRq message, length delimited. Does not implicitly {@link priority.netitems.form.BatchRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.BatchRq
                 * @static
                 * @param {priority.netitems.form.IBatchRq} message BatchRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BatchRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BatchRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.BatchRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.BatchRq} BatchRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BatchRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.BatchRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Tabulaini = reader.string();
                            break;
                        case 2:
                            if (!(message.Tasks && message.Tasks.length))
                                message.Tasks = [];
                            message.Tasks.push($root.priority.netitems.form.Grpc2Net.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BatchRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.BatchRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.BatchRq} BatchRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BatchRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BatchRq message.
                 * @function verify
                 * @memberof priority.netitems.form.BatchRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BatchRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Tabulaini != null && message.hasOwnProperty("Tabulaini"))
                        if (!$util.isString(message.Tabulaini))
                            return "Tabulaini: string expected";
                    if (message.Tasks != null && message.hasOwnProperty("Tasks")) {
                        if (!Array.isArray(message.Tasks))
                            return "Tasks: array expected";
                        for (var i = 0; i < message.Tasks.length; ++i) {
                            var error = $root.priority.netitems.form.Grpc2Net.verify(message.Tasks[i]);
                            if (error)
                                return "Tasks." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BatchRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.BatchRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.BatchRq} BatchRq
                 */
                BatchRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.BatchRq)
                        return object;
                    var message = new $root.priority.netitems.form.BatchRq();
                    if (object.Tabulaini != null)
                        message.Tabulaini = String(object.Tabulaini);
                    if (object.Tasks) {
                        if (!Array.isArray(object.Tasks))
                            throw TypeError(".priority.netitems.form.BatchRq.Tasks: array expected");
                        message.Tasks = [];
                        for (var i = 0; i < object.Tasks.length; ++i) {
                            if (typeof object.Tasks[i] !== "object")
                                throw TypeError(".priority.netitems.form.BatchRq.Tasks: object expected");
                            message.Tasks[i] = $root.priority.netitems.form.Grpc2Net.fromObject(object.Tasks[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BatchRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.BatchRq
                 * @static
                 * @param {priority.netitems.form.BatchRq} message BatchRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BatchRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Tasks = [];
                    if (options.defaults)
                        object.Tabulaini = "";
                    if (message.Tabulaini != null && message.hasOwnProperty("Tabulaini"))
                        object.Tabulaini = message.Tabulaini;
                    if (message.Tasks && message.Tasks.length) {
                        object.Tasks = [];
                        for (var j = 0; j < message.Tasks.length; ++j)
                            object.Tasks[j] = $root.priority.netitems.form.Grpc2Net.toObject(message.Tasks[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this BatchRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.BatchRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BatchRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BatchRq;
            })();

            form.BatchRs = (function() {

                /**
                 * Properties of a BatchRs.
                 * @memberof priority.netitems.form
                 * @interface IBatchRs
                 * @property {Array.<priority.netitems.form.INet2Grpc>|null} [Tasks] BatchRs Tasks
                 */

                /**
                 * Constructs a new BatchRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a BatchRs.
                 * @implements IBatchRs
                 * @constructor
                 * @param {priority.netitems.form.IBatchRs=} [properties] Properties to set
                 */
                function BatchRs(properties) {
                    this.Tasks = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BatchRs Tasks.
                 * @member {Array.<priority.netitems.form.INet2Grpc>} Tasks
                 * @memberof priority.netitems.form.BatchRs
                 * @instance
                 */
                BatchRs.prototype.Tasks = $util.emptyArray;

                /**
                 * Creates a new BatchRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.BatchRs
                 * @static
                 * @param {priority.netitems.form.IBatchRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.BatchRs} BatchRs instance
                 */
                BatchRs.create = function create(properties) {
                    return new BatchRs(properties);
                };

                /**
                 * Encodes the specified BatchRs message. Does not implicitly {@link priority.netitems.form.BatchRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.BatchRs
                 * @static
                 * @param {priority.netitems.form.IBatchRs} message BatchRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BatchRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Tasks != null && message.Tasks.length)
                        for (var i = 0; i < message.Tasks.length; ++i)
                            $root.priority.netitems.form.Net2Grpc.encode(message.Tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BatchRs message, length delimited. Does not implicitly {@link priority.netitems.form.BatchRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.BatchRs
                 * @static
                 * @param {priority.netitems.form.IBatchRs} message BatchRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BatchRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BatchRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.BatchRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.BatchRs} BatchRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BatchRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.BatchRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Tasks && message.Tasks.length))
                                message.Tasks = [];
                            message.Tasks.push($root.priority.netitems.form.Net2Grpc.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BatchRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.BatchRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.BatchRs} BatchRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BatchRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BatchRs message.
                 * @function verify
                 * @memberof priority.netitems.form.BatchRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BatchRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Tasks != null && message.hasOwnProperty("Tasks")) {
                        if (!Array.isArray(message.Tasks))
                            return "Tasks: array expected";
                        for (var i = 0; i < message.Tasks.length; ++i) {
                            var error = $root.priority.netitems.form.Net2Grpc.verify(message.Tasks[i]);
                            if (error)
                                return "Tasks." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a BatchRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.BatchRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.BatchRs} BatchRs
                 */
                BatchRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.BatchRs)
                        return object;
                    var message = new $root.priority.netitems.form.BatchRs();
                    if (object.Tasks) {
                        if (!Array.isArray(object.Tasks))
                            throw TypeError(".priority.netitems.form.BatchRs.Tasks: array expected");
                        message.Tasks = [];
                        for (var i = 0; i < object.Tasks.length; ++i) {
                            if (typeof object.Tasks[i] !== "object")
                                throw TypeError(".priority.netitems.form.BatchRs.Tasks: object expected");
                            message.Tasks[i] = $root.priority.netitems.form.Net2Grpc.fromObject(object.Tasks[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BatchRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.BatchRs
                 * @static
                 * @param {priority.netitems.form.BatchRs} message BatchRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BatchRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Tasks = [];
                    if (message.Tasks && message.Tasks.length) {
                        object.Tasks = [];
                        for (var j = 0; j < message.Tasks.length; ++j)
                            object.Tasks[j] = $root.priority.netitems.form.Net2Grpc.toObject(message.Tasks[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this BatchRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.BatchRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BatchRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BatchRs;
            })();

            /**
             * Hide enum.
             * @name priority.netitems.form.Hide
             * @enum {number}
             * @property {number} Visible=0 Visible value
             * @property {number} HiddenByDesign=1 HiddenByDesign value
             * @property {number} HiddenByPackage=2 HiddenByPackage value
             */
            form.Hide = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "Visible"] = 0;
                values[valuesById[1] = "HiddenByDesign"] = 1;
                values[valuesById[2] = "HiddenByPackage"] = 2;
                return values;
            })();

            form.TableViewColumnsDesign = (function() {

                /**
                 * Properties of a TableViewColumnsDesign.
                 * @memberof priority.netitems.form
                 * @interface ITableViewColumnsDesign
                 * @property {string|null} [Name] TableViewColumnsDesign Name
                 * @property {string|null} [Title] TableViewColumnsDesign Title
                 * @property {priority.netitems.form.Hide|null} [Hidden] TableViewColumnsDesign Hidden
                 * @property {boolean|null} [Cover] TableViewColumnsDesign Cover
                 * @property {number|Long|null} [PackageId] TableViewColumnsDesign PackageId
                 */

                /**
                 * Constructs a new TableViewColumnsDesign.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a TableViewColumnsDesign.
                 * @implements ITableViewColumnsDesign
                 * @constructor
                 * @param {priority.netitems.form.ITableViewColumnsDesign=} [properties] Properties to set
                 */
                function TableViewColumnsDesign(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TableViewColumnsDesign Name.
                 * @member {string} Name
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @instance
                 */
                TableViewColumnsDesign.prototype.Name = "";

                /**
                 * TableViewColumnsDesign Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @instance
                 */
                TableViewColumnsDesign.prototype.Title = "";

                /**
                 * TableViewColumnsDesign Hidden.
                 * @member {priority.netitems.form.Hide} Hidden
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @instance
                 */
                TableViewColumnsDesign.prototype.Hidden = 0;

                /**
                 * TableViewColumnsDesign Cover.
                 * @member {boolean} Cover
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @instance
                 */
                TableViewColumnsDesign.prototype.Cover = false;

                /**
                 * TableViewColumnsDesign PackageId.
                 * @member {number|Long} PackageId
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @instance
                 */
                TableViewColumnsDesign.prototype.PackageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new TableViewColumnsDesign instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesign=} [properties] Properties to set
                 * @returns {priority.netitems.form.TableViewColumnsDesign} TableViewColumnsDesign instance
                 */
                TableViewColumnsDesign.create = function create(properties) {
                    return new TableViewColumnsDesign(properties);
                };

                /**
                 * Encodes the specified TableViewColumnsDesign message. Does not implicitly {@link priority.netitems.form.TableViewColumnsDesign.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesign} message TableViewColumnsDesign message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TableViewColumnsDesign.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Name);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.Hidden != null && Object.hasOwnProperty.call(message, "Hidden"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Hidden);
                    if (message.Cover != null && Object.hasOwnProperty.call(message, "Cover"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Cover);
                    if (message.PackageId != null && Object.hasOwnProperty.call(message, "PackageId"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.PackageId);
                    return writer;
                };

                /**
                 * Encodes the specified TableViewColumnsDesign message, length delimited. Does not implicitly {@link priority.netitems.form.TableViewColumnsDesign.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesign} message TableViewColumnsDesign message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TableViewColumnsDesign.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TableViewColumnsDesign message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.TableViewColumnsDesign} TableViewColumnsDesign
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TableViewColumnsDesign.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.TableViewColumnsDesign();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Name = reader.string();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.Hidden = reader.int32();
                            break;
                        case 4:
                            message.Cover = reader.bool();
                            break;
                        case 5:
                            message.PackageId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TableViewColumnsDesign message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.TableViewColumnsDesign} TableViewColumnsDesign
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TableViewColumnsDesign.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TableViewColumnsDesign message.
                 * @function verify
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TableViewColumnsDesign.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        switch (message.Hidden) {
                        default:
                            return "Hidden: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.Cover != null && message.hasOwnProperty("Cover"))
                        if (typeof message.Cover !== "boolean")
                            return "Cover: boolean expected";
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (!$util.isInteger(message.PackageId) && !(message.PackageId && $util.isInteger(message.PackageId.low) && $util.isInteger(message.PackageId.high)))
                            return "PackageId: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a TableViewColumnsDesign message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.TableViewColumnsDesign} TableViewColumnsDesign
                 */
                TableViewColumnsDesign.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.TableViewColumnsDesign)
                        return object;
                    var message = new $root.priority.netitems.form.TableViewColumnsDesign();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    switch (object.Hidden) {
                    case "Visible":
                    case 0:
                        message.Hidden = 0;
                        break;
                    case "HiddenByDesign":
                    case 1:
                        message.Hidden = 1;
                        break;
                    case "HiddenByPackage":
                    case 2:
                        message.Hidden = 2;
                        break;
                    }
                    if (object.Cover != null)
                        message.Cover = Boolean(object.Cover);
                    if (object.PackageId != null)
                        if ($util.Long)
                            (message.PackageId = $util.Long.fromValue(object.PackageId)).unsigned = false;
                        else if (typeof object.PackageId === "string")
                            message.PackageId = parseInt(object.PackageId, 10);
                        else if (typeof object.PackageId === "number")
                            message.PackageId = object.PackageId;
                        else if (typeof object.PackageId === "object")
                            message.PackageId = new $util.LongBits(object.PackageId.low >>> 0, object.PackageId.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a TableViewColumnsDesign message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @static
                 * @param {priority.netitems.form.TableViewColumnsDesign} message TableViewColumnsDesign
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TableViewColumnsDesign.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Name = "";
                        object.Title = "";
                        object.Hidden = options.enums === String ? "Visible" : 0;
                        object.Cover = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.PackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.PackageId = options.longs === String ? "0" : 0;
                    }
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        object.Hidden = options.enums === String ? $root.priority.netitems.form.Hide[message.Hidden] : message.Hidden;
                    if (message.Cover != null && message.hasOwnProperty("Cover"))
                        object.Cover = message.Cover;
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (typeof message.PackageId === "number")
                            object.PackageId = options.longs === String ? String(message.PackageId) : message.PackageId;
                        else
                            object.PackageId = options.longs === String ? $util.Long.prototype.toString.call(message.PackageId) : options.longs === Number ? new $util.LongBits(message.PackageId.low >>> 0, message.PackageId.high >>> 0).toNumber() : message.PackageId;
                    return object;
                };

                /**
                 * Converts this TableViewColumnsDesign to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.TableViewColumnsDesign
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TableViewColumnsDesign.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TableViewColumnsDesign;
            })();

            form.TableViewColumnsDesignRq = (function() {

                /**
                 * Properties of a TableViewColumnsDesignRq.
                 * @memberof priority.netitems.form
                 * @interface ITableViewColumnsDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] TableViewColumnsDesignRq Properties
                 * @property {string|null} [MainFormName] TableViewColumnsDesignRq MainFormName
                 * @property {string|null} [FormName] TableViewColumnsDesignRq FormName
                 */

                /**
                 * Constructs a new TableViewColumnsDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a TableViewColumnsDesignRq.
                 * @implements ITableViewColumnsDesignRq
                 * @constructor
                 * @param {priority.netitems.form.ITableViewColumnsDesignRq=} [properties] Properties to set
                 */
                function TableViewColumnsDesignRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TableViewColumnsDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @instance
                 */
                TableViewColumnsDesignRq.prototype.Properties = null;

                /**
                 * TableViewColumnsDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @instance
                 */
                TableViewColumnsDesignRq.prototype.MainFormName = "";

                /**
                 * TableViewColumnsDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @instance
                 */
                TableViewColumnsDesignRq.prototype.FormName = "";

                /**
                 * Creates a new TableViewColumnsDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.TableViewColumnsDesignRq} TableViewColumnsDesignRq instance
                 */
                TableViewColumnsDesignRq.create = function create(properties) {
                    return new TableViewColumnsDesignRq(properties);
                };

                /**
                 * Encodes the specified TableViewColumnsDesignRq message. Does not implicitly {@link priority.netitems.form.TableViewColumnsDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesignRq} message TableViewColumnsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TableViewColumnsDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    return writer;
                };

                /**
                 * Encodes the specified TableViewColumnsDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.TableViewColumnsDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesignRq} message TableViewColumnsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TableViewColumnsDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TableViewColumnsDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.TableViewColumnsDesignRq} TableViewColumnsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TableViewColumnsDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.TableViewColumnsDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TableViewColumnsDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.TableViewColumnsDesignRq} TableViewColumnsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TableViewColumnsDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TableViewColumnsDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TableViewColumnsDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    return null;
                };

                /**
                 * Creates a TableViewColumnsDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.TableViewColumnsDesignRq} TableViewColumnsDesignRq
                 */
                TableViewColumnsDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.TableViewColumnsDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.TableViewColumnsDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.TableViewColumnsDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    return message;
                };

                /**
                 * Creates a plain object from a TableViewColumnsDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.TableViewColumnsDesignRq} message TableViewColumnsDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TableViewColumnsDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    return object;
                };

                /**
                 * Converts this TableViewColumnsDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.TableViewColumnsDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TableViewColumnsDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TableViewColumnsDesignRq;
            })();

            form.TableViewColumnsDesignRs = (function() {

                /**
                 * Properties of a TableViewColumnsDesignRs.
                 * @memberof priority.netitems.form
                 * @interface ITableViewColumnsDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] TableViewColumnsDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] TableViewColumnsDesignRs Messages
                 * @property {Array.<priority.netitems.form.ITableViewColumnsDesign>|null} [ColumnsDesign] TableViewColumnsDesignRs ColumnsDesign
                 */

                /**
                 * Constructs a new TableViewColumnsDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a TableViewColumnsDesignRs.
                 * @implements ITableViewColumnsDesignRs
                 * @constructor
                 * @param {priority.netitems.form.ITableViewColumnsDesignRs=} [properties] Properties to set
                 */
                function TableViewColumnsDesignRs(properties) {
                    this.Messages = [];
                    this.ColumnsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TableViewColumnsDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @instance
                 */
                TableViewColumnsDesignRs.prototype.Perf = null;

                /**
                 * TableViewColumnsDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @instance
                 */
                TableViewColumnsDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * TableViewColumnsDesignRs ColumnsDesign.
                 * @member {Array.<priority.netitems.form.ITableViewColumnsDesign>} ColumnsDesign
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @instance
                 */
                TableViewColumnsDesignRs.prototype.ColumnsDesign = $util.emptyArray;

                /**
                 * Creates a new TableViewColumnsDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.TableViewColumnsDesignRs} TableViewColumnsDesignRs instance
                 */
                TableViewColumnsDesignRs.create = function create(properties) {
                    return new TableViewColumnsDesignRs(properties);
                };

                /**
                 * Encodes the specified TableViewColumnsDesignRs message. Does not implicitly {@link priority.netitems.form.TableViewColumnsDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesignRs} message TableViewColumnsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TableViewColumnsDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ColumnsDesign != null && message.ColumnsDesign.length)
                        for (var i = 0; i < message.ColumnsDesign.length; ++i)
                            $root.priority.netitems.form.TableViewColumnsDesign.encode(message.ColumnsDesign[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified TableViewColumnsDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.TableViewColumnsDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ITableViewColumnsDesignRs} message TableViewColumnsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TableViewColumnsDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TableViewColumnsDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.TableViewColumnsDesignRs} TableViewColumnsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TableViewColumnsDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.TableViewColumnsDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.ColumnsDesign && message.ColumnsDesign.length))
                                message.ColumnsDesign = [];
                            message.ColumnsDesign.push($root.priority.netitems.form.TableViewColumnsDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TableViewColumnsDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.TableViewColumnsDesignRs} TableViewColumnsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TableViewColumnsDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TableViewColumnsDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TableViewColumnsDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.ColumnsDesign != null && message.hasOwnProperty("ColumnsDesign")) {
                        if (!Array.isArray(message.ColumnsDesign))
                            return "ColumnsDesign: array expected";
                        for (var i = 0; i < message.ColumnsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.TableViewColumnsDesign.verify(message.ColumnsDesign[i]);
                            if (error)
                                return "ColumnsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a TableViewColumnsDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.TableViewColumnsDesignRs} TableViewColumnsDesignRs
                 */
                TableViewColumnsDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.TableViewColumnsDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.TableViewColumnsDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.TableViewColumnsDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.TableViewColumnsDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.TableViewColumnsDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.ColumnsDesign) {
                        if (!Array.isArray(object.ColumnsDesign))
                            throw TypeError(".priority.netitems.form.TableViewColumnsDesignRs.ColumnsDesign: array expected");
                        message.ColumnsDesign = [];
                        for (var i = 0; i < object.ColumnsDesign.length; ++i) {
                            if (typeof object.ColumnsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.TableViewColumnsDesignRs.ColumnsDesign: object expected");
                            message.ColumnsDesign[i] = $root.priority.netitems.form.TableViewColumnsDesign.fromObject(object.ColumnsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a TableViewColumnsDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.TableViewColumnsDesignRs} message TableViewColumnsDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TableViewColumnsDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.ColumnsDesign = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.ColumnsDesign && message.ColumnsDesign.length) {
                        object.ColumnsDesign = [];
                        for (var j = 0; j < message.ColumnsDesign.length; ++j)
                            object.ColumnsDesign[j] = $root.priority.netitems.form.TableViewColumnsDesign.toObject(message.ColumnsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this TableViewColumnsDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.TableViewColumnsDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TableViewColumnsDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TableViewColumnsDesignRs;
            })();

            form.SaveTableViewColumnsDesignRq = (function() {

                /**
                 * Properties of a SaveTableViewColumnsDesignRq.
                 * @memberof priority.netitems.form
                 * @interface ISaveTableViewColumnsDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SaveTableViewColumnsDesignRq Properties
                 * @property {string|null} [MainFormName] SaveTableViewColumnsDesignRq MainFormName
                 * @property {string|null} [FormName] SaveTableViewColumnsDesignRq FormName
                 * @property {Array.<priority.netitems.form.ITableViewColumnsDesign>|null} [ColumnsDesign] SaveTableViewColumnsDesignRq ColumnsDesign
                 */

                /**
                 * Constructs a new SaveTableViewColumnsDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SaveTableViewColumnsDesignRq.
                 * @implements ISaveTableViewColumnsDesignRq
                 * @constructor
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRq=} [properties] Properties to set
                 */
                function SaveTableViewColumnsDesignRq(properties) {
                    this.ColumnsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SaveTableViewColumnsDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @instance
                 */
                SaveTableViewColumnsDesignRq.prototype.Properties = null;

                /**
                 * SaveTableViewColumnsDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @instance
                 */
                SaveTableViewColumnsDesignRq.prototype.MainFormName = "";

                /**
                 * SaveTableViewColumnsDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @instance
                 */
                SaveTableViewColumnsDesignRq.prototype.FormName = "";

                /**
                 * SaveTableViewColumnsDesignRq ColumnsDesign.
                 * @member {Array.<priority.netitems.form.ITableViewColumnsDesign>} ColumnsDesign
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @instance
                 */
                SaveTableViewColumnsDesignRq.prototype.ColumnsDesign = $util.emptyArray;

                /**
                 * Creates a new SaveTableViewColumnsDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SaveTableViewColumnsDesignRq} SaveTableViewColumnsDesignRq instance
                 */
                SaveTableViewColumnsDesignRq.create = function create(properties) {
                    return new SaveTableViewColumnsDesignRq(properties);
                };

                /**
                 * Encodes the specified SaveTableViewColumnsDesignRq message. Does not implicitly {@link priority.netitems.form.SaveTableViewColumnsDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRq} message SaveTableViewColumnsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveTableViewColumnsDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    if (message.ColumnsDesign != null && message.ColumnsDesign.length)
                        for (var i = 0; i < message.ColumnsDesign.length; ++i)
                            $root.priority.netitems.form.TableViewColumnsDesign.encode(message.ColumnsDesign[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SaveTableViewColumnsDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.SaveTableViewColumnsDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRq} message SaveTableViewColumnsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveTableViewColumnsDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SaveTableViewColumnsDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SaveTableViewColumnsDesignRq} SaveTableViewColumnsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveTableViewColumnsDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SaveTableViewColumnsDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        case 4:
                            if (!(message.ColumnsDesign && message.ColumnsDesign.length))
                                message.ColumnsDesign = [];
                            message.ColumnsDesign.push($root.priority.netitems.form.TableViewColumnsDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SaveTableViewColumnsDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SaveTableViewColumnsDesignRq} SaveTableViewColumnsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveTableViewColumnsDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SaveTableViewColumnsDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SaveTableViewColumnsDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.ColumnsDesign != null && message.hasOwnProperty("ColumnsDesign")) {
                        if (!Array.isArray(message.ColumnsDesign))
                            return "ColumnsDesign: array expected";
                        for (var i = 0; i < message.ColumnsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.TableViewColumnsDesign.verify(message.ColumnsDesign[i]);
                            if (error)
                                return "ColumnsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SaveTableViewColumnsDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SaveTableViewColumnsDesignRq} SaveTableViewColumnsDesignRq
                 */
                SaveTableViewColumnsDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SaveTableViewColumnsDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.SaveTableViewColumnsDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SaveTableViewColumnsDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    if (object.ColumnsDesign) {
                        if (!Array.isArray(object.ColumnsDesign))
                            throw TypeError(".priority.netitems.form.SaveTableViewColumnsDesignRq.ColumnsDesign: array expected");
                        message.ColumnsDesign = [];
                        for (var i = 0; i < object.ColumnsDesign.length; ++i) {
                            if (typeof object.ColumnsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.SaveTableViewColumnsDesignRq.ColumnsDesign: object expected");
                            message.ColumnsDesign[i] = $root.priority.netitems.form.TableViewColumnsDesign.fromObject(object.ColumnsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SaveTableViewColumnsDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.SaveTableViewColumnsDesignRq} message SaveTableViewColumnsDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SaveTableViewColumnsDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.ColumnsDesign = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.ColumnsDesign && message.ColumnsDesign.length) {
                        object.ColumnsDesign = [];
                        for (var j = 0; j < message.ColumnsDesign.length; ++j)
                            object.ColumnsDesign[j] = $root.priority.netitems.form.TableViewColumnsDesign.toObject(message.ColumnsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SaveTableViewColumnsDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SaveTableViewColumnsDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SaveTableViewColumnsDesignRq;
            })();

            form.SaveTableViewColumnsDesignRs = (function() {

                /**
                 * Properties of a SaveTableViewColumnsDesignRs.
                 * @memberof priority.netitems.form
                 * @interface ISaveTableViewColumnsDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SaveTableViewColumnsDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SaveTableViewColumnsDesignRs Messages
                 */

                /**
                 * Constructs a new SaveTableViewColumnsDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SaveTableViewColumnsDesignRs.
                 * @implements ISaveTableViewColumnsDesignRs
                 * @constructor
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRs=} [properties] Properties to set
                 */
                function SaveTableViewColumnsDesignRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SaveTableViewColumnsDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @instance
                 */
                SaveTableViewColumnsDesignRs.prototype.Perf = null;

                /**
                 * SaveTableViewColumnsDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @instance
                 */
                SaveTableViewColumnsDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new SaveTableViewColumnsDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.SaveTableViewColumnsDesignRs} SaveTableViewColumnsDesignRs instance
                 */
                SaveTableViewColumnsDesignRs.create = function create(properties) {
                    return new SaveTableViewColumnsDesignRs(properties);
                };

                /**
                 * Encodes the specified SaveTableViewColumnsDesignRs message. Does not implicitly {@link priority.netitems.form.SaveTableViewColumnsDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRs} message SaveTableViewColumnsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveTableViewColumnsDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SaveTableViewColumnsDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.SaveTableViewColumnsDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRs} message SaveTableViewColumnsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveTableViewColumnsDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SaveTableViewColumnsDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SaveTableViewColumnsDesignRs} SaveTableViewColumnsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveTableViewColumnsDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SaveTableViewColumnsDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SaveTableViewColumnsDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SaveTableViewColumnsDesignRs} SaveTableViewColumnsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveTableViewColumnsDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SaveTableViewColumnsDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SaveTableViewColumnsDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SaveTableViewColumnsDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SaveTableViewColumnsDesignRs} SaveTableViewColumnsDesignRs
                 */
                SaveTableViewColumnsDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SaveTableViewColumnsDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.SaveTableViewColumnsDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.SaveTableViewColumnsDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.SaveTableViewColumnsDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.SaveTableViewColumnsDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SaveTableViewColumnsDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.SaveTableViewColumnsDesignRs} message SaveTableViewColumnsDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SaveTableViewColumnsDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SaveTableViewColumnsDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SaveTableViewColumnsDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SaveTableViewColumnsDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SaveTableViewColumnsDesignRs;
            })();

            /**
             * Picture enum.
             * @name priority.netitems.form.Picture
             * @enum {number}
             * @property {number} NoPicture=0 NoPicture value
             * @property {number} HiddenPicture=1 HiddenPicture value
             * @property {number} VisiblePicture=2 VisiblePicture value
             */
            form.Picture = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "NoPicture"] = 0;
                values[valuesById[1] = "HiddenPicture"] = 1;
                values[valuesById[2] = "VisiblePicture"] = 2;
                return values;
            })();

            form.RowViewColumnsDesign = (function() {

                /**
                 * Properties of a RowViewColumnsDesign.
                 * @memberof priority.netitems.form
                 * @interface IRowViewColumnsDesign
                 * @property {string|null} [Name] RowViewColumnsDesign Name
                 * @property {string|null} [Title] RowViewColumnsDesign Title
                 * @property {priority.netitems.form.Hide|null} [Hidden] RowViewColumnsDesign Hidden
                 * @property {boolean|null} [Newarea] RowViewColumnsDesign Newarea
                 * @property {boolean|null} [Merge] RowViewColumnsDesign Merge
                 * @property {boolean|null} [Mandatory] RowViewColumnsDesign Mandatory
                 * @property {number|Long|null} [PackageId] RowViewColumnsDesign PackageId
                 */

                /**
                 * Constructs a new RowViewColumnsDesign.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RowViewColumnsDesign.
                 * @implements IRowViewColumnsDesign
                 * @constructor
                 * @param {priority.netitems.form.IRowViewColumnsDesign=} [properties] Properties to set
                 */
                function RowViewColumnsDesign(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RowViewColumnsDesign Name.
                 * @member {string} Name
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @instance
                 */
                RowViewColumnsDesign.prototype.Name = "";

                /**
                 * RowViewColumnsDesign Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @instance
                 */
                RowViewColumnsDesign.prototype.Title = "";

                /**
                 * RowViewColumnsDesign Hidden.
                 * @member {priority.netitems.form.Hide} Hidden
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @instance
                 */
                RowViewColumnsDesign.prototype.Hidden = 0;

                /**
                 * RowViewColumnsDesign Newarea.
                 * @member {boolean} Newarea
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @instance
                 */
                RowViewColumnsDesign.prototype.Newarea = false;

                /**
                 * RowViewColumnsDesign Merge.
                 * @member {boolean} Merge
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @instance
                 */
                RowViewColumnsDesign.prototype.Merge = false;

                /**
                 * RowViewColumnsDesign Mandatory.
                 * @member {boolean} Mandatory
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @instance
                 */
                RowViewColumnsDesign.prototype.Mandatory = false;

                /**
                 * RowViewColumnsDesign PackageId.
                 * @member {number|Long} PackageId
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @instance
                 */
                RowViewColumnsDesign.prototype.PackageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new RowViewColumnsDesign instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesign=} [properties] Properties to set
                 * @returns {priority.netitems.form.RowViewColumnsDesign} RowViewColumnsDesign instance
                 */
                RowViewColumnsDesign.create = function create(properties) {
                    return new RowViewColumnsDesign(properties);
                };

                /**
                 * Encodes the specified RowViewColumnsDesign message. Does not implicitly {@link priority.netitems.form.RowViewColumnsDesign.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesign} message RowViewColumnsDesign message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RowViewColumnsDesign.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
                    if (message.Hidden != null && Object.hasOwnProperty.call(message, "Hidden"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Hidden);
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
                    if (message.Newarea != null && Object.hasOwnProperty.call(message, "Newarea"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Newarea);
                    if (message.Merge != null && Object.hasOwnProperty.call(message, "Merge"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.Merge);
                    if (message.Mandatory != null && Object.hasOwnProperty.call(message, "Mandatory"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.Mandatory);
                    if (message.PackageId != null && Object.hasOwnProperty.call(message, "PackageId"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.PackageId);
                    return writer;
                };

                /**
                 * Encodes the specified RowViewColumnsDesign message, length delimited. Does not implicitly {@link priority.netitems.form.RowViewColumnsDesign.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesign} message RowViewColumnsDesign message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RowViewColumnsDesign.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RowViewColumnsDesign message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RowViewColumnsDesign} RowViewColumnsDesign
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RowViewColumnsDesign.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RowViewColumnsDesign();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 3:
                            message.Name = reader.string();
                            break;
                        case 1:
                            message.Title = reader.string();
                            break;
                        case 2:
                            message.Hidden = reader.int32();
                            break;
                        case 4:
                            message.Newarea = reader.bool();
                            break;
                        case 5:
                            message.Merge = reader.bool();
                            break;
                        case 6:
                            message.Mandatory = reader.bool();
                            break;
                        case 7:
                            message.PackageId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RowViewColumnsDesign message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RowViewColumnsDesign} RowViewColumnsDesign
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RowViewColumnsDesign.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RowViewColumnsDesign message.
                 * @function verify
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RowViewColumnsDesign.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        switch (message.Hidden) {
                        default:
                            return "Hidden: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.Newarea != null && message.hasOwnProperty("Newarea"))
                        if (typeof message.Newarea !== "boolean")
                            return "Newarea: boolean expected";
                    if (message.Merge != null && message.hasOwnProperty("Merge"))
                        if (typeof message.Merge !== "boolean")
                            return "Merge: boolean expected";
                    if (message.Mandatory != null && message.hasOwnProperty("Mandatory"))
                        if (typeof message.Mandatory !== "boolean")
                            return "Mandatory: boolean expected";
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (!$util.isInteger(message.PackageId) && !(message.PackageId && $util.isInteger(message.PackageId.low) && $util.isInteger(message.PackageId.high)))
                            return "PackageId: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a RowViewColumnsDesign message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RowViewColumnsDesign} RowViewColumnsDesign
                 */
                RowViewColumnsDesign.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RowViewColumnsDesign)
                        return object;
                    var message = new $root.priority.netitems.form.RowViewColumnsDesign();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    switch (object.Hidden) {
                    case "Visible":
                    case 0:
                        message.Hidden = 0;
                        break;
                    case "HiddenByDesign":
                    case 1:
                        message.Hidden = 1;
                        break;
                    case "HiddenByPackage":
                    case 2:
                        message.Hidden = 2;
                        break;
                    }
                    if (object.Newarea != null)
                        message.Newarea = Boolean(object.Newarea);
                    if (object.Merge != null)
                        message.Merge = Boolean(object.Merge);
                    if (object.Mandatory != null)
                        message.Mandatory = Boolean(object.Mandatory);
                    if (object.PackageId != null)
                        if ($util.Long)
                            (message.PackageId = $util.Long.fromValue(object.PackageId)).unsigned = false;
                        else if (typeof object.PackageId === "string")
                            message.PackageId = parseInt(object.PackageId, 10);
                        else if (typeof object.PackageId === "number")
                            message.PackageId = object.PackageId;
                        else if (typeof object.PackageId === "object")
                            message.PackageId = new $util.LongBits(object.PackageId.low >>> 0, object.PackageId.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a RowViewColumnsDesign message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @static
                 * @param {priority.netitems.form.RowViewColumnsDesign} message RowViewColumnsDesign
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RowViewColumnsDesign.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Title = "";
                        object.Hidden = options.enums === String ? "Visible" : 0;
                        object.Name = "";
                        object.Newarea = false;
                        object.Merge = false;
                        object.Mandatory = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.PackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.PackageId = options.longs === String ? "0" : 0;
                    }
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        object.Hidden = options.enums === String ? $root.priority.netitems.form.Hide[message.Hidden] : message.Hidden;
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Newarea != null && message.hasOwnProperty("Newarea"))
                        object.Newarea = message.Newarea;
                    if (message.Merge != null && message.hasOwnProperty("Merge"))
                        object.Merge = message.Merge;
                    if (message.Mandatory != null && message.hasOwnProperty("Mandatory"))
                        object.Mandatory = message.Mandatory;
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (typeof message.PackageId === "number")
                            object.PackageId = options.longs === String ? String(message.PackageId) : message.PackageId;
                        else
                            object.PackageId = options.longs === String ? $util.Long.prototype.toString.call(message.PackageId) : options.longs === Number ? new $util.LongBits(message.PackageId.low >>> 0, message.PackageId.high >>> 0).toNumber() : message.PackageId;
                    return object;
                };

                /**
                 * Converts this RowViewColumnsDesign to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RowViewColumnsDesign
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RowViewColumnsDesign.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RowViewColumnsDesign;
            })();

            form.RowViewTabsDesign = (function() {

                /**
                 * Properties of a RowViewTabsDesign.
                 * @memberof priority.netitems.form
                 * @interface IRowViewTabsDesign
                 * @property {string|null} [Title] RowViewTabsDesign Title
                 * @property {priority.netitems.form.Hide|null} [Hidden] RowViewTabsDesign Hidden
                 * @property {boolean|null} [General] RowViewTabsDesign General
                 * @property {boolean|null} [Personal] RowViewTabsDesign Personal
                 * @property {Array.<priority.netitems.form.IRowViewColumnsDesign>|null} [ColumnsDesign] RowViewTabsDesign ColumnsDesign
                 */

                /**
                 * Constructs a new RowViewTabsDesign.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RowViewTabsDesign.
                 * @implements IRowViewTabsDesign
                 * @constructor
                 * @param {priority.netitems.form.IRowViewTabsDesign=} [properties] Properties to set
                 */
                function RowViewTabsDesign(properties) {
                    this.ColumnsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RowViewTabsDesign Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @instance
                 */
                RowViewTabsDesign.prototype.Title = "";

                /**
                 * RowViewTabsDesign Hidden.
                 * @member {priority.netitems.form.Hide} Hidden
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @instance
                 */
                RowViewTabsDesign.prototype.Hidden = 0;

                /**
                 * RowViewTabsDesign General.
                 * @member {boolean} General
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @instance
                 */
                RowViewTabsDesign.prototype.General = false;

                /**
                 * RowViewTabsDesign Personal.
                 * @member {boolean} Personal
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @instance
                 */
                RowViewTabsDesign.prototype.Personal = false;

                /**
                 * RowViewTabsDesign ColumnsDesign.
                 * @member {Array.<priority.netitems.form.IRowViewColumnsDesign>} ColumnsDesign
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @instance
                 */
                RowViewTabsDesign.prototype.ColumnsDesign = $util.emptyArray;

                /**
                 * Creates a new RowViewTabsDesign instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @static
                 * @param {priority.netitems.form.IRowViewTabsDesign=} [properties] Properties to set
                 * @returns {priority.netitems.form.RowViewTabsDesign} RowViewTabsDesign instance
                 */
                RowViewTabsDesign.create = function create(properties) {
                    return new RowViewTabsDesign(properties);
                };

                /**
                 * Encodes the specified RowViewTabsDesign message. Does not implicitly {@link priority.netitems.form.RowViewTabsDesign.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @static
                 * @param {priority.netitems.form.IRowViewTabsDesign} message RowViewTabsDesign message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RowViewTabsDesign.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
                    if (message.Hidden != null && Object.hasOwnProperty.call(message, "Hidden"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Hidden);
                    if (message.General != null && Object.hasOwnProperty.call(message, "General"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.General);
                    if (message.Personal != null && Object.hasOwnProperty.call(message, "Personal"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Personal);
                    if (message.ColumnsDesign != null && message.ColumnsDesign.length)
                        for (var i = 0; i < message.ColumnsDesign.length; ++i)
                            $root.priority.netitems.form.RowViewColumnsDesign.encode(message.ColumnsDesign[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RowViewTabsDesign message, length delimited. Does not implicitly {@link priority.netitems.form.RowViewTabsDesign.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @static
                 * @param {priority.netitems.form.IRowViewTabsDesign} message RowViewTabsDesign message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RowViewTabsDesign.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RowViewTabsDesign message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RowViewTabsDesign} RowViewTabsDesign
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RowViewTabsDesign.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RowViewTabsDesign();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Title = reader.string();
                            break;
                        case 2:
                            message.Hidden = reader.int32();
                            break;
                        case 3:
                            message.General = reader.bool();
                            break;
                        case 4:
                            message.Personal = reader.bool();
                            break;
                        case 5:
                            if (!(message.ColumnsDesign && message.ColumnsDesign.length))
                                message.ColumnsDesign = [];
                            message.ColumnsDesign.push($root.priority.netitems.form.RowViewColumnsDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RowViewTabsDesign message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RowViewTabsDesign} RowViewTabsDesign
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RowViewTabsDesign.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RowViewTabsDesign message.
                 * @function verify
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RowViewTabsDesign.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        switch (message.Hidden) {
                        default:
                            return "Hidden: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.General != null && message.hasOwnProperty("General"))
                        if (typeof message.General !== "boolean")
                            return "General: boolean expected";
                    if (message.Personal != null && message.hasOwnProperty("Personal"))
                        if (typeof message.Personal !== "boolean")
                            return "Personal: boolean expected";
                    if (message.ColumnsDesign != null && message.hasOwnProperty("ColumnsDesign")) {
                        if (!Array.isArray(message.ColumnsDesign))
                            return "ColumnsDesign: array expected";
                        for (var i = 0; i < message.ColumnsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.RowViewColumnsDesign.verify(message.ColumnsDesign[i]);
                            if (error)
                                return "ColumnsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a RowViewTabsDesign message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RowViewTabsDesign} RowViewTabsDesign
                 */
                RowViewTabsDesign.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RowViewTabsDesign)
                        return object;
                    var message = new $root.priority.netitems.form.RowViewTabsDesign();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    switch (object.Hidden) {
                    case "Visible":
                    case 0:
                        message.Hidden = 0;
                        break;
                    case "HiddenByDesign":
                    case 1:
                        message.Hidden = 1;
                        break;
                    case "HiddenByPackage":
                    case 2:
                        message.Hidden = 2;
                        break;
                    }
                    if (object.General != null)
                        message.General = Boolean(object.General);
                    if (object.Personal != null)
                        message.Personal = Boolean(object.Personal);
                    if (object.ColumnsDesign) {
                        if (!Array.isArray(object.ColumnsDesign))
                            throw TypeError(".priority.netitems.form.RowViewTabsDesign.ColumnsDesign: array expected");
                        message.ColumnsDesign = [];
                        for (var i = 0; i < object.ColumnsDesign.length; ++i) {
                            if (typeof object.ColumnsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.RowViewTabsDesign.ColumnsDesign: object expected");
                            message.ColumnsDesign[i] = $root.priority.netitems.form.RowViewColumnsDesign.fromObject(object.ColumnsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RowViewTabsDesign message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @static
                 * @param {priority.netitems.form.RowViewTabsDesign} message RowViewTabsDesign
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RowViewTabsDesign.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.ColumnsDesign = [];
                    if (options.defaults) {
                        object.Title = "";
                        object.Hidden = options.enums === String ? "Visible" : 0;
                        object.General = false;
                        object.Personal = false;
                    }
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        object.Hidden = options.enums === String ? $root.priority.netitems.form.Hide[message.Hidden] : message.Hidden;
                    if (message.General != null && message.hasOwnProperty("General"))
                        object.General = message.General;
                    if (message.Personal != null && message.hasOwnProperty("Personal"))
                        object.Personal = message.Personal;
                    if (message.ColumnsDesign && message.ColumnsDesign.length) {
                        object.ColumnsDesign = [];
                        for (var j = 0; j < message.ColumnsDesign.length; ++j)
                            object.ColumnsDesign[j] = $root.priority.netitems.form.RowViewColumnsDesign.toObject(message.ColumnsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this RowViewTabsDesign to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RowViewTabsDesign
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RowViewTabsDesign.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RowViewTabsDesign;
            })();

            form.RowViewColumnsDesignRq = (function() {

                /**
                 * Properties of a RowViewColumnsDesignRq.
                 * @memberof priority.netitems.form
                 * @interface IRowViewColumnsDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RowViewColumnsDesignRq Properties
                 * @property {string|null} [MainFormName] RowViewColumnsDesignRq MainFormName
                 * @property {string|null} [FormName] RowViewColumnsDesignRq FormName
                 */

                /**
                 * Constructs a new RowViewColumnsDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RowViewColumnsDesignRq.
                 * @implements IRowViewColumnsDesignRq
                 * @constructor
                 * @param {priority.netitems.form.IRowViewColumnsDesignRq=} [properties] Properties to set
                 */
                function RowViewColumnsDesignRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RowViewColumnsDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @instance
                 */
                RowViewColumnsDesignRq.prototype.Properties = null;

                /**
                 * RowViewColumnsDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @instance
                 */
                RowViewColumnsDesignRq.prototype.MainFormName = "";

                /**
                 * RowViewColumnsDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @instance
                 */
                RowViewColumnsDesignRq.prototype.FormName = "";

                /**
                 * Creates a new RowViewColumnsDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RowViewColumnsDesignRq} RowViewColumnsDesignRq instance
                 */
                RowViewColumnsDesignRq.create = function create(properties) {
                    return new RowViewColumnsDesignRq(properties);
                };

                /**
                 * Encodes the specified RowViewColumnsDesignRq message. Does not implicitly {@link priority.netitems.form.RowViewColumnsDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesignRq} message RowViewColumnsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RowViewColumnsDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    return writer;
                };

                /**
                 * Encodes the specified RowViewColumnsDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.RowViewColumnsDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesignRq} message RowViewColumnsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RowViewColumnsDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RowViewColumnsDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RowViewColumnsDesignRq} RowViewColumnsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RowViewColumnsDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RowViewColumnsDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RowViewColumnsDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RowViewColumnsDesignRq} RowViewColumnsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RowViewColumnsDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RowViewColumnsDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RowViewColumnsDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    return null;
                };

                /**
                 * Creates a RowViewColumnsDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RowViewColumnsDesignRq} RowViewColumnsDesignRq
                 */
                RowViewColumnsDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RowViewColumnsDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.RowViewColumnsDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RowViewColumnsDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    return message;
                };

                /**
                 * Creates a plain object from a RowViewColumnsDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.RowViewColumnsDesignRq} message RowViewColumnsDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RowViewColumnsDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    return object;
                };

                /**
                 * Converts this RowViewColumnsDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RowViewColumnsDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RowViewColumnsDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RowViewColumnsDesignRq;
            })();

            form.RowViewColumnsDesignRs = (function() {

                /**
                 * Properties of a RowViewColumnsDesignRs.
                 * @memberof priority.netitems.form
                 * @interface IRowViewColumnsDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RowViewColumnsDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RowViewColumnsDesignRs Messages
                 * @property {priority.netitems.form.Picture|null} [Picture] RowViewColumnsDesignRs Picture
                 * @property {Array.<priority.netitems.form.IRowViewTabsDesign>|null} [TabsDesign] RowViewColumnsDesignRs TabsDesign
                 */

                /**
                 * Constructs a new RowViewColumnsDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RowViewColumnsDesignRs.
                 * @implements IRowViewColumnsDesignRs
                 * @constructor
                 * @param {priority.netitems.form.IRowViewColumnsDesignRs=} [properties] Properties to set
                 */
                function RowViewColumnsDesignRs(properties) {
                    this.Messages = [];
                    this.TabsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RowViewColumnsDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @instance
                 */
                RowViewColumnsDesignRs.prototype.Perf = null;

                /**
                 * RowViewColumnsDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @instance
                 */
                RowViewColumnsDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * RowViewColumnsDesignRs Picture.
                 * @member {priority.netitems.form.Picture} Picture
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @instance
                 */
                RowViewColumnsDesignRs.prototype.Picture = 0;

                /**
                 * RowViewColumnsDesignRs TabsDesign.
                 * @member {Array.<priority.netitems.form.IRowViewTabsDesign>} TabsDesign
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @instance
                 */
                RowViewColumnsDesignRs.prototype.TabsDesign = $util.emptyArray;

                /**
                 * Creates a new RowViewColumnsDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RowViewColumnsDesignRs} RowViewColumnsDesignRs instance
                 */
                RowViewColumnsDesignRs.create = function create(properties) {
                    return new RowViewColumnsDesignRs(properties);
                };

                /**
                 * Encodes the specified RowViewColumnsDesignRs message. Does not implicitly {@link priority.netitems.form.RowViewColumnsDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesignRs} message RowViewColumnsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RowViewColumnsDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Picture != null && Object.hasOwnProperty.call(message, "Picture"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Picture);
                    if (message.TabsDesign != null && message.TabsDesign.length)
                        for (var i = 0; i < message.TabsDesign.length; ++i)
                            $root.priority.netitems.form.RowViewTabsDesign.encode(message.TabsDesign[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified RowViewColumnsDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.RowViewColumnsDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.IRowViewColumnsDesignRs} message RowViewColumnsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RowViewColumnsDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RowViewColumnsDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RowViewColumnsDesignRs} RowViewColumnsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RowViewColumnsDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RowViewColumnsDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Picture = reader.int32();
                            break;
                        case 4:
                            if (!(message.TabsDesign && message.TabsDesign.length))
                                message.TabsDesign = [];
                            message.TabsDesign.push($root.priority.netitems.form.RowViewTabsDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RowViewColumnsDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RowViewColumnsDesignRs} RowViewColumnsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RowViewColumnsDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RowViewColumnsDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RowViewColumnsDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Picture != null && message.hasOwnProperty("Picture"))
                        switch (message.Picture) {
                        default:
                            return "Picture: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.TabsDesign != null && message.hasOwnProperty("TabsDesign")) {
                        if (!Array.isArray(message.TabsDesign))
                            return "TabsDesign: array expected";
                        for (var i = 0; i < message.TabsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.RowViewTabsDesign.verify(message.TabsDesign[i]);
                            if (error)
                                return "TabsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a RowViewColumnsDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RowViewColumnsDesignRs} RowViewColumnsDesignRs
                 */
                RowViewColumnsDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RowViewColumnsDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.RowViewColumnsDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RowViewColumnsDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RowViewColumnsDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RowViewColumnsDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    switch (object.Picture) {
                    case "NoPicture":
                    case 0:
                        message.Picture = 0;
                        break;
                    case "HiddenPicture":
                    case 1:
                        message.Picture = 1;
                        break;
                    case "VisiblePicture":
                    case 2:
                        message.Picture = 2;
                        break;
                    }
                    if (object.TabsDesign) {
                        if (!Array.isArray(object.TabsDesign))
                            throw TypeError(".priority.netitems.form.RowViewColumnsDesignRs.TabsDesign: array expected");
                        message.TabsDesign = [];
                        for (var i = 0; i < object.TabsDesign.length; ++i) {
                            if (typeof object.TabsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.RowViewColumnsDesignRs.TabsDesign: object expected");
                            message.TabsDesign[i] = $root.priority.netitems.form.RowViewTabsDesign.fromObject(object.TabsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RowViewColumnsDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.RowViewColumnsDesignRs} message RowViewColumnsDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RowViewColumnsDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.TabsDesign = [];
                    }
                    if (options.defaults) {
                        object.Perf = null;
                        object.Picture = options.enums === String ? "NoPicture" : 0;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Picture != null && message.hasOwnProperty("Picture"))
                        object.Picture = options.enums === String ? $root.priority.netitems.form.Picture[message.Picture] : message.Picture;
                    if (message.TabsDesign && message.TabsDesign.length) {
                        object.TabsDesign = [];
                        for (var j = 0; j < message.TabsDesign.length; ++j)
                            object.TabsDesign[j] = $root.priority.netitems.form.RowViewTabsDesign.toObject(message.TabsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this RowViewColumnsDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RowViewColumnsDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RowViewColumnsDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RowViewColumnsDesignRs;
            })();

            form.SaveRowViewColumnsDesignRq = (function() {

                /**
                 * Properties of a SaveRowViewColumnsDesignRq.
                 * @memberof priority.netitems.form
                 * @interface ISaveRowViewColumnsDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SaveRowViewColumnsDesignRq Properties
                 * @property {string|null} [MainFormName] SaveRowViewColumnsDesignRq MainFormName
                 * @property {string|null} [FormName] SaveRowViewColumnsDesignRq FormName
                 * @property {priority.netitems.form.Picture|null} [Picture] SaveRowViewColumnsDesignRq Picture
                 * @property {Array.<priority.netitems.form.IRowViewTabsDesign>|null} [TabsDesign] SaveRowViewColumnsDesignRq TabsDesign
                 */

                /**
                 * Constructs a new SaveRowViewColumnsDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SaveRowViewColumnsDesignRq.
                 * @implements ISaveRowViewColumnsDesignRq
                 * @constructor
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRq=} [properties] Properties to set
                 */
                function SaveRowViewColumnsDesignRq(properties) {
                    this.TabsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SaveRowViewColumnsDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @instance
                 */
                SaveRowViewColumnsDesignRq.prototype.Properties = null;

                /**
                 * SaveRowViewColumnsDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @instance
                 */
                SaveRowViewColumnsDesignRq.prototype.MainFormName = "";

                /**
                 * SaveRowViewColumnsDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @instance
                 */
                SaveRowViewColumnsDesignRq.prototype.FormName = "";

                /**
                 * SaveRowViewColumnsDesignRq Picture.
                 * @member {priority.netitems.form.Picture} Picture
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @instance
                 */
                SaveRowViewColumnsDesignRq.prototype.Picture = 0;

                /**
                 * SaveRowViewColumnsDesignRq TabsDesign.
                 * @member {Array.<priority.netitems.form.IRowViewTabsDesign>} TabsDesign
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @instance
                 */
                SaveRowViewColumnsDesignRq.prototype.TabsDesign = $util.emptyArray;

                /**
                 * Creates a new SaveRowViewColumnsDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SaveRowViewColumnsDesignRq} SaveRowViewColumnsDesignRq instance
                 */
                SaveRowViewColumnsDesignRq.create = function create(properties) {
                    return new SaveRowViewColumnsDesignRq(properties);
                };

                /**
                 * Encodes the specified SaveRowViewColumnsDesignRq message. Does not implicitly {@link priority.netitems.form.SaveRowViewColumnsDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRq} message SaveRowViewColumnsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveRowViewColumnsDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    if (message.Picture != null && Object.hasOwnProperty.call(message, "Picture"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Picture);
                    if (message.TabsDesign != null && message.TabsDesign.length)
                        for (var i = 0; i < message.TabsDesign.length; ++i)
                            $root.priority.netitems.form.RowViewTabsDesign.encode(message.TabsDesign[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SaveRowViewColumnsDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.SaveRowViewColumnsDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRq} message SaveRowViewColumnsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveRowViewColumnsDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SaveRowViewColumnsDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SaveRowViewColumnsDesignRq} SaveRowViewColumnsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveRowViewColumnsDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SaveRowViewColumnsDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        case 4:
                            message.Picture = reader.int32();
                            break;
                        case 5:
                            if (!(message.TabsDesign && message.TabsDesign.length))
                                message.TabsDesign = [];
                            message.TabsDesign.push($root.priority.netitems.form.RowViewTabsDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SaveRowViewColumnsDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SaveRowViewColumnsDesignRq} SaveRowViewColumnsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveRowViewColumnsDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SaveRowViewColumnsDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SaveRowViewColumnsDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.Picture != null && message.hasOwnProperty("Picture"))
                        switch (message.Picture) {
                        default:
                            return "Picture: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.TabsDesign != null && message.hasOwnProperty("TabsDesign")) {
                        if (!Array.isArray(message.TabsDesign))
                            return "TabsDesign: array expected";
                        for (var i = 0; i < message.TabsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.RowViewTabsDesign.verify(message.TabsDesign[i]);
                            if (error)
                                return "TabsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SaveRowViewColumnsDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SaveRowViewColumnsDesignRq} SaveRowViewColumnsDesignRq
                 */
                SaveRowViewColumnsDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SaveRowViewColumnsDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.SaveRowViewColumnsDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SaveRowViewColumnsDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    switch (object.Picture) {
                    case "NoPicture":
                    case 0:
                        message.Picture = 0;
                        break;
                    case "HiddenPicture":
                    case 1:
                        message.Picture = 1;
                        break;
                    case "VisiblePicture":
                    case 2:
                        message.Picture = 2;
                        break;
                    }
                    if (object.TabsDesign) {
                        if (!Array.isArray(object.TabsDesign))
                            throw TypeError(".priority.netitems.form.SaveRowViewColumnsDesignRq.TabsDesign: array expected");
                        message.TabsDesign = [];
                        for (var i = 0; i < object.TabsDesign.length; ++i) {
                            if (typeof object.TabsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.SaveRowViewColumnsDesignRq.TabsDesign: object expected");
                            message.TabsDesign[i] = $root.priority.netitems.form.RowViewTabsDesign.fromObject(object.TabsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SaveRowViewColumnsDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @static
                 * @param {priority.netitems.form.SaveRowViewColumnsDesignRq} message SaveRowViewColumnsDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SaveRowViewColumnsDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.TabsDesign = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                        object.Picture = options.enums === String ? "NoPicture" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.Picture != null && message.hasOwnProperty("Picture"))
                        object.Picture = options.enums === String ? $root.priority.netitems.form.Picture[message.Picture] : message.Picture;
                    if (message.TabsDesign && message.TabsDesign.length) {
                        object.TabsDesign = [];
                        for (var j = 0; j < message.TabsDesign.length; ++j)
                            object.TabsDesign[j] = $root.priority.netitems.form.RowViewTabsDesign.toObject(message.TabsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SaveRowViewColumnsDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SaveRowViewColumnsDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SaveRowViewColumnsDesignRq;
            })();

            form.SaveRowViewColumnsDesignRs = (function() {

                /**
                 * Properties of a SaveRowViewColumnsDesignRs.
                 * @memberof priority.netitems.form
                 * @interface ISaveRowViewColumnsDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SaveRowViewColumnsDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SaveRowViewColumnsDesignRs Messages
                 */

                /**
                 * Constructs a new SaveRowViewColumnsDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SaveRowViewColumnsDesignRs.
                 * @implements ISaveRowViewColumnsDesignRs
                 * @constructor
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRs=} [properties] Properties to set
                 */
                function SaveRowViewColumnsDesignRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SaveRowViewColumnsDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @instance
                 */
                SaveRowViewColumnsDesignRs.prototype.Perf = null;

                /**
                 * SaveRowViewColumnsDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @instance
                 */
                SaveRowViewColumnsDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new SaveRowViewColumnsDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.SaveRowViewColumnsDesignRs} SaveRowViewColumnsDesignRs instance
                 */
                SaveRowViewColumnsDesignRs.create = function create(properties) {
                    return new SaveRowViewColumnsDesignRs(properties);
                };

                /**
                 * Encodes the specified SaveRowViewColumnsDesignRs message. Does not implicitly {@link priority.netitems.form.SaveRowViewColumnsDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRs} message SaveRowViewColumnsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveRowViewColumnsDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SaveRowViewColumnsDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.SaveRowViewColumnsDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRs} message SaveRowViewColumnsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveRowViewColumnsDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SaveRowViewColumnsDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SaveRowViewColumnsDesignRs} SaveRowViewColumnsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveRowViewColumnsDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SaveRowViewColumnsDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SaveRowViewColumnsDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SaveRowViewColumnsDesignRs} SaveRowViewColumnsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveRowViewColumnsDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SaveRowViewColumnsDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SaveRowViewColumnsDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SaveRowViewColumnsDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SaveRowViewColumnsDesignRs} SaveRowViewColumnsDesignRs
                 */
                SaveRowViewColumnsDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SaveRowViewColumnsDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.SaveRowViewColumnsDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.SaveRowViewColumnsDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.SaveRowViewColumnsDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.SaveRowViewColumnsDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SaveRowViewColumnsDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @static
                 * @param {priority.netitems.form.SaveRowViewColumnsDesignRs} message SaveRowViewColumnsDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SaveRowViewColumnsDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SaveRowViewColumnsDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SaveRowViewColumnsDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SaveRowViewColumnsDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SaveRowViewColumnsDesignRs;
            })();

            /**
             * DesignType enum.
             * @name priority.netitems.form.DesignType
             * @enum {number}
             * @property {number} DoNotRestoreDesign=0 DoNotRestoreDesign value
             * @property {number} TableViewDesign=1 TableViewDesign value
             * @property {number} RowViewDesign=2 RowViewDesign value
             * @property {number} SubformsDesign=3 SubformsDesign value
             * @property {number} ActionsDesign=4 ActionsDesign value
             */
            form.DesignType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "DoNotRestoreDesign"] = 0;
                values[valuesById[1] = "TableViewDesign"] = 1;
                values[valuesById[2] = "RowViewDesign"] = 2;
                values[valuesById[3] = "SubformsDesign"] = 3;
                values[valuesById[4] = "ActionsDesign"] = 4;
                return values;
            })();

            form.RestoreDefaultDesignRq = (function() {

                /**
                 * Properties of a RestoreDefaultDesignRq.
                 * @memberof priority.netitems.form
                 * @interface IRestoreDefaultDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] RestoreDefaultDesignRq Properties
                 * @property {string|null} [MainFormName] RestoreDefaultDesignRq MainFormName
                 * @property {string|null} [FormName] RestoreDefaultDesignRq FormName
                 * @property {priority.netitems.form.DesignType|null} [DesignType] RestoreDefaultDesignRq DesignType
                 */

                /**
                 * Constructs a new RestoreDefaultDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RestoreDefaultDesignRq.
                 * @implements IRestoreDefaultDesignRq
                 * @constructor
                 * @param {priority.netitems.form.IRestoreDefaultDesignRq=} [properties] Properties to set
                 */
                function RestoreDefaultDesignRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RestoreDefaultDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @instance
                 */
                RestoreDefaultDesignRq.prototype.Properties = null;

                /**
                 * RestoreDefaultDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @instance
                 */
                RestoreDefaultDesignRq.prototype.MainFormName = "";

                /**
                 * RestoreDefaultDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @instance
                 */
                RestoreDefaultDesignRq.prototype.FormName = "";

                /**
                 * RestoreDefaultDesignRq DesignType.
                 * @member {priority.netitems.form.DesignType} DesignType
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @instance
                 */
                RestoreDefaultDesignRq.prototype.DesignType = 0;

                /**
                 * Creates a new RestoreDefaultDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @static
                 * @param {priority.netitems.form.IRestoreDefaultDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.RestoreDefaultDesignRq} RestoreDefaultDesignRq instance
                 */
                RestoreDefaultDesignRq.create = function create(properties) {
                    return new RestoreDefaultDesignRq(properties);
                };

                /**
                 * Encodes the specified RestoreDefaultDesignRq message. Does not implicitly {@link priority.netitems.form.RestoreDefaultDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @static
                 * @param {priority.netitems.form.IRestoreDefaultDesignRq} message RestoreDefaultDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RestoreDefaultDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    if (message.DesignType != null && Object.hasOwnProperty.call(message, "DesignType"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.DesignType);
                    return writer;
                };

                /**
                 * Encodes the specified RestoreDefaultDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.RestoreDefaultDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @static
                 * @param {priority.netitems.form.IRestoreDefaultDesignRq} message RestoreDefaultDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RestoreDefaultDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RestoreDefaultDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RestoreDefaultDesignRq} RestoreDefaultDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RestoreDefaultDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RestoreDefaultDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        case 4:
                            message.DesignType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RestoreDefaultDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RestoreDefaultDesignRq} RestoreDefaultDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RestoreDefaultDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RestoreDefaultDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RestoreDefaultDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.DesignType != null && message.hasOwnProperty("DesignType"))
                        switch (message.DesignType) {
                        default:
                            return "DesignType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a RestoreDefaultDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RestoreDefaultDesignRq} RestoreDefaultDesignRq
                 */
                RestoreDefaultDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RestoreDefaultDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.RestoreDefaultDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.RestoreDefaultDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    switch (object.DesignType) {
                    case "DoNotRestoreDesign":
                    case 0:
                        message.DesignType = 0;
                        break;
                    case "TableViewDesign":
                    case 1:
                        message.DesignType = 1;
                        break;
                    case "RowViewDesign":
                    case 2:
                        message.DesignType = 2;
                        break;
                    case "SubformsDesign":
                    case 3:
                        message.DesignType = 3;
                        break;
                    case "ActionsDesign":
                    case 4:
                        message.DesignType = 4;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a RestoreDefaultDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @static
                 * @param {priority.netitems.form.RestoreDefaultDesignRq} message RestoreDefaultDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RestoreDefaultDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                        object.DesignType = options.enums === String ? "DoNotRestoreDesign" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.DesignType != null && message.hasOwnProperty("DesignType"))
                        object.DesignType = options.enums === String ? $root.priority.netitems.form.DesignType[message.DesignType] : message.DesignType;
                    return object;
                };

                /**
                 * Converts this RestoreDefaultDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RestoreDefaultDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RestoreDefaultDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RestoreDefaultDesignRq;
            })();

            form.RestoreDefaultDesignRs = (function() {

                /**
                 * Properties of a RestoreDefaultDesignRs.
                 * @memberof priority.netitems.form
                 * @interface IRestoreDefaultDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] RestoreDefaultDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] RestoreDefaultDesignRs Messages
                 * @property {boolean|null} [ReloadNeeded] RestoreDefaultDesignRs ReloadNeeded
                 */

                /**
                 * Constructs a new RestoreDefaultDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RestoreDefaultDesignRs.
                 * @implements IRestoreDefaultDesignRs
                 * @constructor
                 * @param {priority.netitems.form.IRestoreDefaultDesignRs=} [properties] Properties to set
                 */
                function RestoreDefaultDesignRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RestoreDefaultDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @instance
                 */
                RestoreDefaultDesignRs.prototype.Perf = null;

                /**
                 * RestoreDefaultDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @instance
                 */
                RestoreDefaultDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * RestoreDefaultDesignRs ReloadNeeded.
                 * @member {boolean} ReloadNeeded
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @instance
                 */
                RestoreDefaultDesignRs.prototype.ReloadNeeded = false;

                /**
                 * Creates a new RestoreDefaultDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @static
                 * @param {priority.netitems.form.IRestoreDefaultDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.RestoreDefaultDesignRs} RestoreDefaultDesignRs instance
                 */
                RestoreDefaultDesignRs.create = function create(properties) {
                    return new RestoreDefaultDesignRs(properties);
                };

                /**
                 * Encodes the specified RestoreDefaultDesignRs message. Does not implicitly {@link priority.netitems.form.RestoreDefaultDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @static
                 * @param {priority.netitems.form.IRestoreDefaultDesignRs} message RestoreDefaultDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RestoreDefaultDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ReloadNeeded != null && Object.hasOwnProperty.call(message, "ReloadNeeded"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.ReloadNeeded);
                    return writer;
                };

                /**
                 * Encodes the specified RestoreDefaultDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.RestoreDefaultDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @static
                 * @param {priority.netitems.form.IRestoreDefaultDesignRs} message RestoreDefaultDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RestoreDefaultDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RestoreDefaultDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RestoreDefaultDesignRs} RestoreDefaultDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RestoreDefaultDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RestoreDefaultDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.ReloadNeeded = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RestoreDefaultDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RestoreDefaultDesignRs} RestoreDefaultDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RestoreDefaultDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RestoreDefaultDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RestoreDefaultDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.ReloadNeeded != null && message.hasOwnProperty("ReloadNeeded"))
                        if (typeof message.ReloadNeeded !== "boolean")
                            return "ReloadNeeded: boolean expected";
                    return null;
                };

                /**
                 * Creates a RestoreDefaultDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RestoreDefaultDesignRs} RestoreDefaultDesignRs
                 */
                RestoreDefaultDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RestoreDefaultDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.RestoreDefaultDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.RestoreDefaultDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.RestoreDefaultDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.RestoreDefaultDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.ReloadNeeded != null)
                        message.ReloadNeeded = Boolean(object.ReloadNeeded);
                    return message;
                };

                /**
                 * Creates a plain object from a RestoreDefaultDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @static
                 * @param {priority.netitems.form.RestoreDefaultDesignRs} message RestoreDefaultDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RestoreDefaultDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.ReloadNeeded = false;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.ReloadNeeded != null && message.hasOwnProperty("ReloadNeeded"))
                        object.ReloadNeeded = message.ReloadNeeded;
                    return object;
                };

                /**
                 * Converts this RestoreDefaultDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RestoreDefaultDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RestoreDefaultDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RestoreDefaultDesignRs;
            })();

            form.MenuDesign = (function() {

                /**
                 * Properties of a MenuDesign.
                 * @memberof priority.netitems.form
                 * @interface IMenuDesign
                 * @property {string|null} [Title] MenuDesign Title
                 * @property {string|null} [Name] MenuDesign Name
                 * @property {priority.netitems.form.Hide|null} [Hidden] MenuDesign Hidden
                 * @property {number|Long|null} [PackageId] MenuDesign PackageId
                 * @property {number|Long|null} [Exec] MenuDesign Exec
                 * @property {priority.netitems.form.SubformType|null} [SubformType] MenuDesign SubformType
                 */

                /**
                 * Constructs a new MenuDesign.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a MenuDesign.
                 * @implements IMenuDesign
                 * @constructor
                 * @param {priority.netitems.form.IMenuDesign=} [properties] Properties to set
                 */
                function MenuDesign(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * MenuDesign Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.MenuDesign
                 * @instance
                 */
                MenuDesign.prototype.Title = "";

                /**
                 * MenuDesign Name.
                 * @member {string} Name
                 * @memberof priority.netitems.form.MenuDesign
                 * @instance
                 */
                MenuDesign.prototype.Name = "";

                /**
                 * MenuDesign Hidden.
                 * @member {priority.netitems.form.Hide} Hidden
                 * @memberof priority.netitems.form.MenuDesign
                 * @instance
                 */
                MenuDesign.prototype.Hidden = 0;

                /**
                 * MenuDesign PackageId.
                 * @member {number|Long} PackageId
                 * @memberof priority.netitems.form.MenuDesign
                 * @instance
                 */
                MenuDesign.prototype.PackageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MenuDesign Exec.
                 * @member {number|Long} Exec
                 * @memberof priority.netitems.form.MenuDesign
                 * @instance
                 */
                MenuDesign.prototype.Exec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * MenuDesign SubformType.
                 * @member {priority.netitems.form.SubformType} SubformType
                 * @memberof priority.netitems.form.MenuDesign
                 * @instance
                 */
                MenuDesign.prototype.SubformType = 0;

                /**
                 * Creates a new MenuDesign instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.MenuDesign
                 * @static
                 * @param {priority.netitems.form.IMenuDesign=} [properties] Properties to set
                 * @returns {priority.netitems.form.MenuDesign} MenuDesign instance
                 */
                MenuDesign.create = function create(properties) {
                    return new MenuDesign(properties);
                };

                /**
                 * Encodes the specified MenuDesign message. Does not implicitly {@link priority.netitems.form.MenuDesign.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.MenuDesign
                 * @static
                 * @param {priority.netitems.form.IMenuDesign} message MenuDesign message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuDesign.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
                    if (message.Hidden != null && Object.hasOwnProperty.call(message, "Hidden"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Hidden);
                    if (message.PackageId != null && Object.hasOwnProperty.call(message, "PackageId"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.PackageId);
                    if (message.Exec != null && Object.hasOwnProperty.call(message, "Exec"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Exec);
                    if (message.SubformType != null && Object.hasOwnProperty.call(message, "SubformType"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.SubformType);
                    return writer;
                };

                /**
                 * Encodes the specified MenuDesign message, length delimited. Does not implicitly {@link priority.netitems.form.MenuDesign.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.MenuDesign
                 * @static
                 * @param {priority.netitems.form.IMenuDesign} message MenuDesign message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MenuDesign.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a MenuDesign message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.MenuDesign
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.MenuDesign} MenuDesign
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuDesign.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.MenuDesign();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Title = reader.string();
                            break;
                        case 2:
                            message.Name = reader.string();
                            break;
                        case 3:
                            message.Hidden = reader.int32();
                            break;
                        case 4:
                            message.PackageId = reader.int64();
                            break;
                        case 5:
                            message.Exec = reader.int64();
                            break;
                        case 6:
                            message.SubformType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a MenuDesign message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.MenuDesign
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.MenuDesign} MenuDesign
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MenuDesign.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a MenuDesign message.
                 * @function verify
                 * @memberof priority.netitems.form.MenuDesign
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MenuDesign.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        switch (message.Hidden) {
                        default:
                            return "Hidden: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (!$util.isInteger(message.PackageId) && !(message.PackageId && $util.isInteger(message.PackageId.low) && $util.isInteger(message.PackageId.high)))
                            return "PackageId: integer|Long expected";
                    if (message.Exec != null && message.hasOwnProperty("Exec"))
                        if (!$util.isInteger(message.Exec) && !(message.Exec && $util.isInteger(message.Exec.low) && $util.isInteger(message.Exec.high)))
                            return "Exec: integer|Long expected";
                    if (message.SubformType != null && message.hasOwnProperty("SubformType"))
                        switch (message.SubformType) {
                        default:
                            return "SubformType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a MenuDesign message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.MenuDesign
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.MenuDesign} MenuDesign
                 */
                MenuDesign.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.MenuDesign)
                        return object;
                    var message = new $root.priority.netitems.form.MenuDesign();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    switch (object.Hidden) {
                    case "Visible":
                    case 0:
                        message.Hidden = 0;
                        break;
                    case "HiddenByDesign":
                    case 1:
                        message.Hidden = 1;
                        break;
                    case "HiddenByPackage":
                    case 2:
                        message.Hidden = 2;
                        break;
                    }
                    if (object.PackageId != null)
                        if ($util.Long)
                            (message.PackageId = $util.Long.fromValue(object.PackageId)).unsigned = false;
                        else if (typeof object.PackageId === "string")
                            message.PackageId = parseInt(object.PackageId, 10);
                        else if (typeof object.PackageId === "number")
                            message.PackageId = object.PackageId;
                        else if (typeof object.PackageId === "object")
                            message.PackageId = new $util.LongBits(object.PackageId.low >>> 0, object.PackageId.high >>> 0).toNumber();
                    if (object.Exec != null)
                        if ($util.Long)
                            (message.Exec = $util.Long.fromValue(object.Exec)).unsigned = false;
                        else if (typeof object.Exec === "string")
                            message.Exec = parseInt(object.Exec, 10);
                        else if (typeof object.Exec === "number")
                            message.Exec = object.Exec;
                        else if (typeof object.Exec === "object")
                            message.Exec = new $util.LongBits(object.Exec.low >>> 0, object.Exec.high >>> 0).toNumber();
                    switch (object.SubformType) {
                    case "Regular":
                    case 0:
                        message.SubformType = 0;
                        break;
                    case "InternalDialog":
                    case 1:
                        message.SubformType = 1;
                        break;
                    case "Attachments":
                    case 2:
                        message.SubformType = 2;
                        break;
                    case "StatusLog":
                    case 3:
                        message.SubformType = 3;
                        break;
                    case "ChangeLog":
                    case 4:
                        message.SubformType = 4;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a MenuDesign message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.MenuDesign
                 * @static
                 * @param {priority.netitems.form.MenuDesign} message MenuDesign
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MenuDesign.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Title = "";
                        object.Name = "";
                        object.Hidden = options.enums === String ? "Visible" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.PackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.PackageId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Exec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Exec = options.longs === String ? "0" : 0;
                        object.SubformType = options.enums === String ? "Regular" : 0;
                    }
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        object.Hidden = options.enums === String ? $root.priority.netitems.form.Hide[message.Hidden] : message.Hidden;
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (typeof message.PackageId === "number")
                            object.PackageId = options.longs === String ? String(message.PackageId) : message.PackageId;
                        else
                            object.PackageId = options.longs === String ? $util.Long.prototype.toString.call(message.PackageId) : options.longs === Number ? new $util.LongBits(message.PackageId.low >>> 0, message.PackageId.high >>> 0).toNumber() : message.PackageId;
                    if (message.Exec != null && message.hasOwnProperty("Exec"))
                        if (typeof message.Exec === "number")
                            object.Exec = options.longs === String ? String(message.Exec) : message.Exec;
                        else
                            object.Exec = options.longs === String ? $util.Long.prototype.toString.call(message.Exec) : options.longs === Number ? new $util.LongBits(message.Exec.low >>> 0, message.Exec.high >>> 0).toNumber() : message.Exec;
                    if (message.SubformType != null && message.hasOwnProperty("SubformType"))
                        object.SubformType = options.enums === String ? $root.priority.netitems.form.SubformType[message.SubformType] : message.SubformType;
                    return object;
                };

                /**
                 * Converts this MenuDesign to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.MenuDesign
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MenuDesign.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return MenuDesign;
            })();

            form.SubformsDesignRq = (function() {

                /**
                 * Properties of a SubformsDesignRq.
                 * @memberof priority.netitems.form
                 * @interface ISubformsDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SubformsDesignRq Properties
                 * @property {string|null} [MainFormName] SubformsDesignRq MainFormName
                 * @property {string|null} [FormName] SubformsDesignRq FormName
                 */

                /**
                 * Constructs a new SubformsDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SubformsDesignRq.
                 * @implements ISubformsDesignRq
                 * @constructor
                 * @param {priority.netitems.form.ISubformsDesignRq=} [properties] Properties to set
                 */
                function SubformsDesignRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubformsDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @instance
                 */
                SubformsDesignRq.prototype.Properties = null;

                /**
                 * SubformsDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @instance
                 */
                SubformsDesignRq.prototype.MainFormName = "";

                /**
                 * SubformsDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @instance
                 */
                SubformsDesignRq.prototype.FormName = "";

                /**
                 * Creates a new SubformsDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISubformsDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SubformsDesignRq} SubformsDesignRq instance
                 */
                SubformsDesignRq.create = function create(properties) {
                    return new SubformsDesignRq(properties);
                };

                /**
                 * Encodes the specified SubformsDesignRq message. Does not implicitly {@link priority.netitems.form.SubformsDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISubformsDesignRq} message SubformsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformsDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    return writer;
                };

                /**
                 * Encodes the specified SubformsDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.SubformsDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISubformsDesignRq} message SubformsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformsDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubformsDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SubformsDesignRq} SubformsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformsDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SubformsDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubformsDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SubformsDesignRq} SubformsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformsDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubformsDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubformsDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    return null;
                };

                /**
                 * Creates a SubformsDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SubformsDesignRq} SubformsDesignRq
                 */
                SubformsDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SubformsDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.SubformsDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SubformsDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    return message;
                };

                /**
                 * Creates a plain object from a SubformsDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @static
                 * @param {priority.netitems.form.SubformsDesignRq} message SubformsDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubformsDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    return object;
                };

                /**
                 * Converts this SubformsDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SubformsDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubformsDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SubformsDesignRq;
            })();

            form.SubformsDesignRs = (function() {

                /**
                 * Properties of a SubformsDesignRs.
                 * @memberof priority.netitems.form
                 * @interface ISubformsDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SubformsDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SubformsDesignRs Messages
                 * @property {Array.<priority.netitems.form.IMenuDesign>|null} [SubformsDesign] SubformsDesignRs SubformsDesign
                 */

                /**
                 * Constructs a new SubformsDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SubformsDesignRs.
                 * @implements ISubformsDesignRs
                 * @constructor
                 * @param {priority.netitems.form.ISubformsDesignRs=} [properties] Properties to set
                 */
                function SubformsDesignRs(properties) {
                    this.Messages = [];
                    this.SubformsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SubformsDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @instance
                 */
                SubformsDesignRs.prototype.Perf = null;

                /**
                 * SubformsDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @instance
                 */
                SubformsDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * SubformsDesignRs SubformsDesign.
                 * @member {Array.<priority.netitems.form.IMenuDesign>} SubformsDesign
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @instance
                 */
                SubformsDesignRs.prototype.SubformsDesign = $util.emptyArray;

                /**
                 * Creates a new SubformsDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISubformsDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.SubformsDesignRs} SubformsDesignRs instance
                 */
                SubformsDesignRs.create = function create(properties) {
                    return new SubformsDesignRs(properties);
                };

                /**
                 * Encodes the specified SubformsDesignRs message. Does not implicitly {@link priority.netitems.form.SubformsDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISubformsDesignRs} message SubformsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformsDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.SubformsDesign != null && message.SubformsDesign.length)
                        for (var i = 0; i < message.SubformsDesign.length; ++i)
                            $root.priority.netitems.form.MenuDesign.encode(message.SubformsDesign[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SubformsDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.SubformsDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISubformsDesignRs} message SubformsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SubformsDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SubformsDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SubformsDesignRs} SubformsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformsDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SubformsDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.SubformsDesign && message.SubformsDesign.length))
                                message.SubformsDesign = [];
                            message.SubformsDesign.push($root.priority.netitems.form.MenuDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SubformsDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SubformsDesignRs} SubformsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SubformsDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SubformsDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SubformsDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.SubformsDesign != null && message.hasOwnProperty("SubformsDesign")) {
                        if (!Array.isArray(message.SubformsDesign))
                            return "SubformsDesign: array expected";
                        for (var i = 0; i < message.SubformsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.MenuDesign.verify(message.SubformsDesign[i]);
                            if (error)
                                return "SubformsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SubformsDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SubformsDesignRs} SubformsDesignRs
                 */
                SubformsDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SubformsDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.SubformsDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.SubformsDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.SubformsDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.SubformsDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.SubformsDesign) {
                        if (!Array.isArray(object.SubformsDesign))
                            throw TypeError(".priority.netitems.form.SubformsDesignRs.SubformsDesign: array expected");
                        message.SubformsDesign = [];
                        for (var i = 0; i < object.SubformsDesign.length; ++i) {
                            if (typeof object.SubformsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.SubformsDesignRs.SubformsDesign: object expected");
                            message.SubformsDesign[i] = $root.priority.netitems.form.MenuDesign.fromObject(object.SubformsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SubformsDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @static
                 * @param {priority.netitems.form.SubformsDesignRs} message SubformsDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SubformsDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.SubformsDesign = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.SubformsDesign && message.SubformsDesign.length) {
                        object.SubformsDesign = [];
                        for (var j = 0; j < message.SubformsDesign.length; ++j)
                            object.SubformsDesign[j] = $root.priority.netitems.form.MenuDesign.toObject(message.SubformsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SubformsDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SubformsDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SubformsDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SubformsDesignRs;
            })();

            form.SaveSubformsDesignRq = (function() {

                /**
                 * Properties of a SaveSubformsDesignRq.
                 * @memberof priority.netitems.form
                 * @interface ISaveSubformsDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SaveSubformsDesignRq Properties
                 * @property {string|null} [MainFormName] SaveSubformsDesignRq MainFormName
                 * @property {string|null} [FormName] SaveSubformsDesignRq FormName
                 * @property {Array.<priority.netitems.form.IMenuDesign>|null} [SubformsDesign] SaveSubformsDesignRq SubformsDesign
                 */

                /**
                 * Constructs a new SaveSubformsDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SaveSubformsDesignRq.
                 * @implements ISaveSubformsDesignRq
                 * @constructor
                 * @param {priority.netitems.form.ISaveSubformsDesignRq=} [properties] Properties to set
                 */
                function SaveSubformsDesignRq(properties) {
                    this.SubformsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SaveSubformsDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @instance
                 */
                SaveSubformsDesignRq.prototype.Properties = null;

                /**
                 * SaveSubformsDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @instance
                 */
                SaveSubformsDesignRq.prototype.MainFormName = "";

                /**
                 * SaveSubformsDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @instance
                 */
                SaveSubformsDesignRq.prototype.FormName = "";

                /**
                 * SaveSubformsDesignRq SubformsDesign.
                 * @member {Array.<priority.netitems.form.IMenuDesign>} SubformsDesign
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @instance
                 */
                SaveSubformsDesignRq.prototype.SubformsDesign = $util.emptyArray;

                /**
                 * Creates a new SaveSubformsDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveSubformsDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SaveSubformsDesignRq} SaveSubformsDesignRq instance
                 */
                SaveSubformsDesignRq.create = function create(properties) {
                    return new SaveSubformsDesignRq(properties);
                };

                /**
                 * Encodes the specified SaveSubformsDesignRq message. Does not implicitly {@link priority.netitems.form.SaveSubformsDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveSubformsDesignRq} message SaveSubformsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveSubformsDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    if (message.SubformsDesign != null && message.SubformsDesign.length)
                        for (var i = 0; i < message.SubformsDesign.length; ++i)
                            $root.priority.netitems.form.MenuDesign.encode(message.SubformsDesign[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SaveSubformsDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.SaveSubformsDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveSubformsDesignRq} message SaveSubformsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveSubformsDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SaveSubformsDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SaveSubformsDesignRq} SaveSubformsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveSubformsDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SaveSubformsDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        case 4:
                            if (!(message.SubformsDesign && message.SubformsDesign.length))
                                message.SubformsDesign = [];
                            message.SubformsDesign.push($root.priority.netitems.form.MenuDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SaveSubformsDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SaveSubformsDesignRq} SaveSubformsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveSubformsDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SaveSubformsDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SaveSubformsDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.SubformsDesign != null && message.hasOwnProperty("SubformsDesign")) {
                        if (!Array.isArray(message.SubformsDesign))
                            return "SubformsDesign: array expected";
                        for (var i = 0; i < message.SubformsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.MenuDesign.verify(message.SubformsDesign[i]);
                            if (error)
                                return "SubformsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SaveSubformsDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SaveSubformsDesignRq} SaveSubformsDesignRq
                 */
                SaveSubformsDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SaveSubformsDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.SaveSubformsDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SaveSubformsDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    if (object.SubformsDesign) {
                        if (!Array.isArray(object.SubformsDesign))
                            throw TypeError(".priority.netitems.form.SaveSubformsDesignRq.SubformsDesign: array expected");
                        message.SubformsDesign = [];
                        for (var i = 0; i < object.SubformsDesign.length; ++i) {
                            if (typeof object.SubformsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.SaveSubformsDesignRq.SubformsDesign: object expected");
                            message.SubformsDesign[i] = $root.priority.netitems.form.MenuDesign.fromObject(object.SubformsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SaveSubformsDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @static
                 * @param {priority.netitems.form.SaveSubformsDesignRq} message SaveSubformsDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SaveSubformsDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.SubformsDesign = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.SubformsDesign && message.SubformsDesign.length) {
                        object.SubformsDesign = [];
                        for (var j = 0; j < message.SubformsDesign.length; ++j)
                            object.SubformsDesign[j] = $root.priority.netitems.form.MenuDesign.toObject(message.SubformsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SaveSubformsDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SaveSubformsDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SaveSubformsDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SaveSubformsDesignRq;
            })();

            form.SaveSubformsDesignRs = (function() {

                /**
                 * Properties of a SaveSubformsDesignRs.
                 * @memberof priority.netitems.form
                 * @interface ISaveSubformsDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SaveSubformsDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SaveSubformsDesignRs Messages
                 */

                /**
                 * Constructs a new SaveSubformsDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SaveSubformsDesignRs.
                 * @implements ISaveSubformsDesignRs
                 * @constructor
                 * @param {priority.netitems.form.ISaveSubformsDesignRs=} [properties] Properties to set
                 */
                function SaveSubformsDesignRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SaveSubformsDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @instance
                 */
                SaveSubformsDesignRs.prototype.Perf = null;

                /**
                 * SaveSubformsDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @instance
                 */
                SaveSubformsDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new SaveSubformsDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveSubformsDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.SaveSubformsDesignRs} SaveSubformsDesignRs instance
                 */
                SaveSubformsDesignRs.create = function create(properties) {
                    return new SaveSubformsDesignRs(properties);
                };

                /**
                 * Encodes the specified SaveSubformsDesignRs message. Does not implicitly {@link priority.netitems.form.SaveSubformsDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveSubformsDesignRs} message SaveSubformsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveSubformsDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SaveSubformsDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.SaveSubformsDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveSubformsDesignRs} message SaveSubformsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveSubformsDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SaveSubformsDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SaveSubformsDesignRs} SaveSubformsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveSubformsDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SaveSubformsDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SaveSubformsDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SaveSubformsDesignRs} SaveSubformsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveSubformsDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SaveSubformsDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SaveSubformsDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SaveSubformsDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SaveSubformsDesignRs} SaveSubformsDesignRs
                 */
                SaveSubformsDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SaveSubformsDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.SaveSubformsDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.SaveSubformsDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.SaveSubformsDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.SaveSubformsDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SaveSubformsDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @static
                 * @param {priority.netitems.form.SaveSubformsDesignRs} message SaveSubformsDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SaveSubformsDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SaveSubformsDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SaveSubformsDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SaveSubformsDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SaveSubformsDesignRs;
            })();

            form.ActionsDesignRq = (function() {

                /**
                 * Properties of an ActionsDesignRq.
                 * @memberof priority.netitems.form
                 * @interface IActionsDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ActionsDesignRq Properties
                 * @property {string|null} [MainFormName] ActionsDesignRq MainFormName
                 * @property {string|null} [FormName] ActionsDesignRq FormName
                 */

                /**
                 * Constructs a new ActionsDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ActionsDesignRq.
                 * @implements IActionsDesignRq
                 * @constructor
                 * @param {priority.netitems.form.IActionsDesignRq=} [properties] Properties to set
                 */
                function ActionsDesignRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ActionsDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @instance
                 */
                ActionsDesignRq.prototype.Properties = null;

                /**
                 * ActionsDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @instance
                 */
                ActionsDesignRq.prototype.MainFormName = "";

                /**
                 * ActionsDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @instance
                 */
                ActionsDesignRq.prototype.FormName = "";

                /**
                 * Creates a new ActionsDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @static
                 * @param {priority.netitems.form.IActionsDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.ActionsDesignRq} ActionsDesignRq instance
                 */
                ActionsDesignRq.create = function create(properties) {
                    return new ActionsDesignRq(properties);
                };

                /**
                 * Encodes the specified ActionsDesignRq message. Does not implicitly {@link priority.netitems.form.ActionsDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @static
                 * @param {priority.netitems.form.IActionsDesignRq} message ActionsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionsDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    return writer;
                };

                /**
                 * Encodes the specified ActionsDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.ActionsDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @static
                 * @param {priority.netitems.form.IActionsDesignRq} message ActionsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionsDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ActionsDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ActionsDesignRq} ActionsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionsDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ActionsDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ActionsDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ActionsDesignRq} ActionsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionsDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ActionsDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ActionsDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    return null;
                };

                /**
                 * Creates an ActionsDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ActionsDesignRq} ActionsDesignRq
                 */
                ActionsDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ActionsDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.ActionsDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.ActionsDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    return message;
                };

                /**
                 * Creates a plain object from an ActionsDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @static
                 * @param {priority.netitems.form.ActionsDesignRq} message ActionsDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ActionsDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    return object;
                };

                /**
                 * Converts this ActionsDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ActionsDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ActionsDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ActionsDesignRq;
            })();

            form.ActionsDesignRs = (function() {

                /**
                 * Properties of an ActionsDesignRs.
                 * @memberof priority.netitems.form
                 * @interface IActionsDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] ActionsDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ActionsDesignRs Messages
                 * @property {Array.<priority.netitems.form.IMenuDesign>|null} [ActionsDesign] ActionsDesignRs ActionsDesign
                 */

                /**
                 * Constructs a new ActionsDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ActionsDesignRs.
                 * @implements IActionsDesignRs
                 * @constructor
                 * @param {priority.netitems.form.IActionsDesignRs=} [properties] Properties to set
                 */
                function ActionsDesignRs(properties) {
                    this.Messages = [];
                    this.ActionsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ActionsDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @instance
                 */
                ActionsDesignRs.prototype.Perf = null;

                /**
                 * ActionsDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @instance
                 */
                ActionsDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * ActionsDesignRs ActionsDesign.
                 * @member {Array.<priority.netitems.form.IMenuDesign>} ActionsDesign
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @instance
                 */
                ActionsDesignRs.prototype.ActionsDesign = $util.emptyArray;

                /**
                 * Creates a new ActionsDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @static
                 * @param {priority.netitems.form.IActionsDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.ActionsDesignRs} ActionsDesignRs instance
                 */
                ActionsDesignRs.create = function create(properties) {
                    return new ActionsDesignRs(properties);
                };

                /**
                 * Encodes the specified ActionsDesignRs message. Does not implicitly {@link priority.netitems.form.ActionsDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @static
                 * @param {priority.netitems.form.IActionsDesignRs} message ActionsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionsDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ActionsDesign != null && message.ActionsDesign.length)
                        for (var i = 0; i < message.ActionsDesign.length; ++i)
                            $root.priority.netitems.form.MenuDesign.encode(message.ActionsDesign[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ActionsDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.ActionsDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @static
                 * @param {priority.netitems.form.IActionsDesignRs} message ActionsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ActionsDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ActionsDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ActionsDesignRs} ActionsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionsDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ActionsDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.ActionsDesign && message.ActionsDesign.length))
                                message.ActionsDesign = [];
                            message.ActionsDesign.push($root.priority.netitems.form.MenuDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ActionsDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ActionsDesignRs} ActionsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ActionsDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ActionsDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ActionsDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.ActionsDesign != null && message.hasOwnProperty("ActionsDesign")) {
                        if (!Array.isArray(message.ActionsDesign))
                            return "ActionsDesign: array expected";
                        for (var i = 0; i < message.ActionsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.MenuDesign.verify(message.ActionsDesign[i]);
                            if (error)
                                return "ActionsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an ActionsDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ActionsDesignRs} ActionsDesignRs
                 */
                ActionsDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ActionsDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.ActionsDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.ActionsDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.ActionsDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.ActionsDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.ActionsDesign) {
                        if (!Array.isArray(object.ActionsDesign))
                            throw TypeError(".priority.netitems.form.ActionsDesignRs.ActionsDesign: array expected");
                        message.ActionsDesign = [];
                        for (var i = 0; i < object.ActionsDesign.length; ++i) {
                            if (typeof object.ActionsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.ActionsDesignRs.ActionsDesign: object expected");
                            message.ActionsDesign[i] = $root.priority.netitems.form.MenuDesign.fromObject(object.ActionsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ActionsDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @static
                 * @param {priority.netitems.form.ActionsDesignRs} message ActionsDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ActionsDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.ActionsDesign = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.ActionsDesign && message.ActionsDesign.length) {
                        object.ActionsDesign = [];
                        for (var j = 0; j < message.ActionsDesign.length; ++j)
                            object.ActionsDesign[j] = $root.priority.netitems.form.MenuDesign.toObject(message.ActionsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ActionsDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ActionsDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ActionsDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ActionsDesignRs;
            })();

            form.SaveActionsDesignRq = (function() {

                /**
                 * Properties of a SaveActionsDesignRq.
                 * @memberof priority.netitems.form
                 * @interface ISaveActionsDesignRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SaveActionsDesignRq Properties
                 * @property {string|null} [MainFormName] SaveActionsDesignRq MainFormName
                 * @property {string|null} [FormName] SaveActionsDesignRq FormName
                 * @property {Array.<priority.netitems.form.IMenuDesign>|null} [ActionsDesign] SaveActionsDesignRq ActionsDesign
                 */

                /**
                 * Constructs a new SaveActionsDesignRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SaveActionsDesignRq.
                 * @implements ISaveActionsDesignRq
                 * @constructor
                 * @param {priority.netitems.form.ISaveActionsDesignRq=} [properties] Properties to set
                 */
                function SaveActionsDesignRq(properties) {
                    this.ActionsDesign = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SaveActionsDesignRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @instance
                 */
                SaveActionsDesignRq.prototype.Properties = null;

                /**
                 * SaveActionsDesignRq MainFormName.
                 * @member {string} MainFormName
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @instance
                 */
                SaveActionsDesignRq.prototype.MainFormName = "";

                /**
                 * SaveActionsDesignRq FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @instance
                 */
                SaveActionsDesignRq.prototype.FormName = "";

                /**
                 * SaveActionsDesignRq ActionsDesign.
                 * @member {Array.<priority.netitems.form.IMenuDesign>} ActionsDesign
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @instance
                 */
                SaveActionsDesignRq.prototype.ActionsDesign = $util.emptyArray;

                /**
                 * Creates a new SaveActionsDesignRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveActionsDesignRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.SaveActionsDesignRq} SaveActionsDesignRq instance
                 */
                SaveActionsDesignRq.create = function create(properties) {
                    return new SaveActionsDesignRq(properties);
                };

                /**
                 * Encodes the specified SaveActionsDesignRq message. Does not implicitly {@link priority.netitems.form.SaveActionsDesignRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveActionsDesignRq} message SaveActionsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveActionsDesignRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.MainFormName != null && Object.hasOwnProperty.call(message, "MainFormName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MainFormName);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    if (message.ActionsDesign != null && message.ActionsDesign.length)
                        for (var i = 0; i < message.ActionsDesign.length; ++i)
                            $root.priority.netitems.form.MenuDesign.encode(message.ActionsDesign[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SaveActionsDesignRq message, length delimited. Does not implicitly {@link priority.netitems.form.SaveActionsDesignRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @static
                 * @param {priority.netitems.form.ISaveActionsDesignRq} message SaveActionsDesignRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveActionsDesignRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SaveActionsDesignRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SaveActionsDesignRq} SaveActionsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveActionsDesignRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SaveActionsDesignRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.MainFormName = reader.string();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        case 4:
                            if (!(message.ActionsDesign && message.ActionsDesign.length))
                                message.ActionsDesign = [];
                            message.ActionsDesign.push($root.priority.netitems.form.MenuDesign.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SaveActionsDesignRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SaveActionsDesignRq} SaveActionsDesignRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveActionsDesignRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SaveActionsDesignRq message.
                 * @function verify
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SaveActionsDesignRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        if (!$util.isString(message.MainFormName))
                            return "MainFormName: string expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.ActionsDesign != null && message.hasOwnProperty("ActionsDesign")) {
                        if (!Array.isArray(message.ActionsDesign))
                            return "ActionsDesign: array expected";
                        for (var i = 0; i < message.ActionsDesign.length; ++i) {
                            var error = $root.priority.netitems.form.MenuDesign.verify(message.ActionsDesign[i]);
                            if (error)
                                return "ActionsDesign." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SaveActionsDesignRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SaveActionsDesignRq} SaveActionsDesignRq
                 */
                SaveActionsDesignRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SaveActionsDesignRq)
                        return object;
                    var message = new $root.priority.netitems.form.SaveActionsDesignRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.SaveActionsDesignRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.MainFormName != null)
                        message.MainFormName = String(object.MainFormName);
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    if (object.ActionsDesign) {
                        if (!Array.isArray(object.ActionsDesign))
                            throw TypeError(".priority.netitems.form.SaveActionsDesignRq.ActionsDesign: array expected");
                        message.ActionsDesign = [];
                        for (var i = 0; i < object.ActionsDesign.length; ++i) {
                            if (typeof object.ActionsDesign[i] !== "object")
                                throw TypeError(".priority.netitems.form.SaveActionsDesignRq.ActionsDesign: object expected");
                            message.ActionsDesign[i] = $root.priority.netitems.form.MenuDesign.fromObject(object.ActionsDesign[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SaveActionsDesignRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @static
                 * @param {priority.netitems.form.SaveActionsDesignRq} message SaveActionsDesignRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SaveActionsDesignRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.ActionsDesign = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.MainFormName = "";
                        object.FormName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.MainFormName != null && message.hasOwnProperty("MainFormName"))
                        object.MainFormName = message.MainFormName;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.ActionsDesign && message.ActionsDesign.length) {
                        object.ActionsDesign = [];
                        for (var j = 0; j < message.ActionsDesign.length; ++j)
                            object.ActionsDesign[j] = $root.priority.netitems.form.MenuDesign.toObject(message.ActionsDesign[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SaveActionsDesignRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SaveActionsDesignRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SaveActionsDesignRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SaveActionsDesignRq;
            })();

            form.SaveActionsDesignRs = (function() {

                /**
                 * Properties of a SaveActionsDesignRs.
                 * @memberof priority.netitems.form
                 * @interface ISaveActionsDesignRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SaveActionsDesignRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SaveActionsDesignRs Messages
                 */

                /**
                 * Constructs a new SaveActionsDesignRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SaveActionsDesignRs.
                 * @implements ISaveActionsDesignRs
                 * @constructor
                 * @param {priority.netitems.form.ISaveActionsDesignRs=} [properties] Properties to set
                 */
                function SaveActionsDesignRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SaveActionsDesignRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @instance
                 */
                SaveActionsDesignRs.prototype.Perf = null;

                /**
                 * SaveActionsDesignRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @instance
                 */
                SaveActionsDesignRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new SaveActionsDesignRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveActionsDesignRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.SaveActionsDesignRs} SaveActionsDesignRs instance
                 */
                SaveActionsDesignRs.create = function create(properties) {
                    return new SaveActionsDesignRs(properties);
                };

                /**
                 * Encodes the specified SaveActionsDesignRs message. Does not implicitly {@link priority.netitems.form.SaveActionsDesignRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveActionsDesignRs} message SaveActionsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveActionsDesignRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SaveActionsDesignRs message, length delimited. Does not implicitly {@link priority.netitems.form.SaveActionsDesignRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @static
                 * @param {priority.netitems.form.ISaveActionsDesignRs} message SaveActionsDesignRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SaveActionsDesignRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SaveActionsDesignRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SaveActionsDesignRs} SaveActionsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveActionsDesignRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SaveActionsDesignRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SaveActionsDesignRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SaveActionsDesignRs} SaveActionsDesignRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SaveActionsDesignRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SaveActionsDesignRs message.
                 * @function verify
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SaveActionsDesignRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SaveActionsDesignRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SaveActionsDesignRs} SaveActionsDesignRs
                 */
                SaveActionsDesignRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SaveActionsDesignRs)
                        return object;
                    var message = new $root.priority.netitems.form.SaveActionsDesignRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.SaveActionsDesignRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.SaveActionsDesignRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.SaveActionsDesignRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SaveActionsDesignRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @static
                 * @param {priority.netitems.form.SaveActionsDesignRs} message SaveActionsDesignRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SaveActionsDesignRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SaveActionsDesignRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SaveActionsDesignRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SaveActionsDesignRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SaveActionsDesignRs;
            })();

            form.PreFieldRq = (function() {

                /**
                 * Properties of a PreFieldRq.
                 * @memberof priority.netitems.form
                 * @interface IPreFieldRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] PreFieldRq Properties
                 * @property {string|null} [Session] PreFieldRq Session
                 * @property {number|Long|null} [ColumnId] PreFieldRq ColumnId
                 * @property {Array.<priority.netitems.form.IField>|null} [Keys] PreFieldRq Keys
                 * @property {number|Long|null} [ScrLine] PreFieldRq ScrLine
                 */

                /**
                 * Constructs a new PreFieldRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a PreFieldRq.
                 * @implements IPreFieldRq
                 * @constructor
                 * @param {priority.netitems.form.IPreFieldRq=} [properties] Properties to set
                 */
                function PreFieldRq(properties) {
                    this.Keys = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PreFieldRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.PreFieldRq
                 * @instance
                 */
                PreFieldRq.prototype.Properties = null;

                /**
                 * PreFieldRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.PreFieldRq
                 * @instance
                 */
                PreFieldRq.prototype.Session = "";

                /**
                 * PreFieldRq ColumnId.
                 * @member {number|Long} ColumnId
                 * @memberof priority.netitems.form.PreFieldRq
                 * @instance
                 */
                PreFieldRq.prototype.ColumnId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * PreFieldRq Keys.
                 * @member {Array.<priority.netitems.form.IField>} Keys
                 * @memberof priority.netitems.form.PreFieldRq
                 * @instance
                 */
                PreFieldRq.prototype.Keys = $util.emptyArray;

                /**
                 * PreFieldRq ScrLine.
                 * @member {number|Long} ScrLine
                 * @memberof priority.netitems.form.PreFieldRq
                 * @instance
                 */
                PreFieldRq.prototype.ScrLine = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new PreFieldRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.PreFieldRq
                 * @static
                 * @param {priority.netitems.form.IPreFieldRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.PreFieldRq} PreFieldRq instance
                 */
                PreFieldRq.create = function create(properties) {
                    return new PreFieldRq(properties);
                };

                /**
                 * Encodes the specified PreFieldRq message. Does not implicitly {@link priority.netitems.form.PreFieldRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.PreFieldRq
                 * @static
                 * @param {priority.netitems.form.IPreFieldRq} message PreFieldRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PreFieldRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.ColumnId != null && Object.hasOwnProperty.call(message, "ColumnId"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ColumnId);
                    if (message.Keys != null && message.Keys.length)
                        for (var i = 0; i < message.Keys.length; ++i)
                            $root.priority.netitems.form.Field.encode(message.Keys[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.ScrLine != null && Object.hasOwnProperty.call(message, "ScrLine"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.ScrLine);
                    return writer;
                };

                /**
                 * Encodes the specified PreFieldRq message, length delimited. Does not implicitly {@link priority.netitems.form.PreFieldRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.PreFieldRq
                 * @static
                 * @param {priority.netitems.form.IPreFieldRq} message PreFieldRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PreFieldRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PreFieldRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.PreFieldRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.PreFieldRq} PreFieldRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PreFieldRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.PreFieldRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.ColumnId = reader.int64();
                            break;
                        case 4:
                            if (!(message.Keys && message.Keys.length))
                                message.Keys = [];
                            message.Keys.push($root.priority.netitems.form.Field.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            message.ScrLine = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PreFieldRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.PreFieldRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.PreFieldRq} PreFieldRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PreFieldRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PreFieldRq message.
                 * @function verify
                 * @memberof priority.netitems.form.PreFieldRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PreFieldRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.ColumnId != null && message.hasOwnProperty("ColumnId"))
                        if (!$util.isInteger(message.ColumnId) && !(message.ColumnId && $util.isInteger(message.ColumnId.low) && $util.isInteger(message.ColumnId.high)))
                            return "ColumnId: integer|Long expected";
                    if (message.Keys != null && message.hasOwnProperty("Keys")) {
                        if (!Array.isArray(message.Keys))
                            return "Keys: array expected";
                        for (var i = 0; i < message.Keys.length; ++i) {
                            var error = $root.priority.netitems.form.Field.verify(message.Keys[i]);
                            if (error)
                                return "Keys." + error;
                        }
                    }
                    if (message.ScrLine != null && message.hasOwnProperty("ScrLine"))
                        if (!$util.isInteger(message.ScrLine) && !(message.ScrLine && $util.isInteger(message.ScrLine.low) && $util.isInteger(message.ScrLine.high)))
                            return "ScrLine: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a PreFieldRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.PreFieldRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.PreFieldRq} PreFieldRq
                 */
                PreFieldRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.PreFieldRq)
                        return object;
                    var message = new $root.priority.netitems.form.PreFieldRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.PreFieldRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.ColumnId != null)
                        if ($util.Long)
                            (message.ColumnId = $util.Long.fromValue(object.ColumnId)).unsigned = false;
                        else if (typeof object.ColumnId === "string")
                            message.ColumnId = parseInt(object.ColumnId, 10);
                        else if (typeof object.ColumnId === "number")
                            message.ColumnId = object.ColumnId;
                        else if (typeof object.ColumnId === "object")
                            message.ColumnId = new $util.LongBits(object.ColumnId.low >>> 0, object.ColumnId.high >>> 0).toNumber();
                    if (object.Keys) {
                        if (!Array.isArray(object.Keys))
                            throw TypeError(".priority.netitems.form.PreFieldRq.Keys: array expected");
                        message.Keys = [];
                        for (var i = 0; i < object.Keys.length; ++i) {
                            if (typeof object.Keys[i] !== "object")
                                throw TypeError(".priority.netitems.form.PreFieldRq.Keys: object expected");
                            message.Keys[i] = $root.priority.netitems.form.Field.fromObject(object.Keys[i]);
                        }
                    }
                    if (object.ScrLine != null)
                        if ($util.Long)
                            (message.ScrLine = $util.Long.fromValue(object.ScrLine)).unsigned = false;
                        else if (typeof object.ScrLine === "string")
                            message.ScrLine = parseInt(object.ScrLine, 10);
                        else if (typeof object.ScrLine === "number")
                            message.ScrLine = object.ScrLine;
                        else if (typeof object.ScrLine === "object")
                            message.ScrLine = new $util.LongBits(object.ScrLine.low >>> 0, object.ScrLine.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a PreFieldRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.PreFieldRq
                 * @static
                 * @param {priority.netitems.form.PreFieldRq} message PreFieldRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PreFieldRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Keys = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ColumnId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ColumnId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ScrLine = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ScrLine = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.ColumnId != null && message.hasOwnProperty("ColumnId"))
                        if (typeof message.ColumnId === "number")
                            object.ColumnId = options.longs === String ? String(message.ColumnId) : message.ColumnId;
                        else
                            object.ColumnId = options.longs === String ? $util.Long.prototype.toString.call(message.ColumnId) : options.longs === Number ? new $util.LongBits(message.ColumnId.low >>> 0, message.ColumnId.high >>> 0).toNumber() : message.ColumnId;
                    if (message.Keys && message.Keys.length) {
                        object.Keys = [];
                        for (var j = 0; j < message.Keys.length; ++j)
                            object.Keys[j] = $root.priority.netitems.form.Field.toObject(message.Keys[j], options);
                    }
                    if (message.ScrLine != null && message.hasOwnProperty("ScrLine"))
                        if (typeof message.ScrLine === "number")
                            object.ScrLine = options.longs === String ? String(message.ScrLine) : message.ScrLine;
                        else
                            object.ScrLine = options.longs === String ? $util.Long.prototype.toString.call(message.ScrLine) : options.longs === Number ? new $util.LongBits(message.ScrLine.low >>> 0, message.ScrLine.high >>> 0).toNumber() : message.ScrLine;
                    return object;
                };

                /**
                 * Converts this PreFieldRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.PreFieldRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PreFieldRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PreFieldRq;
            })();

            form.PreFieldRs = (function() {

                /**
                 * Properties of a PreFieldRs.
                 * @memberof priority.netitems.form
                 * @interface IPreFieldRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] PreFieldRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] PreFieldRs Messages
                 * @property {priority.netitems.form.IRecord|null} [Record] PreFieldRs Record
                 */

                /**
                 * Constructs a new PreFieldRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a PreFieldRs.
                 * @implements IPreFieldRs
                 * @constructor
                 * @param {priority.netitems.form.IPreFieldRs=} [properties] Properties to set
                 */
                function PreFieldRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PreFieldRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.PreFieldRs
                 * @instance
                 */
                PreFieldRs.prototype.Perf = null;

                /**
                 * PreFieldRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.PreFieldRs
                 * @instance
                 */
                PreFieldRs.prototype.Messages = $util.emptyArray;

                /**
                 * PreFieldRs Record.
                 * @member {priority.netitems.form.IRecord|null|undefined} Record
                 * @memberof priority.netitems.form.PreFieldRs
                 * @instance
                 */
                PreFieldRs.prototype.Record = null;

                /**
                 * Creates a new PreFieldRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.PreFieldRs
                 * @static
                 * @param {priority.netitems.form.IPreFieldRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.PreFieldRs} PreFieldRs instance
                 */
                PreFieldRs.create = function create(properties) {
                    return new PreFieldRs(properties);
                };

                /**
                 * Encodes the specified PreFieldRs message. Does not implicitly {@link priority.netitems.form.PreFieldRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.PreFieldRs
                 * @static
                 * @param {priority.netitems.form.IPreFieldRs} message PreFieldRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PreFieldRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Record != null && Object.hasOwnProperty.call(message, "Record"))
                        $root.priority.netitems.form.Record.encode(message.Record, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PreFieldRs message, length delimited. Does not implicitly {@link priority.netitems.form.PreFieldRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.PreFieldRs
                 * @static
                 * @param {priority.netitems.form.IPreFieldRs} message PreFieldRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PreFieldRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PreFieldRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.PreFieldRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.PreFieldRs} PreFieldRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PreFieldRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.PreFieldRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Record = $root.priority.netitems.form.Record.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PreFieldRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.PreFieldRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.PreFieldRs} PreFieldRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PreFieldRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PreFieldRs message.
                 * @function verify
                 * @memberof priority.netitems.form.PreFieldRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PreFieldRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Record != null && message.hasOwnProperty("Record")) {
                        var error = $root.priority.netitems.form.Record.verify(message.Record);
                        if (error)
                            return "Record." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PreFieldRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.PreFieldRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.PreFieldRs} PreFieldRs
                 */
                PreFieldRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.PreFieldRs)
                        return object;
                    var message = new $root.priority.netitems.form.PreFieldRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.PreFieldRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.PreFieldRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.PreFieldRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Record != null) {
                        if (typeof object.Record !== "object")
                            throw TypeError(".priority.netitems.form.PreFieldRs.Record: object expected");
                        message.Record = $root.priority.netitems.form.Record.fromObject(object.Record);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PreFieldRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.PreFieldRs
                 * @static
                 * @param {priority.netitems.form.PreFieldRs} message PreFieldRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PreFieldRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.Record = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Record != null && message.hasOwnProperty("Record"))
                        object.Record = $root.priority.netitems.form.Record.toObject(message.Record, options);
                    return object;
                };

                /**
                 * Converts this PreFieldRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.PreFieldRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PreFieldRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PreFieldRs;
            })();

            form.Grpc2Net = (function() {

                /**
                 * Properties of a Grpc2Net.
                 * @memberof priority.netitems.form
                 * @interface IGrpc2Net
                 * @property {priority.netitems.form.IUncompressedPrpData|null} [PrpData] Grpc2Net PrpData
                 * @property {Uint8Array|null} [SessionData] Grpc2Net SessionData
                 * @property {string|null} [SessionID] Grpc2Net SessionID
                 * @property {priority.netitems.form.IStartRq|null} [Start] Grpc2Net Start
                 * @property {priority.netitems.form.IEndRq|null} [End] Grpc2Net End
                 * @property {priority.netitems.form.IRecordEditRq|null} [RecordEdit] Grpc2Net RecordEdit
                 * @property {priority.netitems.form.IRecordSaveRq|null} [RecordSave] Grpc2Net RecordSave
                 * @property {priority.netitems.form.IFieldUpdateRq|null} [FieldUpdate] Grpc2Net FieldUpdate
                 * @property {priority.netitems.form.IFetchRq|null} [Fetch] Grpc2Net Fetch
                 * @property {priority.netitems.form.ISubformsRq|null} [Subforms] Grpc2Net Subforms
                 * @property {priority.netitems.form.ISubformRq|null} [Subform] Grpc2Net Subform
                 * @property {priority.netitems.form.IColumnsRq|null} [Columns] Grpc2Net Columns
                 * @property {priority.netitems.form.IActionsRq|null} [Actions] Grpc2Net Actions
                 * @property {priority.netitems.form.IRecordDeleteRq|null} [RecordDelete] Grpc2Net RecordDelete
                 * @property {priority.netitems.form.IRecordUndoRq|null} [RecordUndo] Grpc2Net RecordUndo
                 * @property {priority.netitems.form.IWarningApproveRq|null} [WarningApprove] Grpc2Net WarningApprove
                 * @property {priority.netitems.form.IHtmlUnlockRq|null} [HtmlUnlock] Grpc2Net HtmlUnlock
                 * @property {boolean|null} [HtmlState] Grpc2Net HtmlState
                 * @property {priority.netitems.form.IOlapsRq|null} [Olaps] Grpc2Net Olaps
                 * @property {priority.netitems.form.IRecordColorsRq|null} [RecordColors] Grpc2Net RecordColors
                 * @property {priority.netitems.form.ISetRecordColorRq|null} [SetRecordColor] Grpc2Net SetRecordColor
                 * @property {priority.netitems.form.IRemoveAllColorsRq|null} [RemoveAllColors] Grpc2Net RemoveAllColors
                 * @property {priority.netitems.form.IActionRq|null} [Action] Grpc2Net Action
                 * @property {priority.netitems.form.IRecordZoomRq|null} [RecordZoom] Grpc2Net RecordZoom
                 * @property {priority.netitems.form.IFieldUndoRq|null} [FieldUndo] Grpc2Net FieldUndo
                 * @property {priority.netitems.form.IActionEndRq|null} [ActionEnd] Grpc2Net ActionEnd
                 * @property {priority.netitems.form.IHtmlFetchRq|null} [HtmlFetch] Grpc2Net HtmlFetch
                 * @property {priority.netitems.form.IHtmlSignatureRq|null} [HtmlSignature] Grpc2Net HtmlSignature
                 * @property {priority.netitems.form.IHtmlSaveRq|null} [HtmlSave] Grpc2Net HtmlSave
                 * @property {priority.netitems.form.IFieldSelectRq|null} [FieldSelect] Grpc2Net FieldSelect
                 * @property {priority.netitems.form.IHelpRq|null} [Help] Grpc2Net Help
                 * @property {priority.netitems.form.ISystemConstantsRq|null} [SystemConstants] Grpc2Net SystemConstants
                 * @property {priority.netitems.form.IStatusesRq|null} [Statuses] Grpc2Net Statuses
                 * @property {priority.netitems.form.ICountFetchRq|null} [CountFetch] Grpc2Net CountFetch
                 * @property {priority.netitems.form.IAlertCheckExprRq|null} [AlertCheckExpr] Grpc2Net AlertCheckExpr
                 * @property {priority.netitems.form.IAlertListRq|null} [AlertList] Grpc2Net AlertList
                 * @property {priority.netitems.form.IAlertChoosesRq|null} [AlertChooses] Grpc2Net AlertChooses
                 * @property {priority.netitems.form.IAlertSaveRq|null} [AlertSave] Grpc2Net AlertSave
                 * @property {priority.netitems.form.IAlertChooseRq|null} [AlertChoose] Grpc2Net AlertChoose
                 * @property {priority.netitems.form.IAlertDeleteRq|null} [AlertDelete] Grpc2Net AlertDelete
                 * @property {priority.netitems.form.IAlertOrderRq|null} [AlertOrder] Grpc2Net AlertOrder
                 * @property {priority.netitems.form.ITableViewColumnsDesignRq|null} [TableViewColumnsDesign] Grpc2Net TableViewColumnsDesign
                 * @property {priority.netitems.form.ISaveTableViewColumnsDesignRq|null} [SaveTableViewColumnsDesign] Grpc2Net SaveTableViewColumnsDesign
                 * @property {priority.netitems.form.IRowViewColumnsDesignRq|null} [RowViewColumnsDesign] Grpc2Net RowViewColumnsDesign
                 * @property {priority.netitems.form.ISaveRowViewColumnsDesignRq|null} [SaveRowViewColumnsDesign] Grpc2Net SaveRowViewColumnsDesign
                 * @property {priority.netitems.form.IRestoreDefaultDesignRq|null} [RestoreDefaultDesign] Grpc2Net RestoreDefaultDesign
                 * @property {priority.netitems.form.ISubformsDesignRq|null} [SubformsDesign] Grpc2Net SubformsDesign
                 * @property {priority.netitems.form.ISaveSubformsDesignRq|null} [SaveSubformsDesign] Grpc2Net SaveSubformsDesign
                 * @property {priority.netitems.form.IActionsDesignRq|null} [ActionsDesign] Grpc2Net ActionsDesign
                 * @property {priority.netitems.form.ISaveActionsDesignRq|null} [SaveActionsDesign] Grpc2Net SaveActionsDesign
                 * @property {priority.netitems.form.IPreFieldRq|null} [PreField] Grpc2Net PreField
                 * @property {priority.netitems.form.IFormToExcelRq|null} [FormToExcel] Grpc2Net FormToExcel
                 * @property {priority.netitems.form.IGetUncompressedPrpRq|null} [GetUncompressedPrp] Grpc2Net GetUncompressedPrp
                 */

                /**
                 * Constructs a new Grpc2Net.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Grpc2Net.
                 * @implements IGrpc2Net
                 * @constructor
                 * @param {priority.netitems.form.IGrpc2Net=} [properties] Properties to set
                 */
                function Grpc2Net(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Grpc2Net PrpData.
                 * @member {priority.netitems.form.IUncompressedPrpData|null|undefined} PrpData
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.PrpData = null;

                /**
                 * Grpc2Net SessionData.
                 * @member {Uint8Array} SessionData
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SessionData = $util.newBuffer([]);

                /**
                 * Grpc2Net SessionID.
                 * @member {string} SessionID
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SessionID = "";

                /**
                 * Grpc2Net Start.
                 * @member {priority.netitems.form.IStartRq|null|undefined} Start
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Start = null;

                /**
                 * Grpc2Net End.
                 * @member {priority.netitems.form.IEndRq|null|undefined} End
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.End = null;

                /**
                 * Grpc2Net RecordEdit.
                 * @member {priority.netitems.form.IRecordEditRq|null|undefined} RecordEdit
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RecordEdit = null;

                /**
                 * Grpc2Net RecordSave.
                 * @member {priority.netitems.form.IRecordSaveRq|null|undefined} RecordSave
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RecordSave = null;

                /**
                 * Grpc2Net FieldUpdate.
                 * @member {priority.netitems.form.IFieldUpdateRq|null|undefined} FieldUpdate
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.FieldUpdate = null;

                /**
                 * Grpc2Net Fetch.
                 * @member {priority.netitems.form.IFetchRq|null|undefined} Fetch
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Fetch = null;

                /**
                 * Grpc2Net Subforms.
                 * @member {priority.netitems.form.ISubformsRq|null|undefined} Subforms
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Subforms = null;

                /**
                 * Grpc2Net Subform.
                 * @member {priority.netitems.form.ISubformRq|null|undefined} Subform
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Subform = null;

                /**
                 * Grpc2Net Columns.
                 * @member {priority.netitems.form.IColumnsRq|null|undefined} Columns
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Columns = null;

                /**
                 * Grpc2Net Actions.
                 * @member {priority.netitems.form.IActionsRq|null|undefined} Actions
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Actions = null;

                /**
                 * Grpc2Net RecordDelete.
                 * @member {priority.netitems.form.IRecordDeleteRq|null|undefined} RecordDelete
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RecordDelete = null;

                /**
                 * Grpc2Net RecordUndo.
                 * @member {priority.netitems.form.IRecordUndoRq|null|undefined} RecordUndo
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RecordUndo = null;

                /**
                 * Grpc2Net WarningApprove.
                 * @member {priority.netitems.form.IWarningApproveRq|null|undefined} WarningApprove
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.WarningApprove = null;

                /**
                 * Grpc2Net HtmlUnlock.
                 * @member {priority.netitems.form.IHtmlUnlockRq|null|undefined} HtmlUnlock
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.HtmlUnlock = null;

                /**
                 * Grpc2Net HtmlState.
                 * @member {boolean|null|undefined} HtmlState
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.HtmlState = null;

                /**
                 * Grpc2Net Olaps.
                 * @member {priority.netitems.form.IOlapsRq|null|undefined} Olaps
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Olaps = null;

                /**
                 * Grpc2Net RecordColors.
                 * @member {priority.netitems.form.IRecordColorsRq|null|undefined} RecordColors
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RecordColors = null;

                /**
                 * Grpc2Net SetRecordColor.
                 * @member {priority.netitems.form.ISetRecordColorRq|null|undefined} SetRecordColor
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SetRecordColor = null;

                /**
                 * Grpc2Net RemoveAllColors.
                 * @member {priority.netitems.form.IRemoveAllColorsRq|null|undefined} RemoveAllColors
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RemoveAllColors = null;

                /**
                 * Grpc2Net Action.
                 * @member {priority.netitems.form.IActionRq|null|undefined} Action
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Action = null;

                /**
                 * Grpc2Net RecordZoom.
                 * @member {priority.netitems.form.IRecordZoomRq|null|undefined} RecordZoom
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RecordZoom = null;

                /**
                 * Grpc2Net FieldUndo.
                 * @member {priority.netitems.form.IFieldUndoRq|null|undefined} FieldUndo
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.FieldUndo = null;

                /**
                 * Grpc2Net ActionEnd.
                 * @member {priority.netitems.form.IActionEndRq|null|undefined} ActionEnd
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ActionEnd = null;

                /**
                 * Grpc2Net HtmlFetch.
                 * @member {priority.netitems.form.IHtmlFetchRq|null|undefined} HtmlFetch
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.HtmlFetch = null;

                /**
                 * Grpc2Net HtmlSignature.
                 * @member {priority.netitems.form.IHtmlSignatureRq|null|undefined} HtmlSignature
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.HtmlSignature = null;

                /**
                 * Grpc2Net HtmlSave.
                 * @member {priority.netitems.form.IHtmlSaveRq|null|undefined} HtmlSave
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.HtmlSave = null;

                /**
                 * Grpc2Net FieldSelect.
                 * @member {priority.netitems.form.IFieldSelectRq|null|undefined} FieldSelect
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.FieldSelect = null;

                /**
                 * Grpc2Net Help.
                 * @member {priority.netitems.form.IHelpRq|null|undefined} Help
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Help = null;

                /**
                 * Grpc2Net SystemConstants.
                 * @member {priority.netitems.form.ISystemConstantsRq|null|undefined} SystemConstants
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SystemConstants = null;

                /**
                 * Grpc2Net Statuses.
                 * @member {priority.netitems.form.IStatusesRq|null|undefined} Statuses
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Statuses = null;

                /**
                 * Grpc2Net CountFetch.
                 * @member {priority.netitems.form.ICountFetchRq|null|undefined} CountFetch
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.CountFetch = null;

                /**
                 * Grpc2Net AlertCheckExpr.
                 * @member {priority.netitems.form.IAlertCheckExprRq|null|undefined} AlertCheckExpr
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.AlertCheckExpr = null;

                /**
                 * Grpc2Net AlertList.
                 * @member {priority.netitems.form.IAlertListRq|null|undefined} AlertList
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.AlertList = null;

                /**
                 * Grpc2Net AlertChooses.
                 * @member {priority.netitems.form.IAlertChoosesRq|null|undefined} AlertChooses
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.AlertChooses = null;

                /**
                 * Grpc2Net AlertSave.
                 * @member {priority.netitems.form.IAlertSaveRq|null|undefined} AlertSave
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.AlertSave = null;

                /**
                 * Grpc2Net AlertChoose.
                 * @member {priority.netitems.form.IAlertChooseRq|null|undefined} AlertChoose
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.AlertChoose = null;

                /**
                 * Grpc2Net AlertDelete.
                 * @member {priority.netitems.form.IAlertDeleteRq|null|undefined} AlertDelete
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.AlertDelete = null;

                /**
                 * Grpc2Net AlertOrder.
                 * @member {priority.netitems.form.IAlertOrderRq|null|undefined} AlertOrder
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.AlertOrder = null;

                /**
                 * Grpc2Net TableViewColumnsDesign.
                 * @member {priority.netitems.form.ITableViewColumnsDesignRq|null|undefined} TableViewColumnsDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.TableViewColumnsDesign = null;

                /**
                 * Grpc2Net SaveTableViewColumnsDesign.
                 * @member {priority.netitems.form.ISaveTableViewColumnsDesignRq|null|undefined} SaveTableViewColumnsDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SaveTableViewColumnsDesign = null;

                /**
                 * Grpc2Net RowViewColumnsDesign.
                 * @member {priority.netitems.form.IRowViewColumnsDesignRq|null|undefined} RowViewColumnsDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RowViewColumnsDesign = null;

                /**
                 * Grpc2Net SaveRowViewColumnsDesign.
                 * @member {priority.netitems.form.ISaveRowViewColumnsDesignRq|null|undefined} SaveRowViewColumnsDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SaveRowViewColumnsDesign = null;

                /**
                 * Grpc2Net RestoreDefaultDesign.
                 * @member {priority.netitems.form.IRestoreDefaultDesignRq|null|undefined} RestoreDefaultDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.RestoreDefaultDesign = null;

                /**
                 * Grpc2Net SubformsDesign.
                 * @member {priority.netitems.form.ISubformsDesignRq|null|undefined} SubformsDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SubformsDesign = null;

                /**
                 * Grpc2Net SaveSubformsDesign.
                 * @member {priority.netitems.form.ISaveSubformsDesignRq|null|undefined} SaveSubformsDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SaveSubformsDesign = null;

                /**
                 * Grpc2Net ActionsDesign.
                 * @member {priority.netitems.form.IActionsDesignRq|null|undefined} ActionsDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ActionsDesign = null;

                /**
                 * Grpc2Net SaveActionsDesign.
                 * @member {priority.netitems.form.ISaveActionsDesignRq|null|undefined} SaveActionsDesign
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.SaveActionsDesign = null;

                /**
                 * Grpc2Net PreField.
                 * @member {priority.netitems.form.IPreFieldRq|null|undefined} PreField
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.PreField = null;

                /**
                 * Grpc2Net FormToExcel.
                 * @member {priority.netitems.form.IFormToExcelRq|null|undefined} FormToExcel
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.FormToExcel = null;

                /**
                 * Grpc2Net GetUncompressedPrp.
                 * @member {priority.netitems.form.IGetUncompressedPrpRq|null|undefined} GetUncompressedPrp
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.GetUncompressedPrp = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Grpc2Net inner.
                 * @member {"Start"|"End"|"RecordEdit"|"RecordSave"|"FieldUpdate"|"Fetch"|"Subforms"|"Subform"|"Columns"|"Actions"|"RecordDelete"|"RecordUndo"|"WarningApprove"|"HtmlUnlock"|"HtmlState"|"Olaps"|"RecordColors"|"SetRecordColor"|"RemoveAllColors"|"Action"|"RecordZoom"|"FieldUndo"|"ActionEnd"|"HtmlFetch"|"HtmlSignature"|"HtmlSave"|"FieldSelect"|"Help"|"SystemConstants"|"Statuses"|"CountFetch"|"AlertCheckExpr"|"AlertList"|"AlertChooses"|"AlertSave"|"AlertChoose"|"AlertDelete"|"AlertOrder"|"TableViewColumnsDesign"|"SaveTableViewColumnsDesign"|"RowViewColumnsDesign"|"SaveRowViewColumnsDesign"|"RestoreDefaultDesign"|"SubformsDesign"|"SaveSubformsDesign"|"ActionsDesign"|"SaveActionsDesign"|"PreField"|"FormToExcel"|"GetUncompressedPrp"|undefined} inner
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 */
                Object.defineProperty(Grpc2Net.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["Start", "End", "RecordEdit", "RecordSave", "FieldUpdate", "Fetch", "Subforms", "Subform", "Columns", "Actions", "RecordDelete", "RecordUndo", "WarningApprove", "HtmlUnlock", "HtmlState", "Olaps", "RecordColors", "SetRecordColor", "RemoveAllColors", "Action", "RecordZoom", "FieldUndo", "ActionEnd", "HtmlFetch", "HtmlSignature", "HtmlSave", "FieldSelect", "Help", "SystemConstants", "Statuses", "CountFetch", "AlertCheckExpr", "AlertList", "AlertChooses", "AlertSave", "AlertChoose", "AlertDelete", "AlertOrder", "TableViewColumnsDesign", "SaveTableViewColumnsDesign", "RowViewColumnsDesign", "SaveRowViewColumnsDesign", "RestoreDefaultDesign", "SubformsDesign", "SaveSubformsDesign", "ActionsDesign", "SaveActionsDesign", "PreField", "FormToExcel", "GetUncompressedPrp"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Grpc2Net instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Grpc2Net
                 * @static
                 * @param {priority.netitems.form.IGrpc2Net=} [properties] Properties to set
                 * @returns {priority.netitems.form.Grpc2Net} Grpc2Net instance
                 */
                Grpc2Net.create = function create(properties) {
                    return new Grpc2Net(properties);
                };

                /**
                 * Encodes the specified Grpc2Net message. Does not implicitly {@link priority.netitems.form.Grpc2Net.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Grpc2Net
                 * @static
                 * @param {priority.netitems.form.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                        $root.priority.netitems.form.StartRq.encode(message.Start, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                        $root.priority.netitems.form.EndRq.encode(message.End, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.RecordEdit != null && Object.hasOwnProperty.call(message, "RecordEdit"))
                        $root.priority.netitems.form.RecordEditRq.encode(message.RecordEdit, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.RecordSave != null && Object.hasOwnProperty.call(message, "RecordSave"))
                        $root.priority.netitems.form.RecordSaveRq.encode(message.RecordSave, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.FieldUpdate != null && Object.hasOwnProperty.call(message, "FieldUpdate"))
                        $root.priority.netitems.form.FieldUpdateRq.encode(message.FieldUpdate, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.Fetch != null && Object.hasOwnProperty.call(message, "Fetch"))
                        $root.priority.netitems.form.FetchRq.encode(message.Fetch, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Subforms != null && Object.hasOwnProperty.call(message, "Subforms"))
                        $root.priority.netitems.form.SubformsRq.encode(message.Subforms, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.Subform != null && Object.hasOwnProperty.call(message, "Subform"))
                        $root.priority.netitems.form.SubformRq.encode(message.Subform, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.Columns != null && Object.hasOwnProperty.call(message, "Columns"))
                        $root.priority.netitems.form.ColumnsRq.encode(message.Columns, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.Actions != null && Object.hasOwnProperty.call(message, "Actions"))
                        $root.priority.netitems.form.ActionsRq.encode(message.Actions, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.RecordDelete != null && Object.hasOwnProperty.call(message, "RecordDelete"))
                        $root.priority.netitems.form.RecordDeleteRq.encode(message.RecordDelete, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.RecordUndo != null && Object.hasOwnProperty.call(message, "RecordUndo"))
                        $root.priority.netitems.form.RecordUndoRq.encode(message.RecordUndo, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.WarningApprove != null && Object.hasOwnProperty.call(message, "WarningApprove"))
                        $root.priority.netitems.form.WarningApproveRq.encode(message.WarningApprove, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.HtmlUnlock != null && Object.hasOwnProperty.call(message, "HtmlUnlock"))
                        $root.priority.netitems.form.HtmlUnlockRq.encode(message.HtmlUnlock, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.HtmlState != null && Object.hasOwnProperty.call(message, "HtmlState"))
                        writer.uint32(/* id 15, wireType 0 =*/120).bool(message.HtmlState);
                    if (message.Olaps != null && Object.hasOwnProperty.call(message, "Olaps"))
                        $root.priority.netitems.form.OlapsRq.encode(message.Olaps, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.RecordColors != null && Object.hasOwnProperty.call(message, "RecordColors"))
                        $root.priority.netitems.form.RecordColorsRq.encode(message.RecordColors, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    if (message.SetRecordColor != null && Object.hasOwnProperty.call(message, "SetRecordColor"))
                        $root.priority.netitems.form.SetRecordColorRq.encode(message.SetRecordColor, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                    if (message.RemoveAllColors != null && Object.hasOwnProperty.call(message, "RemoveAllColors"))
                        $root.priority.netitems.form.RemoveAllColorsRq.encode(message.RemoveAllColors, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    if (message.Action != null && Object.hasOwnProperty.call(message, "Action"))
                        $root.priority.netitems.form.ActionRq.encode(message.Action, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                    if (message.RecordZoom != null && Object.hasOwnProperty.call(message, "RecordZoom"))
                        $root.priority.netitems.form.RecordZoomRq.encode(message.RecordZoom, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                    if (message.FieldUndo != null && Object.hasOwnProperty.call(message, "FieldUndo"))
                        $root.priority.netitems.form.FieldUndoRq.encode(message.FieldUndo, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
                    if (message.ActionEnd != null && Object.hasOwnProperty.call(message, "ActionEnd"))
                        $root.priority.netitems.form.ActionEndRq.encode(message.ActionEnd, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                    if (message.HtmlFetch != null && Object.hasOwnProperty.call(message, "HtmlFetch"))
                        $root.priority.netitems.form.HtmlFetchRq.encode(message.HtmlFetch, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                    if (message.HtmlSignature != null && Object.hasOwnProperty.call(message, "HtmlSignature"))
                        $root.priority.netitems.form.HtmlSignatureRq.encode(message.HtmlSignature, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
                    if (message.HtmlSave != null && Object.hasOwnProperty.call(message, "HtmlSave"))
                        $root.priority.netitems.form.HtmlSaveRq.encode(message.HtmlSave, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                    if (message.FieldSelect != null && Object.hasOwnProperty.call(message, "FieldSelect"))
                        $root.priority.netitems.form.FieldSelectRq.encode(message.FieldSelect, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
                    if (message.Help != null && Object.hasOwnProperty.call(message, "Help"))
                        $root.priority.netitems.form.HelpRq.encode(message.Help, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
                    if (message.SystemConstants != null && Object.hasOwnProperty.call(message, "SystemConstants"))
                        $root.priority.netitems.form.SystemConstantsRq.encode(message.SystemConstants, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
                    if (message.Statuses != null && Object.hasOwnProperty.call(message, "Statuses"))
                        $root.priority.netitems.form.StatusesRq.encode(message.Statuses, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
                    if (message.CountFetch != null && Object.hasOwnProperty.call(message, "CountFetch"))
                        $root.priority.netitems.form.CountFetchRq.encode(message.CountFetch, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                    if (message.AlertCheckExpr != null && Object.hasOwnProperty.call(message, "AlertCheckExpr"))
                        $root.priority.netitems.form.AlertCheckExprRq.encode(message.AlertCheckExpr, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
                    if (message.AlertList != null && Object.hasOwnProperty.call(message, "AlertList"))
                        $root.priority.netitems.form.AlertListRq.encode(message.AlertList, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
                    if (message.AlertChooses != null && Object.hasOwnProperty.call(message, "AlertChooses"))
                        $root.priority.netitems.form.AlertChoosesRq.encode(message.AlertChooses, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
                    if (message.TableViewColumnsDesign != null && Object.hasOwnProperty.call(message, "TableViewColumnsDesign"))
                        $root.priority.netitems.form.TableViewColumnsDesignRq.encode(message.TableViewColumnsDesign, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
                    if (message.AlertSave != null && Object.hasOwnProperty.call(message, "AlertSave"))
                        $root.priority.netitems.form.AlertSaveRq.encode(message.AlertSave, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
                    if (message.AlertChoose != null && Object.hasOwnProperty.call(message, "AlertChoose"))
                        $root.priority.netitems.form.AlertChooseRq.encode(message.AlertChoose, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
                    if (message.AlertDelete != null && Object.hasOwnProperty.call(message, "AlertDelete"))
                        $root.priority.netitems.form.AlertDeleteRq.encode(message.AlertDelete, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
                    if (message.AlertOrder != null && Object.hasOwnProperty.call(message, "AlertOrder"))
                        $root.priority.netitems.form.AlertOrderRq.encode(message.AlertOrder, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
                    if (message.RowViewColumnsDesign != null && Object.hasOwnProperty.call(message, "RowViewColumnsDesign"))
                        $root.priority.netitems.form.RowViewColumnsDesignRq.encode(message.RowViewColumnsDesign, writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
                    if (message.SaveRowViewColumnsDesign != null && Object.hasOwnProperty.call(message, "SaveRowViewColumnsDesign"))
                        $root.priority.netitems.form.SaveRowViewColumnsDesignRq.encode(message.SaveRowViewColumnsDesign, writer.uint32(/* id 44, wireType 2 =*/354).fork()).ldelim();
                    if (message.PreField != null && Object.hasOwnProperty.call(message, "PreField"))
                        $root.priority.netitems.form.PreFieldRq.encode(message.PreField, writer.uint32(/* id 46, wireType 2 =*/370).fork()).ldelim();
                    if (message.RestoreDefaultDesign != null && Object.hasOwnProperty.call(message, "RestoreDefaultDesign"))
                        $root.priority.netitems.form.RestoreDefaultDesignRq.encode(message.RestoreDefaultDesign, writer.uint32(/* id 47, wireType 2 =*/378).fork()).ldelim();
                    if (message.SubformsDesign != null && Object.hasOwnProperty.call(message, "SubformsDesign"))
                        $root.priority.netitems.form.SubformsDesignRq.encode(message.SubformsDesign, writer.uint32(/* id 48, wireType 2 =*/386).fork()).ldelim();
                    if (message.SaveSubformsDesign != null && Object.hasOwnProperty.call(message, "SaveSubformsDesign"))
                        $root.priority.netitems.form.SaveSubformsDesignRq.encode(message.SaveSubformsDesign, writer.uint32(/* id 49, wireType 2 =*/394).fork()).ldelim();
                    if (message.ActionsDesign != null && Object.hasOwnProperty.call(message, "ActionsDesign"))
                        $root.priority.netitems.form.ActionsDesignRq.encode(message.ActionsDesign, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
                    if (message.SaveActionsDesign != null && Object.hasOwnProperty.call(message, "SaveActionsDesign"))
                        $root.priority.netitems.form.SaveActionsDesignRq.encode(message.SaveActionsDesign, writer.uint32(/* id 51, wireType 2 =*/410).fork()).ldelim();
                    if (message.SaveTableViewColumnsDesign != null && Object.hasOwnProperty.call(message, "SaveTableViewColumnsDesign"))
                        $root.priority.netitems.form.SaveTableViewColumnsDesignRq.encode(message.SaveTableViewColumnsDesign, writer.uint32(/* id 52, wireType 2 =*/418).fork()).ldelim();
                    if (message.FormToExcel != null && Object.hasOwnProperty.call(message, "FormToExcel"))
                        $root.priority.netitems.form.FormToExcelRq.encode(message.FormToExcel, writer.uint32(/* id 60, wireType 2 =*/482).fork()).ldelim();
                    if (message.GetUncompressedPrp != null && Object.hasOwnProperty.call(message, "GetUncompressedPrp"))
                        $root.priority.netitems.form.GetUncompressedPrpRq.encode(message.GetUncompressedPrp, writer.uint32(/* id 64, wireType 2 =*/514).fork()).ldelim();
                    if (message.PrpData != null && Object.hasOwnProperty.call(message, "PrpData"))
                        $root.priority.netitems.form.UncompressedPrpData.encode(message.PrpData, writer.uint32(/* id 100, wireType 2 =*/802).fork()).ldelim();
                    if (message.SessionData != null && Object.hasOwnProperty.call(message, "SessionData"))
                        writer.uint32(/* id 101, wireType 2 =*/810).bytes(message.SessionData);
                    if (message.SessionID != null && Object.hasOwnProperty.call(message, "SessionID"))
                        writer.uint32(/* id 102, wireType 2 =*/818).string(message.SessionID);
                    return writer;
                };

                /**
                 * Encodes the specified Grpc2Net message, length delimited. Does not implicitly {@link priority.netitems.form.Grpc2Net.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Grpc2Net
                 * @static
                 * @param {priority.netitems.form.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Grpc2Net();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 100:
                            message.PrpData = $root.priority.netitems.form.UncompressedPrpData.decode(reader, reader.uint32());
                            break;
                        case 101:
                            message.SessionData = reader.bytes();
                            break;
                        case 102:
                            message.SessionID = reader.string();
                            break;
                        case 1:
                            message.Start = $root.priority.netitems.form.StartRq.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.End = $root.priority.netitems.form.EndRq.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.RecordEdit = $root.priority.netitems.form.RecordEditRq.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.RecordSave = $root.priority.netitems.form.RecordSaveRq.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.FieldUpdate = $root.priority.netitems.form.FieldUpdateRq.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.Fetch = $root.priority.netitems.form.FetchRq.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.Subforms = $root.priority.netitems.form.SubformsRq.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.Subform = $root.priority.netitems.form.SubformRq.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.Columns = $root.priority.netitems.form.ColumnsRq.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.Actions = $root.priority.netitems.form.ActionsRq.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.RecordDelete = $root.priority.netitems.form.RecordDeleteRq.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.RecordUndo = $root.priority.netitems.form.RecordUndoRq.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.WarningApprove = $root.priority.netitems.form.WarningApproveRq.decode(reader, reader.uint32());
                            break;
                        case 14:
                            message.HtmlUnlock = $root.priority.netitems.form.HtmlUnlockRq.decode(reader, reader.uint32());
                            break;
                        case 15:
                            message.HtmlState = reader.bool();
                            break;
                        case 17:
                            message.Olaps = $root.priority.netitems.form.OlapsRq.decode(reader, reader.uint32());
                            break;
                        case 19:
                            message.RecordColors = $root.priority.netitems.form.RecordColorsRq.decode(reader, reader.uint32());
                            break;
                        case 20:
                            message.SetRecordColor = $root.priority.netitems.form.SetRecordColorRq.decode(reader, reader.uint32());
                            break;
                        case 21:
                            message.RemoveAllColors = $root.priority.netitems.form.RemoveAllColorsRq.decode(reader, reader.uint32());
                            break;
                        case 22:
                            message.Action = $root.priority.netitems.form.ActionRq.decode(reader, reader.uint32());
                            break;
                        case 23:
                            message.RecordZoom = $root.priority.netitems.form.RecordZoomRq.decode(reader, reader.uint32());
                            break;
                        case 24:
                            message.FieldUndo = $root.priority.netitems.form.FieldUndoRq.decode(reader, reader.uint32());
                            break;
                        case 25:
                            message.ActionEnd = $root.priority.netitems.form.ActionEndRq.decode(reader, reader.uint32());
                            break;
                        case 26:
                            message.HtmlFetch = $root.priority.netitems.form.HtmlFetchRq.decode(reader, reader.uint32());
                            break;
                        case 27:
                            message.HtmlSignature = $root.priority.netitems.form.HtmlSignatureRq.decode(reader, reader.uint32());
                            break;
                        case 28:
                            message.HtmlSave = $root.priority.netitems.form.HtmlSaveRq.decode(reader, reader.uint32());
                            break;
                        case 29:
                            message.FieldSelect = $root.priority.netitems.form.FieldSelectRq.decode(reader, reader.uint32());
                            break;
                        case 30:
                            message.Help = $root.priority.netitems.form.HelpRq.decode(reader, reader.uint32());
                            break;
                        case 32:
                            message.SystemConstants = $root.priority.netitems.form.SystemConstantsRq.decode(reader, reader.uint32());
                            break;
                        case 33:
                            message.Statuses = $root.priority.netitems.form.StatusesRq.decode(reader, reader.uint32());
                            break;
                        case 34:
                            message.CountFetch = $root.priority.netitems.form.CountFetchRq.decode(reader, reader.uint32());
                            break;
                        case 35:
                            message.AlertCheckExpr = $root.priority.netitems.form.AlertCheckExprRq.decode(reader, reader.uint32());
                            break;
                        case 36:
                            message.AlertList = $root.priority.netitems.form.AlertListRq.decode(reader, reader.uint32());
                            break;
                        case 37:
                            message.AlertChooses = $root.priority.netitems.form.AlertChoosesRq.decode(reader, reader.uint32());
                            break;
                        case 39:
                            message.AlertSave = $root.priority.netitems.form.AlertSaveRq.decode(reader, reader.uint32());
                            break;
                        case 40:
                            message.AlertChoose = $root.priority.netitems.form.AlertChooseRq.decode(reader, reader.uint32());
                            break;
                        case 41:
                            message.AlertDelete = $root.priority.netitems.form.AlertDeleteRq.decode(reader, reader.uint32());
                            break;
                        case 42:
                            message.AlertOrder = $root.priority.netitems.form.AlertOrderRq.decode(reader, reader.uint32());
                            break;
                        case 38:
                            message.TableViewColumnsDesign = $root.priority.netitems.form.TableViewColumnsDesignRq.decode(reader, reader.uint32());
                            break;
                        case 52:
                            message.SaveTableViewColumnsDesign = $root.priority.netitems.form.SaveTableViewColumnsDesignRq.decode(reader, reader.uint32());
                            break;
                        case 43:
                            message.RowViewColumnsDesign = $root.priority.netitems.form.RowViewColumnsDesignRq.decode(reader, reader.uint32());
                            break;
                        case 44:
                            message.SaveRowViewColumnsDesign = $root.priority.netitems.form.SaveRowViewColumnsDesignRq.decode(reader, reader.uint32());
                            break;
                        case 47:
                            message.RestoreDefaultDesign = $root.priority.netitems.form.RestoreDefaultDesignRq.decode(reader, reader.uint32());
                            break;
                        case 48:
                            message.SubformsDesign = $root.priority.netitems.form.SubformsDesignRq.decode(reader, reader.uint32());
                            break;
                        case 49:
                            message.SaveSubformsDesign = $root.priority.netitems.form.SaveSubformsDesignRq.decode(reader, reader.uint32());
                            break;
                        case 50:
                            message.ActionsDesign = $root.priority.netitems.form.ActionsDesignRq.decode(reader, reader.uint32());
                            break;
                        case 51:
                            message.SaveActionsDesign = $root.priority.netitems.form.SaveActionsDesignRq.decode(reader, reader.uint32());
                            break;
                        case 46:
                            message.PreField = $root.priority.netitems.form.PreFieldRq.decode(reader, reader.uint32());
                            break;
                        case 60:
                            message.FormToExcel = $root.priority.netitems.form.FormToExcelRq.decode(reader, reader.uint32());
                            break;
                        case 64:
                            message.GetUncompressedPrp = $root.priority.netitems.form.GetUncompressedPrpRq.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Grpc2Net message.
                 * @function verify
                 * @memberof priority.netitems.form.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Grpc2Net.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.PrpData != null && message.hasOwnProperty("PrpData")) {
                        var error = $root.priority.netitems.form.UncompressedPrpData.verify(message.PrpData);
                        if (error)
                            return "PrpData." + error;
                    }
                    if (message.SessionData != null && message.hasOwnProperty("SessionData"))
                        if (!(message.SessionData && typeof message.SessionData.length === "number" || $util.isString(message.SessionData)))
                            return "SessionData: buffer expected";
                    if (message.SessionID != null && message.hasOwnProperty("SessionID"))
                        if (!$util.isString(message.SessionID))
                            return "SessionID: string expected";
                    if (message.Start != null && message.hasOwnProperty("Start")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.StartRq.verify(message.Start);
                            if (error)
                                return "Start." + error;
                        }
                    }
                    if (message.End != null && message.hasOwnProperty("End")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.EndRq.verify(message.End);
                            if (error)
                                return "End." + error;
                        }
                    }
                    if (message.RecordEdit != null && message.hasOwnProperty("RecordEdit")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordEditRq.verify(message.RecordEdit);
                            if (error)
                                return "RecordEdit." + error;
                        }
                    }
                    if (message.RecordSave != null && message.hasOwnProperty("RecordSave")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordSaveRq.verify(message.RecordSave);
                            if (error)
                                return "RecordSave." + error;
                        }
                    }
                    if (message.FieldUpdate != null && message.hasOwnProperty("FieldUpdate")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FieldUpdateRq.verify(message.FieldUpdate);
                            if (error)
                                return "FieldUpdate." + error;
                        }
                    }
                    if (message.Fetch != null && message.hasOwnProperty("Fetch")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FetchRq.verify(message.Fetch);
                            if (error)
                                return "Fetch." + error;
                        }
                    }
                    if (message.Subforms != null && message.hasOwnProperty("Subforms")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SubformsRq.verify(message.Subforms);
                            if (error)
                                return "Subforms." + error;
                        }
                    }
                    if (message.Subform != null && message.hasOwnProperty("Subform")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SubformRq.verify(message.Subform);
                            if (error)
                                return "Subform." + error;
                        }
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ColumnsRq.verify(message.Columns);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.Actions != null && message.hasOwnProperty("Actions")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ActionsRq.verify(message.Actions);
                            if (error)
                                return "Actions." + error;
                        }
                    }
                    if (message.RecordDelete != null && message.hasOwnProperty("RecordDelete")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordDeleteRq.verify(message.RecordDelete);
                            if (error)
                                return "RecordDelete." + error;
                        }
                    }
                    if (message.RecordUndo != null && message.hasOwnProperty("RecordUndo")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordUndoRq.verify(message.RecordUndo);
                            if (error)
                                return "RecordUndo." + error;
                        }
                    }
                    if (message.WarningApprove != null && message.hasOwnProperty("WarningApprove")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.WarningApproveRq.verify(message.WarningApprove);
                            if (error)
                                return "WarningApprove." + error;
                        }
                    }
                    if (message.HtmlUnlock != null && message.hasOwnProperty("HtmlUnlock")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HtmlUnlockRq.verify(message.HtmlUnlock);
                            if (error)
                                return "HtmlUnlock." + error;
                        }
                    }
                    if (message.HtmlState != null && message.hasOwnProperty("HtmlState")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        if (typeof message.HtmlState !== "boolean")
                            return "HtmlState: boolean expected";
                    }
                    if (message.Olaps != null && message.hasOwnProperty("Olaps")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.OlapsRq.verify(message.Olaps);
                            if (error)
                                return "Olaps." + error;
                        }
                    }
                    if (message.RecordColors != null && message.hasOwnProperty("RecordColors")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordColorsRq.verify(message.RecordColors);
                            if (error)
                                return "RecordColors." + error;
                        }
                    }
                    if (message.SetRecordColor != null && message.hasOwnProperty("SetRecordColor")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SetRecordColorRq.verify(message.SetRecordColor);
                            if (error)
                                return "SetRecordColor." + error;
                        }
                    }
                    if (message.RemoveAllColors != null && message.hasOwnProperty("RemoveAllColors")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RemoveAllColorsRq.verify(message.RemoveAllColors);
                            if (error)
                                return "RemoveAllColors." + error;
                        }
                    }
                    if (message.Action != null && message.hasOwnProperty("Action")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ActionRq.verify(message.Action);
                            if (error)
                                return "Action." + error;
                        }
                    }
                    if (message.RecordZoom != null && message.hasOwnProperty("RecordZoom")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordZoomRq.verify(message.RecordZoom);
                            if (error)
                                return "RecordZoom." + error;
                        }
                    }
                    if (message.FieldUndo != null && message.hasOwnProperty("FieldUndo")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FieldUndoRq.verify(message.FieldUndo);
                            if (error)
                                return "FieldUndo." + error;
                        }
                    }
                    if (message.ActionEnd != null && message.hasOwnProperty("ActionEnd")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ActionEndRq.verify(message.ActionEnd);
                            if (error)
                                return "ActionEnd." + error;
                        }
                    }
                    if (message.HtmlFetch != null && message.hasOwnProperty("HtmlFetch")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HtmlFetchRq.verify(message.HtmlFetch);
                            if (error)
                                return "HtmlFetch." + error;
                        }
                    }
                    if (message.HtmlSignature != null && message.hasOwnProperty("HtmlSignature")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HtmlSignatureRq.verify(message.HtmlSignature);
                            if (error)
                                return "HtmlSignature." + error;
                        }
                    }
                    if (message.HtmlSave != null && message.hasOwnProperty("HtmlSave")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HtmlSaveRq.verify(message.HtmlSave);
                            if (error)
                                return "HtmlSave." + error;
                        }
                    }
                    if (message.FieldSelect != null && message.hasOwnProperty("FieldSelect")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FieldSelectRq.verify(message.FieldSelect);
                            if (error)
                                return "FieldSelect." + error;
                        }
                    }
                    if (message.Help != null && message.hasOwnProperty("Help")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HelpRq.verify(message.Help);
                            if (error)
                                return "Help." + error;
                        }
                    }
                    if (message.SystemConstants != null && message.hasOwnProperty("SystemConstants")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SystemConstantsRq.verify(message.SystemConstants);
                            if (error)
                                return "SystemConstants." + error;
                        }
                    }
                    if (message.Statuses != null && message.hasOwnProperty("Statuses")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.StatusesRq.verify(message.Statuses);
                            if (error)
                                return "Statuses." + error;
                        }
                    }
                    if (message.CountFetch != null && message.hasOwnProperty("CountFetch")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.CountFetchRq.verify(message.CountFetch);
                            if (error)
                                return "CountFetch." + error;
                        }
                    }
                    if (message.AlertCheckExpr != null && message.hasOwnProperty("AlertCheckExpr")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertCheckExprRq.verify(message.AlertCheckExpr);
                            if (error)
                                return "AlertCheckExpr." + error;
                        }
                    }
                    if (message.AlertList != null && message.hasOwnProperty("AlertList")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertListRq.verify(message.AlertList);
                            if (error)
                                return "AlertList." + error;
                        }
                    }
                    if (message.AlertChooses != null && message.hasOwnProperty("AlertChooses")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertChoosesRq.verify(message.AlertChooses);
                            if (error)
                                return "AlertChooses." + error;
                        }
                    }
                    if (message.AlertSave != null && message.hasOwnProperty("AlertSave")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertSaveRq.verify(message.AlertSave);
                            if (error)
                                return "AlertSave." + error;
                        }
                    }
                    if (message.AlertChoose != null && message.hasOwnProperty("AlertChoose")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertChooseRq.verify(message.AlertChoose);
                            if (error)
                                return "AlertChoose." + error;
                        }
                    }
                    if (message.AlertDelete != null && message.hasOwnProperty("AlertDelete")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertDeleteRq.verify(message.AlertDelete);
                            if (error)
                                return "AlertDelete." + error;
                        }
                    }
                    if (message.AlertOrder != null && message.hasOwnProperty("AlertOrder")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertOrderRq.verify(message.AlertOrder);
                            if (error)
                                return "AlertOrder." + error;
                        }
                    }
                    if (message.TableViewColumnsDesign != null && message.hasOwnProperty("TableViewColumnsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.TableViewColumnsDesignRq.verify(message.TableViewColumnsDesign);
                            if (error)
                                return "TableViewColumnsDesign." + error;
                        }
                    }
                    if (message.SaveTableViewColumnsDesign != null && message.hasOwnProperty("SaveTableViewColumnsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SaveTableViewColumnsDesignRq.verify(message.SaveTableViewColumnsDesign);
                            if (error)
                                return "SaveTableViewColumnsDesign." + error;
                        }
                    }
                    if (message.RowViewColumnsDesign != null && message.hasOwnProperty("RowViewColumnsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RowViewColumnsDesignRq.verify(message.RowViewColumnsDesign);
                            if (error)
                                return "RowViewColumnsDesign." + error;
                        }
                    }
                    if (message.SaveRowViewColumnsDesign != null && message.hasOwnProperty("SaveRowViewColumnsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SaveRowViewColumnsDesignRq.verify(message.SaveRowViewColumnsDesign);
                            if (error)
                                return "SaveRowViewColumnsDesign." + error;
                        }
                    }
                    if (message.RestoreDefaultDesign != null && message.hasOwnProperty("RestoreDefaultDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RestoreDefaultDesignRq.verify(message.RestoreDefaultDesign);
                            if (error)
                                return "RestoreDefaultDesign." + error;
                        }
                    }
                    if (message.SubformsDesign != null && message.hasOwnProperty("SubformsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SubformsDesignRq.verify(message.SubformsDesign);
                            if (error)
                                return "SubformsDesign." + error;
                        }
                    }
                    if (message.SaveSubformsDesign != null && message.hasOwnProperty("SaveSubformsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SaveSubformsDesignRq.verify(message.SaveSubformsDesign);
                            if (error)
                                return "SaveSubformsDesign." + error;
                        }
                    }
                    if (message.ActionsDesign != null && message.hasOwnProperty("ActionsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ActionsDesignRq.verify(message.ActionsDesign);
                            if (error)
                                return "ActionsDesign." + error;
                        }
                    }
                    if (message.SaveActionsDesign != null && message.hasOwnProperty("SaveActionsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SaveActionsDesignRq.verify(message.SaveActionsDesign);
                            if (error)
                                return "SaveActionsDesign." + error;
                        }
                    }
                    if (message.PreField != null && message.hasOwnProperty("PreField")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.PreFieldRq.verify(message.PreField);
                            if (error)
                                return "PreField." + error;
                        }
                    }
                    if (message.FormToExcel != null && message.hasOwnProperty("FormToExcel")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FormToExcelRq.verify(message.FormToExcel);
                            if (error)
                                return "FormToExcel." + error;
                        }
                    }
                    if (message.GetUncompressedPrp != null && message.hasOwnProperty("GetUncompressedPrp")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.GetUncompressedPrpRq.verify(message.GetUncompressedPrp);
                            if (error)
                                return "GetUncompressedPrp." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Grpc2Net message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Grpc2Net} Grpc2Net
                 */
                Grpc2Net.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Grpc2Net)
                        return object;
                    var message = new $root.priority.netitems.form.Grpc2Net();
                    if (object.PrpData != null) {
                        if (typeof object.PrpData !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.PrpData: object expected");
                        message.PrpData = $root.priority.netitems.form.UncompressedPrpData.fromObject(object.PrpData);
                    }
                    if (object.SessionData != null)
                        if (typeof object.SessionData === "string")
                            $util.base64.decode(object.SessionData, message.SessionData = $util.newBuffer($util.base64.length(object.SessionData)), 0);
                        else if (object.SessionData.length)
                            message.SessionData = object.SessionData;
                    if (object.SessionID != null)
                        message.SessionID = String(object.SessionID);
                    if (object.Start != null) {
                        if (typeof object.Start !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Start: object expected");
                        message.Start = $root.priority.netitems.form.StartRq.fromObject(object.Start);
                    }
                    if (object.End != null) {
                        if (typeof object.End !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.End: object expected");
                        message.End = $root.priority.netitems.form.EndRq.fromObject(object.End);
                    }
                    if (object.RecordEdit != null) {
                        if (typeof object.RecordEdit !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RecordEdit: object expected");
                        message.RecordEdit = $root.priority.netitems.form.RecordEditRq.fromObject(object.RecordEdit);
                    }
                    if (object.RecordSave != null) {
                        if (typeof object.RecordSave !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RecordSave: object expected");
                        message.RecordSave = $root.priority.netitems.form.RecordSaveRq.fromObject(object.RecordSave);
                    }
                    if (object.FieldUpdate != null) {
                        if (typeof object.FieldUpdate !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.FieldUpdate: object expected");
                        message.FieldUpdate = $root.priority.netitems.form.FieldUpdateRq.fromObject(object.FieldUpdate);
                    }
                    if (object.Fetch != null) {
                        if (typeof object.Fetch !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Fetch: object expected");
                        message.Fetch = $root.priority.netitems.form.FetchRq.fromObject(object.Fetch);
                    }
                    if (object.Subforms != null) {
                        if (typeof object.Subforms !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Subforms: object expected");
                        message.Subforms = $root.priority.netitems.form.SubformsRq.fromObject(object.Subforms);
                    }
                    if (object.Subform != null) {
                        if (typeof object.Subform !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Subform: object expected");
                        message.Subform = $root.priority.netitems.form.SubformRq.fromObject(object.Subform);
                    }
                    if (object.Columns != null) {
                        if (typeof object.Columns !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Columns: object expected");
                        message.Columns = $root.priority.netitems.form.ColumnsRq.fromObject(object.Columns);
                    }
                    if (object.Actions != null) {
                        if (typeof object.Actions !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Actions: object expected");
                        message.Actions = $root.priority.netitems.form.ActionsRq.fromObject(object.Actions);
                    }
                    if (object.RecordDelete != null) {
                        if (typeof object.RecordDelete !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RecordDelete: object expected");
                        message.RecordDelete = $root.priority.netitems.form.RecordDeleteRq.fromObject(object.RecordDelete);
                    }
                    if (object.RecordUndo != null) {
                        if (typeof object.RecordUndo !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RecordUndo: object expected");
                        message.RecordUndo = $root.priority.netitems.form.RecordUndoRq.fromObject(object.RecordUndo);
                    }
                    if (object.WarningApprove != null) {
                        if (typeof object.WarningApprove !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.WarningApprove: object expected");
                        message.WarningApprove = $root.priority.netitems.form.WarningApproveRq.fromObject(object.WarningApprove);
                    }
                    if (object.HtmlUnlock != null) {
                        if (typeof object.HtmlUnlock !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.HtmlUnlock: object expected");
                        message.HtmlUnlock = $root.priority.netitems.form.HtmlUnlockRq.fromObject(object.HtmlUnlock);
                    }
                    if (object.HtmlState != null)
                        message.HtmlState = Boolean(object.HtmlState);
                    if (object.Olaps != null) {
                        if (typeof object.Olaps !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Olaps: object expected");
                        message.Olaps = $root.priority.netitems.form.OlapsRq.fromObject(object.Olaps);
                    }
                    if (object.RecordColors != null) {
                        if (typeof object.RecordColors !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RecordColors: object expected");
                        message.RecordColors = $root.priority.netitems.form.RecordColorsRq.fromObject(object.RecordColors);
                    }
                    if (object.SetRecordColor != null) {
                        if (typeof object.SetRecordColor !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.SetRecordColor: object expected");
                        message.SetRecordColor = $root.priority.netitems.form.SetRecordColorRq.fromObject(object.SetRecordColor);
                    }
                    if (object.RemoveAllColors != null) {
                        if (typeof object.RemoveAllColors !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RemoveAllColors: object expected");
                        message.RemoveAllColors = $root.priority.netitems.form.RemoveAllColorsRq.fromObject(object.RemoveAllColors);
                    }
                    if (object.Action != null) {
                        if (typeof object.Action !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Action: object expected");
                        message.Action = $root.priority.netitems.form.ActionRq.fromObject(object.Action);
                    }
                    if (object.RecordZoom != null) {
                        if (typeof object.RecordZoom !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RecordZoom: object expected");
                        message.RecordZoom = $root.priority.netitems.form.RecordZoomRq.fromObject(object.RecordZoom);
                    }
                    if (object.FieldUndo != null) {
                        if (typeof object.FieldUndo !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.FieldUndo: object expected");
                        message.FieldUndo = $root.priority.netitems.form.FieldUndoRq.fromObject(object.FieldUndo);
                    }
                    if (object.ActionEnd != null) {
                        if (typeof object.ActionEnd !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.ActionEnd: object expected");
                        message.ActionEnd = $root.priority.netitems.form.ActionEndRq.fromObject(object.ActionEnd);
                    }
                    if (object.HtmlFetch != null) {
                        if (typeof object.HtmlFetch !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.HtmlFetch: object expected");
                        message.HtmlFetch = $root.priority.netitems.form.HtmlFetchRq.fromObject(object.HtmlFetch);
                    }
                    if (object.HtmlSignature != null) {
                        if (typeof object.HtmlSignature !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.HtmlSignature: object expected");
                        message.HtmlSignature = $root.priority.netitems.form.HtmlSignatureRq.fromObject(object.HtmlSignature);
                    }
                    if (object.HtmlSave != null) {
                        if (typeof object.HtmlSave !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.HtmlSave: object expected");
                        message.HtmlSave = $root.priority.netitems.form.HtmlSaveRq.fromObject(object.HtmlSave);
                    }
                    if (object.FieldSelect != null) {
                        if (typeof object.FieldSelect !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.FieldSelect: object expected");
                        message.FieldSelect = $root.priority.netitems.form.FieldSelectRq.fromObject(object.FieldSelect);
                    }
                    if (object.Help != null) {
                        if (typeof object.Help !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Help: object expected");
                        message.Help = $root.priority.netitems.form.HelpRq.fromObject(object.Help);
                    }
                    if (object.SystemConstants != null) {
                        if (typeof object.SystemConstants !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.SystemConstants: object expected");
                        message.SystemConstants = $root.priority.netitems.form.SystemConstantsRq.fromObject(object.SystemConstants);
                    }
                    if (object.Statuses != null) {
                        if (typeof object.Statuses !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.Statuses: object expected");
                        message.Statuses = $root.priority.netitems.form.StatusesRq.fromObject(object.Statuses);
                    }
                    if (object.CountFetch != null) {
                        if (typeof object.CountFetch !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.CountFetch: object expected");
                        message.CountFetch = $root.priority.netitems.form.CountFetchRq.fromObject(object.CountFetch);
                    }
                    if (object.AlertCheckExpr != null) {
                        if (typeof object.AlertCheckExpr !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.AlertCheckExpr: object expected");
                        message.AlertCheckExpr = $root.priority.netitems.form.AlertCheckExprRq.fromObject(object.AlertCheckExpr);
                    }
                    if (object.AlertList != null) {
                        if (typeof object.AlertList !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.AlertList: object expected");
                        message.AlertList = $root.priority.netitems.form.AlertListRq.fromObject(object.AlertList);
                    }
                    if (object.AlertChooses != null) {
                        if (typeof object.AlertChooses !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.AlertChooses: object expected");
                        message.AlertChooses = $root.priority.netitems.form.AlertChoosesRq.fromObject(object.AlertChooses);
                    }
                    if (object.AlertSave != null) {
                        if (typeof object.AlertSave !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.AlertSave: object expected");
                        message.AlertSave = $root.priority.netitems.form.AlertSaveRq.fromObject(object.AlertSave);
                    }
                    if (object.AlertChoose != null) {
                        if (typeof object.AlertChoose !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.AlertChoose: object expected");
                        message.AlertChoose = $root.priority.netitems.form.AlertChooseRq.fromObject(object.AlertChoose);
                    }
                    if (object.AlertDelete != null) {
                        if (typeof object.AlertDelete !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.AlertDelete: object expected");
                        message.AlertDelete = $root.priority.netitems.form.AlertDeleteRq.fromObject(object.AlertDelete);
                    }
                    if (object.AlertOrder != null) {
                        if (typeof object.AlertOrder !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.AlertOrder: object expected");
                        message.AlertOrder = $root.priority.netitems.form.AlertOrderRq.fromObject(object.AlertOrder);
                    }
                    if (object.TableViewColumnsDesign != null) {
                        if (typeof object.TableViewColumnsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.TableViewColumnsDesign: object expected");
                        message.TableViewColumnsDesign = $root.priority.netitems.form.TableViewColumnsDesignRq.fromObject(object.TableViewColumnsDesign);
                    }
                    if (object.SaveTableViewColumnsDesign != null) {
                        if (typeof object.SaveTableViewColumnsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.SaveTableViewColumnsDesign: object expected");
                        message.SaveTableViewColumnsDesign = $root.priority.netitems.form.SaveTableViewColumnsDesignRq.fromObject(object.SaveTableViewColumnsDesign);
                    }
                    if (object.RowViewColumnsDesign != null) {
                        if (typeof object.RowViewColumnsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RowViewColumnsDesign: object expected");
                        message.RowViewColumnsDesign = $root.priority.netitems.form.RowViewColumnsDesignRq.fromObject(object.RowViewColumnsDesign);
                    }
                    if (object.SaveRowViewColumnsDesign != null) {
                        if (typeof object.SaveRowViewColumnsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.SaveRowViewColumnsDesign: object expected");
                        message.SaveRowViewColumnsDesign = $root.priority.netitems.form.SaveRowViewColumnsDesignRq.fromObject(object.SaveRowViewColumnsDesign);
                    }
                    if (object.RestoreDefaultDesign != null) {
                        if (typeof object.RestoreDefaultDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.RestoreDefaultDesign: object expected");
                        message.RestoreDefaultDesign = $root.priority.netitems.form.RestoreDefaultDesignRq.fromObject(object.RestoreDefaultDesign);
                    }
                    if (object.SubformsDesign != null) {
                        if (typeof object.SubformsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.SubformsDesign: object expected");
                        message.SubformsDesign = $root.priority.netitems.form.SubformsDesignRq.fromObject(object.SubformsDesign);
                    }
                    if (object.SaveSubformsDesign != null) {
                        if (typeof object.SaveSubformsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.SaveSubformsDesign: object expected");
                        message.SaveSubformsDesign = $root.priority.netitems.form.SaveSubformsDesignRq.fromObject(object.SaveSubformsDesign);
                    }
                    if (object.ActionsDesign != null) {
                        if (typeof object.ActionsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.ActionsDesign: object expected");
                        message.ActionsDesign = $root.priority.netitems.form.ActionsDesignRq.fromObject(object.ActionsDesign);
                    }
                    if (object.SaveActionsDesign != null) {
                        if (typeof object.SaveActionsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.SaveActionsDesign: object expected");
                        message.SaveActionsDesign = $root.priority.netitems.form.SaveActionsDesignRq.fromObject(object.SaveActionsDesign);
                    }
                    if (object.PreField != null) {
                        if (typeof object.PreField !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.PreField: object expected");
                        message.PreField = $root.priority.netitems.form.PreFieldRq.fromObject(object.PreField);
                    }
                    if (object.FormToExcel != null) {
                        if (typeof object.FormToExcel !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.FormToExcel: object expected");
                        message.FormToExcel = $root.priority.netitems.form.FormToExcelRq.fromObject(object.FormToExcel);
                    }
                    if (object.GetUncompressedPrp != null) {
                        if (typeof object.GetUncompressedPrp !== "object")
                            throw TypeError(".priority.netitems.form.Grpc2Net.GetUncompressedPrp: object expected");
                        message.GetUncompressedPrp = $root.priority.netitems.form.GetUncompressedPrpRq.fromObject(object.GetUncompressedPrp);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Grpc2Net message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Grpc2Net
                 * @static
                 * @param {priority.netitems.form.Grpc2Net} message Grpc2Net
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Grpc2Net.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.PrpData = null;
                        if (options.bytes === String)
                            object.SessionData = "";
                        else {
                            object.SessionData = [];
                            if (options.bytes !== Array)
                                object.SessionData = $util.newBuffer(object.SessionData);
                        }
                        object.SessionID = "";
                    }
                    if (message.Start != null && message.hasOwnProperty("Start")) {
                        object.Start = $root.priority.netitems.form.StartRq.toObject(message.Start, options);
                        if (options.oneofs)
                            object.inner = "Start";
                    }
                    if (message.End != null && message.hasOwnProperty("End")) {
                        object.End = $root.priority.netitems.form.EndRq.toObject(message.End, options);
                        if (options.oneofs)
                            object.inner = "End";
                    }
                    if (message.RecordEdit != null && message.hasOwnProperty("RecordEdit")) {
                        object.RecordEdit = $root.priority.netitems.form.RecordEditRq.toObject(message.RecordEdit, options);
                        if (options.oneofs)
                            object.inner = "RecordEdit";
                    }
                    if (message.RecordSave != null && message.hasOwnProperty("RecordSave")) {
                        object.RecordSave = $root.priority.netitems.form.RecordSaveRq.toObject(message.RecordSave, options);
                        if (options.oneofs)
                            object.inner = "RecordSave";
                    }
                    if (message.FieldUpdate != null && message.hasOwnProperty("FieldUpdate")) {
                        object.FieldUpdate = $root.priority.netitems.form.FieldUpdateRq.toObject(message.FieldUpdate, options);
                        if (options.oneofs)
                            object.inner = "FieldUpdate";
                    }
                    if (message.Fetch != null && message.hasOwnProperty("Fetch")) {
                        object.Fetch = $root.priority.netitems.form.FetchRq.toObject(message.Fetch, options);
                        if (options.oneofs)
                            object.inner = "Fetch";
                    }
                    if (message.Subforms != null && message.hasOwnProperty("Subforms")) {
                        object.Subforms = $root.priority.netitems.form.SubformsRq.toObject(message.Subforms, options);
                        if (options.oneofs)
                            object.inner = "Subforms";
                    }
                    if (message.Subform != null && message.hasOwnProperty("Subform")) {
                        object.Subform = $root.priority.netitems.form.SubformRq.toObject(message.Subform, options);
                        if (options.oneofs)
                            object.inner = "Subform";
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        object.Columns = $root.priority.netitems.form.ColumnsRq.toObject(message.Columns, options);
                        if (options.oneofs)
                            object.inner = "Columns";
                    }
                    if (message.Actions != null && message.hasOwnProperty("Actions")) {
                        object.Actions = $root.priority.netitems.form.ActionsRq.toObject(message.Actions, options);
                        if (options.oneofs)
                            object.inner = "Actions";
                    }
                    if (message.RecordDelete != null && message.hasOwnProperty("RecordDelete")) {
                        object.RecordDelete = $root.priority.netitems.form.RecordDeleteRq.toObject(message.RecordDelete, options);
                        if (options.oneofs)
                            object.inner = "RecordDelete";
                    }
                    if (message.RecordUndo != null && message.hasOwnProperty("RecordUndo")) {
                        object.RecordUndo = $root.priority.netitems.form.RecordUndoRq.toObject(message.RecordUndo, options);
                        if (options.oneofs)
                            object.inner = "RecordUndo";
                    }
                    if (message.WarningApprove != null && message.hasOwnProperty("WarningApprove")) {
                        object.WarningApprove = $root.priority.netitems.form.WarningApproveRq.toObject(message.WarningApprove, options);
                        if (options.oneofs)
                            object.inner = "WarningApprove";
                    }
                    if (message.HtmlUnlock != null && message.hasOwnProperty("HtmlUnlock")) {
                        object.HtmlUnlock = $root.priority.netitems.form.HtmlUnlockRq.toObject(message.HtmlUnlock, options);
                        if (options.oneofs)
                            object.inner = "HtmlUnlock";
                    }
                    if (message.HtmlState != null && message.hasOwnProperty("HtmlState")) {
                        object.HtmlState = message.HtmlState;
                        if (options.oneofs)
                            object.inner = "HtmlState";
                    }
                    if (message.Olaps != null && message.hasOwnProperty("Olaps")) {
                        object.Olaps = $root.priority.netitems.form.OlapsRq.toObject(message.Olaps, options);
                        if (options.oneofs)
                            object.inner = "Olaps";
                    }
                    if (message.RecordColors != null && message.hasOwnProperty("RecordColors")) {
                        object.RecordColors = $root.priority.netitems.form.RecordColorsRq.toObject(message.RecordColors, options);
                        if (options.oneofs)
                            object.inner = "RecordColors";
                    }
                    if (message.SetRecordColor != null && message.hasOwnProperty("SetRecordColor")) {
                        object.SetRecordColor = $root.priority.netitems.form.SetRecordColorRq.toObject(message.SetRecordColor, options);
                        if (options.oneofs)
                            object.inner = "SetRecordColor";
                    }
                    if (message.RemoveAllColors != null && message.hasOwnProperty("RemoveAllColors")) {
                        object.RemoveAllColors = $root.priority.netitems.form.RemoveAllColorsRq.toObject(message.RemoveAllColors, options);
                        if (options.oneofs)
                            object.inner = "RemoveAllColors";
                    }
                    if (message.Action != null && message.hasOwnProperty("Action")) {
                        object.Action = $root.priority.netitems.form.ActionRq.toObject(message.Action, options);
                        if (options.oneofs)
                            object.inner = "Action";
                    }
                    if (message.RecordZoom != null && message.hasOwnProperty("RecordZoom")) {
                        object.RecordZoom = $root.priority.netitems.form.RecordZoomRq.toObject(message.RecordZoom, options);
                        if (options.oneofs)
                            object.inner = "RecordZoom";
                    }
                    if (message.FieldUndo != null && message.hasOwnProperty("FieldUndo")) {
                        object.FieldUndo = $root.priority.netitems.form.FieldUndoRq.toObject(message.FieldUndo, options);
                        if (options.oneofs)
                            object.inner = "FieldUndo";
                    }
                    if (message.ActionEnd != null && message.hasOwnProperty("ActionEnd")) {
                        object.ActionEnd = $root.priority.netitems.form.ActionEndRq.toObject(message.ActionEnd, options);
                        if (options.oneofs)
                            object.inner = "ActionEnd";
                    }
                    if (message.HtmlFetch != null && message.hasOwnProperty("HtmlFetch")) {
                        object.HtmlFetch = $root.priority.netitems.form.HtmlFetchRq.toObject(message.HtmlFetch, options);
                        if (options.oneofs)
                            object.inner = "HtmlFetch";
                    }
                    if (message.HtmlSignature != null && message.hasOwnProperty("HtmlSignature")) {
                        object.HtmlSignature = $root.priority.netitems.form.HtmlSignatureRq.toObject(message.HtmlSignature, options);
                        if (options.oneofs)
                            object.inner = "HtmlSignature";
                    }
                    if (message.HtmlSave != null && message.hasOwnProperty("HtmlSave")) {
                        object.HtmlSave = $root.priority.netitems.form.HtmlSaveRq.toObject(message.HtmlSave, options);
                        if (options.oneofs)
                            object.inner = "HtmlSave";
                    }
                    if (message.FieldSelect != null && message.hasOwnProperty("FieldSelect")) {
                        object.FieldSelect = $root.priority.netitems.form.FieldSelectRq.toObject(message.FieldSelect, options);
                        if (options.oneofs)
                            object.inner = "FieldSelect";
                    }
                    if (message.Help != null && message.hasOwnProperty("Help")) {
                        object.Help = $root.priority.netitems.form.HelpRq.toObject(message.Help, options);
                        if (options.oneofs)
                            object.inner = "Help";
                    }
                    if (message.SystemConstants != null && message.hasOwnProperty("SystemConstants")) {
                        object.SystemConstants = $root.priority.netitems.form.SystemConstantsRq.toObject(message.SystemConstants, options);
                        if (options.oneofs)
                            object.inner = "SystemConstants";
                    }
                    if (message.Statuses != null && message.hasOwnProperty("Statuses")) {
                        object.Statuses = $root.priority.netitems.form.StatusesRq.toObject(message.Statuses, options);
                        if (options.oneofs)
                            object.inner = "Statuses";
                    }
                    if (message.CountFetch != null && message.hasOwnProperty("CountFetch")) {
                        object.CountFetch = $root.priority.netitems.form.CountFetchRq.toObject(message.CountFetch, options);
                        if (options.oneofs)
                            object.inner = "CountFetch";
                    }
                    if (message.AlertCheckExpr != null && message.hasOwnProperty("AlertCheckExpr")) {
                        object.AlertCheckExpr = $root.priority.netitems.form.AlertCheckExprRq.toObject(message.AlertCheckExpr, options);
                        if (options.oneofs)
                            object.inner = "AlertCheckExpr";
                    }
                    if (message.AlertList != null && message.hasOwnProperty("AlertList")) {
                        object.AlertList = $root.priority.netitems.form.AlertListRq.toObject(message.AlertList, options);
                        if (options.oneofs)
                            object.inner = "AlertList";
                    }
                    if (message.AlertChooses != null && message.hasOwnProperty("AlertChooses")) {
                        object.AlertChooses = $root.priority.netitems.form.AlertChoosesRq.toObject(message.AlertChooses, options);
                        if (options.oneofs)
                            object.inner = "AlertChooses";
                    }
                    if (message.TableViewColumnsDesign != null && message.hasOwnProperty("TableViewColumnsDesign")) {
                        object.TableViewColumnsDesign = $root.priority.netitems.form.TableViewColumnsDesignRq.toObject(message.TableViewColumnsDesign, options);
                        if (options.oneofs)
                            object.inner = "TableViewColumnsDesign";
                    }
                    if (message.AlertSave != null && message.hasOwnProperty("AlertSave")) {
                        object.AlertSave = $root.priority.netitems.form.AlertSaveRq.toObject(message.AlertSave, options);
                        if (options.oneofs)
                            object.inner = "AlertSave";
                    }
                    if (message.AlertChoose != null && message.hasOwnProperty("AlertChoose")) {
                        object.AlertChoose = $root.priority.netitems.form.AlertChooseRq.toObject(message.AlertChoose, options);
                        if (options.oneofs)
                            object.inner = "AlertChoose";
                    }
                    if (message.AlertDelete != null && message.hasOwnProperty("AlertDelete")) {
                        object.AlertDelete = $root.priority.netitems.form.AlertDeleteRq.toObject(message.AlertDelete, options);
                        if (options.oneofs)
                            object.inner = "AlertDelete";
                    }
                    if (message.AlertOrder != null && message.hasOwnProperty("AlertOrder")) {
                        object.AlertOrder = $root.priority.netitems.form.AlertOrderRq.toObject(message.AlertOrder, options);
                        if (options.oneofs)
                            object.inner = "AlertOrder";
                    }
                    if (message.RowViewColumnsDesign != null && message.hasOwnProperty("RowViewColumnsDesign")) {
                        object.RowViewColumnsDesign = $root.priority.netitems.form.RowViewColumnsDesignRq.toObject(message.RowViewColumnsDesign, options);
                        if (options.oneofs)
                            object.inner = "RowViewColumnsDesign";
                    }
                    if (message.SaveRowViewColumnsDesign != null && message.hasOwnProperty("SaveRowViewColumnsDesign")) {
                        object.SaveRowViewColumnsDesign = $root.priority.netitems.form.SaveRowViewColumnsDesignRq.toObject(message.SaveRowViewColumnsDesign, options);
                        if (options.oneofs)
                            object.inner = "SaveRowViewColumnsDesign";
                    }
                    if (message.PreField != null && message.hasOwnProperty("PreField")) {
                        object.PreField = $root.priority.netitems.form.PreFieldRq.toObject(message.PreField, options);
                        if (options.oneofs)
                            object.inner = "PreField";
                    }
                    if (message.RestoreDefaultDesign != null && message.hasOwnProperty("RestoreDefaultDesign")) {
                        object.RestoreDefaultDesign = $root.priority.netitems.form.RestoreDefaultDesignRq.toObject(message.RestoreDefaultDesign, options);
                        if (options.oneofs)
                            object.inner = "RestoreDefaultDesign";
                    }
                    if (message.SubformsDesign != null && message.hasOwnProperty("SubformsDesign")) {
                        object.SubformsDesign = $root.priority.netitems.form.SubformsDesignRq.toObject(message.SubformsDesign, options);
                        if (options.oneofs)
                            object.inner = "SubformsDesign";
                    }
                    if (message.SaveSubformsDesign != null && message.hasOwnProperty("SaveSubformsDesign")) {
                        object.SaveSubformsDesign = $root.priority.netitems.form.SaveSubformsDesignRq.toObject(message.SaveSubformsDesign, options);
                        if (options.oneofs)
                            object.inner = "SaveSubformsDesign";
                    }
                    if (message.ActionsDesign != null && message.hasOwnProperty("ActionsDesign")) {
                        object.ActionsDesign = $root.priority.netitems.form.ActionsDesignRq.toObject(message.ActionsDesign, options);
                        if (options.oneofs)
                            object.inner = "ActionsDesign";
                    }
                    if (message.SaveActionsDesign != null && message.hasOwnProperty("SaveActionsDesign")) {
                        object.SaveActionsDesign = $root.priority.netitems.form.SaveActionsDesignRq.toObject(message.SaveActionsDesign, options);
                        if (options.oneofs)
                            object.inner = "SaveActionsDesign";
                    }
                    if (message.SaveTableViewColumnsDesign != null && message.hasOwnProperty("SaveTableViewColumnsDesign")) {
                        object.SaveTableViewColumnsDesign = $root.priority.netitems.form.SaveTableViewColumnsDesignRq.toObject(message.SaveTableViewColumnsDesign, options);
                        if (options.oneofs)
                            object.inner = "SaveTableViewColumnsDesign";
                    }
                    if (message.FormToExcel != null && message.hasOwnProperty("FormToExcel")) {
                        object.FormToExcel = $root.priority.netitems.form.FormToExcelRq.toObject(message.FormToExcel, options);
                        if (options.oneofs)
                            object.inner = "FormToExcel";
                    }
                    if (message.GetUncompressedPrp != null && message.hasOwnProperty("GetUncompressedPrp")) {
                        object.GetUncompressedPrp = $root.priority.netitems.form.GetUncompressedPrpRq.toObject(message.GetUncompressedPrp, options);
                        if (options.oneofs)
                            object.inner = "GetUncompressedPrp";
                    }
                    if (message.PrpData != null && message.hasOwnProperty("PrpData"))
                        object.PrpData = $root.priority.netitems.form.UncompressedPrpData.toObject(message.PrpData, options);
                    if (message.SessionData != null && message.hasOwnProperty("SessionData"))
                        object.SessionData = options.bytes === String ? $util.base64.encode(message.SessionData, 0, message.SessionData.length) : options.bytes === Array ? Array.prototype.slice.call(message.SessionData) : message.SessionData;
                    if (message.SessionID != null && message.hasOwnProperty("SessionID"))
                        object.SessionID = message.SessionID;
                    return object;
                };

                /**
                 * Converts this Grpc2Net to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Grpc2Net
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Grpc2Net.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Grpc2Net;
            })();

            form.Net2Grpc = (function() {

                /**
                 * Properties of a Net2Grpc.
                 * @memberof priority.netitems.form
                 * @interface INet2Grpc
                 * @property {priority.netitems.shared.IGrpcError|null} [FatalError] Net2Grpc FatalError
                 * @property {priority.netitems.shared.IMessage|null} [ApplicationError] Net2Grpc ApplicationError
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] Net2Grpc Perf
                 * @property {Uint8Array|null} [SessionData] Net2Grpc SessionData
                 * @property {priority.netitems.form.IStartRs|null} [Start] Net2Grpc Start
                 * @property {priority.netitems.form.IEndRs|null} [End] Net2Grpc End
                 * @property {priority.netitems.form.IRecordEditRs|null} [RecordEdit] Net2Grpc RecordEdit
                 * @property {priority.netitems.form.IRecordSaveRs|null} [RecordSave] Net2Grpc RecordSave
                 * @property {priority.netitems.form.IFieldUpdateRs|null} [FieldUpdate] Net2Grpc FieldUpdate
                 * @property {priority.netitems.form.IFetchRs|null} [Fetch] Net2Grpc Fetch
                 * @property {priority.netitems.form.ISubformsRs|null} [Subforms] Net2Grpc Subforms
                 * @property {priority.netitems.form.IStartRs|null} [Subform] Net2Grpc Subform
                 * @property {priority.netitems.form.IColumnsRs|null} [Columns] Net2Grpc Columns
                 * @property {priority.netitems.form.IActionsRs|null} [Actions] Net2Grpc Actions
                 * @property {priority.netitems.form.IRecordDeleteRs|null} [RecordDelete] Net2Grpc RecordDelete
                 * @property {priority.netitems.form.IRecordUndoRs|null} [RecordUndo] Net2Grpc RecordUndo
                 * @property {priority.netitems.form.IWarningApproveRs|null} [WarningApprove] Net2Grpc WarningApprove
                 * @property {priority.netitems.form.IHtmlUnlockRs|null} [HtmlUnlock] Net2Grpc HtmlUnlock
                 * @property {priority.netitems.form.IOlapsRs|null} [Olaps] Net2Grpc Olaps
                 * @property {priority.netitems.form.IRecordColorsRs|null} [RecordColors] Net2Grpc RecordColors
                 * @property {priority.netitems.form.ISetRecordColorRs|null} [SetRecordColor] Net2Grpc SetRecordColor
                 * @property {priority.netitems.form.IRemoveAllColorsRs|null} [RemoveAllColors] Net2Grpc RemoveAllColors
                 * @property {priority.netitems.form.IActionRs|null} [Action] Net2Grpc Action
                 * @property {priority.netitems.form.IRecordZoomRs|null} [RecordZoom] Net2Grpc RecordZoom
                 * @property {priority.netitems.form.IFieldUndoRs|null} [FieldUndo] Net2Grpc FieldUndo
                 * @property {priority.netitems.form.IActionEndRs|null} [ActionEnd] Net2Grpc ActionEnd
                 * @property {priority.netitems.form.IHtmlFetchRs|null} [HtmlFetch] Net2Grpc HtmlFetch
                 * @property {priority.netitems.form.IHtmlSignatureRs|null} [HtmlSignature] Net2Grpc HtmlSignature
                 * @property {priority.netitems.form.IHtmlSaveRs|null} [HtmlSave] Net2Grpc HtmlSave
                 * @property {priority.netitems.form.IFieldSelectRs|null} [FieldSelect] Net2Grpc FieldSelect
                 * @property {priority.netitems.form.IHelpRs|null} [Help] Net2Grpc Help
                 * @property {priority.netitems.form.ISystemConstantsRs|null} [SystemConstants] Net2Grpc SystemConstants
                 * @property {priority.netitems.form.IStatusesRs|null} [Statuses] Net2Grpc Statuses
                 * @property {priority.netitems.form.ICountFetchRs|null} [CountFetch] Net2Grpc CountFetch
                 * @property {priority.netitems.form.IEmptyRs|null} [EmptyResponse] Net2Grpc EmptyResponse
                 * @property {priority.netitems.form.IAlertListRs|null} [AlertList] Net2Grpc AlertList
                 * @property {priority.netitems.form.IAlertChoosesRs|null} [AlertChooses] Net2Grpc AlertChooses
                 * @property {priority.netitems.form.IAlertListRs|null} [AlertSave] Net2Grpc AlertSave
                 * @property {priority.netitems.form.IAlertCheckExprRs|null} [AlertCheckExpr] Net2Grpc AlertCheckExpr
                 * @property {priority.netitems.form.ITableViewColumnsDesignRs|null} [TableViewColumnsDesign] Net2Grpc TableViewColumnsDesign
                 * @property {priority.netitems.form.ISaveTableViewColumnsDesignRs|null} [SaveTableViewColumnsDesign] Net2Grpc SaveTableViewColumnsDesign
                 * @property {priority.netitems.form.IRowViewColumnsDesignRs|null} [RowViewColumnsDesign] Net2Grpc RowViewColumnsDesign
                 * @property {priority.netitems.form.ISaveRowViewColumnsDesignRs|null} [SaveRowViewColumnsDesign] Net2Grpc SaveRowViewColumnsDesign
                 * @property {priority.netitems.form.IRestoreDefaultDesignRs|null} [RestoreDefaultDesign] Net2Grpc RestoreDefaultDesign
                 * @property {priority.netitems.form.ISubformsDesignRs|null} [SubformsDesign] Net2Grpc SubformsDesign
                 * @property {priority.netitems.form.ISaveSubformsDesignRs|null} [SaveSubformsDesign] Net2Grpc SaveSubformsDesign
                 * @property {priority.netitems.form.IActionsDesignRs|null} [ActionsDesign] Net2Grpc ActionsDesign
                 * @property {priority.netitems.form.ISaveActionsDesignRs|null} [SaveActionsDesign] Net2Grpc SaveActionsDesign
                 * @property {priority.netitems.form.IPreFieldRs|null} [PreField] Net2Grpc PreField
                 * @property {priority.netitems.form.IFormToExcelRs|null} [FormToExcel] Net2Grpc FormToExcel
                 * @property {priority.netitems.form.IGetUncompressedPrpRs|null} [GetUncompressedPrp] Net2Grpc GetUncompressedPrp
                 */

                /**
                 * Constructs a new Net2Grpc.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Net2Grpc.
                 * @implements INet2Grpc
                 * @constructor
                 * @param {priority.netitems.form.INet2Grpc=} [properties] Properties to set
                 */
                function Net2Grpc(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Net2Grpc FatalError.
                 * @member {priority.netitems.shared.IGrpcError|null|undefined} FatalError
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FatalError = null;

                /**
                 * Net2Grpc ApplicationError.
                 * @member {priority.netitems.shared.IMessage|null|undefined} ApplicationError
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ApplicationError = null;

                /**
                 * Net2Grpc Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Perf = null;

                /**
                 * Net2Grpc SessionData.
                 * @member {Uint8Array} SessionData
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.SessionData = $util.newBuffer([]);

                /**
                 * Net2Grpc Start.
                 * @member {priority.netitems.form.IStartRs|null|undefined} Start
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Start = null;

                /**
                 * Net2Grpc End.
                 * @member {priority.netitems.form.IEndRs|null|undefined} End
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.End = null;

                /**
                 * Net2Grpc RecordEdit.
                 * @member {priority.netitems.form.IRecordEditRs|null|undefined} RecordEdit
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RecordEdit = null;

                /**
                 * Net2Grpc RecordSave.
                 * @member {priority.netitems.form.IRecordSaveRs|null|undefined} RecordSave
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RecordSave = null;

                /**
                 * Net2Grpc FieldUpdate.
                 * @member {priority.netitems.form.IFieldUpdateRs|null|undefined} FieldUpdate
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FieldUpdate = null;

                /**
                 * Net2Grpc Fetch.
                 * @member {priority.netitems.form.IFetchRs|null|undefined} Fetch
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Fetch = null;

                /**
                 * Net2Grpc Subforms.
                 * @member {priority.netitems.form.ISubformsRs|null|undefined} Subforms
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Subforms = null;

                /**
                 * Net2Grpc Subform.
                 * @member {priority.netitems.form.IStartRs|null|undefined} Subform
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Subform = null;

                /**
                 * Net2Grpc Columns.
                 * @member {priority.netitems.form.IColumnsRs|null|undefined} Columns
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Columns = null;

                /**
                 * Net2Grpc Actions.
                 * @member {priority.netitems.form.IActionsRs|null|undefined} Actions
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Actions = null;

                /**
                 * Net2Grpc RecordDelete.
                 * @member {priority.netitems.form.IRecordDeleteRs|null|undefined} RecordDelete
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RecordDelete = null;

                /**
                 * Net2Grpc RecordUndo.
                 * @member {priority.netitems.form.IRecordUndoRs|null|undefined} RecordUndo
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RecordUndo = null;

                /**
                 * Net2Grpc WarningApprove.
                 * @member {priority.netitems.form.IWarningApproveRs|null|undefined} WarningApprove
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.WarningApprove = null;

                /**
                 * Net2Grpc HtmlUnlock.
                 * @member {priority.netitems.form.IHtmlUnlockRs|null|undefined} HtmlUnlock
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.HtmlUnlock = null;

                /**
                 * Net2Grpc Olaps.
                 * @member {priority.netitems.form.IOlapsRs|null|undefined} Olaps
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Olaps = null;

                /**
                 * Net2Grpc RecordColors.
                 * @member {priority.netitems.form.IRecordColorsRs|null|undefined} RecordColors
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RecordColors = null;

                /**
                 * Net2Grpc SetRecordColor.
                 * @member {priority.netitems.form.ISetRecordColorRs|null|undefined} SetRecordColor
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.SetRecordColor = null;

                /**
                 * Net2Grpc RemoveAllColors.
                 * @member {priority.netitems.form.IRemoveAllColorsRs|null|undefined} RemoveAllColors
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RemoveAllColors = null;

                /**
                 * Net2Grpc Action.
                 * @member {priority.netitems.form.IActionRs|null|undefined} Action
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Action = null;

                /**
                 * Net2Grpc RecordZoom.
                 * @member {priority.netitems.form.IRecordZoomRs|null|undefined} RecordZoom
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RecordZoom = null;

                /**
                 * Net2Grpc FieldUndo.
                 * @member {priority.netitems.form.IFieldUndoRs|null|undefined} FieldUndo
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FieldUndo = null;

                /**
                 * Net2Grpc ActionEnd.
                 * @member {priority.netitems.form.IActionEndRs|null|undefined} ActionEnd
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ActionEnd = null;

                /**
                 * Net2Grpc HtmlFetch.
                 * @member {priority.netitems.form.IHtmlFetchRs|null|undefined} HtmlFetch
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.HtmlFetch = null;

                /**
                 * Net2Grpc HtmlSignature.
                 * @member {priority.netitems.form.IHtmlSignatureRs|null|undefined} HtmlSignature
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.HtmlSignature = null;

                /**
                 * Net2Grpc HtmlSave.
                 * @member {priority.netitems.form.IHtmlSaveRs|null|undefined} HtmlSave
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.HtmlSave = null;

                /**
                 * Net2Grpc FieldSelect.
                 * @member {priority.netitems.form.IFieldSelectRs|null|undefined} FieldSelect
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FieldSelect = null;

                /**
                 * Net2Grpc Help.
                 * @member {priority.netitems.form.IHelpRs|null|undefined} Help
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Help = null;

                /**
                 * Net2Grpc SystemConstants.
                 * @member {priority.netitems.form.ISystemConstantsRs|null|undefined} SystemConstants
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.SystemConstants = null;

                /**
                 * Net2Grpc Statuses.
                 * @member {priority.netitems.form.IStatusesRs|null|undefined} Statuses
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Statuses = null;

                /**
                 * Net2Grpc CountFetch.
                 * @member {priority.netitems.form.ICountFetchRs|null|undefined} CountFetch
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.CountFetch = null;

                /**
                 * Net2Grpc EmptyResponse.
                 * @member {priority.netitems.form.IEmptyRs|null|undefined} EmptyResponse
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.EmptyResponse = null;

                /**
                 * Net2Grpc AlertList.
                 * @member {priority.netitems.form.IAlertListRs|null|undefined} AlertList
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.AlertList = null;

                /**
                 * Net2Grpc AlertChooses.
                 * @member {priority.netitems.form.IAlertChoosesRs|null|undefined} AlertChooses
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.AlertChooses = null;

                /**
                 * Net2Grpc AlertSave.
                 * @member {priority.netitems.form.IAlertListRs|null|undefined} AlertSave
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.AlertSave = null;

                /**
                 * Net2Grpc AlertCheckExpr.
                 * @member {priority.netitems.form.IAlertCheckExprRs|null|undefined} AlertCheckExpr
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.AlertCheckExpr = null;

                /**
                 * Net2Grpc TableViewColumnsDesign.
                 * @member {priority.netitems.form.ITableViewColumnsDesignRs|null|undefined} TableViewColumnsDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.TableViewColumnsDesign = null;

                /**
                 * Net2Grpc SaveTableViewColumnsDesign.
                 * @member {priority.netitems.form.ISaveTableViewColumnsDesignRs|null|undefined} SaveTableViewColumnsDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.SaveTableViewColumnsDesign = null;

                /**
                 * Net2Grpc RowViewColumnsDesign.
                 * @member {priority.netitems.form.IRowViewColumnsDesignRs|null|undefined} RowViewColumnsDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RowViewColumnsDesign = null;

                /**
                 * Net2Grpc SaveRowViewColumnsDesign.
                 * @member {priority.netitems.form.ISaveRowViewColumnsDesignRs|null|undefined} SaveRowViewColumnsDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.SaveRowViewColumnsDesign = null;

                /**
                 * Net2Grpc RestoreDefaultDesign.
                 * @member {priority.netitems.form.IRestoreDefaultDesignRs|null|undefined} RestoreDefaultDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.RestoreDefaultDesign = null;

                /**
                 * Net2Grpc SubformsDesign.
                 * @member {priority.netitems.form.ISubformsDesignRs|null|undefined} SubformsDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.SubformsDesign = null;

                /**
                 * Net2Grpc SaveSubformsDesign.
                 * @member {priority.netitems.form.ISaveSubformsDesignRs|null|undefined} SaveSubformsDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.SaveSubformsDesign = null;

                /**
                 * Net2Grpc ActionsDesign.
                 * @member {priority.netitems.form.IActionsDesignRs|null|undefined} ActionsDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ActionsDesign = null;

                /**
                 * Net2Grpc SaveActionsDesign.
                 * @member {priority.netitems.form.ISaveActionsDesignRs|null|undefined} SaveActionsDesign
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.SaveActionsDesign = null;

                /**
                 * Net2Grpc PreField.
                 * @member {priority.netitems.form.IPreFieldRs|null|undefined} PreField
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.PreField = null;

                /**
                 * Net2Grpc FormToExcel.
                 * @member {priority.netitems.form.IFormToExcelRs|null|undefined} FormToExcel
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FormToExcel = null;

                /**
                 * Net2Grpc GetUncompressedPrp.
                 * @member {priority.netitems.form.IGetUncompressedPrpRs|null|undefined} GetUncompressedPrp
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.GetUncompressedPrp = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Net2Grpc inner.
                 * @member {"Start"|"End"|"RecordEdit"|"RecordSave"|"FieldUpdate"|"Fetch"|"Subforms"|"Subform"|"Columns"|"Actions"|"RecordDelete"|"RecordUndo"|"WarningApprove"|"HtmlUnlock"|"Olaps"|"RecordColors"|"SetRecordColor"|"RemoveAllColors"|"Action"|"RecordZoom"|"FieldUndo"|"ActionEnd"|"HtmlFetch"|"HtmlSignature"|"HtmlSave"|"FieldSelect"|"Help"|"SystemConstants"|"Statuses"|"CountFetch"|"EmptyResponse"|"AlertList"|"AlertChooses"|"AlertSave"|"AlertCheckExpr"|"TableViewColumnsDesign"|"SaveTableViewColumnsDesign"|"RowViewColumnsDesign"|"SaveRowViewColumnsDesign"|"RestoreDefaultDesign"|"SubformsDesign"|"SaveSubformsDesign"|"ActionsDesign"|"SaveActionsDesign"|"PreField"|"FormToExcel"|"GetUncompressedPrp"|undefined} inner
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 */
                Object.defineProperty(Net2Grpc.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["Start", "End", "RecordEdit", "RecordSave", "FieldUpdate", "Fetch", "Subforms", "Subform", "Columns", "Actions", "RecordDelete", "RecordUndo", "WarningApprove", "HtmlUnlock", "Olaps", "RecordColors", "SetRecordColor", "RemoveAllColors", "Action", "RecordZoom", "FieldUndo", "ActionEnd", "HtmlFetch", "HtmlSignature", "HtmlSave", "FieldSelect", "Help", "SystemConstants", "Statuses", "CountFetch", "EmptyResponse", "AlertList", "AlertChooses", "AlertSave", "AlertCheckExpr", "TableViewColumnsDesign", "SaveTableViewColumnsDesign", "RowViewColumnsDesign", "SaveRowViewColumnsDesign", "RestoreDefaultDesign", "SubformsDesign", "SaveSubformsDesign", "ActionsDesign", "SaveActionsDesign", "PreField", "FormToExcel", "GetUncompressedPrp"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Net2Grpc instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Net2Grpc
                 * @static
                 * @param {priority.netitems.form.INet2Grpc=} [properties] Properties to set
                 * @returns {priority.netitems.form.Net2Grpc} Net2Grpc instance
                 */
                Net2Grpc.create = function create(properties) {
                    return new Net2Grpc(properties);
                };

                /**
                 * Encodes the specified Net2Grpc message. Does not implicitly {@link priority.netitems.form.Net2Grpc.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Net2Grpc
                 * @static
                 * @param {priority.netitems.form.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.FatalError != null && Object.hasOwnProperty.call(message, "FatalError"))
                        $root.priority.netitems.shared.GrpcError.encode(message.FatalError, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ApplicationError != null && Object.hasOwnProperty.call(message, "ApplicationError"))
                        $root.priority.netitems.shared.Message.encode(message.ApplicationError, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Start != null && Object.hasOwnProperty.call(message, "Start"))
                        $root.priority.netitems.form.StartRs.encode(message.Start, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.End != null && Object.hasOwnProperty.call(message, "End"))
                        $root.priority.netitems.form.EndRs.encode(message.End, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.RecordEdit != null && Object.hasOwnProperty.call(message, "RecordEdit"))
                        $root.priority.netitems.form.RecordEditRs.encode(message.RecordEdit, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.RecordSave != null && Object.hasOwnProperty.call(message, "RecordSave"))
                        $root.priority.netitems.form.RecordSaveRs.encode(message.RecordSave, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.FieldUpdate != null && Object.hasOwnProperty.call(message, "FieldUpdate"))
                        $root.priority.netitems.form.FieldUpdateRs.encode(message.FieldUpdate, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.Fetch != null && Object.hasOwnProperty.call(message, "Fetch"))
                        $root.priority.netitems.form.FetchRs.encode(message.Fetch, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.Subforms != null && Object.hasOwnProperty.call(message, "Subforms"))
                        $root.priority.netitems.form.SubformsRs.encode(message.Subforms, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.Subform != null && Object.hasOwnProperty.call(message, "Subform"))
                        $root.priority.netitems.form.StartRs.encode(message.Subform, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.Columns != null && Object.hasOwnProperty.call(message, "Columns"))
                        $root.priority.netitems.form.ColumnsRs.encode(message.Columns, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.Actions != null && Object.hasOwnProperty.call(message, "Actions"))
                        $root.priority.netitems.form.ActionsRs.encode(message.Actions, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.RecordDelete != null && Object.hasOwnProperty.call(message, "RecordDelete"))
                        $root.priority.netitems.form.RecordDeleteRs.encode(message.RecordDelete, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.RecordUndo != null && Object.hasOwnProperty.call(message, "RecordUndo"))
                        $root.priority.netitems.form.RecordUndoRs.encode(message.RecordUndo, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.WarningApprove != null && Object.hasOwnProperty.call(message, "WarningApprove"))
                        $root.priority.netitems.form.WarningApproveRs.encode(message.WarningApprove, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.HtmlUnlock != null && Object.hasOwnProperty.call(message, "HtmlUnlock"))
                        $root.priority.netitems.form.HtmlUnlockRs.encode(message.HtmlUnlock, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.Olaps != null && Object.hasOwnProperty.call(message, "Olaps"))
                        $root.priority.netitems.form.OlapsRs.encode(message.Olaps, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.RecordColors != null && Object.hasOwnProperty.call(message, "RecordColors"))
                        $root.priority.netitems.form.RecordColorsRs.encode(message.RecordColors, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                    if (message.SetRecordColor != null && Object.hasOwnProperty.call(message, "SetRecordColor"))
                        $root.priority.netitems.form.SetRecordColorRs.encode(message.SetRecordColor, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    if (message.RemoveAllColors != null && Object.hasOwnProperty.call(message, "RemoveAllColors"))
                        $root.priority.netitems.form.RemoveAllColorsRs.encode(message.RemoveAllColors, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                    if (message.Action != null && Object.hasOwnProperty.call(message, "Action"))
                        $root.priority.netitems.form.ActionRs.encode(message.Action, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                    if (message.RecordZoom != null && Object.hasOwnProperty.call(message, "RecordZoom"))
                        $root.priority.netitems.form.RecordZoomRs.encode(message.RecordZoom, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
                    if (message.FieldUndo != null && Object.hasOwnProperty.call(message, "FieldUndo"))
                        $root.priority.netitems.form.FieldUndoRs.encode(message.FieldUndo, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                    if (message.ActionEnd != null && Object.hasOwnProperty.call(message, "ActionEnd"))
                        $root.priority.netitems.form.ActionEndRs.encode(message.ActionEnd, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                    if (message.HtmlFetch != null && Object.hasOwnProperty.call(message, "HtmlFetch"))
                        $root.priority.netitems.form.HtmlFetchRs.encode(message.HtmlFetch, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
                    if (message.HtmlSignature != null && Object.hasOwnProperty.call(message, "HtmlSignature"))
                        $root.priority.netitems.form.HtmlSignatureRs.encode(message.HtmlSignature, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                    if (message.HtmlSave != null && Object.hasOwnProperty.call(message, "HtmlSave"))
                        $root.priority.netitems.form.HtmlSaveRs.encode(message.HtmlSave, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
                    if (message.FieldSelect != null && Object.hasOwnProperty.call(message, "FieldSelect"))
                        $root.priority.netitems.form.FieldSelectRs.encode(message.FieldSelect, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
                    if (message.Help != null && Object.hasOwnProperty.call(message, "Help"))
                        $root.priority.netitems.form.HelpRs.encode(message.Help, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
                    if (message.SystemConstants != null && Object.hasOwnProperty.call(message, "SystemConstants"))
                        $root.priority.netitems.form.SystemConstantsRs.encode(message.SystemConstants, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
                    if (message.Statuses != null && Object.hasOwnProperty.call(message, "Statuses"))
                        $root.priority.netitems.form.StatusesRs.encode(message.Statuses, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                    if (message.CountFetch != null && Object.hasOwnProperty.call(message, "CountFetch"))
                        $root.priority.netitems.form.CountFetchRs.encode(message.CountFetch, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
                    if (message.EmptyResponse != null && Object.hasOwnProperty.call(message, "EmptyResponse"))
                        $root.priority.netitems.form.EmptyRs.encode(message.EmptyResponse, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
                    if (message.AlertList != null && Object.hasOwnProperty.call(message, "AlertList"))
                        $root.priority.netitems.form.AlertListRs.encode(message.AlertList, writer.uint32(/* id 37, wireType 2 =*/298).fork()).ldelim();
                    if (message.AlertChooses != null && Object.hasOwnProperty.call(message, "AlertChooses"))
                        $root.priority.netitems.form.AlertChoosesRs.encode(message.AlertChooses, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
                    if (message.TableViewColumnsDesign != null && Object.hasOwnProperty.call(message, "TableViewColumnsDesign"))
                        $root.priority.netitems.form.TableViewColumnsDesignRs.encode(message.TableViewColumnsDesign, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
                    if (message.AlertSave != null && Object.hasOwnProperty.call(message, "AlertSave"))
                        $root.priority.netitems.form.AlertListRs.encode(message.AlertSave, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
                    if (message.AlertCheckExpr != null && Object.hasOwnProperty.call(message, "AlertCheckExpr"))
                        $root.priority.netitems.form.AlertCheckExprRs.encode(message.AlertCheckExpr, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
                    if (message.RowViewColumnsDesign != null && Object.hasOwnProperty.call(message, "RowViewColumnsDesign"))
                        $root.priority.netitems.form.RowViewColumnsDesignRs.encode(message.RowViewColumnsDesign, writer.uint32(/* id 44, wireType 2 =*/354).fork()).ldelim();
                    if (message.SaveRowViewColumnsDesign != null && Object.hasOwnProperty.call(message, "SaveRowViewColumnsDesign"))
                        $root.priority.netitems.form.SaveRowViewColumnsDesignRs.encode(message.SaveRowViewColumnsDesign, writer.uint32(/* id 45, wireType 2 =*/362).fork()).ldelim();
                    if (message.PreField != null && Object.hasOwnProperty.call(message, "PreField"))
                        $root.priority.netitems.form.PreFieldRs.encode(message.PreField, writer.uint32(/* id 46, wireType 2 =*/370).fork()).ldelim();
                    if (message.RestoreDefaultDesign != null && Object.hasOwnProperty.call(message, "RestoreDefaultDesign"))
                        $root.priority.netitems.form.RestoreDefaultDesignRs.encode(message.RestoreDefaultDesign, writer.uint32(/* id 47, wireType 2 =*/378).fork()).ldelim();
                    if (message.SubformsDesign != null && Object.hasOwnProperty.call(message, "SubformsDesign"))
                        $root.priority.netitems.form.SubformsDesignRs.encode(message.SubformsDesign, writer.uint32(/* id 48, wireType 2 =*/386).fork()).ldelim();
                    if (message.SaveSubformsDesign != null && Object.hasOwnProperty.call(message, "SaveSubformsDesign"))
                        $root.priority.netitems.form.SaveSubformsDesignRs.encode(message.SaveSubformsDesign, writer.uint32(/* id 49, wireType 2 =*/394).fork()).ldelim();
                    if (message.ActionsDesign != null && Object.hasOwnProperty.call(message, "ActionsDesign"))
                        $root.priority.netitems.form.ActionsDesignRs.encode(message.ActionsDesign, writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
                    if (message.SaveActionsDesign != null && Object.hasOwnProperty.call(message, "SaveActionsDesign"))
                        $root.priority.netitems.form.SaveActionsDesignRs.encode(message.SaveActionsDesign, writer.uint32(/* id 51, wireType 2 =*/410).fork()).ldelim();
                    if (message.SaveTableViewColumnsDesign != null && Object.hasOwnProperty.call(message, "SaveTableViewColumnsDesign"))
                        $root.priority.netitems.form.SaveTableViewColumnsDesignRs.encode(message.SaveTableViewColumnsDesign, writer.uint32(/* id 52, wireType 2 =*/418).fork()).ldelim();
                    if (message.FormToExcel != null && Object.hasOwnProperty.call(message, "FormToExcel"))
                        $root.priority.netitems.form.FormToExcelRs.encode(message.FormToExcel, writer.uint32(/* id 60, wireType 2 =*/482).fork()).ldelim();
                    if (message.GetUncompressedPrp != null && Object.hasOwnProperty.call(message, "GetUncompressedPrp"))
                        $root.priority.netitems.form.GetUncompressedPrpRs.encode(message.GetUncompressedPrp, writer.uint32(/* id 64, wireType 2 =*/514).fork()).ldelim();
                    if (message.SessionData != null && Object.hasOwnProperty.call(message, "SessionData"))
                        writer.uint32(/* id 101, wireType 2 =*/810).bytes(message.SessionData);
                    return writer;
                };

                /**
                 * Encodes the specified Net2Grpc message, length delimited. Does not implicitly {@link priority.netitems.form.Net2Grpc.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Net2Grpc
                 * @static
                 * @param {priority.netitems.form.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Net2Grpc();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.FatalError = $root.priority.netitems.shared.GrpcError.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.ApplicationError = $root.priority.netitems.shared.Message.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 101:
                            message.SessionData = reader.bytes();
                            break;
                        case 4:
                            message.Start = $root.priority.netitems.form.StartRs.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.End = $root.priority.netitems.form.EndRs.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.RecordEdit = $root.priority.netitems.form.RecordEditRs.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.RecordSave = $root.priority.netitems.form.RecordSaveRs.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.FieldUpdate = $root.priority.netitems.form.FieldUpdateRs.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.Fetch = $root.priority.netitems.form.FetchRs.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.Subforms = $root.priority.netitems.form.SubformsRs.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.Subform = $root.priority.netitems.form.StartRs.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.Columns = $root.priority.netitems.form.ColumnsRs.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.Actions = $root.priority.netitems.form.ActionsRs.decode(reader, reader.uint32());
                            break;
                        case 14:
                            message.RecordDelete = $root.priority.netitems.form.RecordDeleteRs.decode(reader, reader.uint32());
                            break;
                        case 15:
                            message.RecordUndo = $root.priority.netitems.form.RecordUndoRs.decode(reader, reader.uint32());
                            break;
                        case 16:
                            message.WarningApprove = $root.priority.netitems.form.WarningApproveRs.decode(reader, reader.uint32());
                            break;
                        case 17:
                            message.HtmlUnlock = $root.priority.netitems.form.HtmlUnlockRs.decode(reader, reader.uint32());
                            break;
                        case 18:
                            message.Olaps = $root.priority.netitems.form.OlapsRs.decode(reader, reader.uint32());
                            break;
                        case 20:
                            message.RecordColors = $root.priority.netitems.form.RecordColorsRs.decode(reader, reader.uint32());
                            break;
                        case 21:
                            message.SetRecordColor = $root.priority.netitems.form.SetRecordColorRs.decode(reader, reader.uint32());
                            break;
                        case 22:
                            message.RemoveAllColors = $root.priority.netitems.form.RemoveAllColorsRs.decode(reader, reader.uint32());
                            break;
                        case 23:
                            message.Action = $root.priority.netitems.form.ActionRs.decode(reader, reader.uint32());
                            break;
                        case 24:
                            message.RecordZoom = $root.priority.netitems.form.RecordZoomRs.decode(reader, reader.uint32());
                            break;
                        case 25:
                            message.FieldUndo = $root.priority.netitems.form.FieldUndoRs.decode(reader, reader.uint32());
                            break;
                        case 26:
                            message.ActionEnd = $root.priority.netitems.form.ActionEndRs.decode(reader, reader.uint32());
                            break;
                        case 27:
                            message.HtmlFetch = $root.priority.netitems.form.HtmlFetchRs.decode(reader, reader.uint32());
                            break;
                        case 28:
                            message.HtmlSignature = $root.priority.netitems.form.HtmlSignatureRs.decode(reader, reader.uint32());
                            break;
                        case 29:
                            message.HtmlSave = $root.priority.netitems.form.HtmlSaveRs.decode(reader, reader.uint32());
                            break;
                        case 30:
                            message.FieldSelect = $root.priority.netitems.form.FieldSelectRs.decode(reader, reader.uint32());
                            break;
                        case 31:
                            message.Help = $root.priority.netitems.form.HelpRs.decode(reader, reader.uint32());
                            break;
                        case 33:
                            message.SystemConstants = $root.priority.netitems.form.SystemConstantsRs.decode(reader, reader.uint32());
                            break;
                        case 34:
                            message.Statuses = $root.priority.netitems.form.StatusesRs.decode(reader, reader.uint32());
                            break;
                        case 35:
                            message.CountFetch = $root.priority.netitems.form.CountFetchRs.decode(reader, reader.uint32());
                            break;
                        case 36:
                            message.EmptyResponse = $root.priority.netitems.form.EmptyRs.decode(reader, reader.uint32());
                            break;
                        case 37:
                            message.AlertList = $root.priority.netitems.form.AlertListRs.decode(reader, reader.uint32());
                            break;
                        case 38:
                            message.AlertChooses = $root.priority.netitems.form.AlertChoosesRs.decode(reader, reader.uint32());
                            break;
                        case 40:
                            message.AlertSave = $root.priority.netitems.form.AlertListRs.decode(reader, reader.uint32());
                            break;
                        case 42:
                            message.AlertCheckExpr = $root.priority.netitems.form.AlertCheckExprRs.decode(reader, reader.uint32());
                            break;
                        case 39:
                            message.TableViewColumnsDesign = $root.priority.netitems.form.TableViewColumnsDesignRs.decode(reader, reader.uint32());
                            break;
                        case 52:
                            message.SaveTableViewColumnsDesign = $root.priority.netitems.form.SaveTableViewColumnsDesignRs.decode(reader, reader.uint32());
                            break;
                        case 44:
                            message.RowViewColumnsDesign = $root.priority.netitems.form.RowViewColumnsDesignRs.decode(reader, reader.uint32());
                            break;
                        case 45:
                            message.SaveRowViewColumnsDesign = $root.priority.netitems.form.SaveRowViewColumnsDesignRs.decode(reader, reader.uint32());
                            break;
                        case 47:
                            message.RestoreDefaultDesign = $root.priority.netitems.form.RestoreDefaultDesignRs.decode(reader, reader.uint32());
                            break;
                        case 48:
                            message.SubformsDesign = $root.priority.netitems.form.SubformsDesignRs.decode(reader, reader.uint32());
                            break;
                        case 49:
                            message.SaveSubformsDesign = $root.priority.netitems.form.SaveSubformsDesignRs.decode(reader, reader.uint32());
                            break;
                        case 50:
                            message.ActionsDesign = $root.priority.netitems.form.ActionsDesignRs.decode(reader, reader.uint32());
                            break;
                        case 51:
                            message.SaveActionsDesign = $root.priority.netitems.form.SaveActionsDesignRs.decode(reader, reader.uint32());
                            break;
                        case 46:
                            message.PreField = $root.priority.netitems.form.PreFieldRs.decode(reader, reader.uint32());
                            break;
                        case 60:
                            message.FormToExcel = $root.priority.netitems.form.FormToExcelRs.decode(reader, reader.uint32());
                            break;
                        case 64:
                            message.GetUncompressedPrp = $root.priority.netitems.form.GetUncompressedPrpRs.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Net2Grpc message.
                 * @function verify
                 * @memberof priority.netitems.form.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Net2Grpc.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.FatalError != null && message.hasOwnProperty("FatalError")) {
                        var error = $root.priority.netitems.shared.GrpcError.verify(message.FatalError);
                        if (error)
                            return "FatalError." + error;
                    }
                    if (message.ApplicationError != null && message.hasOwnProperty("ApplicationError")) {
                        var error = $root.priority.netitems.shared.Message.verify(message.ApplicationError);
                        if (error)
                            return "ApplicationError." + error;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.SessionData != null && message.hasOwnProperty("SessionData"))
                        if (!(message.SessionData && typeof message.SessionData.length === "number" || $util.isString(message.SessionData)))
                            return "SessionData: buffer expected";
                    if (message.Start != null && message.hasOwnProperty("Start")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.StartRs.verify(message.Start);
                            if (error)
                                return "Start." + error;
                        }
                    }
                    if (message.End != null && message.hasOwnProperty("End")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.EndRs.verify(message.End);
                            if (error)
                                return "End." + error;
                        }
                    }
                    if (message.RecordEdit != null && message.hasOwnProperty("RecordEdit")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordEditRs.verify(message.RecordEdit);
                            if (error)
                                return "RecordEdit." + error;
                        }
                    }
                    if (message.RecordSave != null && message.hasOwnProperty("RecordSave")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordSaveRs.verify(message.RecordSave);
                            if (error)
                                return "RecordSave." + error;
                        }
                    }
                    if (message.FieldUpdate != null && message.hasOwnProperty("FieldUpdate")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FieldUpdateRs.verify(message.FieldUpdate);
                            if (error)
                                return "FieldUpdate." + error;
                        }
                    }
                    if (message.Fetch != null && message.hasOwnProperty("Fetch")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FetchRs.verify(message.Fetch);
                            if (error)
                                return "Fetch." + error;
                        }
                    }
                    if (message.Subforms != null && message.hasOwnProperty("Subforms")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SubformsRs.verify(message.Subforms);
                            if (error)
                                return "Subforms." + error;
                        }
                    }
                    if (message.Subform != null && message.hasOwnProperty("Subform")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.StartRs.verify(message.Subform);
                            if (error)
                                return "Subform." + error;
                        }
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ColumnsRs.verify(message.Columns);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.Actions != null && message.hasOwnProperty("Actions")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ActionsRs.verify(message.Actions);
                            if (error)
                                return "Actions." + error;
                        }
                    }
                    if (message.RecordDelete != null && message.hasOwnProperty("RecordDelete")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordDeleteRs.verify(message.RecordDelete);
                            if (error)
                                return "RecordDelete." + error;
                        }
                    }
                    if (message.RecordUndo != null && message.hasOwnProperty("RecordUndo")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordUndoRs.verify(message.RecordUndo);
                            if (error)
                                return "RecordUndo." + error;
                        }
                    }
                    if (message.WarningApprove != null && message.hasOwnProperty("WarningApprove")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.WarningApproveRs.verify(message.WarningApprove);
                            if (error)
                                return "WarningApprove." + error;
                        }
                    }
                    if (message.HtmlUnlock != null && message.hasOwnProperty("HtmlUnlock")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HtmlUnlockRs.verify(message.HtmlUnlock);
                            if (error)
                                return "HtmlUnlock." + error;
                        }
                    }
                    if (message.Olaps != null && message.hasOwnProperty("Olaps")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.OlapsRs.verify(message.Olaps);
                            if (error)
                                return "Olaps." + error;
                        }
                    }
                    if (message.RecordColors != null && message.hasOwnProperty("RecordColors")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordColorsRs.verify(message.RecordColors);
                            if (error)
                                return "RecordColors." + error;
                        }
                    }
                    if (message.SetRecordColor != null && message.hasOwnProperty("SetRecordColor")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SetRecordColorRs.verify(message.SetRecordColor);
                            if (error)
                                return "SetRecordColor." + error;
                        }
                    }
                    if (message.RemoveAllColors != null && message.hasOwnProperty("RemoveAllColors")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RemoveAllColorsRs.verify(message.RemoveAllColors);
                            if (error)
                                return "RemoveAllColors." + error;
                        }
                    }
                    if (message.Action != null && message.hasOwnProperty("Action")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ActionRs.verify(message.Action);
                            if (error)
                                return "Action." + error;
                        }
                    }
                    if (message.RecordZoom != null && message.hasOwnProperty("RecordZoom")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RecordZoomRs.verify(message.RecordZoom);
                            if (error)
                                return "RecordZoom." + error;
                        }
                    }
                    if (message.FieldUndo != null && message.hasOwnProperty("FieldUndo")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FieldUndoRs.verify(message.FieldUndo);
                            if (error)
                                return "FieldUndo." + error;
                        }
                    }
                    if (message.ActionEnd != null && message.hasOwnProperty("ActionEnd")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ActionEndRs.verify(message.ActionEnd);
                            if (error)
                                return "ActionEnd." + error;
                        }
                    }
                    if (message.HtmlFetch != null && message.hasOwnProperty("HtmlFetch")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HtmlFetchRs.verify(message.HtmlFetch);
                            if (error)
                                return "HtmlFetch." + error;
                        }
                    }
                    if (message.HtmlSignature != null && message.hasOwnProperty("HtmlSignature")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HtmlSignatureRs.verify(message.HtmlSignature);
                            if (error)
                                return "HtmlSignature." + error;
                        }
                    }
                    if (message.HtmlSave != null && message.hasOwnProperty("HtmlSave")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HtmlSaveRs.verify(message.HtmlSave);
                            if (error)
                                return "HtmlSave." + error;
                        }
                    }
                    if (message.FieldSelect != null && message.hasOwnProperty("FieldSelect")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FieldSelectRs.verify(message.FieldSelect);
                            if (error)
                                return "FieldSelect." + error;
                        }
                    }
                    if (message.Help != null && message.hasOwnProperty("Help")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.HelpRs.verify(message.Help);
                            if (error)
                                return "Help." + error;
                        }
                    }
                    if (message.SystemConstants != null && message.hasOwnProperty("SystemConstants")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SystemConstantsRs.verify(message.SystemConstants);
                            if (error)
                                return "SystemConstants." + error;
                        }
                    }
                    if (message.Statuses != null && message.hasOwnProperty("Statuses")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.StatusesRs.verify(message.Statuses);
                            if (error)
                                return "Statuses." + error;
                        }
                    }
                    if (message.CountFetch != null && message.hasOwnProperty("CountFetch")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.CountFetchRs.verify(message.CountFetch);
                            if (error)
                                return "CountFetch." + error;
                        }
                    }
                    if (message.EmptyResponse != null && message.hasOwnProperty("EmptyResponse")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.EmptyRs.verify(message.EmptyResponse);
                            if (error)
                                return "EmptyResponse." + error;
                        }
                    }
                    if (message.AlertList != null && message.hasOwnProperty("AlertList")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertListRs.verify(message.AlertList);
                            if (error)
                                return "AlertList." + error;
                        }
                    }
                    if (message.AlertChooses != null && message.hasOwnProperty("AlertChooses")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertChoosesRs.verify(message.AlertChooses);
                            if (error)
                                return "AlertChooses." + error;
                        }
                    }
                    if (message.AlertSave != null && message.hasOwnProperty("AlertSave")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertListRs.verify(message.AlertSave);
                            if (error)
                                return "AlertSave." + error;
                        }
                    }
                    if (message.AlertCheckExpr != null && message.hasOwnProperty("AlertCheckExpr")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.AlertCheckExprRs.verify(message.AlertCheckExpr);
                            if (error)
                                return "AlertCheckExpr." + error;
                        }
                    }
                    if (message.TableViewColumnsDesign != null && message.hasOwnProperty("TableViewColumnsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.TableViewColumnsDesignRs.verify(message.TableViewColumnsDesign);
                            if (error)
                                return "TableViewColumnsDesign." + error;
                        }
                    }
                    if (message.SaveTableViewColumnsDesign != null && message.hasOwnProperty("SaveTableViewColumnsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SaveTableViewColumnsDesignRs.verify(message.SaveTableViewColumnsDesign);
                            if (error)
                                return "SaveTableViewColumnsDesign." + error;
                        }
                    }
                    if (message.RowViewColumnsDesign != null && message.hasOwnProperty("RowViewColumnsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RowViewColumnsDesignRs.verify(message.RowViewColumnsDesign);
                            if (error)
                                return "RowViewColumnsDesign." + error;
                        }
                    }
                    if (message.SaveRowViewColumnsDesign != null && message.hasOwnProperty("SaveRowViewColumnsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SaveRowViewColumnsDesignRs.verify(message.SaveRowViewColumnsDesign);
                            if (error)
                                return "SaveRowViewColumnsDesign." + error;
                        }
                    }
                    if (message.RestoreDefaultDesign != null && message.hasOwnProperty("RestoreDefaultDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.RestoreDefaultDesignRs.verify(message.RestoreDefaultDesign);
                            if (error)
                                return "RestoreDefaultDesign." + error;
                        }
                    }
                    if (message.SubformsDesign != null && message.hasOwnProperty("SubformsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SubformsDesignRs.verify(message.SubformsDesign);
                            if (error)
                                return "SubformsDesign." + error;
                        }
                    }
                    if (message.SaveSubformsDesign != null && message.hasOwnProperty("SaveSubformsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SaveSubformsDesignRs.verify(message.SaveSubformsDesign);
                            if (error)
                                return "SaveSubformsDesign." + error;
                        }
                    }
                    if (message.ActionsDesign != null && message.hasOwnProperty("ActionsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.ActionsDesignRs.verify(message.ActionsDesign);
                            if (error)
                                return "ActionsDesign." + error;
                        }
                    }
                    if (message.SaveActionsDesign != null && message.hasOwnProperty("SaveActionsDesign")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.SaveActionsDesignRs.verify(message.SaveActionsDesign);
                            if (error)
                                return "SaveActionsDesign." + error;
                        }
                    }
                    if (message.PreField != null && message.hasOwnProperty("PreField")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.PreFieldRs.verify(message.PreField);
                            if (error)
                                return "PreField." + error;
                        }
                    }
                    if (message.FormToExcel != null && message.hasOwnProperty("FormToExcel")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.FormToExcelRs.verify(message.FormToExcel);
                            if (error)
                                return "FormToExcel." + error;
                        }
                    }
                    if (message.GetUncompressedPrp != null && message.hasOwnProperty("GetUncompressedPrp")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.form.GetUncompressedPrpRs.verify(message.GetUncompressedPrp);
                            if (error)
                                return "GetUncompressedPrp." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Net2Grpc message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Net2Grpc} Net2Grpc
                 */
                Net2Grpc.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Net2Grpc)
                        return object;
                    var message = new $root.priority.netitems.form.Net2Grpc();
                    if (object.FatalError != null) {
                        if (typeof object.FatalError !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.FatalError: object expected");
                        message.FatalError = $root.priority.netitems.shared.GrpcError.fromObject(object.FatalError);
                    }
                    if (object.ApplicationError != null) {
                        if (typeof object.ApplicationError !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.ApplicationError: object expected");
                        message.ApplicationError = $root.priority.netitems.shared.Message.fromObject(object.ApplicationError);
                    }
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.SessionData != null)
                        if (typeof object.SessionData === "string")
                            $util.base64.decode(object.SessionData, message.SessionData = $util.newBuffer($util.base64.length(object.SessionData)), 0);
                        else if (object.SessionData.length)
                            message.SessionData = object.SessionData;
                    if (object.Start != null) {
                        if (typeof object.Start !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Start: object expected");
                        message.Start = $root.priority.netitems.form.StartRs.fromObject(object.Start);
                    }
                    if (object.End != null) {
                        if (typeof object.End !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.End: object expected");
                        message.End = $root.priority.netitems.form.EndRs.fromObject(object.End);
                    }
                    if (object.RecordEdit != null) {
                        if (typeof object.RecordEdit !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RecordEdit: object expected");
                        message.RecordEdit = $root.priority.netitems.form.RecordEditRs.fromObject(object.RecordEdit);
                    }
                    if (object.RecordSave != null) {
                        if (typeof object.RecordSave !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RecordSave: object expected");
                        message.RecordSave = $root.priority.netitems.form.RecordSaveRs.fromObject(object.RecordSave);
                    }
                    if (object.FieldUpdate != null) {
                        if (typeof object.FieldUpdate !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.FieldUpdate: object expected");
                        message.FieldUpdate = $root.priority.netitems.form.FieldUpdateRs.fromObject(object.FieldUpdate);
                    }
                    if (object.Fetch != null) {
                        if (typeof object.Fetch !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Fetch: object expected");
                        message.Fetch = $root.priority.netitems.form.FetchRs.fromObject(object.Fetch);
                    }
                    if (object.Subforms != null) {
                        if (typeof object.Subforms !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Subforms: object expected");
                        message.Subforms = $root.priority.netitems.form.SubformsRs.fromObject(object.Subforms);
                    }
                    if (object.Subform != null) {
                        if (typeof object.Subform !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Subform: object expected");
                        message.Subform = $root.priority.netitems.form.StartRs.fromObject(object.Subform);
                    }
                    if (object.Columns != null) {
                        if (typeof object.Columns !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Columns: object expected");
                        message.Columns = $root.priority.netitems.form.ColumnsRs.fromObject(object.Columns);
                    }
                    if (object.Actions != null) {
                        if (typeof object.Actions !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Actions: object expected");
                        message.Actions = $root.priority.netitems.form.ActionsRs.fromObject(object.Actions);
                    }
                    if (object.RecordDelete != null) {
                        if (typeof object.RecordDelete !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RecordDelete: object expected");
                        message.RecordDelete = $root.priority.netitems.form.RecordDeleteRs.fromObject(object.RecordDelete);
                    }
                    if (object.RecordUndo != null) {
                        if (typeof object.RecordUndo !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RecordUndo: object expected");
                        message.RecordUndo = $root.priority.netitems.form.RecordUndoRs.fromObject(object.RecordUndo);
                    }
                    if (object.WarningApprove != null) {
                        if (typeof object.WarningApprove !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.WarningApprove: object expected");
                        message.WarningApprove = $root.priority.netitems.form.WarningApproveRs.fromObject(object.WarningApprove);
                    }
                    if (object.HtmlUnlock != null) {
                        if (typeof object.HtmlUnlock !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.HtmlUnlock: object expected");
                        message.HtmlUnlock = $root.priority.netitems.form.HtmlUnlockRs.fromObject(object.HtmlUnlock);
                    }
                    if (object.Olaps != null) {
                        if (typeof object.Olaps !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Olaps: object expected");
                        message.Olaps = $root.priority.netitems.form.OlapsRs.fromObject(object.Olaps);
                    }
                    if (object.RecordColors != null) {
                        if (typeof object.RecordColors !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RecordColors: object expected");
                        message.RecordColors = $root.priority.netitems.form.RecordColorsRs.fromObject(object.RecordColors);
                    }
                    if (object.SetRecordColor != null) {
                        if (typeof object.SetRecordColor !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.SetRecordColor: object expected");
                        message.SetRecordColor = $root.priority.netitems.form.SetRecordColorRs.fromObject(object.SetRecordColor);
                    }
                    if (object.RemoveAllColors != null) {
                        if (typeof object.RemoveAllColors !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RemoveAllColors: object expected");
                        message.RemoveAllColors = $root.priority.netitems.form.RemoveAllColorsRs.fromObject(object.RemoveAllColors);
                    }
                    if (object.Action != null) {
                        if (typeof object.Action !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Action: object expected");
                        message.Action = $root.priority.netitems.form.ActionRs.fromObject(object.Action);
                    }
                    if (object.RecordZoom != null) {
                        if (typeof object.RecordZoom !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RecordZoom: object expected");
                        message.RecordZoom = $root.priority.netitems.form.RecordZoomRs.fromObject(object.RecordZoom);
                    }
                    if (object.FieldUndo != null) {
                        if (typeof object.FieldUndo !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.FieldUndo: object expected");
                        message.FieldUndo = $root.priority.netitems.form.FieldUndoRs.fromObject(object.FieldUndo);
                    }
                    if (object.ActionEnd != null) {
                        if (typeof object.ActionEnd !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.ActionEnd: object expected");
                        message.ActionEnd = $root.priority.netitems.form.ActionEndRs.fromObject(object.ActionEnd);
                    }
                    if (object.HtmlFetch != null) {
                        if (typeof object.HtmlFetch !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.HtmlFetch: object expected");
                        message.HtmlFetch = $root.priority.netitems.form.HtmlFetchRs.fromObject(object.HtmlFetch);
                    }
                    if (object.HtmlSignature != null) {
                        if (typeof object.HtmlSignature !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.HtmlSignature: object expected");
                        message.HtmlSignature = $root.priority.netitems.form.HtmlSignatureRs.fromObject(object.HtmlSignature);
                    }
                    if (object.HtmlSave != null) {
                        if (typeof object.HtmlSave !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.HtmlSave: object expected");
                        message.HtmlSave = $root.priority.netitems.form.HtmlSaveRs.fromObject(object.HtmlSave);
                    }
                    if (object.FieldSelect != null) {
                        if (typeof object.FieldSelect !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.FieldSelect: object expected");
                        message.FieldSelect = $root.priority.netitems.form.FieldSelectRs.fromObject(object.FieldSelect);
                    }
                    if (object.Help != null) {
                        if (typeof object.Help !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Help: object expected");
                        message.Help = $root.priority.netitems.form.HelpRs.fromObject(object.Help);
                    }
                    if (object.SystemConstants != null) {
                        if (typeof object.SystemConstants !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.SystemConstants: object expected");
                        message.SystemConstants = $root.priority.netitems.form.SystemConstantsRs.fromObject(object.SystemConstants);
                    }
                    if (object.Statuses != null) {
                        if (typeof object.Statuses !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.Statuses: object expected");
                        message.Statuses = $root.priority.netitems.form.StatusesRs.fromObject(object.Statuses);
                    }
                    if (object.CountFetch != null) {
                        if (typeof object.CountFetch !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.CountFetch: object expected");
                        message.CountFetch = $root.priority.netitems.form.CountFetchRs.fromObject(object.CountFetch);
                    }
                    if (object.EmptyResponse != null) {
                        if (typeof object.EmptyResponse !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.EmptyResponse: object expected");
                        message.EmptyResponse = $root.priority.netitems.form.EmptyRs.fromObject(object.EmptyResponse);
                    }
                    if (object.AlertList != null) {
                        if (typeof object.AlertList !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.AlertList: object expected");
                        message.AlertList = $root.priority.netitems.form.AlertListRs.fromObject(object.AlertList);
                    }
                    if (object.AlertChooses != null) {
                        if (typeof object.AlertChooses !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.AlertChooses: object expected");
                        message.AlertChooses = $root.priority.netitems.form.AlertChoosesRs.fromObject(object.AlertChooses);
                    }
                    if (object.AlertSave != null) {
                        if (typeof object.AlertSave !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.AlertSave: object expected");
                        message.AlertSave = $root.priority.netitems.form.AlertListRs.fromObject(object.AlertSave);
                    }
                    if (object.AlertCheckExpr != null) {
                        if (typeof object.AlertCheckExpr !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.AlertCheckExpr: object expected");
                        message.AlertCheckExpr = $root.priority.netitems.form.AlertCheckExprRs.fromObject(object.AlertCheckExpr);
                    }
                    if (object.TableViewColumnsDesign != null) {
                        if (typeof object.TableViewColumnsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.TableViewColumnsDesign: object expected");
                        message.TableViewColumnsDesign = $root.priority.netitems.form.TableViewColumnsDesignRs.fromObject(object.TableViewColumnsDesign);
                    }
                    if (object.SaveTableViewColumnsDesign != null) {
                        if (typeof object.SaveTableViewColumnsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.SaveTableViewColumnsDesign: object expected");
                        message.SaveTableViewColumnsDesign = $root.priority.netitems.form.SaveTableViewColumnsDesignRs.fromObject(object.SaveTableViewColumnsDesign);
                    }
                    if (object.RowViewColumnsDesign != null) {
                        if (typeof object.RowViewColumnsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RowViewColumnsDesign: object expected");
                        message.RowViewColumnsDesign = $root.priority.netitems.form.RowViewColumnsDesignRs.fromObject(object.RowViewColumnsDesign);
                    }
                    if (object.SaveRowViewColumnsDesign != null) {
                        if (typeof object.SaveRowViewColumnsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.SaveRowViewColumnsDesign: object expected");
                        message.SaveRowViewColumnsDesign = $root.priority.netitems.form.SaveRowViewColumnsDesignRs.fromObject(object.SaveRowViewColumnsDesign);
                    }
                    if (object.RestoreDefaultDesign != null) {
                        if (typeof object.RestoreDefaultDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.RestoreDefaultDesign: object expected");
                        message.RestoreDefaultDesign = $root.priority.netitems.form.RestoreDefaultDesignRs.fromObject(object.RestoreDefaultDesign);
                    }
                    if (object.SubformsDesign != null) {
                        if (typeof object.SubformsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.SubformsDesign: object expected");
                        message.SubformsDesign = $root.priority.netitems.form.SubformsDesignRs.fromObject(object.SubformsDesign);
                    }
                    if (object.SaveSubformsDesign != null) {
                        if (typeof object.SaveSubformsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.SaveSubformsDesign: object expected");
                        message.SaveSubformsDesign = $root.priority.netitems.form.SaveSubformsDesignRs.fromObject(object.SaveSubformsDesign);
                    }
                    if (object.ActionsDesign != null) {
                        if (typeof object.ActionsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.ActionsDesign: object expected");
                        message.ActionsDesign = $root.priority.netitems.form.ActionsDesignRs.fromObject(object.ActionsDesign);
                    }
                    if (object.SaveActionsDesign != null) {
                        if (typeof object.SaveActionsDesign !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.SaveActionsDesign: object expected");
                        message.SaveActionsDesign = $root.priority.netitems.form.SaveActionsDesignRs.fromObject(object.SaveActionsDesign);
                    }
                    if (object.PreField != null) {
                        if (typeof object.PreField !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.PreField: object expected");
                        message.PreField = $root.priority.netitems.form.PreFieldRs.fromObject(object.PreField);
                    }
                    if (object.FormToExcel != null) {
                        if (typeof object.FormToExcel !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.FormToExcel: object expected");
                        message.FormToExcel = $root.priority.netitems.form.FormToExcelRs.fromObject(object.FormToExcel);
                    }
                    if (object.GetUncompressedPrp != null) {
                        if (typeof object.GetUncompressedPrp !== "object")
                            throw TypeError(".priority.netitems.form.Net2Grpc.GetUncompressedPrp: object expected");
                        message.GetUncompressedPrp = $root.priority.netitems.form.GetUncompressedPrpRs.fromObject(object.GetUncompressedPrp);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Net2Grpc message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Net2Grpc
                 * @static
                 * @param {priority.netitems.form.Net2Grpc} message Net2Grpc
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Net2Grpc.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.FatalError = null;
                        object.ApplicationError = null;
                        object.Perf = null;
                        if (options.bytes === String)
                            object.SessionData = "";
                        else {
                            object.SessionData = [];
                            if (options.bytes !== Array)
                                object.SessionData = $util.newBuffer(object.SessionData);
                        }
                    }
                    if (message.FatalError != null && message.hasOwnProperty("FatalError"))
                        object.FatalError = $root.priority.netitems.shared.GrpcError.toObject(message.FatalError, options);
                    if (message.ApplicationError != null && message.hasOwnProperty("ApplicationError"))
                        object.ApplicationError = $root.priority.netitems.shared.Message.toObject(message.ApplicationError, options);
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Start != null && message.hasOwnProperty("Start")) {
                        object.Start = $root.priority.netitems.form.StartRs.toObject(message.Start, options);
                        if (options.oneofs)
                            object.inner = "Start";
                    }
                    if (message.End != null && message.hasOwnProperty("End")) {
                        object.End = $root.priority.netitems.form.EndRs.toObject(message.End, options);
                        if (options.oneofs)
                            object.inner = "End";
                    }
                    if (message.RecordEdit != null && message.hasOwnProperty("RecordEdit")) {
                        object.RecordEdit = $root.priority.netitems.form.RecordEditRs.toObject(message.RecordEdit, options);
                        if (options.oneofs)
                            object.inner = "RecordEdit";
                    }
                    if (message.RecordSave != null && message.hasOwnProperty("RecordSave")) {
                        object.RecordSave = $root.priority.netitems.form.RecordSaveRs.toObject(message.RecordSave, options);
                        if (options.oneofs)
                            object.inner = "RecordSave";
                    }
                    if (message.FieldUpdate != null && message.hasOwnProperty("FieldUpdate")) {
                        object.FieldUpdate = $root.priority.netitems.form.FieldUpdateRs.toObject(message.FieldUpdate, options);
                        if (options.oneofs)
                            object.inner = "FieldUpdate";
                    }
                    if (message.Fetch != null && message.hasOwnProperty("Fetch")) {
                        object.Fetch = $root.priority.netitems.form.FetchRs.toObject(message.Fetch, options);
                        if (options.oneofs)
                            object.inner = "Fetch";
                    }
                    if (message.Subforms != null && message.hasOwnProperty("Subforms")) {
                        object.Subforms = $root.priority.netitems.form.SubformsRs.toObject(message.Subforms, options);
                        if (options.oneofs)
                            object.inner = "Subforms";
                    }
                    if (message.Subform != null && message.hasOwnProperty("Subform")) {
                        object.Subform = $root.priority.netitems.form.StartRs.toObject(message.Subform, options);
                        if (options.oneofs)
                            object.inner = "Subform";
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        object.Columns = $root.priority.netitems.form.ColumnsRs.toObject(message.Columns, options);
                        if (options.oneofs)
                            object.inner = "Columns";
                    }
                    if (message.Actions != null && message.hasOwnProperty("Actions")) {
                        object.Actions = $root.priority.netitems.form.ActionsRs.toObject(message.Actions, options);
                        if (options.oneofs)
                            object.inner = "Actions";
                    }
                    if (message.RecordDelete != null && message.hasOwnProperty("RecordDelete")) {
                        object.RecordDelete = $root.priority.netitems.form.RecordDeleteRs.toObject(message.RecordDelete, options);
                        if (options.oneofs)
                            object.inner = "RecordDelete";
                    }
                    if (message.RecordUndo != null && message.hasOwnProperty("RecordUndo")) {
                        object.RecordUndo = $root.priority.netitems.form.RecordUndoRs.toObject(message.RecordUndo, options);
                        if (options.oneofs)
                            object.inner = "RecordUndo";
                    }
                    if (message.WarningApprove != null && message.hasOwnProperty("WarningApprove")) {
                        object.WarningApprove = $root.priority.netitems.form.WarningApproveRs.toObject(message.WarningApprove, options);
                        if (options.oneofs)
                            object.inner = "WarningApprove";
                    }
                    if (message.HtmlUnlock != null && message.hasOwnProperty("HtmlUnlock")) {
                        object.HtmlUnlock = $root.priority.netitems.form.HtmlUnlockRs.toObject(message.HtmlUnlock, options);
                        if (options.oneofs)
                            object.inner = "HtmlUnlock";
                    }
                    if (message.Olaps != null && message.hasOwnProperty("Olaps")) {
                        object.Olaps = $root.priority.netitems.form.OlapsRs.toObject(message.Olaps, options);
                        if (options.oneofs)
                            object.inner = "Olaps";
                    }
                    if (message.RecordColors != null && message.hasOwnProperty("RecordColors")) {
                        object.RecordColors = $root.priority.netitems.form.RecordColorsRs.toObject(message.RecordColors, options);
                        if (options.oneofs)
                            object.inner = "RecordColors";
                    }
                    if (message.SetRecordColor != null && message.hasOwnProperty("SetRecordColor")) {
                        object.SetRecordColor = $root.priority.netitems.form.SetRecordColorRs.toObject(message.SetRecordColor, options);
                        if (options.oneofs)
                            object.inner = "SetRecordColor";
                    }
                    if (message.RemoveAllColors != null && message.hasOwnProperty("RemoveAllColors")) {
                        object.RemoveAllColors = $root.priority.netitems.form.RemoveAllColorsRs.toObject(message.RemoveAllColors, options);
                        if (options.oneofs)
                            object.inner = "RemoveAllColors";
                    }
                    if (message.Action != null && message.hasOwnProperty("Action")) {
                        object.Action = $root.priority.netitems.form.ActionRs.toObject(message.Action, options);
                        if (options.oneofs)
                            object.inner = "Action";
                    }
                    if (message.RecordZoom != null && message.hasOwnProperty("RecordZoom")) {
                        object.RecordZoom = $root.priority.netitems.form.RecordZoomRs.toObject(message.RecordZoom, options);
                        if (options.oneofs)
                            object.inner = "RecordZoom";
                    }
                    if (message.FieldUndo != null && message.hasOwnProperty("FieldUndo")) {
                        object.FieldUndo = $root.priority.netitems.form.FieldUndoRs.toObject(message.FieldUndo, options);
                        if (options.oneofs)
                            object.inner = "FieldUndo";
                    }
                    if (message.ActionEnd != null && message.hasOwnProperty("ActionEnd")) {
                        object.ActionEnd = $root.priority.netitems.form.ActionEndRs.toObject(message.ActionEnd, options);
                        if (options.oneofs)
                            object.inner = "ActionEnd";
                    }
                    if (message.HtmlFetch != null && message.hasOwnProperty("HtmlFetch")) {
                        object.HtmlFetch = $root.priority.netitems.form.HtmlFetchRs.toObject(message.HtmlFetch, options);
                        if (options.oneofs)
                            object.inner = "HtmlFetch";
                    }
                    if (message.HtmlSignature != null && message.hasOwnProperty("HtmlSignature")) {
                        object.HtmlSignature = $root.priority.netitems.form.HtmlSignatureRs.toObject(message.HtmlSignature, options);
                        if (options.oneofs)
                            object.inner = "HtmlSignature";
                    }
                    if (message.HtmlSave != null && message.hasOwnProperty("HtmlSave")) {
                        object.HtmlSave = $root.priority.netitems.form.HtmlSaveRs.toObject(message.HtmlSave, options);
                        if (options.oneofs)
                            object.inner = "HtmlSave";
                    }
                    if (message.FieldSelect != null && message.hasOwnProperty("FieldSelect")) {
                        object.FieldSelect = $root.priority.netitems.form.FieldSelectRs.toObject(message.FieldSelect, options);
                        if (options.oneofs)
                            object.inner = "FieldSelect";
                    }
                    if (message.Help != null && message.hasOwnProperty("Help")) {
                        object.Help = $root.priority.netitems.form.HelpRs.toObject(message.Help, options);
                        if (options.oneofs)
                            object.inner = "Help";
                    }
                    if (message.SystemConstants != null && message.hasOwnProperty("SystemConstants")) {
                        object.SystemConstants = $root.priority.netitems.form.SystemConstantsRs.toObject(message.SystemConstants, options);
                        if (options.oneofs)
                            object.inner = "SystemConstants";
                    }
                    if (message.Statuses != null && message.hasOwnProperty("Statuses")) {
                        object.Statuses = $root.priority.netitems.form.StatusesRs.toObject(message.Statuses, options);
                        if (options.oneofs)
                            object.inner = "Statuses";
                    }
                    if (message.CountFetch != null && message.hasOwnProperty("CountFetch")) {
                        object.CountFetch = $root.priority.netitems.form.CountFetchRs.toObject(message.CountFetch, options);
                        if (options.oneofs)
                            object.inner = "CountFetch";
                    }
                    if (message.EmptyResponse != null && message.hasOwnProperty("EmptyResponse")) {
                        object.EmptyResponse = $root.priority.netitems.form.EmptyRs.toObject(message.EmptyResponse, options);
                        if (options.oneofs)
                            object.inner = "EmptyResponse";
                    }
                    if (message.AlertList != null && message.hasOwnProperty("AlertList")) {
                        object.AlertList = $root.priority.netitems.form.AlertListRs.toObject(message.AlertList, options);
                        if (options.oneofs)
                            object.inner = "AlertList";
                    }
                    if (message.AlertChooses != null && message.hasOwnProperty("AlertChooses")) {
                        object.AlertChooses = $root.priority.netitems.form.AlertChoosesRs.toObject(message.AlertChooses, options);
                        if (options.oneofs)
                            object.inner = "AlertChooses";
                    }
                    if (message.TableViewColumnsDesign != null && message.hasOwnProperty("TableViewColumnsDesign")) {
                        object.TableViewColumnsDesign = $root.priority.netitems.form.TableViewColumnsDesignRs.toObject(message.TableViewColumnsDesign, options);
                        if (options.oneofs)
                            object.inner = "TableViewColumnsDesign";
                    }
                    if (message.AlertSave != null && message.hasOwnProperty("AlertSave")) {
                        object.AlertSave = $root.priority.netitems.form.AlertListRs.toObject(message.AlertSave, options);
                        if (options.oneofs)
                            object.inner = "AlertSave";
                    }
                    if (message.AlertCheckExpr != null && message.hasOwnProperty("AlertCheckExpr")) {
                        object.AlertCheckExpr = $root.priority.netitems.form.AlertCheckExprRs.toObject(message.AlertCheckExpr, options);
                        if (options.oneofs)
                            object.inner = "AlertCheckExpr";
                    }
                    if (message.RowViewColumnsDesign != null && message.hasOwnProperty("RowViewColumnsDesign")) {
                        object.RowViewColumnsDesign = $root.priority.netitems.form.RowViewColumnsDesignRs.toObject(message.RowViewColumnsDesign, options);
                        if (options.oneofs)
                            object.inner = "RowViewColumnsDesign";
                    }
                    if (message.SaveRowViewColumnsDesign != null && message.hasOwnProperty("SaveRowViewColumnsDesign")) {
                        object.SaveRowViewColumnsDesign = $root.priority.netitems.form.SaveRowViewColumnsDesignRs.toObject(message.SaveRowViewColumnsDesign, options);
                        if (options.oneofs)
                            object.inner = "SaveRowViewColumnsDesign";
                    }
                    if (message.PreField != null && message.hasOwnProperty("PreField")) {
                        object.PreField = $root.priority.netitems.form.PreFieldRs.toObject(message.PreField, options);
                        if (options.oneofs)
                            object.inner = "PreField";
                    }
                    if (message.RestoreDefaultDesign != null && message.hasOwnProperty("RestoreDefaultDesign")) {
                        object.RestoreDefaultDesign = $root.priority.netitems.form.RestoreDefaultDesignRs.toObject(message.RestoreDefaultDesign, options);
                        if (options.oneofs)
                            object.inner = "RestoreDefaultDesign";
                    }
                    if (message.SubformsDesign != null && message.hasOwnProperty("SubformsDesign")) {
                        object.SubformsDesign = $root.priority.netitems.form.SubformsDesignRs.toObject(message.SubformsDesign, options);
                        if (options.oneofs)
                            object.inner = "SubformsDesign";
                    }
                    if (message.SaveSubformsDesign != null && message.hasOwnProperty("SaveSubformsDesign")) {
                        object.SaveSubformsDesign = $root.priority.netitems.form.SaveSubformsDesignRs.toObject(message.SaveSubformsDesign, options);
                        if (options.oneofs)
                            object.inner = "SaveSubformsDesign";
                    }
                    if (message.ActionsDesign != null && message.hasOwnProperty("ActionsDesign")) {
                        object.ActionsDesign = $root.priority.netitems.form.ActionsDesignRs.toObject(message.ActionsDesign, options);
                        if (options.oneofs)
                            object.inner = "ActionsDesign";
                    }
                    if (message.SaveActionsDesign != null && message.hasOwnProperty("SaveActionsDesign")) {
                        object.SaveActionsDesign = $root.priority.netitems.form.SaveActionsDesignRs.toObject(message.SaveActionsDesign, options);
                        if (options.oneofs)
                            object.inner = "SaveActionsDesign";
                    }
                    if (message.SaveTableViewColumnsDesign != null && message.hasOwnProperty("SaveTableViewColumnsDesign")) {
                        object.SaveTableViewColumnsDesign = $root.priority.netitems.form.SaveTableViewColumnsDesignRs.toObject(message.SaveTableViewColumnsDesign, options);
                        if (options.oneofs)
                            object.inner = "SaveTableViewColumnsDesign";
                    }
                    if (message.FormToExcel != null && message.hasOwnProperty("FormToExcel")) {
                        object.FormToExcel = $root.priority.netitems.form.FormToExcelRs.toObject(message.FormToExcel, options);
                        if (options.oneofs)
                            object.inner = "FormToExcel";
                    }
                    if (message.GetUncompressedPrp != null && message.hasOwnProperty("GetUncompressedPrp")) {
                        object.GetUncompressedPrp = $root.priority.netitems.form.GetUncompressedPrpRs.toObject(message.GetUncompressedPrp, options);
                        if (options.oneofs)
                            object.inner = "GetUncompressedPrp";
                    }
                    if (message.SessionData != null && message.hasOwnProperty("SessionData"))
                        object.SessionData = options.bytes === String ? $util.base64.encode(message.SessionData, 0, message.SessionData.length) : options.bytes === Array ? Array.prototype.slice.call(message.SessionData) : message.SessionData;
                    return object;
                };

                /**
                 * Converts this Net2Grpc to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Net2Grpc
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Net2Grpc.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Net2Grpc;
            })();

            form.NForm = (function() {

                /**
                 * Constructs a new NForm service.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a NForm
                 * @extends $protobuf.rpc.Service
                 * @constructor
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 */
                function NForm(rpcImpl, requestDelimited, responseDelimited) {
                    $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }

                (NForm.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NForm;

                /**
                 * Creates new NForm service using the specified rpc implementation.
                 * @function create
                 * @memberof priority.netitems.form.NForm
                 * @static
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 * @returns {NForm} RPC service. Useful where requests and/or responses are streamed.
                 */
                NForm.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#start}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef StartCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.StartRs} [response] StartRs
                 */

                /**
                 * Calls Start.
                 * @function start
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IStartRq} request StartRq message or plain object
                 * @param {priority.netitems.form.NForm.StartCallback} callback Node-style callback called with the error, if any, and StartRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.start = function start(request, callback) {
                    return this.rpcCall(start, $root.priority.netitems.form.StartRq, $root.priority.netitems.form.StartRs, request, callback);
                }, "name", { value: "Start" });

                /**
                 * Calls Start.
                 * @function start
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IStartRq} request StartRq message or plain object
                 * @returns {Promise<priority.netitems.form.StartRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#end}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef EndCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.EndRs} [response] EndRs
                 */

                /**
                 * Calls End.
                 * @function end
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IEndRq} request EndRq message or plain object
                 * @param {priority.netitems.form.NForm.EndCallback} callback Node-style callback called with the error, if any, and EndRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.end = function end(request, callback) {
                    return this.rpcCall(end, $root.priority.netitems.form.EndRq, $root.priority.netitems.form.EndRs, request, callback);
                }, "name", { value: "End" });

                /**
                 * Calls End.
                 * @function end
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IEndRq} request EndRq message or plain object
                 * @returns {Promise<priority.netitems.form.EndRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#recordEdit}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RecordEditCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RecordEditRs} [response] RecordEditRs
                 */

                /**
                 * Calls RecordEdit.
                 * @function recordEdit
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordEditRq} request RecordEditRq message or plain object
                 * @param {priority.netitems.form.NForm.RecordEditCallback} callback Node-style callback called with the error, if any, and RecordEditRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.recordEdit = function recordEdit(request, callback) {
                    return this.rpcCall(recordEdit, $root.priority.netitems.form.RecordEditRq, $root.priority.netitems.form.RecordEditRs, request, callback);
                }, "name", { value: "RecordEdit" });

                /**
                 * Calls RecordEdit.
                 * @function recordEdit
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordEditRq} request RecordEditRq message or plain object
                 * @returns {Promise<priority.netitems.form.RecordEditRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#recordSave}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RecordSaveCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RecordSaveRs} [response] RecordSaveRs
                 */

                /**
                 * Calls RecordSave.
                 * @function recordSave
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordSaveRq} request RecordSaveRq message or plain object
                 * @param {priority.netitems.form.NForm.RecordSaveCallback} callback Node-style callback called with the error, if any, and RecordSaveRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.recordSave = function recordSave(request, callback) {
                    return this.rpcCall(recordSave, $root.priority.netitems.form.RecordSaveRq, $root.priority.netitems.form.RecordSaveRs, request, callback);
                }, "name", { value: "RecordSave" });

                /**
                 * Calls RecordSave.
                 * @function recordSave
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordSaveRq} request RecordSaveRq message or plain object
                 * @returns {Promise<priority.netitems.form.RecordSaveRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#olaps}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef OlapsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.OlapsRs} [response] OlapsRs
                 */

                /**
                 * Calls Olaps.
                 * @function olaps
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IOlapsRq} request OlapsRq message or plain object
                 * @param {priority.netitems.form.NForm.OlapsCallback} callback Node-style callback called with the error, if any, and OlapsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.olaps = function olaps(request, callback) {
                    return this.rpcCall(olaps, $root.priority.netitems.form.OlapsRq, $root.priority.netitems.form.OlapsRs, request, callback);
                }, "name", { value: "Olaps" });

                /**
                 * Calls Olaps.
                 * @function olaps
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IOlapsRq} request OlapsRq message or plain object
                 * @returns {Promise<priority.netitems.form.OlapsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#fieldUpdate}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef FieldUpdateCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.FieldUpdateRs} [response] FieldUpdateRs
                 */

                /**
                 * Calls FieldUpdate.
                 * @function fieldUpdate
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFieldUpdateRq} request FieldUpdateRq message or plain object
                 * @param {priority.netitems.form.NForm.FieldUpdateCallback} callback Node-style callback called with the error, if any, and FieldUpdateRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.fieldUpdate = function fieldUpdate(request, callback) {
                    return this.rpcCall(fieldUpdate, $root.priority.netitems.form.FieldUpdateRq, $root.priority.netitems.form.FieldUpdateRs, request, callback);
                }, "name", { value: "FieldUpdate" });

                /**
                 * Calls FieldUpdate.
                 * @function fieldUpdate
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFieldUpdateRq} request FieldUpdateRq message or plain object
                 * @returns {Promise<priority.netitems.form.FieldUpdateRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#fetch}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef FetchCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.FetchRs} [response] FetchRs
                 */

                /**
                 * Calls Fetch.
                 * @function fetch
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFetchRq} request FetchRq message or plain object
                 * @param {priority.netitems.form.NForm.FetchCallback} callback Node-style callback called with the error, if any, and FetchRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.fetch = function fetch(request, callback) {
                    return this.rpcCall(fetch, $root.priority.netitems.form.FetchRq, $root.priority.netitems.form.FetchRs, request, callback);
                }, "name", { value: "Fetch" });

                /**
                 * Calls Fetch.
                 * @function fetch
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFetchRq} request FetchRq message or plain object
                 * @returns {Promise<priority.netitems.form.FetchRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#subforms}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SubformsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.SubformsRs} [response] SubformsRs
                 */

                /**
                 * Calls Subforms.
                 * @function subforms
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISubformsRq} request SubformsRq message or plain object
                 * @param {priority.netitems.form.NForm.SubformsCallback} callback Node-style callback called with the error, if any, and SubformsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.subforms = function subforms(request, callback) {
                    return this.rpcCall(subforms, $root.priority.netitems.form.SubformsRq, $root.priority.netitems.form.SubformsRs, request, callback);
                }, "name", { value: "Subforms" });

                /**
                 * Calls Subforms.
                 * @function subforms
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISubformsRq} request SubformsRq message or plain object
                 * @returns {Promise<priority.netitems.form.SubformsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#subform}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SubformCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.StartRs} [response] StartRs
                 */

                /**
                 * Calls Subform.
                 * @function subform
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISubformRq} request SubformRq message or plain object
                 * @param {priority.netitems.form.NForm.SubformCallback} callback Node-style callback called with the error, if any, and StartRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.subform = function subform(request, callback) {
                    return this.rpcCall(subform, $root.priority.netitems.form.SubformRq, $root.priority.netitems.form.StartRs, request, callback);
                }, "name", { value: "Subform" });

                /**
                 * Calls Subform.
                 * @function subform
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISubformRq} request SubformRq message or plain object
                 * @returns {Promise<priority.netitems.form.StartRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#columns}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef ColumnsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.ColumnsRs} [response] ColumnsRs
                 */

                /**
                 * Calls Columns.
                 * @function columns
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IColumnsRq} request ColumnsRq message or plain object
                 * @param {priority.netitems.form.NForm.ColumnsCallback} callback Node-style callback called with the error, if any, and ColumnsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.columns = function columns(request, callback) {
                    return this.rpcCall(columns, $root.priority.netitems.form.ColumnsRq, $root.priority.netitems.form.ColumnsRs, request, callback);
                }, "name", { value: "Columns" });

                /**
                 * Calls Columns.
                 * @function columns
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IColumnsRq} request ColumnsRq message or plain object
                 * @returns {Promise<priority.netitems.form.ColumnsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#actions}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef ActionsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.ActionsRs} [response] ActionsRs
                 */

                /**
                 * Calls Actions.
                 * @function actions
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IActionsRq} request ActionsRq message or plain object
                 * @param {priority.netitems.form.NForm.ActionsCallback} callback Node-style callback called with the error, if any, and ActionsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.actions = function actions(request, callback) {
                    return this.rpcCall(actions, $root.priority.netitems.form.ActionsRq, $root.priority.netitems.form.ActionsRs, request, callback);
                }, "name", { value: "Actions" });

                /**
                 * Calls Actions.
                 * @function actions
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IActionsRq} request ActionsRq message or plain object
                 * @returns {Promise<priority.netitems.form.ActionsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#recordDelete}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RecordDeleteCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RecordDeleteRs} [response] RecordDeleteRs
                 */

                /**
                 * Calls RecordDelete.
                 * @function recordDelete
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordDeleteRq} request RecordDeleteRq message or plain object
                 * @param {priority.netitems.form.NForm.RecordDeleteCallback} callback Node-style callback called with the error, if any, and RecordDeleteRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.recordDelete = function recordDelete(request, callback) {
                    return this.rpcCall(recordDelete, $root.priority.netitems.form.RecordDeleteRq, $root.priority.netitems.form.RecordDeleteRs, request, callback);
                }, "name", { value: "RecordDelete" });

                /**
                 * Calls RecordDelete.
                 * @function recordDelete
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordDeleteRq} request RecordDeleteRq message or plain object
                 * @returns {Promise<priority.netitems.form.RecordDeleteRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#recordUndo}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RecordUndoCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RecordUndoRs} [response] RecordUndoRs
                 */

                /**
                 * Calls RecordUndo.
                 * @function recordUndo
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordUndoRq} request RecordUndoRq message or plain object
                 * @param {priority.netitems.form.NForm.RecordUndoCallback} callback Node-style callback called with the error, if any, and RecordUndoRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.recordUndo = function recordUndo(request, callback) {
                    return this.rpcCall(recordUndo, $root.priority.netitems.form.RecordUndoRq, $root.priority.netitems.form.RecordUndoRs, request, callback);
                }, "name", { value: "RecordUndo" });

                /**
                 * Calls RecordUndo.
                 * @function recordUndo
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordUndoRq} request RecordUndoRq message or plain object
                 * @returns {Promise<priority.netitems.form.RecordUndoRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#recordAction}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RecordActionCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.ActionRs} [response] ActionRs
                 */

                /**
                 * Calls RecordAction.
                 * @function recordAction
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IActionRq} request ActionRq message or plain object
                 * @param {priority.netitems.form.NForm.RecordActionCallback} callback Node-style callback called with the error, if any, and ActionRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.recordAction = function recordAction(request, callback) {
                    return this.rpcCall(recordAction, $root.priority.netitems.form.ActionRq, $root.priority.netitems.form.ActionRs, request, callback);
                }, "name", { value: "RecordAction" });

                /**
                 * Calls RecordAction.
                 * @function recordAction
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IActionRq} request ActionRq message or plain object
                 * @returns {Promise<priority.netitems.form.ActionRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#recordActionEnd}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RecordActionEndCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.ActionEndRs} [response] ActionEndRs
                 */

                /**
                 * Calls RecordActionEnd.
                 * @function recordActionEnd
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IActionEndRq} request ActionEndRq message or plain object
                 * @param {priority.netitems.form.NForm.RecordActionEndCallback} callback Node-style callback called with the error, if any, and ActionEndRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.recordActionEnd = function recordActionEnd(request, callback) {
                    return this.rpcCall(recordActionEnd, $root.priority.netitems.form.ActionEndRq, $root.priority.netitems.form.ActionEndRs, request, callback);
                }, "name", { value: "RecordActionEnd" });

                /**
                 * Calls RecordActionEnd.
                 * @function recordActionEnd
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IActionEndRq} request ActionEndRq message or plain object
                 * @returns {Promise<priority.netitems.form.ActionEndRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#warningApprove}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef WarningApproveCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.WarningApproveRs} [response] WarningApproveRs
                 */

                /**
                 * Calls WarningApprove.
                 * @function warningApprove
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IWarningApproveRq} request WarningApproveRq message or plain object
                 * @param {priority.netitems.form.NForm.WarningApproveCallback} callback Node-style callback called with the error, if any, and WarningApproveRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.warningApprove = function warningApprove(request, callback) {
                    return this.rpcCall(warningApprove, $root.priority.netitems.form.WarningApproveRq, $root.priority.netitems.form.WarningApproveRs, request, callback);
                }, "name", { value: "WarningApprove" });

                /**
                 * Calls WarningApprove.
                 * @function warningApprove
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IWarningApproveRq} request WarningApproveRq message or plain object
                 * @returns {Promise<priority.netitems.form.WarningApproveRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#recordColors}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RecordColorsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RecordColorsRs} [response] RecordColorsRs
                 */

                /**
                 * Calls RecordColors.
                 * @function recordColors
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordColorsRq} request RecordColorsRq message or plain object
                 * @param {priority.netitems.form.NForm.RecordColorsCallback} callback Node-style callback called with the error, if any, and RecordColorsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.recordColors = function recordColors(request, callback) {
                    return this.rpcCall(recordColors, $root.priority.netitems.form.RecordColorsRq, $root.priority.netitems.form.RecordColorsRs, request, callback);
                }, "name", { value: "RecordColors" });

                /**
                 * Calls RecordColors.
                 * @function recordColors
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordColorsRq} request RecordColorsRq message or plain object
                 * @returns {Promise<priority.netitems.form.RecordColorsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#setRecordColor}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SetRecordColorCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.SetRecordColorRs} [response] SetRecordColorRs
                 */

                /**
                 * Calls SetRecordColor.
                 * @function setRecordColor
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISetRecordColorRq} request SetRecordColorRq message or plain object
                 * @param {priority.netitems.form.NForm.SetRecordColorCallback} callback Node-style callback called with the error, if any, and SetRecordColorRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.setRecordColor = function setRecordColor(request, callback) {
                    return this.rpcCall(setRecordColor, $root.priority.netitems.form.SetRecordColorRq, $root.priority.netitems.form.SetRecordColorRs, request, callback);
                }, "name", { value: "SetRecordColor" });

                /**
                 * Calls SetRecordColor.
                 * @function setRecordColor
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISetRecordColorRq} request SetRecordColorRq message or plain object
                 * @returns {Promise<priority.netitems.form.SetRecordColorRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#removeAllColors}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RemoveAllColorsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RemoveAllColorsRs} [response] RemoveAllColorsRs
                 */

                /**
                 * Calls RemoveAllColors.
                 * @function removeAllColors
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRemoveAllColorsRq} request RemoveAllColorsRq message or plain object
                 * @param {priority.netitems.form.NForm.RemoveAllColorsCallback} callback Node-style callback called with the error, if any, and RemoveAllColorsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.removeAllColors = function removeAllColors(request, callback) {
                    return this.rpcCall(removeAllColors, $root.priority.netitems.form.RemoveAllColorsRq, $root.priority.netitems.form.RemoveAllColorsRs, request, callback);
                }, "name", { value: "RemoveAllColors" });

                /**
                 * Calls RemoveAllColors.
                 * @function removeAllColors
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRemoveAllColorsRq} request RemoveAllColorsRq message or plain object
                 * @returns {Promise<priority.netitems.form.RemoveAllColorsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#htmlFetch}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef HtmlFetchCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.HtmlFetchRs} [response] HtmlFetchRs
                 */

                /**
                 * Calls HtmlFetch.
                 * @function htmlFetch
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHtmlFetchRq} request HtmlFetchRq message or plain object
                 * @param {priority.netitems.form.NForm.HtmlFetchCallback} callback Node-style callback called with the error, if any, and HtmlFetchRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.htmlFetch = function htmlFetch(request, callback) {
                    return this.rpcCall(htmlFetch, $root.priority.netitems.form.HtmlFetchRq, $root.priority.netitems.form.HtmlFetchRs, request, callback);
                }, "name", { value: "HtmlFetch" });

                /**
                 * Calls HtmlFetch.
                 * @function htmlFetch
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHtmlFetchRq} request HtmlFetchRq message or plain object
                 * @returns {Promise<priority.netitems.form.HtmlFetchRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#htmlUnlock}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef HtmlUnlockCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.HtmlUnlockRs} [response] HtmlUnlockRs
                 */

                /**
                 * Calls HtmlUnlock.
                 * @function htmlUnlock
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHtmlUnlockRq} request HtmlUnlockRq message or plain object
                 * @param {priority.netitems.form.NForm.HtmlUnlockCallback} callback Node-style callback called with the error, if any, and HtmlUnlockRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.htmlUnlock = function htmlUnlock(request, callback) {
                    return this.rpcCall(htmlUnlock, $root.priority.netitems.form.HtmlUnlockRq, $root.priority.netitems.form.HtmlUnlockRs, request, callback);
                }, "name", { value: "HtmlUnlock" });

                /**
                 * Calls HtmlUnlock.
                 * @function htmlUnlock
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHtmlUnlockRq} request HtmlUnlockRq message or plain object
                 * @returns {Promise<priority.netitems.form.HtmlUnlockRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#recordZoom}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RecordZoomCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RecordZoomRs} [response] RecordZoomRs
                 */

                /**
                 * Calls RecordZoom.
                 * @function recordZoom
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordZoomRq} request RecordZoomRq message or plain object
                 * @param {priority.netitems.form.NForm.RecordZoomCallback} callback Node-style callback called with the error, if any, and RecordZoomRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.recordZoom = function recordZoom(request, callback) {
                    return this.rpcCall(recordZoom, $root.priority.netitems.form.RecordZoomRq, $root.priority.netitems.form.RecordZoomRs, request, callback);
                }, "name", { value: "RecordZoom" });

                /**
                 * Calls RecordZoom.
                 * @function recordZoom
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRecordZoomRq} request RecordZoomRq message or plain object
                 * @returns {Promise<priority.netitems.form.RecordZoomRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#fieldUndo}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef FieldUndoCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.FieldUndoRs} [response] FieldUndoRs
                 */

                /**
                 * Calls FieldUndo.
                 * @function fieldUndo
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFieldUndoRq} request FieldUndoRq message or plain object
                 * @param {priority.netitems.form.NForm.FieldUndoCallback} callback Node-style callback called with the error, if any, and FieldUndoRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.fieldUndo = function fieldUndo(request, callback) {
                    return this.rpcCall(fieldUndo, $root.priority.netitems.form.FieldUndoRq, $root.priority.netitems.form.FieldUndoRs, request, callback);
                }, "name", { value: "FieldUndo" });

                /**
                 * Calls FieldUndo.
                 * @function fieldUndo
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFieldUndoRq} request FieldUndoRq message or plain object
                 * @returns {Promise<priority.netitems.form.FieldUndoRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#htmlSignature}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef HtmlSignatureCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.HtmlSignatureRs} [response] HtmlSignatureRs
                 */

                /**
                 * Calls HtmlSignature.
                 * @function htmlSignature
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHtmlSignatureRq} request HtmlSignatureRq message or plain object
                 * @param {priority.netitems.form.NForm.HtmlSignatureCallback} callback Node-style callback called with the error, if any, and HtmlSignatureRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.htmlSignature = function htmlSignature(request, callback) {
                    return this.rpcCall(htmlSignature, $root.priority.netitems.form.HtmlSignatureRq, $root.priority.netitems.form.HtmlSignatureRs, request, callback);
                }, "name", { value: "HtmlSignature" });

                /**
                 * Calls HtmlSignature.
                 * @function htmlSignature
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHtmlSignatureRq} request HtmlSignatureRq message or plain object
                 * @returns {Promise<priority.netitems.form.HtmlSignatureRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#htmlSave}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef HtmlSaveCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.HtmlSaveRs} [response] HtmlSaveRs
                 */

                /**
                 * Calls HtmlSave.
                 * @function htmlSave
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHtmlSaveRq} request HtmlSaveRq message or plain object
                 * @param {priority.netitems.form.NForm.HtmlSaveCallback} callback Node-style callback called with the error, if any, and HtmlSaveRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.htmlSave = function htmlSave(request, callback) {
                    return this.rpcCall(htmlSave, $root.priority.netitems.form.HtmlSaveRq, $root.priority.netitems.form.HtmlSaveRs, request, callback);
                }, "name", { value: "HtmlSave" });

                /**
                 * Calls HtmlSave.
                 * @function htmlSave
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHtmlSaveRq} request HtmlSaveRq message or plain object
                 * @returns {Promise<priority.netitems.form.HtmlSaveRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#help}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef HelpCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.HelpRs} [response] HelpRs
                 */

                /**
                 * Calls Help.
                 * @function help
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHelpRq} request HelpRq message or plain object
                 * @param {priority.netitems.form.NForm.HelpCallback} callback Node-style callback called with the error, if any, and HelpRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.help = function help(request, callback) {
                    return this.rpcCall(help, $root.priority.netitems.form.HelpRq, $root.priority.netitems.form.HelpRs, request, callback);
                }, "name", { value: "Help" });

                /**
                 * Calls Help.
                 * @function help
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IHelpRq} request HelpRq message or plain object
                 * @returns {Promise<priority.netitems.form.HelpRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#fieldSelect}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef FieldSelectCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.FieldSelectRs} [response] FieldSelectRs
                 */

                /**
                 * Calls FieldSelect.
                 * @function fieldSelect
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFieldSelectRq} request FieldSelectRq message or plain object
                 * @param {priority.netitems.form.NForm.FieldSelectCallback} callback Node-style callback called with the error, if any, and FieldSelectRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.fieldSelect = function fieldSelect(request, callback) {
                    return this.rpcCall(fieldSelect, $root.priority.netitems.form.FieldSelectRq, $root.priority.netitems.form.FieldSelectRs, request, callback);
                }, "name", { value: "FieldSelect" });

                /**
                 * Calls FieldSelect.
                 * @function fieldSelect
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFieldSelectRq} request FieldSelectRq message or plain object
                 * @returns {Promise<priority.netitems.form.FieldSelectRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#systemConstants}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SystemConstantsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.SystemConstantsRs} [response] SystemConstantsRs
                 */

                /**
                 * Calls SystemConstants.
                 * @function systemConstants
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISystemConstantsRq} request SystemConstantsRq message or plain object
                 * @param {priority.netitems.form.NForm.SystemConstantsCallback} callback Node-style callback called with the error, if any, and SystemConstantsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.systemConstants = function systemConstants(request, callback) {
                    return this.rpcCall(systemConstants, $root.priority.netitems.form.SystemConstantsRq, $root.priority.netitems.form.SystemConstantsRs, request, callback);
                }, "name", { value: "SystemConstants" });

                /**
                 * Calls SystemConstants.
                 * @function systemConstants
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISystemConstantsRq} request SystemConstantsRq message or plain object
                 * @returns {Promise<priority.netitems.form.SystemConstantsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#statuses}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef StatusesCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.StatusesRs} [response] StatusesRs
                 */

                /**
                 * Calls Statuses.
                 * @function statuses
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IStatusesRq} request StatusesRq message or plain object
                 * @param {priority.netitems.form.NForm.StatusesCallback} callback Node-style callback called with the error, if any, and StatusesRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.statuses = function statuses(request, callback) {
                    return this.rpcCall(statuses, $root.priority.netitems.form.StatusesRq, $root.priority.netitems.form.StatusesRs, request, callback);
                }, "name", { value: "Statuses" });

                /**
                 * Calls Statuses.
                 * @function statuses
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IStatusesRq} request StatusesRq message or plain object
                 * @returns {Promise<priority.netitems.form.StatusesRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#batch}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef BatchCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.BatchRs} [response] BatchRs
                 */

                /**
                 * Calls Batch.
                 * @function batch
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IBatchRq} request BatchRq message or plain object
                 * @param {priority.netitems.form.NForm.BatchCallback} callback Node-style callback called with the error, if any, and BatchRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.batch = function batch(request, callback) {
                    return this.rpcCall(batch, $root.priority.netitems.form.BatchRq, $root.priority.netitems.form.BatchRs, request, callback);
                }, "name", { value: "Batch" });

                /**
                 * Calls Batch.
                 * @function batch
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IBatchRq} request BatchRq message or plain object
                 * @returns {Promise<priority.netitems.form.BatchRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#countFetch}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef CountFetchCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.CountFetchRs} [response] CountFetchRs
                 */

                /**
                 * Calls CountFetch.
                 * @function countFetch
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ICountFetchRq} request CountFetchRq message or plain object
                 * @param {priority.netitems.form.NForm.CountFetchCallback} callback Node-style callback called with the error, if any, and CountFetchRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.countFetch = function countFetch(request, callback) {
                    return this.rpcCall(countFetch, $root.priority.netitems.form.CountFetchRq, $root.priority.netitems.form.CountFetchRs, request, callback);
                }, "name", { value: "CountFetch" });

                /**
                 * Calls CountFetch.
                 * @function countFetch
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ICountFetchRq} request CountFetchRq message or plain object
                 * @returns {Promise<priority.netitems.form.CountFetchRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#alertList}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef AlertListCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.AlertListRs} [response] AlertListRs
                 */

                /**
                 * Calls AlertList.
                 * @function alertList
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertListRq} request AlertListRq message or plain object
                 * @param {priority.netitems.form.NForm.AlertListCallback} callback Node-style callback called with the error, if any, and AlertListRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.alertList = function alertList(request, callback) {
                    return this.rpcCall(alertList, $root.priority.netitems.form.AlertListRq, $root.priority.netitems.form.AlertListRs, request, callback);
                }, "name", { value: "AlertList" });

                /**
                 * Calls AlertList.
                 * @function alertList
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertListRq} request AlertListRq message or plain object
                 * @returns {Promise<priority.netitems.form.AlertListRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#alertChooses}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef AlertChoosesCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.AlertChoosesRs} [response] AlertChoosesRs
                 */

                /**
                 * Calls AlertChooses.
                 * @function alertChooses
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertChoosesRq} request AlertChoosesRq message or plain object
                 * @param {priority.netitems.form.NForm.AlertChoosesCallback} callback Node-style callback called with the error, if any, and AlertChoosesRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.alertChooses = function alertChooses(request, callback) {
                    return this.rpcCall(alertChooses, $root.priority.netitems.form.AlertChoosesRq, $root.priority.netitems.form.AlertChoosesRs, request, callback);
                }, "name", { value: "AlertChooses" });

                /**
                 * Calls AlertChooses.
                 * @function alertChooses
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertChoosesRq} request AlertChoosesRq message or plain object
                 * @returns {Promise<priority.netitems.form.AlertChoosesRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#alertChoose}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef AlertChooseCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.FieldSelectRs} [response] FieldSelectRs
                 */

                /**
                 * Calls AlertChoose.
                 * @function alertChoose
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertChooseRq} request AlertChooseRq message or plain object
                 * @param {priority.netitems.form.NForm.AlertChooseCallback} callback Node-style callback called with the error, if any, and FieldSelectRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.alertChoose = function alertChoose(request, callback) {
                    return this.rpcCall(alertChoose, $root.priority.netitems.form.AlertChooseRq, $root.priority.netitems.form.FieldSelectRs, request, callback);
                }, "name", { value: "AlertChoose" });

                /**
                 * Calls AlertChoose.
                 * @function alertChoose
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertChooseRq} request AlertChooseRq message or plain object
                 * @returns {Promise<priority.netitems.form.FieldSelectRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#alertSave}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef AlertSaveCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.AlertListRs} [response] AlertListRs
                 */

                /**
                 * Calls AlertSave.
                 * @function alertSave
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertSaveRq} request AlertSaveRq message or plain object
                 * @param {priority.netitems.form.NForm.AlertSaveCallback} callback Node-style callback called with the error, if any, and AlertListRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.alertSave = function alertSave(request, callback) {
                    return this.rpcCall(alertSave, $root.priority.netitems.form.AlertSaveRq, $root.priority.netitems.form.AlertListRs, request, callback);
                }, "name", { value: "AlertSave" });

                /**
                 * Calls AlertSave.
                 * @function alertSave
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertSaveRq} request AlertSaveRq message or plain object
                 * @returns {Promise<priority.netitems.form.AlertListRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#alertDelete}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef AlertDeleteCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.EmptyRs} [response] EmptyRs
                 */

                /**
                 * Calls AlertDelete.
                 * @function alertDelete
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertDeleteRq} request AlertDeleteRq message or plain object
                 * @param {priority.netitems.form.NForm.AlertDeleteCallback} callback Node-style callback called with the error, if any, and EmptyRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.alertDelete = function alertDelete(request, callback) {
                    return this.rpcCall(alertDelete, $root.priority.netitems.form.AlertDeleteRq, $root.priority.netitems.form.EmptyRs, request, callback);
                }, "name", { value: "AlertDelete" });

                /**
                 * Calls AlertDelete.
                 * @function alertDelete
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertDeleteRq} request AlertDeleteRq message or plain object
                 * @returns {Promise<priority.netitems.form.EmptyRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#alertOrder}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef AlertOrderCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.EmptyRs} [response] EmptyRs
                 */

                /**
                 * Calls AlertOrder.
                 * @function alertOrder
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertOrderRq} request AlertOrderRq message or plain object
                 * @param {priority.netitems.form.NForm.AlertOrderCallback} callback Node-style callback called with the error, if any, and EmptyRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.alertOrder = function alertOrder(request, callback) {
                    return this.rpcCall(alertOrder, $root.priority.netitems.form.AlertOrderRq, $root.priority.netitems.form.EmptyRs, request, callback);
                }, "name", { value: "AlertOrder" });

                /**
                 * Calls AlertOrder.
                 * @function alertOrder
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertOrderRq} request AlertOrderRq message or plain object
                 * @returns {Promise<priority.netitems.form.EmptyRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#alertCheckExpr}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef AlertCheckExprCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.AlertCheckExprRs} [response] AlertCheckExprRs
                 */

                /**
                 * Calls AlertCheckExpr.
                 * @function alertCheckExpr
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertCheckExprRq} request AlertCheckExprRq message or plain object
                 * @param {priority.netitems.form.NForm.AlertCheckExprCallback} callback Node-style callback called with the error, if any, and AlertCheckExprRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.alertCheckExpr = function alertCheckExpr(request, callback) {
                    return this.rpcCall(alertCheckExpr, $root.priority.netitems.form.AlertCheckExprRq, $root.priority.netitems.form.AlertCheckExprRs, request, callback);
                }, "name", { value: "AlertCheckExpr" });

                /**
                 * Calls AlertCheckExpr.
                 * @function alertCheckExpr
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IAlertCheckExprRq} request AlertCheckExprRq message or plain object
                 * @returns {Promise<priority.netitems.form.AlertCheckExprRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#formToExcel}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef FormToExcelCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.FormToExcelRs} [response] FormToExcelRs
                 */

                /**
                 * Calls FormToExcel.
                 * @function formToExcel
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFormToExcelRq} request FormToExcelRq message or plain object
                 * @param {priority.netitems.form.NForm.FormToExcelCallback} callback Node-style callback called with the error, if any, and FormToExcelRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.formToExcel = function formToExcel(request, callback) {
                    return this.rpcCall(formToExcel, $root.priority.netitems.form.FormToExcelRq, $root.priority.netitems.form.FormToExcelRs, request, callback);
                }, "name", { value: "FormToExcel" });

                /**
                 * Calls FormToExcel.
                 * @function formToExcel
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IFormToExcelRq} request FormToExcelRq message or plain object
                 * @returns {Promise<priority.netitems.form.FormToExcelRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#tableViewColumnsDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef TableViewColumnsDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.TableViewColumnsDesignRs} [response] TableViewColumnsDesignRs
                 */

                /**
                 * Calls TableViewColumnsDesign.
                 * @function tableViewColumnsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ITableViewColumnsDesignRq} request TableViewColumnsDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.TableViewColumnsDesignCallback} callback Node-style callback called with the error, if any, and TableViewColumnsDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.tableViewColumnsDesign = function tableViewColumnsDesign(request, callback) {
                    return this.rpcCall(tableViewColumnsDesign, $root.priority.netitems.form.TableViewColumnsDesignRq, $root.priority.netitems.form.TableViewColumnsDesignRs, request, callback);
                }, "name", { value: "TableViewColumnsDesign" });

                /**
                 * Calls TableViewColumnsDesign.
                 * @function tableViewColumnsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ITableViewColumnsDesignRq} request TableViewColumnsDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.TableViewColumnsDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#saveTableViewColumnsDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SaveTableViewColumnsDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.SaveTableViewColumnsDesignRs} [response] SaveTableViewColumnsDesignRs
                 */

                /**
                 * Calls SaveTableViewColumnsDesign.
                 * @function saveTableViewColumnsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRq} request SaveTableViewColumnsDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.SaveTableViewColumnsDesignCallback} callback Node-style callback called with the error, if any, and SaveTableViewColumnsDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.saveTableViewColumnsDesign = function saveTableViewColumnsDesign(request, callback) {
                    return this.rpcCall(saveTableViewColumnsDesign, $root.priority.netitems.form.SaveTableViewColumnsDesignRq, $root.priority.netitems.form.SaveTableViewColumnsDesignRs, request, callback);
                }, "name", { value: "SaveTableViewColumnsDesign" });

                /**
                 * Calls SaveTableViewColumnsDesign.
                 * @function saveTableViewColumnsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISaveTableViewColumnsDesignRq} request SaveTableViewColumnsDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.SaveTableViewColumnsDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#rowViewColumnsDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RowViewColumnsDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RowViewColumnsDesignRs} [response] RowViewColumnsDesignRs
                 */

                /**
                 * Calls RowViewColumnsDesign.
                 * @function rowViewColumnsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRowViewColumnsDesignRq} request RowViewColumnsDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.RowViewColumnsDesignCallback} callback Node-style callback called with the error, if any, and RowViewColumnsDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.rowViewColumnsDesign = function rowViewColumnsDesign(request, callback) {
                    return this.rpcCall(rowViewColumnsDesign, $root.priority.netitems.form.RowViewColumnsDesignRq, $root.priority.netitems.form.RowViewColumnsDesignRs, request, callback);
                }, "name", { value: "RowViewColumnsDesign" });

                /**
                 * Calls RowViewColumnsDesign.
                 * @function rowViewColumnsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRowViewColumnsDesignRq} request RowViewColumnsDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.RowViewColumnsDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#saveRowViewColumnsDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SaveRowViewColumnsDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.SaveRowViewColumnsDesignRs} [response] SaveRowViewColumnsDesignRs
                 */

                /**
                 * Calls SaveRowViewColumnsDesign.
                 * @function saveRowViewColumnsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRq} request SaveRowViewColumnsDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.SaveRowViewColumnsDesignCallback} callback Node-style callback called with the error, if any, and SaveRowViewColumnsDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.saveRowViewColumnsDesign = function saveRowViewColumnsDesign(request, callback) {
                    return this.rpcCall(saveRowViewColumnsDesign, $root.priority.netitems.form.SaveRowViewColumnsDesignRq, $root.priority.netitems.form.SaveRowViewColumnsDesignRs, request, callback);
                }, "name", { value: "SaveRowViewColumnsDesign" });

                /**
                 * Calls SaveRowViewColumnsDesign.
                 * @function saveRowViewColumnsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISaveRowViewColumnsDesignRq} request SaveRowViewColumnsDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.SaveRowViewColumnsDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#restoreDefaultDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef RestoreDefaultDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.RestoreDefaultDesignRs} [response] RestoreDefaultDesignRs
                 */

                /**
                 * Calls RestoreDefaultDesign.
                 * @function restoreDefaultDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRestoreDefaultDesignRq} request RestoreDefaultDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.RestoreDefaultDesignCallback} callback Node-style callback called with the error, if any, and RestoreDefaultDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.restoreDefaultDesign = function restoreDefaultDesign(request, callback) {
                    return this.rpcCall(restoreDefaultDesign, $root.priority.netitems.form.RestoreDefaultDesignRq, $root.priority.netitems.form.RestoreDefaultDesignRs, request, callback);
                }, "name", { value: "RestoreDefaultDesign" });

                /**
                 * Calls RestoreDefaultDesign.
                 * @function restoreDefaultDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IRestoreDefaultDesignRq} request RestoreDefaultDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.RestoreDefaultDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#subformsDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SubformsDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.SubformsDesignRs} [response] SubformsDesignRs
                 */

                /**
                 * Calls SubformsDesign.
                 * @function subformsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISubformsDesignRq} request SubformsDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.SubformsDesignCallback} callback Node-style callback called with the error, if any, and SubformsDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.subformsDesign = function subformsDesign(request, callback) {
                    return this.rpcCall(subformsDesign, $root.priority.netitems.form.SubformsDesignRq, $root.priority.netitems.form.SubformsDesignRs, request, callback);
                }, "name", { value: "SubformsDesign" });

                /**
                 * Calls SubformsDesign.
                 * @function subformsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISubformsDesignRq} request SubformsDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.SubformsDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#saveSubformsDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SaveSubformsDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.SaveSubformsDesignRs} [response] SaveSubformsDesignRs
                 */

                /**
                 * Calls SaveSubformsDesign.
                 * @function saveSubformsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISaveSubformsDesignRq} request SaveSubformsDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.SaveSubformsDesignCallback} callback Node-style callback called with the error, if any, and SaveSubformsDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.saveSubformsDesign = function saveSubformsDesign(request, callback) {
                    return this.rpcCall(saveSubformsDesign, $root.priority.netitems.form.SaveSubformsDesignRq, $root.priority.netitems.form.SaveSubformsDesignRs, request, callback);
                }, "name", { value: "SaveSubformsDesign" });

                /**
                 * Calls SaveSubformsDesign.
                 * @function saveSubformsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISaveSubformsDesignRq} request SaveSubformsDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.SaveSubformsDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#actionsDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef ActionsDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.ActionsDesignRs} [response] ActionsDesignRs
                 */

                /**
                 * Calls ActionsDesign.
                 * @function actionsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IActionsDesignRq} request ActionsDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.ActionsDesignCallback} callback Node-style callback called with the error, if any, and ActionsDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.actionsDesign = function actionsDesign(request, callback) {
                    return this.rpcCall(actionsDesign, $root.priority.netitems.form.ActionsDesignRq, $root.priority.netitems.form.ActionsDesignRs, request, callback);
                }, "name", { value: "ActionsDesign" });

                /**
                 * Calls ActionsDesign.
                 * @function actionsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IActionsDesignRq} request ActionsDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.ActionsDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#saveActionsDesign}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef SaveActionsDesignCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.SaveActionsDesignRs} [response] SaveActionsDesignRs
                 */

                /**
                 * Calls SaveActionsDesign.
                 * @function saveActionsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISaveActionsDesignRq} request SaveActionsDesignRq message or plain object
                 * @param {priority.netitems.form.NForm.SaveActionsDesignCallback} callback Node-style callback called with the error, if any, and SaveActionsDesignRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.saveActionsDesign = function saveActionsDesign(request, callback) {
                    return this.rpcCall(saveActionsDesign, $root.priority.netitems.form.SaveActionsDesignRq, $root.priority.netitems.form.SaveActionsDesignRs, request, callback);
                }, "name", { value: "SaveActionsDesign" });

                /**
                 * Calls SaveActionsDesign.
                 * @function saveActionsDesign
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.ISaveActionsDesignRq} request SaveActionsDesignRq message or plain object
                 * @returns {Promise<priority.netitems.form.SaveActionsDesignRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.form.NForm#preField}.
                 * @memberof priority.netitems.form.NForm
                 * @typedef PreFieldCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.form.PreFieldRs} [response] PreFieldRs
                 */

                /**
                 * Calls PreField.
                 * @function preField
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IPreFieldRq} request PreFieldRq message or plain object
                 * @param {priority.netitems.form.NForm.PreFieldCallback} callback Node-style callback called with the error, if any, and PreFieldRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NForm.prototype.preField = function preField(request, callback) {
                    return this.rpcCall(preField, $root.priority.netitems.form.PreFieldRq, $root.priority.netitems.form.PreFieldRs, request, callback);
                }, "name", { value: "PreField" });

                /**
                 * Calls PreField.
                 * @function preField
                 * @memberof priority.netitems.form.NForm
                 * @instance
                 * @param {priority.netitems.form.IPreFieldRq} request PreFieldRq message or plain object
                 * @returns {Promise<priority.netitems.form.PreFieldRs>} Promise
                 * @variation 2
                 */

                return NForm;
            })();

            form.GetUncompressedPrpRq = (function() {

                /**
                 * Properties of a GetUncompressedPrpRq.
                 * @memberof priority.netitems.form
                 * @interface IGetUncompressedPrpRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] GetUncompressedPrpRq Properties
                 * @property {number|Long|null} [FormId] GetUncompressedPrpRq FormId
                 * @property {string|null} [FormName] GetUncompressedPrpRq FormName
                 */

                /**
                 * Constructs a new GetUncompressedPrpRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a GetUncompressedPrpRq.
                 * @implements IGetUncompressedPrpRq
                 * @constructor
                 * @param {priority.netitems.form.IGetUncompressedPrpRq=} [properties] Properties to set
                 */
                function GetUncompressedPrpRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetUncompressedPrpRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @instance
                 */
                GetUncompressedPrpRq.prototype.Properties = null;

                /**
                 * GetUncompressedPrpRq FormId.
                 * @member {number|Long|null|undefined} FormId
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @instance
                 */
                GetUncompressedPrpRq.prototype.FormId = null;

                /**
                 * GetUncompressedPrpRq FormName.
                 * @member {string|null|undefined} FormName
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @instance
                 */
                GetUncompressedPrpRq.prototype.FormName = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * GetUncompressedPrpRq _FormId.
                 * @member {"FormId"|undefined} _FormId
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @instance
                 */
                Object.defineProperty(GetUncompressedPrpRq.prototype, "_FormId", {
                    get: $util.oneOfGetter($oneOfFields = ["FormId"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * GetUncompressedPrpRq _FormName.
                 * @member {"FormName"|undefined} _FormName
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @instance
                 */
                Object.defineProperty(GetUncompressedPrpRq.prototype, "_FormName", {
                    get: $util.oneOfGetter($oneOfFields = ["FormName"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new GetUncompressedPrpRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @static
                 * @param {priority.netitems.form.IGetUncompressedPrpRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.GetUncompressedPrpRq} GetUncompressedPrpRq instance
                 */
                GetUncompressedPrpRq.create = function create(properties) {
                    return new GetUncompressedPrpRq(properties);
                };

                /**
                 * Encodes the specified GetUncompressedPrpRq message. Does not implicitly {@link priority.netitems.form.GetUncompressedPrpRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @static
                 * @param {priority.netitems.form.IGetUncompressedPrpRq} message GetUncompressedPrpRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetUncompressedPrpRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.FormId != null && Object.hasOwnProperty.call(message, "FormId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.FormId);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    return writer;
                };

                /**
                 * Encodes the specified GetUncompressedPrpRq message, length delimited. Does not implicitly {@link priority.netitems.form.GetUncompressedPrpRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @static
                 * @param {priority.netitems.form.IGetUncompressedPrpRq} message GetUncompressedPrpRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetUncompressedPrpRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetUncompressedPrpRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.GetUncompressedPrpRq} GetUncompressedPrpRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetUncompressedPrpRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.GetUncompressedPrpRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.FormId = reader.int64();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetUncompressedPrpRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.GetUncompressedPrpRq} GetUncompressedPrpRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetUncompressedPrpRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetUncompressedPrpRq message.
                 * @function verify
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetUncompressedPrpRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.FormId != null && message.hasOwnProperty("FormId")) {
                        properties._FormId = 1;
                        if (!$util.isInteger(message.FormId) && !(message.FormId && $util.isInteger(message.FormId.low) && $util.isInteger(message.FormId.high)))
                            return "FormId: integer|Long expected";
                    }
                    if (message.FormName != null && message.hasOwnProperty("FormName")) {
                        properties._FormName = 1;
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a GetUncompressedPrpRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.GetUncompressedPrpRq} GetUncompressedPrpRq
                 */
                GetUncompressedPrpRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.GetUncompressedPrpRq)
                        return object;
                    var message = new $root.priority.netitems.form.GetUncompressedPrpRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.GetUncompressedPrpRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.FormId != null)
                        if ($util.Long)
                            (message.FormId = $util.Long.fromValue(object.FormId)).unsigned = false;
                        else if (typeof object.FormId === "string")
                            message.FormId = parseInt(object.FormId, 10);
                        else if (typeof object.FormId === "number")
                            message.FormId = object.FormId;
                        else if (typeof object.FormId === "object")
                            message.FormId = new $util.LongBits(object.FormId.low >>> 0, object.FormId.high >>> 0).toNumber();
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    return message;
                };

                /**
                 * Creates a plain object from a GetUncompressedPrpRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @static
                 * @param {priority.netitems.form.GetUncompressedPrpRq} message GetUncompressedPrpRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetUncompressedPrpRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.FormId != null && message.hasOwnProperty("FormId")) {
                        if (typeof message.FormId === "number")
                            object.FormId = options.longs === String ? String(message.FormId) : message.FormId;
                        else
                            object.FormId = options.longs === String ? $util.Long.prototype.toString.call(message.FormId) : options.longs === Number ? new $util.LongBits(message.FormId.low >>> 0, message.FormId.high >>> 0).toNumber() : message.FormId;
                        if (options.oneofs)
                            object._FormId = "FormId";
                    }
                    if (message.FormName != null && message.hasOwnProperty("FormName")) {
                        object.FormName = message.FormName;
                        if (options.oneofs)
                            object._FormName = "FormName";
                    }
                    return object;
                };

                /**
                 * Converts this GetUncompressedPrpRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.GetUncompressedPrpRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetUncompressedPrpRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GetUncompressedPrpRq;
            })();

            form.UncompressedPrpData = (function() {

                /**
                 * Properties of an UncompressedPrpData.
                 * @memberof priority.netitems.form
                 * @interface IUncompressedPrpData
                 * @property {Uint8Array|null} [Data] UncompressedPrpData Data
                 * @property {number|Long|null} [FormID] UncompressedPrpData FormID
                 * @property {string|null} [FormName] UncompressedPrpData FormName
                 * @property {number|Long|null} [PrpVersion] UncompressedPrpData PrpVersion
                 */

                /**
                 * Constructs a new UncompressedPrpData.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an UncompressedPrpData.
                 * @implements IUncompressedPrpData
                 * @constructor
                 * @param {priority.netitems.form.IUncompressedPrpData=} [properties] Properties to set
                 */
                function UncompressedPrpData(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UncompressedPrpData Data.
                 * @member {Uint8Array} Data
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @instance
                 */
                UncompressedPrpData.prototype.Data = $util.newBuffer([]);

                /**
                 * UncompressedPrpData FormID.
                 * @member {number|Long} FormID
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @instance
                 */
                UncompressedPrpData.prototype.FormID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * UncompressedPrpData FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @instance
                 */
                UncompressedPrpData.prototype.FormName = "";

                /**
                 * UncompressedPrpData PrpVersion.
                 * @member {number|Long} PrpVersion
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @instance
                 */
                UncompressedPrpData.prototype.PrpVersion = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new UncompressedPrpData instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @static
                 * @param {priority.netitems.form.IUncompressedPrpData=} [properties] Properties to set
                 * @returns {priority.netitems.form.UncompressedPrpData} UncompressedPrpData instance
                 */
                UncompressedPrpData.create = function create(properties) {
                    return new UncompressedPrpData(properties);
                };

                /**
                 * Encodes the specified UncompressedPrpData message. Does not implicitly {@link priority.netitems.form.UncompressedPrpData.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @static
                 * @param {priority.netitems.form.IUncompressedPrpData} message UncompressedPrpData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UncompressedPrpData.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.Data);
                    if (message.FormID != null && Object.hasOwnProperty.call(message, "FormID"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.FormID);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormName);
                    if (message.PrpVersion != null && Object.hasOwnProperty.call(message, "PrpVersion"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.PrpVersion);
                    return writer;
                };

                /**
                 * Encodes the specified UncompressedPrpData message, length delimited. Does not implicitly {@link priority.netitems.form.UncompressedPrpData.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @static
                 * @param {priority.netitems.form.IUncompressedPrpData} message UncompressedPrpData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UncompressedPrpData.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UncompressedPrpData message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.UncompressedPrpData} UncompressedPrpData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UncompressedPrpData.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.UncompressedPrpData();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Data = reader.bytes();
                            break;
                        case 2:
                            message.FormID = reader.int64();
                            break;
                        case 3:
                            message.FormName = reader.string();
                            break;
                        case 4:
                            message.PrpVersion = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UncompressedPrpData message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.UncompressedPrpData} UncompressedPrpData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UncompressedPrpData.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UncompressedPrpData message.
                 * @function verify
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UncompressedPrpData.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Data != null && message.hasOwnProperty("Data"))
                        if (!(message.Data && typeof message.Data.length === "number" || $util.isString(message.Data)))
                            return "Data: buffer expected";
                    if (message.FormID != null && message.hasOwnProperty("FormID"))
                        if (!$util.isInteger(message.FormID) && !(message.FormID && $util.isInteger(message.FormID.low) && $util.isInteger(message.FormID.high)))
                            return "FormID: integer|Long expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.PrpVersion != null && message.hasOwnProperty("PrpVersion"))
                        if (!$util.isInteger(message.PrpVersion) && !(message.PrpVersion && $util.isInteger(message.PrpVersion.low) && $util.isInteger(message.PrpVersion.high)))
                            return "PrpVersion: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an UncompressedPrpData message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.UncompressedPrpData} UncompressedPrpData
                 */
                UncompressedPrpData.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.UncompressedPrpData)
                        return object;
                    var message = new $root.priority.netitems.form.UncompressedPrpData();
                    if (object.Data != null)
                        if (typeof object.Data === "string")
                            $util.base64.decode(object.Data, message.Data = $util.newBuffer($util.base64.length(object.Data)), 0);
                        else if (object.Data.length)
                            message.Data = object.Data;
                    if (object.FormID != null)
                        if ($util.Long)
                            (message.FormID = $util.Long.fromValue(object.FormID)).unsigned = false;
                        else if (typeof object.FormID === "string")
                            message.FormID = parseInt(object.FormID, 10);
                        else if (typeof object.FormID === "number")
                            message.FormID = object.FormID;
                        else if (typeof object.FormID === "object")
                            message.FormID = new $util.LongBits(object.FormID.low >>> 0, object.FormID.high >>> 0).toNumber();
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    if (object.PrpVersion != null)
                        if ($util.Long)
                            (message.PrpVersion = $util.Long.fromValue(object.PrpVersion)).unsigned = false;
                        else if (typeof object.PrpVersion === "string")
                            message.PrpVersion = parseInt(object.PrpVersion, 10);
                        else if (typeof object.PrpVersion === "number")
                            message.PrpVersion = object.PrpVersion;
                        else if (typeof object.PrpVersion === "object")
                            message.PrpVersion = new $util.LongBits(object.PrpVersion.low >>> 0, object.PrpVersion.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an UncompressedPrpData message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @static
                 * @param {priority.netitems.form.UncompressedPrpData} message UncompressedPrpData
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UncompressedPrpData.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if (options.bytes === String)
                            object.Data = "";
                        else {
                            object.Data = [];
                            if (options.bytes !== Array)
                                object.Data = $util.newBuffer(object.Data);
                        }
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.FormID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.FormID = options.longs === String ? "0" : 0;
                        object.FormName = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.PrpVersion = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.PrpVersion = options.longs === String ? "0" : 0;
                    }
                    if (message.Data != null && message.hasOwnProperty("Data"))
                        object.Data = options.bytes === String ? $util.base64.encode(message.Data, 0, message.Data.length) : options.bytes === Array ? Array.prototype.slice.call(message.Data) : message.Data;
                    if (message.FormID != null && message.hasOwnProperty("FormID"))
                        if (typeof message.FormID === "number")
                            object.FormID = options.longs === String ? String(message.FormID) : message.FormID;
                        else
                            object.FormID = options.longs === String ? $util.Long.prototype.toString.call(message.FormID) : options.longs === Number ? new $util.LongBits(message.FormID.low >>> 0, message.FormID.high >>> 0).toNumber() : message.FormID;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.PrpVersion != null && message.hasOwnProperty("PrpVersion"))
                        if (typeof message.PrpVersion === "number")
                            object.PrpVersion = options.longs === String ? String(message.PrpVersion) : message.PrpVersion;
                        else
                            object.PrpVersion = options.longs === String ? $util.Long.prototype.toString.call(message.PrpVersion) : options.longs === Number ? new $util.LongBits(message.PrpVersion.low >>> 0, message.PrpVersion.high >>> 0).toNumber() : message.PrpVersion;
                    return object;
                };

                /**
                 * Converts this UncompressedPrpData to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.UncompressedPrpData
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UncompressedPrpData.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UncompressedPrpData;
            })();

            form.GetUncompressedPrpRs = (function() {

                /**
                 * Properties of a GetUncompressedPrpRs.
                 * @memberof priority.netitems.form
                 * @interface IGetUncompressedPrpRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] GetUncompressedPrpRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] GetUncompressedPrpRs Messages
                 * @property {priority.netitems.form.IUncompressedPrpData|null} [PrpData] GetUncompressedPrpRs PrpData
                 */

                /**
                 * Constructs a new GetUncompressedPrpRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a GetUncompressedPrpRs.
                 * @implements IGetUncompressedPrpRs
                 * @constructor
                 * @param {priority.netitems.form.IGetUncompressedPrpRs=} [properties] Properties to set
                 */
                function GetUncompressedPrpRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetUncompressedPrpRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @instance
                 */
                GetUncompressedPrpRs.prototype.Perf = null;

                /**
                 * GetUncompressedPrpRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @instance
                 */
                GetUncompressedPrpRs.prototype.Messages = $util.emptyArray;

                /**
                 * GetUncompressedPrpRs PrpData.
                 * @member {priority.netitems.form.IUncompressedPrpData|null|undefined} PrpData
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @instance
                 */
                GetUncompressedPrpRs.prototype.PrpData = null;

                /**
                 * Creates a new GetUncompressedPrpRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @static
                 * @param {priority.netitems.form.IGetUncompressedPrpRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.GetUncompressedPrpRs} GetUncompressedPrpRs instance
                 */
                GetUncompressedPrpRs.create = function create(properties) {
                    return new GetUncompressedPrpRs(properties);
                };

                /**
                 * Encodes the specified GetUncompressedPrpRs message. Does not implicitly {@link priority.netitems.form.GetUncompressedPrpRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @static
                 * @param {priority.netitems.form.IGetUncompressedPrpRs} message GetUncompressedPrpRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetUncompressedPrpRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.PrpData != null && Object.hasOwnProperty.call(message, "PrpData"))
                        $root.priority.netitems.form.UncompressedPrpData.encode(message.PrpData, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified GetUncompressedPrpRs message, length delimited. Does not implicitly {@link priority.netitems.form.GetUncompressedPrpRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @static
                 * @param {priority.netitems.form.IGetUncompressedPrpRs} message GetUncompressedPrpRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetUncompressedPrpRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetUncompressedPrpRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.GetUncompressedPrpRs} GetUncompressedPrpRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetUncompressedPrpRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.GetUncompressedPrpRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.PrpData = $root.priority.netitems.form.UncompressedPrpData.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetUncompressedPrpRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.GetUncompressedPrpRs} GetUncompressedPrpRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetUncompressedPrpRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetUncompressedPrpRs message.
                 * @function verify
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetUncompressedPrpRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.PrpData != null && message.hasOwnProperty("PrpData")) {
                        var error = $root.priority.netitems.form.UncompressedPrpData.verify(message.PrpData);
                        if (error)
                            return "PrpData." + error;
                    }
                    return null;
                };

                /**
                 * Creates a GetUncompressedPrpRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.GetUncompressedPrpRs} GetUncompressedPrpRs
                 */
                GetUncompressedPrpRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.GetUncompressedPrpRs)
                        return object;
                    var message = new $root.priority.netitems.form.GetUncompressedPrpRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.GetUncompressedPrpRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.GetUncompressedPrpRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.GetUncompressedPrpRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.PrpData != null) {
                        if (typeof object.PrpData !== "object")
                            throw TypeError(".priority.netitems.form.GetUncompressedPrpRs.PrpData: object expected");
                        message.PrpData = $root.priority.netitems.form.UncompressedPrpData.fromObject(object.PrpData);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GetUncompressedPrpRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @static
                 * @param {priority.netitems.form.GetUncompressedPrpRs} message GetUncompressedPrpRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetUncompressedPrpRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.PrpData = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.PrpData != null && message.hasOwnProperty("PrpData"))
                        object.PrpData = $root.priority.netitems.form.UncompressedPrpData.toObject(message.PrpData, options);
                    return object;
                };

                /**
                 * Converts this GetUncompressedPrpRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.GetUncompressedPrpRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetUncompressedPrpRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GetUncompressedPrpRs;
            })();

            form.EmptyRs = (function() {

                /**
                 * Properties of an EmptyRs.
                 * @memberof priority.netitems.form
                 * @interface IEmptyRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] EmptyRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] EmptyRs Messages
                 */

                /**
                 * Constructs a new EmptyRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an EmptyRs.
                 * @implements IEmptyRs
                 * @constructor
                 * @param {priority.netitems.form.IEmptyRs=} [properties] Properties to set
                 */
                function EmptyRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EmptyRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.EmptyRs
                 * @instance
                 */
                EmptyRs.prototype.Perf = null;

                /**
                 * EmptyRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.EmptyRs
                 * @instance
                 */
                EmptyRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new EmptyRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.EmptyRs
                 * @static
                 * @param {priority.netitems.form.IEmptyRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.EmptyRs} EmptyRs instance
                 */
                EmptyRs.create = function create(properties) {
                    return new EmptyRs(properties);
                };

                /**
                 * Encodes the specified EmptyRs message. Does not implicitly {@link priority.netitems.form.EmptyRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.EmptyRs
                 * @static
                 * @param {priority.netitems.form.IEmptyRs} message EmptyRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmptyRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified EmptyRs message, length delimited. Does not implicitly {@link priority.netitems.form.EmptyRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.EmptyRs
                 * @static
                 * @param {priority.netitems.form.IEmptyRs} message EmptyRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmptyRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EmptyRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.EmptyRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.EmptyRs} EmptyRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmptyRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.EmptyRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EmptyRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.EmptyRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.EmptyRs} EmptyRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmptyRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EmptyRs message.
                 * @function verify
                 * @memberof priority.netitems.form.EmptyRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EmptyRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an EmptyRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.EmptyRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.EmptyRs} EmptyRs
                 */
                EmptyRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.EmptyRs)
                        return object;
                    var message = new $root.priority.netitems.form.EmptyRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.EmptyRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.EmptyRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.EmptyRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an EmptyRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.EmptyRs
                 * @static
                 * @param {priority.netitems.form.EmptyRs} message EmptyRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EmptyRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this EmptyRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.EmptyRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EmptyRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return EmptyRs;
            })();

            form.AlertListRq = (function() {

                /**
                 * Properties of an AlertListRq.
                 * @memberof priority.netitems.form
                 * @interface IAlertListRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AlertListRq Properties
                 * @property {string|null} [Session] AlertListRq Session
                 * @property {priority.netitems.form.RuleType|null} [Type] AlertListRq Type
                 */

                /**
                 * Constructs a new AlertListRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertListRq.
                 * @implements IAlertListRq
                 * @constructor
                 * @param {priority.netitems.form.IAlertListRq=} [properties] Properties to set
                 */
                function AlertListRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertListRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.AlertListRq
                 * @instance
                 */
                AlertListRq.prototype.Properties = null;

                /**
                 * AlertListRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.AlertListRq
                 * @instance
                 */
                AlertListRq.prototype.Session = "";

                /**
                 * AlertListRq Type.
                 * @member {priority.netitems.form.RuleType} Type
                 * @memberof priority.netitems.form.AlertListRq
                 * @instance
                 */
                AlertListRq.prototype.Type = 0;

                /**
                 * Creates a new AlertListRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertListRq
                 * @static
                 * @param {priority.netitems.form.IAlertListRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertListRq} AlertListRq instance
                 */
                AlertListRq.create = function create(properties) {
                    return new AlertListRq(properties);
                };

                /**
                 * Encodes the specified AlertListRq message. Does not implicitly {@link priority.netitems.form.AlertListRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertListRq
                 * @static
                 * @param {priority.netitems.form.IAlertListRq} message AlertListRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertListRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Type);
                    return writer;
                };

                /**
                 * Encodes the specified AlertListRq message, length delimited. Does not implicitly {@link priority.netitems.form.AlertListRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertListRq
                 * @static
                 * @param {priority.netitems.form.IAlertListRq} message AlertListRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertListRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertListRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertListRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertListRq} AlertListRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertListRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertListRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.Type = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertListRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertListRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertListRq} AlertListRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertListRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertListRq message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertListRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertListRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        switch (message.Type) {
                        default:
                            return "Type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates an AlertListRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertListRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertListRq} AlertListRq
                 */
                AlertListRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertListRq)
                        return object;
                    var message = new $root.priority.netitems.form.AlertListRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.AlertListRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    switch (object.Type) {
                    case "UNKNOWN_RULETYPE":
                    case 0:
                        message.Type = 0;
                        break;
                    case "Business":
                    case 1:
                        message.Type = 1;
                        break;
                    case "AutoFill":
                    case 2:
                        message.Type = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AlertListRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertListRq
                 * @static
                 * @param {priority.netitems.form.AlertListRq} message AlertListRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertListRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.Type = options.enums === String ? "UNKNOWN_RULETYPE" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        object.Type = options.enums === String ? $root.priority.netitems.form.RuleType[message.Type] : message.Type;
                    return object;
                };

                /**
                 * Converts this AlertListRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertListRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertListRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertListRq;
            })();

            form.AlertListRs = (function() {

                /**
                 * Properties of an AlertListRs.
                 * @memberof priority.netitems.form
                 * @interface IAlertListRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] AlertListRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] AlertListRs Messages
                 * @property {Array.<priority.netitems.form.IAlert>|null} [AlertList] AlertListRs AlertList
                 */

                /**
                 * Constructs a new AlertListRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertListRs.
                 * @implements IAlertListRs
                 * @constructor
                 * @param {priority.netitems.form.IAlertListRs=} [properties] Properties to set
                 */
                function AlertListRs(properties) {
                    this.Messages = [];
                    this.AlertList = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertListRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.AlertListRs
                 * @instance
                 */
                AlertListRs.prototype.Perf = null;

                /**
                 * AlertListRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.AlertListRs
                 * @instance
                 */
                AlertListRs.prototype.Messages = $util.emptyArray;

                /**
                 * AlertListRs AlertList.
                 * @member {Array.<priority.netitems.form.IAlert>} AlertList
                 * @memberof priority.netitems.form.AlertListRs
                 * @instance
                 */
                AlertListRs.prototype.AlertList = $util.emptyArray;

                /**
                 * Creates a new AlertListRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertListRs
                 * @static
                 * @param {priority.netitems.form.IAlertListRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertListRs} AlertListRs instance
                 */
                AlertListRs.create = function create(properties) {
                    return new AlertListRs(properties);
                };

                /**
                 * Encodes the specified AlertListRs message. Does not implicitly {@link priority.netitems.form.AlertListRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertListRs
                 * @static
                 * @param {priority.netitems.form.IAlertListRs} message AlertListRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertListRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.AlertList != null && message.AlertList.length)
                        for (var i = 0; i < message.AlertList.length; ++i)
                            $root.priority.netitems.form.Alert.encode(message.AlertList[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AlertListRs message, length delimited. Does not implicitly {@link priority.netitems.form.AlertListRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertListRs
                 * @static
                 * @param {priority.netitems.form.IAlertListRs} message AlertListRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertListRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertListRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertListRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertListRs} AlertListRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertListRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertListRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            if (!(message.AlertList && message.AlertList.length))
                                message.AlertList = [];
                            message.AlertList.push($root.priority.netitems.form.Alert.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertListRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertListRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertListRs} AlertListRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertListRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertListRs message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertListRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertListRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.AlertList != null && message.hasOwnProperty("AlertList")) {
                        if (!Array.isArray(message.AlertList))
                            return "AlertList: array expected";
                        for (var i = 0; i < message.AlertList.length; ++i) {
                            var error = $root.priority.netitems.form.Alert.verify(message.AlertList[i]);
                            if (error)
                                return "AlertList." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an AlertListRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertListRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertListRs} AlertListRs
                 */
                AlertListRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertListRs)
                        return object;
                    var message = new $root.priority.netitems.form.AlertListRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.AlertListRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.AlertListRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertListRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.AlertList) {
                        if (!Array.isArray(object.AlertList))
                            throw TypeError(".priority.netitems.form.AlertListRs.AlertList: array expected");
                        message.AlertList = [];
                        for (var i = 0; i < object.AlertList.length; ++i) {
                            if (typeof object.AlertList[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertListRs.AlertList: object expected");
                            message.AlertList[i] = $root.priority.netitems.form.Alert.fromObject(object.AlertList[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AlertListRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertListRs
                 * @static
                 * @param {priority.netitems.form.AlertListRs} message AlertListRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertListRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.AlertList = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.AlertList && message.AlertList.length) {
                        object.AlertList = [];
                        for (var j = 0; j < message.AlertList.length; ++j)
                            object.AlertList[j] = $root.priority.netitems.form.Alert.toObject(message.AlertList[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this AlertListRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertListRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertListRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertListRs;
            })();

            form.AlertChoosesRq = (function() {

                /**
                 * Properties of an AlertChoosesRq.
                 * @memberof priority.netitems.form
                 * @interface IAlertChoosesRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AlertChoosesRq Properties
                 * @property {string|null} [Session] AlertChoosesRq Session
                 */

                /**
                 * Constructs a new AlertChoosesRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertChoosesRq.
                 * @implements IAlertChoosesRq
                 * @constructor
                 * @param {priority.netitems.form.IAlertChoosesRq=} [properties] Properties to set
                 */
                function AlertChoosesRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertChoosesRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @instance
                 */
                AlertChoosesRq.prototype.Properties = null;

                /**
                 * AlertChoosesRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @instance
                 */
                AlertChoosesRq.prototype.Session = "";

                /**
                 * Creates a new AlertChoosesRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @static
                 * @param {priority.netitems.form.IAlertChoosesRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertChoosesRq} AlertChoosesRq instance
                 */
                AlertChoosesRq.create = function create(properties) {
                    return new AlertChoosesRq(properties);
                };

                /**
                 * Encodes the specified AlertChoosesRq message. Does not implicitly {@link priority.netitems.form.AlertChoosesRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @static
                 * @param {priority.netitems.form.IAlertChoosesRq} message AlertChoosesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChoosesRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    return writer;
                };

                /**
                 * Encodes the specified AlertChoosesRq message, length delimited. Does not implicitly {@link priority.netitems.form.AlertChoosesRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @static
                 * @param {priority.netitems.form.IAlertChoosesRq} message AlertChoosesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChoosesRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertChoosesRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertChoosesRq} AlertChoosesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChoosesRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertChoosesRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertChoosesRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertChoosesRq} AlertChoosesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChoosesRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertChoosesRq message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertChoosesRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    return null;
                };

                /**
                 * Creates an AlertChoosesRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertChoosesRq} AlertChoosesRq
                 */
                AlertChoosesRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertChoosesRq)
                        return object;
                    var message = new $root.priority.netitems.form.AlertChoosesRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.AlertChoosesRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    return message;
                };

                /**
                 * Creates a plain object from an AlertChoosesRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @static
                 * @param {priority.netitems.form.AlertChoosesRq} message AlertChoosesRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertChoosesRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    return object;
                };

                /**
                 * Converts this AlertChoosesRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertChoosesRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertChoosesRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertChoosesRq;
            })();

            form.AlertChoosesRs = (function() {

                /**
                 * Properties of an AlertChoosesRs.
                 * @memberof priority.netitems.form
                 * @interface IAlertChoosesRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] AlertChoosesRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] AlertChoosesRs Messages
                 * @property {string|null} [ChooseTitle] AlertChoosesRs ChooseTitle
                 * @property {string|null} [DialogTitle] AlertChoosesRs DialogTitle
                 * @property {string|null} [ListDialogTitle] AlertChoosesRs ListDialogTitle
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [TimeUnits] AlertChoosesRs TimeUnits
                 * @property {Array.<priority.netitems.form.IAlertChooseDocuments>|null} [Documents] AlertChoosesRs Documents
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [User] AlertChoosesRs User
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [ExprPredefined] AlertChoosesRs ExprPredefined
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [ExprFunc] AlertChoosesRs ExprFunc
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [Groups] AlertChoosesRs Groups
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [MessageTypes] AlertChoosesRs MessageTypes
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [MailFields] AlertChoosesRs MailFields
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [MailUserFields] AlertChoosesRs MailUserFields
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [MailTypes] AlertChoosesRs MailTypes
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [Ops] AlertChoosesRs Ops
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [CurrrentValues] AlertChoosesRs CurrrentValues
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [Fields] AlertChoosesRs Fields
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [EnglishFields] AlertChoosesRs EnglishFields
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [ValidTypes] AlertChoosesRs ValidTypes
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [PrivilegeGroups] AlertChoosesRs PrivilegeGroups
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [ValueFields] AlertChoosesRs ValueFields
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [DateFields] AlertChoosesRs DateFields
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [Webhooks] AlertChoosesRs Webhooks
                 */

                /**
                 * Constructs a new AlertChoosesRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertChoosesRs.
                 * @implements IAlertChoosesRs
                 * @constructor
                 * @param {priority.netitems.form.IAlertChoosesRs=} [properties] Properties to set
                 */
                function AlertChoosesRs(properties) {
                    this.Messages = [];
                    this.TimeUnits = [];
                    this.Documents = [];
                    this.User = [];
                    this.ExprPredefined = [];
                    this.ExprFunc = [];
                    this.Groups = [];
                    this.MessageTypes = [];
                    this.MailFields = [];
                    this.MailUserFields = [];
                    this.MailTypes = [];
                    this.Ops = [];
                    this.CurrrentValues = [];
                    this.Fields = [];
                    this.EnglishFields = [];
                    this.ValidTypes = [];
                    this.PrivilegeGroups = [];
                    this.ValueFields = [];
                    this.DateFields = [];
                    this.Webhooks = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertChoosesRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.Perf = null;

                /**
                 * AlertChoosesRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.Messages = $util.emptyArray;

                /**
                 * AlertChoosesRs ChooseTitle.
                 * @member {string} ChooseTitle
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.ChooseTitle = "";

                /**
                 * AlertChoosesRs DialogTitle.
                 * @member {string} DialogTitle
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.DialogTitle = "";

                /**
                 * AlertChoosesRs ListDialogTitle.
                 * @member {string} ListDialogTitle
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.ListDialogTitle = "";

                /**
                 * AlertChoosesRs TimeUnits.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} TimeUnits
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.TimeUnits = $util.emptyArray;

                /**
                 * AlertChoosesRs Documents.
                 * @member {Array.<priority.netitems.form.IAlertChooseDocuments>} Documents
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.Documents = $util.emptyArray;

                /**
                 * AlertChoosesRs User.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} User
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.User = $util.emptyArray;

                /**
                 * AlertChoosesRs ExprPredefined.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} ExprPredefined
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.ExprPredefined = $util.emptyArray;

                /**
                 * AlertChoosesRs ExprFunc.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} ExprFunc
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.ExprFunc = $util.emptyArray;

                /**
                 * AlertChoosesRs Groups.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} Groups
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.Groups = $util.emptyArray;

                /**
                 * AlertChoosesRs MessageTypes.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} MessageTypes
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.MessageTypes = $util.emptyArray;

                /**
                 * AlertChoosesRs MailFields.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} MailFields
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.MailFields = $util.emptyArray;

                /**
                 * AlertChoosesRs MailUserFields.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} MailUserFields
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.MailUserFields = $util.emptyArray;

                /**
                 * AlertChoosesRs MailTypes.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} MailTypes
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.MailTypes = $util.emptyArray;

                /**
                 * AlertChoosesRs Ops.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} Ops
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.Ops = $util.emptyArray;

                /**
                 * AlertChoosesRs CurrrentValues.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} CurrrentValues
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.CurrrentValues = $util.emptyArray;

                /**
                 * AlertChoosesRs Fields.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} Fields
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.Fields = $util.emptyArray;

                /**
                 * AlertChoosesRs EnglishFields.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} EnglishFields
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.EnglishFields = $util.emptyArray;

                /**
                 * AlertChoosesRs ValidTypes.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} ValidTypes
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.ValidTypes = $util.emptyArray;

                /**
                 * AlertChoosesRs PrivilegeGroups.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} PrivilegeGroups
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.PrivilegeGroups = $util.emptyArray;

                /**
                 * AlertChoosesRs ValueFields.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} ValueFields
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.ValueFields = $util.emptyArray;

                /**
                 * AlertChoosesRs DateFields.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} DateFields
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.DateFields = $util.emptyArray;

                /**
                 * AlertChoosesRs Webhooks.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} Webhooks
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 */
                AlertChoosesRs.prototype.Webhooks = $util.emptyArray;

                /**
                 * Creates a new AlertChoosesRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @static
                 * @param {priority.netitems.form.IAlertChoosesRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertChoosesRs} AlertChoosesRs instance
                 */
                AlertChoosesRs.create = function create(properties) {
                    return new AlertChoosesRs(properties);
                };

                /**
                 * Encodes the specified AlertChoosesRs message. Does not implicitly {@link priority.netitems.form.AlertChoosesRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @static
                 * @param {priority.netitems.form.IAlertChoosesRs} message AlertChoosesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChoosesRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ChooseTitle != null && Object.hasOwnProperty.call(message, "ChooseTitle"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.ChooseTitle);
                    if (message.DialogTitle != null && Object.hasOwnProperty.call(message, "DialogTitle"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.DialogTitle);
                    if (message.ListDialogTitle != null && Object.hasOwnProperty.call(message, "ListDialogTitle"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.ListDialogTitle);
                    if (message.TimeUnits != null && message.TimeUnits.length)
                        for (var i = 0; i < message.TimeUnits.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.TimeUnits[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Documents != null && message.Documents.length)
                        for (var i = 0; i < message.Documents.length; ++i)
                            $root.priority.netitems.form.AlertChooseDocuments.encode(message.Documents[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.User != null && message.User.length)
                        for (var i = 0; i < message.User.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.User[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.ExprPredefined != null && message.ExprPredefined.length)
                        for (var i = 0; i < message.ExprPredefined.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.ExprPredefined[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.ExprFunc != null && message.ExprFunc.length)
                        for (var i = 0; i < message.ExprFunc.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.ExprFunc[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.Groups != null && message.Groups.length)
                        for (var i = 0; i < message.Groups.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.Groups[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.MessageTypes != null && message.MessageTypes.length)
                        for (var i = 0; i < message.MessageTypes.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.MessageTypes[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.MailFields != null && message.MailFields.length)
                        for (var i = 0; i < message.MailFields.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.MailFields[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.MailUserFields != null && message.MailUserFields.length)
                        for (var i = 0; i < message.MailUserFields.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.MailUserFields[i], writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.MailTypes != null && message.MailTypes.length)
                        for (var i = 0; i < message.MailTypes.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.MailTypes[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.Ops != null && message.Ops.length)
                        for (var i = 0; i < message.Ops.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.Ops[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.CurrrentValues != null && message.CurrrentValues.length)
                        for (var i = 0; i < message.CurrrentValues.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.CurrrentValues[i], writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.Fields != null && message.Fields.length)
                        for (var i = 0; i < message.Fields.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.Fields[i], writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.EnglishFields != null && message.EnglishFields.length)
                        for (var i = 0; i < message.EnglishFields.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.EnglishFields[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    if (message.ValidTypes != null && message.ValidTypes.length)
                        for (var i = 0; i < message.ValidTypes.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.ValidTypes[i], writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                    if (message.PrivilegeGroups != null && message.PrivilegeGroups.length)
                        for (var i = 0; i < message.PrivilegeGroups.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.PrivilegeGroups[i], writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    if (message.ValueFields != null && message.ValueFields.length)
                        for (var i = 0; i < message.ValueFields.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.ValueFields[i], writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                    if (message.DateFields != null && message.DateFields.length)
                        for (var i = 0; i < message.DateFields.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.DateFields[i], writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                    if (message.Webhooks != null && message.Webhooks.length)
                        for (var i = 0; i < message.Webhooks.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.Webhooks[i], writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AlertChoosesRs message, length delimited. Does not implicitly {@link priority.netitems.form.AlertChoosesRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @static
                 * @param {priority.netitems.form.IAlertChoosesRs} message AlertChoosesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChoosesRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertChoosesRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertChoosesRs} AlertChoosesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChoosesRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertChoosesRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.ChooseTitle = reader.string();
                            break;
                        case 4:
                            message.DialogTitle = reader.string();
                            break;
                        case 5:
                            message.ListDialogTitle = reader.string();
                            break;
                        case 6:
                            if (!(message.TimeUnits && message.TimeUnits.length))
                                message.TimeUnits = [];
                            message.TimeUnits.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            if (!(message.Documents && message.Documents.length))
                                message.Documents = [];
                            message.Documents.push($root.priority.netitems.form.AlertChooseDocuments.decode(reader, reader.uint32()));
                            break;
                        case 8:
                            if (!(message.User && message.User.length))
                                message.User = [];
                            message.User.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 9:
                            if (!(message.ExprPredefined && message.ExprPredefined.length))
                                message.ExprPredefined = [];
                            message.ExprPredefined.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 10:
                            if (!(message.ExprFunc && message.ExprFunc.length))
                                message.ExprFunc = [];
                            message.ExprFunc.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 11:
                            if (!(message.Groups && message.Groups.length))
                                message.Groups = [];
                            message.Groups.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 12:
                            if (!(message.MessageTypes && message.MessageTypes.length))
                                message.MessageTypes = [];
                            message.MessageTypes.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 13:
                            if (!(message.MailFields && message.MailFields.length))
                                message.MailFields = [];
                            message.MailFields.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 14:
                            if (!(message.MailUserFields && message.MailUserFields.length))
                                message.MailUserFields = [];
                            message.MailUserFields.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 15:
                            if (!(message.MailTypes && message.MailTypes.length))
                                message.MailTypes = [];
                            message.MailTypes.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 16:
                            if (!(message.Ops && message.Ops.length))
                                message.Ops = [];
                            message.Ops.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 17:
                            if (!(message.CurrrentValues && message.CurrrentValues.length))
                                message.CurrrentValues = [];
                            message.CurrrentValues.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 18:
                            if (!(message.Fields && message.Fields.length))
                                message.Fields = [];
                            message.Fields.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 19:
                            if (!(message.EnglishFields && message.EnglishFields.length))
                                message.EnglishFields = [];
                            message.EnglishFields.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 20:
                            if (!(message.ValidTypes && message.ValidTypes.length))
                                message.ValidTypes = [];
                            message.ValidTypes.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 21:
                            if (!(message.PrivilegeGroups && message.PrivilegeGroups.length))
                                message.PrivilegeGroups = [];
                            message.PrivilegeGroups.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 22:
                            if (!(message.ValueFields && message.ValueFields.length))
                                message.ValueFields = [];
                            message.ValueFields.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 23:
                            if (!(message.DateFields && message.DateFields.length))
                                message.DateFields = [];
                            message.DateFields.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 24:
                            if (!(message.Webhooks && message.Webhooks.length))
                                message.Webhooks = [];
                            message.Webhooks.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertChoosesRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertChoosesRs} AlertChoosesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChoosesRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertChoosesRs message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertChoosesRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.ChooseTitle != null && message.hasOwnProperty("ChooseTitle"))
                        if (!$util.isString(message.ChooseTitle))
                            return "ChooseTitle: string expected";
                    if (message.DialogTitle != null && message.hasOwnProperty("DialogTitle"))
                        if (!$util.isString(message.DialogTitle))
                            return "DialogTitle: string expected";
                    if (message.ListDialogTitle != null && message.hasOwnProperty("ListDialogTitle"))
                        if (!$util.isString(message.ListDialogTitle))
                            return "ListDialogTitle: string expected";
                    if (message.TimeUnits != null && message.hasOwnProperty("TimeUnits")) {
                        if (!Array.isArray(message.TimeUnits))
                            return "TimeUnits: array expected";
                        for (var i = 0; i < message.TimeUnits.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.TimeUnits[i]);
                            if (error)
                                return "TimeUnits." + error;
                        }
                    }
                    if (message.Documents != null && message.hasOwnProperty("Documents")) {
                        if (!Array.isArray(message.Documents))
                            return "Documents: array expected";
                        for (var i = 0; i < message.Documents.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChooseDocuments.verify(message.Documents[i]);
                            if (error)
                                return "Documents." + error;
                        }
                    }
                    if (message.User != null && message.hasOwnProperty("User")) {
                        if (!Array.isArray(message.User))
                            return "User: array expected";
                        for (var i = 0; i < message.User.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.User[i]);
                            if (error)
                                return "User." + error;
                        }
                    }
                    if (message.ExprPredefined != null && message.hasOwnProperty("ExprPredefined")) {
                        if (!Array.isArray(message.ExprPredefined))
                            return "ExprPredefined: array expected";
                        for (var i = 0; i < message.ExprPredefined.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.ExprPredefined[i]);
                            if (error)
                                return "ExprPredefined." + error;
                        }
                    }
                    if (message.ExprFunc != null && message.hasOwnProperty("ExprFunc")) {
                        if (!Array.isArray(message.ExprFunc))
                            return "ExprFunc: array expected";
                        for (var i = 0; i < message.ExprFunc.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.ExprFunc[i]);
                            if (error)
                                return "ExprFunc." + error;
                        }
                    }
                    if (message.Groups != null && message.hasOwnProperty("Groups")) {
                        if (!Array.isArray(message.Groups))
                            return "Groups: array expected";
                        for (var i = 0; i < message.Groups.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.Groups[i]);
                            if (error)
                                return "Groups." + error;
                        }
                    }
                    if (message.MessageTypes != null && message.hasOwnProperty("MessageTypes")) {
                        if (!Array.isArray(message.MessageTypes))
                            return "MessageTypes: array expected";
                        for (var i = 0; i < message.MessageTypes.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.MessageTypes[i]);
                            if (error)
                                return "MessageTypes." + error;
                        }
                    }
                    if (message.MailFields != null && message.hasOwnProperty("MailFields")) {
                        if (!Array.isArray(message.MailFields))
                            return "MailFields: array expected";
                        for (var i = 0; i < message.MailFields.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.MailFields[i]);
                            if (error)
                                return "MailFields." + error;
                        }
                    }
                    if (message.MailUserFields != null && message.hasOwnProperty("MailUserFields")) {
                        if (!Array.isArray(message.MailUserFields))
                            return "MailUserFields: array expected";
                        for (var i = 0; i < message.MailUserFields.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.MailUserFields[i]);
                            if (error)
                                return "MailUserFields." + error;
                        }
                    }
                    if (message.MailTypes != null && message.hasOwnProperty("MailTypes")) {
                        if (!Array.isArray(message.MailTypes))
                            return "MailTypes: array expected";
                        for (var i = 0; i < message.MailTypes.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.MailTypes[i]);
                            if (error)
                                return "MailTypes." + error;
                        }
                    }
                    if (message.Ops != null && message.hasOwnProperty("Ops")) {
                        if (!Array.isArray(message.Ops))
                            return "Ops: array expected";
                        for (var i = 0; i < message.Ops.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.Ops[i]);
                            if (error)
                                return "Ops." + error;
                        }
                    }
                    if (message.CurrrentValues != null && message.hasOwnProperty("CurrrentValues")) {
                        if (!Array.isArray(message.CurrrentValues))
                            return "CurrrentValues: array expected";
                        for (var i = 0; i < message.CurrrentValues.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.CurrrentValues[i]);
                            if (error)
                                return "CurrrentValues." + error;
                        }
                    }
                    if (message.Fields != null && message.hasOwnProperty("Fields")) {
                        if (!Array.isArray(message.Fields))
                            return "Fields: array expected";
                        for (var i = 0; i < message.Fields.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.Fields[i]);
                            if (error)
                                return "Fields." + error;
                        }
                    }
                    if (message.EnglishFields != null && message.hasOwnProperty("EnglishFields")) {
                        if (!Array.isArray(message.EnglishFields))
                            return "EnglishFields: array expected";
                        for (var i = 0; i < message.EnglishFields.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.EnglishFields[i]);
                            if (error)
                                return "EnglishFields." + error;
                        }
                    }
                    if (message.ValidTypes != null && message.hasOwnProperty("ValidTypes")) {
                        if (!Array.isArray(message.ValidTypes))
                            return "ValidTypes: array expected";
                        for (var i = 0; i < message.ValidTypes.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.ValidTypes[i]);
                            if (error)
                                return "ValidTypes." + error;
                        }
                    }
                    if (message.PrivilegeGroups != null && message.hasOwnProperty("PrivilegeGroups")) {
                        if (!Array.isArray(message.PrivilegeGroups))
                            return "PrivilegeGroups: array expected";
                        for (var i = 0; i < message.PrivilegeGroups.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.PrivilegeGroups[i]);
                            if (error)
                                return "PrivilegeGroups." + error;
                        }
                    }
                    if (message.ValueFields != null && message.hasOwnProperty("ValueFields")) {
                        if (!Array.isArray(message.ValueFields))
                            return "ValueFields: array expected";
                        for (var i = 0; i < message.ValueFields.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.ValueFields[i]);
                            if (error)
                                return "ValueFields." + error;
                        }
                    }
                    if (message.DateFields != null && message.hasOwnProperty("DateFields")) {
                        if (!Array.isArray(message.DateFields))
                            return "DateFields: array expected";
                        for (var i = 0; i < message.DateFields.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.DateFields[i]);
                            if (error)
                                return "DateFields." + error;
                        }
                    }
                    if (message.Webhooks != null && message.hasOwnProperty("Webhooks")) {
                        if (!Array.isArray(message.Webhooks))
                            return "Webhooks: array expected";
                        for (var i = 0; i < message.Webhooks.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.Webhooks[i]);
                            if (error)
                                return "Webhooks." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an AlertChoosesRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertChoosesRs} AlertChoosesRs
                 */
                AlertChoosesRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertChoosesRs)
                        return object;
                    var message = new $root.priority.netitems.form.AlertChoosesRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.ChooseTitle != null)
                        message.ChooseTitle = String(object.ChooseTitle);
                    if (object.DialogTitle != null)
                        message.DialogTitle = String(object.DialogTitle);
                    if (object.ListDialogTitle != null)
                        message.ListDialogTitle = String(object.ListDialogTitle);
                    if (object.TimeUnits) {
                        if (!Array.isArray(object.TimeUnits))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.TimeUnits: array expected");
                        message.TimeUnits = [];
                        for (var i = 0; i < object.TimeUnits.length; ++i) {
                            if (typeof object.TimeUnits[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.TimeUnits: object expected");
                            message.TimeUnits[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.TimeUnits[i]);
                        }
                    }
                    if (object.Documents) {
                        if (!Array.isArray(object.Documents))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.Documents: array expected");
                        message.Documents = [];
                        for (var i = 0; i < object.Documents.length; ++i) {
                            if (typeof object.Documents[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.Documents: object expected");
                            message.Documents[i] = $root.priority.netitems.form.AlertChooseDocuments.fromObject(object.Documents[i]);
                        }
                    }
                    if (object.User) {
                        if (!Array.isArray(object.User))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.User: array expected");
                        message.User = [];
                        for (var i = 0; i < object.User.length; ++i) {
                            if (typeof object.User[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.User: object expected");
                            message.User[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.User[i]);
                        }
                    }
                    if (object.ExprPredefined) {
                        if (!Array.isArray(object.ExprPredefined))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.ExprPredefined: array expected");
                        message.ExprPredefined = [];
                        for (var i = 0; i < object.ExprPredefined.length; ++i) {
                            if (typeof object.ExprPredefined[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.ExprPredefined: object expected");
                            message.ExprPredefined[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.ExprPredefined[i]);
                        }
                    }
                    if (object.ExprFunc) {
                        if (!Array.isArray(object.ExprFunc))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.ExprFunc: array expected");
                        message.ExprFunc = [];
                        for (var i = 0; i < object.ExprFunc.length; ++i) {
                            if (typeof object.ExprFunc[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.ExprFunc: object expected");
                            message.ExprFunc[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.ExprFunc[i]);
                        }
                    }
                    if (object.Groups) {
                        if (!Array.isArray(object.Groups))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.Groups: array expected");
                        message.Groups = [];
                        for (var i = 0; i < object.Groups.length; ++i) {
                            if (typeof object.Groups[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.Groups: object expected");
                            message.Groups[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.Groups[i]);
                        }
                    }
                    if (object.MessageTypes) {
                        if (!Array.isArray(object.MessageTypes))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.MessageTypes: array expected");
                        message.MessageTypes = [];
                        for (var i = 0; i < object.MessageTypes.length; ++i) {
                            if (typeof object.MessageTypes[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.MessageTypes: object expected");
                            message.MessageTypes[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.MessageTypes[i]);
                        }
                    }
                    if (object.MailFields) {
                        if (!Array.isArray(object.MailFields))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.MailFields: array expected");
                        message.MailFields = [];
                        for (var i = 0; i < object.MailFields.length; ++i) {
                            if (typeof object.MailFields[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.MailFields: object expected");
                            message.MailFields[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.MailFields[i]);
                        }
                    }
                    if (object.MailUserFields) {
                        if (!Array.isArray(object.MailUserFields))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.MailUserFields: array expected");
                        message.MailUserFields = [];
                        for (var i = 0; i < object.MailUserFields.length; ++i) {
                            if (typeof object.MailUserFields[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.MailUserFields: object expected");
                            message.MailUserFields[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.MailUserFields[i]);
                        }
                    }
                    if (object.MailTypes) {
                        if (!Array.isArray(object.MailTypes))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.MailTypes: array expected");
                        message.MailTypes = [];
                        for (var i = 0; i < object.MailTypes.length; ++i) {
                            if (typeof object.MailTypes[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.MailTypes: object expected");
                            message.MailTypes[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.MailTypes[i]);
                        }
                    }
                    if (object.Ops) {
                        if (!Array.isArray(object.Ops))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.Ops: array expected");
                        message.Ops = [];
                        for (var i = 0; i < object.Ops.length; ++i) {
                            if (typeof object.Ops[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.Ops: object expected");
                            message.Ops[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.Ops[i]);
                        }
                    }
                    if (object.CurrrentValues) {
                        if (!Array.isArray(object.CurrrentValues))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.CurrrentValues: array expected");
                        message.CurrrentValues = [];
                        for (var i = 0; i < object.CurrrentValues.length; ++i) {
                            if (typeof object.CurrrentValues[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.CurrrentValues: object expected");
                            message.CurrrentValues[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.CurrrentValues[i]);
                        }
                    }
                    if (object.Fields) {
                        if (!Array.isArray(object.Fields))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.Fields: array expected");
                        message.Fields = [];
                        for (var i = 0; i < object.Fields.length; ++i) {
                            if (typeof object.Fields[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.Fields: object expected");
                            message.Fields[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.Fields[i]);
                        }
                    }
                    if (object.EnglishFields) {
                        if (!Array.isArray(object.EnglishFields))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.EnglishFields: array expected");
                        message.EnglishFields = [];
                        for (var i = 0; i < object.EnglishFields.length; ++i) {
                            if (typeof object.EnglishFields[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.EnglishFields: object expected");
                            message.EnglishFields[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.EnglishFields[i]);
                        }
                    }
                    if (object.ValidTypes) {
                        if (!Array.isArray(object.ValidTypes))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.ValidTypes: array expected");
                        message.ValidTypes = [];
                        for (var i = 0; i < object.ValidTypes.length; ++i) {
                            if (typeof object.ValidTypes[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.ValidTypes: object expected");
                            message.ValidTypes[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.ValidTypes[i]);
                        }
                    }
                    if (object.PrivilegeGroups) {
                        if (!Array.isArray(object.PrivilegeGroups))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.PrivilegeGroups: array expected");
                        message.PrivilegeGroups = [];
                        for (var i = 0; i < object.PrivilegeGroups.length; ++i) {
                            if (typeof object.PrivilegeGroups[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.PrivilegeGroups: object expected");
                            message.PrivilegeGroups[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.PrivilegeGroups[i]);
                        }
                    }
                    if (object.ValueFields) {
                        if (!Array.isArray(object.ValueFields))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.ValueFields: array expected");
                        message.ValueFields = [];
                        for (var i = 0; i < object.ValueFields.length; ++i) {
                            if (typeof object.ValueFields[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.ValueFields: object expected");
                            message.ValueFields[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.ValueFields[i]);
                        }
                    }
                    if (object.DateFields) {
                        if (!Array.isArray(object.DateFields))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.DateFields: array expected");
                        message.DateFields = [];
                        for (var i = 0; i < object.DateFields.length; ++i) {
                            if (typeof object.DateFields[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.DateFields: object expected");
                            message.DateFields[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.DateFields[i]);
                        }
                    }
                    if (object.Webhooks) {
                        if (!Array.isArray(object.Webhooks))
                            throw TypeError(".priority.netitems.form.AlertChoosesRs.Webhooks: array expected");
                        message.Webhooks = [];
                        for (var i = 0; i < object.Webhooks.length; ++i) {
                            if (typeof object.Webhooks[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChoosesRs.Webhooks: object expected");
                            message.Webhooks[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.Webhooks[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AlertChoosesRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @static
                 * @param {priority.netitems.form.AlertChoosesRs} message AlertChoosesRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertChoosesRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.TimeUnits = [];
                        object.Documents = [];
                        object.User = [];
                        object.ExprPredefined = [];
                        object.ExprFunc = [];
                        object.Groups = [];
                        object.MessageTypes = [];
                        object.MailFields = [];
                        object.MailUserFields = [];
                        object.MailTypes = [];
                        object.Ops = [];
                        object.CurrrentValues = [];
                        object.Fields = [];
                        object.EnglishFields = [];
                        object.ValidTypes = [];
                        object.PrivilegeGroups = [];
                        object.ValueFields = [];
                        object.DateFields = [];
                        object.Webhooks = [];
                    }
                    if (options.defaults) {
                        object.Perf = null;
                        object.ChooseTitle = "";
                        object.DialogTitle = "";
                        object.ListDialogTitle = "";
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.ChooseTitle != null && message.hasOwnProperty("ChooseTitle"))
                        object.ChooseTitle = message.ChooseTitle;
                    if (message.DialogTitle != null && message.hasOwnProperty("DialogTitle"))
                        object.DialogTitle = message.DialogTitle;
                    if (message.ListDialogTitle != null && message.hasOwnProperty("ListDialogTitle"))
                        object.ListDialogTitle = message.ListDialogTitle;
                    if (message.TimeUnits && message.TimeUnits.length) {
                        object.TimeUnits = [];
                        for (var j = 0; j < message.TimeUnits.length; ++j)
                            object.TimeUnits[j] = $root.priority.netitems.form.AlertChoose.toObject(message.TimeUnits[j], options);
                    }
                    if (message.Documents && message.Documents.length) {
                        object.Documents = [];
                        for (var j = 0; j < message.Documents.length; ++j)
                            object.Documents[j] = $root.priority.netitems.form.AlertChooseDocuments.toObject(message.Documents[j], options);
                    }
                    if (message.User && message.User.length) {
                        object.User = [];
                        for (var j = 0; j < message.User.length; ++j)
                            object.User[j] = $root.priority.netitems.form.AlertChoose.toObject(message.User[j], options);
                    }
                    if (message.ExprPredefined && message.ExprPredefined.length) {
                        object.ExprPredefined = [];
                        for (var j = 0; j < message.ExprPredefined.length; ++j)
                            object.ExprPredefined[j] = $root.priority.netitems.form.AlertChoose.toObject(message.ExprPredefined[j], options);
                    }
                    if (message.ExprFunc && message.ExprFunc.length) {
                        object.ExprFunc = [];
                        for (var j = 0; j < message.ExprFunc.length; ++j)
                            object.ExprFunc[j] = $root.priority.netitems.form.AlertChoose.toObject(message.ExprFunc[j], options);
                    }
                    if (message.Groups && message.Groups.length) {
                        object.Groups = [];
                        for (var j = 0; j < message.Groups.length; ++j)
                            object.Groups[j] = $root.priority.netitems.form.AlertChoose.toObject(message.Groups[j], options);
                    }
                    if (message.MessageTypes && message.MessageTypes.length) {
                        object.MessageTypes = [];
                        for (var j = 0; j < message.MessageTypes.length; ++j)
                            object.MessageTypes[j] = $root.priority.netitems.form.AlertChoose.toObject(message.MessageTypes[j], options);
                    }
                    if (message.MailFields && message.MailFields.length) {
                        object.MailFields = [];
                        for (var j = 0; j < message.MailFields.length; ++j)
                            object.MailFields[j] = $root.priority.netitems.form.AlertChoose.toObject(message.MailFields[j], options);
                    }
                    if (message.MailUserFields && message.MailUserFields.length) {
                        object.MailUserFields = [];
                        for (var j = 0; j < message.MailUserFields.length; ++j)
                            object.MailUserFields[j] = $root.priority.netitems.form.AlertChoose.toObject(message.MailUserFields[j], options);
                    }
                    if (message.MailTypes && message.MailTypes.length) {
                        object.MailTypes = [];
                        for (var j = 0; j < message.MailTypes.length; ++j)
                            object.MailTypes[j] = $root.priority.netitems.form.AlertChoose.toObject(message.MailTypes[j], options);
                    }
                    if (message.Ops && message.Ops.length) {
                        object.Ops = [];
                        for (var j = 0; j < message.Ops.length; ++j)
                            object.Ops[j] = $root.priority.netitems.form.AlertChoose.toObject(message.Ops[j], options);
                    }
                    if (message.CurrrentValues && message.CurrrentValues.length) {
                        object.CurrrentValues = [];
                        for (var j = 0; j < message.CurrrentValues.length; ++j)
                            object.CurrrentValues[j] = $root.priority.netitems.form.AlertChoose.toObject(message.CurrrentValues[j], options);
                    }
                    if (message.Fields && message.Fields.length) {
                        object.Fields = [];
                        for (var j = 0; j < message.Fields.length; ++j)
                            object.Fields[j] = $root.priority.netitems.form.AlertChoose.toObject(message.Fields[j], options);
                    }
                    if (message.EnglishFields && message.EnglishFields.length) {
                        object.EnglishFields = [];
                        for (var j = 0; j < message.EnglishFields.length; ++j)
                            object.EnglishFields[j] = $root.priority.netitems.form.AlertChoose.toObject(message.EnglishFields[j], options);
                    }
                    if (message.ValidTypes && message.ValidTypes.length) {
                        object.ValidTypes = [];
                        for (var j = 0; j < message.ValidTypes.length; ++j)
                            object.ValidTypes[j] = $root.priority.netitems.form.AlertChoose.toObject(message.ValidTypes[j], options);
                    }
                    if (message.PrivilegeGroups && message.PrivilegeGroups.length) {
                        object.PrivilegeGroups = [];
                        for (var j = 0; j < message.PrivilegeGroups.length; ++j)
                            object.PrivilegeGroups[j] = $root.priority.netitems.form.AlertChoose.toObject(message.PrivilegeGroups[j], options);
                    }
                    if (message.ValueFields && message.ValueFields.length) {
                        object.ValueFields = [];
                        for (var j = 0; j < message.ValueFields.length; ++j)
                            object.ValueFields[j] = $root.priority.netitems.form.AlertChoose.toObject(message.ValueFields[j], options);
                    }
                    if (message.DateFields && message.DateFields.length) {
                        object.DateFields = [];
                        for (var j = 0; j < message.DateFields.length; ++j)
                            object.DateFields[j] = $root.priority.netitems.form.AlertChoose.toObject(message.DateFields[j], options);
                    }
                    if (message.Webhooks && message.Webhooks.length) {
                        object.Webhooks = [];
                        for (var j = 0; j < message.Webhooks.length; ++j)
                            object.Webhooks[j] = $root.priority.netitems.form.AlertChoose.toObject(message.Webhooks[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this AlertChoosesRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertChoosesRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertChoosesRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertChoosesRs;
            })();

            form.AlertChooseRq = (function() {

                /**
                 * Properties of an AlertChooseRq.
                 * @memberof priority.netitems.form
                 * @interface IAlertChooseRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AlertChooseRq Properties
                 * @property {string|null} [Session] AlertChooseRq Session
                 * @property {number|Long|null} [Field] AlertChooseRq Field
                 * @property {string|null} [Pattern] AlertChooseRq Pattern
                 * @property {boolean|null} [IgnoreCase] AlertChooseRq IgnoreCase
                 * @property {boolean|null} [FromStart] AlertChooseRq FromStart
                 * @property {number|Long|null} [Page] AlertChooseRq Page
                 * @property {priority.netitems.shared.FieldSelectType|null} [Preferred] AlertChooseRq Preferred
                 */

                /**
                 * Constructs a new AlertChooseRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertChooseRq.
                 * @implements IAlertChooseRq
                 * @constructor
                 * @param {priority.netitems.form.IAlertChooseRq=} [properties] Properties to set
                 */
                function AlertChooseRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertChooseRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 */
                AlertChooseRq.prototype.Properties = null;

                /**
                 * AlertChooseRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 */
                AlertChooseRq.prototype.Session = "";

                /**
                 * AlertChooseRq Field.
                 * @member {number|Long} Field
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 */
                AlertChooseRq.prototype.Field = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertChooseRq Pattern.
                 * @member {string} Pattern
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 */
                AlertChooseRq.prototype.Pattern = "";

                /**
                 * AlertChooseRq IgnoreCase.
                 * @member {boolean} IgnoreCase
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 */
                AlertChooseRq.prototype.IgnoreCase = false;

                /**
                 * AlertChooseRq FromStart.
                 * @member {boolean} FromStart
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 */
                AlertChooseRq.prototype.FromStart = false;

                /**
                 * AlertChooseRq Page.
                 * @member {number|Long} Page
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 */
                AlertChooseRq.prototype.Page = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertChooseRq Preferred.
                 * @member {priority.netitems.shared.FieldSelectType} Preferred
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 */
                AlertChooseRq.prototype.Preferred = 0;

                /**
                 * Creates a new AlertChooseRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @static
                 * @param {priority.netitems.form.IAlertChooseRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertChooseRq} AlertChooseRq instance
                 */
                AlertChooseRq.create = function create(properties) {
                    return new AlertChooseRq(properties);
                };

                /**
                 * Encodes the specified AlertChooseRq message. Does not implicitly {@link priority.netitems.form.AlertChooseRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @static
                 * @param {priority.netitems.form.IAlertChooseRq} message AlertChooseRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChooseRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Field != null && Object.hasOwnProperty.call(message, "Field"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.Field);
                    if (message.Pattern != null && Object.hasOwnProperty.call(message, "Pattern"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Pattern);
                    if (message.IgnoreCase != null && Object.hasOwnProperty.call(message, "IgnoreCase"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.IgnoreCase);
                    if (message.FromStart != null && Object.hasOwnProperty.call(message, "FromStart"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.FromStart);
                    if (message.Page != null && Object.hasOwnProperty.call(message, "Page"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.Page);
                    if (message.Preferred != null && Object.hasOwnProperty.call(message, "Preferred"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.Preferred);
                    return writer;
                };

                /**
                 * Encodes the specified AlertChooseRq message, length delimited. Does not implicitly {@link priority.netitems.form.AlertChooseRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @static
                 * @param {priority.netitems.form.IAlertChooseRq} message AlertChooseRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChooseRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertChooseRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertChooseRq} AlertChooseRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChooseRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertChooseRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.Field = reader.int64();
                            break;
                        case 4:
                            message.Pattern = reader.string();
                            break;
                        case 5:
                            message.IgnoreCase = reader.bool();
                            break;
                        case 6:
                            message.FromStart = reader.bool();
                            break;
                        case 7:
                            message.Page = reader.int64();
                            break;
                        case 8:
                            message.Preferred = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertChooseRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertChooseRq} AlertChooseRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChooseRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertChooseRq message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertChooseRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Field != null && message.hasOwnProperty("Field"))
                        if (!$util.isInteger(message.Field) && !(message.Field && $util.isInteger(message.Field.low) && $util.isInteger(message.Field.high)))
                            return "Field: integer|Long expected";
                    if (message.Pattern != null && message.hasOwnProperty("Pattern"))
                        if (!$util.isString(message.Pattern))
                            return "Pattern: string expected";
                    if (message.IgnoreCase != null && message.hasOwnProperty("IgnoreCase"))
                        if (typeof message.IgnoreCase !== "boolean")
                            return "IgnoreCase: boolean expected";
                    if (message.FromStart != null && message.hasOwnProperty("FromStart"))
                        if (typeof message.FromStart !== "boolean")
                            return "FromStart: boolean expected";
                    if (message.Page != null && message.hasOwnProperty("Page"))
                        if (!$util.isInteger(message.Page) && !(message.Page && $util.isInteger(message.Page.low) && $util.isInteger(message.Page.high)))
                            return "Page: integer|Long expected";
                    if (message.Preferred != null && message.hasOwnProperty("Preferred"))
                        switch (message.Preferred) {
                        default:
                            return "Preferred: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates an AlertChooseRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertChooseRq} AlertChooseRq
                 */
                AlertChooseRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertChooseRq)
                        return object;
                    var message = new $root.priority.netitems.form.AlertChooseRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.AlertChooseRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Field != null)
                        if ($util.Long)
                            (message.Field = $util.Long.fromValue(object.Field)).unsigned = false;
                        else if (typeof object.Field === "string")
                            message.Field = parseInt(object.Field, 10);
                        else if (typeof object.Field === "number")
                            message.Field = object.Field;
                        else if (typeof object.Field === "object")
                            message.Field = new $util.LongBits(object.Field.low >>> 0, object.Field.high >>> 0).toNumber();
                    if (object.Pattern != null)
                        message.Pattern = String(object.Pattern);
                    if (object.IgnoreCase != null)
                        message.IgnoreCase = Boolean(object.IgnoreCase);
                    if (object.FromStart != null)
                        message.FromStart = Boolean(object.FromStart);
                    if (object.Page != null)
                        if ($util.Long)
                            (message.Page = $util.Long.fromValue(object.Page)).unsigned = false;
                        else if (typeof object.Page === "string")
                            message.Page = parseInt(object.Page, 10);
                        else if (typeof object.Page === "number")
                            message.Page = object.Page;
                        else if (typeof object.Page === "object")
                            message.Page = new $util.LongBits(object.Page.low >>> 0, object.Page.high >>> 0).toNumber();
                    switch (object.Preferred) {
                    case "Choose":
                    case 0:
                        message.Preferred = 0;
                        break;
                    case "SearchDes":
                    case 1:
                        message.Preferred = 1;
                        break;
                    case "SearchName":
                    case 2:
                        message.Preferred = 2;
                        break;
                    case "SearchEdes":
                    case 3:
                        message.Preferred = 3;
                        break;
                    case "SearchAll":
                    case 4:
                        message.Preferred = 4;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AlertChooseRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @static
                 * @param {priority.netitems.form.AlertChooseRq} message AlertChooseRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertChooseRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Field = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Field = options.longs === String ? "0" : 0;
                        object.Pattern = "";
                        object.IgnoreCase = false;
                        object.FromStart = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Page = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Page = options.longs === String ? "0" : 0;
                        object.Preferred = options.enums === String ? "Choose" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Field != null && message.hasOwnProperty("Field"))
                        if (typeof message.Field === "number")
                            object.Field = options.longs === String ? String(message.Field) : message.Field;
                        else
                            object.Field = options.longs === String ? $util.Long.prototype.toString.call(message.Field) : options.longs === Number ? new $util.LongBits(message.Field.low >>> 0, message.Field.high >>> 0).toNumber() : message.Field;
                    if (message.Pattern != null && message.hasOwnProperty("Pattern"))
                        object.Pattern = message.Pattern;
                    if (message.IgnoreCase != null && message.hasOwnProperty("IgnoreCase"))
                        object.IgnoreCase = message.IgnoreCase;
                    if (message.FromStart != null && message.hasOwnProperty("FromStart"))
                        object.FromStart = message.FromStart;
                    if (message.Page != null && message.hasOwnProperty("Page"))
                        if (typeof message.Page === "number")
                            object.Page = options.longs === String ? String(message.Page) : message.Page;
                        else
                            object.Page = options.longs === String ? $util.Long.prototype.toString.call(message.Page) : options.longs === Number ? new $util.LongBits(message.Page.low >>> 0, message.Page.high >>> 0).toNumber() : message.Page;
                    if (message.Preferred != null && message.hasOwnProperty("Preferred"))
                        object.Preferred = options.enums === String ? $root.priority.netitems.shared.FieldSelectType[message.Preferred] : message.Preferred;
                    return object;
                };

                /**
                 * Converts this AlertChooseRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertChooseRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertChooseRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertChooseRq;
            })();

            form.AlertOrderRq = (function() {

                /**
                 * Properties of an AlertOrderRq.
                 * @memberof priority.netitems.form
                 * @interface IAlertOrderRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AlertOrderRq Properties
                 * @property {Array.<priority.netitems.form.IAlertOrder>|null} [AlertsOrder] AlertOrderRq AlertsOrder
                 */

                /**
                 * Constructs a new AlertOrderRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertOrderRq.
                 * @implements IAlertOrderRq
                 * @constructor
                 * @param {priority.netitems.form.IAlertOrderRq=} [properties] Properties to set
                 */
                function AlertOrderRq(properties) {
                    this.AlertsOrder = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertOrderRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @instance
                 */
                AlertOrderRq.prototype.Properties = null;

                /**
                 * AlertOrderRq AlertsOrder.
                 * @member {Array.<priority.netitems.form.IAlertOrder>} AlertsOrder
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @instance
                 */
                AlertOrderRq.prototype.AlertsOrder = $util.emptyArray;

                /**
                 * Creates a new AlertOrderRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @static
                 * @param {priority.netitems.form.IAlertOrderRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertOrderRq} AlertOrderRq instance
                 */
                AlertOrderRq.create = function create(properties) {
                    return new AlertOrderRq(properties);
                };

                /**
                 * Encodes the specified AlertOrderRq message. Does not implicitly {@link priority.netitems.form.AlertOrderRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @static
                 * @param {priority.netitems.form.IAlertOrderRq} message AlertOrderRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertOrderRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.AlertsOrder != null && message.AlertsOrder.length)
                        for (var i = 0; i < message.AlertsOrder.length; ++i)
                            $root.priority.netitems.form.AlertOrder.encode(message.AlertsOrder[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AlertOrderRq message, length delimited. Does not implicitly {@link priority.netitems.form.AlertOrderRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @static
                 * @param {priority.netitems.form.IAlertOrderRq} message AlertOrderRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertOrderRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertOrderRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertOrderRq} AlertOrderRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertOrderRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertOrderRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.AlertsOrder && message.AlertsOrder.length))
                                message.AlertsOrder = [];
                            message.AlertsOrder.push($root.priority.netitems.form.AlertOrder.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertOrderRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertOrderRq} AlertOrderRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertOrderRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertOrderRq message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertOrderRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.AlertsOrder != null && message.hasOwnProperty("AlertsOrder")) {
                        if (!Array.isArray(message.AlertsOrder))
                            return "AlertsOrder: array expected";
                        for (var i = 0; i < message.AlertsOrder.length; ++i) {
                            var error = $root.priority.netitems.form.AlertOrder.verify(message.AlertsOrder[i]);
                            if (error)
                                return "AlertsOrder." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an AlertOrderRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertOrderRq} AlertOrderRq
                 */
                AlertOrderRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertOrderRq)
                        return object;
                    var message = new $root.priority.netitems.form.AlertOrderRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.AlertOrderRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.AlertsOrder) {
                        if (!Array.isArray(object.AlertsOrder))
                            throw TypeError(".priority.netitems.form.AlertOrderRq.AlertsOrder: array expected");
                        message.AlertsOrder = [];
                        for (var i = 0; i < object.AlertsOrder.length; ++i) {
                            if (typeof object.AlertsOrder[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertOrderRq.AlertsOrder: object expected");
                            message.AlertsOrder[i] = $root.priority.netitems.form.AlertOrder.fromObject(object.AlertsOrder[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AlertOrderRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @static
                 * @param {priority.netitems.form.AlertOrderRq} message AlertOrderRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertOrderRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.AlertsOrder = [];
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.AlertsOrder && message.AlertsOrder.length) {
                        object.AlertsOrder = [];
                        for (var j = 0; j < message.AlertsOrder.length; ++j)
                            object.AlertsOrder[j] = $root.priority.netitems.form.AlertOrder.toObject(message.AlertsOrder[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this AlertOrderRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertOrderRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertOrderRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertOrderRq;
            })();

            form.AlertCheckExprRq = (function() {

                /**
                 * Properties of an AlertCheckExprRq.
                 * @memberof priority.netitems.form
                 * @interface IAlertCheckExprRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AlertCheckExprRq Properties
                 * @property {string|null} [Session] AlertCheckExprRq Session
                 * @property {number|Long|null} [Field] AlertCheckExprRq Field
                 * @property {string|null} [Expression] AlertCheckExprRq Expression
                 */

                /**
                 * Constructs a new AlertCheckExprRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertCheckExprRq.
                 * @implements IAlertCheckExprRq
                 * @constructor
                 * @param {priority.netitems.form.IAlertCheckExprRq=} [properties] Properties to set
                 */
                function AlertCheckExprRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertCheckExprRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @instance
                 */
                AlertCheckExprRq.prototype.Properties = null;

                /**
                 * AlertCheckExprRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @instance
                 */
                AlertCheckExprRq.prototype.Session = "";

                /**
                 * AlertCheckExprRq Field.
                 * @member {number|Long} Field
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @instance
                 */
                AlertCheckExprRq.prototype.Field = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertCheckExprRq Expression.
                 * @member {string} Expression
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @instance
                 */
                AlertCheckExprRq.prototype.Expression = "";

                /**
                 * Creates a new AlertCheckExprRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @static
                 * @param {priority.netitems.form.IAlertCheckExprRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertCheckExprRq} AlertCheckExprRq instance
                 */
                AlertCheckExprRq.create = function create(properties) {
                    return new AlertCheckExprRq(properties);
                };

                /**
                 * Encodes the specified AlertCheckExprRq message. Does not implicitly {@link priority.netitems.form.AlertCheckExprRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @static
                 * @param {priority.netitems.form.IAlertCheckExprRq} message AlertCheckExprRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertCheckExprRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Field != null && Object.hasOwnProperty.call(message, "Field"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.Field);
                    if (message.Expression != null && Object.hasOwnProperty.call(message, "Expression"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Expression);
                    return writer;
                };

                /**
                 * Encodes the specified AlertCheckExprRq message, length delimited. Does not implicitly {@link priority.netitems.form.AlertCheckExprRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @static
                 * @param {priority.netitems.form.IAlertCheckExprRq} message AlertCheckExprRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertCheckExprRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertCheckExprRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertCheckExprRq} AlertCheckExprRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertCheckExprRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertCheckExprRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.Field = reader.int64();
                            break;
                        case 4:
                            message.Expression = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertCheckExprRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertCheckExprRq} AlertCheckExprRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertCheckExprRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertCheckExprRq message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertCheckExprRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Field != null && message.hasOwnProperty("Field"))
                        if (!$util.isInteger(message.Field) && !(message.Field && $util.isInteger(message.Field.low) && $util.isInteger(message.Field.high)))
                            return "Field: integer|Long expected";
                    if (message.Expression != null && message.hasOwnProperty("Expression"))
                        if (!$util.isString(message.Expression))
                            return "Expression: string expected";
                    return null;
                };

                /**
                 * Creates an AlertCheckExprRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertCheckExprRq} AlertCheckExprRq
                 */
                AlertCheckExprRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertCheckExprRq)
                        return object;
                    var message = new $root.priority.netitems.form.AlertCheckExprRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.AlertCheckExprRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Field != null)
                        if ($util.Long)
                            (message.Field = $util.Long.fromValue(object.Field)).unsigned = false;
                        else if (typeof object.Field === "string")
                            message.Field = parseInt(object.Field, 10);
                        else if (typeof object.Field === "number")
                            message.Field = object.Field;
                        else if (typeof object.Field === "object")
                            message.Field = new $util.LongBits(object.Field.low >>> 0, object.Field.high >>> 0).toNumber();
                    if (object.Expression != null)
                        message.Expression = String(object.Expression);
                    return message;
                };

                /**
                 * Creates a plain object from an AlertCheckExprRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @static
                 * @param {priority.netitems.form.AlertCheckExprRq} message AlertCheckExprRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertCheckExprRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Field = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Field = options.longs === String ? "0" : 0;
                        object.Expression = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Field != null && message.hasOwnProperty("Field"))
                        if (typeof message.Field === "number")
                            object.Field = options.longs === String ? String(message.Field) : message.Field;
                        else
                            object.Field = options.longs === String ? $util.Long.prototype.toString.call(message.Field) : options.longs === Number ? new $util.LongBits(message.Field.low >>> 0, message.Field.high >>> 0).toNumber() : message.Field;
                    if (message.Expression != null && message.hasOwnProperty("Expression"))
                        object.Expression = message.Expression;
                    return object;
                };

                /**
                 * Converts this AlertCheckExprRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertCheckExprRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertCheckExprRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertCheckExprRq;
            })();

            form.AlertCheckExprRs = (function() {

                /**
                 * Properties of an AlertCheckExprRs.
                 * @memberof priority.netitems.form
                 * @interface IAlertCheckExprRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] AlertCheckExprRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] AlertCheckExprRs Messages
                 * @property {boolean|null} [ValidExpr] AlertCheckExprRs ValidExpr
                 */

                /**
                 * Constructs a new AlertCheckExprRs.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertCheckExprRs.
                 * @implements IAlertCheckExprRs
                 * @constructor
                 * @param {priority.netitems.form.IAlertCheckExprRs=} [properties] Properties to set
                 */
                function AlertCheckExprRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertCheckExprRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @instance
                 */
                AlertCheckExprRs.prototype.Perf = null;

                /**
                 * AlertCheckExprRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @instance
                 */
                AlertCheckExprRs.prototype.Messages = $util.emptyArray;

                /**
                 * AlertCheckExprRs ValidExpr.
                 * @member {boolean} ValidExpr
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @instance
                 */
                AlertCheckExprRs.prototype.ValidExpr = false;

                /**
                 * Creates a new AlertCheckExprRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @static
                 * @param {priority.netitems.form.IAlertCheckExprRs=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertCheckExprRs} AlertCheckExprRs instance
                 */
                AlertCheckExprRs.create = function create(properties) {
                    return new AlertCheckExprRs(properties);
                };

                /**
                 * Encodes the specified AlertCheckExprRs message. Does not implicitly {@link priority.netitems.form.AlertCheckExprRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @static
                 * @param {priority.netitems.form.IAlertCheckExprRs} message AlertCheckExprRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertCheckExprRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ValidExpr != null && Object.hasOwnProperty.call(message, "ValidExpr"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.ValidExpr);
                    return writer;
                };

                /**
                 * Encodes the specified AlertCheckExprRs message, length delimited. Does not implicitly {@link priority.netitems.form.AlertCheckExprRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @static
                 * @param {priority.netitems.form.IAlertCheckExprRs} message AlertCheckExprRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertCheckExprRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertCheckExprRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertCheckExprRs} AlertCheckExprRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertCheckExprRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertCheckExprRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.ValidExpr = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertCheckExprRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertCheckExprRs} AlertCheckExprRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertCheckExprRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertCheckExprRs message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertCheckExprRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.ValidExpr != null && message.hasOwnProperty("ValidExpr"))
                        if (typeof message.ValidExpr !== "boolean")
                            return "ValidExpr: boolean expected";
                    return null;
                };

                /**
                 * Creates an AlertCheckExprRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertCheckExprRs} AlertCheckExprRs
                 */
                AlertCheckExprRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertCheckExprRs)
                        return object;
                    var message = new $root.priority.netitems.form.AlertCheckExprRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.form.AlertCheckExprRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.AlertCheckExprRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertCheckExprRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.ValidExpr != null)
                        message.ValidExpr = Boolean(object.ValidExpr);
                    return message;
                };

                /**
                 * Creates a plain object from an AlertCheckExprRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @static
                 * @param {priority.netitems.form.AlertCheckExprRs} message AlertCheckExprRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertCheckExprRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.ValidExpr = false;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.ValidExpr != null && message.hasOwnProperty("ValidExpr"))
                        object.ValidExpr = message.ValidExpr;
                    return object;
                };

                /**
                 * Converts this AlertCheckExprRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertCheckExprRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertCheckExprRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertCheckExprRs;
            })();

            form.AlertDeleteRq = (function() {

                /**
                 * Properties of an AlertDeleteRq.
                 * @memberof priority.netitems.form
                 * @interface IAlertDeleteRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AlertDeleteRq Properties
                 * @property {string|null} [Session] AlertDeleteRq Session
                 * @property {number|Long|null} [Alert] AlertDeleteRq Alert
                 */

                /**
                 * Constructs a new AlertDeleteRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertDeleteRq.
                 * @implements IAlertDeleteRq
                 * @constructor
                 * @param {priority.netitems.form.IAlertDeleteRq=} [properties] Properties to set
                 */
                function AlertDeleteRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertDeleteRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @instance
                 */
                AlertDeleteRq.prototype.Properties = null;

                /**
                 * AlertDeleteRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @instance
                 */
                AlertDeleteRq.prototype.Session = "";

                /**
                 * AlertDeleteRq Alert.
                 * @member {number|Long} Alert
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @instance
                 */
                AlertDeleteRq.prototype.Alert = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new AlertDeleteRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @static
                 * @param {priority.netitems.form.IAlertDeleteRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertDeleteRq} AlertDeleteRq instance
                 */
                AlertDeleteRq.create = function create(properties) {
                    return new AlertDeleteRq(properties);
                };

                /**
                 * Encodes the specified AlertDeleteRq message. Does not implicitly {@link priority.netitems.form.AlertDeleteRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @static
                 * @param {priority.netitems.form.IAlertDeleteRq} message AlertDeleteRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertDeleteRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.Alert != null && Object.hasOwnProperty.call(message, "Alert"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.Alert);
                    return writer;
                };

                /**
                 * Encodes the specified AlertDeleteRq message, length delimited. Does not implicitly {@link priority.netitems.form.AlertDeleteRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @static
                 * @param {priority.netitems.form.IAlertDeleteRq} message AlertDeleteRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertDeleteRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertDeleteRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertDeleteRq} AlertDeleteRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertDeleteRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertDeleteRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.Alert = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertDeleteRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertDeleteRq} AlertDeleteRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertDeleteRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertDeleteRq message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertDeleteRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.Alert != null && message.hasOwnProperty("Alert"))
                        if (!$util.isInteger(message.Alert) && !(message.Alert && $util.isInteger(message.Alert.low) && $util.isInteger(message.Alert.high)))
                            return "Alert: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an AlertDeleteRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertDeleteRq} AlertDeleteRq
                 */
                AlertDeleteRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertDeleteRq)
                        return object;
                    var message = new $root.priority.netitems.form.AlertDeleteRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.AlertDeleteRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.Alert != null)
                        if ($util.Long)
                            (message.Alert = $util.Long.fromValue(object.Alert)).unsigned = false;
                        else if (typeof object.Alert === "string")
                            message.Alert = parseInt(object.Alert, 10);
                        else if (typeof object.Alert === "number")
                            message.Alert = object.Alert;
                        else if (typeof object.Alert === "object")
                            message.Alert = new $util.LongBits(object.Alert.low >>> 0, object.Alert.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an AlertDeleteRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @static
                 * @param {priority.netitems.form.AlertDeleteRq} message AlertDeleteRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertDeleteRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Alert = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Alert = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.Alert != null && message.hasOwnProperty("Alert"))
                        if (typeof message.Alert === "number")
                            object.Alert = options.longs === String ? String(message.Alert) : message.Alert;
                        else
                            object.Alert = options.longs === String ? $util.Long.prototype.toString.call(message.Alert) : options.longs === Number ? new $util.LongBits(message.Alert.low >>> 0, message.Alert.high >>> 0).toNumber() : message.Alert;
                    return object;
                };

                /**
                 * Converts this AlertDeleteRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertDeleteRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertDeleteRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertDeleteRq;
            })();

            form.AlertSaveRq = (function() {

                /**
                 * Properties of an AlertSaveRq.
                 * @memberof priority.netitems.form
                 * @interface IAlertSaveRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AlertSaveRq Properties
                 * @property {string|null} [Session] AlertSaveRq Session
                 * @property {priority.netitems.form.IAlert|null} [AlertData] AlertSaveRq AlertData
                 * @property {priority.netitems.form.RuleType|null} [Type] AlertSaveRq Type
                 */

                /**
                 * Constructs a new AlertSaveRq.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertSaveRq.
                 * @implements IAlertSaveRq
                 * @constructor
                 * @param {priority.netitems.form.IAlertSaveRq=} [properties] Properties to set
                 */
                function AlertSaveRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertSaveRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @instance
                 */
                AlertSaveRq.prototype.Properties = null;

                /**
                 * AlertSaveRq Session.
                 * @member {string} Session
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @instance
                 */
                AlertSaveRq.prototype.Session = "";

                /**
                 * AlertSaveRq AlertData.
                 * @member {priority.netitems.form.IAlert|null|undefined} AlertData
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @instance
                 */
                AlertSaveRq.prototype.AlertData = null;

                /**
                 * AlertSaveRq Type.
                 * @member {priority.netitems.form.RuleType} Type
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @instance
                 */
                AlertSaveRq.prototype.Type = 0;

                /**
                 * Creates a new AlertSaveRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @static
                 * @param {priority.netitems.form.IAlertSaveRq=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertSaveRq} AlertSaveRq instance
                 */
                AlertSaveRq.create = function create(properties) {
                    return new AlertSaveRq(properties);
                };

                /**
                 * Encodes the specified AlertSaveRq message. Does not implicitly {@link priority.netitems.form.AlertSaveRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @static
                 * @param {priority.netitems.form.IAlertSaveRq} message AlertSaveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertSaveRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.AlertData != null && Object.hasOwnProperty.call(message, "AlertData"))
                        $root.priority.netitems.form.Alert.encode(message.AlertData, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Type);
                    return writer;
                };

                /**
                 * Encodes the specified AlertSaveRq message, length delimited. Does not implicitly {@link priority.netitems.form.AlertSaveRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @static
                 * @param {priority.netitems.form.IAlertSaveRq} message AlertSaveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertSaveRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertSaveRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertSaveRq} AlertSaveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertSaveRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertSaveRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 3:
                            message.AlertData = $root.priority.netitems.form.Alert.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.Type = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertSaveRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertSaveRq} AlertSaveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertSaveRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertSaveRq message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertSaveRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.AlertData != null && message.hasOwnProperty("AlertData")) {
                        var error = $root.priority.netitems.form.Alert.verify(message.AlertData);
                        if (error)
                            return "AlertData." + error;
                    }
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        switch (message.Type) {
                        default:
                            return "Type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates an AlertSaveRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertSaveRq} AlertSaveRq
                 */
                AlertSaveRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertSaveRq)
                        return object;
                    var message = new $root.priority.netitems.form.AlertSaveRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.form.AlertSaveRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.AlertData != null) {
                        if (typeof object.AlertData !== "object")
                            throw TypeError(".priority.netitems.form.AlertSaveRq.AlertData: object expected");
                        message.AlertData = $root.priority.netitems.form.Alert.fromObject(object.AlertData);
                    }
                    switch (object.Type) {
                    case "UNKNOWN_RULETYPE":
                    case 0:
                        message.Type = 0;
                        break;
                    case "Business":
                    case 1:
                        message.Type = 1;
                        break;
                    case "AutoFill":
                    case 2:
                        message.Type = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AlertSaveRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @static
                 * @param {priority.netitems.form.AlertSaveRq} message AlertSaveRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertSaveRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                        object.AlertData = null;
                        object.Type = options.enums === String ? "UNKNOWN_RULETYPE" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.AlertData != null && message.hasOwnProperty("AlertData"))
                        object.AlertData = $root.priority.netitems.form.Alert.toObject(message.AlertData, options);
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        object.Type = options.enums === String ? $root.priority.netitems.form.RuleType[message.Type] : message.Type;
                    return object;
                };

                /**
                 * Converts this AlertSaveRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertSaveRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertSaveRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertSaveRq;
            })();

            form.Filter = (function() {

                /**
                 * Properties of a Filter.
                 * @memberof priority.netitems.form
                 * @interface IFilter
                 * @property {Array.<priority.netitems.form.ICondition>|null} [Condition] Filter Condition
                 * @property {priority.netitems.shared.LogicalOperator|null} [Operator] Filter Operator
                 */

                /**
                 * Constructs a new Filter.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Filter.
                 * @implements IFilter
                 * @constructor
                 * @param {priority.netitems.form.IFilter=} [properties] Properties to set
                 */
                function Filter(properties) {
                    this.Condition = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Filter Condition.
                 * @member {Array.<priority.netitems.form.ICondition>} Condition
                 * @memberof priority.netitems.form.Filter
                 * @instance
                 */
                Filter.prototype.Condition = $util.emptyArray;

                /**
                 * Filter Operator.
                 * @member {priority.netitems.shared.LogicalOperator} Operator
                 * @memberof priority.netitems.form.Filter
                 * @instance
                 */
                Filter.prototype.Operator = 0;

                /**
                 * Creates a new Filter instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Filter
                 * @static
                 * @param {priority.netitems.form.IFilter=} [properties] Properties to set
                 * @returns {priority.netitems.form.Filter} Filter instance
                 */
                Filter.create = function create(properties) {
                    return new Filter(properties);
                };

                /**
                 * Encodes the specified Filter message. Does not implicitly {@link priority.netitems.form.Filter.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Filter
                 * @static
                 * @param {priority.netitems.form.IFilter} message Filter message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Filter.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Condition != null && message.Condition.length)
                        for (var i = 0; i < message.Condition.length; ++i)
                            $root.priority.netitems.form.Condition.encode(message.Condition[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Operator != null && Object.hasOwnProperty.call(message, "Operator"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Operator);
                    return writer;
                };

                /**
                 * Encodes the specified Filter message, length delimited. Does not implicitly {@link priority.netitems.form.Filter.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Filter
                 * @static
                 * @param {priority.netitems.form.IFilter} message Filter message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Filter.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Filter message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Filter
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Filter} Filter
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Filter.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Filter();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Condition && message.Condition.length))
                                message.Condition = [];
                            message.Condition.push($root.priority.netitems.form.Condition.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.Operator = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Filter message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Filter
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Filter} Filter
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Filter.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Filter message.
                 * @function verify
                 * @memberof priority.netitems.form.Filter
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Filter.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Condition != null && message.hasOwnProperty("Condition")) {
                        if (!Array.isArray(message.Condition))
                            return "Condition: array expected";
                        for (var i = 0; i < message.Condition.length; ++i) {
                            var error = $root.priority.netitems.form.Condition.verify(message.Condition[i]);
                            if (error)
                                return "Condition." + error;
                        }
                    }
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        switch (message.Operator) {
                        default:
                            return "Operator: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a Filter message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Filter
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Filter} Filter
                 */
                Filter.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Filter)
                        return object;
                    var message = new $root.priority.netitems.form.Filter();
                    if (object.Condition) {
                        if (!Array.isArray(object.Condition))
                            throw TypeError(".priority.netitems.form.Filter.Condition: array expected");
                        message.Condition = [];
                        for (var i = 0; i < object.Condition.length; ++i) {
                            if (typeof object.Condition[i] !== "object")
                                throw TypeError(".priority.netitems.form.Filter.Condition: object expected");
                            message.Condition[i] = $root.priority.netitems.form.Condition.fromObject(object.Condition[i]);
                        }
                    }
                    switch (object.Operator) {
                    case "And":
                    case 0:
                        message.Operator = 0;
                        break;
                    case "Or":
                    case 1:
                        message.Operator = 1;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Filter message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Filter
                 * @static
                 * @param {priority.netitems.form.Filter} message Filter
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Filter.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Condition = [];
                    if (options.defaults)
                        object.Operator = options.enums === String ? "And" : 0;
                    if (message.Condition && message.Condition.length) {
                        object.Condition = [];
                        for (var j = 0; j < message.Condition.length; ++j)
                            object.Condition[j] = $root.priority.netitems.form.Condition.toObject(message.Condition[j], options);
                    }
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        object.Operator = options.enums === String ? $root.priority.netitems.shared.LogicalOperator[message.Operator] : message.Operator;
                    return object;
                };

                /**
                 * Converts this Filter to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Filter
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Filter.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Filter;
            })();

            form.Sort = (function() {

                /**
                 * Properties of a Sort.
                 * @memberof priority.netitems.form
                 * @interface ISort
                 * @property {number|Long|null} [ColumnID] Sort ColumnID
                 * @property {boolean|null} [Desc] Sort Desc
                 */

                /**
                 * Constructs a new Sort.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Sort.
                 * @implements ISort
                 * @constructor
                 * @param {priority.netitems.form.ISort=} [properties] Properties to set
                 */
                function Sort(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Sort ColumnID.
                 * @member {number|Long} ColumnID
                 * @memberof priority.netitems.form.Sort
                 * @instance
                 */
                Sort.prototype.ColumnID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Sort Desc.
                 * @member {boolean} Desc
                 * @memberof priority.netitems.form.Sort
                 * @instance
                 */
                Sort.prototype.Desc = false;

                /**
                 * Creates a new Sort instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Sort
                 * @static
                 * @param {priority.netitems.form.ISort=} [properties] Properties to set
                 * @returns {priority.netitems.form.Sort} Sort instance
                 */
                Sort.create = function create(properties) {
                    return new Sort(properties);
                };

                /**
                 * Encodes the specified Sort message. Does not implicitly {@link priority.netitems.form.Sort.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Sort
                 * @static
                 * @param {priority.netitems.form.ISort} message Sort message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Sort.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ColumnID != null && Object.hasOwnProperty.call(message, "ColumnID"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ColumnID);
                    if (message.Desc != null && Object.hasOwnProperty.call(message, "Desc"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Desc);
                    return writer;
                };

                /**
                 * Encodes the specified Sort message, length delimited. Does not implicitly {@link priority.netitems.form.Sort.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Sort
                 * @static
                 * @param {priority.netitems.form.ISort} message Sort message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Sort.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Sort message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Sort
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Sort} Sort
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Sort.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Sort();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ColumnID = reader.int64();
                            break;
                        case 2:
                            message.Desc = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Sort message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Sort
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Sort} Sort
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Sort.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Sort message.
                 * @function verify
                 * @memberof priority.netitems.form.Sort
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Sort.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ColumnID != null && message.hasOwnProperty("ColumnID"))
                        if (!$util.isInteger(message.ColumnID) && !(message.ColumnID && $util.isInteger(message.ColumnID.low) && $util.isInteger(message.ColumnID.high)))
                            return "ColumnID: integer|Long expected";
                    if (message.Desc != null && message.hasOwnProperty("Desc"))
                        if (typeof message.Desc !== "boolean")
                            return "Desc: boolean expected";
                    return null;
                };

                /**
                 * Creates a Sort message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Sort
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Sort} Sort
                 */
                Sort.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Sort)
                        return object;
                    var message = new $root.priority.netitems.form.Sort();
                    if (object.ColumnID != null)
                        if ($util.Long)
                            (message.ColumnID = $util.Long.fromValue(object.ColumnID)).unsigned = false;
                        else if (typeof object.ColumnID === "string")
                            message.ColumnID = parseInt(object.ColumnID, 10);
                        else if (typeof object.ColumnID === "number")
                            message.ColumnID = object.ColumnID;
                        else if (typeof object.ColumnID === "object")
                            message.ColumnID = new $util.LongBits(object.ColumnID.low >>> 0, object.ColumnID.high >>> 0).toNumber();
                    if (object.Desc != null)
                        message.Desc = Boolean(object.Desc);
                    return message;
                };

                /**
                 * Creates a plain object from a Sort message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Sort
                 * @static
                 * @param {priority.netitems.form.Sort} message Sort
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Sort.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ColumnID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ColumnID = options.longs === String ? "0" : 0;
                        object.Desc = false;
                    }
                    if (message.ColumnID != null && message.hasOwnProperty("ColumnID"))
                        if (typeof message.ColumnID === "number")
                            object.ColumnID = options.longs === String ? String(message.ColumnID) : message.ColumnID;
                        else
                            object.ColumnID = options.longs === String ? $util.Long.prototype.toString.call(message.ColumnID) : options.longs === Number ? new $util.LongBits(message.ColumnID.low >>> 0, message.ColumnID.high >>> 0).toNumber() : message.ColumnID;
                    if (message.Desc != null && message.hasOwnProperty("Desc"))
                        object.Desc = message.Desc;
                    return object;
                };

                /**
                 * Converts this Sort to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Sort
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Sort.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Sort;
            })();

            form.Condition = (function() {

                /**
                 * Properties of a Condition.
                 * @memberof priority.netitems.form
                 * @interface ICondition
                 * @property {number|Long|null} [ColumnID] Condition ColumnID
                 * @property {priority.netitems.shared.ComparisonOperator|null} [Operator] Condition Operator
                 * @property {Array.<string>|null} [Values] Condition Values
                 * @property {boolean|null} [IgnoreCase] Condition IgnoreCase
                 */

                /**
                 * Constructs a new Condition.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Condition.
                 * @implements ICondition
                 * @constructor
                 * @param {priority.netitems.form.ICondition=} [properties] Properties to set
                 */
                function Condition(properties) {
                    this.Values = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Condition ColumnID.
                 * @member {number|Long} ColumnID
                 * @memberof priority.netitems.form.Condition
                 * @instance
                 */
                Condition.prototype.ColumnID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Condition Operator.
                 * @member {priority.netitems.shared.ComparisonOperator} Operator
                 * @memberof priority.netitems.form.Condition
                 * @instance
                 */
                Condition.prototype.Operator = 0;

                /**
                 * Condition Values.
                 * @member {Array.<string>} Values
                 * @memberof priority.netitems.form.Condition
                 * @instance
                 */
                Condition.prototype.Values = $util.emptyArray;

                /**
                 * Condition IgnoreCase.
                 * @member {boolean} IgnoreCase
                 * @memberof priority.netitems.form.Condition
                 * @instance
                 */
                Condition.prototype.IgnoreCase = false;

                /**
                 * Creates a new Condition instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Condition
                 * @static
                 * @param {priority.netitems.form.ICondition=} [properties] Properties to set
                 * @returns {priority.netitems.form.Condition} Condition instance
                 */
                Condition.create = function create(properties) {
                    return new Condition(properties);
                };

                /**
                 * Encodes the specified Condition message. Does not implicitly {@link priority.netitems.form.Condition.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Condition
                 * @static
                 * @param {priority.netitems.form.ICondition} message Condition message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Condition.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ColumnID != null && Object.hasOwnProperty.call(message, "ColumnID"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ColumnID);
                    if (message.Operator != null && Object.hasOwnProperty.call(message, "Operator"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Operator);
                    if (message.Values != null && message.Values.length)
                        for (var i = 0; i < message.Values.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Values[i]);
                    if (message.IgnoreCase != null && Object.hasOwnProperty.call(message, "IgnoreCase"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.IgnoreCase);
                    return writer;
                };

                /**
                 * Encodes the specified Condition message, length delimited. Does not implicitly {@link priority.netitems.form.Condition.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Condition
                 * @static
                 * @param {priority.netitems.form.ICondition} message Condition message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Condition.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Condition message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Condition
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Condition} Condition
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Condition.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Condition();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ColumnID = reader.int64();
                            break;
                        case 2:
                            message.Operator = reader.int32();
                            break;
                        case 3:
                            if (!(message.Values && message.Values.length))
                                message.Values = [];
                            message.Values.push(reader.string());
                            break;
                        case 4:
                            message.IgnoreCase = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Condition message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Condition
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Condition} Condition
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Condition.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Condition message.
                 * @function verify
                 * @memberof priority.netitems.form.Condition
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Condition.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ColumnID != null && message.hasOwnProperty("ColumnID"))
                        if (!$util.isInteger(message.ColumnID) && !(message.ColumnID && $util.isInteger(message.ColumnID.low) && $util.isInteger(message.ColumnID.high)))
                            return "ColumnID: integer|Long expected";
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        switch (message.Operator) {
                        default:
                            return "Operator: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                            break;
                        }
                    if (message.Values != null && message.hasOwnProperty("Values")) {
                        if (!Array.isArray(message.Values))
                            return "Values: array expected";
                        for (var i = 0; i < message.Values.length; ++i)
                            if (!$util.isString(message.Values[i]))
                                return "Values: string[] expected";
                    }
                    if (message.IgnoreCase != null && message.hasOwnProperty("IgnoreCase"))
                        if (typeof message.IgnoreCase !== "boolean")
                            return "IgnoreCase: boolean expected";
                    return null;
                };

                /**
                 * Creates a Condition message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Condition
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Condition} Condition
                 */
                Condition.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Condition)
                        return object;
                    var message = new $root.priority.netitems.form.Condition();
                    if (object.ColumnID != null)
                        if ($util.Long)
                            (message.ColumnID = $util.Long.fromValue(object.ColumnID)).unsigned = false;
                        else if (typeof object.ColumnID === "string")
                            message.ColumnID = parseInt(object.ColumnID, 10);
                        else if (typeof object.ColumnID === "number")
                            message.ColumnID = object.ColumnID;
                        else if (typeof object.ColumnID === "object")
                            message.ColumnID = new $util.LongBits(object.ColumnID.low >>> 0, object.ColumnID.high >>> 0).toNumber();
                    switch (object.Operator) {
                    case "Eq":
                    case 0:
                        message.Operator = 0;
                        break;
                    case "In":
                    case 1:
                        message.Operator = 1;
                        break;
                    case "NotIn":
                    case 2:
                        message.Operator = 2;
                        break;
                    case "Between":
                    case 3:
                        message.Operator = 3;
                        break;
                    case "Gt":
                    case 4:
                        message.Operator = 4;
                        break;
                    case "Lt":
                    case 5:
                        message.Operator = 5;
                        break;
                    case "Le":
                    case 6:
                        message.Operator = 6;
                        break;
                    case "Ge":
                    case 7:
                        message.Operator = 7;
                        break;
                    case "Ne":
                    case 8:
                        message.Operator = 8;
                        break;
                    case "NotBetween":
                    case 9:
                        message.Operator = 9;
                        break;
                    case "IsNull":
                    case 10:
                        message.Operator = 10;
                        break;
                    case "IsNotNull":
                    case 11:
                        message.Operator = 11;
                        break;
                    case "Like":
                    case 12:
                        message.Operator = 12;
                        break;
                    case "NotLike":
                    case 13:
                        message.Operator = 13;
                        break;
                    case "AndNot":
                    case 14:
                        message.Operator = 14;
                        break;
                    }
                    if (object.Values) {
                        if (!Array.isArray(object.Values))
                            throw TypeError(".priority.netitems.form.Condition.Values: array expected");
                        message.Values = [];
                        for (var i = 0; i < object.Values.length; ++i)
                            message.Values[i] = String(object.Values[i]);
                    }
                    if (object.IgnoreCase != null)
                        message.IgnoreCase = Boolean(object.IgnoreCase);
                    return message;
                };

                /**
                 * Creates a plain object from a Condition message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Condition
                 * @static
                 * @param {priority.netitems.form.Condition} message Condition
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Condition.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Values = [];
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ColumnID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ColumnID = options.longs === String ? "0" : 0;
                        object.Operator = options.enums === String ? "Eq" : 0;
                        object.IgnoreCase = false;
                    }
                    if (message.ColumnID != null && message.hasOwnProperty("ColumnID"))
                        if (typeof message.ColumnID === "number")
                            object.ColumnID = options.longs === String ? String(message.ColumnID) : message.ColumnID;
                        else
                            object.ColumnID = options.longs === String ? $util.Long.prototype.toString.call(message.ColumnID) : options.longs === Number ? new $util.LongBits(message.ColumnID.low >>> 0, message.ColumnID.high >>> 0).toNumber() : message.ColumnID;
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        object.Operator = options.enums === String ? $root.priority.netitems.shared.ComparisonOperator[message.Operator] : message.Operator;
                    if (message.Values && message.Values.length) {
                        object.Values = [];
                        for (var j = 0; j < message.Values.length; ++j)
                            object.Values[j] = message.Values[j];
                    }
                    if (message.IgnoreCase != null && message.hasOwnProperty("IgnoreCase"))
                        object.IgnoreCase = message.IgnoreCase;
                    return object;
                };

                /**
                 * Converts this Condition to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Condition
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Condition.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Condition;
            })();

            /**
             * ETemplate enum.
             * @name priority.netitems.form.ETemplate
             * @enum {number}
             * @property {number} UNKOWN_ETEMPLATE=0 UNKOWN_ETEMPLATE value
             * @property {number} NOTEMPLATE=-1 NOTEMPLATE value
             * @property {number} NEWTEMPLATE=-2 NEWTEMPLATE value
             */
            form.ETemplate = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKOWN_ETEMPLATE"] = 0;
                values[valuesById[-1] = "NOTEMPLATE"] = -1;
                values[valuesById[-2] = "NEWTEMPLATE"] = -2;
                return values;
            })();

            /**
             * ZoomType enum.
             * @name priority.netitems.form.ZoomType
             * @enum {number}
             * @property {number} NoneZoom=0 NoneZoom value
             * @property {number} AttachZoom=1 AttachZoom value
             * @property {number} SelectZoom=2 SelectZoom value
             * @property {number} ZoomZoom=4 ZoomZoom value
             * @property {number} Date14Zoom=5 Date14Zoom value
             * @property {number} Date8Zoom=6 Date8Zoom value
             * @property {number} Date10Zoom=7 Date10Zoom value
             * @property {number} EMailZoom=8 EMailZoom value
             * @property {number} URLZoom=9 URLZoom value
             * @property {number} HiddenZoom=10 HiddenZoom value
             * @property {number} LinkFileZoom=11 LinkFileZoom value
             * @property {number} QEditZoom=12 QEditZoom value
             * @property {number} SpecialAttachZoom=14 SpecialAttachZoom value
             */
            form.ZoomType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "NoneZoom"] = 0;
                values[valuesById[1] = "AttachZoom"] = 1;
                values[valuesById[2] = "SelectZoom"] = 2;
                values[valuesById[4] = "ZoomZoom"] = 4;
                values[valuesById[5] = "Date14Zoom"] = 5;
                values[valuesById[6] = "Date8Zoom"] = 6;
                values[valuesById[7] = "Date10Zoom"] = 7;
                values[valuesById[8] = "EMailZoom"] = 8;
                values[valuesById[9] = "URLZoom"] = 9;
                values[valuesById[10] = "HiddenZoom"] = 10;
                values[valuesById[11] = "LinkFileZoom"] = 11;
                values[valuesById[12] = "QEditZoom"] = 12;
                values[valuesById[14] = "SpecialAttachZoom"] = 14;
                return values;
            })();

            /**
             * ColumnType enum.
             * @name priority.netitems.form.ColumnType
             * @enum {number}
             * @property {number} Char=0 Char value
             * @property {number} Str=1 Str value
             * @property {number} Rstr=2 Rstr value
             * @property {number} Boolean=3 Boolean value
             * @property {number} Real=4 Real value
             * @property {number} Int=5 Int value
             * @property {number} Date8=6 Date8 value
             * @property {number} Date10=7 Date10 value
             * @property {number} Date14=8 Date14 value
             * @property {number} Time5=9 Time5 value
             * @property {number} Time6=10 Time6 value
             * @property {number} Day=11 Day value
             * @property {number} Unsigned=12 Unsigned value
             * @property {number} Operator=13 Operator value
             * @property {number} Attachment=14 Attachment value
             */
            form.ColumnType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "Char"] = 0;
                values[valuesById[1] = "Str"] = 1;
                values[valuesById[2] = "Rstr"] = 2;
                values[valuesById[3] = "Boolean"] = 3;
                values[valuesById[4] = "Real"] = 4;
                values[valuesById[5] = "Int"] = 5;
                values[valuesById[6] = "Date8"] = 6;
                values[valuesById[7] = "Date10"] = 7;
                values[valuesById[8] = "Date14"] = 8;
                values[valuesById[9] = "Time5"] = 9;
                values[valuesById[10] = "Time6"] = 10;
                values[valuesById[11] = "Day"] = 11;
                values[valuesById[12] = "Unsigned"] = 12;
                values[valuesById[13] = "Operator"] = 13;
                values[valuesById[14] = "Attachment"] = 14;
                return values;
            })();

            form.Column = (function() {

                /**
                 * Properties of a Column.
                 * @memberof priority.netitems.form
                 * @interface IColumn
                 * @property {number|Long|null} [ID] Column ID
                 * @property {string|null} [Name] Column Name
                 * @property {string|null} [Title] Column Title
                 * @property {priority.netitems.form.ColumnType|null} [Type] Column Type
                 * @property {number|Long|null} [Width] Column Width
                 * @property {boolean|null} [Key] Column Key
                 * @property {boolean|null} [Mandatory] Column Mandatory
                 * @property {boolean|null} [Readonly] Column Readonly
                 * @property {boolean|null} [SearchAll] Column SearchAll
                 * @property {number|Long|null} [Decimal] Column Decimal
                 * @property {boolean|null} [Qsrch] Column Qsrch
                 * @property {priority.netitems.form.ZoomType|null} [Zoom] Column Zoom
                 * @property {string|null} [Zoomfname] Column Zoomfname
                 * @property {number|Long|null} [Relcol] Column Relcol
                 * @property {string|null} [DefaultValue] Column DefaultValue
                 * @property {boolean|null} [MultiEnv] Column MultiEnv
                 * @property {boolean|null} [InstantMessaging] Column InstantMessaging
                 * @property {boolean|null} [Hidden] Column Hidden
                 * @property {boolean|null} [IsStatus] Column IsStatus
                 * @property {boolean|null} [IsBalance] Column IsBalance
                 * @property {number|Long|null} [Column] Column Column
                 * @property {boolean|null} [HasPreField] Column HasPreField
                 * @property {string|null} [EnglishTitle] Column EnglishTitle
                 */

                /**
                 * Constructs a new Column.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Column.
                 * @implements IColumn
                 * @constructor
                 * @param {priority.netitems.form.IColumn=} [properties] Properties to set
                 */
                function Column(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Column ID.
                 * @member {number|Long} ID
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.ID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Column Name.
                 * @member {string} Name
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Name = "";

                /**
                 * Column Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Title = "";

                /**
                 * Column Type.
                 * @member {priority.netitems.form.ColumnType} Type
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Type = 0;

                /**
                 * Column Width.
                 * @member {number|Long} Width
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Width = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Column Key.
                 * @member {boolean} Key
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Key = false;

                /**
                 * Column Mandatory.
                 * @member {boolean} Mandatory
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Mandatory = false;

                /**
                 * Column Readonly.
                 * @member {boolean} Readonly
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Readonly = false;

                /**
                 * Column SearchAll.
                 * @member {boolean} SearchAll
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.SearchAll = false;

                /**
                 * Column Decimal.
                 * @member {number|Long} Decimal
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Decimal = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Column Qsrch.
                 * @member {boolean} Qsrch
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Qsrch = false;

                /**
                 * Column Zoom.
                 * @member {priority.netitems.form.ZoomType} Zoom
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Zoom = 0;

                /**
                 * Column Zoomfname.
                 * @member {string} Zoomfname
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Zoomfname = "";

                /**
                 * Column Relcol.
                 * @member {number|Long} Relcol
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Relcol = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Column DefaultValue.
                 * @member {string} DefaultValue
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.DefaultValue = "";

                /**
                 * Column MultiEnv.
                 * @member {boolean} MultiEnv
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.MultiEnv = false;

                /**
                 * Column InstantMessaging.
                 * @member {boolean} InstantMessaging
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.InstantMessaging = false;

                /**
                 * Column Hidden.
                 * @member {boolean} Hidden
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Hidden = false;

                /**
                 * Column IsStatus.
                 * @member {boolean} IsStatus
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.IsStatus = false;

                /**
                 * Column IsBalance.
                 * @member {boolean} IsBalance
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.IsBalance = false;

                /**
                 * Column Column.
                 * @member {number|Long} Column
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.Column = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Column HasPreField.
                 * @member {boolean} HasPreField
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.HasPreField = false;

                /**
                 * Column EnglishTitle.
                 * @member {string|null|undefined} EnglishTitle
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Column.prototype.EnglishTitle = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Column _EnglishTitle.
                 * @member {"EnglishTitle"|undefined} _EnglishTitle
                 * @memberof priority.netitems.form.Column
                 * @instance
                 */
                Object.defineProperty(Column.prototype, "_EnglishTitle", {
                    get: $util.oneOfGetter($oneOfFields = ["EnglishTitle"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Column instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Column
                 * @static
                 * @param {priority.netitems.form.IColumn=} [properties] Properties to set
                 * @returns {priority.netitems.form.Column} Column instance
                 */
                Column.create = function create(properties) {
                    return new Column(properties);
                };

                /**
                 * Encodes the specified Column message. Does not implicitly {@link priority.netitems.form.Column.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Column
                 * @static
                 * @param {priority.netitems.form.IColumn} message Column message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Column.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ID);
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Title);
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Type);
                    if (message.Width != null && Object.hasOwnProperty.call(message, "Width"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Width);
                    if (message.Key != null && Object.hasOwnProperty.call(message, "Key"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.Key);
                    if (message.Mandatory != null && Object.hasOwnProperty.call(message, "Mandatory"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.Mandatory);
                    if (message.Readonly != null && Object.hasOwnProperty.call(message, "Readonly"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.Readonly);
                    if (message.SearchAll != null && Object.hasOwnProperty.call(message, "SearchAll"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.SearchAll);
                    if (message.Decimal != null && Object.hasOwnProperty.call(message, "Decimal"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int64(message.Decimal);
                    if (message.Qsrch != null && Object.hasOwnProperty.call(message, "Qsrch"))
                        writer.uint32(/* id 13, wireType 0 =*/104).bool(message.Qsrch);
                    if (message.Zoom != null && Object.hasOwnProperty.call(message, "Zoom"))
                        writer.uint32(/* id 14, wireType 0 =*/112).int32(message.Zoom);
                    if (message.Zoomfname != null && Object.hasOwnProperty.call(message, "Zoomfname"))
                        writer.uint32(/* id 15, wireType 2 =*/122).string(message.Zoomfname);
                    if (message.Relcol != null && Object.hasOwnProperty.call(message, "Relcol"))
                        writer.uint32(/* id 16, wireType 0 =*/128).int64(message.Relcol);
                    if (message.DefaultValue != null && Object.hasOwnProperty.call(message, "DefaultValue"))
                        writer.uint32(/* id 17, wireType 2 =*/138).string(message.DefaultValue);
                    if (message.MultiEnv != null && Object.hasOwnProperty.call(message, "MultiEnv"))
                        writer.uint32(/* id 18, wireType 0 =*/144).bool(message.MultiEnv);
                    if (message.InstantMessaging != null && Object.hasOwnProperty.call(message, "InstantMessaging"))
                        writer.uint32(/* id 19, wireType 0 =*/152).bool(message.InstantMessaging);
                    if (message.Hidden != null && Object.hasOwnProperty.call(message, "Hidden"))
                        writer.uint32(/* id 20, wireType 0 =*/160).bool(message.Hidden);
                    if (message.IsStatus != null && Object.hasOwnProperty.call(message, "IsStatus"))
                        writer.uint32(/* id 21, wireType 0 =*/168).bool(message.IsStatus);
                    if (message.IsBalance != null && Object.hasOwnProperty.call(message, "IsBalance"))
                        writer.uint32(/* id 22, wireType 0 =*/176).bool(message.IsBalance);
                    if (message.Column != null && Object.hasOwnProperty.call(message, "Column"))
                        writer.uint32(/* id 23, wireType 0 =*/184).int64(message.Column);
                    if (message.HasPreField != null && Object.hasOwnProperty.call(message, "HasPreField"))
                        writer.uint32(/* id 24, wireType 0 =*/192).bool(message.HasPreField);
                    if (message.EnglishTitle != null && Object.hasOwnProperty.call(message, "EnglishTitle"))
                        writer.uint32(/* id 25, wireType 2 =*/202).string(message.EnglishTitle);
                    return writer;
                };

                /**
                 * Encodes the specified Column message, length delimited. Does not implicitly {@link priority.netitems.form.Column.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Column
                 * @static
                 * @param {priority.netitems.form.IColumn} message Column message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Column.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Column message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Column
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Column} Column
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Column.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Column();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ID = reader.int64();
                            break;
                        case 2:
                            message.Name = reader.string();
                            break;
                        case 3:
                            message.Title = reader.string();
                            break;
                        case 4:
                            message.Type = reader.int32();
                            break;
                        case 5:
                            message.Width = reader.int64();
                            break;
                        case 6:
                            message.Key = reader.bool();
                            break;
                        case 7:
                            message.Mandatory = reader.bool();
                            break;
                        case 8:
                            message.Readonly = reader.bool();
                            break;
                        case 10:
                            message.SearchAll = reader.bool();
                            break;
                        case 12:
                            message.Decimal = reader.int64();
                            break;
                        case 13:
                            message.Qsrch = reader.bool();
                            break;
                        case 14:
                            message.Zoom = reader.int32();
                            break;
                        case 15:
                            message.Zoomfname = reader.string();
                            break;
                        case 16:
                            message.Relcol = reader.int64();
                            break;
                        case 17:
                            message.DefaultValue = reader.string();
                            break;
                        case 18:
                            message.MultiEnv = reader.bool();
                            break;
                        case 19:
                            message.InstantMessaging = reader.bool();
                            break;
                        case 20:
                            message.Hidden = reader.bool();
                            break;
                        case 21:
                            message.IsStatus = reader.bool();
                            break;
                        case 22:
                            message.IsBalance = reader.bool();
                            break;
                        case 23:
                            message.Column = reader.int64();
                            break;
                        case 24:
                            message.HasPreField = reader.bool();
                            break;
                        case 25:
                            message.EnglishTitle = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Column message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Column
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Column} Column
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Column.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Column message.
                 * @function verify
                 * @memberof priority.netitems.form.Column
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Column.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.ID != null && message.hasOwnProperty("ID"))
                        if (!$util.isInteger(message.ID) && !(message.ID && $util.isInteger(message.ID.low) && $util.isInteger(message.ID.high)))
                            return "ID: integer|Long expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        switch (message.Type) {
                        default:
                            return "Type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                            break;
                        }
                    if (message.Width != null && message.hasOwnProperty("Width"))
                        if (!$util.isInteger(message.Width) && !(message.Width && $util.isInteger(message.Width.low) && $util.isInteger(message.Width.high)))
                            return "Width: integer|Long expected";
                    if (message.Key != null && message.hasOwnProperty("Key"))
                        if (typeof message.Key !== "boolean")
                            return "Key: boolean expected";
                    if (message.Mandatory != null && message.hasOwnProperty("Mandatory"))
                        if (typeof message.Mandatory !== "boolean")
                            return "Mandatory: boolean expected";
                    if (message.Readonly != null && message.hasOwnProperty("Readonly"))
                        if (typeof message.Readonly !== "boolean")
                            return "Readonly: boolean expected";
                    if (message.SearchAll != null && message.hasOwnProperty("SearchAll"))
                        if (typeof message.SearchAll !== "boolean")
                            return "SearchAll: boolean expected";
                    if (message.Decimal != null && message.hasOwnProperty("Decimal"))
                        if (!$util.isInteger(message.Decimal) && !(message.Decimal && $util.isInteger(message.Decimal.low) && $util.isInteger(message.Decimal.high)))
                            return "Decimal: integer|Long expected";
                    if (message.Qsrch != null && message.hasOwnProperty("Qsrch"))
                        if (typeof message.Qsrch !== "boolean")
                            return "Qsrch: boolean expected";
                    if (message.Zoom != null && message.hasOwnProperty("Zoom"))
                        switch (message.Zoom) {
                        default:
                            return "Zoom: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 14:
                            break;
                        }
                    if (message.Zoomfname != null && message.hasOwnProperty("Zoomfname"))
                        if (!$util.isString(message.Zoomfname))
                            return "Zoomfname: string expected";
                    if (message.Relcol != null && message.hasOwnProperty("Relcol"))
                        if (!$util.isInteger(message.Relcol) && !(message.Relcol && $util.isInteger(message.Relcol.low) && $util.isInteger(message.Relcol.high)))
                            return "Relcol: integer|Long expected";
                    if (message.DefaultValue != null && message.hasOwnProperty("DefaultValue"))
                        if (!$util.isString(message.DefaultValue))
                            return "DefaultValue: string expected";
                    if (message.MultiEnv != null && message.hasOwnProperty("MultiEnv"))
                        if (typeof message.MultiEnv !== "boolean")
                            return "MultiEnv: boolean expected";
                    if (message.InstantMessaging != null && message.hasOwnProperty("InstantMessaging"))
                        if (typeof message.InstantMessaging !== "boolean")
                            return "InstantMessaging: boolean expected";
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        if (typeof message.Hidden !== "boolean")
                            return "Hidden: boolean expected";
                    if (message.IsStatus != null && message.hasOwnProperty("IsStatus"))
                        if (typeof message.IsStatus !== "boolean")
                            return "IsStatus: boolean expected";
                    if (message.IsBalance != null && message.hasOwnProperty("IsBalance"))
                        if (typeof message.IsBalance !== "boolean")
                            return "IsBalance: boolean expected";
                    if (message.Column != null && message.hasOwnProperty("Column"))
                        if (!$util.isInteger(message.Column) && !(message.Column && $util.isInteger(message.Column.low) && $util.isInteger(message.Column.high)))
                            return "Column: integer|Long expected";
                    if (message.HasPreField != null && message.hasOwnProperty("HasPreField"))
                        if (typeof message.HasPreField !== "boolean")
                            return "HasPreField: boolean expected";
                    if (message.EnglishTitle != null && message.hasOwnProperty("EnglishTitle")) {
                        properties._EnglishTitle = 1;
                        if (!$util.isString(message.EnglishTitle))
                            return "EnglishTitle: string expected";
                    }
                    return null;
                };

                /**
                 * Creates a Column message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Column
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Column} Column
                 */
                Column.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Column)
                        return object;
                    var message = new $root.priority.netitems.form.Column();
                    if (object.ID != null)
                        if ($util.Long)
                            (message.ID = $util.Long.fromValue(object.ID)).unsigned = false;
                        else if (typeof object.ID === "string")
                            message.ID = parseInt(object.ID, 10);
                        else if (typeof object.ID === "number")
                            message.ID = object.ID;
                        else if (typeof object.ID === "object")
                            message.ID = new $util.LongBits(object.ID.low >>> 0, object.ID.high >>> 0).toNumber();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    switch (object.Type) {
                    case "Char":
                    case 0:
                        message.Type = 0;
                        break;
                    case "Str":
                    case 1:
                        message.Type = 1;
                        break;
                    case "Rstr":
                    case 2:
                        message.Type = 2;
                        break;
                    case "Boolean":
                    case 3:
                        message.Type = 3;
                        break;
                    case "Real":
                    case 4:
                        message.Type = 4;
                        break;
                    case "Int":
                    case 5:
                        message.Type = 5;
                        break;
                    case "Date8":
                    case 6:
                        message.Type = 6;
                        break;
                    case "Date10":
                    case 7:
                        message.Type = 7;
                        break;
                    case "Date14":
                    case 8:
                        message.Type = 8;
                        break;
                    case "Time5":
                    case 9:
                        message.Type = 9;
                        break;
                    case "Time6":
                    case 10:
                        message.Type = 10;
                        break;
                    case "Day":
                    case 11:
                        message.Type = 11;
                        break;
                    case "Unsigned":
                    case 12:
                        message.Type = 12;
                        break;
                    case "Operator":
                    case 13:
                        message.Type = 13;
                        break;
                    case "Attachment":
                    case 14:
                        message.Type = 14;
                        break;
                    }
                    if (object.Width != null)
                        if ($util.Long)
                            (message.Width = $util.Long.fromValue(object.Width)).unsigned = false;
                        else if (typeof object.Width === "string")
                            message.Width = parseInt(object.Width, 10);
                        else if (typeof object.Width === "number")
                            message.Width = object.Width;
                        else if (typeof object.Width === "object")
                            message.Width = new $util.LongBits(object.Width.low >>> 0, object.Width.high >>> 0).toNumber();
                    if (object.Key != null)
                        message.Key = Boolean(object.Key);
                    if (object.Mandatory != null)
                        message.Mandatory = Boolean(object.Mandatory);
                    if (object.Readonly != null)
                        message.Readonly = Boolean(object.Readonly);
                    if (object.SearchAll != null)
                        message.SearchAll = Boolean(object.SearchAll);
                    if (object.Decimal != null)
                        if ($util.Long)
                            (message.Decimal = $util.Long.fromValue(object.Decimal)).unsigned = false;
                        else if (typeof object.Decimal === "string")
                            message.Decimal = parseInt(object.Decimal, 10);
                        else if (typeof object.Decimal === "number")
                            message.Decimal = object.Decimal;
                        else if (typeof object.Decimal === "object")
                            message.Decimal = new $util.LongBits(object.Decimal.low >>> 0, object.Decimal.high >>> 0).toNumber();
                    if (object.Qsrch != null)
                        message.Qsrch = Boolean(object.Qsrch);
                    switch (object.Zoom) {
                    case "NoneZoom":
                    case 0:
                        message.Zoom = 0;
                        break;
                    case "AttachZoom":
                    case 1:
                        message.Zoom = 1;
                        break;
                    case "SelectZoom":
                    case 2:
                        message.Zoom = 2;
                        break;
                    case "ZoomZoom":
                    case 4:
                        message.Zoom = 4;
                        break;
                    case "Date14Zoom":
                    case 5:
                        message.Zoom = 5;
                        break;
                    case "Date8Zoom":
                    case 6:
                        message.Zoom = 6;
                        break;
                    case "Date10Zoom":
                    case 7:
                        message.Zoom = 7;
                        break;
                    case "EMailZoom":
                    case 8:
                        message.Zoom = 8;
                        break;
                    case "URLZoom":
                    case 9:
                        message.Zoom = 9;
                        break;
                    case "HiddenZoom":
                    case 10:
                        message.Zoom = 10;
                        break;
                    case "LinkFileZoom":
                    case 11:
                        message.Zoom = 11;
                        break;
                    case "QEditZoom":
                    case 12:
                        message.Zoom = 12;
                        break;
                    case "SpecialAttachZoom":
                    case 14:
                        message.Zoom = 14;
                        break;
                    }
                    if (object.Zoomfname != null)
                        message.Zoomfname = String(object.Zoomfname);
                    if (object.Relcol != null)
                        if ($util.Long)
                            (message.Relcol = $util.Long.fromValue(object.Relcol)).unsigned = false;
                        else if (typeof object.Relcol === "string")
                            message.Relcol = parseInt(object.Relcol, 10);
                        else if (typeof object.Relcol === "number")
                            message.Relcol = object.Relcol;
                        else if (typeof object.Relcol === "object")
                            message.Relcol = new $util.LongBits(object.Relcol.low >>> 0, object.Relcol.high >>> 0).toNumber();
                    if (object.DefaultValue != null)
                        message.DefaultValue = String(object.DefaultValue);
                    if (object.MultiEnv != null)
                        message.MultiEnv = Boolean(object.MultiEnv);
                    if (object.InstantMessaging != null)
                        message.InstantMessaging = Boolean(object.InstantMessaging);
                    if (object.Hidden != null)
                        message.Hidden = Boolean(object.Hidden);
                    if (object.IsStatus != null)
                        message.IsStatus = Boolean(object.IsStatus);
                    if (object.IsBalance != null)
                        message.IsBalance = Boolean(object.IsBalance);
                    if (object.Column != null)
                        if ($util.Long)
                            (message.Column = $util.Long.fromValue(object.Column)).unsigned = false;
                        else if (typeof object.Column === "string")
                            message.Column = parseInt(object.Column, 10);
                        else if (typeof object.Column === "number")
                            message.Column = object.Column;
                        else if (typeof object.Column === "object")
                            message.Column = new $util.LongBits(object.Column.low >>> 0, object.Column.high >>> 0).toNumber();
                    if (object.HasPreField != null)
                        message.HasPreField = Boolean(object.HasPreField);
                    if (object.EnglishTitle != null)
                        message.EnglishTitle = String(object.EnglishTitle);
                    return message;
                };

                /**
                 * Creates a plain object from a Column message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Column
                 * @static
                 * @param {priority.netitems.form.Column} message Column
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Column.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ID = options.longs === String ? "0" : 0;
                        object.Name = "";
                        object.Title = "";
                        object.Type = options.enums === String ? "Char" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Width = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Width = options.longs === String ? "0" : 0;
                        object.Key = false;
                        object.Mandatory = false;
                        object.Readonly = false;
                        object.SearchAll = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Decimal = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Decimal = options.longs === String ? "0" : 0;
                        object.Qsrch = false;
                        object.Zoom = options.enums === String ? "NoneZoom" : 0;
                        object.Zoomfname = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Relcol = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Relcol = options.longs === String ? "0" : 0;
                        object.DefaultValue = "";
                        object.MultiEnv = false;
                        object.InstantMessaging = false;
                        object.Hidden = false;
                        object.IsStatus = false;
                        object.IsBalance = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Column = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Column = options.longs === String ? "0" : 0;
                        object.HasPreField = false;
                    }
                    if (message.ID != null && message.hasOwnProperty("ID"))
                        if (typeof message.ID === "number")
                            object.ID = options.longs === String ? String(message.ID) : message.ID;
                        else
                            object.ID = options.longs === String ? $util.Long.prototype.toString.call(message.ID) : options.longs === Number ? new $util.LongBits(message.ID.low >>> 0, message.ID.high >>> 0).toNumber() : message.ID;
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        object.Type = options.enums === String ? $root.priority.netitems.form.ColumnType[message.Type] : message.Type;
                    if (message.Width != null && message.hasOwnProperty("Width"))
                        if (typeof message.Width === "number")
                            object.Width = options.longs === String ? String(message.Width) : message.Width;
                        else
                            object.Width = options.longs === String ? $util.Long.prototype.toString.call(message.Width) : options.longs === Number ? new $util.LongBits(message.Width.low >>> 0, message.Width.high >>> 0).toNumber() : message.Width;
                    if (message.Key != null && message.hasOwnProperty("Key"))
                        object.Key = message.Key;
                    if (message.Mandatory != null && message.hasOwnProperty("Mandatory"))
                        object.Mandatory = message.Mandatory;
                    if (message.Readonly != null && message.hasOwnProperty("Readonly"))
                        object.Readonly = message.Readonly;
                    if (message.SearchAll != null && message.hasOwnProperty("SearchAll"))
                        object.SearchAll = message.SearchAll;
                    if (message.Decimal != null && message.hasOwnProperty("Decimal"))
                        if (typeof message.Decimal === "number")
                            object.Decimal = options.longs === String ? String(message.Decimal) : message.Decimal;
                        else
                            object.Decimal = options.longs === String ? $util.Long.prototype.toString.call(message.Decimal) : options.longs === Number ? new $util.LongBits(message.Decimal.low >>> 0, message.Decimal.high >>> 0).toNumber() : message.Decimal;
                    if (message.Qsrch != null && message.hasOwnProperty("Qsrch"))
                        object.Qsrch = message.Qsrch;
                    if (message.Zoom != null && message.hasOwnProperty("Zoom"))
                        object.Zoom = options.enums === String ? $root.priority.netitems.form.ZoomType[message.Zoom] : message.Zoom;
                    if (message.Zoomfname != null && message.hasOwnProperty("Zoomfname"))
                        object.Zoomfname = message.Zoomfname;
                    if (message.Relcol != null && message.hasOwnProperty("Relcol"))
                        if (typeof message.Relcol === "number")
                            object.Relcol = options.longs === String ? String(message.Relcol) : message.Relcol;
                        else
                            object.Relcol = options.longs === String ? $util.Long.prototype.toString.call(message.Relcol) : options.longs === Number ? new $util.LongBits(message.Relcol.low >>> 0, message.Relcol.high >>> 0).toNumber() : message.Relcol;
                    if (message.DefaultValue != null && message.hasOwnProperty("DefaultValue"))
                        object.DefaultValue = message.DefaultValue;
                    if (message.MultiEnv != null && message.hasOwnProperty("MultiEnv"))
                        object.MultiEnv = message.MultiEnv;
                    if (message.InstantMessaging != null && message.hasOwnProperty("InstantMessaging"))
                        object.InstantMessaging = message.InstantMessaging;
                    if (message.Hidden != null && message.hasOwnProperty("Hidden"))
                        object.Hidden = message.Hidden;
                    if (message.IsStatus != null && message.hasOwnProperty("IsStatus"))
                        object.IsStatus = message.IsStatus;
                    if (message.IsBalance != null && message.hasOwnProperty("IsBalance"))
                        object.IsBalance = message.IsBalance;
                    if (message.Column != null && message.hasOwnProperty("Column"))
                        if (typeof message.Column === "number")
                            object.Column = options.longs === String ? String(message.Column) : message.Column;
                        else
                            object.Column = options.longs === String ? $util.Long.prototype.toString.call(message.Column) : options.longs === Number ? new $util.LongBits(message.Column.low >>> 0, message.Column.high >>> 0).toNumber() : message.Column;
                    if (message.HasPreField != null && message.hasOwnProperty("HasPreField"))
                        object.HasPreField = message.HasPreField;
                    if (message.EnglishTitle != null && message.hasOwnProperty("EnglishTitle")) {
                        object.EnglishTitle = message.EnglishTitle;
                        if (options.oneofs)
                            object._EnglishTitle = "EnglishTitle";
                    }
                    return object;
                };

                /**
                 * Converts this Column to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Column
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Column.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Column;
            })();

            /**
             * SubformType enum.
             * @name priority.netitems.form.SubformType
             * @enum {number}
             * @property {number} Regular=0 Regular value
             * @property {number} InternalDialog=1 InternalDialog value
             * @property {number} Attachments=2 Attachments value
             * @property {number} StatusLog=3 StatusLog value
             * @property {number} ChangeLog=4 ChangeLog value
             */
            form.SubformType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "Regular"] = 0;
                values[valuesById[1] = "InternalDialog"] = 1;
                values[valuesById[2] = "Attachments"] = 2;
                values[valuesById[3] = "StatusLog"] = 3;
                values[valuesById[4] = "ChangeLog"] = 4;
                return values;
            })();

            form.Subform = (function() {

                /**
                 * Properties of a Subform.
                 * @memberof priority.netitems.form
                 * @interface ISubform
                 * @property {string|null} [Title] Subform Title
                 * @property {string|null} [Ename] Subform Ename
                 * @property {boolean|null} [IsText] Subform IsText
                 * @property {priority.netitems.form.SubformType|null} [Type] Subform Type
                 */

                /**
                 * Constructs a new Subform.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Subform.
                 * @implements ISubform
                 * @constructor
                 * @param {priority.netitems.form.ISubform=} [properties] Properties to set
                 */
                function Subform(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Subform Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.Subform
                 * @instance
                 */
                Subform.prototype.Title = "";

                /**
                 * Subform Ename.
                 * @member {string} Ename
                 * @memberof priority.netitems.form.Subform
                 * @instance
                 */
                Subform.prototype.Ename = "";

                /**
                 * Subform IsText.
                 * @member {boolean} IsText
                 * @memberof priority.netitems.form.Subform
                 * @instance
                 */
                Subform.prototype.IsText = false;

                /**
                 * Subform Type.
                 * @member {priority.netitems.form.SubformType} Type
                 * @memberof priority.netitems.form.Subform
                 * @instance
                 */
                Subform.prototype.Type = 0;

                /**
                 * Creates a new Subform instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Subform
                 * @static
                 * @param {priority.netitems.form.ISubform=} [properties] Properties to set
                 * @returns {priority.netitems.form.Subform} Subform instance
                 */
                Subform.create = function create(properties) {
                    return new Subform(properties);
                };

                /**
                 * Encodes the specified Subform message. Does not implicitly {@link priority.netitems.form.Subform.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Subform
                 * @static
                 * @param {priority.netitems.form.ISubform} message Subform message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Subform.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
                    if (message.Ename != null && Object.hasOwnProperty.call(message, "Ename"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Ename);
                    if (message.IsText != null && Object.hasOwnProperty.call(message, "IsText"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsText);
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Type);
                    return writer;
                };

                /**
                 * Encodes the specified Subform message, length delimited. Does not implicitly {@link priority.netitems.form.Subform.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Subform
                 * @static
                 * @param {priority.netitems.form.ISubform} message Subform message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Subform.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Subform message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Subform
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Subform} Subform
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Subform.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Subform();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Title = reader.string();
                            break;
                        case 2:
                            message.Ename = reader.string();
                            break;
                        case 3:
                            message.IsText = reader.bool();
                            break;
                        case 4:
                            message.Type = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Subform message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Subform
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Subform} Subform
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Subform.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Subform message.
                 * @function verify
                 * @memberof priority.netitems.form.Subform
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Subform.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Ename != null && message.hasOwnProperty("Ename"))
                        if (!$util.isString(message.Ename))
                            return "Ename: string expected";
                    if (message.IsText != null && message.hasOwnProperty("IsText"))
                        if (typeof message.IsText !== "boolean")
                            return "IsText: boolean expected";
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        switch (message.Type) {
                        default:
                            return "Type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a Subform message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Subform
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Subform} Subform
                 */
                Subform.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Subform)
                        return object;
                    var message = new $root.priority.netitems.form.Subform();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Ename != null)
                        message.Ename = String(object.Ename);
                    if (object.IsText != null)
                        message.IsText = Boolean(object.IsText);
                    switch (object.Type) {
                    case "Regular":
                    case 0:
                        message.Type = 0;
                        break;
                    case "InternalDialog":
                    case 1:
                        message.Type = 1;
                        break;
                    case "Attachments":
                    case 2:
                        message.Type = 2;
                        break;
                    case "StatusLog":
                    case 3:
                        message.Type = 3;
                        break;
                    case "ChangeLog":
                    case 4:
                        message.Type = 4;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Subform message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Subform
                 * @static
                 * @param {priority.netitems.form.Subform} message Subform
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Subform.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Title = "";
                        object.Ename = "";
                        object.IsText = false;
                        object.Type = options.enums === String ? "Regular" : 0;
                    }
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Ename != null && message.hasOwnProperty("Ename"))
                        object.Ename = message.Ename;
                    if (message.IsText != null && message.hasOwnProperty("IsText"))
                        object.IsText = message.IsText;
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        object.Type = options.enums === String ? $root.priority.netitems.form.SubformType[message.Type] : message.Type;
                    return object;
                };

                /**
                 * Converts this Subform to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Subform
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Subform.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Subform;
            })();

            form.Action = (function() {

                /**
                 * Properties of an Action.
                 * @memberof priority.netitems.form
                 * @interface IAction
                 * @property {string|null} [Title] Action Title
                 * @property {number|Long|null} [Form] Action Form
                 * @property {number|Long|null} [Type] Action Type
                 * @property {string|null} [Ename] Action Ename
                 * @property {boolean|null} [Confirm] Action Confirm
                 * @property {boolean|null} [Background] Action Background
                 * @property {number|Long|null} [Etype] Action Etype
                 * @property {number|Long|null} [Exec] Action Exec
                 */

                /**
                 * Constructs a new Action.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an Action.
                 * @implements IAction
                 * @constructor
                 * @param {priority.netitems.form.IAction=} [properties] Properties to set
                 */
                function Action(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Action Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.Action
                 * @instance
                 */
                Action.prototype.Title = "";

                /**
                 * Action Form.
                 * @member {number|Long} Form
                 * @memberof priority.netitems.form.Action
                 * @instance
                 */
                Action.prototype.Form = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Action Type.
                 * @member {number|Long} Type
                 * @memberof priority.netitems.form.Action
                 * @instance
                 */
                Action.prototype.Type = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Action Ename.
                 * @member {string} Ename
                 * @memberof priority.netitems.form.Action
                 * @instance
                 */
                Action.prototype.Ename = "";

                /**
                 * Action Confirm.
                 * @member {boolean} Confirm
                 * @memberof priority.netitems.form.Action
                 * @instance
                 */
                Action.prototype.Confirm = false;

                /**
                 * Action Background.
                 * @member {boolean} Background
                 * @memberof priority.netitems.form.Action
                 * @instance
                 */
                Action.prototype.Background = false;

                /**
                 * Action Etype.
                 * @member {number|Long} Etype
                 * @memberof priority.netitems.form.Action
                 * @instance
                 */
                Action.prototype.Etype = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Action Exec.
                 * @member {number|Long} Exec
                 * @memberof priority.netitems.form.Action
                 * @instance
                 */
                Action.prototype.Exec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new Action instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Action
                 * @static
                 * @param {priority.netitems.form.IAction=} [properties] Properties to set
                 * @returns {priority.netitems.form.Action} Action instance
                 */
                Action.create = function create(properties) {
                    return new Action(properties);
                };

                /**
                 * Encodes the specified Action message. Does not implicitly {@link priority.netitems.form.Action.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Action
                 * @static
                 * @param {priority.netitems.form.IAction} message Action message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Action.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
                    if (message.Form != null && Object.hasOwnProperty.call(message, "Form"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Form);
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.Type);
                    if (message.Ename != null && Object.hasOwnProperty.call(message, "Ename"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Ename);
                    if (message.Confirm != null && Object.hasOwnProperty.call(message, "Confirm"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.Confirm);
                    if (message.Background != null && Object.hasOwnProperty.call(message, "Background"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.Background);
                    if (message.Etype != null && Object.hasOwnProperty.call(message, "Etype"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.Etype);
                    if (message.Exec != null && Object.hasOwnProperty.call(message, "Exec"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.Exec);
                    return writer;
                };

                /**
                 * Encodes the specified Action message, length delimited. Does not implicitly {@link priority.netitems.form.Action.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Action
                 * @static
                 * @param {priority.netitems.form.IAction} message Action message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Action.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Action message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Action
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Action} Action
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Action.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Action();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Title = reader.string();
                            break;
                        case 2:
                            message.Form = reader.int64();
                            break;
                        case 3:
                            message.Type = reader.int64();
                            break;
                        case 4:
                            message.Ename = reader.string();
                            break;
                        case 5:
                            message.Confirm = reader.bool();
                            break;
                        case 6:
                            message.Background = reader.bool();
                            break;
                        case 7:
                            message.Etype = reader.int64();
                            break;
                        case 8:
                            message.Exec = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Action message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Action
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Action} Action
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Action.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Action message.
                 * @function verify
                 * @memberof priority.netitems.form.Action
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Action.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Form != null && message.hasOwnProperty("Form"))
                        if (!$util.isInteger(message.Form) && !(message.Form && $util.isInteger(message.Form.low) && $util.isInteger(message.Form.high)))
                            return "Form: integer|Long expected";
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        if (!$util.isInteger(message.Type) && !(message.Type && $util.isInteger(message.Type.low) && $util.isInteger(message.Type.high)))
                            return "Type: integer|Long expected";
                    if (message.Ename != null && message.hasOwnProperty("Ename"))
                        if (!$util.isString(message.Ename))
                            return "Ename: string expected";
                    if (message.Confirm != null && message.hasOwnProperty("Confirm"))
                        if (typeof message.Confirm !== "boolean")
                            return "Confirm: boolean expected";
                    if (message.Background != null && message.hasOwnProperty("Background"))
                        if (typeof message.Background !== "boolean")
                            return "Background: boolean expected";
                    if (message.Etype != null && message.hasOwnProperty("Etype"))
                        if (!$util.isInteger(message.Etype) && !(message.Etype && $util.isInteger(message.Etype.low) && $util.isInteger(message.Etype.high)))
                            return "Etype: integer|Long expected";
                    if (message.Exec != null && message.hasOwnProperty("Exec"))
                        if (!$util.isInteger(message.Exec) && !(message.Exec && $util.isInteger(message.Exec.low) && $util.isInteger(message.Exec.high)))
                            return "Exec: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an Action message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Action
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Action} Action
                 */
                Action.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Action)
                        return object;
                    var message = new $root.priority.netitems.form.Action();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Form != null)
                        if ($util.Long)
                            (message.Form = $util.Long.fromValue(object.Form)).unsigned = false;
                        else if (typeof object.Form === "string")
                            message.Form = parseInt(object.Form, 10);
                        else if (typeof object.Form === "number")
                            message.Form = object.Form;
                        else if (typeof object.Form === "object")
                            message.Form = new $util.LongBits(object.Form.low >>> 0, object.Form.high >>> 0).toNumber();
                    if (object.Type != null)
                        if ($util.Long)
                            (message.Type = $util.Long.fromValue(object.Type)).unsigned = false;
                        else if (typeof object.Type === "string")
                            message.Type = parseInt(object.Type, 10);
                        else if (typeof object.Type === "number")
                            message.Type = object.Type;
                        else if (typeof object.Type === "object")
                            message.Type = new $util.LongBits(object.Type.low >>> 0, object.Type.high >>> 0).toNumber();
                    if (object.Ename != null)
                        message.Ename = String(object.Ename);
                    if (object.Confirm != null)
                        message.Confirm = Boolean(object.Confirm);
                    if (object.Background != null)
                        message.Background = Boolean(object.Background);
                    if (object.Etype != null)
                        if ($util.Long)
                            (message.Etype = $util.Long.fromValue(object.Etype)).unsigned = false;
                        else if (typeof object.Etype === "string")
                            message.Etype = parseInt(object.Etype, 10);
                        else if (typeof object.Etype === "number")
                            message.Etype = object.Etype;
                        else if (typeof object.Etype === "object")
                            message.Etype = new $util.LongBits(object.Etype.low >>> 0, object.Etype.high >>> 0).toNumber();
                    if (object.Exec != null)
                        if ($util.Long)
                            (message.Exec = $util.Long.fromValue(object.Exec)).unsigned = false;
                        else if (typeof object.Exec === "string")
                            message.Exec = parseInt(object.Exec, 10);
                        else if (typeof object.Exec === "number")
                            message.Exec = object.Exec;
                        else if (typeof object.Exec === "object")
                            message.Exec = new $util.LongBits(object.Exec.low >>> 0, object.Exec.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an Action message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Action
                 * @static
                 * @param {priority.netitems.form.Action} message Action
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Action.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Title = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Form = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Form = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Type = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Type = options.longs === String ? "0" : 0;
                        object.Ename = "";
                        object.Confirm = false;
                        object.Background = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Etype = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Etype = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Exec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Exec = options.longs === String ? "0" : 0;
                    }
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Form != null && message.hasOwnProperty("Form"))
                        if (typeof message.Form === "number")
                            object.Form = options.longs === String ? String(message.Form) : message.Form;
                        else
                            object.Form = options.longs === String ? $util.Long.prototype.toString.call(message.Form) : options.longs === Number ? new $util.LongBits(message.Form.low >>> 0, message.Form.high >>> 0).toNumber() : message.Form;
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        if (typeof message.Type === "number")
                            object.Type = options.longs === String ? String(message.Type) : message.Type;
                        else
                            object.Type = options.longs === String ? $util.Long.prototype.toString.call(message.Type) : options.longs === Number ? new $util.LongBits(message.Type.low >>> 0, message.Type.high >>> 0).toNumber() : message.Type;
                    if (message.Ename != null && message.hasOwnProperty("Ename"))
                        object.Ename = message.Ename;
                    if (message.Confirm != null && message.hasOwnProperty("Confirm"))
                        object.Confirm = message.Confirm;
                    if (message.Background != null && message.hasOwnProperty("Background"))
                        object.Background = message.Background;
                    if (message.Etype != null && message.hasOwnProperty("Etype"))
                        if (typeof message.Etype === "number")
                            object.Etype = options.longs === String ? String(message.Etype) : message.Etype;
                        else
                            object.Etype = options.longs === String ? $util.Long.prototype.toString.call(message.Etype) : options.longs === Number ? new $util.LongBits(message.Etype.low >>> 0, message.Etype.high >>> 0).toNumber() : message.Etype;
                    if (message.Exec != null && message.hasOwnProperty("Exec"))
                        if (typeof message.Exec === "number")
                            object.Exec = options.longs === String ? String(message.Exec) : message.Exec;
                        else
                            object.Exec = options.longs === String ? $util.Long.prototype.toString.call(message.Exec) : options.longs === Number ? new $util.LongBits(message.Exec.low >>> 0, message.Exec.high >>> 0).toNumber() : message.Exec;
                    return object;
                };

                /**
                 * Converts this Action to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Action
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Action.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Action;
            })();

            form.Query = (function() {

                /**
                 * Properties of a Query.
                 * @memberof priority.netitems.form
                 * @interface IQuery
                 * @property {number|Long|null} [Num] Query Num
                 * @property {string|null} [Name] Query Name
                 * @property {boolean|null} [IsDefault] Query IsDefault
                 */

                /**
                 * Constructs a new Query.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Query.
                 * @implements IQuery
                 * @constructor
                 * @param {priority.netitems.form.IQuery=} [properties] Properties to set
                 */
                function Query(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Query Num.
                 * @member {number|Long} Num
                 * @memberof priority.netitems.form.Query
                 * @instance
                 */
                Query.prototype.Num = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Query Name.
                 * @member {string} Name
                 * @memberof priority.netitems.form.Query
                 * @instance
                 */
                Query.prototype.Name = "";

                /**
                 * Query IsDefault.
                 * @member {boolean} IsDefault
                 * @memberof priority.netitems.form.Query
                 * @instance
                 */
                Query.prototype.IsDefault = false;

                /**
                 * Creates a new Query instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Query
                 * @static
                 * @param {priority.netitems.form.IQuery=} [properties] Properties to set
                 * @returns {priority.netitems.form.Query} Query instance
                 */
                Query.create = function create(properties) {
                    return new Query(properties);
                };

                /**
                 * Encodes the specified Query message. Does not implicitly {@link priority.netitems.form.Query.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Query
                 * @static
                 * @param {priority.netitems.form.IQuery} message Query message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Query.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Num != null && Object.hasOwnProperty.call(message, "Num"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Num);
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
                    if (message.IsDefault != null && Object.hasOwnProperty.call(message, "IsDefault"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsDefault);
                    return writer;
                };

                /**
                 * Encodes the specified Query message, length delimited. Does not implicitly {@link priority.netitems.form.Query.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Query
                 * @static
                 * @param {priority.netitems.form.IQuery} message Query message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Query.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Query message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Query
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Query} Query
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Query.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Query();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Num = reader.int64();
                            break;
                        case 2:
                            message.Name = reader.string();
                            break;
                        case 3:
                            message.IsDefault = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Query message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Query
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Query} Query
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Query.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Query message.
                 * @function verify
                 * @memberof priority.netitems.form.Query
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Query.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Num != null && message.hasOwnProperty("Num"))
                        if (!$util.isInteger(message.Num) && !(message.Num && $util.isInteger(message.Num.low) && $util.isInteger(message.Num.high)))
                            return "Num: integer|Long expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.IsDefault != null && message.hasOwnProperty("IsDefault"))
                        if (typeof message.IsDefault !== "boolean")
                            return "IsDefault: boolean expected";
                    return null;
                };

                /**
                 * Creates a Query message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Query
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Query} Query
                 */
                Query.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Query)
                        return object;
                    var message = new $root.priority.netitems.form.Query();
                    if (object.Num != null)
                        if ($util.Long)
                            (message.Num = $util.Long.fromValue(object.Num)).unsigned = false;
                        else if (typeof object.Num === "string")
                            message.Num = parseInt(object.Num, 10);
                        else if (typeof object.Num === "number")
                            message.Num = object.Num;
                        else if (typeof object.Num === "object")
                            message.Num = new $util.LongBits(object.Num.low >>> 0, object.Num.high >>> 0).toNumber();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.IsDefault != null)
                        message.IsDefault = Boolean(object.IsDefault);
                    return message;
                };

                /**
                 * Creates a plain object from a Query message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Query
                 * @static
                 * @param {priority.netitems.form.Query} message Query
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Query.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Num = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Num = options.longs === String ? "0" : 0;
                        object.Name = "";
                        object.IsDefault = false;
                    }
                    if (message.Num != null && message.hasOwnProperty("Num"))
                        if (typeof message.Num === "number")
                            object.Num = options.longs === String ? String(message.Num) : message.Num;
                        else
                            object.Num = options.longs === String ? $util.Long.prototype.toString.call(message.Num) : options.longs === Number ? new $util.LongBits(message.Num.low >>> 0, message.Num.high >>> 0).toNumber() : message.Num;
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.IsDefault != null && message.hasOwnProperty("IsDefault"))
                        object.IsDefault = message.IsDefault;
                    return object;
                };

                /**
                 * Converts this Query to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Query
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Query.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Query;
            })();

            form.Macro = (function() {

                /**
                 * Properties of a Macro.
                 * @memberof priority.netitems.form
                 * @interface IMacro
                 * @property {string|null} [Macro] Macro Macro
                 * @property {string|null} [MayDelete] Macro MayDelete
                 * @property {string|null} [IsNew] Macro IsNew
                 * @property {string|null} [OrigTitle] Macro OrigTitle
                 * @property {string|null} [Title] Macro Title
                 */

                /**
                 * Constructs a new Macro.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Macro.
                 * @implements IMacro
                 * @constructor
                 * @param {priority.netitems.form.IMacro=} [properties] Properties to set
                 */
                function Macro(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Macro Macro.
                 * @member {string} Macro
                 * @memberof priority.netitems.form.Macro
                 * @instance
                 */
                Macro.prototype.Macro = "";

                /**
                 * Macro MayDelete.
                 * @member {string} MayDelete
                 * @memberof priority.netitems.form.Macro
                 * @instance
                 */
                Macro.prototype.MayDelete = "";

                /**
                 * Macro IsNew.
                 * @member {string} IsNew
                 * @memberof priority.netitems.form.Macro
                 * @instance
                 */
                Macro.prototype.IsNew = "";

                /**
                 * Macro OrigTitle.
                 * @member {string} OrigTitle
                 * @memberof priority.netitems.form.Macro
                 * @instance
                 */
                Macro.prototype.OrigTitle = "";

                /**
                 * Macro Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.Macro
                 * @instance
                 */
                Macro.prototype.Title = "";

                /**
                 * Creates a new Macro instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Macro
                 * @static
                 * @param {priority.netitems.form.IMacro=} [properties] Properties to set
                 * @returns {priority.netitems.form.Macro} Macro instance
                 */
                Macro.create = function create(properties) {
                    return new Macro(properties);
                };

                /**
                 * Encodes the specified Macro message. Does not implicitly {@link priority.netitems.form.Macro.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Macro
                 * @static
                 * @param {priority.netitems.form.IMacro} message Macro message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Macro.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Macro != null && Object.hasOwnProperty.call(message, "Macro"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Macro);
                    if (message.MayDelete != null && Object.hasOwnProperty.call(message, "MayDelete"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.MayDelete);
                    if (message.IsNew != null && Object.hasOwnProperty.call(message, "IsNew"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.IsNew);
                    if (message.OrigTitle != null && Object.hasOwnProperty.call(message, "OrigTitle"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.OrigTitle);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.Title);
                    return writer;
                };

                /**
                 * Encodes the specified Macro message, length delimited. Does not implicitly {@link priority.netitems.form.Macro.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Macro
                 * @static
                 * @param {priority.netitems.form.IMacro} message Macro message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Macro.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Macro message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Macro
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Macro} Macro
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Macro.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Macro();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Macro = reader.string();
                            break;
                        case 2:
                            message.MayDelete = reader.string();
                            break;
                        case 3:
                            message.IsNew = reader.string();
                            break;
                        case 4:
                            message.OrigTitle = reader.string();
                            break;
                        case 5:
                            message.Title = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Macro message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Macro
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Macro} Macro
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Macro.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Macro message.
                 * @function verify
                 * @memberof priority.netitems.form.Macro
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Macro.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Macro != null && message.hasOwnProperty("Macro"))
                        if (!$util.isString(message.Macro))
                            return "Macro: string expected";
                    if (message.MayDelete != null && message.hasOwnProperty("MayDelete"))
                        if (!$util.isString(message.MayDelete))
                            return "MayDelete: string expected";
                    if (message.IsNew != null && message.hasOwnProperty("IsNew"))
                        if (!$util.isString(message.IsNew))
                            return "IsNew: string expected";
                    if (message.OrigTitle != null && message.hasOwnProperty("OrigTitle"))
                        if (!$util.isString(message.OrigTitle))
                            return "OrigTitle: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    return null;
                };

                /**
                 * Creates a Macro message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Macro
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Macro} Macro
                 */
                Macro.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Macro)
                        return object;
                    var message = new $root.priority.netitems.form.Macro();
                    if (object.Macro != null)
                        message.Macro = String(object.Macro);
                    if (object.MayDelete != null)
                        message.MayDelete = String(object.MayDelete);
                    if (object.IsNew != null)
                        message.IsNew = String(object.IsNew);
                    if (object.OrigTitle != null)
                        message.OrigTitle = String(object.OrigTitle);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    return message;
                };

                /**
                 * Creates a plain object from a Macro message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Macro
                 * @static
                 * @param {priority.netitems.form.Macro} message Macro
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Macro.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Macro = "";
                        object.MayDelete = "";
                        object.IsNew = "";
                        object.OrigTitle = "";
                        object.Title = "";
                    }
                    if (message.Macro != null && message.hasOwnProperty("Macro"))
                        object.Macro = message.Macro;
                    if (message.MayDelete != null && message.hasOwnProperty("MayDelete"))
                        object.MayDelete = message.MayDelete;
                    if (message.IsNew != null && message.hasOwnProperty("IsNew"))
                        object.IsNew = message.IsNew;
                    if (message.OrigTitle != null && message.hasOwnProperty("OrigTitle"))
                        object.OrigTitle = message.OrigTitle;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    return object;
                };

                /**
                 * Converts this Macro to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Macro
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Macro.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Macro;
            })();

            form.Field = (function() {

                /**
                 * Properties of a Field.
                 * @memberof priority.netitems.form
                 * @interface IField
                 * @property {number|Long|null} [ColumnID] Field ColumnID
                 * @property {common.IConstant|null} [Value] Field Value
                 */

                /**
                 * Constructs a new Field.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Field.
                 * @implements IField
                 * @constructor
                 * @param {priority.netitems.form.IField=} [properties] Properties to set
                 */
                function Field(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Field ColumnID.
                 * @member {number|Long} ColumnID
                 * @memberof priority.netitems.form.Field
                 * @instance
                 */
                Field.prototype.ColumnID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Field Value.
                 * @member {common.IConstant|null|undefined} Value
                 * @memberof priority.netitems.form.Field
                 * @instance
                 */
                Field.prototype.Value = null;

                /**
                 * Creates a new Field instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Field
                 * @static
                 * @param {priority.netitems.form.IField=} [properties] Properties to set
                 * @returns {priority.netitems.form.Field} Field instance
                 */
                Field.create = function create(properties) {
                    return new Field(properties);
                };

                /**
                 * Encodes the specified Field message. Does not implicitly {@link priority.netitems.form.Field.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Field
                 * @static
                 * @param {priority.netitems.form.IField} message Field message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Field.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ColumnID != null && Object.hasOwnProperty.call(message, "ColumnID"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ColumnID);
                    if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
                        $root.common.Constant.encode(message.Value, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Field message, length delimited. Does not implicitly {@link priority.netitems.form.Field.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Field
                 * @static
                 * @param {priority.netitems.form.IField} message Field message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Field.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Field message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Field
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Field} Field
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Field.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Field();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ColumnID = reader.int64();
                            break;
                        case 2:
                            message.Value = $root.common.Constant.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Field message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Field
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Field} Field
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Field.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Field message.
                 * @function verify
                 * @memberof priority.netitems.form.Field
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Field.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ColumnID != null && message.hasOwnProperty("ColumnID"))
                        if (!$util.isInteger(message.ColumnID) && !(message.ColumnID && $util.isInteger(message.ColumnID.low) && $util.isInteger(message.ColumnID.high)))
                            return "ColumnID: integer|Long expected";
                    if (message.Value != null && message.hasOwnProperty("Value")) {
                        var error = $root.common.Constant.verify(message.Value);
                        if (error)
                            return "Value." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Field message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Field
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Field} Field
                 */
                Field.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Field)
                        return object;
                    var message = new $root.priority.netitems.form.Field();
                    if (object.ColumnID != null)
                        if ($util.Long)
                            (message.ColumnID = $util.Long.fromValue(object.ColumnID)).unsigned = false;
                        else if (typeof object.ColumnID === "string")
                            message.ColumnID = parseInt(object.ColumnID, 10);
                        else if (typeof object.ColumnID === "number")
                            message.ColumnID = object.ColumnID;
                        else if (typeof object.ColumnID === "object")
                            message.ColumnID = new $util.LongBits(object.ColumnID.low >>> 0, object.ColumnID.high >>> 0).toNumber();
                    if (object.Value != null) {
                        if (typeof object.Value !== "object")
                            throw TypeError(".priority.netitems.form.Field.Value: object expected");
                        message.Value = $root.common.Constant.fromObject(object.Value);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Field message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Field
                 * @static
                 * @param {priority.netitems.form.Field} message Field
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Field.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ColumnID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ColumnID = options.longs === String ? "0" : 0;
                        object.Value = null;
                    }
                    if (message.ColumnID != null && message.hasOwnProperty("ColumnID"))
                        if (typeof message.ColumnID === "number")
                            object.ColumnID = options.longs === String ? String(message.ColumnID) : message.ColumnID;
                        else
                            object.ColumnID = options.longs === String ? $util.Long.prototype.toString.call(message.ColumnID) : options.longs === Number ? new $util.LongBits(message.ColumnID.low >>> 0, message.ColumnID.high >>> 0).toNumber() : message.ColumnID;
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        object.Value = $root.common.Constant.toObject(message.Value, options);
                    return object;
                };

                /**
                 * Converts this Field to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Field
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Field.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Field;
            })();

            form.Record = (function() {

                /**
                 * Properties of a Record.
                 * @memberof priority.netitems.form
                 * @interface IRecord
                 * @property {Array.<priority.netitems.form.IField>|null} [Fields] Record Fields
                 */

                /**
                 * Constructs a new Record.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a Record.
                 * @implements IRecord
                 * @constructor
                 * @param {priority.netitems.form.IRecord=} [properties] Properties to set
                 */
                function Record(properties) {
                    this.Fields = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Record Fields.
                 * @member {Array.<priority.netitems.form.IField>} Fields
                 * @memberof priority.netitems.form.Record
                 * @instance
                 */
                Record.prototype.Fields = $util.emptyArray;

                /**
                 * Creates a new Record instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Record
                 * @static
                 * @param {priority.netitems.form.IRecord=} [properties] Properties to set
                 * @returns {priority.netitems.form.Record} Record instance
                 */
                Record.create = function create(properties) {
                    return new Record(properties);
                };

                /**
                 * Encodes the specified Record message. Does not implicitly {@link priority.netitems.form.Record.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Record
                 * @static
                 * @param {priority.netitems.form.IRecord} message Record message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Record.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Fields != null && message.Fields.length)
                        for (var i = 0; i < message.Fields.length; ++i)
                            $root.priority.netitems.form.Field.encode(message.Fields[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Record message, length delimited. Does not implicitly {@link priority.netitems.form.Record.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Record
                 * @static
                 * @param {priority.netitems.form.IRecord} message Record message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Record.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Record message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Record
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Record} Record
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Record.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Record();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Fields && message.Fields.length))
                                message.Fields = [];
                            message.Fields.push($root.priority.netitems.form.Field.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Record message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Record
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Record} Record
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Record.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Record message.
                 * @function verify
                 * @memberof priority.netitems.form.Record
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Record.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Fields != null && message.hasOwnProperty("Fields")) {
                        if (!Array.isArray(message.Fields))
                            return "Fields: array expected";
                        for (var i = 0; i < message.Fields.length; ++i) {
                            var error = $root.priority.netitems.form.Field.verify(message.Fields[i]);
                            if (error)
                                return "Fields." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Record message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Record
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Record} Record
                 */
                Record.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Record)
                        return object;
                    var message = new $root.priority.netitems.form.Record();
                    if (object.Fields) {
                        if (!Array.isArray(object.Fields))
                            throw TypeError(".priority.netitems.form.Record.Fields: array expected");
                        message.Fields = [];
                        for (var i = 0; i < object.Fields.length; ++i) {
                            if (typeof object.Fields[i] !== "object")
                                throw TypeError(".priority.netitems.form.Record.Fields: object expected");
                            message.Fields[i] = $root.priority.netitems.form.Field.fromObject(object.Fields[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Record message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Record
                 * @static
                 * @param {priority.netitems.form.Record} message Record
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Record.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Fields = [];
                    if (message.Fields && message.Fields.length) {
                        object.Fields = [];
                        for (var j = 0; j < message.Fields.length; ++j)
                            object.Fields[j] = $root.priority.netitems.form.Field.toObject(message.Fields[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Record to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Record
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Record.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Record;
            })();

            form.RecordColor = (function() {

                /**
                 * Properties of a RecordColor.
                 * @memberof priority.netitems.form
                 * @interface IRecordColor
                 * @property {string|null} [Colname] RecordColor Colname
                 * @property {string|null} [Color] RecordColor Color
                 * @property {string|null} [Value] RecordColor Value
                 * @property {string|null} [Value2] RecordColor Value2
                 * @property {priority.netitems.shared.ComparisonOperator|null} [Op] RecordColor Op
                 * @property {number|Long|null} [Ord] RecordColor Ord
                 */

                /**
                 * Constructs a new RecordColor.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a RecordColor.
                 * @implements IRecordColor
                 * @constructor
                 * @param {priority.netitems.form.IRecordColor=} [properties] Properties to set
                 */
                function RecordColor(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * RecordColor Colname.
                 * @member {string} Colname
                 * @memberof priority.netitems.form.RecordColor
                 * @instance
                 */
                RecordColor.prototype.Colname = "";

                /**
                 * RecordColor Color.
                 * @member {string} Color
                 * @memberof priority.netitems.form.RecordColor
                 * @instance
                 */
                RecordColor.prototype.Color = "";

                /**
                 * RecordColor Value.
                 * @member {string} Value
                 * @memberof priority.netitems.form.RecordColor
                 * @instance
                 */
                RecordColor.prototype.Value = "";

                /**
                 * RecordColor Value2.
                 * @member {string} Value2
                 * @memberof priority.netitems.form.RecordColor
                 * @instance
                 */
                RecordColor.prototype.Value2 = "";

                /**
                 * RecordColor Op.
                 * @member {priority.netitems.shared.ComparisonOperator} Op
                 * @memberof priority.netitems.form.RecordColor
                 * @instance
                 */
                RecordColor.prototype.Op = 0;

                /**
                 * RecordColor Ord.
                 * @member {number|Long} Ord
                 * @memberof priority.netitems.form.RecordColor
                 * @instance
                 */
                RecordColor.prototype.Ord = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new RecordColor instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.RecordColor
                 * @static
                 * @param {priority.netitems.form.IRecordColor=} [properties] Properties to set
                 * @returns {priority.netitems.form.RecordColor} RecordColor instance
                 */
                RecordColor.create = function create(properties) {
                    return new RecordColor(properties);
                };

                /**
                 * Encodes the specified RecordColor message. Does not implicitly {@link priority.netitems.form.RecordColor.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.RecordColor
                 * @static
                 * @param {priority.netitems.form.IRecordColor} message RecordColor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordColor.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Colname != null && Object.hasOwnProperty.call(message, "Colname"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Colname);
                    if (message.Color != null && Object.hasOwnProperty.call(message, "Color"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Color);
                    if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Value);
                    if (message.Value2 != null && Object.hasOwnProperty.call(message, "Value2"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Value2);
                    if (message.Op != null && Object.hasOwnProperty.call(message, "Op"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.Op);
                    if (message.Ord != null && Object.hasOwnProperty.call(message, "Ord"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.Ord);
                    return writer;
                };

                /**
                 * Encodes the specified RecordColor message, length delimited. Does not implicitly {@link priority.netitems.form.RecordColor.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.RecordColor
                 * @static
                 * @param {priority.netitems.form.IRecordColor} message RecordColor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                RecordColor.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a RecordColor message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.RecordColor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.RecordColor} RecordColor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordColor.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.RecordColor();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Colname = reader.string();
                            break;
                        case 2:
                            message.Color = reader.string();
                            break;
                        case 3:
                            message.Value = reader.string();
                            break;
                        case 4:
                            message.Value2 = reader.string();
                            break;
                        case 5:
                            message.Op = reader.int32();
                            break;
                        case 6:
                            message.Ord = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a RecordColor message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.RecordColor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.RecordColor} RecordColor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                RecordColor.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a RecordColor message.
                 * @function verify
                 * @memberof priority.netitems.form.RecordColor
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                RecordColor.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Colname != null && message.hasOwnProperty("Colname"))
                        if (!$util.isString(message.Colname))
                            return "Colname: string expected";
                    if (message.Color != null && message.hasOwnProperty("Color"))
                        if (!$util.isString(message.Color))
                            return "Color: string expected";
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        if (!$util.isString(message.Value))
                            return "Value: string expected";
                    if (message.Value2 != null && message.hasOwnProperty("Value2"))
                        if (!$util.isString(message.Value2))
                            return "Value2: string expected";
                    if (message.Op != null && message.hasOwnProperty("Op"))
                        switch (message.Op) {
                        default:
                            return "Op: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                            break;
                        }
                    if (message.Ord != null && message.hasOwnProperty("Ord"))
                        if (!$util.isInteger(message.Ord) && !(message.Ord && $util.isInteger(message.Ord.low) && $util.isInteger(message.Ord.high)))
                            return "Ord: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a RecordColor message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.RecordColor
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.RecordColor} RecordColor
                 */
                RecordColor.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.RecordColor)
                        return object;
                    var message = new $root.priority.netitems.form.RecordColor();
                    if (object.Colname != null)
                        message.Colname = String(object.Colname);
                    if (object.Color != null)
                        message.Color = String(object.Color);
                    if (object.Value != null)
                        message.Value = String(object.Value);
                    if (object.Value2 != null)
                        message.Value2 = String(object.Value2);
                    switch (object.Op) {
                    case "Eq":
                    case 0:
                        message.Op = 0;
                        break;
                    case "In":
                    case 1:
                        message.Op = 1;
                        break;
                    case "NotIn":
                    case 2:
                        message.Op = 2;
                        break;
                    case "Between":
                    case 3:
                        message.Op = 3;
                        break;
                    case "Gt":
                    case 4:
                        message.Op = 4;
                        break;
                    case "Lt":
                    case 5:
                        message.Op = 5;
                        break;
                    case "Le":
                    case 6:
                        message.Op = 6;
                        break;
                    case "Ge":
                    case 7:
                        message.Op = 7;
                        break;
                    case "Ne":
                    case 8:
                        message.Op = 8;
                        break;
                    case "NotBetween":
                    case 9:
                        message.Op = 9;
                        break;
                    case "IsNull":
                    case 10:
                        message.Op = 10;
                        break;
                    case "IsNotNull":
                    case 11:
                        message.Op = 11;
                        break;
                    case "Like":
                    case 12:
                        message.Op = 12;
                        break;
                    case "NotLike":
                    case 13:
                        message.Op = 13;
                        break;
                    case "AndNot":
                    case 14:
                        message.Op = 14;
                        break;
                    }
                    if (object.Ord != null)
                        if ($util.Long)
                            (message.Ord = $util.Long.fromValue(object.Ord)).unsigned = false;
                        else if (typeof object.Ord === "string")
                            message.Ord = parseInt(object.Ord, 10);
                        else if (typeof object.Ord === "number")
                            message.Ord = object.Ord;
                        else if (typeof object.Ord === "object")
                            message.Ord = new $util.LongBits(object.Ord.low >>> 0, object.Ord.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a RecordColor message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.RecordColor
                 * @static
                 * @param {priority.netitems.form.RecordColor} message RecordColor
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                RecordColor.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Colname = "";
                        object.Color = "";
                        object.Value = "";
                        object.Value2 = "";
                        object.Op = options.enums === String ? "Eq" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Ord = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Ord = options.longs === String ? "0" : 0;
                    }
                    if (message.Colname != null && message.hasOwnProperty("Colname"))
                        object.Colname = message.Colname;
                    if (message.Color != null && message.hasOwnProperty("Color"))
                        object.Color = message.Color;
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        object.Value = message.Value;
                    if (message.Value2 != null && message.hasOwnProperty("Value2"))
                        object.Value2 = message.Value2;
                    if (message.Op != null && message.hasOwnProperty("Op"))
                        object.Op = options.enums === String ? $root.priority.netitems.shared.ComparisonOperator[message.Op] : message.Op;
                    if (message.Ord != null && message.hasOwnProperty("Ord"))
                        if (typeof message.Ord === "number")
                            object.Ord = options.longs === String ? String(message.Ord) : message.Ord;
                        else
                            object.Ord = options.longs === String ? $util.Long.prototype.toString.call(message.Ord) : options.longs === Number ? new $util.LongBits(message.Ord.low >>> 0, message.Ord.high >>> 0).toNumber() : message.Ord;
                    return object;
                };

                /**
                 * Converts this RecordColor to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.RecordColor
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                RecordColor.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return RecordColor;
            })();

            form.HtmlSignatureFlags = (function() {

                /**
                 * Properties of a HtmlSignatureFlags.
                 * @memberof priority.netitems.form
                 * @interface IHtmlSignatureFlags
                 * @property {boolean|null} [Hr] HtmlSignatureFlags Hr
                 * @property {boolean|null} [Date] HtmlSignatureFlags Date
                 * @property {boolean|null} [Message] HtmlSignatureFlags Message
                 * @property {boolean|null} [Name] HtmlSignatureFlags Name
                 * @property {boolean|null} [Position] HtmlSignatureFlags Position
                 * @property {boolean|null} [Email] HtmlSignatureFlags Email
                 * @property {boolean|null} [Phone] HtmlSignatureFlags Phone
                 * @property {boolean|null} [Cellphone] HtmlSignatureFlags Cellphone
                 * @property {boolean|null} [Branch] HtmlSignatureFlags Branch
                 * @property {boolean|null} [Dept] HtmlSignatureFlags Dept
                 * @property {boolean|null} [Company] HtmlSignatureFlags Company
                 */

                /**
                 * Constructs a new HtmlSignatureFlags.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlSignatureFlags.
                 * @implements IHtmlSignatureFlags
                 * @constructor
                 * @param {priority.netitems.form.IHtmlSignatureFlags=} [properties] Properties to set
                 */
                function HtmlSignatureFlags(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlSignatureFlags Hr.
                 * @member {boolean} Hr
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Hr = false;

                /**
                 * HtmlSignatureFlags Date.
                 * @member {boolean} Date
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Date = false;

                /**
                 * HtmlSignatureFlags Message.
                 * @member {boolean} Message
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Message = false;

                /**
                 * HtmlSignatureFlags Name.
                 * @member {boolean} Name
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Name = false;

                /**
                 * HtmlSignatureFlags Position.
                 * @member {boolean} Position
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Position = false;

                /**
                 * HtmlSignatureFlags Email.
                 * @member {boolean} Email
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Email = false;

                /**
                 * HtmlSignatureFlags Phone.
                 * @member {boolean} Phone
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Phone = false;

                /**
                 * HtmlSignatureFlags Cellphone.
                 * @member {boolean} Cellphone
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Cellphone = false;

                /**
                 * HtmlSignatureFlags Branch.
                 * @member {boolean} Branch
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Branch = false;

                /**
                 * HtmlSignatureFlags Dept.
                 * @member {boolean} Dept
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Dept = false;

                /**
                 * HtmlSignatureFlags Company.
                 * @member {boolean} Company
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 */
                HtmlSignatureFlags.prototype.Company = false;

                /**
                 * Creates a new HtmlSignatureFlags instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureFlags=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlSignatureFlags} HtmlSignatureFlags instance
                 */
                HtmlSignatureFlags.create = function create(properties) {
                    return new HtmlSignatureFlags(properties);
                };

                /**
                 * Encodes the specified HtmlSignatureFlags message. Does not implicitly {@link priority.netitems.form.HtmlSignatureFlags.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureFlags} message HtmlSignatureFlags message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSignatureFlags.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Hr != null && Object.hasOwnProperty.call(message, "Hr"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.Hr);
                    if (message.Date != null && Object.hasOwnProperty.call(message, "Date"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Date);
                    if (message.Message != null && Object.hasOwnProperty.call(message, "Message"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.Message);
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Name);
                    if (message.Position != null && Object.hasOwnProperty.call(message, "Position"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.Position);
                    if (message.Email != null && Object.hasOwnProperty.call(message, "Email"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.Email);
                    if (message.Phone != null && Object.hasOwnProperty.call(message, "Phone"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.Phone);
                    if (message.Cellphone != null && Object.hasOwnProperty.call(message, "Cellphone"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.Cellphone);
                    if (message.Branch != null && Object.hasOwnProperty.call(message, "Branch"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.Branch);
                    if (message.Dept != null && Object.hasOwnProperty.call(message, "Dept"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.Dept);
                    if (message.Company != null && Object.hasOwnProperty.call(message, "Company"))
                        writer.uint32(/* id 11, wireType 0 =*/88).bool(message.Company);
                    return writer;
                };

                /**
                 * Encodes the specified HtmlSignatureFlags message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlSignatureFlags.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureFlags} message HtmlSignatureFlags message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSignatureFlags.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlSignatureFlags message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlSignatureFlags} HtmlSignatureFlags
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSignatureFlags.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlSignatureFlags();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Hr = reader.bool();
                            break;
                        case 2:
                            message.Date = reader.bool();
                            break;
                        case 3:
                            message.Message = reader.bool();
                            break;
                        case 4:
                            message.Name = reader.bool();
                            break;
                        case 5:
                            message.Position = reader.bool();
                            break;
                        case 6:
                            message.Email = reader.bool();
                            break;
                        case 7:
                            message.Phone = reader.bool();
                            break;
                        case 8:
                            message.Cellphone = reader.bool();
                            break;
                        case 9:
                            message.Branch = reader.bool();
                            break;
                        case 10:
                            message.Dept = reader.bool();
                            break;
                        case 11:
                            message.Company = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlSignatureFlags message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlSignatureFlags} HtmlSignatureFlags
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSignatureFlags.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlSignatureFlags message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlSignatureFlags.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Hr != null && message.hasOwnProperty("Hr"))
                        if (typeof message.Hr !== "boolean")
                            return "Hr: boolean expected";
                    if (message.Date != null && message.hasOwnProperty("Date"))
                        if (typeof message.Date !== "boolean")
                            return "Date: boolean expected";
                    if (message.Message != null && message.hasOwnProperty("Message"))
                        if (typeof message.Message !== "boolean")
                            return "Message: boolean expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (typeof message.Name !== "boolean")
                            return "Name: boolean expected";
                    if (message.Position != null && message.hasOwnProperty("Position"))
                        if (typeof message.Position !== "boolean")
                            return "Position: boolean expected";
                    if (message.Email != null && message.hasOwnProperty("Email"))
                        if (typeof message.Email !== "boolean")
                            return "Email: boolean expected";
                    if (message.Phone != null && message.hasOwnProperty("Phone"))
                        if (typeof message.Phone !== "boolean")
                            return "Phone: boolean expected";
                    if (message.Cellphone != null && message.hasOwnProperty("Cellphone"))
                        if (typeof message.Cellphone !== "boolean")
                            return "Cellphone: boolean expected";
                    if (message.Branch != null && message.hasOwnProperty("Branch"))
                        if (typeof message.Branch !== "boolean")
                            return "Branch: boolean expected";
                    if (message.Dept != null && message.hasOwnProperty("Dept"))
                        if (typeof message.Dept !== "boolean")
                            return "Dept: boolean expected";
                    if (message.Company != null && message.hasOwnProperty("Company"))
                        if (typeof message.Company !== "boolean")
                            return "Company: boolean expected";
                    return null;
                };

                /**
                 * Creates a HtmlSignatureFlags message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlSignatureFlags} HtmlSignatureFlags
                 */
                HtmlSignatureFlags.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlSignatureFlags)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlSignatureFlags();
                    if (object.Hr != null)
                        message.Hr = Boolean(object.Hr);
                    if (object.Date != null)
                        message.Date = Boolean(object.Date);
                    if (object.Message != null)
                        message.Message = Boolean(object.Message);
                    if (object.Name != null)
                        message.Name = Boolean(object.Name);
                    if (object.Position != null)
                        message.Position = Boolean(object.Position);
                    if (object.Email != null)
                        message.Email = Boolean(object.Email);
                    if (object.Phone != null)
                        message.Phone = Boolean(object.Phone);
                    if (object.Cellphone != null)
                        message.Cellphone = Boolean(object.Cellphone);
                    if (object.Branch != null)
                        message.Branch = Boolean(object.Branch);
                    if (object.Dept != null)
                        message.Dept = Boolean(object.Dept);
                    if (object.Company != null)
                        message.Company = Boolean(object.Company);
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlSignatureFlags message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @static
                 * @param {priority.netitems.form.HtmlSignatureFlags} message HtmlSignatureFlags
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlSignatureFlags.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Hr = false;
                        object.Date = false;
                        object.Message = false;
                        object.Name = false;
                        object.Position = false;
                        object.Email = false;
                        object.Phone = false;
                        object.Cellphone = false;
                        object.Branch = false;
                        object.Dept = false;
                        object.Company = false;
                    }
                    if (message.Hr != null && message.hasOwnProperty("Hr"))
                        object.Hr = message.Hr;
                    if (message.Date != null && message.hasOwnProperty("Date"))
                        object.Date = message.Date;
                    if (message.Message != null && message.hasOwnProperty("Message"))
                        object.Message = message.Message;
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Position != null && message.hasOwnProperty("Position"))
                        object.Position = message.Position;
                    if (message.Email != null && message.hasOwnProperty("Email"))
                        object.Email = message.Email;
                    if (message.Phone != null && message.hasOwnProperty("Phone"))
                        object.Phone = message.Phone;
                    if (message.Cellphone != null && message.hasOwnProperty("Cellphone"))
                        object.Cellphone = message.Cellphone;
                    if (message.Branch != null && message.hasOwnProperty("Branch"))
                        object.Branch = message.Branch;
                    if (message.Dept != null && message.hasOwnProperty("Dept"))
                        object.Dept = message.Dept;
                    if (message.Company != null && message.hasOwnProperty("Company"))
                        object.Company = message.Company;
                    return object;
                };

                /**
                 * Converts this HtmlSignatureFlags to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlSignatureFlags
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlSignatureFlags.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlSignatureFlags;
            })();

            form.HtmlSignatureBase = (function() {

                /**
                 * Properties of a HtmlSignatureBase.
                 * @memberof priority.netitems.form
                 * @interface IHtmlSignatureBase
                 * @property {string|null} [Date] HtmlSignatureBase Date
                 * @property {string|null} [Name] HtmlSignatureBase Name
                 * @property {boolean|null} [Hr] HtmlSignatureBase Hr
                 * @property {boolean|null} [Begin] HtmlSignatureBase Begin
                 * @property {string|null} [Position] HtmlSignatureBase Position
                 * @property {string|null} [Email] HtmlSignatureBase Email
                 * @property {string|null} [Phone] HtmlSignatureBase Phone
                 * @property {string|null} [Sincerely] HtmlSignatureBase Sincerely
                 * @property {number|Long|null} [Fontsize] HtmlSignatureBase Fontsize
                 * @property {string|null} [Cellphone] HtmlSignatureBase Cellphone
                 * @property {string|null} [Branch] HtmlSignatureBase Branch
                 * @property {string|null} [Dept] HtmlSignatureBase Dept
                 * @property {string|null} [Company] HtmlSignatureBase Company
                 * @property {priority.netitems.form.IHtmlSignatureFlags|null} [Flags] HtmlSignatureBase Flags
                 */

                /**
                 * Constructs a new HtmlSignatureBase.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a HtmlSignatureBase.
                 * @implements IHtmlSignatureBase
                 * @constructor
                 * @param {priority.netitems.form.IHtmlSignatureBase=} [properties] Properties to set
                 */
                function HtmlSignatureBase(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * HtmlSignatureBase Date.
                 * @member {string} Date
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Date = "";

                /**
                 * HtmlSignatureBase Name.
                 * @member {string} Name
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Name = "";

                /**
                 * HtmlSignatureBase Hr.
                 * @member {boolean} Hr
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Hr = false;

                /**
                 * HtmlSignatureBase Begin.
                 * @member {boolean} Begin
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Begin = false;

                /**
                 * HtmlSignatureBase Position.
                 * @member {string} Position
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Position = "";

                /**
                 * HtmlSignatureBase Email.
                 * @member {string} Email
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Email = "";

                /**
                 * HtmlSignatureBase Phone.
                 * @member {string} Phone
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Phone = "";

                /**
                 * HtmlSignatureBase Sincerely.
                 * @member {string} Sincerely
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Sincerely = "";

                /**
                 * HtmlSignatureBase Fontsize.
                 * @member {number|Long} Fontsize
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Fontsize = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * HtmlSignatureBase Cellphone.
                 * @member {string} Cellphone
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Cellphone = "";

                /**
                 * HtmlSignatureBase Branch.
                 * @member {string} Branch
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Branch = "";

                /**
                 * HtmlSignatureBase Dept.
                 * @member {string} Dept
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Dept = "";

                /**
                 * HtmlSignatureBase Company.
                 * @member {string} Company
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Company = "";

                /**
                 * HtmlSignatureBase Flags.
                 * @member {priority.netitems.form.IHtmlSignatureFlags|null|undefined} Flags
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 */
                HtmlSignatureBase.prototype.Flags = null;

                /**
                 * Creates a new HtmlSignatureBase instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureBase=} [properties] Properties to set
                 * @returns {priority.netitems.form.HtmlSignatureBase} HtmlSignatureBase instance
                 */
                HtmlSignatureBase.create = function create(properties) {
                    return new HtmlSignatureBase(properties);
                };

                /**
                 * Encodes the specified HtmlSignatureBase message. Does not implicitly {@link priority.netitems.form.HtmlSignatureBase.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureBase} message HtmlSignatureBase message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSignatureBase.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Date != null && Object.hasOwnProperty.call(message, "Date"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Date);
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
                    if (message.Hr != null && Object.hasOwnProperty.call(message, "Hr"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.Hr);
                    if (message.Begin != null && Object.hasOwnProperty.call(message, "Begin"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Begin);
                    if (message.Position != null && Object.hasOwnProperty.call(message, "Position"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.Position);
                    if (message.Email != null && Object.hasOwnProperty.call(message, "Email"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.Email);
                    if (message.Phone != null && Object.hasOwnProperty.call(message, "Phone"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.Phone);
                    if (message.Sincerely != null && Object.hasOwnProperty.call(message, "Sincerely"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.Sincerely);
                    if (message.Fontsize != null && Object.hasOwnProperty.call(message, "Fontsize"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.Fontsize);
                    if (message.Cellphone != null && Object.hasOwnProperty.call(message, "Cellphone"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.Cellphone);
                    if (message.Branch != null && Object.hasOwnProperty.call(message, "Branch"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.Branch);
                    if (message.Dept != null && Object.hasOwnProperty.call(message, "Dept"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.Dept);
                    if (message.Company != null && Object.hasOwnProperty.call(message, "Company"))
                        writer.uint32(/* id 13, wireType 2 =*/106).string(message.Company);
                    if (message.Flags != null && Object.hasOwnProperty.call(message, "Flags"))
                        $root.priority.netitems.form.HtmlSignatureFlags.encode(message.Flags, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified HtmlSignatureBase message, length delimited. Does not implicitly {@link priority.netitems.form.HtmlSignatureBase.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @static
                 * @param {priority.netitems.form.IHtmlSignatureBase} message HtmlSignatureBase message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HtmlSignatureBase.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a HtmlSignatureBase message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.HtmlSignatureBase} HtmlSignatureBase
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSignatureBase.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.HtmlSignatureBase();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Date = reader.string();
                            break;
                        case 2:
                            message.Name = reader.string();
                            break;
                        case 3:
                            message.Hr = reader.bool();
                            break;
                        case 4:
                            message.Begin = reader.bool();
                            break;
                        case 5:
                            message.Position = reader.string();
                            break;
                        case 6:
                            message.Email = reader.string();
                            break;
                        case 7:
                            message.Phone = reader.string();
                            break;
                        case 8:
                            message.Sincerely = reader.string();
                            break;
                        case 9:
                            message.Fontsize = reader.int64();
                            break;
                        case 10:
                            message.Cellphone = reader.string();
                            break;
                        case 11:
                            message.Branch = reader.string();
                            break;
                        case 12:
                            message.Dept = reader.string();
                            break;
                        case 13:
                            message.Company = reader.string();
                            break;
                        case 14:
                            message.Flags = $root.priority.netitems.form.HtmlSignatureFlags.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a HtmlSignatureBase message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.HtmlSignatureBase} HtmlSignatureBase
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HtmlSignatureBase.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a HtmlSignatureBase message.
                 * @function verify
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HtmlSignatureBase.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Date != null && message.hasOwnProperty("Date"))
                        if (!$util.isString(message.Date))
                            return "Date: string expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Hr != null && message.hasOwnProperty("Hr"))
                        if (typeof message.Hr !== "boolean")
                            return "Hr: boolean expected";
                    if (message.Begin != null && message.hasOwnProperty("Begin"))
                        if (typeof message.Begin !== "boolean")
                            return "Begin: boolean expected";
                    if (message.Position != null && message.hasOwnProperty("Position"))
                        if (!$util.isString(message.Position))
                            return "Position: string expected";
                    if (message.Email != null && message.hasOwnProperty("Email"))
                        if (!$util.isString(message.Email))
                            return "Email: string expected";
                    if (message.Phone != null && message.hasOwnProperty("Phone"))
                        if (!$util.isString(message.Phone))
                            return "Phone: string expected";
                    if (message.Sincerely != null && message.hasOwnProperty("Sincerely"))
                        if (!$util.isString(message.Sincerely))
                            return "Sincerely: string expected";
                    if (message.Fontsize != null && message.hasOwnProperty("Fontsize"))
                        if (!$util.isInteger(message.Fontsize) && !(message.Fontsize && $util.isInteger(message.Fontsize.low) && $util.isInteger(message.Fontsize.high)))
                            return "Fontsize: integer|Long expected";
                    if (message.Cellphone != null && message.hasOwnProperty("Cellphone"))
                        if (!$util.isString(message.Cellphone))
                            return "Cellphone: string expected";
                    if (message.Branch != null && message.hasOwnProperty("Branch"))
                        if (!$util.isString(message.Branch))
                            return "Branch: string expected";
                    if (message.Dept != null && message.hasOwnProperty("Dept"))
                        if (!$util.isString(message.Dept))
                            return "Dept: string expected";
                    if (message.Company != null && message.hasOwnProperty("Company"))
                        if (!$util.isString(message.Company))
                            return "Company: string expected";
                    if (message.Flags != null && message.hasOwnProperty("Flags")) {
                        var error = $root.priority.netitems.form.HtmlSignatureFlags.verify(message.Flags);
                        if (error)
                            return "Flags." + error;
                    }
                    return null;
                };

                /**
                 * Creates a HtmlSignatureBase message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.HtmlSignatureBase} HtmlSignatureBase
                 */
                HtmlSignatureBase.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.HtmlSignatureBase)
                        return object;
                    var message = new $root.priority.netitems.form.HtmlSignatureBase();
                    if (object.Date != null)
                        message.Date = String(object.Date);
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Hr != null)
                        message.Hr = Boolean(object.Hr);
                    if (object.Begin != null)
                        message.Begin = Boolean(object.Begin);
                    if (object.Position != null)
                        message.Position = String(object.Position);
                    if (object.Email != null)
                        message.Email = String(object.Email);
                    if (object.Phone != null)
                        message.Phone = String(object.Phone);
                    if (object.Sincerely != null)
                        message.Sincerely = String(object.Sincerely);
                    if (object.Fontsize != null)
                        if ($util.Long)
                            (message.Fontsize = $util.Long.fromValue(object.Fontsize)).unsigned = false;
                        else if (typeof object.Fontsize === "string")
                            message.Fontsize = parseInt(object.Fontsize, 10);
                        else if (typeof object.Fontsize === "number")
                            message.Fontsize = object.Fontsize;
                        else if (typeof object.Fontsize === "object")
                            message.Fontsize = new $util.LongBits(object.Fontsize.low >>> 0, object.Fontsize.high >>> 0).toNumber();
                    if (object.Cellphone != null)
                        message.Cellphone = String(object.Cellphone);
                    if (object.Branch != null)
                        message.Branch = String(object.Branch);
                    if (object.Dept != null)
                        message.Dept = String(object.Dept);
                    if (object.Company != null)
                        message.Company = String(object.Company);
                    if (object.Flags != null) {
                        if (typeof object.Flags !== "object")
                            throw TypeError(".priority.netitems.form.HtmlSignatureBase.Flags: object expected");
                        message.Flags = $root.priority.netitems.form.HtmlSignatureFlags.fromObject(object.Flags);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a HtmlSignatureBase message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @static
                 * @param {priority.netitems.form.HtmlSignatureBase} message HtmlSignatureBase
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HtmlSignatureBase.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Date = "";
                        object.Name = "";
                        object.Hr = false;
                        object.Begin = false;
                        object.Position = "";
                        object.Email = "";
                        object.Phone = "";
                        object.Sincerely = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Fontsize = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Fontsize = options.longs === String ? "0" : 0;
                        object.Cellphone = "";
                        object.Branch = "";
                        object.Dept = "";
                        object.Company = "";
                        object.Flags = null;
                    }
                    if (message.Date != null && message.hasOwnProperty("Date"))
                        object.Date = message.Date;
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Hr != null && message.hasOwnProperty("Hr"))
                        object.Hr = message.Hr;
                    if (message.Begin != null && message.hasOwnProperty("Begin"))
                        object.Begin = message.Begin;
                    if (message.Position != null && message.hasOwnProperty("Position"))
                        object.Position = message.Position;
                    if (message.Email != null && message.hasOwnProperty("Email"))
                        object.Email = message.Email;
                    if (message.Phone != null && message.hasOwnProperty("Phone"))
                        object.Phone = message.Phone;
                    if (message.Sincerely != null && message.hasOwnProperty("Sincerely"))
                        object.Sincerely = message.Sincerely;
                    if (message.Fontsize != null && message.hasOwnProperty("Fontsize"))
                        if (typeof message.Fontsize === "number")
                            object.Fontsize = options.longs === String ? String(message.Fontsize) : message.Fontsize;
                        else
                            object.Fontsize = options.longs === String ? $util.Long.prototype.toString.call(message.Fontsize) : options.longs === Number ? new $util.LongBits(message.Fontsize.low >>> 0, message.Fontsize.high >>> 0).toNumber() : message.Fontsize;
                    if (message.Cellphone != null && message.hasOwnProperty("Cellphone"))
                        object.Cellphone = message.Cellphone;
                    if (message.Branch != null && message.hasOwnProperty("Branch"))
                        object.Branch = message.Branch;
                    if (message.Dept != null && message.hasOwnProperty("Dept"))
                        object.Dept = message.Dept;
                    if (message.Company != null && message.hasOwnProperty("Company"))
                        object.Company = message.Company;
                    if (message.Flags != null && message.hasOwnProperty("Flags"))
                        object.Flags = $root.priority.netitems.form.HtmlSignatureFlags.toObject(message.Flags, options);
                    return object;
                };

                /**
                 * Converts this HtmlSignatureBase to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.HtmlSignatureBase
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HtmlSignatureBase.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return HtmlSignatureBase;
            })();

            /**
             * AttachmentOptions enum.
             * @name priority.netitems.form.AttachmentOptions
             * @enum {number}
             * @property {number} Attach_NoData=0 Attach_NoData value
             * @property {number} Attach_Data=1 Attach_Data value
             */
            form.AttachmentOptions = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "Attach_NoData"] = 0;
                values[valuesById[1] = "Attach_Data"] = 1;
                return values;
            })();

            /**
             * ThumbnailType enum.
             * @name priority.netitems.form.ThumbnailType
             * @enum {number}
             * @property {number} No_Thumbnail=0 No_Thumbnail value
             * @property {number} Small_Thumbnail=1 Small_Thumbnail value
             * @property {number} Medium_Thumbnail=2 Medium_Thumbnail value
             */
            form.ThumbnailType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "No_Thumbnail"] = 0;
                values[valuesById[1] = "Small_Thumbnail"] = 1;
                values[valuesById[2] = "Medium_Thumbnail"] = 2;
                return values;
            })();

            form.ImageOptions = (function() {

                /**
                 * Properties of an ImageOptions.
                 * @memberof priority.netitems.form
                 * @interface IImageOptions
                 * @property {priority.netitems.form.ThumbnailType|null} [Thumbnail] ImageOptions Thumbnail
                 */

                /**
                 * Constructs a new ImageOptions.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an ImageOptions.
                 * @implements IImageOptions
                 * @constructor
                 * @param {priority.netitems.form.IImageOptions=} [properties] Properties to set
                 */
                function ImageOptions(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ImageOptions Thumbnail.
                 * @member {priority.netitems.form.ThumbnailType} Thumbnail
                 * @memberof priority.netitems.form.ImageOptions
                 * @instance
                 */
                ImageOptions.prototype.Thumbnail = 0;

                /**
                 * Creates a new ImageOptions instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.ImageOptions
                 * @static
                 * @param {priority.netitems.form.IImageOptions=} [properties] Properties to set
                 * @returns {priority.netitems.form.ImageOptions} ImageOptions instance
                 */
                ImageOptions.create = function create(properties) {
                    return new ImageOptions(properties);
                };

                /**
                 * Encodes the specified ImageOptions message. Does not implicitly {@link priority.netitems.form.ImageOptions.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.ImageOptions
                 * @static
                 * @param {priority.netitems.form.IImageOptions} message ImageOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ImageOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Thumbnail != null && Object.hasOwnProperty.call(message, "Thumbnail"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Thumbnail);
                    return writer;
                };

                /**
                 * Encodes the specified ImageOptions message, length delimited. Does not implicitly {@link priority.netitems.form.ImageOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.ImageOptions
                 * @static
                 * @param {priority.netitems.form.IImageOptions} message ImageOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ImageOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ImageOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.ImageOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.ImageOptions} ImageOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ImageOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.ImageOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Thumbnail = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ImageOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.ImageOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.ImageOptions} ImageOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ImageOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ImageOptions message.
                 * @function verify
                 * @memberof priority.netitems.form.ImageOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ImageOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Thumbnail != null && message.hasOwnProperty("Thumbnail"))
                        switch (message.Thumbnail) {
                        default:
                            return "Thumbnail: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates an ImageOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.ImageOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.ImageOptions} ImageOptions
                 */
                ImageOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.ImageOptions)
                        return object;
                    var message = new $root.priority.netitems.form.ImageOptions();
                    switch (object.Thumbnail) {
                    case "No_Thumbnail":
                    case 0:
                        message.Thumbnail = 0;
                        break;
                    case "Small_Thumbnail":
                    case 1:
                        message.Thumbnail = 1;
                        break;
                    case "Medium_Thumbnail":
                    case 2:
                        message.Thumbnail = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ImageOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.ImageOptions
                 * @static
                 * @param {priority.netitems.form.ImageOptions} message ImageOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ImageOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Thumbnail = options.enums === String ? "No_Thumbnail" : 0;
                    if (message.Thumbnail != null && message.hasOwnProperty("Thumbnail"))
                        object.Thumbnail = options.enums === String ? $root.priority.netitems.form.ThumbnailType[message.Thumbnail] : message.Thumbnail;
                    return object;
                };

                /**
                 * Converts this ImageOptions to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.ImageOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ImageOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ImageOptions;
            })();

            form.SelectValues = (function() {

                /**
                 * Properties of a SelectValues.
                 * @memberof priority.netitems.form
                 * @interface ISelectValues
                 * @property {string|null} [Value] SelectValues Value
                 * @property {string|null} [Description] SelectValues Description
                 * @property {string|null} [Description2] SelectValues Description2
                 */

                /**
                 * Constructs a new SelectValues.
                 * @memberof priority.netitems.form
                 * @classdesc Represents a SelectValues.
                 * @implements ISelectValues
                 * @constructor
                 * @param {priority.netitems.form.ISelectValues=} [properties] Properties to set
                 */
                function SelectValues(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SelectValues Value.
                 * @member {string} Value
                 * @memberof priority.netitems.form.SelectValues
                 * @instance
                 */
                SelectValues.prototype.Value = "";

                /**
                 * SelectValues Description.
                 * @member {string} Description
                 * @memberof priority.netitems.form.SelectValues
                 * @instance
                 */
                SelectValues.prototype.Description = "";

                /**
                 * SelectValues Description2.
                 * @member {string} Description2
                 * @memberof priority.netitems.form.SelectValues
                 * @instance
                 */
                SelectValues.prototype.Description2 = "";

                /**
                 * Creates a new SelectValues instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.SelectValues
                 * @static
                 * @param {priority.netitems.form.ISelectValues=} [properties] Properties to set
                 * @returns {priority.netitems.form.SelectValues} SelectValues instance
                 */
                SelectValues.create = function create(properties) {
                    return new SelectValues(properties);
                };

                /**
                 * Encodes the specified SelectValues message. Does not implicitly {@link priority.netitems.form.SelectValues.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.SelectValues
                 * @static
                 * @param {priority.netitems.form.ISelectValues} message SelectValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SelectValues.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Value);
                    if (message.Description != null && Object.hasOwnProperty.call(message, "Description"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Description);
                    if (message.Description2 != null && Object.hasOwnProperty.call(message, "Description2"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Description2);
                    return writer;
                };

                /**
                 * Encodes the specified SelectValues message, length delimited. Does not implicitly {@link priority.netitems.form.SelectValues.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.SelectValues
                 * @static
                 * @param {priority.netitems.form.ISelectValues} message SelectValues message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SelectValues.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SelectValues message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.SelectValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.SelectValues} SelectValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SelectValues.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.SelectValues();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Value = reader.string();
                            break;
                        case 2:
                            message.Description = reader.string();
                            break;
                        case 3:
                            message.Description2 = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SelectValues message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.SelectValues
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.SelectValues} SelectValues
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SelectValues.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SelectValues message.
                 * @function verify
                 * @memberof priority.netitems.form.SelectValues
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SelectValues.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        if (!$util.isString(message.Value))
                            return "Value: string expected";
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        if (!$util.isString(message.Description))
                            return "Description: string expected";
                    if (message.Description2 != null && message.hasOwnProperty("Description2"))
                        if (!$util.isString(message.Description2))
                            return "Description2: string expected";
                    return null;
                };

                /**
                 * Creates a SelectValues message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.SelectValues
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.SelectValues} SelectValues
                 */
                SelectValues.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.SelectValues)
                        return object;
                    var message = new $root.priority.netitems.form.SelectValues();
                    if (object.Value != null)
                        message.Value = String(object.Value);
                    if (object.Description != null)
                        message.Description = String(object.Description);
                    if (object.Description2 != null)
                        message.Description2 = String(object.Description2);
                    return message;
                };

                /**
                 * Creates a plain object from a SelectValues message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.SelectValues
                 * @static
                 * @param {priority.netitems.form.SelectValues} message SelectValues
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SelectValues.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Value = "";
                        object.Description = "";
                        object.Description2 = "";
                    }
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        object.Value = message.Value;
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        object.Description = message.Description;
                    if (message.Description2 != null && message.hasOwnProperty("Description2"))
                        object.Description2 = message.Description2;
                    return object;
                };

                /**
                 * Converts this SelectValues to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.SelectValues
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SelectValues.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SelectValues;
            })();

            /**
             * RuleType enum.
             * @name priority.netitems.form.RuleType
             * @enum {number}
             * @property {number} UNKNOWN_RULETYPE=0 UNKNOWN_RULETYPE value
             * @property {number} Business=1 Business value
             * @property {number} AutoFill=2 AutoFill value
             */
            form.RuleType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN_RULETYPE"] = 0;
                values[valuesById[1] = "Business"] = 1;
                values[valuesById[2] = "AutoFill"] = 2;
                return values;
            })();

            form.Alert = (function() {

                /**
                 * Properties of an Alert.
                 * @memberof priority.netitems.form
                 * @interface IAlert
                 * @property {number|Long|null} [AlertNumber] Alert AlertNumber
                 * @property {Array.<priority.netitems.form.IAlertMessage>|null} [Messages] Alert Messages
                 * @property {number|Long|null} [Document] Alert Document
                 * @property {number|Long|null} [DocumentFormat] Alert DocumentFormat
                 * @property {number|Long|null} [DocumentFormatLang] Alert DocumentFormatLang
                 * @property {string|null} [Description] Alert Description
                 * @property {number|Long|null} [MessageType] Alert MessageType
                 * @property {number|Long|null} [MailType] Alert MailType
                 * @property {boolean|null} [Active] Alert Active
                 * @property {number|Long|null} [WebHook] Alert WebHook
                 * @property {Array.<number|Long>|null} [RecipientUser] Alert RecipientUser
                 * @property {Array.<number|Long>|null} [RecipientGroup] Alert RecipientGroup
                 * @property {number|Long|null} [RecipientField] Alert RecipientField
                 * @property {Array.<string>|null} [RecipientMail] Alert RecipientMail
                 * @property {priority.netitems.form.IAlertBPM|null} [BPM] Alert BPM
                 * @property {priority.netitems.form.IAlertForm|null} [Form] Alert Form
                 * @property {Array.<priority.netitems.form.IAlertCondition>|null} [AlertConds] Alert AlertConds
                 * @property {boolean|null} [Pdf] Alert Pdf
                 * @property {boolean|null} [ExtFile] Alert ExtFile
                 * @property {boolean|null} [WordTemplates] Alert WordTemplates
                 * @property {boolean|null} [ConditionsOperator] Alert ConditionsOperator
                 * @property {string|null} [LastMobifyBy] Alert LastMobifyBy
                 * @property {Array.<priority.netitems.form.IAlertMessage>|null} [CoverLetters] Alert CoverLetters
                 */

                /**
                 * Constructs a new Alert.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an Alert.
                 * @implements IAlert
                 * @constructor
                 * @param {priority.netitems.form.IAlert=} [properties] Properties to set
                 */
                function Alert(properties) {
                    this.Messages = [];
                    this.RecipientUser = [];
                    this.RecipientGroup = [];
                    this.RecipientMail = [];
                    this.AlertConds = [];
                    this.CoverLetters = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Alert AlertNumber.
                 * @member {number|Long} AlertNumber
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.AlertNumber = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Alert Messages.
                 * @member {Array.<priority.netitems.form.IAlertMessage>} Messages
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.Messages = $util.emptyArray;

                /**
                 * Alert Document.
                 * @member {number|Long} Document
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.Document = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Alert DocumentFormat.
                 * @member {number|Long} DocumentFormat
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.DocumentFormat = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Alert DocumentFormatLang.
                 * @member {number|Long} DocumentFormatLang
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.DocumentFormatLang = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Alert Description.
                 * @member {string} Description
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.Description = "";

                /**
                 * Alert MessageType.
                 * @member {number|Long} MessageType
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.MessageType = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Alert MailType.
                 * @member {number|Long} MailType
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.MailType = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Alert Active.
                 * @member {boolean} Active
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.Active = false;

                /**
                 * Alert WebHook.
                 * @member {number|Long} WebHook
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.WebHook = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Alert RecipientUser.
                 * @member {Array.<number|Long>} RecipientUser
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.RecipientUser = $util.emptyArray;

                /**
                 * Alert RecipientGroup.
                 * @member {Array.<number|Long>} RecipientGroup
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.RecipientGroup = $util.emptyArray;

                /**
                 * Alert RecipientField.
                 * @member {number|Long} RecipientField
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.RecipientField = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Alert RecipientMail.
                 * @member {Array.<string>} RecipientMail
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.RecipientMail = $util.emptyArray;

                /**
                 * Alert BPM.
                 * @member {priority.netitems.form.IAlertBPM|null|undefined} BPM
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.BPM = null;

                /**
                 * Alert Form.
                 * @member {priority.netitems.form.IAlertForm|null|undefined} Form
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.Form = null;

                /**
                 * Alert AlertConds.
                 * @member {Array.<priority.netitems.form.IAlertCondition>} AlertConds
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.AlertConds = $util.emptyArray;

                /**
                 * Alert Pdf.
                 * @member {boolean} Pdf
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.Pdf = false;

                /**
                 * Alert ExtFile.
                 * @member {boolean} ExtFile
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.ExtFile = false;

                /**
                 * Alert WordTemplates.
                 * @member {boolean} WordTemplates
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.WordTemplates = false;

                /**
                 * Alert ConditionsOperator.
                 * @member {boolean} ConditionsOperator
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.ConditionsOperator = false;

                /**
                 * Alert LastMobifyBy.
                 * @member {string} LastMobifyBy
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.LastMobifyBy = "";

                /**
                 * Alert CoverLetters.
                 * @member {Array.<priority.netitems.form.IAlertMessage>} CoverLetters
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Alert.prototype.CoverLetters = $util.emptyArray;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Alert AlertType.
                 * @member {"BPM"|"Form"|undefined} AlertType
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 */
                Object.defineProperty(Alert.prototype, "AlertType", {
                    get: $util.oneOfGetter($oneOfFields = ["BPM", "Form"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Alert instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.Alert
                 * @static
                 * @param {priority.netitems.form.IAlert=} [properties] Properties to set
                 * @returns {priority.netitems.form.Alert} Alert instance
                 */
                Alert.create = function create(properties) {
                    return new Alert(properties);
                };

                /**
                 * Encodes the specified Alert message. Does not implicitly {@link priority.netitems.form.Alert.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.Alert
                 * @static
                 * @param {priority.netitems.form.IAlert} message Alert message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Alert.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.AlertNumber != null && Object.hasOwnProperty.call(message, "AlertNumber"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.AlertNumber);
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.form.AlertMessage.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Document != null && Object.hasOwnProperty.call(message, "Document"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.Document);
                    if (message.DocumentFormat != null && Object.hasOwnProperty.call(message, "DocumentFormat"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.DocumentFormat);
                    if (message.DocumentFormatLang != null && Object.hasOwnProperty.call(message, "DocumentFormatLang"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.DocumentFormatLang);
                    if (message.Description != null && Object.hasOwnProperty.call(message, "Description"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.Description);
                    if (message.MessageType != null && Object.hasOwnProperty.call(message, "MessageType"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.MessageType);
                    if (message.MailType != null && Object.hasOwnProperty.call(message, "MailType"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int64(message.MailType);
                    if (message.Active != null && Object.hasOwnProperty.call(message, "Active"))
                        writer.uint32(/* id 11, wireType 0 =*/88).bool(message.Active);
                    if (message.WebHook != null && Object.hasOwnProperty.call(message, "WebHook"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int64(message.WebHook);
                    if (message.RecipientUser != null && message.RecipientUser.length) {
                        writer.uint32(/* id 13, wireType 2 =*/106).fork();
                        for (var i = 0; i < message.RecipientUser.length; ++i)
                            writer.int64(message.RecipientUser[i]);
                        writer.ldelim();
                    }
                    if (message.RecipientGroup != null && message.RecipientGroup.length) {
                        writer.uint32(/* id 14, wireType 2 =*/114).fork();
                        for (var i = 0; i < message.RecipientGroup.length; ++i)
                            writer.int64(message.RecipientGroup[i]);
                        writer.ldelim();
                    }
                    if (message.RecipientField != null && Object.hasOwnProperty.call(message, "RecipientField"))
                        writer.uint32(/* id 15, wireType 0 =*/120).int64(message.RecipientField);
                    if (message.RecipientMail != null && message.RecipientMail.length)
                        for (var i = 0; i < message.RecipientMail.length; ++i)
                            writer.uint32(/* id 16, wireType 2 =*/130).string(message.RecipientMail[i]);
                    if (message.BPM != null && Object.hasOwnProperty.call(message, "BPM"))
                        $root.priority.netitems.form.AlertBPM.encode(message.BPM, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.Form != null && Object.hasOwnProperty.call(message, "Form"))
                        $root.priority.netitems.form.AlertForm.encode(message.Form, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.AlertConds != null && message.AlertConds.length)
                        for (var i = 0; i < message.AlertConds.length; ++i)
                            $root.priority.netitems.form.AlertCondition.encode(message.AlertConds[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    if (message.Pdf != null && Object.hasOwnProperty.call(message, "Pdf"))
                        writer.uint32(/* id 20, wireType 0 =*/160).bool(message.Pdf);
                    if (message.ExtFile != null && Object.hasOwnProperty.call(message, "ExtFile"))
                        writer.uint32(/* id 21, wireType 0 =*/168).bool(message.ExtFile);
                    if (message.WordTemplates != null && Object.hasOwnProperty.call(message, "WordTemplates"))
                        writer.uint32(/* id 22, wireType 0 =*/176).bool(message.WordTemplates);
                    if (message.ConditionsOperator != null && Object.hasOwnProperty.call(message, "ConditionsOperator"))
                        writer.uint32(/* id 23, wireType 0 =*/184).bool(message.ConditionsOperator);
                    if (message.LastMobifyBy != null && Object.hasOwnProperty.call(message, "LastMobifyBy"))
                        writer.uint32(/* id 24, wireType 2 =*/194).string(message.LastMobifyBy);
                    if (message.CoverLetters != null && message.CoverLetters.length)
                        for (var i = 0; i < message.CoverLetters.length; ++i)
                            $root.priority.netitems.form.AlertMessage.encode(message.CoverLetters[i], writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Alert message, length delimited. Does not implicitly {@link priority.netitems.form.Alert.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.Alert
                 * @static
                 * @param {priority.netitems.form.IAlert} message Alert message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Alert.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Alert message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.Alert
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.Alert} Alert
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Alert.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.Alert();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.AlertNumber = reader.int64();
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.form.AlertMessage.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Document = reader.int64();
                            break;
                        case 4:
                            message.DocumentFormat = reader.int64();
                            break;
                        case 5:
                            message.DocumentFormatLang = reader.int64();
                            break;
                        case 6:
                            message.Description = reader.string();
                            break;
                        case 9:
                            message.MessageType = reader.int64();
                            break;
                        case 10:
                            message.MailType = reader.int64();
                            break;
                        case 11:
                            message.Active = reader.bool();
                            break;
                        case 12:
                            message.WebHook = reader.int64();
                            break;
                        case 13:
                            if (!(message.RecipientUser && message.RecipientUser.length))
                                message.RecipientUser = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.RecipientUser.push(reader.int64());
                            } else
                                message.RecipientUser.push(reader.int64());
                            break;
                        case 14:
                            if (!(message.RecipientGroup && message.RecipientGroup.length))
                                message.RecipientGroup = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.RecipientGroup.push(reader.int64());
                            } else
                                message.RecipientGroup.push(reader.int64());
                            break;
                        case 15:
                            message.RecipientField = reader.int64();
                            break;
                        case 16:
                            if (!(message.RecipientMail && message.RecipientMail.length))
                                message.RecipientMail = [];
                            message.RecipientMail.push(reader.string());
                            break;
                        case 17:
                            message.BPM = $root.priority.netitems.form.AlertBPM.decode(reader, reader.uint32());
                            break;
                        case 18:
                            message.Form = $root.priority.netitems.form.AlertForm.decode(reader, reader.uint32());
                            break;
                        case 19:
                            if (!(message.AlertConds && message.AlertConds.length))
                                message.AlertConds = [];
                            message.AlertConds.push($root.priority.netitems.form.AlertCondition.decode(reader, reader.uint32()));
                            break;
                        case 20:
                            message.Pdf = reader.bool();
                            break;
                        case 21:
                            message.ExtFile = reader.bool();
                            break;
                        case 22:
                            message.WordTemplates = reader.bool();
                            break;
                        case 23:
                            message.ConditionsOperator = reader.bool();
                            break;
                        case 24:
                            message.LastMobifyBy = reader.string();
                            break;
                        case 25:
                            if (!(message.CoverLetters && message.CoverLetters.length))
                                message.CoverLetters = [];
                            message.CoverLetters.push($root.priority.netitems.form.AlertMessage.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Alert message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.Alert
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.Alert} Alert
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Alert.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Alert message.
                 * @function verify
                 * @memberof priority.netitems.form.Alert
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Alert.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.AlertNumber != null && message.hasOwnProperty("AlertNumber"))
                        if (!$util.isInteger(message.AlertNumber) && !(message.AlertNumber && $util.isInteger(message.AlertNumber.low) && $util.isInteger(message.AlertNumber.high)))
                            return "AlertNumber: integer|Long expected";
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.form.AlertMessage.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Document != null && message.hasOwnProperty("Document"))
                        if (!$util.isInteger(message.Document) && !(message.Document && $util.isInteger(message.Document.low) && $util.isInteger(message.Document.high)))
                            return "Document: integer|Long expected";
                    if (message.DocumentFormat != null && message.hasOwnProperty("DocumentFormat"))
                        if (!$util.isInteger(message.DocumentFormat) && !(message.DocumentFormat && $util.isInteger(message.DocumentFormat.low) && $util.isInteger(message.DocumentFormat.high)))
                            return "DocumentFormat: integer|Long expected";
                    if (message.DocumentFormatLang != null && message.hasOwnProperty("DocumentFormatLang"))
                        if (!$util.isInteger(message.DocumentFormatLang) && !(message.DocumentFormatLang && $util.isInteger(message.DocumentFormatLang.low) && $util.isInteger(message.DocumentFormatLang.high)))
                            return "DocumentFormatLang: integer|Long expected";
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        if (!$util.isString(message.Description))
                            return "Description: string expected";
                    if (message.MessageType != null && message.hasOwnProperty("MessageType"))
                        if (!$util.isInteger(message.MessageType) && !(message.MessageType && $util.isInteger(message.MessageType.low) && $util.isInteger(message.MessageType.high)))
                            return "MessageType: integer|Long expected";
                    if (message.MailType != null && message.hasOwnProperty("MailType"))
                        if (!$util.isInteger(message.MailType) && !(message.MailType && $util.isInteger(message.MailType.low) && $util.isInteger(message.MailType.high)))
                            return "MailType: integer|Long expected";
                    if (message.Active != null && message.hasOwnProperty("Active"))
                        if (typeof message.Active !== "boolean")
                            return "Active: boolean expected";
                    if (message.WebHook != null && message.hasOwnProperty("WebHook"))
                        if (!$util.isInteger(message.WebHook) && !(message.WebHook && $util.isInteger(message.WebHook.low) && $util.isInteger(message.WebHook.high)))
                            return "WebHook: integer|Long expected";
                    if (message.RecipientUser != null && message.hasOwnProperty("RecipientUser")) {
                        if (!Array.isArray(message.RecipientUser))
                            return "RecipientUser: array expected";
                        for (var i = 0; i < message.RecipientUser.length; ++i)
                            if (!$util.isInteger(message.RecipientUser[i]) && !(message.RecipientUser[i] && $util.isInteger(message.RecipientUser[i].low) && $util.isInteger(message.RecipientUser[i].high)))
                                return "RecipientUser: integer|Long[] expected";
                    }
                    if (message.RecipientGroup != null && message.hasOwnProperty("RecipientGroup")) {
                        if (!Array.isArray(message.RecipientGroup))
                            return "RecipientGroup: array expected";
                        for (var i = 0; i < message.RecipientGroup.length; ++i)
                            if (!$util.isInteger(message.RecipientGroup[i]) && !(message.RecipientGroup[i] && $util.isInteger(message.RecipientGroup[i].low) && $util.isInteger(message.RecipientGroup[i].high)))
                                return "RecipientGroup: integer|Long[] expected";
                    }
                    if (message.RecipientField != null && message.hasOwnProperty("RecipientField"))
                        if (!$util.isInteger(message.RecipientField) && !(message.RecipientField && $util.isInteger(message.RecipientField.low) && $util.isInteger(message.RecipientField.high)))
                            return "RecipientField: integer|Long expected";
                    if (message.RecipientMail != null && message.hasOwnProperty("RecipientMail")) {
                        if (!Array.isArray(message.RecipientMail))
                            return "RecipientMail: array expected";
                        for (var i = 0; i < message.RecipientMail.length; ++i)
                            if (!$util.isString(message.RecipientMail[i]))
                                return "RecipientMail: string[] expected";
                    }
                    if (message.BPM != null && message.hasOwnProperty("BPM")) {
                        properties.AlertType = 1;
                        {
                            var error = $root.priority.netitems.form.AlertBPM.verify(message.BPM);
                            if (error)
                                return "BPM." + error;
                        }
                    }
                    if (message.Form != null && message.hasOwnProperty("Form")) {
                        if (properties.AlertType === 1)
                            return "AlertType: multiple values";
                        properties.AlertType = 1;
                        {
                            var error = $root.priority.netitems.form.AlertForm.verify(message.Form);
                            if (error)
                                return "Form." + error;
                        }
                    }
                    if (message.AlertConds != null && message.hasOwnProperty("AlertConds")) {
                        if (!Array.isArray(message.AlertConds))
                            return "AlertConds: array expected";
                        for (var i = 0; i < message.AlertConds.length; ++i) {
                            var error = $root.priority.netitems.form.AlertCondition.verify(message.AlertConds[i]);
                            if (error)
                                return "AlertConds." + error;
                        }
                    }
                    if (message.Pdf != null && message.hasOwnProperty("Pdf"))
                        if (typeof message.Pdf !== "boolean")
                            return "Pdf: boolean expected";
                    if (message.ExtFile != null && message.hasOwnProperty("ExtFile"))
                        if (typeof message.ExtFile !== "boolean")
                            return "ExtFile: boolean expected";
                    if (message.WordTemplates != null && message.hasOwnProperty("WordTemplates"))
                        if (typeof message.WordTemplates !== "boolean")
                            return "WordTemplates: boolean expected";
                    if (message.ConditionsOperator != null && message.hasOwnProperty("ConditionsOperator"))
                        if (typeof message.ConditionsOperator !== "boolean")
                            return "ConditionsOperator: boolean expected";
                    if (message.LastMobifyBy != null && message.hasOwnProperty("LastMobifyBy"))
                        if (!$util.isString(message.LastMobifyBy))
                            return "LastMobifyBy: string expected";
                    if (message.CoverLetters != null && message.hasOwnProperty("CoverLetters")) {
                        if (!Array.isArray(message.CoverLetters))
                            return "CoverLetters: array expected";
                        for (var i = 0; i < message.CoverLetters.length; ++i) {
                            var error = $root.priority.netitems.form.AlertMessage.verify(message.CoverLetters[i]);
                            if (error)
                                return "CoverLetters." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an Alert message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.Alert
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.Alert} Alert
                 */
                Alert.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.Alert)
                        return object;
                    var message = new $root.priority.netitems.form.Alert();
                    if (object.AlertNumber != null)
                        if ($util.Long)
                            (message.AlertNumber = $util.Long.fromValue(object.AlertNumber)).unsigned = false;
                        else if (typeof object.AlertNumber === "string")
                            message.AlertNumber = parseInt(object.AlertNumber, 10);
                        else if (typeof object.AlertNumber === "number")
                            message.AlertNumber = object.AlertNumber;
                        else if (typeof object.AlertNumber === "object")
                            message.AlertNumber = new $util.LongBits(object.AlertNumber.low >>> 0, object.AlertNumber.high >>> 0).toNumber();
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.form.Alert.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.form.Alert.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.form.AlertMessage.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Document != null)
                        if ($util.Long)
                            (message.Document = $util.Long.fromValue(object.Document)).unsigned = false;
                        else if (typeof object.Document === "string")
                            message.Document = parseInt(object.Document, 10);
                        else if (typeof object.Document === "number")
                            message.Document = object.Document;
                        else if (typeof object.Document === "object")
                            message.Document = new $util.LongBits(object.Document.low >>> 0, object.Document.high >>> 0).toNumber();
                    if (object.DocumentFormat != null)
                        if ($util.Long)
                            (message.DocumentFormat = $util.Long.fromValue(object.DocumentFormat)).unsigned = false;
                        else if (typeof object.DocumentFormat === "string")
                            message.DocumentFormat = parseInt(object.DocumentFormat, 10);
                        else if (typeof object.DocumentFormat === "number")
                            message.DocumentFormat = object.DocumentFormat;
                        else if (typeof object.DocumentFormat === "object")
                            message.DocumentFormat = new $util.LongBits(object.DocumentFormat.low >>> 0, object.DocumentFormat.high >>> 0).toNumber();
                    if (object.DocumentFormatLang != null)
                        if ($util.Long)
                            (message.DocumentFormatLang = $util.Long.fromValue(object.DocumentFormatLang)).unsigned = false;
                        else if (typeof object.DocumentFormatLang === "string")
                            message.DocumentFormatLang = parseInt(object.DocumentFormatLang, 10);
                        else if (typeof object.DocumentFormatLang === "number")
                            message.DocumentFormatLang = object.DocumentFormatLang;
                        else if (typeof object.DocumentFormatLang === "object")
                            message.DocumentFormatLang = new $util.LongBits(object.DocumentFormatLang.low >>> 0, object.DocumentFormatLang.high >>> 0).toNumber();
                    if (object.Description != null)
                        message.Description = String(object.Description);
                    if (object.MessageType != null)
                        if ($util.Long)
                            (message.MessageType = $util.Long.fromValue(object.MessageType)).unsigned = false;
                        else if (typeof object.MessageType === "string")
                            message.MessageType = parseInt(object.MessageType, 10);
                        else if (typeof object.MessageType === "number")
                            message.MessageType = object.MessageType;
                        else if (typeof object.MessageType === "object")
                            message.MessageType = new $util.LongBits(object.MessageType.low >>> 0, object.MessageType.high >>> 0).toNumber();
                    if (object.MailType != null)
                        if ($util.Long)
                            (message.MailType = $util.Long.fromValue(object.MailType)).unsigned = false;
                        else if (typeof object.MailType === "string")
                            message.MailType = parseInt(object.MailType, 10);
                        else if (typeof object.MailType === "number")
                            message.MailType = object.MailType;
                        else if (typeof object.MailType === "object")
                            message.MailType = new $util.LongBits(object.MailType.low >>> 0, object.MailType.high >>> 0).toNumber();
                    if (object.Active != null)
                        message.Active = Boolean(object.Active);
                    if (object.WebHook != null)
                        if ($util.Long)
                            (message.WebHook = $util.Long.fromValue(object.WebHook)).unsigned = false;
                        else if (typeof object.WebHook === "string")
                            message.WebHook = parseInt(object.WebHook, 10);
                        else if (typeof object.WebHook === "number")
                            message.WebHook = object.WebHook;
                        else if (typeof object.WebHook === "object")
                            message.WebHook = new $util.LongBits(object.WebHook.low >>> 0, object.WebHook.high >>> 0).toNumber();
                    if (object.RecipientUser) {
                        if (!Array.isArray(object.RecipientUser))
                            throw TypeError(".priority.netitems.form.Alert.RecipientUser: array expected");
                        message.RecipientUser = [];
                        for (var i = 0; i < object.RecipientUser.length; ++i)
                            if ($util.Long)
                                (message.RecipientUser[i] = $util.Long.fromValue(object.RecipientUser[i])).unsigned = false;
                            else if (typeof object.RecipientUser[i] === "string")
                                message.RecipientUser[i] = parseInt(object.RecipientUser[i], 10);
                            else if (typeof object.RecipientUser[i] === "number")
                                message.RecipientUser[i] = object.RecipientUser[i];
                            else if (typeof object.RecipientUser[i] === "object")
                                message.RecipientUser[i] = new $util.LongBits(object.RecipientUser[i].low >>> 0, object.RecipientUser[i].high >>> 0).toNumber();
                    }
                    if (object.RecipientGroup) {
                        if (!Array.isArray(object.RecipientGroup))
                            throw TypeError(".priority.netitems.form.Alert.RecipientGroup: array expected");
                        message.RecipientGroup = [];
                        for (var i = 0; i < object.RecipientGroup.length; ++i)
                            if ($util.Long)
                                (message.RecipientGroup[i] = $util.Long.fromValue(object.RecipientGroup[i])).unsigned = false;
                            else if (typeof object.RecipientGroup[i] === "string")
                                message.RecipientGroup[i] = parseInt(object.RecipientGroup[i], 10);
                            else if (typeof object.RecipientGroup[i] === "number")
                                message.RecipientGroup[i] = object.RecipientGroup[i];
                            else if (typeof object.RecipientGroup[i] === "object")
                                message.RecipientGroup[i] = new $util.LongBits(object.RecipientGroup[i].low >>> 0, object.RecipientGroup[i].high >>> 0).toNumber();
                    }
                    if (object.RecipientField != null)
                        if ($util.Long)
                            (message.RecipientField = $util.Long.fromValue(object.RecipientField)).unsigned = false;
                        else if (typeof object.RecipientField === "string")
                            message.RecipientField = parseInt(object.RecipientField, 10);
                        else if (typeof object.RecipientField === "number")
                            message.RecipientField = object.RecipientField;
                        else if (typeof object.RecipientField === "object")
                            message.RecipientField = new $util.LongBits(object.RecipientField.low >>> 0, object.RecipientField.high >>> 0).toNumber();
                    if (object.RecipientMail) {
                        if (!Array.isArray(object.RecipientMail))
                            throw TypeError(".priority.netitems.form.Alert.RecipientMail: array expected");
                        message.RecipientMail = [];
                        for (var i = 0; i < object.RecipientMail.length; ++i)
                            message.RecipientMail[i] = String(object.RecipientMail[i]);
                    }
                    if (object.BPM != null) {
                        if (typeof object.BPM !== "object")
                            throw TypeError(".priority.netitems.form.Alert.BPM: object expected");
                        message.BPM = $root.priority.netitems.form.AlertBPM.fromObject(object.BPM);
                    }
                    if (object.Form != null) {
                        if (typeof object.Form !== "object")
                            throw TypeError(".priority.netitems.form.Alert.Form: object expected");
                        message.Form = $root.priority.netitems.form.AlertForm.fromObject(object.Form);
                    }
                    if (object.AlertConds) {
                        if (!Array.isArray(object.AlertConds))
                            throw TypeError(".priority.netitems.form.Alert.AlertConds: array expected");
                        message.AlertConds = [];
                        for (var i = 0; i < object.AlertConds.length; ++i) {
                            if (typeof object.AlertConds[i] !== "object")
                                throw TypeError(".priority.netitems.form.Alert.AlertConds: object expected");
                            message.AlertConds[i] = $root.priority.netitems.form.AlertCondition.fromObject(object.AlertConds[i]);
                        }
                    }
                    if (object.Pdf != null)
                        message.Pdf = Boolean(object.Pdf);
                    if (object.ExtFile != null)
                        message.ExtFile = Boolean(object.ExtFile);
                    if (object.WordTemplates != null)
                        message.WordTemplates = Boolean(object.WordTemplates);
                    if (object.ConditionsOperator != null)
                        message.ConditionsOperator = Boolean(object.ConditionsOperator);
                    if (object.LastMobifyBy != null)
                        message.LastMobifyBy = String(object.LastMobifyBy);
                    if (object.CoverLetters) {
                        if (!Array.isArray(object.CoverLetters))
                            throw TypeError(".priority.netitems.form.Alert.CoverLetters: array expected");
                        message.CoverLetters = [];
                        for (var i = 0; i < object.CoverLetters.length; ++i) {
                            if (typeof object.CoverLetters[i] !== "object")
                                throw TypeError(".priority.netitems.form.Alert.CoverLetters: object expected");
                            message.CoverLetters[i] = $root.priority.netitems.form.AlertMessage.fromObject(object.CoverLetters[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an Alert message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.Alert
                 * @static
                 * @param {priority.netitems.form.Alert} message Alert
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Alert.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.RecipientUser = [];
                        object.RecipientGroup = [];
                        object.RecipientMail = [];
                        object.AlertConds = [];
                        object.CoverLetters = [];
                    }
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.AlertNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.AlertNumber = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Document = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Document = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.DocumentFormat = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.DocumentFormat = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.DocumentFormatLang = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.DocumentFormatLang = options.longs === String ? "0" : 0;
                        object.Description = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.MessageType = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.MessageType = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.MailType = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.MailType = options.longs === String ? "0" : 0;
                        object.Active = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.WebHook = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.WebHook = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.RecipientField = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.RecipientField = options.longs === String ? "0" : 0;
                        object.Pdf = false;
                        object.ExtFile = false;
                        object.WordTemplates = false;
                        object.ConditionsOperator = false;
                        object.LastMobifyBy = "";
                    }
                    if (message.AlertNumber != null && message.hasOwnProperty("AlertNumber"))
                        if (typeof message.AlertNumber === "number")
                            object.AlertNumber = options.longs === String ? String(message.AlertNumber) : message.AlertNumber;
                        else
                            object.AlertNumber = options.longs === String ? $util.Long.prototype.toString.call(message.AlertNumber) : options.longs === Number ? new $util.LongBits(message.AlertNumber.low >>> 0, message.AlertNumber.high >>> 0).toNumber() : message.AlertNumber;
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.form.AlertMessage.toObject(message.Messages[j], options);
                    }
                    if (message.Document != null && message.hasOwnProperty("Document"))
                        if (typeof message.Document === "number")
                            object.Document = options.longs === String ? String(message.Document) : message.Document;
                        else
                            object.Document = options.longs === String ? $util.Long.prototype.toString.call(message.Document) : options.longs === Number ? new $util.LongBits(message.Document.low >>> 0, message.Document.high >>> 0).toNumber() : message.Document;
                    if (message.DocumentFormat != null && message.hasOwnProperty("DocumentFormat"))
                        if (typeof message.DocumentFormat === "number")
                            object.DocumentFormat = options.longs === String ? String(message.DocumentFormat) : message.DocumentFormat;
                        else
                            object.DocumentFormat = options.longs === String ? $util.Long.prototype.toString.call(message.DocumentFormat) : options.longs === Number ? new $util.LongBits(message.DocumentFormat.low >>> 0, message.DocumentFormat.high >>> 0).toNumber() : message.DocumentFormat;
                    if (message.DocumentFormatLang != null && message.hasOwnProperty("DocumentFormatLang"))
                        if (typeof message.DocumentFormatLang === "number")
                            object.DocumentFormatLang = options.longs === String ? String(message.DocumentFormatLang) : message.DocumentFormatLang;
                        else
                            object.DocumentFormatLang = options.longs === String ? $util.Long.prototype.toString.call(message.DocumentFormatLang) : options.longs === Number ? new $util.LongBits(message.DocumentFormatLang.low >>> 0, message.DocumentFormatLang.high >>> 0).toNumber() : message.DocumentFormatLang;
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        object.Description = message.Description;
                    if (message.MessageType != null && message.hasOwnProperty("MessageType"))
                        if (typeof message.MessageType === "number")
                            object.MessageType = options.longs === String ? String(message.MessageType) : message.MessageType;
                        else
                            object.MessageType = options.longs === String ? $util.Long.prototype.toString.call(message.MessageType) : options.longs === Number ? new $util.LongBits(message.MessageType.low >>> 0, message.MessageType.high >>> 0).toNumber() : message.MessageType;
                    if (message.MailType != null && message.hasOwnProperty("MailType"))
                        if (typeof message.MailType === "number")
                            object.MailType = options.longs === String ? String(message.MailType) : message.MailType;
                        else
                            object.MailType = options.longs === String ? $util.Long.prototype.toString.call(message.MailType) : options.longs === Number ? new $util.LongBits(message.MailType.low >>> 0, message.MailType.high >>> 0).toNumber() : message.MailType;
                    if (message.Active != null && message.hasOwnProperty("Active"))
                        object.Active = message.Active;
                    if (message.WebHook != null && message.hasOwnProperty("WebHook"))
                        if (typeof message.WebHook === "number")
                            object.WebHook = options.longs === String ? String(message.WebHook) : message.WebHook;
                        else
                            object.WebHook = options.longs === String ? $util.Long.prototype.toString.call(message.WebHook) : options.longs === Number ? new $util.LongBits(message.WebHook.low >>> 0, message.WebHook.high >>> 0).toNumber() : message.WebHook;
                    if (message.RecipientUser && message.RecipientUser.length) {
                        object.RecipientUser = [];
                        for (var j = 0; j < message.RecipientUser.length; ++j)
                            if (typeof message.RecipientUser[j] === "number")
                                object.RecipientUser[j] = options.longs === String ? String(message.RecipientUser[j]) : message.RecipientUser[j];
                            else
                                object.RecipientUser[j] = options.longs === String ? $util.Long.prototype.toString.call(message.RecipientUser[j]) : options.longs === Number ? new $util.LongBits(message.RecipientUser[j].low >>> 0, message.RecipientUser[j].high >>> 0).toNumber() : message.RecipientUser[j];
                    }
                    if (message.RecipientGroup && message.RecipientGroup.length) {
                        object.RecipientGroup = [];
                        for (var j = 0; j < message.RecipientGroup.length; ++j)
                            if (typeof message.RecipientGroup[j] === "number")
                                object.RecipientGroup[j] = options.longs === String ? String(message.RecipientGroup[j]) : message.RecipientGroup[j];
                            else
                                object.RecipientGroup[j] = options.longs === String ? $util.Long.prototype.toString.call(message.RecipientGroup[j]) : options.longs === Number ? new $util.LongBits(message.RecipientGroup[j].low >>> 0, message.RecipientGroup[j].high >>> 0).toNumber() : message.RecipientGroup[j];
                    }
                    if (message.RecipientField != null && message.hasOwnProperty("RecipientField"))
                        if (typeof message.RecipientField === "number")
                            object.RecipientField = options.longs === String ? String(message.RecipientField) : message.RecipientField;
                        else
                            object.RecipientField = options.longs === String ? $util.Long.prototype.toString.call(message.RecipientField) : options.longs === Number ? new $util.LongBits(message.RecipientField.low >>> 0, message.RecipientField.high >>> 0).toNumber() : message.RecipientField;
                    if (message.RecipientMail && message.RecipientMail.length) {
                        object.RecipientMail = [];
                        for (var j = 0; j < message.RecipientMail.length; ++j)
                            object.RecipientMail[j] = message.RecipientMail[j];
                    }
                    if (message.BPM != null && message.hasOwnProperty("BPM")) {
                        object.BPM = $root.priority.netitems.form.AlertBPM.toObject(message.BPM, options);
                        if (options.oneofs)
                            object.AlertType = "BPM";
                    }
                    if (message.Form != null && message.hasOwnProperty("Form")) {
                        object.Form = $root.priority.netitems.form.AlertForm.toObject(message.Form, options);
                        if (options.oneofs)
                            object.AlertType = "Form";
                    }
                    if (message.AlertConds && message.AlertConds.length) {
                        object.AlertConds = [];
                        for (var j = 0; j < message.AlertConds.length; ++j)
                            object.AlertConds[j] = $root.priority.netitems.form.AlertCondition.toObject(message.AlertConds[j], options);
                    }
                    if (message.Pdf != null && message.hasOwnProperty("Pdf"))
                        object.Pdf = message.Pdf;
                    if (message.ExtFile != null && message.hasOwnProperty("ExtFile"))
                        object.ExtFile = message.ExtFile;
                    if (message.WordTemplates != null && message.hasOwnProperty("WordTemplates"))
                        object.WordTemplates = message.WordTemplates;
                    if (message.ConditionsOperator != null && message.hasOwnProperty("ConditionsOperator"))
                        object.ConditionsOperator = message.ConditionsOperator;
                    if (message.LastMobifyBy != null && message.hasOwnProperty("LastMobifyBy"))
                        object.LastMobifyBy = message.LastMobifyBy;
                    if (message.CoverLetters && message.CoverLetters.length) {
                        object.CoverLetters = [];
                        for (var j = 0; j < message.CoverLetters.length; ++j)
                            object.CoverLetters[j] = $root.priority.netitems.form.AlertMessage.toObject(message.CoverLetters[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Alert to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.Alert
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Alert.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Alert;
            })();

            form.AlertChoose = (function() {

                /**
                 * Properties of an AlertChoose.
                 * @memberof priority.netitems.form
                 * @interface IAlertChoose
                 * @property {number|Long|null} [Id] AlertChoose Id
                 * @property {string|null} [Title] AlertChoose Title
                 * @property {string|null} [Description] AlertChoose Description
                 * @property {priority.netitems.form.ZoomType|null} [Zoom] AlertChoose Zoom
                 * @property {number|Long|null} [ReadOnly] AlertChoose ReadOnly
                 * @property {priority.netitems.form.ColumnType|null} [ColType] AlertChoose ColType
                 * @property {string|null} [ColName] AlertChoose ColName
                 */

                /**
                 * Constructs a new AlertChoose.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertChoose.
                 * @implements IAlertChoose
                 * @constructor
                 * @param {priority.netitems.form.IAlertChoose=} [properties] Properties to set
                 */
                function AlertChoose(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertChoose Id.
                 * @member {number|Long} Id
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                AlertChoose.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertChoose Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                AlertChoose.prototype.Title = "";

                /**
                 * AlertChoose Description.
                 * @member {string} Description
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                AlertChoose.prototype.Description = "";

                /**
                 * AlertChoose Zoom.
                 * @member {priority.netitems.form.ZoomType} Zoom
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                AlertChoose.prototype.Zoom = 0;

                /**
                 * AlertChoose ReadOnly.
                 * @member {number|Long} ReadOnly
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                AlertChoose.prototype.ReadOnly = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertChoose ColType.
                 * @member {priority.netitems.form.ColumnType|null|undefined} ColType
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                AlertChoose.prototype.ColType = null;

                /**
                 * AlertChoose ColName.
                 * @member {string|null|undefined} ColName
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                AlertChoose.prototype.ColName = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * AlertChoose _ColType.
                 * @member {"ColType"|undefined} _ColType
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                Object.defineProperty(AlertChoose.prototype, "_ColType", {
                    get: $util.oneOfGetter($oneOfFields = ["ColType"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * AlertChoose _ColName.
                 * @member {"ColName"|undefined} _ColName
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 */
                Object.defineProperty(AlertChoose.prototype, "_ColName", {
                    get: $util.oneOfGetter($oneOfFields = ["ColName"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new AlertChoose instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertChoose
                 * @static
                 * @param {priority.netitems.form.IAlertChoose=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertChoose} AlertChoose instance
                 */
                AlertChoose.create = function create(properties) {
                    return new AlertChoose(properties);
                };

                /**
                 * Encodes the specified AlertChoose message. Does not implicitly {@link priority.netitems.form.AlertChoose.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertChoose
                 * @static
                 * @param {priority.netitems.form.IAlertChoose} message AlertChoose message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChoose.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.Description != null && Object.hasOwnProperty.call(message, "Description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Description);
                    if (message.Zoom != null && Object.hasOwnProperty.call(message, "Zoom"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Zoom);
                    if (message.ReadOnly != null && Object.hasOwnProperty.call(message, "ReadOnly"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.ReadOnly);
                    if (message.ColType != null && Object.hasOwnProperty.call(message, "ColType"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.ColType);
                    if (message.ColName != null && Object.hasOwnProperty.call(message, "ColName"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.ColName);
                    return writer;
                };

                /**
                 * Encodes the specified AlertChoose message, length delimited. Does not implicitly {@link priority.netitems.form.AlertChoose.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertChoose
                 * @static
                 * @param {priority.netitems.form.IAlertChoose} message AlertChoose message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChoose.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertChoose message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertChoose
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertChoose} AlertChoose
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChoose.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertChoose();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Id = reader.int64();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.Description = reader.string();
                            break;
                        case 4:
                            message.Zoom = reader.int32();
                            break;
                        case 5:
                            message.ReadOnly = reader.int64();
                            break;
                        case 6:
                            message.ColType = reader.int32();
                            break;
                        case 7:
                            message.ColName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertChoose message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertChoose
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertChoose} AlertChoose
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChoose.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertChoose message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertChoose
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertChoose.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                            return "Id: integer|Long expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        if (!$util.isString(message.Description))
                            return "Description: string expected";
                    if (message.Zoom != null && message.hasOwnProperty("Zoom"))
                        switch (message.Zoom) {
                        default:
                            return "Zoom: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 14:
                            break;
                        }
                    if (message.ReadOnly != null && message.hasOwnProperty("ReadOnly"))
                        if (!$util.isInteger(message.ReadOnly) && !(message.ReadOnly && $util.isInteger(message.ReadOnly.low) && $util.isInteger(message.ReadOnly.high)))
                            return "ReadOnly: integer|Long expected";
                    if (message.ColType != null && message.hasOwnProperty("ColType")) {
                        properties._ColType = 1;
                        switch (message.ColType) {
                        default:
                            return "ColType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                            break;
                        }
                    }
                    if (message.ColName != null && message.hasOwnProperty("ColName")) {
                        properties._ColName = 1;
                        if (!$util.isString(message.ColName))
                            return "ColName: string expected";
                    }
                    return null;
                };

                /**
                 * Creates an AlertChoose message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertChoose
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertChoose} AlertChoose
                 */
                AlertChoose.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertChoose)
                        return object;
                    var message = new $root.priority.netitems.form.AlertChoose();
                    if (object.Id != null)
                        if ($util.Long)
                            (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                        else if (typeof object.Id === "string")
                            message.Id = parseInt(object.Id, 10);
                        else if (typeof object.Id === "number")
                            message.Id = object.Id;
                        else if (typeof object.Id === "object")
                            message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Description != null)
                        message.Description = String(object.Description);
                    switch (object.Zoom) {
                    case "NoneZoom":
                    case 0:
                        message.Zoom = 0;
                        break;
                    case "AttachZoom":
                    case 1:
                        message.Zoom = 1;
                        break;
                    case "SelectZoom":
                    case 2:
                        message.Zoom = 2;
                        break;
                    case "ZoomZoom":
                    case 4:
                        message.Zoom = 4;
                        break;
                    case "Date14Zoom":
                    case 5:
                        message.Zoom = 5;
                        break;
                    case "Date8Zoom":
                    case 6:
                        message.Zoom = 6;
                        break;
                    case "Date10Zoom":
                    case 7:
                        message.Zoom = 7;
                        break;
                    case "EMailZoom":
                    case 8:
                        message.Zoom = 8;
                        break;
                    case "URLZoom":
                    case 9:
                        message.Zoom = 9;
                        break;
                    case "HiddenZoom":
                    case 10:
                        message.Zoom = 10;
                        break;
                    case "LinkFileZoom":
                    case 11:
                        message.Zoom = 11;
                        break;
                    case "QEditZoom":
                    case 12:
                        message.Zoom = 12;
                        break;
                    case "SpecialAttachZoom":
                    case 14:
                        message.Zoom = 14;
                        break;
                    }
                    if (object.ReadOnly != null)
                        if ($util.Long)
                            (message.ReadOnly = $util.Long.fromValue(object.ReadOnly)).unsigned = false;
                        else if (typeof object.ReadOnly === "string")
                            message.ReadOnly = parseInt(object.ReadOnly, 10);
                        else if (typeof object.ReadOnly === "number")
                            message.ReadOnly = object.ReadOnly;
                        else if (typeof object.ReadOnly === "object")
                            message.ReadOnly = new $util.LongBits(object.ReadOnly.low >>> 0, object.ReadOnly.high >>> 0).toNumber();
                    switch (object.ColType) {
                    case "Char":
                    case 0:
                        message.ColType = 0;
                        break;
                    case "Str":
                    case 1:
                        message.ColType = 1;
                        break;
                    case "Rstr":
                    case 2:
                        message.ColType = 2;
                        break;
                    case "Boolean":
                    case 3:
                        message.ColType = 3;
                        break;
                    case "Real":
                    case 4:
                        message.ColType = 4;
                        break;
                    case "Int":
                    case 5:
                        message.ColType = 5;
                        break;
                    case "Date8":
                    case 6:
                        message.ColType = 6;
                        break;
                    case "Date10":
                    case 7:
                        message.ColType = 7;
                        break;
                    case "Date14":
                    case 8:
                        message.ColType = 8;
                        break;
                    case "Time5":
                    case 9:
                        message.ColType = 9;
                        break;
                    case "Time6":
                    case 10:
                        message.ColType = 10;
                        break;
                    case "Day":
                    case 11:
                        message.ColType = 11;
                        break;
                    case "Unsigned":
                    case 12:
                        message.ColType = 12;
                        break;
                    case "Operator":
                    case 13:
                        message.ColType = 13;
                        break;
                    case "Attachment":
                    case 14:
                        message.ColType = 14;
                        break;
                    }
                    if (object.ColName != null)
                        message.ColName = String(object.ColName);
                    return message;
                };

                /**
                 * Creates a plain object from an AlertChoose message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertChoose
                 * @static
                 * @param {priority.netitems.form.AlertChoose} message AlertChoose
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertChoose.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Id = options.longs === String ? "0" : 0;
                        object.Title = "";
                        object.Description = "";
                        object.Zoom = options.enums === String ? "NoneZoom" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReadOnly = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReadOnly = options.longs === String ? "0" : 0;
                    }
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (typeof message.Id === "number")
                            object.Id = options.longs === String ? String(message.Id) : message.Id;
                        else
                            object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        object.Description = message.Description;
                    if (message.Zoom != null && message.hasOwnProperty("Zoom"))
                        object.Zoom = options.enums === String ? $root.priority.netitems.form.ZoomType[message.Zoom] : message.Zoom;
                    if (message.ReadOnly != null && message.hasOwnProperty("ReadOnly"))
                        if (typeof message.ReadOnly === "number")
                            object.ReadOnly = options.longs === String ? String(message.ReadOnly) : message.ReadOnly;
                        else
                            object.ReadOnly = options.longs === String ? $util.Long.prototype.toString.call(message.ReadOnly) : options.longs === Number ? new $util.LongBits(message.ReadOnly.low >>> 0, message.ReadOnly.high >>> 0).toNumber() : message.ReadOnly;
                    if (message.ColType != null && message.hasOwnProperty("ColType")) {
                        object.ColType = options.enums === String ? $root.priority.netitems.form.ColumnType[message.ColType] : message.ColType;
                        if (options.oneofs)
                            object._ColType = "ColType";
                    }
                    if (message.ColName != null && message.hasOwnProperty("ColName")) {
                        object.ColName = message.ColName;
                        if (options.oneofs)
                            object._ColName = "ColName";
                    }
                    return object;
                };

                /**
                 * Converts this AlertChoose to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertChoose
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertChoose.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertChoose;
            })();

            form.AlertTemplates = (function() {

                /**
                 * Properties of an AlertTemplates.
                 * @memberof priority.netitems.form
                 * @interface IAlertTemplates
                 * @property {number|Long|null} [Id] AlertTemplates Id
                 * @property {string|null} [Title] AlertTemplates Title
                 * @property {number|Long|null} [ReadOnly] AlertTemplates ReadOnly
                 * @property {number|Long|null} [Selected] AlertTemplates Selected
                 * @property {number|Long|null} [Language] AlertTemplates Language
                 */

                /**
                 * Constructs a new AlertTemplates.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertTemplates.
                 * @implements IAlertTemplates
                 * @constructor
                 * @param {priority.netitems.form.IAlertTemplates=} [properties] Properties to set
                 */
                function AlertTemplates(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertTemplates Id.
                 * @member {number|Long} Id
                 * @memberof priority.netitems.form.AlertTemplates
                 * @instance
                 */
                AlertTemplates.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertTemplates Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.AlertTemplates
                 * @instance
                 */
                AlertTemplates.prototype.Title = "";

                /**
                 * AlertTemplates ReadOnly.
                 * @member {number|Long} ReadOnly
                 * @memberof priority.netitems.form.AlertTemplates
                 * @instance
                 */
                AlertTemplates.prototype.ReadOnly = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertTemplates Selected.
                 * @member {number|Long} Selected
                 * @memberof priority.netitems.form.AlertTemplates
                 * @instance
                 */
                AlertTemplates.prototype.Selected = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertTemplates Language.
                 * @member {number|Long} Language
                 * @memberof priority.netitems.form.AlertTemplates
                 * @instance
                 */
                AlertTemplates.prototype.Language = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new AlertTemplates instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertTemplates
                 * @static
                 * @param {priority.netitems.form.IAlertTemplates=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertTemplates} AlertTemplates instance
                 */
                AlertTemplates.create = function create(properties) {
                    return new AlertTemplates(properties);
                };

                /**
                 * Encodes the specified AlertTemplates message. Does not implicitly {@link priority.netitems.form.AlertTemplates.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertTemplates
                 * @static
                 * @param {priority.netitems.form.IAlertTemplates} message AlertTemplates message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertTemplates.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.ReadOnly != null && Object.hasOwnProperty.call(message, "ReadOnly"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ReadOnly);
                    if (message.Selected != null && Object.hasOwnProperty.call(message, "Selected"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.Selected);
                    if (message.Language != null && Object.hasOwnProperty.call(message, "Language"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Language);
                    return writer;
                };

                /**
                 * Encodes the specified AlertTemplates message, length delimited. Does not implicitly {@link priority.netitems.form.AlertTemplates.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertTemplates
                 * @static
                 * @param {priority.netitems.form.IAlertTemplates} message AlertTemplates message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertTemplates.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertTemplates message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertTemplates
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertTemplates} AlertTemplates
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertTemplates.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertTemplates();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Id = reader.int64();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.ReadOnly = reader.int64();
                            break;
                        case 4:
                            message.Selected = reader.int64();
                            break;
                        case 5:
                            message.Language = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertTemplates message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertTemplates
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertTemplates} AlertTemplates
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertTemplates.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertTemplates message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertTemplates
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertTemplates.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                            return "Id: integer|Long expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.ReadOnly != null && message.hasOwnProperty("ReadOnly"))
                        if (!$util.isInteger(message.ReadOnly) && !(message.ReadOnly && $util.isInteger(message.ReadOnly.low) && $util.isInteger(message.ReadOnly.high)))
                            return "ReadOnly: integer|Long expected";
                    if (message.Selected != null && message.hasOwnProperty("Selected"))
                        if (!$util.isInteger(message.Selected) && !(message.Selected && $util.isInteger(message.Selected.low) && $util.isInteger(message.Selected.high)))
                            return "Selected: integer|Long expected";
                    if (message.Language != null && message.hasOwnProperty("Language"))
                        if (!$util.isInteger(message.Language) && !(message.Language && $util.isInteger(message.Language.low) && $util.isInteger(message.Language.high)))
                            return "Language: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an AlertTemplates message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertTemplates
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertTemplates} AlertTemplates
                 */
                AlertTemplates.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertTemplates)
                        return object;
                    var message = new $root.priority.netitems.form.AlertTemplates();
                    if (object.Id != null)
                        if ($util.Long)
                            (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                        else if (typeof object.Id === "string")
                            message.Id = parseInt(object.Id, 10);
                        else if (typeof object.Id === "number")
                            message.Id = object.Id;
                        else if (typeof object.Id === "object")
                            message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.ReadOnly != null)
                        if ($util.Long)
                            (message.ReadOnly = $util.Long.fromValue(object.ReadOnly)).unsigned = false;
                        else if (typeof object.ReadOnly === "string")
                            message.ReadOnly = parseInt(object.ReadOnly, 10);
                        else if (typeof object.ReadOnly === "number")
                            message.ReadOnly = object.ReadOnly;
                        else if (typeof object.ReadOnly === "object")
                            message.ReadOnly = new $util.LongBits(object.ReadOnly.low >>> 0, object.ReadOnly.high >>> 0).toNumber();
                    if (object.Selected != null)
                        if ($util.Long)
                            (message.Selected = $util.Long.fromValue(object.Selected)).unsigned = false;
                        else if (typeof object.Selected === "string")
                            message.Selected = parseInt(object.Selected, 10);
                        else if (typeof object.Selected === "number")
                            message.Selected = object.Selected;
                        else if (typeof object.Selected === "object")
                            message.Selected = new $util.LongBits(object.Selected.low >>> 0, object.Selected.high >>> 0).toNumber();
                    if (object.Language != null)
                        if ($util.Long)
                            (message.Language = $util.Long.fromValue(object.Language)).unsigned = false;
                        else if (typeof object.Language === "string")
                            message.Language = parseInt(object.Language, 10);
                        else if (typeof object.Language === "number")
                            message.Language = object.Language;
                        else if (typeof object.Language === "object")
                            message.Language = new $util.LongBits(object.Language.low >>> 0, object.Language.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an AlertTemplates message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertTemplates
                 * @static
                 * @param {priority.netitems.form.AlertTemplates} message AlertTemplates
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertTemplates.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Id = options.longs === String ? "0" : 0;
                        object.Title = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReadOnly = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReadOnly = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Selected = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Selected = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Language = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Language = options.longs === String ? "0" : 0;
                    }
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (typeof message.Id === "number")
                            object.Id = options.longs === String ? String(message.Id) : message.Id;
                        else
                            object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.ReadOnly != null && message.hasOwnProperty("ReadOnly"))
                        if (typeof message.ReadOnly === "number")
                            object.ReadOnly = options.longs === String ? String(message.ReadOnly) : message.ReadOnly;
                        else
                            object.ReadOnly = options.longs === String ? $util.Long.prototype.toString.call(message.ReadOnly) : options.longs === Number ? new $util.LongBits(message.ReadOnly.low >>> 0, message.ReadOnly.high >>> 0).toNumber() : message.ReadOnly;
                    if (message.Selected != null && message.hasOwnProperty("Selected"))
                        if (typeof message.Selected === "number")
                            object.Selected = options.longs === String ? String(message.Selected) : message.Selected;
                        else
                            object.Selected = options.longs === String ? $util.Long.prototype.toString.call(message.Selected) : options.longs === Number ? new $util.LongBits(message.Selected.low >>> 0, message.Selected.high >>> 0).toNumber() : message.Selected;
                    if (message.Language != null && message.hasOwnProperty("Language"))
                        if (typeof message.Language === "number")
                            object.Language = options.longs === String ? String(message.Language) : message.Language;
                        else
                            object.Language = options.longs === String ? $util.Long.prototype.toString.call(message.Language) : options.longs === Number ? new $util.LongBits(message.Language.low >>> 0, message.Language.high >>> 0).toNumber() : message.Language;
                    return object;
                };

                /**
                 * Converts this AlertTemplates to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertTemplates
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertTemplates.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertTemplates;
            })();

            form.AlertChooseDocuments = (function() {

                /**
                 * Properties of an AlertChooseDocuments.
                 * @memberof priority.netitems.form
                 * @interface IAlertChooseDocuments
                 * @property {number|Long|null} [Id] AlertChooseDocuments Id
                 * @property {string|null} [Title] AlertChooseDocuments Title
                 * @property {string|null} [Description] AlertChooseDocuments Description
                 * @property {priority.netitems.form.ZoomType|null} [Zoom] AlertChooseDocuments Zoom
                 * @property {number|Long|null} [ReadOnly] AlertChooseDocuments ReadOnly
                 * @property {Array.<priority.netitems.form.IAlertChoose>|null} [PrintFormates] AlertChooseDocuments PrintFormates
                 * @property {Array.<priority.netitems.form.IAlertTemplates>|null} [PrintTemplates] AlertChooseDocuments PrintTemplates
                 */

                /**
                 * Constructs a new AlertChooseDocuments.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertChooseDocuments.
                 * @implements IAlertChooseDocuments
                 * @constructor
                 * @param {priority.netitems.form.IAlertChooseDocuments=} [properties] Properties to set
                 */
                function AlertChooseDocuments(properties) {
                    this.PrintFormates = [];
                    this.PrintTemplates = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertChooseDocuments Id.
                 * @member {number|Long} Id
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @instance
                 */
                AlertChooseDocuments.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertChooseDocuments Title.
                 * @member {string} Title
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @instance
                 */
                AlertChooseDocuments.prototype.Title = "";

                /**
                 * AlertChooseDocuments Description.
                 * @member {string} Description
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @instance
                 */
                AlertChooseDocuments.prototype.Description = "";

                /**
                 * AlertChooseDocuments Zoom.
                 * @member {priority.netitems.form.ZoomType} Zoom
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @instance
                 */
                AlertChooseDocuments.prototype.Zoom = 0;

                /**
                 * AlertChooseDocuments ReadOnly.
                 * @member {number|Long} ReadOnly
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @instance
                 */
                AlertChooseDocuments.prototype.ReadOnly = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertChooseDocuments PrintFormates.
                 * @member {Array.<priority.netitems.form.IAlertChoose>} PrintFormates
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @instance
                 */
                AlertChooseDocuments.prototype.PrintFormates = $util.emptyArray;

                /**
                 * AlertChooseDocuments PrintTemplates.
                 * @member {Array.<priority.netitems.form.IAlertTemplates>} PrintTemplates
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @instance
                 */
                AlertChooseDocuments.prototype.PrintTemplates = $util.emptyArray;

                /**
                 * Creates a new AlertChooseDocuments instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @static
                 * @param {priority.netitems.form.IAlertChooseDocuments=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertChooseDocuments} AlertChooseDocuments instance
                 */
                AlertChooseDocuments.create = function create(properties) {
                    return new AlertChooseDocuments(properties);
                };

                /**
                 * Encodes the specified AlertChooseDocuments message. Does not implicitly {@link priority.netitems.form.AlertChooseDocuments.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @static
                 * @param {priority.netitems.form.IAlertChooseDocuments} message AlertChooseDocuments message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChooseDocuments.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.Description != null && Object.hasOwnProperty.call(message, "Description"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Description);
                    if (message.Zoom != null && Object.hasOwnProperty.call(message, "Zoom"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Zoom);
                    if (message.ReadOnly != null && Object.hasOwnProperty.call(message, "ReadOnly"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.ReadOnly);
                    if (message.PrintFormates != null && message.PrintFormates.length)
                        for (var i = 0; i < message.PrintFormates.length; ++i)
                            $root.priority.netitems.form.AlertChoose.encode(message.PrintFormates[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.PrintTemplates != null && message.PrintTemplates.length)
                        for (var i = 0; i < message.PrintTemplates.length; ++i)
                            $root.priority.netitems.form.AlertTemplates.encode(message.PrintTemplates[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified AlertChooseDocuments message, length delimited. Does not implicitly {@link priority.netitems.form.AlertChooseDocuments.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @static
                 * @param {priority.netitems.form.IAlertChooseDocuments} message AlertChooseDocuments message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertChooseDocuments.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertChooseDocuments message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertChooseDocuments} AlertChooseDocuments
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChooseDocuments.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertChooseDocuments();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Id = reader.int64();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.Description = reader.string();
                            break;
                        case 4:
                            message.Zoom = reader.int32();
                            break;
                        case 5:
                            message.ReadOnly = reader.int64();
                            break;
                        case 6:
                            if (!(message.PrintFormates && message.PrintFormates.length))
                                message.PrintFormates = [];
                            message.PrintFormates.push($root.priority.netitems.form.AlertChoose.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            if (!(message.PrintTemplates && message.PrintTemplates.length))
                                message.PrintTemplates = [];
                            message.PrintTemplates.push($root.priority.netitems.form.AlertTemplates.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertChooseDocuments message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertChooseDocuments} AlertChooseDocuments
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertChooseDocuments.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertChooseDocuments message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertChooseDocuments.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                            return "Id: integer|Long expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        if (!$util.isString(message.Description))
                            return "Description: string expected";
                    if (message.Zoom != null && message.hasOwnProperty("Zoom"))
                        switch (message.Zoom) {
                        default:
                            return "Zoom: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 14:
                            break;
                        }
                    if (message.ReadOnly != null && message.hasOwnProperty("ReadOnly"))
                        if (!$util.isInteger(message.ReadOnly) && !(message.ReadOnly && $util.isInteger(message.ReadOnly.low) && $util.isInteger(message.ReadOnly.high)))
                            return "ReadOnly: integer|Long expected";
                    if (message.PrintFormates != null && message.hasOwnProperty("PrintFormates")) {
                        if (!Array.isArray(message.PrintFormates))
                            return "PrintFormates: array expected";
                        for (var i = 0; i < message.PrintFormates.length; ++i) {
                            var error = $root.priority.netitems.form.AlertChoose.verify(message.PrintFormates[i]);
                            if (error)
                                return "PrintFormates." + error;
                        }
                    }
                    if (message.PrintTemplates != null && message.hasOwnProperty("PrintTemplates")) {
                        if (!Array.isArray(message.PrintTemplates))
                            return "PrintTemplates: array expected";
                        for (var i = 0; i < message.PrintTemplates.length; ++i) {
                            var error = $root.priority.netitems.form.AlertTemplates.verify(message.PrintTemplates[i]);
                            if (error)
                                return "PrintTemplates." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an AlertChooseDocuments message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertChooseDocuments} AlertChooseDocuments
                 */
                AlertChooseDocuments.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertChooseDocuments)
                        return object;
                    var message = new $root.priority.netitems.form.AlertChooseDocuments();
                    if (object.Id != null)
                        if ($util.Long)
                            (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                        else if (typeof object.Id === "string")
                            message.Id = parseInt(object.Id, 10);
                        else if (typeof object.Id === "number")
                            message.Id = object.Id;
                        else if (typeof object.Id === "object")
                            message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Description != null)
                        message.Description = String(object.Description);
                    switch (object.Zoom) {
                    case "NoneZoom":
                    case 0:
                        message.Zoom = 0;
                        break;
                    case "AttachZoom":
                    case 1:
                        message.Zoom = 1;
                        break;
                    case "SelectZoom":
                    case 2:
                        message.Zoom = 2;
                        break;
                    case "ZoomZoom":
                    case 4:
                        message.Zoom = 4;
                        break;
                    case "Date14Zoom":
                    case 5:
                        message.Zoom = 5;
                        break;
                    case "Date8Zoom":
                    case 6:
                        message.Zoom = 6;
                        break;
                    case "Date10Zoom":
                    case 7:
                        message.Zoom = 7;
                        break;
                    case "EMailZoom":
                    case 8:
                        message.Zoom = 8;
                        break;
                    case "URLZoom":
                    case 9:
                        message.Zoom = 9;
                        break;
                    case "HiddenZoom":
                    case 10:
                        message.Zoom = 10;
                        break;
                    case "LinkFileZoom":
                    case 11:
                        message.Zoom = 11;
                        break;
                    case "QEditZoom":
                    case 12:
                        message.Zoom = 12;
                        break;
                    case "SpecialAttachZoom":
                    case 14:
                        message.Zoom = 14;
                        break;
                    }
                    if (object.ReadOnly != null)
                        if ($util.Long)
                            (message.ReadOnly = $util.Long.fromValue(object.ReadOnly)).unsigned = false;
                        else if (typeof object.ReadOnly === "string")
                            message.ReadOnly = parseInt(object.ReadOnly, 10);
                        else if (typeof object.ReadOnly === "number")
                            message.ReadOnly = object.ReadOnly;
                        else if (typeof object.ReadOnly === "object")
                            message.ReadOnly = new $util.LongBits(object.ReadOnly.low >>> 0, object.ReadOnly.high >>> 0).toNumber();
                    if (object.PrintFormates) {
                        if (!Array.isArray(object.PrintFormates))
                            throw TypeError(".priority.netitems.form.AlertChooseDocuments.PrintFormates: array expected");
                        message.PrintFormates = [];
                        for (var i = 0; i < object.PrintFormates.length; ++i) {
                            if (typeof object.PrintFormates[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChooseDocuments.PrintFormates: object expected");
                            message.PrintFormates[i] = $root.priority.netitems.form.AlertChoose.fromObject(object.PrintFormates[i]);
                        }
                    }
                    if (object.PrintTemplates) {
                        if (!Array.isArray(object.PrintTemplates))
                            throw TypeError(".priority.netitems.form.AlertChooseDocuments.PrintTemplates: array expected");
                        message.PrintTemplates = [];
                        for (var i = 0; i < object.PrintTemplates.length; ++i) {
                            if (typeof object.PrintTemplates[i] !== "object")
                                throw TypeError(".priority.netitems.form.AlertChooseDocuments.PrintTemplates: object expected");
                            message.PrintTemplates[i] = $root.priority.netitems.form.AlertTemplates.fromObject(object.PrintTemplates[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an AlertChooseDocuments message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @static
                 * @param {priority.netitems.form.AlertChooseDocuments} message AlertChooseDocuments
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertChooseDocuments.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.PrintFormates = [];
                        object.PrintTemplates = [];
                    }
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Id = options.longs === String ? "0" : 0;
                        object.Title = "";
                        object.Description = "";
                        object.Zoom = options.enums === String ? "NoneZoom" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReadOnly = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReadOnly = options.longs === String ? "0" : 0;
                    }
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (typeof message.Id === "number")
                            object.Id = options.longs === String ? String(message.Id) : message.Id;
                        else
                            object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        object.Description = message.Description;
                    if (message.Zoom != null && message.hasOwnProperty("Zoom"))
                        object.Zoom = options.enums === String ? $root.priority.netitems.form.ZoomType[message.Zoom] : message.Zoom;
                    if (message.ReadOnly != null && message.hasOwnProperty("ReadOnly"))
                        if (typeof message.ReadOnly === "number")
                            object.ReadOnly = options.longs === String ? String(message.ReadOnly) : message.ReadOnly;
                        else
                            object.ReadOnly = options.longs === String ? $util.Long.prototype.toString.call(message.ReadOnly) : options.longs === Number ? new $util.LongBits(message.ReadOnly.low >>> 0, message.ReadOnly.high >>> 0).toNumber() : message.ReadOnly;
                    if (message.PrintFormates && message.PrintFormates.length) {
                        object.PrintFormates = [];
                        for (var j = 0; j < message.PrintFormates.length; ++j)
                            object.PrintFormates[j] = $root.priority.netitems.form.AlertChoose.toObject(message.PrintFormates[j], options);
                    }
                    if (message.PrintTemplates && message.PrintTemplates.length) {
                        object.PrintTemplates = [];
                        for (var j = 0; j < message.PrintTemplates.length; ++j)
                            object.PrintTemplates[j] = $root.priority.netitems.form.AlertTemplates.toObject(message.PrintTemplates[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this AlertChooseDocuments to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertChooseDocuments
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertChooseDocuments.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertChooseDocuments;
            })();

            form.AlertCondition = (function() {

                /**
                 * Properties of an AlertCondition.
                 * @memberof priority.netitems.form
                 * @interface IAlertCondition
                 * @property {number|Long|null} [CurrentValue] AlertCondition CurrentValue
                 * @property {number|Long|null} [ConditionOperator] AlertCondition ConditionOperator
                 * @property {number|Long|null} [ConditionField] AlertCondition ConditionField
                 * @property {string|null} [ConditionValue] AlertCondition ConditionValue
                 * @property {string|null} [ConditionSecondValue] AlertCondition ConditionSecondValue
                 */

                /**
                 * Constructs a new AlertCondition.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertCondition.
                 * @implements IAlertCondition
                 * @constructor
                 * @param {priority.netitems.form.IAlertCondition=} [properties] Properties to set
                 */
                function AlertCondition(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertCondition CurrentValue.
                 * @member {number|Long} CurrentValue
                 * @memberof priority.netitems.form.AlertCondition
                 * @instance
                 */
                AlertCondition.prototype.CurrentValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertCondition ConditionOperator.
                 * @member {number|Long} ConditionOperator
                 * @memberof priority.netitems.form.AlertCondition
                 * @instance
                 */
                AlertCondition.prototype.ConditionOperator = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertCondition ConditionField.
                 * @member {number|Long} ConditionField
                 * @memberof priority.netitems.form.AlertCondition
                 * @instance
                 */
                AlertCondition.prototype.ConditionField = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertCondition ConditionValue.
                 * @member {string} ConditionValue
                 * @memberof priority.netitems.form.AlertCondition
                 * @instance
                 */
                AlertCondition.prototype.ConditionValue = "";

                /**
                 * AlertCondition ConditionSecondValue.
                 * @member {string} ConditionSecondValue
                 * @memberof priority.netitems.form.AlertCondition
                 * @instance
                 */
                AlertCondition.prototype.ConditionSecondValue = "";

                /**
                 * Creates a new AlertCondition instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertCondition
                 * @static
                 * @param {priority.netitems.form.IAlertCondition=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertCondition} AlertCondition instance
                 */
                AlertCondition.create = function create(properties) {
                    return new AlertCondition(properties);
                };

                /**
                 * Encodes the specified AlertCondition message. Does not implicitly {@link priority.netitems.form.AlertCondition.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertCondition
                 * @static
                 * @param {priority.netitems.form.IAlertCondition} message AlertCondition message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertCondition.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.CurrentValue != null && Object.hasOwnProperty.call(message, "CurrentValue"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.CurrentValue);
                    if (message.ConditionOperator != null && Object.hasOwnProperty.call(message, "ConditionOperator"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.ConditionOperator);
                    if (message.ConditionField != null && Object.hasOwnProperty.call(message, "ConditionField"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ConditionField);
                    if (message.ConditionValue != null && Object.hasOwnProperty.call(message, "ConditionValue"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.ConditionValue);
                    if (message.ConditionSecondValue != null && Object.hasOwnProperty.call(message, "ConditionSecondValue"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.ConditionSecondValue);
                    return writer;
                };

                /**
                 * Encodes the specified AlertCondition message, length delimited. Does not implicitly {@link priority.netitems.form.AlertCondition.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertCondition
                 * @static
                 * @param {priority.netitems.form.IAlertCondition} message AlertCondition message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertCondition.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertCondition message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertCondition
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertCondition} AlertCondition
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertCondition.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertCondition();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.CurrentValue = reader.int64();
                            break;
                        case 2:
                            message.ConditionOperator = reader.int64();
                            break;
                        case 3:
                            message.ConditionField = reader.int64();
                            break;
                        case 4:
                            message.ConditionValue = reader.string();
                            break;
                        case 5:
                            message.ConditionSecondValue = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertCondition message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertCondition
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertCondition} AlertCondition
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertCondition.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertCondition message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertCondition
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertCondition.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.CurrentValue != null && message.hasOwnProperty("CurrentValue"))
                        if (!$util.isInteger(message.CurrentValue) && !(message.CurrentValue && $util.isInteger(message.CurrentValue.low) && $util.isInteger(message.CurrentValue.high)))
                            return "CurrentValue: integer|Long expected";
                    if (message.ConditionOperator != null && message.hasOwnProperty("ConditionOperator"))
                        if (!$util.isInteger(message.ConditionOperator) && !(message.ConditionOperator && $util.isInteger(message.ConditionOperator.low) && $util.isInteger(message.ConditionOperator.high)))
                            return "ConditionOperator: integer|Long expected";
                    if (message.ConditionField != null && message.hasOwnProperty("ConditionField"))
                        if (!$util.isInteger(message.ConditionField) && !(message.ConditionField && $util.isInteger(message.ConditionField.low) && $util.isInteger(message.ConditionField.high)))
                            return "ConditionField: integer|Long expected";
                    if (message.ConditionValue != null && message.hasOwnProperty("ConditionValue"))
                        if (!$util.isString(message.ConditionValue))
                            return "ConditionValue: string expected";
                    if (message.ConditionSecondValue != null && message.hasOwnProperty("ConditionSecondValue"))
                        if (!$util.isString(message.ConditionSecondValue))
                            return "ConditionSecondValue: string expected";
                    return null;
                };

                /**
                 * Creates an AlertCondition message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertCondition
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertCondition} AlertCondition
                 */
                AlertCondition.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertCondition)
                        return object;
                    var message = new $root.priority.netitems.form.AlertCondition();
                    if (object.CurrentValue != null)
                        if ($util.Long)
                            (message.CurrentValue = $util.Long.fromValue(object.CurrentValue)).unsigned = false;
                        else if (typeof object.CurrentValue === "string")
                            message.CurrentValue = parseInt(object.CurrentValue, 10);
                        else if (typeof object.CurrentValue === "number")
                            message.CurrentValue = object.CurrentValue;
                        else if (typeof object.CurrentValue === "object")
                            message.CurrentValue = new $util.LongBits(object.CurrentValue.low >>> 0, object.CurrentValue.high >>> 0).toNumber();
                    if (object.ConditionOperator != null)
                        if ($util.Long)
                            (message.ConditionOperator = $util.Long.fromValue(object.ConditionOperator)).unsigned = false;
                        else if (typeof object.ConditionOperator === "string")
                            message.ConditionOperator = parseInt(object.ConditionOperator, 10);
                        else if (typeof object.ConditionOperator === "number")
                            message.ConditionOperator = object.ConditionOperator;
                        else if (typeof object.ConditionOperator === "object")
                            message.ConditionOperator = new $util.LongBits(object.ConditionOperator.low >>> 0, object.ConditionOperator.high >>> 0).toNumber();
                    if (object.ConditionField != null)
                        if ($util.Long)
                            (message.ConditionField = $util.Long.fromValue(object.ConditionField)).unsigned = false;
                        else if (typeof object.ConditionField === "string")
                            message.ConditionField = parseInt(object.ConditionField, 10);
                        else if (typeof object.ConditionField === "number")
                            message.ConditionField = object.ConditionField;
                        else if (typeof object.ConditionField === "object")
                            message.ConditionField = new $util.LongBits(object.ConditionField.low >>> 0, object.ConditionField.high >>> 0).toNumber();
                    if (object.ConditionValue != null)
                        message.ConditionValue = String(object.ConditionValue);
                    if (object.ConditionSecondValue != null)
                        message.ConditionSecondValue = String(object.ConditionSecondValue);
                    return message;
                };

                /**
                 * Creates a plain object from an AlertCondition message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertCondition
                 * @static
                 * @param {priority.netitems.form.AlertCondition} message AlertCondition
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertCondition.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.CurrentValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.CurrentValue = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ConditionOperator = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ConditionOperator = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ConditionField = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ConditionField = options.longs === String ? "0" : 0;
                        object.ConditionValue = "";
                        object.ConditionSecondValue = "";
                    }
                    if (message.CurrentValue != null && message.hasOwnProperty("CurrentValue"))
                        if (typeof message.CurrentValue === "number")
                            object.CurrentValue = options.longs === String ? String(message.CurrentValue) : message.CurrentValue;
                        else
                            object.CurrentValue = options.longs === String ? $util.Long.prototype.toString.call(message.CurrentValue) : options.longs === Number ? new $util.LongBits(message.CurrentValue.low >>> 0, message.CurrentValue.high >>> 0).toNumber() : message.CurrentValue;
                    if (message.ConditionOperator != null && message.hasOwnProperty("ConditionOperator"))
                        if (typeof message.ConditionOperator === "number")
                            object.ConditionOperator = options.longs === String ? String(message.ConditionOperator) : message.ConditionOperator;
                        else
                            object.ConditionOperator = options.longs === String ? $util.Long.prototype.toString.call(message.ConditionOperator) : options.longs === Number ? new $util.LongBits(message.ConditionOperator.low >>> 0, message.ConditionOperator.high >>> 0).toNumber() : message.ConditionOperator;
                    if (message.ConditionField != null && message.hasOwnProperty("ConditionField"))
                        if (typeof message.ConditionField === "number")
                            object.ConditionField = options.longs === String ? String(message.ConditionField) : message.ConditionField;
                        else
                            object.ConditionField = options.longs === String ? $util.Long.prototype.toString.call(message.ConditionField) : options.longs === Number ? new $util.LongBits(message.ConditionField.low >>> 0, message.ConditionField.high >>> 0).toNumber() : message.ConditionField;
                    if (message.ConditionValue != null && message.hasOwnProperty("ConditionValue"))
                        object.ConditionValue = message.ConditionValue;
                    if (message.ConditionSecondValue != null && message.hasOwnProperty("ConditionSecondValue"))
                        object.ConditionSecondValue = message.ConditionSecondValue;
                    return object;
                };

                /**
                 * Converts this AlertCondition to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertCondition
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertCondition.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertCondition;
            })();

            form.AlertOrder = (function() {

                /**
                 * Properties of an AlertOrder.
                 * @memberof priority.netitems.form
                 * @interface IAlertOrder
                 * @property {number|Long|null} [Alert] AlertOrder Alert
                 * @property {number|Long|null} [Line] AlertOrder Line
                 */

                /**
                 * Constructs a new AlertOrder.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertOrder.
                 * @implements IAlertOrder
                 * @constructor
                 * @param {priority.netitems.form.IAlertOrder=} [properties] Properties to set
                 */
                function AlertOrder(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertOrder Alert.
                 * @member {number|Long} Alert
                 * @memberof priority.netitems.form.AlertOrder
                 * @instance
                 */
                AlertOrder.prototype.Alert = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertOrder Line.
                 * @member {number|Long} Line
                 * @memberof priority.netitems.form.AlertOrder
                 * @instance
                 */
                AlertOrder.prototype.Line = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new AlertOrder instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertOrder
                 * @static
                 * @param {priority.netitems.form.IAlertOrder=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertOrder} AlertOrder instance
                 */
                AlertOrder.create = function create(properties) {
                    return new AlertOrder(properties);
                };

                /**
                 * Encodes the specified AlertOrder message. Does not implicitly {@link priority.netitems.form.AlertOrder.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertOrder
                 * @static
                 * @param {priority.netitems.form.IAlertOrder} message AlertOrder message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertOrder.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Alert != null && Object.hasOwnProperty.call(message, "Alert"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Alert);
                    if (message.Line != null && Object.hasOwnProperty.call(message, "Line"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Line);
                    return writer;
                };

                /**
                 * Encodes the specified AlertOrder message, length delimited. Does not implicitly {@link priority.netitems.form.AlertOrder.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertOrder
                 * @static
                 * @param {priority.netitems.form.IAlertOrder} message AlertOrder message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertOrder.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertOrder message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertOrder
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertOrder} AlertOrder
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertOrder.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertOrder();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Alert = reader.int64();
                            break;
                        case 2:
                            message.Line = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertOrder message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertOrder
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertOrder} AlertOrder
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertOrder.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertOrder message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertOrder
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertOrder.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Alert != null && message.hasOwnProperty("Alert"))
                        if (!$util.isInteger(message.Alert) && !(message.Alert && $util.isInteger(message.Alert.low) && $util.isInteger(message.Alert.high)))
                            return "Alert: integer|Long expected";
                    if (message.Line != null && message.hasOwnProperty("Line"))
                        if (!$util.isInteger(message.Line) && !(message.Line && $util.isInteger(message.Line.low) && $util.isInteger(message.Line.high)))
                            return "Line: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an AlertOrder message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertOrder
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertOrder} AlertOrder
                 */
                AlertOrder.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertOrder)
                        return object;
                    var message = new $root.priority.netitems.form.AlertOrder();
                    if (object.Alert != null)
                        if ($util.Long)
                            (message.Alert = $util.Long.fromValue(object.Alert)).unsigned = false;
                        else if (typeof object.Alert === "string")
                            message.Alert = parseInt(object.Alert, 10);
                        else if (typeof object.Alert === "number")
                            message.Alert = object.Alert;
                        else if (typeof object.Alert === "object")
                            message.Alert = new $util.LongBits(object.Alert.low >>> 0, object.Alert.high >>> 0).toNumber();
                    if (object.Line != null)
                        if ($util.Long)
                            (message.Line = $util.Long.fromValue(object.Line)).unsigned = false;
                        else if (typeof object.Line === "string")
                            message.Line = parseInt(object.Line, 10);
                        else if (typeof object.Line === "number")
                            message.Line = object.Line;
                        else if (typeof object.Line === "object")
                            message.Line = new $util.LongBits(object.Line.low >>> 0, object.Line.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an AlertOrder message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertOrder
                 * @static
                 * @param {priority.netitems.form.AlertOrder} message AlertOrder
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertOrder.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Alert = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Alert = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Line = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Line = options.longs === String ? "0" : 0;
                    }
                    if (message.Alert != null && message.hasOwnProperty("Alert"))
                        if (typeof message.Alert === "number")
                            object.Alert = options.longs === String ? String(message.Alert) : message.Alert;
                        else
                            object.Alert = options.longs === String ? $util.Long.prototype.toString.call(message.Alert) : options.longs === Number ? new $util.LongBits(message.Alert.low >>> 0, message.Alert.high >>> 0).toNumber() : message.Alert;
                    if (message.Line != null && message.hasOwnProperty("Line"))
                        if (typeof message.Line === "number")
                            object.Line = options.longs === String ? String(message.Line) : message.Line;
                        else
                            object.Line = options.longs === String ? $util.Long.prototype.toString.call(message.Line) : options.longs === Number ? new $util.LongBits(message.Line.low >>> 0, message.Line.high >>> 0).toNumber() : message.Line;
                    return object;
                };

                /**
                 * Converts this AlertOrder to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertOrder
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertOrder.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertOrder;
            })();

            form.AlertBPM = (function() {

                /**
                 * Properties of an AlertBPM.
                 * @memberof priority.netitems.form
                 * @interface IAlertBPM
                 * @property {number|Long|null} [TimeValue] AlertBPM TimeValue
                 * @property {number|Long|null} [TimeUnit] AlertBPM TimeUnit
                 * @property {number|Long|null} [TimeStatus] AlertBPM TimeStatus
                 * @property {number|Long|null} [TimeField] AlertBPM TimeField
                 * @property {number|Long|null} [FromStatus] AlertBPM FromStatus
                 * @property {number|Long|null} [ToStatus] AlertBPM ToStatus
                 */

                /**
                 * Constructs a new AlertBPM.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertBPM.
                 * @implements IAlertBPM
                 * @constructor
                 * @param {priority.netitems.form.IAlertBPM=} [properties] Properties to set
                 */
                function AlertBPM(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertBPM TimeValue.
                 * @member {number|Long} TimeValue
                 * @memberof priority.netitems.form.AlertBPM
                 * @instance
                 */
                AlertBPM.prototype.TimeValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertBPM TimeUnit.
                 * @member {number|Long} TimeUnit
                 * @memberof priority.netitems.form.AlertBPM
                 * @instance
                 */
                AlertBPM.prototype.TimeUnit = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertBPM TimeStatus.
                 * @member {number|Long} TimeStatus
                 * @memberof priority.netitems.form.AlertBPM
                 * @instance
                 */
                AlertBPM.prototype.TimeStatus = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertBPM TimeField.
                 * @member {number|Long} TimeField
                 * @memberof priority.netitems.form.AlertBPM
                 * @instance
                 */
                AlertBPM.prototype.TimeField = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertBPM FromStatus.
                 * @member {number|Long} FromStatus
                 * @memberof priority.netitems.form.AlertBPM
                 * @instance
                 */
                AlertBPM.prototype.FromStatus = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertBPM ToStatus.
                 * @member {number|Long} ToStatus
                 * @memberof priority.netitems.form.AlertBPM
                 * @instance
                 */
                AlertBPM.prototype.ToStatus = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new AlertBPM instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertBPM
                 * @static
                 * @param {priority.netitems.form.IAlertBPM=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertBPM} AlertBPM instance
                 */
                AlertBPM.create = function create(properties) {
                    return new AlertBPM(properties);
                };

                /**
                 * Encodes the specified AlertBPM message. Does not implicitly {@link priority.netitems.form.AlertBPM.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertBPM
                 * @static
                 * @param {priority.netitems.form.IAlertBPM} message AlertBPM message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertBPM.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.TimeValue != null && Object.hasOwnProperty.call(message, "TimeValue"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.TimeValue);
                    if (message.TimeUnit != null && Object.hasOwnProperty.call(message, "TimeUnit"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.TimeUnit);
                    if (message.TimeStatus != null && Object.hasOwnProperty.call(message, "TimeStatus"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.TimeStatus);
                    if (message.TimeField != null && Object.hasOwnProperty.call(message, "TimeField"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.TimeField);
                    if (message.FromStatus != null && Object.hasOwnProperty.call(message, "FromStatus"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.FromStatus);
                    if (message.ToStatus != null && Object.hasOwnProperty.call(message, "ToStatus"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.ToStatus);
                    return writer;
                };

                /**
                 * Encodes the specified AlertBPM message, length delimited. Does not implicitly {@link priority.netitems.form.AlertBPM.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertBPM
                 * @static
                 * @param {priority.netitems.form.IAlertBPM} message AlertBPM message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertBPM.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertBPM message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertBPM
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertBPM} AlertBPM
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertBPM.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertBPM();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.TimeValue = reader.int64();
                            break;
                        case 2:
                            message.TimeUnit = reader.int64();
                            break;
                        case 3:
                            message.TimeStatus = reader.int64();
                            break;
                        case 4:
                            message.TimeField = reader.int64();
                            break;
                        case 5:
                            message.FromStatus = reader.int64();
                            break;
                        case 6:
                            message.ToStatus = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertBPM message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertBPM
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertBPM} AlertBPM
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertBPM.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertBPM message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertBPM
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertBPM.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.TimeValue != null && message.hasOwnProperty("TimeValue"))
                        if (!$util.isInteger(message.TimeValue) && !(message.TimeValue && $util.isInteger(message.TimeValue.low) && $util.isInteger(message.TimeValue.high)))
                            return "TimeValue: integer|Long expected";
                    if (message.TimeUnit != null && message.hasOwnProperty("TimeUnit"))
                        if (!$util.isInteger(message.TimeUnit) && !(message.TimeUnit && $util.isInteger(message.TimeUnit.low) && $util.isInteger(message.TimeUnit.high)))
                            return "TimeUnit: integer|Long expected";
                    if (message.TimeStatus != null && message.hasOwnProperty("TimeStatus"))
                        if (!$util.isInteger(message.TimeStatus) && !(message.TimeStatus && $util.isInteger(message.TimeStatus.low) && $util.isInteger(message.TimeStatus.high)))
                            return "TimeStatus: integer|Long expected";
                    if (message.TimeField != null && message.hasOwnProperty("TimeField"))
                        if (!$util.isInteger(message.TimeField) && !(message.TimeField && $util.isInteger(message.TimeField.low) && $util.isInteger(message.TimeField.high)))
                            return "TimeField: integer|Long expected";
                    if (message.FromStatus != null && message.hasOwnProperty("FromStatus"))
                        if (!$util.isInteger(message.FromStatus) && !(message.FromStatus && $util.isInteger(message.FromStatus.low) && $util.isInteger(message.FromStatus.high)))
                            return "FromStatus: integer|Long expected";
                    if (message.ToStatus != null && message.hasOwnProperty("ToStatus"))
                        if (!$util.isInteger(message.ToStatus) && !(message.ToStatus && $util.isInteger(message.ToStatus.low) && $util.isInteger(message.ToStatus.high)))
                            return "ToStatus: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an AlertBPM message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertBPM
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertBPM} AlertBPM
                 */
                AlertBPM.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertBPM)
                        return object;
                    var message = new $root.priority.netitems.form.AlertBPM();
                    if (object.TimeValue != null)
                        if ($util.Long)
                            (message.TimeValue = $util.Long.fromValue(object.TimeValue)).unsigned = false;
                        else if (typeof object.TimeValue === "string")
                            message.TimeValue = parseInt(object.TimeValue, 10);
                        else if (typeof object.TimeValue === "number")
                            message.TimeValue = object.TimeValue;
                        else if (typeof object.TimeValue === "object")
                            message.TimeValue = new $util.LongBits(object.TimeValue.low >>> 0, object.TimeValue.high >>> 0).toNumber();
                    if (object.TimeUnit != null)
                        if ($util.Long)
                            (message.TimeUnit = $util.Long.fromValue(object.TimeUnit)).unsigned = false;
                        else if (typeof object.TimeUnit === "string")
                            message.TimeUnit = parseInt(object.TimeUnit, 10);
                        else if (typeof object.TimeUnit === "number")
                            message.TimeUnit = object.TimeUnit;
                        else if (typeof object.TimeUnit === "object")
                            message.TimeUnit = new $util.LongBits(object.TimeUnit.low >>> 0, object.TimeUnit.high >>> 0).toNumber();
                    if (object.TimeStatus != null)
                        if ($util.Long)
                            (message.TimeStatus = $util.Long.fromValue(object.TimeStatus)).unsigned = false;
                        else if (typeof object.TimeStatus === "string")
                            message.TimeStatus = parseInt(object.TimeStatus, 10);
                        else if (typeof object.TimeStatus === "number")
                            message.TimeStatus = object.TimeStatus;
                        else if (typeof object.TimeStatus === "object")
                            message.TimeStatus = new $util.LongBits(object.TimeStatus.low >>> 0, object.TimeStatus.high >>> 0).toNumber();
                    if (object.TimeField != null)
                        if ($util.Long)
                            (message.TimeField = $util.Long.fromValue(object.TimeField)).unsigned = false;
                        else if (typeof object.TimeField === "string")
                            message.TimeField = parseInt(object.TimeField, 10);
                        else if (typeof object.TimeField === "number")
                            message.TimeField = object.TimeField;
                        else if (typeof object.TimeField === "object")
                            message.TimeField = new $util.LongBits(object.TimeField.low >>> 0, object.TimeField.high >>> 0).toNumber();
                    if (object.FromStatus != null)
                        if ($util.Long)
                            (message.FromStatus = $util.Long.fromValue(object.FromStatus)).unsigned = false;
                        else if (typeof object.FromStatus === "string")
                            message.FromStatus = parseInt(object.FromStatus, 10);
                        else if (typeof object.FromStatus === "number")
                            message.FromStatus = object.FromStatus;
                        else if (typeof object.FromStatus === "object")
                            message.FromStatus = new $util.LongBits(object.FromStatus.low >>> 0, object.FromStatus.high >>> 0).toNumber();
                    if (object.ToStatus != null)
                        if ($util.Long)
                            (message.ToStatus = $util.Long.fromValue(object.ToStatus)).unsigned = false;
                        else if (typeof object.ToStatus === "string")
                            message.ToStatus = parseInt(object.ToStatus, 10);
                        else if (typeof object.ToStatus === "number")
                            message.ToStatus = object.ToStatus;
                        else if (typeof object.ToStatus === "object")
                            message.ToStatus = new $util.LongBits(object.ToStatus.low >>> 0, object.ToStatus.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an AlertBPM message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertBPM
                 * @static
                 * @param {priority.netitems.form.AlertBPM} message AlertBPM
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertBPM.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.TimeValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.TimeValue = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.TimeUnit = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.TimeUnit = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.TimeStatus = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.TimeStatus = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.TimeField = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.TimeField = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.FromStatus = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.FromStatus = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ToStatus = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ToStatus = options.longs === String ? "0" : 0;
                    }
                    if (message.TimeValue != null && message.hasOwnProperty("TimeValue"))
                        if (typeof message.TimeValue === "number")
                            object.TimeValue = options.longs === String ? String(message.TimeValue) : message.TimeValue;
                        else
                            object.TimeValue = options.longs === String ? $util.Long.prototype.toString.call(message.TimeValue) : options.longs === Number ? new $util.LongBits(message.TimeValue.low >>> 0, message.TimeValue.high >>> 0).toNumber() : message.TimeValue;
                    if (message.TimeUnit != null && message.hasOwnProperty("TimeUnit"))
                        if (typeof message.TimeUnit === "number")
                            object.TimeUnit = options.longs === String ? String(message.TimeUnit) : message.TimeUnit;
                        else
                            object.TimeUnit = options.longs === String ? $util.Long.prototype.toString.call(message.TimeUnit) : options.longs === Number ? new $util.LongBits(message.TimeUnit.low >>> 0, message.TimeUnit.high >>> 0).toNumber() : message.TimeUnit;
                    if (message.TimeStatus != null && message.hasOwnProperty("TimeStatus"))
                        if (typeof message.TimeStatus === "number")
                            object.TimeStatus = options.longs === String ? String(message.TimeStatus) : message.TimeStatus;
                        else
                            object.TimeStatus = options.longs === String ? $util.Long.prototype.toString.call(message.TimeStatus) : options.longs === Number ? new $util.LongBits(message.TimeStatus.low >>> 0, message.TimeStatus.high >>> 0).toNumber() : message.TimeStatus;
                    if (message.TimeField != null && message.hasOwnProperty("TimeField"))
                        if (typeof message.TimeField === "number")
                            object.TimeField = options.longs === String ? String(message.TimeField) : message.TimeField;
                        else
                            object.TimeField = options.longs === String ? $util.Long.prototype.toString.call(message.TimeField) : options.longs === Number ? new $util.LongBits(message.TimeField.low >>> 0, message.TimeField.high >>> 0).toNumber() : message.TimeField;
                    if (message.FromStatus != null && message.hasOwnProperty("FromStatus"))
                        if (typeof message.FromStatus === "number")
                            object.FromStatus = options.longs === String ? String(message.FromStatus) : message.FromStatus;
                        else
                            object.FromStatus = options.longs === String ? $util.Long.prototype.toString.call(message.FromStatus) : options.longs === Number ? new $util.LongBits(message.FromStatus.low >>> 0, message.FromStatus.high >>> 0).toNumber() : message.FromStatus;
                    if (message.ToStatus != null && message.hasOwnProperty("ToStatus"))
                        if (typeof message.ToStatus === "number")
                            object.ToStatus = options.longs === String ? String(message.ToStatus) : message.ToStatus;
                        else
                            object.ToStatus = options.longs === String ? $util.Long.prototype.toString.call(message.ToStatus) : options.longs === Number ? new $util.LongBits(message.ToStatus.low >>> 0, message.ToStatus.high >>> 0).toNumber() : message.ToStatus;
                    return object;
                };

                /**
                 * Converts this AlertBPM to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertBPM
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertBPM.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertBPM;
            })();

            form.AlertForm = (function() {

                /**
                 * Properties of an AlertForm.
                 * @memberof priority.netitems.form
                 * @interface IAlertForm
                 * @property {Array.<number|Long>|null} [ValidUser] AlertForm ValidUser
                 * @property {Array.<number|Long>|null} [ValidGroup] AlertForm ValidGroup
                 * @property {boolean|null} [ValidAllUsers] AlertForm ValidAllUsers
                 * @property {boolean|null} [ValidMySelf] AlertForm ValidMySelf
                 * @property {boolean|null} [ValidUserInGroup] AlertForm ValidUserInGroup
                 * @property {number|Long|null} [UpdateField] AlertForm UpdateField
                 * @property {boolean|null} [MultiComp] AlertForm MultiComp
                 */

                /**
                 * Constructs a new AlertForm.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertForm.
                 * @implements IAlertForm
                 * @constructor
                 * @param {priority.netitems.form.IAlertForm=} [properties] Properties to set
                 */
                function AlertForm(properties) {
                    this.ValidUser = [];
                    this.ValidGroup = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertForm ValidUser.
                 * @member {Array.<number|Long>} ValidUser
                 * @memberof priority.netitems.form.AlertForm
                 * @instance
                 */
                AlertForm.prototype.ValidUser = $util.emptyArray;

                /**
                 * AlertForm ValidGroup.
                 * @member {Array.<number|Long>} ValidGroup
                 * @memberof priority.netitems.form.AlertForm
                 * @instance
                 */
                AlertForm.prototype.ValidGroup = $util.emptyArray;

                /**
                 * AlertForm ValidAllUsers.
                 * @member {boolean} ValidAllUsers
                 * @memberof priority.netitems.form.AlertForm
                 * @instance
                 */
                AlertForm.prototype.ValidAllUsers = false;

                /**
                 * AlertForm ValidMySelf.
                 * @member {boolean} ValidMySelf
                 * @memberof priority.netitems.form.AlertForm
                 * @instance
                 */
                AlertForm.prototype.ValidMySelf = false;

                /**
                 * AlertForm ValidUserInGroup.
                 * @member {boolean} ValidUserInGroup
                 * @memberof priority.netitems.form.AlertForm
                 * @instance
                 */
                AlertForm.prototype.ValidUserInGroup = false;

                /**
                 * AlertForm UpdateField.
                 * @member {number|Long} UpdateField
                 * @memberof priority.netitems.form.AlertForm
                 * @instance
                 */
                AlertForm.prototype.UpdateField = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AlertForm MultiComp.
                 * @member {boolean} MultiComp
                 * @memberof priority.netitems.form.AlertForm
                 * @instance
                 */
                AlertForm.prototype.MultiComp = false;

                /**
                 * Creates a new AlertForm instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertForm
                 * @static
                 * @param {priority.netitems.form.IAlertForm=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertForm} AlertForm instance
                 */
                AlertForm.create = function create(properties) {
                    return new AlertForm(properties);
                };

                /**
                 * Encodes the specified AlertForm message. Does not implicitly {@link priority.netitems.form.AlertForm.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertForm
                 * @static
                 * @param {priority.netitems.form.IAlertForm} message AlertForm message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertForm.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ValidUser != null && message.ValidUser.length) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork();
                        for (var i = 0; i < message.ValidUser.length; ++i)
                            writer.int64(message.ValidUser[i]);
                        writer.ldelim();
                    }
                    if (message.ValidGroup != null && message.ValidGroup.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.ValidGroup.length; ++i)
                            writer.int64(message.ValidGroup[i]);
                        writer.ldelim();
                    }
                    if (message.ValidAllUsers != null && Object.hasOwnProperty.call(message, "ValidAllUsers"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.ValidAllUsers);
                    if (message.ValidMySelf != null && Object.hasOwnProperty.call(message, "ValidMySelf"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.ValidMySelf);
                    if (message.ValidUserInGroup != null && Object.hasOwnProperty.call(message, "ValidUserInGroup"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.ValidUserInGroup);
                    if (message.UpdateField != null && Object.hasOwnProperty.call(message, "UpdateField"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.UpdateField);
                    if (message.MultiComp != null && Object.hasOwnProperty.call(message, "MultiComp"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.MultiComp);
                    return writer;
                };

                /**
                 * Encodes the specified AlertForm message, length delimited. Does not implicitly {@link priority.netitems.form.AlertForm.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertForm
                 * @static
                 * @param {priority.netitems.form.IAlertForm} message AlertForm message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertForm.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertForm message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertForm
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertForm} AlertForm
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertForm.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertForm();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.ValidUser && message.ValidUser.length))
                                message.ValidUser = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.ValidUser.push(reader.int64());
                            } else
                                message.ValidUser.push(reader.int64());
                            break;
                        case 2:
                            if (!(message.ValidGroup && message.ValidGroup.length))
                                message.ValidGroup = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.ValidGroup.push(reader.int64());
                            } else
                                message.ValidGroup.push(reader.int64());
                            break;
                        case 3:
                            message.ValidAllUsers = reader.bool();
                            break;
                        case 4:
                            message.ValidMySelf = reader.bool();
                            break;
                        case 5:
                            message.ValidUserInGroup = reader.bool();
                            break;
                        case 6:
                            message.UpdateField = reader.int64();
                            break;
                        case 7:
                            message.MultiComp = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertForm message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertForm
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertForm} AlertForm
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertForm.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertForm message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertForm
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertForm.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ValidUser != null && message.hasOwnProperty("ValidUser")) {
                        if (!Array.isArray(message.ValidUser))
                            return "ValidUser: array expected";
                        for (var i = 0; i < message.ValidUser.length; ++i)
                            if (!$util.isInteger(message.ValidUser[i]) && !(message.ValidUser[i] && $util.isInteger(message.ValidUser[i].low) && $util.isInteger(message.ValidUser[i].high)))
                                return "ValidUser: integer|Long[] expected";
                    }
                    if (message.ValidGroup != null && message.hasOwnProperty("ValidGroup")) {
                        if (!Array.isArray(message.ValidGroup))
                            return "ValidGroup: array expected";
                        for (var i = 0; i < message.ValidGroup.length; ++i)
                            if (!$util.isInteger(message.ValidGroup[i]) && !(message.ValidGroup[i] && $util.isInteger(message.ValidGroup[i].low) && $util.isInteger(message.ValidGroup[i].high)))
                                return "ValidGroup: integer|Long[] expected";
                    }
                    if (message.ValidAllUsers != null && message.hasOwnProperty("ValidAllUsers"))
                        if (typeof message.ValidAllUsers !== "boolean")
                            return "ValidAllUsers: boolean expected";
                    if (message.ValidMySelf != null && message.hasOwnProperty("ValidMySelf"))
                        if (typeof message.ValidMySelf !== "boolean")
                            return "ValidMySelf: boolean expected";
                    if (message.ValidUserInGroup != null && message.hasOwnProperty("ValidUserInGroup"))
                        if (typeof message.ValidUserInGroup !== "boolean")
                            return "ValidUserInGroup: boolean expected";
                    if (message.UpdateField != null && message.hasOwnProperty("UpdateField"))
                        if (!$util.isInteger(message.UpdateField) && !(message.UpdateField && $util.isInteger(message.UpdateField.low) && $util.isInteger(message.UpdateField.high)))
                            return "UpdateField: integer|Long expected";
                    if (message.MultiComp != null && message.hasOwnProperty("MultiComp"))
                        if (typeof message.MultiComp !== "boolean")
                            return "MultiComp: boolean expected";
                    return null;
                };

                /**
                 * Creates an AlertForm message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertForm
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertForm} AlertForm
                 */
                AlertForm.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertForm)
                        return object;
                    var message = new $root.priority.netitems.form.AlertForm();
                    if (object.ValidUser) {
                        if (!Array.isArray(object.ValidUser))
                            throw TypeError(".priority.netitems.form.AlertForm.ValidUser: array expected");
                        message.ValidUser = [];
                        for (var i = 0; i < object.ValidUser.length; ++i)
                            if ($util.Long)
                                (message.ValidUser[i] = $util.Long.fromValue(object.ValidUser[i])).unsigned = false;
                            else if (typeof object.ValidUser[i] === "string")
                                message.ValidUser[i] = parseInt(object.ValidUser[i], 10);
                            else if (typeof object.ValidUser[i] === "number")
                                message.ValidUser[i] = object.ValidUser[i];
                            else if (typeof object.ValidUser[i] === "object")
                                message.ValidUser[i] = new $util.LongBits(object.ValidUser[i].low >>> 0, object.ValidUser[i].high >>> 0).toNumber();
                    }
                    if (object.ValidGroup) {
                        if (!Array.isArray(object.ValidGroup))
                            throw TypeError(".priority.netitems.form.AlertForm.ValidGroup: array expected");
                        message.ValidGroup = [];
                        for (var i = 0; i < object.ValidGroup.length; ++i)
                            if ($util.Long)
                                (message.ValidGroup[i] = $util.Long.fromValue(object.ValidGroup[i])).unsigned = false;
                            else if (typeof object.ValidGroup[i] === "string")
                                message.ValidGroup[i] = parseInt(object.ValidGroup[i], 10);
                            else if (typeof object.ValidGroup[i] === "number")
                                message.ValidGroup[i] = object.ValidGroup[i];
                            else if (typeof object.ValidGroup[i] === "object")
                                message.ValidGroup[i] = new $util.LongBits(object.ValidGroup[i].low >>> 0, object.ValidGroup[i].high >>> 0).toNumber();
                    }
                    if (object.ValidAllUsers != null)
                        message.ValidAllUsers = Boolean(object.ValidAllUsers);
                    if (object.ValidMySelf != null)
                        message.ValidMySelf = Boolean(object.ValidMySelf);
                    if (object.ValidUserInGroup != null)
                        message.ValidUserInGroup = Boolean(object.ValidUserInGroup);
                    if (object.UpdateField != null)
                        if ($util.Long)
                            (message.UpdateField = $util.Long.fromValue(object.UpdateField)).unsigned = false;
                        else if (typeof object.UpdateField === "string")
                            message.UpdateField = parseInt(object.UpdateField, 10);
                        else if (typeof object.UpdateField === "number")
                            message.UpdateField = object.UpdateField;
                        else if (typeof object.UpdateField === "object")
                            message.UpdateField = new $util.LongBits(object.UpdateField.low >>> 0, object.UpdateField.high >>> 0).toNumber();
                    if (object.MultiComp != null)
                        message.MultiComp = Boolean(object.MultiComp);
                    return message;
                };

                /**
                 * Creates a plain object from an AlertForm message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertForm
                 * @static
                 * @param {priority.netitems.form.AlertForm} message AlertForm
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertForm.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.ValidUser = [];
                        object.ValidGroup = [];
                    }
                    if (options.defaults) {
                        object.ValidAllUsers = false;
                        object.ValidMySelf = false;
                        object.ValidUserInGroup = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.UpdateField = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.UpdateField = options.longs === String ? "0" : 0;
                        object.MultiComp = false;
                    }
                    if (message.ValidUser && message.ValidUser.length) {
                        object.ValidUser = [];
                        for (var j = 0; j < message.ValidUser.length; ++j)
                            if (typeof message.ValidUser[j] === "number")
                                object.ValidUser[j] = options.longs === String ? String(message.ValidUser[j]) : message.ValidUser[j];
                            else
                                object.ValidUser[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ValidUser[j]) : options.longs === Number ? new $util.LongBits(message.ValidUser[j].low >>> 0, message.ValidUser[j].high >>> 0).toNumber() : message.ValidUser[j];
                    }
                    if (message.ValidGroup && message.ValidGroup.length) {
                        object.ValidGroup = [];
                        for (var j = 0; j < message.ValidGroup.length; ++j)
                            if (typeof message.ValidGroup[j] === "number")
                                object.ValidGroup[j] = options.longs === String ? String(message.ValidGroup[j]) : message.ValidGroup[j];
                            else
                                object.ValidGroup[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ValidGroup[j]) : options.longs === Number ? new $util.LongBits(message.ValidGroup[j].low >>> 0, message.ValidGroup[j].high >>> 0).toNumber() : message.ValidGroup[j];
                    }
                    if (message.ValidAllUsers != null && message.hasOwnProperty("ValidAllUsers"))
                        object.ValidAllUsers = message.ValidAllUsers;
                    if (message.ValidMySelf != null && message.hasOwnProperty("ValidMySelf"))
                        object.ValidMySelf = message.ValidMySelf;
                    if (message.ValidUserInGroup != null && message.hasOwnProperty("ValidUserInGroup"))
                        object.ValidUserInGroup = message.ValidUserInGroup;
                    if (message.UpdateField != null && message.hasOwnProperty("UpdateField"))
                        if (typeof message.UpdateField === "number")
                            object.UpdateField = options.longs === String ? String(message.UpdateField) : message.UpdateField;
                        else
                            object.UpdateField = options.longs === String ? $util.Long.prototype.toString.call(message.UpdateField) : options.longs === Number ? new $util.LongBits(message.UpdateField.low >>> 0, message.UpdateField.high >>> 0).toNumber() : message.UpdateField;
                    if (message.MultiComp != null && message.hasOwnProperty("MultiComp"))
                        object.MultiComp = message.MultiComp;
                    return object;
                };

                /**
                 * Converts this AlertForm to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertForm
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertForm.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertForm;
            })();

            form.AlertMessage = (function() {

                /**
                 * Properties of an AlertMessage.
                 * @memberof priority.netitems.form
                 * @interface IAlertMessage
                 * @property {string|null} [Subject] AlertMessage Subject
                 * @property {string|null} [Message] AlertMessage Message
                 * @property {number|Long|null} [Language] AlertMessage Language
                 */

                /**
                 * Constructs a new AlertMessage.
                 * @memberof priority.netitems.form
                 * @classdesc Represents an AlertMessage.
                 * @implements IAlertMessage
                 * @constructor
                 * @param {priority.netitems.form.IAlertMessage=} [properties] Properties to set
                 */
                function AlertMessage(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AlertMessage Subject.
                 * @member {string} Subject
                 * @memberof priority.netitems.form.AlertMessage
                 * @instance
                 */
                AlertMessage.prototype.Subject = "";

                /**
                 * AlertMessage Message.
                 * @member {string} Message
                 * @memberof priority.netitems.form.AlertMessage
                 * @instance
                 */
                AlertMessage.prototype.Message = "";

                /**
                 * AlertMessage Language.
                 * @member {number|Long} Language
                 * @memberof priority.netitems.form.AlertMessage
                 * @instance
                 */
                AlertMessage.prototype.Language = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new AlertMessage instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.form.AlertMessage
                 * @static
                 * @param {priority.netitems.form.IAlertMessage=} [properties] Properties to set
                 * @returns {priority.netitems.form.AlertMessage} AlertMessage instance
                 */
                AlertMessage.create = function create(properties) {
                    return new AlertMessage(properties);
                };

                /**
                 * Encodes the specified AlertMessage message. Does not implicitly {@link priority.netitems.form.AlertMessage.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.form.AlertMessage
                 * @static
                 * @param {priority.netitems.form.IAlertMessage} message AlertMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertMessage.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Subject != null && Object.hasOwnProperty.call(message, "Subject"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Subject);
                    if (message.Message != null && Object.hasOwnProperty.call(message, "Message"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Message);
                    if (message.Language != null && Object.hasOwnProperty.call(message, "Language"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.Language);
                    return writer;
                };

                /**
                 * Encodes the specified AlertMessage message, length delimited. Does not implicitly {@link priority.netitems.form.AlertMessage.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.form.AlertMessage
                 * @static
                 * @param {priority.netitems.form.IAlertMessage} message AlertMessage message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AlertMessage.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AlertMessage message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.form.AlertMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.form.AlertMessage} AlertMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertMessage.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.form.AlertMessage();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Subject = reader.string();
                            break;
                        case 2:
                            message.Message = reader.string();
                            break;
                        case 3:
                            message.Language = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AlertMessage message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.form.AlertMessage
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.form.AlertMessage} AlertMessage
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AlertMessage.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AlertMessage message.
                 * @function verify
                 * @memberof priority.netitems.form.AlertMessage
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AlertMessage.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Subject != null && message.hasOwnProperty("Subject"))
                        if (!$util.isString(message.Subject))
                            return "Subject: string expected";
                    if (message.Message != null && message.hasOwnProperty("Message"))
                        if (!$util.isString(message.Message))
                            return "Message: string expected";
                    if (message.Language != null && message.hasOwnProperty("Language"))
                        if (!$util.isInteger(message.Language) && !(message.Language && $util.isInteger(message.Language.low) && $util.isInteger(message.Language.high)))
                            return "Language: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an AlertMessage message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.form.AlertMessage
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.form.AlertMessage} AlertMessage
                 */
                AlertMessage.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.form.AlertMessage)
                        return object;
                    var message = new $root.priority.netitems.form.AlertMessage();
                    if (object.Subject != null)
                        message.Subject = String(object.Subject);
                    if (object.Message != null)
                        message.Message = String(object.Message);
                    if (object.Language != null)
                        if ($util.Long)
                            (message.Language = $util.Long.fromValue(object.Language)).unsigned = false;
                        else if (typeof object.Language === "string")
                            message.Language = parseInt(object.Language, 10);
                        else if (typeof object.Language === "number")
                            message.Language = object.Language;
                        else if (typeof object.Language === "object")
                            message.Language = new $util.LongBits(object.Language.low >>> 0, object.Language.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an AlertMessage message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.form.AlertMessage
                 * @static
                 * @param {priority.netitems.form.AlertMessage} message AlertMessage
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AlertMessage.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Subject = "";
                        object.Message = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Language = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Language = options.longs === String ? "0" : 0;
                    }
                    if (message.Subject != null && message.hasOwnProperty("Subject"))
                        object.Subject = message.Subject;
                    if (message.Message != null && message.hasOwnProperty("Message"))
                        object.Message = message.Message;
                    if (message.Language != null && message.hasOwnProperty("Language"))
                        if (typeof message.Language === "number")
                            object.Language = options.longs === String ? String(message.Language) : message.Language;
                        else
                            object.Language = options.longs === String ? $util.Long.prototype.toString.call(message.Language) : options.longs === Number ? new $util.LongBits(message.Language.low >>> 0, message.Language.high >>> 0).toNumber() : message.Language;
                    return object;
                };

                /**
                 * Converts this AlertMessage to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.form.AlertMessage
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AlertMessage.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AlertMessage;
            })();

            return form;
        })();

        netitems.metadata = (function() {

            /**
             * Namespace metadata.
             * @memberof priority.netitems
             * @namespace
             */
            var metadata = {};

            metadata.AsapiDetails = (function() {

                /**
                 * Properties of an AsapiDetails.
                 * @memberof priority.netitems.metadata
                 * @interface IAsapiDetails
                 * @property {string|null} [ID] AsapiDetails ID
                 * @property {string|null} [Key] AsapiDetails Key
                 */

                /**
                 * Constructs a new AsapiDetails.
                 * @memberof priority.netitems.metadata
                 * @classdesc Represents an AsapiDetails.
                 * @implements IAsapiDetails
                 * @constructor
                 * @param {priority.netitems.metadata.IAsapiDetails=} [properties] Properties to set
                 */
                function AsapiDetails(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AsapiDetails ID.
                 * @member {string} ID
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @instance
                 */
                AsapiDetails.prototype.ID = "";

                /**
                 * AsapiDetails Key.
                 * @member {string} Key
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @instance
                 */
                AsapiDetails.prototype.Key = "";

                /**
                 * Creates a new AsapiDetails instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @static
                 * @param {priority.netitems.metadata.IAsapiDetails=} [properties] Properties to set
                 * @returns {priority.netitems.metadata.AsapiDetails} AsapiDetails instance
                 */
                AsapiDetails.create = function create(properties) {
                    return new AsapiDetails(properties);
                };

                /**
                 * Encodes the specified AsapiDetails message. Does not implicitly {@link priority.netitems.metadata.AsapiDetails.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @static
                 * @param {priority.netitems.metadata.IAsapiDetails} message AsapiDetails message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AsapiDetails.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ID != null && Object.hasOwnProperty.call(message, "ID"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
                    if (message.Key != null && Object.hasOwnProperty.call(message, "Key"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Key);
                    return writer;
                };

                /**
                 * Encodes the specified AsapiDetails message, length delimited. Does not implicitly {@link priority.netitems.metadata.AsapiDetails.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @static
                 * @param {priority.netitems.metadata.IAsapiDetails} message AsapiDetails message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AsapiDetails.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AsapiDetails message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.metadata.AsapiDetails} AsapiDetails
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AsapiDetails.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.metadata.AsapiDetails();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ID = reader.string();
                            break;
                        case 2:
                            message.Key = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AsapiDetails message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.metadata.AsapiDetails} AsapiDetails
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AsapiDetails.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AsapiDetails message.
                 * @function verify
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AsapiDetails.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ID != null && message.hasOwnProperty("ID"))
                        if (!$util.isString(message.ID))
                            return "ID: string expected";
                    if (message.Key != null && message.hasOwnProperty("Key"))
                        if (!$util.isString(message.Key))
                            return "Key: string expected";
                    return null;
                };

                /**
                 * Creates an AsapiDetails message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.metadata.AsapiDetails} AsapiDetails
                 */
                AsapiDetails.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.metadata.AsapiDetails)
                        return object;
                    var message = new $root.priority.netitems.metadata.AsapiDetails();
                    if (object.ID != null)
                        message.ID = String(object.ID);
                    if (object.Key != null)
                        message.Key = String(object.Key);
                    return message;
                };

                /**
                 * Creates a plain object from an AsapiDetails message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @static
                 * @param {priority.netitems.metadata.AsapiDetails} message AsapiDetails
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AsapiDetails.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.ID = "";
                        object.Key = "";
                    }
                    if (message.ID != null && message.hasOwnProperty("ID"))
                        object.ID = message.ID;
                    if (message.Key != null && message.hasOwnProperty("Key"))
                        object.Key = message.Key;
                    return object;
                };

                /**
                 * Converts this AsapiDetails to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.metadata.AsapiDetails
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AsapiDetails.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AsapiDetails;
            })();

            metadata.Location = (function() {

                /**
                 * Properties of a Location.
                 * @memberof priority.netitems.metadata
                 * @interface ILocation
                 * @property {string|null} [Address] Location Address
                 * @property {string|null} [Latitude] Location Latitude
                 * @property {string|null} [Longitude] Location Longitude
                 */

                /**
                 * Constructs a new Location.
                 * @memberof priority.netitems.metadata
                 * @classdesc Represents a Location.
                 * @implements ILocation
                 * @constructor
                 * @param {priority.netitems.metadata.ILocation=} [properties] Properties to set
                 */
                function Location(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Location Address.
                 * @member {string} Address
                 * @memberof priority.netitems.metadata.Location
                 * @instance
                 */
                Location.prototype.Address = "";

                /**
                 * Location Latitude.
                 * @member {string} Latitude
                 * @memberof priority.netitems.metadata.Location
                 * @instance
                 */
                Location.prototype.Latitude = "";

                /**
                 * Location Longitude.
                 * @member {string} Longitude
                 * @memberof priority.netitems.metadata.Location
                 * @instance
                 */
                Location.prototype.Longitude = "";

                /**
                 * Creates a new Location instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.metadata.Location
                 * @static
                 * @param {priority.netitems.metadata.ILocation=} [properties] Properties to set
                 * @returns {priority.netitems.metadata.Location} Location instance
                 */
                Location.create = function create(properties) {
                    return new Location(properties);
                };

                /**
                 * Encodes the specified Location message. Does not implicitly {@link priority.netitems.metadata.Location.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.metadata.Location
                 * @static
                 * @param {priority.netitems.metadata.ILocation} message Location message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Location.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Address != null && Object.hasOwnProperty.call(message, "Address"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Address);
                    if (message.Latitude != null && Object.hasOwnProperty.call(message, "Latitude"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Latitude);
                    if (message.Longitude != null && Object.hasOwnProperty.call(message, "Longitude"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Longitude);
                    return writer;
                };

                /**
                 * Encodes the specified Location message, length delimited. Does not implicitly {@link priority.netitems.metadata.Location.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.metadata.Location
                 * @static
                 * @param {priority.netitems.metadata.ILocation} message Location message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Location.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Location message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.metadata.Location
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.metadata.Location} Location
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Location.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.metadata.Location();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Address = reader.string();
                            break;
                        case 2:
                            message.Latitude = reader.string();
                            break;
                        case 3:
                            message.Longitude = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Location message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.metadata.Location
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.metadata.Location} Location
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Location.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Location message.
                 * @function verify
                 * @memberof priority.netitems.metadata.Location
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Location.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Address != null && message.hasOwnProperty("Address"))
                        if (!$util.isString(message.Address))
                            return "Address: string expected";
                    if (message.Latitude != null && message.hasOwnProperty("Latitude"))
                        if (!$util.isString(message.Latitude))
                            return "Latitude: string expected";
                    if (message.Longitude != null && message.hasOwnProperty("Longitude"))
                        if (!$util.isString(message.Longitude))
                            return "Longitude: string expected";
                    return null;
                };

                /**
                 * Creates a Location message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.metadata.Location
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.metadata.Location} Location
                 */
                Location.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.metadata.Location)
                        return object;
                    var message = new $root.priority.netitems.metadata.Location();
                    if (object.Address != null)
                        message.Address = String(object.Address);
                    if (object.Latitude != null)
                        message.Latitude = String(object.Latitude);
                    if (object.Longitude != null)
                        message.Longitude = String(object.Longitude);
                    return message;
                };

                /**
                 * Creates a plain object from a Location message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.metadata.Location
                 * @static
                 * @param {priority.netitems.metadata.Location} message Location
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Location.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Address = "";
                        object.Latitude = "";
                        object.Longitude = "";
                    }
                    if (message.Address != null && message.hasOwnProperty("Address"))
                        object.Address = message.Address;
                    if (message.Latitude != null && message.hasOwnProperty("Latitude"))
                        object.Latitude = message.Latitude;
                    if (message.Longitude != null && message.hasOwnProperty("Longitude"))
                        object.Longitude = message.Longitude;
                    return object;
                };

                /**
                 * Converts this Location to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.metadata.Location
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Location.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Location;
            })();

            metadata.TimeZone = (function() {

                /**
                 * Properties of a TimeZone.
                 * @memberof priority.netitems.metadata
                 * @interface ITimeZone
                 * @property {number|null} [Diff] TimeZone Diff
                 * @property {string|null} [IANA] TimeZone IANA
                 */

                /**
                 * Constructs a new TimeZone.
                 * @memberof priority.netitems.metadata
                 * @classdesc Represents a TimeZone.
                 * @implements ITimeZone
                 * @constructor
                 * @param {priority.netitems.metadata.ITimeZone=} [properties] Properties to set
                 */
                function TimeZone(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TimeZone Diff.
                 * @member {number} Diff
                 * @memberof priority.netitems.metadata.TimeZone
                 * @instance
                 */
                TimeZone.prototype.Diff = 0;

                /**
                 * TimeZone IANA.
                 * @member {string} IANA
                 * @memberof priority.netitems.metadata.TimeZone
                 * @instance
                 */
                TimeZone.prototype.IANA = "";

                /**
                 * Creates a new TimeZone instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.metadata.TimeZone
                 * @static
                 * @param {priority.netitems.metadata.ITimeZone=} [properties] Properties to set
                 * @returns {priority.netitems.metadata.TimeZone} TimeZone instance
                 */
                TimeZone.create = function create(properties) {
                    return new TimeZone(properties);
                };

                /**
                 * Encodes the specified TimeZone message. Does not implicitly {@link priority.netitems.metadata.TimeZone.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.metadata.TimeZone
                 * @static
                 * @param {priority.netitems.metadata.ITimeZone} message TimeZone message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TimeZone.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Diff != null && Object.hasOwnProperty.call(message, "Diff"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Diff);
                    if (message.IANA != null && Object.hasOwnProperty.call(message, "IANA"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.IANA);
                    return writer;
                };

                /**
                 * Encodes the specified TimeZone message, length delimited. Does not implicitly {@link priority.netitems.metadata.TimeZone.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.metadata.TimeZone
                 * @static
                 * @param {priority.netitems.metadata.ITimeZone} message TimeZone message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TimeZone.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TimeZone message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.metadata.TimeZone
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.metadata.TimeZone} TimeZone
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TimeZone.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.metadata.TimeZone();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Diff = reader.int32();
                            break;
                        case 2:
                            message.IANA = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TimeZone message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.metadata.TimeZone
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.metadata.TimeZone} TimeZone
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TimeZone.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TimeZone message.
                 * @function verify
                 * @memberof priority.netitems.metadata.TimeZone
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TimeZone.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Diff != null && message.hasOwnProperty("Diff"))
                        if (!$util.isInteger(message.Diff))
                            return "Diff: integer expected";
                    if (message.IANA != null && message.hasOwnProperty("IANA"))
                        if (!$util.isString(message.IANA))
                            return "IANA: string expected";
                    return null;
                };

                /**
                 * Creates a TimeZone message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.metadata.TimeZone
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.metadata.TimeZone} TimeZone
                 */
                TimeZone.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.metadata.TimeZone)
                        return object;
                    var message = new $root.priority.netitems.metadata.TimeZone();
                    if (object.Diff != null)
                        message.Diff = object.Diff | 0;
                    if (object.IANA != null)
                        message.IANA = String(object.IANA);
                    return message;
                };

                /**
                 * Creates a plain object from a TimeZone message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.metadata.TimeZone
                 * @static
                 * @param {priority.netitems.metadata.TimeZone} message TimeZone
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TimeZone.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Diff = 0;
                        object.IANA = "";
                    }
                    if (message.Diff != null && message.hasOwnProperty("Diff"))
                        object.Diff = message.Diff;
                    if (message.IANA != null && message.hasOwnProperty("IANA"))
                        object.IANA = message.IANA;
                    return object;
                };

                /**
                 * Converts this TimeZone to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.metadata.TimeZone
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TimeZone.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TimeZone;
            })();

            metadata.Credentials = (function() {

                /**
                 * Properties of a Credentials.
                 * @memberof priority.netitems.metadata
                 * @interface ICredentials
                 * @property {priority.netitems.metadata.Credentials.IBasic|null} [Simple] Credentials Simple
                 * @property {priority.netitems.metadata.Credentials.IBearer|null} [Openid] Credentials Openid
                 */

                /**
                 * Constructs a new Credentials.
                 * @memberof priority.netitems.metadata
                 * @classdesc Represents a Credentials.
                 * @implements ICredentials
                 * @constructor
                 * @param {priority.netitems.metadata.ICredentials=} [properties] Properties to set
                 */
                function Credentials(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Credentials Simple.
                 * @member {priority.netitems.metadata.Credentials.IBasic|null|undefined} Simple
                 * @memberof priority.netitems.metadata.Credentials
                 * @instance
                 */
                Credentials.prototype.Simple = null;

                /**
                 * Credentials Openid.
                 * @member {priority.netitems.metadata.Credentials.IBearer|null|undefined} Openid
                 * @memberof priority.netitems.metadata.Credentials
                 * @instance
                 */
                Credentials.prototype.Openid = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Credentials Creds.
                 * @member {"Simple"|"Openid"|undefined} Creds
                 * @memberof priority.netitems.metadata.Credentials
                 * @instance
                 */
                Object.defineProperty(Credentials.prototype, "Creds", {
                    get: $util.oneOfGetter($oneOfFields = ["Simple", "Openid"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Credentials instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.metadata.Credentials
                 * @static
                 * @param {priority.netitems.metadata.ICredentials=} [properties] Properties to set
                 * @returns {priority.netitems.metadata.Credentials} Credentials instance
                 */
                Credentials.create = function create(properties) {
                    return new Credentials(properties);
                };

                /**
                 * Encodes the specified Credentials message. Does not implicitly {@link priority.netitems.metadata.Credentials.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.metadata.Credentials
                 * @static
                 * @param {priority.netitems.metadata.ICredentials} message Credentials message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Credentials.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Simple != null && Object.hasOwnProperty.call(message, "Simple"))
                        $root.priority.netitems.metadata.Credentials.Basic.encode(message.Simple, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Openid != null && Object.hasOwnProperty.call(message, "Openid"))
                        $root.priority.netitems.metadata.Credentials.Bearer.encode(message.Openid, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Credentials message, length delimited. Does not implicitly {@link priority.netitems.metadata.Credentials.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.metadata.Credentials
                 * @static
                 * @param {priority.netitems.metadata.ICredentials} message Credentials message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Credentials.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Credentials message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.metadata.Credentials
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.metadata.Credentials} Credentials
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Credentials.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.metadata.Credentials();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Simple = $root.priority.netitems.metadata.Credentials.Basic.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Openid = $root.priority.netitems.metadata.Credentials.Bearer.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Credentials message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.metadata.Credentials
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.metadata.Credentials} Credentials
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Credentials.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Credentials message.
                 * @function verify
                 * @memberof priority.netitems.metadata.Credentials
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Credentials.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Simple != null && message.hasOwnProperty("Simple")) {
                        properties.Creds = 1;
                        {
                            var error = $root.priority.netitems.metadata.Credentials.Basic.verify(message.Simple);
                            if (error)
                                return "Simple." + error;
                        }
                    }
                    if (message.Openid != null && message.hasOwnProperty("Openid")) {
                        if (properties.Creds === 1)
                            return "Creds: multiple values";
                        properties.Creds = 1;
                        {
                            var error = $root.priority.netitems.metadata.Credentials.Bearer.verify(message.Openid);
                            if (error)
                                return "Openid." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Credentials message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.metadata.Credentials
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.metadata.Credentials} Credentials
                 */
                Credentials.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.metadata.Credentials)
                        return object;
                    var message = new $root.priority.netitems.metadata.Credentials();
                    if (object.Simple != null) {
                        if (typeof object.Simple !== "object")
                            throw TypeError(".priority.netitems.metadata.Credentials.Simple: object expected");
                        message.Simple = $root.priority.netitems.metadata.Credentials.Basic.fromObject(object.Simple);
                    }
                    if (object.Openid != null) {
                        if (typeof object.Openid !== "object")
                            throw TypeError(".priority.netitems.metadata.Credentials.Openid: object expected");
                        message.Openid = $root.priority.netitems.metadata.Credentials.Bearer.fromObject(object.Openid);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Credentials message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.metadata.Credentials
                 * @static
                 * @param {priority.netitems.metadata.Credentials} message Credentials
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Credentials.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.Simple != null && message.hasOwnProperty("Simple")) {
                        object.Simple = $root.priority.netitems.metadata.Credentials.Basic.toObject(message.Simple, options);
                        if (options.oneofs)
                            object.Creds = "Simple";
                    }
                    if (message.Openid != null && message.hasOwnProperty("Openid")) {
                        object.Openid = $root.priority.netitems.metadata.Credentials.Bearer.toObject(message.Openid, options);
                        if (options.oneofs)
                            object.Creds = "Openid";
                    }
                    return object;
                };

                /**
                 * Converts this Credentials to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.metadata.Credentials
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Credentials.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                Credentials.Basic = (function() {

                    /**
                     * Properties of a Basic.
                     * @memberof priority.netitems.metadata.Credentials
                     * @interface IBasic
                     * @property {string|null} [Userlogin] Basic Userlogin
                     * @property {string|null} [Password] Basic Password
                     */

                    /**
                     * Constructs a new Basic.
                     * @memberof priority.netitems.metadata.Credentials
                     * @classdesc Represents a Basic.
                     * @implements IBasic
                     * @constructor
                     * @param {priority.netitems.metadata.Credentials.IBasic=} [properties] Properties to set
                     */
                    function Basic(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Basic Userlogin.
                     * @member {string} Userlogin
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @instance
                     */
                    Basic.prototype.Userlogin = "";

                    /**
                     * Basic Password.
                     * @member {string} Password
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @instance
                     */
                    Basic.prototype.Password = "";

                    /**
                     * Creates a new Basic instance using the specified properties.
                     * @function create
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @static
                     * @param {priority.netitems.metadata.Credentials.IBasic=} [properties] Properties to set
                     * @returns {priority.netitems.metadata.Credentials.Basic} Basic instance
                     */
                    Basic.create = function create(properties) {
                        return new Basic(properties);
                    };

                    /**
                     * Encodes the specified Basic message. Does not implicitly {@link priority.netitems.metadata.Credentials.Basic.verify|verify} messages.
                     * @function encode
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @static
                     * @param {priority.netitems.metadata.Credentials.IBasic} message Basic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Basic.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.Userlogin != null && Object.hasOwnProperty.call(message, "Userlogin"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Userlogin);
                        if (message.Password != null && Object.hasOwnProperty.call(message, "Password"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Password);
                        return writer;
                    };

                    /**
                     * Encodes the specified Basic message, length delimited. Does not implicitly {@link priority.netitems.metadata.Credentials.Basic.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @static
                     * @param {priority.netitems.metadata.Credentials.IBasic} message Basic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Basic.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Basic message from the specified reader or buffer.
                     * @function decode
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {priority.netitems.metadata.Credentials.Basic} Basic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Basic.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.metadata.Credentials.Basic();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.Userlogin = reader.string();
                                break;
                            case 2:
                                message.Password = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Basic message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {priority.netitems.metadata.Credentials.Basic} Basic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Basic.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Basic message.
                     * @function verify
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Basic.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.Userlogin != null && message.hasOwnProperty("Userlogin"))
                            if (!$util.isString(message.Userlogin))
                                return "Userlogin: string expected";
                        if (message.Password != null && message.hasOwnProperty("Password"))
                            if (!$util.isString(message.Password))
                                return "Password: string expected";
                        return null;
                    };

                    /**
                     * Creates a Basic message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {priority.netitems.metadata.Credentials.Basic} Basic
                     */
                    Basic.fromObject = function fromObject(object) {
                        if (object instanceof $root.priority.netitems.metadata.Credentials.Basic)
                            return object;
                        var message = new $root.priority.netitems.metadata.Credentials.Basic();
                        if (object.Userlogin != null)
                            message.Userlogin = String(object.Userlogin);
                        if (object.Password != null)
                            message.Password = String(object.Password);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Basic message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @static
                     * @param {priority.netitems.metadata.Credentials.Basic} message Basic
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Basic.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.Userlogin = "";
                            object.Password = "";
                        }
                        if (message.Userlogin != null && message.hasOwnProperty("Userlogin"))
                            object.Userlogin = message.Userlogin;
                        if (message.Password != null && message.hasOwnProperty("Password"))
                            object.Password = message.Password;
                        return object;
                    };

                    /**
                     * Converts this Basic to JSON.
                     * @function toJSON
                     * @memberof priority.netitems.metadata.Credentials.Basic
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Basic.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Basic;
                })();

                Credentials.Bearer = (function() {

                    /**
                     * Properties of a Bearer.
                     * @memberof priority.netitems.metadata.Credentials
                     * @interface IBearer
                     * @property {string|null} [Token] Bearer Token
                     */

                    /**
                     * Constructs a new Bearer.
                     * @memberof priority.netitems.metadata.Credentials
                     * @classdesc Represents a Bearer.
                     * @implements IBearer
                     * @constructor
                     * @param {priority.netitems.metadata.Credentials.IBearer=} [properties] Properties to set
                     */
                    function Bearer(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }

                    /**
                     * Bearer Token.
                     * @member {string} Token
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @instance
                     */
                    Bearer.prototype.Token = "";

                    /**
                     * Creates a new Bearer instance using the specified properties.
                     * @function create
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @static
                     * @param {priority.netitems.metadata.Credentials.IBearer=} [properties] Properties to set
                     * @returns {priority.netitems.metadata.Credentials.Bearer} Bearer instance
                     */
                    Bearer.create = function create(properties) {
                        return new Bearer(properties);
                    };

                    /**
                     * Encodes the specified Bearer message. Does not implicitly {@link priority.netitems.metadata.Credentials.Bearer.verify|verify} messages.
                     * @function encode
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @static
                     * @param {priority.netitems.metadata.Credentials.IBearer} message Bearer message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Bearer.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.Token != null && Object.hasOwnProperty.call(message, "Token"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Token);
                        return writer;
                    };

                    /**
                     * Encodes the specified Bearer message, length delimited. Does not implicitly {@link priority.netitems.metadata.Credentials.Bearer.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @static
                     * @param {priority.netitems.metadata.Credentials.IBearer} message Bearer message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Bearer.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };

                    /**
                     * Decodes a Bearer message from the specified reader or buffer.
                     * @function decode
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {priority.netitems.metadata.Credentials.Bearer} Bearer
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Bearer.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.metadata.Credentials.Bearer();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.Token = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };

                    /**
                     * Decodes a Bearer message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {priority.netitems.metadata.Credentials.Bearer} Bearer
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Bearer.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };

                    /**
                     * Verifies a Bearer message.
                     * @function verify
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Bearer.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.Token != null && message.hasOwnProperty("Token"))
                            if (!$util.isString(message.Token))
                                return "Token: string expected";
                        return null;
                    };

                    /**
                     * Creates a Bearer message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {priority.netitems.metadata.Credentials.Bearer} Bearer
                     */
                    Bearer.fromObject = function fromObject(object) {
                        if (object instanceof $root.priority.netitems.metadata.Credentials.Bearer)
                            return object;
                        var message = new $root.priority.netitems.metadata.Credentials.Bearer();
                        if (object.Token != null)
                            message.Token = String(object.Token);
                        return message;
                    };

                    /**
                     * Creates a plain object from a Bearer message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @static
                     * @param {priority.netitems.metadata.Credentials.Bearer} message Bearer
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Bearer.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.Token = "";
                        if (message.Token != null && message.hasOwnProperty("Token"))
                            object.Token = message.Token;
                        return object;
                    };

                    /**
                     * Converts this Bearer to JSON.
                     * @function toJSON
                     * @memberof priority.netitems.metadata.Credentials.Bearer
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Bearer.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };

                    return Bearer;
                })();

                return Credentials;
            })();

            metadata.AdditionalProperties = (function() {

                /**
                 * Properties of an AdditionalProperties.
                 * @memberof priority.netitems.metadata
                 * @interface IAdditionalProperties
                 * @property {string|null} [TenantID] AdditionalProperties TenantID
                 * @property {string|null} [Tabulaini] AdditionalProperties Tabulaini
                 * @property {string|null} [Dname] AdditionalProperties Dname
                 * @property {number|Long|null} [Language] AdditionalProperties Language
                 * @property {boolean|null} [Debug] AdditionalProperties Debug
                 * @property {string|null} [Userlogin] AdditionalProperties Userlogin
                 * @property {string|null} [ApplicationName] AdditionalProperties ApplicationName
                 * @property {priority.netitems.metadata.IAsapiDetails|null} [Asapi] AdditionalProperties Asapi
                 * @property {priority.netitems.metadata.ILocation|null} [Location] AdditionalProperties Location
                 * @property {priority.netitems.metadata.ITimeZone|null} [Timezone] AdditionalProperties Timezone
                 * @property {boolean|null} [PluginEnabled] AdditionalProperties PluginEnabled
                 * @property {priority.netitems.metadata.ICredentials|null} [Credentials] AdditionalProperties Credentials
                 * @property {boolean|null} [IsWebSDK] AdditionalProperties IsWebSDK
                 * @property {string|null} [OtherInfo] AdditionalProperties OtherInfo
                 * @property {boolean|null} [Trace] AdditionalProperties Trace
                 * @property {priority.netitems.metadata.AdditionalProperties.ADCInternal|null} [Adc] AdditionalProperties Adc
                 * @property {number|Long|null} [TraceID] AdditionalProperties TraceID
                 * @property {number|Long|null} [SpandID] AdditionalProperties SpandID
                 * @property {number|Long|null} [UserID] AdditionalProperties UserID
                 * @property {number|Long|null} [DebugServer] AdditionalProperties DebugServer
                 * @property {number|Long|null} [CustomTimeoutSeconds] AdditionalProperties CustomTimeoutSeconds
                 */

                /**
                 * Constructs a new AdditionalProperties.
                 * @memberof priority.netitems.metadata
                 * @classdesc Represents an AdditionalProperties.
                 * @implements IAdditionalProperties
                 * @constructor
                 * @param {priority.netitems.metadata.IAdditionalProperties=} [properties] Properties to set
                 */
                function AdditionalProperties(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AdditionalProperties TenantID.
                 * @member {string} TenantID
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.TenantID = "";

                /**
                 * AdditionalProperties Tabulaini.
                 * @member {string} Tabulaini
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Tabulaini = "";

                /**
                 * AdditionalProperties Dname.
                 * @member {string} Dname
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Dname = "";

                /**
                 * AdditionalProperties Language.
                 * @member {number|Long} Language
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Language = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AdditionalProperties Debug.
                 * @member {boolean} Debug
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Debug = false;

                /**
                 * AdditionalProperties Userlogin.
                 * @member {string} Userlogin
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Userlogin = "";

                /**
                 * AdditionalProperties ApplicationName.
                 * @member {string} ApplicationName
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.ApplicationName = "";

                /**
                 * AdditionalProperties Asapi.
                 * @member {priority.netitems.metadata.IAsapiDetails|null|undefined} Asapi
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Asapi = null;

                /**
                 * AdditionalProperties Location.
                 * @member {priority.netitems.metadata.ILocation|null|undefined} Location
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Location = null;

                /**
                 * AdditionalProperties Timezone.
                 * @member {priority.netitems.metadata.ITimeZone|null|undefined} Timezone
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Timezone = null;

                /**
                 * AdditionalProperties PluginEnabled.
                 * @member {boolean} PluginEnabled
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.PluginEnabled = false;

                /**
                 * AdditionalProperties Credentials.
                 * @member {priority.netitems.metadata.ICredentials|null|undefined} Credentials
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Credentials = null;

                /**
                 * AdditionalProperties IsWebSDK.
                 * @member {boolean} IsWebSDK
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.IsWebSDK = false;

                /**
                 * AdditionalProperties OtherInfo.
                 * @member {string} OtherInfo
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.OtherInfo = "";

                /**
                 * AdditionalProperties Trace.
                 * @member {boolean} Trace
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Trace = false;

                /**
                 * AdditionalProperties Adc.
                 * @member {priority.netitems.metadata.AdditionalProperties.ADCInternal} Adc
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.Adc = 0;

                /**
                 * AdditionalProperties TraceID.
                 * @member {number|Long} TraceID
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.TraceID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

                /**
                 * AdditionalProperties SpandID.
                 * @member {number|Long} SpandID
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.SpandID = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

                /**
                 * AdditionalProperties UserID.
                 * @member {number|Long} UserID
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.UserID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AdditionalProperties DebugServer.
                 * @member {number|Long} DebugServer
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.DebugServer = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * AdditionalProperties CustomTimeoutSeconds.
                 * @member {number|Long} CustomTimeoutSeconds
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 */
                AdditionalProperties.prototype.CustomTimeoutSeconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new AdditionalProperties instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @static
                 * @param {priority.netitems.metadata.IAdditionalProperties=} [properties] Properties to set
                 * @returns {priority.netitems.metadata.AdditionalProperties} AdditionalProperties instance
                 */
                AdditionalProperties.create = function create(properties) {
                    return new AdditionalProperties(properties);
                };

                /**
                 * Encodes the specified AdditionalProperties message. Does not implicitly {@link priority.netitems.metadata.AdditionalProperties.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @static
                 * @param {priority.netitems.metadata.IAdditionalProperties} message AdditionalProperties message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AdditionalProperties.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.TenantID != null && Object.hasOwnProperty.call(message, "TenantID"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.TenantID);
                    if (message.Tabulaini != null && Object.hasOwnProperty.call(message, "Tabulaini"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Tabulaini);
                    if (message.Dname != null && Object.hasOwnProperty.call(message, "Dname"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Dname);
                    if (message.Language != null && Object.hasOwnProperty.call(message, "Language"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.Language);
                    if (message.Debug != null && Object.hasOwnProperty.call(message, "Debug"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.Debug);
                    if (message.Userlogin != null && Object.hasOwnProperty.call(message, "Userlogin"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.Userlogin);
                    if (message.ApplicationName != null && Object.hasOwnProperty.call(message, "ApplicationName"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.ApplicationName);
                    if (message.Asapi != null && Object.hasOwnProperty.call(message, "Asapi"))
                        $root.priority.netitems.metadata.AsapiDetails.encode(message.Asapi, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.Location != null && Object.hasOwnProperty.call(message, "Location"))
                        $root.priority.netitems.metadata.Location.encode(message.Location, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.Timezone != null && Object.hasOwnProperty.call(message, "Timezone"))
                        $root.priority.netitems.metadata.TimeZone.encode(message.Timezone, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.PluginEnabled != null && Object.hasOwnProperty.call(message, "PluginEnabled"))
                        writer.uint32(/* id 11, wireType 0 =*/88).bool(message.PluginEnabled);
                    if (message.Credentials != null && Object.hasOwnProperty.call(message, "Credentials"))
                        $root.priority.netitems.metadata.Credentials.encode(message.Credentials, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.IsWebSDK != null && Object.hasOwnProperty.call(message, "IsWebSDK"))
                        writer.uint32(/* id 13, wireType 0 =*/104).bool(message.IsWebSDK);
                    if (message.OtherInfo != null && Object.hasOwnProperty.call(message, "OtherInfo"))
                        writer.uint32(/* id 14, wireType 2 =*/114).string(message.OtherInfo);
                    if (message.Trace != null && Object.hasOwnProperty.call(message, "Trace"))
                        writer.uint32(/* id 15, wireType 0 =*/120).bool(message.Trace);
                    if (message.Adc != null && Object.hasOwnProperty.call(message, "Adc"))
                        writer.uint32(/* id 16, wireType 0 =*/128).int32(message.Adc);
                    if (message.TraceID != null && Object.hasOwnProperty.call(message, "TraceID"))
                        writer.uint32(/* id 17, wireType 0 =*/136).uint64(message.TraceID);
                    if (message.SpandID != null && Object.hasOwnProperty.call(message, "SpandID"))
                        writer.uint32(/* id 18, wireType 0 =*/144).uint64(message.SpandID);
                    if (message.UserID != null && Object.hasOwnProperty.call(message, "UserID"))
                        writer.uint32(/* id 19, wireType 0 =*/152).int64(message.UserID);
                    if (message.DebugServer != null && Object.hasOwnProperty.call(message, "DebugServer"))
                        writer.uint32(/* id 20, wireType 0 =*/160).int64(message.DebugServer);
                    if (message.CustomTimeoutSeconds != null && Object.hasOwnProperty.call(message, "CustomTimeoutSeconds"))
                        writer.uint32(/* id 21, wireType 0 =*/168).int64(message.CustomTimeoutSeconds);
                    return writer;
                };

                /**
                 * Encodes the specified AdditionalProperties message, length delimited. Does not implicitly {@link priority.netitems.metadata.AdditionalProperties.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @static
                 * @param {priority.netitems.metadata.IAdditionalProperties} message AdditionalProperties message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AdditionalProperties.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AdditionalProperties message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.metadata.AdditionalProperties} AdditionalProperties
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AdditionalProperties.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.metadata.AdditionalProperties();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.TenantID = reader.string();
                            break;
                        case 2:
                            message.Tabulaini = reader.string();
                            break;
                        case 3:
                            message.Dname = reader.string();
                            break;
                        case 4:
                            message.Language = reader.int64();
                            break;
                        case 5:
                            message.Debug = reader.bool();
                            break;
                        case 6:
                            message.Userlogin = reader.string();
                            break;
                        case 7:
                            message.ApplicationName = reader.string();
                            break;
                        case 8:
                            message.Asapi = $root.priority.netitems.metadata.AsapiDetails.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.Location = $root.priority.netitems.metadata.Location.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.Timezone = $root.priority.netitems.metadata.TimeZone.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.PluginEnabled = reader.bool();
                            break;
                        case 12:
                            message.Credentials = $root.priority.netitems.metadata.Credentials.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.IsWebSDK = reader.bool();
                            break;
                        case 14:
                            message.OtherInfo = reader.string();
                            break;
                        case 15:
                            message.Trace = reader.bool();
                            break;
                        case 16:
                            message.Adc = reader.int32();
                            break;
                        case 17:
                            message.TraceID = reader.uint64();
                            break;
                        case 18:
                            message.SpandID = reader.uint64();
                            break;
                        case 19:
                            message.UserID = reader.int64();
                            break;
                        case 20:
                            message.DebugServer = reader.int64();
                            break;
                        case 21:
                            message.CustomTimeoutSeconds = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AdditionalProperties message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.metadata.AdditionalProperties} AdditionalProperties
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AdditionalProperties.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AdditionalProperties message.
                 * @function verify
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AdditionalProperties.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                        if (!$util.isString(message.TenantID))
                            return "TenantID: string expected";
                    if (message.Tabulaini != null && message.hasOwnProperty("Tabulaini"))
                        if (!$util.isString(message.Tabulaini))
                            return "Tabulaini: string expected";
                    if (message.Dname != null && message.hasOwnProperty("Dname"))
                        if (!$util.isString(message.Dname))
                            return "Dname: string expected";
                    if (message.Language != null && message.hasOwnProperty("Language"))
                        if (!$util.isInteger(message.Language) && !(message.Language && $util.isInteger(message.Language.low) && $util.isInteger(message.Language.high)))
                            return "Language: integer|Long expected";
                    if (message.Debug != null && message.hasOwnProperty("Debug"))
                        if (typeof message.Debug !== "boolean")
                            return "Debug: boolean expected";
                    if (message.Userlogin != null && message.hasOwnProperty("Userlogin"))
                        if (!$util.isString(message.Userlogin))
                            return "Userlogin: string expected";
                    if (message.ApplicationName != null && message.hasOwnProperty("ApplicationName"))
                        if (!$util.isString(message.ApplicationName))
                            return "ApplicationName: string expected";
                    if (message.Asapi != null && message.hasOwnProperty("Asapi")) {
                        var error = $root.priority.netitems.metadata.AsapiDetails.verify(message.Asapi);
                        if (error)
                            return "Asapi." + error;
                    }
                    if (message.Location != null && message.hasOwnProperty("Location")) {
                        var error = $root.priority.netitems.metadata.Location.verify(message.Location);
                        if (error)
                            return "Location." + error;
                    }
                    if (message.Timezone != null && message.hasOwnProperty("Timezone")) {
                        var error = $root.priority.netitems.metadata.TimeZone.verify(message.Timezone);
                        if (error)
                            return "Timezone." + error;
                    }
                    if (message.PluginEnabled != null && message.hasOwnProperty("PluginEnabled"))
                        if (typeof message.PluginEnabled !== "boolean")
                            return "PluginEnabled: boolean expected";
                    if (message.Credentials != null && message.hasOwnProperty("Credentials")) {
                        var error = $root.priority.netitems.metadata.Credentials.verify(message.Credentials);
                        if (error)
                            return "Credentials." + error;
                    }
                    if (message.IsWebSDK != null && message.hasOwnProperty("IsWebSDK"))
                        if (typeof message.IsWebSDK !== "boolean")
                            return "IsWebSDK: boolean expected";
                    if (message.OtherInfo != null && message.hasOwnProperty("OtherInfo"))
                        if (!$util.isString(message.OtherInfo))
                            return "OtherInfo: string expected";
                    if (message.Trace != null && message.hasOwnProperty("Trace"))
                        if (typeof message.Trace !== "boolean")
                            return "Trace: boolean expected";
                    if (message.Adc != null && message.hasOwnProperty("Adc"))
                        switch (message.Adc) {
                        default:
                            return "Adc: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.TraceID != null && message.hasOwnProperty("TraceID"))
                        if (!$util.isInteger(message.TraceID) && !(message.TraceID && $util.isInteger(message.TraceID.low) && $util.isInteger(message.TraceID.high)))
                            return "TraceID: integer|Long expected";
                    if (message.SpandID != null && message.hasOwnProperty("SpandID"))
                        if (!$util.isInteger(message.SpandID) && !(message.SpandID && $util.isInteger(message.SpandID.low) && $util.isInteger(message.SpandID.high)))
                            return "SpandID: integer|Long expected";
                    if (message.UserID != null && message.hasOwnProperty("UserID"))
                        if (!$util.isInteger(message.UserID) && !(message.UserID && $util.isInteger(message.UserID.low) && $util.isInteger(message.UserID.high)))
                            return "UserID: integer|Long expected";
                    if (message.DebugServer != null && message.hasOwnProperty("DebugServer"))
                        if (!$util.isInteger(message.DebugServer) && !(message.DebugServer && $util.isInteger(message.DebugServer.low) && $util.isInteger(message.DebugServer.high)))
                            return "DebugServer: integer|Long expected";
                    if (message.CustomTimeoutSeconds != null && message.hasOwnProperty("CustomTimeoutSeconds"))
                        if (!$util.isInteger(message.CustomTimeoutSeconds) && !(message.CustomTimeoutSeconds && $util.isInteger(message.CustomTimeoutSeconds.low) && $util.isInteger(message.CustomTimeoutSeconds.high)))
                            return "CustomTimeoutSeconds: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an AdditionalProperties message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.metadata.AdditionalProperties} AdditionalProperties
                 */
                AdditionalProperties.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.metadata.AdditionalProperties)
                        return object;
                    var message = new $root.priority.netitems.metadata.AdditionalProperties();
                    if (object.TenantID != null)
                        message.TenantID = String(object.TenantID);
                    if (object.Tabulaini != null)
                        message.Tabulaini = String(object.Tabulaini);
                    if (object.Dname != null)
                        message.Dname = String(object.Dname);
                    if (object.Language != null)
                        if ($util.Long)
                            (message.Language = $util.Long.fromValue(object.Language)).unsigned = false;
                        else if (typeof object.Language === "string")
                            message.Language = parseInt(object.Language, 10);
                        else if (typeof object.Language === "number")
                            message.Language = object.Language;
                        else if (typeof object.Language === "object")
                            message.Language = new $util.LongBits(object.Language.low >>> 0, object.Language.high >>> 0).toNumber();
                    if (object.Debug != null)
                        message.Debug = Boolean(object.Debug);
                    if (object.Userlogin != null)
                        message.Userlogin = String(object.Userlogin);
                    if (object.ApplicationName != null)
                        message.ApplicationName = String(object.ApplicationName);
                    if (object.Asapi != null) {
                        if (typeof object.Asapi !== "object")
                            throw TypeError(".priority.netitems.metadata.AdditionalProperties.Asapi: object expected");
                        message.Asapi = $root.priority.netitems.metadata.AsapiDetails.fromObject(object.Asapi);
                    }
                    if (object.Location != null) {
                        if (typeof object.Location !== "object")
                            throw TypeError(".priority.netitems.metadata.AdditionalProperties.Location: object expected");
                        message.Location = $root.priority.netitems.metadata.Location.fromObject(object.Location);
                    }
                    if (object.Timezone != null) {
                        if (typeof object.Timezone !== "object")
                            throw TypeError(".priority.netitems.metadata.AdditionalProperties.Timezone: object expected");
                        message.Timezone = $root.priority.netitems.metadata.TimeZone.fromObject(object.Timezone);
                    }
                    if (object.PluginEnabled != null)
                        message.PluginEnabled = Boolean(object.PluginEnabled);
                    if (object.Credentials != null) {
                        if (typeof object.Credentials !== "object")
                            throw TypeError(".priority.netitems.metadata.AdditionalProperties.Credentials: object expected");
                        message.Credentials = $root.priority.netitems.metadata.Credentials.fromObject(object.Credentials);
                    }
                    if (object.IsWebSDK != null)
                        message.IsWebSDK = Boolean(object.IsWebSDK);
                    if (object.OtherInfo != null)
                        message.OtherInfo = String(object.OtherInfo);
                    if (object.Trace != null)
                        message.Trace = Boolean(object.Trace);
                    switch (object.Adc) {
                    case "None":
                    case 0:
                        message.Adc = 0;
                        break;
                    case "WMS":
                    case 1:
                        message.Adc = 1;
                        break;
                    }
                    if (object.TraceID != null)
                        if ($util.Long)
                            (message.TraceID = $util.Long.fromValue(object.TraceID)).unsigned = true;
                        else if (typeof object.TraceID === "string")
                            message.TraceID = parseInt(object.TraceID, 10);
                        else if (typeof object.TraceID === "number")
                            message.TraceID = object.TraceID;
                        else if (typeof object.TraceID === "object")
                            message.TraceID = new $util.LongBits(object.TraceID.low >>> 0, object.TraceID.high >>> 0).toNumber(true);
                    if (object.SpandID != null)
                        if ($util.Long)
                            (message.SpandID = $util.Long.fromValue(object.SpandID)).unsigned = true;
                        else if (typeof object.SpandID === "string")
                            message.SpandID = parseInt(object.SpandID, 10);
                        else if (typeof object.SpandID === "number")
                            message.SpandID = object.SpandID;
                        else if (typeof object.SpandID === "object")
                            message.SpandID = new $util.LongBits(object.SpandID.low >>> 0, object.SpandID.high >>> 0).toNumber(true);
                    if (object.UserID != null)
                        if ($util.Long)
                            (message.UserID = $util.Long.fromValue(object.UserID)).unsigned = false;
                        else if (typeof object.UserID === "string")
                            message.UserID = parseInt(object.UserID, 10);
                        else if (typeof object.UserID === "number")
                            message.UserID = object.UserID;
                        else if (typeof object.UserID === "object")
                            message.UserID = new $util.LongBits(object.UserID.low >>> 0, object.UserID.high >>> 0).toNumber();
                    if (object.DebugServer != null)
                        if ($util.Long)
                            (message.DebugServer = $util.Long.fromValue(object.DebugServer)).unsigned = false;
                        else if (typeof object.DebugServer === "string")
                            message.DebugServer = parseInt(object.DebugServer, 10);
                        else if (typeof object.DebugServer === "number")
                            message.DebugServer = object.DebugServer;
                        else if (typeof object.DebugServer === "object")
                            message.DebugServer = new $util.LongBits(object.DebugServer.low >>> 0, object.DebugServer.high >>> 0).toNumber();
                    if (object.CustomTimeoutSeconds != null)
                        if ($util.Long)
                            (message.CustomTimeoutSeconds = $util.Long.fromValue(object.CustomTimeoutSeconds)).unsigned = false;
                        else if (typeof object.CustomTimeoutSeconds === "string")
                            message.CustomTimeoutSeconds = parseInt(object.CustomTimeoutSeconds, 10);
                        else if (typeof object.CustomTimeoutSeconds === "number")
                            message.CustomTimeoutSeconds = object.CustomTimeoutSeconds;
                        else if (typeof object.CustomTimeoutSeconds === "object")
                            message.CustomTimeoutSeconds = new $util.LongBits(object.CustomTimeoutSeconds.low >>> 0, object.CustomTimeoutSeconds.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an AdditionalProperties message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @static
                 * @param {priority.netitems.metadata.AdditionalProperties} message AdditionalProperties
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AdditionalProperties.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.TenantID = "";
                        object.Tabulaini = "";
                        object.Dname = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Language = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Language = options.longs === String ? "0" : 0;
                        object.Debug = false;
                        object.Userlogin = "";
                        object.ApplicationName = "";
                        object.Asapi = null;
                        object.Location = null;
                        object.Timezone = null;
                        object.PluginEnabled = false;
                        object.Credentials = null;
                        object.IsWebSDK = false;
                        object.OtherInfo = "";
                        object.Trace = false;
                        object.Adc = options.enums === String ? "None" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, true);
                            object.TraceID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.TraceID = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, true);
                            object.SpandID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.SpandID = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.UserID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.UserID = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.DebugServer = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.DebugServer = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.CustomTimeoutSeconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.CustomTimeoutSeconds = options.longs === String ? "0" : 0;
                    }
                    if (message.TenantID != null && message.hasOwnProperty("TenantID"))
                        object.TenantID = message.TenantID;
                    if (message.Tabulaini != null && message.hasOwnProperty("Tabulaini"))
                        object.Tabulaini = message.Tabulaini;
                    if (message.Dname != null && message.hasOwnProperty("Dname"))
                        object.Dname = message.Dname;
                    if (message.Language != null && message.hasOwnProperty("Language"))
                        if (typeof message.Language === "number")
                            object.Language = options.longs === String ? String(message.Language) : message.Language;
                        else
                            object.Language = options.longs === String ? $util.Long.prototype.toString.call(message.Language) : options.longs === Number ? new $util.LongBits(message.Language.low >>> 0, message.Language.high >>> 0).toNumber() : message.Language;
                    if (message.Debug != null && message.hasOwnProperty("Debug"))
                        object.Debug = message.Debug;
                    if (message.Userlogin != null && message.hasOwnProperty("Userlogin"))
                        object.Userlogin = message.Userlogin;
                    if (message.ApplicationName != null && message.hasOwnProperty("ApplicationName"))
                        object.ApplicationName = message.ApplicationName;
                    if (message.Asapi != null && message.hasOwnProperty("Asapi"))
                        object.Asapi = $root.priority.netitems.metadata.AsapiDetails.toObject(message.Asapi, options);
                    if (message.Location != null && message.hasOwnProperty("Location"))
                        object.Location = $root.priority.netitems.metadata.Location.toObject(message.Location, options);
                    if (message.Timezone != null && message.hasOwnProperty("Timezone"))
                        object.Timezone = $root.priority.netitems.metadata.TimeZone.toObject(message.Timezone, options);
                    if (message.PluginEnabled != null && message.hasOwnProperty("PluginEnabled"))
                        object.PluginEnabled = message.PluginEnabled;
                    if (message.Credentials != null && message.hasOwnProperty("Credentials"))
                        object.Credentials = $root.priority.netitems.metadata.Credentials.toObject(message.Credentials, options);
                    if (message.IsWebSDK != null && message.hasOwnProperty("IsWebSDK"))
                        object.IsWebSDK = message.IsWebSDK;
                    if (message.OtherInfo != null && message.hasOwnProperty("OtherInfo"))
                        object.OtherInfo = message.OtherInfo;
                    if (message.Trace != null && message.hasOwnProperty("Trace"))
                        object.Trace = message.Trace;
                    if (message.Adc != null && message.hasOwnProperty("Adc"))
                        object.Adc = options.enums === String ? $root.priority.netitems.metadata.AdditionalProperties.ADCInternal[message.Adc] : message.Adc;
                    if (message.TraceID != null && message.hasOwnProperty("TraceID"))
                        if (typeof message.TraceID === "number")
                            object.TraceID = options.longs === String ? String(message.TraceID) : message.TraceID;
                        else
                            object.TraceID = options.longs === String ? $util.Long.prototype.toString.call(message.TraceID) : options.longs === Number ? new $util.LongBits(message.TraceID.low >>> 0, message.TraceID.high >>> 0).toNumber(true) : message.TraceID;
                    if (message.SpandID != null && message.hasOwnProperty("SpandID"))
                        if (typeof message.SpandID === "number")
                            object.SpandID = options.longs === String ? String(message.SpandID) : message.SpandID;
                        else
                            object.SpandID = options.longs === String ? $util.Long.prototype.toString.call(message.SpandID) : options.longs === Number ? new $util.LongBits(message.SpandID.low >>> 0, message.SpandID.high >>> 0).toNumber(true) : message.SpandID;
                    if (message.UserID != null && message.hasOwnProperty("UserID"))
                        if (typeof message.UserID === "number")
                            object.UserID = options.longs === String ? String(message.UserID) : message.UserID;
                        else
                            object.UserID = options.longs === String ? $util.Long.prototype.toString.call(message.UserID) : options.longs === Number ? new $util.LongBits(message.UserID.low >>> 0, message.UserID.high >>> 0).toNumber() : message.UserID;
                    if (message.DebugServer != null && message.hasOwnProperty("DebugServer"))
                        if (typeof message.DebugServer === "number")
                            object.DebugServer = options.longs === String ? String(message.DebugServer) : message.DebugServer;
                        else
                            object.DebugServer = options.longs === String ? $util.Long.prototype.toString.call(message.DebugServer) : options.longs === Number ? new $util.LongBits(message.DebugServer.low >>> 0, message.DebugServer.high >>> 0).toNumber() : message.DebugServer;
                    if (message.CustomTimeoutSeconds != null && message.hasOwnProperty("CustomTimeoutSeconds"))
                        if (typeof message.CustomTimeoutSeconds === "number")
                            object.CustomTimeoutSeconds = options.longs === String ? String(message.CustomTimeoutSeconds) : message.CustomTimeoutSeconds;
                        else
                            object.CustomTimeoutSeconds = options.longs === String ? $util.Long.prototype.toString.call(message.CustomTimeoutSeconds) : options.longs === Number ? new $util.LongBits(message.CustomTimeoutSeconds.low >>> 0, message.CustomTimeoutSeconds.high >>> 0).toNumber() : message.CustomTimeoutSeconds;
                    return object;
                };

                /**
                 * Converts this AdditionalProperties to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.metadata.AdditionalProperties
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AdditionalProperties.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * ADCInternal enum.
                 * @name priority.netitems.metadata.AdditionalProperties.ADCInternal
                 * @enum {number}
                 * @property {number} None=0 None value
                 * @property {number} WMS=1 WMS value
                 */
                AdditionalProperties.ADCInternal = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "None"] = 0;
                    values[valuesById[1] = "WMS"] = 1;
                    return values;
                })();

                return AdditionalProperties;
            })();

            return metadata;
        })();

        netitems.shared = (function() {

            /**
             * Namespace shared.
             * @memberof priority.netitems
             * @namespace
             */
            var shared = {};

            shared.Metric = (function() {

                /**
                 * Properties of a Metric.
                 * @memberof priority.netitems.shared
                 * @interface IMetric
                 * @property {string|null} [Name] Metric Name
                 * @property {number|Long|null} [Value] Metric Value
                 * @property {string|null} [StringValue] Metric StringValue
                 * @property {number|Long|null} [IntValue] Metric IntValue
                 * @property {number|null} [FloatValue] Metric FloatValue
                 * @property {boolean|null} [BoolValue] Metric BoolValue
                 */

                /**
                 * Constructs a new Metric.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a Metric.
                 * @implements IMetric
                 * @constructor
                 * @param {priority.netitems.shared.IMetric=} [properties] Properties to set
                 */
                function Metric(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Metric Name.
                 * @member {string} Name
                 * @memberof priority.netitems.shared.Metric
                 * @instance
                 */
                Metric.prototype.Name = "";

                /**
                 * Metric Value.
                 * @member {number|Long} Value
                 * @memberof priority.netitems.shared.Metric
                 * @instance
                 */
                Metric.prototype.Value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Metric StringValue.
                 * @member {string|null|undefined} StringValue
                 * @memberof priority.netitems.shared.Metric
                 * @instance
                 */
                Metric.prototype.StringValue = null;

                /**
                 * Metric IntValue.
                 * @member {number|Long|null|undefined} IntValue
                 * @memberof priority.netitems.shared.Metric
                 * @instance
                 */
                Metric.prototype.IntValue = null;

                /**
                 * Metric FloatValue.
                 * @member {number|null|undefined} FloatValue
                 * @memberof priority.netitems.shared.Metric
                 * @instance
                 */
                Metric.prototype.FloatValue = null;

                /**
                 * Metric BoolValue.
                 * @member {boolean|null|undefined} BoolValue
                 * @memberof priority.netitems.shared.Metric
                 * @instance
                 */
                Metric.prototype.BoolValue = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Metric OneofValue.
                 * @member {"StringValue"|"IntValue"|"FloatValue"|"BoolValue"|undefined} OneofValue
                 * @memberof priority.netitems.shared.Metric
                 * @instance
                 */
                Object.defineProperty(Metric.prototype, "OneofValue", {
                    get: $util.oneOfGetter($oneOfFields = ["StringValue", "IntValue", "FloatValue", "BoolValue"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Metric instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.Metric
                 * @static
                 * @param {priority.netitems.shared.IMetric=} [properties] Properties to set
                 * @returns {priority.netitems.shared.Metric} Metric instance
                 */
                Metric.create = function create(properties) {
                    return new Metric(properties);
                };

                /**
                 * Encodes the specified Metric message. Does not implicitly {@link priority.netitems.shared.Metric.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.Metric
                 * @static
                 * @param {priority.netitems.shared.IMetric} message Metric message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Metric.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Name);
                    if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Value);
                    if (message.StringValue != null && Object.hasOwnProperty.call(message, "StringValue"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.StringValue);
                    if (message.IntValue != null && Object.hasOwnProperty.call(message, "IntValue"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.IntValue);
                    if (message.FloatValue != null && Object.hasOwnProperty.call(message, "FloatValue"))
                        writer.uint32(/* id 5, wireType 5 =*/45).float(message.FloatValue);
                    if (message.BoolValue != null && Object.hasOwnProperty.call(message, "BoolValue"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.BoolValue);
                    return writer;
                };

                /**
                 * Encodes the specified Metric message, length delimited. Does not implicitly {@link priority.netitems.shared.Metric.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.Metric
                 * @static
                 * @param {priority.netitems.shared.IMetric} message Metric message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Metric.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Metric message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.Metric
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.Metric} Metric
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Metric.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.Metric();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Name = reader.string();
                            break;
                        case 2:
                            message.Value = reader.int64();
                            break;
                        case 3:
                            message.StringValue = reader.string();
                            break;
                        case 4:
                            message.IntValue = reader.int64();
                            break;
                        case 5:
                            message.FloatValue = reader.float();
                            break;
                        case 6:
                            message.BoolValue = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Metric message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.Metric
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.Metric} Metric
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Metric.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Metric message.
                 * @function verify
                 * @memberof priority.netitems.shared.Metric
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Metric.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        if (!$util.isInteger(message.Value) && !(message.Value && $util.isInteger(message.Value.low) && $util.isInteger(message.Value.high)))
                            return "Value: integer|Long expected";
                    if (message.StringValue != null && message.hasOwnProperty("StringValue")) {
                        properties.OneofValue = 1;
                        if (!$util.isString(message.StringValue))
                            return "StringValue: string expected";
                    }
                    if (message.IntValue != null && message.hasOwnProperty("IntValue")) {
                        if (properties.OneofValue === 1)
                            return "OneofValue: multiple values";
                        properties.OneofValue = 1;
                        if (!$util.isInteger(message.IntValue) && !(message.IntValue && $util.isInteger(message.IntValue.low) && $util.isInteger(message.IntValue.high)))
                            return "IntValue: integer|Long expected";
                    }
                    if (message.FloatValue != null && message.hasOwnProperty("FloatValue")) {
                        if (properties.OneofValue === 1)
                            return "OneofValue: multiple values";
                        properties.OneofValue = 1;
                        if (typeof message.FloatValue !== "number")
                            return "FloatValue: number expected";
                    }
                    if (message.BoolValue != null && message.hasOwnProperty("BoolValue")) {
                        if (properties.OneofValue === 1)
                            return "OneofValue: multiple values";
                        properties.OneofValue = 1;
                        if (typeof message.BoolValue !== "boolean")
                            return "BoolValue: boolean expected";
                    }
                    return null;
                };

                /**
                 * Creates a Metric message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.Metric
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.Metric} Metric
                 */
                Metric.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.Metric)
                        return object;
                    var message = new $root.priority.netitems.shared.Metric();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Value != null)
                        if ($util.Long)
                            (message.Value = $util.Long.fromValue(object.Value)).unsigned = false;
                        else if (typeof object.Value === "string")
                            message.Value = parseInt(object.Value, 10);
                        else if (typeof object.Value === "number")
                            message.Value = object.Value;
                        else if (typeof object.Value === "object")
                            message.Value = new $util.LongBits(object.Value.low >>> 0, object.Value.high >>> 0).toNumber();
                    if (object.StringValue != null)
                        message.StringValue = String(object.StringValue);
                    if (object.IntValue != null)
                        if ($util.Long)
                            (message.IntValue = $util.Long.fromValue(object.IntValue)).unsigned = false;
                        else if (typeof object.IntValue === "string")
                            message.IntValue = parseInt(object.IntValue, 10);
                        else if (typeof object.IntValue === "number")
                            message.IntValue = object.IntValue;
                        else if (typeof object.IntValue === "object")
                            message.IntValue = new $util.LongBits(object.IntValue.low >>> 0, object.IntValue.high >>> 0).toNumber();
                    if (object.FloatValue != null)
                        message.FloatValue = Number(object.FloatValue);
                    if (object.BoolValue != null)
                        message.BoolValue = Boolean(object.BoolValue);
                    return message;
                };

                /**
                 * Creates a plain object from a Metric message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.Metric
                 * @static
                 * @param {priority.netitems.shared.Metric} message Metric
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Metric.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Name = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Value = options.longs === String ? "0" : 0;
                    }
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        if (typeof message.Value === "number")
                            object.Value = options.longs === String ? String(message.Value) : message.Value;
                        else
                            object.Value = options.longs === String ? $util.Long.prototype.toString.call(message.Value) : options.longs === Number ? new $util.LongBits(message.Value.low >>> 0, message.Value.high >>> 0).toNumber() : message.Value;
                    if (message.StringValue != null && message.hasOwnProperty("StringValue")) {
                        object.StringValue = message.StringValue;
                        if (options.oneofs)
                            object.OneofValue = "StringValue";
                    }
                    if (message.IntValue != null && message.hasOwnProperty("IntValue")) {
                        if (typeof message.IntValue === "number")
                            object.IntValue = options.longs === String ? String(message.IntValue) : message.IntValue;
                        else
                            object.IntValue = options.longs === String ? $util.Long.prototype.toString.call(message.IntValue) : options.longs === Number ? new $util.LongBits(message.IntValue.low >>> 0, message.IntValue.high >>> 0).toNumber() : message.IntValue;
                        if (options.oneofs)
                            object.OneofValue = "IntValue";
                    }
                    if (message.FloatValue != null && message.hasOwnProperty("FloatValue")) {
                        object.FloatValue = options.json && !isFinite(message.FloatValue) ? String(message.FloatValue) : message.FloatValue;
                        if (options.oneofs)
                            object.OneofValue = "FloatValue";
                    }
                    if (message.BoolValue != null && message.hasOwnProperty("BoolValue")) {
                        object.BoolValue = message.BoolValue;
                        if (options.oneofs)
                            object.OneofValue = "BoolValue";
                    }
                    return object;
                };

                /**
                 * Converts this Metric to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.Metric
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Metric.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Metric;
            })();

            shared.PodMetrics = (function() {

                /**
                 * Properties of a PodMetrics.
                 * @memberof priority.netitems.shared
                 * @interface IPodMetrics
                 * @property {string|null} [PodName] PodMetrics PodName
                 * @property {Array.<priority.netitems.shared.IMetric>|null} [Metrics] PodMetrics Metrics
                 * @property {Array.<string>|null} [ActiveTenants] PodMetrics ActiveTenants
                 */

                /**
                 * Constructs a new PodMetrics.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a PodMetrics.
                 * @implements IPodMetrics
                 * @constructor
                 * @param {priority.netitems.shared.IPodMetrics=} [properties] Properties to set
                 */
                function PodMetrics(properties) {
                    this.Metrics = [];
                    this.ActiveTenants = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PodMetrics PodName.
                 * @member {string} PodName
                 * @memberof priority.netitems.shared.PodMetrics
                 * @instance
                 */
                PodMetrics.prototype.PodName = "";

                /**
                 * PodMetrics Metrics.
                 * @member {Array.<priority.netitems.shared.IMetric>} Metrics
                 * @memberof priority.netitems.shared.PodMetrics
                 * @instance
                 */
                PodMetrics.prototype.Metrics = $util.emptyArray;

                /**
                 * PodMetrics ActiveTenants.
                 * @member {Array.<string>} ActiveTenants
                 * @memberof priority.netitems.shared.PodMetrics
                 * @instance
                 */
                PodMetrics.prototype.ActiveTenants = $util.emptyArray;

                /**
                 * Creates a new PodMetrics instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.PodMetrics
                 * @static
                 * @param {priority.netitems.shared.IPodMetrics=} [properties] Properties to set
                 * @returns {priority.netitems.shared.PodMetrics} PodMetrics instance
                 */
                PodMetrics.create = function create(properties) {
                    return new PodMetrics(properties);
                };

                /**
                 * Encodes the specified PodMetrics message. Does not implicitly {@link priority.netitems.shared.PodMetrics.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.PodMetrics
                 * @static
                 * @param {priority.netitems.shared.IPodMetrics} message PodMetrics message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PodMetrics.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.PodName != null && Object.hasOwnProperty.call(message, "PodName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.PodName);
                    if (message.Metrics != null && message.Metrics.length)
                        for (var i = 0; i < message.Metrics.length; ++i)
                            $root.priority.netitems.shared.Metric.encode(message.Metrics[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ActiveTenants != null && message.ActiveTenants.length)
                        for (var i = 0; i < message.ActiveTenants.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ActiveTenants[i]);
                    return writer;
                };

                /**
                 * Encodes the specified PodMetrics message, length delimited. Does not implicitly {@link priority.netitems.shared.PodMetrics.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.PodMetrics
                 * @static
                 * @param {priority.netitems.shared.IPodMetrics} message PodMetrics message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PodMetrics.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PodMetrics message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.PodMetrics
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.PodMetrics} PodMetrics
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PodMetrics.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.PodMetrics();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.PodName = reader.string();
                            break;
                        case 2:
                            if (!(message.Metrics && message.Metrics.length))
                                message.Metrics = [];
                            message.Metrics.push($root.priority.netitems.shared.Metric.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.ActiveTenants && message.ActiveTenants.length))
                                message.ActiveTenants = [];
                            message.ActiveTenants.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PodMetrics message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.PodMetrics
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.PodMetrics} PodMetrics
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PodMetrics.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PodMetrics message.
                 * @function verify
                 * @memberof priority.netitems.shared.PodMetrics
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PodMetrics.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.PodName != null && message.hasOwnProperty("PodName"))
                        if (!$util.isString(message.PodName))
                            return "PodName: string expected";
                    if (message.Metrics != null && message.hasOwnProperty("Metrics")) {
                        if (!Array.isArray(message.Metrics))
                            return "Metrics: array expected";
                        for (var i = 0; i < message.Metrics.length; ++i) {
                            var error = $root.priority.netitems.shared.Metric.verify(message.Metrics[i]);
                            if (error)
                                return "Metrics." + error;
                        }
                    }
                    if (message.ActiveTenants != null && message.hasOwnProperty("ActiveTenants")) {
                        if (!Array.isArray(message.ActiveTenants))
                            return "ActiveTenants: array expected";
                        for (var i = 0; i < message.ActiveTenants.length; ++i)
                            if (!$util.isString(message.ActiveTenants[i]))
                                return "ActiveTenants: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a PodMetrics message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.PodMetrics
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.PodMetrics} PodMetrics
                 */
                PodMetrics.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.PodMetrics)
                        return object;
                    var message = new $root.priority.netitems.shared.PodMetrics();
                    if (object.PodName != null)
                        message.PodName = String(object.PodName);
                    if (object.Metrics) {
                        if (!Array.isArray(object.Metrics))
                            throw TypeError(".priority.netitems.shared.PodMetrics.Metrics: array expected");
                        message.Metrics = [];
                        for (var i = 0; i < object.Metrics.length; ++i) {
                            if (typeof object.Metrics[i] !== "object")
                                throw TypeError(".priority.netitems.shared.PodMetrics.Metrics: object expected");
                            message.Metrics[i] = $root.priority.netitems.shared.Metric.fromObject(object.Metrics[i]);
                        }
                    }
                    if (object.ActiveTenants) {
                        if (!Array.isArray(object.ActiveTenants))
                            throw TypeError(".priority.netitems.shared.PodMetrics.ActiveTenants: array expected");
                        message.ActiveTenants = [];
                        for (var i = 0; i < object.ActiveTenants.length; ++i)
                            message.ActiveTenants[i] = String(object.ActiveTenants[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PodMetrics message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.PodMetrics
                 * @static
                 * @param {priority.netitems.shared.PodMetrics} message PodMetrics
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PodMetrics.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Metrics = [];
                        object.ActiveTenants = [];
                    }
                    if (options.defaults)
                        object.PodName = "";
                    if (message.PodName != null && message.hasOwnProperty("PodName"))
                        object.PodName = message.PodName;
                    if (message.Metrics && message.Metrics.length) {
                        object.Metrics = [];
                        for (var j = 0; j < message.Metrics.length; ++j)
                            object.Metrics[j] = $root.priority.netitems.shared.Metric.toObject(message.Metrics[j], options);
                    }
                    if (message.ActiveTenants && message.ActiveTenants.length) {
                        object.ActiveTenants = [];
                        for (var j = 0; j < message.ActiveTenants.length; ++j)
                            object.ActiveTenants[j] = message.ActiveTenants[j];
                    }
                    return object;
                };

                /**
                 * Converts this PodMetrics to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.PodMetrics
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PodMetrics.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PodMetrics;
            })();

            shared.StatsForNerds = (function() {

                /**
                 * Properties of a StatsForNerds.
                 * @memberof priority.netitems.shared
                 * @interface IStatsForNerds
                 * @property {number|Long|null} [WorkerIDIn] StatsForNerds WorkerIDIn
                 * @property {number|Long|null} [WorkerIDOut] StatsForNerds WorkerIDOut
                 */

                /**
                 * Constructs a new StatsForNerds.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a StatsForNerds.
                 * @implements IStatsForNerds
                 * @constructor
                 * @param {priority.netitems.shared.IStatsForNerds=} [properties] Properties to set
                 */
                function StatsForNerds(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * StatsForNerds WorkerIDIn.
                 * @member {number|Long} WorkerIDIn
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @instance
                 */
                StatsForNerds.prototype.WorkerIDIn = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * StatsForNerds WorkerIDOut.
                 * @member {number|Long} WorkerIDOut
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @instance
                 */
                StatsForNerds.prototype.WorkerIDOut = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new StatsForNerds instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @static
                 * @param {priority.netitems.shared.IStatsForNerds=} [properties] Properties to set
                 * @returns {priority.netitems.shared.StatsForNerds} StatsForNerds instance
                 */
                StatsForNerds.create = function create(properties) {
                    return new StatsForNerds(properties);
                };

                /**
                 * Encodes the specified StatsForNerds message. Does not implicitly {@link priority.netitems.shared.StatsForNerds.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @static
                 * @param {priority.netitems.shared.IStatsForNerds} message StatsForNerds message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatsForNerds.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.WorkerIDIn != null && Object.hasOwnProperty.call(message, "WorkerIDIn"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.WorkerIDIn);
                    if (message.WorkerIDOut != null && Object.hasOwnProperty.call(message, "WorkerIDOut"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.WorkerIDOut);
                    return writer;
                };

                /**
                 * Encodes the specified StatsForNerds message, length delimited. Does not implicitly {@link priority.netitems.shared.StatsForNerds.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @static
                 * @param {priority.netitems.shared.IStatsForNerds} message StatsForNerds message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StatsForNerds.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a StatsForNerds message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.StatsForNerds} StatsForNerds
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatsForNerds.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.StatsForNerds();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.WorkerIDIn = reader.int64();
                            break;
                        case 2:
                            message.WorkerIDOut = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a StatsForNerds message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.StatsForNerds} StatsForNerds
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StatsForNerds.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a StatsForNerds message.
                 * @function verify
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StatsForNerds.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.WorkerIDIn != null && message.hasOwnProperty("WorkerIDIn"))
                        if (!$util.isInteger(message.WorkerIDIn) && !(message.WorkerIDIn && $util.isInteger(message.WorkerIDIn.low) && $util.isInteger(message.WorkerIDIn.high)))
                            return "WorkerIDIn: integer|Long expected";
                    if (message.WorkerIDOut != null && message.hasOwnProperty("WorkerIDOut"))
                        if (!$util.isInteger(message.WorkerIDOut) && !(message.WorkerIDOut && $util.isInteger(message.WorkerIDOut.low) && $util.isInteger(message.WorkerIDOut.high)))
                            return "WorkerIDOut: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a StatsForNerds message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.StatsForNerds} StatsForNerds
                 */
                StatsForNerds.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.StatsForNerds)
                        return object;
                    var message = new $root.priority.netitems.shared.StatsForNerds();
                    if (object.WorkerIDIn != null)
                        if ($util.Long)
                            (message.WorkerIDIn = $util.Long.fromValue(object.WorkerIDIn)).unsigned = false;
                        else if (typeof object.WorkerIDIn === "string")
                            message.WorkerIDIn = parseInt(object.WorkerIDIn, 10);
                        else if (typeof object.WorkerIDIn === "number")
                            message.WorkerIDIn = object.WorkerIDIn;
                        else if (typeof object.WorkerIDIn === "object")
                            message.WorkerIDIn = new $util.LongBits(object.WorkerIDIn.low >>> 0, object.WorkerIDIn.high >>> 0).toNumber();
                    if (object.WorkerIDOut != null)
                        if ($util.Long)
                            (message.WorkerIDOut = $util.Long.fromValue(object.WorkerIDOut)).unsigned = false;
                        else if (typeof object.WorkerIDOut === "string")
                            message.WorkerIDOut = parseInt(object.WorkerIDOut, 10);
                        else if (typeof object.WorkerIDOut === "number")
                            message.WorkerIDOut = object.WorkerIDOut;
                        else if (typeof object.WorkerIDOut === "object")
                            message.WorkerIDOut = new $util.LongBits(object.WorkerIDOut.low >>> 0, object.WorkerIDOut.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a StatsForNerds message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @static
                 * @param {priority.netitems.shared.StatsForNerds} message StatsForNerds
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StatsForNerds.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.WorkerIDIn = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.WorkerIDIn = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.WorkerIDOut = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.WorkerIDOut = options.longs === String ? "0" : 0;
                    }
                    if (message.WorkerIDIn != null && message.hasOwnProperty("WorkerIDIn"))
                        if (typeof message.WorkerIDIn === "number")
                            object.WorkerIDIn = options.longs === String ? String(message.WorkerIDIn) : message.WorkerIDIn;
                        else
                            object.WorkerIDIn = options.longs === String ? $util.Long.prototype.toString.call(message.WorkerIDIn) : options.longs === Number ? new $util.LongBits(message.WorkerIDIn.low >>> 0, message.WorkerIDIn.high >>> 0).toNumber() : message.WorkerIDIn;
                    if (message.WorkerIDOut != null && message.hasOwnProperty("WorkerIDOut"))
                        if (typeof message.WorkerIDOut === "number")
                            object.WorkerIDOut = options.longs === String ? String(message.WorkerIDOut) : message.WorkerIDOut;
                        else
                            object.WorkerIDOut = options.longs === String ? $util.Long.prototype.toString.call(message.WorkerIDOut) : options.longs === Number ? new $util.LongBits(message.WorkerIDOut.low >>> 0, message.WorkerIDOut.high >>> 0).toNumber() : message.WorkerIDOut;
                    return object;
                };

                /**
                 * Converts this StatsForNerds to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.StatsForNerds
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StatsForNerds.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return StatsForNerds;
            })();

            shared.PerfMonitor = (function() {

                /**
                 * Properties of a PerfMonitor.
                 * @memberof priority.netitems.shared
                 * @interface IPerfMonitor
                 * @property {number|null} [DBTime] PerfMonitor DBTime
                 * @property {number|null} [RedisTime] PerfMonitor RedisTime
                 * @property {number|null} [AppTime] PerfMonitor AppTime
                 * @property {number|null} [DBPID] PerfMonitor DBPID
                 * @property {string|null} [TraceData] PerfMonitor TraceData
                 * @property {priority.netitems.shared.IStatsForNerds|null} [DebugData] PerfMonitor DebugData
                 */

                /**
                 * Constructs a new PerfMonitor.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a PerfMonitor.
                 * @implements IPerfMonitor
                 * @constructor
                 * @param {priority.netitems.shared.IPerfMonitor=} [properties] Properties to set
                 */
                function PerfMonitor(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PerfMonitor DBTime.
                 * @member {number} DBTime
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @instance
                 */
                PerfMonitor.prototype.DBTime = 0;

                /**
                 * PerfMonitor RedisTime.
                 * @member {number} RedisTime
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @instance
                 */
                PerfMonitor.prototype.RedisTime = 0;

                /**
                 * PerfMonitor AppTime.
                 * @member {number} AppTime
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @instance
                 */
                PerfMonitor.prototype.AppTime = 0;

                /**
                 * PerfMonitor DBPID.
                 * @member {number} DBPID
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @instance
                 */
                PerfMonitor.prototype.DBPID = 0;

                /**
                 * PerfMonitor TraceData.
                 * @member {string} TraceData
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @instance
                 */
                PerfMonitor.prototype.TraceData = "";

                /**
                 * PerfMonitor DebugData.
                 * @member {priority.netitems.shared.IStatsForNerds|null|undefined} DebugData
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @instance
                 */
                PerfMonitor.prototype.DebugData = null;

                /**
                 * Creates a new PerfMonitor instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @static
                 * @param {priority.netitems.shared.IPerfMonitor=} [properties] Properties to set
                 * @returns {priority.netitems.shared.PerfMonitor} PerfMonitor instance
                 */
                PerfMonitor.create = function create(properties) {
                    return new PerfMonitor(properties);
                };

                /**
                 * Encodes the specified PerfMonitor message. Does not implicitly {@link priority.netitems.shared.PerfMonitor.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @static
                 * @param {priority.netitems.shared.IPerfMonitor} message PerfMonitor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PerfMonitor.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.DBTime != null && Object.hasOwnProperty.call(message, "DBTime"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.DBTime);
                    if (message.RedisTime != null && Object.hasOwnProperty.call(message, "RedisTime"))
                        writer.uint32(/* id 2, wireType 5 =*/21).float(message.RedisTime);
                    if (message.AppTime != null && Object.hasOwnProperty.call(message, "AppTime"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.AppTime);
                    if (message.DBPID != null && Object.hasOwnProperty.call(message, "DBPID"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.DBPID);
                    if (message.TraceData != null && Object.hasOwnProperty.call(message, "TraceData"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.TraceData);
                    if (message.DebugData != null && Object.hasOwnProperty.call(message, "DebugData"))
                        $root.priority.netitems.shared.StatsForNerds.encode(message.DebugData, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PerfMonitor message, length delimited. Does not implicitly {@link priority.netitems.shared.PerfMonitor.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @static
                 * @param {priority.netitems.shared.IPerfMonitor} message PerfMonitor message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PerfMonitor.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PerfMonitor message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.PerfMonitor} PerfMonitor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PerfMonitor.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.PerfMonitor();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.DBTime = reader.float();
                            break;
                        case 2:
                            message.RedisTime = reader.float();
                            break;
                        case 3:
                            message.AppTime = reader.float();
                            break;
                        case 4:
                            message.DBPID = reader.int32();
                            break;
                        case 5:
                            message.TraceData = reader.string();
                            break;
                        case 6:
                            message.DebugData = $root.priority.netitems.shared.StatsForNerds.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PerfMonitor message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.PerfMonitor} PerfMonitor
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PerfMonitor.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PerfMonitor message.
                 * @function verify
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PerfMonitor.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.DBTime != null && message.hasOwnProperty("DBTime"))
                        if (typeof message.DBTime !== "number")
                            return "DBTime: number expected";
                    if (message.RedisTime != null && message.hasOwnProperty("RedisTime"))
                        if (typeof message.RedisTime !== "number")
                            return "RedisTime: number expected";
                    if (message.AppTime != null && message.hasOwnProperty("AppTime"))
                        if (typeof message.AppTime !== "number")
                            return "AppTime: number expected";
                    if (message.DBPID != null && message.hasOwnProperty("DBPID"))
                        if (!$util.isInteger(message.DBPID))
                            return "DBPID: integer expected";
                    if (message.TraceData != null && message.hasOwnProperty("TraceData"))
                        if (!$util.isString(message.TraceData))
                            return "TraceData: string expected";
                    if (message.DebugData != null && message.hasOwnProperty("DebugData")) {
                        var error = $root.priority.netitems.shared.StatsForNerds.verify(message.DebugData);
                        if (error)
                            return "DebugData." + error;
                    }
                    return null;
                };

                /**
                 * Creates a PerfMonitor message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.PerfMonitor} PerfMonitor
                 */
                PerfMonitor.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.PerfMonitor)
                        return object;
                    var message = new $root.priority.netitems.shared.PerfMonitor();
                    if (object.DBTime != null)
                        message.DBTime = Number(object.DBTime);
                    if (object.RedisTime != null)
                        message.RedisTime = Number(object.RedisTime);
                    if (object.AppTime != null)
                        message.AppTime = Number(object.AppTime);
                    if (object.DBPID != null)
                        message.DBPID = object.DBPID | 0;
                    if (object.TraceData != null)
                        message.TraceData = String(object.TraceData);
                    if (object.DebugData != null) {
                        if (typeof object.DebugData !== "object")
                            throw TypeError(".priority.netitems.shared.PerfMonitor.DebugData: object expected");
                        message.DebugData = $root.priority.netitems.shared.StatsForNerds.fromObject(object.DebugData);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PerfMonitor message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @static
                 * @param {priority.netitems.shared.PerfMonitor} message PerfMonitor
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PerfMonitor.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.DBTime = 0;
                        object.RedisTime = 0;
                        object.AppTime = 0;
                        object.DBPID = 0;
                        object.TraceData = "";
                        object.DebugData = null;
                    }
                    if (message.DBTime != null && message.hasOwnProperty("DBTime"))
                        object.DBTime = options.json && !isFinite(message.DBTime) ? String(message.DBTime) : message.DBTime;
                    if (message.RedisTime != null && message.hasOwnProperty("RedisTime"))
                        object.RedisTime = options.json && !isFinite(message.RedisTime) ? String(message.RedisTime) : message.RedisTime;
                    if (message.AppTime != null && message.hasOwnProperty("AppTime"))
                        object.AppTime = options.json && !isFinite(message.AppTime) ? String(message.AppTime) : message.AppTime;
                    if (message.DBPID != null && message.hasOwnProperty("DBPID"))
                        object.DBPID = message.DBPID;
                    if (message.TraceData != null && message.hasOwnProperty("TraceData"))
                        object.TraceData = message.TraceData;
                    if (message.DebugData != null && message.hasOwnProperty("DebugData"))
                        object.DebugData = $root.priority.netitems.shared.StatsForNerds.toObject(message.DebugData, options);
                    return object;
                };

                /**
                 * Converts this PerfMonitor to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.PerfMonitor
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PerfMonitor.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PerfMonitor;
            })();

            shared.Message = (function() {

                /**
                 * Properties of a Message.
                 * @memberof priority.netitems.shared
                 * @interface IMessage
                 * @property {priority.netitems.shared.Message.Type|null} [MType] Message MType
                 * @property {string|null} [Text] Message Text
                 * @property {number|Long|null} [FieldId] Message FieldId
                 * @property {number|Long|null} [AlertNum] Message AlertNum
                 * @property {Object.<string,string>|null} [Links] Message Links
                 * @property {string|null} [MoreInfo] Message MoreInfo
                 */

                /**
                 * Constructs a new Message.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a Message.
                 * @implements IMessage
                 * @constructor
                 * @param {priority.netitems.shared.IMessage=} [properties] Properties to set
                 */
                function Message(properties) {
                    this.Links = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Message MType.
                 * @member {priority.netitems.shared.Message.Type} MType
                 * @memberof priority.netitems.shared.Message
                 * @instance
                 */
                Message.prototype.MType = 0;

                /**
                 * Message Text.
                 * @member {string} Text
                 * @memberof priority.netitems.shared.Message
                 * @instance
                 */
                Message.prototype.Text = "";

                /**
                 * Message FieldId.
                 * @member {number|Long} FieldId
                 * @memberof priority.netitems.shared.Message
                 * @instance
                 */
                Message.prototype.FieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Message AlertNum.
                 * @member {number|Long} AlertNum
                 * @memberof priority.netitems.shared.Message
                 * @instance
                 */
                Message.prototype.AlertNum = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Message Links.
                 * @member {Object.<string,string>} Links
                 * @memberof priority.netitems.shared.Message
                 * @instance
                 */
                Message.prototype.Links = $util.emptyObject;

                /**
                 * Message MoreInfo.
                 * @member {string} MoreInfo
                 * @memberof priority.netitems.shared.Message
                 * @instance
                 */
                Message.prototype.MoreInfo = "";

                /**
                 * Creates a new Message instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.Message
                 * @static
                 * @param {priority.netitems.shared.IMessage=} [properties] Properties to set
                 * @returns {priority.netitems.shared.Message} Message instance
                 */
                Message.create = function create(properties) {
                    return new Message(properties);
                };

                /**
                 * Encodes the specified Message message. Does not implicitly {@link priority.netitems.shared.Message.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.Message
                 * @static
                 * @param {priority.netitems.shared.IMessage} message Message message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Message.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.MType != null && Object.hasOwnProperty.call(message, "MType"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.MType);
                    if (message.Text != null && Object.hasOwnProperty.call(message, "Text"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Text);
                    if (message.FieldId != null && Object.hasOwnProperty.call(message, "FieldId"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.FieldId);
                    if (message.AlertNum != null && Object.hasOwnProperty.call(message, "AlertNum"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.AlertNum);
                    if (message.Links != null && Object.hasOwnProperty.call(message, "Links"))
                        for (var keys = Object.keys(message.Links), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.Links[keys[i]]).ldelim();
                    if (message.MoreInfo != null && Object.hasOwnProperty.call(message, "MoreInfo"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.MoreInfo);
                    return writer;
                };

                /**
                 * Encodes the specified Message message, length delimited. Does not implicitly {@link priority.netitems.shared.Message.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.Message
                 * @static
                 * @param {priority.netitems.shared.IMessage} message Message message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Message.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Message message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.Message
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.Message} Message
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Message.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.Message(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.MType = reader.int32();
                            break;
                        case 2:
                            message.Text = reader.string();
                            break;
                        case 3:
                            message.FieldId = reader.int64();
                            break;
                        case 4:
                            message.AlertNum = reader.int64();
                            break;
                        case 5:
                            if (message.Links === $util.emptyObject)
                                message.Links = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = "";
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.Links[key] = value;
                            break;
                        case 6:
                            message.MoreInfo = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Message message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.Message
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.Message} Message
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Message.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Message message.
                 * @function verify
                 * @memberof priority.netitems.shared.Message
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Message.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.MType != null && message.hasOwnProperty("MType"))
                        switch (message.MType) {
                        default:
                            return "MType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.Text != null && message.hasOwnProperty("Text"))
                        if (!$util.isString(message.Text))
                            return "Text: string expected";
                    if (message.FieldId != null && message.hasOwnProperty("FieldId"))
                        if (!$util.isInteger(message.FieldId) && !(message.FieldId && $util.isInteger(message.FieldId.low) && $util.isInteger(message.FieldId.high)))
                            return "FieldId: integer|Long expected";
                    if (message.AlertNum != null && message.hasOwnProperty("AlertNum"))
                        if (!$util.isInteger(message.AlertNum) && !(message.AlertNum && $util.isInteger(message.AlertNum.low) && $util.isInteger(message.AlertNum.high)))
                            return "AlertNum: integer|Long expected";
                    if (message.Links != null && message.hasOwnProperty("Links")) {
                        if (!$util.isObject(message.Links))
                            return "Links: object expected";
                        var key = Object.keys(message.Links);
                        for (var i = 0; i < key.length; ++i)
                            if (!$util.isString(message.Links[key[i]]))
                                return "Links: string{k:string} expected";
                    }
                    if (message.MoreInfo != null && message.hasOwnProperty("MoreInfo"))
                        if (!$util.isString(message.MoreInfo))
                            return "MoreInfo: string expected";
                    return null;
                };

                /**
                 * Creates a Message message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.Message
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.Message} Message
                 */
                Message.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.Message)
                        return object;
                    var message = new $root.priority.netitems.shared.Message();
                    switch (object.MType) {
                    case "Information":
                    case 0:
                        message.MType = 0;
                        break;
                    case "Warning":
                    case 1:
                        message.MType = 1;
                        break;
                    case "Error":
                    case 2:
                        message.MType = 2;
                        break;
                    case "Fatal":
                    case 3:
                        message.MType = 3;
                        break;
                    case "PwdDlg":
                    case 4:
                        message.MType = 4;
                        break;
                    }
                    if (object.Text != null)
                        message.Text = String(object.Text);
                    if (object.FieldId != null)
                        if ($util.Long)
                            (message.FieldId = $util.Long.fromValue(object.FieldId)).unsigned = false;
                        else if (typeof object.FieldId === "string")
                            message.FieldId = parseInt(object.FieldId, 10);
                        else if (typeof object.FieldId === "number")
                            message.FieldId = object.FieldId;
                        else if (typeof object.FieldId === "object")
                            message.FieldId = new $util.LongBits(object.FieldId.low >>> 0, object.FieldId.high >>> 0).toNumber();
                    if (object.AlertNum != null)
                        if ($util.Long)
                            (message.AlertNum = $util.Long.fromValue(object.AlertNum)).unsigned = false;
                        else if (typeof object.AlertNum === "string")
                            message.AlertNum = parseInt(object.AlertNum, 10);
                        else if (typeof object.AlertNum === "number")
                            message.AlertNum = object.AlertNum;
                        else if (typeof object.AlertNum === "object")
                            message.AlertNum = new $util.LongBits(object.AlertNum.low >>> 0, object.AlertNum.high >>> 0).toNumber();
                    if (object.Links) {
                        if (typeof object.Links !== "object")
                            throw TypeError(".priority.netitems.shared.Message.Links: object expected");
                        message.Links = {};
                        for (var keys = Object.keys(object.Links), i = 0; i < keys.length; ++i)
                            message.Links[keys[i]] = String(object.Links[keys[i]]);
                    }
                    if (object.MoreInfo != null)
                        message.MoreInfo = String(object.MoreInfo);
                    return message;
                };

                /**
                 * Creates a plain object from a Message message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.Message
                 * @static
                 * @param {priority.netitems.shared.Message} message Message
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Message.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.objects || options.defaults)
                        object.Links = {};
                    if (options.defaults) {
                        object.MType = options.enums === String ? "Information" : 0;
                        object.Text = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.FieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.FieldId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.AlertNum = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.AlertNum = options.longs === String ? "0" : 0;
                        object.MoreInfo = "";
                    }
                    if (message.MType != null && message.hasOwnProperty("MType"))
                        object.MType = options.enums === String ? $root.priority.netitems.shared.Message.Type[message.MType] : message.MType;
                    if (message.Text != null && message.hasOwnProperty("Text"))
                        object.Text = message.Text;
                    if (message.FieldId != null && message.hasOwnProperty("FieldId"))
                        if (typeof message.FieldId === "number")
                            object.FieldId = options.longs === String ? String(message.FieldId) : message.FieldId;
                        else
                            object.FieldId = options.longs === String ? $util.Long.prototype.toString.call(message.FieldId) : options.longs === Number ? new $util.LongBits(message.FieldId.low >>> 0, message.FieldId.high >>> 0).toNumber() : message.FieldId;
                    if (message.AlertNum != null && message.hasOwnProperty("AlertNum"))
                        if (typeof message.AlertNum === "number")
                            object.AlertNum = options.longs === String ? String(message.AlertNum) : message.AlertNum;
                        else
                            object.AlertNum = options.longs === String ? $util.Long.prototype.toString.call(message.AlertNum) : options.longs === Number ? new $util.LongBits(message.AlertNum.low >>> 0, message.AlertNum.high >>> 0).toNumber() : message.AlertNum;
                    var keys2;
                    if (message.Links && (keys2 = Object.keys(message.Links)).length) {
                        object.Links = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.Links[keys2[j]] = message.Links[keys2[j]];
                    }
                    if (message.MoreInfo != null && message.hasOwnProperty("MoreInfo"))
                        object.MoreInfo = message.MoreInfo;
                    return object;
                };

                /**
                 * Converts this Message to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.Message
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Message.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * Type enum.
                 * @name priority.netitems.shared.Message.Type
                 * @enum {number}
                 * @property {number} Information=0 Information value
                 * @property {number} Warning=1 Warning value
                 * @property {number} Error=2 Error value
                 * @property {number} Fatal=3 Fatal value
                 * @property {number} PwdDlg=4 PwdDlg value
                 */
                Message.Type = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "Information"] = 0;
                    values[valuesById[1] = "Warning"] = 1;
                    values[valuesById[2] = "Error"] = 2;
                    values[valuesById[3] = "Fatal"] = 3;
                    values[valuesById[4] = "PwdDlg"] = 4;
                    return values;
                })();

                return Message;
            })();

            shared.GeneralRequest = (function() {

                /**
                 * Properties of a GeneralRequest.
                 * @memberof priority.netitems.shared
                 * @interface IGeneralRequest
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] GeneralRequest Properties
                 * @property {string|null} [Session] GeneralRequest Session
                 * @property {Array.<string>|null} [values] GeneralRequest values
                 */

                /**
                 * Constructs a new GeneralRequest.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a GeneralRequest.
                 * @implements IGeneralRequest
                 * @constructor
                 * @param {priority.netitems.shared.IGeneralRequest=} [properties] Properties to set
                 */
                function GeneralRequest(properties) {
                    this.values = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GeneralRequest Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @instance
                 */
                GeneralRequest.prototype.Properties = null;

                /**
                 * GeneralRequest Session.
                 * @member {string} Session
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @instance
                 */
                GeneralRequest.prototype.Session = "";

                /**
                 * GeneralRequest values.
                 * @member {Array.<string>} values
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @instance
                 */
                GeneralRequest.prototype.values = $util.emptyArray;

                /**
                 * Creates a new GeneralRequest instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @static
                 * @param {priority.netitems.shared.IGeneralRequest=} [properties] Properties to set
                 * @returns {priority.netitems.shared.GeneralRequest} GeneralRequest instance
                 */
                GeneralRequest.create = function create(properties) {
                    return new GeneralRequest(properties);
                };

                /**
                 * Encodes the specified GeneralRequest message. Does not implicitly {@link priority.netitems.shared.GeneralRequest.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @static
                 * @param {priority.netitems.shared.IGeneralRequest} message GeneralRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneralRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Session != null && Object.hasOwnProperty.call(message, "Session"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Session);
                    if (message.values != null && message.values.length)
                        for (var i = 0; i < message.values.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.values[i]);
                    return writer;
                };

                /**
                 * Encodes the specified GeneralRequest message, length delimited. Does not implicitly {@link priority.netitems.shared.GeneralRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @static
                 * @param {priority.netitems.shared.IGeneralRequest} message GeneralRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneralRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GeneralRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.GeneralRequest} GeneralRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneralRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.GeneralRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Session = reader.string();
                            break;
                        case 5:
                            if (!(message.values && message.values.length))
                                message.values = [];
                            message.values.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GeneralRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.GeneralRequest} GeneralRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneralRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GeneralRequest message.
                 * @function verify
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GeneralRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        if (!$util.isString(message.Session))
                            return "Session: string expected";
                    if (message.values != null && message.hasOwnProperty("values")) {
                        if (!Array.isArray(message.values))
                            return "values: array expected";
                        for (var i = 0; i < message.values.length; ++i)
                            if (!$util.isString(message.values[i]))
                                return "values: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a GeneralRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.GeneralRequest} GeneralRequest
                 */
                GeneralRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.GeneralRequest)
                        return object;
                    var message = new $root.priority.netitems.shared.GeneralRequest();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.shared.GeneralRequest.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Session != null)
                        message.Session = String(object.Session);
                    if (object.values) {
                        if (!Array.isArray(object.values))
                            throw TypeError(".priority.netitems.shared.GeneralRequest.values: array expected");
                        message.values = [];
                        for (var i = 0; i < object.values.length; ++i)
                            message.values[i] = String(object.values[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GeneralRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @static
                 * @param {priority.netitems.shared.GeneralRequest} message GeneralRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GeneralRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.values = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Session = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Session != null && message.hasOwnProperty("Session"))
                        object.Session = message.Session;
                    if (message.values && message.values.length) {
                        object.values = [];
                        for (var j = 0; j < message.values.length; ++j)
                            object.values[j] = message.values[j];
                    }
                    return object;
                };

                /**
                 * Converts this GeneralRequest to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.GeneralRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GeneralRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GeneralRequest;
            })();

            shared.GeneralResponse = (function() {

                /**
                 * Properties of a GeneralResponse.
                 * @memberof priority.netitems.shared
                 * @interface IGeneralResponse
                 * @property {string|null} [data] GeneralResponse data
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] GeneralResponse Perf
                 */

                /**
                 * Constructs a new GeneralResponse.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a GeneralResponse.
                 * @implements IGeneralResponse
                 * @constructor
                 * @param {priority.netitems.shared.IGeneralResponse=} [properties] Properties to set
                 */
                function GeneralResponse(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GeneralResponse data.
                 * @member {string} data
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @instance
                 */
                GeneralResponse.prototype.data = "";

                /**
                 * GeneralResponse Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @instance
                 */
                GeneralResponse.prototype.Perf = null;

                /**
                 * Creates a new GeneralResponse instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @static
                 * @param {priority.netitems.shared.IGeneralResponse=} [properties] Properties to set
                 * @returns {priority.netitems.shared.GeneralResponse} GeneralResponse instance
                 */
                GeneralResponse.create = function create(properties) {
                    return new GeneralResponse(properties);
                };

                /**
                 * Encodes the specified GeneralResponse message. Does not implicitly {@link priority.netitems.shared.GeneralResponse.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @static
                 * @param {priority.netitems.shared.IGeneralResponse} message GeneralResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneralResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.data);
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified GeneralResponse message, length delimited. Does not implicitly {@link priority.netitems.shared.GeneralResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @static
                 * @param {priority.netitems.shared.IGeneralResponse} message GeneralResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneralResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GeneralResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.GeneralResponse} GeneralResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneralResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.GeneralResponse();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.data = reader.string();
                            break;
                        case 2:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GeneralResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.GeneralResponse} GeneralResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneralResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GeneralResponse message.
                 * @function verify
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GeneralResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.data != null && message.hasOwnProperty("data"))
                        if (!$util.isString(message.data))
                            return "data: string expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    return null;
                };

                /**
                 * Creates a GeneralResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.GeneralResponse} GeneralResponse
                 */
                GeneralResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.GeneralResponse)
                        return object;
                    var message = new $root.priority.netitems.shared.GeneralResponse();
                    if (object.data != null)
                        message.data = String(object.data);
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.shared.GeneralResponse.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GeneralResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @static
                 * @param {priority.netitems.shared.GeneralResponse} message GeneralResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GeneralResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.data = "";
                        object.Perf = null;
                    }
                    if (message.data != null && message.hasOwnProperty("data"))
                        object.data = message.data;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    return object;
                };

                /**
                 * Converts this GeneralResponse to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.GeneralResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GeneralResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GeneralResponse;
            })();

            shared.UserData = (function() {

                /**
                 * Properties of a UserData.
                 * @memberof priority.netitems.shared
                 * @interface IUserData
                 * @property {string|null} [login] UserData login
                 * @property {string|null} [apiLogin] UserData apiLogin
                 * @property {string|null} [email] UserData email
                 * @property {string|null} [firstname] UserData firstname
                 * @property {string|null} [lastname] UserData lastname
                 * @property {string|null} [fullname] UserData fullname
                 * @property {number|Long|null} [userID] UserData userID
                 * @property {number|Long|null} [employeeID] UserData employeeID
                 * @property {string|null} [subject] UserData subject
                 * @property {boolean|null} [active] UserData active
                 */

                /**
                 * Constructs a new UserData.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a UserData.
                 * @implements IUserData
                 * @constructor
                 * @param {priority.netitems.shared.IUserData=} [properties] Properties to set
                 */
                function UserData(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UserData login.
                 * @member {string} login
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.login = "";

                /**
                 * UserData apiLogin.
                 * @member {string} apiLogin
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.apiLogin = "";

                /**
                 * UserData email.
                 * @member {string} email
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.email = "";

                /**
                 * UserData firstname.
                 * @member {string} firstname
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.firstname = "";

                /**
                 * UserData lastname.
                 * @member {string} lastname
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.lastname = "";

                /**
                 * UserData fullname.
                 * @member {string} fullname
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.fullname = "";

                /**
                 * UserData userID.
                 * @member {number|Long} userID
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.userID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * UserData employeeID.
                 * @member {number|Long} employeeID
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.employeeID = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * UserData subject.
                 * @member {string} subject
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.subject = "";

                /**
                 * UserData active.
                 * @member {boolean} active
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 */
                UserData.prototype.active = false;

                /**
                 * Creates a new UserData instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.UserData
                 * @static
                 * @param {priority.netitems.shared.IUserData=} [properties] Properties to set
                 * @returns {priority.netitems.shared.UserData} UserData instance
                 */
                UserData.create = function create(properties) {
                    return new UserData(properties);
                };

                /**
                 * Encodes the specified UserData message. Does not implicitly {@link priority.netitems.shared.UserData.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.UserData
                 * @static
                 * @param {priority.netitems.shared.IUserData} message UserData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UserData.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.login != null && Object.hasOwnProperty.call(message, "login"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.login);
                    if (message.apiLogin != null && Object.hasOwnProperty.call(message, "apiLogin"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.apiLogin);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
                    if (message.firstname != null && Object.hasOwnProperty.call(message, "firstname"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.firstname);
                    if (message.lastname != null && Object.hasOwnProperty.call(message, "lastname"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.lastname);
                    if (message.fullname != null && Object.hasOwnProperty.call(message, "fullname"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.fullname);
                    if (message.userID != null && Object.hasOwnProperty.call(message, "userID"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.userID);
                    if (message.employeeID != null && Object.hasOwnProperty.call(message, "employeeID"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.employeeID);
                    if (message.subject != null && Object.hasOwnProperty.call(message, "subject"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.subject);
                    if (message.active != null && Object.hasOwnProperty.call(message, "active"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.active);
                    return writer;
                };

                /**
                 * Encodes the specified UserData message, length delimited. Does not implicitly {@link priority.netitems.shared.UserData.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.UserData
                 * @static
                 * @param {priority.netitems.shared.IUserData} message UserData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UserData.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a UserData message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.UserData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.UserData} UserData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UserData.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.UserData();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.login = reader.string();
                            break;
                        case 2:
                            message.apiLogin = reader.string();
                            break;
                        case 3:
                            message.email = reader.string();
                            break;
                        case 4:
                            message.firstname = reader.string();
                            break;
                        case 5:
                            message.lastname = reader.string();
                            break;
                        case 6:
                            message.fullname = reader.string();
                            break;
                        case 7:
                            message.userID = reader.int64();
                            break;
                        case 8:
                            message.employeeID = reader.int64();
                            break;
                        case 9:
                            message.subject = reader.string();
                            break;
                        case 10:
                            message.active = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a UserData message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.UserData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.UserData} UserData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UserData.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a UserData message.
                 * @function verify
                 * @memberof priority.netitems.shared.UserData
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UserData.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.login != null && message.hasOwnProperty("login"))
                        if (!$util.isString(message.login))
                            return "login: string expected";
                    if (message.apiLogin != null && message.hasOwnProperty("apiLogin"))
                        if (!$util.isString(message.apiLogin))
                            return "apiLogin: string expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.firstname != null && message.hasOwnProperty("firstname"))
                        if (!$util.isString(message.firstname))
                            return "firstname: string expected";
                    if (message.lastname != null && message.hasOwnProperty("lastname"))
                        if (!$util.isString(message.lastname))
                            return "lastname: string expected";
                    if (message.fullname != null && message.hasOwnProperty("fullname"))
                        if (!$util.isString(message.fullname))
                            return "fullname: string expected";
                    if (message.userID != null && message.hasOwnProperty("userID"))
                        if (!$util.isInteger(message.userID) && !(message.userID && $util.isInteger(message.userID.low) && $util.isInteger(message.userID.high)))
                            return "userID: integer|Long expected";
                    if (message.employeeID != null && message.hasOwnProperty("employeeID"))
                        if (!$util.isInteger(message.employeeID) && !(message.employeeID && $util.isInteger(message.employeeID.low) && $util.isInteger(message.employeeID.high)))
                            return "employeeID: integer|Long expected";
                    if (message.subject != null && message.hasOwnProperty("subject"))
                        if (!$util.isString(message.subject))
                            return "subject: string expected";
                    if (message.active != null && message.hasOwnProperty("active"))
                        if (typeof message.active !== "boolean")
                            return "active: boolean expected";
                    return null;
                };

                /**
                 * Creates a UserData message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.UserData
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.UserData} UserData
                 */
                UserData.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.UserData)
                        return object;
                    var message = new $root.priority.netitems.shared.UserData();
                    if (object.login != null)
                        message.login = String(object.login);
                    if (object.apiLogin != null)
                        message.apiLogin = String(object.apiLogin);
                    if (object.email != null)
                        message.email = String(object.email);
                    if (object.firstname != null)
                        message.firstname = String(object.firstname);
                    if (object.lastname != null)
                        message.lastname = String(object.lastname);
                    if (object.fullname != null)
                        message.fullname = String(object.fullname);
                    if (object.userID != null)
                        if ($util.Long)
                            (message.userID = $util.Long.fromValue(object.userID)).unsigned = false;
                        else if (typeof object.userID === "string")
                            message.userID = parseInt(object.userID, 10);
                        else if (typeof object.userID === "number")
                            message.userID = object.userID;
                        else if (typeof object.userID === "object")
                            message.userID = new $util.LongBits(object.userID.low >>> 0, object.userID.high >>> 0).toNumber();
                    if (object.employeeID != null)
                        if ($util.Long)
                            (message.employeeID = $util.Long.fromValue(object.employeeID)).unsigned = false;
                        else if (typeof object.employeeID === "string")
                            message.employeeID = parseInt(object.employeeID, 10);
                        else if (typeof object.employeeID === "number")
                            message.employeeID = object.employeeID;
                        else if (typeof object.employeeID === "object")
                            message.employeeID = new $util.LongBits(object.employeeID.low >>> 0, object.employeeID.high >>> 0).toNumber();
                    if (object.subject != null)
                        message.subject = String(object.subject);
                    if (object.active != null)
                        message.active = Boolean(object.active);
                    return message;
                };

                /**
                 * Creates a plain object from a UserData message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.UserData
                 * @static
                 * @param {priority.netitems.shared.UserData} message UserData
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UserData.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.login = "";
                        object.apiLogin = "";
                        object.email = "";
                        object.firstname = "";
                        object.lastname = "";
                        object.fullname = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.userID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.userID = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.employeeID = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.employeeID = options.longs === String ? "0" : 0;
                        object.subject = "";
                        object.active = false;
                    }
                    if (message.login != null && message.hasOwnProperty("login"))
                        object.login = message.login;
                    if (message.apiLogin != null && message.hasOwnProperty("apiLogin"))
                        object.apiLogin = message.apiLogin;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.firstname != null && message.hasOwnProperty("firstname"))
                        object.firstname = message.firstname;
                    if (message.lastname != null && message.hasOwnProperty("lastname"))
                        object.lastname = message.lastname;
                    if (message.fullname != null && message.hasOwnProperty("fullname"))
                        object.fullname = message.fullname;
                    if (message.userID != null && message.hasOwnProperty("userID"))
                        if (typeof message.userID === "number")
                            object.userID = options.longs === String ? String(message.userID) : message.userID;
                        else
                            object.userID = options.longs === String ? $util.Long.prototype.toString.call(message.userID) : options.longs === Number ? new $util.LongBits(message.userID.low >>> 0, message.userID.high >>> 0).toNumber() : message.userID;
                    if (message.employeeID != null && message.hasOwnProperty("employeeID"))
                        if (typeof message.employeeID === "number")
                            object.employeeID = options.longs === String ? String(message.employeeID) : message.employeeID;
                        else
                            object.employeeID = options.longs === String ? $util.Long.prototype.toString.call(message.employeeID) : options.longs === Number ? new $util.LongBits(message.employeeID.low >>> 0, message.employeeID.high >>> 0).toNumber() : message.employeeID;
                    if (message.subject != null && message.hasOwnProperty("subject"))
                        object.subject = message.subject;
                    if (message.active != null && message.hasOwnProperty("active"))
                        object.active = message.active;
                    return object;
                };

                /**
                 * Converts this UserData to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.UserData
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UserData.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UserData;
            })();

            shared.TenantDetailsResponse = (function() {

                /**
                 * Properties of a TenantDetailsResponse.
                 * @memberof priority.netitems.shared
                 * @interface ITenantDetailsResponse
                 * @property {boolean|null} [hosting] TenantDetailsResponse hosting
                 * @property {string|null} [licenseID] TenantDetailsResponse licenseID
                 * @property {string|null} [tenantID] TenantDetailsResponse tenantID
                 * @property {string|null} [gatewayURL] TenantDetailsResponse gatewayURL
                 * @property {string|null} [publicKeyID] TenantDetailsResponse publicKeyID
                 * @property {string|null} [publicKeyData] TenantDetailsResponse publicKeyData
                 * @property {number|null} [Version] TenantDetailsResponse Version
                 */

                /**
                 * Constructs a new TenantDetailsResponse.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a TenantDetailsResponse.
                 * @implements ITenantDetailsResponse
                 * @constructor
                 * @param {priority.netitems.shared.ITenantDetailsResponse=} [properties] Properties to set
                 */
                function TenantDetailsResponse(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TenantDetailsResponse hosting.
                 * @member {boolean} hosting
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @instance
                 */
                TenantDetailsResponse.prototype.hosting = false;

                /**
                 * TenantDetailsResponse licenseID.
                 * @member {string} licenseID
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @instance
                 */
                TenantDetailsResponse.prototype.licenseID = "";

                /**
                 * TenantDetailsResponse tenantID.
                 * @member {string} tenantID
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @instance
                 */
                TenantDetailsResponse.prototype.tenantID = "";

                /**
                 * TenantDetailsResponse gatewayURL.
                 * @member {string} gatewayURL
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @instance
                 */
                TenantDetailsResponse.prototype.gatewayURL = "";

                /**
                 * TenantDetailsResponse publicKeyID.
                 * @member {string} publicKeyID
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @instance
                 */
                TenantDetailsResponse.prototype.publicKeyID = "";

                /**
                 * TenantDetailsResponse publicKeyData.
                 * @member {string} publicKeyData
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @instance
                 */
                TenantDetailsResponse.prototype.publicKeyData = "";

                /**
                 * TenantDetailsResponse Version.
                 * @member {number} Version
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @instance
                 */
                TenantDetailsResponse.prototype.Version = 0;

                /**
                 * Creates a new TenantDetailsResponse instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @static
                 * @param {priority.netitems.shared.ITenantDetailsResponse=} [properties] Properties to set
                 * @returns {priority.netitems.shared.TenantDetailsResponse} TenantDetailsResponse instance
                 */
                TenantDetailsResponse.create = function create(properties) {
                    return new TenantDetailsResponse(properties);
                };

                /**
                 * Encodes the specified TenantDetailsResponse message. Does not implicitly {@link priority.netitems.shared.TenantDetailsResponse.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @static
                 * @param {priority.netitems.shared.ITenantDetailsResponse} message TenantDetailsResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TenantDetailsResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.hosting != null && Object.hasOwnProperty.call(message, "hosting"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.hosting);
                    if (message.licenseID != null && Object.hasOwnProperty.call(message, "licenseID"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.licenseID);
                    if (message.tenantID != null && Object.hasOwnProperty.call(message, "tenantID"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.tenantID);
                    if (message.gatewayURL != null && Object.hasOwnProperty.call(message, "gatewayURL"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.gatewayURL);
                    if (message.publicKeyID != null && Object.hasOwnProperty.call(message, "publicKeyID"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.publicKeyID);
                    if (message.publicKeyData != null && Object.hasOwnProperty.call(message, "publicKeyData"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.publicKeyData);
                    if (message.Version != null && Object.hasOwnProperty.call(message, "Version"))
                        writer.uint32(/* id 7, wireType 5 =*/61).float(message.Version);
                    return writer;
                };

                /**
                 * Encodes the specified TenantDetailsResponse message, length delimited. Does not implicitly {@link priority.netitems.shared.TenantDetailsResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @static
                 * @param {priority.netitems.shared.ITenantDetailsResponse} message TenantDetailsResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TenantDetailsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TenantDetailsResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.TenantDetailsResponse} TenantDetailsResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TenantDetailsResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.TenantDetailsResponse();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.hosting = reader.bool();
                            break;
                        case 2:
                            message.licenseID = reader.string();
                            break;
                        case 3:
                            message.tenantID = reader.string();
                            break;
                        case 4:
                            message.gatewayURL = reader.string();
                            break;
                        case 5:
                            message.publicKeyID = reader.string();
                            break;
                        case 6:
                            message.publicKeyData = reader.string();
                            break;
                        case 7:
                            message.Version = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TenantDetailsResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.TenantDetailsResponse} TenantDetailsResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TenantDetailsResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TenantDetailsResponse message.
                 * @function verify
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TenantDetailsResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.hosting != null && message.hasOwnProperty("hosting"))
                        if (typeof message.hosting !== "boolean")
                            return "hosting: boolean expected";
                    if (message.licenseID != null && message.hasOwnProperty("licenseID"))
                        if (!$util.isString(message.licenseID))
                            return "licenseID: string expected";
                    if (message.tenantID != null && message.hasOwnProperty("tenantID"))
                        if (!$util.isString(message.tenantID))
                            return "tenantID: string expected";
                    if (message.gatewayURL != null && message.hasOwnProperty("gatewayURL"))
                        if (!$util.isString(message.gatewayURL))
                            return "gatewayURL: string expected";
                    if (message.publicKeyID != null && message.hasOwnProperty("publicKeyID"))
                        if (!$util.isString(message.publicKeyID))
                            return "publicKeyID: string expected";
                    if (message.publicKeyData != null && message.hasOwnProperty("publicKeyData"))
                        if (!$util.isString(message.publicKeyData))
                            return "publicKeyData: string expected";
                    if (message.Version != null && message.hasOwnProperty("Version"))
                        if (typeof message.Version !== "number")
                            return "Version: number expected";
                    return null;
                };

                /**
                 * Creates a TenantDetailsResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.TenantDetailsResponse} TenantDetailsResponse
                 */
                TenantDetailsResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.TenantDetailsResponse)
                        return object;
                    var message = new $root.priority.netitems.shared.TenantDetailsResponse();
                    if (object.hosting != null)
                        message.hosting = Boolean(object.hosting);
                    if (object.licenseID != null)
                        message.licenseID = String(object.licenseID);
                    if (object.tenantID != null)
                        message.tenantID = String(object.tenantID);
                    if (object.gatewayURL != null)
                        message.gatewayURL = String(object.gatewayURL);
                    if (object.publicKeyID != null)
                        message.publicKeyID = String(object.publicKeyID);
                    if (object.publicKeyData != null)
                        message.publicKeyData = String(object.publicKeyData);
                    if (object.Version != null)
                        message.Version = Number(object.Version);
                    return message;
                };

                /**
                 * Creates a plain object from a TenantDetailsResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @static
                 * @param {priority.netitems.shared.TenantDetailsResponse} message TenantDetailsResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TenantDetailsResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.hosting = false;
                        object.licenseID = "";
                        object.tenantID = "";
                        object.gatewayURL = "";
                        object.publicKeyID = "";
                        object.publicKeyData = "";
                        object.Version = 0;
                    }
                    if (message.hosting != null && message.hasOwnProperty("hosting"))
                        object.hosting = message.hosting;
                    if (message.licenseID != null && message.hasOwnProperty("licenseID"))
                        object.licenseID = message.licenseID;
                    if (message.tenantID != null && message.hasOwnProperty("tenantID"))
                        object.tenantID = message.tenantID;
                    if (message.gatewayURL != null && message.hasOwnProperty("gatewayURL"))
                        object.gatewayURL = message.gatewayURL;
                    if (message.publicKeyID != null && message.hasOwnProperty("publicKeyID"))
                        object.publicKeyID = message.publicKeyID;
                    if (message.publicKeyData != null && message.hasOwnProperty("publicKeyData"))
                        object.publicKeyData = message.publicKeyData;
                    if (message.Version != null && message.hasOwnProperty("Version"))
                        object.Version = options.json && !isFinite(message.Version) ? String(message.Version) : message.Version;
                    return object;
                };

                /**
                 * Converts this TenantDetailsResponse to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.TenantDetailsResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TenantDetailsResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TenantDetailsResponse;
            })();

            /**
             * FieldSelectType enum.
             * @name priority.netitems.shared.FieldSelectType
             * @enum {number}
             * @property {number} Choose=0 Choose value
             * @property {number} SearchDes=1 SearchDes value
             * @property {number} SearchName=2 SearchName value
             * @property {number} SearchEdes=3 SearchEdes value
             * @property {number} SearchAll=4 SearchAll value
             */
            shared.FieldSelectType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "Choose"] = 0;
                values[valuesById[1] = "SearchDes"] = 1;
                values[valuesById[2] = "SearchName"] = 2;
                values[valuesById[3] = "SearchEdes"] = 3;
                values[valuesById[4] = "SearchAll"] = 4;
                return values;
            })();

            /**
             * LogicalOperator enum.
             * @name priority.netitems.shared.LogicalOperator
             * @enum {number}
             * @property {number} And=0 And value
             * @property {number} Or=1 Or value
             */
            shared.LogicalOperator = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "And"] = 0;
                values[valuesById[1] = "Or"] = 1;
                return values;
            })();

            /**
             * ComparisonOperator enum.
             * @name priority.netitems.shared.ComparisonOperator
             * @enum {number}
             * @property {number} Eq=0 Eq value
             * @property {number} In=1 In value
             * @property {number} NotIn=2 NotIn value
             * @property {number} Between=3 Between value
             * @property {number} Gt=4 Gt value
             * @property {number} Lt=5 Lt value
             * @property {number} Le=6 Le value
             * @property {number} Ge=7 Ge value
             * @property {number} Ne=8 Ne value
             * @property {number} NotBetween=9 NotBetween value
             * @property {number} IsNull=10 IsNull value
             * @property {number} IsNotNull=11 IsNotNull value
             * @property {number} Like=12 Like value
             * @property {number} NotLike=13 NotLike value
             * @property {number} AndNot=14 AndNot value
             */
            shared.ComparisonOperator = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "Eq"] = 0;
                values[valuesById[1] = "In"] = 1;
                values[valuesById[2] = "NotIn"] = 2;
                values[valuesById[3] = "Between"] = 3;
                values[valuesById[4] = "Gt"] = 4;
                values[valuesById[5] = "Lt"] = 5;
                values[valuesById[6] = "Le"] = 6;
                values[valuesById[7] = "Ge"] = 7;
                values[valuesById[8] = "Ne"] = 8;
                values[valuesById[9] = "NotBetween"] = 9;
                values[valuesById[10] = "IsNull"] = 10;
                values[valuesById[11] = "IsNotNull"] = 11;
                values[valuesById[12] = "Like"] = 12;
                values[valuesById[13] = "NotLike"] = 13;
                values[valuesById[14] = "AndNot"] = 14;
                return values;
            })();

            shared.GrpcError = (function() {

                /**
                 * Properties of a GrpcError.
                 * @memberof priority.netitems.shared
                 * @interface IGrpcError
                 * @property {string|null} [error] GrpcError error
                 * @property {number|Long|null} [code] GrpcError code
                 */

                /**
                 * Constructs a new GrpcError.
                 * @memberof priority.netitems.shared
                 * @classdesc Represents a GrpcError.
                 * @implements IGrpcError
                 * @constructor
                 * @param {priority.netitems.shared.IGrpcError=} [properties] Properties to set
                 */
                function GrpcError(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GrpcError error.
                 * @member {string} error
                 * @memberof priority.netitems.shared.GrpcError
                 * @instance
                 */
                GrpcError.prototype.error = "";

                /**
                 * GrpcError code.
                 * @member {number|Long} code
                 * @memberof priority.netitems.shared.GrpcError
                 * @instance
                 */
                GrpcError.prototype.code = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new GrpcError instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.shared.GrpcError
                 * @static
                 * @param {priority.netitems.shared.IGrpcError=} [properties] Properties to set
                 * @returns {priority.netitems.shared.GrpcError} GrpcError instance
                 */
                GrpcError.create = function create(properties) {
                    return new GrpcError(properties);
                };

                /**
                 * Encodes the specified GrpcError message. Does not implicitly {@link priority.netitems.shared.GrpcError.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.shared.GrpcError
                 * @static
                 * @param {priority.netitems.shared.IGrpcError} message GrpcError message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GrpcError.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.error != null && Object.hasOwnProperty.call(message, "error"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.error);
                    if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.code);
                    return writer;
                };

                /**
                 * Encodes the specified GrpcError message, length delimited. Does not implicitly {@link priority.netitems.shared.GrpcError.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.shared.GrpcError
                 * @static
                 * @param {priority.netitems.shared.IGrpcError} message GrpcError message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GrpcError.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GrpcError message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.shared.GrpcError
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.shared.GrpcError} GrpcError
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GrpcError.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.shared.GrpcError();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.error = reader.string();
                            break;
                        case 2:
                            message.code = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GrpcError message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.shared.GrpcError
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.shared.GrpcError} GrpcError
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GrpcError.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GrpcError message.
                 * @function verify
                 * @memberof priority.netitems.shared.GrpcError
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GrpcError.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.error != null && message.hasOwnProperty("error"))
                        if (!$util.isString(message.error))
                            return "error: string expected";
                    if (message.code != null && message.hasOwnProperty("code"))
                        if (!$util.isInteger(message.code) && !(message.code && $util.isInteger(message.code.low) && $util.isInteger(message.code.high)))
                            return "code: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a GrpcError message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.shared.GrpcError
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.shared.GrpcError} GrpcError
                 */
                GrpcError.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.shared.GrpcError)
                        return object;
                    var message = new $root.priority.netitems.shared.GrpcError();
                    if (object.error != null)
                        message.error = String(object.error);
                    if (object.code != null)
                        if ($util.Long)
                            (message.code = $util.Long.fromValue(object.code)).unsigned = false;
                        else if (typeof object.code === "string")
                            message.code = parseInt(object.code, 10);
                        else if (typeof object.code === "number")
                            message.code = object.code;
                        else if (typeof object.code === "object")
                            message.code = new $util.LongBits(object.code.low >>> 0, object.code.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a GrpcError message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.shared.GrpcError
                 * @static
                 * @param {priority.netitems.shared.GrpcError} message GrpcError
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GrpcError.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.error = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.code = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.code = options.longs === String ? "0" : 0;
                    }
                    if (message.error != null && message.hasOwnProperty("error"))
                        object.error = message.error;
                    if (message.code != null && message.hasOwnProperty("code"))
                        if (typeof message.code === "number")
                            object.code = options.longs === String ? String(message.code) : message.code;
                        else
                            object.code = options.longs === String ? $util.Long.prototype.toString.call(message.code) : options.longs === Number ? new $util.LongBits(message.code.low >>> 0, message.code.high >>> 0).toNumber() : message.code;
                    return object;
                };

                /**
                 * Converts this GrpcError to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.shared.GrpcError
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GrpcError.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GrpcError;
            })();

            return shared;
        })();

        netitems.ngtw = (function() {

            /**
             * Namespace ngtw.
             * @memberof priority.netitems
             * @namespace
             */
            var ngtw = {};

            ngtw.NetdefsResponse = (function() {

                /**
                 * Properties of a NetdefsResponse.
                 * @memberof priority.netitems.ngtw
                 * @interface INetdefsResponse
                 * @property {string|null} [ServerURL] NetdefsResponse ServerURL
                 * @property {string|null} [Click2PayRestApiUser] NetdefsResponse Click2PayRestApiUser
                 * @property {string|null} [Click2PayRestApiPassword] NetdefsResponse Click2PayRestApiPassword
                 * @property {string|null} [WCF_URL] NetdefsResponse WCF_URL
                 */

                /**
                 * Constructs a new NetdefsResponse.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a NetdefsResponse.
                 * @implements INetdefsResponse
                 * @constructor
                 * @param {priority.netitems.ngtw.INetdefsResponse=} [properties] Properties to set
                 */
                function NetdefsResponse(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NetdefsResponse ServerURL.
                 * @member {string} ServerURL
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @instance
                 */
                NetdefsResponse.prototype.ServerURL = "";

                /**
                 * NetdefsResponse Click2PayRestApiUser.
                 * @member {string} Click2PayRestApiUser
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @instance
                 */
                NetdefsResponse.prototype.Click2PayRestApiUser = "";

                /**
                 * NetdefsResponse Click2PayRestApiPassword.
                 * @member {string} Click2PayRestApiPassword
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @instance
                 */
                NetdefsResponse.prototype.Click2PayRestApiPassword = "";

                /**
                 * NetdefsResponse WCF_URL.
                 * @member {string} WCF_URL
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @instance
                 */
                NetdefsResponse.prototype.WCF_URL = "";

                /**
                 * Creates a new NetdefsResponse instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @static
                 * @param {priority.netitems.ngtw.INetdefsResponse=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.NetdefsResponse} NetdefsResponse instance
                 */
                NetdefsResponse.create = function create(properties) {
                    return new NetdefsResponse(properties);
                };

                /**
                 * Encodes the specified NetdefsResponse message. Does not implicitly {@link priority.netitems.ngtw.NetdefsResponse.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @static
                 * @param {priority.netitems.ngtw.INetdefsResponse} message NetdefsResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NetdefsResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ServerURL != null && Object.hasOwnProperty.call(message, "ServerURL"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.ServerURL);
                    if (message.Click2PayRestApiUser != null && Object.hasOwnProperty.call(message, "Click2PayRestApiUser"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Click2PayRestApiUser);
                    if (message.Click2PayRestApiPassword != null && Object.hasOwnProperty.call(message, "Click2PayRestApiPassword"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Click2PayRestApiPassword);
                    if (message.WCF_URL != null && Object.hasOwnProperty.call(message, "WCF_URL"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.WCF_URL);
                    return writer;
                };

                /**
                 * Encodes the specified NetdefsResponse message, length delimited. Does not implicitly {@link priority.netitems.ngtw.NetdefsResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @static
                 * @param {priority.netitems.ngtw.INetdefsResponse} message NetdefsResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NetdefsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NetdefsResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.NetdefsResponse} NetdefsResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NetdefsResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.NetdefsResponse();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ServerURL = reader.string();
                            break;
                        case 2:
                            message.Click2PayRestApiUser = reader.string();
                            break;
                        case 3:
                            message.Click2PayRestApiPassword = reader.string();
                            break;
                        case 4:
                            message.WCF_URL = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NetdefsResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.NetdefsResponse} NetdefsResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NetdefsResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NetdefsResponse message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NetdefsResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ServerURL != null && message.hasOwnProperty("ServerURL"))
                        if (!$util.isString(message.ServerURL))
                            return "ServerURL: string expected";
                    if (message.Click2PayRestApiUser != null && message.hasOwnProperty("Click2PayRestApiUser"))
                        if (!$util.isString(message.Click2PayRestApiUser))
                            return "Click2PayRestApiUser: string expected";
                    if (message.Click2PayRestApiPassword != null && message.hasOwnProperty("Click2PayRestApiPassword"))
                        if (!$util.isString(message.Click2PayRestApiPassword))
                            return "Click2PayRestApiPassword: string expected";
                    if (message.WCF_URL != null && message.hasOwnProperty("WCF_URL"))
                        if (!$util.isString(message.WCF_URL))
                            return "WCF_URL: string expected";
                    return null;
                };

                /**
                 * Creates a NetdefsResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.NetdefsResponse} NetdefsResponse
                 */
                NetdefsResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.NetdefsResponse)
                        return object;
                    var message = new $root.priority.netitems.ngtw.NetdefsResponse();
                    if (object.ServerURL != null)
                        message.ServerURL = String(object.ServerURL);
                    if (object.Click2PayRestApiUser != null)
                        message.Click2PayRestApiUser = String(object.Click2PayRestApiUser);
                    if (object.Click2PayRestApiPassword != null)
                        message.Click2PayRestApiPassword = String(object.Click2PayRestApiPassword);
                    if (object.WCF_URL != null)
                        message.WCF_URL = String(object.WCF_URL);
                    return message;
                };

                /**
                 * Creates a plain object from a NetdefsResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @static
                 * @param {priority.netitems.ngtw.NetdefsResponse} message NetdefsResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NetdefsResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.ServerURL = "";
                        object.Click2PayRestApiUser = "";
                        object.Click2PayRestApiPassword = "";
                        object.WCF_URL = "";
                    }
                    if (message.ServerURL != null && message.hasOwnProperty("ServerURL"))
                        object.ServerURL = message.ServerURL;
                    if (message.Click2PayRestApiUser != null && message.hasOwnProperty("Click2PayRestApiUser"))
                        object.Click2PayRestApiUser = message.Click2PayRestApiUser;
                    if (message.Click2PayRestApiPassword != null && message.hasOwnProperty("Click2PayRestApiPassword"))
                        object.Click2PayRestApiPassword = message.Click2PayRestApiPassword;
                    if (message.WCF_URL != null && message.hasOwnProperty("WCF_URL"))
                        object.WCF_URL = message.WCF_URL;
                    return object;
                };

                /**
                 * Converts this NetdefsResponse to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.NetdefsResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NetdefsResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NetdefsResponse;
            })();

            ngtw.EntityMessagesRequest = (function() {

                /**
                 * Properties of an EntityMessagesRequest.
                 * @memberof priority.netitems.ngtw
                 * @interface IEntityMessagesRequest
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] EntityMessagesRequest Properties
                 * @property {string|null} [ename] EntityMessagesRequest ename
                 * @property {priority.netitems.ngtw.EntityMessagesRequest.EntityType|null} [entityType] EntityMessagesRequest entityType
                 * @property {number|Long|null} [lang] EntityMessagesRequest lang
                 * @property {number|Long|null} [frommsg] EntityMessagesRequest frommsg
                 * @property {number|Long|null} [tomsg] EntityMessagesRequest tomsg
                 */

                /**
                 * Constructs a new EntityMessagesRequest.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an EntityMessagesRequest.
                 * @implements IEntityMessagesRequest
                 * @constructor
                 * @param {priority.netitems.ngtw.IEntityMessagesRequest=} [properties] Properties to set
                 */
                function EntityMessagesRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EntityMessagesRequest Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @instance
                 */
                EntityMessagesRequest.prototype.Properties = null;

                /**
                 * EntityMessagesRequest ename.
                 * @member {string} ename
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @instance
                 */
                EntityMessagesRequest.prototype.ename = "";

                /**
                 * EntityMessagesRequest entityType.
                 * @member {priority.netitems.ngtw.EntityMessagesRequest.EntityType} entityType
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @instance
                 */
                EntityMessagesRequest.prototype.entityType = 0;

                /**
                 * EntityMessagesRequest lang.
                 * @member {number|Long} lang
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @instance
                 */
                EntityMessagesRequest.prototype.lang = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * EntityMessagesRequest frommsg.
                 * @member {number|Long} frommsg
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @instance
                 */
                EntityMessagesRequest.prototype.frommsg = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * EntityMessagesRequest tomsg.
                 * @member {number|Long} tomsg
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @instance
                 */
                EntityMessagesRequest.prototype.tomsg = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new EntityMessagesRequest instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @static
                 * @param {priority.netitems.ngtw.IEntityMessagesRequest=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.EntityMessagesRequest} EntityMessagesRequest instance
                 */
                EntityMessagesRequest.create = function create(properties) {
                    return new EntityMessagesRequest(properties);
                };

                /**
                 * Encodes the specified EntityMessagesRequest message. Does not implicitly {@link priority.netitems.ngtw.EntityMessagesRequest.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @static
                 * @param {priority.netitems.ngtw.IEntityMessagesRequest} message EntityMessagesRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EntityMessagesRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ename != null && Object.hasOwnProperty.call(message, "ename"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.ename);
                    if (message.entityType != null && Object.hasOwnProperty.call(message, "entityType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.entityType);
                    if (message.lang != null && Object.hasOwnProperty.call(message, "lang"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lang);
                    if (message.frommsg != null && Object.hasOwnProperty.call(message, "frommsg"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.frommsg);
                    if (message.tomsg != null && Object.hasOwnProperty.call(message, "tomsg"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.tomsg);
                    return writer;
                };

                /**
                 * Encodes the specified EntityMessagesRequest message, length delimited. Does not implicitly {@link priority.netitems.ngtw.EntityMessagesRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @static
                 * @param {priority.netitems.ngtw.IEntityMessagesRequest} message EntityMessagesRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EntityMessagesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EntityMessagesRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.EntityMessagesRequest} EntityMessagesRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EntityMessagesRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.EntityMessagesRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.ename = reader.string();
                            break;
                        case 3:
                            message.entityType = reader.int32();
                            break;
                        case 4:
                            message.lang = reader.int64();
                            break;
                        case 5:
                            message.frommsg = reader.int64();
                            break;
                        case 6:
                            message.tomsg = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EntityMessagesRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.EntityMessagesRequest} EntityMessagesRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EntityMessagesRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EntityMessagesRequest message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EntityMessagesRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.ename != null && message.hasOwnProperty("ename"))
                        if (!$util.isString(message.ename))
                            return "ename: string expected";
                    if (message.entityType != null && message.hasOwnProperty("entityType"))
                        switch (message.entityType) {
                        default:
                            return "entityType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.lang != null && message.hasOwnProperty("lang"))
                        if (!$util.isInteger(message.lang) && !(message.lang && $util.isInteger(message.lang.low) && $util.isInteger(message.lang.high)))
                            return "lang: integer|Long expected";
                    if (message.frommsg != null && message.hasOwnProperty("frommsg"))
                        if (!$util.isInteger(message.frommsg) && !(message.frommsg && $util.isInteger(message.frommsg.low) && $util.isInteger(message.frommsg.high)))
                            return "frommsg: integer|Long expected";
                    if (message.tomsg != null && message.hasOwnProperty("tomsg"))
                        if (!$util.isInteger(message.tomsg) && !(message.tomsg && $util.isInteger(message.tomsg.low) && $util.isInteger(message.tomsg.high)))
                            return "tomsg: integer|Long expected";
                    return null;
                };

                /**
                 * Creates an EntityMessagesRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.EntityMessagesRequest} EntityMessagesRequest
                 */
                EntityMessagesRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.EntityMessagesRequest)
                        return object;
                    var message = new $root.priority.netitems.ngtw.EntityMessagesRequest();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngtw.EntityMessagesRequest.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.ename != null)
                        message.ename = String(object.ename);
                    switch (object.entityType) {
                    case "Procedure":
                    case 0:
                        message.entityType = 0;
                        break;
                    case "Compiled":
                    case 1:
                        message.entityType = 1;
                        break;
                    case "Form":
                    case 2:
                        message.entityType = 2;
                        break;
                    }
                    if (object.lang != null)
                        if ($util.Long)
                            (message.lang = $util.Long.fromValue(object.lang)).unsigned = false;
                        else if (typeof object.lang === "string")
                            message.lang = parseInt(object.lang, 10);
                        else if (typeof object.lang === "number")
                            message.lang = object.lang;
                        else if (typeof object.lang === "object")
                            message.lang = new $util.LongBits(object.lang.low >>> 0, object.lang.high >>> 0).toNumber();
                    if (object.frommsg != null)
                        if ($util.Long)
                            (message.frommsg = $util.Long.fromValue(object.frommsg)).unsigned = false;
                        else if (typeof object.frommsg === "string")
                            message.frommsg = parseInt(object.frommsg, 10);
                        else if (typeof object.frommsg === "number")
                            message.frommsg = object.frommsg;
                        else if (typeof object.frommsg === "object")
                            message.frommsg = new $util.LongBits(object.frommsg.low >>> 0, object.frommsg.high >>> 0).toNumber();
                    if (object.tomsg != null)
                        if ($util.Long)
                            (message.tomsg = $util.Long.fromValue(object.tomsg)).unsigned = false;
                        else if (typeof object.tomsg === "string")
                            message.tomsg = parseInt(object.tomsg, 10);
                        else if (typeof object.tomsg === "number")
                            message.tomsg = object.tomsg;
                        else if (typeof object.tomsg === "object")
                            message.tomsg = new $util.LongBits(object.tomsg.low >>> 0, object.tomsg.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from an EntityMessagesRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @static
                 * @param {priority.netitems.ngtw.EntityMessagesRequest} message EntityMessagesRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EntityMessagesRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.ename = "";
                        object.entityType = options.enums === String ? "Procedure" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lang = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lang = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.frommsg = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.frommsg = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.tomsg = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.tomsg = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.ename != null && message.hasOwnProperty("ename"))
                        object.ename = message.ename;
                    if (message.entityType != null && message.hasOwnProperty("entityType"))
                        object.entityType = options.enums === String ? $root.priority.netitems.ngtw.EntityMessagesRequest.EntityType[message.entityType] : message.entityType;
                    if (message.lang != null && message.hasOwnProperty("lang"))
                        if (typeof message.lang === "number")
                            object.lang = options.longs === String ? String(message.lang) : message.lang;
                        else
                            object.lang = options.longs === String ? $util.Long.prototype.toString.call(message.lang) : options.longs === Number ? new $util.LongBits(message.lang.low >>> 0, message.lang.high >>> 0).toNumber() : message.lang;
                    if (message.frommsg != null && message.hasOwnProperty("frommsg"))
                        if (typeof message.frommsg === "number")
                            object.frommsg = options.longs === String ? String(message.frommsg) : message.frommsg;
                        else
                            object.frommsg = options.longs === String ? $util.Long.prototype.toString.call(message.frommsg) : options.longs === Number ? new $util.LongBits(message.frommsg.low >>> 0, message.frommsg.high >>> 0).toNumber() : message.frommsg;
                    if (message.tomsg != null && message.hasOwnProperty("tomsg"))
                        if (typeof message.tomsg === "number")
                            object.tomsg = options.longs === String ? String(message.tomsg) : message.tomsg;
                        else
                            object.tomsg = options.longs === String ? $util.Long.prototype.toString.call(message.tomsg) : options.longs === Number ? new $util.LongBits(message.tomsg.low >>> 0, message.tomsg.high >>> 0).toNumber() : message.tomsg;
                    return object;
                };

                /**
                 * Converts this EntityMessagesRequest to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.EntityMessagesRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EntityMessagesRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * EntityType enum.
                 * @name priority.netitems.ngtw.EntityMessagesRequest.EntityType
                 * @enum {number}
                 * @property {number} Procedure=0 Procedure value
                 * @property {number} Compiled=1 Compiled value
                 * @property {number} Form=2 Form value
                 */
                EntityMessagesRequest.EntityType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "Procedure"] = 0;
                    values[valuesById[1] = "Compiled"] = 1;
                    values[valuesById[2] = "Form"] = 2;
                    return values;
                })();

                return EntityMessagesRequest;
            })();

            ngtw.EntityMessagesResponse = (function() {

                /**
                 * Properties of an EntityMessagesResponse.
                 * @memberof priority.netitems.ngtw
                 * @interface IEntityMessagesResponse
                 * @property {Object.<string,string>|null} [msgs] EntityMessagesResponse msgs
                 */

                /**
                 * Constructs a new EntityMessagesResponse.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an EntityMessagesResponse.
                 * @implements IEntityMessagesResponse
                 * @constructor
                 * @param {priority.netitems.ngtw.IEntityMessagesResponse=} [properties] Properties to set
                 */
                function EntityMessagesResponse(properties) {
                    this.msgs = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * EntityMessagesResponse msgs.
                 * @member {Object.<string,string>} msgs
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @instance
                 */
                EntityMessagesResponse.prototype.msgs = $util.emptyObject;

                /**
                 * Creates a new EntityMessagesResponse instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @static
                 * @param {priority.netitems.ngtw.IEntityMessagesResponse=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.EntityMessagesResponse} EntityMessagesResponse instance
                 */
                EntityMessagesResponse.create = function create(properties) {
                    return new EntityMessagesResponse(properties);
                };

                /**
                 * Encodes the specified EntityMessagesResponse message. Does not implicitly {@link priority.netitems.ngtw.EntityMessagesResponse.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @static
                 * @param {priority.netitems.ngtw.IEntityMessagesResponse} message EntityMessagesResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EntityMessagesResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.msgs != null && Object.hasOwnProperty.call(message, "msgs"))
                        for (var keys = Object.keys(message.msgs), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 0 =*/8).int64(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.msgs[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified EntityMessagesResponse message, length delimited. Does not implicitly {@link priority.netitems.ngtw.EntityMessagesResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @static
                 * @param {priority.netitems.ngtw.IEntityMessagesResponse} message EntityMessagesResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EntityMessagesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an EntityMessagesResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.EntityMessagesResponse} EntityMessagesResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EntityMessagesResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.EntityMessagesResponse(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (message.msgs === $util.emptyObject)
                                message.msgs = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = 0;
                            value = "";
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.int64();
                                    break;
                                case 2:
                                    value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.msgs[typeof key === "object" ? $util.longToHash(key) : key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an EntityMessagesResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.EntityMessagesResponse} EntityMessagesResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EntityMessagesResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an EntityMessagesResponse message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EntityMessagesResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.msgs != null && message.hasOwnProperty("msgs")) {
                        if (!$util.isObject(message.msgs))
                            return "msgs: object expected";
                        var key = Object.keys(message.msgs);
                        for (var i = 0; i < key.length; ++i) {
                            if (!$util.key64Re.test(key[i]))
                                return "msgs: integer|Long key{k:int64} expected";
                            if (!$util.isString(message.msgs[key[i]]))
                                return "msgs: string{k:int64} expected";
                        }
                    }
                    return null;
                };

                /**
                 * Creates an EntityMessagesResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.EntityMessagesResponse} EntityMessagesResponse
                 */
                EntityMessagesResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.EntityMessagesResponse)
                        return object;
                    var message = new $root.priority.netitems.ngtw.EntityMessagesResponse();
                    if (object.msgs) {
                        if (typeof object.msgs !== "object")
                            throw TypeError(".priority.netitems.ngtw.EntityMessagesResponse.msgs: object expected");
                        message.msgs = {};
                        for (var keys = Object.keys(object.msgs), i = 0; i < keys.length; ++i)
                            message.msgs[keys[i]] = String(object.msgs[keys[i]]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an EntityMessagesResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @static
                 * @param {priority.netitems.ngtw.EntityMessagesResponse} message EntityMessagesResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EntityMessagesResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.objects || options.defaults)
                        object.msgs = {};
                    var keys2;
                    if (message.msgs && (keys2 = Object.keys(message.msgs)).length) {
                        object.msgs = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.msgs[keys2[j]] = message.msgs[keys2[j]];
                    }
                    return object;
                };

                /**
                 * Converts this EntityMessagesResponse to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.EntityMessagesResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EntityMessagesResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return EntityMessagesResponse;
            })();

            ngtw.ExecuteCompiledParam = (function() {

                /**
                 * Properties of an ExecuteCompiledParam.
                 * @memberof priority.netitems.ngtw
                 * @interface IExecuteCompiledParam
                 * @property {priority.netitems.ngtw.ExecuteCompiledParam.ParamType|null} [type] ExecuteCompiledParam type
                 * @property {string|null} [value] ExecuteCompiledParam value
                 * @property {Uint8Array|null} [bvalue] ExecuteCompiledParam bvalue
                 * @property {string|null} [extension] ExecuteCompiledParam extension
                 */

                /**
                 * Constructs a new ExecuteCompiledParam.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an ExecuteCompiledParam.
                 * @implements IExecuteCompiledParam
                 * @constructor
                 * @param {priority.netitems.ngtw.IExecuteCompiledParam=} [properties] Properties to set
                 */
                function ExecuteCompiledParam(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ExecuteCompiledParam type.
                 * @member {priority.netitems.ngtw.ExecuteCompiledParam.ParamType} type
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @instance
                 */
                ExecuteCompiledParam.prototype.type = 0;

                /**
                 * ExecuteCompiledParam value.
                 * @member {string} value
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @instance
                 */
                ExecuteCompiledParam.prototype.value = "";

                /**
                 * ExecuteCompiledParam bvalue.
                 * @member {Uint8Array} bvalue
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @instance
                 */
                ExecuteCompiledParam.prototype.bvalue = $util.newBuffer([]);

                /**
                 * ExecuteCompiledParam extension.
                 * @member {string} extension
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @instance
                 */
                ExecuteCompiledParam.prototype.extension = "";

                /**
                 * Creates a new ExecuteCompiledParam instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledParam=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.ExecuteCompiledParam} ExecuteCompiledParam instance
                 */
                ExecuteCompiledParam.create = function create(properties) {
                    return new ExecuteCompiledParam(properties);
                };

                /**
                 * Encodes the specified ExecuteCompiledParam message. Does not implicitly {@link priority.netitems.ngtw.ExecuteCompiledParam.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledParam} message ExecuteCompiledParam message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExecuteCompiledParam.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                    if (message.bvalue != null && Object.hasOwnProperty.call(message, "bvalue"))
                        writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.bvalue);
                    if (message.extension != null && Object.hasOwnProperty.call(message, "extension"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.extension);
                    return writer;
                };

                /**
                 * Encodes the specified ExecuteCompiledParam message, length delimited. Does not implicitly {@link priority.netitems.ngtw.ExecuteCompiledParam.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledParam} message ExecuteCompiledParam message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExecuteCompiledParam.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ExecuteCompiledParam message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.ExecuteCompiledParam} ExecuteCompiledParam
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExecuteCompiledParam.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.ExecuteCompiledParam();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.type = reader.int32();
                            break;
                        case 2:
                            message.value = reader.string();
                            break;
                        case 3:
                            message.bvalue = reader.bytes();
                            break;
                        case 4:
                            message.extension = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ExecuteCompiledParam message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.ExecuteCompiledParam} ExecuteCompiledParam
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExecuteCompiledParam.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ExecuteCompiledParam message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ExecuteCompiledParam.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!$util.isString(message.value))
                            return "value: string expected";
                    if (message.bvalue != null && message.hasOwnProperty("bvalue"))
                        if (!(message.bvalue && typeof message.bvalue.length === "number" || $util.isString(message.bvalue)))
                            return "bvalue: buffer expected";
                    if (message.extension != null && message.hasOwnProperty("extension"))
                        if (!$util.isString(message.extension))
                            return "extension: string expected";
                    return null;
                };

                /**
                 * Creates an ExecuteCompiledParam message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.ExecuteCompiledParam} ExecuteCompiledParam
                 */
                ExecuteCompiledParam.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.ExecuteCompiledParam)
                        return object;
                    var message = new $root.priority.netitems.ngtw.ExecuteCompiledParam();
                    switch (object.type) {
                    case "String":
                    case 0:
                        message.type = 0;
                        break;
                    case "File":
                    case 1:
                        message.type = 1;
                        break;
                    case "Output":
                    case 2:
                        message.type = 2;
                        break;
                    case "EncryptedFile":
                    case 3:
                        message.type = 3;
                        break;
                    case "BinaryFile":
                    case 4:
                        message.type = 4;
                        break;
                    case "BinaryOutput":
                    case 5:
                        message.type = 5;
                        break;
                    }
                    if (object.value != null)
                        message.value = String(object.value);
                    if (object.bvalue != null)
                        if (typeof object.bvalue === "string")
                            $util.base64.decode(object.bvalue, message.bvalue = $util.newBuffer($util.base64.length(object.bvalue)), 0);
                        else if (object.bvalue.length)
                            message.bvalue = object.bvalue;
                    if (object.extension != null)
                        message.extension = String(object.extension);
                    return message;
                };

                /**
                 * Creates a plain object from an ExecuteCompiledParam message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @static
                 * @param {priority.netitems.ngtw.ExecuteCompiledParam} message ExecuteCompiledParam
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ExecuteCompiledParam.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.type = options.enums === String ? "String" : 0;
                        object.value = "";
                        if (options.bytes === String)
                            object.bvalue = "";
                        else {
                            object.bvalue = [];
                            if (options.bytes !== Array)
                                object.bvalue = $util.newBuffer(object.bvalue);
                        }
                        object.extension = "";
                    }
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.priority.netitems.ngtw.ExecuteCompiledParam.ParamType[message.type] : message.type;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = message.value;
                    if (message.bvalue != null && message.hasOwnProperty("bvalue"))
                        object.bvalue = options.bytes === String ? $util.base64.encode(message.bvalue, 0, message.bvalue.length) : options.bytes === Array ? Array.prototype.slice.call(message.bvalue) : message.bvalue;
                    if (message.extension != null && message.hasOwnProperty("extension"))
                        object.extension = message.extension;
                    return object;
                };

                /**
                 * Converts this ExecuteCompiledParam to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.ExecuteCompiledParam
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ExecuteCompiledParam.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                /**
                 * ParamType enum.
                 * @name priority.netitems.ngtw.ExecuteCompiledParam.ParamType
                 * @enum {number}
                 * @property {number} String=0 String value
                 * @property {number} File=1 File value
                 * @property {number} Output=2 Output value
                 * @property {number} EncryptedFile=3 EncryptedFile value
                 * @property {number} BinaryFile=4 BinaryFile value
                 * @property {number} BinaryOutput=5 BinaryOutput value
                 */
                ExecuteCompiledParam.ParamType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "String"] = 0;
                    values[valuesById[1] = "File"] = 1;
                    values[valuesById[2] = "Output"] = 2;
                    values[valuesById[3] = "EncryptedFile"] = 3;
                    values[valuesById[4] = "BinaryFile"] = 4;
                    values[valuesById[5] = "BinaryOutput"] = 5;
                    return values;
                })();

                return ExecuteCompiledParam;
            })();

            ngtw.ExecuteCompiledRequest = (function() {

                /**
                 * Properties of an ExecuteCompiledRequest.
                 * @memberof priority.netitems.ngtw
                 * @interface IExecuteCompiledRequest
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ExecuteCompiledRequest Properties
                 * @property {string|null} [Progname] ExecuteCompiledRequest Progname
                 * @property {Array.<priority.netitems.ngtw.IExecuteCompiledParam>|null} [Params] ExecuteCompiledRequest Params
                 */

                /**
                 * Constructs a new ExecuteCompiledRequest.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an ExecuteCompiledRequest.
                 * @implements IExecuteCompiledRequest
                 * @constructor
                 * @param {priority.netitems.ngtw.IExecuteCompiledRequest=} [properties] Properties to set
                 */
                function ExecuteCompiledRequest(properties) {
                    this.Params = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ExecuteCompiledRequest Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @instance
                 */
                ExecuteCompiledRequest.prototype.Properties = null;

                /**
                 * ExecuteCompiledRequest Progname.
                 * @member {string} Progname
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @instance
                 */
                ExecuteCompiledRequest.prototype.Progname = "";

                /**
                 * ExecuteCompiledRequest Params.
                 * @member {Array.<priority.netitems.ngtw.IExecuteCompiledParam>} Params
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @instance
                 */
                ExecuteCompiledRequest.prototype.Params = $util.emptyArray;

                /**
                 * Creates a new ExecuteCompiledRequest instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledRequest=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.ExecuteCompiledRequest} ExecuteCompiledRequest instance
                 */
                ExecuteCompiledRequest.create = function create(properties) {
                    return new ExecuteCompiledRequest(properties);
                };

                /**
                 * Encodes the specified ExecuteCompiledRequest message. Does not implicitly {@link priority.netitems.ngtw.ExecuteCompiledRequest.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledRequest} message ExecuteCompiledRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExecuteCompiledRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Progname != null && Object.hasOwnProperty.call(message, "Progname"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Progname);
                    if (message.Params != null && message.Params.length)
                        for (var i = 0; i < message.Params.length; ++i)
                            $root.priority.netitems.ngtw.ExecuteCompiledParam.encode(message.Params[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ExecuteCompiledRequest message, length delimited. Does not implicitly {@link priority.netitems.ngtw.ExecuteCompiledRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledRequest} message ExecuteCompiledRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExecuteCompiledRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ExecuteCompiledRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.ExecuteCompiledRequest} ExecuteCompiledRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExecuteCompiledRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.ExecuteCompiledRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Progname = reader.string();
                            break;
                        case 3:
                            if (!(message.Params && message.Params.length))
                                message.Params = [];
                            message.Params.push($root.priority.netitems.ngtw.ExecuteCompiledParam.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ExecuteCompiledRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.ExecuteCompiledRequest} ExecuteCompiledRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExecuteCompiledRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ExecuteCompiledRequest message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ExecuteCompiledRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Progname != null && message.hasOwnProperty("Progname"))
                        if (!$util.isString(message.Progname))
                            return "Progname: string expected";
                    if (message.Params != null && message.hasOwnProperty("Params")) {
                        if (!Array.isArray(message.Params))
                            return "Params: array expected";
                        for (var i = 0; i < message.Params.length; ++i) {
                            var error = $root.priority.netitems.ngtw.ExecuteCompiledParam.verify(message.Params[i]);
                            if (error)
                                return "Params." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an ExecuteCompiledRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.ExecuteCompiledRequest} ExecuteCompiledRequest
                 */
                ExecuteCompiledRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.ExecuteCompiledRequest)
                        return object;
                    var message = new $root.priority.netitems.ngtw.ExecuteCompiledRequest();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngtw.ExecuteCompiledRequest.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Progname != null)
                        message.Progname = String(object.Progname);
                    if (object.Params) {
                        if (!Array.isArray(object.Params))
                            throw TypeError(".priority.netitems.ngtw.ExecuteCompiledRequest.Params: array expected");
                        message.Params = [];
                        for (var i = 0; i < object.Params.length; ++i) {
                            if (typeof object.Params[i] !== "object")
                                throw TypeError(".priority.netitems.ngtw.ExecuteCompiledRequest.Params: object expected");
                            message.Params[i] = $root.priority.netitems.ngtw.ExecuteCompiledParam.fromObject(object.Params[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ExecuteCompiledRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @static
                 * @param {priority.netitems.ngtw.ExecuteCompiledRequest} message ExecuteCompiledRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ExecuteCompiledRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Params = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.Progname = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Progname != null && message.hasOwnProperty("Progname"))
                        object.Progname = message.Progname;
                    if (message.Params && message.Params.length) {
                        object.Params = [];
                        for (var j = 0; j < message.Params.length; ++j)
                            object.Params[j] = $root.priority.netitems.ngtw.ExecuteCompiledParam.toObject(message.Params[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ExecuteCompiledRequest to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.ExecuteCompiledRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ExecuteCompiledRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ExecuteCompiledRequest;
            })();

            ngtw.ExecuteCompiledResponse = (function() {

                /**
                 * Properties of an ExecuteCompiledResponse.
                 * @memberof priority.netitems.ngtw
                 * @interface IExecuteCompiledResponse
                 * @property {boolean|null} [result] ExecuteCompiledResponse result
                 * @property {string|null} [message] ExecuteCompiledResponse message
                 * @property {Array.<priority.netitems.ngtw.IExecuteCompiledParam>|null} [params] ExecuteCompiledResponse params
                 */

                /**
                 * Constructs a new ExecuteCompiledResponse.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an ExecuteCompiledResponse.
                 * @implements IExecuteCompiledResponse
                 * @constructor
                 * @param {priority.netitems.ngtw.IExecuteCompiledResponse=} [properties] Properties to set
                 */
                function ExecuteCompiledResponse(properties) {
                    this.params = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ExecuteCompiledResponse result.
                 * @member {boolean} result
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @instance
                 */
                ExecuteCompiledResponse.prototype.result = false;

                /**
                 * ExecuteCompiledResponse message.
                 * @member {string} message
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @instance
                 */
                ExecuteCompiledResponse.prototype.message = "";

                /**
                 * ExecuteCompiledResponse params.
                 * @member {Array.<priority.netitems.ngtw.IExecuteCompiledParam>} params
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @instance
                 */
                ExecuteCompiledResponse.prototype.params = $util.emptyArray;

                /**
                 * Creates a new ExecuteCompiledResponse instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledResponse=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.ExecuteCompiledResponse} ExecuteCompiledResponse instance
                 */
                ExecuteCompiledResponse.create = function create(properties) {
                    return new ExecuteCompiledResponse(properties);
                };

                /**
                 * Encodes the specified ExecuteCompiledResponse message. Does not implicitly {@link priority.netitems.ngtw.ExecuteCompiledResponse.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledResponse} message ExecuteCompiledResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExecuteCompiledResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.result);
                    if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                    if (message.params != null && message.params.length)
                        for (var i = 0; i < message.params.length; ++i)
                            $root.priority.netitems.ngtw.ExecuteCompiledParam.encode(message.params[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ExecuteCompiledResponse message, length delimited. Does not implicitly {@link priority.netitems.ngtw.ExecuteCompiledResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @static
                 * @param {priority.netitems.ngtw.IExecuteCompiledResponse} message ExecuteCompiledResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExecuteCompiledResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ExecuteCompiledResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.ExecuteCompiledResponse} ExecuteCompiledResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExecuteCompiledResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.ExecuteCompiledResponse();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.result = reader.bool();
                            break;
                        case 2:
                            message.message = reader.string();
                            break;
                        case 3:
                            if (!(message.params && message.params.length))
                                message.params = [];
                            message.params.push($root.priority.netitems.ngtw.ExecuteCompiledParam.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ExecuteCompiledResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.ExecuteCompiledResponse} ExecuteCompiledResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExecuteCompiledResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ExecuteCompiledResponse message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ExecuteCompiledResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.result != null && message.hasOwnProperty("result"))
                        if (typeof message.result !== "boolean")
                            return "result: boolean expected";
                    if (message.message != null && message.hasOwnProperty("message"))
                        if (!$util.isString(message.message))
                            return "message: string expected";
                    if (message.params != null && message.hasOwnProperty("params")) {
                        if (!Array.isArray(message.params))
                            return "params: array expected";
                        for (var i = 0; i < message.params.length; ++i) {
                            var error = $root.priority.netitems.ngtw.ExecuteCompiledParam.verify(message.params[i]);
                            if (error)
                                return "params." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates an ExecuteCompiledResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.ExecuteCompiledResponse} ExecuteCompiledResponse
                 */
                ExecuteCompiledResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.ExecuteCompiledResponse)
                        return object;
                    var message = new $root.priority.netitems.ngtw.ExecuteCompiledResponse();
                    if (object.result != null)
                        message.result = Boolean(object.result);
                    if (object.message != null)
                        message.message = String(object.message);
                    if (object.params) {
                        if (!Array.isArray(object.params))
                            throw TypeError(".priority.netitems.ngtw.ExecuteCompiledResponse.params: array expected");
                        message.params = [];
                        for (var i = 0; i < object.params.length; ++i) {
                            if (typeof object.params[i] !== "object")
                                throw TypeError(".priority.netitems.ngtw.ExecuteCompiledResponse.params: object expected");
                            message.params[i] = $root.priority.netitems.ngtw.ExecuteCompiledParam.fromObject(object.params[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an ExecuteCompiledResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @static
                 * @param {priority.netitems.ngtw.ExecuteCompiledResponse} message ExecuteCompiledResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ExecuteCompiledResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.params = [];
                    if (options.defaults) {
                        object.result = false;
                        object.message = "";
                    }
                    if (message.result != null && message.hasOwnProperty("result"))
                        object.result = message.result;
                    if (message.message != null && message.hasOwnProperty("message"))
                        object.message = message.message;
                    if (message.params && message.params.length) {
                        object.params = [];
                        for (var j = 0; j < message.params.length; ++j)
                            object.params[j] = $root.priority.netitems.ngtw.ExecuteCompiledParam.toObject(message.params[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ExecuteCompiledResponse to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.ExecuteCompiledResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ExecuteCompiledResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ExecuteCompiledResponse;
            })();

            ngtw.GatewayRsaKey = (function() {

                /**
                 * Properties of a GatewayRsaKey.
                 * @memberof priority.netitems.ngtw
                 * @interface IGatewayRsaKey
                 * @property {string|null} [publicKeyID] GatewayRsaKey publicKeyID
                 * @property {string|null} [privateKey] GatewayRsaKey privateKey
                 */

                /**
                 * Constructs a new GatewayRsaKey.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a GatewayRsaKey.
                 * @implements IGatewayRsaKey
                 * @constructor
                 * @param {priority.netitems.ngtw.IGatewayRsaKey=} [properties] Properties to set
                 */
                function GatewayRsaKey(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GatewayRsaKey publicKeyID.
                 * @member {string} publicKeyID
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @instance
                 */
                GatewayRsaKey.prototype.publicKeyID = "";

                /**
                 * GatewayRsaKey privateKey.
                 * @member {string} privateKey
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @instance
                 */
                GatewayRsaKey.prototype.privateKey = "";

                /**
                 * Creates a new GatewayRsaKey instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @static
                 * @param {priority.netitems.ngtw.IGatewayRsaKey=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.GatewayRsaKey} GatewayRsaKey instance
                 */
                GatewayRsaKey.create = function create(properties) {
                    return new GatewayRsaKey(properties);
                };

                /**
                 * Encodes the specified GatewayRsaKey message. Does not implicitly {@link priority.netitems.ngtw.GatewayRsaKey.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @static
                 * @param {priority.netitems.ngtw.IGatewayRsaKey} message GatewayRsaKey message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GatewayRsaKey.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.publicKeyID != null && Object.hasOwnProperty.call(message, "publicKeyID"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.publicKeyID);
                    if (message.privateKey != null && Object.hasOwnProperty.call(message, "privateKey"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.privateKey);
                    return writer;
                };

                /**
                 * Encodes the specified GatewayRsaKey message, length delimited. Does not implicitly {@link priority.netitems.ngtw.GatewayRsaKey.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @static
                 * @param {priority.netitems.ngtw.IGatewayRsaKey} message GatewayRsaKey message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GatewayRsaKey.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GatewayRsaKey message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.GatewayRsaKey} GatewayRsaKey
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GatewayRsaKey.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.GatewayRsaKey();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.publicKeyID = reader.string();
                            break;
                        case 2:
                            message.privateKey = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GatewayRsaKey message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.GatewayRsaKey} GatewayRsaKey
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GatewayRsaKey.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GatewayRsaKey message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GatewayRsaKey.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.publicKeyID != null && message.hasOwnProperty("publicKeyID"))
                        if (!$util.isString(message.publicKeyID))
                            return "publicKeyID: string expected";
                    if (message.privateKey != null && message.hasOwnProperty("privateKey"))
                        if (!$util.isString(message.privateKey))
                            return "privateKey: string expected";
                    return null;
                };

                /**
                 * Creates a GatewayRsaKey message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.GatewayRsaKey} GatewayRsaKey
                 */
                GatewayRsaKey.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.GatewayRsaKey)
                        return object;
                    var message = new $root.priority.netitems.ngtw.GatewayRsaKey();
                    if (object.publicKeyID != null)
                        message.publicKeyID = String(object.publicKeyID);
                    if (object.privateKey != null)
                        message.privateKey = String(object.privateKey);
                    return message;
                };

                /**
                 * Creates a plain object from a GatewayRsaKey message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @static
                 * @param {priority.netitems.ngtw.GatewayRsaKey} message GatewayRsaKey
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GatewayRsaKey.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.publicKeyID = "";
                        object.privateKey = "";
                    }
                    if (message.publicKeyID != null && message.hasOwnProperty("publicKeyID"))
                        object.publicKeyID = message.publicKeyID;
                    if (message.privateKey != null && message.hasOwnProperty("privateKey"))
                        object.privateKey = message.privateKey;
                    return object;
                };

                /**
                 * Converts this GatewayRsaKey to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.GatewayRsaKey
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GatewayRsaKey.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GatewayRsaKey;
            })();

            ngtw.AttachmentRequest = (function() {

                /**
                 * Properties of an AttachmentRequest.
                 * @memberof priority.netitems.ngtw
                 * @interface IAttachmentRequest
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AttachmentRequest Properties
                 * @property {string|null} [Name] AttachmentRequest Name
                 * @property {string|null} [Form] AttachmentRequest Form
                 */

                /**
                 * Constructs a new AttachmentRequest.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an AttachmentRequest.
                 * @implements IAttachmentRequest
                 * @constructor
                 * @param {priority.netitems.ngtw.IAttachmentRequest=} [properties] Properties to set
                 */
                function AttachmentRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AttachmentRequest Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @instance
                 */
                AttachmentRequest.prototype.Properties = null;

                /**
                 * AttachmentRequest Name.
                 * @member {string} Name
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @instance
                 */
                AttachmentRequest.prototype.Name = "";

                /**
                 * AttachmentRequest Form.
                 * @member {string} Form
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @instance
                 */
                AttachmentRequest.prototype.Form = "";

                /**
                 * Creates a new AttachmentRequest instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @static
                 * @param {priority.netitems.ngtw.IAttachmentRequest=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.AttachmentRequest} AttachmentRequest instance
                 */
                AttachmentRequest.create = function create(properties) {
                    return new AttachmentRequest(properties);
                };

                /**
                 * Encodes the specified AttachmentRequest message. Does not implicitly {@link priority.netitems.ngtw.AttachmentRequest.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @static
                 * @param {priority.netitems.ngtw.IAttachmentRequest} message AttachmentRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AttachmentRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
                    if (message.Form != null && Object.hasOwnProperty.call(message, "Form"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Form);
                    return writer;
                };

                /**
                 * Encodes the specified AttachmentRequest message, length delimited. Does not implicitly {@link priority.netitems.ngtw.AttachmentRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @static
                 * @param {priority.netitems.ngtw.IAttachmentRequest} message AttachmentRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AttachmentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AttachmentRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.AttachmentRequest} AttachmentRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AttachmentRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.AttachmentRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Name = reader.string();
                            break;
                        case 3:
                            message.Form = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AttachmentRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.AttachmentRequest} AttachmentRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AttachmentRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AttachmentRequest message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AttachmentRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Form != null && message.hasOwnProperty("Form"))
                        if (!$util.isString(message.Form))
                            return "Form: string expected";
                    return null;
                };

                /**
                 * Creates an AttachmentRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.AttachmentRequest} AttachmentRequest
                 */
                AttachmentRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.AttachmentRequest)
                        return object;
                    var message = new $root.priority.netitems.ngtw.AttachmentRequest();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngtw.AttachmentRequest.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Form != null)
                        message.Form = String(object.Form);
                    return message;
                };

                /**
                 * Creates a plain object from an AttachmentRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @static
                 * @param {priority.netitems.ngtw.AttachmentRequest} message AttachmentRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AttachmentRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Name = "";
                        object.Form = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Form != null && message.hasOwnProperty("Form"))
                        object.Form = message.Form;
                    return object;
                };

                /**
                 * Converts this AttachmentRequest to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.AttachmentRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AttachmentRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AttachmentRequest;
            })();

            ngtw.AttachmentResponse = (function() {

                /**
                 * Properties of an AttachmentResponse.
                 * @memberof priority.netitems.ngtw
                 * @interface IAttachmentResponse
                 * @property {string|null} [Name] AttachmentResponse Name
                 * @property {Uint8Array|null} [Data] AttachmentResponse Data
                 */

                /**
                 * Constructs a new AttachmentResponse.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an AttachmentResponse.
                 * @implements IAttachmentResponse
                 * @constructor
                 * @param {priority.netitems.ngtw.IAttachmentResponse=} [properties] Properties to set
                 */
                function AttachmentResponse(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AttachmentResponse Name.
                 * @member {string} Name
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @instance
                 */
                AttachmentResponse.prototype.Name = "";

                /**
                 * AttachmentResponse Data.
                 * @member {Uint8Array} Data
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @instance
                 */
                AttachmentResponse.prototype.Data = $util.newBuffer([]);

                /**
                 * Creates a new AttachmentResponse instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @static
                 * @param {priority.netitems.ngtw.IAttachmentResponse=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.AttachmentResponse} AttachmentResponse instance
                 */
                AttachmentResponse.create = function create(properties) {
                    return new AttachmentResponse(properties);
                };

                /**
                 * Encodes the specified AttachmentResponse message. Does not implicitly {@link priority.netitems.ngtw.AttachmentResponse.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @static
                 * @param {priority.netitems.ngtw.IAttachmentResponse} message AttachmentResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AttachmentResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Name);
                    if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.Data);
                    return writer;
                };

                /**
                 * Encodes the specified AttachmentResponse message, length delimited. Does not implicitly {@link priority.netitems.ngtw.AttachmentResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @static
                 * @param {priority.netitems.ngtw.IAttachmentResponse} message AttachmentResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AttachmentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AttachmentResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.AttachmentResponse} AttachmentResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AttachmentResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.AttachmentResponse();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Name = reader.string();
                            break;
                        case 2:
                            message.Data = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AttachmentResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.AttachmentResponse} AttachmentResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AttachmentResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AttachmentResponse message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AttachmentResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Data != null && message.hasOwnProperty("Data"))
                        if (!(message.Data && typeof message.Data.length === "number" || $util.isString(message.Data)))
                            return "Data: buffer expected";
                    return null;
                };

                /**
                 * Creates an AttachmentResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.AttachmentResponse} AttachmentResponse
                 */
                AttachmentResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.AttachmentResponse)
                        return object;
                    var message = new $root.priority.netitems.ngtw.AttachmentResponse();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Data != null)
                        if (typeof object.Data === "string")
                            $util.base64.decode(object.Data, message.Data = $util.newBuffer($util.base64.length(object.Data)), 0);
                        else if (object.Data.length)
                            message.Data = object.Data;
                    return message;
                };

                /**
                 * Creates a plain object from an AttachmentResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @static
                 * @param {priority.netitems.ngtw.AttachmentResponse} message AttachmentResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AttachmentResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Name = "";
                        if (options.bytes === String)
                            object.Data = "";
                        else {
                            object.Data = [];
                            if (options.bytes !== Array)
                                object.Data = $util.newBuffer(object.Data);
                        }
                    }
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Data != null && message.hasOwnProperty("Data"))
                        object.Data = options.bytes === String ? $util.base64.encode(message.Data, 0, message.Data.length) : options.bytes === Array ? Array.prototype.slice.call(message.Data) : message.Data;
                    return object;
                };

                /**
                 * Converts this AttachmentResponse to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.AttachmentResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AttachmentResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AttachmentResponse;
            })();

            ngtw.AsapiRequest = (function() {

                /**
                 * Properties of an AsapiRequest.
                 * @memberof priority.netitems.ngtw
                 * @interface IAsapiRequest
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] AsapiRequest Properties
                 * @property {string|null} [AsapiID] AsapiRequest AsapiID
                 * @property {string|null} [AsapiKey] AsapiRequest AsapiKey
                 */

                /**
                 * Constructs a new AsapiRequest.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an AsapiRequest.
                 * @implements IAsapiRequest
                 * @constructor
                 * @param {priority.netitems.ngtw.IAsapiRequest=} [properties] Properties to set
                 */
                function AsapiRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AsapiRequest Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @instance
                 */
                AsapiRequest.prototype.Properties = null;

                /**
                 * AsapiRequest AsapiID.
                 * @member {string} AsapiID
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @instance
                 */
                AsapiRequest.prototype.AsapiID = "";

                /**
                 * AsapiRequest AsapiKey.
                 * @member {string} AsapiKey
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @instance
                 */
                AsapiRequest.prototype.AsapiKey = "";

                /**
                 * Creates a new AsapiRequest instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @static
                 * @param {priority.netitems.ngtw.IAsapiRequest=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.AsapiRequest} AsapiRequest instance
                 */
                AsapiRequest.create = function create(properties) {
                    return new AsapiRequest(properties);
                };

                /**
                 * Encodes the specified AsapiRequest message. Does not implicitly {@link priority.netitems.ngtw.AsapiRequest.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @static
                 * @param {priority.netitems.ngtw.IAsapiRequest} message AsapiRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AsapiRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.AsapiID != null && Object.hasOwnProperty.call(message, "AsapiID"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.AsapiID);
                    if (message.AsapiKey != null && Object.hasOwnProperty.call(message, "AsapiKey"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.AsapiKey);
                    return writer;
                };

                /**
                 * Encodes the specified AsapiRequest message, length delimited. Does not implicitly {@link priority.netitems.ngtw.AsapiRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @static
                 * @param {priority.netitems.ngtw.IAsapiRequest} message AsapiRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AsapiRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AsapiRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.AsapiRequest} AsapiRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AsapiRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.AsapiRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.AsapiID = reader.string();
                            break;
                        case 3:
                            message.AsapiKey = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AsapiRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.AsapiRequest} AsapiRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AsapiRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AsapiRequest message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AsapiRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.AsapiID != null && message.hasOwnProperty("AsapiID"))
                        if (!$util.isString(message.AsapiID))
                            return "AsapiID: string expected";
                    if (message.AsapiKey != null && message.hasOwnProperty("AsapiKey"))
                        if (!$util.isString(message.AsapiKey))
                            return "AsapiKey: string expected";
                    return null;
                };

                /**
                 * Creates an AsapiRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.AsapiRequest} AsapiRequest
                 */
                AsapiRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.AsapiRequest)
                        return object;
                    var message = new $root.priority.netitems.ngtw.AsapiRequest();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngtw.AsapiRequest.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.AsapiID != null)
                        message.AsapiID = String(object.AsapiID);
                    if (object.AsapiKey != null)
                        message.AsapiKey = String(object.AsapiKey);
                    return message;
                };

                /**
                 * Creates a plain object from an AsapiRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @static
                 * @param {priority.netitems.ngtw.AsapiRequest} message AsapiRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AsapiRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.AsapiID = "";
                        object.AsapiKey = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.AsapiID != null && message.hasOwnProperty("AsapiID"))
                        object.AsapiID = message.AsapiID;
                    if (message.AsapiKey != null && message.hasOwnProperty("AsapiKey"))
                        object.AsapiKey = message.AsapiKey;
                    return object;
                };

                /**
                 * Converts this AsapiRequest to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.AsapiRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AsapiRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AsapiRequest;
            })();

            ngtw.AsapiResponse = (function() {

                /**
                 * Properties of an AsapiResponse.
                 * @memberof priority.netitems.ngtw
                 * @interface IAsapiResponse
                 * @property {Array.<string>|null} [Users] AsapiResponse Users
                 * @property {boolean|null} [Valid] AsapiResponse Valid
                 */

                /**
                 * Constructs a new AsapiResponse.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents an AsapiResponse.
                 * @implements IAsapiResponse
                 * @constructor
                 * @param {priority.netitems.ngtw.IAsapiResponse=} [properties] Properties to set
                 */
                function AsapiResponse(properties) {
                    this.Users = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * AsapiResponse Users.
                 * @member {Array.<string>} Users
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @instance
                 */
                AsapiResponse.prototype.Users = $util.emptyArray;

                /**
                 * AsapiResponse Valid.
                 * @member {boolean} Valid
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @instance
                 */
                AsapiResponse.prototype.Valid = false;

                /**
                 * Creates a new AsapiResponse instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @static
                 * @param {priority.netitems.ngtw.IAsapiResponse=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.AsapiResponse} AsapiResponse instance
                 */
                AsapiResponse.create = function create(properties) {
                    return new AsapiResponse(properties);
                };

                /**
                 * Encodes the specified AsapiResponse message. Does not implicitly {@link priority.netitems.ngtw.AsapiResponse.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @static
                 * @param {priority.netitems.ngtw.IAsapiResponse} message AsapiResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AsapiResponse.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Users != null && message.Users.length)
                        for (var i = 0; i < message.Users.length; ++i)
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Users[i]);
                    if (message.Valid != null && Object.hasOwnProperty.call(message, "Valid"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Valid);
                    return writer;
                };

                /**
                 * Encodes the specified AsapiResponse message, length delimited. Does not implicitly {@link priority.netitems.ngtw.AsapiResponse.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @static
                 * @param {priority.netitems.ngtw.IAsapiResponse} message AsapiResponse message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                AsapiResponse.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an AsapiResponse message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.AsapiResponse} AsapiResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AsapiResponse.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.AsapiResponse();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Users && message.Users.length))
                                message.Users = [];
                            message.Users.push(reader.string());
                            break;
                        case 2:
                            message.Valid = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an AsapiResponse message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.AsapiResponse} AsapiResponse
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                AsapiResponse.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an AsapiResponse message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                AsapiResponse.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Users != null && message.hasOwnProperty("Users")) {
                        if (!Array.isArray(message.Users))
                            return "Users: array expected";
                        for (var i = 0; i < message.Users.length; ++i)
                            if (!$util.isString(message.Users[i]))
                                return "Users: string[] expected";
                    }
                    if (message.Valid != null && message.hasOwnProperty("Valid"))
                        if (typeof message.Valid !== "boolean")
                            return "Valid: boolean expected";
                    return null;
                };

                /**
                 * Creates an AsapiResponse message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.AsapiResponse} AsapiResponse
                 */
                AsapiResponse.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.AsapiResponse)
                        return object;
                    var message = new $root.priority.netitems.ngtw.AsapiResponse();
                    if (object.Users) {
                        if (!Array.isArray(object.Users))
                            throw TypeError(".priority.netitems.ngtw.AsapiResponse.Users: array expected");
                        message.Users = [];
                        for (var i = 0; i < object.Users.length; ++i)
                            message.Users[i] = String(object.Users[i]);
                    }
                    if (object.Valid != null)
                        message.Valid = Boolean(object.Valid);
                    return message;
                };

                /**
                 * Creates a plain object from an AsapiResponse message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @static
                 * @param {priority.netitems.ngtw.AsapiResponse} message AsapiResponse
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                AsapiResponse.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Users = [];
                    if (options.defaults)
                        object.Valid = false;
                    if (message.Users && message.Users.length) {
                        object.Users = [];
                        for (var j = 0; j < message.Users.length; ++j)
                            object.Users[j] = message.Users[j];
                    }
                    if (message.Valid != null && message.hasOwnProperty("Valid"))
                        object.Valid = message.Valid;
                    return object;
                };

                /**
                 * Converts this AsapiResponse to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.AsapiResponse
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                AsapiResponse.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AsapiResponse;
            })();

            ngtw.DataStoreSetRq = (function() {

                /**
                 * Properties of a DataStoreSetRq.
                 * @memberof priority.netitems.ngtw
                 * @interface IDataStoreSetRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] DataStoreSetRq Properties
                 * @property {Object.<string,common.IConstant>|null} [StoreMap] DataStoreSetRq StoreMap
                 * @property {boolean|null} [CurrentScopeUser] DataStoreSetRq CurrentScopeUser
                 * @property {boolean|null} [CurrentScopeCompany] DataStoreSetRq CurrentScopeCompany
                 */

                /**
                 * Constructs a new DataStoreSetRq.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a DataStoreSetRq.
                 * @implements IDataStoreSetRq
                 * @constructor
                 * @param {priority.netitems.ngtw.IDataStoreSetRq=} [properties] Properties to set
                 */
                function DataStoreSetRq(properties) {
                    this.StoreMap = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataStoreSetRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @instance
                 */
                DataStoreSetRq.prototype.Properties = null;

                /**
                 * DataStoreSetRq StoreMap.
                 * @member {Object.<string,common.IConstant>} StoreMap
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @instance
                 */
                DataStoreSetRq.prototype.StoreMap = $util.emptyObject;

                /**
                 * DataStoreSetRq CurrentScopeUser.
                 * @member {boolean} CurrentScopeUser
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @instance
                 */
                DataStoreSetRq.prototype.CurrentScopeUser = false;

                /**
                 * DataStoreSetRq CurrentScopeCompany.
                 * @member {boolean} CurrentScopeCompany
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @instance
                 */
                DataStoreSetRq.prototype.CurrentScopeCompany = false;

                /**
                 * Creates a new DataStoreSetRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreSetRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.DataStoreSetRq} DataStoreSetRq instance
                 */
                DataStoreSetRq.create = function create(properties) {
                    return new DataStoreSetRq(properties);
                };

                /**
                 * Encodes the specified DataStoreSetRq message. Does not implicitly {@link priority.netitems.ngtw.DataStoreSetRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreSetRq} message DataStoreSetRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataStoreSetRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.StoreMap != null && Object.hasOwnProperty.call(message, "StoreMap"))
                        for (var keys = Object.keys(message.StoreMap), i = 0; i < keys.length; ++i) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                            $root.common.Constant.encode(message.StoreMap[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                        }
                    if (message.CurrentScopeUser != null && Object.hasOwnProperty.call(message, "CurrentScopeUser"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.CurrentScopeUser);
                    if (message.CurrentScopeCompany != null && Object.hasOwnProperty.call(message, "CurrentScopeCompany"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.CurrentScopeCompany);
                    return writer;
                };

                /**
                 * Encodes the specified DataStoreSetRq message, length delimited. Does not implicitly {@link priority.netitems.ngtw.DataStoreSetRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreSetRq} message DataStoreSetRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataStoreSetRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataStoreSetRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.DataStoreSetRq} DataStoreSetRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataStoreSetRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.DataStoreSetRq(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (message.StoreMap === $util.emptyObject)
                                message.StoreMap = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.common.Constant.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.StoreMap[key] = value;
                            break;
                        case 3:
                            message.CurrentScopeUser = reader.bool();
                            break;
                        case 4:
                            message.CurrentScopeCompany = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataStoreSetRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.DataStoreSetRq} DataStoreSetRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataStoreSetRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataStoreSetRq message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataStoreSetRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.StoreMap != null && message.hasOwnProperty("StoreMap")) {
                        if (!$util.isObject(message.StoreMap))
                            return "StoreMap: object expected";
                        var key = Object.keys(message.StoreMap);
                        for (var i = 0; i < key.length; ++i) {
                            var error = $root.common.Constant.verify(message.StoreMap[key[i]]);
                            if (error)
                                return "StoreMap." + error;
                        }
                    }
                    if (message.CurrentScopeUser != null && message.hasOwnProperty("CurrentScopeUser"))
                        if (typeof message.CurrentScopeUser !== "boolean")
                            return "CurrentScopeUser: boolean expected";
                    if (message.CurrentScopeCompany != null && message.hasOwnProperty("CurrentScopeCompany"))
                        if (typeof message.CurrentScopeCompany !== "boolean")
                            return "CurrentScopeCompany: boolean expected";
                    return null;
                };

                /**
                 * Creates a DataStoreSetRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.DataStoreSetRq} DataStoreSetRq
                 */
                DataStoreSetRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.DataStoreSetRq)
                        return object;
                    var message = new $root.priority.netitems.ngtw.DataStoreSetRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngtw.DataStoreSetRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.StoreMap) {
                        if (typeof object.StoreMap !== "object")
                            throw TypeError(".priority.netitems.ngtw.DataStoreSetRq.StoreMap: object expected");
                        message.StoreMap = {};
                        for (var keys = Object.keys(object.StoreMap), i = 0; i < keys.length; ++i) {
                            if (typeof object.StoreMap[keys[i]] !== "object")
                                throw TypeError(".priority.netitems.ngtw.DataStoreSetRq.StoreMap: object expected");
                            message.StoreMap[keys[i]] = $root.common.Constant.fromObject(object.StoreMap[keys[i]]);
                        }
                    }
                    if (object.CurrentScopeUser != null)
                        message.CurrentScopeUser = Boolean(object.CurrentScopeUser);
                    if (object.CurrentScopeCompany != null)
                        message.CurrentScopeCompany = Boolean(object.CurrentScopeCompany);
                    return message;
                };

                /**
                 * Creates a plain object from a DataStoreSetRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @static
                 * @param {priority.netitems.ngtw.DataStoreSetRq} message DataStoreSetRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataStoreSetRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.objects || options.defaults)
                        object.StoreMap = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.CurrentScopeUser = false;
                        object.CurrentScopeCompany = false;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    var keys2;
                    if (message.StoreMap && (keys2 = Object.keys(message.StoreMap)).length) {
                        object.StoreMap = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.StoreMap[keys2[j]] = $root.common.Constant.toObject(message.StoreMap[keys2[j]], options);
                    }
                    if (message.CurrentScopeUser != null && message.hasOwnProperty("CurrentScopeUser"))
                        object.CurrentScopeUser = message.CurrentScopeUser;
                    if (message.CurrentScopeCompany != null && message.hasOwnProperty("CurrentScopeCompany"))
                        object.CurrentScopeCompany = message.CurrentScopeCompany;
                    return object;
                };

                /**
                 * Converts this DataStoreSetRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.DataStoreSetRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataStoreSetRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataStoreSetRq;
            })();

            ngtw.DataStoreSetRs = (function() {

                /**
                 * Properties of a DataStoreSetRs.
                 * @memberof priority.netitems.ngtw
                 * @interface IDataStoreSetRs
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] DataStoreSetRs Messages
                 */

                /**
                 * Constructs a new DataStoreSetRs.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a DataStoreSetRs.
                 * @implements IDataStoreSetRs
                 * @constructor
                 * @param {priority.netitems.ngtw.IDataStoreSetRs=} [properties] Properties to set
                 */
                function DataStoreSetRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataStoreSetRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @instance
                 */
                DataStoreSetRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new DataStoreSetRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreSetRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.DataStoreSetRs} DataStoreSetRs instance
                 */
                DataStoreSetRs.create = function create(properties) {
                    return new DataStoreSetRs(properties);
                };

                /**
                 * Encodes the specified DataStoreSetRs message. Does not implicitly {@link priority.netitems.ngtw.DataStoreSetRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreSetRs} message DataStoreSetRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataStoreSetRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DataStoreSetRs message, length delimited. Does not implicitly {@link priority.netitems.ngtw.DataStoreSetRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreSetRs} message DataStoreSetRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataStoreSetRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataStoreSetRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.DataStoreSetRs} DataStoreSetRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataStoreSetRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.DataStoreSetRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataStoreSetRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.DataStoreSetRs} DataStoreSetRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataStoreSetRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataStoreSetRs message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataStoreSetRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DataStoreSetRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.DataStoreSetRs} DataStoreSetRs
                 */
                DataStoreSetRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.DataStoreSetRs)
                        return object;
                    var message = new $root.priority.netitems.ngtw.DataStoreSetRs();
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngtw.DataStoreSetRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngtw.DataStoreSetRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DataStoreSetRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @static
                 * @param {priority.netitems.ngtw.DataStoreSetRs} message DataStoreSetRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataStoreSetRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this DataStoreSetRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.DataStoreSetRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataStoreSetRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataStoreSetRs;
            })();

            ngtw.DataStoreGetRq = (function() {

                /**
                 * Properties of a DataStoreGetRq.
                 * @memberof priority.netitems.ngtw
                 * @interface IDataStoreGetRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] DataStoreGetRq Properties
                 * @property {Array.<string>|null} [Keys] DataStoreGetRq Keys
                 * @property {boolean|null} [CurrentScopeUser] DataStoreGetRq CurrentScopeUser
                 * @property {boolean|null} [CurrentScopeCompany] DataStoreGetRq CurrentScopeCompany
                 */

                /**
                 * Constructs a new DataStoreGetRq.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a DataStoreGetRq.
                 * @implements IDataStoreGetRq
                 * @constructor
                 * @param {priority.netitems.ngtw.IDataStoreGetRq=} [properties] Properties to set
                 */
                function DataStoreGetRq(properties) {
                    this.Keys = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataStoreGetRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @instance
                 */
                DataStoreGetRq.prototype.Properties = null;

                /**
                 * DataStoreGetRq Keys.
                 * @member {Array.<string>} Keys
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @instance
                 */
                DataStoreGetRq.prototype.Keys = $util.emptyArray;

                /**
                 * DataStoreGetRq CurrentScopeUser.
                 * @member {boolean} CurrentScopeUser
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @instance
                 */
                DataStoreGetRq.prototype.CurrentScopeUser = false;

                /**
                 * DataStoreGetRq CurrentScopeCompany.
                 * @member {boolean} CurrentScopeCompany
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @instance
                 */
                DataStoreGetRq.prototype.CurrentScopeCompany = false;

                /**
                 * Creates a new DataStoreGetRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreGetRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.DataStoreGetRq} DataStoreGetRq instance
                 */
                DataStoreGetRq.create = function create(properties) {
                    return new DataStoreGetRq(properties);
                };

                /**
                 * Encodes the specified DataStoreGetRq message. Does not implicitly {@link priority.netitems.ngtw.DataStoreGetRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreGetRq} message DataStoreGetRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataStoreGetRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Keys != null && message.Keys.length)
                        for (var i = 0; i < message.Keys.length; ++i)
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Keys[i]);
                    if (message.CurrentScopeUser != null && Object.hasOwnProperty.call(message, "CurrentScopeUser"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.CurrentScopeUser);
                    if (message.CurrentScopeCompany != null && Object.hasOwnProperty.call(message, "CurrentScopeCompany"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.CurrentScopeCompany);
                    return writer;
                };

                /**
                 * Encodes the specified DataStoreGetRq message, length delimited. Does not implicitly {@link priority.netitems.ngtw.DataStoreGetRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreGetRq} message DataStoreGetRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataStoreGetRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataStoreGetRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.DataStoreGetRq} DataStoreGetRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataStoreGetRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.DataStoreGetRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Keys && message.Keys.length))
                                message.Keys = [];
                            message.Keys.push(reader.string());
                            break;
                        case 3:
                            message.CurrentScopeUser = reader.bool();
                            break;
                        case 4:
                            message.CurrentScopeCompany = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataStoreGetRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.DataStoreGetRq} DataStoreGetRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataStoreGetRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataStoreGetRq message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataStoreGetRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Keys != null && message.hasOwnProperty("Keys")) {
                        if (!Array.isArray(message.Keys))
                            return "Keys: array expected";
                        for (var i = 0; i < message.Keys.length; ++i)
                            if (!$util.isString(message.Keys[i]))
                                return "Keys: string[] expected";
                    }
                    if (message.CurrentScopeUser != null && message.hasOwnProperty("CurrentScopeUser"))
                        if (typeof message.CurrentScopeUser !== "boolean")
                            return "CurrentScopeUser: boolean expected";
                    if (message.CurrentScopeCompany != null && message.hasOwnProperty("CurrentScopeCompany"))
                        if (typeof message.CurrentScopeCompany !== "boolean")
                            return "CurrentScopeCompany: boolean expected";
                    return null;
                };

                /**
                 * Creates a DataStoreGetRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.DataStoreGetRq} DataStoreGetRq
                 */
                DataStoreGetRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.DataStoreGetRq)
                        return object;
                    var message = new $root.priority.netitems.ngtw.DataStoreGetRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngtw.DataStoreGetRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Keys) {
                        if (!Array.isArray(object.Keys))
                            throw TypeError(".priority.netitems.ngtw.DataStoreGetRq.Keys: array expected");
                        message.Keys = [];
                        for (var i = 0; i < object.Keys.length; ++i)
                            message.Keys[i] = String(object.Keys[i]);
                    }
                    if (object.CurrentScopeUser != null)
                        message.CurrentScopeUser = Boolean(object.CurrentScopeUser);
                    if (object.CurrentScopeCompany != null)
                        message.CurrentScopeCompany = Boolean(object.CurrentScopeCompany);
                    return message;
                };

                /**
                 * Creates a plain object from a DataStoreGetRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @static
                 * @param {priority.netitems.ngtw.DataStoreGetRq} message DataStoreGetRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataStoreGetRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Keys = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.CurrentScopeUser = false;
                        object.CurrentScopeCompany = false;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Keys && message.Keys.length) {
                        object.Keys = [];
                        for (var j = 0; j < message.Keys.length; ++j)
                            object.Keys[j] = message.Keys[j];
                    }
                    if (message.CurrentScopeUser != null && message.hasOwnProperty("CurrentScopeUser"))
                        object.CurrentScopeUser = message.CurrentScopeUser;
                    if (message.CurrentScopeCompany != null && message.hasOwnProperty("CurrentScopeCompany"))
                        object.CurrentScopeCompany = message.CurrentScopeCompany;
                    return object;
                };

                /**
                 * Converts this DataStoreGetRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.DataStoreGetRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataStoreGetRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataStoreGetRq;
            })();

            ngtw.DataStoreGetRs = (function() {

                /**
                 * Properties of a DataStoreGetRs.
                 * @memberof priority.netitems.ngtw
                 * @interface IDataStoreGetRs
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] DataStoreGetRs Messages
                 * @property {Object.<string,common.IConstant>|null} [StoreMap] DataStoreGetRs StoreMap
                 */

                /**
                 * Constructs a new DataStoreGetRs.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a DataStoreGetRs.
                 * @implements IDataStoreGetRs
                 * @constructor
                 * @param {priority.netitems.ngtw.IDataStoreGetRs=} [properties] Properties to set
                 */
                function DataStoreGetRs(properties) {
                    this.Messages = [];
                    this.StoreMap = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataStoreGetRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @instance
                 */
                DataStoreGetRs.prototype.Messages = $util.emptyArray;

                /**
                 * DataStoreGetRs StoreMap.
                 * @member {Object.<string,common.IConstant>} StoreMap
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @instance
                 */
                DataStoreGetRs.prototype.StoreMap = $util.emptyObject;

                /**
                 * Creates a new DataStoreGetRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreGetRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.DataStoreGetRs} DataStoreGetRs instance
                 */
                DataStoreGetRs.create = function create(properties) {
                    return new DataStoreGetRs(properties);
                };

                /**
                 * Encodes the specified DataStoreGetRs message. Does not implicitly {@link priority.netitems.ngtw.DataStoreGetRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreGetRs} message DataStoreGetRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataStoreGetRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.StoreMap != null && Object.hasOwnProperty.call(message, "StoreMap"))
                        for (var keys = Object.keys(message.StoreMap), i = 0; i < keys.length; ++i) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                            $root.common.Constant.encode(message.StoreMap[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                        }
                    return writer;
                };

                /**
                 * Encodes the specified DataStoreGetRs message, length delimited. Does not implicitly {@link priority.netitems.ngtw.DataStoreGetRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @static
                 * @param {priority.netitems.ngtw.IDataStoreGetRs} message DataStoreGetRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataStoreGetRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataStoreGetRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.DataStoreGetRs} DataStoreGetRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataStoreGetRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.DataStoreGetRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (message.StoreMap === $util.emptyObject)
                                message.StoreMap = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = null;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = $root.common.Constant.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.StoreMap[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataStoreGetRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.DataStoreGetRs} DataStoreGetRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataStoreGetRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataStoreGetRs message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataStoreGetRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.StoreMap != null && message.hasOwnProperty("StoreMap")) {
                        if (!$util.isObject(message.StoreMap))
                            return "StoreMap: object expected";
                        var key = Object.keys(message.StoreMap);
                        for (var i = 0; i < key.length; ++i) {
                            var error = $root.common.Constant.verify(message.StoreMap[key[i]]);
                            if (error)
                                return "StoreMap." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DataStoreGetRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.DataStoreGetRs} DataStoreGetRs
                 */
                DataStoreGetRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.DataStoreGetRs)
                        return object;
                    var message = new $root.priority.netitems.ngtw.DataStoreGetRs();
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngtw.DataStoreGetRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngtw.DataStoreGetRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.StoreMap) {
                        if (typeof object.StoreMap !== "object")
                            throw TypeError(".priority.netitems.ngtw.DataStoreGetRs.StoreMap: object expected");
                        message.StoreMap = {};
                        for (var keys = Object.keys(object.StoreMap), i = 0; i < keys.length; ++i) {
                            if (typeof object.StoreMap[keys[i]] !== "object")
                                throw TypeError(".priority.netitems.ngtw.DataStoreGetRs.StoreMap: object expected");
                            message.StoreMap[keys[i]] = $root.common.Constant.fromObject(object.StoreMap[keys[i]]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DataStoreGetRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @static
                 * @param {priority.netitems.ngtw.DataStoreGetRs} message DataStoreGetRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataStoreGetRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.StoreMap = {};
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    var keys2;
                    if (message.StoreMap && (keys2 = Object.keys(message.StoreMap)).length) {
                        object.StoreMap = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.StoreMap[keys2[j]] = $root.common.Constant.toObject(message.StoreMap[keys2[j]], options);
                    }
                    return object;
                };

                /**
                 * Converts this DataStoreGetRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.DataStoreGetRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataStoreGetRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataStoreGetRs;
            })();

            ngtw.GeneralAboutRq = (function() {

                /**
                 * Properties of a GeneralAboutRq.
                 * @memberof priority.netitems.ngtw
                 * @interface IGeneralAboutRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] GeneralAboutRq Properties
                 */

                /**
                 * Constructs a new GeneralAboutRq.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a GeneralAboutRq.
                 * @implements IGeneralAboutRq
                 * @constructor
                 * @param {priority.netitems.ngtw.IGeneralAboutRq=} [properties] Properties to set
                 */
                function GeneralAboutRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GeneralAboutRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @instance
                 */
                GeneralAboutRq.prototype.Properties = null;

                /**
                 * Creates a new GeneralAboutRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @static
                 * @param {priority.netitems.ngtw.IGeneralAboutRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.GeneralAboutRq} GeneralAboutRq instance
                 */
                GeneralAboutRq.create = function create(properties) {
                    return new GeneralAboutRq(properties);
                };

                /**
                 * Encodes the specified GeneralAboutRq message. Does not implicitly {@link priority.netitems.ngtw.GeneralAboutRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @static
                 * @param {priority.netitems.ngtw.IGeneralAboutRq} message GeneralAboutRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneralAboutRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified GeneralAboutRq message, length delimited. Does not implicitly {@link priority.netitems.ngtw.GeneralAboutRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @static
                 * @param {priority.netitems.ngtw.IGeneralAboutRq} message GeneralAboutRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneralAboutRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GeneralAboutRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.GeneralAboutRq} GeneralAboutRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneralAboutRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.GeneralAboutRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GeneralAboutRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.GeneralAboutRq} GeneralAboutRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneralAboutRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GeneralAboutRq message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GeneralAboutRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a GeneralAboutRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.GeneralAboutRq} GeneralAboutRq
                 */
                GeneralAboutRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.GeneralAboutRq)
                        return object;
                    var message = new $root.priority.netitems.ngtw.GeneralAboutRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngtw.GeneralAboutRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GeneralAboutRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @static
                 * @param {priority.netitems.ngtw.GeneralAboutRq} message GeneralAboutRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GeneralAboutRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this GeneralAboutRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.GeneralAboutRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GeneralAboutRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GeneralAboutRq;
            })();

            ngtw.GeneralAboutRs = (function() {

                /**
                 * Properties of a GeneralAboutRs.
                 * @memberof priority.netitems.ngtw
                 * @interface IGeneralAboutRs
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] GeneralAboutRs Messages
                 * @property {string|null} [PriorityVersion] GeneralAboutRs PriorityVersion
                 * @property {string|null} [BinVersion] GeneralAboutRs BinVersion
                 */

                /**
                 * Constructs a new GeneralAboutRs.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a GeneralAboutRs.
                 * @implements IGeneralAboutRs
                 * @constructor
                 * @param {priority.netitems.ngtw.IGeneralAboutRs=} [properties] Properties to set
                 */
                function GeneralAboutRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GeneralAboutRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @instance
                 */
                GeneralAboutRs.prototype.Messages = $util.emptyArray;

                /**
                 * GeneralAboutRs PriorityVersion.
                 * @member {string} PriorityVersion
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @instance
                 */
                GeneralAboutRs.prototype.PriorityVersion = "";

                /**
                 * GeneralAboutRs BinVersion.
                 * @member {string} BinVersion
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @instance
                 */
                GeneralAboutRs.prototype.BinVersion = "";

                /**
                 * Creates a new GeneralAboutRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @static
                 * @param {priority.netitems.ngtw.IGeneralAboutRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.GeneralAboutRs} GeneralAboutRs instance
                 */
                GeneralAboutRs.create = function create(properties) {
                    return new GeneralAboutRs(properties);
                };

                /**
                 * Encodes the specified GeneralAboutRs message. Does not implicitly {@link priority.netitems.ngtw.GeneralAboutRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @static
                 * @param {priority.netitems.ngtw.IGeneralAboutRs} message GeneralAboutRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneralAboutRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.PriorityVersion != null && Object.hasOwnProperty.call(message, "PriorityVersion"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.PriorityVersion);
                    if (message.BinVersion != null && Object.hasOwnProperty.call(message, "BinVersion"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.BinVersion);
                    return writer;
                };

                /**
                 * Encodes the specified GeneralAboutRs message, length delimited. Does not implicitly {@link priority.netitems.ngtw.GeneralAboutRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @static
                 * @param {priority.netitems.ngtw.IGeneralAboutRs} message GeneralAboutRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneralAboutRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GeneralAboutRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.GeneralAboutRs} GeneralAboutRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneralAboutRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.GeneralAboutRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.PriorityVersion = reader.string();
                            break;
                        case 3:
                            message.BinVersion = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GeneralAboutRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.GeneralAboutRs} GeneralAboutRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneralAboutRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GeneralAboutRs message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GeneralAboutRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.PriorityVersion != null && message.hasOwnProperty("PriorityVersion"))
                        if (!$util.isString(message.PriorityVersion))
                            return "PriorityVersion: string expected";
                    if (message.BinVersion != null && message.hasOwnProperty("BinVersion"))
                        if (!$util.isString(message.BinVersion))
                            return "BinVersion: string expected";
                    return null;
                };

                /**
                 * Creates a GeneralAboutRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.GeneralAboutRs} GeneralAboutRs
                 */
                GeneralAboutRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.GeneralAboutRs)
                        return object;
                    var message = new $root.priority.netitems.ngtw.GeneralAboutRs();
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngtw.GeneralAboutRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngtw.GeneralAboutRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.PriorityVersion != null)
                        message.PriorityVersion = String(object.PriorityVersion);
                    if (object.BinVersion != null)
                        message.BinVersion = String(object.BinVersion);
                    return message;
                };

                /**
                 * Creates a plain object from a GeneralAboutRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @static
                 * @param {priority.netitems.ngtw.GeneralAboutRs} message GeneralAboutRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GeneralAboutRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.PriorityVersion = "";
                        object.BinVersion = "";
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.PriorityVersion != null && message.hasOwnProperty("PriorityVersion"))
                        object.PriorityVersion = message.PriorityVersion;
                    if (message.BinVersion != null && message.hasOwnProperty("BinVersion"))
                        object.BinVersion = message.BinVersion;
                    return object;
                };

                /**
                 * Converts this GeneralAboutRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.GeneralAboutRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GeneralAboutRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GeneralAboutRs;
            })();

            ngtw.Grpc2Net = (function() {

                /**
                 * Properties of a Grpc2Net.
                 * @memberof priority.netitems.ngtw
                 * @interface IGrpc2Net
                 * @property {common.IEmpty|null} [rsaKey] Grpc2Net rsaKey
                 * @property {common.IEmpty|null} [tenantDetails] Grpc2Net tenantDetails
                 * @property {priority.netitems.ngtw.IEntityMessagesRequest|null} [entityMessages] Grpc2Net entityMessages
                 * @property {priority.netitems.ngtw.IExecuteCompiledRequest|null} [exec] Grpc2Net exec
                 * @property {common.IEmpty|null} [Netdefs] Grpc2Net Netdefs
                 * @property {priority.netitems.ngtw.IAttachmentRequest|null} [Attach] Grpc2Net Attach
                 * @property {priority.netitems.ngtw.IAsapiRequest|null} [Asapi] Grpc2Net Asapi
                 * @property {common.ICompaniesRq|null} [Companies] Grpc2Net Companies
                 * @property {priority.netitems.ngtw.IDataStoreSetRq|null} [DataStoreSet] Grpc2Net DataStoreSet
                 * @property {priority.netitems.ngtw.IDataStoreGetRq|null} [DataStoreGet] Grpc2Net DataStoreGet
                 * @property {priority.netitems.ngtw.IGeneralAboutRq|null} [GeneralAbout] Grpc2Net GeneralAbout
                 */

                /**
                 * Constructs a new Grpc2Net.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a Grpc2Net.
                 * @implements IGrpc2Net
                 * @constructor
                 * @param {priority.netitems.ngtw.IGrpc2Net=} [properties] Properties to set
                 */
                function Grpc2Net(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Grpc2Net rsaKey.
                 * @member {common.IEmpty|null|undefined} rsaKey
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.rsaKey = null;

                /**
                 * Grpc2Net tenantDetails.
                 * @member {common.IEmpty|null|undefined} tenantDetails
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.tenantDetails = null;

                /**
                 * Grpc2Net entityMessages.
                 * @member {priority.netitems.ngtw.IEntityMessagesRequest|null|undefined} entityMessages
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.entityMessages = null;

                /**
                 * Grpc2Net exec.
                 * @member {priority.netitems.ngtw.IExecuteCompiledRequest|null|undefined} exec
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.exec = null;

                /**
                 * Grpc2Net Netdefs.
                 * @member {common.IEmpty|null|undefined} Netdefs
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Netdefs = null;

                /**
                 * Grpc2Net Attach.
                 * @member {priority.netitems.ngtw.IAttachmentRequest|null|undefined} Attach
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Attach = null;

                /**
                 * Grpc2Net Asapi.
                 * @member {priority.netitems.ngtw.IAsapiRequest|null|undefined} Asapi
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Asapi = null;

                /**
                 * Grpc2Net Companies.
                 * @member {common.ICompaniesRq|null|undefined} Companies
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Companies = null;

                /**
                 * Grpc2Net DataStoreSet.
                 * @member {priority.netitems.ngtw.IDataStoreSetRq|null|undefined} DataStoreSet
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.DataStoreSet = null;

                /**
                 * Grpc2Net DataStoreGet.
                 * @member {priority.netitems.ngtw.IDataStoreGetRq|null|undefined} DataStoreGet
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.DataStoreGet = null;

                /**
                 * Grpc2Net GeneralAbout.
                 * @member {priority.netitems.ngtw.IGeneralAboutRq|null|undefined} GeneralAbout
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.GeneralAbout = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Grpc2Net Inner.
                 * @member {"rsaKey"|"tenantDetails"|"entityMessages"|"exec"|"Netdefs"|"Attach"|"Asapi"|"Companies"|"DataStoreSet"|"DataStoreGet"|"GeneralAbout"|undefined} Inner
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 */
                Object.defineProperty(Grpc2Net.prototype, "Inner", {
                    get: $util.oneOfGetter($oneOfFields = ["rsaKey", "tenantDetails", "entityMessages", "exec", "Netdefs", "Attach", "Asapi", "Companies", "DataStoreSet", "DataStoreGet", "GeneralAbout"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Grpc2Net instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @static
                 * @param {priority.netitems.ngtw.IGrpc2Net=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.Grpc2Net} Grpc2Net instance
                 */
                Grpc2Net.create = function create(properties) {
                    return new Grpc2Net(properties);
                };

                /**
                 * Encodes the specified Grpc2Net message. Does not implicitly {@link priority.netitems.ngtw.Grpc2Net.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @static
                 * @param {priority.netitems.ngtw.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.rsaKey != null && Object.hasOwnProperty.call(message, "rsaKey"))
                        $root.common.Empty.encode(message.rsaKey, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.tenantDetails != null && Object.hasOwnProperty.call(message, "tenantDetails"))
                        $root.common.Empty.encode(message.tenantDetails, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.entityMessages != null && Object.hasOwnProperty.call(message, "entityMessages"))
                        $root.priority.netitems.ngtw.EntityMessagesRequest.encode(message.entityMessages, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.exec != null && Object.hasOwnProperty.call(message, "exec"))
                        $root.priority.netitems.ngtw.ExecuteCompiledRequest.encode(message.exec, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.Netdefs != null && Object.hasOwnProperty.call(message, "Netdefs"))
                        $root.common.Empty.encode(message.Netdefs, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Attach != null && Object.hasOwnProperty.call(message, "Attach"))
                        $root.priority.netitems.ngtw.AttachmentRequest.encode(message.Attach, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.Asapi != null && Object.hasOwnProperty.call(message, "Asapi"))
                        $root.priority.netitems.ngtw.AsapiRequest.encode(message.Asapi, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.Companies != null && Object.hasOwnProperty.call(message, "Companies"))
                        $root.common.CompaniesRq.encode(message.Companies, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.DataStoreSet != null && Object.hasOwnProperty.call(message, "DataStoreSet"))
                        $root.priority.netitems.ngtw.DataStoreSetRq.encode(message.DataStoreSet, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.DataStoreGet != null && Object.hasOwnProperty.call(message, "DataStoreGet"))
                        $root.priority.netitems.ngtw.DataStoreGetRq.encode(message.DataStoreGet, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.GeneralAbout != null && Object.hasOwnProperty.call(message, "GeneralAbout"))
                        $root.priority.netitems.ngtw.GeneralAboutRq.encode(message.GeneralAbout, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Grpc2Net message, length delimited. Does not implicitly {@link priority.netitems.ngtw.Grpc2Net.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @static
                 * @param {priority.netitems.ngtw.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.Grpc2Net();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            message.rsaKey = $root.common.Empty.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.tenantDetails = $root.common.Empty.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.entityMessages = $root.priority.netitems.ngtw.EntityMessagesRequest.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.exec = $root.priority.netitems.ngtw.ExecuteCompiledRequest.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.Netdefs = $root.common.Empty.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.Attach = $root.priority.netitems.ngtw.AttachmentRequest.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.Asapi = $root.priority.netitems.ngtw.AsapiRequest.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.Companies = $root.common.CompaniesRq.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.DataStoreSet = $root.priority.netitems.ngtw.DataStoreSetRq.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.DataStoreGet = $root.priority.netitems.ngtw.DataStoreGetRq.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.GeneralAbout = $root.priority.netitems.ngtw.GeneralAboutRq.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Grpc2Net message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Grpc2Net.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.rsaKey != null && message.hasOwnProperty("rsaKey")) {
                        properties.Inner = 1;
                        {
                            var error = $root.common.Empty.verify(message.rsaKey);
                            if (error)
                                return "rsaKey." + error;
                        }
                    }
                    if (message.tenantDetails != null && message.hasOwnProperty("tenantDetails")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.common.Empty.verify(message.tenantDetails);
                            if (error)
                                return "tenantDetails." + error;
                        }
                    }
                    if (message.entityMessages != null && message.hasOwnProperty("entityMessages")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.EntityMessagesRequest.verify(message.entityMessages);
                            if (error)
                                return "entityMessages." + error;
                        }
                    }
                    if (message.exec != null && message.hasOwnProperty("exec")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.ExecuteCompiledRequest.verify(message.exec);
                            if (error)
                                return "exec." + error;
                        }
                    }
                    if (message.Netdefs != null && message.hasOwnProperty("Netdefs")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.common.Empty.verify(message.Netdefs);
                            if (error)
                                return "Netdefs." + error;
                        }
                    }
                    if (message.Attach != null && message.hasOwnProperty("Attach")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.AttachmentRequest.verify(message.Attach);
                            if (error)
                                return "Attach." + error;
                        }
                    }
                    if (message.Asapi != null && message.hasOwnProperty("Asapi")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.AsapiRequest.verify(message.Asapi);
                            if (error)
                                return "Asapi." + error;
                        }
                    }
                    if (message.Companies != null && message.hasOwnProperty("Companies")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.common.CompaniesRq.verify(message.Companies);
                            if (error)
                                return "Companies." + error;
                        }
                    }
                    if (message.DataStoreSet != null && message.hasOwnProperty("DataStoreSet")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.DataStoreSetRq.verify(message.DataStoreSet);
                            if (error)
                                return "DataStoreSet." + error;
                        }
                    }
                    if (message.DataStoreGet != null && message.hasOwnProperty("DataStoreGet")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.DataStoreGetRq.verify(message.DataStoreGet);
                            if (error)
                                return "DataStoreGet." + error;
                        }
                    }
                    if (message.GeneralAbout != null && message.hasOwnProperty("GeneralAbout")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.GeneralAboutRq.verify(message.GeneralAbout);
                            if (error)
                                return "GeneralAbout." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Grpc2Net message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.Grpc2Net} Grpc2Net
                 */
                Grpc2Net.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.Grpc2Net)
                        return object;
                    var message = new $root.priority.netitems.ngtw.Grpc2Net();
                    if (object.rsaKey != null) {
                        if (typeof object.rsaKey !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.rsaKey: object expected");
                        message.rsaKey = $root.common.Empty.fromObject(object.rsaKey);
                    }
                    if (object.tenantDetails != null) {
                        if (typeof object.tenantDetails !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.tenantDetails: object expected");
                        message.tenantDetails = $root.common.Empty.fromObject(object.tenantDetails);
                    }
                    if (object.entityMessages != null) {
                        if (typeof object.entityMessages !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.entityMessages: object expected");
                        message.entityMessages = $root.priority.netitems.ngtw.EntityMessagesRequest.fromObject(object.entityMessages);
                    }
                    if (object.exec != null) {
                        if (typeof object.exec !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.exec: object expected");
                        message.exec = $root.priority.netitems.ngtw.ExecuteCompiledRequest.fromObject(object.exec);
                    }
                    if (object.Netdefs != null) {
                        if (typeof object.Netdefs !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.Netdefs: object expected");
                        message.Netdefs = $root.common.Empty.fromObject(object.Netdefs);
                    }
                    if (object.Attach != null) {
                        if (typeof object.Attach !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.Attach: object expected");
                        message.Attach = $root.priority.netitems.ngtw.AttachmentRequest.fromObject(object.Attach);
                    }
                    if (object.Asapi != null) {
                        if (typeof object.Asapi !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.Asapi: object expected");
                        message.Asapi = $root.priority.netitems.ngtw.AsapiRequest.fromObject(object.Asapi);
                    }
                    if (object.Companies != null) {
                        if (typeof object.Companies !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.Companies: object expected");
                        message.Companies = $root.common.CompaniesRq.fromObject(object.Companies);
                    }
                    if (object.DataStoreSet != null) {
                        if (typeof object.DataStoreSet !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.DataStoreSet: object expected");
                        message.DataStoreSet = $root.priority.netitems.ngtw.DataStoreSetRq.fromObject(object.DataStoreSet);
                    }
                    if (object.DataStoreGet != null) {
                        if (typeof object.DataStoreGet !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.DataStoreGet: object expected");
                        message.DataStoreGet = $root.priority.netitems.ngtw.DataStoreGetRq.fromObject(object.DataStoreGet);
                    }
                    if (object.GeneralAbout != null) {
                        if (typeof object.GeneralAbout !== "object")
                            throw TypeError(".priority.netitems.ngtw.Grpc2Net.GeneralAbout: object expected");
                        message.GeneralAbout = $root.priority.netitems.ngtw.GeneralAboutRq.fromObject(object.GeneralAbout);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Grpc2Net message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @static
                 * @param {priority.netitems.ngtw.Grpc2Net} message Grpc2Net
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Grpc2Net.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.rsaKey != null && message.hasOwnProperty("rsaKey")) {
                        object.rsaKey = $root.common.Empty.toObject(message.rsaKey, options);
                        if (options.oneofs)
                            object.Inner = "rsaKey";
                    }
                    if (message.tenantDetails != null && message.hasOwnProperty("tenantDetails")) {
                        object.tenantDetails = $root.common.Empty.toObject(message.tenantDetails, options);
                        if (options.oneofs)
                            object.Inner = "tenantDetails";
                    }
                    if (message.entityMessages != null && message.hasOwnProperty("entityMessages")) {
                        object.entityMessages = $root.priority.netitems.ngtw.EntityMessagesRequest.toObject(message.entityMessages, options);
                        if (options.oneofs)
                            object.Inner = "entityMessages";
                    }
                    if (message.exec != null && message.hasOwnProperty("exec")) {
                        object.exec = $root.priority.netitems.ngtw.ExecuteCompiledRequest.toObject(message.exec, options);
                        if (options.oneofs)
                            object.Inner = "exec";
                    }
                    if (message.Netdefs != null && message.hasOwnProperty("Netdefs")) {
                        object.Netdefs = $root.common.Empty.toObject(message.Netdefs, options);
                        if (options.oneofs)
                            object.Inner = "Netdefs";
                    }
                    if (message.Attach != null && message.hasOwnProperty("Attach")) {
                        object.Attach = $root.priority.netitems.ngtw.AttachmentRequest.toObject(message.Attach, options);
                        if (options.oneofs)
                            object.Inner = "Attach";
                    }
                    if (message.Asapi != null && message.hasOwnProperty("Asapi")) {
                        object.Asapi = $root.priority.netitems.ngtw.AsapiRequest.toObject(message.Asapi, options);
                        if (options.oneofs)
                            object.Inner = "Asapi";
                    }
                    if (message.Companies != null && message.hasOwnProperty("Companies")) {
                        object.Companies = $root.common.CompaniesRq.toObject(message.Companies, options);
                        if (options.oneofs)
                            object.Inner = "Companies";
                    }
                    if (message.DataStoreSet != null && message.hasOwnProperty("DataStoreSet")) {
                        object.DataStoreSet = $root.priority.netitems.ngtw.DataStoreSetRq.toObject(message.DataStoreSet, options);
                        if (options.oneofs)
                            object.Inner = "DataStoreSet";
                    }
                    if (message.DataStoreGet != null && message.hasOwnProperty("DataStoreGet")) {
                        object.DataStoreGet = $root.priority.netitems.ngtw.DataStoreGetRq.toObject(message.DataStoreGet, options);
                        if (options.oneofs)
                            object.Inner = "DataStoreGet";
                    }
                    if (message.GeneralAbout != null && message.hasOwnProperty("GeneralAbout")) {
                        object.GeneralAbout = $root.priority.netitems.ngtw.GeneralAboutRq.toObject(message.GeneralAbout, options);
                        if (options.oneofs)
                            object.Inner = "GeneralAbout";
                    }
                    return object;
                };

                /**
                 * Converts this Grpc2Net to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.Grpc2Net
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Grpc2Net.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Grpc2Net;
            })();

            ngtw.Net2Grpc = (function() {

                /**
                 * Properties of a Net2Grpc.
                 * @memberof priority.netitems.ngtw
                 * @interface INet2Grpc
                 * @property {priority.netitems.shared.IGrpcError|null} [FatalError] Net2Grpc FatalError
                 * @property {priority.netitems.ngtw.IGatewayRsaKey|null} [rsaKey] Net2Grpc rsaKey
                 * @property {priority.netitems.shared.ITenantDetailsResponse|null} [tenantDetails] Net2Grpc tenantDetails
                 * @property {priority.netitems.ngtw.IEntityMessagesResponse|null} [entityMessages] Net2Grpc entityMessages
                 * @property {priority.netitems.ngtw.IExecuteCompiledResponse|null} [exec] Net2Grpc exec
                 * @property {priority.netitems.ngtw.INetdefsResponse|null} [Netdefs] Net2Grpc Netdefs
                 * @property {priority.netitems.ngtw.IAttachmentResponse|null} [Attach] Net2Grpc Attach
                 * @property {priority.netitems.ngtw.IAsapiResponse|null} [Asapi] Net2Grpc Asapi
                 * @property {common.ICompaniesRs|null} [Companies] Net2Grpc Companies
                 * @property {priority.netitems.ngtw.IDataStoreSetRs|null} [DataStoreSet] Net2Grpc DataStoreSet
                 * @property {priority.netitems.ngtw.IDataStoreGetRs|null} [DataStoreGet] Net2Grpc DataStoreGet
                 * @property {priority.netitems.ngtw.IGeneralAboutRs|null} [GeneralAbout] Net2Grpc GeneralAbout
                 */

                /**
                 * Constructs a new Net2Grpc.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a Net2Grpc.
                 * @implements INet2Grpc
                 * @constructor
                 * @param {priority.netitems.ngtw.INet2Grpc=} [properties] Properties to set
                 */
                function Net2Grpc(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Net2Grpc FatalError.
                 * @member {priority.netitems.shared.IGrpcError|null|undefined} FatalError
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FatalError = null;

                /**
                 * Net2Grpc rsaKey.
                 * @member {priority.netitems.ngtw.IGatewayRsaKey|null|undefined} rsaKey
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.rsaKey = null;

                /**
                 * Net2Grpc tenantDetails.
                 * @member {priority.netitems.shared.ITenantDetailsResponse|null|undefined} tenantDetails
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.tenantDetails = null;

                /**
                 * Net2Grpc entityMessages.
                 * @member {priority.netitems.ngtw.IEntityMessagesResponse|null|undefined} entityMessages
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.entityMessages = null;

                /**
                 * Net2Grpc exec.
                 * @member {priority.netitems.ngtw.IExecuteCompiledResponse|null|undefined} exec
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.exec = null;

                /**
                 * Net2Grpc Netdefs.
                 * @member {priority.netitems.ngtw.INetdefsResponse|null|undefined} Netdefs
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Netdefs = null;

                /**
                 * Net2Grpc Attach.
                 * @member {priority.netitems.ngtw.IAttachmentResponse|null|undefined} Attach
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Attach = null;

                /**
                 * Net2Grpc Asapi.
                 * @member {priority.netitems.ngtw.IAsapiResponse|null|undefined} Asapi
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Asapi = null;

                /**
                 * Net2Grpc Companies.
                 * @member {common.ICompaniesRs|null|undefined} Companies
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Companies = null;

                /**
                 * Net2Grpc DataStoreSet.
                 * @member {priority.netitems.ngtw.IDataStoreSetRs|null|undefined} DataStoreSet
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.DataStoreSet = null;

                /**
                 * Net2Grpc DataStoreGet.
                 * @member {priority.netitems.ngtw.IDataStoreGetRs|null|undefined} DataStoreGet
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.DataStoreGet = null;

                /**
                 * Net2Grpc GeneralAbout.
                 * @member {priority.netitems.ngtw.IGeneralAboutRs|null|undefined} GeneralAbout
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.GeneralAbout = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Net2Grpc Inner.
                 * @member {"rsaKey"|"tenantDetails"|"entityMessages"|"exec"|"Netdefs"|"Attach"|"Asapi"|"Companies"|"DataStoreSet"|"DataStoreGet"|"GeneralAbout"|undefined} Inner
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 */
                Object.defineProperty(Net2Grpc.prototype, "Inner", {
                    get: $util.oneOfGetter($oneOfFields = ["rsaKey", "tenantDetails", "entityMessages", "exec", "Netdefs", "Attach", "Asapi", "Companies", "DataStoreSet", "DataStoreGet", "GeneralAbout"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Net2Grpc instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @static
                 * @param {priority.netitems.ngtw.INet2Grpc=} [properties] Properties to set
                 * @returns {priority.netitems.ngtw.Net2Grpc} Net2Grpc instance
                 */
                Net2Grpc.create = function create(properties) {
                    return new Net2Grpc(properties);
                };

                /**
                 * Encodes the specified Net2Grpc message. Does not implicitly {@link priority.netitems.ngtw.Net2Grpc.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @static
                 * @param {priority.netitems.ngtw.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.FatalError != null && Object.hasOwnProperty.call(message, "FatalError"))
                        $root.priority.netitems.shared.GrpcError.encode(message.FatalError, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.rsaKey != null && Object.hasOwnProperty.call(message, "rsaKey"))
                        $root.priority.netitems.ngtw.GatewayRsaKey.encode(message.rsaKey, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.tenantDetails != null && Object.hasOwnProperty.call(message, "tenantDetails"))
                        $root.priority.netitems.shared.TenantDetailsResponse.encode(message.tenantDetails, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.entityMessages != null && Object.hasOwnProperty.call(message, "entityMessages"))
                        $root.priority.netitems.ngtw.EntityMessagesResponse.encode(message.entityMessages, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.exec != null && Object.hasOwnProperty.call(message, "exec"))
                        $root.priority.netitems.ngtw.ExecuteCompiledResponse.encode(message.exec, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.Netdefs != null && Object.hasOwnProperty.call(message, "Netdefs"))
                        $root.priority.netitems.ngtw.NetdefsResponse.encode(message.Netdefs, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Attach != null && Object.hasOwnProperty.call(message, "Attach"))
                        $root.priority.netitems.ngtw.AttachmentResponse.encode(message.Attach, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.Asapi != null && Object.hasOwnProperty.call(message, "Asapi"))
                        $root.priority.netitems.ngtw.AsapiResponse.encode(message.Asapi, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.Companies != null && Object.hasOwnProperty.call(message, "Companies"))
                        $root.common.CompaniesRs.encode(message.Companies, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.DataStoreSet != null && Object.hasOwnProperty.call(message, "DataStoreSet"))
                        $root.priority.netitems.ngtw.DataStoreSetRs.encode(message.DataStoreSet, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.DataStoreGet != null && Object.hasOwnProperty.call(message, "DataStoreGet"))
                        $root.priority.netitems.ngtw.DataStoreGetRs.encode(message.DataStoreGet, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.GeneralAbout != null && Object.hasOwnProperty.call(message, "GeneralAbout"))
                        $root.priority.netitems.ngtw.GeneralAboutRs.encode(message.GeneralAbout, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Net2Grpc message, length delimited. Does not implicitly {@link priority.netitems.ngtw.Net2Grpc.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @static
                 * @param {priority.netitems.ngtw.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngtw.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngtw.Net2Grpc();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.FatalError = $root.priority.netitems.shared.GrpcError.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.rsaKey = $root.priority.netitems.ngtw.GatewayRsaKey.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.tenantDetails = $root.priority.netitems.shared.TenantDetailsResponse.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.entityMessages = $root.priority.netitems.ngtw.EntityMessagesResponse.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.exec = $root.priority.netitems.ngtw.ExecuteCompiledResponse.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.Netdefs = $root.priority.netitems.ngtw.NetdefsResponse.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.Attach = $root.priority.netitems.ngtw.AttachmentResponse.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.Asapi = $root.priority.netitems.ngtw.AsapiResponse.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.Companies = $root.common.CompaniesRs.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.DataStoreSet = $root.priority.netitems.ngtw.DataStoreSetRs.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.DataStoreGet = $root.priority.netitems.ngtw.DataStoreGetRs.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.GeneralAbout = $root.priority.netitems.ngtw.GeneralAboutRs.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngtw.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Net2Grpc message.
                 * @function verify
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Net2Grpc.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.FatalError != null && message.hasOwnProperty("FatalError")) {
                        var error = $root.priority.netitems.shared.GrpcError.verify(message.FatalError);
                        if (error)
                            return "FatalError." + error;
                    }
                    if (message.rsaKey != null && message.hasOwnProperty("rsaKey")) {
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.GatewayRsaKey.verify(message.rsaKey);
                            if (error)
                                return "rsaKey." + error;
                        }
                    }
                    if (message.tenantDetails != null && message.hasOwnProperty("tenantDetails")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.shared.TenantDetailsResponse.verify(message.tenantDetails);
                            if (error)
                                return "tenantDetails." + error;
                        }
                    }
                    if (message.entityMessages != null && message.hasOwnProperty("entityMessages")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.EntityMessagesResponse.verify(message.entityMessages);
                            if (error)
                                return "entityMessages." + error;
                        }
                    }
                    if (message.exec != null && message.hasOwnProperty("exec")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.ExecuteCompiledResponse.verify(message.exec);
                            if (error)
                                return "exec." + error;
                        }
                    }
                    if (message.Netdefs != null && message.hasOwnProperty("Netdefs")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.NetdefsResponse.verify(message.Netdefs);
                            if (error)
                                return "Netdefs." + error;
                        }
                    }
                    if (message.Attach != null && message.hasOwnProperty("Attach")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.AttachmentResponse.verify(message.Attach);
                            if (error)
                                return "Attach." + error;
                        }
                    }
                    if (message.Asapi != null && message.hasOwnProperty("Asapi")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.AsapiResponse.verify(message.Asapi);
                            if (error)
                                return "Asapi." + error;
                        }
                    }
                    if (message.Companies != null && message.hasOwnProperty("Companies")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.common.CompaniesRs.verify(message.Companies);
                            if (error)
                                return "Companies." + error;
                        }
                    }
                    if (message.DataStoreSet != null && message.hasOwnProperty("DataStoreSet")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.DataStoreSetRs.verify(message.DataStoreSet);
                            if (error)
                                return "DataStoreSet." + error;
                        }
                    }
                    if (message.DataStoreGet != null && message.hasOwnProperty("DataStoreGet")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.DataStoreGetRs.verify(message.DataStoreGet);
                            if (error)
                                return "DataStoreGet." + error;
                        }
                    }
                    if (message.GeneralAbout != null && message.hasOwnProperty("GeneralAbout")) {
                        if (properties.Inner === 1)
                            return "Inner: multiple values";
                        properties.Inner = 1;
                        {
                            var error = $root.priority.netitems.ngtw.GeneralAboutRs.verify(message.GeneralAbout);
                            if (error)
                                return "GeneralAbout." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Net2Grpc message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngtw.Net2Grpc} Net2Grpc
                 */
                Net2Grpc.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngtw.Net2Grpc)
                        return object;
                    var message = new $root.priority.netitems.ngtw.Net2Grpc();
                    if (object.FatalError != null) {
                        if (typeof object.FatalError !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.FatalError: object expected");
                        message.FatalError = $root.priority.netitems.shared.GrpcError.fromObject(object.FatalError);
                    }
                    if (object.rsaKey != null) {
                        if (typeof object.rsaKey !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.rsaKey: object expected");
                        message.rsaKey = $root.priority.netitems.ngtw.GatewayRsaKey.fromObject(object.rsaKey);
                    }
                    if (object.tenantDetails != null) {
                        if (typeof object.tenantDetails !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.tenantDetails: object expected");
                        message.tenantDetails = $root.priority.netitems.shared.TenantDetailsResponse.fromObject(object.tenantDetails);
                    }
                    if (object.entityMessages != null) {
                        if (typeof object.entityMessages !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.entityMessages: object expected");
                        message.entityMessages = $root.priority.netitems.ngtw.EntityMessagesResponse.fromObject(object.entityMessages);
                    }
                    if (object.exec != null) {
                        if (typeof object.exec !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.exec: object expected");
                        message.exec = $root.priority.netitems.ngtw.ExecuteCompiledResponse.fromObject(object.exec);
                    }
                    if (object.Netdefs != null) {
                        if (typeof object.Netdefs !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.Netdefs: object expected");
                        message.Netdefs = $root.priority.netitems.ngtw.NetdefsResponse.fromObject(object.Netdefs);
                    }
                    if (object.Attach != null) {
                        if (typeof object.Attach !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.Attach: object expected");
                        message.Attach = $root.priority.netitems.ngtw.AttachmentResponse.fromObject(object.Attach);
                    }
                    if (object.Asapi != null) {
                        if (typeof object.Asapi !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.Asapi: object expected");
                        message.Asapi = $root.priority.netitems.ngtw.AsapiResponse.fromObject(object.Asapi);
                    }
                    if (object.Companies != null) {
                        if (typeof object.Companies !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.Companies: object expected");
                        message.Companies = $root.common.CompaniesRs.fromObject(object.Companies);
                    }
                    if (object.DataStoreSet != null) {
                        if (typeof object.DataStoreSet !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.DataStoreSet: object expected");
                        message.DataStoreSet = $root.priority.netitems.ngtw.DataStoreSetRs.fromObject(object.DataStoreSet);
                    }
                    if (object.DataStoreGet != null) {
                        if (typeof object.DataStoreGet !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.DataStoreGet: object expected");
                        message.DataStoreGet = $root.priority.netitems.ngtw.DataStoreGetRs.fromObject(object.DataStoreGet);
                    }
                    if (object.GeneralAbout != null) {
                        if (typeof object.GeneralAbout !== "object")
                            throw TypeError(".priority.netitems.ngtw.Net2Grpc.GeneralAbout: object expected");
                        message.GeneralAbout = $root.priority.netitems.ngtw.GeneralAboutRs.fromObject(object.GeneralAbout);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Net2Grpc message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @static
                 * @param {priority.netitems.ngtw.Net2Grpc} message Net2Grpc
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Net2Grpc.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.FatalError = null;
                    if (message.FatalError != null && message.hasOwnProperty("FatalError"))
                        object.FatalError = $root.priority.netitems.shared.GrpcError.toObject(message.FatalError, options);
                    if (message.rsaKey != null && message.hasOwnProperty("rsaKey")) {
                        object.rsaKey = $root.priority.netitems.ngtw.GatewayRsaKey.toObject(message.rsaKey, options);
                        if (options.oneofs)
                            object.Inner = "rsaKey";
                    }
                    if (message.tenantDetails != null && message.hasOwnProperty("tenantDetails")) {
                        object.tenantDetails = $root.priority.netitems.shared.TenantDetailsResponse.toObject(message.tenantDetails, options);
                        if (options.oneofs)
                            object.Inner = "tenantDetails";
                    }
                    if (message.entityMessages != null && message.hasOwnProperty("entityMessages")) {
                        object.entityMessages = $root.priority.netitems.ngtw.EntityMessagesResponse.toObject(message.entityMessages, options);
                        if (options.oneofs)
                            object.Inner = "entityMessages";
                    }
                    if (message.exec != null && message.hasOwnProperty("exec")) {
                        object.exec = $root.priority.netitems.ngtw.ExecuteCompiledResponse.toObject(message.exec, options);
                        if (options.oneofs)
                            object.Inner = "exec";
                    }
                    if (message.Netdefs != null && message.hasOwnProperty("Netdefs")) {
                        object.Netdefs = $root.priority.netitems.ngtw.NetdefsResponse.toObject(message.Netdefs, options);
                        if (options.oneofs)
                            object.Inner = "Netdefs";
                    }
                    if (message.Attach != null && message.hasOwnProperty("Attach")) {
                        object.Attach = $root.priority.netitems.ngtw.AttachmentResponse.toObject(message.Attach, options);
                        if (options.oneofs)
                            object.Inner = "Attach";
                    }
                    if (message.Asapi != null && message.hasOwnProperty("Asapi")) {
                        object.Asapi = $root.priority.netitems.ngtw.AsapiResponse.toObject(message.Asapi, options);
                        if (options.oneofs)
                            object.Inner = "Asapi";
                    }
                    if (message.Companies != null && message.hasOwnProperty("Companies")) {
                        object.Companies = $root.common.CompaniesRs.toObject(message.Companies, options);
                        if (options.oneofs)
                            object.Inner = "Companies";
                    }
                    if (message.DataStoreSet != null && message.hasOwnProperty("DataStoreSet")) {
                        object.DataStoreSet = $root.priority.netitems.ngtw.DataStoreSetRs.toObject(message.DataStoreSet, options);
                        if (options.oneofs)
                            object.Inner = "DataStoreSet";
                    }
                    if (message.DataStoreGet != null && message.hasOwnProperty("DataStoreGet")) {
                        object.DataStoreGet = $root.priority.netitems.ngtw.DataStoreGetRs.toObject(message.DataStoreGet, options);
                        if (options.oneofs)
                            object.Inner = "DataStoreGet";
                    }
                    if (message.GeneralAbout != null && message.hasOwnProperty("GeneralAbout")) {
                        object.GeneralAbout = $root.priority.netitems.ngtw.GeneralAboutRs.toObject(message.GeneralAbout, options);
                        if (options.oneofs)
                            object.Inner = "GeneralAbout";
                    }
                    return object;
                };

                /**
                 * Converts this Net2Grpc to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngtw.Net2Grpc
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Net2Grpc.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Net2Grpc;
            })();

            ngtw.NetGateway = (function() {

                /**
                 * Constructs a new NetGateway service.
                 * @memberof priority.netitems.ngtw
                 * @classdesc Represents a NetGateway
                 * @extends $protobuf.rpc.Service
                 * @constructor
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 */
                function NetGateway(rpcImpl, requestDelimited, responseDelimited) {
                    $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }

                (NetGateway.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NetGateway;

                /**
                 * Creates new NetGateway service using the specified rpc implementation.
                 * @function create
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @static
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 * @returns {NetGateway} RPC service. Useful where requests and/or responses are streamed.
                 */
                NetGateway.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#getGatewayPrivateKey}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef GetGatewayPrivateKeyCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.GatewayRsaKey} [response] GatewayRsaKey
                 */

                /**
                 * Calls GetGatewayPrivateKey.
                 * @function getGatewayPrivateKey
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.metadata.IAdditionalProperties} request AdditionalProperties message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.GetGatewayPrivateKeyCallback} callback Node-style callback called with the error, if any, and GatewayRsaKey
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.getGatewayPrivateKey = function getGatewayPrivateKey(request, callback) {
                    return this.rpcCall(getGatewayPrivateKey, $root.priority.netitems.metadata.AdditionalProperties, $root.priority.netitems.ngtw.GatewayRsaKey, request, callback);
                }, "name", { value: "GetGatewayPrivateKey" });

                /**
                 * Calls GetGatewayPrivateKey.
                 * @function getGatewayPrivateKey
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.metadata.IAdditionalProperties} request AdditionalProperties message or plain object
                 * @returns {Promise<priority.netitems.ngtw.GatewayRsaKey>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#getTenantDetails}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef GetTenantDetailsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.shared.TenantDetailsResponse} [response] TenantDetailsResponse
                 */

                /**
                 * Calls GetTenantDetails.
                 * @function getTenantDetails
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.metadata.IAdditionalProperties} request AdditionalProperties message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.GetTenantDetailsCallback} callback Node-style callback called with the error, if any, and TenantDetailsResponse
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.getTenantDetails = function getTenantDetails(request, callback) {
                    return this.rpcCall(getTenantDetails, $root.priority.netitems.metadata.AdditionalProperties, $root.priority.netitems.shared.TenantDetailsResponse, request, callback);
                }, "name", { value: "GetTenantDetails" });

                /**
                 * Calls GetTenantDetails.
                 * @function getTenantDetails
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.metadata.IAdditionalProperties} request AdditionalProperties message or plain object
                 * @returns {Promise<priority.netitems.shared.TenantDetailsResponse>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#getEntityMessages}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef GetEntityMessagesCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.EntityMessagesResponse} [response] EntityMessagesResponse
                 */

                /**
                 * Calls GetEntityMessages.
                 * @function getEntityMessages
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IEntityMessagesRequest} request EntityMessagesRequest message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.GetEntityMessagesCallback} callback Node-style callback called with the error, if any, and EntityMessagesResponse
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.getEntityMessages = function getEntityMessages(request, callback) {
                    return this.rpcCall(getEntityMessages, $root.priority.netitems.ngtw.EntityMessagesRequest, $root.priority.netitems.ngtw.EntityMessagesResponse, request, callback);
                }, "name", { value: "GetEntityMessages" });

                /**
                 * Calls GetEntityMessages.
                 * @function getEntityMessages
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IEntityMessagesRequest} request EntityMessagesRequest message or plain object
                 * @returns {Promise<priority.netitems.ngtw.EntityMessagesResponse>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#executeCompiled}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef ExecuteCompiledCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.ExecuteCompiledResponse} [response] ExecuteCompiledResponse
                 */

                /**
                 * Calls ExecuteCompiled.
                 * @function executeCompiled
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IExecuteCompiledRequest} request ExecuteCompiledRequest message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.ExecuteCompiledCallback} callback Node-style callback called with the error, if any, and ExecuteCompiledResponse
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.executeCompiled = function executeCompiled(request, callback) {
                    return this.rpcCall(executeCompiled, $root.priority.netitems.ngtw.ExecuteCompiledRequest, $root.priority.netitems.ngtw.ExecuteCompiledResponse, request, callback);
                }, "name", { value: "ExecuteCompiled" });

                /**
                 * Calls ExecuteCompiled.
                 * @function executeCompiled
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IExecuteCompiledRequest} request ExecuteCompiledRequest message or plain object
                 * @returns {Promise<priority.netitems.ngtw.ExecuteCompiledResponse>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#netDefs}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef NetDefsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.NetdefsResponse} [response] NetdefsResponse
                 */

                /**
                 * Calls NetDefs.
                 * @function netDefs
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.metadata.IAdditionalProperties} request AdditionalProperties message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.NetDefsCallback} callback Node-style callback called with the error, if any, and NetdefsResponse
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.netDefs = function netDefs(request, callback) {
                    return this.rpcCall(netDefs, $root.priority.netitems.metadata.AdditionalProperties, $root.priority.netitems.ngtw.NetdefsResponse, request, callback);
                }, "name", { value: "NetDefs" });

                /**
                 * Calls NetDefs.
                 * @function netDefs
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.metadata.IAdditionalProperties} request AdditionalProperties message or plain object
                 * @returns {Promise<priority.netitems.ngtw.NetdefsResponse>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#attachment}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef AttachmentCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.AttachmentResponse} [response] AttachmentResponse
                 */

                /**
                 * Calls Attachment.
                 * @function attachment
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IAttachmentRequest} request AttachmentRequest message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.AttachmentCallback} callback Node-style callback called with the error, if any, and AttachmentResponse
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.attachment = function attachment(request, callback) {
                    return this.rpcCall(attachment, $root.priority.netitems.ngtw.AttachmentRequest, $root.priority.netitems.ngtw.AttachmentResponse, request, callback);
                }, "name", { value: "Attachment" });

                /**
                 * Calls Attachment.
                 * @function attachment
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IAttachmentRequest} request AttachmentRequest message or plain object
                 * @returns {Promise<priority.netitems.ngtw.AttachmentResponse>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#asapi}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef AsapiCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.AsapiResponse} [response] AsapiResponse
                 */

                /**
                 * Calls Asapi.
                 * @function asapi
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IAsapiRequest} request AsapiRequest message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.AsapiCallback} callback Node-style callback called with the error, if any, and AsapiResponse
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.asapi = function asapi(request, callback) {
                    return this.rpcCall(asapi, $root.priority.netitems.ngtw.AsapiRequest, $root.priority.netitems.ngtw.AsapiResponse, request, callback);
                }, "name", { value: "Asapi" });

                /**
                 * Calls Asapi.
                 * @function asapi
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IAsapiRequest} request AsapiRequest message or plain object
                 * @returns {Promise<priority.netitems.ngtw.AsapiResponse>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#companies}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef CompaniesCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {common.CompaniesRs} [response] CompaniesRs
                 */

                /**
                 * Calls Companies.
                 * @function companies
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {common.ICompaniesRq} request CompaniesRq message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.CompaniesCallback} callback Node-style callback called with the error, if any, and CompaniesRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.companies = function companies(request, callback) {
                    return this.rpcCall(companies, $root.common.CompaniesRq, $root.common.CompaniesRs, request, callback);
                }, "name", { value: "Companies" });

                /**
                 * Calls Companies.
                 * @function companies
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {common.ICompaniesRq} request CompaniesRq message or plain object
                 * @returns {Promise<common.CompaniesRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#dataStoreSet}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef DataStoreSetCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.DataStoreSetRs} [response] DataStoreSetRs
                 */

                /**
                 * Calls DataStoreSet.
                 * @function dataStoreSet
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IDataStoreSetRq} request DataStoreSetRq message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.DataStoreSetCallback} callback Node-style callback called with the error, if any, and DataStoreSetRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.dataStoreSet = function dataStoreSet(request, callback) {
                    return this.rpcCall(dataStoreSet, $root.priority.netitems.ngtw.DataStoreSetRq, $root.priority.netitems.ngtw.DataStoreSetRs, request, callback);
                }, "name", { value: "DataStoreSet" });

                /**
                 * Calls DataStoreSet.
                 * @function dataStoreSet
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IDataStoreSetRq} request DataStoreSetRq message or plain object
                 * @returns {Promise<priority.netitems.ngtw.DataStoreSetRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#dataStoreGet}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef DataStoreGetCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.DataStoreGetRs} [response] DataStoreGetRs
                 */

                /**
                 * Calls DataStoreGet.
                 * @function dataStoreGet
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IDataStoreGetRq} request DataStoreGetRq message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.DataStoreGetCallback} callback Node-style callback called with the error, if any, and DataStoreGetRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.dataStoreGet = function dataStoreGet(request, callback) {
                    return this.rpcCall(dataStoreGet, $root.priority.netitems.ngtw.DataStoreGetRq, $root.priority.netitems.ngtw.DataStoreGetRs, request, callback);
                }, "name", { value: "DataStoreGet" });

                /**
                 * Calls DataStoreGet.
                 * @function dataStoreGet
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IDataStoreGetRq} request DataStoreGetRq message or plain object
                 * @returns {Promise<priority.netitems.ngtw.DataStoreGetRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngtw.NetGateway#generalAbout}.
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @typedef GeneralAboutCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngtw.GeneralAboutRs} [response] GeneralAboutRs
                 */

                /**
                 * Calls GeneralAbout.
                 * @function generalAbout
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IGeneralAboutRq} request GeneralAboutRq message or plain object
                 * @param {priority.netitems.ngtw.NetGateway.GeneralAboutCallback} callback Node-style callback called with the error, if any, and GeneralAboutRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NetGateway.prototype.generalAbout = function generalAbout(request, callback) {
                    return this.rpcCall(generalAbout, $root.priority.netitems.ngtw.GeneralAboutRq, $root.priority.netitems.ngtw.GeneralAboutRs, request, callback);
                }, "name", { value: "GeneralAbout" });

                /**
                 * Calls GeneralAbout.
                 * @function generalAbout
                 * @memberof priority.netitems.ngtw.NetGateway
                 * @instance
                 * @param {priority.netitems.ngtw.IGeneralAboutRq} request GeneralAboutRq message or plain object
                 * @returns {Promise<priority.netitems.ngtw.GeneralAboutRs>} Promise
                 * @variation 2
                 */

                return NetGateway;
            })();

            return ngtw;
        })();

        netitems.nrest = (function() {

            /**
             * Namespace nrest.
             * @memberof priority.netitems
             * @namespace
             */
            var nrest = {};

            nrest.QueryRq = (function() {

                /**
                 * Properties of a QueryRq.
                 * @memberof priority.netitems.nrest
                 * @interface IQueryRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] QueryRq Properties
                 * @property {Array.<priority.netitems.nrest.IExpr>|null} [Select] QueryRq Select
                 * @property {Array.<priority.netitems.nrest.IForm>|null} [From] QueryRq From
                 * @property {Array.<priority.netitems.nrest.IJoin>|null} [Joins] QueryRq Joins
                 * @property {priority.netitems.nrest.ICondExpr|null} [Where] QueryRq Where
                 * @property {Array.<number|Long>|null} [GroupBy] QueryRq GroupBy
                 * @property {Array.<priority.netitems.nrest.IOrderby>|null} [OrderBy] QueryRq OrderBy
                 * @property {number|Long|null} [Top] QueryRq Top
                 * @property {number|Long|null} [Skip] QueryRq Skip
                 * @property {boolean|null} [Distinct] QueryRq Distinct
                 */

                /**
                 * Constructs a new QueryRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a QueryRq.
                 * @implements IQueryRq
                 * @constructor
                 * @param {priority.netitems.nrest.IQueryRq=} [properties] Properties to set
                 */
                function QueryRq(properties) {
                    this.Select = [];
                    this.From = [];
                    this.Joins = [];
                    this.GroupBy = [];
                    this.OrderBy = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * QueryRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.Properties = null;

                /**
                 * QueryRq Select.
                 * @member {Array.<priority.netitems.nrest.IExpr>} Select
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.Select = $util.emptyArray;

                /**
                 * QueryRq From.
                 * @member {Array.<priority.netitems.nrest.IForm>} From
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.From = $util.emptyArray;

                /**
                 * QueryRq Joins.
                 * @member {Array.<priority.netitems.nrest.IJoin>} Joins
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.Joins = $util.emptyArray;

                /**
                 * QueryRq Where.
                 * @member {priority.netitems.nrest.ICondExpr|null|undefined} Where
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.Where = null;

                /**
                 * QueryRq GroupBy.
                 * @member {Array.<number|Long>} GroupBy
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.GroupBy = $util.emptyArray;

                /**
                 * QueryRq OrderBy.
                 * @member {Array.<priority.netitems.nrest.IOrderby>} OrderBy
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.OrderBy = $util.emptyArray;

                /**
                 * QueryRq Top.
                 * @member {number|Long} Top
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.Top = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * QueryRq Skip.
                 * @member {number|Long} Skip
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.Skip = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * QueryRq Distinct.
                 * @member {boolean} Distinct
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 */
                QueryRq.prototype.Distinct = false;

                /**
                 * Creates a new QueryRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.QueryRq
                 * @static
                 * @param {priority.netitems.nrest.IQueryRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.QueryRq} QueryRq instance
                 */
                QueryRq.create = function create(properties) {
                    return new QueryRq(properties);
                };

                /**
                 * Encodes the specified QueryRq message. Does not implicitly {@link priority.netitems.nrest.QueryRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.QueryRq
                 * @static
                 * @param {priority.netitems.nrest.IQueryRq} message QueryRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Select != null && message.Select.length)
                        for (var i = 0; i < message.Select.length; ++i)
                            $root.priority.netitems.nrest.Expr.encode(message.Select[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.From != null && message.From.length)
                        for (var i = 0; i < message.From.length; ++i)
                            $root.priority.netitems.nrest.Form.encode(message.From[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Joins != null && message.Joins.length)
                        for (var i = 0; i < message.Joins.length; ++i)
                            $root.priority.netitems.nrest.Join.encode(message.Joins[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.Where != null && Object.hasOwnProperty.call(message, "Where"))
                        $root.priority.netitems.nrest.CondExpr.encode(message.Where, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.GroupBy != null && message.GroupBy.length) {
                        writer.uint32(/* id 6, wireType 2 =*/50).fork();
                        for (var i = 0; i < message.GroupBy.length; ++i)
                            writer.int64(message.GroupBy[i]);
                        writer.ldelim();
                    }
                    if (message.OrderBy != null && message.OrderBy.length)
                        for (var i = 0; i < message.OrderBy.length; ++i)
                            $root.priority.netitems.nrest.Orderby.encode(message.OrderBy[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.Top != null && Object.hasOwnProperty.call(message, "Top"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.Top);
                    if (message.Skip != null && Object.hasOwnProperty.call(message, "Skip"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.Skip);
                    if (message.Distinct != null && Object.hasOwnProperty.call(message, "Distinct"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.Distinct);
                    return writer;
                };

                /**
                 * Encodes the specified QueryRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.QueryRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.QueryRq
                 * @static
                 * @param {priority.netitems.nrest.IQueryRq} message QueryRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a QueryRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.QueryRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.QueryRq} QueryRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.QueryRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Select && message.Select.length))
                                message.Select = [];
                            message.Select.push($root.priority.netitems.nrest.Expr.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.From && message.From.length))
                                message.From = [];
                            message.From.push($root.priority.netitems.nrest.Form.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            if (!(message.Joins && message.Joins.length))
                                message.Joins = [];
                            message.Joins.push($root.priority.netitems.nrest.Join.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            message.Where = $root.priority.netitems.nrest.CondExpr.decode(reader, reader.uint32());
                            break;
                        case 6:
                            if (!(message.GroupBy && message.GroupBy.length))
                                message.GroupBy = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.GroupBy.push(reader.int64());
                            } else
                                message.GroupBy.push(reader.int64());
                            break;
                        case 7:
                            if (!(message.OrderBy && message.OrderBy.length))
                                message.OrderBy = [];
                            message.OrderBy.push($root.priority.netitems.nrest.Orderby.decode(reader, reader.uint32()));
                            break;
                        case 8:
                            message.Top = reader.int64();
                            break;
                        case 9:
                            message.Skip = reader.int64();
                            break;
                        case 10:
                            message.Distinct = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a QueryRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.QueryRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.QueryRq} QueryRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a QueryRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.QueryRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                QueryRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Select != null && message.hasOwnProperty("Select")) {
                        if (!Array.isArray(message.Select))
                            return "Select: array expected";
                        for (var i = 0; i < message.Select.length; ++i) {
                            var error = $root.priority.netitems.nrest.Expr.verify(message.Select[i]);
                            if (error)
                                return "Select." + error;
                        }
                    }
                    if (message.From != null && message.hasOwnProperty("From")) {
                        if (!Array.isArray(message.From))
                            return "From: array expected";
                        for (var i = 0; i < message.From.length; ++i) {
                            var error = $root.priority.netitems.nrest.Form.verify(message.From[i]);
                            if (error)
                                return "From." + error;
                        }
                    }
                    if (message.Joins != null && message.hasOwnProperty("Joins")) {
                        if (!Array.isArray(message.Joins))
                            return "Joins: array expected";
                        for (var i = 0; i < message.Joins.length; ++i) {
                            var error = $root.priority.netitems.nrest.Join.verify(message.Joins[i]);
                            if (error)
                                return "Joins." + error;
                        }
                    }
                    if (message.Where != null && message.hasOwnProperty("Where")) {
                        var error = $root.priority.netitems.nrest.CondExpr.verify(message.Where);
                        if (error)
                            return "Where." + error;
                    }
                    if (message.GroupBy != null && message.hasOwnProperty("GroupBy")) {
                        if (!Array.isArray(message.GroupBy))
                            return "GroupBy: array expected";
                        for (var i = 0; i < message.GroupBy.length; ++i)
                            if (!$util.isInteger(message.GroupBy[i]) && !(message.GroupBy[i] && $util.isInteger(message.GroupBy[i].low) && $util.isInteger(message.GroupBy[i].high)))
                                return "GroupBy: integer|Long[] expected";
                    }
                    if (message.OrderBy != null && message.hasOwnProperty("OrderBy")) {
                        if (!Array.isArray(message.OrderBy))
                            return "OrderBy: array expected";
                        for (var i = 0; i < message.OrderBy.length; ++i) {
                            var error = $root.priority.netitems.nrest.Orderby.verify(message.OrderBy[i]);
                            if (error)
                                return "OrderBy." + error;
                        }
                    }
                    if (message.Top != null && message.hasOwnProperty("Top"))
                        if (!$util.isInteger(message.Top) && !(message.Top && $util.isInteger(message.Top.low) && $util.isInteger(message.Top.high)))
                            return "Top: integer|Long expected";
                    if (message.Skip != null && message.hasOwnProperty("Skip"))
                        if (!$util.isInteger(message.Skip) && !(message.Skip && $util.isInteger(message.Skip.low) && $util.isInteger(message.Skip.high)))
                            return "Skip: integer|Long expected";
                    if (message.Distinct != null && message.hasOwnProperty("Distinct"))
                        if (typeof message.Distinct !== "boolean")
                            return "Distinct: boolean expected";
                    return null;
                };

                /**
                 * Creates a QueryRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.QueryRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.QueryRq} QueryRq
                 */
                QueryRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.QueryRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.QueryRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.QueryRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Select) {
                        if (!Array.isArray(object.Select))
                            throw TypeError(".priority.netitems.nrest.QueryRq.Select: array expected");
                        message.Select = [];
                        for (var i = 0; i < object.Select.length; ++i) {
                            if (typeof object.Select[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.QueryRq.Select: object expected");
                            message.Select[i] = $root.priority.netitems.nrest.Expr.fromObject(object.Select[i]);
                        }
                    }
                    if (object.From) {
                        if (!Array.isArray(object.From))
                            throw TypeError(".priority.netitems.nrest.QueryRq.From: array expected");
                        message.From = [];
                        for (var i = 0; i < object.From.length; ++i) {
                            if (typeof object.From[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.QueryRq.From: object expected");
                            message.From[i] = $root.priority.netitems.nrest.Form.fromObject(object.From[i]);
                        }
                    }
                    if (object.Joins) {
                        if (!Array.isArray(object.Joins))
                            throw TypeError(".priority.netitems.nrest.QueryRq.Joins: array expected");
                        message.Joins = [];
                        for (var i = 0; i < object.Joins.length; ++i) {
                            if (typeof object.Joins[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.QueryRq.Joins: object expected");
                            message.Joins[i] = $root.priority.netitems.nrest.Join.fromObject(object.Joins[i]);
                        }
                    }
                    if (object.Where != null) {
                        if (typeof object.Where !== "object")
                            throw TypeError(".priority.netitems.nrest.QueryRq.Where: object expected");
                        message.Where = $root.priority.netitems.nrest.CondExpr.fromObject(object.Where);
                    }
                    if (object.GroupBy) {
                        if (!Array.isArray(object.GroupBy))
                            throw TypeError(".priority.netitems.nrest.QueryRq.GroupBy: array expected");
                        message.GroupBy = [];
                        for (var i = 0; i < object.GroupBy.length; ++i)
                            if ($util.Long)
                                (message.GroupBy[i] = $util.Long.fromValue(object.GroupBy[i])).unsigned = false;
                            else if (typeof object.GroupBy[i] === "string")
                                message.GroupBy[i] = parseInt(object.GroupBy[i], 10);
                            else if (typeof object.GroupBy[i] === "number")
                                message.GroupBy[i] = object.GroupBy[i];
                            else if (typeof object.GroupBy[i] === "object")
                                message.GroupBy[i] = new $util.LongBits(object.GroupBy[i].low >>> 0, object.GroupBy[i].high >>> 0).toNumber();
                    }
                    if (object.OrderBy) {
                        if (!Array.isArray(object.OrderBy))
                            throw TypeError(".priority.netitems.nrest.QueryRq.OrderBy: array expected");
                        message.OrderBy = [];
                        for (var i = 0; i < object.OrderBy.length; ++i) {
                            if (typeof object.OrderBy[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.QueryRq.OrderBy: object expected");
                            message.OrderBy[i] = $root.priority.netitems.nrest.Orderby.fromObject(object.OrderBy[i]);
                        }
                    }
                    if (object.Top != null)
                        if ($util.Long)
                            (message.Top = $util.Long.fromValue(object.Top)).unsigned = false;
                        else if (typeof object.Top === "string")
                            message.Top = parseInt(object.Top, 10);
                        else if (typeof object.Top === "number")
                            message.Top = object.Top;
                        else if (typeof object.Top === "object")
                            message.Top = new $util.LongBits(object.Top.low >>> 0, object.Top.high >>> 0).toNumber();
                    if (object.Skip != null)
                        if ($util.Long)
                            (message.Skip = $util.Long.fromValue(object.Skip)).unsigned = false;
                        else if (typeof object.Skip === "string")
                            message.Skip = parseInt(object.Skip, 10);
                        else if (typeof object.Skip === "number")
                            message.Skip = object.Skip;
                        else if (typeof object.Skip === "object")
                            message.Skip = new $util.LongBits(object.Skip.low >>> 0, object.Skip.high >>> 0).toNumber();
                    if (object.Distinct != null)
                        message.Distinct = Boolean(object.Distinct);
                    return message;
                };

                /**
                 * Creates a plain object from a QueryRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.QueryRq
                 * @static
                 * @param {priority.netitems.nrest.QueryRq} message QueryRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                QueryRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Select = [];
                        object.From = [];
                        object.Joins = [];
                        object.GroupBy = [];
                        object.OrderBy = [];
                    }
                    if (options.defaults) {
                        object.Properties = null;
                        object.Where = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Top = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Top = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Skip = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Skip = options.longs === String ? "0" : 0;
                        object.Distinct = false;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Select && message.Select.length) {
                        object.Select = [];
                        for (var j = 0; j < message.Select.length; ++j)
                            object.Select[j] = $root.priority.netitems.nrest.Expr.toObject(message.Select[j], options);
                    }
                    if (message.From && message.From.length) {
                        object.From = [];
                        for (var j = 0; j < message.From.length; ++j)
                            object.From[j] = $root.priority.netitems.nrest.Form.toObject(message.From[j], options);
                    }
                    if (message.Joins && message.Joins.length) {
                        object.Joins = [];
                        for (var j = 0; j < message.Joins.length; ++j)
                            object.Joins[j] = $root.priority.netitems.nrest.Join.toObject(message.Joins[j], options);
                    }
                    if (message.Where != null && message.hasOwnProperty("Where"))
                        object.Where = $root.priority.netitems.nrest.CondExpr.toObject(message.Where, options);
                    if (message.GroupBy && message.GroupBy.length) {
                        object.GroupBy = [];
                        for (var j = 0; j < message.GroupBy.length; ++j)
                            if (typeof message.GroupBy[j] === "number")
                                object.GroupBy[j] = options.longs === String ? String(message.GroupBy[j]) : message.GroupBy[j];
                            else
                                object.GroupBy[j] = options.longs === String ? $util.Long.prototype.toString.call(message.GroupBy[j]) : options.longs === Number ? new $util.LongBits(message.GroupBy[j].low >>> 0, message.GroupBy[j].high >>> 0).toNumber() : message.GroupBy[j];
                    }
                    if (message.OrderBy && message.OrderBy.length) {
                        object.OrderBy = [];
                        for (var j = 0; j < message.OrderBy.length; ++j)
                            object.OrderBy[j] = $root.priority.netitems.nrest.Orderby.toObject(message.OrderBy[j], options);
                    }
                    if (message.Top != null && message.hasOwnProperty("Top"))
                        if (typeof message.Top === "number")
                            object.Top = options.longs === String ? String(message.Top) : message.Top;
                        else
                            object.Top = options.longs === String ? $util.Long.prototype.toString.call(message.Top) : options.longs === Number ? new $util.LongBits(message.Top.low >>> 0, message.Top.high >>> 0).toNumber() : message.Top;
                    if (message.Skip != null && message.hasOwnProperty("Skip"))
                        if (typeof message.Skip === "number")
                            object.Skip = options.longs === String ? String(message.Skip) : message.Skip;
                        else
                            object.Skip = options.longs === String ? $util.Long.prototype.toString.call(message.Skip) : options.longs === Number ? new $util.LongBits(message.Skip.low >>> 0, message.Skip.high >>> 0).toNumber() : message.Skip;
                    if (message.Distinct != null && message.hasOwnProperty("Distinct"))
                        object.Distinct = message.Distinct;
                    return object;
                };

                /**
                 * Converts this QueryRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.QueryRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                QueryRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return QueryRq;
            })();

            nrest.Orderby = (function() {

                /**
                 * Properties of an Orderby.
                 * @memberof priority.netitems.nrest
                 * @interface IOrderby
                 * @property {number|Long|null} [LocationInSelect] Orderby LocationInSelect
                 * @property {boolean|null} [Desc] Orderby Desc
                 */

                /**
                 * Constructs a new Orderby.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents an Orderby.
                 * @implements IOrderby
                 * @constructor
                 * @param {priority.netitems.nrest.IOrderby=} [properties] Properties to set
                 */
                function Orderby(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Orderby LocationInSelect.
                 * @member {number|Long} LocationInSelect
                 * @memberof priority.netitems.nrest.Orderby
                 * @instance
                 */
                Orderby.prototype.LocationInSelect = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Orderby Desc.
                 * @member {boolean} Desc
                 * @memberof priority.netitems.nrest.Orderby
                 * @instance
                 */
                Orderby.prototype.Desc = false;

                /**
                 * Creates a new Orderby instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Orderby
                 * @static
                 * @param {priority.netitems.nrest.IOrderby=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Orderby} Orderby instance
                 */
                Orderby.create = function create(properties) {
                    return new Orderby(properties);
                };

                /**
                 * Encodes the specified Orderby message. Does not implicitly {@link priority.netitems.nrest.Orderby.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Orderby
                 * @static
                 * @param {priority.netitems.nrest.IOrderby} message Orderby message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Orderby.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.LocationInSelect != null && Object.hasOwnProperty.call(message, "LocationInSelect"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.LocationInSelect);
                    if (message.Desc != null && Object.hasOwnProperty.call(message, "Desc"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.Desc);
                    return writer;
                };

                /**
                 * Encodes the specified Orderby message, length delimited. Does not implicitly {@link priority.netitems.nrest.Orderby.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Orderby
                 * @static
                 * @param {priority.netitems.nrest.IOrderby} message Orderby message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Orderby.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Orderby message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Orderby
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Orderby} Orderby
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Orderby.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Orderby();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.LocationInSelect = reader.int64();
                            break;
                        case 2:
                            message.Desc = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Orderby message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Orderby
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Orderby} Orderby
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Orderby.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Orderby message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Orderby
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Orderby.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.LocationInSelect != null && message.hasOwnProperty("LocationInSelect"))
                        if (!$util.isInteger(message.LocationInSelect) && !(message.LocationInSelect && $util.isInteger(message.LocationInSelect.low) && $util.isInteger(message.LocationInSelect.high)))
                            return "LocationInSelect: integer|Long expected";
                    if (message.Desc != null && message.hasOwnProperty("Desc"))
                        if (typeof message.Desc !== "boolean")
                            return "Desc: boolean expected";
                    return null;
                };

                /**
                 * Creates an Orderby message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Orderby
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Orderby} Orderby
                 */
                Orderby.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Orderby)
                        return object;
                    var message = new $root.priority.netitems.nrest.Orderby();
                    if (object.LocationInSelect != null)
                        if ($util.Long)
                            (message.LocationInSelect = $util.Long.fromValue(object.LocationInSelect)).unsigned = false;
                        else if (typeof object.LocationInSelect === "string")
                            message.LocationInSelect = parseInt(object.LocationInSelect, 10);
                        else if (typeof object.LocationInSelect === "number")
                            message.LocationInSelect = object.LocationInSelect;
                        else if (typeof object.LocationInSelect === "object")
                            message.LocationInSelect = new $util.LongBits(object.LocationInSelect.low >>> 0, object.LocationInSelect.high >>> 0).toNumber();
                    if (object.Desc != null)
                        message.Desc = Boolean(object.Desc);
                    return message;
                };

                /**
                 * Creates a plain object from an Orderby message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Orderby
                 * @static
                 * @param {priority.netitems.nrest.Orderby} message Orderby
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Orderby.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.LocationInSelect = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.LocationInSelect = options.longs === String ? "0" : 0;
                        object.Desc = false;
                    }
                    if (message.LocationInSelect != null && message.hasOwnProperty("LocationInSelect"))
                        if (typeof message.LocationInSelect === "number")
                            object.LocationInSelect = options.longs === String ? String(message.LocationInSelect) : message.LocationInSelect;
                        else
                            object.LocationInSelect = options.longs === String ? $util.Long.prototype.toString.call(message.LocationInSelect) : options.longs === Number ? new $util.LongBits(message.LocationInSelect.low >>> 0, message.LocationInSelect.high >>> 0).toNumber() : message.LocationInSelect;
                    if (message.Desc != null && message.hasOwnProperty("Desc"))
                        object.Desc = message.Desc;
                    return object;
                };

                /**
                 * Converts this Orderby to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Orderby
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Orderby.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Orderby;
            })();

            nrest.Form = (function() {

                /**
                 * Properties of a Form.
                 * @memberof priority.netitems.nrest
                 * @interface IForm
                 * @property {string|null} [FormName] Form FormName
                 * @property {string|null} [FormAlias] Form FormAlias
                 * @property {boolean|null} [OuterJoin] Form OuterJoin
                 */

                /**
                 * Constructs a new Form.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a Form.
                 * @implements IForm
                 * @constructor
                 * @param {priority.netitems.nrest.IForm=} [properties] Properties to set
                 */
                function Form(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Form FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.nrest.Form
                 * @instance
                 */
                Form.prototype.FormName = "";

                /**
                 * Form FormAlias.
                 * @member {string} FormAlias
                 * @memberof priority.netitems.nrest.Form
                 * @instance
                 */
                Form.prototype.FormAlias = "";

                /**
                 * Form OuterJoin.
                 * @member {boolean} OuterJoin
                 * @memberof priority.netitems.nrest.Form
                 * @instance
                 */
                Form.prototype.OuterJoin = false;

                /**
                 * Creates a new Form instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Form
                 * @static
                 * @param {priority.netitems.nrest.IForm=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Form} Form instance
                 */
                Form.create = function create(properties) {
                    return new Form(properties);
                };

                /**
                 * Encodes the specified Form message. Does not implicitly {@link priority.netitems.nrest.Form.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Form
                 * @static
                 * @param {priority.netitems.nrest.IForm} message Form message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Form.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.FormName);
                    if (message.FormAlias != null && Object.hasOwnProperty.call(message, "FormAlias"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.FormAlias);
                    if (message.OuterJoin != null && Object.hasOwnProperty.call(message, "OuterJoin"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.OuterJoin);
                    return writer;
                };

                /**
                 * Encodes the specified Form message, length delimited. Does not implicitly {@link priority.netitems.nrest.Form.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Form
                 * @static
                 * @param {priority.netitems.nrest.IForm} message Form message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Form.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Form message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Form
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Form} Form
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Form.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Form();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.FormName = reader.string();
                            break;
                        case 2:
                            message.FormAlias = reader.string();
                            break;
                        case 3:
                            message.OuterJoin = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Form message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Form
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Form} Form
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Form.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Form message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Form
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Form.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.FormAlias != null && message.hasOwnProperty("FormAlias"))
                        if (!$util.isString(message.FormAlias))
                            return "FormAlias: string expected";
                    if (message.OuterJoin != null && message.hasOwnProperty("OuterJoin"))
                        if (typeof message.OuterJoin !== "boolean")
                            return "OuterJoin: boolean expected";
                    return null;
                };

                /**
                 * Creates a Form message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Form
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Form} Form
                 */
                Form.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Form)
                        return object;
                    var message = new $root.priority.netitems.nrest.Form();
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    if (object.FormAlias != null)
                        message.FormAlias = String(object.FormAlias);
                    if (object.OuterJoin != null)
                        message.OuterJoin = Boolean(object.OuterJoin);
                    return message;
                };

                /**
                 * Creates a plain object from a Form message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Form
                 * @static
                 * @param {priority.netitems.nrest.Form} message Form
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Form.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.FormName = "";
                        object.FormAlias = "";
                        object.OuterJoin = false;
                    }
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.FormAlias != null && message.hasOwnProperty("FormAlias"))
                        object.FormAlias = message.FormAlias;
                    if (message.OuterJoin != null && message.hasOwnProperty("OuterJoin"))
                        object.OuterJoin = message.OuterJoin;
                    return object;
                };

                /**
                 * Converts this Form to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Form
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Form.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Form;
            })();

            nrest.Column = (function() {

                /**
                 * Properties of a Column.
                 * @memberof priority.netitems.nrest
                 * @interface IColumn
                 * @property {string|null} [FormName] Column FormName
                 * @property {string|null} [FormAlias] Column FormAlias
                 * @property {string|null} [Colname] Column Colname
                 */

                /**
                 * Constructs a new Column.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a Column.
                 * @implements IColumn
                 * @constructor
                 * @param {priority.netitems.nrest.IColumn=} [properties] Properties to set
                 */
                function Column(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Column FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.nrest.Column
                 * @instance
                 */
                Column.prototype.FormName = "";

                /**
                 * Column FormAlias.
                 * @member {string} FormAlias
                 * @memberof priority.netitems.nrest.Column
                 * @instance
                 */
                Column.prototype.FormAlias = "";

                /**
                 * Column Colname.
                 * @member {string} Colname
                 * @memberof priority.netitems.nrest.Column
                 * @instance
                 */
                Column.prototype.Colname = "";

                /**
                 * Creates a new Column instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Column
                 * @static
                 * @param {priority.netitems.nrest.IColumn=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Column} Column instance
                 */
                Column.create = function create(properties) {
                    return new Column(properties);
                };

                /**
                 * Encodes the specified Column message. Does not implicitly {@link priority.netitems.nrest.Column.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Column
                 * @static
                 * @param {priority.netitems.nrest.IColumn} message Column message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Column.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.FormName);
                    if (message.FormAlias != null && Object.hasOwnProperty.call(message, "FormAlias"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.FormAlias);
                    if (message.Colname != null && Object.hasOwnProperty.call(message, "Colname"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Colname);
                    return writer;
                };

                /**
                 * Encodes the specified Column message, length delimited. Does not implicitly {@link priority.netitems.nrest.Column.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Column
                 * @static
                 * @param {priority.netitems.nrest.IColumn} message Column message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Column.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Column message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Column
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Column} Column
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Column.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Column();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.FormName = reader.string();
                            break;
                        case 2:
                            message.FormAlias = reader.string();
                            break;
                        case 3:
                            message.Colname = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Column message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Column
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Column} Column
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Column.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Column message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Column
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Column.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.FormAlias != null && message.hasOwnProperty("FormAlias"))
                        if (!$util.isString(message.FormAlias))
                            return "FormAlias: string expected";
                    if (message.Colname != null && message.hasOwnProperty("Colname"))
                        if (!$util.isString(message.Colname))
                            return "Colname: string expected";
                    return null;
                };

                /**
                 * Creates a Column message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Column
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Column} Column
                 */
                Column.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Column)
                        return object;
                    var message = new $root.priority.netitems.nrest.Column();
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    if (object.FormAlias != null)
                        message.FormAlias = String(object.FormAlias);
                    if (object.Colname != null)
                        message.Colname = String(object.Colname);
                    return message;
                };

                /**
                 * Creates a plain object from a Column message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Column
                 * @static
                 * @param {priority.netitems.nrest.Column} message Column
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Column.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.FormName = "";
                        object.FormAlias = "";
                        object.Colname = "";
                    }
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.FormAlias != null && message.hasOwnProperty("FormAlias"))
                        object.FormAlias = message.FormAlias;
                    if (message.Colname != null && message.hasOwnProperty("Colname"))
                        object.Colname = message.Colname;
                    return object;
                };

                /**
                 * Converts this Column to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Column
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Column.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Column;
            })();

            nrest.Join = (function() {

                /**
                 * Properties of a Join.
                 * @memberof priority.netitems.nrest
                 * @interface IJoin
                 * @property {priority.netitems.nrest.IColumn|null} [From] Join From
                 * @property {priority.netitems.nrest.IColumn|null} [To] Join To
                 */

                /**
                 * Constructs a new Join.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a Join.
                 * @implements IJoin
                 * @constructor
                 * @param {priority.netitems.nrest.IJoin=} [properties] Properties to set
                 */
                function Join(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Join From.
                 * @member {priority.netitems.nrest.IColumn|null|undefined} From
                 * @memberof priority.netitems.nrest.Join
                 * @instance
                 */
                Join.prototype.From = null;

                /**
                 * Join To.
                 * @member {priority.netitems.nrest.IColumn|null|undefined} To
                 * @memberof priority.netitems.nrest.Join
                 * @instance
                 */
                Join.prototype.To = null;

                /**
                 * Creates a new Join instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Join
                 * @static
                 * @param {priority.netitems.nrest.IJoin=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Join} Join instance
                 */
                Join.create = function create(properties) {
                    return new Join(properties);
                };

                /**
                 * Encodes the specified Join message. Does not implicitly {@link priority.netitems.nrest.Join.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Join
                 * @static
                 * @param {priority.netitems.nrest.IJoin} message Join message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Join.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.From != null && Object.hasOwnProperty.call(message, "From"))
                        $root.priority.netitems.nrest.Column.encode(message.From, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.To != null && Object.hasOwnProperty.call(message, "To"))
                        $root.priority.netitems.nrest.Column.encode(message.To, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Join message, length delimited. Does not implicitly {@link priority.netitems.nrest.Join.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Join
                 * @static
                 * @param {priority.netitems.nrest.IJoin} message Join message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Join.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Join message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Join
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Join} Join
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Join.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Join();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.From = $root.priority.netitems.nrest.Column.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.To = $root.priority.netitems.nrest.Column.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Join message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Join
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Join} Join
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Join.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Join message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Join
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Join.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.From != null && message.hasOwnProperty("From")) {
                        var error = $root.priority.netitems.nrest.Column.verify(message.From);
                        if (error)
                            return "From." + error;
                    }
                    if (message.To != null && message.hasOwnProperty("To")) {
                        var error = $root.priority.netitems.nrest.Column.verify(message.To);
                        if (error)
                            return "To." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Join message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Join
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Join} Join
                 */
                Join.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Join)
                        return object;
                    var message = new $root.priority.netitems.nrest.Join();
                    if (object.From != null) {
                        if (typeof object.From !== "object")
                            throw TypeError(".priority.netitems.nrest.Join.From: object expected");
                        message.From = $root.priority.netitems.nrest.Column.fromObject(object.From);
                    }
                    if (object.To != null) {
                        if (typeof object.To !== "object")
                            throw TypeError(".priority.netitems.nrest.Join.To: object expected");
                        message.To = $root.priority.netitems.nrest.Column.fromObject(object.To);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Join message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Join
                 * @static
                 * @param {priority.netitems.nrest.Join} message Join
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Join.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.From = null;
                        object.To = null;
                    }
                    if (message.From != null && message.hasOwnProperty("From"))
                        object.From = $root.priority.netitems.nrest.Column.toObject(message.From, options);
                    if (message.To != null && message.hasOwnProperty("To"))
                        object.To = $root.priority.netitems.nrest.Column.toObject(message.To, options);
                    return object;
                };

                /**
                 * Converts this Join to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Join
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Join.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Join;
            })();

            nrest.QueryRs = (function() {

                /**
                 * Properties of a QueryRs.
                 * @memberof priority.netitems.nrest
                 * @interface IQueryRs
                 * @property {Array.<priority.netitems.nrest.ISqlColumn>|null} [Columns] QueryRs Columns
                 * @property {Array.<priority.netitems.nrest.IDataRow>|null} [DataRows] QueryRs DataRows
                 * @property {string|null} [Warning] QueryRs Warning
                 */

                /**
                 * Constructs a new QueryRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a QueryRs.
                 * @implements IQueryRs
                 * @constructor
                 * @param {priority.netitems.nrest.IQueryRs=} [properties] Properties to set
                 */
                function QueryRs(properties) {
                    this.Columns = [];
                    this.DataRows = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * QueryRs Columns.
                 * @member {Array.<priority.netitems.nrest.ISqlColumn>} Columns
                 * @memberof priority.netitems.nrest.QueryRs
                 * @instance
                 */
                QueryRs.prototype.Columns = $util.emptyArray;

                /**
                 * QueryRs DataRows.
                 * @member {Array.<priority.netitems.nrest.IDataRow>} DataRows
                 * @memberof priority.netitems.nrest.QueryRs
                 * @instance
                 */
                QueryRs.prototype.DataRows = $util.emptyArray;

                /**
                 * QueryRs Warning.
                 * @member {string} Warning
                 * @memberof priority.netitems.nrest.QueryRs
                 * @instance
                 */
                QueryRs.prototype.Warning = "";

                /**
                 * Creates a new QueryRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.QueryRs
                 * @static
                 * @param {priority.netitems.nrest.IQueryRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.QueryRs} QueryRs instance
                 */
                QueryRs.create = function create(properties) {
                    return new QueryRs(properties);
                };

                /**
                 * Encodes the specified QueryRs message. Does not implicitly {@link priority.netitems.nrest.QueryRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.QueryRs
                 * @static
                 * @param {priority.netitems.nrest.IQueryRs} message QueryRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Columns != null && message.Columns.length)
                        for (var i = 0; i < message.Columns.length; ++i)
                            $root.priority.netitems.nrest.SqlColumn.encode(message.Columns[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.DataRows != null && message.DataRows.length)
                        for (var i = 0; i < message.DataRows.length; ++i)
                            $root.priority.netitems.nrest.DataRow.encode(message.DataRows[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Warning != null && Object.hasOwnProperty.call(message, "Warning"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Warning);
                    return writer;
                };

                /**
                 * Encodes the specified QueryRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.QueryRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.QueryRs
                 * @static
                 * @param {priority.netitems.nrest.IQueryRs} message QueryRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                QueryRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a QueryRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.QueryRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.QueryRs} QueryRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.QueryRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Columns && message.Columns.length))
                                message.Columns = [];
                            message.Columns.push($root.priority.netitems.nrest.SqlColumn.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.DataRows && message.DataRows.length))
                                message.DataRows = [];
                            message.DataRows.push($root.priority.netitems.nrest.DataRow.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.Warning = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a QueryRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.QueryRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.QueryRs} QueryRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                QueryRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a QueryRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.QueryRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                QueryRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (!Array.isArray(message.Columns))
                            return "Columns: array expected";
                        for (var i = 0; i < message.Columns.length; ++i) {
                            var error = $root.priority.netitems.nrest.SqlColumn.verify(message.Columns[i]);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.DataRows != null && message.hasOwnProperty("DataRows")) {
                        if (!Array.isArray(message.DataRows))
                            return "DataRows: array expected";
                        for (var i = 0; i < message.DataRows.length; ++i) {
                            var error = $root.priority.netitems.nrest.DataRow.verify(message.DataRows[i]);
                            if (error)
                                return "DataRows." + error;
                        }
                    }
                    if (message.Warning != null && message.hasOwnProperty("Warning"))
                        if (!$util.isString(message.Warning))
                            return "Warning: string expected";
                    return null;
                };

                /**
                 * Creates a QueryRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.QueryRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.QueryRs} QueryRs
                 */
                QueryRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.QueryRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.QueryRs();
                    if (object.Columns) {
                        if (!Array.isArray(object.Columns))
                            throw TypeError(".priority.netitems.nrest.QueryRs.Columns: array expected");
                        message.Columns = [];
                        for (var i = 0; i < object.Columns.length; ++i) {
                            if (typeof object.Columns[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.QueryRs.Columns: object expected");
                            message.Columns[i] = $root.priority.netitems.nrest.SqlColumn.fromObject(object.Columns[i]);
                        }
                    }
                    if (object.DataRows) {
                        if (!Array.isArray(object.DataRows))
                            throw TypeError(".priority.netitems.nrest.QueryRs.DataRows: array expected");
                        message.DataRows = [];
                        for (var i = 0; i < object.DataRows.length; ++i) {
                            if (typeof object.DataRows[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.QueryRs.DataRows: object expected");
                            message.DataRows[i] = $root.priority.netitems.nrest.DataRow.fromObject(object.DataRows[i]);
                        }
                    }
                    if (object.Warning != null)
                        message.Warning = String(object.Warning);
                    return message;
                };

                /**
                 * Creates a plain object from a QueryRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.QueryRs
                 * @static
                 * @param {priority.netitems.nrest.QueryRs} message QueryRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                QueryRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Columns = [];
                        object.DataRows = [];
                    }
                    if (options.defaults)
                        object.Warning = "";
                    if (message.Columns && message.Columns.length) {
                        object.Columns = [];
                        for (var j = 0; j < message.Columns.length; ++j)
                            object.Columns[j] = $root.priority.netitems.nrest.SqlColumn.toObject(message.Columns[j], options);
                    }
                    if (message.DataRows && message.DataRows.length) {
                        object.DataRows = [];
                        for (var j = 0; j < message.DataRows.length; ++j)
                            object.DataRows[j] = $root.priority.netitems.nrest.DataRow.toObject(message.DataRows[j], options);
                    }
                    if (message.Warning != null && message.hasOwnProperty("Warning"))
                        object.Warning = message.Warning;
                    return object;
                };

                /**
                 * Converts this QueryRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.QueryRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                QueryRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return QueryRs;
            })();

            nrest.DataRow = (function() {

                /**
                 * Properties of a DataRow.
                 * @memberof priority.netitems.nrest
                 * @interface IDataRow
                 * @property {Array.<string>|null} [Val] DataRow Val
                 */

                /**
                 * Constructs a new DataRow.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DataRow.
                 * @implements IDataRow
                 * @constructor
                 * @param {priority.netitems.nrest.IDataRow=} [properties] Properties to set
                 */
                function DataRow(properties) {
                    this.Val = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataRow Val.
                 * @member {Array.<string>} Val
                 * @memberof priority.netitems.nrest.DataRow
                 * @instance
                 */
                DataRow.prototype.Val = $util.emptyArray;

                /**
                 * Creates a new DataRow instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DataRow
                 * @static
                 * @param {priority.netitems.nrest.IDataRow=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DataRow} DataRow instance
                 */
                DataRow.create = function create(properties) {
                    return new DataRow(properties);
                };

                /**
                 * Encodes the specified DataRow message. Does not implicitly {@link priority.netitems.nrest.DataRow.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DataRow
                 * @static
                 * @param {priority.netitems.nrest.IDataRow} message DataRow message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataRow.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Val != null && message.Val.length)
                        for (var i = 0; i < message.Val.length; ++i)
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Val[i]);
                    return writer;
                };

                /**
                 * Encodes the specified DataRow message, length delimited. Does not implicitly {@link priority.netitems.nrest.DataRow.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DataRow
                 * @static
                 * @param {priority.netitems.nrest.IDataRow} message DataRow message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataRow.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataRow message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DataRow
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DataRow} DataRow
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataRow.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DataRow();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Val && message.Val.length))
                                message.Val = [];
                            message.Val.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataRow message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DataRow
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DataRow} DataRow
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataRow.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataRow message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DataRow
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataRow.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Val != null && message.hasOwnProperty("Val")) {
                        if (!Array.isArray(message.Val))
                            return "Val: array expected";
                        for (var i = 0; i < message.Val.length; ++i)
                            if (!$util.isString(message.Val[i]))
                                return "Val: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a DataRow message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DataRow
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DataRow} DataRow
                 */
                DataRow.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DataRow)
                        return object;
                    var message = new $root.priority.netitems.nrest.DataRow();
                    if (object.Val) {
                        if (!Array.isArray(object.Val))
                            throw TypeError(".priority.netitems.nrest.DataRow.Val: array expected");
                        message.Val = [];
                        for (var i = 0; i < object.Val.length; ++i)
                            message.Val[i] = String(object.Val[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DataRow message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DataRow
                 * @static
                 * @param {priority.netitems.nrest.DataRow} message DataRow
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataRow.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Val = [];
                    if (message.Val && message.Val.length) {
                        object.Val = [];
                        for (var j = 0; j < message.Val.length; ++j)
                            object.Val[j] = message.Val[j];
                    }
                    return object;
                };

                /**
                 * Converts this DataRow to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DataRow
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataRow.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataRow;
            })();

            /**
             * UnaryOp enum.
             * @name priority.netitems.nrest.UnaryOp
             * @enum {number}
             * @property {number} UnaryOp_Minus=0 UnaryOp_Minus value
             */
            nrest.UnaryOp = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UnaryOp_Minus"] = 0;
                return values;
            })();

            /**
             * BinaryOp enum.
             * @name priority.netitems.nrest.BinaryOp
             * @enum {number}
             * @property {number} BinaryOp_Minus=0 BinaryOp_Minus value
             * @property {number} BinaryOp_Plus=1 BinaryOp_Plus value
             * @property {number} BinaryOp_Mult=2 BinaryOp_Mult value
             * @property {number} BinaryOp_Div=3 BinaryOp_Div value
             */
            nrest.BinaryOp = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "BinaryOp_Minus"] = 0;
                values[valuesById[1] = "BinaryOp_Plus"] = 1;
                values[valuesById[2] = "BinaryOp_Mult"] = 2;
                values[valuesById[3] = "BinaryOp_Div"] = 3;
                return values;
            })();

            nrest.IfElseExpr = (function() {

                /**
                 * Properties of an IfElseExpr.
                 * @memberof priority.netitems.nrest
                 * @interface IIfElseExpr
                 * @property {priority.netitems.nrest.ICondExpr|null} [If] IfElseExpr If
                 * @property {priority.netitems.nrest.IExpr|null} [Then] IfElseExpr Then
                 * @property {priority.netitems.nrest.IExpr|null} [Else] IfElseExpr Else
                 */

                /**
                 * Constructs a new IfElseExpr.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents an IfElseExpr.
                 * @implements IIfElseExpr
                 * @constructor
                 * @param {priority.netitems.nrest.IIfElseExpr=} [properties] Properties to set
                 */
                function IfElseExpr(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * IfElseExpr If.
                 * @member {priority.netitems.nrest.ICondExpr|null|undefined} If
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @instance
                 */
                IfElseExpr.prototype.If = null;

                /**
                 * IfElseExpr Then.
                 * @member {priority.netitems.nrest.IExpr|null|undefined} Then
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @instance
                 */
                IfElseExpr.prototype.Then = null;

                /**
                 * IfElseExpr Else.
                 * @member {priority.netitems.nrest.IExpr|null|undefined} Else
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @instance
                 */
                IfElseExpr.prototype.Else = null;

                /**
                 * Creates a new IfElseExpr instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @static
                 * @param {priority.netitems.nrest.IIfElseExpr=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.IfElseExpr} IfElseExpr instance
                 */
                IfElseExpr.create = function create(properties) {
                    return new IfElseExpr(properties);
                };

                /**
                 * Encodes the specified IfElseExpr message. Does not implicitly {@link priority.netitems.nrest.IfElseExpr.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @static
                 * @param {priority.netitems.nrest.IIfElseExpr} message IfElseExpr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IfElseExpr.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.If != null && Object.hasOwnProperty.call(message, "If"))
                        $root.priority.netitems.nrest.CondExpr.encode(message.If, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Then != null && Object.hasOwnProperty.call(message, "Then"))
                        $root.priority.netitems.nrest.Expr.encode(message.Then, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Else != null && Object.hasOwnProperty.call(message, "Else"))
                        $root.priority.netitems.nrest.Expr.encode(message.Else, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified IfElseExpr message, length delimited. Does not implicitly {@link priority.netitems.nrest.IfElseExpr.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @static
                 * @param {priority.netitems.nrest.IIfElseExpr} message IfElseExpr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                IfElseExpr.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an IfElseExpr message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.IfElseExpr} IfElseExpr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IfElseExpr.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.IfElseExpr();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.If = $root.priority.netitems.nrest.CondExpr.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Then = $root.priority.netitems.nrest.Expr.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.Else = $root.priority.netitems.nrest.Expr.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an IfElseExpr message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.IfElseExpr} IfElseExpr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                IfElseExpr.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an IfElseExpr message.
                 * @function verify
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                IfElseExpr.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.If != null && message.hasOwnProperty("If")) {
                        var error = $root.priority.netitems.nrest.CondExpr.verify(message.If);
                        if (error)
                            return "If." + error;
                    }
                    if (message.Then != null && message.hasOwnProperty("Then")) {
                        var error = $root.priority.netitems.nrest.Expr.verify(message.Then);
                        if (error)
                            return "Then." + error;
                    }
                    if (message.Else != null && message.hasOwnProperty("Else")) {
                        var error = $root.priority.netitems.nrest.Expr.verify(message.Else);
                        if (error)
                            return "Else." + error;
                    }
                    return null;
                };

                /**
                 * Creates an IfElseExpr message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.IfElseExpr} IfElseExpr
                 */
                IfElseExpr.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.IfElseExpr)
                        return object;
                    var message = new $root.priority.netitems.nrest.IfElseExpr();
                    if (object.If != null) {
                        if (typeof object.If !== "object")
                            throw TypeError(".priority.netitems.nrest.IfElseExpr.If: object expected");
                        message.If = $root.priority.netitems.nrest.CondExpr.fromObject(object.If);
                    }
                    if (object.Then != null) {
                        if (typeof object.Then !== "object")
                            throw TypeError(".priority.netitems.nrest.IfElseExpr.Then: object expected");
                        message.Then = $root.priority.netitems.nrest.Expr.fromObject(object.Then);
                    }
                    if (object.Else != null) {
                        if (typeof object.Else !== "object")
                            throw TypeError(".priority.netitems.nrest.IfElseExpr.Else: object expected");
                        message.Else = $root.priority.netitems.nrest.Expr.fromObject(object.Else);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an IfElseExpr message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @static
                 * @param {priority.netitems.nrest.IfElseExpr} message IfElseExpr
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                IfElseExpr.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.If = null;
                        object.Then = null;
                        object.Else = null;
                    }
                    if (message.If != null && message.hasOwnProperty("If"))
                        object.If = $root.priority.netitems.nrest.CondExpr.toObject(message.If, options);
                    if (message.Then != null && message.hasOwnProperty("Then"))
                        object.Then = $root.priority.netitems.nrest.Expr.toObject(message.Then, options);
                    if (message.Else != null && message.hasOwnProperty("Else"))
                        object.Else = $root.priority.netitems.nrest.Expr.toObject(message.Else, options);
                    return object;
                };

                /**
                 * Converts this IfElseExpr to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.IfElseExpr
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                IfElseExpr.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return IfElseExpr;
            })();

            nrest.BinaryCondition = (function() {

                /**
                 * Properties of a BinaryCondition.
                 * @memberof priority.netitems.nrest
                 * @interface IBinaryCondition
                 * @property {priority.netitems.nrest.ICondExpr|null} [Left] BinaryCondition Left
                 * @property {priority.netitems.shared.LogicalOperator|null} [Operator] BinaryCondition Operator
                 * @property {priority.netitems.nrest.ICondExpr|null} [Right] BinaryCondition Right
                 */

                /**
                 * Constructs a new BinaryCondition.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a BinaryCondition.
                 * @implements IBinaryCondition
                 * @constructor
                 * @param {priority.netitems.nrest.IBinaryCondition=} [properties] Properties to set
                 */
                function BinaryCondition(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BinaryCondition Left.
                 * @member {priority.netitems.nrest.ICondExpr|null|undefined} Left
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @instance
                 */
                BinaryCondition.prototype.Left = null;

                /**
                 * BinaryCondition Operator.
                 * @member {priority.netitems.shared.LogicalOperator} Operator
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @instance
                 */
                BinaryCondition.prototype.Operator = 0;

                /**
                 * BinaryCondition Right.
                 * @member {priority.netitems.nrest.ICondExpr|null|undefined} Right
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @instance
                 */
                BinaryCondition.prototype.Right = null;

                /**
                 * Creates a new BinaryCondition instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @static
                 * @param {priority.netitems.nrest.IBinaryCondition=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.BinaryCondition} BinaryCondition instance
                 */
                BinaryCondition.create = function create(properties) {
                    return new BinaryCondition(properties);
                };

                /**
                 * Encodes the specified BinaryCondition message. Does not implicitly {@link priority.netitems.nrest.BinaryCondition.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @static
                 * @param {priority.netitems.nrest.IBinaryCondition} message BinaryCondition message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BinaryCondition.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Left != null && Object.hasOwnProperty.call(message, "Left"))
                        $root.priority.netitems.nrest.CondExpr.encode(message.Left, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Operator != null && Object.hasOwnProperty.call(message, "Operator"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Operator);
                    if (message.Right != null && Object.hasOwnProperty.call(message, "Right"))
                        $root.priority.netitems.nrest.CondExpr.encode(message.Right, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BinaryCondition message, length delimited. Does not implicitly {@link priority.netitems.nrest.BinaryCondition.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @static
                 * @param {priority.netitems.nrest.IBinaryCondition} message BinaryCondition message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BinaryCondition.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BinaryCondition message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.BinaryCondition} BinaryCondition
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BinaryCondition.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.BinaryCondition();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Left = $root.priority.netitems.nrest.CondExpr.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Operator = reader.int32();
                            break;
                        case 3:
                            message.Right = $root.priority.netitems.nrest.CondExpr.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BinaryCondition message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.BinaryCondition} BinaryCondition
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BinaryCondition.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BinaryCondition message.
                 * @function verify
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BinaryCondition.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Left != null && message.hasOwnProperty("Left")) {
                        var error = $root.priority.netitems.nrest.CondExpr.verify(message.Left);
                        if (error)
                            return "Left." + error;
                    }
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        switch (message.Operator) {
                        default:
                            return "Operator: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.Right != null && message.hasOwnProperty("Right")) {
                        var error = $root.priority.netitems.nrest.CondExpr.verify(message.Right);
                        if (error)
                            return "Right." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BinaryCondition message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.BinaryCondition} BinaryCondition
                 */
                BinaryCondition.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.BinaryCondition)
                        return object;
                    var message = new $root.priority.netitems.nrest.BinaryCondition();
                    if (object.Left != null) {
                        if (typeof object.Left !== "object")
                            throw TypeError(".priority.netitems.nrest.BinaryCondition.Left: object expected");
                        message.Left = $root.priority.netitems.nrest.CondExpr.fromObject(object.Left);
                    }
                    switch (object.Operator) {
                    case "And":
                    case 0:
                        message.Operator = 0;
                        break;
                    case "Or":
                    case 1:
                        message.Operator = 1;
                        break;
                    }
                    if (object.Right != null) {
                        if (typeof object.Right !== "object")
                            throw TypeError(".priority.netitems.nrest.BinaryCondition.Right: object expected");
                        message.Right = $root.priority.netitems.nrest.CondExpr.fromObject(object.Right);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BinaryCondition message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @static
                 * @param {priority.netitems.nrest.BinaryCondition} message BinaryCondition
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BinaryCondition.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Left = null;
                        object.Operator = options.enums === String ? "And" : 0;
                        object.Right = null;
                    }
                    if (message.Left != null && message.hasOwnProperty("Left"))
                        object.Left = $root.priority.netitems.nrest.CondExpr.toObject(message.Left, options);
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        object.Operator = options.enums === String ? $root.priority.netitems.shared.LogicalOperator[message.Operator] : message.Operator;
                    if (message.Right != null && message.hasOwnProperty("Right"))
                        object.Right = $root.priority.netitems.nrest.CondExpr.toObject(message.Right, options);
                    return object;
                };

                /**
                 * Converts this BinaryCondition to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.BinaryCondition
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BinaryCondition.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BinaryCondition;
            })();

            nrest.Condition = (function() {

                /**
                 * Properties of a Condition.
                 * @memberof priority.netitems.nrest
                 * @interface ICondition
                 * @property {priority.netitems.nrest.IExpr|null} [Left] Condition Left
                 * @property {priority.netitems.shared.ComparisonOperator|null} [Operator] Condition Operator
                 * @property {Array.<priority.netitems.nrest.IExpr>|null} [Values] Condition Values
                 */

                /**
                 * Constructs a new Condition.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a Condition.
                 * @implements ICondition
                 * @constructor
                 * @param {priority.netitems.nrest.ICondition=} [properties] Properties to set
                 */
                function Condition(properties) {
                    this.Values = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Condition Left.
                 * @member {priority.netitems.nrest.IExpr|null|undefined} Left
                 * @memberof priority.netitems.nrest.Condition
                 * @instance
                 */
                Condition.prototype.Left = null;

                /**
                 * Condition Operator.
                 * @member {priority.netitems.shared.ComparisonOperator} Operator
                 * @memberof priority.netitems.nrest.Condition
                 * @instance
                 */
                Condition.prototype.Operator = 0;

                /**
                 * Condition Values.
                 * @member {Array.<priority.netitems.nrest.IExpr>} Values
                 * @memberof priority.netitems.nrest.Condition
                 * @instance
                 */
                Condition.prototype.Values = $util.emptyArray;

                /**
                 * Creates a new Condition instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Condition
                 * @static
                 * @param {priority.netitems.nrest.ICondition=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Condition} Condition instance
                 */
                Condition.create = function create(properties) {
                    return new Condition(properties);
                };

                /**
                 * Encodes the specified Condition message. Does not implicitly {@link priority.netitems.nrest.Condition.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Condition
                 * @static
                 * @param {priority.netitems.nrest.ICondition} message Condition message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Condition.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Left != null && Object.hasOwnProperty.call(message, "Left"))
                        $root.priority.netitems.nrest.Expr.encode(message.Left, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Operator != null && Object.hasOwnProperty.call(message, "Operator"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Operator);
                    if (message.Values != null && message.Values.length)
                        for (var i = 0; i < message.Values.length; ++i)
                            $root.priority.netitems.nrest.Expr.encode(message.Values[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Condition message, length delimited. Does not implicitly {@link priority.netitems.nrest.Condition.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Condition
                 * @static
                 * @param {priority.netitems.nrest.ICondition} message Condition message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Condition.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Condition message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Condition
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Condition} Condition
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Condition.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Condition();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Left = $root.priority.netitems.nrest.Expr.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Operator = reader.int32();
                            break;
                        case 3:
                            if (!(message.Values && message.Values.length))
                                message.Values = [];
                            message.Values.push($root.priority.netitems.nrest.Expr.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Condition message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Condition
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Condition} Condition
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Condition.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Condition message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Condition
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Condition.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Left != null && message.hasOwnProperty("Left")) {
                        var error = $root.priority.netitems.nrest.Expr.verify(message.Left);
                        if (error)
                            return "Left." + error;
                    }
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        switch (message.Operator) {
                        default:
                            return "Operator: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                            break;
                        }
                    if (message.Values != null && message.hasOwnProperty("Values")) {
                        if (!Array.isArray(message.Values))
                            return "Values: array expected";
                        for (var i = 0; i < message.Values.length; ++i) {
                            var error = $root.priority.netitems.nrest.Expr.verify(message.Values[i]);
                            if (error)
                                return "Values." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Condition message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Condition
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Condition} Condition
                 */
                Condition.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Condition)
                        return object;
                    var message = new $root.priority.netitems.nrest.Condition();
                    if (object.Left != null) {
                        if (typeof object.Left !== "object")
                            throw TypeError(".priority.netitems.nrest.Condition.Left: object expected");
                        message.Left = $root.priority.netitems.nrest.Expr.fromObject(object.Left);
                    }
                    switch (object.Operator) {
                    case "Eq":
                    case 0:
                        message.Operator = 0;
                        break;
                    case "In":
                    case 1:
                        message.Operator = 1;
                        break;
                    case "NotIn":
                    case 2:
                        message.Operator = 2;
                        break;
                    case "Between":
                    case 3:
                        message.Operator = 3;
                        break;
                    case "Gt":
                    case 4:
                        message.Operator = 4;
                        break;
                    case "Lt":
                    case 5:
                        message.Operator = 5;
                        break;
                    case "Le":
                    case 6:
                        message.Operator = 6;
                        break;
                    case "Ge":
                    case 7:
                        message.Operator = 7;
                        break;
                    case "Ne":
                    case 8:
                        message.Operator = 8;
                        break;
                    case "NotBetween":
                    case 9:
                        message.Operator = 9;
                        break;
                    case "IsNull":
                    case 10:
                        message.Operator = 10;
                        break;
                    case "IsNotNull":
                    case 11:
                        message.Operator = 11;
                        break;
                    case "Like":
                    case 12:
                        message.Operator = 12;
                        break;
                    case "NotLike":
                    case 13:
                        message.Operator = 13;
                        break;
                    case "AndNot":
                    case 14:
                        message.Operator = 14;
                        break;
                    }
                    if (object.Values) {
                        if (!Array.isArray(object.Values))
                            throw TypeError(".priority.netitems.nrest.Condition.Values: array expected");
                        message.Values = [];
                        for (var i = 0; i < object.Values.length; ++i) {
                            if (typeof object.Values[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.Condition.Values: object expected");
                            message.Values[i] = $root.priority.netitems.nrest.Expr.fromObject(object.Values[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Condition message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Condition
                 * @static
                 * @param {priority.netitems.nrest.Condition} message Condition
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Condition.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Values = [];
                    if (options.defaults) {
                        object.Left = null;
                        object.Operator = options.enums === String ? "Eq" : 0;
                    }
                    if (message.Left != null && message.hasOwnProperty("Left"))
                        object.Left = $root.priority.netitems.nrest.Expr.toObject(message.Left, options);
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        object.Operator = options.enums === String ? $root.priority.netitems.shared.ComparisonOperator[message.Operator] : message.Operator;
                    if (message.Values && message.Values.length) {
                        object.Values = [];
                        for (var j = 0; j < message.Values.length; ++j)
                            object.Values[j] = $root.priority.netitems.nrest.Expr.toObject(message.Values[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this Condition to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Condition
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Condition.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Condition;
            })();

            nrest.CondExpr = (function() {

                /**
                 * Properties of a CondExpr.
                 * @memberof priority.netitems.nrest
                 * @interface ICondExpr
                 * @property {priority.netitems.nrest.ICondition|null} [Cond] CondExpr Cond
                 * @property {priority.netitems.nrest.IBinaryCondition|null} [BinaryCond] CondExpr BinaryCond
                 * @property {priority.netitems.nrest.ICondExpr|null} [NotCondExpr] CondExpr NotCondExpr
                 */

                /**
                 * Constructs a new CondExpr.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a CondExpr.
                 * @implements ICondExpr
                 * @constructor
                 * @param {priority.netitems.nrest.ICondExpr=} [properties] Properties to set
                 */
                function CondExpr(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CondExpr Cond.
                 * @member {priority.netitems.nrest.ICondition|null|undefined} Cond
                 * @memberof priority.netitems.nrest.CondExpr
                 * @instance
                 */
                CondExpr.prototype.Cond = null;

                /**
                 * CondExpr BinaryCond.
                 * @member {priority.netitems.nrest.IBinaryCondition|null|undefined} BinaryCond
                 * @memberof priority.netitems.nrest.CondExpr
                 * @instance
                 */
                CondExpr.prototype.BinaryCond = null;

                /**
                 * CondExpr NotCondExpr.
                 * @member {priority.netitems.nrest.ICondExpr|null|undefined} NotCondExpr
                 * @memberof priority.netitems.nrest.CondExpr
                 * @instance
                 */
                CondExpr.prototype.NotCondExpr = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * CondExpr inner.
                 * @member {"Cond"|"BinaryCond"|"NotCondExpr"|undefined} inner
                 * @memberof priority.netitems.nrest.CondExpr
                 * @instance
                 */
                Object.defineProperty(CondExpr.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["Cond", "BinaryCond", "NotCondExpr"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new CondExpr instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.CondExpr
                 * @static
                 * @param {priority.netitems.nrest.ICondExpr=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.CondExpr} CondExpr instance
                 */
                CondExpr.create = function create(properties) {
                    return new CondExpr(properties);
                };

                /**
                 * Encodes the specified CondExpr message. Does not implicitly {@link priority.netitems.nrest.CondExpr.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.CondExpr
                 * @static
                 * @param {priority.netitems.nrest.ICondExpr} message CondExpr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CondExpr.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Cond != null && Object.hasOwnProperty.call(message, "Cond"))
                        $root.priority.netitems.nrest.Condition.encode(message.Cond, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.BinaryCond != null && Object.hasOwnProperty.call(message, "BinaryCond"))
                        $root.priority.netitems.nrest.BinaryCondition.encode(message.BinaryCond, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.NotCondExpr != null && Object.hasOwnProperty.call(message, "NotCondExpr"))
                        $root.priority.netitems.nrest.CondExpr.encode(message.NotCondExpr, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified CondExpr message, length delimited. Does not implicitly {@link priority.netitems.nrest.CondExpr.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.CondExpr
                 * @static
                 * @param {priority.netitems.nrest.ICondExpr} message CondExpr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CondExpr.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CondExpr message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.CondExpr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.CondExpr} CondExpr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CondExpr.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.CondExpr();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Cond = $root.priority.netitems.nrest.Condition.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.BinaryCond = $root.priority.netitems.nrest.BinaryCondition.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.NotCondExpr = $root.priority.netitems.nrest.CondExpr.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CondExpr message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.CondExpr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.CondExpr} CondExpr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CondExpr.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CondExpr message.
                 * @function verify
                 * @memberof priority.netitems.nrest.CondExpr
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CondExpr.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Cond != null && message.hasOwnProperty("Cond")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.Condition.verify(message.Cond);
                            if (error)
                                return "Cond." + error;
                        }
                    }
                    if (message.BinaryCond != null && message.hasOwnProperty("BinaryCond")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.BinaryCondition.verify(message.BinaryCond);
                            if (error)
                                return "BinaryCond." + error;
                        }
                    }
                    if (message.NotCondExpr != null && message.hasOwnProperty("NotCondExpr")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.CondExpr.verify(message.NotCondExpr);
                            if (error)
                                return "NotCondExpr." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a CondExpr message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.CondExpr
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.CondExpr} CondExpr
                 */
                CondExpr.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.CondExpr)
                        return object;
                    var message = new $root.priority.netitems.nrest.CondExpr();
                    if (object.Cond != null) {
                        if (typeof object.Cond !== "object")
                            throw TypeError(".priority.netitems.nrest.CondExpr.Cond: object expected");
                        message.Cond = $root.priority.netitems.nrest.Condition.fromObject(object.Cond);
                    }
                    if (object.BinaryCond != null) {
                        if (typeof object.BinaryCond !== "object")
                            throw TypeError(".priority.netitems.nrest.CondExpr.BinaryCond: object expected");
                        message.BinaryCond = $root.priority.netitems.nrest.BinaryCondition.fromObject(object.BinaryCond);
                    }
                    if (object.NotCondExpr != null) {
                        if (typeof object.NotCondExpr !== "object")
                            throw TypeError(".priority.netitems.nrest.CondExpr.NotCondExpr: object expected");
                        message.NotCondExpr = $root.priority.netitems.nrest.CondExpr.fromObject(object.NotCondExpr);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CondExpr message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.CondExpr
                 * @static
                 * @param {priority.netitems.nrest.CondExpr} message CondExpr
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CondExpr.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.Cond != null && message.hasOwnProperty("Cond")) {
                        object.Cond = $root.priority.netitems.nrest.Condition.toObject(message.Cond, options);
                        if (options.oneofs)
                            object.inner = "Cond";
                    }
                    if (message.BinaryCond != null && message.hasOwnProperty("BinaryCond")) {
                        object.BinaryCond = $root.priority.netitems.nrest.BinaryCondition.toObject(message.BinaryCond, options);
                        if (options.oneofs)
                            object.inner = "BinaryCond";
                    }
                    if (message.NotCondExpr != null && message.hasOwnProperty("NotCondExpr")) {
                        object.NotCondExpr = $root.priority.netitems.nrest.CondExpr.toObject(message.NotCondExpr, options);
                        if (options.oneofs)
                            object.inner = "NotCondExpr";
                    }
                    return object;
                };

                /**
                 * Converts this CondExpr to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.CondExpr
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CondExpr.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CondExpr;
            })();

            nrest.Expr = (function() {

                /**
                 * Properties of an Expr.
                 * @memberof priority.netitems.nrest
                 * @interface IExpr
                 * @property {priority.netitems.nrest.IUnaryExpr|null} [UnaryExpr] Expr UnaryExpr
                 * @property {priority.netitems.nrest.IBinaryExpr|null} [BinaryExpr] Expr BinaryExpr
                 * @property {priority.netitems.nrest.IIfElseExpr|null} [IfElseExpr] Expr IfElseExpr
                 * @property {priority.netitems.nrest.IColumn|null} [col] Expr col
                 * @property {string|null} [Constant] Expr Constant
                 */

                /**
                 * Constructs a new Expr.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents an Expr.
                 * @implements IExpr
                 * @constructor
                 * @param {priority.netitems.nrest.IExpr=} [properties] Properties to set
                 */
                function Expr(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Expr UnaryExpr.
                 * @member {priority.netitems.nrest.IUnaryExpr|null|undefined} UnaryExpr
                 * @memberof priority.netitems.nrest.Expr
                 * @instance
                 */
                Expr.prototype.UnaryExpr = null;

                /**
                 * Expr BinaryExpr.
                 * @member {priority.netitems.nrest.IBinaryExpr|null|undefined} BinaryExpr
                 * @memberof priority.netitems.nrest.Expr
                 * @instance
                 */
                Expr.prototype.BinaryExpr = null;

                /**
                 * Expr IfElseExpr.
                 * @member {priority.netitems.nrest.IIfElseExpr|null|undefined} IfElseExpr
                 * @memberof priority.netitems.nrest.Expr
                 * @instance
                 */
                Expr.prototype.IfElseExpr = null;

                /**
                 * Expr col.
                 * @member {priority.netitems.nrest.IColumn|null|undefined} col
                 * @memberof priority.netitems.nrest.Expr
                 * @instance
                 */
                Expr.prototype.col = null;

                /**
                 * Expr Constant.
                 * @member {string|null|undefined} Constant
                 * @memberof priority.netitems.nrest.Expr
                 * @instance
                 */
                Expr.prototype.Constant = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Expr inner.
                 * @member {"UnaryExpr"|"BinaryExpr"|"IfElseExpr"|"col"|"Constant"|undefined} inner
                 * @memberof priority.netitems.nrest.Expr
                 * @instance
                 */
                Object.defineProperty(Expr.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["UnaryExpr", "BinaryExpr", "IfElseExpr", "col", "Constant"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Expr instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Expr
                 * @static
                 * @param {priority.netitems.nrest.IExpr=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Expr} Expr instance
                 */
                Expr.create = function create(properties) {
                    return new Expr(properties);
                };

                /**
                 * Encodes the specified Expr message. Does not implicitly {@link priority.netitems.nrest.Expr.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Expr
                 * @static
                 * @param {priority.netitems.nrest.IExpr} message Expr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Expr.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.UnaryExpr != null && Object.hasOwnProperty.call(message, "UnaryExpr"))
                        $root.priority.netitems.nrest.UnaryExpr.encode(message.UnaryExpr, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.BinaryExpr != null && Object.hasOwnProperty.call(message, "BinaryExpr"))
                        $root.priority.netitems.nrest.BinaryExpr.encode(message.BinaryExpr, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.IfElseExpr != null && Object.hasOwnProperty.call(message, "IfElseExpr"))
                        $root.priority.netitems.nrest.IfElseExpr.encode(message.IfElseExpr, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.col != null && Object.hasOwnProperty.call(message, "col"))
                        $root.priority.netitems.nrest.Column.encode(message.col, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.Constant != null && Object.hasOwnProperty.call(message, "Constant"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.Constant);
                    return writer;
                };

                /**
                 * Encodes the specified Expr message, length delimited. Does not implicitly {@link priority.netitems.nrest.Expr.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Expr
                 * @static
                 * @param {priority.netitems.nrest.IExpr} message Expr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Expr.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Expr message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Expr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Expr} Expr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Expr.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Expr();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.UnaryExpr = $root.priority.netitems.nrest.UnaryExpr.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.BinaryExpr = $root.priority.netitems.nrest.BinaryExpr.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.IfElseExpr = $root.priority.netitems.nrest.IfElseExpr.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.col = $root.priority.netitems.nrest.Column.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.Constant = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Expr message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Expr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Expr} Expr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Expr.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Expr message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Expr
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Expr.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.UnaryExpr != null && message.hasOwnProperty("UnaryExpr")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.UnaryExpr.verify(message.UnaryExpr);
                            if (error)
                                return "UnaryExpr." + error;
                        }
                    }
                    if (message.BinaryExpr != null && message.hasOwnProperty("BinaryExpr")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.BinaryExpr.verify(message.BinaryExpr);
                            if (error)
                                return "BinaryExpr." + error;
                        }
                    }
                    if (message.IfElseExpr != null && message.hasOwnProperty("IfElseExpr")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.IfElseExpr.verify(message.IfElseExpr);
                            if (error)
                                return "IfElseExpr." + error;
                        }
                    }
                    if (message.col != null && message.hasOwnProperty("col")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.Column.verify(message.col);
                            if (error)
                                return "col." + error;
                        }
                    }
                    if (message.Constant != null && message.hasOwnProperty("Constant")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        if (!$util.isString(message.Constant))
                            return "Constant: string expected";
                    }
                    return null;
                };

                /**
                 * Creates an Expr message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Expr
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Expr} Expr
                 */
                Expr.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Expr)
                        return object;
                    var message = new $root.priority.netitems.nrest.Expr();
                    if (object.UnaryExpr != null) {
                        if (typeof object.UnaryExpr !== "object")
                            throw TypeError(".priority.netitems.nrest.Expr.UnaryExpr: object expected");
                        message.UnaryExpr = $root.priority.netitems.nrest.UnaryExpr.fromObject(object.UnaryExpr);
                    }
                    if (object.BinaryExpr != null) {
                        if (typeof object.BinaryExpr !== "object")
                            throw TypeError(".priority.netitems.nrest.Expr.BinaryExpr: object expected");
                        message.BinaryExpr = $root.priority.netitems.nrest.BinaryExpr.fromObject(object.BinaryExpr);
                    }
                    if (object.IfElseExpr != null) {
                        if (typeof object.IfElseExpr !== "object")
                            throw TypeError(".priority.netitems.nrest.Expr.IfElseExpr: object expected");
                        message.IfElseExpr = $root.priority.netitems.nrest.IfElseExpr.fromObject(object.IfElseExpr);
                    }
                    if (object.col != null) {
                        if (typeof object.col !== "object")
                            throw TypeError(".priority.netitems.nrest.Expr.col: object expected");
                        message.col = $root.priority.netitems.nrest.Column.fromObject(object.col);
                    }
                    if (object.Constant != null)
                        message.Constant = String(object.Constant);
                    return message;
                };

                /**
                 * Creates a plain object from an Expr message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Expr
                 * @static
                 * @param {priority.netitems.nrest.Expr} message Expr
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Expr.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.UnaryExpr != null && message.hasOwnProperty("UnaryExpr")) {
                        object.UnaryExpr = $root.priority.netitems.nrest.UnaryExpr.toObject(message.UnaryExpr, options);
                        if (options.oneofs)
                            object.inner = "UnaryExpr";
                    }
                    if (message.BinaryExpr != null && message.hasOwnProperty("BinaryExpr")) {
                        object.BinaryExpr = $root.priority.netitems.nrest.BinaryExpr.toObject(message.BinaryExpr, options);
                        if (options.oneofs)
                            object.inner = "BinaryExpr";
                    }
                    if (message.IfElseExpr != null && message.hasOwnProperty("IfElseExpr")) {
                        object.IfElseExpr = $root.priority.netitems.nrest.IfElseExpr.toObject(message.IfElseExpr, options);
                        if (options.oneofs)
                            object.inner = "IfElseExpr";
                    }
                    if (message.col != null && message.hasOwnProperty("col")) {
                        object.col = $root.priority.netitems.nrest.Column.toObject(message.col, options);
                        if (options.oneofs)
                            object.inner = "col";
                    }
                    if (message.Constant != null && message.hasOwnProperty("Constant")) {
                        object.Constant = message.Constant;
                        if (options.oneofs)
                            object.inner = "Constant";
                    }
                    return object;
                };

                /**
                 * Converts this Expr to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Expr
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Expr.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Expr;
            })();

            nrest.UnaryExpr = (function() {

                /**
                 * Properties of an UnaryExpr.
                 * @memberof priority.netitems.nrest
                 * @interface IUnaryExpr
                 * @property {priority.netitems.nrest.UnaryOp|null} [Operaotr] UnaryExpr Operaotr
                 * @property {priority.netitems.nrest.UnaryFunc|null} [UnaryFunc] UnaryExpr UnaryFunc
                 * @property {priority.netitems.nrest.IExpr|null} [Expr] UnaryExpr Expr
                 */

                /**
                 * Constructs a new UnaryExpr.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents an UnaryExpr.
                 * @implements IUnaryExpr
                 * @constructor
                 * @param {priority.netitems.nrest.IUnaryExpr=} [properties] Properties to set
                 */
                function UnaryExpr(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UnaryExpr Operaotr.
                 * @member {priority.netitems.nrest.UnaryOp|null|undefined} Operaotr
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @instance
                 */
                UnaryExpr.prototype.Operaotr = null;

                /**
                 * UnaryExpr UnaryFunc.
                 * @member {priority.netitems.nrest.UnaryFunc|null|undefined} UnaryFunc
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @instance
                 */
                UnaryExpr.prototype.UnaryFunc = null;

                /**
                 * UnaryExpr Expr.
                 * @member {priority.netitems.nrest.IExpr|null|undefined} Expr
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @instance
                 */
                UnaryExpr.prototype.Expr = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * UnaryExpr op.
                 * @member {"Operaotr"|"UnaryFunc"|undefined} op
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @instance
                 */
                Object.defineProperty(UnaryExpr.prototype, "op", {
                    get: $util.oneOfGetter($oneOfFields = ["Operaotr", "UnaryFunc"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new UnaryExpr instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @static
                 * @param {priority.netitems.nrest.IUnaryExpr=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.UnaryExpr} UnaryExpr instance
                 */
                UnaryExpr.create = function create(properties) {
                    return new UnaryExpr(properties);
                };

                /**
                 * Encodes the specified UnaryExpr message. Does not implicitly {@link priority.netitems.nrest.UnaryExpr.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @static
                 * @param {priority.netitems.nrest.IUnaryExpr} message UnaryExpr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UnaryExpr.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Operaotr != null && Object.hasOwnProperty.call(message, "Operaotr"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Operaotr);
                    if (message.UnaryFunc != null && Object.hasOwnProperty.call(message, "UnaryFunc"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.UnaryFunc);
                    if (message.Expr != null && Object.hasOwnProperty.call(message, "Expr"))
                        $root.priority.netitems.nrest.Expr.encode(message.Expr, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UnaryExpr message, length delimited. Does not implicitly {@link priority.netitems.nrest.UnaryExpr.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @static
                 * @param {priority.netitems.nrest.IUnaryExpr} message UnaryExpr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UnaryExpr.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UnaryExpr message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.UnaryExpr} UnaryExpr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UnaryExpr.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.UnaryExpr();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Operaotr = reader.int32();
                            break;
                        case 2:
                            message.UnaryFunc = reader.int32();
                            break;
                        case 3:
                            message.Expr = $root.priority.netitems.nrest.Expr.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UnaryExpr message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.UnaryExpr} UnaryExpr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UnaryExpr.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UnaryExpr message.
                 * @function verify
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UnaryExpr.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Operaotr != null && message.hasOwnProperty("Operaotr")) {
                        properties.op = 1;
                        switch (message.Operaotr) {
                        default:
                            return "Operaotr: enum value expected";
                        case 0:
                            break;
                        }
                    }
                    if (message.UnaryFunc != null && message.hasOwnProperty("UnaryFunc")) {
                        if (properties.op === 1)
                            return "op: multiple values";
                        properties.op = 1;
                        switch (message.UnaryFunc) {
                        default:
                            return "UnaryFunc: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    }
                    if (message.Expr != null && message.hasOwnProperty("Expr")) {
                        var error = $root.priority.netitems.nrest.Expr.verify(message.Expr);
                        if (error)
                            return "Expr." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UnaryExpr message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.UnaryExpr} UnaryExpr
                 */
                UnaryExpr.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.UnaryExpr)
                        return object;
                    var message = new $root.priority.netitems.nrest.UnaryExpr();
                    switch (object.Operaotr) {
                    case "UnaryOp_Minus":
                    case 0:
                        message.Operaotr = 0;
                        break;
                    }
                    switch (object.UnaryFunc) {
                    case "UnaryFunc_ToUpper":
                    case 0:
                        message.UnaryFunc = 0;
                        break;
                    case "UnaryFunc_ToLower":
                    case 1:
                        message.UnaryFunc = 1;
                        break;
                    case "UnaryFunc_Round":
                    case 2:
                        message.UnaryFunc = 2;
                        break;
                    case "UnaryFunc_Max":
                    case 3:
                        message.UnaryFunc = 3;
                        break;
                    case "UnaryFunc_Count":
                    case 4:
                        message.UnaryFunc = 4;
                        break;
                    case "UnaryFunc_Sum":
                    case 5:
                        message.UnaryFunc = 5;
                        break;
                    case "UnaryFunc_Average":
                    case 6:
                        message.UnaryFunc = 6;
                        break;
                    case "UnaryFunc_Min":
                    case 7:
                        message.UnaryFunc = 7;
                        break;
                    case "UnaryFunc_CountDistinct":
                    case 8:
                        message.UnaryFunc = 8;
                        break;
                    }
                    if (object.Expr != null) {
                        if (typeof object.Expr !== "object")
                            throw TypeError(".priority.netitems.nrest.UnaryExpr.Expr: object expected");
                        message.Expr = $root.priority.netitems.nrest.Expr.fromObject(object.Expr);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UnaryExpr message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @static
                 * @param {priority.netitems.nrest.UnaryExpr} message UnaryExpr
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UnaryExpr.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Expr = null;
                    if (message.Operaotr != null && message.hasOwnProperty("Operaotr")) {
                        object.Operaotr = options.enums === String ? $root.priority.netitems.nrest.UnaryOp[message.Operaotr] : message.Operaotr;
                        if (options.oneofs)
                            object.op = "Operaotr";
                    }
                    if (message.UnaryFunc != null && message.hasOwnProperty("UnaryFunc")) {
                        object.UnaryFunc = options.enums === String ? $root.priority.netitems.nrest.UnaryFunc[message.UnaryFunc] : message.UnaryFunc;
                        if (options.oneofs)
                            object.op = "UnaryFunc";
                    }
                    if (message.Expr != null && message.hasOwnProperty("Expr"))
                        object.Expr = $root.priority.netitems.nrest.Expr.toObject(message.Expr, options);
                    return object;
                };

                /**
                 * Converts this UnaryExpr to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.UnaryExpr
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UnaryExpr.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UnaryExpr;
            })();

            nrest.BinaryExpr = (function() {

                /**
                 * Properties of a BinaryExpr.
                 * @memberof priority.netitems.nrest
                 * @interface IBinaryExpr
                 * @property {priority.netitems.nrest.IExpr|null} [Left] BinaryExpr Left
                 * @property {priority.netitems.nrest.BinaryOp|null} [Operaotr] BinaryExpr Operaotr
                 * @property {priority.netitems.nrest.BinaryFunc|null} [BinaryFunc] BinaryExpr BinaryFunc
                 * @property {priority.netitems.nrest.IExpr|null} [Right] BinaryExpr Right
                 */

                /**
                 * Constructs a new BinaryExpr.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a BinaryExpr.
                 * @implements IBinaryExpr
                 * @constructor
                 * @param {priority.netitems.nrest.IBinaryExpr=} [properties] Properties to set
                 */
                function BinaryExpr(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * BinaryExpr Left.
                 * @member {priority.netitems.nrest.IExpr|null|undefined} Left
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @instance
                 */
                BinaryExpr.prototype.Left = null;

                /**
                 * BinaryExpr Operaotr.
                 * @member {priority.netitems.nrest.BinaryOp|null|undefined} Operaotr
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @instance
                 */
                BinaryExpr.prototype.Operaotr = null;

                /**
                 * BinaryExpr BinaryFunc.
                 * @member {priority.netitems.nrest.BinaryFunc|null|undefined} BinaryFunc
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @instance
                 */
                BinaryExpr.prototype.BinaryFunc = null;

                /**
                 * BinaryExpr Right.
                 * @member {priority.netitems.nrest.IExpr|null|undefined} Right
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @instance
                 */
                BinaryExpr.prototype.Right = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * BinaryExpr op.
                 * @member {"Operaotr"|"BinaryFunc"|undefined} op
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @instance
                 */
                Object.defineProperty(BinaryExpr.prototype, "op", {
                    get: $util.oneOfGetter($oneOfFields = ["Operaotr", "BinaryFunc"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new BinaryExpr instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @static
                 * @param {priority.netitems.nrest.IBinaryExpr=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.BinaryExpr} BinaryExpr instance
                 */
                BinaryExpr.create = function create(properties) {
                    return new BinaryExpr(properties);
                };

                /**
                 * Encodes the specified BinaryExpr message. Does not implicitly {@link priority.netitems.nrest.BinaryExpr.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @static
                 * @param {priority.netitems.nrest.IBinaryExpr} message BinaryExpr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BinaryExpr.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Left != null && Object.hasOwnProperty.call(message, "Left"))
                        $root.priority.netitems.nrest.Expr.encode(message.Left, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Operaotr != null && Object.hasOwnProperty.call(message, "Operaotr"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Operaotr);
                    if (message.BinaryFunc != null && Object.hasOwnProperty.call(message, "BinaryFunc"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.BinaryFunc);
                    if (message.Right != null && Object.hasOwnProperty.call(message, "Right"))
                        $root.priority.netitems.nrest.Expr.encode(message.Right, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified BinaryExpr message, length delimited. Does not implicitly {@link priority.netitems.nrest.BinaryExpr.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @static
                 * @param {priority.netitems.nrest.IBinaryExpr} message BinaryExpr message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BinaryExpr.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a BinaryExpr message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.BinaryExpr} BinaryExpr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BinaryExpr.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.BinaryExpr();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Left = $root.priority.netitems.nrest.Expr.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Operaotr = reader.int32();
                            break;
                        case 3:
                            message.BinaryFunc = reader.int32();
                            break;
                        case 4:
                            message.Right = $root.priority.netitems.nrest.Expr.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a BinaryExpr message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.BinaryExpr} BinaryExpr
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BinaryExpr.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a BinaryExpr message.
                 * @function verify
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BinaryExpr.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Left != null && message.hasOwnProperty("Left")) {
                        var error = $root.priority.netitems.nrest.Expr.verify(message.Left);
                        if (error)
                            return "Left." + error;
                    }
                    if (message.Operaotr != null && message.hasOwnProperty("Operaotr")) {
                        properties.op = 1;
                        switch (message.Operaotr) {
                        default:
                            return "Operaotr: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    }
                    if (message.BinaryFunc != null && message.hasOwnProperty("BinaryFunc")) {
                        if (properties.op === 1)
                            return "op: multiple values";
                        properties.op = 1;
                        switch (message.BinaryFunc) {
                        default:
                            return "BinaryFunc: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    }
                    if (message.Right != null && message.hasOwnProperty("Right")) {
                        var error = $root.priority.netitems.nrest.Expr.verify(message.Right);
                        if (error)
                            return "Right." + error;
                    }
                    return null;
                };

                /**
                 * Creates a BinaryExpr message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.BinaryExpr} BinaryExpr
                 */
                BinaryExpr.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.BinaryExpr)
                        return object;
                    var message = new $root.priority.netitems.nrest.BinaryExpr();
                    if (object.Left != null) {
                        if (typeof object.Left !== "object")
                            throw TypeError(".priority.netitems.nrest.BinaryExpr.Left: object expected");
                        message.Left = $root.priority.netitems.nrest.Expr.fromObject(object.Left);
                    }
                    switch (object.Operaotr) {
                    case "BinaryOp_Minus":
                    case 0:
                        message.Operaotr = 0;
                        break;
                    case "BinaryOp_Plus":
                    case 1:
                        message.Operaotr = 1;
                        break;
                    case "BinaryOp_Mult":
                    case 2:
                        message.Operaotr = 2;
                        break;
                    case "BinaryOp_Div":
                    case 3:
                        message.Operaotr = 3;
                        break;
                    }
                    switch (object.BinaryFunc) {
                    case "BinaryFunc_Strcat":
                    case 0:
                        message.BinaryFunc = 0;
                        break;
                    case "BinaryFunc_Power":
                    case 1:
                        message.BinaryFunc = 1;
                        break;
                    }
                    if (object.Right != null) {
                        if (typeof object.Right !== "object")
                            throw TypeError(".priority.netitems.nrest.BinaryExpr.Right: object expected");
                        message.Right = $root.priority.netitems.nrest.Expr.fromObject(object.Right);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a BinaryExpr message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @static
                 * @param {priority.netitems.nrest.BinaryExpr} message BinaryExpr
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BinaryExpr.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Left = null;
                        object.Right = null;
                    }
                    if (message.Left != null && message.hasOwnProperty("Left"))
                        object.Left = $root.priority.netitems.nrest.Expr.toObject(message.Left, options);
                    if (message.Operaotr != null && message.hasOwnProperty("Operaotr")) {
                        object.Operaotr = options.enums === String ? $root.priority.netitems.nrest.BinaryOp[message.Operaotr] : message.Operaotr;
                        if (options.oneofs)
                            object.op = "Operaotr";
                    }
                    if (message.BinaryFunc != null && message.hasOwnProperty("BinaryFunc")) {
                        object.BinaryFunc = options.enums === String ? $root.priority.netitems.nrest.BinaryFunc[message.BinaryFunc] : message.BinaryFunc;
                        if (options.oneofs)
                            object.op = "BinaryFunc";
                    }
                    if (message.Right != null && message.hasOwnProperty("Right"))
                        object.Right = $root.priority.netitems.nrest.Expr.toObject(message.Right, options);
                    return object;
                };

                /**
                 * Converts this BinaryExpr to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.BinaryExpr
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BinaryExpr.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return BinaryExpr;
            })();

            /**
             * UnaryFunc enum.
             * @name priority.netitems.nrest.UnaryFunc
             * @enum {number}
             * @property {number} UnaryFunc_ToUpper=0 UnaryFunc_ToUpper value
             * @property {number} UnaryFunc_ToLower=1 UnaryFunc_ToLower value
             * @property {number} UnaryFunc_Round=2 UnaryFunc_Round value
             * @property {number} UnaryFunc_Max=3 UnaryFunc_Max value
             * @property {number} UnaryFunc_Count=4 UnaryFunc_Count value
             * @property {number} UnaryFunc_Sum=5 UnaryFunc_Sum value
             * @property {number} UnaryFunc_Average=6 UnaryFunc_Average value
             * @property {number} UnaryFunc_Min=7 UnaryFunc_Min value
             * @property {number} UnaryFunc_CountDistinct=8 UnaryFunc_CountDistinct value
             */
            nrest.UnaryFunc = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UnaryFunc_ToUpper"] = 0;
                values[valuesById[1] = "UnaryFunc_ToLower"] = 1;
                values[valuesById[2] = "UnaryFunc_Round"] = 2;
                values[valuesById[3] = "UnaryFunc_Max"] = 3;
                values[valuesById[4] = "UnaryFunc_Count"] = 4;
                values[valuesById[5] = "UnaryFunc_Sum"] = 5;
                values[valuesById[6] = "UnaryFunc_Average"] = 6;
                values[valuesById[7] = "UnaryFunc_Min"] = 7;
                values[valuesById[8] = "UnaryFunc_CountDistinct"] = 8;
                return values;
            })();

            /**
             * BinaryFunc enum.
             * @name priority.netitems.nrest.BinaryFunc
             * @enum {number}
             * @property {number} BinaryFunc_Strcat=0 BinaryFunc_Strcat value
             * @property {number} BinaryFunc_Power=1 BinaryFunc_Power value
             */
            nrest.BinaryFunc = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "BinaryFunc_Strcat"] = 0;
                values[valuesById[1] = "BinaryFunc_Power"] = 1;
                return values;
            })();

            nrest.SqlTable = (function() {

                /**
                 * Properties of a SqlTable.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlTable
                 * @property {string|null} [TableName] SqlTable TableName
                 * @property {string|null} [Remarks] SqlTable Remarks
                 */

                /**
                 * Constructs a new SqlTable.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlTable.
                 * @implements ISqlTable
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlTable=} [properties] Properties to set
                 */
                function SqlTable(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlTable TableName.
                 * @member {string} TableName
                 * @memberof priority.netitems.nrest.SqlTable
                 * @instance
                 */
                SqlTable.prototype.TableName = "";

                /**
                 * SqlTable Remarks.
                 * @member {string} Remarks
                 * @memberof priority.netitems.nrest.SqlTable
                 * @instance
                 */
                SqlTable.prototype.Remarks = "";

                /**
                 * Creates a new SqlTable instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlTable
                 * @static
                 * @param {priority.netitems.nrest.ISqlTable=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlTable} SqlTable instance
                 */
                SqlTable.create = function create(properties) {
                    return new SqlTable(properties);
                };

                /**
                 * Encodes the specified SqlTable message. Does not implicitly {@link priority.netitems.nrest.SqlTable.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlTable
                 * @static
                 * @param {priority.netitems.nrest.ISqlTable} message SqlTable message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlTable.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.TableName != null && Object.hasOwnProperty.call(message, "TableName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.TableName);
                    if (message.Remarks != null && Object.hasOwnProperty.call(message, "Remarks"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Remarks);
                    return writer;
                };

                /**
                 * Encodes the specified SqlTable message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlTable.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlTable
                 * @static
                 * @param {priority.netitems.nrest.ISqlTable} message SqlTable message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlTable.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlTable message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlTable
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlTable} SqlTable
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlTable.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlTable();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.TableName = reader.string();
                            break;
                        case 2:
                            message.Remarks = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlTable message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlTable
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlTable} SqlTable
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlTable.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlTable message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlTable
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlTable.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.TableName != null && message.hasOwnProperty("TableName"))
                        if (!$util.isString(message.TableName))
                            return "TableName: string expected";
                    if (message.Remarks != null && message.hasOwnProperty("Remarks"))
                        if (!$util.isString(message.Remarks))
                            return "Remarks: string expected";
                    return null;
                };

                /**
                 * Creates a SqlTable message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlTable
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlTable} SqlTable
                 */
                SqlTable.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlTable)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlTable();
                    if (object.TableName != null)
                        message.TableName = String(object.TableName);
                    if (object.Remarks != null)
                        message.Remarks = String(object.Remarks);
                    return message;
                };

                /**
                 * Creates a plain object from a SqlTable message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlTable
                 * @static
                 * @param {priority.netitems.nrest.SqlTable} message SqlTable
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlTable.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.TableName = "";
                        object.Remarks = "";
                    }
                    if (message.TableName != null && message.hasOwnProperty("TableName"))
                        object.TableName = message.TableName;
                    if (message.Remarks != null && message.hasOwnProperty("Remarks"))
                        object.Remarks = message.Remarks;
                    return object;
                };

                /**
                 * Converts this SqlTable to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlTable
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlTable.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlTable;
            })();

            nrest.SqlTablesRq = (function() {

                /**
                 * Properties of a SqlTablesRq.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlTablesRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SqlTablesRq Properties
                 * @property {string|null} [TableSearchPattern] SqlTablesRq TableSearchPattern
                 */

                /**
                 * Constructs a new SqlTablesRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlTablesRq.
                 * @implements ISqlTablesRq
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlTablesRq=} [properties] Properties to set
                 */
                function SqlTablesRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlTablesRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @instance
                 */
                SqlTablesRq.prototype.Properties = null;

                /**
                 * SqlTablesRq TableSearchPattern.
                 * @member {string} TableSearchPattern
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @instance
                 */
                SqlTablesRq.prototype.TableSearchPattern = "";

                /**
                 * Creates a new SqlTablesRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlTablesRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlTablesRq} SqlTablesRq instance
                 */
                SqlTablesRq.create = function create(properties) {
                    return new SqlTablesRq(properties);
                };

                /**
                 * Encodes the specified SqlTablesRq message. Does not implicitly {@link priority.netitems.nrest.SqlTablesRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlTablesRq} message SqlTablesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlTablesRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.TableSearchPattern != null && Object.hasOwnProperty.call(message, "TableSearchPattern"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.TableSearchPattern);
                    return writer;
                };

                /**
                 * Encodes the specified SqlTablesRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlTablesRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlTablesRq} message SqlTablesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlTablesRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlTablesRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlTablesRq} SqlTablesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlTablesRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlTablesRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.TableSearchPattern = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlTablesRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlTablesRq} SqlTablesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlTablesRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlTablesRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlTablesRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.TableSearchPattern != null && message.hasOwnProperty("TableSearchPattern"))
                        if (!$util.isString(message.TableSearchPattern))
                            return "TableSearchPattern: string expected";
                    return null;
                };

                /**
                 * Creates a SqlTablesRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlTablesRq} SqlTablesRq
                 */
                SqlTablesRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlTablesRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlTablesRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.SqlTablesRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.TableSearchPattern != null)
                        message.TableSearchPattern = String(object.TableSearchPattern);
                    return message;
                };

                /**
                 * Creates a plain object from a SqlTablesRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @static
                 * @param {priority.netitems.nrest.SqlTablesRq} message SqlTablesRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlTablesRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.TableSearchPattern = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.TableSearchPattern != null && message.hasOwnProperty("TableSearchPattern"))
                        object.TableSearchPattern = message.TableSearchPattern;
                    return object;
                };

                /**
                 * Converts this SqlTablesRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlTablesRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlTablesRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlTablesRq;
            })();

            nrest.SqlTablesRs = (function() {

                /**
                 * Properties of a SqlTablesRs.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlTablesRs
                 * @property {Array.<priority.netitems.nrest.ISqlTable>|null} [SqlTable] SqlTablesRs SqlTable
                 */

                /**
                 * Constructs a new SqlTablesRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlTablesRs.
                 * @implements ISqlTablesRs
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlTablesRs=} [properties] Properties to set
                 */
                function SqlTablesRs(properties) {
                    this.SqlTable = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlTablesRs SqlTable.
                 * @member {Array.<priority.netitems.nrest.ISqlTable>} SqlTable
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @instance
                 */
                SqlTablesRs.prototype.SqlTable = $util.emptyArray;

                /**
                 * Creates a new SqlTablesRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlTablesRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlTablesRs} SqlTablesRs instance
                 */
                SqlTablesRs.create = function create(properties) {
                    return new SqlTablesRs(properties);
                };

                /**
                 * Encodes the specified SqlTablesRs message. Does not implicitly {@link priority.netitems.nrest.SqlTablesRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlTablesRs} message SqlTablesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlTablesRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.SqlTable != null && message.SqlTable.length)
                        for (var i = 0; i < message.SqlTable.length; ++i)
                            $root.priority.netitems.nrest.SqlTable.encode(message.SqlTable[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SqlTablesRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlTablesRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlTablesRs} message SqlTablesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlTablesRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlTablesRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlTablesRs} SqlTablesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlTablesRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlTablesRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.SqlTable && message.SqlTable.length))
                                message.SqlTable = [];
                            message.SqlTable.push($root.priority.netitems.nrest.SqlTable.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlTablesRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlTablesRs} SqlTablesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlTablesRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlTablesRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlTablesRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.SqlTable != null && message.hasOwnProperty("SqlTable")) {
                        if (!Array.isArray(message.SqlTable))
                            return "SqlTable: array expected";
                        for (var i = 0; i < message.SqlTable.length; ++i) {
                            var error = $root.priority.netitems.nrest.SqlTable.verify(message.SqlTable[i]);
                            if (error)
                                return "SqlTable." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SqlTablesRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlTablesRs} SqlTablesRs
                 */
                SqlTablesRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlTablesRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlTablesRs();
                    if (object.SqlTable) {
                        if (!Array.isArray(object.SqlTable))
                            throw TypeError(".priority.netitems.nrest.SqlTablesRs.SqlTable: array expected");
                        message.SqlTable = [];
                        for (var i = 0; i < object.SqlTable.length; ++i) {
                            if (typeof object.SqlTable[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.SqlTablesRs.SqlTable: object expected");
                            message.SqlTable[i] = $root.priority.netitems.nrest.SqlTable.fromObject(object.SqlTable[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SqlTablesRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @static
                 * @param {priority.netitems.nrest.SqlTablesRs} message SqlTablesRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlTablesRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.SqlTable = [];
                    if (message.SqlTable && message.SqlTable.length) {
                        object.SqlTable = [];
                        for (var j = 0; j < message.SqlTable.length; ++j)
                            object.SqlTable[j] = $root.priority.netitems.nrest.SqlTable.toObject(message.SqlTable[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SqlTablesRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlTablesRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlTablesRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlTablesRs;
            })();

            nrest.SqlColumnsRq = (function() {

                /**
                 * Properties of a SqlColumnsRq.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlColumnsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SqlColumnsRq Properties
                 * @property {string|null} [TableSearchPattern] SqlColumnsRq TableSearchPattern
                 * @property {string|null} [ColumnSearchPattern] SqlColumnsRq ColumnSearchPattern
                 */

                /**
                 * Constructs a new SqlColumnsRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlColumnsRq.
                 * @implements ISqlColumnsRq
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlColumnsRq=} [properties] Properties to set
                 */
                function SqlColumnsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlColumnsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @instance
                 */
                SqlColumnsRq.prototype.Properties = null;

                /**
                 * SqlColumnsRq TableSearchPattern.
                 * @member {string} TableSearchPattern
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @instance
                 */
                SqlColumnsRq.prototype.TableSearchPattern = "";

                /**
                 * SqlColumnsRq ColumnSearchPattern.
                 * @member {string} ColumnSearchPattern
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @instance
                 */
                SqlColumnsRq.prototype.ColumnSearchPattern = "";

                /**
                 * Creates a new SqlColumnsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumnsRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlColumnsRq} SqlColumnsRq instance
                 */
                SqlColumnsRq.create = function create(properties) {
                    return new SqlColumnsRq(properties);
                };

                /**
                 * Encodes the specified SqlColumnsRq message. Does not implicitly {@link priority.netitems.nrest.SqlColumnsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumnsRq} message SqlColumnsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlColumnsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.TableSearchPattern != null && Object.hasOwnProperty.call(message, "TableSearchPattern"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.TableSearchPattern);
                    if (message.ColumnSearchPattern != null && Object.hasOwnProperty.call(message, "ColumnSearchPattern"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.ColumnSearchPattern);
                    return writer;
                };

                /**
                 * Encodes the specified SqlColumnsRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlColumnsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumnsRq} message SqlColumnsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlColumnsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlColumnsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlColumnsRq} SqlColumnsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlColumnsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlColumnsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.TableSearchPattern = reader.string();
                            break;
                        case 3:
                            message.ColumnSearchPattern = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlColumnsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlColumnsRq} SqlColumnsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlColumnsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlColumnsRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlColumnsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.TableSearchPattern != null && message.hasOwnProperty("TableSearchPattern"))
                        if (!$util.isString(message.TableSearchPattern))
                            return "TableSearchPattern: string expected";
                    if (message.ColumnSearchPattern != null && message.hasOwnProperty("ColumnSearchPattern"))
                        if (!$util.isString(message.ColumnSearchPattern))
                            return "ColumnSearchPattern: string expected";
                    return null;
                };

                /**
                 * Creates a SqlColumnsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlColumnsRq} SqlColumnsRq
                 */
                SqlColumnsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlColumnsRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlColumnsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.SqlColumnsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.TableSearchPattern != null)
                        message.TableSearchPattern = String(object.TableSearchPattern);
                    if (object.ColumnSearchPattern != null)
                        message.ColumnSearchPattern = String(object.ColumnSearchPattern);
                    return message;
                };

                /**
                 * Creates a plain object from a SqlColumnsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @static
                 * @param {priority.netitems.nrest.SqlColumnsRq} message SqlColumnsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlColumnsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.TableSearchPattern = "";
                        object.ColumnSearchPattern = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.TableSearchPattern != null && message.hasOwnProperty("TableSearchPattern"))
                        object.TableSearchPattern = message.TableSearchPattern;
                    if (message.ColumnSearchPattern != null && message.hasOwnProperty("ColumnSearchPattern"))
                        object.ColumnSearchPattern = message.ColumnSearchPattern;
                    return object;
                };

                /**
                 * Converts this SqlColumnsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlColumnsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlColumnsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlColumnsRq;
            })();

            nrest.SqlColumnsRs = (function() {

                /**
                 * Properties of a SqlColumnsRs.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlColumnsRs
                 * @property {Array.<priority.netitems.nrest.ISqlColumn>|null} [Column] SqlColumnsRs Column
                 */

                /**
                 * Constructs a new SqlColumnsRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlColumnsRs.
                 * @implements ISqlColumnsRs
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlColumnsRs=} [properties] Properties to set
                 */
                function SqlColumnsRs(properties) {
                    this.Column = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlColumnsRs Column.
                 * @member {Array.<priority.netitems.nrest.ISqlColumn>} Column
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @instance
                 */
                SqlColumnsRs.prototype.Column = $util.emptyArray;

                /**
                 * Creates a new SqlColumnsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumnsRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlColumnsRs} SqlColumnsRs instance
                 */
                SqlColumnsRs.create = function create(properties) {
                    return new SqlColumnsRs(properties);
                };

                /**
                 * Encodes the specified SqlColumnsRs message. Does not implicitly {@link priority.netitems.nrest.SqlColumnsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumnsRs} message SqlColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlColumnsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Column != null && message.Column.length)
                        for (var i = 0; i < message.Column.length; ++i)
                            $root.priority.netitems.nrest.SqlColumn.encode(message.Column[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SqlColumnsRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlColumnsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumnsRs} message SqlColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlColumnsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlColumnsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlColumnsRs} SqlColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlColumnsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlColumnsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Column && message.Column.length))
                                message.Column = [];
                            message.Column.push($root.priority.netitems.nrest.SqlColumn.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlColumnsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlColumnsRs} SqlColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlColumnsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlColumnsRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlColumnsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Column != null && message.hasOwnProperty("Column")) {
                        if (!Array.isArray(message.Column))
                            return "Column: array expected";
                        for (var i = 0; i < message.Column.length; ++i) {
                            var error = $root.priority.netitems.nrest.SqlColumn.verify(message.Column[i]);
                            if (error)
                                return "Column." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SqlColumnsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlColumnsRs} SqlColumnsRs
                 */
                SqlColumnsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlColumnsRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlColumnsRs();
                    if (object.Column) {
                        if (!Array.isArray(object.Column))
                            throw TypeError(".priority.netitems.nrest.SqlColumnsRs.Column: array expected");
                        message.Column = [];
                        for (var i = 0; i < object.Column.length; ++i) {
                            if (typeof object.Column[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.SqlColumnsRs.Column: object expected");
                            message.Column[i] = $root.priority.netitems.nrest.SqlColumn.fromObject(object.Column[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SqlColumnsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @static
                 * @param {priority.netitems.nrest.SqlColumnsRs} message SqlColumnsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlColumnsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Column = [];
                    if (message.Column && message.Column.length) {
                        object.Column = [];
                        for (var j = 0; j < message.Column.length; ++j)
                            object.Column[j] = $root.priority.netitems.nrest.SqlColumn.toObject(message.Column[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SqlColumnsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlColumnsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlColumnsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlColumnsRs;
            })();

            nrest.SqlColumn = (function() {

                /**
                 * Properties of a SqlColumn.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlColumn
                 * @property {string|null} [TableName] SqlColumn TableName
                 * @property {string|null} [ColumnName] SqlColumn ColumnName
                 * @property {priority.netitems.nrest.SqlTypes|null} [SqlType] SqlColumn SqlType
                 * @property {string|null} [TypeName] SqlColumn TypeName
                 * @property {number|null} [MaxLength] SqlColumn MaxLength
                 * @property {number|null} [Scale] SqlColumn Scale
                 * @property {string|null} [Remarks] SqlColumn Remarks
                 */

                /**
                 * Constructs a new SqlColumn.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlColumn.
                 * @implements ISqlColumn
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlColumn=} [properties] Properties to set
                 */
                function SqlColumn(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlColumn TableName.
                 * @member {string} TableName
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @instance
                 */
                SqlColumn.prototype.TableName = "";

                /**
                 * SqlColumn ColumnName.
                 * @member {string} ColumnName
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @instance
                 */
                SqlColumn.prototype.ColumnName = "";

                /**
                 * SqlColumn SqlType.
                 * @member {priority.netitems.nrest.SqlTypes} SqlType
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @instance
                 */
                SqlColumn.prototype.SqlType = 0;

                /**
                 * SqlColumn TypeName.
                 * @member {string} TypeName
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @instance
                 */
                SqlColumn.prototype.TypeName = "";

                /**
                 * SqlColumn MaxLength.
                 * @member {number} MaxLength
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @instance
                 */
                SqlColumn.prototype.MaxLength = 0;

                /**
                 * SqlColumn Scale.
                 * @member {number} Scale
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @instance
                 */
                SqlColumn.prototype.Scale = 0;

                /**
                 * SqlColumn Remarks.
                 * @member {string} Remarks
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @instance
                 */
                SqlColumn.prototype.Remarks = "";

                /**
                 * Creates a new SqlColumn instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumn=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlColumn} SqlColumn instance
                 */
                SqlColumn.create = function create(properties) {
                    return new SqlColumn(properties);
                };

                /**
                 * Encodes the specified SqlColumn message. Does not implicitly {@link priority.netitems.nrest.SqlColumn.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumn} message SqlColumn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlColumn.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.TableName != null && Object.hasOwnProperty.call(message, "TableName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.TableName);
                    if (message.ColumnName != null && Object.hasOwnProperty.call(message, "ColumnName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.ColumnName);
                    if (message.SqlType != null && Object.hasOwnProperty.call(message, "SqlType"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SqlType);
                    if (message.TypeName != null && Object.hasOwnProperty.call(message, "TypeName"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.TypeName);
                    if (message.MaxLength != null && Object.hasOwnProperty.call(message, "MaxLength"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.MaxLength);
                    if (message.Scale != null && Object.hasOwnProperty.call(message, "Scale"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.Scale);
                    if (message.Remarks != null && Object.hasOwnProperty.call(message, "Remarks"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.Remarks);
                    return writer;
                };

                /**
                 * Encodes the specified SqlColumn message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlColumn.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @static
                 * @param {priority.netitems.nrest.ISqlColumn} message SqlColumn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlColumn.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlColumn message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlColumn} SqlColumn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlColumn.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlColumn();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            message.TableName = reader.string();
                            break;
                        case 3:
                            message.ColumnName = reader.string();
                            break;
                        case 4:
                            message.SqlType = reader.int32();
                            break;
                        case 5:
                            message.TypeName = reader.string();
                            break;
                        case 6:
                            message.MaxLength = reader.int32();
                            break;
                        case 7:
                            message.Scale = reader.int32();
                            break;
                        case 8:
                            message.Remarks = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlColumn message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlColumn} SqlColumn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlColumn.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlColumn message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlColumn.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.TableName != null && message.hasOwnProperty("TableName"))
                        if (!$util.isString(message.TableName))
                            return "TableName: string expected";
                    if (message.ColumnName != null && message.hasOwnProperty("ColumnName"))
                        if (!$util.isString(message.ColumnName))
                            return "ColumnName: string expected";
                    if (message.SqlType != null && message.hasOwnProperty("SqlType"))
                        switch (message.SqlType) {
                        default:
                            return "SqlType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 9:
                        case 10:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                            break;
                        }
                    if (message.TypeName != null && message.hasOwnProperty("TypeName"))
                        if (!$util.isString(message.TypeName))
                            return "TypeName: string expected";
                    if (message.MaxLength != null && message.hasOwnProperty("MaxLength"))
                        if (!$util.isInteger(message.MaxLength))
                            return "MaxLength: integer expected";
                    if (message.Scale != null && message.hasOwnProperty("Scale"))
                        if (!$util.isInteger(message.Scale))
                            return "Scale: integer expected";
                    if (message.Remarks != null && message.hasOwnProperty("Remarks"))
                        if (!$util.isString(message.Remarks))
                            return "Remarks: string expected";
                    return null;
                };

                /**
                 * Creates a SqlColumn message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlColumn} SqlColumn
                 */
                SqlColumn.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlColumn)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlColumn();
                    if (object.TableName != null)
                        message.TableName = String(object.TableName);
                    if (object.ColumnName != null)
                        message.ColumnName = String(object.ColumnName);
                    switch (object.SqlType) {
                    case "SqlTypes_SQL_UNKNOWN_TYPE":
                    case 0:
                        message.SqlType = 0;
                        break;
                    case "SqlTypes_SQL_CHAR":
                    case 1:
                        message.SqlType = 1;
                        break;
                    case "SqlTypes_SQL_NUMERIC":
                    case 2:
                        message.SqlType = 2;
                        break;
                    case "SqlTypes_SQL_DECIMAL":
                    case 3:
                        message.SqlType = 3;
                        break;
                    case "SqlTypes_SQL_INTEGER":
                    case 4:
                        message.SqlType = 4;
                        break;
                    case "SqlTypes_SQL_SMALLINT":
                    case 5:
                        message.SqlType = 5;
                        break;
                    case "SqlTypes_SQL_FLOAT":
                    case 6:
                        message.SqlType = 6;
                        break;
                    case "SqlTypes_SQL_REAL":
                    case 7:
                        message.SqlType = 7;
                        break;
                    case "SqlTypes_SQL_DOUBLE":
                    case 8:
                        message.SqlType = 8;
                        break;
                    case "SqlTypes_SQL_DATETIME":
                    case 9:
                        message.SqlType = 9;
                        break;
                    case "SqlTypes_SQL_DATE":
                    case 9:
                        message.SqlType = 9;
                        break;
                    case "SqlTypes_SQL_INTERVAL":
                    case 10:
                        message.SqlType = 10;
                        break;
                    case "SqlTypes_SQL_TIME":
                    case 10:
                        message.SqlType = 10;
                        break;
                    case "SqlTypes_SQL_TIMESTAMP":
                    case 11:
                        message.SqlType = 11;
                        break;
                    case "SqlTypes_SQL_VARCHAR":
                    case 12:
                        message.SqlType = 12;
                        break;
                    case "SqlTypes_SQL_BIGINT":
                    case 13:
                        message.SqlType = 13;
                        break;
                    case "SqlTypes_SQL_WCHAR":
                    case 14:
                        message.SqlType = 14;
                        break;
                    case "SqlTypes_SQL_WVARCHAR":
                    case 15:
                        message.SqlType = 15;
                        break;
                    case "SqlTypes_SQL_INTERVAL_MINUTE":
                    case 16:
                        message.SqlType = 16;
                        break;
                    }
                    if (object.TypeName != null)
                        message.TypeName = String(object.TypeName);
                    if (object.MaxLength != null)
                        message.MaxLength = object.MaxLength | 0;
                    if (object.Scale != null)
                        message.Scale = object.Scale | 0;
                    if (object.Remarks != null)
                        message.Remarks = String(object.Remarks);
                    return message;
                };

                /**
                 * Creates a plain object from a SqlColumn message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @static
                 * @param {priority.netitems.nrest.SqlColumn} message SqlColumn
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlColumn.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.TableName = "";
                        object.ColumnName = "";
                        object.SqlType = options.enums === String ? "SqlTypes_SQL_UNKNOWN_TYPE" : 0;
                        object.TypeName = "";
                        object.MaxLength = 0;
                        object.Scale = 0;
                        object.Remarks = "";
                    }
                    if (message.TableName != null && message.hasOwnProperty("TableName"))
                        object.TableName = message.TableName;
                    if (message.ColumnName != null && message.hasOwnProperty("ColumnName"))
                        object.ColumnName = message.ColumnName;
                    if (message.SqlType != null && message.hasOwnProperty("SqlType"))
                        object.SqlType = options.enums === String ? $root.priority.netitems.nrest.SqlTypes[message.SqlType] : message.SqlType;
                    if (message.TypeName != null && message.hasOwnProperty("TypeName"))
                        object.TypeName = message.TypeName;
                    if (message.MaxLength != null && message.hasOwnProperty("MaxLength"))
                        object.MaxLength = message.MaxLength;
                    if (message.Scale != null && message.hasOwnProperty("Scale"))
                        object.Scale = message.Scale;
                    if (message.Remarks != null && message.hasOwnProperty("Remarks"))
                        object.Remarks = message.Remarks;
                    return object;
                };

                /**
                 * Converts this SqlColumn to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlColumn
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlColumn.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlColumn;
            })();

            nrest.SqlPrimaryKeysRq = (function() {

                /**
                 * Properties of a SqlPrimaryKeysRq.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlPrimaryKeysRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SqlPrimaryKeysRq Properties
                 * @property {string|null} [TableName] SqlPrimaryKeysRq TableName
                 */

                /**
                 * Constructs a new SqlPrimaryKeysRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlPrimaryKeysRq.
                 * @implements ISqlPrimaryKeysRq
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRq=} [properties] Properties to set
                 */
                function SqlPrimaryKeysRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlPrimaryKeysRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @instance
                 */
                SqlPrimaryKeysRq.prototype.Properties = null;

                /**
                 * SqlPrimaryKeysRq TableName.
                 * @member {string} TableName
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @instance
                 */
                SqlPrimaryKeysRq.prototype.TableName = "";

                /**
                 * Creates a new SqlPrimaryKeysRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlPrimaryKeysRq} SqlPrimaryKeysRq instance
                 */
                SqlPrimaryKeysRq.create = function create(properties) {
                    return new SqlPrimaryKeysRq(properties);
                };

                /**
                 * Encodes the specified SqlPrimaryKeysRq message. Does not implicitly {@link priority.netitems.nrest.SqlPrimaryKeysRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRq} message SqlPrimaryKeysRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlPrimaryKeysRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.TableName != null && Object.hasOwnProperty.call(message, "TableName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.TableName);
                    return writer;
                };

                /**
                 * Encodes the specified SqlPrimaryKeysRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlPrimaryKeysRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRq} message SqlPrimaryKeysRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlPrimaryKeysRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlPrimaryKeysRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlPrimaryKeysRq} SqlPrimaryKeysRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlPrimaryKeysRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlPrimaryKeysRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.TableName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlPrimaryKeysRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlPrimaryKeysRq} SqlPrimaryKeysRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlPrimaryKeysRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlPrimaryKeysRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlPrimaryKeysRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.TableName != null && message.hasOwnProperty("TableName"))
                        if (!$util.isString(message.TableName))
                            return "TableName: string expected";
                    return null;
                };

                /**
                 * Creates a SqlPrimaryKeysRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlPrimaryKeysRq} SqlPrimaryKeysRq
                 */
                SqlPrimaryKeysRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlPrimaryKeysRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlPrimaryKeysRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.SqlPrimaryKeysRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.TableName != null)
                        message.TableName = String(object.TableName);
                    return message;
                };

                /**
                 * Creates a plain object from a SqlPrimaryKeysRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @static
                 * @param {priority.netitems.nrest.SqlPrimaryKeysRq} message SqlPrimaryKeysRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlPrimaryKeysRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.TableName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.TableName != null && message.hasOwnProperty("TableName"))
                        object.TableName = message.TableName;
                    return object;
                };

                /**
                 * Converts this SqlPrimaryKeysRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlPrimaryKeysRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlPrimaryKeysRq;
            })();

            nrest.SqlPrimaryKeysRs = (function() {

                /**
                 * Properties of a SqlPrimaryKeysRs.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlPrimaryKeysRs
                 * @property {Array.<priority.netitems.nrest.ISqlPrimaryKey>|null} [PrimaryKey] SqlPrimaryKeysRs PrimaryKey
                 */

                /**
                 * Constructs a new SqlPrimaryKeysRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlPrimaryKeysRs.
                 * @implements ISqlPrimaryKeysRs
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRs=} [properties] Properties to set
                 */
                function SqlPrimaryKeysRs(properties) {
                    this.PrimaryKey = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlPrimaryKeysRs PrimaryKey.
                 * @member {Array.<priority.netitems.nrest.ISqlPrimaryKey>} PrimaryKey
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @instance
                 */
                SqlPrimaryKeysRs.prototype.PrimaryKey = $util.emptyArray;

                /**
                 * Creates a new SqlPrimaryKeysRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlPrimaryKeysRs} SqlPrimaryKeysRs instance
                 */
                SqlPrimaryKeysRs.create = function create(properties) {
                    return new SqlPrimaryKeysRs(properties);
                };

                /**
                 * Encodes the specified SqlPrimaryKeysRs message. Does not implicitly {@link priority.netitems.nrest.SqlPrimaryKeysRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRs} message SqlPrimaryKeysRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlPrimaryKeysRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.PrimaryKey != null && message.PrimaryKey.length)
                        for (var i = 0; i < message.PrimaryKey.length; ++i)
                            $root.priority.netitems.nrest.SqlPrimaryKey.encode(message.PrimaryKey[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SqlPrimaryKeysRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlPrimaryKeysRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRs} message SqlPrimaryKeysRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlPrimaryKeysRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlPrimaryKeysRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlPrimaryKeysRs} SqlPrimaryKeysRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlPrimaryKeysRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlPrimaryKeysRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.PrimaryKey && message.PrimaryKey.length))
                                message.PrimaryKey = [];
                            message.PrimaryKey.push($root.priority.netitems.nrest.SqlPrimaryKey.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlPrimaryKeysRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlPrimaryKeysRs} SqlPrimaryKeysRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlPrimaryKeysRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlPrimaryKeysRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlPrimaryKeysRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.PrimaryKey != null && message.hasOwnProperty("PrimaryKey")) {
                        if (!Array.isArray(message.PrimaryKey))
                            return "PrimaryKey: array expected";
                        for (var i = 0; i < message.PrimaryKey.length; ++i) {
                            var error = $root.priority.netitems.nrest.SqlPrimaryKey.verify(message.PrimaryKey[i]);
                            if (error)
                                return "PrimaryKey." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SqlPrimaryKeysRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlPrimaryKeysRs} SqlPrimaryKeysRs
                 */
                SqlPrimaryKeysRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlPrimaryKeysRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlPrimaryKeysRs();
                    if (object.PrimaryKey) {
                        if (!Array.isArray(object.PrimaryKey))
                            throw TypeError(".priority.netitems.nrest.SqlPrimaryKeysRs.PrimaryKey: array expected");
                        message.PrimaryKey = [];
                        for (var i = 0; i < object.PrimaryKey.length; ++i) {
                            if (typeof object.PrimaryKey[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.SqlPrimaryKeysRs.PrimaryKey: object expected");
                            message.PrimaryKey[i] = $root.priority.netitems.nrest.SqlPrimaryKey.fromObject(object.PrimaryKey[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SqlPrimaryKeysRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @static
                 * @param {priority.netitems.nrest.SqlPrimaryKeysRs} message SqlPrimaryKeysRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlPrimaryKeysRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.PrimaryKey = [];
                    if (message.PrimaryKey && message.PrimaryKey.length) {
                        object.PrimaryKey = [];
                        for (var j = 0; j < message.PrimaryKey.length; ++j)
                            object.PrimaryKey[j] = $root.priority.netitems.nrest.SqlPrimaryKey.toObject(message.PrimaryKey[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SqlPrimaryKeysRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlPrimaryKeysRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlPrimaryKeysRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlPrimaryKeysRs;
            })();

            nrest.SqlPrimaryKey = (function() {

                /**
                 * Properties of a SqlPrimaryKey.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlPrimaryKey
                 * @property {string|null} [TableName] SqlPrimaryKey TableName
                 * @property {string|null} [ColumnName] SqlPrimaryKey ColumnName
                 * @property {number|null} [KeySeq] SqlPrimaryKey KeySeq
                 */

                /**
                 * Constructs a new SqlPrimaryKey.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlPrimaryKey.
                 * @implements ISqlPrimaryKey
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlPrimaryKey=} [properties] Properties to set
                 */
                function SqlPrimaryKey(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlPrimaryKey TableName.
                 * @member {string} TableName
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @instance
                 */
                SqlPrimaryKey.prototype.TableName = "";

                /**
                 * SqlPrimaryKey ColumnName.
                 * @member {string} ColumnName
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @instance
                 */
                SqlPrimaryKey.prototype.ColumnName = "";

                /**
                 * SqlPrimaryKey KeySeq.
                 * @member {number} KeySeq
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @instance
                 */
                SqlPrimaryKey.prototype.KeySeq = 0;

                /**
                 * Creates a new SqlPrimaryKey instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKey=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlPrimaryKey} SqlPrimaryKey instance
                 */
                SqlPrimaryKey.create = function create(properties) {
                    return new SqlPrimaryKey(properties);
                };

                /**
                 * Encodes the specified SqlPrimaryKey message. Does not implicitly {@link priority.netitems.nrest.SqlPrimaryKey.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKey} message SqlPrimaryKey message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlPrimaryKey.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.TableName != null && Object.hasOwnProperty.call(message, "TableName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.TableName);
                    if (message.ColumnName != null && Object.hasOwnProperty.call(message, "ColumnName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.ColumnName);
                    if (message.KeySeq != null && Object.hasOwnProperty.call(message, "KeySeq"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.KeySeq);
                    return writer;
                };

                /**
                 * Encodes the specified SqlPrimaryKey message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlPrimaryKey.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @static
                 * @param {priority.netitems.nrest.ISqlPrimaryKey} message SqlPrimaryKey message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlPrimaryKey.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlPrimaryKey message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlPrimaryKey} SqlPrimaryKey
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlPrimaryKey.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlPrimaryKey();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.TableName = reader.string();
                            break;
                        case 2:
                            message.ColumnName = reader.string();
                            break;
                        case 3:
                            message.KeySeq = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlPrimaryKey message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlPrimaryKey} SqlPrimaryKey
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlPrimaryKey.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlPrimaryKey message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlPrimaryKey.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.TableName != null && message.hasOwnProperty("TableName"))
                        if (!$util.isString(message.TableName))
                            return "TableName: string expected";
                    if (message.ColumnName != null && message.hasOwnProperty("ColumnName"))
                        if (!$util.isString(message.ColumnName))
                            return "ColumnName: string expected";
                    if (message.KeySeq != null && message.hasOwnProperty("KeySeq"))
                        if (!$util.isInteger(message.KeySeq))
                            return "KeySeq: integer expected";
                    return null;
                };

                /**
                 * Creates a SqlPrimaryKey message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlPrimaryKey} SqlPrimaryKey
                 */
                SqlPrimaryKey.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlPrimaryKey)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlPrimaryKey();
                    if (object.TableName != null)
                        message.TableName = String(object.TableName);
                    if (object.ColumnName != null)
                        message.ColumnName = String(object.ColumnName);
                    if (object.KeySeq != null)
                        message.KeySeq = object.KeySeq | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SqlPrimaryKey message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @static
                 * @param {priority.netitems.nrest.SqlPrimaryKey} message SqlPrimaryKey
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlPrimaryKey.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.TableName = "";
                        object.ColumnName = "";
                        object.KeySeq = 0;
                    }
                    if (message.TableName != null && message.hasOwnProperty("TableName"))
                        object.TableName = message.TableName;
                    if (message.ColumnName != null && message.hasOwnProperty("ColumnName"))
                        object.ColumnName = message.ColumnName;
                    if (message.KeySeq != null && message.hasOwnProperty("KeySeq"))
                        object.KeySeq = message.KeySeq;
                    return object;
                };

                /**
                 * Converts this SqlPrimaryKey to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlPrimaryKey
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlPrimaryKey.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlPrimaryKey;
            })();

            nrest.SqlForeignKeysRq = (function() {

                /**
                 * Properties of a SqlForeignKeysRq.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlForeignKeysRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SqlForeignKeysRq Properties
                 * @property {string|null} [PrimaryTableName] SqlForeignKeysRq PrimaryTableName
                 * @property {string|null} [ForeignTableName] SqlForeignKeysRq ForeignTableName
                 */

                /**
                 * Constructs a new SqlForeignKeysRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlForeignKeysRq.
                 * @implements ISqlForeignKeysRq
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlForeignKeysRq=} [properties] Properties to set
                 */
                function SqlForeignKeysRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlForeignKeysRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @instance
                 */
                SqlForeignKeysRq.prototype.Properties = null;

                /**
                 * SqlForeignKeysRq PrimaryTableName.
                 * @member {string} PrimaryTableName
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @instance
                 */
                SqlForeignKeysRq.prototype.PrimaryTableName = "";

                /**
                 * SqlForeignKeysRq ForeignTableName.
                 * @member {string} ForeignTableName
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @instance
                 */
                SqlForeignKeysRq.prototype.ForeignTableName = "";

                /**
                 * Creates a new SqlForeignKeysRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKeysRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlForeignKeysRq} SqlForeignKeysRq instance
                 */
                SqlForeignKeysRq.create = function create(properties) {
                    return new SqlForeignKeysRq(properties);
                };

                /**
                 * Encodes the specified SqlForeignKeysRq message. Does not implicitly {@link priority.netitems.nrest.SqlForeignKeysRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKeysRq} message SqlForeignKeysRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlForeignKeysRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.PrimaryTableName != null && Object.hasOwnProperty.call(message, "PrimaryTableName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.PrimaryTableName);
                    if (message.ForeignTableName != null && Object.hasOwnProperty.call(message, "ForeignTableName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.ForeignTableName);
                    return writer;
                };

                /**
                 * Encodes the specified SqlForeignKeysRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlForeignKeysRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKeysRq} message SqlForeignKeysRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlForeignKeysRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlForeignKeysRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlForeignKeysRq} SqlForeignKeysRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlForeignKeysRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlForeignKeysRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.PrimaryTableName = reader.string();
                            break;
                        case 3:
                            message.ForeignTableName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlForeignKeysRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlForeignKeysRq} SqlForeignKeysRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlForeignKeysRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlForeignKeysRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlForeignKeysRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.PrimaryTableName != null && message.hasOwnProperty("PrimaryTableName"))
                        if (!$util.isString(message.PrimaryTableName))
                            return "PrimaryTableName: string expected";
                    if (message.ForeignTableName != null && message.hasOwnProperty("ForeignTableName"))
                        if (!$util.isString(message.ForeignTableName))
                            return "ForeignTableName: string expected";
                    return null;
                };

                /**
                 * Creates a SqlForeignKeysRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlForeignKeysRq} SqlForeignKeysRq
                 */
                SqlForeignKeysRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlForeignKeysRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlForeignKeysRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.SqlForeignKeysRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.PrimaryTableName != null)
                        message.PrimaryTableName = String(object.PrimaryTableName);
                    if (object.ForeignTableName != null)
                        message.ForeignTableName = String(object.ForeignTableName);
                    return message;
                };

                /**
                 * Creates a plain object from a SqlForeignKeysRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @static
                 * @param {priority.netitems.nrest.SqlForeignKeysRq} message SqlForeignKeysRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlForeignKeysRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.PrimaryTableName = "";
                        object.ForeignTableName = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.PrimaryTableName != null && message.hasOwnProperty("PrimaryTableName"))
                        object.PrimaryTableName = message.PrimaryTableName;
                    if (message.ForeignTableName != null && message.hasOwnProperty("ForeignTableName"))
                        object.ForeignTableName = message.ForeignTableName;
                    return object;
                };

                /**
                 * Converts this SqlForeignKeysRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlForeignKeysRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlForeignKeysRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlForeignKeysRq;
            })();

            nrest.SqlForeignKeysRs = (function() {

                /**
                 * Properties of a SqlForeignKeysRs.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlForeignKeysRs
                 * @property {Array.<priority.netitems.nrest.ISqlForeignKey>|null} [ForeignKey] SqlForeignKeysRs ForeignKey
                 */

                /**
                 * Constructs a new SqlForeignKeysRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlForeignKeysRs.
                 * @implements ISqlForeignKeysRs
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlForeignKeysRs=} [properties] Properties to set
                 */
                function SqlForeignKeysRs(properties) {
                    this.ForeignKey = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlForeignKeysRs ForeignKey.
                 * @member {Array.<priority.netitems.nrest.ISqlForeignKey>} ForeignKey
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @instance
                 */
                SqlForeignKeysRs.prototype.ForeignKey = $util.emptyArray;

                /**
                 * Creates a new SqlForeignKeysRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKeysRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlForeignKeysRs} SqlForeignKeysRs instance
                 */
                SqlForeignKeysRs.create = function create(properties) {
                    return new SqlForeignKeysRs(properties);
                };

                /**
                 * Encodes the specified SqlForeignKeysRs message. Does not implicitly {@link priority.netitems.nrest.SqlForeignKeysRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKeysRs} message SqlForeignKeysRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlForeignKeysRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ForeignKey != null && message.ForeignKey.length)
                        for (var i = 0; i < message.ForeignKey.length; ++i)
                            $root.priority.netitems.nrest.SqlForeignKey.encode(message.ForeignKey[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SqlForeignKeysRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlForeignKeysRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKeysRs} message SqlForeignKeysRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlForeignKeysRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlForeignKeysRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlForeignKeysRs} SqlForeignKeysRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlForeignKeysRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlForeignKeysRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.ForeignKey && message.ForeignKey.length))
                                message.ForeignKey = [];
                            message.ForeignKey.push($root.priority.netitems.nrest.SqlForeignKey.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlForeignKeysRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlForeignKeysRs} SqlForeignKeysRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlForeignKeysRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlForeignKeysRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlForeignKeysRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ForeignKey != null && message.hasOwnProperty("ForeignKey")) {
                        if (!Array.isArray(message.ForeignKey))
                            return "ForeignKey: array expected";
                        for (var i = 0; i < message.ForeignKey.length; ++i) {
                            var error = $root.priority.netitems.nrest.SqlForeignKey.verify(message.ForeignKey[i]);
                            if (error)
                                return "ForeignKey." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SqlForeignKeysRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlForeignKeysRs} SqlForeignKeysRs
                 */
                SqlForeignKeysRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlForeignKeysRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlForeignKeysRs();
                    if (object.ForeignKey) {
                        if (!Array.isArray(object.ForeignKey))
                            throw TypeError(".priority.netitems.nrest.SqlForeignKeysRs.ForeignKey: array expected");
                        message.ForeignKey = [];
                        for (var i = 0; i < object.ForeignKey.length; ++i) {
                            if (typeof object.ForeignKey[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.SqlForeignKeysRs.ForeignKey: object expected");
                            message.ForeignKey[i] = $root.priority.netitems.nrest.SqlForeignKey.fromObject(object.ForeignKey[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SqlForeignKeysRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @static
                 * @param {priority.netitems.nrest.SqlForeignKeysRs} message SqlForeignKeysRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlForeignKeysRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.ForeignKey = [];
                    if (message.ForeignKey && message.ForeignKey.length) {
                        object.ForeignKey = [];
                        for (var j = 0; j < message.ForeignKey.length; ++j)
                            object.ForeignKey[j] = $root.priority.netitems.nrest.SqlForeignKey.toObject(message.ForeignKey[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SqlForeignKeysRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlForeignKeysRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlForeignKeysRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlForeignKeysRs;
            })();

            nrest.SqlForeignKey = (function() {

                /**
                 * Properties of a SqlForeignKey.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlForeignKey
                 * @property {string|null} [PrimaryTableName] SqlForeignKey PrimaryTableName
                 * @property {string|null} [PrimaryColumnName] SqlForeignKey PrimaryColumnName
                 * @property {string|null} [ForeignTableName] SqlForeignKey ForeignTableName
                 * @property {string|null} [ForeignColumnName] SqlForeignKey ForeignColumnName
                 * @property {number|null} [KeySeq] SqlForeignKey KeySeq
                 */

                /**
                 * Constructs a new SqlForeignKey.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlForeignKey.
                 * @implements ISqlForeignKey
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlForeignKey=} [properties] Properties to set
                 */
                function SqlForeignKey(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlForeignKey PrimaryTableName.
                 * @member {string} PrimaryTableName
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @instance
                 */
                SqlForeignKey.prototype.PrimaryTableName = "";

                /**
                 * SqlForeignKey PrimaryColumnName.
                 * @member {string} PrimaryColumnName
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @instance
                 */
                SqlForeignKey.prototype.PrimaryColumnName = "";

                /**
                 * SqlForeignKey ForeignTableName.
                 * @member {string} ForeignTableName
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @instance
                 */
                SqlForeignKey.prototype.ForeignTableName = "";

                /**
                 * SqlForeignKey ForeignColumnName.
                 * @member {string} ForeignColumnName
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @instance
                 */
                SqlForeignKey.prototype.ForeignColumnName = "";

                /**
                 * SqlForeignKey KeySeq.
                 * @member {number} KeySeq
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @instance
                 */
                SqlForeignKey.prototype.KeySeq = 0;

                /**
                 * Creates a new SqlForeignKey instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKey=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlForeignKey} SqlForeignKey instance
                 */
                SqlForeignKey.create = function create(properties) {
                    return new SqlForeignKey(properties);
                };

                /**
                 * Encodes the specified SqlForeignKey message. Does not implicitly {@link priority.netitems.nrest.SqlForeignKey.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKey} message SqlForeignKey message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlForeignKey.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.PrimaryTableName != null && Object.hasOwnProperty.call(message, "PrimaryTableName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.PrimaryTableName);
                    if (message.PrimaryColumnName != null && Object.hasOwnProperty.call(message, "PrimaryColumnName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.PrimaryColumnName);
                    if (message.ForeignTableName != null && Object.hasOwnProperty.call(message, "ForeignTableName"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.ForeignTableName);
                    if (message.ForeignColumnName != null && Object.hasOwnProperty.call(message, "ForeignColumnName"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.ForeignColumnName);
                    if (message.KeySeq != null && Object.hasOwnProperty.call(message, "KeySeq"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.KeySeq);
                    return writer;
                };

                /**
                 * Encodes the specified SqlForeignKey message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlForeignKey.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @static
                 * @param {priority.netitems.nrest.ISqlForeignKey} message SqlForeignKey message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlForeignKey.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlForeignKey message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlForeignKey} SqlForeignKey
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlForeignKey.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlForeignKey();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.PrimaryTableName = reader.string();
                            break;
                        case 2:
                            message.PrimaryColumnName = reader.string();
                            break;
                        case 3:
                            message.ForeignTableName = reader.string();
                            break;
                        case 4:
                            message.ForeignColumnName = reader.string();
                            break;
                        case 5:
                            message.KeySeq = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlForeignKey message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlForeignKey} SqlForeignKey
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlForeignKey.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlForeignKey message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlForeignKey.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.PrimaryTableName != null && message.hasOwnProperty("PrimaryTableName"))
                        if (!$util.isString(message.PrimaryTableName))
                            return "PrimaryTableName: string expected";
                    if (message.PrimaryColumnName != null && message.hasOwnProperty("PrimaryColumnName"))
                        if (!$util.isString(message.PrimaryColumnName))
                            return "PrimaryColumnName: string expected";
                    if (message.ForeignTableName != null && message.hasOwnProperty("ForeignTableName"))
                        if (!$util.isString(message.ForeignTableName))
                            return "ForeignTableName: string expected";
                    if (message.ForeignColumnName != null && message.hasOwnProperty("ForeignColumnName"))
                        if (!$util.isString(message.ForeignColumnName))
                            return "ForeignColumnName: string expected";
                    if (message.KeySeq != null && message.hasOwnProperty("KeySeq"))
                        if (!$util.isInteger(message.KeySeq))
                            return "KeySeq: integer expected";
                    return null;
                };

                /**
                 * Creates a SqlForeignKey message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlForeignKey} SqlForeignKey
                 */
                SqlForeignKey.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlForeignKey)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlForeignKey();
                    if (object.PrimaryTableName != null)
                        message.PrimaryTableName = String(object.PrimaryTableName);
                    if (object.PrimaryColumnName != null)
                        message.PrimaryColumnName = String(object.PrimaryColumnName);
                    if (object.ForeignTableName != null)
                        message.ForeignTableName = String(object.ForeignTableName);
                    if (object.ForeignColumnName != null)
                        message.ForeignColumnName = String(object.ForeignColumnName);
                    if (object.KeySeq != null)
                        message.KeySeq = object.KeySeq | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a SqlForeignKey message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @static
                 * @param {priority.netitems.nrest.SqlForeignKey} message SqlForeignKey
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlForeignKey.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.PrimaryTableName = "";
                        object.PrimaryColumnName = "";
                        object.ForeignTableName = "";
                        object.ForeignColumnName = "";
                        object.KeySeq = 0;
                    }
                    if (message.PrimaryTableName != null && message.hasOwnProperty("PrimaryTableName"))
                        object.PrimaryTableName = message.PrimaryTableName;
                    if (message.PrimaryColumnName != null && message.hasOwnProperty("PrimaryColumnName"))
                        object.PrimaryColumnName = message.PrimaryColumnName;
                    if (message.ForeignTableName != null && message.hasOwnProperty("ForeignTableName"))
                        object.ForeignTableName = message.ForeignTableName;
                    if (message.ForeignColumnName != null && message.hasOwnProperty("ForeignColumnName"))
                        object.ForeignColumnName = message.ForeignColumnName;
                    if (message.KeySeq != null && message.hasOwnProperty("KeySeq"))
                        object.KeySeq = message.KeySeq;
                    return object;
                };

                /**
                 * Converts this SqlForeignKey to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlForeignKey
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlForeignKey.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlForeignKey;
            })();

            /**
             * SqlTypes enum.
             * @name priority.netitems.nrest.SqlTypes
             * @enum {number}
             * @property {number} SqlTypes_SQL_UNKNOWN_TYPE=0 SqlTypes_SQL_UNKNOWN_TYPE value
             * @property {number} SqlTypes_SQL_CHAR=1 SqlTypes_SQL_CHAR value
             * @property {number} SqlTypes_SQL_NUMERIC=2 SqlTypes_SQL_NUMERIC value
             * @property {number} SqlTypes_SQL_DECIMAL=3 SqlTypes_SQL_DECIMAL value
             * @property {number} SqlTypes_SQL_INTEGER=4 SqlTypes_SQL_INTEGER value
             * @property {number} SqlTypes_SQL_SMALLINT=5 SqlTypes_SQL_SMALLINT value
             * @property {number} SqlTypes_SQL_FLOAT=6 SqlTypes_SQL_FLOAT value
             * @property {number} SqlTypes_SQL_REAL=7 SqlTypes_SQL_REAL value
             * @property {number} SqlTypes_SQL_DOUBLE=8 SqlTypes_SQL_DOUBLE value
             * @property {number} SqlTypes_SQL_DATETIME=9 SqlTypes_SQL_DATETIME value
             * @property {number} SqlTypes_SQL_DATE=9 SqlTypes_SQL_DATE value
             * @property {number} SqlTypes_SQL_INTERVAL=10 SqlTypes_SQL_INTERVAL value
             * @property {number} SqlTypes_SQL_TIME=10 SqlTypes_SQL_TIME value
             * @property {number} SqlTypes_SQL_TIMESTAMP=11 SqlTypes_SQL_TIMESTAMP value
             * @property {number} SqlTypes_SQL_VARCHAR=12 SqlTypes_SQL_VARCHAR value
             * @property {number} SqlTypes_SQL_BIGINT=13 SqlTypes_SQL_BIGINT value
             * @property {number} SqlTypes_SQL_WCHAR=14 SqlTypes_SQL_WCHAR value
             * @property {number} SqlTypes_SQL_WVARCHAR=15 SqlTypes_SQL_WVARCHAR value
             * @property {number} SqlTypes_SQL_INTERVAL_MINUTE=16 SqlTypes_SQL_INTERVAL_MINUTE value
             */
            nrest.SqlTypes = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SqlTypes_SQL_UNKNOWN_TYPE"] = 0;
                values[valuesById[1] = "SqlTypes_SQL_CHAR"] = 1;
                values[valuesById[2] = "SqlTypes_SQL_NUMERIC"] = 2;
                values[valuesById[3] = "SqlTypes_SQL_DECIMAL"] = 3;
                values[valuesById[4] = "SqlTypes_SQL_INTEGER"] = 4;
                values[valuesById[5] = "SqlTypes_SQL_SMALLINT"] = 5;
                values[valuesById[6] = "SqlTypes_SQL_FLOAT"] = 6;
                values[valuesById[7] = "SqlTypes_SQL_REAL"] = 7;
                values[valuesById[8] = "SqlTypes_SQL_DOUBLE"] = 8;
                values[valuesById[9] = "SqlTypes_SQL_DATETIME"] = 9;
                values["SqlTypes_SQL_DATE"] = 9;
                values[valuesById[10] = "SqlTypes_SQL_INTERVAL"] = 10;
                values["SqlTypes_SQL_TIME"] = 10;
                values[valuesById[11] = "SqlTypes_SQL_TIMESTAMP"] = 11;
                values[valuesById[12] = "SqlTypes_SQL_VARCHAR"] = 12;
                values[valuesById[13] = "SqlTypes_SQL_BIGINT"] = 13;
                values[valuesById[14] = "SqlTypes_SQL_WCHAR"] = 14;
                values[valuesById[15] = "SqlTypes_SQL_WVARCHAR"] = 15;
                values[valuesById[16] = "SqlTypes_SQL_INTERVAL_MINUTE"] = 16;
                return values;
            })();

            nrest.SqlExecDirectRq = (function() {

                /**
                 * Properties of a SqlExecDirectRq.
                 * @memberof priority.netitems.nrest
                 * @interface ISqlExecDirectRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SqlExecDirectRq Properties
                 * @property {string|null} [query] SqlExecDirectRq query
                 */

                /**
                 * Constructs a new SqlExecDirectRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a SqlExecDirectRq.
                 * @implements ISqlExecDirectRq
                 * @constructor
                 * @param {priority.netitems.nrest.ISqlExecDirectRq=} [properties] Properties to set
                 */
                function SqlExecDirectRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SqlExecDirectRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @instance
                 */
                SqlExecDirectRq.prototype.Properties = null;

                /**
                 * SqlExecDirectRq query.
                 * @member {string} query
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @instance
                 */
                SqlExecDirectRq.prototype.query = "";

                /**
                 * Creates a new SqlExecDirectRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlExecDirectRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.SqlExecDirectRq} SqlExecDirectRq instance
                 */
                SqlExecDirectRq.create = function create(properties) {
                    return new SqlExecDirectRq(properties);
                };

                /**
                 * Encodes the specified SqlExecDirectRq message. Does not implicitly {@link priority.netitems.nrest.SqlExecDirectRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlExecDirectRq} message SqlExecDirectRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlExecDirectRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.query);
                    return writer;
                };

                /**
                 * Encodes the specified SqlExecDirectRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.SqlExecDirectRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @static
                 * @param {priority.netitems.nrest.ISqlExecDirectRq} message SqlExecDirectRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SqlExecDirectRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SqlExecDirectRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.SqlExecDirectRq} SqlExecDirectRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlExecDirectRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.SqlExecDirectRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.query = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SqlExecDirectRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.SqlExecDirectRq} SqlExecDirectRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SqlExecDirectRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SqlExecDirectRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SqlExecDirectRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.query != null && message.hasOwnProperty("query"))
                        if (!$util.isString(message.query))
                            return "query: string expected";
                    return null;
                };

                /**
                 * Creates a SqlExecDirectRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.SqlExecDirectRq} SqlExecDirectRq
                 */
                SqlExecDirectRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.SqlExecDirectRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.SqlExecDirectRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.SqlExecDirectRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.query != null)
                        message.query = String(object.query);
                    return message;
                };

                /**
                 * Creates a plain object from a SqlExecDirectRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @static
                 * @param {priority.netitems.nrest.SqlExecDirectRq} message SqlExecDirectRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SqlExecDirectRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.query = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.query != null && message.hasOwnProperty("query"))
                        object.query = message.query;
                    return object;
                };

                /**
                 * Converts this SqlExecDirectRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.SqlExecDirectRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SqlExecDirectRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SqlExecDirectRq;
            })();

            nrest.TokenRq = (function() {

                /**
                 * Properties of a TokenRq.
                 * @memberof priority.netitems.nrest
                 * @interface ITokenRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] TokenRq Properties
                 * @property {Uint8Array|null} [token] TokenRq token
                 * @property {Array.<string>|null} [params] TokenRq params
                 */

                /**
                 * Constructs a new TokenRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a TokenRq.
                 * @implements ITokenRq
                 * @constructor
                 * @param {priority.netitems.nrest.ITokenRq=} [properties] Properties to set
                 */
                function TokenRq(properties) {
                    this.params = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TokenRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.TokenRq
                 * @instance
                 */
                TokenRq.prototype.Properties = null;

                /**
                 * TokenRq token.
                 * @member {Uint8Array} token
                 * @memberof priority.netitems.nrest.TokenRq
                 * @instance
                 */
                TokenRq.prototype.token = $util.newBuffer([]);

                /**
                 * TokenRq params.
                 * @member {Array.<string>} params
                 * @memberof priority.netitems.nrest.TokenRq
                 * @instance
                 */
                TokenRq.prototype.params = $util.emptyArray;

                /**
                 * Creates a new TokenRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.TokenRq
                 * @static
                 * @param {priority.netitems.nrest.ITokenRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.TokenRq} TokenRq instance
                 */
                TokenRq.create = function create(properties) {
                    return new TokenRq(properties);
                };

                /**
                 * Encodes the specified TokenRq message. Does not implicitly {@link priority.netitems.nrest.TokenRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.TokenRq
                 * @static
                 * @param {priority.netitems.nrest.ITokenRq} message TokenRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TokenRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.token);
                    if (message.params != null && message.params.length)
                        for (var i = 0; i < message.params.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.params[i]);
                    return writer;
                };

                /**
                 * Encodes the specified TokenRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.TokenRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.TokenRq
                 * @static
                 * @param {priority.netitems.nrest.ITokenRq} message TokenRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TokenRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TokenRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.TokenRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.TokenRq} TokenRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TokenRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.TokenRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.token = reader.bytes();
                            break;
                        case 3:
                            if (!(message.params && message.params.length))
                                message.params = [];
                            message.params.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TokenRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.TokenRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.TokenRq} TokenRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TokenRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TokenRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.TokenRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TokenRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.token != null && message.hasOwnProperty("token"))
                        if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                            return "token: buffer expected";
                    if (message.params != null && message.hasOwnProperty("params")) {
                        if (!Array.isArray(message.params))
                            return "params: array expected";
                        for (var i = 0; i < message.params.length; ++i)
                            if (!$util.isString(message.params[i]))
                                return "params: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a TokenRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.TokenRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.TokenRq} TokenRq
                 */
                TokenRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.TokenRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.TokenRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.TokenRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.token != null)
                        if (typeof object.token === "string")
                            $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                        else if (object.token.length)
                            message.token = object.token;
                    if (object.params) {
                        if (!Array.isArray(object.params))
                            throw TypeError(".priority.netitems.nrest.TokenRq.params: array expected");
                        message.params = [];
                        for (var i = 0; i < object.params.length; ++i)
                            message.params[i] = String(object.params[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a TokenRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.TokenRq
                 * @static
                 * @param {priority.netitems.nrest.TokenRq} message TokenRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TokenRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.params = [];
                    if (options.defaults) {
                        object.Properties = null;
                        if (options.bytes === String)
                            object.token = "";
                        else {
                            object.token = [];
                            if (options.bytes !== Array)
                                object.token = $util.newBuffer(object.token);
                        }
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.token != null && message.hasOwnProperty("token"))
                        object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
                    if (message.params && message.params.length) {
                        object.params = [];
                        for (var j = 0; j < message.params.length; ++j)
                            object.params[j] = message.params[j];
                    }
                    return object;
                };

                /**
                 * Converts this TokenRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.TokenRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TokenRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TokenRq;
            })();

            nrest.TokenRs = (function() {

                /**
                 * Properties of a TokenRs.
                 * @memberof priority.netitems.nrest
                 * @interface ITokenRs
                 * @property {Array.<priority.netitems.nrest.ISqlColumn>|null} [Columns] TokenRs Columns
                 * @property {Uint8Array|null} [token] TokenRs token
                 */

                /**
                 * Constructs a new TokenRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a TokenRs.
                 * @implements ITokenRs
                 * @constructor
                 * @param {priority.netitems.nrest.ITokenRs=} [properties] Properties to set
                 */
                function TokenRs(properties) {
                    this.Columns = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TokenRs Columns.
                 * @member {Array.<priority.netitems.nrest.ISqlColumn>} Columns
                 * @memberof priority.netitems.nrest.TokenRs
                 * @instance
                 */
                TokenRs.prototype.Columns = $util.emptyArray;

                /**
                 * TokenRs token.
                 * @member {Uint8Array} token
                 * @memberof priority.netitems.nrest.TokenRs
                 * @instance
                 */
                TokenRs.prototype.token = $util.newBuffer([]);

                /**
                 * Creates a new TokenRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.TokenRs
                 * @static
                 * @param {priority.netitems.nrest.ITokenRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.TokenRs} TokenRs instance
                 */
                TokenRs.create = function create(properties) {
                    return new TokenRs(properties);
                };

                /**
                 * Encodes the specified TokenRs message. Does not implicitly {@link priority.netitems.nrest.TokenRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.TokenRs
                 * @static
                 * @param {priority.netitems.nrest.ITokenRs} message TokenRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TokenRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Columns != null && message.Columns.length)
                        for (var i = 0; i < message.Columns.length; ++i)
                            $root.priority.netitems.nrest.SqlColumn.encode(message.Columns[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                        writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.token);
                    return writer;
                };

                /**
                 * Encodes the specified TokenRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.TokenRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.TokenRs
                 * @static
                 * @param {priority.netitems.nrest.ITokenRs} message TokenRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TokenRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TokenRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.TokenRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.TokenRs} TokenRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TokenRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.TokenRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Columns && message.Columns.length))
                                message.Columns = [];
                            message.Columns.push($root.priority.netitems.nrest.SqlColumn.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.token = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TokenRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.TokenRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.TokenRs} TokenRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TokenRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TokenRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.TokenRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TokenRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (!Array.isArray(message.Columns))
                            return "Columns: array expected";
                        for (var i = 0; i < message.Columns.length; ++i) {
                            var error = $root.priority.netitems.nrest.SqlColumn.verify(message.Columns[i]);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.token != null && message.hasOwnProperty("token"))
                        if (!(message.token && typeof message.token.length === "number" || $util.isString(message.token)))
                            return "token: buffer expected";
                    return null;
                };

                /**
                 * Creates a TokenRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.TokenRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.TokenRs} TokenRs
                 */
                TokenRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.TokenRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.TokenRs();
                    if (object.Columns) {
                        if (!Array.isArray(object.Columns))
                            throw TypeError(".priority.netitems.nrest.TokenRs.Columns: array expected");
                        message.Columns = [];
                        for (var i = 0; i < object.Columns.length; ++i) {
                            if (typeof object.Columns[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.TokenRs.Columns: object expected");
                            message.Columns[i] = $root.priority.netitems.nrest.SqlColumn.fromObject(object.Columns[i]);
                        }
                    }
                    if (object.token != null)
                        if (typeof object.token === "string")
                            $util.base64.decode(object.token, message.token = $util.newBuffer($util.base64.length(object.token)), 0);
                        else if (object.token.length)
                            message.token = object.token;
                    return message;
                };

                /**
                 * Creates a plain object from a TokenRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.TokenRs
                 * @static
                 * @param {priority.netitems.nrest.TokenRs} message TokenRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TokenRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Columns = [];
                    if (options.defaults)
                        if (options.bytes === String)
                            object.token = "";
                        else {
                            object.token = [];
                            if (options.bytes !== Array)
                                object.token = $util.newBuffer(object.token);
                        }
                    if (message.Columns && message.Columns.length) {
                        object.Columns = [];
                        for (var j = 0; j < message.Columns.length; ++j)
                            object.Columns[j] = $root.priority.netitems.nrest.SqlColumn.toObject(message.Columns[j], options);
                    }
                    if (message.token != null && message.hasOwnProperty("token"))
                        object.token = options.bytes === String ? $util.base64.encode(message.token, 0, message.token.length) : options.bytes === Array ? Array.prototype.slice.call(message.token) : message.token;
                    return object;
                };

                /**
                 * Converts this TokenRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.TokenRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TokenRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TokenRs;
            })();

            nrest.ReportListRq = (function() {

                /**
                 * Properties of a ReportListRq.
                 * @memberof priority.netitems.nrest
                 * @interface IReportListRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ReportListRq Properties
                 * @property {string|null} [RootNodeId] ReportListRq RootNodeId
                 */

                /**
                 * Constructs a new ReportListRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportListRq.
                 * @implements IReportListRq
                 * @constructor
                 * @param {priority.netitems.nrest.IReportListRq=} [properties] Properties to set
                 */
                function ReportListRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportListRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @instance
                 */
                ReportListRq.prototype.Properties = null;

                /**
                 * ReportListRq RootNodeId.
                 * @member {string} RootNodeId
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @instance
                 */
                ReportListRq.prototype.RootNodeId = "";

                /**
                 * Creates a new ReportListRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @static
                 * @param {priority.netitems.nrest.IReportListRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportListRq} ReportListRq instance
                 */
                ReportListRq.create = function create(properties) {
                    return new ReportListRq(properties);
                };

                /**
                 * Encodes the specified ReportListRq message. Does not implicitly {@link priority.netitems.nrest.ReportListRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @static
                 * @param {priority.netitems.nrest.IReportListRq} message ReportListRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportListRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.RootNodeId != null && Object.hasOwnProperty.call(message, "RootNodeId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.RootNodeId);
                    return writer;
                };

                /**
                 * Encodes the specified ReportListRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportListRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @static
                 * @param {priority.netitems.nrest.IReportListRq} message ReportListRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportListRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportListRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportListRq} ReportListRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportListRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportListRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.RootNodeId = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportListRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportListRq} ReportListRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportListRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportListRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportListRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.RootNodeId != null && message.hasOwnProperty("RootNodeId"))
                        if (!$util.isString(message.RootNodeId))
                            return "RootNodeId: string expected";
                    return null;
                };

                /**
                 * Creates a ReportListRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportListRq} ReportListRq
                 */
                ReportListRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportListRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportListRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportListRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.RootNodeId != null)
                        message.RootNodeId = String(object.RootNodeId);
                    return message;
                };

                /**
                 * Creates a plain object from a ReportListRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @static
                 * @param {priority.netitems.nrest.ReportListRq} message ReportListRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportListRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.RootNodeId = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.RootNodeId != null && message.hasOwnProperty("RootNodeId"))
                        object.RootNodeId = message.RootNodeId;
                    return object;
                };

                /**
                 * Converts this ReportListRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportListRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportListRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportListRq;
            })();

            nrest.ReportInput = (function() {

                /**
                 * Properties of a ReportInput.
                 * @memberof priority.netitems.nrest
                 * @interface IReportInput
                 * @property {string|null} [Colname] ReportInput Colname
                 * @property {boolean|null} [IsCompany] ReportInput IsCompany
                 */

                /**
                 * Constructs a new ReportInput.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportInput.
                 * @implements IReportInput
                 * @constructor
                 * @param {priority.netitems.nrest.IReportInput=} [properties] Properties to set
                 */
                function ReportInput(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportInput Colname.
                 * @member {string} Colname
                 * @memberof priority.netitems.nrest.ReportInput
                 * @instance
                 */
                ReportInput.prototype.Colname = "";

                /**
                 * ReportInput IsCompany.
                 * @member {boolean} IsCompany
                 * @memberof priority.netitems.nrest.ReportInput
                 * @instance
                 */
                ReportInput.prototype.IsCompany = false;

                /**
                 * Creates a new ReportInput instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportInput
                 * @static
                 * @param {priority.netitems.nrest.IReportInput=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportInput} ReportInput instance
                 */
                ReportInput.create = function create(properties) {
                    return new ReportInput(properties);
                };

                /**
                 * Encodes the specified ReportInput message. Does not implicitly {@link priority.netitems.nrest.ReportInput.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportInput
                 * @static
                 * @param {priority.netitems.nrest.IReportInput} message ReportInput message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportInput.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Colname != null && Object.hasOwnProperty.call(message, "Colname"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Colname);
                    if (message.IsCompany != null && Object.hasOwnProperty.call(message, "IsCompany"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.IsCompany);
                    return writer;
                };

                /**
                 * Encodes the specified ReportInput message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportInput.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportInput
                 * @static
                 * @param {priority.netitems.nrest.IReportInput} message ReportInput message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportInput.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportInput message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportInput
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportInput} ReportInput
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportInput.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportInput();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Colname = reader.string();
                            break;
                        case 2:
                            message.IsCompany = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportInput message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportInput
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportInput} ReportInput
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportInput.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportInput message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportInput
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportInput.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Colname != null && message.hasOwnProperty("Colname"))
                        if (!$util.isString(message.Colname))
                            return "Colname: string expected";
                    if (message.IsCompany != null && message.hasOwnProperty("IsCompany"))
                        if (typeof message.IsCompany !== "boolean")
                            return "IsCompany: boolean expected";
                    return null;
                };

                /**
                 * Creates a ReportInput message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportInput
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportInput} ReportInput
                 */
                ReportInput.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportInput)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportInput();
                    if (object.Colname != null)
                        message.Colname = String(object.Colname);
                    if (object.IsCompany != null)
                        message.IsCompany = Boolean(object.IsCompany);
                    return message;
                };

                /**
                 * Creates a plain object from a ReportInput message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportInput
                 * @static
                 * @param {priority.netitems.nrest.ReportInput} message ReportInput
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportInput.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Colname = "";
                        object.IsCompany = false;
                    }
                    if (message.Colname != null && message.hasOwnProperty("Colname"))
                        object.Colname = message.Colname;
                    if (message.IsCompany != null && message.hasOwnProperty("IsCompany"))
                        object.IsCompany = message.IsCompany;
                    return object;
                };

                /**
                 * Converts this ReportInput to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportInput
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportInput.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportInput;
            })();

            nrest.ReportTitle = (function() {

                /**
                 * Properties of a ReportTitle.
                 * @memberof priority.netitems.nrest
                 * @interface IReportTitle
                 * @property {number|Long|null} [ReportId] ReportTitle ReportId
                 * @property {string|null} [RootNodeId] ReportTitle RootNodeId
                 * @property {string|null} [Title] ReportTitle Title
                 * @property {string|null} [Username] ReportTitle Username
                 * @property {common.IDate|null} [CreatedDate] ReportTitle CreatedDate
                 * @property {common.IDateTime|null} [UpdateTime] ReportTitle UpdateTime
                 * @property {boolean|null} [General] ReportTitle General
                 * @property {string|null} [Type] ReportTitle Type
                 * @property {boolean|null} [InUse] ReportTitle InUse
                 * @property {priority.netitems.nrest.RepType|null} [ReportType] ReportTitle ReportType
                 * @property {Array.<priority.netitems.nrest.IReportInput>|null} [Inputs] ReportTitle Inputs
                 */

                /**
                 * Constructs a new ReportTitle.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportTitle.
                 * @implements IReportTitle
                 * @constructor
                 * @param {priority.netitems.nrest.IReportTitle=} [properties] Properties to set
                 */
                function ReportTitle(properties) {
                    this.Inputs = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportTitle ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportTitle RootNodeId.
                 * @member {string} RootNodeId
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.RootNodeId = "";

                /**
                 * ReportTitle Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.Title = "";

                /**
                 * ReportTitle Username.
                 * @member {string} Username
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.Username = "";

                /**
                 * ReportTitle CreatedDate.
                 * @member {common.IDate|null|undefined} CreatedDate
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.CreatedDate = null;

                /**
                 * ReportTitle UpdateTime.
                 * @member {common.IDateTime|null|undefined} UpdateTime
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.UpdateTime = null;

                /**
                 * ReportTitle General.
                 * @member {boolean} General
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.General = false;

                /**
                 * ReportTitle Type.
                 * @member {string} Type
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.Type = "";

                /**
                 * ReportTitle InUse.
                 * @member {boolean} InUse
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.InUse = false;

                /**
                 * ReportTitle ReportType.
                 * @member {priority.netitems.nrest.RepType} ReportType
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.ReportType = 0;

                /**
                 * ReportTitle Inputs.
                 * @member {Array.<priority.netitems.nrest.IReportInput>} Inputs
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 */
                ReportTitle.prototype.Inputs = $util.emptyArray;

                /**
                 * Creates a new ReportTitle instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @static
                 * @param {priority.netitems.nrest.IReportTitle=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportTitle} ReportTitle instance
                 */
                ReportTitle.create = function create(properties) {
                    return new ReportTitle(properties);
                };

                /**
                 * Encodes the specified ReportTitle message. Does not implicitly {@link priority.netitems.nrest.ReportTitle.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @static
                 * @param {priority.netitems.nrest.IReportTitle} message ReportTitle message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportTitle.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ReportId);
                    if (message.RootNodeId != null && Object.hasOwnProperty.call(message, "RootNodeId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.RootNodeId);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Title);
                    if (message.Username != null && Object.hasOwnProperty.call(message, "Username"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Username);
                    if (message.CreatedDate != null && Object.hasOwnProperty.call(message, "CreatedDate"))
                        $root.common.Date.encode(message.CreatedDate, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.UpdateTime != null && Object.hasOwnProperty.call(message, "UpdateTime"))
                        $root.common.DateTime.encode(message.UpdateTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.General != null && Object.hasOwnProperty.call(message, "General"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.General);
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.Type);
                    if (message.InUse != null && Object.hasOwnProperty.call(message, "InUse"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.InUse);
                    if (message.ReportType != null && Object.hasOwnProperty.call(message, "ReportType"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int32(message.ReportType);
                    if (message.Inputs != null && message.Inputs.length)
                        for (var i = 0; i < message.Inputs.length; ++i)
                            $root.priority.netitems.nrest.ReportInput.encode(message.Inputs[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ReportTitle message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportTitle.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @static
                 * @param {priority.netitems.nrest.IReportTitle} message ReportTitle message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportTitle.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportTitle message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportTitle} ReportTitle
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportTitle.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportTitle();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ReportId = reader.int64();
                            break;
                        case 2:
                            message.RootNodeId = reader.string();
                            break;
                        case 3:
                            message.Title = reader.string();
                            break;
                        case 4:
                            message.Username = reader.string();
                            break;
                        case 5:
                            message.CreatedDate = $root.common.Date.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.UpdateTime = $root.common.DateTime.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.General = reader.bool();
                            break;
                        case 8:
                            message.Type = reader.string();
                            break;
                        case 9:
                            message.InUse = reader.bool();
                            break;
                        case 10:
                            message.ReportType = reader.int32();
                            break;
                        case 11:
                            if (!(message.Inputs && message.Inputs.length))
                                message.Inputs = [];
                            message.Inputs.push($root.priority.netitems.nrest.ReportInput.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportTitle message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportTitle} ReportTitle
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportTitle.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportTitle message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportTitle.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    if (message.RootNodeId != null && message.hasOwnProperty("RootNodeId"))
                        if (!$util.isString(message.RootNodeId))
                            return "RootNodeId: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Username != null && message.hasOwnProperty("Username"))
                        if (!$util.isString(message.Username))
                            return "Username: string expected";
                    if (message.CreatedDate != null && message.hasOwnProperty("CreatedDate")) {
                        var error = $root.common.Date.verify(message.CreatedDate);
                        if (error)
                            return "CreatedDate." + error;
                    }
                    if (message.UpdateTime != null && message.hasOwnProperty("UpdateTime")) {
                        var error = $root.common.DateTime.verify(message.UpdateTime);
                        if (error)
                            return "UpdateTime." + error;
                    }
                    if (message.General != null && message.hasOwnProperty("General"))
                        if (typeof message.General !== "boolean")
                            return "General: boolean expected";
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        if (!$util.isString(message.Type))
                            return "Type: string expected";
                    if (message.InUse != null && message.hasOwnProperty("InUse"))
                        if (typeof message.InUse !== "boolean")
                            return "InUse: boolean expected";
                    if (message.ReportType != null && message.hasOwnProperty("ReportType"))
                        switch (message.ReportType) {
                        default:
                            return "ReportType: enum value expected";
                        case 0:
                        case 97:
                        case 99:
                        case 111:
                        case 114:
                        case 119:
                        case 121:
                            break;
                        }
                    if (message.Inputs != null && message.hasOwnProperty("Inputs")) {
                        if (!Array.isArray(message.Inputs))
                            return "Inputs: array expected";
                        for (var i = 0; i < message.Inputs.length; ++i) {
                            var error = $root.priority.netitems.nrest.ReportInput.verify(message.Inputs[i]);
                            if (error)
                                return "Inputs." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ReportTitle message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportTitle} ReportTitle
                 */
                ReportTitle.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportTitle)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportTitle();
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    if (object.RootNodeId != null)
                        message.RootNodeId = String(object.RootNodeId);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Username != null)
                        message.Username = String(object.Username);
                    if (object.CreatedDate != null) {
                        if (typeof object.CreatedDate !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportTitle.CreatedDate: object expected");
                        message.CreatedDate = $root.common.Date.fromObject(object.CreatedDate);
                    }
                    if (object.UpdateTime != null) {
                        if (typeof object.UpdateTime !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportTitle.UpdateTime: object expected");
                        message.UpdateTime = $root.common.DateTime.fromObject(object.UpdateTime);
                    }
                    if (object.General != null)
                        message.General = Boolean(object.General);
                    if (object.Type != null)
                        message.Type = String(object.Type);
                    if (object.InUse != null)
                        message.InUse = Boolean(object.InUse);
                    switch (object.ReportType) {
                    case "RepType_None":
                    case 0:
                        message.ReportType = 0;
                        break;
                    case "RepType_DynFields":
                    case 97:
                        message.ReportType = 97;
                        break;
                    case "RepType_Chart":
                    case 99:
                        message.ReportType = 99;
                        break;
                    case "RepType_DataSet":
                    case 111:
                        message.ReportType = 111;
                        break;
                    case "RepType_OldReport":
                    case 114:
                        message.ReportType = 114;
                        break;
                    case "RepType_Widget":
                    case 119:
                        message.ReportType = 119;
                        break;
                    case "RepType_Report":
                    case 121:
                        message.ReportType = 121;
                        break;
                    }
                    if (object.Inputs) {
                        if (!Array.isArray(object.Inputs))
                            throw TypeError(".priority.netitems.nrest.ReportTitle.Inputs: array expected");
                        message.Inputs = [];
                        for (var i = 0; i < object.Inputs.length; ++i) {
                            if (typeof object.Inputs[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportTitle.Inputs: object expected");
                            message.Inputs[i] = $root.priority.netitems.nrest.ReportInput.fromObject(object.Inputs[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ReportTitle message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @static
                 * @param {priority.netitems.nrest.ReportTitle} message ReportTitle
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportTitle.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Inputs = [];
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                        object.RootNodeId = "";
                        object.Title = "";
                        object.Username = "";
                        object.CreatedDate = null;
                        object.UpdateTime = null;
                        object.General = false;
                        object.Type = "";
                        object.InUse = false;
                        object.ReportType = options.enums === String ? "RepType_None" : 0;
                    }
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    if (message.RootNodeId != null && message.hasOwnProperty("RootNodeId"))
                        object.RootNodeId = message.RootNodeId;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Username != null && message.hasOwnProperty("Username"))
                        object.Username = message.Username;
                    if (message.CreatedDate != null && message.hasOwnProperty("CreatedDate"))
                        object.CreatedDate = $root.common.Date.toObject(message.CreatedDate, options);
                    if (message.UpdateTime != null && message.hasOwnProperty("UpdateTime"))
                        object.UpdateTime = $root.common.DateTime.toObject(message.UpdateTime, options);
                    if (message.General != null && message.hasOwnProperty("General"))
                        object.General = message.General;
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        object.Type = message.Type;
                    if (message.InUse != null && message.hasOwnProperty("InUse"))
                        object.InUse = message.InUse;
                    if (message.ReportType != null && message.hasOwnProperty("ReportType"))
                        object.ReportType = options.enums === String ? $root.priority.netitems.nrest.RepType[message.ReportType] : message.ReportType;
                    if (message.Inputs && message.Inputs.length) {
                        object.Inputs = [];
                        for (var j = 0; j < message.Inputs.length; ++j)
                            object.Inputs[j] = $root.priority.netitems.nrest.ReportInput.toObject(message.Inputs[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ReportTitle to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportTitle
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportTitle.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportTitle;
            })();

            nrest.ReportListRs = (function() {

                /**
                 * Properties of a ReportListRs.
                 * @memberof priority.netitems.nrest
                 * @interface IReportListRs
                 * @property {Array.<priority.netitems.nrest.IReportTitle>|null} [Title] ReportListRs Title
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ReportListRs Messages
                 */

                /**
                 * Constructs a new ReportListRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportListRs.
                 * @implements IReportListRs
                 * @constructor
                 * @param {priority.netitems.nrest.IReportListRs=} [properties] Properties to set
                 */
                function ReportListRs(properties) {
                    this.Title = [];
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportListRs Title.
                 * @member {Array.<priority.netitems.nrest.IReportTitle>} Title
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @instance
                 */
                ReportListRs.prototype.Title = $util.emptyArray;

                /**
                 * ReportListRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @instance
                 */
                ReportListRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new ReportListRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @static
                 * @param {priority.netitems.nrest.IReportListRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportListRs} ReportListRs instance
                 */
                ReportListRs.create = function create(properties) {
                    return new ReportListRs(properties);
                };

                /**
                 * Encodes the specified ReportListRs message. Does not implicitly {@link priority.netitems.nrest.ReportListRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @static
                 * @param {priority.netitems.nrest.IReportListRs} message ReportListRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportListRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Title != null && message.Title.length)
                        for (var i = 0; i < message.Title.length; ++i)
                            $root.priority.netitems.nrest.ReportTitle.encode(message.Title[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ReportListRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportListRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @static
                 * @param {priority.netitems.nrest.IReportListRs} message ReportListRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportListRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportListRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportListRs} ReportListRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportListRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportListRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Title && message.Title.length))
                                message.Title = [];
                            message.Title.push($root.priority.netitems.nrest.ReportTitle.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportListRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportListRs} ReportListRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportListRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportListRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportListRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Title != null && message.hasOwnProperty("Title")) {
                        if (!Array.isArray(message.Title))
                            return "Title: array expected";
                        for (var i = 0; i < message.Title.length; ++i) {
                            var error = $root.priority.netitems.nrest.ReportTitle.verify(message.Title[i]);
                            if (error)
                                return "Title." + error;
                        }
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ReportListRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportListRs} ReportListRs
                 */
                ReportListRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportListRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportListRs();
                    if (object.Title) {
                        if (!Array.isArray(object.Title))
                            throw TypeError(".priority.netitems.nrest.ReportListRs.Title: array expected");
                        message.Title = [];
                        for (var i = 0; i < object.Title.length; ++i) {
                            if (typeof object.Title[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportListRs.Title: object expected");
                            message.Title[i] = $root.priority.netitems.nrest.ReportTitle.fromObject(object.Title[i]);
                        }
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.ReportListRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportListRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ReportListRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @static
                 * @param {priority.netitems.nrest.ReportListRs} message ReportListRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportListRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Title = [];
                        object.Messages = [];
                    }
                    if (message.Title && message.Title.length) {
                        object.Title = [];
                        for (var j = 0; j < message.Title.length; ++j)
                            object.Title[j] = $root.priority.netitems.nrest.ReportTitle.toObject(message.Title[j], options);
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ReportListRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportListRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportListRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportListRs;
            })();

            /**
             * TreeNodeChildrenModes enum.
             * @name priority.netitems.nrest.TreeNodeChildrenModes
             * @enum {number}
             * @property {number} TreeNodeChildrenModes_Both=0 TreeNodeChildrenModes_Both value
             * @property {number} TreeNodeChildrenModes_Forms=1 TreeNodeChildrenModes_Forms value
             * @property {number} TreeNodeChildrenModes_Columns=2 TreeNodeChildrenModes_Columns value
             */
            nrest.TreeNodeChildrenModes = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "TreeNodeChildrenModes_Both"] = 0;
                values[valuesById[1] = "TreeNodeChildrenModes_Forms"] = 1;
                values[valuesById[2] = "TreeNodeChildrenModes_Columns"] = 2;
                return values;
            })();

            nrest.TreeNodeChildrenRq = (function() {

                /**
                 * Properties of a TreeNodeChildrenRq.
                 * @memberof priority.netitems.nrest
                 * @interface ITreeNodeChildrenRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] TreeNodeChildrenRq Properties
                 * @property {string|null} [NodeId] TreeNodeChildrenRq NodeId
                 * @property {number|Long|null} [ReportId] TreeNodeChildrenRq ReportId
                 * @property {priority.netitems.nrest.TreeNodeChildrenModes|null} [Mode] TreeNodeChildrenRq Mode
                 */

                /**
                 * Constructs a new TreeNodeChildrenRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a TreeNodeChildrenRq.
                 * @implements ITreeNodeChildrenRq
                 * @constructor
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRq=} [properties] Properties to set
                 */
                function TreeNodeChildrenRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TreeNodeChildrenRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @instance
                 */
                TreeNodeChildrenRq.prototype.Properties = null;

                /**
                 * TreeNodeChildrenRq NodeId.
                 * @member {string} NodeId
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @instance
                 */
                TreeNodeChildrenRq.prototype.NodeId = "";

                /**
                 * TreeNodeChildrenRq ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @instance
                 */
                TreeNodeChildrenRq.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * TreeNodeChildrenRq Mode.
                 * @member {priority.netitems.nrest.TreeNodeChildrenModes} Mode
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @instance
                 */
                TreeNodeChildrenRq.prototype.Mode = 0;

                /**
                 * Creates a new TreeNodeChildrenRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @static
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.TreeNodeChildrenRq} TreeNodeChildrenRq instance
                 */
                TreeNodeChildrenRq.create = function create(properties) {
                    return new TreeNodeChildrenRq(properties);
                };

                /**
                 * Encodes the specified TreeNodeChildrenRq message. Does not implicitly {@link priority.netitems.nrest.TreeNodeChildrenRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @static
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRq} message TreeNodeChildrenRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TreeNodeChildrenRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.NodeId != null && Object.hasOwnProperty.call(message, "NodeId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.NodeId);
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ReportId);
                    if (message.Mode != null && Object.hasOwnProperty.call(message, "Mode"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Mode);
                    return writer;
                };

                /**
                 * Encodes the specified TreeNodeChildrenRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.TreeNodeChildrenRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @static
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRq} message TreeNodeChildrenRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TreeNodeChildrenRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TreeNodeChildrenRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.TreeNodeChildrenRq} TreeNodeChildrenRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TreeNodeChildrenRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.TreeNodeChildrenRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.NodeId = reader.string();
                            break;
                        case 3:
                            message.ReportId = reader.int64();
                            break;
                        case 4:
                            message.Mode = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TreeNodeChildrenRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.TreeNodeChildrenRq} TreeNodeChildrenRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TreeNodeChildrenRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TreeNodeChildrenRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TreeNodeChildrenRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.NodeId != null && message.hasOwnProperty("NodeId"))
                        if (!$util.isString(message.NodeId))
                            return "NodeId: string expected";
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    if (message.Mode != null && message.hasOwnProperty("Mode"))
                        switch (message.Mode) {
                        default:
                            return "Mode: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };

                /**
                 * Creates a TreeNodeChildrenRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.TreeNodeChildrenRq} TreeNodeChildrenRq
                 */
                TreeNodeChildrenRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.TreeNodeChildrenRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.TreeNodeChildrenRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.TreeNodeChildrenRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.NodeId != null)
                        message.NodeId = String(object.NodeId);
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    switch (object.Mode) {
                    case "TreeNodeChildrenModes_Both":
                    case 0:
                        message.Mode = 0;
                        break;
                    case "TreeNodeChildrenModes_Forms":
                    case 1:
                        message.Mode = 1;
                        break;
                    case "TreeNodeChildrenModes_Columns":
                    case 2:
                        message.Mode = 2;
                        break;
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a TreeNodeChildrenRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @static
                 * @param {priority.netitems.nrest.TreeNodeChildrenRq} message TreeNodeChildrenRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TreeNodeChildrenRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.NodeId = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                        object.Mode = options.enums === String ? "TreeNodeChildrenModes_Both" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.NodeId != null && message.hasOwnProperty("NodeId"))
                        object.NodeId = message.NodeId;
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    if (message.Mode != null && message.hasOwnProperty("Mode"))
                        object.Mode = options.enums === String ? $root.priority.netitems.nrest.TreeNodeChildrenModes[message.Mode] : message.Mode;
                    return object;
                };

                /**
                 * Converts this TreeNodeChildrenRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TreeNodeChildrenRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TreeNodeChildrenRq;
            })();

            /**
             * TreeNodeTypes enum.
             * @name priority.netitems.nrest.TreeNodeTypes
             * @enum {number}
             * @property {number} TreeNodeTypes_Form=0 TreeNodeTypes_Form value
             * @property {number} TreeNodeTypes_Column=1 TreeNodeTypes_Column value
             */
            nrest.TreeNodeTypes = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "TreeNodeTypes_Form"] = 0;
                values[valuesById[1] = "TreeNodeTypes_Column"] = 1;
                return values;
            })();

            nrest.TreeNode = (function() {

                /**
                 * Properties of a TreeNode.
                 * @memberof priority.netitems.nrest
                 * @interface ITreeNode
                 * @property {string|null} [NodeId] TreeNode NodeId
                 * @property {string|null} [Title] TreeNode Title
                 * @property {boolean|null} [Selected] TreeNode Selected
                 * @property {priority.netitems.nrest.TreeNodeTypes|null} [Type] TreeNode Type
                 * @property {string|null} [ZoomFormNodeId] TreeNode ZoomFormNodeId
                 * @property {string|null} [FormTitle] TreeNode FormTitle
                 * @property {string|null} [OrigTitle] TreeNode OrigTitle
                 * @property {number|Long|null} [FormId] TreeNode FormId
                 * @property {string|null} [FormName] TreeNode FormName
                 */

                /**
                 * Constructs a new TreeNode.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a TreeNode.
                 * @implements ITreeNode
                 * @constructor
                 * @param {priority.netitems.nrest.ITreeNode=} [properties] Properties to set
                 */
                function TreeNode(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TreeNode NodeId.
                 * @member {string} NodeId
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.NodeId = "";

                /**
                 * TreeNode Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.Title = "";

                /**
                 * TreeNode Selected.
                 * @member {boolean} Selected
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.Selected = false;

                /**
                 * TreeNode Type.
                 * @member {priority.netitems.nrest.TreeNodeTypes} Type
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.Type = 0;

                /**
                 * TreeNode ZoomFormNodeId.
                 * @member {string} ZoomFormNodeId
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.ZoomFormNodeId = "";

                /**
                 * TreeNode FormTitle.
                 * @member {string} FormTitle
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.FormTitle = "";

                /**
                 * TreeNode OrigTitle.
                 * @member {string} OrigTitle
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.OrigTitle = "";

                /**
                 * TreeNode FormId.
                 * @member {number|Long} FormId
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.FormId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * TreeNode FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 */
                TreeNode.prototype.FormName = "";

                /**
                 * Creates a new TreeNode instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.TreeNode
                 * @static
                 * @param {priority.netitems.nrest.ITreeNode=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.TreeNode} TreeNode instance
                 */
                TreeNode.create = function create(properties) {
                    return new TreeNode(properties);
                };

                /**
                 * Encodes the specified TreeNode message. Does not implicitly {@link priority.netitems.nrest.TreeNode.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.TreeNode
                 * @static
                 * @param {priority.netitems.nrest.ITreeNode} message TreeNode message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TreeNode.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.NodeId != null && Object.hasOwnProperty.call(message, "NodeId"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.NodeId);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.Selected != null && Object.hasOwnProperty.call(message, "Selected"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.Selected);
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Type);
                    if (message.ZoomFormNodeId != null && Object.hasOwnProperty.call(message, "ZoomFormNodeId"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.ZoomFormNodeId);
                    if (message.FormTitle != null && Object.hasOwnProperty.call(message, "FormTitle"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.FormTitle);
                    if (message.OrigTitle != null && Object.hasOwnProperty.call(message, "OrigTitle"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.OrigTitle);
                    if (message.FormId != null && Object.hasOwnProperty.call(message, "FormId"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.FormId);
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 9, wireType 2 =*/74).string(message.FormName);
                    return writer;
                };

                /**
                 * Encodes the specified TreeNode message, length delimited. Does not implicitly {@link priority.netitems.nrest.TreeNode.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.TreeNode
                 * @static
                 * @param {priority.netitems.nrest.ITreeNode} message TreeNode message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TreeNode.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TreeNode message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.TreeNode
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.TreeNode} TreeNode
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TreeNode.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.TreeNode();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.NodeId = reader.string();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.Selected = reader.bool();
                            break;
                        case 4:
                            message.Type = reader.int32();
                            break;
                        case 5:
                            message.ZoomFormNodeId = reader.string();
                            break;
                        case 6:
                            message.FormTitle = reader.string();
                            break;
                        case 7:
                            message.OrigTitle = reader.string();
                            break;
                        case 8:
                            message.FormId = reader.int64();
                            break;
                        case 9:
                            message.FormName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TreeNode message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.TreeNode
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.TreeNode} TreeNode
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TreeNode.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TreeNode message.
                 * @function verify
                 * @memberof priority.netitems.nrest.TreeNode
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TreeNode.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.NodeId != null && message.hasOwnProperty("NodeId"))
                        if (!$util.isString(message.NodeId))
                            return "NodeId: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Selected != null && message.hasOwnProperty("Selected"))
                        if (typeof message.Selected !== "boolean")
                            return "Selected: boolean expected";
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        switch (message.Type) {
                        default:
                            return "Type: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.ZoomFormNodeId != null && message.hasOwnProperty("ZoomFormNodeId"))
                        if (!$util.isString(message.ZoomFormNodeId))
                            return "ZoomFormNodeId: string expected";
                    if (message.FormTitle != null && message.hasOwnProperty("FormTitle"))
                        if (!$util.isString(message.FormTitle))
                            return "FormTitle: string expected";
                    if (message.OrigTitle != null && message.hasOwnProperty("OrigTitle"))
                        if (!$util.isString(message.OrigTitle))
                            return "OrigTitle: string expected";
                    if (message.FormId != null && message.hasOwnProperty("FormId"))
                        if (!$util.isInteger(message.FormId) && !(message.FormId && $util.isInteger(message.FormId.low) && $util.isInteger(message.FormId.high)))
                            return "FormId: integer|Long expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    return null;
                };

                /**
                 * Creates a TreeNode message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.TreeNode
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.TreeNode} TreeNode
                 */
                TreeNode.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.TreeNode)
                        return object;
                    var message = new $root.priority.netitems.nrest.TreeNode();
                    if (object.NodeId != null)
                        message.NodeId = String(object.NodeId);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Selected != null)
                        message.Selected = Boolean(object.Selected);
                    switch (object.Type) {
                    case "TreeNodeTypes_Form":
                    case 0:
                        message.Type = 0;
                        break;
                    case "TreeNodeTypes_Column":
                    case 1:
                        message.Type = 1;
                        break;
                    }
                    if (object.ZoomFormNodeId != null)
                        message.ZoomFormNodeId = String(object.ZoomFormNodeId);
                    if (object.FormTitle != null)
                        message.FormTitle = String(object.FormTitle);
                    if (object.OrigTitle != null)
                        message.OrigTitle = String(object.OrigTitle);
                    if (object.FormId != null)
                        if ($util.Long)
                            (message.FormId = $util.Long.fromValue(object.FormId)).unsigned = false;
                        else if (typeof object.FormId === "string")
                            message.FormId = parseInt(object.FormId, 10);
                        else if (typeof object.FormId === "number")
                            message.FormId = object.FormId;
                        else if (typeof object.FormId === "object")
                            message.FormId = new $util.LongBits(object.FormId.low >>> 0, object.FormId.high >>> 0).toNumber();
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    return message;
                };

                /**
                 * Creates a plain object from a TreeNode message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.TreeNode
                 * @static
                 * @param {priority.netitems.nrest.TreeNode} message TreeNode
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TreeNode.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.NodeId = "";
                        object.Title = "";
                        object.Selected = false;
                        object.Type = options.enums === String ? "TreeNodeTypes_Form" : 0;
                        object.ZoomFormNodeId = "";
                        object.FormTitle = "";
                        object.OrigTitle = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.FormId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.FormId = options.longs === String ? "0" : 0;
                        object.FormName = "";
                    }
                    if (message.NodeId != null && message.hasOwnProperty("NodeId"))
                        object.NodeId = message.NodeId;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Selected != null && message.hasOwnProperty("Selected"))
                        object.Selected = message.Selected;
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        object.Type = options.enums === String ? $root.priority.netitems.nrest.TreeNodeTypes[message.Type] : message.Type;
                    if (message.ZoomFormNodeId != null && message.hasOwnProperty("ZoomFormNodeId"))
                        object.ZoomFormNodeId = message.ZoomFormNodeId;
                    if (message.FormTitle != null && message.hasOwnProperty("FormTitle"))
                        object.FormTitle = message.FormTitle;
                    if (message.OrigTitle != null && message.hasOwnProperty("OrigTitle"))
                        object.OrigTitle = message.OrigTitle;
                    if (message.FormId != null && message.hasOwnProperty("FormId"))
                        if (typeof message.FormId === "number")
                            object.FormId = options.longs === String ? String(message.FormId) : message.FormId;
                        else
                            object.FormId = options.longs === String ? $util.Long.prototype.toString.call(message.FormId) : options.longs === Number ? new $util.LongBits(message.FormId.low >>> 0, message.FormId.high >>> 0).toNumber() : message.FormId;
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    return object;
                };

                /**
                 * Converts this TreeNode to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.TreeNode
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TreeNode.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TreeNode;
            })();

            nrest.TreeNodeChildrenRs = (function() {

                /**
                 * Properties of a TreeNodeChildrenRs.
                 * @memberof priority.netitems.nrest
                 * @interface ITreeNodeChildrenRs
                 * @property {Array.<priority.netitems.nrest.ITreeNode>|null} [TreeNode] TreeNodeChildrenRs TreeNode
                 * @property {Array.<priority.netitems.nrest.ITreeNode>|null} [SelectedColsInReport] TreeNodeChildrenRs SelectedColsInReport
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] TreeNodeChildrenRs Messages
                 */

                /**
                 * Constructs a new TreeNodeChildrenRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a TreeNodeChildrenRs.
                 * @implements ITreeNodeChildrenRs
                 * @constructor
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRs=} [properties] Properties to set
                 */
                function TreeNodeChildrenRs(properties) {
                    this.TreeNode = [];
                    this.SelectedColsInReport = [];
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * TreeNodeChildrenRs TreeNode.
                 * @member {Array.<priority.netitems.nrest.ITreeNode>} TreeNode
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @instance
                 */
                TreeNodeChildrenRs.prototype.TreeNode = $util.emptyArray;

                /**
                 * TreeNodeChildrenRs SelectedColsInReport.
                 * @member {Array.<priority.netitems.nrest.ITreeNode>} SelectedColsInReport
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @instance
                 */
                TreeNodeChildrenRs.prototype.SelectedColsInReport = $util.emptyArray;

                /**
                 * TreeNodeChildrenRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @instance
                 */
                TreeNodeChildrenRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new TreeNodeChildrenRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @static
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.TreeNodeChildrenRs} TreeNodeChildrenRs instance
                 */
                TreeNodeChildrenRs.create = function create(properties) {
                    return new TreeNodeChildrenRs(properties);
                };

                /**
                 * Encodes the specified TreeNodeChildrenRs message. Does not implicitly {@link priority.netitems.nrest.TreeNodeChildrenRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @static
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRs} message TreeNodeChildrenRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TreeNodeChildrenRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.TreeNode != null && message.TreeNode.length)
                        for (var i = 0; i < message.TreeNode.length; ++i)
                            $root.priority.netitems.nrest.TreeNode.encode(message.TreeNode[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.SelectedColsInReport != null && message.SelectedColsInReport.length)
                        for (var i = 0; i < message.SelectedColsInReport.length; ++i)
                            $root.priority.netitems.nrest.TreeNode.encode(message.SelectedColsInReport[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified TreeNodeChildrenRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.TreeNodeChildrenRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @static
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRs} message TreeNodeChildrenRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                TreeNodeChildrenRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a TreeNodeChildrenRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.TreeNodeChildrenRs} TreeNodeChildrenRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TreeNodeChildrenRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.TreeNodeChildrenRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.TreeNode && message.TreeNode.length))
                                message.TreeNode = [];
                            message.TreeNode.push($root.priority.netitems.nrest.TreeNode.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.SelectedColsInReport && message.SelectedColsInReport.length))
                                message.SelectedColsInReport = [];
                            message.SelectedColsInReport.push($root.priority.netitems.nrest.TreeNode.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a TreeNodeChildrenRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.TreeNodeChildrenRs} TreeNodeChildrenRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                TreeNodeChildrenRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a TreeNodeChildrenRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                TreeNodeChildrenRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.TreeNode != null && message.hasOwnProperty("TreeNode")) {
                        if (!Array.isArray(message.TreeNode))
                            return "TreeNode: array expected";
                        for (var i = 0; i < message.TreeNode.length; ++i) {
                            var error = $root.priority.netitems.nrest.TreeNode.verify(message.TreeNode[i]);
                            if (error)
                                return "TreeNode." + error;
                        }
                    }
                    if (message.SelectedColsInReport != null && message.hasOwnProperty("SelectedColsInReport")) {
                        if (!Array.isArray(message.SelectedColsInReport))
                            return "SelectedColsInReport: array expected";
                        for (var i = 0; i < message.SelectedColsInReport.length; ++i) {
                            var error = $root.priority.netitems.nrest.TreeNode.verify(message.SelectedColsInReport[i]);
                            if (error)
                                return "SelectedColsInReport." + error;
                        }
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a TreeNodeChildrenRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.TreeNodeChildrenRs} TreeNodeChildrenRs
                 */
                TreeNodeChildrenRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.TreeNodeChildrenRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.TreeNodeChildrenRs();
                    if (object.TreeNode) {
                        if (!Array.isArray(object.TreeNode))
                            throw TypeError(".priority.netitems.nrest.TreeNodeChildrenRs.TreeNode: array expected");
                        message.TreeNode = [];
                        for (var i = 0; i < object.TreeNode.length; ++i) {
                            if (typeof object.TreeNode[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.TreeNodeChildrenRs.TreeNode: object expected");
                            message.TreeNode[i] = $root.priority.netitems.nrest.TreeNode.fromObject(object.TreeNode[i]);
                        }
                    }
                    if (object.SelectedColsInReport) {
                        if (!Array.isArray(object.SelectedColsInReport))
                            throw TypeError(".priority.netitems.nrest.TreeNodeChildrenRs.SelectedColsInReport: array expected");
                        message.SelectedColsInReport = [];
                        for (var i = 0; i < object.SelectedColsInReport.length; ++i) {
                            if (typeof object.SelectedColsInReport[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.TreeNodeChildrenRs.SelectedColsInReport: object expected");
                            message.SelectedColsInReport[i] = $root.priority.netitems.nrest.TreeNode.fromObject(object.SelectedColsInReport[i]);
                        }
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.TreeNodeChildrenRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.TreeNodeChildrenRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a TreeNodeChildrenRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @static
                 * @param {priority.netitems.nrest.TreeNodeChildrenRs} message TreeNodeChildrenRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                TreeNodeChildrenRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.TreeNode = [];
                        object.SelectedColsInReport = [];
                        object.Messages = [];
                    }
                    if (message.TreeNode && message.TreeNode.length) {
                        object.TreeNode = [];
                        for (var j = 0; j < message.TreeNode.length; ++j)
                            object.TreeNode[j] = $root.priority.netitems.nrest.TreeNode.toObject(message.TreeNode[j], options);
                    }
                    if (message.SelectedColsInReport && message.SelectedColsInReport.length) {
                        object.SelectedColsInReport = [];
                        for (var j = 0; j < message.SelectedColsInReport.length; ++j)
                            object.SelectedColsInReport[j] = $root.priority.netitems.nrest.TreeNode.toObject(message.SelectedColsInReport[j], options);
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this TreeNodeChildrenRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.TreeNodeChildrenRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                TreeNodeChildrenRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return TreeNodeChildrenRs;
            })();

            nrest.FormField = (function() {

                /**
                 * Properties of a FormField.
                 * @memberof priority.netitems.nrest
                 * @interface IFormField
                 * @property {string|null} [Name] FormField Name
                 * @property {string|null} [Title] FormField Title
                 * @property {string|null} [Id] FormField Id
                 */

                /**
                 * Constructs a new FormField.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a FormField.
                 * @implements IFormField
                 * @constructor
                 * @param {priority.netitems.nrest.IFormField=} [properties] Properties to set
                 */
                function FormField(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FormField Name.
                 * @member {string} Name
                 * @memberof priority.netitems.nrest.FormField
                 * @instance
                 */
                FormField.prototype.Name = "";

                /**
                 * FormField Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.FormField
                 * @instance
                 */
                FormField.prototype.Title = "";

                /**
                 * FormField Id.
                 * @member {string} Id
                 * @memberof priority.netitems.nrest.FormField
                 * @instance
                 */
                FormField.prototype.Id = "";

                /**
                 * Creates a new FormField instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.FormField
                 * @static
                 * @param {priority.netitems.nrest.IFormField=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.FormField} FormField instance
                 */
                FormField.create = function create(properties) {
                    return new FormField(properties);
                };

                /**
                 * Encodes the specified FormField message. Does not implicitly {@link priority.netitems.nrest.FormField.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.FormField
                 * @static
                 * @param {priority.netitems.nrest.IFormField} message FormField message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormField.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Name);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Id);
                    return writer;
                };

                /**
                 * Encodes the specified FormField message, length delimited. Does not implicitly {@link priority.netitems.nrest.FormField.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.FormField
                 * @static
                 * @param {priority.netitems.nrest.IFormField} message FormField message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormField.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FormField message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.FormField
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.FormField} FormField
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormField.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.FormField();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Name = reader.string();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.Id = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FormField message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.FormField
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.FormField} FormField
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormField.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FormField message.
                 * @function verify
                 * @memberof priority.netitems.nrest.FormField
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FormField.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (!$util.isString(message.Id))
                            return "Id: string expected";
                    return null;
                };

                /**
                 * Creates a FormField message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.FormField
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.FormField} FormField
                 */
                FormField.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.FormField)
                        return object;
                    var message = new $root.priority.netitems.nrest.FormField();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Id != null)
                        message.Id = String(object.Id);
                    return message;
                };

                /**
                 * Creates a plain object from a FormField message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.FormField
                 * @static
                 * @param {priority.netitems.nrest.FormField} message FormField
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FormField.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Name = "";
                        object.Title = "";
                        object.Id = "";
                    }
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        object.Id = message.Id;
                    return object;
                };

                /**
                 * Converts this FormField to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.FormField
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FormField.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FormField;
            })();

            nrest.FormsTreeNode = (function() {

                /**
                 * Properties of a FormsTreeNode.
                 * @memberof priority.netitems.nrest
                 * @interface IFormsTreeNode
                 * @property {string|null} [Name] FormsTreeNode Name
                 * @property {string|null} [Title] FormsTreeNode Title
                 * @property {string|null} [Id] FormsTreeNode Id
                 * @property {Array.<priority.netitems.nrest.IFormsTreeNode>|null} [Form] FormsTreeNode Form
                 * @property {Array.<priority.netitems.nrest.IFormField>|null} [Field] FormsTreeNode Field
                 */

                /**
                 * Constructs a new FormsTreeNode.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a FormsTreeNode.
                 * @implements IFormsTreeNode
                 * @constructor
                 * @param {priority.netitems.nrest.IFormsTreeNode=} [properties] Properties to set
                 */
                function FormsTreeNode(properties) {
                    this.Form = [];
                    this.Field = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FormsTreeNode Name.
                 * @member {string} Name
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @instance
                 */
                FormsTreeNode.prototype.Name = "";

                /**
                 * FormsTreeNode Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @instance
                 */
                FormsTreeNode.prototype.Title = "";

                /**
                 * FormsTreeNode Id.
                 * @member {string} Id
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @instance
                 */
                FormsTreeNode.prototype.Id = "";

                /**
                 * FormsTreeNode Form.
                 * @member {Array.<priority.netitems.nrest.IFormsTreeNode>} Form
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @instance
                 */
                FormsTreeNode.prototype.Form = $util.emptyArray;

                /**
                 * FormsTreeNode Field.
                 * @member {Array.<priority.netitems.nrest.IFormField>} Field
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @instance
                 */
                FormsTreeNode.prototype.Field = $util.emptyArray;

                /**
                 * Creates a new FormsTreeNode instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeNode=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.FormsTreeNode} FormsTreeNode instance
                 */
                FormsTreeNode.create = function create(properties) {
                    return new FormsTreeNode(properties);
                };

                /**
                 * Encodes the specified FormsTreeNode message. Does not implicitly {@link priority.netitems.nrest.FormsTreeNode.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeNode} message FormsTreeNode message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormsTreeNode.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Name);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Id);
                    if (message.Form != null && message.Form.length)
                        for (var i = 0; i < message.Form.length; ++i)
                            $root.priority.netitems.nrest.FormsTreeNode.encode(message.Form[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.Field != null && message.Field.length)
                        for (var i = 0; i < message.Field.length; ++i)
                            $root.priority.netitems.nrest.FormField.encode(message.Field[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FormsTreeNode message, length delimited. Does not implicitly {@link priority.netitems.nrest.FormsTreeNode.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeNode} message FormsTreeNode message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormsTreeNode.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FormsTreeNode message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.FormsTreeNode} FormsTreeNode
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormsTreeNode.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.FormsTreeNode();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Name = reader.string();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.Id = reader.string();
                            break;
                        case 4:
                            if (!(message.Form && message.Form.length))
                                message.Form = [];
                            message.Form.push($root.priority.netitems.nrest.FormsTreeNode.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            if (!(message.Field && message.Field.length))
                                message.Field = [];
                            message.Field.push($root.priority.netitems.nrest.FormField.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FormsTreeNode message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.FormsTreeNode} FormsTreeNode
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormsTreeNode.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FormsTreeNode message.
                 * @function verify
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FormsTreeNode.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (!$util.isString(message.Id))
                            return "Id: string expected";
                    if (message.Form != null && message.hasOwnProperty("Form")) {
                        if (!Array.isArray(message.Form))
                            return "Form: array expected";
                        for (var i = 0; i < message.Form.length; ++i) {
                            var error = $root.priority.netitems.nrest.FormsTreeNode.verify(message.Form[i]);
                            if (error)
                                return "Form." + error;
                        }
                    }
                    if (message.Field != null && message.hasOwnProperty("Field")) {
                        if (!Array.isArray(message.Field))
                            return "Field: array expected";
                        for (var i = 0; i < message.Field.length; ++i) {
                            var error = $root.priority.netitems.nrest.FormField.verify(message.Field[i]);
                            if (error)
                                return "Field." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a FormsTreeNode message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.FormsTreeNode} FormsTreeNode
                 */
                FormsTreeNode.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.FormsTreeNode)
                        return object;
                    var message = new $root.priority.netitems.nrest.FormsTreeNode();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Id != null)
                        message.Id = String(object.Id);
                    if (object.Form) {
                        if (!Array.isArray(object.Form))
                            throw TypeError(".priority.netitems.nrest.FormsTreeNode.Form: array expected");
                        message.Form = [];
                        for (var i = 0; i < object.Form.length; ++i) {
                            if (typeof object.Form[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.FormsTreeNode.Form: object expected");
                            message.Form[i] = $root.priority.netitems.nrest.FormsTreeNode.fromObject(object.Form[i]);
                        }
                    }
                    if (object.Field) {
                        if (!Array.isArray(object.Field))
                            throw TypeError(".priority.netitems.nrest.FormsTreeNode.Field: array expected");
                        message.Field = [];
                        for (var i = 0; i < object.Field.length; ++i) {
                            if (typeof object.Field[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.FormsTreeNode.Field: object expected");
                            message.Field[i] = $root.priority.netitems.nrest.FormField.fromObject(object.Field[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FormsTreeNode message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @static
                 * @param {priority.netitems.nrest.FormsTreeNode} message FormsTreeNode
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FormsTreeNode.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Form = [];
                        object.Field = [];
                    }
                    if (options.defaults) {
                        object.Name = "";
                        object.Title = "";
                        object.Id = "";
                    }
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        object.Id = message.Id;
                    if (message.Form && message.Form.length) {
                        object.Form = [];
                        for (var j = 0; j < message.Form.length; ++j)
                            object.Form[j] = $root.priority.netitems.nrest.FormsTreeNode.toObject(message.Form[j], options);
                    }
                    if (message.Field && message.Field.length) {
                        object.Field = [];
                        for (var j = 0; j < message.Field.length; ++j)
                            object.Field[j] = $root.priority.netitems.nrest.FormField.toObject(message.Field[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this FormsTreeNode to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.FormsTreeNode
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FormsTreeNode.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FormsTreeNode;
            })();

            nrest.FormsTreeRq = (function() {

                /**
                 * Properties of a FormsTreeRq.
                 * @memberof priority.netitems.nrest
                 * @interface IFormsTreeRq
                 * @property {string|null} [Form] FormsTreeRq Form
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] FormsTreeRq Properties
                 */

                /**
                 * Constructs a new FormsTreeRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a FormsTreeRq.
                 * @implements IFormsTreeRq
                 * @constructor
                 * @param {priority.netitems.nrest.IFormsTreeRq=} [properties] Properties to set
                 */
                function FormsTreeRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FormsTreeRq Form.
                 * @member {string} Form
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @instance
                 */
                FormsTreeRq.prototype.Form = "";

                /**
                 * FormsTreeRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @instance
                 */
                FormsTreeRq.prototype.Properties = null;

                /**
                 * Creates a new FormsTreeRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.FormsTreeRq} FormsTreeRq instance
                 */
                FormsTreeRq.create = function create(properties) {
                    return new FormsTreeRq(properties);
                };

                /**
                 * Encodes the specified FormsTreeRq message. Does not implicitly {@link priority.netitems.nrest.FormsTreeRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeRq} message FormsTreeRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormsTreeRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Form != null && Object.hasOwnProperty.call(message, "Form"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Form);
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FormsTreeRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.FormsTreeRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeRq} message FormsTreeRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormsTreeRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FormsTreeRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.FormsTreeRq} FormsTreeRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormsTreeRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.FormsTreeRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Form = reader.string();
                            break;
                        case 2:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FormsTreeRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.FormsTreeRq} FormsTreeRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormsTreeRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FormsTreeRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FormsTreeRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Form != null && message.hasOwnProperty("Form"))
                        if (!$util.isString(message.Form))
                            return "Form: string expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a FormsTreeRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.FormsTreeRq} FormsTreeRq
                 */
                FormsTreeRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.FormsTreeRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.FormsTreeRq();
                    if (object.Form != null)
                        message.Form = String(object.Form);
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.FormsTreeRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FormsTreeRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @static
                 * @param {priority.netitems.nrest.FormsTreeRq} message FormsTreeRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FormsTreeRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Form = "";
                        object.Properties = null;
                    }
                    if (message.Form != null && message.hasOwnProperty("Form"))
                        object.Form = message.Form;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this FormsTreeRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.FormsTreeRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FormsTreeRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FormsTreeRq;
            })();

            nrest.FormsTreeRs = (function() {

                /**
                 * Properties of a FormsTreeRs.
                 * @memberof priority.netitems.nrest
                 * @interface IFormsTreeRs
                 * @property {Array.<priority.netitems.nrest.IFormsTreeNode>|null} [Form] FormsTreeRs Form
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] FormsTreeRs Messages
                 */

                /**
                 * Constructs a new FormsTreeRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a FormsTreeRs.
                 * @implements IFormsTreeRs
                 * @constructor
                 * @param {priority.netitems.nrest.IFormsTreeRs=} [properties] Properties to set
                 */
                function FormsTreeRs(properties) {
                    this.Form = [];
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * FormsTreeRs Form.
                 * @member {Array.<priority.netitems.nrest.IFormsTreeNode>} Form
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @instance
                 */
                FormsTreeRs.prototype.Form = $util.emptyArray;

                /**
                 * FormsTreeRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @instance
                 */
                FormsTreeRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new FormsTreeRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.FormsTreeRs} FormsTreeRs instance
                 */
                FormsTreeRs.create = function create(properties) {
                    return new FormsTreeRs(properties);
                };

                /**
                 * Encodes the specified FormsTreeRs message. Does not implicitly {@link priority.netitems.nrest.FormsTreeRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeRs} message FormsTreeRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormsTreeRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Form != null && message.Form.length)
                        for (var i = 0; i < message.Form.length; ++i)
                            $root.priority.netitems.nrest.FormsTreeNode.encode(message.Form[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified FormsTreeRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.FormsTreeRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @static
                 * @param {priority.netitems.nrest.IFormsTreeRs} message FormsTreeRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FormsTreeRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a FormsTreeRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.FormsTreeRs} FormsTreeRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormsTreeRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.FormsTreeRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Form && message.Form.length))
                                message.Form = [];
                            message.Form.push($root.priority.netitems.nrest.FormsTreeNode.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a FormsTreeRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.FormsTreeRs} FormsTreeRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FormsTreeRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a FormsTreeRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FormsTreeRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Form != null && message.hasOwnProperty("Form")) {
                        if (!Array.isArray(message.Form))
                            return "Form: array expected";
                        for (var i = 0; i < message.Form.length; ++i) {
                            var error = $root.priority.netitems.nrest.FormsTreeNode.verify(message.Form[i]);
                            if (error)
                                return "Form." + error;
                        }
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a FormsTreeRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.FormsTreeRs} FormsTreeRs
                 */
                FormsTreeRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.FormsTreeRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.FormsTreeRs();
                    if (object.Form) {
                        if (!Array.isArray(object.Form))
                            throw TypeError(".priority.netitems.nrest.FormsTreeRs.Form: array expected");
                        message.Form = [];
                        for (var i = 0; i < object.Form.length; ++i) {
                            if (typeof object.Form[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.FormsTreeRs.Form: object expected");
                            message.Form[i] = $root.priority.netitems.nrest.FormsTreeNode.fromObject(object.Form[i]);
                        }
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.FormsTreeRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.FormsTreeRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a FormsTreeRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @static
                 * @param {priority.netitems.nrest.FormsTreeRs} message FormsTreeRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FormsTreeRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Form = [];
                        object.Messages = [];
                    }
                    if (message.Form && message.Form.length) {
                        object.Form = [];
                        for (var j = 0; j < message.Form.length; ++j)
                            object.Form[j] = $root.priority.netitems.nrest.FormsTreeNode.toObject(message.Form[j], options);
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this FormsTreeRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.FormsTreeRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FormsTreeRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return FormsTreeRs;
            })();

            /**
             * RepColHeaderModes enum.
             * @name priority.netitems.nrest.RepColHeaderModes
             * @enum {number}
             * @property {number} RepColHeaderModes_None=0 RepColHeaderModes_None value
             * @property {number} RepColHeaderModes_NewHeader=1 RepColHeaderModes_NewHeader value
             * @property {number} RepColHeaderModes_AppendToHeader=2 RepColHeaderModes_AppendToHeader value
             */
            nrest.RepColHeaderModes = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "RepColHeaderModes_None"] = 0;
                values[valuesById[1] = "RepColHeaderModes_NewHeader"] = 1;
                values[valuesById[2] = "RepColHeaderModes_AppendToHeader"] = 2;
                return values;
            })();

            /**
             * RepColFunc enum.
             * @name priority.netitems.nrest.RepColFunc
             * @enum {number}
             * @property {number} RepColFunc_None=0 RepColFunc_None value
             * @property {number} RepColFunc_Sum=1 RepColFunc_Sum value
             * @property {number} RepColFunc_Avg=2 RepColFunc_Avg value
             * @property {number} RepColFunc_Max=3 RepColFunc_Max value
             * @property {number} RepColFunc_Min=4 RepColFunc_Min value
             */
            nrest.RepColFunc = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "RepColFunc_None"] = 0;
                values[valuesById[1] = "RepColFunc_Sum"] = 1;
                values[valuesById[2] = "RepColFunc_Avg"] = 2;
                values[valuesById[3] = "RepColFunc_Max"] = 3;
                values[valuesById[4] = "RepColFunc_Min"] = 4;
                return values;
            })();

            /**
             * RepGroupFunc enum.
             * @name priority.netitems.nrest.RepGroupFunc
             * @enum {number}
             * @property {number} RepGroupFunc_None=0 RepGroupFunc_None value
             * @property {number} RepGroupFunc_Group=1 RepGroupFunc_Group value
             * @property {number} RepGroupFunc_Report=2 RepGroupFunc_Report value
             * @property {number} RepGroupFunc_Both=3 RepGroupFunc_Both value
             * @property {number} RepGroupFunc_RepeatValue=4 RepGroupFunc_RepeatValue value
             */
            nrest.RepGroupFunc = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "RepGroupFunc_None"] = 0;
                values[valuesById[1] = "RepGroupFunc_Group"] = 1;
                values[valuesById[2] = "RepGroupFunc_Report"] = 2;
                values[valuesById[3] = "RepGroupFunc_Both"] = 3;
                values[valuesById[4] = "RepGroupFunc_RepeatValue"] = 4;
                return values;
            })();

            /**
             * RepColAxisMode enum.
             * @name priority.netitems.nrest.RepColAxisMode
             * @enum {number}
             * @property {number} RepColAxisMode_None=0 RepColAxisMode_None value
             * @property {number} RepColAxisMode_X=1 RepColAxisMode_X value
             * @property {number} RepColAxisMode_OrderBy=2 RepColAxisMode_OrderBy value
             * @property {number} RepColAxisMode_InTableOnly=3 RepColAxisMode_InTableOnly value
             */
            nrest.RepColAxisMode = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "RepColAxisMode_None"] = 0;
                values[valuesById[1] = "RepColAxisMode_X"] = 1;
                values[valuesById[2] = "RepColAxisMode_OrderBy"] = 2;
                values[valuesById[3] = "RepColAxisMode_InTableOnly"] = 3;
                return values;
            })();

            /**
             * RepColSortType enum.
             * @name priority.netitems.nrest.RepColSortType
             * @enum {number}
             * @property {number} RepColSortType_None=0 RepColSortType_None value
             * @property {number} RepColSortType_Ascending=1 RepColSortType_Ascending value
             * @property {number} RepColSortType_Descending=2 RepColSortType_Descending value
             * @property {number} RepColSortType_AlphanumericAscending=3 RepColSortType_AlphanumericAscending value
             * @property {number} RepColSortType_AlphanumericDescending=4 RepColSortType_AlphanumericDescending value
             */
            nrest.RepColSortType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "RepColSortType_None"] = 0;
                values[valuesById[1] = "RepColSortType_Ascending"] = 1;
                values[valuesById[2] = "RepColSortType_Descending"] = 2;
                values[valuesById[3] = "RepColSortType_AlphanumericAscending"] = 3;
                values[valuesById[4] = "RepColSortType_AlphanumericDescending"] = 4;
                return values;
            })();

            nrest.ReportCol = (function() {

                /**
                 * Properties of a ReportCol.
                 * @memberof priority.netitems.nrest
                 * @interface IReportCol
                 * @property {number|Long|null} [ColId] ReportCol ColId
                 * @property {string|null} [Title] ReportCol Title
                 * @property {number|Long|null} [Width] ReportCol Width
                 * @property {boolean|null} [Input] ReportCol Input
                 * @property {number|Long|null} [Group] ReportCol Group
                 * @property {priority.netitems.nrest.RepColHeaderModes|null} [Header] ReportCol Header
                 * @property {boolean|null} [Xaxis] ReportCol Xaxis
                 * @property {boolean|null} [Hide] ReportCol Hide
                 * @property {number|Long|null} [Sort] ReportCol Sort
                 * @property {string|null} [Expr] ReportCol Expr
                 * @property {boolean|null} [IsExpression] ReportCol IsExpression
                 * @property {boolean|null} [IsCompany] ReportCol IsCompany
                 * @property {priority.netitems.form.ColumnType|null} [Type] ReportCol Type
                 * @property {priority.netitems.nrest.RepColFunc|null} [Func] ReportCol Func
                 * @property {number|Long|null} [DateFormat] ReportCol DateFormat
                 * @property {string|null} [NodeId] ReportCol NodeId
                 * @property {string|null} [OrigTitle] ReportCol OrigTitle
                 * @property {string|null} [FormTitle] ReportCol FormTitle
                 * @property {priority.netitems.nrest.RepGroupFunc|null} [GroupFunc] ReportCol GroupFunc
                 * @property {number|Long|null} [NumericFormat] ReportCol NumericFormat
                 * @property {priority.netitems.nrest.RepColAxisMode|null} [AxisMode] ReportCol AxisMode
                 * @property {priority.netitems.nrest.RepColSortType|null} [SortType] ReportCol SortType
                 * @property {boolean|null} [ShowMineEnabled] ReportCol ShowMineEnabled
                 * @property {boolean|null} [ShowMine] ReportCol ShowMine
                 * @property {string|null} [DateFunc] ReportCol DateFunc
                 */

                /**
                 * Constructs a new ReportCol.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportCol.
                 * @implements IReportCol
                 * @constructor
                 * @param {priority.netitems.nrest.IReportCol=} [properties] Properties to set
                 */
                function ReportCol(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportCol ColId.
                 * @member {number|Long} ColId
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.ColId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportCol Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Title = "";

                /**
                 * ReportCol Width.
                 * @member {number|Long} Width
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Width = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportCol Input.
                 * @member {boolean} Input
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Input = false;

                /**
                 * ReportCol Group.
                 * @member {number|Long} Group
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Group = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportCol Header.
                 * @member {priority.netitems.nrest.RepColHeaderModes} Header
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Header = 0;

                /**
                 * ReportCol Xaxis.
                 * @member {boolean} Xaxis
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Xaxis = false;

                /**
                 * ReportCol Hide.
                 * @member {boolean} Hide
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Hide = false;

                /**
                 * ReportCol Sort.
                 * @member {number|Long} Sort
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Sort = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportCol Expr.
                 * @member {string} Expr
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Expr = "";

                /**
                 * ReportCol IsExpression.
                 * @member {boolean} IsExpression
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.IsExpression = false;

                /**
                 * ReportCol IsCompany.
                 * @member {boolean} IsCompany
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.IsCompany = false;

                /**
                 * ReportCol Type.
                 * @member {priority.netitems.form.ColumnType} Type
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Type = 0;

                /**
                 * ReportCol Func.
                 * @member {priority.netitems.nrest.RepColFunc} Func
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.Func = 0;

                /**
                 * ReportCol DateFormat.
                 * @member {number|Long} DateFormat
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.DateFormat = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportCol NodeId.
                 * @member {string} NodeId
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.NodeId = "";

                /**
                 * ReportCol OrigTitle.
                 * @member {string} OrigTitle
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.OrigTitle = "";

                /**
                 * ReportCol FormTitle.
                 * @member {string} FormTitle
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.FormTitle = "";

                /**
                 * ReportCol GroupFunc.
                 * @member {priority.netitems.nrest.RepGroupFunc} GroupFunc
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.GroupFunc = 0;

                /**
                 * ReportCol NumericFormat.
                 * @member {number|Long} NumericFormat
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.NumericFormat = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportCol AxisMode.
                 * @member {priority.netitems.nrest.RepColAxisMode} AxisMode
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.AxisMode = 0;

                /**
                 * ReportCol SortType.
                 * @member {priority.netitems.nrest.RepColSortType} SortType
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.SortType = 0;

                /**
                 * ReportCol ShowMineEnabled.
                 * @member {boolean} ShowMineEnabled
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.ShowMineEnabled = false;

                /**
                 * ReportCol ShowMine.
                 * @member {boolean} ShowMine
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.ShowMine = false;

                /**
                 * ReportCol DateFunc.
                 * @member {string} DateFunc
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 */
                ReportCol.prototype.DateFunc = "";

                /**
                 * Creates a new ReportCol instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportCol
                 * @static
                 * @param {priority.netitems.nrest.IReportCol=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportCol} ReportCol instance
                 */
                ReportCol.create = function create(properties) {
                    return new ReportCol(properties);
                };

                /**
                 * Encodes the specified ReportCol message. Does not implicitly {@link priority.netitems.nrest.ReportCol.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportCol
                 * @static
                 * @param {priority.netitems.nrest.IReportCol} message ReportCol message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportCol.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ColId != null && Object.hasOwnProperty.call(message, "ColId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ColId);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.Width != null && Object.hasOwnProperty.call(message, "Width"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.Width);
                    if (message.Input != null && Object.hasOwnProperty.call(message, "Input"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Input);
                    if (message.Group != null && Object.hasOwnProperty.call(message, "Group"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Group);
                    if (message.Header != null && Object.hasOwnProperty.call(message, "Header"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.Header);
                    if (message.Xaxis != null && Object.hasOwnProperty.call(message, "Xaxis"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.Xaxis);
                    if (message.Hide != null && Object.hasOwnProperty.call(message, "Hide"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.Hide);
                    if (message.Sort != null && Object.hasOwnProperty.call(message, "Sort"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.Sort);
                    if (message.Expr != null && Object.hasOwnProperty.call(message, "Expr"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.Expr);
                    if (message.IsExpression != null && Object.hasOwnProperty.call(message, "IsExpression"))
                        writer.uint32(/* id 11, wireType 0 =*/88).bool(message.IsExpression);
                    if (message.IsCompany != null && Object.hasOwnProperty.call(message, "IsCompany"))
                        writer.uint32(/* id 12, wireType 0 =*/96).bool(message.IsCompany);
                    if (message.Type != null && Object.hasOwnProperty.call(message, "Type"))
                        writer.uint32(/* id 13, wireType 0 =*/104).int32(message.Type);
                    if (message.Func != null && Object.hasOwnProperty.call(message, "Func"))
                        writer.uint32(/* id 14, wireType 0 =*/112).int32(message.Func);
                    if (message.DateFormat != null && Object.hasOwnProperty.call(message, "DateFormat"))
                        writer.uint32(/* id 15, wireType 0 =*/120).int64(message.DateFormat);
                    if (message.NodeId != null && Object.hasOwnProperty.call(message, "NodeId"))
                        writer.uint32(/* id 16, wireType 2 =*/130).string(message.NodeId);
                    if (message.OrigTitle != null && Object.hasOwnProperty.call(message, "OrigTitle"))
                        writer.uint32(/* id 17, wireType 2 =*/138).string(message.OrigTitle);
                    if (message.FormTitle != null && Object.hasOwnProperty.call(message, "FormTitle"))
                        writer.uint32(/* id 18, wireType 2 =*/146).string(message.FormTitle);
                    if (message.GroupFunc != null && Object.hasOwnProperty.call(message, "GroupFunc"))
                        writer.uint32(/* id 19, wireType 0 =*/152).int32(message.GroupFunc);
                    if (message.NumericFormat != null && Object.hasOwnProperty.call(message, "NumericFormat"))
                        writer.uint32(/* id 20, wireType 0 =*/160).int64(message.NumericFormat);
                    if (message.AxisMode != null && Object.hasOwnProperty.call(message, "AxisMode"))
                        writer.uint32(/* id 21, wireType 0 =*/168).int32(message.AxisMode);
                    if (message.SortType != null && Object.hasOwnProperty.call(message, "SortType"))
                        writer.uint32(/* id 22, wireType 0 =*/176).int32(message.SortType);
                    if (message.ShowMineEnabled != null && Object.hasOwnProperty.call(message, "ShowMineEnabled"))
                        writer.uint32(/* id 23, wireType 0 =*/184).bool(message.ShowMineEnabled);
                    if (message.ShowMine != null && Object.hasOwnProperty.call(message, "ShowMine"))
                        writer.uint32(/* id 24, wireType 0 =*/192).bool(message.ShowMine);
                    if (message.DateFunc != null && Object.hasOwnProperty.call(message, "DateFunc"))
                        writer.uint32(/* id 25, wireType 2 =*/202).string(message.DateFunc);
                    return writer;
                };

                /**
                 * Encodes the specified ReportCol message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportCol.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportCol
                 * @static
                 * @param {priority.netitems.nrest.IReportCol} message ReportCol message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportCol.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportCol message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportCol
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportCol} ReportCol
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportCol.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportCol();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ColId = reader.int64();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.Width = reader.int64();
                            break;
                        case 4:
                            message.Input = reader.bool();
                            break;
                        case 5:
                            message.Group = reader.int64();
                            break;
                        case 6:
                            message.Header = reader.int32();
                            break;
                        case 7:
                            message.Xaxis = reader.bool();
                            break;
                        case 8:
                            message.Hide = reader.bool();
                            break;
                        case 9:
                            message.Sort = reader.int64();
                            break;
                        case 10:
                            message.Expr = reader.string();
                            break;
                        case 11:
                            message.IsExpression = reader.bool();
                            break;
                        case 12:
                            message.IsCompany = reader.bool();
                            break;
                        case 13:
                            message.Type = reader.int32();
                            break;
                        case 14:
                            message.Func = reader.int32();
                            break;
                        case 15:
                            message.DateFormat = reader.int64();
                            break;
                        case 16:
                            message.NodeId = reader.string();
                            break;
                        case 17:
                            message.OrigTitle = reader.string();
                            break;
                        case 18:
                            message.FormTitle = reader.string();
                            break;
                        case 19:
                            message.GroupFunc = reader.int32();
                            break;
                        case 20:
                            message.NumericFormat = reader.int64();
                            break;
                        case 21:
                            message.AxisMode = reader.int32();
                            break;
                        case 22:
                            message.SortType = reader.int32();
                            break;
                        case 23:
                            message.ShowMineEnabled = reader.bool();
                            break;
                        case 24:
                            message.ShowMine = reader.bool();
                            break;
                        case 25:
                            message.DateFunc = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportCol message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportCol
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportCol} ReportCol
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportCol.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportCol message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportCol
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportCol.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ColId != null && message.hasOwnProperty("ColId"))
                        if (!$util.isInteger(message.ColId) && !(message.ColId && $util.isInteger(message.ColId.low) && $util.isInteger(message.ColId.high)))
                            return "ColId: integer|Long expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Width != null && message.hasOwnProperty("Width"))
                        if (!$util.isInteger(message.Width) && !(message.Width && $util.isInteger(message.Width.low) && $util.isInteger(message.Width.high)))
                            return "Width: integer|Long expected";
                    if (message.Input != null && message.hasOwnProperty("Input"))
                        if (typeof message.Input !== "boolean")
                            return "Input: boolean expected";
                    if (message.Group != null && message.hasOwnProperty("Group"))
                        if (!$util.isInteger(message.Group) && !(message.Group && $util.isInteger(message.Group.low) && $util.isInteger(message.Group.high)))
                            return "Group: integer|Long expected";
                    if (message.Header != null && message.hasOwnProperty("Header"))
                        switch (message.Header) {
                        default:
                            return "Header: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.Xaxis != null && message.hasOwnProperty("Xaxis"))
                        if (typeof message.Xaxis !== "boolean")
                            return "Xaxis: boolean expected";
                    if (message.Hide != null && message.hasOwnProperty("Hide"))
                        if (typeof message.Hide !== "boolean")
                            return "Hide: boolean expected";
                    if (message.Sort != null && message.hasOwnProperty("Sort"))
                        if (!$util.isInteger(message.Sort) && !(message.Sort && $util.isInteger(message.Sort.low) && $util.isInteger(message.Sort.high)))
                            return "Sort: integer|Long expected";
                    if (message.Expr != null && message.hasOwnProperty("Expr"))
                        if (!$util.isString(message.Expr))
                            return "Expr: string expected";
                    if (message.IsExpression != null && message.hasOwnProperty("IsExpression"))
                        if (typeof message.IsExpression !== "boolean")
                            return "IsExpression: boolean expected";
                    if (message.IsCompany != null && message.hasOwnProperty("IsCompany"))
                        if (typeof message.IsCompany !== "boolean")
                            return "IsCompany: boolean expected";
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        switch (message.Type) {
                        default:
                            return "Type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                            break;
                        }
                    if (message.Func != null && message.hasOwnProperty("Func"))
                        switch (message.Func) {
                        default:
                            return "Func: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.DateFormat != null && message.hasOwnProperty("DateFormat"))
                        if (!$util.isInteger(message.DateFormat) && !(message.DateFormat && $util.isInteger(message.DateFormat.low) && $util.isInteger(message.DateFormat.high)))
                            return "DateFormat: integer|Long expected";
                    if (message.NodeId != null && message.hasOwnProperty("NodeId"))
                        if (!$util.isString(message.NodeId))
                            return "NodeId: string expected";
                    if (message.OrigTitle != null && message.hasOwnProperty("OrigTitle"))
                        if (!$util.isString(message.OrigTitle))
                            return "OrigTitle: string expected";
                    if (message.FormTitle != null && message.hasOwnProperty("FormTitle"))
                        if (!$util.isString(message.FormTitle))
                            return "FormTitle: string expected";
                    if (message.GroupFunc != null && message.hasOwnProperty("GroupFunc"))
                        switch (message.GroupFunc) {
                        default:
                            return "GroupFunc: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.NumericFormat != null && message.hasOwnProperty("NumericFormat"))
                        if (!$util.isInteger(message.NumericFormat) && !(message.NumericFormat && $util.isInteger(message.NumericFormat.low) && $util.isInteger(message.NumericFormat.high)))
                            return "NumericFormat: integer|Long expected";
                    if (message.AxisMode != null && message.hasOwnProperty("AxisMode"))
                        switch (message.AxisMode) {
                        default:
                            return "AxisMode: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.SortType != null && message.hasOwnProperty("SortType"))
                        switch (message.SortType) {
                        default:
                            return "SortType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                            break;
                        }
                    if (message.ShowMineEnabled != null && message.hasOwnProperty("ShowMineEnabled"))
                        if (typeof message.ShowMineEnabled !== "boolean")
                            return "ShowMineEnabled: boolean expected";
                    if (message.ShowMine != null && message.hasOwnProperty("ShowMine"))
                        if (typeof message.ShowMine !== "boolean")
                            return "ShowMine: boolean expected";
                    if (message.DateFunc != null && message.hasOwnProperty("DateFunc"))
                        if (!$util.isString(message.DateFunc))
                            return "DateFunc: string expected";
                    return null;
                };

                /**
                 * Creates a ReportCol message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportCol
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportCol} ReportCol
                 */
                ReportCol.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportCol)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportCol();
                    if (object.ColId != null)
                        if ($util.Long)
                            (message.ColId = $util.Long.fromValue(object.ColId)).unsigned = false;
                        else if (typeof object.ColId === "string")
                            message.ColId = parseInt(object.ColId, 10);
                        else if (typeof object.ColId === "number")
                            message.ColId = object.ColId;
                        else if (typeof object.ColId === "object")
                            message.ColId = new $util.LongBits(object.ColId.low >>> 0, object.ColId.high >>> 0).toNumber();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Width != null)
                        if ($util.Long)
                            (message.Width = $util.Long.fromValue(object.Width)).unsigned = false;
                        else if (typeof object.Width === "string")
                            message.Width = parseInt(object.Width, 10);
                        else if (typeof object.Width === "number")
                            message.Width = object.Width;
                        else if (typeof object.Width === "object")
                            message.Width = new $util.LongBits(object.Width.low >>> 0, object.Width.high >>> 0).toNumber();
                    if (object.Input != null)
                        message.Input = Boolean(object.Input);
                    if (object.Group != null)
                        if ($util.Long)
                            (message.Group = $util.Long.fromValue(object.Group)).unsigned = false;
                        else if (typeof object.Group === "string")
                            message.Group = parseInt(object.Group, 10);
                        else if (typeof object.Group === "number")
                            message.Group = object.Group;
                        else if (typeof object.Group === "object")
                            message.Group = new $util.LongBits(object.Group.low >>> 0, object.Group.high >>> 0).toNumber();
                    switch (object.Header) {
                    case "RepColHeaderModes_None":
                    case 0:
                        message.Header = 0;
                        break;
                    case "RepColHeaderModes_NewHeader":
                    case 1:
                        message.Header = 1;
                        break;
                    case "RepColHeaderModes_AppendToHeader":
                    case 2:
                        message.Header = 2;
                        break;
                    }
                    if (object.Xaxis != null)
                        message.Xaxis = Boolean(object.Xaxis);
                    if (object.Hide != null)
                        message.Hide = Boolean(object.Hide);
                    if (object.Sort != null)
                        if ($util.Long)
                            (message.Sort = $util.Long.fromValue(object.Sort)).unsigned = false;
                        else if (typeof object.Sort === "string")
                            message.Sort = parseInt(object.Sort, 10);
                        else if (typeof object.Sort === "number")
                            message.Sort = object.Sort;
                        else if (typeof object.Sort === "object")
                            message.Sort = new $util.LongBits(object.Sort.low >>> 0, object.Sort.high >>> 0).toNumber();
                    if (object.Expr != null)
                        message.Expr = String(object.Expr);
                    if (object.IsExpression != null)
                        message.IsExpression = Boolean(object.IsExpression);
                    if (object.IsCompany != null)
                        message.IsCompany = Boolean(object.IsCompany);
                    switch (object.Type) {
                    case "Char":
                    case 0:
                        message.Type = 0;
                        break;
                    case "Str":
                    case 1:
                        message.Type = 1;
                        break;
                    case "Rstr":
                    case 2:
                        message.Type = 2;
                        break;
                    case "Boolean":
                    case 3:
                        message.Type = 3;
                        break;
                    case "Real":
                    case 4:
                        message.Type = 4;
                        break;
                    case "Int":
                    case 5:
                        message.Type = 5;
                        break;
                    case "Date8":
                    case 6:
                        message.Type = 6;
                        break;
                    case "Date10":
                    case 7:
                        message.Type = 7;
                        break;
                    case "Date14":
                    case 8:
                        message.Type = 8;
                        break;
                    case "Time5":
                    case 9:
                        message.Type = 9;
                        break;
                    case "Time6":
                    case 10:
                        message.Type = 10;
                        break;
                    case "Day":
                    case 11:
                        message.Type = 11;
                        break;
                    case "Unsigned":
                    case 12:
                        message.Type = 12;
                        break;
                    case "Operator":
                    case 13:
                        message.Type = 13;
                        break;
                    case "Attachment":
                    case 14:
                        message.Type = 14;
                        break;
                    }
                    switch (object.Func) {
                    case "RepColFunc_None":
                    case 0:
                        message.Func = 0;
                        break;
                    case "RepColFunc_Sum":
                    case 1:
                        message.Func = 1;
                        break;
                    case "RepColFunc_Avg":
                    case 2:
                        message.Func = 2;
                        break;
                    case "RepColFunc_Max":
                    case 3:
                        message.Func = 3;
                        break;
                    case "RepColFunc_Min":
                    case 4:
                        message.Func = 4;
                        break;
                    }
                    if (object.DateFormat != null)
                        if ($util.Long)
                            (message.DateFormat = $util.Long.fromValue(object.DateFormat)).unsigned = false;
                        else if (typeof object.DateFormat === "string")
                            message.DateFormat = parseInt(object.DateFormat, 10);
                        else if (typeof object.DateFormat === "number")
                            message.DateFormat = object.DateFormat;
                        else if (typeof object.DateFormat === "object")
                            message.DateFormat = new $util.LongBits(object.DateFormat.low >>> 0, object.DateFormat.high >>> 0).toNumber();
                    if (object.NodeId != null)
                        message.NodeId = String(object.NodeId);
                    if (object.OrigTitle != null)
                        message.OrigTitle = String(object.OrigTitle);
                    if (object.FormTitle != null)
                        message.FormTitle = String(object.FormTitle);
                    switch (object.GroupFunc) {
                    case "RepGroupFunc_None":
                    case 0:
                        message.GroupFunc = 0;
                        break;
                    case "RepGroupFunc_Group":
                    case 1:
                        message.GroupFunc = 1;
                        break;
                    case "RepGroupFunc_Report":
                    case 2:
                        message.GroupFunc = 2;
                        break;
                    case "RepGroupFunc_Both":
                    case 3:
                        message.GroupFunc = 3;
                        break;
                    case "RepGroupFunc_RepeatValue":
                    case 4:
                        message.GroupFunc = 4;
                        break;
                    }
                    if (object.NumericFormat != null)
                        if ($util.Long)
                            (message.NumericFormat = $util.Long.fromValue(object.NumericFormat)).unsigned = false;
                        else if (typeof object.NumericFormat === "string")
                            message.NumericFormat = parseInt(object.NumericFormat, 10);
                        else if (typeof object.NumericFormat === "number")
                            message.NumericFormat = object.NumericFormat;
                        else if (typeof object.NumericFormat === "object")
                            message.NumericFormat = new $util.LongBits(object.NumericFormat.low >>> 0, object.NumericFormat.high >>> 0).toNumber();
                    switch (object.AxisMode) {
                    case "RepColAxisMode_None":
                    case 0:
                        message.AxisMode = 0;
                        break;
                    case "RepColAxisMode_X":
                    case 1:
                        message.AxisMode = 1;
                        break;
                    case "RepColAxisMode_OrderBy":
                    case 2:
                        message.AxisMode = 2;
                        break;
                    case "RepColAxisMode_InTableOnly":
                    case 3:
                        message.AxisMode = 3;
                        break;
                    }
                    switch (object.SortType) {
                    case "RepColSortType_None":
                    case 0:
                        message.SortType = 0;
                        break;
                    case "RepColSortType_Ascending":
                    case 1:
                        message.SortType = 1;
                        break;
                    case "RepColSortType_Descending":
                    case 2:
                        message.SortType = 2;
                        break;
                    case "RepColSortType_AlphanumericAscending":
                    case 3:
                        message.SortType = 3;
                        break;
                    case "RepColSortType_AlphanumericDescending":
                    case 4:
                        message.SortType = 4;
                        break;
                    }
                    if (object.ShowMineEnabled != null)
                        message.ShowMineEnabled = Boolean(object.ShowMineEnabled);
                    if (object.ShowMine != null)
                        message.ShowMine = Boolean(object.ShowMine);
                    if (object.DateFunc != null)
                        message.DateFunc = String(object.DateFunc);
                    return message;
                };

                /**
                 * Creates a plain object from a ReportCol message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportCol
                 * @static
                 * @param {priority.netitems.nrest.ReportCol} message ReportCol
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportCol.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ColId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ColId = options.longs === String ? "0" : 0;
                        object.Title = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Width = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Width = options.longs === String ? "0" : 0;
                        object.Input = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Group = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Group = options.longs === String ? "0" : 0;
                        object.Header = options.enums === String ? "RepColHeaderModes_None" : 0;
                        object.Xaxis = false;
                        object.Hide = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Sort = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Sort = options.longs === String ? "0" : 0;
                        object.Expr = "";
                        object.IsExpression = false;
                        object.IsCompany = false;
                        object.Type = options.enums === String ? "Char" : 0;
                        object.Func = options.enums === String ? "RepColFunc_None" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.DateFormat = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.DateFormat = options.longs === String ? "0" : 0;
                        object.NodeId = "";
                        object.OrigTitle = "";
                        object.FormTitle = "";
                        object.GroupFunc = options.enums === String ? "RepGroupFunc_None" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.NumericFormat = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.NumericFormat = options.longs === String ? "0" : 0;
                        object.AxisMode = options.enums === String ? "RepColAxisMode_None" : 0;
                        object.SortType = options.enums === String ? "RepColSortType_None" : 0;
                        object.ShowMineEnabled = false;
                        object.ShowMine = false;
                        object.DateFunc = "";
                    }
                    if (message.ColId != null && message.hasOwnProperty("ColId"))
                        if (typeof message.ColId === "number")
                            object.ColId = options.longs === String ? String(message.ColId) : message.ColId;
                        else
                            object.ColId = options.longs === String ? $util.Long.prototype.toString.call(message.ColId) : options.longs === Number ? new $util.LongBits(message.ColId.low >>> 0, message.ColId.high >>> 0).toNumber() : message.ColId;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Width != null && message.hasOwnProperty("Width"))
                        if (typeof message.Width === "number")
                            object.Width = options.longs === String ? String(message.Width) : message.Width;
                        else
                            object.Width = options.longs === String ? $util.Long.prototype.toString.call(message.Width) : options.longs === Number ? new $util.LongBits(message.Width.low >>> 0, message.Width.high >>> 0).toNumber() : message.Width;
                    if (message.Input != null && message.hasOwnProperty("Input"))
                        object.Input = message.Input;
                    if (message.Group != null && message.hasOwnProperty("Group"))
                        if (typeof message.Group === "number")
                            object.Group = options.longs === String ? String(message.Group) : message.Group;
                        else
                            object.Group = options.longs === String ? $util.Long.prototype.toString.call(message.Group) : options.longs === Number ? new $util.LongBits(message.Group.low >>> 0, message.Group.high >>> 0).toNumber() : message.Group;
                    if (message.Header != null && message.hasOwnProperty("Header"))
                        object.Header = options.enums === String ? $root.priority.netitems.nrest.RepColHeaderModes[message.Header] : message.Header;
                    if (message.Xaxis != null && message.hasOwnProperty("Xaxis"))
                        object.Xaxis = message.Xaxis;
                    if (message.Hide != null && message.hasOwnProperty("Hide"))
                        object.Hide = message.Hide;
                    if (message.Sort != null && message.hasOwnProperty("Sort"))
                        if (typeof message.Sort === "number")
                            object.Sort = options.longs === String ? String(message.Sort) : message.Sort;
                        else
                            object.Sort = options.longs === String ? $util.Long.prototype.toString.call(message.Sort) : options.longs === Number ? new $util.LongBits(message.Sort.low >>> 0, message.Sort.high >>> 0).toNumber() : message.Sort;
                    if (message.Expr != null && message.hasOwnProperty("Expr"))
                        object.Expr = message.Expr;
                    if (message.IsExpression != null && message.hasOwnProperty("IsExpression"))
                        object.IsExpression = message.IsExpression;
                    if (message.IsCompany != null && message.hasOwnProperty("IsCompany"))
                        object.IsCompany = message.IsCompany;
                    if (message.Type != null && message.hasOwnProperty("Type"))
                        object.Type = options.enums === String ? $root.priority.netitems.form.ColumnType[message.Type] : message.Type;
                    if (message.Func != null && message.hasOwnProperty("Func"))
                        object.Func = options.enums === String ? $root.priority.netitems.nrest.RepColFunc[message.Func] : message.Func;
                    if (message.DateFormat != null && message.hasOwnProperty("DateFormat"))
                        if (typeof message.DateFormat === "number")
                            object.DateFormat = options.longs === String ? String(message.DateFormat) : message.DateFormat;
                        else
                            object.DateFormat = options.longs === String ? $util.Long.prototype.toString.call(message.DateFormat) : options.longs === Number ? new $util.LongBits(message.DateFormat.low >>> 0, message.DateFormat.high >>> 0).toNumber() : message.DateFormat;
                    if (message.NodeId != null && message.hasOwnProperty("NodeId"))
                        object.NodeId = message.NodeId;
                    if (message.OrigTitle != null && message.hasOwnProperty("OrigTitle"))
                        object.OrigTitle = message.OrigTitle;
                    if (message.FormTitle != null && message.hasOwnProperty("FormTitle"))
                        object.FormTitle = message.FormTitle;
                    if (message.GroupFunc != null && message.hasOwnProperty("GroupFunc"))
                        object.GroupFunc = options.enums === String ? $root.priority.netitems.nrest.RepGroupFunc[message.GroupFunc] : message.GroupFunc;
                    if (message.NumericFormat != null && message.hasOwnProperty("NumericFormat"))
                        if (typeof message.NumericFormat === "number")
                            object.NumericFormat = options.longs === String ? String(message.NumericFormat) : message.NumericFormat;
                        else
                            object.NumericFormat = options.longs === String ? $util.Long.prototype.toString.call(message.NumericFormat) : options.longs === Number ? new $util.LongBits(message.NumericFormat.low >>> 0, message.NumericFormat.high >>> 0).toNumber() : message.NumericFormat;
                    if (message.AxisMode != null && message.hasOwnProperty("AxisMode"))
                        object.AxisMode = options.enums === String ? $root.priority.netitems.nrest.RepColAxisMode[message.AxisMode] : message.AxisMode;
                    if (message.SortType != null && message.hasOwnProperty("SortType"))
                        object.SortType = options.enums === String ? $root.priority.netitems.nrest.RepColSortType[message.SortType] : message.SortType;
                    if (message.ShowMineEnabled != null && message.hasOwnProperty("ShowMineEnabled"))
                        object.ShowMineEnabled = message.ShowMineEnabled;
                    if (message.ShowMine != null && message.hasOwnProperty("ShowMine"))
                        object.ShowMine = message.ShowMine;
                    if (message.DateFunc != null && message.hasOwnProperty("DateFunc"))
                        object.DateFunc = message.DateFunc;
                    return object;
                };

                /**
                 * Converts this ReportCol to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportCol
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportCol.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportCol;
            })();

            /**
             * RepType enum.
             * @name priority.netitems.nrest.RepType
             * @enum {number}
             * @property {number} RepType_None=0 RepType_None value
             * @property {number} RepType_DynFields=97 RepType_DynFields value
             * @property {number} RepType_Chart=99 RepType_Chart value
             * @property {number} RepType_DataSet=111 RepType_DataSet value
             * @property {number} RepType_OldReport=114 RepType_OldReport value
             * @property {number} RepType_Widget=119 RepType_Widget value
             * @property {number} RepType_Report=121 RepType_Report value
             */
            nrest.RepType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "RepType_None"] = 0;
                values[valuesById[97] = "RepType_DynFields"] = 97;
                values[valuesById[99] = "RepType_Chart"] = 99;
                values[valuesById[111] = "RepType_DataSet"] = 111;
                values[valuesById[114] = "RepType_OldReport"] = 114;
                values[valuesById[119] = "RepType_Widget"] = 119;
                values[valuesById[121] = "RepType_Report"] = 121;
                return values;
            })();

            nrest.ReportSaveRq = (function() {

                /**
                 * Properties of a ReportSaveRq.
                 * @memberof priority.netitems.nrest
                 * @interface IReportSaveRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ReportSaveRq Properties
                 * @property {string|null} [RootNodeId] ReportSaveRq RootNodeId
                 * @property {string|null} [Title] ReportSaveRq Title
                 * @property {boolean|null} [General] ReportSaveRq General
                 * @property {boolean|null} [Vertical] ReportSaveRq Vertical
                 * @property {number|Long|null} [ReportId] ReportSaveRq ReportId
                 * @property {Array.<priority.netitems.nrest.IReportCol>|null} [Columns] ReportSaveRq Columns
                 * @property {number|Long|null} [CopyOfReportId] ReportSaveRq CopyOfReportId
                 * @property {boolean|null} [InUse] ReportSaveRq InUse
                 * @property {priority.netitems.nrest.RepType|null} [ReportType] ReportSaveRq ReportType
                 * @property {string|null} [LinkId] ReportSaveRq LinkId
                 * @property {boolean|null} [Tabular] ReportSaveRq Tabular
                 * @property {number|Long|null} [OuterJoin] ReportSaveRq OuterJoin
                 * @property {number|Long|null} [ConnectId] ReportSaveRq ConnectId
                 */

                /**
                 * Constructs a new ReportSaveRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportSaveRq.
                 * @implements IReportSaveRq
                 * @constructor
                 * @param {priority.netitems.nrest.IReportSaveRq=} [properties] Properties to set
                 */
                function ReportSaveRq(properties) {
                    this.Columns = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportSaveRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.Properties = null;

                /**
                 * ReportSaveRq RootNodeId.
                 * @member {string} RootNodeId
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.RootNodeId = "";

                /**
                 * ReportSaveRq Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.Title = "";

                /**
                 * ReportSaveRq General.
                 * @member {boolean} General
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.General = false;

                /**
                 * ReportSaveRq Vertical.
                 * @member {boolean} Vertical
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.Vertical = false;

                /**
                 * ReportSaveRq ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportSaveRq Columns.
                 * @member {Array.<priority.netitems.nrest.IReportCol>} Columns
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.Columns = $util.emptyArray;

                /**
                 * ReportSaveRq CopyOfReportId.
                 * @member {number|Long} CopyOfReportId
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.CopyOfReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportSaveRq InUse.
                 * @member {boolean} InUse
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.InUse = false;

                /**
                 * ReportSaveRq ReportType.
                 * @member {priority.netitems.nrest.RepType} ReportType
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.ReportType = 0;

                /**
                 * ReportSaveRq LinkId.
                 * @member {string} LinkId
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.LinkId = "";

                /**
                 * ReportSaveRq Tabular.
                 * @member {boolean} Tabular
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.Tabular = false;

                /**
                 * ReportSaveRq OuterJoin.
                 * @member {number|Long} OuterJoin
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.OuterJoin = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportSaveRq ConnectId.
                 * @member {number|Long} ConnectId
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 */
                ReportSaveRq.prototype.ConnectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new ReportSaveRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @static
                 * @param {priority.netitems.nrest.IReportSaveRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportSaveRq} ReportSaveRq instance
                 */
                ReportSaveRq.create = function create(properties) {
                    return new ReportSaveRq(properties);
                };

                /**
                 * Encodes the specified ReportSaveRq message. Does not implicitly {@link priority.netitems.nrest.ReportSaveRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @static
                 * @param {priority.netitems.nrest.IReportSaveRq} message ReportSaveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportSaveRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.RootNodeId != null && Object.hasOwnProperty.call(message, "RootNodeId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.RootNodeId);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Title);
                    if (message.General != null && Object.hasOwnProperty.call(message, "General"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.General);
                    if (message.Vertical != null && Object.hasOwnProperty.call(message, "Vertical"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.Vertical);
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.ReportId);
                    if (message.Columns != null && message.Columns.length)
                        for (var i = 0; i < message.Columns.length; ++i)
                            $root.priority.netitems.nrest.ReportCol.encode(message.Columns[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.CopyOfReportId != null && Object.hasOwnProperty.call(message, "CopyOfReportId"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.CopyOfReportId);
                    if (message.InUse != null && Object.hasOwnProperty.call(message, "InUse"))
                        writer.uint32(/* id 9, wireType 0 =*/72).bool(message.InUse);
                    if (message.ReportType != null && Object.hasOwnProperty.call(message, "ReportType"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int32(message.ReportType);
                    if (message.LinkId != null && Object.hasOwnProperty.call(message, "LinkId"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.LinkId);
                    if (message.Tabular != null && Object.hasOwnProperty.call(message, "Tabular"))
                        writer.uint32(/* id 12, wireType 0 =*/96).bool(message.Tabular);
                    if (message.OuterJoin != null && Object.hasOwnProperty.call(message, "OuterJoin"))
                        writer.uint32(/* id 13, wireType 0 =*/104).int64(message.OuterJoin);
                    if (message.ConnectId != null && Object.hasOwnProperty.call(message, "ConnectId"))
                        writer.uint32(/* id 15, wireType 0 =*/120).int64(message.ConnectId);
                    return writer;
                };

                /**
                 * Encodes the specified ReportSaveRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportSaveRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @static
                 * @param {priority.netitems.nrest.IReportSaveRq} message ReportSaveRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportSaveRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportSaveRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportSaveRq} ReportSaveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportSaveRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportSaveRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.RootNodeId = reader.string();
                            break;
                        case 3:
                            message.Title = reader.string();
                            break;
                        case 4:
                            message.General = reader.bool();
                            break;
                        case 5:
                            message.Vertical = reader.bool();
                            break;
                        case 6:
                            message.ReportId = reader.int64();
                            break;
                        case 7:
                            if (!(message.Columns && message.Columns.length))
                                message.Columns = [];
                            message.Columns.push($root.priority.netitems.nrest.ReportCol.decode(reader, reader.uint32()));
                            break;
                        case 8:
                            message.CopyOfReportId = reader.int64();
                            break;
                        case 9:
                            message.InUse = reader.bool();
                            break;
                        case 10:
                            message.ReportType = reader.int32();
                            break;
                        case 11:
                            message.LinkId = reader.string();
                            break;
                        case 12:
                            message.Tabular = reader.bool();
                            break;
                        case 13:
                            message.OuterJoin = reader.int64();
                            break;
                        case 15:
                            message.ConnectId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportSaveRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportSaveRq} ReportSaveRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportSaveRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportSaveRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportSaveRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.RootNodeId != null && message.hasOwnProperty("RootNodeId"))
                        if (!$util.isString(message.RootNodeId))
                            return "RootNodeId: string expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.General != null && message.hasOwnProperty("General"))
                        if (typeof message.General !== "boolean")
                            return "General: boolean expected";
                    if (message.Vertical != null && message.hasOwnProperty("Vertical"))
                        if (typeof message.Vertical !== "boolean")
                            return "Vertical: boolean expected";
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (!Array.isArray(message.Columns))
                            return "Columns: array expected";
                        for (var i = 0; i < message.Columns.length; ++i) {
                            var error = $root.priority.netitems.nrest.ReportCol.verify(message.Columns[i]);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.CopyOfReportId != null && message.hasOwnProperty("CopyOfReportId"))
                        if (!$util.isInteger(message.CopyOfReportId) && !(message.CopyOfReportId && $util.isInteger(message.CopyOfReportId.low) && $util.isInteger(message.CopyOfReportId.high)))
                            return "CopyOfReportId: integer|Long expected";
                    if (message.InUse != null && message.hasOwnProperty("InUse"))
                        if (typeof message.InUse !== "boolean")
                            return "InUse: boolean expected";
                    if (message.ReportType != null && message.hasOwnProperty("ReportType"))
                        switch (message.ReportType) {
                        default:
                            return "ReportType: enum value expected";
                        case 0:
                        case 97:
                        case 99:
                        case 111:
                        case 114:
                        case 119:
                        case 121:
                            break;
                        }
                    if (message.LinkId != null && message.hasOwnProperty("LinkId"))
                        if (!$util.isString(message.LinkId))
                            return "LinkId: string expected";
                    if (message.Tabular != null && message.hasOwnProperty("Tabular"))
                        if (typeof message.Tabular !== "boolean")
                            return "Tabular: boolean expected";
                    if (message.OuterJoin != null && message.hasOwnProperty("OuterJoin"))
                        if (!$util.isInteger(message.OuterJoin) && !(message.OuterJoin && $util.isInteger(message.OuterJoin.low) && $util.isInteger(message.OuterJoin.high)))
                            return "OuterJoin: integer|Long expected";
                    if (message.ConnectId != null && message.hasOwnProperty("ConnectId"))
                        if (!$util.isInteger(message.ConnectId) && !(message.ConnectId && $util.isInteger(message.ConnectId.low) && $util.isInteger(message.ConnectId.high)))
                            return "ConnectId: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a ReportSaveRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportSaveRq} ReportSaveRq
                 */
                ReportSaveRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportSaveRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportSaveRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportSaveRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.RootNodeId != null)
                        message.RootNodeId = String(object.RootNodeId);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.General != null)
                        message.General = Boolean(object.General);
                    if (object.Vertical != null)
                        message.Vertical = Boolean(object.Vertical);
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    if (object.Columns) {
                        if (!Array.isArray(object.Columns))
                            throw TypeError(".priority.netitems.nrest.ReportSaveRq.Columns: array expected");
                        message.Columns = [];
                        for (var i = 0; i < object.Columns.length; ++i) {
                            if (typeof object.Columns[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportSaveRq.Columns: object expected");
                            message.Columns[i] = $root.priority.netitems.nrest.ReportCol.fromObject(object.Columns[i]);
                        }
                    }
                    if (object.CopyOfReportId != null)
                        if ($util.Long)
                            (message.CopyOfReportId = $util.Long.fromValue(object.CopyOfReportId)).unsigned = false;
                        else if (typeof object.CopyOfReportId === "string")
                            message.CopyOfReportId = parseInt(object.CopyOfReportId, 10);
                        else if (typeof object.CopyOfReportId === "number")
                            message.CopyOfReportId = object.CopyOfReportId;
                        else if (typeof object.CopyOfReportId === "object")
                            message.CopyOfReportId = new $util.LongBits(object.CopyOfReportId.low >>> 0, object.CopyOfReportId.high >>> 0).toNumber();
                    if (object.InUse != null)
                        message.InUse = Boolean(object.InUse);
                    switch (object.ReportType) {
                    case "RepType_None":
                    case 0:
                        message.ReportType = 0;
                        break;
                    case "RepType_DynFields":
                    case 97:
                        message.ReportType = 97;
                        break;
                    case "RepType_Chart":
                    case 99:
                        message.ReportType = 99;
                        break;
                    case "RepType_DataSet":
                    case 111:
                        message.ReportType = 111;
                        break;
                    case "RepType_OldReport":
                    case 114:
                        message.ReportType = 114;
                        break;
                    case "RepType_Widget":
                    case 119:
                        message.ReportType = 119;
                        break;
                    case "RepType_Report":
                    case 121:
                        message.ReportType = 121;
                        break;
                    }
                    if (object.LinkId != null)
                        message.LinkId = String(object.LinkId);
                    if (object.Tabular != null)
                        message.Tabular = Boolean(object.Tabular);
                    if (object.OuterJoin != null)
                        if ($util.Long)
                            (message.OuterJoin = $util.Long.fromValue(object.OuterJoin)).unsigned = false;
                        else if (typeof object.OuterJoin === "string")
                            message.OuterJoin = parseInt(object.OuterJoin, 10);
                        else if (typeof object.OuterJoin === "number")
                            message.OuterJoin = object.OuterJoin;
                        else if (typeof object.OuterJoin === "object")
                            message.OuterJoin = new $util.LongBits(object.OuterJoin.low >>> 0, object.OuterJoin.high >>> 0).toNumber();
                    if (object.ConnectId != null)
                        if ($util.Long)
                            (message.ConnectId = $util.Long.fromValue(object.ConnectId)).unsigned = false;
                        else if (typeof object.ConnectId === "string")
                            message.ConnectId = parseInt(object.ConnectId, 10);
                        else if (typeof object.ConnectId === "number")
                            message.ConnectId = object.ConnectId;
                        else if (typeof object.ConnectId === "object")
                            message.ConnectId = new $util.LongBits(object.ConnectId.low >>> 0, object.ConnectId.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a ReportSaveRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @static
                 * @param {priority.netitems.nrest.ReportSaveRq} message ReportSaveRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportSaveRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Columns = [];
                    if (options.defaults) {
                        object.Properties = null;
                        object.RootNodeId = "";
                        object.Title = "";
                        object.General = false;
                        object.Vertical = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.CopyOfReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.CopyOfReportId = options.longs === String ? "0" : 0;
                        object.InUse = false;
                        object.ReportType = options.enums === String ? "RepType_None" : 0;
                        object.LinkId = "";
                        object.Tabular = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.OuterJoin = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.OuterJoin = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ConnectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ConnectId = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.RootNodeId != null && message.hasOwnProperty("RootNodeId"))
                        object.RootNodeId = message.RootNodeId;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.General != null && message.hasOwnProperty("General"))
                        object.General = message.General;
                    if (message.Vertical != null && message.hasOwnProperty("Vertical"))
                        object.Vertical = message.Vertical;
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    if (message.Columns && message.Columns.length) {
                        object.Columns = [];
                        for (var j = 0; j < message.Columns.length; ++j)
                            object.Columns[j] = $root.priority.netitems.nrest.ReportCol.toObject(message.Columns[j], options);
                    }
                    if (message.CopyOfReportId != null && message.hasOwnProperty("CopyOfReportId"))
                        if (typeof message.CopyOfReportId === "number")
                            object.CopyOfReportId = options.longs === String ? String(message.CopyOfReportId) : message.CopyOfReportId;
                        else
                            object.CopyOfReportId = options.longs === String ? $util.Long.prototype.toString.call(message.CopyOfReportId) : options.longs === Number ? new $util.LongBits(message.CopyOfReportId.low >>> 0, message.CopyOfReportId.high >>> 0).toNumber() : message.CopyOfReportId;
                    if (message.InUse != null && message.hasOwnProperty("InUse"))
                        object.InUse = message.InUse;
                    if (message.ReportType != null && message.hasOwnProperty("ReportType"))
                        object.ReportType = options.enums === String ? $root.priority.netitems.nrest.RepType[message.ReportType] : message.ReportType;
                    if (message.LinkId != null && message.hasOwnProperty("LinkId"))
                        object.LinkId = message.LinkId;
                    if (message.Tabular != null && message.hasOwnProperty("Tabular"))
                        object.Tabular = message.Tabular;
                    if (message.OuterJoin != null && message.hasOwnProperty("OuterJoin"))
                        if (typeof message.OuterJoin === "number")
                            object.OuterJoin = options.longs === String ? String(message.OuterJoin) : message.OuterJoin;
                        else
                            object.OuterJoin = options.longs === String ? $util.Long.prototype.toString.call(message.OuterJoin) : options.longs === Number ? new $util.LongBits(message.OuterJoin.low >>> 0, message.OuterJoin.high >>> 0).toNumber() : message.OuterJoin;
                    if (message.ConnectId != null && message.hasOwnProperty("ConnectId"))
                        if (typeof message.ConnectId === "number")
                            object.ConnectId = options.longs === String ? String(message.ConnectId) : message.ConnectId;
                        else
                            object.ConnectId = options.longs === String ? $util.Long.prototype.toString.call(message.ConnectId) : options.longs === Number ? new $util.LongBits(message.ConnectId.low >>> 0, message.ConnectId.high >>> 0).toNumber() : message.ConnectId;
                    return object;
                };

                /**
                 * Converts this ReportSaveRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportSaveRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportSaveRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportSaveRq;
            })();

            nrest.ReportSaveRs = (function() {

                /**
                 * Properties of a ReportSaveRs.
                 * @memberof priority.netitems.nrest
                 * @interface IReportSaveRs
                 * @property {number|Long|null} [ReportId] ReportSaveRs ReportId
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ReportSaveRs Messages
                 */

                /**
                 * Constructs a new ReportSaveRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportSaveRs.
                 * @implements IReportSaveRs
                 * @constructor
                 * @param {priority.netitems.nrest.IReportSaveRs=} [properties] Properties to set
                 */
                function ReportSaveRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportSaveRs ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @instance
                 */
                ReportSaveRs.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportSaveRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @instance
                 */
                ReportSaveRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new ReportSaveRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @static
                 * @param {priority.netitems.nrest.IReportSaveRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportSaveRs} ReportSaveRs instance
                 */
                ReportSaveRs.create = function create(properties) {
                    return new ReportSaveRs(properties);
                };

                /**
                 * Encodes the specified ReportSaveRs message. Does not implicitly {@link priority.netitems.nrest.ReportSaveRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @static
                 * @param {priority.netitems.nrest.IReportSaveRs} message ReportSaveRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportSaveRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ReportId);
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ReportSaveRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportSaveRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @static
                 * @param {priority.netitems.nrest.IReportSaveRs} message ReportSaveRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportSaveRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportSaveRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportSaveRs} ReportSaveRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportSaveRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportSaveRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ReportId = reader.int64();
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportSaveRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportSaveRs} ReportSaveRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportSaveRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportSaveRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportSaveRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ReportSaveRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportSaveRs} ReportSaveRs
                 */
                ReportSaveRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportSaveRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportSaveRs();
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.ReportSaveRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportSaveRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ReportSaveRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @static
                 * @param {priority.netitems.nrest.ReportSaveRs} message ReportSaveRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportSaveRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ReportSaveRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportSaveRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportSaveRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportSaveRs;
            })();

            nrest.ReportCancelRq = (function() {

                /**
                 * Properties of a ReportCancelRq.
                 * @memberof priority.netitems.nrest
                 * @interface IReportCancelRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ReportCancelRq Properties
                 * @property {string|null} [LinkId] ReportCancelRq LinkId
                 */

                /**
                 * Constructs a new ReportCancelRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportCancelRq.
                 * @implements IReportCancelRq
                 * @constructor
                 * @param {priority.netitems.nrest.IReportCancelRq=} [properties] Properties to set
                 */
                function ReportCancelRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportCancelRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @instance
                 */
                ReportCancelRq.prototype.Properties = null;

                /**
                 * ReportCancelRq LinkId.
                 * @member {string} LinkId
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @instance
                 */
                ReportCancelRq.prototype.LinkId = "";

                /**
                 * Creates a new ReportCancelRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @static
                 * @param {priority.netitems.nrest.IReportCancelRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportCancelRq} ReportCancelRq instance
                 */
                ReportCancelRq.create = function create(properties) {
                    return new ReportCancelRq(properties);
                };

                /**
                 * Encodes the specified ReportCancelRq message. Does not implicitly {@link priority.netitems.nrest.ReportCancelRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @static
                 * @param {priority.netitems.nrest.IReportCancelRq} message ReportCancelRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportCancelRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.LinkId != null && Object.hasOwnProperty.call(message, "LinkId"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.LinkId);
                    return writer;
                };

                /**
                 * Encodes the specified ReportCancelRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportCancelRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @static
                 * @param {priority.netitems.nrest.IReportCancelRq} message ReportCancelRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportCancelRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportCancelRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportCancelRq} ReportCancelRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportCancelRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportCancelRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.LinkId = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportCancelRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportCancelRq} ReportCancelRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportCancelRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportCancelRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportCancelRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.LinkId != null && message.hasOwnProperty("LinkId"))
                        if (!$util.isString(message.LinkId))
                            return "LinkId: string expected";
                    return null;
                };

                /**
                 * Creates a ReportCancelRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportCancelRq} ReportCancelRq
                 */
                ReportCancelRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportCancelRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportCancelRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportCancelRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.LinkId != null)
                        message.LinkId = String(object.LinkId);
                    return message;
                };

                /**
                 * Creates a plain object from a ReportCancelRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @static
                 * @param {priority.netitems.nrest.ReportCancelRq} message ReportCancelRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportCancelRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.LinkId = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.LinkId != null && message.hasOwnProperty("LinkId"))
                        object.LinkId = message.LinkId;
                    return object;
                };

                /**
                 * Converts this ReportCancelRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportCancelRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportCancelRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportCancelRq;
            })();

            nrest.ReportCancelRs = (function() {

                /**
                 * Properties of a ReportCancelRs.
                 * @memberof priority.netitems.nrest
                 * @interface IReportCancelRs
                 */

                /**
                 * Constructs a new ReportCancelRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportCancelRs.
                 * @implements IReportCancelRs
                 * @constructor
                 * @param {priority.netitems.nrest.IReportCancelRs=} [properties] Properties to set
                 */
                function ReportCancelRs(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Creates a new ReportCancelRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @static
                 * @param {priority.netitems.nrest.IReportCancelRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportCancelRs} ReportCancelRs instance
                 */
                ReportCancelRs.create = function create(properties) {
                    return new ReportCancelRs(properties);
                };

                /**
                 * Encodes the specified ReportCancelRs message. Does not implicitly {@link priority.netitems.nrest.ReportCancelRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @static
                 * @param {priority.netitems.nrest.IReportCancelRs} message ReportCancelRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportCancelRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };

                /**
                 * Encodes the specified ReportCancelRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportCancelRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @static
                 * @param {priority.netitems.nrest.IReportCancelRs} message ReportCancelRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportCancelRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportCancelRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportCancelRs} ReportCancelRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportCancelRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportCancelRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportCancelRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportCancelRs} ReportCancelRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportCancelRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportCancelRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportCancelRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };

                /**
                 * Creates a ReportCancelRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportCancelRs} ReportCancelRs
                 */
                ReportCancelRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportCancelRs)
                        return object;
                    return new $root.priority.netitems.nrest.ReportCancelRs();
                };

                /**
                 * Creates a plain object from a ReportCancelRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @static
                 * @param {priority.netitems.nrest.ReportCancelRs} message ReportCancelRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportCancelRs.toObject = function toObject() {
                    return {};
                };

                /**
                 * Converts this ReportCancelRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportCancelRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportCancelRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportCancelRs;
            })();

            nrest.DataInput = (function() {

                /**
                 * Properties of a DataInput.
                 * @memberof priority.netitems.nrest
                 * @interface IDataInput
                 * @property {priority.netitems.shared.ComparisonOperator|null} [Operator] DataInput Operator
                 * @property {Array.<string>|null} [Values] DataInput Values
                 */

                /**
                 * Constructs a new DataInput.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DataInput.
                 * @implements IDataInput
                 * @constructor
                 * @param {priority.netitems.nrest.IDataInput=} [properties] Properties to set
                 */
                function DataInput(properties) {
                    this.Values = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataInput Operator.
                 * @member {priority.netitems.shared.ComparisonOperator} Operator
                 * @memberof priority.netitems.nrest.DataInput
                 * @instance
                 */
                DataInput.prototype.Operator = 0;

                /**
                 * DataInput Values.
                 * @member {Array.<string>} Values
                 * @memberof priority.netitems.nrest.DataInput
                 * @instance
                 */
                DataInput.prototype.Values = $util.emptyArray;

                /**
                 * Creates a new DataInput instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DataInput
                 * @static
                 * @param {priority.netitems.nrest.IDataInput=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DataInput} DataInput instance
                 */
                DataInput.create = function create(properties) {
                    return new DataInput(properties);
                };

                /**
                 * Encodes the specified DataInput message. Does not implicitly {@link priority.netitems.nrest.DataInput.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DataInput
                 * @static
                 * @param {priority.netitems.nrest.IDataInput} message DataInput message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataInput.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Operator != null && Object.hasOwnProperty.call(message, "Operator"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Operator);
                    if (message.Values != null && message.Values.length)
                        for (var i = 0; i < message.Values.length; ++i)
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Values[i]);
                    return writer;
                };

                /**
                 * Encodes the specified DataInput message, length delimited. Does not implicitly {@link priority.netitems.nrest.DataInput.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DataInput
                 * @static
                 * @param {priority.netitems.nrest.IDataInput} message DataInput message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataInput.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataInput message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DataInput
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DataInput} DataInput
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataInput.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DataInput();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Operator = reader.int32();
                            break;
                        case 2:
                            if (!(message.Values && message.Values.length))
                                message.Values = [];
                            message.Values.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataInput message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DataInput
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DataInput} DataInput
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataInput.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataInput message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DataInput
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataInput.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        switch (message.Operator) {
                        default:
                            return "Operator: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                            break;
                        }
                    if (message.Values != null && message.hasOwnProperty("Values")) {
                        if (!Array.isArray(message.Values))
                            return "Values: array expected";
                        for (var i = 0; i < message.Values.length; ++i)
                            if (!$util.isString(message.Values[i]))
                                return "Values: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a DataInput message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DataInput
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DataInput} DataInput
                 */
                DataInput.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DataInput)
                        return object;
                    var message = new $root.priority.netitems.nrest.DataInput();
                    switch (object.Operator) {
                    case "Eq":
                    case 0:
                        message.Operator = 0;
                        break;
                    case "In":
                    case 1:
                        message.Operator = 1;
                        break;
                    case "NotIn":
                    case 2:
                        message.Operator = 2;
                        break;
                    case "Between":
                    case 3:
                        message.Operator = 3;
                        break;
                    case "Gt":
                    case 4:
                        message.Operator = 4;
                        break;
                    case "Lt":
                    case 5:
                        message.Operator = 5;
                        break;
                    case "Le":
                    case 6:
                        message.Operator = 6;
                        break;
                    case "Ge":
                    case 7:
                        message.Operator = 7;
                        break;
                    case "Ne":
                    case 8:
                        message.Operator = 8;
                        break;
                    case "NotBetween":
                    case 9:
                        message.Operator = 9;
                        break;
                    case "IsNull":
                    case 10:
                        message.Operator = 10;
                        break;
                    case "IsNotNull":
                    case 11:
                        message.Operator = 11;
                        break;
                    case "Like":
                    case 12:
                        message.Operator = 12;
                        break;
                    case "NotLike":
                    case 13:
                        message.Operator = 13;
                        break;
                    case "AndNot":
                    case 14:
                        message.Operator = 14;
                        break;
                    }
                    if (object.Values) {
                        if (!Array.isArray(object.Values))
                            throw TypeError(".priority.netitems.nrest.DataInput.Values: array expected");
                        message.Values = [];
                        for (var i = 0; i < object.Values.length; ++i)
                            message.Values[i] = String(object.Values[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DataInput message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DataInput
                 * @static
                 * @param {priority.netitems.nrest.DataInput} message DataInput
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataInput.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Values = [];
                    if (options.defaults)
                        object.Operator = options.enums === String ? "Eq" : 0;
                    if (message.Operator != null && message.hasOwnProperty("Operator"))
                        object.Operator = options.enums === String ? $root.priority.netitems.shared.ComparisonOperator[message.Operator] : message.Operator;
                    if (message.Values && message.Values.length) {
                        object.Values = [];
                        for (var j = 0; j < message.Values.length; ++j)
                            object.Values[j] = message.Values[j];
                    }
                    return object;
                };

                /**
                 * Converts this DataInput to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DataInput
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataInput.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataInput;
            })();

            nrest.DataInputInfo = (function() {

                /**
                 * Properties of a DataInputInfo.
                 * @memberof priority.netitems.nrest
                 * @interface IDataInputInfo
                 * @property {string|null} [Title] DataInputInfo Title
                 * @property {string|null} [Sign] DataInputInfo Sign
                 * @property {string|null} [Value] DataInputInfo Value
                 */

                /**
                 * Constructs a new DataInputInfo.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DataInputInfo.
                 * @implements IDataInputInfo
                 * @constructor
                 * @param {priority.netitems.nrest.IDataInputInfo=} [properties] Properties to set
                 */
                function DataInputInfo(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataInputInfo Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @instance
                 */
                DataInputInfo.prototype.Title = "";

                /**
                 * DataInputInfo Sign.
                 * @member {string} Sign
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @instance
                 */
                DataInputInfo.prototype.Sign = "";

                /**
                 * DataInputInfo Value.
                 * @member {string} Value
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @instance
                 */
                DataInputInfo.prototype.Value = "";

                /**
                 * Creates a new DataInputInfo instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @static
                 * @param {priority.netitems.nrest.IDataInputInfo=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DataInputInfo} DataInputInfo instance
                 */
                DataInputInfo.create = function create(properties) {
                    return new DataInputInfo(properties);
                };

                /**
                 * Encodes the specified DataInputInfo message. Does not implicitly {@link priority.netitems.nrest.DataInputInfo.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @static
                 * @param {priority.netitems.nrest.IDataInputInfo} message DataInputInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataInputInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
                    if (message.Sign != null && Object.hasOwnProperty.call(message, "Sign"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Sign);
                    if (message.Value != null && Object.hasOwnProperty.call(message, "Value"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Value);
                    return writer;
                };

                /**
                 * Encodes the specified DataInputInfo message, length delimited. Does not implicitly {@link priority.netitems.nrest.DataInputInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @static
                 * @param {priority.netitems.nrest.IDataInputInfo} message DataInputInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataInputInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataInputInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DataInputInfo} DataInputInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataInputInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DataInputInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Title = reader.string();
                            break;
                        case 2:
                            message.Sign = reader.string();
                            break;
                        case 3:
                            message.Value = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataInputInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DataInputInfo} DataInputInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataInputInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataInputInfo message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataInputInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Sign != null && message.hasOwnProperty("Sign"))
                        if (!$util.isString(message.Sign))
                            return "Sign: string expected";
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        if (!$util.isString(message.Value))
                            return "Value: string expected";
                    return null;
                };

                /**
                 * Creates a DataInputInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DataInputInfo} DataInputInfo
                 */
                DataInputInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DataInputInfo)
                        return object;
                    var message = new $root.priority.netitems.nrest.DataInputInfo();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Sign != null)
                        message.Sign = String(object.Sign);
                    if (object.Value != null)
                        message.Value = String(object.Value);
                    return message;
                };

                /**
                 * Creates a plain object from a DataInputInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @static
                 * @param {priority.netitems.nrest.DataInputInfo} message DataInputInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataInputInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Title = "";
                        object.Sign = "";
                        object.Value = "";
                    }
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Sign != null && message.hasOwnProperty("Sign"))
                        object.Sign = message.Sign;
                    if (message.Value != null && message.hasOwnProperty("Value"))
                        object.Value = message.Value;
                    return object;
                };

                /**
                 * Converts this DataInputInfo to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DataInputInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataInputInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataInputInfo;
            })();

            nrest.DataRq = (function() {

                /**
                 * Properties of a DataRq.
                 * @memberof priority.netitems.nrest
                 * @interface IDataRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] DataRq Properties
                 * @property {number|Long|null} [ReportId] DataRq ReportId
                 * @property {Array.<priority.netitems.nrest.IDataInput>|null} [Inputs] DataRq Inputs
                 */

                /**
                 * Constructs a new DataRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DataRq.
                 * @implements IDataRq
                 * @constructor
                 * @param {priority.netitems.nrest.IDataRq=} [properties] Properties to set
                 */
                function DataRq(properties) {
                    this.Inputs = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.DataRq
                 * @instance
                 */
                DataRq.prototype.Properties = null;

                /**
                 * DataRq ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.DataRq
                 * @instance
                 */
                DataRq.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * DataRq Inputs.
                 * @member {Array.<priority.netitems.nrest.IDataInput>} Inputs
                 * @memberof priority.netitems.nrest.DataRq
                 * @instance
                 */
                DataRq.prototype.Inputs = $util.emptyArray;

                /**
                 * Creates a new DataRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DataRq
                 * @static
                 * @param {priority.netitems.nrest.IDataRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DataRq} DataRq instance
                 */
                DataRq.create = function create(properties) {
                    return new DataRq(properties);
                };

                /**
                 * Encodes the specified DataRq message. Does not implicitly {@link priority.netitems.nrest.DataRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DataRq
                 * @static
                 * @param {priority.netitems.nrest.IDataRq} message DataRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.ReportId);
                    if (message.Inputs != null && message.Inputs.length)
                        for (var i = 0; i < message.Inputs.length; ++i)
                            $root.priority.netitems.nrest.DataInput.encode(message.Inputs[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DataRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.DataRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DataRq
                 * @static
                 * @param {priority.netitems.nrest.IDataRq} message DataRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DataRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DataRq} DataRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DataRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.ReportId = reader.int64();
                            break;
                        case 3:
                            if (!(message.Inputs && message.Inputs.length))
                                message.Inputs = [];
                            message.Inputs.push($root.priority.netitems.nrest.DataInput.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DataRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DataRq} DataRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DataRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    if (message.Inputs != null && message.hasOwnProperty("Inputs")) {
                        if (!Array.isArray(message.Inputs))
                            return "Inputs: array expected";
                        for (var i = 0; i < message.Inputs.length; ++i) {
                            var error = $root.priority.netitems.nrest.DataInput.verify(message.Inputs[i]);
                            if (error)
                                return "Inputs." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DataRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DataRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DataRq} DataRq
                 */
                DataRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DataRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.DataRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.DataRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    if (object.Inputs) {
                        if (!Array.isArray(object.Inputs))
                            throw TypeError(".priority.netitems.nrest.DataRq.Inputs: array expected");
                        message.Inputs = [];
                        for (var i = 0; i < object.Inputs.length; ++i) {
                            if (typeof object.Inputs[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DataRq.Inputs: object expected");
                            message.Inputs[i] = $root.priority.netitems.nrest.DataInput.fromObject(object.Inputs[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DataRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DataRq
                 * @static
                 * @param {priority.netitems.nrest.DataRq} message DataRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Inputs = [];
                    if (options.defaults) {
                        object.Properties = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    if (message.Inputs && message.Inputs.length) {
                        object.Inputs = [];
                        for (var j = 0; j < message.Inputs.length; ++j)
                            object.Inputs[j] = $root.priority.netitems.nrest.DataInput.toObject(message.Inputs[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this DataRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DataRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataRq;
            })();

            nrest.DataColumn = (function() {

                /**
                 * Properties of a DataColumn.
                 * @memberof priority.netitems.nrest
                 * @interface IDataColumn
                 * @property {number|Long|null} [Id] DataColumn Id
                 * @property {boolean|null} [IsCompany] DataColumn IsCompany
                 * @property {string|null} [Title] DataColumn Title
                 */

                /**
                 * Constructs a new DataColumn.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DataColumn.
                 * @implements IDataColumn
                 * @constructor
                 * @param {priority.netitems.nrest.IDataColumn=} [properties] Properties to set
                 */
                function DataColumn(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataColumn Id.
                 * @member {number|Long} Id
                 * @memberof priority.netitems.nrest.DataColumn
                 * @instance
                 */
                DataColumn.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * DataColumn IsCompany.
                 * @member {boolean} IsCompany
                 * @memberof priority.netitems.nrest.DataColumn
                 * @instance
                 */
                DataColumn.prototype.IsCompany = false;

                /**
                 * DataColumn Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.DataColumn
                 * @instance
                 */
                DataColumn.prototype.Title = "";

                /**
                 * Creates a new DataColumn instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DataColumn
                 * @static
                 * @param {priority.netitems.nrest.IDataColumn=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DataColumn} DataColumn instance
                 */
                DataColumn.create = function create(properties) {
                    return new DataColumn(properties);
                };

                /**
                 * Encodes the specified DataColumn message. Does not implicitly {@link priority.netitems.nrest.DataColumn.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DataColumn
                 * @static
                 * @param {priority.netitems.nrest.IDataColumn} message DataColumn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataColumn.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
                    if (message.IsCompany != null && Object.hasOwnProperty.call(message, "IsCompany"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.IsCompany);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Title);
                    return writer;
                };

                /**
                 * Encodes the specified DataColumn message, length delimited. Does not implicitly {@link priority.netitems.nrest.DataColumn.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DataColumn
                 * @static
                 * @param {priority.netitems.nrest.IDataColumn} message DataColumn message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataColumn.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataColumn message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DataColumn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DataColumn} DataColumn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataColumn.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DataColumn();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Id = reader.int64();
                            break;
                        case 2:
                            message.IsCompany = reader.bool();
                            break;
                        case 3:
                            message.Title = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataColumn message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DataColumn
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DataColumn} DataColumn
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataColumn.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataColumn message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DataColumn
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataColumn.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                            return "Id: integer|Long expected";
                    if (message.IsCompany != null && message.hasOwnProperty("IsCompany"))
                        if (typeof message.IsCompany !== "boolean")
                            return "IsCompany: boolean expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    return null;
                };

                /**
                 * Creates a DataColumn message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DataColumn
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DataColumn} DataColumn
                 */
                DataColumn.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DataColumn)
                        return object;
                    var message = new $root.priority.netitems.nrest.DataColumn();
                    if (object.Id != null)
                        if ($util.Long)
                            (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                        else if (typeof object.Id === "string")
                            message.Id = parseInt(object.Id, 10);
                        else if (typeof object.Id === "number")
                            message.Id = object.Id;
                        else if (typeof object.Id === "object")
                            message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
                    if (object.IsCompany != null)
                        message.IsCompany = Boolean(object.IsCompany);
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    return message;
                };

                /**
                 * Creates a plain object from a DataColumn message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DataColumn
                 * @static
                 * @param {priority.netitems.nrest.DataColumn} message DataColumn
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataColumn.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Id = options.longs === String ? "0" : 0;
                        object.IsCompany = false;
                        object.Title = "";
                    }
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (typeof message.Id === "number")
                            object.Id = options.longs === String ? String(message.Id) : message.Id;
                        else
                            object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                    if (message.IsCompany != null && message.hasOwnProperty("IsCompany"))
                        object.IsCompany = message.IsCompany;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    return object;
                };

                /**
                 * Converts this DataColumn to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DataColumn
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataColumn.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataColumn;
            })();

            nrest.DataHeader = (function() {

                /**
                 * Properties of a DataHeader.
                 * @memberof priority.netitems.nrest
                 * @interface IDataHeader
                 * @property {string|null} [Company] DataHeader Company
                 * @property {string|null} [User] DataHeader User
                 * @property {common.IDateTime|null} [Updated] DataHeader Updated
                 * @property {string|null} [Inputs] DataHeader Inputs
                 */

                /**
                 * Constructs a new DataHeader.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DataHeader.
                 * @implements IDataHeader
                 * @constructor
                 * @param {priority.netitems.nrest.IDataHeader=} [properties] Properties to set
                 */
                function DataHeader(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataHeader Company.
                 * @member {string} Company
                 * @memberof priority.netitems.nrest.DataHeader
                 * @instance
                 */
                DataHeader.prototype.Company = "";

                /**
                 * DataHeader User.
                 * @member {string} User
                 * @memberof priority.netitems.nrest.DataHeader
                 * @instance
                 */
                DataHeader.prototype.User = "";

                /**
                 * DataHeader Updated.
                 * @member {common.IDateTime|null|undefined} Updated
                 * @memberof priority.netitems.nrest.DataHeader
                 * @instance
                 */
                DataHeader.prototype.Updated = null;

                /**
                 * DataHeader Inputs.
                 * @member {string} Inputs
                 * @memberof priority.netitems.nrest.DataHeader
                 * @instance
                 */
                DataHeader.prototype.Inputs = "";

                /**
                 * Creates a new DataHeader instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DataHeader
                 * @static
                 * @param {priority.netitems.nrest.IDataHeader=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DataHeader} DataHeader instance
                 */
                DataHeader.create = function create(properties) {
                    return new DataHeader(properties);
                };

                /**
                 * Encodes the specified DataHeader message. Does not implicitly {@link priority.netitems.nrest.DataHeader.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DataHeader
                 * @static
                 * @param {priority.netitems.nrest.IDataHeader} message DataHeader message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataHeader.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Company != null && Object.hasOwnProperty.call(message, "Company"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Company);
                    if (message.User != null && Object.hasOwnProperty.call(message, "User"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.User);
                    if (message.Updated != null && Object.hasOwnProperty.call(message, "Updated"))
                        $root.common.DateTime.encode(message.Updated, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Inputs != null && Object.hasOwnProperty.call(message, "Inputs"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.Inputs);
                    return writer;
                };

                /**
                 * Encodes the specified DataHeader message, length delimited. Does not implicitly {@link priority.netitems.nrest.DataHeader.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DataHeader
                 * @static
                 * @param {priority.netitems.nrest.IDataHeader} message DataHeader message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataHeader.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataHeader message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DataHeader
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DataHeader} DataHeader
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataHeader.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DataHeader();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Company = reader.string();
                            break;
                        case 2:
                            message.User = reader.string();
                            break;
                        case 3:
                            message.Updated = $root.common.DateTime.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.Inputs = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataHeader message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DataHeader
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DataHeader} DataHeader
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataHeader.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataHeader message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DataHeader
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataHeader.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Company != null && message.hasOwnProperty("Company"))
                        if (!$util.isString(message.Company))
                            return "Company: string expected";
                    if (message.User != null && message.hasOwnProperty("User"))
                        if (!$util.isString(message.User))
                            return "User: string expected";
                    if (message.Updated != null && message.hasOwnProperty("Updated")) {
                        var error = $root.common.DateTime.verify(message.Updated);
                        if (error)
                            return "Updated." + error;
                    }
                    if (message.Inputs != null && message.hasOwnProperty("Inputs"))
                        if (!$util.isString(message.Inputs))
                            return "Inputs: string expected";
                    return null;
                };

                /**
                 * Creates a DataHeader message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DataHeader
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DataHeader} DataHeader
                 */
                DataHeader.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DataHeader)
                        return object;
                    var message = new $root.priority.netitems.nrest.DataHeader();
                    if (object.Company != null)
                        message.Company = String(object.Company);
                    if (object.User != null)
                        message.User = String(object.User);
                    if (object.Updated != null) {
                        if (typeof object.Updated !== "object")
                            throw TypeError(".priority.netitems.nrest.DataHeader.Updated: object expected");
                        message.Updated = $root.common.DateTime.fromObject(object.Updated);
                    }
                    if (object.Inputs != null)
                        message.Inputs = String(object.Inputs);
                    return message;
                };

                /**
                 * Creates a plain object from a DataHeader message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DataHeader
                 * @static
                 * @param {priority.netitems.nrest.DataHeader} message DataHeader
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataHeader.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Company = "";
                        object.User = "";
                        object.Updated = null;
                        object.Inputs = "";
                    }
                    if (message.Company != null && message.hasOwnProperty("Company"))
                        object.Company = message.Company;
                    if (message.User != null && message.hasOwnProperty("User"))
                        object.User = message.User;
                    if (message.Updated != null && message.hasOwnProperty("Updated"))
                        object.Updated = $root.common.DateTime.toObject(message.Updated, options);
                    if (message.Inputs != null && message.hasOwnProperty("Inputs"))
                        object.Inputs = message.Inputs;
                    return object;
                };

                /**
                 * Converts this DataHeader to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DataHeader
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataHeader.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataHeader;
            })();

            nrest.Company = (function() {

                /**
                 * Properties of a Company.
                 * @memberof priority.netitems.nrest
                 * @interface ICompany
                 * @property {string|null} [Title] Company Title
                 * @property {string|null} [Translation] Company Translation
                 */

                /**
                 * Constructs a new Company.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a Company.
                 * @implements ICompany
                 * @constructor
                 * @param {priority.netitems.nrest.ICompany=} [properties] Properties to set
                 */
                function Company(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Company Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.Company
                 * @instance
                 */
                Company.prototype.Title = "";

                /**
                 * Company Translation.
                 * @member {string} Translation
                 * @memberof priority.netitems.nrest.Company
                 * @instance
                 */
                Company.prototype.Translation = "";

                /**
                 * Creates a new Company instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Company
                 * @static
                 * @param {priority.netitems.nrest.ICompany=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Company} Company instance
                 */
                Company.create = function create(properties) {
                    return new Company(properties);
                };

                /**
                 * Encodes the specified Company message. Does not implicitly {@link priority.netitems.nrest.Company.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Company
                 * @static
                 * @param {priority.netitems.nrest.ICompany} message Company message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Company.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
                    if (message.Translation != null && Object.hasOwnProperty.call(message, "Translation"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Translation);
                    return writer;
                };

                /**
                 * Encodes the specified Company message, length delimited. Does not implicitly {@link priority.netitems.nrest.Company.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Company
                 * @static
                 * @param {priority.netitems.nrest.ICompany} message Company message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Company.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Company message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Company
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Company} Company
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Company.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Company();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Title = reader.string();
                            break;
                        case 2:
                            message.Translation = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Company message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Company
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Company} Company
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Company.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Company message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Company
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Company.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.Translation != null && message.hasOwnProperty("Translation"))
                        if (!$util.isString(message.Translation))
                            return "Translation: string expected";
                    return null;
                };

                /**
                 * Creates a Company message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Company
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Company} Company
                 */
                Company.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Company)
                        return object;
                    var message = new $root.priority.netitems.nrest.Company();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.Translation != null)
                        message.Translation = String(object.Translation);
                    return message;
                };

                /**
                 * Creates a plain object from a Company message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Company
                 * @static
                 * @param {priority.netitems.nrest.Company} message Company
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Company.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Title = "";
                        object.Translation = "";
                    }
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.Translation != null && message.hasOwnProperty("Translation"))
                        object.Translation = message.Translation;
                    return object;
                };

                /**
                 * Converts this Company to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Company
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Company.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Company;
            })();

            nrest.Row = (function() {

                /**
                 * Properties of a Row.
                 * @memberof priority.netitems.nrest
                 * @interface IRow
                 * @property {priority.netitems.nrest.IDataRow|null} [Val] Row Val
                 * @property {priority.netitems.nrest.IDataRow|null} [Orig] Row Orig
                 */

                /**
                 * Constructs a new Row.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a Row.
                 * @implements IRow
                 * @constructor
                 * @param {priority.netitems.nrest.IRow=} [properties] Properties to set
                 */
                function Row(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Row Val.
                 * @member {priority.netitems.nrest.IDataRow|null|undefined} Val
                 * @memberof priority.netitems.nrest.Row
                 * @instance
                 */
                Row.prototype.Val = null;

                /**
                 * Row Orig.
                 * @member {priority.netitems.nrest.IDataRow|null|undefined} Orig
                 * @memberof priority.netitems.nrest.Row
                 * @instance
                 */
                Row.prototype.Orig = null;

                /**
                 * Creates a new Row instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Row
                 * @static
                 * @param {priority.netitems.nrest.IRow=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Row} Row instance
                 */
                Row.create = function create(properties) {
                    return new Row(properties);
                };

                /**
                 * Encodes the specified Row message. Does not implicitly {@link priority.netitems.nrest.Row.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Row
                 * @static
                 * @param {priority.netitems.nrest.IRow} message Row message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Row.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Val != null && Object.hasOwnProperty.call(message, "Val"))
                        $root.priority.netitems.nrest.DataRow.encode(message.Val, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Orig != null && Object.hasOwnProperty.call(message, "Orig"))
                        $root.priority.netitems.nrest.DataRow.encode(message.Orig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Row message, length delimited. Does not implicitly {@link priority.netitems.nrest.Row.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Row
                 * @static
                 * @param {priority.netitems.nrest.IRow} message Row message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Row.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Row message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Row
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Row} Row
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Row.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Row();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Val = $root.priority.netitems.nrest.DataRow.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Orig = $root.priority.netitems.nrest.DataRow.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Row message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Row
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Row} Row
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Row.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Row message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Row
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Row.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Val != null && message.hasOwnProperty("Val")) {
                        var error = $root.priority.netitems.nrest.DataRow.verify(message.Val);
                        if (error)
                            return "Val." + error;
                    }
                    if (message.Orig != null && message.hasOwnProperty("Orig")) {
                        var error = $root.priority.netitems.nrest.DataRow.verify(message.Orig);
                        if (error)
                            return "Orig." + error;
                    }
                    return null;
                };

                /**
                 * Creates a Row message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Row
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Row} Row
                 */
                Row.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Row)
                        return object;
                    var message = new $root.priority.netitems.nrest.Row();
                    if (object.Val != null) {
                        if (typeof object.Val !== "object")
                            throw TypeError(".priority.netitems.nrest.Row.Val: object expected");
                        message.Val = $root.priority.netitems.nrest.DataRow.fromObject(object.Val);
                    }
                    if (object.Orig != null) {
                        if (typeof object.Orig !== "object")
                            throw TypeError(".priority.netitems.nrest.Row.Orig: object expected");
                        message.Orig = $root.priority.netitems.nrest.DataRow.fromObject(object.Orig);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Row message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Row
                 * @static
                 * @param {priority.netitems.nrest.Row} message Row
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Row.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Val = null;
                        object.Orig = null;
                    }
                    if (message.Val != null && message.hasOwnProperty("Val"))
                        object.Val = $root.priority.netitems.nrest.DataRow.toObject(message.Val, options);
                    if (message.Orig != null && message.hasOwnProperty("Orig"))
                        object.Orig = $root.priority.netitems.nrest.DataRow.toObject(message.Orig, options);
                    return object;
                };

                /**
                 * Converts this Row to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Row
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Row.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Row;
            })();

            nrest.DataRs = (function() {

                /**
                 * Properties of a DataRs.
                 * @memberof priority.netitems.nrest
                 * @interface IDataRs
                 * @property {Array.<priority.netitems.nrest.IDataColumn>|null} [Columns] DataRs Columns
                 * @property {Array.<priority.netitems.nrest.IDataRow>|null} [DataRows] DataRs DataRows
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] DataRs Messages
                 * @property {priority.netitems.nrest.IDataHeader|null} [Header] DataRs Header
                 * @property {Array.<priority.netitems.nrest.ICompany>|null} [Companies] DataRs Companies
                 * @property {Array.<priority.netitems.nrest.IRow>|null} [Rows] DataRs Rows
                 * @property {Array.<priority.netitems.nrest.IDataInputInfo>|null} [Inputs] DataRs Inputs
                 */

                /**
                 * Constructs a new DataRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DataRs.
                 * @implements IDataRs
                 * @constructor
                 * @param {priority.netitems.nrest.IDataRs=} [properties] Properties to set
                 */
                function DataRs(properties) {
                    this.Columns = [];
                    this.DataRows = [];
                    this.Messages = [];
                    this.Companies = [];
                    this.Rows = [];
                    this.Inputs = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DataRs Columns.
                 * @member {Array.<priority.netitems.nrest.IDataColumn>} Columns
                 * @memberof priority.netitems.nrest.DataRs
                 * @instance
                 */
                DataRs.prototype.Columns = $util.emptyArray;

                /**
                 * DataRs DataRows.
                 * @member {Array.<priority.netitems.nrest.IDataRow>} DataRows
                 * @memberof priority.netitems.nrest.DataRs
                 * @instance
                 */
                DataRs.prototype.DataRows = $util.emptyArray;

                /**
                 * DataRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.DataRs
                 * @instance
                 */
                DataRs.prototype.Messages = $util.emptyArray;

                /**
                 * DataRs Header.
                 * @member {priority.netitems.nrest.IDataHeader|null|undefined} Header
                 * @memberof priority.netitems.nrest.DataRs
                 * @instance
                 */
                DataRs.prototype.Header = null;

                /**
                 * DataRs Companies.
                 * @member {Array.<priority.netitems.nrest.ICompany>} Companies
                 * @memberof priority.netitems.nrest.DataRs
                 * @instance
                 */
                DataRs.prototype.Companies = $util.emptyArray;

                /**
                 * DataRs Rows.
                 * @member {Array.<priority.netitems.nrest.IRow>} Rows
                 * @memberof priority.netitems.nrest.DataRs
                 * @instance
                 */
                DataRs.prototype.Rows = $util.emptyArray;

                /**
                 * DataRs Inputs.
                 * @member {Array.<priority.netitems.nrest.IDataInputInfo>} Inputs
                 * @memberof priority.netitems.nrest.DataRs
                 * @instance
                 */
                DataRs.prototype.Inputs = $util.emptyArray;

                /**
                 * Creates a new DataRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DataRs
                 * @static
                 * @param {priority.netitems.nrest.IDataRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DataRs} DataRs instance
                 */
                DataRs.create = function create(properties) {
                    return new DataRs(properties);
                };

                /**
                 * Encodes the specified DataRs message. Does not implicitly {@link priority.netitems.nrest.DataRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DataRs
                 * @static
                 * @param {priority.netitems.nrest.IDataRs} message DataRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Columns != null && message.Columns.length)
                        for (var i = 0; i < message.Columns.length; ++i)
                            $root.priority.netitems.nrest.DataColumn.encode(message.Columns[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.DataRows != null && message.DataRows.length)
                        for (var i = 0; i < message.DataRows.length; ++i)
                            $root.priority.netitems.nrest.DataRow.encode(message.DataRows[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Header != null && Object.hasOwnProperty.call(message, "Header"))
                        $root.priority.netitems.nrest.DataHeader.encode(message.Header, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.Companies != null && message.Companies.length)
                        for (var i = 0; i < message.Companies.length; ++i)
                            $root.priority.netitems.nrest.Company.encode(message.Companies[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.Rows != null && message.Rows.length)
                        for (var i = 0; i < message.Rows.length; ++i)
                            $root.priority.netitems.nrest.Row.encode(message.Rows[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Inputs != null && message.Inputs.length)
                        for (var i = 0; i < message.Inputs.length; ++i)
                            $root.priority.netitems.nrest.DataInputInfo.encode(message.Inputs[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DataRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.DataRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DataRs
                 * @static
                 * @param {priority.netitems.nrest.IDataRs} message DataRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DataRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DataRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DataRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DataRs} DataRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DataRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Columns && message.Columns.length))
                                message.Columns = [];
                            message.Columns.push($root.priority.netitems.nrest.DataColumn.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.DataRows && message.DataRows.length))
                                message.DataRows = [];
                            message.DataRows.push($root.priority.netitems.nrest.DataRow.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            message.Header = $root.priority.netitems.nrest.DataHeader.decode(reader, reader.uint32());
                            break;
                        case 5:
                            if (!(message.Companies && message.Companies.length))
                                message.Companies = [];
                            message.Companies.push($root.priority.netitems.nrest.Company.decode(reader, reader.uint32()));
                            break;
                        case 6:
                            if (!(message.Rows && message.Rows.length))
                                message.Rows = [];
                            message.Rows.push($root.priority.netitems.nrest.Row.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            if (!(message.Inputs && message.Inputs.length))
                                message.Inputs = [];
                            message.Inputs.push($root.priority.netitems.nrest.DataInputInfo.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DataRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DataRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DataRs} DataRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DataRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DataRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DataRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DataRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (!Array.isArray(message.Columns))
                            return "Columns: array expected";
                        for (var i = 0; i < message.Columns.length; ++i) {
                            var error = $root.priority.netitems.nrest.DataColumn.verify(message.Columns[i]);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.DataRows != null && message.hasOwnProperty("DataRows")) {
                        if (!Array.isArray(message.DataRows))
                            return "DataRows: array expected";
                        for (var i = 0; i < message.DataRows.length; ++i) {
                            var error = $root.priority.netitems.nrest.DataRow.verify(message.DataRows[i]);
                            if (error)
                                return "DataRows." + error;
                        }
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Header != null && message.hasOwnProperty("Header")) {
                        var error = $root.priority.netitems.nrest.DataHeader.verify(message.Header);
                        if (error)
                            return "Header." + error;
                    }
                    if (message.Companies != null && message.hasOwnProperty("Companies")) {
                        if (!Array.isArray(message.Companies))
                            return "Companies: array expected";
                        for (var i = 0; i < message.Companies.length; ++i) {
                            var error = $root.priority.netitems.nrest.Company.verify(message.Companies[i]);
                            if (error)
                                return "Companies." + error;
                        }
                    }
                    if (message.Rows != null && message.hasOwnProperty("Rows")) {
                        if (!Array.isArray(message.Rows))
                            return "Rows: array expected";
                        for (var i = 0; i < message.Rows.length; ++i) {
                            var error = $root.priority.netitems.nrest.Row.verify(message.Rows[i]);
                            if (error)
                                return "Rows." + error;
                        }
                    }
                    if (message.Inputs != null && message.hasOwnProperty("Inputs")) {
                        if (!Array.isArray(message.Inputs))
                            return "Inputs: array expected";
                        for (var i = 0; i < message.Inputs.length; ++i) {
                            var error = $root.priority.netitems.nrest.DataInputInfo.verify(message.Inputs[i]);
                            if (error)
                                return "Inputs." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DataRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DataRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DataRs} DataRs
                 */
                DataRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DataRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.DataRs();
                    if (object.Columns) {
                        if (!Array.isArray(object.Columns))
                            throw TypeError(".priority.netitems.nrest.DataRs.Columns: array expected");
                        message.Columns = [];
                        for (var i = 0; i < object.Columns.length; ++i) {
                            if (typeof object.Columns[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DataRs.Columns: object expected");
                            message.Columns[i] = $root.priority.netitems.nrest.DataColumn.fromObject(object.Columns[i]);
                        }
                    }
                    if (object.DataRows) {
                        if (!Array.isArray(object.DataRows))
                            throw TypeError(".priority.netitems.nrest.DataRs.DataRows: array expected");
                        message.DataRows = [];
                        for (var i = 0; i < object.DataRows.length; ++i) {
                            if (typeof object.DataRows[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DataRs.DataRows: object expected");
                            message.DataRows[i] = $root.priority.netitems.nrest.DataRow.fromObject(object.DataRows[i]);
                        }
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.DataRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DataRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Header != null) {
                        if (typeof object.Header !== "object")
                            throw TypeError(".priority.netitems.nrest.DataRs.Header: object expected");
                        message.Header = $root.priority.netitems.nrest.DataHeader.fromObject(object.Header);
                    }
                    if (object.Companies) {
                        if (!Array.isArray(object.Companies))
                            throw TypeError(".priority.netitems.nrest.DataRs.Companies: array expected");
                        message.Companies = [];
                        for (var i = 0; i < object.Companies.length; ++i) {
                            if (typeof object.Companies[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DataRs.Companies: object expected");
                            message.Companies[i] = $root.priority.netitems.nrest.Company.fromObject(object.Companies[i]);
                        }
                    }
                    if (object.Rows) {
                        if (!Array.isArray(object.Rows))
                            throw TypeError(".priority.netitems.nrest.DataRs.Rows: array expected");
                        message.Rows = [];
                        for (var i = 0; i < object.Rows.length; ++i) {
                            if (typeof object.Rows[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DataRs.Rows: object expected");
                            message.Rows[i] = $root.priority.netitems.nrest.Row.fromObject(object.Rows[i]);
                        }
                    }
                    if (object.Inputs) {
                        if (!Array.isArray(object.Inputs))
                            throw TypeError(".priority.netitems.nrest.DataRs.Inputs: array expected");
                        message.Inputs = [];
                        for (var i = 0; i < object.Inputs.length; ++i) {
                            if (typeof object.Inputs[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DataRs.Inputs: object expected");
                            message.Inputs[i] = $root.priority.netitems.nrest.DataInputInfo.fromObject(object.Inputs[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DataRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DataRs
                 * @static
                 * @param {priority.netitems.nrest.DataRs} message DataRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DataRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Columns = [];
                        object.DataRows = [];
                        object.Messages = [];
                        object.Companies = [];
                        object.Rows = [];
                        object.Inputs = [];
                    }
                    if (options.defaults)
                        object.Header = null;
                    if (message.Columns && message.Columns.length) {
                        object.Columns = [];
                        for (var j = 0; j < message.Columns.length; ++j)
                            object.Columns[j] = $root.priority.netitems.nrest.DataColumn.toObject(message.Columns[j], options);
                    }
                    if (message.DataRows && message.DataRows.length) {
                        object.DataRows = [];
                        for (var j = 0; j < message.DataRows.length; ++j)
                            object.DataRows[j] = $root.priority.netitems.nrest.DataRow.toObject(message.DataRows[j], options);
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Header != null && message.hasOwnProperty("Header"))
                        object.Header = $root.priority.netitems.nrest.DataHeader.toObject(message.Header, options);
                    if (message.Companies && message.Companies.length) {
                        object.Companies = [];
                        for (var j = 0; j < message.Companies.length; ++j)
                            object.Companies[j] = $root.priority.netitems.nrest.Company.toObject(message.Companies[j], options);
                    }
                    if (message.Rows && message.Rows.length) {
                        object.Rows = [];
                        for (var j = 0; j < message.Rows.length; ++j)
                            object.Rows[j] = $root.priority.netitems.nrest.Row.toObject(message.Rows[j], options);
                    }
                    if (message.Inputs && message.Inputs.length) {
                        object.Inputs = [];
                        for (var j = 0; j < message.Inputs.length; ++j)
                            object.Inputs[j] = $root.priority.netitems.nrest.DataInputInfo.toObject(message.Inputs[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this DataRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DataRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DataRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DataRs;
            })();

            nrest.ReportDataRq = (function() {

                /**
                 * Properties of a ReportDataRq.
                 * @memberof priority.netitems.nrest
                 * @interface IReportDataRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ReportDataRq Properties
                 * @property {number|Long|null} [ReportId] ReportDataRq ReportId
                 */

                /**
                 * Constructs a new ReportDataRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportDataRq.
                 * @implements IReportDataRq
                 * @constructor
                 * @param {priority.netitems.nrest.IReportDataRq=} [properties] Properties to set
                 */
                function ReportDataRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportDataRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @instance
                 */
                ReportDataRq.prototype.Properties = null;

                /**
                 * ReportDataRq ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @instance
                 */
                ReportDataRq.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new ReportDataRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @static
                 * @param {priority.netitems.nrest.IReportDataRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportDataRq} ReportDataRq instance
                 */
                ReportDataRq.create = function create(properties) {
                    return new ReportDataRq(properties);
                };

                /**
                 * Encodes the specified ReportDataRq message. Does not implicitly {@link priority.netitems.nrest.ReportDataRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @static
                 * @param {priority.netitems.nrest.IReportDataRq} message ReportDataRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportDataRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.ReportId);
                    return writer;
                };

                /**
                 * Encodes the specified ReportDataRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportDataRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @static
                 * @param {priority.netitems.nrest.IReportDataRq} message ReportDataRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportDataRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportDataRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportDataRq} ReportDataRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportDataRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportDataRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.ReportId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportDataRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportDataRq} ReportDataRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportDataRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportDataRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportDataRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a ReportDataRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportDataRq} ReportDataRq
                 */
                ReportDataRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportDataRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportDataRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportDataRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a ReportDataRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @static
                 * @param {priority.netitems.nrest.ReportDataRq} message ReportDataRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportDataRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    return object;
                };

                /**
                 * Converts this ReportDataRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportDataRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportDataRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportDataRq;
            })();

            nrest.ReportData = (function() {

                /**
                 * Properties of a ReportData.
                 * @memberof priority.netitems.nrest
                 * @interface IReportData
                 * @property {number|Long|null} [ReportId] ReportData ReportId
                 * @property {string|null} [Title] ReportData Title
                 * @property {boolean|null} [General] ReportData General
                 * @property {boolean|null} [Vertical] ReportData Vertical
                 * @property {Array.<priority.netitems.nrest.IReportCol>|null} [Columns] ReportData Columns
                 * @property {boolean|null} [InUse] ReportData InUse
                 * @property {priority.netitems.nrest.RepType|null} [ReportType] ReportData ReportType
                 * @property {boolean|null} [Tabular] ReportData Tabular
                 * @property {number|Long|null} [OuterJoin] ReportData OuterJoin
                 * @property {number|Long|null} [ConnectId] ReportData ConnectId
                 */

                /**
                 * Constructs a new ReportData.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportData.
                 * @implements IReportData
                 * @constructor
                 * @param {priority.netitems.nrest.IReportData=} [properties] Properties to set
                 */
                function ReportData(properties) {
                    this.Columns = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportData ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportData Title.
                 * @member {string} Title
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.Title = "";

                /**
                 * ReportData General.
                 * @member {boolean} General
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.General = false;

                /**
                 * ReportData Vertical.
                 * @member {boolean} Vertical
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.Vertical = false;

                /**
                 * ReportData Columns.
                 * @member {Array.<priority.netitems.nrest.IReportCol>} Columns
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.Columns = $util.emptyArray;

                /**
                 * ReportData InUse.
                 * @member {boolean} InUse
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.InUse = false;

                /**
                 * ReportData ReportType.
                 * @member {priority.netitems.nrest.RepType} ReportType
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.ReportType = 0;

                /**
                 * ReportData Tabular.
                 * @member {boolean} Tabular
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.Tabular = false;

                /**
                 * ReportData OuterJoin.
                 * @member {number|Long} OuterJoin
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.OuterJoin = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportData ConnectId.
                 * @member {number|Long} ConnectId
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 */
                ReportData.prototype.ConnectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new ReportData instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportData
                 * @static
                 * @param {priority.netitems.nrest.IReportData=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportData} ReportData instance
                 */
                ReportData.create = function create(properties) {
                    return new ReportData(properties);
                };

                /**
                 * Encodes the specified ReportData message. Does not implicitly {@link priority.netitems.nrest.ReportData.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportData
                 * @static
                 * @param {priority.netitems.nrest.IReportData} message ReportData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportData.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.ReportId);
                    if (message.Title != null && Object.hasOwnProperty.call(message, "Title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
                    if (message.General != null && Object.hasOwnProperty.call(message, "General"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.General);
                    if (message.Vertical != null && Object.hasOwnProperty.call(message, "Vertical"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.Vertical);
                    if (message.Columns != null && message.Columns.length)
                        for (var i = 0; i < message.Columns.length; ++i)
                            $root.priority.netitems.nrest.ReportCol.encode(message.Columns[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.InUse != null && Object.hasOwnProperty.call(message, "InUse"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.InUse);
                    if (message.ReportType != null && Object.hasOwnProperty.call(message, "ReportType"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ReportType);
                    if (message.Tabular != null && Object.hasOwnProperty.call(message, "Tabular"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.Tabular);
                    if (message.OuterJoin != null && Object.hasOwnProperty.call(message, "OuterJoin"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.OuterJoin);
                    if (message.ConnectId != null && Object.hasOwnProperty.call(message, "ConnectId"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int64(message.ConnectId);
                    return writer;
                };

                /**
                 * Encodes the specified ReportData message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportData.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportData
                 * @static
                 * @param {priority.netitems.nrest.IReportData} message ReportData message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportData.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportData message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportData} ReportData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportData.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportData();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ReportId = reader.int64();
                            break;
                        case 2:
                            message.Title = reader.string();
                            break;
                        case 3:
                            message.General = reader.bool();
                            break;
                        case 4:
                            message.Vertical = reader.bool();
                            break;
                        case 5:
                            if (!(message.Columns && message.Columns.length))
                                message.Columns = [];
                            message.Columns.push($root.priority.netitems.nrest.ReportCol.decode(reader, reader.uint32()));
                            break;
                        case 6:
                            message.InUse = reader.bool();
                            break;
                        case 7:
                            message.ReportType = reader.int32();
                            break;
                        case 8:
                            message.Tabular = reader.bool();
                            break;
                        case 9:
                            message.OuterJoin = reader.int64();
                            break;
                        case 10:
                            message.ConnectId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportData message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportData
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportData} ReportData
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportData.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportData message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportData
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportData.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        if (!$util.isString(message.Title))
                            return "Title: string expected";
                    if (message.General != null && message.hasOwnProperty("General"))
                        if (typeof message.General !== "boolean")
                            return "General: boolean expected";
                    if (message.Vertical != null && message.hasOwnProperty("Vertical"))
                        if (typeof message.Vertical !== "boolean")
                            return "Vertical: boolean expected";
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (!Array.isArray(message.Columns))
                            return "Columns: array expected";
                        for (var i = 0; i < message.Columns.length; ++i) {
                            var error = $root.priority.netitems.nrest.ReportCol.verify(message.Columns[i]);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.InUse != null && message.hasOwnProperty("InUse"))
                        if (typeof message.InUse !== "boolean")
                            return "InUse: boolean expected";
                    if (message.ReportType != null && message.hasOwnProperty("ReportType"))
                        switch (message.ReportType) {
                        default:
                            return "ReportType: enum value expected";
                        case 0:
                        case 97:
                        case 99:
                        case 111:
                        case 114:
                        case 119:
                        case 121:
                            break;
                        }
                    if (message.Tabular != null && message.hasOwnProperty("Tabular"))
                        if (typeof message.Tabular !== "boolean")
                            return "Tabular: boolean expected";
                    if (message.OuterJoin != null && message.hasOwnProperty("OuterJoin"))
                        if (!$util.isInteger(message.OuterJoin) && !(message.OuterJoin && $util.isInteger(message.OuterJoin.low) && $util.isInteger(message.OuterJoin.high)))
                            return "OuterJoin: integer|Long expected";
                    if (message.ConnectId != null && message.hasOwnProperty("ConnectId"))
                        if (!$util.isInteger(message.ConnectId) && !(message.ConnectId && $util.isInteger(message.ConnectId.low) && $util.isInteger(message.ConnectId.high)))
                            return "ConnectId: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a ReportData message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportData
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportData} ReportData
                 */
                ReportData.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportData)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportData();
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    if (object.Title != null)
                        message.Title = String(object.Title);
                    if (object.General != null)
                        message.General = Boolean(object.General);
                    if (object.Vertical != null)
                        message.Vertical = Boolean(object.Vertical);
                    if (object.Columns) {
                        if (!Array.isArray(object.Columns))
                            throw TypeError(".priority.netitems.nrest.ReportData.Columns: array expected");
                        message.Columns = [];
                        for (var i = 0; i < object.Columns.length; ++i) {
                            if (typeof object.Columns[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportData.Columns: object expected");
                            message.Columns[i] = $root.priority.netitems.nrest.ReportCol.fromObject(object.Columns[i]);
                        }
                    }
                    if (object.InUse != null)
                        message.InUse = Boolean(object.InUse);
                    switch (object.ReportType) {
                    case "RepType_None":
                    case 0:
                        message.ReportType = 0;
                        break;
                    case "RepType_DynFields":
                    case 97:
                        message.ReportType = 97;
                        break;
                    case "RepType_Chart":
                    case 99:
                        message.ReportType = 99;
                        break;
                    case "RepType_DataSet":
                    case 111:
                        message.ReportType = 111;
                        break;
                    case "RepType_OldReport":
                    case 114:
                        message.ReportType = 114;
                        break;
                    case "RepType_Widget":
                    case 119:
                        message.ReportType = 119;
                        break;
                    case "RepType_Report":
                    case 121:
                        message.ReportType = 121;
                        break;
                    }
                    if (object.Tabular != null)
                        message.Tabular = Boolean(object.Tabular);
                    if (object.OuterJoin != null)
                        if ($util.Long)
                            (message.OuterJoin = $util.Long.fromValue(object.OuterJoin)).unsigned = false;
                        else if (typeof object.OuterJoin === "string")
                            message.OuterJoin = parseInt(object.OuterJoin, 10);
                        else if (typeof object.OuterJoin === "number")
                            message.OuterJoin = object.OuterJoin;
                        else if (typeof object.OuterJoin === "object")
                            message.OuterJoin = new $util.LongBits(object.OuterJoin.low >>> 0, object.OuterJoin.high >>> 0).toNumber();
                    if (object.ConnectId != null)
                        if ($util.Long)
                            (message.ConnectId = $util.Long.fromValue(object.ConnectId)).unsigned = false;
                        else if (typeof object.ConnectId === "string")
                            message.ConnectId = parseInt(object.ConnectId, 10);
                        else if (typeof object.ConnectId === "number")
                            message.ConnectId = object.ConnectId;
                        else if (typeof object.ConnectId === "object")
                            message.ConnectId = new $util.LongBits(object.ConnectId.low >>> 0, object.ConnectId.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a ReportData message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportData
                 * @static
                 * @param {priority.netitems.nrest.ReportData} message ReportData
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportData.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Columns = [];
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                        object.Title = "";
                        object.General = false;
                        object.Vertical = false;
                        object.InUse = false;
                        object.ReportType = options.enums === String ? "RepType_None" : 0;
                        object.Tabular = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.OuterJoin = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.OuterJoin = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ConnectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ConnectId = options.longs === String ? "0" : 0;
                    }
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    if (message.Title != null && message.hasOwnProperty("Title"))
                        object.Title = message.Title;
                    if (message.General != null && message.hasOwnProperty("General"))
                        object.General = message.General;
                    if (message.Vertical != null && message.hasOwnProperty("Vertical"))
                        object.Vertical = message.Vertical;
                    if (message.Columns && message.Columns.length) {
                        object.Columns = [];
                        for (var j = 0; j < message.Columns.length; ++j)
                            object.Columns[j] = $root.priority.netitems.nrest.ReportCol.toObject(message.Columns[j], options);
                    }
                    if (message.InUse != null && message.hasOwnProperty("InUse"))
                        object.InUse = message.InUse;
                    if (message.ReportType != null && message.hasOwnProperty("ReportType"))
                        object.ReportType = options.enums === String ? $root.priority.netitems.nrest.RepType[message.ReportType] : message.ReportType;
                    if (message.Tabular != null && message.hasOwnProperty("Tabular"))
                        object.Tabular = message.Tabular;
                    if (message.OuterJoin != null && message.hasOwnProperty("OuterJoin"))
                        if (typeof message.OuterJoin === "number")
                            object.OuterJoin = options.longs === String ? String(message.OuterJoin) : message.OuterJoin;
                        else
                            object.OuterJoin = options.longs === String ? $util.Long.prototype.toString.call(message.OuterJoin) : options.longs === Number ? new $util.LongBits(message.OuterJoin.low >>> 0, message.OuterJoin.high >>> 0).toNumber() : message.OuterJoin;
                    if (message.ConnectId != null && message.hasOwnProperty("ConnectId"))
                        if (typeof message.ConnectId === "number")
                            object.ConnectId = options.longs === String ? String(message.ConnectId) : message.ConnectId;
                        else
                            object.ConnectId = options.longs === String ? $util.Long.prototype.toString.call(message.ConnectId) : options.longs === Number ? new $util.LongBits(message.ConnectId.low >>> 0, message.ConnectId.high >>> 0).toNumber() : message.ConnectId;
                    return object;
                };

                /**
                 * Converts this ReportData to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportData
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportData.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportData;
            })();

            nrest.ReportDataRs = (function() {

                /**
                 * Properties of a ReportDataRs.
                 * @memberof priority.netitems.nrest
                 * @interface IReportDataRs
                 * @property {priority.netitems.nrest.IReportData|null} [data] ReportDataRs data
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ReportDataRs Messages
                 */

                /**
                 * Constructs a new ReportDataRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportDataRs.
                 * @implements IReportDataRs
                 * @constructor
                 * @param {priority.netitems.nrest.IReportDataRs=} [properties] Properties to set
                 */
                function ReportDataRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportDataRs data.
                 * @member {priority.netitems.nrest.IReportData|null|undefined} data
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @instance
                 */
                ReportDataRs.prototype.data = null;

                /**
                 * ReportDataRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @instance
                 */
                ReportDataRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new ReportDataRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @static
                 * @param {priority.netitems.nrest.IReportDataRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportDataRs} ReportDataRs instance
                 */
                ReportDataRs.create = function create(properties) {
                    return new ReportDataRs(properties);
                };

                /**
                 * Encodes the specified ReportDataRs message. Does not implicitly {@link priority.netitems.nrest.ReportDataRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @static
                 * @param {priority.netitems.nrest.IReportDataRs} message ReportDataRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportDataRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                        $root.priority.netitems.nrest.ReportData.encode(message.data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ReportDataRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportDataRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @static
                 * @param {priority.netitems.nrest.IReportDataRs} message ReportDataRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportDataRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportDataRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportDataRs} ReportDataRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportDataRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportDataRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.data = $root.priority.netitems.nrest.ReportData.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportDataRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportDataRs} ReportDataRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportDataRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportDataRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportDataRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.data != null && message.hasOwnProperty("data")) {
                        var error = $root.priority.netitems.nrest.ReportData.verify(message.data);
                        if (error)
                            return "data." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ReportDataRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportDataRs} ReportDataRs
                 */
                ReportDataRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportDataRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportDataRs();
                    if (object.data != null) {
                        if (typeof object.data !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportDataRs.data: object expected");
                        message.data = $root.priority.netitems.nrest.ReportData.fromObject(object.data);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.ReportDataRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportDataRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ReportDataRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @static
                 * @param {priority.netitems.nrest.ReportDataRs} message ReportDataRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportDataRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.data = null;
                    if (message.data != null && message.hasOwnProperty("data"))
                        object.data = $root.priority.netitems.nrest.ReportData.toObject(message.data, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ReportDataRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportDataRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportDataRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportDataRs;
            })();

            nrest.ReportDelRq = (function() {

                /**
                 * Properties of a ReportDelRq.
                 * @memberof priority.netitems.nrest
                 * @interface IReportDelRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ReportDelRq Properties
                 * @property {number|Long|null} [ReportId] ReportDelRq ReportId
                 */

                /**
                 * Constructs a new ReportDelRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportDelRq.
                 * @implements IReportDelRq
                 * @constructor
                 * @param {priority.netitems.nrest.IReportDelRq=} [properties] Properties to set
                 */
                function ReportDelRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportDelRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @instance
                 */
                ReportDelRq.prototype.Properties = null;

                /**
                 * ReportDelRq ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @instance
                 */
                ReportDelRq.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new ReportDelRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @static
                 * @param {priority.netitems.nrest.IReportDelRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportDelRq} ReportDelRq instance
                 */
                ReportDelRq.create = function create(properties) {
                    return new ReportDelRq(properties);
                };

                /**
                 * Encodes the specified ReportDelRq message. Does not implicitly {@link priority.netitems.nrest.ReportDelRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @static
                 * @param {priority.netitems.nrest.IReportDelRq} message ReportDelRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportDelRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.ReportId);
                    return writer;
                };

                /**
                 * Encodes the specified ReportDelRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportDelRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @static
                 * @param {priority.netitems.nrest.IReportDelRq} message ReportDelRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportDelRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportDelRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportDelRq} ReportDelRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportDelRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportDelRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.ReportId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportDelRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportDelRq} ReportDelRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportDelRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportDelRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportDelRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a ReportDelRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportDelRq} ReportDelRq
                 */
                ReportDelRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportDelRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportDelRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportDelRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a ReportDelRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @static
                 * @param {priority.netitems.nrest.ReportDelRq} message ReportDelRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportDelRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    return object;
                };

                /**
                 * Converts this ReportDelRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportDelRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportDelRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportDelRq;
            })();

            nrest.ReportDelRs = (function() {

                /**
                 * Properties of a ReportDelRs.
                 * @memberof priority.netitems.nrest
                 * @interface IReportDelRs
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ReportDelRs Messages
                 */

                /**
                 * Constructs a new ReportDelRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportDelRs.
                 * @implements IReportDelRs
                 * @constructor
                 * @param {priority.netitems.nrest.IReportDelRs=} [properties] Properties to set
                 */
                function ReportDelRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportDelRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @instance
                 */
                ReportDelRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new ReportDelRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @static
                 * @param {priority.netitems.nrest.IReportDelRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportDelRs} ReportDelRs instance
                 */
                ReportDelRs.create = function create(properties) {
                    return new ReportDelRs(properties);
                };

                /**
                 * Encodes the specified ReportDelRs message. Does not implicitly {@link priority.netitems.nrest.ReportDelRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @static
                 * @param {priority.netitems.nrest.IReportDelRs} message ReportDelRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportDelRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ReportDelRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportDelRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @static
                 * @param {priority.netitems.nrest.IReportDelRs} message ReportDelRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportDelRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportDelRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportDelRs} ReportDelRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportDelRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportDelRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportDelRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportDelRs} ReportDelRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportDelRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportDelRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportDelRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ReportDelRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportDelRs} ReportDelRs
                 */
                ReportDelRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportDelRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportDelRs();
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.ReportDelRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportDelRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ReportDelRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @static
                 * @param {priority.netitems.nrest.ReportDelRs} message ReportDelRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportDelRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ReportDelRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportDelRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportDelRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportDelRs;
            })();

            nrest.ReportGenerateRq = (function() {

                /**
                 * Properties of a ReportGenerateRq.
                 * @memberof priority.netitems.nrest
                 * @interface IReportGenerateRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ReportGenerateRq Properties
                 * @property {number|Long|null} [ReportId] ReportGenerateRq ReportId
                 * @property {Array.<string>|null} [NodeId] ReportGenerateRq NodeId
                 */

                /**
                 * Constructs a new ReportGenerateRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportGenerateRq.
                 * @implements IReportGenerateRq
                 * @constructor
                 * @param {priority.netitems.nrest.IReportGenerateRq=} [properties] Properties to set
                 */
                function ReportGenerateRq(properties) {
                    this.NodeId = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportGenerateRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @instance
                 */
                ReportGenerateRq.prototype.Properties = null;

                /**
                 * ReportGenerateRq ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @instance
                 */
                ReportGenerateRq.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportGenerateRq NodeId.
                 * @member {Array.<string>} NodeId
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @instance
                 */
                ReportGenerateRq.prototype.NodeId = $util.emptyArray;

                /**
                 * Creates a new ReportGenerateRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @static
                 * @param {priority.netitems.nrest.IReportGenerateRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportGenerateRq} ReportGenerateRq instance
                 */
                ReportGenerateRq.create = function create(properties) {
                    return new ReportGenerateRq(properties);
                };

                /**
                 * Encodes the specified ReportGenerateRq message. Does not implicitly {@link priority.netitems.nrest.ReportGenerateRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @static
                 * @param {priority.netitems.nrest.IReportGenerateRq} message ReportGenerateRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportGenerateRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.ReportId);
                    if (message.NodeId != null && message.NodeId.length)
                        for (var i = 0; i < message.NodeId.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.NodeId[i]);
                    return writer;
                };

                /**
                 * Encodes the specified ReportGenerateRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportGenerateRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @static
                 * @param {priority.netitems.nrest.IReportGenerateRq} message ReportGenerateRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportGenerateRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportGenerateRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportGenerateRq} ReportGenerateRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportGenerateRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportGenerateRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.ReportId = reader.int64();
                            break;
                        case 3:
                            if (!(message.NodeId && message.NodeId.length))
                                message.NodeId = [];
                            message.NodeId.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportGenerateRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportGenerateRq} ReportGenerateRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportGenerateRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportGenerateRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportGenerateRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    if (message.NodeId != null && message.hasOwnProperty("NodeId")) {
                        if (!Array.isArray(message.NodeId))
                            return "NodeId: array expected";
                        for (var i = 0; i < message.NodeId.length; ++i)
                            if (!$util.isString(message.NodeId[i]))
                                return "NodeId: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a ReportGenerateRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportGenerateRq} ReportGenerateRq
                 */
                ReportGenerateRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportGenerateRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportGenerateRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportGenerateRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    if (object.NodeId) {
                        if (!Array.isArray(object.NodeId))
                            throw TypeError(".priority.netitems.nrest.ReportGenerateRq.NodeId: array expected");
                        message.NodeId = [];
                        for (var i = 0; i < object.NodeId.length; ++i)
                            message.NodeId[i] = String(object.NodeId[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ReportGenerateRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @static
                 * @param {priority.netitems.nrest.ReportGenerateRq} message ReportGenerateRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportGenerateRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.NodeId = [];
                    if (options.defaults) {
                        object.Properties = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    if (message.NodeId && message.NodeId.length) {
                        object.NodeId = [];
                        for (var j = 0; j < message.NodeId.length; ++j)
                            object.NodeId[j] = message.NodeId[j];
                    }
                    return object;
                };

                /**
                 * Converts this ReportGenerateRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportGenerateRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportGenerateRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportGenerateRq;
            })();

            nrest.ReportGenerateRs = (function() {

                /**
                 * Properties of a ReportGenerateRs.
                 * @memberof priority.netitems.nrest
                 * @interface IReportGenerateRs
                 * @property {priority.netitems.nrest.IReportData|null} [data] ReportGenerateRs data
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ReportGenerateRs Messages
                 */

                /**
                 * Constructs a new ReportGenerateRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportGenerateRs.
                 * @implements IReportGenerateRs
                 * @constructor
                 * @param {priority.netitems.nrest.IReportGenerateRs=} [properties] Properties to set
                 */
                function ReportGenerateRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportGenerateRs data.
                 * @member {priority.netitems.nrest.IReportData|null|undefined} data
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @instance
                 */
                ReportGenerateRs.prototype.data = null;

                /**
                 * ReportGenerateRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @instance
                 */
                ReportGenerateRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new ReportGenerateRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @static
                 * @param {priority.netitems.nrest.IReportGenerateRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportGenerateRs} ReportGenerateRs instance
                 */
                ReportGenerateRs.create = function create(properties) {
                    return new ReportGenerateRs(properties);
                };

                /**
                 * Encodes the specified ReportGenerateRs message. Does not implicitly {@link priority.netitems.nrest.ReportGenerateRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @static
                 * @param {priority.netitems.nrest.IReportGenerateRs} message ReportGenerateRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportGenerateRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                        $root.priority.netitems.nrest.ReportData.encode(message.data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ReportGenerateRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportGenerateRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @static
                 * @param {priority.netitems.nrest.IReportGenerateRs} message ReportGenerateRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportGenerateRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportGenerateRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportGenerateRs} ReportGenerateRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportGenerateRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportGenerateRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.data = $root.priority.netitems.nrest.ReportData.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportGenerateRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportGenerateRs} ReportGenerateRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportGenerateRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportGenerateRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportGenerateRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.data != null && message.hasOwnProperty("data")) {
                        var error = $root.priority.netitems.nrest.ReportData.verify(message.data);
                        if (error)
                            return "data." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ReportGenerateRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportGenerateRs} ReportGenerateRs
                 */
                ReportGenerateRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportGenerateRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportGenerateRs();
                    if (object.data != null) {
                        if (typeof object.data !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportGenerateRs.data: object expected");
                        message.data = $root.priority.netitems.nrest.ReportData.fromObject(object.data);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.ReportGenerateRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportGenerateRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ReportGenerateRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @static
                 * @param {priority.netitems.nrest.ReportGenerateRs} message ReportGenerateRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportGenerateRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.data = null;
                    if (message.data != null && message.hasOwnProperty("data"))
                        object.data = $root.priority.netitems.nrest.ReportData.toObject(message.data, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ReportGenerateRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportGenerateRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportGenerateRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportGenerateRs;
            })();

            nrest.DateFormatsRq = (function() {

                /**
                 * Properties of a DateFormatsRq.
                 * @memberof priority.netitems.nrest
                 * @interface IDateFormatsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] DateFormatsRq Properties
                 */

                /**
                 * Constructs a new DateFormatsRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DateFormatsRq.
                 * @implements IDateFormatsRq
                 * @constructor
                 * @param {priority.netitems.nrest.IDateFormatsRq=} [properties] Properties to set
                 */
                function DateFormatsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DateFormatsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @instance
                 */
                DateFormatsRq.prototype.Properties = null;

                /**
                 * Creates a new DateFormatsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @static
                 * @param {priority.netitems.nrest.IDateFormatsRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DateFormatsRq} DateFormatsRq instance
                 */
                DateFormatsRq.create = function create(properties) {
                    return new DateFormatsRq(properties);
                };

                /**
                 * Encodes the specified DateFormatsRq message. Does not implicitly {@link priority.netitems.nrest.DateFormatsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @static
                 * @param {priority.netitems.nrest.IDateFormatsRq} message DateFormatsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DateFormatsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DateFormatsRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.DateFormatsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @static
                 * @param {priority.netitems.nrest.IDateFormatsRq} message DateFormatsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DateFormatsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DateFormatsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DateFormatsRq} DateFormatsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DateFormatsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DateFormatsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DateFormatsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DateFormatsRq} DateFormatsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DateFormatsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DateFormatsRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DateFormatsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a DateFormatsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DateFormatsRq} DateFormatsRq
                 */
                DateFormatsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DateFormatsRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.DateFormatsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.DateFormatsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DateFormatsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @static
                 * @param {priority.netitems.nrest.DateFormatsRq} message DateFormatsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DateFormatsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this DateFormatsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DateFormatsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DateFormatsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DateFormatsRq;
            })();

            nrest.DateFormat = (function() {

                /**
                 * Properties of a DateFormat.
                 * @memberof priority.netitems.nrest
                 * @interface IDateFormat
                 * @property {number|Long|null} [Id] DateFormat Id
                 * @property {string|null} [Pattern] DateFormat Pattern
                 */

                /**
                 * Constructs a new DateFormat.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DateFormat.
                 * @implements IDateFormat
                 * @constructor
                 * @param {priority.netitems.nrest.IDateFormat=} [properties] Properties to set
                 */
                function DateFormat(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DateFormat Id.
                 * @member {number|Long} Id
                 * @memberof priority.netitems.nrest.DateFormat
                 * @instance
                 */
                DateFormat.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * DateFormat Pattern.
                 * @member {string} Pattern
                 * @memberof priority.netitems.nrest.DateFormat
                 * @instance
                 */
                DateFormat.prototype.Pattern = "";

                /**
                 * Creates a new DateFormat instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DateFormat
                 * @static
                 * @param {priority.netitems.nrest.IDateFormat=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DateFormat} DateFormat instance
                 */
                DateFormat.create = function create(properties) {
                    return new DateFormat(properties);
                };

                /**
                 * Encodes the specified DateFormat message. Does not implicitly {@link priority.netitems.nrest.DateFormat.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DateFormat
                 * @static
                 * @param {priority.netitems.nrest.IDateFormat} message DateFormat message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DateFormat.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
                    if (message.Pattern != null && Object.hasOwnProperty.call(message, "Pattern"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Pattern);
                    return writer;
                };

                /**
                 * Encodes the specified DateFormat message, length delimited. Does not implicitly {@link priority.netitems.nrest.DateFormat.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DateFormat
                 * @static
                 * @param {priority.netitems.nrest.IDateFormat} message DateFormat message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DateFormat.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DateFormat message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DateFormat
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DateFormat} DateFormat
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DateFormat.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DateFormat();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Id = reader.int64();
                            break;
                        case 2:
                            message.Pattern = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DateFormat message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DateFormat
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DateFormat} DateFormat
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DateFormat.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DateFormat message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DateFormat
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DateFormat.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                            return "Id: integer|Long expected";
                    if (message.Pattern != null && message.hasOwnProperty("Pattern"))
                        if (!$util.isString(message.Pattern))
                            return "Pattern: string expected";
                    return null;
                };

                /**
                 * Creates a DateFormat message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DateFormat
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DateFormat} DateFormat
                 */
                DateFormat.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DateFormat)
                        return object;
                    var message = new $root.priority.netitems.nrest.DateFormat();
                    if (object.Id != null)
                        if ($util.Long)
                            (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                        else if (typeof object.Id === "string")
                            message.Id = parseInt(object.Id, 10);
                        else if (typeof object.Id === "number")
                            message.Id = object.Id;
                        else if (typeof object.Id === "object")
                            message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
                    if (object.Pattern != null)
                        message.Pattern = String(object.Pattern);
                    return message;
                };

                /**
                 * Creates a plain object from a DateFormat message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DateFormat
                 * @static
                 * @param {priority.netitems.nrest.DateFormat} message DateFormat
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DateFormat.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Id = options.longs === String ? "0" : 0;
                        object.Pattern = "";
                    }
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (typeof message.Id === "number")
                            object.Id = options.longs === String ? String(message.Id) : message.Id;
                        else
                            object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                    if (message.Pattern != null && message.hasOwnProperty("Pattern"))
                        object.Pattern = message.Pattern;
                    return object;
                };

                /**
                 * Converts this DateFormat to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DateFormat
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DateFormat.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DateFormat;
            })();

            nrest.DateFormatsRs = (function() {

                /**
                 * Properties of a DateFormatsRs.
                 * @memberof priority.netitems.nrest
                 * @interface IDateFormatsRs
                 * @property {Array.<priority.netitems.nrest.IDateFormat>|null} [Formats] DateFormatsRs Formats
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] DateFormatsRs Messages
                 */

                /**
                 * Constructs a new DateFormatsRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a DateFormatsRs.
                 * @implements IDateFormatsRs
                 * @constructor
                 * @param {priority.netitems.nrest.IDateFormatsRs=} [properties] Properties to set
                 */
                function DateFormatsRs(properties) {
                    this.Formats = [];
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * DateFormatsRs Formats.
                 * @member {Array.<priority.netitems.nrest.IDateFormat>} Formats
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @instance
                 */
                DateFormatsRs.prototype.Formats = $util.emptyArray;

                /**
                 * DateFormatsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @instance
                 */
                DateFormatsRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new DateFormatsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @static
                 * @param {priority.netitems.nrest.IDateFormatsRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.DateFormatsRs} DateFormatsRs instance
                 */
                DateFormatsRs.create = function create(properties) {
                    return new DateFormatsRs(properties);
                };

                /**
                 * Encodes the specified DateFormatsRs message. Does not implicitly {@link priority.netitems.nrest.DateFormatsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @static
                 * @param {priority.netitems.nrest.IDateFormatsRs} message DateFormatsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DateFormatsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Formats != null && message.Formats.length)
                        for (var i = 0; i < message.Formats.length; ++i)
                            $root.priority.netitems.nrest.DateFormat.encode(message.Formats[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified DateFormatsRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.DateFormatsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @static
                 * @param {priority.netitems.nrest.IDateFormatsRs} message DateFormatsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DateFormatsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a DateFormatsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.DateFormatsRs} DateFormatsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DateFormatsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.DateFormatsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Formats && message.Formats.length))
                                message.Formats = [];
                            message.Formats.push($root.priority.netitems.nrest.DateFormat.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a DateFormatsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.DateFormatsRs} DateFormatsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DateFormatsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a DateFormatsRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DateFormatsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Formats != null && message.hasOwnProperty("Formats")) {
                        if (!Array.isArray(message.Formats))
                            return "Formats: array expected";
                        for (var i = 0; i < message.Formats.length; ++i) {
                            var error = $root.priority.netitems.nrest.DateFormat.verify(message.Formats[i]);
                            if (error)
                                return "Formats." + error;
                        }
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a DateFormatsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.DateFormatsRs} DateFormatsRs
                 */
                DateFormatsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.DateFormatsRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.DateFormatsRs();
                    if (object.Formats) {
                        if (!Array.isArray(object.Formats))
                            throw TypeError(".priority.netitems.nrest.DateFormatsRs.Formats: array expected");
                        message.Formats = [];
                        for (var i = 0; i < object.Formats.length; ++i) {
                            if (typeof object.Formats[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DateFormatsRs.Formats: object expected");
                            message.Formats[i] = $root.priority.netitems.nrest.DateFormat.fromObject(object.Formats[i]);
                        }
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.DateFormatsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.DateFormatsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a DateFormatsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @static
                 * @param {priority.netitems.nrest.DateFormatsRs} message DateFormatsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DateFormatsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Formats = [];
                        object.Messages = [];
                    }
                    if (message.Formats && message.Formats.length) {
                        object.Formats = [];
                        for (var j = 0; j < message.Formats.length; ++j)
                            object.Formats[j] = $root.priority.netitems.nrest.DateFormat.toObject(message.Formats[j], options);
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this DateFormatsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.DateFormatsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DateFormatsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return DateFormatsRs;
            })();

            nrest.NumericFormatsRq = (function() {

                /**
                 * Properties of a NumericFormatsRq.
                 * @memberof priority.netitems.nrest
                 * @interface INumericFormatsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] NumericFormatsRq Properties
                 */

                /**
                 * Constructs a new NumericFormatsRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a NumericFormatsRq.
                 * @implements INumericFormatsRq
                 * @constructor
                 * @param {priority.netitems.nrest.INumericFormatsRq=} [properties] Properties to set
                 */
                function NumericFormatsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NumericFormatsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @instance
                 */
                NumericFormatsRq.prototype.Properties = null;

                /**
                 * Creates a new NumericFormatsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @static
                 * @param {priority.netitems.nrest.INumericFormatsRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.NumericFormatsRq} NumericFormatsRq instance
                 */
                NumericFormatsRq.create = function create(properties) {
                    return new NumericFormatsRq(properties);
                };

                /**
                 * Encodes the specified NumericFormatsRq message. Does not implicitly {@link priority.netitems.nrest.NumericFormatsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @static
                 * @param {priority.netitems.nrest.INumericFormatsRq} message NumericFormatsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NumericFormatsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified NumericFormatsRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.NumericFormatsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @static
                 * @param {priority.netitems.nrest.INumericFormatsRq} message NumericFormatsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NumericFormatsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NumericFormatsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.NumericFormatsRq} NumericFormatsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NumericFormatsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.NumericFormatsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NumericFormatsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.NumericFormatsRq} NumericFormatsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NumericFormatsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NumericFormatsRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NumericFormatsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a NumericFormatsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.NumericFormatsRq} NumericFormatsRq
                 */
                NumericFormatsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.NumericFormatsRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.NumericFormatsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.NumericFormatsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a NumericFormatsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @static
                 * @param {priority.netitems.nrest.NumericFormatsRq} message NumericFormatsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NumericFormatsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this NumericFormatsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.NumericFormatsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NumericFormatsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NumericFormatsRq;
            })();

            nrest.NumericFormat = (function() {

                /**
                 * Properties of a NumericFormat.
                 * @memberof priority.netitems.nrest
                 * @interface INumericFormat
                 * @property {number|Long|null} [Id] NumericFormat Id
                 * @property {string|null} [Code] NumericFormat Code
                 * @property {string|null} [Name] NumericFormat Name
                 * @property {number|Long|null} [Decimal] NumericFormat Decimal
                 * @property {number|Long|null} [Coeff] NumericFormat Coeff
                 * @property {string|null} [Prefix] NumericFormat Prefix
                 * @property {string|null} [Suffix] NumericFormat Suffix
                 * @property {boolean|null} [NegNo] NumericFormat NegNo
                 */

                /**
                 * Constructs a new NumericFormat.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a NumericFormat.
                 * @implements INumericFormat
                 * @constructor
                 * @param {priority.netitems.nrest.INumericFormat=} [properties] Properties to set
                 */
                function NumericFormat(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NumericFormat Id.
                 * @member {number|Long} Id
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 */
                NumericFormat.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * NumericFormat Code.
                 * @member {string} Code
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 */
                NumericFormat.prototype.Code = "";

                /**
                 * NumericFormat Name.
                 * @member {string} Name
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 */
                NumericFormat.prototype.Name = "";

                /**
                 * NumericFormat Decimal.
                 * @member {number|Long} Decimal
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 */
                NumericFormat.prototype.Decimal = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * NumericFormat Coeff.
                 * @member {number|Long} Coeff
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 */
                NumericFormat.prototype.Coeff = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * NumericFormat Prefix.
                 * @member {string} Prefix
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 */
                NumericFormat.prototype.Prefix = "";

                /**
                 * NumericFormat Suffix.
                 * @member {string} Suffix
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 */
                NumericFormat.prototype.Suffix = "";

                /**
                 * NumericFormat NegNo.
                 * @member {boolean} NegNo
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 */
                NumericFormat.prototype.NegNo = false;

                /**
                 * Creates a new NumericFormat instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @static
                 * @param {priority.netitems.nrest.INumericFormat=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.NumericFormat} NumericFormat instance
                 */
                NumericFormat.create = function create(properties) {
                    return new NumericFormat(properties);
                };

                /**
                 * Encodes the specified NumericFormat message. Does not implicitly {@link priority.netitems.nrest.NumericFormat.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @static
                 * @param {priority.netitems.nrest.INumericFormat} message NumericFormat message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NumericFormat.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Id != null && Object.hasOwnProperty.call(message, "Id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
                    if (message.Code != null && Object.hasOwnProperty.call(message, "Code"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Code);
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
                    if (message.Decimal != null && Object.hasOwnProperty.call(message, "Decimal"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.Decimal);
                    if (message.Coeff != null && Object.hasOwnProperty.call(message, "Coeff"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.Coeff);
                    if (message.Prefix != null && Object.hasOwnProperty.call(message, "Prefix"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.Prefix);
                    if (message.Suffix != null && Object.hasOwnProperty.call(message, "Suffix"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.Suffix);
                    if (message.NegNo != null && Object.hasOwnProperty.call(message, "NegNo"))
                        writer.uint32(/* id 8, wireType 0 =*/64).bool(message.NegNo);
                    return writer;
                };

                /**
                 * Encodes the specified NumericFormat message, length delimited. Does not implicitly {@link priority.netitems.nrest.NumericFormat.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @static
                 * @param {priority.netitems.nrest.INumericFormat} message NumericFormat message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NumericFormat.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NumericFormat message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.NumericFormat} NumericFormat
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NumericFormat.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.NumericFormat();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Id = reader.int64();
                            break;
                        case 2:
                            message.Code = reader.string();
                            break;
                        case 3:
                            message.Name = reader.string();
                            break;
                        case 4:
                            message.Decimal = reader.int64();
                            break;
                        case 5:
                            message.Coeff = reader.int64();
                            break;
                        case 6:
                            message.Prefix = reader.string();
                            break;
                        case 7:
                            message.Suffix = reader.string();
                            break;
                        case 8:
                            message.NegNo = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NumericFormat message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.NumericFormat} NumericFormat
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NumericFormat.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NumericFormat message.
                 * @function verify
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NumericFormat.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                            return "Id: integer|Long expected";
                    if (message.Code != null && message.hasOwnProperty("Code"))
                        if (!$util.isString(message.Code))
                            return "Code: string expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.Decimal != null && message.hasOwnProperty("Decimal"))
                        if (!$util.isInteger(message.Decimal) && !(message.Decimal && $util.isInteger(message.Decimal.low) && $util.isInteger(message.Decimal.high)))
                            return "Decimal: integer|Long expected";
                    if (message.Coeff != null && message.hasOwnProperty("Coeff"))
                        if (!$util.isInteger(message.Coeff) && !(message.Coeff && $util.isInteger(message.Coeff.low) && $util.isInteger(message.Coeff.high)))
                            return "Coeff: integer|Long expected";
                    if (message.Prefix != null && message.hasOwnProperty("Prefix"))
                        if (!$util.isString(message.Prefix))
                            return "Prefix: string expected";
                    if (message.Suffix != null && message.hasOwnProperty("Suffix"))
                        if (!$util.isString(message.Suffix))
                            return "Suffix: string expected";
                    if (message.NegNo != null && message.hasOwnProperty("NegNo"))
                        if (typeof message.NegNo !== "boolean")
                            return "NegNo: boolean expected";
                    return null;
                };

                /**
                 * Creates a NumericFormat message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.NumericFormat} NumericFormat
                 */
                NumericFormat.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.NumericFormat)
                        return object;
                    var message = new $root.priority.netitems.nrest.NumericFormat();
                    if (object.Id != null)
                        if ($util.Long)
                            (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
                        else if (typeof object.Id === "string")
                            message.Id = parseInt(object.Id, 10);
                        else if (typeof object.Id === "number")
                            message.Id = object.Id;
                        else if (typeof object.Id === "object")
                            message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
                    if (object.Code != null)
                        message.Code = String(object.Code);
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.Decimal != null)
                        if ($util.Long)
                            (message.Decimal = $util.Long.fromValue(object.Decimal)).unsigned = false;
                        else if (typeof object.Decimal === "string")
                            message.Decimal = parseInt(object.Decimal, 10);
                        else if (typeof object.Decimal === "number")
                            message.Decimal = object.Decimal;
                        else if (typeof object.Decimal === "object")
                            message.Decimal = new $util.LongBits(object.Decimal.low >>> 0, object.Decimal.high >>> 0).toNumber();
                    if (object.Coeff != null)
                        if ($util.Long)
                            (message.Coeff = $util.Long.fromValue(object.Coeff)).unsigned = false;
                        else if (typeof object.Coeff === "string")
                            message.Coeff = parseInt(object.Coeff, 10);
                        else if (typeof object.Coeff === "number")
                            message.Coeff = object.Coeff;
                        else if (typeof object.Coeff === "object")
                            message.Coeff = new $util.LongBits(object.Coeff.low >>> 0, object.Coeff.high >>> 0).toNumber();
                    if (object.Prefix != null)
                        message.Prefix = String(object.Prefix);
                    if (object.Suffix != null)
                        message.Suffix = String(object.Suffix);
                    if (object.NegNo != null)
                        message.NegNo = Boolean(object.NegNo);
                    return message;
                };

                /**
                 * Creates a plain object from a NumericFormat message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @static
                 * @param {priority.netitems.nrest.NumericFormat} message NumericFormat
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NumericFormat.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Id = options.longs === String ? "0" : 0;
                        object.Code = "";
                        object.Name = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Decimal = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Decimal = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Coeff = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Coeff = options.longs === String ? "0" : 0;
                        object.Prefix = "";
                        object.Suffix = "";
                        object.NegNo = false;
                    }
                    if (message.Id != null && message.hasOwnProperty("Id"))
                        if (typeof message.Id === "number")
                            object.Id = options.longs === String ? String(message.Id) : message.Id;
                        else
                            object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
                    if (message.Code != null && message.hasOwnProperty("Code"))
                        object.Code = message.Code;
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.Decimal != null && message.hasOwnProperty("Decimal"))
                        if (typeof message.Decimal === "number")
                            object.Decimal = options.longs === String ? String(message.Decimal) : message.Decimal;
                        else
                            object.Decimal = options.longs === String ? $util.Long.prototype.toString.call(message.Decimal) : options.longs === Number ? new $util.LongBits(message.Decimal.low >>> 0, message.Decimal.high >>> 0).toNumber() : message.Decimal;
                    if (message.Coeff != null && message.hasOwnProperty("Coeff"))
                        if (typeof message.Coeff === "number")
                            object.Coeff = options.longs === String ? String(message.Coeff) : message.Coeff;
                        else
                            object.Coeff = options.longs === String ? $util.Long.prototype.toString.call(message.Coeff) : options.longs === Number ? new $util.LongBits(message.Coeff.low >>> 0, message.Coeff.high >>> 0).toNumber() : message.Coeff;
                    if (message.Prefix != null && message.hasOwnProperty("Prefix"))
                        object.Prefix = message.Prefix;
                    if (message.Suffix != null && message.hasOwnProperty("Suffix"))
                        object.Suffix = message.Suffix;
                    if (message.NegNo != null && message.hasOwnProperty("NegNo"))
                        object.NegNo = message.NegNo;
                    return object;
                };

                /**
                 * Converts this NumericFormat to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.NumericFormat
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NumericFormat.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NumericFormat;
            })();

            nrest.NumericFormatsRs = (function() {

                /**
                 * Properties of a NumericFormatsRs.
                 * @memberof priority.netitems.nrest
                 * @interface INumericFormatsRs
                 * @property {Array.<priority.netitems.nrest.INumericFormat>|null} [Formats] NumericFormatsRs Formats
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] NumericFormatsRs Messages
                 */

                /**
                 * Constructs a new NumericFormatsRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a NumericFormatsRs.
                 * @implements INumericFormatsRs
                 * @constructor
                 * @param {priority.netitems.nrest.INumericFormatsRs=} [properties] Properties to set
                 */
                function NumericFormatsRs(properties) {
                    this.Formats = [];
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NumericFormatsRs Formats.
                 * @member {Array.<priority.netitems.nrest.INumericFormat>} Formats
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @instance
                 */
                NumericFormatsRs.prototype.Formats = $util.emptyArray;

                /**
                 * NumericFormatsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @instance
                 */
                NumericFormatsRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new NumericFormatsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @static
                 * @param {priority.netitems.nrest.INumericFormatsRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.NumericFormatsRs} NumericFormatsRs instance
                 */
                NumericFormatsRs.create = function create(properties) {
                    return new NumericFormatsRs(properties);
                };

                /**
                 * Encodes the specified NumericFormatsRs message. Does not implicitly {@link priority.netitems.nrest.NumericFormatsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @static
                 * @param {priority.netitems.nrest.INumericFormatsRs} message NumericFormatsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NumericFormatsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Formats != null && message.Formats.length)
                        for (var i = 0; i < message.Formats.length; ++i)
                            $root.priority.netitems.nrest.NumericFormat.encode(message.Formats[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified NumericFormatsRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.NumericFormatsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @static
                 * @param {priority.netitems.nrest.INumericFormatsRs} message NumericFormatsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NumericFormatsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NumericFormatsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.NumericFormatsRs} NumericFormatsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NumericFormatsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.NumericFormatsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Formats && message.Formats.length))
                                message.Formats = [];
                            message.Formats.push($root.priority.netitems.nrest.NumericFormat.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a NumericFormatsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.NumericFormatsRs} NumericFormatsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NumericFormatsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NumericFormatsRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NumericFormatsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Formats != null && message.hasOwnProperty("Formats")) {
                        if (!Array.isArray(message.Formats))
                            return "Formats: array expected";
                        for (var i = 0; i < message.Formats.length; ++i) {
                            var error = $root.priority.netitems.nrest.NumericFormat.verify(message.Formats[i]);
                            if (error)
                                return "Formats." + error;
                        }
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a NumericFormatsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.NumericFormatsRs} NumericFormatsRs
                 */
                NumericFormatsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.NumericFormatsRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.NumericFormatsRs();
                    if (object.Formats) {
                        if (!Array.isArray(object.Formats))
                            throw TypeError(".priority.netitems.nrest.NumericFormatsRs.Formats: array expected");
                        message.Formats = [];
                        for (var i = 0; i < object.Formats.length; ++i) {
                            if (typeof object.Formats[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.NumericFormatsRs.Formats: object expected");
                            message.Formats[i] = $root.priority.netitems.nrest.NumericFormat.fromObject(object.Formats[i]);
                        }
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.NumericFormatsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.NumericFormatsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a NumericFormatsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @static
                 * @param {priority.netitems.nrest.NumericFormatsRs} message NumericFormatsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NumericFormatsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Formats = [];
                        object.Messages = [];
                    }
                    if (message.Formats && message.Formats.length) {
                        object.Formats = [];
                        for (var j = 0; j < message.Formats.length; ++j)
                            object.Formats[j] = $root.priority.netitems.nrest.NumericFormat.toObject(message.Formats[j], options);
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this NumericFormatsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.NumericFormatsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NumericFormatsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NumericFormatsRs;
            })();

            nrest.ReportColumnsRq = (function() {

                /**
                 * Properties of a ReportColumnsRq.
                 * @memberof priority.netitems.nrest
                 * @interface IReportColumnsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] ReportColumnsRq Properties
                 * @property {Array.<string>|null} [NodeId] ReportColumnsRq NodeId
                 * @property {number|Long|null} [ReportId] ReportColumnsRq ReportId
                 * @property {string|null} [LinkId] ReportColumnsRq LinkId
                 */

                /**
                 * Constructs a new ReportColumnsRq.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportColumnsRq.
                 * @implements IReportColumnsRq
                 * @constructor
                 * @param {priority.netitems.nrest.IReportColumnsRq=} [properties] Properties to set
                 */
                function ReportColumnsRq(properties) {
                    this.NodeId = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportColumnsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @instance
                 */
                ReportColumnsRq.prototype.Properties = null;

                /**
                 * ReportColumnsRq NodeId.
                 * @member {Array.<string>} NodeId
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @instance
                 */
                ReportColumnsRq.prototype.NodeId = $util.emptyArray;

                /**
                 * ReportColumnsRq ReportId.
                 * @member {number|Long} ReportId
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @instance
                 */
                ReportColumnsRq.prototype.ReportId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * ReportColumnsRq LinkId.
                 * @member {string} LinkId
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @instance
                 */
                ReportColumnsRq.prototype.LinkId = "";

                /**
                 * Creates a new ReportColumnsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @static
                 * @param {priority.netitems.nrest.IReportColumnsRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportColumnsRq} ReportColumnsRq instance
                 */
                ReportColumnsRq.create = function create(properties) {
                    return new ReportColumnsRq(properties);
                };

                /**
                 * Encodes the specified ReportColumnsRq message. Does not implicitly {@link priority.netitems.nrest.ReportColumnsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @static
                 * @param {priority.netitems.nrest.IReportColumnsRq} message ReportColumnsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportColumnsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.NodeId != null && message.NodeId.length)
                        for (var i = 0; i < message.NodeId.length; ++i)
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.NodeId[i]);
                    if (message.ReportId != null && Object.hasOwnProperty.call(message, "ReportId"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ReportId);
                    if (message.LinkId != null && Object.hasOwnProperty.call(message, "LinkId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.LinkId);
                    return writer;
                };

                /**
                 * Encodes the specified ReportColumnsRq message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportColumnsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @static
                 * @param {priority.netitems.nrest.IReportColumnsRq} message ReportColumnsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportColumnsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportColumnsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportColumnsRq} ReportColumnsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportColumnsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportColumnsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.NodeId && message.NodeId.length))
                                message.NodeId = [];
                            message.NodeId.push(reader.string());
                            break;
                        case 3:
                            message.ReportId = reader.int64();
                            break;
                        case 4:
                            message.LinkId = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportColumnsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportColumnsRq} ReportColumnsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportColumnsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportColumnsRq message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportColumnsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.NodeId != null && message.hasOwnProperty("NodeId")) {
                        if (!Array.isArray(message.NodeId))
                            return "NodeId: array expected";
                        for (var i = 0; i < message.NodeId.length; ++i)
                            if (!$util.isString(message.NodeId[i]))
                                return "NodeId: string[] expected";
                    }
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (!$util.isInteger(message.ReportId) && !(message.ReportId && $util.isInteger(message.ReportId.low) && $util.isInteger(message.ReportId.high)))
                            return "ReportId: integer|Long expected";
                    if (message.LinkId != null && message.hasOwnProperty("LinkId"))
                        if (!$util.isString(message.LinkId))
                            return "LinkId: string expected";
                    return null;
                };

                /**
                 * Creates a ReportColumnsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportColumnsRq} ReportColumnsRq
                 */
                ReportColumnsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportColumnsRq)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportColumnsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrest.ReportColumnsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.NodeId) {
                        if (!Array.isArray(object.NodeId))
                            throw TypeError(".priority.netitems.nrest.ReportColumnsRq.NodeId: array expected");
                        message.NodeId = [];
                        for (var i = 0; i < object.NodeId.length; ++i)
                            message.NodeId[i] = String(object.NodeId[i]);
                    }
                    if (object.ReportId != null)
                        if ($util.Long)
                            (message.ReportId = $util.Long.fromValue(object.ReportId)).unsigned = false;
                        else if (typeof object.ReportId === "string")
                            message.ReportId = parseInt(object.ReportId, 10);
                        else if (typeof object.ReportId === "number")
                            message.ReportId = object.ReportId;
                        else if (typeof object.ReportId === "object")
                            message.ReportId = new $util.LongBits(object.ReportId.low >>> 0, object.ReportId.high >>> 0).toNumber();
                    if (object.LinkId != null)
                        message.LinkId = String(object.LinkId);
                    return message;
                };

                /**
                 * Creates a plain object from a ReportColumnsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @static
                 * @param {priority.netitems.nrest.ReportColumnsRq} message ReportColumnsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportColumnsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.NodeId = [];
                    if (options.defaults) {
                        object.Properties = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.ReportId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.ReportId = options.longs === String ? "0" : 0;
                        object.LinkId = "";
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.NodeId && message.NodeId.length) {
                        object.NodeId = [];
                        for (var j = 0; j < message.NodeId.length; ++j)
                            object.NodeId[j] = message.NodeId[j];
                    }
                    if (message.ReportId != null && message.hasOwnProperty("ReportId"))
                        if (typeof message.ReportId === "number")
                            object.ReportId = options.longs === String ? String(message.ReportId) : message.ReportId;
                        else
                            object.ReportId = options.longs === String ? $util.Long.prototype.toString.call(message.ReportId) : options.longs === Number ? new $util.LongBits(message.ReportId.low >>> 0, message.ReportId.high >>> 0).toNumber() : message.ReportId;
                    if (message.LinkId != null && message.hasOwnProperty("LinkId"))
                        object.LinkId = message.LinkId;
                    return object;
                };

                /**
                 * Converts this ReportColumnsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportColumnsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportColumnsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportColumnsRq;
            })();

            nrest.ReportColumnsRs = (function() {

                /**
                 * Properties of a ReportColumnsRs.
                 * @memberof priority.netitems.nrest
                 * @interface IReportColumnsRs
                 * @property {Array.<priority.netitems.nrest.IReportCol>|null} [Columns] ReportColumnsRs Columns
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] ReportColumnsRs Messages
                 * @property {string|null} [LinkId] ReportColumnsRs LinkId
                 */

                /**
                 * Constructs a new ReportColumnsRs.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a ReportColumnsRs.
                 * @implements IReportColumnsRs
                 * @constructor
                 * @param {priority.netitems.nrest.IReportColumnsRs=} [properties] Properties to set
                 */
                function ReportColumnsRs(properties) {
                    this.Columns = [];
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReportColumnsRs Columns.
                 * @member {Array.<priority.netitems.nrest.IReportCol>} Columns
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @instance
                 */
                ReportColumnsRs.prototype.Columns = $util.emptyArray;

                /**
                 * ReportColumnsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @instance
                 */
                ReportColumnsRs.prototype.Messages = $util.emptyArray;

                /**
                 * ReportColumnsRs LinkId.
                 * @member {string} LinkId
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @instance
                 */
                ReportColumnsRs.prototype.LinkId = "";

                /**
                 * Creates a new ReportColumnsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @static
                 * @param {priority.netitems.nrest.IReportColumnsRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.ReportColumnsRs} ReportColumnsRs instance
                 */
                ReportColumnsRs.create = function create(properties) {
                    return new ReportColumnsRs(properties);
                };

                /**
                 * Encodes the specified ReportColumnsRs message. Does not implicitly {@link priority.netitems.nrest.ReportColumnsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @static
                 * @param {priority.netitems.nrest.IReportColumnsRs} message ReportColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportColumnsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Columns != null && message.Columns.length)
                        for (var i = 0; i < message.Columns.length; ++i)
                            $root.priority.netitems.nrest.ReportCol.encode(message.Columns[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.LinkId != null && Object.hasOwnProperty.call(message, "LinkId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.LinkId);
                    return writer;
                };

                /**
                 * Encodes the specified ReportColumnsRs message, length delimited. Does not implicitly {@link priority.netitems.nrest.ReportColumnsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @static
                 * @param {priority.netitems.nrest.IReportColumnsRs} message ReportColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReportColumnsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReportColumnsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.ReportColumnsRs} ReportColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportColumnsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.ReportColumnsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Columns && message.Columns.length))
                                message.Columns = [];
                            message.Columns.push($root.priority.netitems.nrest.ReportCol.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.LinkId = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReportColumnsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.ReportColumnsRs} ReportColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReportColumnsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReportColumnsRs message.
                 * @function verify
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReportColumnsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (!Array.isArray(message.Columns))
                            return "Columns: array expected";
                        for (var i = 0; i < message.Columns.length; ++i) {
                            var error = $root.priority.netitems.nrest.ReportCol.verify(message.Columns[i]);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.LinkId != null && message.hasOwnProperty("LinkId"))
                        if (!$util.isString(message.LinkId))
                            return "LinkId: string expected";
                    return null;
                };

                /**
                 * Creates a ReportColumnsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.ReportColumnsRs} ReportColumnsRs
                 */
                ReportColumnsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.ReportColumnsRs)
                        return object;
                    var message = new $root.priority.netitems.nrest.ReportColumnsRs();
                    if (object.Columns) {
                        if (!Array.isArray(object.Columns))
                            throw TypeError(".priority.netitems.nrest.ReportColumnsRs.Columns: array expected");
                        message.Columns = [];
                        for (var i = 0; i < object.Columns.length; ++i) {
                            if (typeof object.Columns[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportColumnsRs.Columns: object expected");
                            message.Columns[i] = $root.priority.netitems.nrest.ReportCol.fromObject(object.Columns[i]);
                        }
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrest.ReportColumnsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrest.ReportColumnsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.LinkId != null)
                        message.LinkId = String(object.LinkId);
                    return message;
                };

                /**
                 * Creates a plain object from a ReportColumnsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @static
                 * @param {priority.netitems.nrest.ReportColumnsRs} message ReportColumnsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReportColumnsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Columns = [];
                        object.Messages = [];
                    }
                    if (options.defaults)
                        object.LinkId = "";
                    if (message.Columns && message.Columns.length) {
                        object.Columns = [];
                        for (var j = 0; j < message.Columns.length; ++j)
                            object.Columns[j] = $root.priority.netitems.nrest.ReportCol.toObject(message.Columns[j], options);
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.LinkId != null && message.hasOwnProperty("LinkId"))
                        object.LinkId = message.LinkId;
                    return object;
                };

                /**
                 * Converts this ReportColumnsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.ReportColumnsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReportColumnsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReportColumnsRs;
            })();

            nrest.Grpc2Net = (function() {

                /**
                 * Properties of a Grpc2Net.
                 * @memberof priority.netitems.nrest
                 * @interface IGrpc2Net
                 * @property {priority.netitems.nrest.ISqlTablesRq|null} [Tables] Grpc2Net Tables
                 * @property {priority.netitems.nrest.IQueryRq|null} [Query] Grpc2Net Query
                 * @property {priority.netitems.nrest.ISqlColumnsRq|null} [Columns] Grpc2Net Columns
                 * @property {priority.netitems.nrest.ISqlPrimaryKeysRq|null} [PrimaryKeys] Grpc2Net PrimaryKeys
                 * @property {priority.netitems.nrest.ISqlForeignKeysRq|null} [ForeignKeys] Grpc2Net ForeignKeys
                 * @property {priority.netitems.nrest.ISqlExecDirectRq|null} [ExecDirect] Grpc2Net ExecDirect
                 * @property {priority.netitems.nrest.ISqlExecDirectRq|null} [Prepare] Grpc2Net Prepare
                 * @property {priority.netitems.nrest.IQueryRq|null} [PrepareN] Grpc2Net PrepareN
                 * @property {priority.netitems.nrest.ITokenRq|null} [Execute] Grpc2Net Execute
                 * @property {priority.netitems.nrest.IReportListRq|null} [ReportList] Grpc2Net ReportList
                 * @property {priority.netitems.nrest.ITreeNodeChildrenRq|null} [TreeNodeChildren] Grpc2Net TreeNodeChildren
                 * @property {priority.netitems.nrest.IReportSaveRq|null} [ReportSave] Grpc2Net ReportSave
                 * @property {priority.netitems.nrest.IReportDataRq|null} [ReportData] Grpc2Net ReportData
                 * @property {priority.netitems.nrest.IReportDelRq|null} [ReportDel] Grpc2Net ReportDel
                 * @property {priority.netitems.nrest.IReportGenerateRq|null} [ReportGenerate] Grpc2Net ReportGenerate
                 * @property {priority.netitems.nrest.IDateFormatsRq|null} [DateFormats] Grpc2Net DateFormats
                 * @property {priority.netitems.nrest.IReportColumnsRq|null} [ReportColumns] Grpc2Net ReportColumns
                 * @property {priority.netitems.nrest.IReportCancelRq|null} [ReportCancel] Grpc2Net ReportCancel
                 * @property {priority.netitems.nrest.IDataRq|null} [Data] Grpc2Net Data
                 * @property {priority.netitems.nrest.INumericFormatsRq|null} [NumericFormats] Grpc2Net NumericFormats
                 * @property {priority.netitems.nrest.IFormsTreeRq|null} [FormsTree] Grpc2Net FormsTree
                 */

                /**
                 * Constructs a new Grpc2Net.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a Grpc2Net.
                 * @implements IGrpc2Net
                 * @constructor
                 * @param {priority.netitems.nrest.IGrpc2Net=} [properties] Properties to set
                 */
                function Grpc2Net(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Grpc2Net Tables.
                 * @member {priority.netitems.nrest.ISqlTablesRq|null|undefined} Tables
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Tables = null;

                /**
                 * Grpc2Net Query.
                 * @member {priority.netitems.nrest.IQueryRq|null|undefined} Query
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Query = null;

                /**
                 * Grpc2Net Columns.
                 * @member {priority.netitems.nrest.ISqlColumnsRq|null|undefined} Columns
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Columns = null;

                /**
                 * Grpc2Net PrimaryKeys.
                 * @member {priority.netitems.nrest.ISqlPrimaryKeysRq|null|undefined} PrimaryKeys
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.PrimaryKeys = null;

                /**
                 * Grpc2Net ForeignKeys.
                 * @member {priority.netitems.nrest.ISqlForeignKeysRq|null|undefined} ForeignKeys
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ForeignKeys = null;

                /**
                 * Grpc2Net ExecDirect.
                 * @member {priority.netitems.nrest.ISqlExecDirectRq|null|undefined} ExecDirect
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ExecDirect = null;

                /**
                 * Grpc2Net Prepare.
                 * @member {priority.netitems.nrest.ISqlExecDirectRq|null|undefined} Prepare
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Prepare = null;

                /**
                 * Grpc2Net PrepareN.
                 * @member {priority.netitems.nrest.IQueryRq|null|undefined} PrepareN
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.PrepareN = null;

                /**
                 * Grpc2Net Execute.
                 * @member {priority.netitems.nrest.ITokenRq|null|undefined} Execute
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Execute = null;

                /**
                 * Grpc2Net ReportList.
                 * @member {priority.netitems.nrest.IReportListRq|null|undefined} ReportList
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ReportList = null;

                /**
                 * Grpc2Net TreeNodeChildren.
                 * @member {priority.netitems.nrest.ITreeNodeChildrenRq|null|undefined} TreeNodeChildren
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.TreeNodeChildren = null;

                /**
                 * Grpc2Net ReportSave.
                 * @member {priority.netitems.nrest.IReportSaveRq|null|undefined} ReportSave
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ReportSave = null;

                /**
                 * Grpc2Net ReportData.
                 * @member {priority.netitems.nrest.IReportDataRq|null|undefined} ReportData
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ReportData = null;

                /**
                 * Grpc2Net ReportDel.
                 * @member {priority.netitems.nrest.IReportDelRq|null|undefined} ReportDel
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ReportDel = null;

                /**
                 * Grpc2Net ReportGenerate.
                 * @member {priority.netitems.nrest.IReportGenerateRq|null|undefined} ReportGenerate
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ReportGenerate = null;

                /**
                 * Grpc2Net DateFormats.
                 * @member {priority.netitems.nrest.IDateFormatsRq|null|undefined} DateFormats
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.DateFormats = null;

                /**
                 * Grpc2Net ReportColumns.
                 * @member {priority.netitems.nrest.IReportColumnsRq|null|undefined} ReportColumns
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ReportColumns = null;

                /**
                 * Grpc2Net ReportCancel.
                 * @member {priority.netitems.nrest.IReportCancelRq|null|undefined} ReportCancel
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.ReportCancel = null;

                /**
                 * Grpc2Net Data.
                 * @member {priority.netitems.nrest.IDataRq|null|undefined} Data
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Data = null;

                /**
                 * Grpc2Net NumericFormats.
                 * @member {priority.netitems.nrest.INumericFormatsRq|null|undefined} NumericFormats
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.NumericFormats = null;

                /**
                 * Grpc2Net FormsTree.
                 * @member {priority.netitems.nrest.IFormsTreeRq|null|undefined} FormsTree
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.FormsTree = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Grpc2Net inner.
                 * @member {"Tables"|"Query"|"Columns"|"PrimaryKeys"|"ForeignKeys"|"ExecDirect"|"Prepare"|"PrepareN"|"Execute"|"ReportList"|"TreeNodeChildren"|"ReportSave"|"ReportData"|"ReportDel"|"ReportGenerate"|"DateFormats"|"ReportColumns"|"ReportCancel"|"Data"|"NumericFormats"|"FormsTree"|undefined} inner
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 */
                Object.defineProperty(Grpc2Net.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["Tables", "Query", "Columns", "PrimaryKeys", "ForeignKeys", "ExecDirect", "Prepare", "PrepareN", "Execute", "ReportList", "TreeNodeChildren", "ReportSave", "ReportData", "ReportDel", "ReportGenerate", "DateFormats", "ReportColumns", "ReportCancel", "Data", "NumericFormats", "FormsTree"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Grpc2Net instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @static
                 * @param {priority.netitems.nrest.IGrpc2Net=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Grpc2Net} Grpc2Net instance
                 */
                Grpc2Net.create = function create(properties) {
                    return new Grpc2Net(properties);
                };

                /**
                 * Encodes the specified Grpc2Net message. Does not implicitly {@link priority.netitems.nrest.Grpc2Net.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @static
                 * @param {priority.netitems.nrest.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Tables != null && Object.hasOwnProperty.call(message, "Tables"))
                        $root.priority.netitems.nrest.SqlTablesRq.encode(message.Tables, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Query != null && Object.hasOwnProperty.call(message, "Query"))
                        $root.priority.netitems.nrest.QueryRq.encode(message.Query, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Columns != null && Object.hasOwnProperty.call(message, "Columns"))
                        $root.priority.netitems.nrest.SqlColumnsRq.encode(message.Columns, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.PrimaryKeys != null && Object.hasOwnProperty.call(message, "PrimaryKeys"))
                        $root.priority.netitems.nrest.SqlPrimaryKeysRq.encode(message.PrimaryKeys, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.ForeignKeys != null && Object.hasOwnProperty.call(message, "ForeignKeys"))
                        $root.priority.netitems.nrest.SqlForeignKeysRq.encode(message.ForeignKeys, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.ExecDirect != null && Object.hasOwnProperty.call(message, "ExecDirect"))
                        $root.priority.netitems.nrest.SqlExecDirectRq.encode(message.ExecDirect, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Prepare != null && Object.hasOwnProperty.call(message, "Prepare"))
                        $root.priority.netitems.nrest.SqlExecDirectRq.encode(message.Prepare, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.PrepareN != null && Object.hasOwnProperty.call(message, "PrepareN"))
                        $root.priority.netitems.nrest.QueryRq.encode(message.PrepareN, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.Execute != null && Object.hasOwnProperty.call(message, "Execute"))
                        $root.priority.netitems.nrest.TokenRq.encode(message.Execute, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.ReportList != null && Object.hasOwnProperty.call(message, "ReportList"))
                        $root.priority.netitems.nrest.ReportListRq.encode(message.ReportList, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.TreeNodeChildren != null && Object.hasOwnProperty.call(message, "TreeNodeChildren"))
                        $root.priority.netitems.nrest.TreeNodeChildrenRq.encode(message.TreeNodeChildren, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.ReportSave != null && Object.hasOwnProperty.call(message, "ReportSave"))
                        $root.priority.netitems.nrest.ReportSaveRq.encode(message.ReportSave, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.ReportData != null && Object.hasOwnProperty.call(message, "ReportData"))
                        $root.priority.netitems.nrest.ReportDataRq.encode(message.ReportData, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.ReportDel != null && Object.hasOwnProperty.call(message, "ReportDel"))
                        $root.priority.netitems.nrest.ReportDelRq.encode(message.ReportDel, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.ReportGenerate != null && Object.hasOwnProperty.call(message, "ReportGenerate"))
                        $root.priority.netitems.nrest.ReportGenerateRq.encode(message.ReportGenerate, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.DateFormats != null && Object.hasOwnProperty.call(message, "DateFormats"))
                        $root.priority.netitems.nrest.DateFormatsRq.encode(message.DateFormats, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.ReportColumns != null && Object.hasOwnProperty.call(message, "ReportColumns"))
                        $root.priority.netitems.nrest.ReportColumnsRq.encode(message.ReportColumns, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.ReportCancel != null && Object.hasOwnProperty.call(message, "ReportCancel"))
                        $root.priority.netitems.nrest.ReportCancelRq.encode(message.ReportCancel, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                        $root.priority.netitems.nrest.DataRq.encode(message.Data, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    if (message.NumericFormats != null && Object.hasOwnProperty.call(message, "NumericFormats"))
                        $root.priority.netitems.nrest.NumericFormatsRq.encode(message.NumericFormats, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                    if (message.FormsTree != null && Object.hasOwnProperty.call(message, "FormsTree"))
                        $root.priority.netitems.nrest.FormsTreeRq.encode(message.FormsTree, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Grpc2Net message, length delimited. Does not implicitly {@link priority.netitems.nrest.Grpc2Net.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @static
                 * @param {priority.netitems.nrest.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Grpc2Net();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Tables = $root.priority.netitems.nrest.SqlTablesRq.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Query = $root.priority.netitems.nrest.QueryRq.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.Columns = $root.priority.netitems.nrest.SqlColumnsRq.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.PrimaryKeys = $root.priority.netitems.nrest.SqlPrimaryKeysRq.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.ForeignKeys = $root.priority.netitems.nrest.SqlForeignKeysRq.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.ExecDirect = $root.priority.netitems.nrest.SqlExecDirectRq.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.Prepare = $root.priority.netitems.nrest.SqlExecDirectRq.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.PrepareN = $root.priority.netitems.nrest.QueryRq.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.Execute = $root.priority.netitems.nrest.TokenRq.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.ReportList = $root.priority.netitems.nrest.ReportListRq.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.TreeNodeChildren = $root.priority.netitems.nrest.TreeNodeChildrenRq.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.ReportSave = $root.priority.netitems.nrest.ReportSaveRq.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.ReportData = $root.priority.netitems.nrest.ReportDataRq.decode(reader, reader.uint32());
                            break;
                        case 14:
                            message.ReportDel = $root.priority.netitems.nrest.ReportDelRq.decode(reader, reader.uint32());
                            break;
                        case 15:
                            message.ReportGenerate = $root.priority.netitems.nrest.ReportGenerateRq.decode(reader, reader.uint32());
                            break;
                        case 16:
                            message.DateFormats = $root.priority.netitems.nrest.DateFormatsRq.decode(reader, reader.uint32());
                            break;
                        case 17:
                            message.ReportColumns = $root.priority.netitems.nrest.ReportColumnsRq.decode(reader, reader.uint32());
                            break;
                        case 18:
                            message.ReportCancel = $root.priority.netitems.nrest.ReportCancelRq.decode(reader, reader.uint32());
                            break;
                        case 19:
                            message.Data = $root.priority.netitems.nrest.DataRq.decode(reader, reader.uint32());
                            break;
                        case 20:
                            message.NumericFormats = $root.priority.netitems.nrest.NumericFormatsRq.decode(reader, reader.uint32());
                            break;
                        case 21:
                            message.FormsTree = $root.priority.netitems.nrest.FormsTreeRq.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Grpc2Net message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Grpc2Net.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.Tables != null && message.hasOwnProperty("Tables")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlTablesRq.verify(message.Tables);
                            if (error)
                                return "Tables." + error;
                        }
                    }
                    if (message.Query != null && message.hasOwnProperty("Query")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.QueryRq.verify(message.Query);
                            if (error)
                                return "Query." + error;
                        }
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlColumnsRq.verify(message.Columns);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.PrimaryKeys != null && message.hasOwnProperty("PrimaryKeys")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlPrimaryKeysRq.verify(message.PrimaryKeys);
                            if (error)
                                return "PrimaryKeys." + error;
                        }
                    }
                    if (message.ForeignKeys != null && message.hasOwnProperty("ForeignKeys")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlForeignKeysRq.verify(message.ForeignKeys);
                            if (error)
                                return "ForeignKeys." + error;
                        }
                    }
                    if (message.ExecDirect != null && message.hasOwnProperty("ExecDirect")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlExecDirectRq.verify(message.ExecDirect);
                            if (error)
                                return "ExecDirect." + error;
                        }
                    }
                    if (message.Prepare != null && message.hasOwnProperty("Prepare")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlExecDirectRq.verify(message.Prepare);
                            if (error)
                                return "Prepare." + error;
                        }
                    }
                    if (message.PrepareN != null && message.hasOwnProperty("PrepareN")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.QueryRq.verify(message.PrepareN);
                            if (error)
                                return "PrepareN." + error;
                        }
                    }
                    if (message.Execute != null && message.hasOwnProperty("Execute")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.TokenRq.verify(message.Execute);
                            if (error)
                                return "Execute." + error;
                        }
                    }
                    if (message.ReportList != null && message.hasOwnProperty("ReportList")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportListRq.verify(message.ReportList);
                            if (error)
                                return "ReportList." + error;
                        }
                    }
                    if (message.TreeNodeChildren != null && message.hasOwnProperty("TreeNodeChildren")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.TreeNodeChildrenRq.verify(message.TreeNodeChildren);
                            if (error)
                                return "TreeNodeChildren." + error;
                        }
                    }
                    if (message.ReportSave != null && message.hasOwnProperty("ReportSave")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportSaveRq.verify(message.ReportSave);
                            if (error)
                                return "ReportSave." + error;
                        }
                    }
                    if (message.ReportData != null && message.hasOwnProperty("ReportData")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportDataRq.verify(message.ReportData);
                            if (error)
                                return "ReportData." + error;
                        }
                    }
                    if (message.ReportDel != null && message.hasOwnProperty("ReportDel")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportDelRq.verify(message.ReportDel);
                            if (error)
                                return "ReportDel." + error;
                        }
                    }
                    if (message.ReportGenerate != null && message.hasOwnProperty("ReportGenerate")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportGenerateRq.verify(message.ReportGenerate);
                            if (error)
                                return "ReportGenerate." + error;
                        }
                    }
                    if (message.DateFormats != null && message.hasOwnProperty("DateFormats")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.DateFormatsRq.verify(message.DateFormats);
                            if (error)
                                return "DateFormats." + error;
                        }
                    }
                    if (message.ReportColumns != null && message.hasOwnProperty("ReportColumns")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportColumnsRq.verify(message.ReportColumns);
                            if (error)
                                return "ReportColumns." + error;
                        }
                    }
                    if (message.ReportCancel != null && message.hasOwnProperty("ReportCancel")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportCancelRq.verify(message.ReportCancel);
                            if (error)
                                return "ReportCancel." + error;
                        }
                    }
                    if (message.Data != null && message.hasOwnProperty("Data")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.DataRq.verify(message.Data);
                            if (error)
                                return "Data." + error;
                        }
                    }
                    if (message.NumericFormats != null && message.hasOwnProperty("NumericFormats")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.NumericFormatsRq.verify(message.NumericFormats);
                            if (error)
                                return "NumericFormats." + error;
                        }
                    }
                    if (message.FormsTree != null && message.hasOwnProperty("FormsTree")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.FormsTreeRq.verify(message.FormsTree);
                            if (error)
                                return "FormsTree." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Grpc2Net message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Grpc2Net} Grpc2Net
                 */
                Grpc2Net.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Grpc2Net)
                        return object;
                    var message = new $root.priority.netitems.nrest.Grpc2Net();
                    if (object.Tables != null) {
                        if (typeof object.Tables !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.Tables: object expected");
                        message.Tables = $root.priority.netitems.nrest.SqlTablesRq.fromObject(object.Tables);
                    }
                    if (object.Query != null) {
                        if (typeof object.Query !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.Query: object expected");
                        message.Query = $root.priority.netitems.nrest.QueryRq.fromObject(object.Query);
                    }
                    if (object.Columns != null) {
                        if (typeof object.Columns !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.Columns: object expected");
                        message.Columns = $root.priority.netitems.nrest.SqlColumnsRq.fromObject(object.Columns);
                    }
                    if (object.PrimaryKeys != null) {
                        if (typeof object.PrimaryKeys !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.PrimaryKeys: object expected");
                        message.PrimaryKeys = $root.priority.netitems.nrest.SqlPrimaryKeysRq.fromObject(object.PrimaryKeys);
                    }
                    if (object.ForeignKeys != null) {
                        if (typeof object.ForeignKeys !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ForeignKeys: object expected");
                        message.ForeignKeys = $root.priority.netitems.nrest.SqlForeignKeysRq.fromObject(object.ForeignKeys);
                    }
                    if (object.ExecDirect != null) {
                        if (typeof object.ExecDirect !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ExecDirect: object expected");
                        message.ExecDirect = $root.priority.netitems.nrest.SqlExecDirectRq.fromObject(object.ExecDirect);
                    }
                    if (object.Prepare != null) {
                        if (typeof object.Prepare !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.Prepare: object expected");
                        message.Prepare = $root.priority.netitems.nrest.SqlExecDirectRq.fromObject(object.Prepare);
                    }
                    if (object.PrepareN != null) {
                        if (typeof object.PrepareN !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.PrepareN: object expected");
                        message.PrepareN = $root.priority.netitems.nrest.QueryRq.fromObject(object.PrepareN);
                    }
                    if (object.Execute != null) {
                        if (typeof object.Execute !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.Execute: object expected");
                        message.Execute = $root.priority.netitems.nrest.TokenRq.fromObject(object.Execute);
                    }
                    if (object.ReportList != null) {
                        if (typeof object.ReportList !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ReportList: object expected");
                        message.ReportList = $root.priority.netitems.nrest.ReportListRq.fromObject(object.ReportList);
                    }
                    if (object.TreeNodeChildren != null) {
                        if (typeof object.TreeNodeChildren !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.TreeNodeChildren: object expected");
                        message.TreeNodeChildren = $root.priority.netitems.nrest.TreeNodeChildrenRq.fromObject(object.TreeNodeChildren);
                    }
                    if (object.ReportSave != null) {
                        if (typeof object.ReportSave !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ReportSave: object expected");
                        message.ReportSave = $root.priority.netitems.nrest.ReportSaveRq.fromObject(object.ReportSave);
                    }
                    if (object.ReportData != null) {
                        if (typeof object.ReportData !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ReportData: object expected");
                        message.ReportData = $root.priority.netitems.nrest.ReportDataRq.fromObject(object.ReportData);
                    }
                    if (object.ReportDel != null) {
                        if (typeof object.ReportDel !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ReportDel: object expected");
                        message.ReportDel = $root.priority.netitems.nrest.ReportDelRq.fromObject(object.ReportDel);
                    }
                    if (object.ReportGenerate != null) {
                        if (typeof object.ReportGenerate !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ReportGenerate: object expected");
                        message.ReportGenerate = $root.priority.netitems.nrest.ReportGenerateRq.fromObject(object.ReportGenerate);
                    }
                    if (object.DateFormats != null) {
                        if (typeof object.DateFormats !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.DateFormats: object expected");
                        message.DateFormats = $root.priority.netitems.nrest.DateFormatsRq.fromObject(object.DateFormats);
                    }
                    if (object.ReportColumns != null) {
                        if (typeof object.ReportColumns !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ReportColumns: object expected");
                        message.ReportColumns = $root.priority.netitems.nrest.ReportColumnsRq.fromObject(object.ReportColumns);
                    }
                    if (object.ReportCancel != null) {
                        if (typeof object.ReportCancel !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.ReportCancel: object expected");
                        message.ReportCancel = $root.priority.netitems.nrest.ReportCancelRq.fromObject(object.ReportCancel);
                    }
                    if (object.Data != null) {
                        if (typeof object.Data !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.Data: object expected");
                        message.Data = $root.priority.netitems.nrest.DataRq.fromObject(object.Data);
                    }
                    if (object.NumericFormats != null) {
                        if (typeof object.NumericFormats !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.NumericFormats: object expected");
                        message.NumericFormats = $root.priority.netitems.nrest.NumericFormatsRq.fromObject(object.NumericFormats);
                    }
                    if (object.FormsTree != null) {
                        if (typeof object.FormsTree !== "object")
                            throw TypeError(".priority.netitems.nrest.Grpc2Net.FormsTree: object expected");
                        message.FormsTree = $root.priority.netitems.nrest.FormsTreeRq.fromObject(object.FormsTree);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Grpc2Net message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @static
                 * @param {priority.netitems.nrest.Grpc2Net} message Grpc2Net
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Grpc2Net.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.Tables != null && message.hasOwnProperty("Tables")) {
                        object.Tables = $root.priority.netitems.nrest.SqlTablesRq.toObject(message.Tables, options);
                        if (options.oneofs)
                            object.inner = "Tables";
                    }
                    if (message.Query != null && message.hasOwnProperty("Query")) {
                        object.Query = $root.priority.netitems.nrest.QueryRq.toObject(message.Query, options);
                        if (options.oneofs)
                            object.inner = "Query";
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        object.Columns = $root.priority.netitems.nrest.SqlColumnsRq.toObject(message.Columns, options);
                        if (options.oneofs)
                            object.inner = "Columns";
                    }
                    if (message.PrimaryKeys != null && message.hasOwnProperty("PrimaryKeys")) {
                        object.PrimaryKeys = $root.priority.netitems.nrest.SqlPrimaryKeysRq.toObject(message.PrimaryKeys, options);
                        if (options.oneofs)
                            object.inner = "PrimaryKeys";
                    }
                    if (message.ForeignKeys != null && message.hasOwnProperty("ForeignKeys")) {
                        object.ForeignKeys = $root.priority.netitems.nrest.SqlForeignKeysRq.toObject(message.ForeignKeys, options);
                        if (options.oneofs)
                            object.inner = "ForeignKeys";
                    }
                    if (message.ExecDirect != null && message.hasOwnProperty("ExecDirect")) {
                        object.ExecDirect = $root.priority.netitems.nrest.SqlExecDirectRq.toObject(message.ExecDirect, options);
                        if (options.oneofs)
                            object.inner = "ExecDirect";
                    }
                    if (message.Prepare != null && message.hasOwnProperty("Prepare")) {
                        object.Prepare = $root.priority.netitems.nrest.SqlExecDirectRq.toObject(message.Prepare, options);
                        if (options.oneofs)
                            object.inner = "Prepare";
                    }
                    if (message.PrepareN != null && message.hasOwnProperty("PrepareN")) {
                        object.PrepareN = $root.priority.netitems.nrest.QueryRq.toObject(message.PrepareN, options);
                        if (options.oneofs)
                            object.inner = "PrepareN";
                    }
                    if (message.Execute != null && message.hasOwnProperty("Execute")) {
                        object.Execute = $root.priority.netitems.nrest.TokenRq.toObject(message.Execute, options);
                        if (options.oneofs)
                            object.inner = "Execute";
                    }
                    if (message.ReportList != null && message.hasOwnProperty("ReportList")) {
                        object.ReportList = $root.priority.netitems.nrest.ReportListRq.toObject(message.ReportList, options);
                        if (options.oneofs)
                            object.inner = "ReportList";
                    }
                    if (message.TreeNodeChildren != null && message.hasOwnProperty("TreeNodeChildren")) {
                        object.TreeNodeChildren = $root.priority.netitems.nrest.TreeNodeChildrenRq.toObject(message.TreeNodeChildren, options);
                        if (options.oneofs)
                            object.inner = "TreeNodeChildren";
                    }
                    if (message.ReportSave != null && message.hasOwnProperty("ReportSave")) {
                        object.ReportSave = $root.priority.netitems.nrest.ReportSaveRq.toObject(message.ReportSave, options);
                        if (options.oneofs)
                            object.inner = "ReportSave";
                    }
                    if (message.ReportData != null && message.hasOwnProperty("ReportData")) {
                        object.ReportData = $root.priority.netitems.nrest.ReportDataRq.toObject(message.ReportData, options);
                        if (options.oneofs)
                            object.inner = "ReportData";
                    }
                    if (message.ReportDel != null && message.hasOwnProperty("ReportDel")) {
                        object.ReportDel = $root.priority.netitems.nrest.ReportDelRq.toObject(message.ReportDel, options);
                        if (options.oneofs)
                            object.inner = "ReportDel";
                    }
                    if (message.ReportGenerate != null && message.hasOwnProperty("ReportGenerate")) {
                        object.ReportGenerate = $root.priority.netitems.nrest.ReportGenerateRq.toObject(message.ReportGenerate, options);
                        if (options.oneofs)
                            object.inner = "ReportGenerate";
                    }
                    if (message.DateFormats != null && message.hasOwnProperty("DateFormats")) {
                        object.DateFormats = $root.priority.netitems.nrest.DateFormatsRq.toObject(message.DateFormats, options);
                        if (options.oneofs)
                            object.inner = "DateFormats";
                    }
                    if (message.ReportColumns != null && message.hasOwnProperty("ReportColumns")) {
                        object.ReportColumns = $root.priority.netitems.nrest.ReportColumnsRq.toObject(message.ReportColumns, options);
                        if (options.oneofs)
                            object.inner = "ReportColumns";
                    }
                    if (message.ReportCancel != null && message.hasOwnProperty("ReportCancel")) {
                        object.ReportCancel = $root.priority.netitems.nrest.ReportCancelRq.toObject(message.ReportCancel, options);
                        if (options.oneofs)
                            object.inner = "ReportCancel";
                    }
                    if (message.Data != null && message.hasOwnProperty("Data")) {
                        object.Data = $root.priority.netitems.nrest.DataRq.toObject(message.Data, options);
                        if (options.oneofs)
                            object.inner = "Data";
                    }
                    if (message.NumericFormats != null && message.hasOwnProperty("NumericFormats")) {
                        object.NumericFormats = $root.priority.netitems.nrest.NumericFormatsRq.toObject(message.NumericFormats, options);
                        if (options.oneofs)
                            object.inner = "NumericFormats";
                    }
                    if (message.FormsTree != null && message.hasOwnProperty("FormsTree")) {
                        object.FormsTree = $root.priority.netitems.nrest.FormsTreeRq.toObject(message.FormsTree, options);
                        if (options.oneofs)
                            object.inner = "FormsTree";
                    }
                    return object;
                };

                /**
                 * Converts this Grpc2Net to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Grpc2Net
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Grpc2Net.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Grpc2Net;
            })();

            nrest.Net2Grpc = (function() {

                /**
                 * Properties of a Net2Grpc.
                 * @memberof priority.netitems.nrest
                 * @interface INet2Grpc
                 * @property {priority.netitems.shared.IGrpcError|null} [FatalError] Net2Grpc FatalError
                 * @property {priority.netitems.nrest.ISqlTablesRs|null} [Tables] Net2Grpc Tables
                 * @property {priority.netitems.nrest.IQueryRs|null} [Query] Net2Grpc Query
                 * @property {priority.netitems.nrest.ISqlColumnsRs|null} [Columns] Net2Grpc Columns
                 * @property {priority.netitems.nrest.ISqlPrimaryKeysRs|null} [PrimaryKeys] Net2Grpc PrimaryKeys
                 * @property {priority.netitems.nrest.ISqlForeignKeysRs|null} [ForeignKeys] Net2Grpc ForeignKeys
                 * @property {priority.netitems.nrest.ITokenRs|null} [Prepare] Net2Grpc Prepare
                 * @property {priority.netitems.nrest.ITokenRs|null} [PrepareN] Net2Grpc PrepareN
                 * @property {priority.netitems.nrest.IQueryRs|null} [Execute] Net2Grpc Execute
                 * @property {priority.netitems.nrest.IReportListRs|null} [ReportList] Net2Grpc ReportList
                 * @property {priority.netitems.nrest.ITreeNodeChildrenRs|null} [TreeNodeChildren] Net2Grpc TreeNodeChildren
                 * @property {priority.netitems.nrest.IReportSaveRs|null} [ReportSave] Net2Grpc ReportSave
                 * @property {priority.netitems.nrest.IReportDataRs|null} [ReportData] Net2Grpc ReportData
                 * @property {priority.netitems.nrest.IReportDelRs|null} [ReportDel] Net2Grpc ReportDel
                 * @property {priority.netitems.nrest.IReportGenerateRs|null} [ReportGenerate] Net2Grpc ReportGenerate
                 * @property {priority.netitems.nrest.IDateFormatsRs|null} [DateFormats] Net2Grpc DateFormats
                 * @property {priority.netitems.nrest.IReportColumnsRs|null} [ReportColumns] Net2Grpc ReportColumns
                 * @property {priority.netitems.nrest.IReportCancelRs|null} [ReportCancel] Net2Grpc ReportCancel
                 * @property {priority.netitems.nrest.IDataRs|null} [Data] Net2Grpc Data
                 * @property {priority.netitems.nrest.INumericFormatsRs|null} [NumericFormats] Net2Grpc NumericFormats
                 * @property {priority.netitems.nrest.IFormsTreeRs|null} [FormsTree] Net2Grpc FormsTree
                 */

                /**
                 * Constructs a new Net2Grpc.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a Net2Grpc.
                 * @implements INet2Grpc
                 * @constructor
                 * @param {priority.netitems.nrest.INet2Grpc=} [properties] Properties to set
                 */
                function Net2Grpc(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Net2Grpc FatalError.
                 * @member {priority.netitems.shared.IGrpcError|null|undefined} FatalError
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FatalError = null;

                /**
                 * Net2Grpc Tables.
                 * @member {priority.netitems.nrest.ISqlTablesRs|null|undefined} Tables
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Tables = null;

                /**
                 * Net2Grpc Query.
                 * @member {priority.netitems.nrest.IQueryRs|null|undefined} Query
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Query = null;

                /**
                 * Net2Grpc Columns.
                 * @member {priority.netitems.nrest.ISqlColumnsRs|null|undefined} Columns
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Columns = null;

                /**
                 * Net2Grpc PrimaryKeys.
                 * @member {priority.netitems.nrest.ISqlPrimaryKeysRs|null|undefined} PrimaryKeys
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.PrimaryKeys = null;

                /**
                 * Net2Grpc ForeignKeys.
                 * @member {priority.netitems.nrest.ISqlForeignKeysRs|null|undefined} ForeignKeys
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ForeignKeys = null;

                /**
                 * Net2Grpc Prepare.
                 * @member {priority.netitems.nrest.ITokenRs|null|undefined} Prepare
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Prepare = null;

                /**
                 * Net2Grpc PrepareN.
                 * @member {priority.netitems.nrest.ITokenRs|null|undefined} PrepareN
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.PrepareN = null;

                /**
                 * Net2Grpc Execute.
                 * @member {priority.netitems.nrest.IQueryRs|null|undefined} Execute
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Execute = null;

                /**
                 * Net2Grpc ReportList.
                 * @member {priority.netitems.nrest.IReportListRs|null|undefined} ReportList
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ReportList = null;

                /**
                 * Net2Grpc TreeNodeChildren.
                 * @member {priority.netitems.nrest.ITreeNodeChildrenRs|null|undefined} TreeNodeChildren
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.TreeNodeChildren = null;

                /**
                 * Net2Grpc ReportSave.
                 * @member {priority.netitems.nrest.IReportSaveRs|null|undefined} ReportSave
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ReportSave = null;

                /**
                 * Net2Grpc ReportData.
                 * @member {priority.netitems.nrest.IReportDataRs|null|undefined} ReportData
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ReportData = null;

                /**
                 * Net2Grpc ReportDel.
                 * @member {priority.netitems.nrest.IReportDelRs|null|undefined} ReportDel
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ReportDel = null;

                /**
                 * Net2Grpc ReportGenerate.
                 * @member {priority.netitems.nrest.IReportGenerateRs|null|undefined} ReportGenerate
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ReportGenerate = null;

                /**
                 * Net2Grpc DateFormats.
                 * @member {priority.netitems.nrest.IDateFormatsRs|null|undefined} DateFormats
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.DateFormats = null;

                /**
                 * Net2Grpc ReportColumns.
                 * @member {priority.netitems.nrest.IReportColumnsRs|null|undefined} ReportColumns
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ReportColumns = null;

                /**
                 * Net2Grpc ReportCancel.
                 * @member {priority.netitems.nrest.IReportCancelRs|null|undefined} ReportCancel
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ReportCancel = null;

                /**
                 * Net2Grpc Data.
                 * @member {priority.netitems.nrest.IDataRs|null|undefined} Data
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Data = null;

                /**
                 * Net2Grpc NumericFormats.
                 * @member {priority.netitems.nrest.INumericFormatsRs|null|undefined} NumericFormats
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.NumericFormats = null;

                /**
                 * Net2Grpc FormsTree.
                 * @member {priority.netitems.nrest.IFormsTreeRs|null|undefined} FormsTree
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FormsTree = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Net2Grpc inner.
                 * @member {"Tables"|"Query"|"Columns"|"PrimaryKeys"|"ForeignKeys"|"Prepare"|"PrepareN"|"Execute"|"ReportList"|"TreeNodeChildren"|"ReportSave"|"ReportData"|"ReportDel"|"ReportGenerate"|"DateFormats"|"ReportColumns"|"ReportCancel"|"Data"|"NumericFormats"|"FormsTree"|undefined} inner
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 */
                Object.defineProperty(Net2Grpc.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["Tables", "Query", "Columns", "PrimaryKeys", "ForeignKeys", "Prepare", "PrepareN", "Execute", "ReportList", "TreeNodeChildren", "ReportSave", "ReportData", "ReportDel", "ReportGenerate", "DateFormats", "ReportColumns", "ReportCancel", "Data", "NumericFormats", "FormsTree"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Net2Grpc instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @static
                 * @param {priority.netitems.nrest.INet2Grpc=} [properties] Properties to set
                 * @returns {priority.netitems.nrest.Net2Grpc} Net2Grpc instance
                 */
                Net2Grpc.create = function create(properties) {
                    return new Net2Grpc(properties);
                };

                /**
                 * Encodes the specified Net2Grpc message. Does not implicitly {@link priority.netitems.nrest.Net2Grpc.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @static
                 * @param {priority.netitems.nrest.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.FatalError != null && Object.hasOwnProperty.call(message, "FatalError"))
                        $root.priority.netitems.shared.GrpcError.encode(message.FatalError, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Tables != null && Object.hasOwnProperty.call(message, "Tables"))
                        $root.priority.netitems.nrest.SqlTablesRs.encode(message.Tables, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Query != null && Object.hasOwnProperty.call(message, "Query"))
                        $root.priority.netitems.nrest.QueryRs.encode(message.Query, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.Columns != null && Object.hasOwnProperty.call(message, "Columns"))
                        $root.priority.netitems.nrest.SqlColumnsRs.encode(message.Columns, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.PrimaryKeys != null && Object.hasOwnProperty.call(message, "PrimaryKeys"))
                        $root.priority.netitems.nrest.SqlPrimaryKeysRs.encode(message.PrimaryKeys, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.ForeignKeys != null && Object.hasOwnProperty.call(message, "ForeignKeys"))
                        $root.priority.netitems.nrest.SqlForeignKeysRs.encode(message.ForeignKeys, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.Prepare != null && Object.hasOwnProperty.call(message, "Prepare"))
                        $root.priority.netitems.nrest.TokenRs.encode(message.Prepare, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.PrepareN != null && Object.hasOwnProperty.call(message, "PrepareN"))
                        $root.priority.netitems.nrest.TokenRs.encode(message.PrepareN, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.Execute != null && Object.hasOwnProperty.call(message, "Execute"))
                        $root.priority.netitems.nrest.QueryRs.encode(message.Execute, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.ReportList != null && Object.hasOwnProperty.call(message, "ReportList"))
                        $root.priority.netitems.nrest.ReportListRs.encode(message.ReportList, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.TreeNodeChildren != null && Object.hasOwnProperty.call(message, "TreeNodeChildren"))
                        $root.priority.netitems.nrest.TreeNodeChildrenRs.encode(message.TreeNodeChildren, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.ReportSave != null && Object.hasOwnProperty.call(message, "ReportSave"))
                        $root.priority.netitems.nrest.ReportSaveRs.encode(message.ReportSave, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    if (message.ReportData != null && Object.hasOwnProperty.call(message, "ReportData"))
                        $root.priority.netitems.nrest.ReportDataRs.encode(message.ReportData, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                    if (message.ReportDel != null && Object.hasOwnProperty.call(message, "ReportDel"))
                        $root.priority.netitems.nrest.ReportDelRs.encode(message.ReportDel, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                    if (message.ReportGenerate != null && Object.hasOwnProperty.call(message, "ReportGenerate"))
                        $root.priority.netitems.nrest.ReportGenerateRs.encode(message.ReportGenerate, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                    if (message.DateFormats != null && Object.hasOwnProperty.call(message, "DateFormats"))
                        $root.priority.netitems.nrest.DateFormatsRs.encode(message.DateFormats, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                    if (message.ReportColumns != null && Object.hasOwnProperty.call(message, "ReportColumns"))
                        $root.priority.netitems.nrest.ReportColumnsRs.encode(message.ReportColumns, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                    if (message.ReportCancel != null && Object.hasOwnProperty.call(message, "ReportCancel"))
                        $root.priority.netitems.nrest.ReportCancelRs.encode(message.ReportCancel, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                    if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                        $root.priority.netitems.nrest.DataRs.encode(message.Data, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                    if (message.NumericFormats != null && Object.hasOwnProperty.call(message, "NumericFormats"))
                        $root.priority.netitems.nrest.NumericFormatsRs.encode(message.NumericFormats, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                    if (message.FormsTree != null && Object.hasOwnProperty.call(message, "FormsTree"))
                        $root.priority.netitems.nrest.FormsTreeRs.encode(message.FormsTree, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Net2Grpc message, length delimited. Does not implicitly {@link priority.netitems.nrest.Net2Grpc.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @static
                 * @param {priority.netitems.nrest.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrest.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrest.Net2Grpc();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.FatalError = $root.priority.netitems.shared.GrpcError.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Tables = $root.priority.netitems.nrest.SqlTablesRs.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.Query = $root.priority.netitems.nrest.QueryRs.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.Columns = $root.priority.netitems.nrest.SqlColumnsRs.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.PrimaryKeys = $root.priority.netitems.nrest.SqlPrimaryKeysRs.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.ForeignKeys = $root.priority.netitems.nrest.SqlForeignKeysRs.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.Prepare = $root.priority.netitems.nrest.TokenRs.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.PrepareN = $root.priority.netitems.nrest.TokenRs.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.Execute = $root.priority.netitems.nrest.QueryRs.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.ReportList = $root.priority.netitems.nrest.ReportListRs.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.TreeNodeChildren = $root.priority.netitems.nrest.TreeNodeChildrenRs.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.ReportSave = $root.priority.netitems.nrest.ReportSaveRs.decode(reader, reader.uint32());
                            break;
                        case 13:
                            message.ReportData = $root.priority.netitems.nrest.ReportDataRs.decode(reader, reader.uint32());
                            break;
                        case 14:
                            message.ReportDel = $root.priority.netitems.nrest.ReportDelRs.decode(reader, reader.uint32());
                            break;
                        case 15:
                            message.ReportGenerate = $root.priority.netitems.nrest.ReportGenerateRs.decode(reader, reader.uint32());
                            break;
                        case 16:
                            message.DateFormats = $root.priority.netitems.nrest.DateFormatsRs.decode(reader, reader.uint32());
                            break;
                        case 17:
                            message.ReportColumns = $root.priority.netitems.nrest.ReportColumnsRs.decode(reader, reader.uint32());
                            break;
                        case 18:
                            message.ReportCancel = $root.priority.netitems.nrest.ReportCancelRs.decode(reader, reader.uint32());
                            break;
                        case 19:
                            message.Data = $root.priority.netitems.nrest.DataRs.decode(reader, reader.uint32());
                            break;
                        case 20:
                            message.NumericFormats = $root.priority.netitems.nrest.NumericFormatsRs.decode(reader, reader.uint32());
                            break;
                        case 21:
                            message.FormsTree = $root.priority.netitems.nrest.FormsTreeRs.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrest.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Net2Grpc message.
                 * @function verify
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Net2Grpc.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.FatalError != null && message.hasOwnProperty("FatalError")) {
                        var error = $root.priority.netitems.shared.GrpcError.verify(message.FatalError);
                        if (error)
                            return "FatalError." + error;
                    }
                    if (message.Tables != null && message.hasOwnProperty("Tables")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlTablesRs.verify(message.Tables);
                            if (error)
                                return "Tables." + error;
                        }
                    }
                    if (message.Query != null && message.hasOwnProperty("Query")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.QueryRs.verify(message.Query);
                            if (error)
                                return "Query." + error;
                        }
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlColumnsRs.verify(message.Columns);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.PrimaryKeys != null && message.hasOwnProperty("PrimaryKeys")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlPrimaryKeysRs.verify(message.PrimaryKeys);
                            if (error)
                                return "PrimaryKeys." + error;
                        }
                    }
                    if (message.ForeignKeys != null && message.hasOwnProperty("ForeignKeys")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.SqlForeignKeysRs.verify(message.ForeignKeys);
                            if (error)
                                return "ForeignKeys." + error;
                        }
                    }
                    if (message.Prepare != null && message.hasOwnProperty("Prepare")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.TokenRs.verify(message.Prepare);
                            if (error)
                                return "Prepare." + error;
                        }
                    }
                    if (message.PrepareN != null && message.hasOwnProperty("PrepareN")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.TokenRs.verify(message.PrepareN);
                            if (error)
                                return "PrepareN." + error;
                        }
                    }
                    if (message.Execute != null && message.hasOwnProperty("Execute")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.QueryRs.verify(message.Execute);
                            if (error)
                                return "Execute." + error;
                        }
                    }
                    if (message.ReportList != null && message.hasOwnProperty("ReportList")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportListRs.verify(message.ReportList);
                            if (error)
                                return "ReportList." + error;
                        }
                    }
                    if (message.TreeNodeChildren != null && message.hasOwnProperty("TreeNodeChildren")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.TreeNodeChildrenRs.verify(message.TreeNodeChildren);
                            if (error)
                                return "TreeNodeChildren." + error;
                        }
                    }
                    if (message.ReportSave != null && message.hasOwnProperty("ReportSave")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportSaveRs.verify(message.ReportSave);
                            if (error)
                                return "ReportSave." + error;
                        }
                    }
                    if (message.ReportData != null && message.hasOwnProperty("ReportData")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportDataRs.verify(message.ReportData);
                            if (error)
                                return "ReportData." + error;
                        }
                    }
                    if (message.ReportDel != null && message.hasOwnProperty("ReportDel")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportDelRs.verify(message.ReportDel);
                            if (error)
                                return "ReportDel." + error;
                        }
                    }
                    if (message.ReportGenerate != null && message.hasOwnProperty("ReportGenerate")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportGenerateRs.verify(message.ReportGenerate);
                            if (error)
                                return "ReportGenerate." + error;
                        }
                    }
                    if (message.DateFormats != null && message.hasOwnProperty("DateFormats")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.DateFormatsRs.verify(message.DateFormats);
                            if (error)
                                return "DateFormats." + error;
                        }
                    }
                    if (message.ReportColumns != null && message.hasOwnProperty("ReportColumns")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportColumnsRs.verify(message.ReportColumns);
                            if (error)
                                return "ReportColumns." + error;
                        }
                    }
                    if (message.ReportCancel != null && message.hasOwnProperty("ReportCancel")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.ReportCancelRs.verify(message.ReportCancel);
                            if (error)
                                return "ReportCancel." + error;
                        }
                    }
                    if (message.Data != null && message.hasOwnProperty("Data")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.DataRs.verify(message.Data);
                            if (error)
                                return "Data." + error;
                        }
                    }
                    if (message.NumericFormats != null && message.hasOwnProperty("NumericFormats")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.NumericFormatsRs.verify(message.NumericFormats);
                            if (error)
                                return "NumericFormats." + error;
                        }
                    }
                    if (message.FormsTree != null && message.hasOwnProperty("FormsTree")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrest.FormsTreeRs.verify(message.FormsTree);
                            if (error)
                                return "FormsTree." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Net2Grpc message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrest.Net2Grpc} Net2Grpc
                 */
                Net2Grpc.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrest.Net2Grpc)
                        return object;
                    var message = new $root.priority.netitems.nrest.Net2Grpc();
                    if (object.FatalError != null) {
                        if (typeof object.FatalError !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.FatalError: object expected");
                        message.FatalError = $root.priority.netitems.shared.GrpcError.fromObject(object.FatalError);
                    }
                    if (object.Tables != null) {
                        if (typeof object.Tables !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.Tables: object expected");
                        message.Tables = $root.priority.netitems.nrest.SqlTablesRs.fromObject(object.Tables);
                    }
                    if (object.Query != null) {
                        if (typeof object.Query !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.Query: object expected");
                        message.Query = $root.priority.netitems.nrest.QueryRs.fromObject(object.Query);
                    }
                    if (object.Columns != null) {
                        if (typeof object.Columns !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.Columns: object expected");
                        message.Columns = $root.priority.netitems.nrest.SqlColumnsRs.fromObject(object.Columns);
                    }
                    if (object.PrimaryKeys != null) {
                        if (typeof object.PrimaryKeys !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.PrimaryKeys: object expected");
                        message.PrimaryKeys = $root.priority.netitems.nrest.SqlPrimaryKeysRs.fromObject(object.PrimaryKeys);
                    }
                    if (object.ForeignKeys != null) {
                        if (typeof object.ForeignKeys !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.ForeignKeys: object expected");
                        message.ForeignKeys = $root.priority.netitems.nrest.SqlForeignKeysRs.fromObject(object.ForeignKeys);
                    }
                    if (object.Prepare != null) {
                        if (typeof object.Prepare !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.Prepare: object expected");
                        message.Prepare = $root.priority.netitems.nrest.TokenRs.fromObject(object.Prepare);
                    }
                    if (object.PrepareN != null) {
                        if (typeof object.PrepareN !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.PrepareN: object expected");
                        message.PrepareN = $root.priority.netitems.nrest.TokenRs.fromObject(object.PrepareN);
                    }
                    if (object.Execute != null) {
                        if (typeof object.Execute !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.Execute: object expected");
                        message.Execute = $root.priority.netitems.nrest.QueryRs.fromObject(object.Execute);
                    }
                    if (object.ReportList != null) {
                        if (typeof object.ReportList !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.ReportList: object expected");
                        message.ReportList = $root.priority.netitems.nrest.ReportListRs.fromObject(object.ReportList);
                    }
                    if (object.TreeNodeChildren != null) {
                        if (typeof object.TreeNodeChildren !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.TreeNodeChildren: object expected");
                        message.TreeNodeChildren = $root.priority.netitems.nrest.TreeNodeChildrenRs.fromObject(object.TreeNodeChildren);
                    }
                    if (object.ReportSave != null) {
                        if (typeof object.ReportSave !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.ReportSave: object expected");
                        message.ReportSave = $root.priority.netitems.nrest.ReportSaveRs.fromObject(object.ReportSave);
                    }
                    if (object.ReportData != null) {
                        if (typeof object.ReportData !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.ReportData: object expected");
                        message.ReportData = $root.priority.netitems.nrest.ReportDataRs.fromObject(object.ReportData);
                    }
                    if (object.ReportDel != null) {
                        if (typeof object.ReportDel !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.ReportDel: object expected");
                        message.ReportDel = $root.priority.netitems.nrest.ReportDelRs.fromObject(object.ReportDel);
                    }
                    if (object.ReportGenerate != null) {
                        if (typeof object.ReportGenerate !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.ReportGenerate: object expected");
                        message.ReportGenerate = $root.priority.netitems.nrest.ReportGenerateRs.fromObject(object.ReportGenerate);
                    }
                    if (object.DateFormats != null) {
                        if (typeof object.DateFormats !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.DateFormats: object expected");
                        message.DateFormats = $root.priority.netitems.nrest.DateFormatsRs.fromObject(object.DateFormats);
                    }
                    if (object.ReportColumns != null) {
                        if (typeof object.ReportColumns !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.ReportColumns: object expected");
                        message.ReportColumns = $root.priority.netitems.nrest.ReportColumnsRs.fromObject(object.ReportColumns);
                    }
                    if (object.ReportCancel != null) {
                        if (typeof object.ReportCancel !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.ReportCancel: object expected");
                        message.ReportCancel = $root.priority.netitems.nrest.ReportCancelRs.fromObject(object.ReportCancel);
                    }
                    if (object.Data != null) {
                        if (typeof object.Data !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.Data: object expected");
                        message.Data = $root.priority.netitems.nrest.DataRs.fromObject(object.Data);
                    }
                    if (object.NumericFormats != null) {
                        if (typeof object.NumericFormats !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.NumericFormats: object expected");
                        message.NumericFormats = $root.priority.netitems.nrest.NumericFormatsRs.fromObject(object.NumericFormats);
                    }
                    if (object.FormsTree != null) {
                        if (typeof object.FormsTree !== "object")
                            throw TypeError(".priority.netitems.nrest.Net2Grpc.FormsTree: object expected");
                        message.FormsTree = $root.priority.netitems.nrest.FormsTreeRs.fromObject(object.FormsTree);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Net2Grpc message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @static
                 * @param {priority.netitems.nrest.Net2Grpc} message Net2Grpc
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Net2Grpc.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.FatalError = null;
                    if (message.FatalError != null && message.hasOwnProperty("FatalError"))
                        object.FatalError = $root.priority.netitems.shared.GrpcError.toObject(message.FatalError, options);
                    if (message.Tables != null && message.hasOwnProperty("Tables")) {
                        object.Tables = $root.priority.netitems.nrest.SqlTablesRs.toObject(message.Tables, options);
                        if (options.oneofs)
                            object.inner = "Tables";
                    }
                    if (message.Query != null && message.hasOwnProperty("Query")) {
                        object.Query = $root.priority.netitems.nrest.QueryRs.toObject(message.Query, options);
                        if (options.oneofs)
                            object.inner = "Query";
                    }
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        object.Columns = $root.priority.netitems.nrest.SqlColumnsRs.toObject(message.Columns, options);
                        if (options.oneofs)
                            object.inner = "Columns";
                    }
                    if (message.PrimaryKeys != null && message.hasOwnProperty("PrimaryKeys")) {
                        object.PrimaryKeys = $root.priority.netitems.nrest.SqlPrimaryKeysRs.toObject(message.PrimaryKeys, options);
                        if (options.oneofs)
                            object.inner = "PrimaryKeys";
                    }
                    if (message.ForeignKeys != null && message.hasOwnProperty("ForeignKeys")) {
                        object.ForeignKeys = $root.priority.netitems.nrest.SqlForeignKeysRs.toObject(message.ForeignKeys, options);
                        if (options.oneofs)
                            object.inner = "ForeignKeys";
                    }
                    if (message.Prepare != null && message.hasOwnProperty("Prepare")) {
                        object.Prepare = $root.priority.netitems.nrest.TokenRs.toObject(message.Prepare, options);
                        if (options.oneofs)
                            object.inner = "Prepare";
                    }
                    if (message.PrepareN != null && message.hasOwnProperty("PrepareN")) {
                        object.PrepareN = $root.priority.netitems.nrest.TokenRs.toObject(message.PrepareN, options);
                        if (options.oneofs)
                            object.inner = "PrepareN";
                    }
                    if (message.Execute != null && message.hasOwnProperty("Execute")) {
                        object.Execute = $root.priority.netitems.nrest.QueryRs.toObject(message.Execute, options);
                        if (options.oneofs)
                            object.inner = "Execute";
                    }
                    if (message.ReportList != null && message.hasOwnProperty("ReportList")) {
                        object.ReportList = $root.priority.netitems.nrest.ReportListRs.toObject(message.ReportList, options);
                        if (options.oneofs)
                            object.inner = "ReportList";
                    }
                    if (message.TreeNodeChildren != null && message.hasOwnProperty("TreeNodeChildren")) {
                        object.TreeNodeChildren = $root.priority.netitems.nrest.TreeNodeChildrenRs.toObject(message.TreeNodeChildren, options);
                        if (options.oneofs)
                            object.inner = "TreeNodeChildren";
                    }
                    if (message.ReportSave != null && message.hasOwnProperty("ReportSave")) {
                        object.ReportSave = $root.priority.netitems.nrest.ReportSaveRs.toObject(message.ReportSave, options);
                        if (options.oneofs)
                            object.inner = "ReportSave";
                    }
                    if (message.ReportData != null && message.hasOwnProperty("ReportData")) {
                        object.ReportData = $root.priority.netitems.nrest.ReportDataRs.toObject(message.ReportData, options);
                        if (options.oneofs)
                            object.inner = "ReportData";
                    }
                    if (message.ReportDel != null && message.hasOwnProperty("ReportDel")) {
                        object.ReportDel = $root.priority.netitems.nrest.ReportDelRs.toObject(message.ReportDel, options);
                        if (options.oneofs)
                            object.inner = "ReportDel";
                    }
                    if (message.ReportGenerate != null && message.hasOwnProperty("ReportGenerate")) {
                        object.ReportGenerate = $root.priority.netitems.nrest.ReportGenerateRs.toObject(message.ReportGenerate, options);
                        if (options.oneofs)
                            object.inner = "ReportGenerate";
                    }
                    if (message.DateFormats != null && message.hasOwnProperty("DateFormats")) {
                        object.DateFormats = $root.priority.netitems.nrest.DateFormatsRs.toObject(message.DateFormats, options);
                        if (options.oneofs)
                            object.inner = "DateFormats";
                    }
                    if (message.ReportColumns != null && message.hasOwnProperty("ReportColumns")) {
                        object.ReportColumns = $root.priority.netitems.nrest.ReportColumnsRs.toObject(message.ReportColumns, options);
                        if (options.oneofs)
                            object.inner = "ReportColumns";
                    }
                    if (message.ReportCancel != null && message.hasOwnProperty("ReportCancel")) {
                        object.ReportCancel = $root.priority.netitems.nrest.ReportCancelRs.toObject(message.ReportCancel, options);
                        if (options.oneofs)
                            object.inner = "ReportCancel";
                    }
                    if (message.Data != null && message.hasOwnProperty("Data")) {
                        object.Data = $root.priority.netitems.nrest.DataRs.toObject(message.Data, options);
                        if (options.oneofs)
                            object.inner = "Data";
                    }
                    if (message.NumericFormats != null && message.hasOwnProperty("NumericFormats")) {
                        object.NumericFormats = $root.priority.netitems.nrest.NumericFormatsRs.toObject(message.NumericFormats, options);
                        if (options.oneofs)
                            object.inner = "NumericFormats";
                    }
                    if (message.FormsTree != null && message.hasOwnProperty("FormsTree")) {
                        object.FormsTree = $root.priority.netitems.nrest.FormsTreeRs.toObject(message.FormsTree, options);
                        if (options.oneofs)
                            object.inner = "FormsTree";
                    }
                    return object;
                };

                /**
                 * Converts this Net2Grpc to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrest.Net2Grpc
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Net2Grpc.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Net2Grpc;
            })();

            nrest.NRest = (function() {

                /**
                 * Constructs a new NRest service.
                 * @memberof priority.netitems.nrest
                 * @classdesc Represents a NRest
                 * @extends $protobuf.rpc.Service
                 * @constructor
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 */
                function NRest(rpcImpl, requestDelimited, responseDelimited) {
                    $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }

                (NRest.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NRest;

                /**
                 * Creates new NRest service using the specified rpc implementation.
                 * @function create
                 * @memberof priority.netitems.nrest.NRest
                 * @static
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 * @returns {NRest} RPC service. Useful where requests and/or responses are streamed.
                 */
                NRest.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#tables}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef TablesCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.SqlTablesRs} [response] SqlTablesRs
                 */

                /**
                 * Calls Tables.
                 * @function tables
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlTablesRq} request SqlTablesRq message or plain object
                 * @param {priority.netitems.nrest.NRest.TablesCallback} callback Node-style callback called with the error, if any, and SqlTablesRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.tables = function tables(request, callback) {
                    return this.rpcCall(tables, $root.priority.netitems.nrest.SqlTablesRq, $root.priority.netitems.nrest.SqlTablesRs, request, callback);
                }, "name", { value: "Tables" });

                /**
                 * Calls Tables.
                 * @function tables
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlTablesRq} request SqlTablesRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.SqlTablesRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#query}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef QueryCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.QueryRs} [response] QueryRs
                 */

                /**
                 * Calls Query.
                 * @function query
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IQueryRq} request QueryRq message or plain object
                 * @param {priority.netitems.nrest.NRest.QueryCallback} callback Node-style callback called with the error, if any, and QueryRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.query = function query(request, callback) {
                    return this.rpcCall(query, $root.priority.netitems.nrest.QueryRq, $root.priority.netitems.nrest.QueryRs, request, callback);
                }, "name", { value: "Query" });

                /**
                 * Calls Query.
                 * @function query
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IQueryRq} request QueryRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.QueryRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#columns}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ColumnsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.SqlColumnsRs} [response] SqlColumnsRs
                 */

                /**
                 * Calls Columns.
                 * @function columns
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlColumnsRq} request SqlColumnsRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ColumnsCallback} callback Node-style callback called with the error, if any, and SqlColumnsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.columns = function columns(request, callback) {
                    return this.rpcCall(columns, $root.priority.netitems.nrest.SqlColumnsRq, $root.priority.netitems.nrest.SqlColumnsRs, request, callback);
                }, "name", { value: "Columns" });

                /**
                 * Calls Columns.
                 * @function columns
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlColumnsRq} request SqlColumnsRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.SqlColumnsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#primaryKeys}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef PrimaryKeysCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.SqlPrimaryKeysRs} [response] SqlPrimaryKeysRs
                 */

                /**
                 * Calls PrimaryKeys.
                 * @function primaryKeys
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRq} request SqlPrimaryKeysRq message or plain object
                 * @param {priority.netitems.nrest.NRest.PrimaryKeysCallback} callback Node-style callback called with the error, if any, and SqlPrimaryKeysRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.primaryKeys = function primaryKeys(request, callback) {
                    return this.rpcCall(primaryKeys, $root.priority.netitems.nrest.SqlPrimaryKeysRq, $root.priority.netitems.nrest.SqlPrimaryKeysRs, request, callback);
                }, "name", { value: "PrimaryKeys" });

                /**
                 * Calls PrimaryKeys.
                 * @function primaryKeys
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlPrimaryKeysRq} request SqlPrimaryKeysRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.SqlPrimaryKeysRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#foreignKeys}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ForeignKeysCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.SqlForeignKeysRs} [response] SqlForeignKeysRs
                 */

                /**
                 * Calls ForeignKeys.
                 * @function foreignKeys
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlForeignKeysRq} request SqlForeignKeysRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ForeignKeysCallback} callback Node-style callback called with the error, if any, and SqlForeignKeysRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.foreignKeys = function foreignKeys(request, callback) {
                    return this.rpcCall(foreignKeys, $root.priority.netitems.nrest.SqlForeignKeysRq, $root.priority.netitems.nrest.SqlForeignKeysRs, request, callback);
                }, "name", { value: "ForeignKeys" });

                /**
                 * Calls ForeignKeys.
                 * @function foreignKeys
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlForeignKeysRq} request SqlForeignKeysRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.SqlForeignKeysRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#execDirect}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ExecDirectCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.QueryRs} [response] QueryRs
                 */

                /**
                 * Calls ExecDirect.
                 * @function execDirect
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlExecDirectRq} request SqlExecDirectRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ExecDirectCallback} callback Node-style callback called with the error, if any, and QueryRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.execDirect = function execDirect(request, callback) {
                    return this.rpcCall(execDirect, $root.priority.netitems.nrest.SqlExecDirectRq, $root.priority.netitems.nrest.QueryRs, request, callback);
                }, "name", { value: "ExecDirect" });

                /**
                 * Calls ExecDirect.
                 * @function execDirect
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlExecDirectRq} request SqlExecDirectRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.QueryRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#prepare}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef PrepareCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.TokenRs} [response] TokenRs
                 */

                /**
                 * Calls Prepare.
                 * @function prepare
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlExecDirectRq} request SqlExecDirectRq message or plain object
                 * @param {priority.netitems.nrest.NRest.PrepareCallback} callback Node-style callback called with the error, if any, and TokenRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.prepare = function prepare(request, callback) {
                    return this.rpcCall(prepare, $root.priority.netitems.nrest.SqlExecDirectRq, $root.priority.netitems.nrest.TokenRs, request, callback);
                }, "name", { value: "Prepare" });

                /**
                 * Calls Prepare.
                 * @function prepare
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ISqlExecDirectRq} request SqlExecDirectRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.TokenRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#prepareN}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef PrepareNCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.TokenRs} [response] TokenRs
                 */

                /**
                 * Calls PrepareN.
                 * @function prepareN
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IQueryRq} request QueryRq message or plain object
                 * @param {priority.netitems.nrest.NRest.PrepareNCallback} callback Node-style callback called with the error, if any, and TokenRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.prepareN = function prepareN(request, callback) {
                    return this.rpcCall(prepareN, $root.priority.netitems.nrest.QueryRq, $root.priority.netitems.nrest.TokenRs, request, callback);
                }, "name", { value: "PrepareN" });

                /**
                 * Calls PrepareN.
                 * @function prepareN
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IQueryRq} request QueryRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.TokenRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#execute}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ExecuteCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.QueryRs} [response] QueryRs
                 */

                /**
                 * Calls Execute.
                 * @function execute
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ITokenRq} request TokenRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ExecuteCallback} callback Node-style callback called with the error, if any, and QueryRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.execute = function execute(request, callback) {
                    return this.rpcCall(execute, $root.priority.netitems.nrest.TokenRq, $root.priority.netitems.nrest.QueryRs, request, callback);
                }, "name", { value: "Execute" });

                /**
                 * Calls Execute.
                 * @function execute
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ITokenRq} request TokenRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.QueryRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#companies}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef CompaniesCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {common.CompaniesRs} [response] CompaniesRs
                 */

                /**
                 * Calls Companies.
                 * @function companies
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {common.ICompaniesRq} request CompaniesRq message or plain object
                 * @param {priority.netitems.nrest.NRest.CompaniesCallback} callback Node-style callback called with the error, if any, and CompaniesRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.companies = function companies(request, callback) {
                    return this.rpcCall(companies, $root.common.CompaniesRq, $root.common.CompaniesRs, request, callback);
                }, "name", { value: "Companies" });

                /**
                 * Calls Companies.
                 * @function companies
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {common.ICompaniesRq} request CompaniesRq message or plain object
                 * @returns {Promise<common.CompaniesRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#reportList}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ReportListCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.ReportListRs} [response] ReportListRs
                 */

                /**
                 * Calls ReportList.
                 * @function reportList
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportListRq} request ReportListRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ReportListCallback} callback Node-style callback called with the error, if any, and ReportListRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.reportList = function reportList(request, callback) {
                    return this.rpcCall(reportList, $root.priority.netitems.nrest.ReportListRq, $root.priority.netitems.nrest.ReportListRs, request, callback);
                }, "name", { value: "ReportList" });

                /**
                 * Calls ReportList.
                 * @function reportList
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportListRq} request ReportListRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.ReportListRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#treeNodeChildren}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef TreeNodeChildrenCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.TreeNodeChildrenRs} [response] TreeNodeChildrenRs
                 */

                /**
                 * Calls TreeNodeChildren.
                 * @function treeNodeChildren
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRq} request TreeNodeChildrenRq message or plain object
                 * @param {priority.netitems.nrest.NRest.TreeNodeChildrenCallback} callback Node-style callback called with the error, if any, and TreeNodeChildrenRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.treeNodeChildren = function treeNodeChildren(request, callback) {
                    return this.rpcCall(treeNodeChildren, $root.priority.netitems.nrest.TreeNodeChildrenRq, $root.priority.netitems.nrest.TreeNodeChildrenRs, request, callback);
                }, "name", { value: "TreeNodeChildren" });

                /**
                 * Calls TreeNodeChildren.
                 * @function treeNodeChildren
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.ITreeNodeChildrenRq} request TreeNodeChildrenRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.TreeNodeChildrenRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#reportSave}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ReportSaveCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.ReportSaveRs} [response] ReportSaveRs
                 */

                /**
                 * Calls ReportSave.
                 * @function reportSave
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportSaveRq} request ReportSaveRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ReportSaveCallback} callback Node-style callback called with the error, if any, and ReportSaveRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.reportSave = function reportSave(request, callback) {
                    return this.rpcCall(reportSave, $root.priority.netitems.nrest.ReportSaveRq, $root.priority.netitems.nrest.ReportSaveRs, request, callback);
                }, "name", { value: "ReportSave" });

                /**
                 * Calls ReportSave.
                 * @function reportSave
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportSaveRq} request ReportSaveRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.ReportSaveRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#reportData}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ReportDataCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.ReportDataRs} [response] ReportDataRs
                 */

                /**
                 * Calls ReportData.
                 * @function reportData
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportDataRq} request ReportDataRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ReportDataCallback} callback Node-style callback called with the error, if any, and ReportDataRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.reportData = function reportData(request, callback) {
                    return this.rpcCall(reportData, $root.priority.netitems.nrest.ReportDataRq, $root.priority.netitems.nrest.ReportDataRs, request, callback);
                }, "name", { value: "ReportData" });

                /**
                 * Calls ReportData.
                 * @function reportData
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportDataRq} request ReportDataRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.ReportDataRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#reportDel}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ReportDelCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.ReportDelRs} [response] ReportDelRs
                 */

                /**
                 * Calls ReportDel.
                 * @function reportDel
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportDelRq} request ReportDelRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ReportDelCallback} callback Node-style callback called with the error, if any, and ReportDelRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.reportDel = function reportDel(request, callback) {
                    return this.rpcCall(reportDel, $root.priority.netitems.nrest.ReportDelRq, $root.priority.netitems.nrest.ReportDelRs, request, callback);
                }, "name", { value: "ReportDel" });

                /**
                 * Calls ReportDel.
                 * @function reportDel
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportDelRq} request ReportDelRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.ReportDelRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#reportGenerate}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ReportGenerateCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.ReportGenerateRs} [response] ReportGenerateRs
                 */

                /**
                 * Calls ReportGenerate.
                 * @function reportGenerate
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportGenerateRq} request ReportGenerateRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ReportGenerateCallback} callback Node-style callback called with the error, if any, and ReportGenerateRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.reportGenerate = function reportGenerate(request, callback) {
                    return this.rpcCall(reportGenerate, $root.priority.netitems.nrest.ReportGenerateRq, $root.priority.netitems.nrest.ReportGenerateRs, request, callback);
                }, "name", { value: "ReportGenerate" });

                /**
                 * Calls ReportGenerate.
                 * @function reportGenerate
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportGenerateRq} request ReportGenerateRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.ReportGenerateRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#dateFormats}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef DateFormatsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.DateFormatsRs} [response] DateFormatsRs
                 */

                /**
                 * Calls DateFormats.
                 * @function dateFormats
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IDateFormatsRq} request DateFormatsRq message or plain object
                 * @param {priority.netitems.nrest.NRest.DateFormatsCallback} callback Node-style callback called with the error, if any, and DateFormatsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.dateFormats = function dateFormats(request, callback) {
                    return this.rpcCall(dateFormats, $root.priority.netitems.nrest.DateFormatsRq, $root.priority.netitems.nrest.DateFormatsRs, request, callback);
                }, "name", { value: "DateFormats" });

                /**
                 * Calls DateFormats.
                 * @function dateFormats
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IDateFormatsRq} request DateFormatsRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.DateFormatsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#reportColumns}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ReportColumnsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.ReportColumnsRs} [response] ReportColumnsRs
                 */

                /**
                 * Calls ReportColumns.
                 * @function reportColumns
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportColumnsRq} request ReportColumnsRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ReportColumnsCallback} callback Node-style callback called with the error, if any, and ReportColumnsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.reportColumns = function reportColumns(request, callback) {
                    return this.rpcCall(reportColumns, $root.priority.netitems.nrest.ReportColumnsRq, $root.priority.netitems.nrest.ReportColumnsRs, request, callback);
                }, "name", { value: "ReportColumns" });

                /**
                 * Calls ReportColumns.
                 * @function reportColumns
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportColumnsRq} request ReportColumnsRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.ReportColumnsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#reportCancel}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef ReportCancelCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.ReportCancelRs} [response] ReportCancelRs
                 */

                /**
                 * Calls ReportCancel.
                 * @function reportCancel
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportCancelRq} request ReportCancelRq message or plain object
                 * @param {priority.netitems.nrest.NRest.ReportCancelCallback} callback Node-style callback called with the error, if any, and ReportCancelRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.reportCancel = function reportCancel(request, callback) {
                    return this.rpcCall(reportCancel, $root.priority.netitems.nrest.ReportCancelRq, $root.priority.netitems.nrest.ReportCancelRs, request, callback);
                }, "name", { value: "ReportCancel" });

                /**
                 * Calls ReportCancel.
                 * @function reportCancel
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IReportCancelRq} request ReportCancelRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.ReportCancelRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#data}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef DataCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.DataRs} [response] DataRs
                 */

                /**
                 * Calls Data.
                 * @function data
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IDataRq} request DataRq message or plain object
                 * @param {priority.netitems.nrest.NRest.DataCallback} callback Node-style callback called with the error, if any, and DataRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.data = function data(request, callback) {
                    return this.rpcCall(data, $root.priority.netitems.nrest.DataRq, $root.priority.netitems.nrest.DataRs, request, callback);
                }, "name", { value: "Data" });

                /**
                 * Calls Data.
                 * @function data
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IDataRq} request DataRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.DataRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#numericFormats}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef NumericFormatsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.NumericFormatsRs} [response] NumericFormatsRs
                 */

                /**
                 * Calls NumericFormats.
                 * @function numericFormats
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.INumericFormatsRq} request NumericFormatsRq message or plain object
                 * @param {priority.netitems.nrest.NRest.NumericFormatsCallback} callback Node-style callback called with the error, if any, and NumericFormatsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.numericFormats = function numericFormats(request, callback) {
                    return this.rpcCall(numericFormats, $root.priority.netitems.nrest.NumericFormatsRq, $root.priority.netitems.nrest.NumericFormatsRs, request, callback);
                }, "name", { value: "NumericFormats" });

                /**
                 * Calls NumericFormats.
                 * @function numericFormats
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.INumericFormatsRq} request NumericFormatsRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.NumericFormatsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrest.NRest#formsTree}.
                 * @memberof priority.netitems.nrest.NRest
                 * @typedef FormsTreeCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrest.FormsTreeRs} [response] FormsTreeRs
                 */

                /**
                 * Calls FormsTree.
                 * @function formsTree
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IFormsTreeRq} request FormsTreeRq message or plain object
                 * @param {priority.netitems.nrest.NRest.FormsTreeCallback} callback Node-style callback called with the error, if any, and FormsTreeRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRest.prototype.formsTree = function formsTree(request, callback) {
                    return this.rpcCall(formsTree, $root.priority.netitems.nrest.FormsTreeRq, $root.priority.netitems.nrest.FormsTreeRs, request, callback);
                }, "name", { value: "FormsTree" });

                /**
                 * Calls FormsTree.
                 * @function formsTree
                 * @memberof priority.netitems.nrest.NRest
                 * @instance
                 * @param {priority.netitems.nrest.IFormsTreeRq} request FormsTreeRq message or plain object
                 * @returns {Promise<priority.netitems.nrest.FormsTreeRs>} Promise
                 * @variation 2
                 */

                return NRest;
            })();

            return nrest;
        })();

        netitems.ngen = (function() {

            /**
             * Namespace ngen.
             * @memberof priority.netitems
             * @namespace
             */
            var ngen = {};

            ngen.PackageByCategory = (function() {

                /**
                 * Properties of a PackageByCategory.
                 * @memberof priority.netitems.ngen
                 * @interface IPackageByCategory
                 * @property {string|null} [Category] PackageByCategory Category
                 * @property {Array.<priority.netitems.ngen.IPackage>|null} [Packages] PackageByCategory Packages
                 */

                /**
                 * Constructs a new PackageByCategory.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a PackageByCategory.
                 * @implements IPackageByCategory
                 * @constructor
                 * @param {priority.netitems.ngen.IPackageByCategory=} [properties] Properties to set
                 */
                function PackageByCategory(properties) {
                    this.Packages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PackageByCategory Category.
                 * @member {string} Category
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @instance
                 */
                PackageByCategory.prototype.Category = "";

                /**
                 * PackageByCategory Packages.
                 * @member {Array.<priority.netitems.ngen.IPackage>} Packages
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @instance
                 */
                PackageByCategory.prototype.Packages = $util.emptyArray;

                /**
                 * Creates a new PackageByCategory instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @static
                 * @param {priority.netitems.ngen.IPackageByCategory=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.PackageByCategory} PackageByCategory instance
                 */
                PackageByCategory.create = function create(properties) {
                    return new PackageByCategory(properties);
                };

                /**
                 * Encodes the specified PackageByCategory message. Does not implicitly {@link priority.netitems.ngen.PackageByCategory.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @static
                 * @param {priority.netitems.ngen.IPackageByCategory} message PackageByCategory message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageByCategory.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Category != null && Object.hasOwnProperty.call(message, "Category"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.Category);
                    if (message.Packages != null && message.Packages.length)
                        for (var i = 0; i < message.Packages.length; ++i)
                            $root.priority.netitems.ngen.Package.encode(message.Packages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PackageByCategory message, length delimited. Does not implicitly {@link priority.netitems.ngen.PackageByCategory.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @static
                 * @param {priority.netitems.ngen.IPackageByCategory} message PackageByCategory message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageByCategory.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PackageByCategory message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.PackageByCategory} PackageByCategory
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageByCategory.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.PackageByCategory();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Category = reader.string();
                            break;
                        case 2:
                            if (!(message.Packages && message.Packages.length))
                                message.Packages = [];
                            message.Packages.push($root.priority.netitems.ngen.Package.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PackageByCategory message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.PackageByCategory} PackageByCategory
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageByCategory.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PackageByCategory message.
                 * @function verify
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PackageByCategory.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Category != null && message.hasOwnProperty("Category"))
                        if (!$util.isString(message.Category))
                            return "Category: string expected";
                    if (message.Packages != null && message.hasOwnProperty("Packages")) {
                        if (!Array.isArray(message.Packages))
                            return "Packages: array expected";
                        for (var i = 0; i < message.Packages.length; ++i) {
                            var error = $root.priority.netitems.ngen.Package.verify(message.Packages[i]);
                            if (error)
                                return "Packages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PackageByCategory message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.PackageByCategory} PackageByCategory
                 */
                PackageByCategory.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.PackageByCategory)
                        return object;
                    var message = new $root.priority.netitems.ngen.PackageByCategory();
                    if (object.Category != null)
                        message.Category = String(object.Category);
                    if (object.Packages) {
                        if (!Array.isArray(object.Packages))
                            throw TypeError(".priority.netitems.ngen.PackageByCategory.Packages: array expected");
                        message.Packages = [];
                        for (var i = 0; i < object.Packages.length; ++i) {
                            if (typeof object.Packages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.PackageByCategory.Packages: object expected");
                            message.Packages[i] = $root.priority.netitems.ngen.Package.fromObject(object.Packages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PackageByCategory message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @static
                 * @param {priority.netitems.ngen.PackageByCategory} message PackageByCategory
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PackageByCategory.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Packages = [];
                    if (options.defaults)
                        object.Category = "";
                    if (message.Category != null && message.hasOwnProperty("Category"))
                        object.Category = message.Category;
                    if (message.Packages && message.Packages.length) {
                        object.Packages = [];
                        for (var j = 0; j < message.Packages.length; ++j)
                            object.Packages[j] = $root.priority.netitems.ngen.Package.toObject(message.Packages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PackageByCategory to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.PackageByCategory
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PackageByCategory.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PackageByCategory;
            })();

            ngen.Package = (function() {

                /**
                 * Properties of a Package.
                 * @memberof priority.netitems.ngen
                 * @interface IPackage
                 * @property {number|Long|null} [PackageId] Package PackageId
                 * @property {string|null} [Name] Package Name
                 * @property {boolean|null} [IsPackageVisible] Package IsPackageVisible
                 * @property {boolean|null} [HasLicense] Package HasLicense
                 * @property {string|null} [Description] Package Description
                 */

                /**
                 * Constructs a new Package.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a Package.
                 * @implements IPackage
                 * @constructor
                 * @param {priority.netitems.ngen.IPackage=} [properties] Properties to set
                 */
                function Package(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Package PackageId.
                 * @member {number|Long} PackageId
                 * @memberof priority.netitems.ngen.Package
                 * @instance
                 */
                Package.prototype.PackageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Package Name.
                 * @member {string} Name
                 * @memberof priority.netitems.ngen.Package
                 * @instance
                 */
                Package.prototype.Name = "";

                /**
                 * Package IsPackageVisible.
                 * @member {boolean} IsPackageVisible
                 * @memberof priority.netitems.ngen.Package
                 * @instance
                 */
                Package.prototype.IsPackageVisible = false;

                /**
                 * Package HasLicense.
                 * @member {boolean} HasLicense
                 * @memberof priority.netitems.ngen.Package
                 * @instance
                 */
                Package.prototype.HasLicense = false;

                /**
                 * Package Description.
                 * @member {string} Description
                 * @memberof priority.netitems.ngen.Package
                 * @instance
                 */
                Package.prototype.Description = "";

                /**
                 * Creates a new Package instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.Package
                 * @static
                 * @param {priority.netitems.ngen.IPackage=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.Package} Package instance
                 */
                Package.create = function create(properties) {
                    return new Package(properties);
                };

                /**
                 * Encodes the specified Package message. Does not implicitly {@link priority.netitems.ngen.Package.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.Package
                 * @static
                 * @param {priority.netitems.ngen.IPackage} message Package message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Package.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.PackageId != null && Object.hasOwnProperty.call(message, "PackageId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.PackageId);
                    if (message.Name != null && Object.hasOwnProperty.call(message, "Name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
                    if (message.IsPackageVisible != null && Object.hasOwnProperty.call(message, "IsPackageVisible"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsPackageVisible);
                    if (message.HasLicense != null && Object.hasOwnProperty.call(message, "HasLicense"))
                        writer.uint32(/* id 4, wireType 0 =*/32).bool(message.HasLicense);
                    if (message.Description != null && Object.hasOwnProperty.call(message, "Description"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.Description);
                    return writer;
                };

                /**
                 * Encodes the specified Package message, length delimited. Does not implicitly {@link priority.netitems.ngen.Package.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.Package
                 * @static
                 * @param {priority.netitems.ngen.IPackage} message Package message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Package.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Package message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.Package
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.Package} Package
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Package.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.Package();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.PackageId = reader.int64();
                            break;
                        case 2:
                            message.Name = reader.string();
                            break;
                        case 3:
                            message.IsPackageVisible = reader.bool();
                            break;
                        case 4:
                            message.HasLicense = reader.bool();
                            break;
                        case 5:
                            message.Description = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Package message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.Package
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.Package} Package
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Package.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Package message.
                 * @function verify
                 * @memberof priority.netitems.ngen.Package
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Package.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (!$util.isInteger(message.PackageId) && !(message.PackageId && $util.isInteger(message.PackageId.low) && $util.isInteger(message.PackageId.high)))
                            return "PackageId: integer|Long expected";
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        if (!$util.isString(message.Name))
                            return "Name: string expected";
                    if (message.IsPackageVisible != null && message.hasOwnProperty("IsPackageVisible"))
                        if (typeof message.IsPackageVisible !== "boolean")
                            return "IsPackageVisible: boolean expected";
                    if (message.HasLicense != null && message.hasOwnProperty("HasLicense"))
                        if (typeof message.HasLicense !== "boolean")
                            return "HasLicense: boolean expected";
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        if (!$util.isString(message.Description))
                            return "Description: string expected";
                    return null;
                };

                /**
                 * Creates a Package message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.Package
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.Package} Package
                 */
                Package.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.Package)
                        return object;
                    var message = new $root.priority.netitems.ngen.Package();
                    if (object.PackageId != null)
                        if ($util.Long)
                            (message.PackageId = $util.Long.fromValue(object.PackageId)).unsigned = false;
                        else if (typeof object.PackageId === "string")
                            message.PackageId = parseInt(object.PackageId, 10);
                        else if (typeof object.PackageId === "number")
                            message.PackageId = object.PackageId;
                        else if (typeof object.PackageId === "object")
                            message.PackageId = new $util.LongBits(object.PackageId.low >>> 0, object.PackageId.high >>> 0).toNumber();
                    if (object.Name != null)
                        message.Name = String(object.Name);
                    if (object.IsPackageVisible != null)
                        message.IsPackageVisible = Boolean(object.IsPackageVisible);
                    if (object.HasLicense != null)
                        message.HasLicense = Boolean(object.HasLicense);
                    if (object.Description != null)
                        message.Description = String(object.Description);
                    return message;
                };

                /**
                 * Creates a plain object from a Package message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.Package
                 * @static
                 * @param {priority.netitems.ngen.Package} message Package
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Package.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.PackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.PackageId = options.longs === String ? "0" : 0;
                        object.Name = "";
                        object.IsPackageVisible = false;
                        object.HasLicense = false;
                        object.Description = "";
                    }
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (typeof message.PackageId === "number")
                            object.PackageId = options.longs === String ? String(message.PackageId) : message.PackageId;
                        else
                            object.PackageId = options.longs === String ? $util.Long.prototype.toString.call(message.PackageId) : options.longs === Number ? new $util.LongBits(message.PackageId.low >>> 0, message.PackageId.high >>> 0).toNumber() : message.PackageId;
                    if (message.Name != null && message.hasOwnProperty("Name"))
                        object.Name = message.Name;
                    if (message.IsPackageVisible != null && message.hasOwnProperty("IsPackageVisible"))
                        object.IsPackageVisible = message.IsPackageVisible;
                    if (message.HasLicense != null && message.hasOwnProperty("HasLicense"))
                        object.HasLicense = message.HasLicense;
                    if (message.Description != null && message.hasOwnProperty("Description"))
                        object.Description = message.Description;
                    return object;
                };

                /**
                 * Converts this Package to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.Package
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Package.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Package;
            })();

            ngen.WhoAmIRq = (function() {

                /**
                 * Properties of a WhoAmIRq.
                 * @memberof priority.netitems.ngen
                 * @interface IWhoAmIRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] WhoAmIRq Properties
                 */

                /**
                 * Constructs a new WhoAmIRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a WhoAmIRq.
                 * @implements IWhoAmIRq
                 * @constructor
                 * @param {priority.netitems.ngen.IWhoAmIRq=} [properties] Properties to set
                 */
                function WhoAmIRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * WhoAmIRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @instance
                 */
                WhoAmIRq.prototype.Properties = null;

                /**
                 * Creates a new WhoAmIRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @static
                 * @param {priority.netitems.ngen.IWhoAmIRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.WhoAmIRq} WhoAmIRq instance
                 */
                WhoAmIRq.create = function create(properties) {
                    return new WhoAmIRq(properties);
                };

                /**
                 * Encodes the specified WhoAmIRq message. Does not implicitly {@link priority.netitems.ngen.WhoAmIRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @static
                 * @param {priority.netitems.ngen.IWhoAmIRq} message WhoAmIRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WhoAmIRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified WhoAmIRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.WhoAmIRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @static
                 * @param {priority.netitems.ngen.IWhoAmIRq} message WhoAmIRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WhoAmIRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a WhoAmIRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.WhoAmIRq} WhoAmIRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WhoAmIRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.WhoAmIRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a WhoAmIRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.WhoAmIRq} WhoAmIRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WhoAmIRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a WhoAmIRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                WhoAmIRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a WhoAmIRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.WhoAmIRq} WhoAmIRq
                 */
                WhoAmIRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.WhoAmIRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.WhoAmIRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.WhoAmIRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a WhoAmIRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @static
                 * @param {priority.netitems.ngen.WhoAmIRq} message WhoAmIRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                WhoAmIRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this WhoAmIRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.WhoAmIRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                WhoAmIRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return WhoAmIRq;
            })();

            ngen.WhoAmIRs = (function() {

                /**
                 * Properties of a WhoAmIRs.
                 * @memberof priority.netitems.ngen
                 * @interface IWhoAmIRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] WhoAmIRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] WhoAmIRs Messages
                 * @property {string|null} [UserLogin] WhoAmIRs UserLogin
                 */

                /**
                 * Constructs a new WhoAmIRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a WhoAmIRs.
                 * @implements IWhoAmIRs
                 * @constructor
                 * @param {priority.netitems.ngen.IWhoAmIRs=} [properties] Properties to set
                 */
                function WhoAmIRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * WhoAmIRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @instance
                 */
                WhoAmIRs.prototype.Perf = null;

                /**
                 * WhoAmIRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @instance
                 */
                WhoAmIRs.prototype.Messages = $util.emptyArray;

                /**
                 * WhoAmIRs UserLogin.
                 * @member {string} UserLogin
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @instance
                 */
                WhoAmIRs.prototype.UserLogin = "";

                /**
                 * Creates a new WhoAmIRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @static
                 * @param {priority.netitems.ngen.IWhoAmIRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.WhoAmIRs} WhoAmIRs instance
                 */
                WhoAmIRs.create = function create(properties) {
                    return new WhoAmIRs(properties);
                };

                /**
                 * Encodes the specified WhoAmIRs message. Does not implicitly {@link priority.netitems.ngen.WhoAmIRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @static
                 * @param {priority.netitems.ngen.IWhoAmIRs} message WhoAmIRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WhoAmIRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.UserLogin != null && Object.hasOwnProperty.call(message, "UserLogin"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.UserLogin);
                    return writer;
                };

                /**
                 * Encodes the specified WhoAmIRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.WhoAmIRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @static
                 * @param {priority.netitems.ngen.IWhoAmIRs} message WhoAmIRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WhoAmIRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a WhoAmIRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.WhoAmIRs} WhoAmIRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WhoAmIRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.WhoAmIRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.UserLogin = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a WhoAmIRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.WhoAmIRs} WhoAmIRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WhoAmIRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a WhoAmIRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                WhoAmIRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.UserLogin != null && message.hasOwnProperty("UserLogin"))
                        if (!$util.isString(message.UserLogin))
                            return "UserLogin: string expected";
                    return null;
                };

                /**
                 * Creates a WhoAmIRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.WhoAmIRs} WhoAmIRs
                 */
                WhoAmIRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.WhoAmIRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.WhoAmIRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.WhoAmIRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.WhoAmIRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.WhoAmIRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.UserLogin != null)
                        message.UserLogin = String(object.UserLogin);
                    return message;
                };

                /**
                 * Creates a plain object from a WhoAmIRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @static
                 * @param {priority.netitems.ngen.WhoAmIRs} message WhoAmIRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                WhoAmIRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.UserLogin = "";
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.UserLogin != null && message.hasOwnProperty("UserLogin"))
                        object.UserLogin = message.UserLogin;
                    return object;
                };

                /**
                 * Converts this WhoAmIRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.WhoAmIRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                WhoAmIRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return WhoAmIRs;
            })();

            ngen.CheckModuleRq = (function() {

                /**
                 * Properties of a CheckModuleRq.
                 * @memberof priority.netitems.ngen
                 * @interface ICheckModuleRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] CheckModuleRq Properties
                 * @property {number|Long|null} [Module] CheckModuleRq Module
                 */

                /**
                 * Constructs a new CheckModuleRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a CheckModuleRq.
                 * @implements ICheckModuleRq
                 * @constructor
                 * @param {priority.netitems.ngen.ICheckModuleRq=} [properties] Properties to set
                 */
                function CheckModuleRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CheckModuleRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @instance
                 */
                CheckModuleRq.prototype.Properties = null;

                /**
                 * CheckModuleRq Module.
                 * @member {number|Long} Module
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @instance
                 */
                CheckModuleRq.prototype.Module = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new CheckModuleRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @static
                 * @param {priority.netitems.ngen.ICheckModuleRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.CheckModuleRq} CheckModuleRq instance
                 */
                CheckModuleRq.create = function create(properties) {
                    return new CheckModuleRq(properties);
                };

                /**
                 * Encodes the specified CheckModuleRq message. Does not implicitly {@link priority.netitems.ngen.CheckModuleRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @static
                 * @param {priority.netitems.ngen.ICheckModuleRq} message CheckModuleRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CheckModuleRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Module != null && Object.hasOwnProperty.call(message, "Module"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.Module);
                    return writer;
                };

                /**
                 * Encodes the specified CheckModuleRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.CheckModuleRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @static
                 * @param {priority.netitems.ngen.ICheckModuleRq} message CheckModuleRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CheckModuleRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CheckModuleRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.CheckModuleRq} CheckModuleRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CheckModuleRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.CheckModuleRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Module = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CheckModuleRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.CheckModuleRq} CheckModuleRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CheckModuleRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CheckModuleRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CheckModuleRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Module != null && message.hasOwnProperty("Module"))
                        if (!$util.isInteger(message.Module) && !(message.Module && $util.isInteger(message.Module.low) && $util.isInteger(message.Module.high)))
                            return "Module: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a CheckModuleRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.CheckModuleRq} CheckModuleRq
                 */
                CheckModuleRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.CheckModuleRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.CheckModuleRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.CheckModuleRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Module != null)
                        if ($util.Long)
                            (message.Module = $util.Long.fromValue(object.Module)).unsigned = false;
                        else if (typeof object.Module === "string")
                            message.Module = parseInt(object.Module, 10);
                        else if (typeof object.Module === "number")
                            message.Module = object.Module;
                        else if (typeof object.Module === "object")
                            message.Module = new $util.LongBits(object.Module.low >>> 0, object.Module.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a CheckModuleRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @static
                 * @param {priority.netitems.ngen.CheckModuleRq} message CheckModuleRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CheckModuleRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.Module = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.Module = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Module != null && message.hasOwnProperty("Module"))
                        if (typeof message.Module === "number")
                            object.Module = options.longs === String ? String(message.Module) : message.Module;
                        else
                            object.Module = options.longs === String ? $util.Long.prototype.toString.call(message.Module) : options.longs === Number ? new $util.LongBits(message.Module.low >>> 0, message.Module.high >>> 0).toNumber() : message.Module;
                    return object;
                };

                /**
                 * Converts this CheckModuleRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.CheckModuleRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CheckModuleRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CheckModuleRq;
            })();

            ngen.CheckModuleRs = (function() {

                /**
                 * Properties of a CheckModuleRs.
                 * @memberof priority.netitems.ngen
                 * @interface ICheckModuleRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] CheckModuleRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] CheckModuleRs Messages
                 * @property {boolean|null} [HasModule] CheckModuleRs HasModule
                 */

                /**
                 * Constructs a new CheckModuleRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a CheckModuleRs.
                 * @implements ICheckModuleRs
                 * @constructor
                 * @param {priority.netitems.ngen.ICheckModuleRs=} [properties] Properties to set
                 */
                function CheckModuleRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CheckModuleRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @instance
                 */
                CheckModuleRs.prototype.Perf = null;

                /**
                 * CheckModuleRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @instance
                 */
                CheckModuleRs.prototype.Messages = $util.emptyArray;

                /**
                 * CheckModuleRs HasModule.
                 * @member {boolean} HasModule
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @instance
                 */
                CheckModuleRs.prototype.HasModule = false;

                /**
                 * Creates a new CheckModuleRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @static
                 * @param {priority.netitems.ngen.ICheckModuleRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.CheckModuleRs} CheckModuleRs instance
                 */
                CheckModuleRs.create = function create(properties) {
                    return new CheckModuleRs(properties);
                };

                /**
                 * Encodes the specified CheckModuleRs message. Does not implicitly {@link priority.netitems.ngen.CheckModuleRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @static
                 * @param {priority.netitems.ngen.ICheckModuleRs} message CheckModuleRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CheckModuleRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.HasModule != null && Object.hasOwnProperty.call(message, "HasModule"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.HasModule);
                    return writer;
                };

                /**
                 * Encodes the specified CheckModuleRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.CheckModuleRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @static
                 * @param {priority.netitems.ngen.ICheckModuleRs} message CheckModuleRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CheckModuleRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CheckModuleRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.CheckModuleRs} CheckModuleRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CheckModuleRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.CheckModuleRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.HasModule = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CheckModuleRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.CheckModuleRs} CheckModuleRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CheckModuleRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CheckModuleRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CheckModuleRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.HasModule != null && message.hasOwnProperty("HasModule"))
                        if (typeof message.HasModule !== "boolean")
                            return "HasModule: boolean expected";
                    return null;
                };

                /**
                 * Creates a CheckModuleRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.CheckModuleRs} CheckModuleRs
                 */
                CheckModuleRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.CheckModuleRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.CheckModuleRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.CheckModuleRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.CheckModuleRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.CheckModuleRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.HasModule != null)
                        message.HasModule = Boolean(object.HasModule);
                    return message;
                };

                /**
                 * Creates a plain object from a CheckModuleRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @static
                 * @param {priority.netitems.ngen.CheckModuleRs} message CheckModuleRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CheckModuleRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.HasModule = false;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.HasModule != null && message.hasOwnProperty("HasModule"))
                        object.HasModule = message.HasModule;
                    return object;
                };

                /**
                 * Converts this CheckModuleRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.CheckModuleRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CheckModuleRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CheckModuleRs;
            })();

            ngen.CheckModulesRq = (function() {

                /**
                 * Properties of a CheckModulesRq.
                 * @memberof priority.netitems.ngen
                 * @interface ICheckModulesRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] CheckModulesRq Properties
                 * @property {Array.<number|Long>|null} [Modules] CheckModulesRq Modules
                 */

                /**
                 * Constructs a new CheckModulesRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a CheckModulesRq.
                 * @implements ICheckModulesRq
                 * @constructor
                 * @param {priority.netitems.ngen.ICheckModulesRq=} [properties] Properties to set
                 */
                function CheckModulesRq(properties) {
                    this.Modules = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CheckModulesRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @instance
                 */
                CheckModulesRq.prototype.Properties = null;

                /**
                 * CheckModulesRq Modules.
                 * @member {Array.<number|Long>} Modules
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @instance
                 */
                CheckModulesRq.prototype.Modules = $util.emptyArray;

                /**
                 * Creates a new CheckModulesRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @static
                 * @param {priority.netitems.ngen.ICheckModulesRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.CheckModulesRq} CheckModulesRq instance
                 */
                CheckModulesRq.create = function create(properties) {
                    return new CheckModulesRq(properties);
                };

                /**
                 * Encodes the specified CheckModulesRq message. Does not implicitly {@link priority.netitems.ngen.CheckModulesRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @static
                 * @param {priority.netitems.ngen.ICheckModulesRq} message CheckModulesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CheckModulesRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Modules != null && message.Modules.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.Modules.length; ++i)
                            writer.int64(message.Modules[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified CheckModulesRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.CheckModulesRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @static
                 * @param {priority.netitems.ngen.ICheckModulesRq} message CheckModulesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CheckModulesRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CheckModulesRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.CheckModulesRq} CheckModulesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CheckModulesRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.CheckModulesRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Modules && message.Modules.length))
                                message.Modules = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.Modules.push(reader.int64());
                            } else
                                message.Modules.push(reader.int64());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CheckModulesRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.CheckModulesRq} CheckModulesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CheckModulesRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CheckModulesRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CheckModulesRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Modules != null && message.hasOwnProperty("Modules")) {
                        if (!Array.isArray(message.Modules))
                            return "Modules: array expected";
                        for (var i = 0; i < message.Modules.length; ++i)
                            if (!$util.isInteger(message.Modules[i]) && !(message.Modules[i] && $util.isInteger(message.Modules[i].low) && $util.isInteger(message.Modules[i].high)))
                                return "Modules: integer|Long[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a CheckModulesRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.CheckModulesRq} CheckModulesRq
                 */
                CheckModulesRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.CheckModulesRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.CheckModulesRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.CheckModulesRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Modules) {
                        if (!Array.isArray(object.Modules))
                            throw TypeError(".priority.netitems.ngen.CheckModulesRq.Modules: array expected");
                        message.Modules = [];
                        for (var i = 0; i < object.Modules.length; ++i)
                            if ($util.Long)
                                (message.Modules[i] = $util.Long.fromValue(object.Modules[i])).unsigned = false;
                            else if (typeof object.Modules[i] === "string")
                                message.Modules[i] = parseInt(object.Modules[i], 10);
                            else if (typeof object.Modules[i] === "number")
                                message.Modules[i] = object.Modules[i];
                            else if (typeof object.Modules[i] === "object")
                                message.Modules[i] = new $util.LongBits(object.Modules[i].low >>> 0, object.Modules[i].high >>> 0).toNumber();
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CheckModulesRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @static
                 * @param {priority.netitems.ngen.CheckModulesRq} message CheckModulesRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CheckModulesRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Modules = [];
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Modules && message.Modules.length) {
                        object.Modules = [];
                        for (var j = 0; j < message.Modules.length; ++j)
                            if (typeof message.Modules[j] === "number")
                                object.Modules[j] = options.longs === String ? String(message.Modules[j]) : message.Modules[j];
                            else
                                object.Modules[j] = options.longs === String ? $util.Long.prototype.toString.call(message.Modules[j]) : options.longs === Number ? new $util.LongBits(message.Modules[j].low >>> 0, message.Modules[j].high >>> 0).toNumber() : message.Modules[j];
                    }
                    return object;
                };

                /**
                 * Converts this CheckModulesRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.CheckModulesRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CheckModulesRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CheckModulesRq;
            })();

            ngen.CheckModulesRs = (function() {

                /**
                 * Properties of a CheckModulesRs.
                 * @memberof priority.netitems.ngen
                 * @interface ICheckModulesRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] CheckModulesRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] CheckModulesRs Messages
                 * @property {Array.<boolean>|null} [HasModules] CheckModulesRs HasModules
                 */

                /**
                 * Constructs a new CheckModulesRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a CheckModulesRs.
                 * @implements ICheckModulesRs
                 * @constructor
                 * @param {priority.netitems.ngen.ICheckModulesRs=} [properties] Properties to set
                 */
                function CheckModulesRs(properties) {
                    this.Messages = [];
                    this.HasModules = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * CheckModulesRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @instance
                 */
                CheckModulesRs.prototype.Perf = null;

                /**
                 * CheckModulesRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @instance
                 */
                CheckModulesRs.prototype.Messages = $util.emptyArray;

                /**
                 * CheckModulesRs HasModules.
                 * @member {Array.<boolean>} HasModules
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @instance
                 */
                CheckModulesRs.prototype.HasModules = $util.emptyArray;

                /**
                 * Creates a new CheckModulesRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @static
                 * @param {priority.netitems.ngen.ICheckModulesRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.CheckModulesRs} CheckModulesRs instance
                 */
                CheckModulesRs.create = function create(properties) {
                    return new CheckModulesRs(properties);
                };

                /**
                 * Encodes the specified CheckModulesRs message. Does not implicitly {@link priority.netitems.ngen.CheckModulesRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @static
                 * @param {priority.netitems.ngen.ICheckModulesRs} message CheckModulesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CheckModulesRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.HasModules != null && message.HasModules.length) {
                        writer.uint32(/* id 3, wireType 2 =*/26).fork();
                        for (var i = 0; i < message.HasModules.length; ++i)
                            writer.bool(message.HasModules[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified CheckModulesRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.CheckModulesRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @static
                 * @param {priority.netitems.ngen.ICheckModulesRs} message CheckModulesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CheckModulesRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a CheckModulesRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.CheckModulesRs} CheckModulesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CheckModulesRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.CheckModulesRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.HasModules && message.HasModules.length))
                                message.HasModules = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.HasModules.push(reader.bool());
                            } else
                                message.HasModules.push(reader.bool());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a CheckModulesRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.CheckModulesRs} CheckModulesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CheckModulesRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a CheckModulesRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CheckModulesRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.HasModules != null && message.hasOwnProperty("HasModules")) {
                        if (!Array.isArray(message.HasModules))
                            return "HasModules: array expected";
                        for (var i = 0; i < message.HasModules.length; ++i)
                            if (typeof message.HasModules[i] !== "boolean")
                                return "HasModules: boolean[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a CheckModulesRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.CheckModulesRs} CheckModulesRs
                 */
                CheckModulesRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.CheckModulesRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.CheckModulesRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.CheckModulesRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.CheckModulesRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.CheckModulesRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.HasModules) {
                        if (!Array.isArray(object.HasModules))
                            throw TypeError(".priority.netitems.ngen.CheckModulesRs.HasModules: array expected");
                        message.HasModules = [];
                        for (var i = 0; i < object.HasModules.length; ++i)
                            message.HasModules[i] = Boolean(object.HasModules[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a CheckModulesRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @static
                 * @param {priority.netitems.ngen.CheckModulesRs} message CheckModulesRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CheckModulesRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.HasModules = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.HasModules && message.HasModules.length) {
                        object.HasModules = [];
                        for (var j = 0; j < message.HasModules.length; ++j)
                            object.HasModules[j] = message.HasModules[j];
                    }
                    return object;
                };

                /**
                 * Converts this CheckModulesRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.CheckModulesRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CheckModulesRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return CheckModulesRs;
            })();

            ngen.UserSpecialPrivsRq = (function() {

                /**
                 * Properties of a UserSpecialPrivsRq.
                 * @memberof priority.netitems.ngen
                 * @interface IUserSpecialPrivsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] UserSpecialPrivsRq Properties
                 */

                /**
                 * Constructs a new UserSpecialPrivsRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a UserSpecialPrivsRq.
                 * @implements IUserSpecialPrivsRq
                 * @constructor
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRq=} [properties] Properties to set
                 */
                function UserSpecialPrivsRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UserSpecialPrivsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @instance
                 */
                UserSpecialPrivsRq.prototype.Properties = null;

                /**
                 * Creates a new UserSpecialPrivsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @static
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.UserSpecialPrivsRq} UserSpecialPrivsRq instance
                 */
                UserSpecialPrivsRq.create = function create(properties) {
                    return new UserSpecialPrivsRq(properties);
                };

                /**
                 * Encodes the specified UserSpecialPrivsRq message. Does not implicitly {@link priority.netitems.ngen.UserSpecialPrivsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @static
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRq} message UserSpecialPrivsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UserSpecialPrivsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UserSpecialPrivsRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.UserSpecialPrivsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @static
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRq} message UserSpecialPrivsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UserSpecialPrivsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a UserSpecialPrivsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.UserSpecialPrivsRq} UserSpecialPrivsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UserSpecialPrivsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.UserSpecialPrivsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a UserSpecialPrivsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.UserSpecialPrivsRq} UserSpecialPrivsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UserSpecialPrivsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a UserSpecialPrivsRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UserSpecialPrivsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a UserSpecialPrivsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.UserSpecialPrivsRq} UserSpecialPrivsRq
                 */
                UserSpecialPrivsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.UserSpecialPrivsRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.UserSpecialPrivsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.UserSpecialPrivsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a UserSpecialPrivsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @static
                 * @param {priority.netitems.ngen.UserSpecialPrivsRq} message UserSpecialPrivsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UserSpecialPrivsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this UserSpecialPrivsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UserSpecialPrivsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UserSpecialPrivsRq;
            })();

            ngen.UserSpecialPrivsRs = (function() {

                /**
                 * Properties of a UserSpecialPrivsRs.
                 * @memberof priority.netitems.ngen
                 * @interface IUserSpecialPrivsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] UserSpecialPrivsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] UserSpecialPrivsRs Messages
                 * @property {Object.<string,boolean>|null} [Priviliges] UserSpecialPrivsRs Priviliges
                 */

                /**
                 * Constructs a new UserSpecialPrivsRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a UserSpecialPrivsRs.
                 * @implements IUserSpecialPrivsRs
                 * @constructor
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRs=} [properties] Properties to set
                 */
                function UserSpecialPrivsRs(properties) {
                    this.Messages = [];
                    this.Priviliges = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UserSpecialPrivsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @instance
                 */
                UserSpecialPrivsRs.prototype.Perf = null;

                /**
                 * UserSpecialPrivsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @instance
                 */
                UserSpecialPrivsRs.prototype.Messages = $util.emptyArray;

                /**
                 * UserSpecialPrivsRs Priviliges.
                 * @member {Object.<string,boolean>} Priviliges
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @instance
                 */
                UserSpecialPrivsRs.prototype.Priviliges = $util.emptyObject;

                /**
                 * Creates a new UserSpecialPrivsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @static
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.UserSpecialPrivsRs} UserSpecialPrivsRs instance
                 */
                UserSpecialPrivsRs.create = function create(properties) {
                    return new UserSpecialPrivsRs(properties);
                };

                /**
                 * Encodes the specified UserSpecialPrivsRs message. Does not implicitly {@link priority.netitems.ngen.UserSpecialPrivsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @static
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRs} message UserSpecialPrivsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UserSpecialPrivsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Priviliges != null && Object.hasOwnProperty.call(message, "Priviliges"))
                        for (var keys = Object.keys(message.Priviliges), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).bool(message.Priviliges[keys[i]]).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UserSpecialPrivsRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.UserSpecialPrivsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @static
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRs} message UserSpecialPrivsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UserSpecialPrivsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a UserSpecialPrivsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.UserSpecialPrivsRs} UserSpecialPrivsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UserSpecialPrivsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.UserSpecialPrivsRs(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (message.Priviliges === $util.emptyObject)
                                message.Priviliges = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = "";
                            value = false;
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.string();
                                    break;
                                case 2:
                                    value = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.Priviliges[key] = value;
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a UserSpecialPrivsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.UserSpecialPrivsRs} UserSpecialPrivsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UserSpecialPrivsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a UserSpecialPrivsRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UserSpecialPrivsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Priviliges != null && message.hasOwnProperty("Priviliges")) {
                        if (!$util.isObject(message.Priviliges))
                            return "Priviliges: object expected";
                        var key = Object.keys(message.Priviliges);
                        for (var i = 0; i < key.length; ++i)
                            if (typeof message.Priviliges[key[i]] !== "boolean")
                                return "Priviliges: boolean{k:string} expected";
                    }
                    return null;
                };

                /**
                 * Creates a UserSpecialPrivsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.UserSpecialPrivsRs} UserSpecialPrivsRs
                 */
                UserSpecialPrivsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.UserSpecialPrivsRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.UserSpecialPrivsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.UserSpecialPrivsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.UserSpecialPrivsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.UserSpecialPrivsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Priviliges) {
                        if (typeof object.Priviliges !== "object")
                            throw TypeError(".priority.netitems.ngen.UserSpecialPrivsRs.Priviliges: object expected");
                        message.Priviliges = {};
                        for (var keys = Object.keys(object.Priviliges), i = 0; i < keys.length; ++i)
                            message.Priviliges[keys[i]] = Boolean(object.Priviliges[keys[i]]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a UserSpecialPrivsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @static
                 * @param {priority.netitems.ngen.UserSpecialPrivsRs} message UserSpecialPrivsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UserSpecialPrivsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.objects || options.defaults)
                        object.Priviliges = {};
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    var keys2;
                    if (message.Priviliges && (keys2 = Object.keys(message.Priviliges)).length) {
                        object.Priviliges = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.Priviliges[keys2[j]] = message.Priviliges[keys2[j]];
                    }
                    return object;
                };

                /**
                 * Converts this UserSpecialPrivsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.UserSpecialPrivsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UserSpecialPrivsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UserSpecialPrivsRs;
            })();

            /**
             * LinkType enum.
             * @name priority.netitems.ngen.LinkType
             * @enum {number}
             * @property {number} NONE=0 NONE value
             * @property {number} MODE_MG=1 MODE_MG value
             * @property {number} MODE_H5=2 MODE_H5 value
             * @property {number} MODE_API=3 MODE_API value
             */
            ngen.LinkType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "NONE"] = 0;
                values[valuesById[1] = "MODE_MG"] = 1;
                values[valuesById[2] = "MODE_H5"] = 2;
                values[valuesById[3] = "MODE_API"] = 3;
                return values;
            })();

            ngen.LinkRq = (function() {

                /**
                 * Properties of a LinkRq.
                 * @memberof priority.netitems.ngen
                 * @interface ILinkRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] LinkRq Properties
                 * @property {Array.<priority.netitems.ngen.LinkType>|null} [LinkTypes] LinkRq LinkTypes
                 */

                /**
                 * Constructs a new LinkRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a LinkRq.
                 * @implements ILinkRq
                 * @constructor
                 * @param {priority.netitems.ngen.ILinkRq=} [properties] Properties to set
                 */
                function LinkRq(properties) {
                    this.LinkTypes = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LinkRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.LinkRq
                 * @instance
                 */
                LinkRq.prototype.Properties = null;

                /**
                 * LinkRq LinkTypes.
                 * @member {Array.<priority.netitems.ngen.LinkType>} LinkTypes
                 * @memberof priority.netitems.ngen.LinkRq
                 * @instance
                 */
                LinkRq.prototype.LinkTypes = $util.emptyArray;

                /**
                 * Creates a new LinkRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.LinkRq
                 * @static
                 * @param {priority.netitems.ngen.ILinkRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.LinkRq} LinkRq instance
                 */
                LinkRq.create = function create(properties) {
                    return new LinkRq(properties);
                };

                /**
                 * Encodes the specified LinkRq message. Does not implicitly {@link priority.netitems.ngen.LinkRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.LinkRq
                 * @static
                 * @param {priority.netitems.ngen.ILinkRq} message LinkRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinkRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.LinkTypes != null && message.LinkTypes.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.LinkTypes.length; ++i)
                            writer.int32(message.LinkTypes[i]);
                        writer.ldelim();
                    }
                    return writer;
                };

                /**
                 * Encodes the specified LinkRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.LinkRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.LinkRq
                 * @static
                 * @param {priority.netitems.ngen.ILinkRq} message LinkRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinkRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LinkRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.LinkRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.LinkRq} LinkRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinkRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.LinkRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.LinkTypes && message.LinkTypes.length))
                                message.LinkTypes = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.LinkTypes.push(reader.int32());
                            } else
                                message.LinkTypes.push(reader.int32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LinkRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.LinkRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.LinkRq} LinkRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinkRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LinkRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.LinkRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LinkRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.LinkTypes != null && message.hasOwnProperty("LinkTypes")) {
                        if (!Array.isArray(message.LinkTypes))
                            return "LinkTypes: array expected";
                        for (var i = 0; i < message.LinkTypes.length; ++i)
                            switch (message.LinkTypes[i]) {
                            default:
                                return "LinkTypes: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                    }
                    return null;
                };

                /**
                 * Creates a LinkRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.LinkRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.LinkRq} LinkRq
                 */
                LinkRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.LinkRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.LinkRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.LinkRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.LinkTypes) {
                        if (!Array.isArray(object.LinkTypes))
                            throw TypeError(".priority.netitems.ngen.LinkRq.LinkTypes: array expected");
                        message.LinkTypes = [];
                        for (var i = 0; i < object.LinkTypes.length; ++i)
                            switch (object.LinkTypes[i]) {
                            default:
                            case "NONE":
                            case 0:
                                message.LinkTypes[i] = 0;
                                break;
                            case "MODE_MG":
                            case 1:
                                message.LinkTypes[i] = 1;
                                break;
                            case "MODE_H5":
                            case 2:
                                message.LinkTypes[i] = 2;
                                break;
                            case "MODE_API":
                            case 3:
                                message.LinkTypes[i] = 3;
                                break;
                            }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LinkRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.LinkRq
                 * @static
                 * @param {priority.netitems.ngen.LinkRq} message LinkRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LinkRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.LinkTypes = [];
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.LinkTypes && message.LinkTypes.length) {
                        object.LinkTypes = [];
                        for (var j = 0; j < message.LinkTypes.length; ++j)
                            object.LinkTypes[j] = options.enums === String ? $root.priority.netitems.ngen.LinkType[message.LinkTypes[j]] : message.LinkTypes[j];
                    }
                    return object;
                };

                /**
                 * Converts this LinkRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.LinkRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LinkRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return LinkRq;
            })();

            ngen.LinkRs = (function() {

                /**
                 * Properties of a LinkRs.
                 * @memberof priority.netitems.ngen
                 * @interface ILinkRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] LinkRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] LinkRs Messages
                 * @property {Array.<string>|null} [Links] LinkRs Links
                 */

                /**
                 * Constructs a new LinkRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a LinkRs.
                 * @implements ILinkRs
                 * @constructor
                 * @param {priority.netitems.ngen.ILinkRs=} [properties] Properties to set
                 */
                function LinkRs(properties) {
                    this.Messages = [];
                    this.Links = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * LinkRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.LinkRs
                 * @instance
                 */
                LinkRs.prototype.Perf = null;

                /**
                 * LinkRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.LinkRs
                 * @instance
                 */
                LinkRs.prototype.Messages = $util.emptyArray;

                /**
                 * LinkRs Links.
                 * @member {Array.<string>} Links
                 * @memberof priority.netitems.ngen.LinkRs
                 * @instance
                 */
                LinkRs.prototype.Links = $util.emptyArray;

                /**
                 * Creates a new LinkRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.LinkRs
                 * @static
                 * @param {priority.netitems.ngen.ILinkRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.LinkRs} LinkRs instance
                 */
                LinkRs.create = function create(properties) {
                    return new LinkRs(properties);
                };

                /**
                 * Encodes the specified LinkRs message. Does not implicitly {@link priority.netitems.ngen.LinkRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.LinkRs
                 * @static
                 * @param {priority.netitems.ngen.ILinkRs} message LinkRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinkRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Links != null && message.Links.length)
                        for (var i = 0; i < message.Links.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Links[i]);
                    return writer;
                };

                /**
                 * Encodes the specified LinkRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.LinkRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.LinkRs
                 * @static
                 * @param {priority.netitems.ngen.ILinkRs} message LinkRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LinkRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a LinkRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.LinkRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.LinkRs} LinkRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinkRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.LinkRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.Links && message.Links.length))
                                message.Links = [];
                            message.Links.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a LinkRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.LinkRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.LinkRs} LinkRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LinkRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a LinkRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.LinkRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LinkRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Links != null && message.hasOwnProperty("Links")) {
                        if (!Array.isArray(message.Links))
                            return "Links: array expected";
                        for (var i = 0; i < message.Links.length; ++i)
                            if (!$util.isString(message.Links[i]))
                                return "Links: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a LinkRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.LinkRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.LinkRs} LinkRs
                 */
                LinkRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.LinkRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.LinkRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.LinkRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.LinkRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.LinkRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Links) {
                        if (!Array.isArray(object.Links))
                            throw TypeError(".priority.netitems.ngen.LinkRs.Links: array expected");
                        message.Links = [];
                        for (var i = 0; i < object.Links.length; ++i)
                            message.Links[i] = String(object.Links[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a LinkRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.LinkRs
                 * @static
                 * @param {priority.netitems.ngen.LinkRs} message LinkRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LinkRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.Links = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Links && message.Links.length) {
                        object.Links = [];
                        for (var j = 0; j < message.Links.length; ++j)
                            object.Links[j] = message.Links[j];
                    }
                    return object;
                };

                /**
                 * Converts this LinkRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.LinkRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LinkRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return LinkRs;
            })();

            ngen.SystemPackagesRq = (function() {

                /**
                 * Properties of a SystemPackagesRq.
                 * @memberof priority.netitems.ngen
                 * @interface ISystemPackagesRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] SystemPackagesRq Properties
                 */

                /**
                 * Constructs a new SystemPackagesRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a SystemPackagesRq.
                 * @implements ISystemPackagesRq
                 * @constructor
                 * @param {priority.netitems.ngen.ISystemPackagesRq=} [properties] Properties to set
                 */
                function SystemPackagesRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemPackagesRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @instance
                 */
                SystemPackagesRq.prototype.Properties = null;

                /**
                 * Creates a new SystemPackagesRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @static
                 * @param {priority.netitems.ngen.ISystemPackagesRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.SystemPackagesRq} SystemPackagesRq instance
                 */
                SystemPackagesRq.create = function create(properties) {
                    return new SystemPackagesRq(properties);
                };

                /**
                 * Encodes the specified SystemPackagesRq message. Does not implicitly {@link priority.netitems.ngen.SystemPackagesRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @static
                 * @param {priority.netitems.ngen.ISystemPackagesRq} message SystemPackagesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemPackagesRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SystemPackagesRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.SystemPackagesRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @static
                 * @param {priority.netitems.ngen.ISystemPackagesRq} message SystemPackagesRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemPackagesRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemPackagesRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.SystemPackagesRq} SystemPackagesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemPackagesRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.SystemPackagesRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemPackagesRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.SystemPackagesRq} SystemPackagesRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemPackagesRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemPackagesRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemPackagesRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    return null;
                };

                /**
                 * Creates a SystemPackagesRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.SystemPackagesRq} SystemPackagesRq
                 */
                SystemPackagesRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.SystemPackagesRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.SystemPackagesRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.SystemPackagesRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemPackagesRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @static
                 * @param {priority.netitems.ngen.SystemPackagesRq} message SystemPackagesRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemPackagesRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    return object;
                };

                /**
                 * Converts this SystemPackagesRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.SystemPackagesRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemPackagesRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SystemPackagesRq;
            })();

            ngen.SystemPackagesRs = (function() {

                /**
                 * Properties of a SystemPackagesRs.
                 * @memberof priority.netitems.ngen
                 * @interface ISystemPackagesRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] SystemPackagesRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] SystemPackagesRs Messages
                 * @property {Array.<priority.netitems.ngen.IPackageByCategory>|null} [PackagesByCategory] SystemPackagesRs PackagesByCategory
                 */

                /**
                 * Constructs a new SystemPackagesRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a SystemPackagesRs.
                 * @implements ISystemPackagesRs
                 * @constructor
                 * @param {priority.netitems.ngen.ISystemPackagesRs=} [properties] Properties to set
                 */
                function SystemPackagesRs(properties) {
                    this.Messages = [];
                    this.PackagesByCategory = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * SystemPackagesRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @instance
                 */
                SystemPackagesRs.prototype.Perf = null;

                /**
                 * SystemPackagesRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @instance
                 */
                SystemPackagesRs.prototype.Messages = $util.emptyArray;

                /**
                 * SystemPackagesRs PackagesByCategory.
                 * @member {Array.<priority.netitems.ngen.IPackageByCategory>} PackagesByCategory
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @instance
                 */
                SystemPackagesRs.prototype.PackagesByCategory = $util.emptyArray;

                /**
                 * Creates a new SystemPackagesRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @static
                 * @param {priority.netitems.ngen.ISystemPackagesRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.SystemPackagesRs} SystemPackagesRs instance
                 */
                SystemPackagesRs.create = function create(properties) {
                    return new SystemPackagesRs(properties);
                };

                /**
                 * Encodes the specified SystemPackagesRs message. Does not implicitly {@link priority.netitems.ngen.SystemPackagesRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @static
                 * @param {priority.netitems.ngen.ISystemPackagesRs} message SystemPackagesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemPackagesRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.PackagesByCategory != null && message.PackagesByCategory.length)
                        for (var i = 0; i < message.PackagesByCategory.length; ++i)
                            $root.priority.netitems.ngen.PackageByCategory.encode(message.PackagesByCategory[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified SystemPackagesRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.SystemPackagesRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @static
                 * @param {priority.netitems.ngen.ISystemPackagesRs} message SystemPackagesRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SystemPackagesRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a SystemPackagesRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.SystemPackagesRs} SystemPackagesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemPackagesRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.SystemPackagesRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.PackagesByCategory && message.PackagesByCategory.length))
                                message.PackagesByCategory = [];
                            message.PackagesByCategory.push($root.priority.netitems.ngen.PackageByCategory.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a SystemPackagesRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.SystemPackagesRs} SystemPackagesRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SystemPackagesRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a SystemPackagesRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SystemPackagesRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.PackagesByCategory != null && message.hasOwnProperty("PackagesByCategory")) {
                        if (!Array.isArray(message.PackagesByCategory))
                            return "PackagesByCategory: array expected";
                        for (var i = 0; i < message.PackagesByCategory.length; ++i) {
                            var error = $root.priority.netitems.ngen.PackageByCategory.verify(message.PackagesByCategory[i]);
                            if (error)
                                return "PackagesByCategory." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a SystemPackagesRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.SystemPackagesRs} SystemPackagesRs
                 */
                SystemPackagesRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.SystemPackagesRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.SystemPackagesRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.SystemPackagesRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.SystemPackagesRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.SystemPackagesRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.PackagesByCategory) {
                        if (!Array.isArray(object.PackagesByCategory))
                            throw TypeError(".priority.netitems.ngen.SystemPackagesRs.PackagesByCategory: array expected");
                        message.PackagesByCategory = [];
                        for (var i = 0; i < object.PackagesByCategory.length; ++i) {
                            if (typeof object.PackagesByCategory[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.SystemPackagesRs.PackagesByCategory: object expected");
                            message.PackagesByCategory[i] = $root.priority.netitems.ngen.PackageByCategory.fromObject(object.PackagesByCategory[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a SystemPackagesRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @static
                 * @param {priority.netitems.ngen.SystemPackagesRs} message SystemPackagesRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SystemPackagesRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.PackagesByCategory = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.PackagesByCategory && message.PackagesByCategory.length) {
                        object.PackagesByCategory = [];
                        for (var j = 0; j < message.PackagesByCategory.length; ++j)
                            object.PackagesByCategory[j] = $root.priority.netitems.ngen.PackageByCategory.toObject(message.PackagesByCategory[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this SystemPackagesRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.SystemPackagesRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SystemPackagesRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return SystemPackagesRs;
            })();

            ngen.PackageChangeRq = (function() {

                /**
                 * Properties of a PackageChangeRq.
                 * @memberof priority.netitems.ngen
                 * @interface IPackageChangeRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] PackageChangeRq Properties
                 * @property {number|Long|null} [PackageId] PackageChangeRq PackageId
                 * @property {boolean|null} [IsPackageVisible] PackageChangeRq IsPackageVisible
                 */

                /**
                 * Constructs a new PackageChangeRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a PackageChangeRq.
                 * @implements IPackageChangeRq
                 * @constructor
                 * @param {priority.netitems.ngen.IPackageChangeRq=} [properties] Properties to set
                 */
                function PackageChangeRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PackageChangeRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @instance
                 */
                PackageChangeRq.prototype.Properties = null;

                /**
                 * PackageChangeRq PackageId.
                 * @member {number|Long} PackageId
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @instance
                 */
                PackageChangeRq.prototype.PackageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * PackageChangeRq IsPackageVisible.
                 * @member {boolean} IsPackageVisible
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @instance
                 */
                PackageChangeRq.prototype.IsPackageVisible = false;

                /**
                 * Creates a new PackageChangeRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @static
                 * @param {priority.netitems.ngen.IPackageChangeRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.PackageChangeRq} PackageChangeRq instance
                 */
                PackageChangeRq.create = function create(properties) {
                    return new PackageChangeRq(properties);
                };

                /**
                 * Encodes the specified PackageChangeRq message. Does not implicitly {@link priority.netitems.ngen.PackageChangeRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @static
                 * @param {priority.netitems.ngen.IPackageChangeRq} message PackageChangeRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageChangeRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.PackageId != null && Object.hasOwnProperty.call(message, "PackageId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.PackageId);
                    if (message.IsPackageVisible != null && Object.hasOwnProperty.call(message, "IsPackageVisible"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsPackageVisible);
                    return writer;
                };

                /**
                 * Encodes the specified PackageChangeRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.PackageChangeRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @static
                 * @param {priority.netitems.ngen.IPackageChangeRq} message PackageChangeRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageChangeRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PackageChangeRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.PackageChangeRq} PackageChangeRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageChangeRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.PackageChangeRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.PackageId = reader.int64();
                            break;
                        case 3:
                            message.IsPackageVisible = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PackageChangeRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.PackageChangeRq} PackageChangeRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageChangeRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PackageChangeRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PackageChangeRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (!$util.isInteger(message.PackageId) && !(message.PackageId && $util.isInteger(message.PackageId.low) && $util.isInteger(message.PackageId.high)))
                            return "PackageId: integer|Long expected";
                    if (message.IsPackageVisible != null && message.hasOwnProperty("IsPackageVisible"))
                        if (typeof message.IsPackageVisible !== "boolean")
                            return "IsPackageVisible: boolean expected";
                    return null;
                };

                /**
                 * Creates a PackageChangeRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.PackageChangeRq} PackageChangeRq
                 */
                PackageChangeRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.PackageChangeRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.PackageChangeRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.PackageChangeRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.PackageId != null)
                        if ($util.Long)
                            (message.PackageId = $util.Long.fromValue(object.PackageId)).unsigned = false;
                        else if (typeof object.PackageId === "string")
                            message.PackageId = parseInt(object.PackageId, 10);
                        else if (typeof object.PackageId === "number")
                            message.PackageId = object.PackageId;
                        else if (typeof object.PackageId === "object")
                            message.PackageId = new $util.LongBits(object.PackageId.low >>> 0, object.PackageId.high >>> 0).toNumber();
                    if (object.IsPackageVisible != null)
                        message.IsPackageVisible = Boolean(object.IsPackageVisible);
                    return message;
                };

                /**
                 * Creates a plain object from a PackageChangeRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @static
                 * @param {priority.netitems.ngen.PackageChangeRq} message PackageChangeRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PackageChangeRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.PackageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.PackageId = options.longs === String ? "0" : 0;
                        object.IsPackageVisible = false;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.PackageId != null && message.hasOwnProperty("PackageId"))
                        if (typeof message.PackageId === "number")
                            object.PackageId = options.longs === String ? String(message.PackageId) : message.PackageId;
                        else
                            object.PackageId = options.longs === String ? $util.Long.prototype.toString.call(message.PackageId) : options.longs === Number ? new $util.LongBits(message.PackageId.low >>> 0, message.PackageId.high >>> 0).toNumber() : message.PackageId;
                    if (message.IsPackageVisible != null && message.hasOwnProperty("IsPackageVisible"))
                        object.IsPackageVisible = message.IsPackageVisible;
                    return object;
                };

                /**
                 * Converts this PackageChangeRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.PackageChangeRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PackageChangeRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PackageChangeRq;
            })();

            ngen.PackageChangeRs = (function() {

                /**
                 * Properties of a PackageChangeRs.
                 * @memberof priority.netitems.ngen
                 * @interface IPackageChangeRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] PackageChangeRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] PackageChangeRs Messages
                 * @property {Array.<priority.netitems.ngen.IPackageByCategory>|null} [PackagesByCategory] PackageChangeRs PackagesByCategory
                 */

                /**
                 * Constructs a new PackageChangeRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a PackageChangeRs.
                 * @implements IPackageChangeRs
                 * @constructor
                 * @param {priority.netitems.ngen.IPackageChangeRs=} [properties] Properties to set
                 */
                function PackageChangeRs(properties) {
                    this.Messages = [];
                    this.PackagesByCategory = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PackageChangeRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @instance
                 */
                PackageChangeRs.prototype.Perf = null;

                /**
                 * PackageChangeRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @instance
                 */
                PackageChangeRs.prototype.Messages = $util.emptyArray;

                /**
                 * PackageChangeRs PackagesByCategory.
                 * @member {Array.<priority.netitems.ngen.IPackageByCategory>} PackagesByCategory
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @instance
                 */
                PackageChangeRs.prototype.PackagesByCategory = $util.emptyArray;

                /**
                 * Creates a new PackageChangeRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @static
                 * @param {priority.netitems.ngen.IPackageChangeRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.PackageChangeRs} PackageChangeRs instance
                 */
                PackageChangeRs.create = function create(properties) {
                    return new PackageChangeRs(properties);
                };

                /**
                 * Encodes the specified PackageChangeRs message. Does not implicitly {@link priority.netitems.ngen.PackageChangeRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @static
                 * @param {priority.netitems.ngen.IPackageChangeRs} message PackageChangeRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageChangeRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.PackagesByCategory != null && message.PackagesByCategory.length)
                        for (var i = 0; i < message.PackagesByCategory.length; ++i)
                            $root.priority.netitems.ngen.PackageByCategory.encode(message.PackagesByCategory[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PackageChangeRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.PackageChangeRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @static
                 * @param {priority.netitems.ngen.IPackageChangeRs} message PackageChangeRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageChangeRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PackageChangeRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.PackageChangeRs} PackageChangeRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageChangeRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.PackageChangeRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.PackagesByCategory && message.PackagesByCategory.length))
                                message.PackagesByCategory = [];
                            message.PackagesByCategory.push($root.priority.netitems.ngen.PackageByCategory.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PackageChangeRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.PackageChangeRs} PackageChangeRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageChangeRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PackageChangeRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PackageChangeRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.PackagesByCategory != null && message.hasOwnProperty("PackagesByCategory")) {
                        if (!Array.isArray(message.PackagesByCategory))
                            return "PackagesByCategory: array expected";
                        for (var i = 0; i < message.PackagesByCategory.length; ++i) {
                            var error = $root.priority.netitems.ngen.PackageByCategory.verify(message.PackagesByCategory[i]);
                            if (error)
                                return "PackagesByCategory." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PackageChangeRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.PackageChangeRs} PackageChangeRs
                 */
                PackageChangeRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.PackageChangeRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.PackageChangeRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.PackageChangeRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.PackageChangeRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.PackageChangeRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.PackagesByCategory) {
                        if (!Array.isArray(object.PackagesByCategory))
                            throw TypeError(".priority.netitems.ngen.PackageChangeRs.PackagesByCategory: array expected");
                        message.PackagesByCategory = [];
                        for (var i = 0; i < object.PackagesByCategory.length; ++i) {
                            if (typeof object.PackagesByCategory[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.PackageChangeRs.PackagesByCategory: object expected");
                            message.PackagesByCategory[i] = $root.priority.netitems.ngen.PackageByCategory.fromObject(object.PackagesByCategory[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PackageChangeRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @static
                 * @param {priority.netitems.ngen.PackageChangeRs} message PackageChangeRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PackageChangeRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.PackagesByCategory = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.PackagesByCategory && message.PackagesByCategory.length) {
                        object.PackagesByCategory = [];
                        for (var j = 0; j < message.PackagesByCategory.length; ++j)
                            object.PackagesByCategory[j] = $root.priority.netitems.ngen.PackageByCategory.toObject(message.PackagesByCategory[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PackageChangeRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.PackageChangeRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PackageChangeRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PackageChangeRs;
            })();

            ngen.PackageSetRq = (function() {

                /**
                 * Properties of a PackageSetRq.
                 * @memberof priority.netitems.ngen
                 * @interface IPackageSetRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] PackageSetRq Properties
                 * @property {Array.<priority.netitems.ngen.IPackage>|null} [Packages] PackageSetRq Packages
                 */

                /**
                 * Constructs a new PackageSetRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a PackageSetRq.
                 * @implements IPackageSetRq
                 * @constructor
                 * @param {priority.netitems.ngen.IPackageSetRq=} [properties] Properties to set
                 */
                function PackageSetRq(properties) {
                    this.Packages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PackageSetRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @instance
                 */
                PackageSetRq.prototype.Properties = null;

                /**
                 * PackageSetRq Packages.
                 * @member {Array.<priority.netitems.ngen.IPackage>} Packages
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @instance
                 */
                PackageSetRq.prototype.Packages = $util.emptyArray;

                /**
                 * Creates a new PackageSetRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @static
                 * @param {priority.netitems.ngen.IPackageSetRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.PackageSetRq} PackageSetRq instance
                 */
                PackageSetRq.create = function create(properties) {
                    return new PackageSetRq(properties);
                };

                /**
                 * Encodes the specified PackageSetRq message. Does not implicitly {@link priority.netitems.ngen.PackageSetRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @static
                 * @param {priority.netitems.ngen.IPackageSetRq} message PackageSetRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageSetRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Packages != null && message.Packages.length)
                        for (var i = 0; i < message.Packages.length; ++i)
                            $root.priority.netitems.ngen.Package.encode(message.Packages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PackageSetRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.PackageSetRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @static
                 * @param {priority.netitems.ngen.IPackageSetRq} message PackageSetRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageSetRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PackageSetRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.PackageSetRq} PackageSetRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageSetRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.PackageSetRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Packages && message.Packages.length))
                                message.Packages = [];
                            message.Packages.push($root.priority.netitems.ngen.Package.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PackageSetRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.PackageSetRq} PackageSetRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageSetRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PackageSetRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PackageSetRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Packages != null && message.hasOwnProperty("Packages")) {
                        if (!Array.isArray(message.Packages))
                            return "Packages: array expected";
                        for (var i = 0; i < message.Packages.length; ++i) {
                            var error = $root.priority.netitems.ngen.Package.verify(message.Packages[i]);
                            if (error)
                                return "Packages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PackageSetRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.PackageSetRq} PackageSetRq
                 */
                PackageSetRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.PackageSetRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.PackageSetRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.PackageSetRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Packages) {
                        if (!Array.isArray(object.Packages))
                            throw TypeError(".priority.netitems.ngen.PackageSetRq.Packages: array expected");
                        message.Packages = [];
                        for (var i = 0; i < object.Packages.length; ++i) {
                            if (typeof object.Packages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.PackageSetRq.Packages: object expected");
                            message.Packages[i] = $root.priority.netitems.ngen.Package.fromObject(object.Packages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PackageSetRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @static
                 * @param {priority.netitems.ngen.PackageSetRq} message PackageSetRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PackageSetRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Packages = [];
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Packages && message.Packages.length) {
                        object.Packages = [];
                        for (var j = 0; j < message.Packages.length; ++j)
                            object.Packages[j] = $root.priority.netitems.ngen.Package.toObject(message.Packages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PackageSetRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.PackageSetRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PackageSetRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PackageSetRq;
            })();

            ngen.PackageSetRs = (function() {

                /**
                 * Properties of a PackageSetRs.
                 * @memberof priority.netitems.ngen
                 * @interface IPackageSetRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] PackageSetRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] PackageSetRs Messages
                 */

                /**
                 * Constructs a new PackageSetRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a PackageSetRs.
                 * @implements IPackageSetRs
                 * @constructor
                 * @param {priority.netitems.ngen.IPackageSetRs=} [properties] Properties to set
                 */
                function PackageSetRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * PackageSetRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @instance
                 */
                PackageSetRs.prototype.Perf = null;

                /**
                 * PackageSetRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @instance
                 */
                PackageSetRs.prototype.Messages = $util.emptyArray;

                /**
                 * Creates a new PackageSetRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @static
                 * @param {priority.netitems.ngen.IPackageSetRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.PackageSetRs} PackageSetRs instance
                 */
                PackageSetRs.create = function create(properties) {
                    return new PackageSetRs(properties);
                };

                /**
                 * Encodes the specified PackageSetRs message. Does not implicitly {@link priority.netitems.ngen.PackageSetRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @static
                 * @param {priority.netitems.ngen.IPackageSetRs} message PackageSetRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageSetRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified PackageSetRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.PackageSetRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @static
                 * @param {priority.netitems.ngen.IPackageSetRs} message PackageSetRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                PackageSetRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a PackageSetRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.PackageSetRs} PackageSetRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageSetRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.PackageSetRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a PackageSetRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.PackageSetRs} PackageSetRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                PackageSetRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a PackageSetRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                PackageSetRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a PackageSetRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.PackageSetRs} PackageSetRs
                 */
                PackageSetRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.PackageSetRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.PackageSetRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.PackageSetRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.PackageSetRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.PackageSetRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a PackageSetRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @static
                 * @param {priority.netitems.ngen.PackageSetRs} message PackageSetRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                PackageSetRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this PackageSetRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.PackageSetRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                PackageSetRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return PackageSetRs;
            })();

            ngen.UploadImageRq = (function() {

                /**
                 * Properties of an UploadImageRq.
                 * @memberof priority.netitems.ngen
                 * @interface IUploadImageRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] UploadImageRq Properties
                 * @property {string|null} [Filename] UploadImageRq Filename
                 * @property {Uint8Array|null} [Data] UploadImageRq Data
                 */

                /**
                 * Constructs a new UploadImageRq.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents an UploadImageRq.
                 * @implements IUploadImageRq
                 * @constructor
                 * @param {priority.netitems.ngen.IUploadImageRq=} [properties] Properties to set
                 */
                function UploadImageRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UploadImageRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @instance
                 */
                UploadImageRq.prototype.Properties = null;

                /**
                 * UploadImageRq Filename.
                 * @member {string} Filename
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @instance
                 */
                UploadImageRq.prototype.Filename = "";

                /**
                 * UploadImageRq Data.
                 * @member {Uint8Array} Data
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @instance
                 */
                UploadImageRq.prototype.Data = $util.newBuffer([]);

                /**
                 * Creates a new UploadImageRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @static
                 * @param {priority.netitems.ngen.IUploadImageRq=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.UploadImageRq} UploadImageRq instance
                 */
                UploadImageRq.create = function create(properties) {
                    return new UploadImageRq(properties);
                };

                /**
                 * Encodes the specified UploadImageRq message. Does not implicitly {@link priority.netitems.ngen.UploadImageRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @static
                 * @param {priority.netitems.ngen.IUploadImageRq} message UploadImageRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UploadImageRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Filename != null && Object.hasOwnProperty.call(message, "Filename"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Filename);
                    if (message.Data != null && Object.hasOwnProperty.call(message, "Data"))
                        writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.Data);
                    return writer;
                };

                /**
                 * Encodes the specified UploadImageRq message, length delimited. Does not implicitly {@link priority.netitems.ngen.UploadImageRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @static
                 * @param {priority.netitems.ngen.IUploadImageRq} message UploadImageRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UploadImageRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UploadImageRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.UploadImageRq} UploadImageRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UploadImageRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.UploadImageRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.Filename = reader.string();
                            break;
                        case 3:
                            message.Data = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UploadImageRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.UploadImageRq} UploadImageRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UploadImageRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UploadImageRq message.
                 * @function verify
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UploadImageRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.Filename != null && message.hasOwnProperty("Filename"))
                        if (!$util.isString(message.Filename))
                            return "Filename: string expected";
                    if (message.Data != null && message.hasOwnProperty("Data"))
                        if (!(message.Data && typeof message.Data.length === "number" || $util.isString(message.Data)))
                            return "Data: buffer expected";
                    return null;
                };

                /**
                 * Creates an UploadImageRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.UploadImageRq} UploadImageRq
                 */
                UploadImageRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.UploadImageRq)
                        return object;
                    var message = new $root.priority.netitems.ngen.UploadImageRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.ngen.UploadImageRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.Filename != null)
                        message.Filename = String(object.Filename);
                    if (object.Data != null)
                        if (typeof object.Data === "string")
                            $util.base64.decode(object.Data, message.Data = $util.newBuffer($util.base64.length(object.Data)), 0);
                        else if (object.Data.length)
                            message.Data = object.Data;
                    return message;
                };

                /**
                 * Creates a plain object from an UploadImageRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @static
                 * @param {priority.netitems.ngen.UploadImageRq} message UploadImageRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UploadImageRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        object.Filename = "";
                        if (options.bytes === String)
                            object.Data = "";
                        else {
                            object.Data = [];
                            if (options.bytes !== Array)
                                object.Data = $util.newBuffer(object.Data);
                        }
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.Filename != null && message.hasOwnProperty("Filename"))
                        object.Filename = message.Filename;
                    if (message.Data != null && message.hasOwnProperty("Data"))
                        object.Data = options.bytes === String ? $util.base64.encode(message.Data, 0, message.Data.length) : options.bytes === Array ? Array.prototype.slice.call(message.Data) : message.Data;
                    return object;
                };

                /**
                 * Converts this UploadImageRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.UploadImageRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UploadImageRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UploadImageRq;
            })();

            ngen.UploadImageRs = (function() {

                /**
                 * Properties of an UploadImageRs.
                 * @memberof priority.netitems.ngen
                 * @interface IUploadImageRs
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] UploadImageRs Messages
                 * @property {string|null} [Url] UploadImageRs Url
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] UploadImageRs Perf
                 */

                /**
                 * Constructs a new UploadImageRs.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents an UploadImageRs.
                 * @implements IUploadImageRs
                 * @constructor
                 * @param {priority.netitems.ngen.IUploadImageRs=} [properties] Properties to set
                 */
                function UploadImageRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * UploadImageRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @instance
                 */
                UploadImageRs.prototype.Messages = $util.emptyArray;

                /**
                 * UploadImageRs Url.
                 * @member {string} Url
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @instance
                 */
                UploadImageRs.prototype.Url = "";

                /**
                 * UploadImageRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @instance
                 */
                UploadImageRs.prototype.Perf = null;

                /**
                 * Creates a new UploadImageRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @static
                 * @param {priority.netitems.ngen.IUploadImageRs=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.UploadImageRs} UploadImageRs instance
                 */
                UploadImageRs.create = function create(properties) {
                    return new UploadImageRs(properties);
                };

                /**
                 * Encodes the specified UploadImageRs message. Does not implicitly {@link priority.netitems.ngen.UploadImageRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @static
                 * @param {priority.netitems.ngen.IUploadImageRs} message UploadImageRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UploadImageRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Url != null && Object.hasOwnProperty.call(message, "Url"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.Url);
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified UploadImageRs message, length delimited. Does not implicitly {@link priority.netitems.ngen.UploadImageRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @static
                 * @param {priority.netitems.ngen.IUploadImageRs} message UploadImageRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UploadImageRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an UploadImageRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.UploadImageRs} UploadImageRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UploadImageRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.UploadImageRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.Url = reader.string();
                            break;
                        case 3:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an UploadImageRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.UploadImageRs} UploadImageRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UploadImageRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an UploadImageRs message.
                 * @function verify
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UploadImageRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.Url != null && message.hasOwnProperty("Url"))
                        if (!$util.isString(message.Url))
                            return "Url: string expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    return null;
                };

                /**
                 * Creates an UploadImageRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.UploadImageRs} UploadImageRs
                 */
                UploadImageRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.UploadImageRs)
                        return object;
                    var message = new $root.priority.netitems.ngen.UploadImageRs();
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.ngen.UploadImageRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.ngen.UploadImageRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.Url != null)
                        message.Url = String(object.Url);
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.UploadImageRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from an UploadImageRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @static
                 * @param {priority.netitems.ngen.UploadImageRs} message UploadImageRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UploadImageRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Url = "";
                        object.Perf = null;
                    }
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.Url != null && message.hasOwnProperty("Url"))
                        object.Url = message.Url;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    return object;
                };

                /**
                 * Converts this UploadImageRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.UploadImageRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UploadImageRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return UploadImageRs;
            })();

            ngen.Grpc2Net = (function() {

                /**
                 * Properties of a Grpc2Net.
                 * @memberof priority.netitems.ngen
                 * @interface IGrpc2Net
                 * @property {priority.netitems.ngen.IWhoAmIRq|null} [WhoAmI] Grpc2Net WhoAmI
                 * @property {priority.netitems.ngen.ICheckModuleRq|null} [CheckModule] Grpc2Net CheckModule
                 * @property {priority.netitems.ngen.ICheckModulesRq|null} [CheckModules] Grpc2Net CheckModules
                 * @property {priority.netitems.ngen.IUserSpecialPrivsRq|null} [UserSpecialPrivs] Grpc2Net UserSpecialPrivs
                 * @property {priority.netitems.ngen.ILinkRq|null} [Link] Grpc2Net Link
                 * @property {priority.netitems.ngen.ISystemPackagesRq|null} [Packages] Grpc2Net Packages
                 * @property {priority.netitems.ngen.IPackageChangeRq|null} [PackageChange] Grpc2Net PackageChange
                 * @property {priority.netitems.ngen.IPackageSetRq|null} [PackageSet] Grpc2Net PackageSet
                 * @property {priority.netitems.ngen.IUploadImageRq|null} [UploadImage] Grpc2Net UploadImage
                 */

                /**
                 * Constructs a new Grpc2Net.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a Grpc2Net.
                 * @implements IGrpc2Net
                 * @constructor
                 * @param {priority.netitems.ngen.IGrpc2Net=} [properties] Properties to set
                 */
                function Grpc2Net(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Grpc2Net WhoAmI.
                 * @member {priority.netitems.ngen.IWhoAmIRq|null|undefined} WhoAmI
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.WhoAmI = null;

                /**
                 * Grpc2Net CheckModule.
                 * @member {priority.netitems.ngen.ICheckModuleRq|null|undefined} CheckModule
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.CheckModule = null;

                /**
                 * Grpc2Net CheckModules.
                 * @member {priority.netitems.ngen.ICheckModulesRq|null|undefined} CheckModules
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.CheckModules = null;

                /**
                 * Grpc2Net UserSpecialPrivs.
                 * @member {priority.netitems.ngen.IUserSpecialPrivsRq|null|undefined} UserSpecialPrivs
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.UserSpecialPrivs = null;

                /**
                 * Grpc2Net Link.
                 * @member {priority.netitems.ngen.ILinkRq|null|undefined} Link
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Link = null;

                /**
                 * Grpc2Net Packages.
                 * @member {priority.netitems.ngen.ISystemPackagesRq|null|undefined} Packages
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.Packages = null;

                /**
                 * Grpc2Net PackageChange.
                 * @member {priority.netitems.ngen.IPackageChangeRq|null|undefined} PackageChange
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.PackageChange = null;

                /**
                 * Grpc2Net PackageSet.
                 * @member {priority.netitems.ngen.IPackageSetRq|null|undefined} PackageSet
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.PackageSet = null;

                /**
                 * Grpc2Net UploadImage.
                 * @member {priority.netitems.ngen.IUploadImageRq|null|undefined} UploadImage
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.UploadImage = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Grpc2Net inner.
                 * @member {"WhoAmI"|"CheckModule"|"CheckModules"|"UserSpecialPrivs"|"Link"|"Packages"|"PackageChange"|"PackageSet"|"UploadImage"|undefined} inner
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 */
                Object.defineProperty(Grpc2Net.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["WhoAmI", "CheckModule", "CheckModules", "UserSpecialPrivs", "Link", "Packages", "PackageChange", "PackageSet", "UploadImage"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Grpc2Net instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @static
                 * @param {priority.netitems.ngen.IGrpc2Net=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.Grpc2Net} Grpc2Net instance
                 */
                Grpc2Net.create = function create(properties) {
                    return new Grpc2Net(properties);
                };

                /**
                 * Encodes the specified Grpc2Net message. Does not implicitly {@link priority.netitems.ngen.Grpc2Net.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @static
                 * @param {priority.netitems.ngen.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.WhoAmI != null && Object.hasOwnProperty.call(message, "WhoAmI"))
                        $root.priority.netitems.ngen.WhoAmIRq.encode(message.WhoAmI, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.CheckModule != null && Object.hasOwnProperty.call(message, "CheckModule"))
                        $root.priority.netitems.ngen.CheckModuleRq.encode(message.CheckModule, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.CheckModules != null && Object.hasOwnProperty.call(message, "CheckModules"))
                        $root.priority.netitems.ngen.CheckModulesRq.encode(message.CheckModules, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.UserSpecialPrivs != null && Object.hasOwnProperty.call(message, "UserSpecialPrivs"))
                        $root.priority.netitems.ngen.UserSpecialPrivsRq.encode(message.UserSpecialPrivs, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.Link != null && Object.hasOwnProperty.call(message, "Link"))
                        $root.priority.netitems.ngen.LinkRq.encode(message.Link, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.Packages != null && Object.hasOwnProperty.call(message, "Packages"))
                        $root.priority.netitems.ngen.SystemPackagesRq.encode(message.Packages, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.PackageChange != null && Object.hasOwnProperty.call(message, "PackageChange"))
                        $root.priority.netitems.ngen.PackageChangeRq.encode(message.PackageChange, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.PackageSet != null && Object.hasOwnProperty.call(message, "PackageSet"))
                        $root.priority.netitems.ngen.PackageSetRq.encode(message.PackageSet, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.UploadImage != null && Object.hasOwnProperty.call(message, "UploadImage"))
                        $root.priority.netitems.ngen.UploadImageRq.encode(message.UploadImage, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Grpc2Net message, length delimited. Does not implicitly {@link priority.netitems.ngen.Grpc2Net.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @static
                 * @param {priority.netitems.ngen.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.Grpc2Net();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.WhoAmI = $root.priority.netitems.ngen.WhoAmIRq.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.CheckModule = $root.priority.netitems.ngen.CheckModuleRq.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.CheckModules = $root.priority.netitems.ngen.CheckModulesRq.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.UserSpecialPrivs = $root.priority.netitems.ngen.UserSpecialPrivsRq.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.Link = $root.priority.netitems.ngen.LinkRq.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.Packages = $root.priority.netitems.ngen.SystemPackagesRq.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.PackageChange = $root.priority.netitems.ngen.PackageChangeRq.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.PackageSet = $root.priority.netitems.ngen.PackageSetRq.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.UploadImage = $root.priority.netitems.ngen.UploadImageRq.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Grpc2Net message.
                 * @function verify
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Grpc2Net.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.WhoAmI != null && message.hasOwnProperty("WhoAmI")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.WhoAmIRq.verify(message.WhoAmI);
                            if (error)
                                return "WhoAmI." + error;
                        }
                    }
                    if (message.CheckModule != null && message.hasOwnProperty("CheckModule")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.CheckModuleRq.verify(message.CheckModule);
                            if (error)
                                return "CheckModule." + error;
                        }
                    }
                    if (message.CheckModules != null && message.hasOwnProperty("CheckModules")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.CheckModulesRq.verify(message.CheckModules);
                            if (error)
                                return "CheckModules." + error;
                        }
                    }
                    if (message.UserSpecialPrivs != null && message.hasOwnProperty("UserSpecialPrivs")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.UserSpecialPrivsRq.verify(message.UserSpecialPrivs);
                            if (error)
                                return "UserSpecialPrivs." + error;
                        }
                    }
                    if (message.Link != null && message.hasOwnProperty("Link")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.LinkRq.verify(message.Link);
                            if (error)
                                return "Link." + error;
                        }
                    }
                    if (message.Packages != null && message.hasOwnProperty("Packages")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.SystemPackagesRq.verify(message.Packages);
                            if (error)
                                return "Packages." + error;
                        }
                    }
                    if (message.PackageChange != null && message.hasOwnProperty("PackageChange")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.PackageChangeRq.verify(message.PackageChange);
                            if (error)
                                return "PackageChange." + error;
                        }
                    }
                    if (message.PackageSet != null && message.hasOwnProperty("PackageSet")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.PackageSetRq.verify(message.PackageSet);
                            if (error)
                                return "PackageSet." + error;
                        }
                    }
                    if (message.UploadImage != null && message.hasOwnProperty("UploadImage")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.UploadImageRq.verify(message.UploadImage);
                            if (error)
                                return "UploadImage." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Grpc2Net message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.Grpc2Net} Grpc2Net
                 */
                Grpc2Net.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.Grpc2Net)
                        return object;
                    var message = new $root.priority.netitems.ngen.Grpc2Net();
                    if (object.WhoAmI != null) {
                        if (typeof object.WhoAmI !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.WhoAmI: object expected");
                        message.WhoAmI = $root.priority.netitems.ngen.WhoAmIRq.fromObject(object.WhoAmI);
                    }
                    if (object.CheckModule != null) {
                        if (typeof object.CheckModule !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.CheckModule: object expected");
                        message.CheckModule = $root.priority.netitems.ngen.CheckModuleRq.fromObject(object.CheckModule);
                    }
                    if (object.CheckModules != null) {
                        if (typeof object.CheckModules !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.CheckModules: object expected");
                        message.CheckModules = $root.priority.netitems.ngen.CheckModulesRq.fromObject(object.CheckModules);
                    }
                    if (object.UserSpecialPrivs != null) {
                        if (typeof object.UserSpecialPrivs !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.UserSpecialPrivs: object expected");
                        message.UserSpecialPrivs = $root.priority.netitems.ngen.UserSpecialPrivsRq.fromObject(object.UserSpecialPrivs);
                    }
                    if (object.Link != null) {
                        if (typeof object.Link !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.Link: object expected");
                        message.Link = $root.priority.netitems.ngen.LinkRq.fromObject(object.Link);
                    }
                    if (object.Packages != null) {
                        if (typeof object.Packages !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.Packages: object expected");
                        message.Packages = $root.priority.netitems.ngen.SystemPackagesRq.fromObject(object.Packages);
                    }
                    if (object.PackageChange != null) {
                        if (typeof object.PackageChange !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.PackageChange: object expected");
                        message.PackageChange = $root.priority.netitems.ngen.PackageChangeRq.fromObject(object.PackageChange);
                    }
                    if (object.PackageSet != null) {
                        if (typeof object.PackageSet !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.PackageSet: object expected");
                        message.PackageSet = $root.priority.netitems.ngen.PackageSetRq.fromObject(object.PackageSet);
                    }
                    if (object.UploadImage != null) {
                        if (typeof object.UploadImage !== "object")
                            throw TypeError(".priority.netitems.ngen.Grpc2Net.UploadImage: object expected");
                        message.UploadImage = $root.priority.netitems.ngen.UploadImageRq.fromObject(object.UploadImage);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Grpc2Net message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @static
                 * @param {priority.netitems.ngen.Grpc2Net} message Grpc2Net
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Grpc2Net.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.WhoAmI != null && message.hasOwnProperty("WhoAmI")) {
                        object.WhoAmI = $root.priority.netitems.ngen.WhoAmIRq.toObject(message.WhoAmI, options);
                        if (options.oneofs)
                            object.inner = "WhoAmI";
                    }
                    if (message.CheckModule != null && message.hasOwnProperty("CheckModule")) {
                        object.CheckModule = $root.priority.netitems.ngen.CheckModuleRq.toObject(message.CheckModule, options);
                        if (options.oneofs)
                            object.inner = "CheckModule";
                    }
                    if (message.CheckModules != null && message.hasOwnProperty("CheckModules")) {
                        object.CheckModules = $root.priority.netitems.ngen.CheckModulesRq.toObject(message.CheckModules, options);
                        if (options.oneofs)
                            object.inner = "CheckModules";
                    }
                    if (message.UserSpecialPrivs != null && message.hasOwnProperty("UserSpecialPrivs")) {
                        object.UserSpecialPrivs = $root.priority.netitems.ngen.UserSpecialPrivsRq.toObject(message.UserSpecialPrivs, options);
                        if (options.oneofs)
                            object.inner = "UserSpecialPrivs";
                    }
                    if (message.Link != null && message.hasOwnProperty("Link")) {
                        object.Link = $root.priority.netitems.ngen.LinkRq.toObject(message.Link, options);
                        if (options.oneofs)
                            object.inner = "Link";
                    }
                    if (message.Packages != null && message.hasOwnProperty("Packages")) {
                        object.Packages = $root.priority.netitems.ngen.SystemPackagesRq.toObject(message.Packages, options);
                        if (options.oneofs)
                            object.inner = "Packages";
                    }
                    if (message.PackageChange != null && message.hasOwnProperty("PackageChange")) {
                        object.PackageChange = $root.priority.netitems.ngen.PackageChangeRq.toObject(message.PackageChange, options);
                        if (options.oneofs)
                            object.inner = "PackageChange";
                    }
                    if (message.PackageSet != null && message.hasOwnProperty("PackageSet")) {
                        object.PackageSet = $root.priority.netitems.ngen.PackageSetRq.toObject(message.PackageSet, options);
                        if (options.oneofs)
                            object.inner = "PackageSet";
                    }
                    if (message.UploadImage != null && message.hasOwnProperty("UploadImage")) {
                        object.UploadImage = $root.priority.netitems.ngen.UploadImageRq.toObject(message.UploadImage, options);
                        if (options.oneofs)
                            object.inner = "UploadImage";
                    }
                    return object;
                };

                /**
                 * Converts this Grpc2Net to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.Grpc2Net
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Grpc2Net.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Grpc2Net;
            })();

            ngen.Net2Grpc = (function() {

                /**
                 * Properties of a Net2Grpc.
                 * @memberof priority.netitems.ngen
                 * @interface INet2Grpc
                 * @property {priority.netitems.shared.IGrpcError|null} [FatalError] Net2Grpc FatalError
                 * @property {priority.netitems.shared.IMessage|null} [ApplicationError] Net2Grpc ApplicationError
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] Net2Grpc Perf
                 * @property {priority.netitems.ngen.IWhoAmIRs|null} [WhoAmI] Net2Grpc WhoAmI
                 * @property {priority.netitems.ngen.ICheckModuleRs|null} [CheckModule] Net2Grpc CheckModule
                 * @property {priority.netitems.ngen.ICheckModulesRs|null} [CheckModules] Net2Grpc CheckModules
                 * @property {priority.netitems.ngen.IUserSpecialPrivsRs|null} [UserSpecialPrivs] Net2Grpc UserSpecialPrivs
                 * @property {priority.netitems.ngen.ILinkRs|null} [Link] Net2Grpc Link
                 * @property {priority.netitems.ngen.ISystemPackagesRs|null} [Packages] Net2Grpc Packages
                 * @property {priority.netitems.ngen.IPackageChangeRs|null} [PackageChange] Net2Grpc PackageChange
                 * @property {priority.netitems.ngen.IPackageSetRs|null} [PackageSet] Net2Grpc PackageSet
                 * @property {priority.netitems.ngen.IUploadImageRs|null} [UploadImage] Net2Grpc UploadImage
                 */

                /**
                 * Constructs a new Net2Grpc.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a Net2Grpc.
                 * @implements INet2Grpc
                 * @constructor
                 * @param {priority.netitems.ngen.INet2Grpc=} [properties] Properties to set
                 */
                function Net2Grpc(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Net2Grpc FatalError.
                 * @member {priority.netitems.shared.IGrpcError|null|undefined} FatalError
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FatalError = null;

                /**
                 * Net2Grpc ApplicationError.
                 * @member {priority.netitems.shared.IMessage|null|undefined} ApplicationError
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ApplicationError = null;

                /**
                 * Net2Grpc Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Perf = null;

                /**
                 * Net2Grpc WhoAmI.
                 * @member {priority.netitems.ngen.IWhoAmIRs|null|undefined} WhoAmI
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.WhoAmI = null;

                /**
                 * Net2Grpc CheckModule.
                 * @member {priority.netitems.ngen.ICheckModuleRs|null|undefined} CheckModule
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.CheckModule = null;

                /**
                 * Net2Grpc CheckModules.
                 * @member {priority.netitems.ngen.ICheckModulesRs|null|undefined} CheckModules
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.CheckModules = null;

                /**
                 * Net2Grpc UserSpecialPrivs.
                 * @member {priority.netitems.ngen.IUserSpecialPrivsRs|null|undefined} UserSpecialPrivs
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.UserSpecialPrivs = null;

                /**
                 * Net2Grpc Link.
                 * @member {priority.netitems.ngen.ILinkRs|null|undefined} Link
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Link = null;

                /**
                 * Net2Grpc Packages.
                 * @member {priority.netitems.ngen.ISystemPackagesRs|null|undefined} Packages
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Packages = null;

                /**
                 * Net2Grpc PackageChange.
                 * @member {priority.netitems.ngen.IPackageChangeRs|null|undefined} PackageChange
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.PackageChange = null;

                /**
                 * Net2Grpc PackageSet.
                 * @member {priority.netitems.ngen.IPackageSetRs|null|undefined} PackageSet
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.PackageSet = null;

                /**
                 * Net2Grpc UploadImage.
                 * @member {priority.netitems.ngen.IUploadImageRs|null|undefined} UploadImage
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.UploadImage = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Net2Grpc inner.
                 * @member {"WhoAmI"|"CheckModule"|"CheckModules"|"UserSpecialPrivs"|"Link"|"Packages"|"PackageChange"|"PackageSet"|"UploadImage"|undefined} inner
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 */
                Object.defineProperty(Net2Grpc.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["WhoAmI", "CheckModule", "CheckModules", "UserSpecialPrivs", "Link", "Packages", "PackageChange", "PackageSet", "UploadImage"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Net2Grpc instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @static
                 * @param {priority.netitems.ngen.INet2Grpc=} [properties] Properties to set
                 * @returns {priority.netitems.ngen.Net2Grpc} Net2Grpc instance
                 */
                Net2Grpc.create = function create(properties) {
                    return new Net2Grpc(properties);
                };

                /**
                 * Encodes the specified Net2Grpc message. Does not implicitly {@link priority.netitems.ngen.Net2Grpc.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @static
                 * @param {priority.netitems.ngen.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.FatalError != null && Object.hasOwnProperty.call(message, "FatalError"))
                        $root.priority.netitems.shared.GrpcError.encode(message.FatalError, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ApplicationError != null && Object.hasOwnProperty.call(message, "ApplicationError"))
                        $root.priority.netitems.shared.Message.encode(message.ApplicationError, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.WhoAmI != null && Object.hasOwnProperty.call(message, "WhoAmI"))
                        $root.priority.netitems.ngen.WhoAmIRs.encode(message.WhoAmI, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.CheckModule != null && Object.hasOwnProperty.call(message, "CheckModule"))
                        $root.priority.netitems.ngen.CheckModuleRs.encode(message.CheckModule, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.CheckModules != null && Object.hasOwnProperty.call(message, "CheckModules"))
                        $root.priority.netitems.ngen.CheckModulesRs.encode(message.CheckModules, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.UserSpecialPrivs != null && Object.hasOwnProperty.call(message, "UserSpecialPrivs"))
                        $root.priority.netitems.ngen.UserSpecialPrivsRs.encode(message.UserSpecialPrivs, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.Link != null && Object.hasOwnProperty.call(message, "Link"))
                        $root.priority.netitems.ngen.LinkRs.encode(message.Link, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.Packages != null && Object.hasOwnProperty.call(message, "Packages"))
                        $root.priority.netitems.ngen.SystemPackagesRs.encode(message.Packages, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.PackageChange != null && Object.hasOwnProperty.call(message, "PackageChange"))
                        $root.priority.netitems.ngen.PackageChangeRs.encode(message.PackageChange, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.PackageSet != null && Object.hasOwnProperty.call(message, "PackageSet"))
                        $root.priority.netitems.ngen.PackageSetRs.encode(message.PackageSet, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.UploadImage != null && Object.hasOwnProperty.call(message, "UploadImage"))
                        $root.priority.netitems.ngen.UploadImageRs.encode(message.UploadImage, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Net2Grpc message, length delimited. Does not implicitly {@link priority.netitems.ngen.Net2Grpc.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @static
                 * @param {priority.netitems.ngen.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.ngen.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.ngen.Net2Grpc();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.FatalError = $root.priority.netitems.shared.GrpcError.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.ApplicationError = $root.priority.netitems.shared.Message.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.WhoAmI = $root.priority.netitems.ngen.WhoAmIRs.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.CheckModule = $root.priority.netitems.ngen.CheckModuleRs.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.CheckModules = $root.priority.netitems.ngen.CheckModulesRs.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.UserSpecialPrivs = $root.priority.netitems.ngen.UserSpecialPrivsRs.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.Link = $root.priority.netitems.ngen.LinkRs.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.Packages = $root.priority.netitems.ngen.SystemPackagesRs.decode(reader, reader.uint32());
                            break;
                        case 10:
                            message.PackageChange = $root.priority.netitems.ngen.PackageChangeRs.decode(reader, reader.uint32());
                            break;
                        case 11:
                            message.PackageSet = $root.priority.netitems.ngen.PackageSetRs.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.UploadImage = $root.priority.netitems.ngen.UploadImageRs.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.ngen.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Net2Grpc message.
                 * @function verify
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Net2Grpc.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.FatalError != null && message.hasOwnProperty("FatalError")) {
                        var error = $root.priority.netitems.shared.GrpcError.verify(message.FatalError);
                        if (error)
                            return "FatalError." + error;
                    }
                    if (message.ApplicationError != null && message.hasOwnProperty("ApplicationError")) {
                        var error = $root.priority.netitems.shared.Message.verify(message.ApplicationError);
                        if (error)
                            return "ApplicationError." + error;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.WhoAmI != null && message.hasOwnProperty("WhoAmI")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.WhoAmIRs.verify(message.WhoAmI);
                            if (error)
                                return "WhoAmI." + error;
                        }
                    }
                    if (message.CheckModule != null && message.hasOwnProperty("CheckModule")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.CheckModuleRs.verify(message.CheckModule);
                            if (error)
                                return "CheckModule." + error;
                        }
                    }
                    if (message.CheckModules != null && message.hasOwnProperty("CheckModules")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.CheckModulesRs.verify(message.CheckModules);
                            if (error)
                                return "CheckModules." + error;
                        }
                    }
                    if (message.UserSpecialPrivs != null && message.hasOwnProperty("UserSpecialPrivs")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.UserSpecialPrivsRs.verify(message.UserSpecialPrivs);
                            if (error)
                                return "UserSpecialPrivs." + error;
                        }
                    }
                    if (message.Link != null && message.hasOwnProperty("Link")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.LinkRs.verify(message.Link);
                            if (error)
                                return "Link." + error;
                        }
                    }
                    if (message.Packages != null && message.hasOwnProperty("Packages")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.SystemPackagesRs.verify(message.Packages);
                            if (error)
                                return "Packages." + error;
                        }
                    }
                    if (message.PackageChange != null && message.hasOwnProperty("PackageChange")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.PackageChangeRs.verify(message.PackageChange);
                            if (error)
                                return "PackageChange." + error;
                        }
                    }
                    if (message.PackageSet != null && message.hasOwnProperty("PackageSet")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.PackageSetRs.verify(message.PackageSet);
                            if (error)
                                return "PackageSet." + error;
                        }
                    }
                    if (message.UploadImage != null && message.hasOwnProperty("UploadImage")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.ngen.UploadImageRs.verify(message.UploadImage);
                            if (error)
                                return "UploadImage." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Net2Grpc message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.ngen.Net2Grpc} Net2Grpc
                 */
                Net2Grpc.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.ngen.Net2Grpc)
                        return object;
                    var message = new $root.priority.netitems.ngen.Net2Grpc();
                    if (object.FatalError != null) {
                        if (typeof object.FatalError !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.FatalError: object expected");
                        message.FatalError = $root.priority.netitems.shared.GrpcError.fromObject(object.FatalError);
                    }
                    if (object.ApplicationError != null) {
                        if (typeof object.ApplicationError !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.ApplicationError: object expected");
                        message.ApplicationError = $root.priority.netitems.shared.Message.fromObject(object.ApplicationError);
                    }
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.WhoAmI != null) {
                        if (typeof object.WhoAmI !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.WhoAmI: object expected");
                        message.WhoAmI = $root.priority.netitems.ngen.WhoAmIRs.fromObject(object.WhoAmI);
                    }
                    if (object.CheckModule != null) {
                        if (typeof object.CheckModule !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.CheckModule: object expected");
                        message.CheckModule = $root.priority.netitems.ngen.CheckModuleRs.fromObject(object.CheckModule);
                    }
                    if (object.CheckModules != null) {
                        if (typeof object.CheckModules !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.CheckModules: object expected");
                        message.CheckModules = $root.priority.netitems.ngen.CheckModulesRs.fromObject(object.CheckModules);
                    }
                    if (object.UserSpecialPrivs != null) {
                        if (typeof object.UserSpecialPrivs !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.UserSpecialPrivs: object expected");
                        message.UserSpecialPrivs = $root.priority.netitems.ngen.UserSpecialPrivsRs.fromObject(object.UserSpecialPrivs);
                    }
                    if (object.Link != null) {
                        if (typeof object.Link !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.Link: object expected");
                        message.Link = $root.priority.netitems.ngen.LinkRs.fromObject(object.Link);
                    }
                    if (object.Packages != null) {
                        if (typeof object.Packages !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.Packages: object expected");
                        message.Packages = $root.priority.netitems.ngen.SystemPackagesRs.fromObject(object.Packages);
                    }
                    if (object.PackageChange != null) {
                        if (typeof object.PackageChange !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.PackageChange: object expected");
                        message.PackageChange = $root.priority.netitems.ngen.PackageChangeRs.fromObject(object.PackageChange);
                    }
                    if (object.PackageSet != null) {
                        if (typeof object.PackageSet !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.PackageSet: object expected");
                        message.PackageSet = $root.priority.netitems.ngen.PackageSetRs.fromObject(object.PackageSet);
                    }
                    if (object.UploadImage != null) {
                        if (typeof object.UploadImage !== "object")
                            throw TypeError(".priority.netitems.ngen.Net2Grpc.UploadImage: object expected");
                        message.UploadImage = $root.priority.netitems.ngen.UploadImageRs.fromObject(object.UploadImage);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Net2Grpc message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @static
                 * @param {priority.netitems.ngen.Net2Grpc} message Net2Grpc
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Net2Grpc.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.FatalError = null;
                        object.ApplicationError = null;
                        object.Perf = null;
                    }
                    if (message.FatalError != null && message.hasOwnProperty("FatalError"))
                        object.FatalError = $root.priority.netitems.shared.GrpcError.toObject(message.FatalError, options);
                    if (message.ApplicationError != null && message.hasOwnProperty("ApplicationError"))
                        object.ApplicationError = $root.priority.netitems.shared.Message.toObject(message.ApplicationError, options);
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.WhoAmI != null && message.hasOwnProperty("WhoAmI")) {
                        object.WhoAmI = $root.priority.netitems.ngen.WhoAmIRs.toObject(message.WhoAmI, options);
                        if (options.oneofs)
                            object.inner = "WhoAmI";
                    }
                    if (message.CheckModule != null && message.hasOwnProperty("CheckModule")) {
                        object.CheckModule = $root.priority.netitems.ngen.CheckModuleRs.toObject(message.CheckModule, options);
                        if (options.oneofs)
                            object.inner = "CheckModule";
                    }
                    if (message.CheckModules != null && message.hasOwnProperty("CheckModules")) {
                        object.CheckModules = $root.priority.netitems.ngen.CheckModulesRs.toObject(message.CheckModules, options);
                        if (options.oneofs)
                            object.inner = "CheckModules";
                    }
                    if (message.UserSpecialPrivs != null && message.hasOwnProperty("UserSpecialPrivs")) {
                        object.UserSpecialPrivs = $root.priority.netitems.ngen.UserSpecialPrivsRs.toObject(message.UserSpecialPrivs, options);
                        if (options.oneofs)
                            object.inner = "UserSpecialPrivs";
                    }
                    if (message.Link != null && message.hasOwnProperty("Link")) {
                        object.Link = $root.priority.netitems.ngen.LinkRs.toObject(message.Link, options);
                        if (options.oneofs)
                            object.inner = "Link";
                    }
                    if (message.Packages != null && message.hasOwnProperty("Packages")) {
                        object.Packages = $root.priority.netitems.ngen.SystemPackagesRs.toObject(message.Packages, options);
                        if (options.oneofs)
                            object.inner = "Packages";
                    }
                    if (message.PackageChange != null && message.hasOwnProperty("PackageChange")) {
                        object.PackageChange = $root.priority.netitems.ngen.PackageChangeRs.toObject(message.PackageChange, options);
                        if (options.oneofs)
                            object.inner = "PackageChange";
                    }
                    if (message.PackageSet != null && message.hasOwnProperty("PackageSet")) {
                        object.PackageSet = $root.priority.netitems.ngen.PackageSetRs.toObject(message.PackageSet, options);
                        if (options.oneofs)
                            object.inner = "PackageSet";
                    }
                    if (message.UploadImage != null && message.hasOwnProperty("UploadImage")) {
                        object.UploadImage = $root.priority.netitems.ngen.UploadImageRs.toObject(message.UploadImage, options);
                        if (options.oneofs)
                            object.inner = "UploadImage";
                    }
                    return object;
                };

                /**
                 * Converts this Net2Grpc to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.ngen.Net2Grpc
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Net2Grpc.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Net2Grpc;
            })();

            ngen.NGen = (function() {

                /**
                 * Constructs a new NGen service.
                 * @memberof priority.netitems.ngen
                 * @classdesc Represents a NGen
                 * @extends $protobuf.rpc.Service
                 * @constructor
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 */
                function NGen(rpcImpl, requestDelimited, responseDelimited) {
                    $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }

                (NGen.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NGen;

                /**
                 * Creates new NGen service using the specified rpc implementation.
                 * @function create
                 * @memberof priority.netitems.ngen.NGen
                 * @static
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 * @returns {NGen} RPC service. Useful where requests and/or responses are streamed.
                 */
                NGen.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#whoAmI}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef WhoAmICallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.WhoAmIRs} [response] WhoAmIRs
                 */

                /**
                 * Calls WhoAmI.
                 * @function whoAmI
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IWhoAmIRq} request WhoAmIRq message or plain object
                 * @param {priority.netitems.ngen.NGen.WhoAmICallback} callback Node-style callback called with the error, if any, and WhoAmIRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.whoAmI = function whoAmI(request, callback) {
                    return this.rpcCall(whoAmI, $root.priority.netitems.ngen.WhoAmIRq, $root.priority.netitems.ngen.WhoAmIRs, request, callback);
                }, "name", { value: "WhoAmI" });

                /**
                 * Calls WhoAmI.
                 * @function whoAmI
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IWhoAmIRq} request WhoAmIRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.WhoAmIRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#checkModule}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef CheckModuleCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.CheckModuleRs} [response] CheckModuleRs
                 */

                /**
                 * Calls CheckModule.
                 * @function checkModule
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.ICheckModuleRq} request CheckModuleRq message or plain object
                 * @param {priority.netitems.ngen.NGen.CheckModuleCallback} callback Node-style callback called with the error, if any, and CheckModuleRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.checkModule = function checkModule(request, callback) {
                    return this.rpcCall(checkModule, $root.priority.netitems.ngen.CheckModuleRq, $root.priority.netitems.ngen.CheckModuleRs, request, callback);
                }, "name", { value: "CheckModule" });

                /**
                 * Calls CheckModule.
                 * @function checkModule
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.ICheckModuleRq} request CheckModuleRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.CheckModuleRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#checkModules}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef CheckModulesCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.CheckModulesRs} [response] CheckModulesRs
                 */

                /**
                 * Calls CheckModules.
                 * @function checkModules
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.ICheckModulesRq} request CheckModulesRq message or plain object
                 * @param {priority.netitems.ngen.NGen.CheckModulesCallback} callback Node-style callback called with the error, if any, and CheckModulesRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.checkModules = function checkModules(request, callback) {
                    return this.rpcCall(checkModules, $root.priority.netitems.ngen.CheckModulesRq, $root.priority.netitems.ngen.CheckModulesRs, request, callback);
                }, "name", { value: "CheckModules" });

                /**
                 * Calls CheckModules.
                 * @function checkModules
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.ICheckModulesRq} request CheckModulesRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.CheckModulesRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#userSpecialPrivs}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef UserSpecialPrivsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.UserSpecialPrivsRs} [response] UserSpecialPrivsRs
                 */

                /**
                 * Calls UserSpecialPrivs.
                 * @function userSpecialPrivs
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRq} request UserSpecialPrivsRq message or plain object
                 * @param {priority.netitems.ngen.NGen.UserSpecialPrivsCallback} callback Node-style callback called with the error, if any, and UserSpecialPrivsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.userSpecialPrivs = function userSpecialPrivs(request, callback) {
                    return this.rpcCall(userSpecialPrivs, $root.priority.netitems.ngen.UserSpecialPrivsRq, $root.priority.netitems.ngen.UserSpecialPrivsRs, request, callback);
                }, "name", { value: "UserSpecialPrivs" });

                /**
                 * Calls UserSpecialPrivs.
                 * @function userSpecialPrivs
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IUserSpecialPrivsRq} request UserSpecialPrivsRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.UserSpecialPrivsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#links}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef LinksCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.LinkRs} [response] LinkRs
                 */

                /**
                 * Calls Links.
                 * @function links
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.ILinkRq} request LinkRq message or plain object
                 * @param {priority.netitems.ngen.NGen.LinksCallback} callback Node-style callback called with the error, if any, and LinkRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.links = function links(request, callback) {
                    return this.rpcCall(links, $root.priority.netitems.ngen.LinkRq, $root.priority.netitems.ngen.LinkRs, request, callback);
                }, "name", { value: "Links" });

                /**
                 * Calls Links.
                 * @function links
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.ILinkRq} request LinkRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.LinkRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#packages}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef PackagesCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.SystemPackagesRs} [response] SystemPackagesRs
                 */

                /**
                 * Calls Packages.
                 * @function packages
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.ISystemPackagesRq} request SystemPackagesRq message or plain object
                 * @param {priority.netitems.ngen.NGen.PackagesCallback} callback Node-style callback called with the error, if any, and SystemPackagesRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.packages = function packages(request, callback) {
                    return this.rpcCall(packages, $root.priority.netitems.ngen.SystemPackagesRq, $root.priority.netitems.ngen.SystemPackagesRs, request, callback);
                }, "name", { value: "Packages" });

                /**
                 * Calls Packages.
                 * @function packages
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.ISystemPackagesRq} request SystemPackagesRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.SystemPackagesRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#packageChange}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef PackageChangeCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.PackageChangeRs} [response] PackageChangeRs
                 */

                /**
                 * Calls PackageChange.
                 * @function packageChange
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IPackageChangeRq} request PackageChangeRq message or plain object
                 * @param {priority.netitems.ngen.NGen.PackageChangeCallback} callback Node-style callback called with the error, if any, and PackageChangeRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.packageChange = function packageChange(request, callback) {
                    return this.rpcCall(packageChange, $root.priority.netitems.ngen.PackageChangeRq, $root.priority.netitems.ngen.PackageChangeRs, request, callback);
                }, "name", { value: "PackageChange" });

                /**
                 * Calls PackageChange.
                 * @function packageChange
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IPackageChangeRq} request PackageChangeRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.PackageChangeRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#packageSet}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef PackageSetCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.PackageSetRs} [response] PackageSetRs
                 */

                /**
                 * Calls PackageSet.
                 * @function packageSet
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IPackageSetRq} request PackageSetRq message or plain object
                 * @param {priority.netitems.ngen.NGen.PackageSetCallback} callback Node-style callback called with the error, if any, and PackageSetRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.packageSet = function packageSet(request, callback) {
                    return this.rpcCall(packageSet, $root.priority.netitems.ngen.PackageSetRq, $root.priority.netitems.ngen.PackageSetRs, request, callback);
                }, "name", { value: "PackageSet" });

                /**
                 * Calls PackageSet.
                 * @function packageSet
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IPackageSetRq} request PackageSetRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.PackageSetRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.ngen.NGen#uploadImage}.
                 * @memberof priority.netitems.ngen.NGen
                 * @typedef UploadImageCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.ngen.UploadImageRs} [response] UploadImageRs
                 */

                /**
                 * Calls UploadImage.
                 * @function uploadImage
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IUploadImageRq} request UploadImageRq message or plain object
                 * @param {priority.netitems.ngen.NGen.UploadImageCallback} callback Node-style callback called with the error, if any, and UploadImageRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NGen.prototype.uploadImage = function uploadImage(request, callback) {
                    return this.rpcCall(uploadImage, $root.priority.netitems.ngen.UploadImageRq, $root.priority.netitems.ngen.UploadImageRs, request, callback);
                }, "name", { value: "UploadImage" });

                /**
                 * Calls UploadImage.
                 * @function uploadImage
                 * @memberof priority.netitems.ngen.NGen
                 * @instance
                 * @param {priority.netitems.ngen.IUploadImageRq} request UploadImageRq message or plain object
                 * @returns {Promise<priority.netitems.ngen.UploadImageRs>} Promise
                 * @variation 2
                 */

                return NGen;
            })();

            return ngen;
        })();

        netitems.nrule = (function() {

            /**
             * Namespace nrule.
             * @memberof priority.netitems
             * @namespace
             */
            var nrule = {};

            nrule.GetMessageColumnsRq = (function() {

                /**
                 * Properties of a GetMessageColumnsRq.
                 * @memberof priority.netitems.nrule
                 * @interface IGetMessageColumnsRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] GetMessageColumnsRq Properties
                 * @property {Array.<string>|null} [FormNamePath] GetMessageColumnsRq FormNamePath
                 */

                /**
                 * Constructs a new GetMessageColumnsRq.
                 * @memberof priority.netitems.nrule
                 * @classdesc Represents a GetMessageColumnsRq.
                 * @implements IGetMessageColumnsRq
                 * @constructor
                 * @param {priority.netitems.nrule.IGetMessageColumnsRq=} [properties] Properties to set
                 */
                function GetMessageColumnsRq(properties) {
                    this.FormNamePath = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetMessageColumnsRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @instance
                 */
                GetMessageColumnsRq.prototype.Properties = null;

                /**
                 * GetMessageColumnsRq FormNamePath.
                 * @member {Array.<string>} FormNamePath
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @instance
                 */
                GetMessageColumnsRq.prototype.FormNamePath = $util.emptyArray;

                /**
                 * Creates a new GetMessageColumnsRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @static
                 * @param {priority.netitems.nrule.IGetMessageColumnsRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrule.GetMessageColumnsRq} GetMessageColumnsRq instance
                 */
                GetMessageColumnsRq.create = function create(properties) {
                    return new GetMessageColumnsRq(properties);
                };

                /**
                 * Encodes the specified GetMessageColumnsRq message. Does not implicitly {@link priority.netitems.nrule.GetMessageColumnsRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @static
                 * @param {priority.netitems.nrule.IGetMessageColumnsRq} message GetMessageColumnsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetMessageColumnsRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.FormNamePath != null && message.FormNamePath.length)
                        for (var i = 0; i < message.FormNamePath.length; ++i)
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.FormNamePath[i]);
                    return writer;
                };

                /**
                 * Encodes the specified GetMessageColumnsRq message, length delimited. Does not implicitly {@link priority.netitems.nrule.GetMessageColumnsRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @static
                 * @param {priority.netitems.nrule.IGetMessageColumnsRq} message GetMessageColumnsRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetMessageColumnsRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetMessageColumnsRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrule.GetMessageColumnsRq} GetMessageColumnsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetMessageColumnsRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrule.GetMessageColumnsRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.FormNamePath && message.FormNamePath.length))
                                message.FormNamePath = [];
                            message.FormNamePath.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetMessageColumnsRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrule.GetMessageColumnsRq} GetMessageColumnsRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetMessageColumnsRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetMessageColumnsRq message.
                 * @function verify
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetMessageColumnsRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.FormNamePath != null && message.hasOwnProperty("FormNamePath")) {
                        if (!Array.isArray(message.FormNamePath))
                            return "FormNamePath: array expected";
                        for (var i = 0; i < message.FormNamePath.length; ++i)
                            if (!$util.isString(message.FormNamePath[i]))
                                return "FormNamePath: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a GetMessageColumnsRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrule.GetMessageColumnsRq} GetMessageColumnsRq
                 */
                GetMessageColumnsRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrule.GetMessageColumnsRq)
                        return object;
                    var message = new $root.priority.netitems.nrule.GetMessageColumnsRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrule.GetMessageColumnsRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.FormNamePath) {
                        if (!Array.isArray(object.FormNamePath))
                            throw TypeError(".priority.netitems.nrule.GetMessageColumnsRq.FormNamePath: array expected");
                        message.FormNamePath = [];
                        for (var i = 0; i < object.FormNamePath.length; ++i)
                            message.FormNamePath[i] = String(object.FormNamePath[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GetMessageColumnsRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @static
                 * @param {priority.netitems.nrule.GetMessageColumnsRq} message GetMessageColumnsRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetMessageColumnsRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.FormNamePath = [];
                    if (options.defaults)
                        object.Properties = null;
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.FormNamePath && message.FormNamePath.length) {
                        object.FormNamePath = [];
                        for (var j = 0; j < message.FormNamePath.length; ++j)
                            object.FormNamePath[j] = message.FormNamePath[j];
                    }
                    return object;
                };

                /**
                 * Converts this GetMessageColumnsRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrule.GetMessageColumnsRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetMessageColumnsRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GetMessageColumnsRq;
            })();

            nrule.GetMessageColumnsRs = (function() {

                /**
                 * Properties of a GetMessageColumnsRs.
                 * @memberof priority.netitems.nrule
                 * @interface IGetMessageColumnsRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] GetMessageColumnsRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] GetMessageColumnsRs Messages
                 * @property {priority.netitems.nrule.IColumnTreeItem|null} [ColumnsTree] GetMessageColumnsRs ColumnsTree
                 */

                /**
                 * Constructs a new GetMessageColumnsRs.
                 * @memberof priority.netitems.nrule
                 * @classdesc Represents a GetMessageColumnsRs.
                 * @implements IGetMessageColumnsRs
                 * @constructor
                 * @param {priority.netitems.nrule.IGetMessageColumnsRs=} [properties] Properties to set
                 */
                function GetMessageColumnsRs(properties) {
                    this.Messages = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetMessageColumnsRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @instance
                 */
                GetMessageColumnsRs.prototype.Perf = null;

                /**
                 * GetMessageColumnsRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @instance
                 */
                GetMessageColumnsRs.prototype.Messages = $util.emptyArray;

                /**
                 * GetMessageColumnsRs ColumnsTree.
                 * @member {priority.netitems.nrule.IColumnTreeItem|null|undefined} ColumnsTree
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @instance
                 */
                GetMessageColumnsRs.prototype.ColumnsTree = null;

                /**
                 * Creates a new GetMessageColumnsRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @static
                 * @param {priority.netitems.nrule.IGetMessageColumnsRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrule.GetMessageColumnsRs} GetMessageColumnsRs instance
                 */
                GetMessageColumnsRs.create = function create(properties) {
                    return new GetMessageColumnsRs(properties);
                };

                /**
                 * Encodes the specified GetMessageColumnsRs message. Does not implicitly {@link priority.netitems.nrule.GetMessageColumnsRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @static
                 * @param {priority.netitems.nrule.IGetMessageColumnsRs} message GetMessageColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetMessageColumnsRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.ColumnsTree != null && Object.hasOwnProperty.call(message, "ColumnsTree"))
                        $root.priority.netitems.nrule.ColumnTreeItem.encode(message.ColumnsTree, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified GetMessageColumnsRs message, length delimited. Does not implicitly {@link priority.netitems.nrule.GetMessageColumnsRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @static
                 * @param {priority.netitems.nrule.IGetMessageColumnsRs} message GetMessageColumnsRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetMessageColumnsRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetMessageColumnsRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrule.GetMessageColumnsRs} GetMessageColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetMessageColumnsRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrule.GetMessageColumnsRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.ColumnsTree = $root.priority.netitems.nrule.ColumnTreeItem.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetMessageColumnsRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrule.GetMessageColumnsRs} GetMessageColumnsRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetMessageColumnsRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetMessageColumnsRs message.
                 * @function verify
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetMessageColumnsRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.ColumnsTree != null && message.hasOwnProperty("ColumnsTree")) {
                        var error = $root.priority.netitems.nrule.ColumnTreeItem.verify(message.ColumnsTree);
                        if (error)
                            return "ColumnsTree." + error;
                    }
                    return null;
                };

                /**
                 * Creates a GetMessageColumnsRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrule.GetMessageColumnsRs} GetMessageColumnsRs
                 */
                GetMessageColumnsRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrule.GetMessageColumnsRs)
                        return object;
                    var message = new $root.priority.netitems.nrule.GetMessageColumnsRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.nrule.GetMessageColumnsRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrule.GetMessageColumnsRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrule.GetMessageColumnsRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.ColumnsTree != null) {
                        if (typeof object.ColumnsTree !== "object")
                            throw TypeError(".priority.netitems.nrule.GetMessageColumnsRs.ColumnsTree: object expected");
                        message.ColumnsTree = $root.priority.netitems.nrule.ColumnTreeItem.fromObject(object.ColumnsTree);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GetMessageColumnsRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @static
                 * @param {priority.netitems.nrule.GetMessageColumnsRs} message GetMessageColumnsRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetMessageColumnsRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.Messages = [];
                    if (options.defaults) {
                        object.Perf = null;
                        object.ColumnsTree = null;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.ColumnsTree != null && message.hasOwnProperty("ColumnsTree"))
                        object.ColumnsTree = $root.priority.netitems.nrule.ColumnTreeItem.toObject(message.ColumnsTree, options);
                    return object;
                };

                /**
                 * Converts this GetMessageColumnsRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrule.GetMessageColumnsRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetMessageColumnsRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GetMessageColumnsRs;
            })();

            nrule.ColumnTreeItem = (function() {

                /**
                 * Properties of a ColumnTreeItem.
                 * @memberof priority.netitems.nrule
                 * @interface IColumnTreeItem
                 * @property {string|null} [FormName] ColumnTreeItem FormName
                 * @property {string|null} [FormTitle] ColumnTreeItem FormTitle
                 * @property {string|null} [FormEnglishTitle] ColumnTreeItem FormEnglishTitle
                 * @property {Array.<priority.netitems.form.IColumn>|null} [Columns] ColumnTreeItem Columns
                 * @property {Array.<priority.netitems.nrule.IColumnTreeItem>|null} [ColumnTreeItems] ColumnTreeItem ColumnTreeItems
                 */

                /**
                 * Constructs a new ColumnTreeItem.
                 * @memberof priority.netitems.nrule
                 * @classdesc Represents a ColumnTreeItem.
                 * @implements IColumnTreeItem
                 * @constructor
                 * @param {priority.netitems.nrule.IColumnTreeItem=} [properties] Properties to set
                 */
                function ColumnTreeItem(properties) {
                    this.Columns = [];
                    this.ColumnTreeItems = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ColumnTreeItem FormName.
                 * @member {string} FormName
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @instance
                 */
                ColumnTreeItem.prototype.FormName = "";

                /**
                 * ColumnTreeItem FormTitle.
                 * @member {string} FormTitle
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @instance
                 */
                ColumnTreeItem.prototype.FormTitle = "";

                /**
                 * ColumnTreeItem FormEnglishTitle.
                 * @member {string} FormEnglishTitle
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @instance
                 */
                ColumnTreeItem.prototype.FormEnglishTitle = "";

                /**
                 * ColumnTreeItem Columns.
                 * @member {Array.<priority.netitems.form.IColumn>} Columns
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @instance
                 */
                ColumnTreeItem.prototype.Columns = $util.emptyArray;

                /**
                 * ColumnTreeItem ColumnTreeItems.
                 * @member {Array.<priority.netitems.nrule.IColumnTreeItem>} ColumnTreeItems
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @instance
                 */
                ColumnTreeItem.prototype.ColumnTreeItems = $util.emptyArray;

                /**
                 * Creates a new ColumnTreeItem instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @static
                 * @param {priority.netitems.nrule.IColumnTreeItem=} [properties] Properties to set
                 * @returns {priority.netitems.nrule.ColumnTreeItem} ColumnTreeItem instance
                 */
                ColumnTreeItem.create = function create(properties) {
                    return new ColumnTreeItem(properties);
                };

                /**
                 * Encodes the specified ColumnTreeItem message. Does not implicitly {@link priority.netitems.nrule.ColumnTreeItem.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @static
                 * @param {priority.netitems.nrule.IColumnTreeItem} message ColumnTreeItem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColumnTreeItem.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.FormName != null && Object.hasOwnProperty.call(message, "FormName"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.FormName);
                    if (message.FormTitle != null && Object.hasOwnProperty.call(message, "FormTitle"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.FormTitle);
                    if (message.FormEnglishTitle != null && Object.hasOwnProperty.call(message, "FormEnglishTitle"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.FormEnglishTitle);
                    if (message.Columns != null && message.Columns.length)
                        for (var i = 0; i < message.Columns.length; ++i)
                            $root.priority.netitems.form.Column.encode(message.Columns[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.ColumnTreeItems != null && message.ColumnTreeItems.length)
                        for (var i = 0; i < message.ColumnTreeItems.length; ++i)
                            $root.priority.netitems.nrule.ColumnTreeItem.encode(message.ColumnTreeItems[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified ColumnTreeItem message, length delimited. Does not implicitly {@link priority.netitems.nrule.ColumnTreeItem.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @static
                 * @param {priority.netitems.nrule.IColumnTreeItem} message ColumnTreeItem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ColumnTreeItem.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ColumnTreeItem message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrule.ColumnTreeItem} ColumnTreeItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColumnTreeItem.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrule.ColumnTreeItem();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.FormName = reader.string();
                            break;
                        case 2:
                            message.FormTitle = reader.string();
                            break;
                        case 3:
                            message.FormEnglishTitle = reader.string();
                            break;
                        case 4:
                            if (!(message.Columns && message.Columns.length))
                                message.Columns = [];
                            message.Columns.push($root.priority.netitems.form.Column.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            if (!(message.ColumnTreeItems && message.ColumnTreeItems.length))
                                message.ColumnTreeItems = [];
                            message.ColumnTreeItems.push($root.priority.netitems.nrule.ColumnTreeItem.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ColumnTreeItem message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrule.ColumnTreeItem} ColumnTreeItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ColumnTreeItem.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ColumnTreeItem message.
                 * @function verify
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ColumnTreeItem.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        if (!$util.isString(message.FormName))
                            return "FormName: string expected";
                    if (message.FormTitle != null && message.hasOwnProperty("FormTitle"))
                        if (!$util.isString(message.FormTitle))
                            return "FormTitle: string expected";
                    if (message.FormEnglishTitle != null && message.hasOwnProperty("FormEnglishTitle"))
                        if (!$util.isString(message.FormEnglishTitle))
                            return "FormEnglishTitle: string expected";
                    if (message.Columns != null && message.hasOwnProperty("Columns")) {
                        if (!Array.isArray(message.Columns))
                            return "Columns: array expected";
                        for (var i = 0; i < message.Columns.length; ++i) {
                            var error = $root.priority.netitems.form.Column.verify(message.Columns[i]);
                            if (error)
                                return "Columns." + error;
                        }
                    }
                    if (message.ColumnTreeItems != null && message.hasOwnProperty("ColumnTreeItems")) {
                        if (!Array.isArray(message.ColumnTreeItems))
                            return "ColumnTreeItems: array expected";
                        for (var i = 0; i < message.ColumnTreeItems.length; ++i) {
                            var error = $root.priority.netitems.nrule.ColumnTreeItem.verify(message.ColumnTreeItems[i]);
                            if (error)
                                return "ColumnTreeItems." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a ColumnTreeItem message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrule.ColumnTreeItem} ColumnTreeItem
                 */
                ColumnTreeItem.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrule.ColumnTreeItem)
                        return object;
                    var message = new $root.priority.netitems.nrule.ColumnTreeItem();
                    if (object.FormName != null)
                        message.FormName = String(object.FormName);
                    if (object.FormTitle != null)
                        message.FormTitle = String(object.FormTitle);
                    if (object.FormEnglishTitle != null)
                        message.FormEnglishTitle = String(object.FormEnglishTitle);
                    if (object.Columns) {
                        if (!Array.isArray(object.Columns))
                            throw TypeError(".priority.netitems.nrule.ColumnTreeItem.Columns: array expected");
                        message.Columns = [];
                        for (var i = 0; i < object.Columns.length; ++i) {
                            if (typeof object.Columns[i] !== "object")
                                throw TypeError(".priority.netitems.nrule.ColumnTreeItem.Columns: object expected");
                            message.Columns[i] = $root.priority.netitems.form.Column.fromObject(object.Columns[i]);
                        }
                    }
                    if (object.ColumnTreeItems) {
                        if (!Array.isArray(object.ColumnTreeItems))
                            throw TypeError(".priority.netitems.nrule.ColumnTreeItem.ColumnTreeItems: array expected");
                        message.ColumnTreeItems = [];
                        for (var i = 0; i < object.ColumnTreeItems.length; ++i) {
                            if (typeof object.ColumnTreeItems[i] !== "object")
                                throw TypeError(".priority.netitems.nrule.ColumnTreeItem.ColumnTreeItems: object expected");
                            message.ColumnTreeItems[i] = $root.priority.netitems.nrule.ColumnTreeItem.fromObject(object.ColumnTreeItems[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a ColumnTreeItem message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @static
                 * @param {priority.netitems.nrule.ColumnTreeItem} message ColumnTreeItem
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ColumnTreeItem.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Columns = [];
                        object.ColumnTreeItems = [];
                    }
                    if (options.defaults) {
                        object.FormName = "";
                        object.FormTitle = "";
                        object.FormEnglishTitle = "";
                    }
                    if (message.FormName != null && message.hasOwnProperty("FormName"))
                        object.FormName = message.FormName;
                    if (message.FormTitle != null && message.hasOwnProperty("FormTitle"))
                        object.FormTitle = message.FormTitle;
                    if (message.FormEnglishTitle != null && message.hasOwnProperty("FormEnglishTitle"))
                        object.FormEnglishTitle = message.FormEnglishTitle;
                    if (message.Columns && message.Columns.length) {
                        object.Columns = [];
                        for (var j = 0; j < message.Columns.length; ++j)
                            object.Columns[j] = $root.priority.netitems.form.Column.toObject(message.Columns[j], options);
                    }
                    if (message.ColumnTreeItems && message.ColumnTreeItems.length) {
                        object.ColumnTreeItems = [];
                        for (var j = 0; j < message.ColumnTreeItems.length; ++j)
                            object.ColumnTreeItems[j] = $root.priority.netitems.nrule.ColumnTreeItem.toObject(message.ColumnTreeItems[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this ColumnTreeItem to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrule.ColumnTreeItem
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ColumnTreeItem.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ColumnTreeItem;
            })();

            nrule.GetCoverLettersRq = (function() {

                /**
                 * Properties of a GetCoverLettersRq.
                 * @memberof priority.netitems.nrule
                 * @interface IGetCoverLettersRq
                 * @property {priority.netitems.metadata.IAdditionalProperties|null} [Properties] GetCoverLettersRq Properties
                 * @property {number|Long|null} [AlertNumber] GetCoverLettersRq AlertNumber
                 */

                /**
                 * Constructs a new GetCoverLettersRq.
                 * @memberof priority.netitems.nrule
                 * @classdesc Represents a GetCoverLettersRq.
                 * @implements IGetCoverLettersRq
                 * @constructor
                 * @param {priority.netitems.nrule.IGetCoverLettersRq=} [properties] Properties to set
                 */
                function GetCoverLettersRq(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetCoverLettersRq Properties.
                 * @member {priority.netitems.metadata.IAdditionalProperties|null|undefined} Properties
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @instance
                 */
                GetCoverLettersRq.prototype.Properties = null;

                /**
                 * GetCoverLettersRq AlertNumber.
                 * @member {number|Long} AlertNumber
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @instance
                 */
                GetCoverLettersRq.prototype.AlertNumber = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

                /**
                 * Creates a new GetCoverLettersRq instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @static
                 * @param {priority.netitems.nrule.IGetCoverLettersRq=} [properties] Properties to set
                 * @returns {priority.netitems.nrule.GetCoverLettersRq} GetCoverLettersRq instance
                 */
                GetCoverLettersRq.create = function create(properties) {
                    return new GetCoverLettersRq(properties);
                };

                /**
                 * Encodes the specified GetCoverLettersRq message. Does not implicitly {@link priority.netitems.nrule.GetCoverLettersRq.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @static
                 * @param {priority.netitems.nrule.IGetCoverLettersRq} message GetCoverLettersRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetCoverLettersRq.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Properties != null && Object.hasOwnProperty.call(message, "Properties"))
                        $root.priority.netitems.metadata.AdditionalProperties.encode(message.Properties, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.AlertNumber != null && Object.hasOwnProperty.call(message, "AlertNumber"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.AlertNumber);
                    return writer;
                };

                /**
                 * Encodes the specified GetCoverLettersRq message, length delimited. Does not implicitly {@link priority.netitems.nrule.GetCoverLettersRq.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @static
                 * @param {priority.netitems.nrule.IGetCoverLettersRq} message GetCoverLettersRq message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetCoverLettersRq.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetCoverLettersRq message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrule.GetCoverLettersRq} GetCoverLettersRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetCoverLettersRq.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrule.GetCoverLettersRq();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Properties = $root.priority.netitems.metadata.AdditionalProperties.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.AlertNumber = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetCoverLettersRq message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrule.GetCoverLettersRq} GetCoverLettersRq
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetCoverLettersRq.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetCoverLettersRq message.
                 * @function verify
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetCoverLettersRq.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Properties != null && message.hasOwnProperty("Properties")) {
                        var error = $root.priority.netitems.metadata.AdditionalProperties.verify(message.Properties);
                        if (error)
                            return "Properties." + error;
                    }
                    if (message.AlertNumber != null && message.hasOwnProperty("AlertNumber"))
                        if (!$util.isInteger(message.AlertNumber) && !(message.AlertNumber && $util.isInteger(message.AlertNumber.low) && $util.isInteger(message.AlertNumber.high)))
                            return "AlertNumber: integer|Long expected";
                    return null;
                };

                /**
                 * Creates a GetCoverLettersRq message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrule.GetCoverLettersRq} GetCoverLettersRq
                 */
                GetCoverLettersRq.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrule.GetCoverLettersRq)
                        return object;
                    var message = new $root.priority.netitems.nrule.GetCoverLettersRq();
                    if (object.Properties != null) {
                        if (typeof object.Properties !== "object")
                            throw TypeError(".priority.netitems.nrule.GetCoverLettersRq.Properties: object expected");
                        message.Properties = $root.priority.netitems.metadata.AdditionalProperties.fromObject(object.Properties);
                    }
                    if (object.AlertNumber != null)
                        if ($util.Long)
                            (message.AlertNumber = $util.Long.fromValue(object.AlertNumber)).unsigned = false;
                        else if (typeof object.AlertNumber === "string")
                            message.AlertNumber = parseInt(object.AlertNumber, 10);
                        else if (typeof object.AlertNumber === "number")
                            message.AlertNumber = object.AlertNumber;
                        else if (typeof object.AlertNumber === "object")
                            message.AlertNumber = new $util.LongBits(object.AlertNumber.low >>> 0, object.AlertNumber.high >>> 0).toNumber();
                    return message;
                };

                /**
                 * Creates a plain object from a GetCoverLettersRq message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @static
                 * @param {priority.netitems.nrule.GetCoverLettersRq} message GetCoverLettersRq
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetCoverLettersRq.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.Properties = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.AlertNumber = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.AlertNumber = options.longs === String ? "0" : 0;
                    }
                    if (message.Properties != null && message.hasOwnProperty("Properties"))
                        object.Properties = $root.priority.netitems.metadata.AdditionalProperties.toObject(message.Properties, options);
                    if (message.AlertNumber != null && message.hasOwnProperty("AlertNumber"))
                        if (typeof message.AlertNumber === "number")
                            object.AlertNumber = options.longs === String ? String(message.AlertNumber) : message.AlertNumber;
                        else
                            object.AlertNumber = options.longs === String ? $util.Long.prototype.toString.call(message.AlertNumber) : options.longs === Number ? new $util.LongBits(message.AlertNumber.low >>> 0, message.AlertNumber.high >>> 0).toNumber() : message.AlertNumber;
                    return object;
                };

                /**
                 * Converts this GetCoverLettersRq to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrule.GetCoverLettersRq
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetCoverLettersRq.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GetCoverLettersRq;
            })();

            nrule.GetCoverLettersRs = (function() {

                /**
                 * Properties of a GetCoverLettersRs.
                 * @memberof priority.netitems.nrule
                 * @interface IGetCoverLettersRs
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] GetCoverLettersRs Perf
                 * @property {Array.<priority.netitems.shared.IMessage>|null} [Messages] GetCoverLettersRs Messages
                 * @property {Array.<priority.netitems.form.IAlertMessage>|null} [CoverLetters] GetCoverLettersRs CoverLetters
                 */

                /**
                 * Constructs a new GetCoverLettersRs.
                 * @memberof priority.netitems.nrule
                 * @classdesc Represents a GetCoverLettersRs.
                 * @implements IGetCoverLettersRs
                 * @constructor
                 * @param {priority.netitems.nrule.IGetCoverLettersRs=} [properties] Properties to set
                 */
                function GetCoverLettersRs(properties) {
                    this.Messages = [];
                    this.CoverLetters = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * GetCoverLettersRs Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @instance
                 */
                GetCoverLettersRs.prototype.Perf = null;

                /**
                 * GetCoverLettersRs Messages.
                 * @member {Array.<priority.netitems.shared.IMessage>} Messages
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @instance
                 */
                GetCoverLettersRs.prototype.Messages = $util.emptyArray;

                /**
                 * GetCoverLettersRs CoverLetters.
                 * @member {Array.<priority.netitems.form.IAlertMessage>} CoverLetters
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @instance
                 */
                GetCoverLettersRs.prototype.CoverLetters = $util.emptyArray;

                /**
                 * Creates a new GetCoverLettersRs instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @static
                 * @param {priority.netitems.nrule.IGetCoverLettersRs=} [properties] Properties to set
                 * @returns {priority.netitems.nrule.GetCoverLettersRs} GetCoverLettersRs instance
                 */
                GetCoverLettersRs.create = function create(properties) {
                    return new GetCoverLettersRs(properties);
                };

                /**
                 * Encodes the specified GetCoverLettersRs message. Does not implicitly {@link priority.netitems.nrule.GetCoverLettersRs.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @static
                 * @param {priority.netitems.nrule.IGetCoverLettersRs} message GetCoverLettersRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetCoverLettersRs.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.Messages != null && message.Messages.length)
                        for (var i = 0; i < message.Messages.length; ++i)
                            $root.priority.netitems.shared.Message.encode(message.Messages[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.CoverLetters != null && message.CoverLetters.length)
                        for (var i = 0; i < message.CoverLetters.length; ++i)
                            $root.priority.netitems.form.AlertMessage.encode(message.CoverLetters[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified GetCoverLettersRs message, length delimited. Does not implicitly {@link priority.netitems.nrule.GetCoverLettersRs.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @static
                 * @param {priority.netitems.nrule.IGetCoverLettersRs} message GetCoverLettersRs message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GetCoverLettersRs.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a GetCoverLettersRs message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrule.GetCoverLettersRs} GetCoverLettersRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetCoverLettersRs.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrule.GetCoverLettersRs();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 2:
                            if (!(message.Messages && message.Messages.length))
                                message.Messages = [];
                            message.Messages.push($root.priority.netitems.shared.Message.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.CoverLetters && message.CoverLetters.length))
                                message.CoverLetters = [];
                            message.CoverLetters.push($root.priority.netitems.form.AlertMessage.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a GetCoverLettersRs message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrule.GetCoverLettersRs} GetCoverLettersRs
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GetCoverLettersRs.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a GetCoverLettersRs message.
                 * @function verify
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GetCoverLettersRs.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.Messages != null && message.hasOwnProperty("Messages")) {
                        if (!Array.isArray(message.Messages))
                            return "Messages: array expected";
                        for (var i = 0; i < message.Messages.length; ++i) {
                            var error = $root.priority.netitems.shared.Message.verify(message.Messages[i]);
                            if (error)
                                return "Messages." + error;
                        }
                    }
                    if (message.CoverLetters != null && message.hasOwnProperty("CoverLetters")) {
                        if (!Array.isArray(message.CoverLetters))
                            return "CoverLetters: array expected";
                        for (var i = 0; i < message.CoverLetters.length; ++i) {
                            var error = $root.priority.netitems.form.AlertMessage.verify(message.CoverLetters[i]);
                            if (error)
                                return "CoverLetters." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a GetCoverLettersRs message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrule.GetCoverLettersRs} GetCoverLettersRs
                 */
                GetCoverLettersRs.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrule.GetCoverLettersRs)
                        return object;
                    var message = new $root.priority.netitems.nrule.GetCoverLettersRs();
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.nrule.GetCoverLettersRs.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.Messages) {
                        if (!Array.isArray(object.Messages))
                            throw TypeError(".priority.netitems.nrule.GetCoverLettersRs.Messages: array expected");
                        message.Messages = [];
                        for (var i = 0; i < object.Messages.length; ++i) {
                            if (typeof object.Messages[i] !== "object")
                                throw TypeError(".priority.netitems.nrule.GetCoverLettersRs.Messages: object expected");
                            message.Messages[i] = $root.priority.netitems.shared.Message.fromObject(object.Messages[i]);
                        }
                    }
                    if (object.CoverLetters) {
                        if (!Array.isArray(object.CoverLetters))
                            throw TypeError(".priority.netitems.nrule.GetCoverLettersRs.CoverLetters: array expected");
                        message.CoverLetters = [];
                        for (var i = 0; i < object.CoverLetters.length; ++i) {
                            if (typeof object.CoverLetters[i] !== "object")
                                throw TypeError(".priority.netitems.nrule.GetCoverLettersRs.CoverLetters: object expected");
                            message.CoverLetters[i] = $root.priority.netitems.form.AlertMessage.fromObject(object.CoverLetters[i]);
                        }
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a GetCoverLettersRs message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @static
                 * @param {priority.netitems.nrule.GetCoverLettersRs} message GetCoverLettersRs
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GetCoverLettersRs.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.Messages = [];
                        object.CoverLetters = [];
                    }
                    if (options.defaults)
                        object.Perf = null;
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.Messages && message.Messages.length) {
                        object.Messages = [];
                        for (var j = 0; j < message.Messages.length; ++j)
                            object.Messages[j] = $root.priority.netitems.shared.Message.toObject(message.Messages[j], options);
                    }
                    if (message.CoverLetters && message.CoverLetters.length) {
                        object.CoverLetters = [];
                        for (var j = 0; j < message.CoverLetters.length; ++j)
                            object.CoverLetters[j] = $root.priority.netitems.form.AlertMessage.toObject(message.CoverLetters[j], options);
                    }
                    return object;
                };

                /**
                 * Converts this GetCoverLettersRs to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrule.GetCoverLettersRs
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GetCoverLettersRs.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return GetCoverLettersRs;
            })();

            nrule.NRule = (function() {

                /**
                 * Constructs a new NRule service.
                 * @memberof priority.netitems.nrule
                 * @classdesc Represents a NRule
                 * @extends $protobuf.rpc.Service
                 * @constructor
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 */
                function NRule(rpcImpl, requestDelimited, responseDelimited) {
                    $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                }

                (NRule.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NRule;

                /**
                 * Creates new NRule service using the specified rpc implementation.
                 * @function create
                 * @memberof priority.netitems.nrule.NRule
                 * @static
                 * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                 * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                 * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                 * @returns {NRule} RPC service. Useful where requests and/or responses are streamed.
                 */
                NRule.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                    return new this(rpcImpl, requestDelimited, responseDelimited);
                };

                /**
                 * Callback as used by {@link priority.netitems.nrule.NRule#getMessageColumns}.
                 * @memberof priority.netitems.nrule.NRule
                 * @typedef GetMessageColumnsCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrule.GetMessageColumnsRs} [response] GetMessageColumnsRs
                 */

                /**
                 * Calls GetMessageColumns.
                 * @function getMessageColumns
                 * @memberof priority.netitems.nrule.NRule
                 * @instance
                 * @param {priority.netitems.nrule.IGetMessageColumnsRq} request GetMessageColumnsRq message or plain object
                 * @param {priority.netitems.nrule.NRule.GetMessageColumnsCallback} callback Node-style callback called with the error, if any, and GetMessageColumnsRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRule.prototype.getMessageColumns = function getMessageColumns(request, callback) {
                    return this.rpcCall(getMessageColumns, $root.priority.netitems.nrule.GetMessageColumnsRq, $root.priority.netitems.nrule.GetMessageColumnsRs, request, callback);
                }, "name", { value: "GetMessageColumns" });

                /**
                 * Calls GetMessageColumns.
                 * @function getMessageColumns
                 * @memberof priority.netitems.nrule.NRule
                 * @instance
                 * @param {priority.netitems.nrule.IGetMessageColumnsRq} request GetMessageColumnsRq message or plain object
                 * @returns {Promise<priority.netitems.nrule.GetMessageColumnsRs>} Promise
                 * @variation 2
                 */

                /**
                 * Callback as used by {@link priority.netitems.nrule.NRule#getCoverLetters}.
                 * @memberof priority.netitems.nrule.NRule
                 * @typedef GetCoverLettersCallback
                 * @type {function}
                 * @param {Error|null} error Error, if any
                 * @param {priority.netitems.nrule.GetCoverLettersRs} [response] GetCoverLettersRs
                 */

                /**
                 * Calls GetCoverLetters.
                 * @function getCoverLetters
                 * @memberof priority.netitems.nrule.NRule
                 * @instance
                 * @param {priority.netitems.nrule.IGetCoverLettersRq} request GetCoverLettersRq message or plain object
                 * @param {priority.netitems.nrule.NRule.GetCoverLettersCallback} callback Node-style callback called with the error, if any, and GetCoverLettersRs
                 * @returns {undefined}
                 * @variation 1
                 */
                Object.defineProperty(NRule.prototype.getCoverLetters = function getCoverLetters(request, callback) {
                    return this.rpcCall(getCoverLetters, $root.priority.netitems.nrule.GetCoverLettersRq, $root.priority.netitems.nrule.GetCoverLettersRs, request, callback);
                }, "name", { value: "GetCoverLetters" });

                /**
                 * Calls GetCoverLetters.
                 * @function getCoverLetters
                 * @memberof priority.netitems.nrule.NRule
                 * @instance
                 * @param {priority.netitems.nrule.IGetCoverLettersRq} request GetCoverLettersRq message or plain object
                 * @returns {Promise<priority.netitems.nrule.GetCoverLettersRs>} Promise
                 * @variation 2
                 */

                return NRule;
            })();

            nrule.Grpc2Net = (function() {

                /**
                 * Properties of a Grpc2Net.
                 * @memberof priority.netitems.nrule
                 * @interface IGrpc2Net
                 * @property {priority.netitems.nrule.IGetMessageColumnsRq|null} [GetMessageColumns] Grpc2Net GetMessageColumns
                 * @property {priority.netitems.nrule.IGetCoverLettersRq|null} [GetCoverLetters] Grpc2Net GetCoverLetters
                 */

                /**
                 * Constructs a new Grpc2Net.
                 * @memberof priority.netitems.nrule
                 * @classdesc Represents a Grpc2Net.
                 * @implements IGrpc2Net
                 * @constructor
                 * @param {priority.netitems.nrule.IGrpc2Net=} [properties] Properties to set
                 */
                function Grpc2Net(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Grpc2Net GetMessageColumns.
                 * @member {priority.netitems.nrule.IGetMessageColumnsRq|null|undefined} GetMessageColumns
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.GetMessageColumns = null;

                /**
                 * Grpc2Net GetCoverLetters.
                 * @member {priority.netitems.nrule.IGetCoverLettersRq|null|undefined} GetCoverLetters
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @instance
                 */
                Grpc2Net.prototype.GetCoverLetters = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Grpc2Net inner.
                 * @member {"GetMessageColumns"|"GetCoverLetters"|undefined} inner
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @instance
                 */
                Object.defineProperty(Grpc2Net.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["GetMessageColumns", "GetCoverLetters"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Grpc2Net instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @static
                 * @param {priority.netitems.nrule.IGrpc2Net=} [properties] Properties to set
                 * @returns {priority.netitems.nrule.Grpc2Net} Grpc2Net instance
                 */
                Grpc2Net.create = function create(properties) {
                    return new Grpc2Net(properties);
                };

                /**
                 * Encodes the specified Grpc2Net message. Does not implicitly {@link priority.netitems.nrule.Grpc2Net.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @static
                 * @param {priority.netitems.nrule.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.GetMessageColumns != null && Object.hasOwnProperty.call(message, "GetMessageColumns"))
                        $root.priority.netitems.nrule.GetMessageColumnsRq.encode(message.GetMessageColumns, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.GetCoverLetters != null && Object.hasOwnProperty.call(message, "GetCoverLetters"))
                        $root.priority.netitems.nrule.GetCoverLettersRq.encode(message.GetCoverLetters, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Grpc2Net message, length delimited. Does not implicitly {@link priority.netitems.nrule.Grpc2Net.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @static
                 * @param {priority.netitems.nrule.IGrpc2Net} message Grpc2Net message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Grpc2Net.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrule.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrule.Grpc2Net();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.GetMessageColumns = $root.priority.netitems.nrule.GetMessageColumnsRq.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.GetCoverLetters = $root.priority.netitems.nrule.GetCoverLettersRq.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Grpc2Net message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrule.Grpc2Net} Grpc2Net
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Grpc2Net.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Grpc2Net message.
                 * @function verify
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Grpc2Net.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.GetMessageColumns != null && message.hasOwnProperty("GetMessageColumns")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrule.GetMessageColumnsRq.verify(message.GetMessageColumns);
                            if (error)
                                return "GetMessageColumns." + error;
                        }
                    }
                    if (message.GetCoverLetters != null && message.hasOwnProperty("GetCoverLetters")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrule.GetCoverLettersRq.verify(message.GetCoverLetters);
                            if (error)
                                return "GetCoverLetters." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Grpc2Net message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrule.Grpc2Net} Grpc2Net
                 */
                Grpc2Net.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrule.Grpc2Net)
                        return object;
                    var message = new $root.priority.netitems.nrule.Grpc2Net();
                    if (object.GetMessageColumns != null) {
                        if (typeof object.GetMessageColumns !== "object")
                            throw TypeError(".priority.netitems.nrule.Grpc2Net.GetMessageColumns: object expected");
                        message.GetMessageColumns = $root.priority.netitems.nrule.GetMessageColumnsRq.fromObject(object.GetMessageColumns);
                    }
                    if (object.GetCoverLetters != null) {
                        if (typeof object.GetCoverLetters !== "object")
                            throw TypeError(".priority.netitems.nrule.Grpc2Net.GetCoverLetters: object expected");
                        message.GetCoverLetters = $root.priority.netitems.nrule.GetCoverLettersRq.fromObject(object.GetCoverLetters);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Grpc2Net message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @static
                 * @param {priority.netitems.nrule.Grpc2Net} message Grpc2Net
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Grpc2Net.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.GetMessageColumns != null && message.hasOwnProperty("GetMessageColumns")) {
                        object.GetMessageColumns = $root.priority.netitems.nrule.GetMessageColumnsRq.toObject(message.GetMessageColumns, options);
                        if (options.oneofs)
                            object.inner = "GetMessageColumns";
                    }
                    if (message.GetCoverLetters != null && message.hasOwnProperty("GetCoverLetters")) {
                        object.GetCoverLetters = $root.priority.netitems.nrule.GetCoverLettersRq.toObject(message.GetCoverLetters, options);
                        if (options.oneofs)
                            object.inner = "GetCoverLetters";
                    }
                    return object;
                };

                /**
                 * Converts this Grpc2Net to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrule.Grpc2Net
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Grpc2Net.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Grpc2Net;
            })();

            nrule.Net2Grpc = (function() {

                /**
                 * Properties of a Net2Grpc.
                 * @memberof priority.netitems.nrule
                 * @interface INet2Grpc
                 * @property {priority.netitems.shared.IGrpcError|null} [FatalError] Net2Grpc FatalError
                 * @property {priority.netitems.shared.IMessage|null} [ApplicationError] Net2Grpc ApplicationError
                 * @property {priority.netitems.shared.IPerfMonitor|null} [Perf] Net2Grpc Perf
                 * @property {priority.netitems.nrule.IGetMessageColumnsRs|null} [GetMessageColumns] Net2Grpc GetMessageColumns
                 * @property {priority.netitems.nrule.IGetCoverLettersRs|null} [GetCoverLetters] Net2Grpc GetCoverLetters
                 */

                /**
                 * Constructs a new Net2Grpc.
                 * @memberof priority.netitems.nrule
                 * @classdesc Represents a Net2Grpc.
                 * @implements INet2Grpc
                 * @constructor
                 * @param {priority.netitems.nrule.INet2Grpc=} [properties] Properties to set
                 */
                function Net2Grpc(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Net2Grpc FatalError.
                 * @member {priority.netitems.shared.IGrpcError|null|undefined} FatalError
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.FatalError = null;

                /**
                 * Net2Grpc ApplicationError.
                 * @member {priority.netitems.shared.IMessage|null|undefined} ApplicationError
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.ApplicationError = null;

                /**
                 * Net2Grpc Perf.
                 * @member {priority.netitems.shared.IPerfMonitor|null|undefined} Perf
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.Perf = null;

                /**
                 * Net2Grpc GetMessageColumns.
                 * @member {priority.netitems.nrule.IGetMessageColumnsRs|null|undefined} GetMessageColumns
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.GetMessageColumns = null;

                /**
                 * Net2Grpc GetCoverLetters.
                 * @member {priority.netitems.nrule.IGetCoverLettersRs|null|undefined} GetCoverLetters
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @instance
                 */
                Net2Grpc.prototype.GetCoverLetters = null;

                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;

                /**
                 * Net2Grpc inner.
                 * @member {"GetMessageColumns"|"GetCoverLetters"|undefined} inner
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @instance
                 */
                Object.defineProperty(Net2Grpc.prototype, "inner", {
                    get: $util.oneOfGetter($oneOfFields = ["GetMessageColumns", "GetCoverLetters"]),
                    set: $util.oneOfSetter($oneOfFields)
                });

                /**
                 * Creates a new Net2Grpc instance using the specified properties.
                 * @function create
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @static
                 * @param {priority.netitems.nrule.INet2Grpc=} [properties] Properties to set
                 * @returns {priority.netitems.nrule.Net2Grpc} Net2Grpc instance
                 */
                Net2Grpc.create = function create(properties) {
                    return new Net2Grpc(properties);
                };

                /**
                 * Encodes the specified Net2Grpc message. Does not implicitly {@link priority.netitems.nrule.Net2Grpc.verify|verify} messages.
                 * @function encode
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @static
                 * @param {priority.netitems.nrule.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.FatalError != null && Object.hasOwnProperty.call(message, "FatalError"))
                        $root.priority.netitems.shared.GrpcError.encode(message.FatalError, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.ApplicationError != null && Object.hasOwnProperty.call(message, "ApplicationError"))
                        $root.priority.netitems.shared.Message.encode(message.ApplicationError, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.Perf != null && Object.hasOwnProperty.call(message, "Perf"))
                        $root.priority.netitems.shared.PerfMonitor.encode(message.Perf, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.GetMessageColumns != null && Object.hasOwnProperty.call(message, "GetMessageColumns"))
                        $root.priority.netitems.nrule.GetMessageColumnsRs.encode(message.GetMessageColumns, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.GetCoverLetters != null && Object.hasOwnProperty.call(message, "GetCoverLetters"))
                        $root.priority.netitems.nrule.GetCoverLettersRs.encode(message.GetCoverLetters, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    return writer;
                };

                /**
                 * Encodes the specified Net2Grpc message, length delimited. Does not implicitly {@link priority.netitems.nrule.Net2Grpc.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @static
                 * @param {priority.netitems.nrule.INet2Grpc} message Net2Grpc message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Net2Grpc.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer.
                 * @function decode
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {priority.netitems.nrule.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.priority.netitems.nrule.Net2Grpc();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.FatalError = $root.priority.netitems.shared.GrpcError.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.ApplicationError = $root.priority.netitems.shared.Message.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.Perf = $root.priority.netitems.shared.PerfMonitor.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.GetMessageColumns = $root.priority.netitems.nrule.GetMessageColumnsRs.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.GetCoverLetters = $root.priority.netitems.nrule.GetCoverLettersRs.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Net2Grpc message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {priority.netitems.nrule.Net2Grpc} Net2Grpc
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Net2Grpc.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Net2Grpc message.
                 * @function verify
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Net2Grpc.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.FatalError != null && message.hasOwnProperty("FatalError")) {
                        var error = $root.priority.netitems.shared.GrpcError.verify(message.FatalError);
                        if (error)
                            return "FatalError." + error;
                    }
                    if (message.ApplicationError != null && message.hasOwnProperty("ApplicationError")) {
                        var error = $root.priority.netitems.shared.Message.verify(message.ApplicationError);
                        if (error)
                            return "ApplicationError." + error;
                    }
                    if (message.Perf != null && message.hasOwnProperty("Perf")) {
                        var error = $root.priority.netitems.shared.PerfMonitor.verify(message.Perf);
                        if (error)
                            return "Perf." + error;
                    }
                    if (message.GetMessageColumns != null && message.hasOwnProperty("GetMessageColumns")) {
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrule.GetMessageColumnsRs.verify(message.GetMessageColumns);
                            if (error)
                                return "GetMessageColumns." + error;
                        }
                    }
                    if (message.GetCoverLetters != null && message.hasOwnProperty("GetCoverLetters")) {
                        if (properties.inner === 1)
                            return "inner: multiple values";
                        properties.inner = 1;
                        {
                            var error = $root.priority.netitems.nrule.GetCoverLettersRs.verify(message.GetCoverLetters);
                            if (error)
                                return "GetCoverLetters." + error;
                        }
                    }
                    return null;
                };

                /**
                 * Creates a Net2Grpc message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {priority.netitems.nrule.Net2Grpc} Net2Grpc
                 */
                Net2Grpc.fromObject = function fromObject(object) {
                    if (object instanceof $root.priority.netitems.nrule.Net2Grpc)
                        return object;
                    var message = new $root.priority.netitems.nrule.Net2Grpc();
                    if (object.FatalError != null) {
                        if (typeof object.FatalError !== "object")
                            throw TypeError(".priority.netitems.nrule.Net2Grpc.FatalError: object expected");
                        message.FatalError = $root.priority.netitems.shared.GrpcError.fromObject(object.FatalError);
                    }
                    if (object.ApplicationError != null) {
                        if (typeof object.ApplicationError !== "object")
                            throw TypeError(".priority.netitems.nrule.Net2Grpc.ApplicationError: object expected");
                        message.ApplicationError = $root.priority.netitems.shared.Message.fromObject(object.ApplicationError);
                    }
                    if (object.Perf != null) {
                        if (typeof object.Perf !== "object")
                            throw TypeError(".priority.netitems.nrule.Net2Grpc.Perf: object expected");
                        message.Perf = $root.priority.netitems.shared.PerfMonitor.fromObject(object.Perf);
                    }
                    if (object.GetMessageColumns != null) {
                        if (typeof object.GetMessageColumns !== "object")
                            throw TypeError(".priority.netitems.nrule.Net2Grpc.GetMessageColumns: object expected");
                        message.GetMessageColumns = $root.priority.netitems.nrule.GetMessageColumnsRs.fromObject(object.GetMessageColumns);
                    }
                    if (object.GetCoverLetters != null) {
                        if (typeof object.GetCoverLetters !== "object")
                            throw TypeError(".priority.netitems.nrule.Net2Grpc.GetCoverLetters: object expected");
                        message.GetCoverLetters = $root.priority.netitems.nrule.GetCoverLettersRs.fromObject(object.GetCoverLetters);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Net2Grpc message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @static
                 * @param {priority.netitems.nrule.Net2Grpc} message Net2Grpc
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Net2Grpc.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.FatalError = null;
                        object.ApplicationError = null;
                        object.Perf = null;
                    }
                    if (message.FatalError != null && message.hasOwnProperty("FatalError"))
                        object.FatalError = $root.priority.netitems.shared.GrpcError.toObject(message.FatalError, options);
                    if (message.ApplicationError != null && message.hasOwnProperty("ApplicationError"))
                        object.ApplicationError = $root.priority.netitems.shared.Message.toObject(message.ApplicationError, options);
                    if (message.Perf != null && message.hasOwnProperty("Perf"))
                        object.Perf = $root.priority.netitems.shared.PerfMonitor.toObject(message.Perf, options);
                    if (message.GetMessageColumns != null && message.hasOwnProperty("GetMessageColumns")) {
                        object.GetMessageColumns = $root.priority.netitems.nrule.GetMessageColumnsRs.toObject(message.GetMessageColumns, options);
                        if (options.oneofs)
                            object.inner = "GetMessageColumns";
                    }
                    if (message.GetCoverLetters != null && message.hasOwnProperty("GetCoverLetters")) {
                        object.GetCoverLetters = $root.priority.netitems.nrule.GetCoverLettersRs.toObject(message.GetCoverLetters, options);
                        if (options.oneofs)
                            object.inner = "GetCoverLetters";
                    }
                    return object;
                };

                /**
                 * Converts this Net2Grpc to JSON.
                 * @function toJSON
                 * @memberof priority.netitems.nrule.Net2Grpc
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Net2Grpc.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Net2Grpc;
            })();

            return nrule;
        })();

        return netitems;
    })();

    return priority;
})();

$root.google = (function() {

    /**
     * Namespace google.
     * @exports google
     * @namespace
     */
    var google = {};

    google.api = (function() {

        /**
         * Namespace api.
         * @memberof google
         * @namespace
         */
        var api = {};

        api.Http = (function() {

            /**
             * Properties of a Http.
             * @memberof google.api
             * @interface IHttp
             * @property {Array.<google.api.IHttpRule>|null} [rules] Http rules
             */

            /**
             * Constructs a new Http.
             * @memberof google.api
             * @classdesc Represents a Http.
             * @implements IHttp
             * @constructor
             * @param {google.api.IHttp=} [properties] Properties to set
             */
            function Http(properties) {
                this.rules = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Http rules.
             * @member {Array.<google.api.IHttpRule>} rules
             * @memberof google.api.Http
             * @instance
             */
            Http.prototype.rules = $util.emptyArray;

            /**
             * Creates a new Http instance using the specified properties.
             * @function create
             * @memberof google.api.Http
             * @static
             * @param {google.api.IHttp=} [properties] Properties to set
             * @returns {google.api.Http} Http instance
             */
            Http.create = function create(properties) {
                return new Http(properties);
            };

            /**
             * Encodes the specified Http message. Does not implicitly {@link google.api.Http.verify|verify} messages.
             * @function encode
             * @memberof google.api.Http
             * @static
             * @param {google.api.IHttp} message Http message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Http.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.rules != null && message.rules.length)
                    for (var i = 0; i < message.rules.length; ++i)
                        $root.google.api.HttpRule.encode(message.rules[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified Http message, length delimited. Does not implicitly {@link google.api.Http.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.api.Http
             * @static
             * @param {google.api.IHttp} message Http message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Http.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Http message from the specified reader or buffer.
             * @function decode
             * @memberof google.api.Http
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.api.Http} Http
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Http.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.Http();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.rules && message.rules.length))
                            message.rules = [];
                        message.rules.push($root.google.api.HttpRule.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Http message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.api.Http
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.api.Http} Http
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Http.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Http message.
             * @function verify
             * @memberof google.api.Http
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Http.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.rules != null && message.hasOwnProperty("rules")) {
                    if (!Array.isArray(message.rules))
                        return "rules: array expected";
                    for (var i = 0; i < message.rules.length; ++i) {
                        var error = $root.google.api.HttpRule.verify(message.rules[i]);
                        if (error)
                            return "rules." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a Http message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.api.Http
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.api.Http} Http
             */
            Http.fromObject = function fromObject(object) {
                if (object instanceof $root.google.api.Http)
                    return object;
                var message = new $root.google.api.Http();
                if (object.rules) {
                    if (!Array.isArray(object.rules))
                        throw TypeError(".google.api.Http.rules: array expected");
                    message.rules = [];
                    for (var i = 0; i < object.rules.length; ++i) {
                        if (typeof object.rules[i] !== "object")
                            throw TypeError(".google.api.Http.rules: object expected");
                        message.rules[i] = $root.google.api.HttpRule.fromObject(object.rules[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a Http message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.api.Http
             * @static
             * @param {google.api.Http} message Http
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Http.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.rules = [];
                if (message.rules && message.rules.length) {
                    object.rules = [];
                    for (var j = 0; j < message.rules.length; ++j)
                        object.rules[j] = $root.google.api.HttpRule.toObject(message.rules[j], options);
                }
                return object;
            };

            /**
             * Converts this Http to JSON.
             * @function toJSON
             * @memberof google.api.Http
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Http.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Http;
        })();

        api.HttpRule = (function() {

            /**
             * Properties of a HttpRule.
             * @memberof google.api
             * @interface IHttpRule
             * @property {string|null} [get] HttpRule get
             * @property {string|null} [put] HttpRule put
             * @property {string|null} [post] HttpRule post
             * @property {string|null} ["delete"] HttpRule delete
             * @property {string|null} [patch] HttpRule patch
             * @property {google.api.ICustomHttpPattern|null} [custom] HttpRule custom
             * @property {string|null} [selector] HttpRule selector
             * @property {string|null} [body] HttpRule body
             * @property {Array.<google.api.IHttpRule>|null} [additionalBindings] HttpRule additionalBindings
             */

            /**
             * Constructs a new HttpRule.
             * @memberof google.api
             * @classdesc Represents a HttpRule.
             * @implements IHttpRule
             * @constructor
             * @param {google.api.IHttpRule=} [properties] Properties to set
             */
            function HttpRule(properties) {
                this.additionalBindings = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * HttpRule get.
             * @member {string|null|undefined} get
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype.get = null;

            /**
             * HttpRule put.
             * @member {string|null|undefined} put
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype.put = null;

            /**
             * HttpRule post.
             * @member {string|null|undefined} post
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype.post = null;

            /**
             * HttpRule delete.
             * @member {string|null|undefined} delete
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype["delete"] = null;

            /**
             * HttpRule patch.
             * @member {string|null|undefined} patch
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype.patch = null;

            /**
             * HttpRule custom.
             * @member {google.api.ICustomHttpPattern|null|undefined} custom
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype.custom = null;

            /**
             * HttpRule selector.
             * @member {string} selector
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype.selector = "";

            /**
             * HttpRule body.
             * @member {string} body
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype.body = "";

            /**
             * HttpRule additionalBindings.
             * @member {Array.<google.api.IHttpRule>} additionalBindings
             * @memberof google.api.HttpRule
             * @instance
             */
            HttpRule.prototype.additionalBindings = $util.emptyArray;

            // OneOf field names bound to virtual getters and setters
            var $oneOfFields;

            /**
             * HttpRule pattern.
             * @member {"get"|"put"|"post"|"delete"|"patch"|"custom"|undefined} pattern
             * @memberof google.api.HttpRule
             * @instance
             */
            Object.defineProperty(HttpRule.prototype, "pattern", {
                get: $util.oneOfGetter($oneOfFields = ["get", "put", "post", "delete", "patch", "custom"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            /**
             * Creates a new HttpRule instance using the specified properties.
             * @function create
             * @memberof google.api.HttpRule
             * @static
             * @param {google.api.IHttpRule=} [properties] Properties to set
             * @returns {google.api.HttpRule} HttpRule instance
             */
            HttpRule.create = function create(properties) {
                return new HttpRule(properties);
            };

            /**
             * Encodes the specified HttpRule message. Does not implicitly {@link google.api.HttpRule.verify|verify} messages.
             * @function encode
             * @memberof google.api.HttpRule
             * @static
             * @param {google.api.IHttpRule} message HttpRule message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HttpRule.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.selector != null && Object.hasOwnProperty.call(message, "selector"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.selector);
                if (message.get != null && Object.hasOwnProperty.call(message, "get"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.get);
                if (message.put != null && Object.hasOwnProperty.call(message, "put"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.put);
                if (message.post != null && Object.hasOwnProperty.call(message, "post"))
                    writer.uint32(/* id 4, wireType 2 =*/34).string(message.post);
                if (message["delete"] != null && Object.hasOwnProperty.call(message, "delete"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message["delete"]);
                if (message.patch != null && Object.hasOwnProperty.call(message, "patch"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.patch);
                if (message.body != null && Object.hasOwnProperty.call(message, "body"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.body);
                if (message.custom != null && Object.hasOwnProperty.call(message, "custom"))
                    $root.google.api.CustomHttpPattern.encode(message.custom, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.additionalBindings != null && message.additionalBindings.length)
                    for (var i = 0; i < message.additionalBindings.length; ++i)
                        $root.google.api.HttpRule.encode(message.additionalBindings[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified HttpRule message, length delimited. Does not implicitly {@link google.api.HttpRule.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.api.HttpRule
             * @static
             * @param {google.api.IHttpRule} message HttpRule message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            HttpRule.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a HttpRule message from the specified reader or buffer.
             * @function decode
             * @memberof google.api.HttpRule
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.api.HttpRule} HttpRule
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HttpRule.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.HttpRule();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.get = reader.string();
                        break;
                    case 3:
                        message.put = reader.string();
                        break;
                    case 4:
                        message.post = reader.string();
                        break;
                    case 5:
                        message["delete"] = reader.string();
                        break;
                    case 6:
                        message.patch = reader.string();
                        break;
                    case 8:
                        message.custom = $root.google.api.CustomHttpPattern.decode(reader, reader.uint32());
                        break;
                    case 1:
                        message.selector = reader.string();
                        break;
                    case 7:
                        message.body = reader.string();
                        break;
                    case 11:
                        if (!(message.additionalBindings && message.additionalBindings.length))
                            message.additionalBindings = [];
                        message.additionalBindings.push($root.google.api.HttpRule.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a HttpRule message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.api.HttpRule
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.api.HttpRule} HttpRule
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            HttpRule.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a HttpRule message.
             * @function verify
             * @memberof google.api.HttpRule
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            HttpRule.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                var properties = {};
                if (message.get != null && message.hasOwnProperty("get")) {
                    properties.pattern = 1;
                    if (!$util.isString(message.get))
                        return "get: string expected";
                }
                if (message.put != null && message.hasOwnProperty("put")) {
                    if (properties.pattern === 1)
                        return "pattern: multiple values";
                    properties.pattern = 1;
                    if (!$util.isString(message.put))
                        return "put: string expected";
                }
                if (message.post != null && message.hasOwnProperty("post")) {
                    if (properties.pattern === 1)
                        return "pattern: multiple values";
                    properties.pattern = 1;
                    if (!$util.isString(message.post))
                        return "post: string expected";
                }
                if (message["delete"] != null && message.hasOwnProperty("delete")) {
                    if (properties.pattern === 1)
                        return "pattern: multiple values";
                    properties.pattern = 1;
                    if (!$util.isString(message["delete"]))
                        return "delete: string expected";
                }
                if (message.patch != null && message.hasOwnProperty("patch")) {
                    if (properties.pattern === 1)
                        return "pattern: multiple values";
                    properties.pattern = 1;
                    if (!$util.isString(message.patch))
                        return "patch: string expected";
                }
                if (message.custom != null && message.hasOwnProperty("custom")) {
                    if (properties.pattern === 1)
                        return "pattern: multiple values";
                    properties.pattern = 1;
                    {
                        var error = $root.google.api.CustomHttpPattern.verify(message.custom);
                        if (error)
                            return "custom." + error;
                    }
                }
                if (message.selector != null && message.hasOwnProperty("selector"))
                    if (!$util.isString(message.selector))
                        return "selector: string expected";
                if (message.body != null && message.hasOwnProperty("body"))
                    if (!$util.isString(message.body))
                        return "body: string expected";
                if (message.additionalBindings != null && message.hasOwnProperty("additionalBindings")) {
                    if (!Array.isArray(message.additionalBindings))
                        return "additionalBindings: array expected";
                    for (var i = 0; i < message.additionalBindings.length; ++i) {
                        var error = $root.google.api.HttpRule.verify(message.additionalBindings[i]);
                        if (error)
                            return "additionalBindings." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a HttpRule message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.api.HttpRule
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.api.HttpRule} HttpRule
             */
            HttpRule.fromObject = function fromObject(object) {
                if (object instanceof $root.google.api.HttpRule)
                    return object;
                var message = new $root.google.api.HttpRule();
                if (object.get != null)
                    message.get = String(object.get);
                if (object.put != null)
                    message.put = String(object.put);
                if (object.post != null)
                    message.post = String(object.post);
                if (object["delete"] != null)
                    message["delete"] = String(object["delete"]);
                if (object.patch != null)
                    message.patch = String(object.patch);
                if (object.custom != null) {
                    if (typeof object.custom !== "object")
                        throw TypeError(".google.api.HttpRule.custom: object expected");
                    message.custom = $root.google.api.CustomHttpPattern.fromObject(object.custom);
                }
                if (object.selector != null)
                    message.selector = String(object.selector);
                if (object.body != null)
                    message.body = String(object.body);
                if (object.additionalBindings) {
                    if (!Array.isArray(object.additionalBindings))
                        throw TypeError(".google.api.HttpRule.additionalBindings: array expected");
                    message.additionalBindings = [];
                    for (var i = 0; i < object.additionalBindings.length; ++i) {
                        if (typeof object.additionalBindings[i] !== "object")
                            throw TypeError(".google.api.HttpRule.additionalBindings: object expected");
                        message.additionalBindings[i] = $root.google.api.HttpRule.fromObject(object.additionalBindings[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a HttpRule message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.api.HttpRule
             * @static
             * @param {google.api.HttpRule} message HttpRule
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            HttpRule.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.additionalBindings = [];
                if (options.defaults) {
                    object.selector = "";
                    object.body = "";
                }
                if (message.selector != null && message.hasOwnProperty("selector"))
                    object.selector = message.selector;
                if (message.get != null && message.hasOwnProperty("get")) {
                    object.get = message.get;
                    if (options.oneofs)
                        object.pattern = "get";
                }
                if (message.put != null && message.hasOwnProperty("put")) {
                    object.put = message.put;
                    if (options.oneofs)
                        object.pattern = "put";
                }
                if (message.post != null && message.hasOwnProperty("post")) {
                    object.post = message.post;
                    if (options.oneofs)
                        object.pattern = "post";
                }
                if (message["delete"] != null && message.hasOwnProperty("delete")) {
                    object["delete"] = message["delete"];
                    if (options.oneofs)
                        object.pattern = "delete";
                }
                if (message.patch != null && message.hasOwnProperty("patch")) {
                    object.patch = message.patch;
                    if (options.oneofs)
                        object.pattern = "patch";
                }
                if (message.body != null && message.hasOwnProperty("body"))
                    object.body = message.body;
                if (message.custom != null && message.hasOwnProperty("custom")) {
                    object.custom = $root.google.api.CustomHttpPattern.toObject(message.custom, options);
                    if (options.oneofs)
                        object.pattern = "custom";
                }
                if (message.additionalBindings && message.additionalBindings.length) {
                    object.additionalBindings = [];
                    for (var j = 0; j < message.additionalBindings.length; ++j)
                        object.additionalBindings[j] = $root.google.api.HttpRule.toObject(message.additionalBindings[j], options);
                }
                return object;
            };

            /**
             * Converts this HttpRule to JSON.
             * @function toJSON
             * @memberof google.api.HttpRule
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            HttpRule.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return HttpRule;
        })();

        api.CustomHttpPattern = (function() {

            /**
             * Properties of a CustomHttpPattern.
             * @memberof google.api
             * @interface ICustomHttpPattern
             * @property {string|null} [kind] CustomHttpPattern kind
             * @property {string|null} [path] CustomHttpPattern path
             */

            /**
             * Constructs a new CustomHttpPattern.
             * @memberof google.api
             * @classdesc Represents a CustomHttpPattern.
             * @implements ICustomHttpPattern
             * @constructor
             * @param {google.api.ICustomHttpPattern=} [properties] Properties to set
             */
            function CustomHttpPattern(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * CustomHttpPattern kind.
             * @member {string} kind
             * @memberof google.api.CustomHttpPattern
             * @instance
             */
            CustomHttpPattern.prototype.kind = "";

            /**
             * CustomHttpPattern path.
             * @member {string} path
             * @memberof google.api.CustomHttpPattern
             * @instance
             */
            CustomHttpPattern.prototype.path = "";

            /**
             * Creates a new CustomHttpPattern instance using the specified properties.
             * @function create
             * @memberof google.api.CustomHttpPattern
             * @static
             * @param {google.api.ICustomHttpPattern=} [properties] Properties to set
             * @returns {google.api.CustomHttpPattern} CustomHttpPattern instance
             */
            CustomHttpPattern.create = function create(properties) {
                return new CustomHttpPattern(properties);
            };

            /**
             * Encodes the specified CustomHttpPattern message. Does not implicitly {@link google.api.CustomHttpPattern.verify|verify} messages.
             * @function encode
             * @memberof google.api.CustomHttpPattern
             * @static
             * @param {google.api.ICustomHttpPattern} message CustomHttpPattern message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CustomHttpPattern.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.kind);
                if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
                return writer;
            };

            /**
             * Encodes the specified CustomHttpPattern message, length delimited. Does not implicitly {@link google.api.CustomHttpPattern.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.api.CustomHttpPattern
             * @static
             * @param {google.api.ICustomHttpPattern} message CustomHttpPattern message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            CustomHttpPattern.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a CustomHttpPattern message from the specified reader or buffer.
             * @function decode
             * @memberof google.api.CustomHttpPattern
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.api.CustomHttpPattern} CustomHttpPattern
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CustomHttpPattern.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.CustomHttpPattern();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.kind = reader.string();
                        break;
                    case 2:
                        message.path = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a CustomHttpPattern message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.api.CustomHttpPattern
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.api.CustomHttpPattern} CustomHttpPattern
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            CustomHttpPattern.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a CustomHttpPattern message.
             * @function verify
             * @memberof google.api.CustomHttpPattern
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            CustomHttpPattern.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.kind != null && message.hasOwnProperty("kind"))
                    if (!$util.isString(message.kind))
                        return "kind: string expected";
                if (message.path != null && message.hasOwnProperty("path"))
                    if (!$util.isString(message.path))
                        return "path: string expected";
                return null;
            };

            /**
             * Creates a CustomHttpPattern message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.api.CustomHttpPattern
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.api.CustomHttpPattern} CustomHttpPattern
             */
            CustomHttpPattern.fromObject = function fromObject(object) {
                if (object instanceof $root.google.api.CustomHttpPattern)
                    return object;
                var message = new $root.google.api.CustomHttpPattern();
                if (object.kind != null)
                    message.kind = String(object.kind);
                if (object.path != null)
                    message.path = String(object.path);
                return message;
            };

            /**
             * Creates a plain object from a CustomHttpPattern message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.api.CustomHttpPattern
             * @static
             * @param {google.api.CustomHttpPattern} message CustomHttpPattern
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            CustomHttpPattern.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.kind = "";
                    object.path = "";
                }
                if (message.kind != null && message.hasOwnProperty("kind"))
                    object.kind = message.kind;
                if (message.path != null && message.hasOwnProperty("path"))
                    object.path = message.path;
                return object;
            };

            /**
             * Converts this CustomHttpPattern to JSON.
             * @function toJSON
             * @memberof google.api.CustomHttpPattern
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            CustomHttpPattern.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return CustomHttpPattern;
        })();

        return api;
    })();

    google.protobuf = (function() {

        /**
         * Namespace protobuf.
         * @memberof google
         * @namespace
         */
        var protobuf = {};

        protobuf.FileDescriptorSet = (function() {

            /**
             * Properties of a FileDescriptorSet.
             * @memberof google.protobuf
             * @interface IFileDescriptorSet
             * @property {Array.<google.protobuf.IFileDescriptorProto>|null} [file] FileDescriptorSet file
             */

            /**
             * Constructs a new FileDescriptorSet.
             * @memberof google.protobuf
             * @classdesc Represents a FileDescriptorSet.
             * @implements IFileDescriptorSet
             * @constructor
             * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
             */
            function FileDescriptorSet(properties) {
                this.file = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileDescriptorSet file.
             * @member {Array.<google.protobuf.IFileDescriptorProto>} file
             * @memberof google.protobuf.FileDescriptorSet
             * @instance
             */
            FileDescriptorSet.prototype.file = $util.emptyArray;

            /**
             * Creates a new FileDescriptorSet instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
             * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet instance
             */
            FileDescriptorSet.create = function create(properties) {
                return new FileDescriptorSet(properties);
            };

            /**
             * Encodes the specified FileDescriptorSet message. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {google.protobuf.IFileDescriptorSet} message FileDescriptorSet message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDescriptorSet.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.file != null && message.file.length)
                    for (var i = 0; i < message.file.length; ++i)
                        $root.google.protobuf.FileDescriptorProto.encode(message.file[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified FileDescriptorSet message, length delimited. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {google.protobuf.IFileDescriptorSet} message FileDescriptorSet message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDescriptorSet.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileDescriptorSet message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDescriptorSet.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorSet();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.file && message.file.length))
                            message.file = [];
                        message.file.push($root.google.protobuf.FileDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileDescriptorSet message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDescriptorSet.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileDescriptorSet message.
             * @function verify
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileDescriptorSet.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.file != null && message.hasOwnProperty("file")) {
                    if (!Array.isArray(message.file))
                        return "file: array expected";
                    for (var i = 0; i < message.file.length; ++i) {
                        var error = $root.google.protobuf.FileDescriptorProto.verify(message.file[i]);
                        if (error)
                            return "file." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a FileDescriptorSet message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
             */
            FileDescriptorSet.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileDescriptorSet)
                    return object;
                var message = new $root.google.protobuf.FileDescriptorSet();
                if (object.file) {
                    if (!Array.isArray(object.file))
                        throw TypeError(".google.protobuf.FileDescriptorSet.file: array expected");
                    message.file = [];
                    for (var i = 0; i < object.file.length; ++i) {
                        if (typeof object.file[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorSet.file: object expected");
                        message.file[i] = $root.google.protobuf.FileDescriptorProto.fromObject(object.file[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a FileDescriptorSet message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.FileDescriptorSet
             * @static
             * @param {google.protobuf.FileDescriptorSet} message FileDescriptorSet
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileDescriptorSet.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.file = [];
                if (message.file && message.file.length) {
                    object.file = [];
                    for (var j = 0; j < message.file.length; ++j)
                        object.file[j] = $root.google.protobuf.FileDescriptorProto.toObject(message.file[j], options);
                }
                return object;
            };

            /**
             * Converts this FileDescriptorSet to JSON.
             * @function toJSON
             * @memberof google.protobuf.FileDescriptorSet
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileDescriptorSet.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FileDescriptorSet;
        })();

        protobuf.FileDescriptorProto = (function() {

            /**
             * Properties of a FileDescriptorProto.
             * @memberof google.protobuf
             * @interface IFileDescriptorProto
             * @property {string|null} [name] FileDescriptorProto name
             * @property {string|null} ["package"] FileDescriptorProto package
             * @property {Array.<string>|null} [dependency] FileDescriptorProto dependency
             * @property {Array.<number>|null} [publicDependency] FileDescriptorProto publicDependency
             * @property {Array.<number>|null} [weakDependency] FileDescriptorProto weakDependency
             * @property {Array.<google.protobuf.IDescriptorProto>|null} [messageType] FileDescriptorProto messageType
             * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] FileDescriptorProto enumType
             * @property {Array.<google.protobuf.IServiceDescriptorProto>|null} [service] FileDescriptorProto service
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] FileDescriptorProto extension
             * @property {google.protobuf.IFileOptions|null} [options] FileDescriptorProto options
             * @property {google.protobuf.ISourceCodeInfo|null} [sourceCodeInfo] FileDescriptorProto sourceCodeInfo
             * @property {string|null} [syntax] FileDescriptorProto syntax
             */

            /**
             * Constructs a new FileDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a FileDescriptorProto.
             * @implements IFileDescriptorProto
             * @constructor
             * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
             */
            function FileDescriptorProto(properties) {
                this.dependency = [];
                this.publicDependency = [];
                this.weakDependency = [];
                this.messageType = [];
                this.enumType = [];
                this.service = [];
                this.extension = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.name = "";

            /**
             * FileDescriptorProto package.
             * @member {string} package
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype["package"] = "";

            /**
             * FileDescriptorProto dependency.
             * @member {Array.<string>} dependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.dependency = $util.emptyArray;

            /**
             * FileDescriptorProto publicDependency.
             * @member {Array.<number>} publicDependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.publicDependency = $util.emptyArray;

            /**
             * FileDescriptorProto weakDependency.
             * @member {Array.<number>} weakDependency
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.weakDependency = $util.emptyArray;

            /**
             * FileDescriptorProto messageType.
             * @member {Array.<google.protobuf.IDescriptorProto>} messageType
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.messageType = $util.emptyArray;

            /**
             * FileDescriptorProto enumType.
             * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.enumType = $util.emptyArray;

            /**
             * FileDescriptorProto service.
             * @member {Array.<google.protobuf.IServiceDescriptorProto>} service
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.service = $util.emptyArray;

            /**
             * FileDescriptorProto extension.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.extension = $util.emptyArray;

            /**
             * FileDescriptorProto options.
             * @member {google.protobuf.IFileOptions|null|undefined} options
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.options = null;

            /**
             * FileDescriptorProto sourceCodeInfo.
             * @member {google.protobuf.ISourceCodeInfo|null|undefined} sourceCodeInfo
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.sourceCodeInfo = null;

            /**
             * FileDescriptorProto syntax.
             * @member {string} syntax
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             */
            FileDescriptorProto.prototype.syntax = "";

            /**
             * Creates a new FileDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto instance
             */
            FileDescriptorProto.create = function create(properties) {
                return new FileDescriptorProto(properties);
            };

            /**
             * Encodes the specified FileDescriptorProto message. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {google.protobuf.IFileDescriptorProto} message FileDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message["package"] != null && Object.hasOwnProperty.call(message, "package"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message["package"]);
                if (message.dependency != null && message.dependency.length)
                    for (var i = 0; i < message.dependency.length; ++i)
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.dependency[i]);
                if (message.messageType != null && message.messageType.length)
                    for (var i = 0; i < message.messageType.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(message.messageType[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.enumType != null && message.enumType.length)
                    for (var i = 0; i < message.enumType.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(message.enumType[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.service != null && message.service.length)
                    for (var i = 0; i < message.service.length; ++i)
                        $root.google.protobuf.ServiceDescriptorProto.encode(message.service[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.extension != null && message.extension.length)
                    for (var i = 0; i < message.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.FileOptions.encode(message.options, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.sourceCodeInfo != null && Object.hasOwnProperty.call(message, "sourceCodeInfo"))
                    $root.google.protobuf.SourceCodeInfo.encode(message.sourceCodeInfo, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.publicDependency != null && message.publicDependency.length)
                    for (var i = 0; i < message.publicDependency.length; ++i)
                        writer.uint32(/* id 10, wireType 0 =*/80).int32(message.publicDependency[i]);
                if (message.weakDependency != null && message.weakDependency.length)
                    for (var i = 0; i < message.weakDependency.length; ++i)
                        writer.uint32(/* id 11, wireType 0 =*/88).int32(message.weakDependency[i]);
                if (message.syntax != null && Object.hasOwnProperty.call(message, "syntax"))
                    writer.uint32(/* id 12, wireType 2 =*/98).string(message.syntax);
                return writer;
            };

            /**
             * Encodes the specified FileDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {google.protobuf.IFileDescriptorProto} message FileDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message["package"] = reader.string();
                        break;
                    case 3:
                        if (!(message.dependency && message.dependency.length))
                            message.dependency = [];
                        message.dependency.push(reader.string());
                        break;
                    case 10:
                        if (!(message.publicDependency && message.publicDependency.length))
                            message.publicDependency = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.publicDependency.push(reader.int32());
                        } else
                            message.publicDependency.push(reader.int32());
                        break;
                    case 11:
                        if (!(message.weakDependency && message.weakDependency.length))
                            message.weakDependency = [];
                        if ((tag & 7) === 2) {
                            var end2 = reader.uint32() + reader.pos;
                            while (reader.pos < end2)
                                message.weakDependency.push(reader.int32());
                        } else
                            message.weakDependency.push(reader.int32());
                        break;
                    case 4:
                        if (!(message.messageType && message.messageType.length))
                            message.messageType = [];
                        message.messageType.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.enumType && message.enumType.length))
                            message.enumType = [];
                        message.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.service && message.service.length))
                            message.service = [];
                        message.service.push($root.google.protobuf.ServiceDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        if (!(message.extension && message.extension.length))
                            message.extension = [];
                        message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        message.options = $root.google.protobuf.FileOptions.decode(reader, reader.uint32());
                        break;
                    case 9:
                        message.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.decode(reader, reader.uint32());
                        break;
                    case 12:
                        message.syntax = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileDescriptorProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileDescriptorProto message.
             * @function verify
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message["package"] != null && message.hasOwnProperty("package"))
                    if (!$util.isString(message["package"]))
                        return "package: string expected";
                if (message.dependency != null && message.hasOwnProperty("dependency")) {
                    if (!Array.isArray(message.dependency))
                        return "dependency: array expected";
                    for (var i = 0; i < message.dependency.length; ++i)
                        if (!$util.isString(message.dependency[i]))
                            return "dependency: string[] expected";
                }
                if (message.publicDependency != null && message.hasOwnProperty("publicDependency")) {
                    if (!Array.isArray(message.publicDependency))
                        return "publicDependency: array expected";
                    for (var i = 0; i < message.publicDependency.length; ++i)
                        if (!$util.isInteger(message.publicDependency[i]))
                            return "publicDependency: integer[] expected";
                }
                if (message.weakDependency != null && message.hasOwnProperty("weakDependency")) {
                    if (!Array.isArray(message.weakDependency))
                        return "weakDependency: array expected";
                    for (var i = 0; i < message.weakDependency.length; ++i)
                        if (!$util.isInteger(message.weakDependency[i]))
                            return "weakDependency: integer[] expected";
                }
                if (message.messageType != null && message.hasOwnProperty("messageType")) {
                    if (!Array.isArray(message.messageType))
                        return "messageType: array expected";
                    for (var i = 0; i < message.messageType.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.verify(message.messageType[i]);
                        if (error)
                            return "messageType." + error;
                    }
                }
                if (message.enumType != null && message.hasOwnProperty("enumType")) {
                    if (!Array.isArray(message.enumType))
                        return "enumType: array expected";
                    for (var i = 0; i < message.enumType.length; ++i) {
                        var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enumType[i]);
                        if (error)
                            return "enumType." + error;
                    }
                }
                if (message.service != null && message.hasOwnProperty("service")) {
                    if (!Array.isArray(message.service))
                        return "service: array expected";
                    for (var i = 0; i < message.service.length; ++i) {
                        var error = $root.google.protobuf.ServiceDescriptorProto.verify(message.service[i]);
                        if (error)
                            return "service." + error;
                    }
                }
                if (message.extension != null && message.hasOwnProperty("extension")) {
                    if (!Array.isArray(message.extension))
                        return "extension: array expected";
                    for (var i = 0; i < message.extension.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                        if (error)
                            return "extension." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.FileOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.sourceCodeInfo != null && message.hasOwnProperty("sourceCodeInfo")) {
                    var error = $root.google.protobuf.SourceCodeInfo.verify(message.sourceCodeInfo);
                    if (error)
                        return "sourceCodeInfo." + error;
                }
                if (message.syntax != null && message.hasOwnProperty("syntax"))
                    if (!$util.isString(message.syntax))
                        return "syntax: string expected";
                return null;
            };

            /**
             * Creates a FileDescriptorProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
             */
            FileDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.FileDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object["package"] != null)
                    message["package"] = String(object["package"]);
                if (object.dependency) {
                    if (!Array.isArray(object.dependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.dependency: array expected");
                    message.dependency = [];
                    for (var i = 0; i < object.dependency.length; ++i)
                        message.dependency[i] = String(object.dependency[i]);
                }
                if (object.publicDependency) {
                    if (!Array.isArray(object.publicDependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.publicDependency: array expected");
                    message.publicDependency = [];
                    for (var i = 0; i < object.publicDependency.length; ++i)
                        message.publicDependency[i] = object.publicDependency[i] | 0;
                }
                if (object.weakDependency) {
                    if (!Array.isArray(object.weakDependency))
                        throw TypeError(".google.protobuf.FileDescriptorProto.weakDependency: array expected");
                    message.weakDependency = [];
                    for (var i = 0; i < object.weakDependency.length; ++i)
                        message.weakDependency[i] = object.weakDependency[i] | 0;
                }
                if (object.messageType) {
                    if (!Array.isArray(object.messageType))
                        throw TypeError(".google.protobuf.FileDescriptorProto.messageType: array expected");
                    message.messageType = [];
                    for (var i = 0; i < object.messageType.length; ++i) {
                        if (typeof object.messageType[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.messageType: object expected");
                        message.messageType[i] = $root.google.protobuf.DescriptorProto.fromObject(object.messageType[i]);
                    }
                }
                if (object.enumType) {
                    if (!Array.isArray(object.enumType))
                        throw TypeError(".google.protobuf.FileDescriptorProto.enumType: array expected");
                    message.enumType = [];
                    for (var i = 0; i < object.enumType.length; ++i) {
                        if (typeof object.enumType[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.enumType: object expected");
                        message.enumType[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enumType[i]);
                    }
                }
                if (object.service) {
                    if (!Array.isArray(object.service))
                        throw TypeError(".google.protobuf.FileDescriptorProto.service: array expected");
                    message.service = [];
                    for (var i = 0; i < object.service.length; ++i) {
                        if (typeof object.service[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.service: object expected");
                        message.service[i] = $root.google.protobuf.ServiceDescriptorProto.fromObject(object.service[i]);
                    }
                }
                if (object.extension) {
                    if (!Array.isArray(object.extension))
                        throw TypeError(".google.protobuf.FileDescriptorProto.extension: array expected");
                    message.extension = [];
                    for (var i = 0; i < object.extension.length; ++i) {
                        if (typeof object.extension[i] !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.extension: object expected");
                        message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.FileDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.FileOptions.fromObject(object.options);
                }
                if (object.sourceCodeInfo != null) {
                    if (typeof object.sourceCodeInfo !== "object")
                        throw TypeError(".google.protobuf.FileDescriptorProto.sourceCodeInfo: object expected");
                    message.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.fromObject(object.sourceCodeInfo);
                }
                if (object.syntax != null)
                    message.syntax = String(object.syntax);
                return message;
            };

            /**
             * Creates a plain object from a FileDescriptorProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.FileDescriptorProto
             * @static
             * @param {google.protobuf.FileDescriptorProto} message FileDescriptorProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.dependency = [];
                    object.messageType = [];
                    object.enumType = [];
                    object.service = [];
                    object.extension = [];
                    object.publicDependency = [];
                    object.weakDependency = [];
                }
                if (options.defaults) {
                    object.name = "";
                    object["package"] = "";
                    object.options = null;
                    object.sourceCodeInfo = null;
                    object.syntax = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message["package"] != null && message.hasOwnProperty("package"))
                    object["package"] = message["package"];
                if (message.dependency && message.dependency.length) {
                    object.dependency = [];
                    for (var j = 0; j < message.dependency.length; ++j)
                        object.dependency[j] = message.dependency[j];
                }
                if (message.messageType && message.messageType.length) {
                    object.messageType = [];
                    for (var j = 0; j < message.messageType.length; ++j)
                        object.messageType[j] = $root.google.protobuf.DescriptorProto.toObject(message.messageType[j], options);
                }
                if (message.enumType && message.enumType.length) {
                    object.enumType = [];
                    for (var j = 0; j < message.enumType.length; ++j)
                        object.enumType[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enumType[j], options);
                }
                if (message.service && message.service.length) {
                    object.service = [];
                    for (var j = 0; j < message.service.length; ++j)
                        object.service[j] = $root.google.protobuf.ServiceDescriptorProto.toObject(message.service[j], options);
                }
                if (message.extension && message.extension.length) {
                    object.extension = [];
                    for (var j = 0; j < message.extension.length; ++j)
                        object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.FileOptions.toObject(message.options, options);
                if (message.sourceCodeInfo != null && message.hasOwnProperty("sourceCodeInfo"))
                    object.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.toObject(message.sourceCodeInfo, options);
                if (message.publicDependency && message.publicDependency.length) {
                    object.publicDependency = [];
                    for (var j = 0; j < message.publicDependency.length; ++j)
                        object.publicDependency[j] = message.publicDependency[j];
                }
                if (message.weakDependency && message.weakDependency.length) {
                    object.weakDependency = [];
                    for (var j = 0; j < message.weakDependency.length; ++j)
                        object.weakDependency[j] = message.weakDependency[j];
                }
                if (message.syntax != null && message.hasOwnProperty("syntax"))
                    object.syntax = message.syntax;
                return object;
            };

            /**
             * Converts this FileDescriptorProto to JSON.
             * @function toJSON
             * @memberof google.protobuf.FileDescriptorProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FileDescriptorProto;
        })();

        protobuf.DescriptorProto = (function() {

            /**
             * Properties of a DescriptorProto.
             * @memberof google.protobuf
             * @interface IDescriptorProto
             * @property {string|null} [name] DescriptorProto name
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [field] DescriptorProto field
             * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] DescriptorProto extension
             * @property {Array.<google.protobuf.IDescriptorProto>|null} [nestedType] DescriptorProto nestedType
             * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] DescriptorProto enumType
             * @property {Array.<google.protobuf.DescriptorProto.IExtensionRange>|null} [extensionRange] DescriptorProto extensionRange
             * @property {Array.<google.protobuf.IOneofDescriptorProto>|null} [oneofDecl] DescriptorProto oneofDecl
             * @property {google.protobuf.IMessageOptions|null} [options] DescriptorProto options
             * @property {Array.<google.protobuf.DescriptorProto.IReservedRange>|null} [reservedRange] DescriptorProto reservedRange
             * @property {Array.<string>|null} [reservedName] DescriptorProto reservedName
             */

            /**
             * Constructs a new DescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a DescriptorProto.
             * @implements IDescriptorProto
             * @constructor
             * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
             */
            function DescriptorProto(properties) {
                this.field = [];
                this.extension = [];
                this.nestedType = [];
                this.enumType = [];
                this.extensionRange = [];
                this.oneofDecl = [];
                this.reservedRange = [];
                this.reservedName = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * DescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.name = "";

            /**
             * DescriptorProto field.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} field
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.field = $util.emptyArray;

            /**
             * DescriptorProto extension.
             * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.extension = $util.emptyArray;

            /**
             * DescriptorProto nestedType.
             * @member {Array.<google.protobuf.IDescriptorProto>} nestedType
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.nestedType = $util.emptyArray;

            /**
             * DescriptorProto enumType.
             * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.enumType = $util.emptyArray;

            /**
             * DescriptorProto extensionRange.
             * @member {Array.<google.protobuf.DescriptorProto.IExtensionRange>} extensionRange
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.extensionRange = $util.emptyArray;

            /**
             * DescriptorProto oneofDecl.
             * @member {Array.<google.protobuf.IOneofDescriptorProto>} oneofDecl
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.oneofDecl = $util.emptyArray;

            /**
             * DescriptorProto options.
             * @member {google.protobuf.IMessageOptions|null|undefined} options
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.options = null;

            /**
             * DescriptorProto reservedRange.
             * @member {Array.<google.protobuf.DescriptorProto.IReservedRange>} reservedRange
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.reservedRange = $util.emptyArray;

            /**
             * DescriptorProto reservedName.
             * @member {Array.<string>} reservedName
             * @memberof google.protobuf.DescriptorProto
             * @instance
             */
            DescriptorProto.prototype.reservedName = $util.emptyArray;

            /**
             * Creates a new DescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.DescriptorProto} DescriptorProto instance
             */
            DescriptorProto.create = function create(properties) {
                return new DescriptorProto(properties);
            };

            /**
             * Encodes the specified DescriptorProto message. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {google.protobuf.IDescriptorProto} message DescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.field != null && message.field.length)
                    for (var i = 0; i < message.field.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.field[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.nestedType != null && message.nestedType.length)
                    for (var i = 0; i < message.nestedType.length; ++i)
                        $root.google.protobuf.DescriptorProto.encode(message.nestedType[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                if (message.enumType != null && message.enumType.length)
                    for (var i = 0; i < message.enumType.length; ++i)
                        $root.google.protobuf.EnumDescriptorProto.encode(message.enumType[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.extensionRange != null && message.extensionRange.length)
                    for (var i = 0; i < message.extensionRange.length; ++i)
                        $root.google.protobuf.DescriptorProto.ExtensionRange.encode(message.extensionRange[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                if (message.extension != null && message.extension.length)
                    for (var i = 0; i < message.extension.length; ++i)
                        $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.MessageOptions.encode(message.options, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                if (message.oneofDecl != null && message.oneofDecl.length)
                    for (var i = 0; i < message.oneofDecl.length; ++i)
                        $root.google.protobuf.OneofDescriptorProto.encode(message.oneofDecl[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.reservedRange != null && message.reservedRange.length)
                    for (var i = 0; i < message.reservedRange.length; ++i)
                        $root.google.protobuf.DescriptorProto.ReservedRange.encode(message.reservedRange[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                if (message.reservedName != null && message.reservedName.length)
                    for (var i = 0; i < message.reservedName.length; ++i)
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.reservedName[i]);
                return writer;
            };

            /**
             * Encodes the specified DescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {google.protobuf.IDescriptorProto} message DescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            DescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a DescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.DescriptorProto} DescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.field && message.field.length))
                            message.field = [];
                        message.field.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 6:
                        if (!(message.extension && message.extension.length))
                            message.extension = [];
                        message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        if (!(message.nestedType && message.nestedType.length))
                            message.nestedType = [];
                        message.nestedType.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 4:
                        if (!(message.enumType && message.enumType.length))
                            message.enumType = [];
                        message.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 5:
                        if (!(message.extensionRange && message.extensionRange.length))
                            message.extensionRange = [];
                        message.extensionRange.push($root.google.protobuf.DescriptorProto.ExtensionRange.decode(reader, reader.uint32()));
                        break;
                    case 8:
                        if (!(message.oneofDecl && message.oneofDecl.length))
                            message.oneofDecl = [];
                        message.oneofDecl.push($root.google.protobuf.OneofDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 7:
                        message.options = $root.google.protobuf.MessageOptions.decode(reader, reader.uint32());
                        break;
                    case 9:
                        if (!(message.reservedRange && message.reservedRange.length))
                            message.reservedRange = [];
                        message.reservedRange.push($root.google.protobuf.DescriptorProto.ReservedRange.decode(reader, reader.uint32()));
                        break;
                    case 10:
                        if (!(message.reservedName && message.reservedName.length))
                            message.reservedName = [];
                        message.reservedName.push(reader.string());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a DescriptorProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.DescriptorProto} DescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            DescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a DescriptorProto message.
             * @function verify
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            DescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.field != null && message.hasOwnProperty("field")) {
                    if (!Array.isArray(message.field))
                        return "field: array expected";
                    for (var i = 0; i < message.field.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.field[i]);
                        if (error)
                            return "field." + error;
                    }
                }
                if (message.extension != null && message.hasOwnProperty("extension")) {
                    if (!Array.isArray(message.extension))
                        return "extension: array expected";
                    for (var i = 0; i < message.extension.length; ++i) {
                        var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                        if (error)
                            return "extension." + error;
                    }
                }
                if (message.nestedType != null && message.hasOwnProperty("nestedType")) {
                    if (!Array.isArray(message.nestedType))
                        return "nestedType: array expected";
                    for (var i = 0; i < message.nestedType.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.verify(message.nestedType[i]);
                        if (error)
                            return "nestedType." + error;
                    }
                }
                if (message.enumType != null && message.hasOwnProperty("enumType")) {
                    if (!Array.isArray(message.enumType))
                        return "enumType: array expected";
                    for (var i = 0; i < message.enumType.length; ++i) {
                        var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enumType[i]);
                        if (error)
                            return "enumType." + error;
                    }
                }
                if (message.extensionRange != null && message.hasOwnProperty("extensionRange")) {
                    if (!Array.isArray(message.extensionRange))
                        return "extensionRange: array expected";
                    for (var i = 0; i < message.extensionRange.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.ExtensionRange.verify(message.extensionRange[i]);
                        if (error)
                            return "extensionRange." + error;
                    }
                }
                if (message.oneofDecl != null && message.hasOwnProperty("oneofDecl")) {
                    if (!Array.isArray(message.oneofDecl))
                        return "oneofDecl: array expected";
                    for (var i = 0; i < message.oneofDecl.length; ++i) {
                        var error = $root.google.protobuf.OneofDescriptorProto.verify(message.oneofDecl[i]);
                        if (error)
                            return "oneofDecl." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.MessageOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.reservedRange != null && message.hasOwnProperty("reservedRange")) {
                    if (!Array.isArray(message.reservedRange))
                        return "reservedRange: array expected";
                    for (var i = 0; i < message.reservedRange.length; ++i) {
                        var error = $root.google.protobuf.DescriptorProto.ReservedRange.verify(message.reservedRange[i]);
                        if (error)
                            return "reservedRange." + error;
                    }
                }
                if (message.reservedName != null && message.hasOwnProperty("reservedName")) {
                    if (!Array.isArray(message.reservedName))
                        return "reservedName: array expected";
                    for (var i = 0; i < message.reservedName.length; ++i)
                        if (!$util.isString(message.reservedName[i]))
                            return "reservedName: string[] expected";
                }
                return null;
            };

            /**
             * Creates a DescriptorProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.DescriptorProto} DescriptorProto
             */
            DescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.DescriptorProto)
                    return object;
                var message = new $root.google.protobuf.DescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.field) {
                    if (!Array.isArray(object.field))
                        throw TypeError(".google.protobuf.DescriptorProto.field: array expected");
                    message.field = [];
                    for (var i = 0; i < object.field.length; ++i) {
                        if (typeof object.field[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.field: object expected");
                        message.field[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.field[i]);
                    }
                }
                if (object.extension) {
                    if (!Array.isArray(object.extension))
                        throw TypeError(".google.protobuf.DescriptorProto.extension: array expected");
                    message.extension = [];
                    for (var i = 0; i < object.extension.length; ++i) {
                        if (typeof object.extension[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.extension: object expected");
                        message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                    }
                }
                if (object.nestedType) {
                    if (!Array.isArray(object.nestedType))
                        throw TypeError(".google.protobuf.DescriptorProto.nestedType: array expected");
                    message.nestedType = [];
                    for (var i = 0; i < object.nestedType.length; ++i) {
                        if (typeof object.nestedType[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.nestedType: object expected");
                        message.nestedType[i] = $root.google.protobuf.DescriptorProto.fromObject(object.nestedType[i]);
                    }
                }
                if (object.enumType) {
                    if (!Array.isArray(object.enumType))
                        throw TypeError(".google.protobuf.DescriptorProto.enumType: array expected");
                    message.enumType = [];
                    for (var i = 0; i < object.enumType.length; ++i) {
                        if (typeof object.enumType[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.enumType: object expected");
                        message.enumType[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enumType[i]);
                    }
                }
                if (object.extensionRange) {
                    if (!Array.isArray(object.extensionRange))
                        throw TypeError(".google.protobuf.DescriptorProto.extensionRange: array expected");
                    message.extensionRange = [];
                    for (var i = 0; i < object.extensionRange.length; ++i) {
                        if (typeof object.extensionRange[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.extensionRange: object expected");
                        message.extensionRange[i] = $root.google.protobuf.DescriptorProto.ExtensionRange.fromObject(object.extensionRange[i]);
                    }
                }
                if (object.oneofDecl) {
                    if (!Array.isArray(object.oneofDecl))
                        throw TypeError(".google.protobuf.DescriptorProto.oneofDecl: array expected");
                    message.oneofDecl = [];
                    for (var i = 0; i < object.oneofDecl.length; ++i) {
                        if (typeof object.oneofDecl[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.oneofDecl: object expected");
                        message.oneofDecl[i] = $root.google.protobuf.OneofDescriptorProto.fromObject(object.oneofDecl[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.DescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.MessageOptions.fromObject(object.options);
                }
                if (object.reservedRange) {
                    if (!Array.isArray(object.reservedRange))
                        throw TypeError(".google.protobuf.DescriptorProto.reservedRange: array expected");
                    message.reservedRange = [];
                    for (var i = 0; i < object.reservedRange.length; ++i) {
                        if (typeof object.reservedRange[i] !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.reservedRange: object expected");
                        message.reservedRange[i] = $root.google.protobuf.DescriptorProto.ReservedRange.fromObject(object.reservedRange[i]);
                    }
                }
                if (object.reservedName) {
                    if (!Array.isArray(object.reservedName))
                        throw TypeError(".google.protobuf.DescriptorProto.reservedName: array expected");
                    message.reservedName = [];
                    for (var i = 0; i < object.reservedName.length; ++i)
                        message.reservedName[i] = String(object.reservedName[i]);
                }
                return message;
            };

            /**
             * Creates a plain object from a DescriptorProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.DescriptorProto
             * @static
             * @param {google.protobuf.DescriptorProto} message DescriptorProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            DescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults) {
                    object.field = [];
                    object.nestedType = [];
                    object.enumType = [];
                    object.extensionRange = [];
                    object.extension = [];
                    object.oneofDecl = [];
                    object.reservedRange = [];
                    object.reservedName = [];
                }
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.field && message.field.length) {
                    object.field = [];
                    for (var j = 0; j < message.field.length; ++j)
                        object.field[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.field[j], options);
                }
                if (message.nestedType && message.nestedType.length) {
                    object.nestedType = [];
                    for (var j = 0; j < message.nestedType.length; ++j)
                        object.nestedType[j] = $root.google.protobuf.DescriptorProto.toObject(message.nestedType[j], options);
                }
                if (message.enumType && message.enumType.length) {
                    object.enumType = [];
                    for (var j = 0; j < message.enumType.length; ++j)
                        object.enumType[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enumType[j], options);
                }
                if (message.extensionRange && message.extensionRange.length) {
                    object.extensionRange = [];
                    for (var j = 0; j < message.extensionRange.length; ++j)
                        object.extensionRange[j] = $root.google.protobuf.DescriptorProto.ExtensionRange.toObject(message.extensionRange[j], options);
                }
                if (message.extension && message.extension.length) {
                    object.extension = [];
                    for (var j = 0; j < message.extension.length; ++j)
                        object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.MessageOptions.toObject(message.options, options);
                if (message.oneofDecl && message.oneofDecl.length) {
                    object.oneofDecl = [];
                    for (var j = 0; j < message.oneofDecl.length; ++j)
                        object.oneofDecl[j] = $root.google.protobuf.OneofDescriptorProto.toObject(message.oneofDecl[j], options);
                }
                if (message.reservedRange && message.reservedRange.length) {
                    object.reservedRange = [];
                    for (var j = 0; j < message.reservedRange.length; ++j)
                        object.reservedRange[j] = $root.google.protobuf.DescriptorProto.ReservedRange.toObject(message.reservedRange[j], options);
                }
                if (message.reservedName && message.reservedName.length) {
                    object.reservedName = [];
                    for (var j = 0; j < message.reservedName.length; ++j)
                        object.reservedName[j] = message.reservedName[j];
                }
                return object;
            };

            /**
             * Converts this DescriptorProto to JSON.
             * @function toJSON
             * @memberof google.protobuf.DescriptorProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            DescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            DescriptorProto.ExtensionRange = (function() {

                /**
                 * Properties of an ExtensionRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @interface IExtensionRange
                 * @property {number|null} [start] ExtensionRange start
                 * @property {number|null} [end] ExtensionRange end
                 */

                /**
                 * Constructs a new ExtensionRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @classdesc Represents an ExtensionRange.
                 * @implements IExtensionRange
                 * @constructor
                 * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
                 */
                function ExtensionRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ExtensionRange start.
                 * @member {number} start
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @instance
                 */
                ExtensionRange.prototype.start = 0;

                /**
                 * ExtensionRange end.
                 * @member {number} end
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @instance
                 */
                ExtensionRange.prototype.end = 0;

                /**
                 * Creates a new ExtensionRange instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
                 * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange instance
                 */
                ExtensionRange.create = function create(properties) {
                    return new ExtensionRange(properties);
                };

                /**
                 * Encodes the specified ExtensionRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IExtensionRange} message ExtensionRange message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExtensionRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.end);
                    return writer;
                };

                /**
                 * Encodes the specified ExtensionRange message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IExtensionRange} message ExtensionRange message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ExtensionRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an ExtensionRange message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExtensionRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int32();
                            break;
                        case 2:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an ExtensionRange message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ExtensionRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an ExtensionRange message.
                 * @function verify
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ExtensionRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                /**
                 * Creates an ExtensionRange message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                 */
                ExtensionRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto.ExtensionRange)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                    if (object.start != null)
                        message.start = object.start | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                /**
                 * Creates a plain object from an ExtensionRange message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.ExtensionRange} message ExtensionRange
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ExtensionRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                /**
                 * Converts this ExtensionRange to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.DescriptorProto.ExtensionRange
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ExtensionRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ExtensionRange;
            })();

            DescriptorProto.ReservedRange = (function() {

                /**
                 * Properties of a ReservedRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @interface IReservedRange
                 * @property {number|null} [start] ReservedRange start
                 * @property {number|null} [end] ReservedRange end
                 */

                /**
                 * Constructs a new ReservedRange.
                 * @memberof google.protobuf.DescriptorProto
                 * @classdesc Represents a ReservedRange.
                 * @implements IReservedRange
                 * @constructor
                 * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
                 */
                function ReservedRange(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * ReservedRange start.
                 * @member {number} start
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @instance
                 */
                ReservedRange.prototype.start = 0;

                /**
                 * ReservedRange end.
                 * @member {number} end
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @instance
                 */
                ReservedRange.prototype.end = 0;

                /**
                 * Creates a new ReservedRange instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
                 * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange instance
                 */
                ReservedRange.create = function create(properties) {
                    return new ReservedRange(properties);
                };

                /**
                 * Encodes the specified ReservedRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IReservedRange} message ReservedRange message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReservedRange.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.start);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.end);
                    return writer;
                };

                /**
                 * Encodes the specified ReservedRange message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.IReservedRange} message ReservedRange message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ReservedRange.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a ReservedRange message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReservedRange.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.start = reader.int32();
                            break;
                        case 2:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a ReservedRange message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ReservedRange.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a ReservedRange message.
                 * @function verify
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ReservedRange.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.start != null && message.hasOwnProperty("start"))
                        if (!$util.isInteger(message.start))
                            return "start: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                /**
                 * Creates a ReservedRange message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                 */
                ReservedRange.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto.ReservedRange)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                    if (object.start != null)
                        message.start = object.start | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                /**
                 * Creates a plain object from a ReservedRange message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @static
                 * @param {google.protobuf.DescriptorProto.ReservedRange} message ReservedRange
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ReservedRange.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.start = 0;
                        object.end = 0;
                    }
                    if (message.start != null && message.hasOwnProperty("start"))
                        object.start = message.start;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                /**
                 * Converts this ReservedRange to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.DescriptorProto.ReservedRange
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ReservedRange.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return ReservedRange;
            })();

            return DescriptorProto;
        })();

        protobuf.FieldDescriptorProto = (function() {

            /**
             * Properties of a FieldDescriptorProto.
             * @memberof google.protobuf
             * @interface IFieldDescriptorProto
             * @property {string|null} [name] FieldDescriptorProto name
             * @property {number|null} [number] FieldDescriptorProto number
             * @property {google.protobuf.FieldDescriptorProto.Label|null} [label] FieldDescriptorProto label
             * @property {google.protobuf.FieldDescriptorProto.Type|null} [type] FieldDescriptorProto type
             * @property {string|null} [typeName] FieldDescriptorProto typeName
             * @property {string|null} [extendee] FieldDescriptorProto extendee
             * @property {string|null} [defaultValue] FieldDescriptorProto defaultValue
             * @property {number|null} [oneofIndex] FieldDescriptorProto oneofIndex
             * @property {string|null} [jsonName] FieldDescriptorProto jsonName
             * @property {google.protobuf.IFieldOptions|null} [options] FieldDescriptorProto options
             */

            /**
             * Constructs a new FieldDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a FieldDescriptorProto.
             * @implements IFieldDescriptorProto
             * @constructor
             * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
             */
            function FieldDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FieldDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.name = "";

            /**
             * FieldDescriptorProto number.
             * @member {number} number
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.number = 0;

            /**
             * FieldDescriptorProto label.
             * @member {google.protobuf.FieldDescriptorProto.Label} label
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.label = 1;

            /**
             * FieldDescriptorProto type.
             * @member {google.protobuf.FieldDescriptorProto.Type} type
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.type = 1;

            /**
             * FieldDescriptorProto typeName.
             * @member {string} typeName
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.typeName = "";

            /**
             * FieldDescriptorProto extendee.
             * @member {string} extendee
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.extendee = "";

            /**
             * FieldDescriptorProto defaultValue.
             * @member {string} defaultValue
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.defaultValue = "";

            /**
             * FieldDescriptorProto oneofIndex.
             * @member {number} oneofIndex
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.oneofIndex = 0;

            /**
             * FieldDescriptorProto jsonName.
             * @member {string} jsonName
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.jsonName = "";

            /**
             * FieldDescriptorProto options.
             * @member {google.protobuf.IFieldOptions|null|undefined} options
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             */
            FieldDescriptorProto.prototype.options = null;

            /**
             * Creates a new FieldDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto instance
             */
            FieldDescriptorProto.create = function create(properties) {
                return new FieldDescriptorProto(properties);
            };

            /**
             * Encodes the specified FieldDescriptorProto message. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {google.protobuf.IFieldDescriptorProto} message FieldDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.extendee != null && Object.hasOwnProperty.call(message, "extendee"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.extendee);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.number);
                if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int32(message.label);
                if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                if (message.typeName != null && Object.hasOwnProperty.call(message, "typeName"))
                    writer.uint32(/* id 6, wireType 2 =*/50).string(message.typeName);
                if (message.defaultValue != null && Object.hasOwnProperty.call(message, "defaultValue"))
                    writer.uint32(/* id 7, wireType 2 =*/58).string(message.defaultValue);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.FieldOptions.encode(message.options, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                if (message.oneofIndex != null && Object.hasOwnProperty.call(message, "oneofIndex"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.oneofIndex);
                if (message.jsonName != null && Object.hasOwnProperty.call(message, "jsonName"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.jsonName);
                return writer;
            };

            /**
             * Encodes the specified FieldDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {google.protobuf.IFieldDescriptorProto} message FieldDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FieldDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 3:
                        message.number = reader.int32();
                        break;
                    case 4:
                        message.label = reader.int32();
                        break;
                    case 5:
                        message.type = reader.int32();
                        break;
                    case 6:
                        message.typeName = reader.string();
                        break;
                    case 2:
                        message.extendee = reader.string();
                        break;
                    case 7:
                        message.defaultValue = reader.string();
                        break;
                    case 9:
                        message.oneofIndex = reader.int32();
                        break;
                    case 10:
                        message.jsonName = reader.string();
                        break;
                    case 8:
                        message.options = $root.google.protobuf.FieldOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FieldDescriptorProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FieldDescriptorProto message.
             * @function verify
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FieldDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                if (message.label != null && message.hasOwnProperty("label"))
                    switch (message.label) {
                    default:
                        return "label: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.type != null && message.hasOwnProperty("type"))
                    switch (message.type) {
                    default:
                        return "type: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 17:
                    case 18:
                        break;
                    }
                if (message.typeName != null && message.hasOwnProperty("typeName"))
                    if (!$util.isString(message.typeName))
                        return "typeName: string expected";
                if (message.extendee != null && message.hasOwnProperty("extendee"))
                    if (!$util.isString(message.extendee))
                        return "extendee: string expected";
                if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
                    if (!$util.isString(message.defaultValue))
                        return "defaultValue: string expected";
                if (message.oneofIndex != null && message.hasOwnProperty("oneofIndex"))
                    if (!$util.isInteger(message.oneofIndex))
                        return "oneofIndex: integer expected";
                if (message.jsonName != null && message.hasOwnProperty("jsonName"))
                    if (!$util.isString(message.jsonName))
                        return "jsonName: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.FieldOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            /**
             * Creates a FieldDescriptorProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
             */
            FieldDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FieldDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.FieldDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.number != null)
                    message.number = object.number | 0;
                switch (object.label) {
                case "LABEL_OPTIONAL":
                case 1:
                    message.label = 1;
                    break;
                case "LABEL_REQUIRED":
                case 2:
                    message.label = 2;
                    break;
                case "LABEL_REPEATED":
                case 3:
                    message.label = 3;
                    break;
                }
                switch (object.type) {
                case "TYPE_DOUBLE":
                case 1:
                    message.type = 1;
                    break;
                case "TYPE_FLOAT":
                case 2:
                    message.type = 2;
                    break;
                case "TYPE_INT64":
                case 3:
                    message.type = 3;
                    break;
                case "TYPE_UINT64":
                case 4:
                    message.type = 4;
                    break;
                case "TYPE_INT32":
                case 5:
                    message.type = 5;
                    break;
                case "TYPE_FIXED64":
                case 6:
                    message.type = 6;
                    break;
                case "TYPE_FIXED32":
                case 7:
                    message.type = 7;
                    break;
                case "TYPE_BOOL":
                case 8:
                    message.type = 8;
                    break;
                case "TYPE_STRING":
                case 9:
                    message.type = 9;
                    break;
                case "TYPE_GROUP":
                case 10:
                    message.type = 10;
                    break;
                case "TYPE_MESSAGE":
                case 11:
                    message.type = 11;
                    break;
                case "TYPE_BYTES":
                case 12:
                    message.type = 12;
                    break;
                case "TYPE_UINT32":
                case 13:
                    message.type = 13;
                    break;
                case "TYPE_ENUM":
                case 14:
                    message.type = 14;
                    break;
                case "TYPE_SFIXED32":
                case 15:
                    message.type = 15;
                    break;
                case "TYPE_SFIXED64":
                case 16:
                    message.type = 16;
                    break;
                case "TYPE_SINT32":
                case 17:
                    message.type = 17;
                    break;
                case "TYPE_SINT64":
                case 18:
                    message.type = 18;
                    break;
                }
                if (object.typeName != null)
                    message.typeName = String(object.typeName);
                if (object.extendee != null)
                    message.extendee = String(object.extendee);
                if (object.defaultValue != null)
                    message.defaultValue = String(object.defaultValue);
                if (object.oneofIndex != null)
                    message.oneofIndex = object.oneofIndex | 0;
                if (object.jsonName != null)
                    message.jsonName = String(object.jsonName);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.FieldDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.FieldOptions.fromObject(object.options);
                }
                return message;
            };

            /**
             * Creates a plain object from a FieldDescriptorProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.FieldDescriptorProto
             * @static
             * @param {google.protobuf.FieldDescriptorProto} message FieldDescriptorProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FieldDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.extendee = "";
                    object.number = 0;
                    object.label = options.enums === String ? "LABEL_OPTIONAL" : 1;
                    object.type = options.enums === String ? "TYPE_DOUBLE" : 1;
                    object.typeName = "";
                    object.defaultValue = "";
                    object.options = null;
                    object.oneofIndex = 0;
                    object.jsonName = "";
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.extendee != null && message.hasOwnProperty("extendee"))
                    object.extendee = message.extendee;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.label != null && message.hasOwnProperty("label"))
                    object.label = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Label[message.label] : message.label;
                if (message.type != null && message.hasOwnProperty("type"))
                    object.type = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Type[message.type] : message.type;
                if (message.typeName != null && message.hasOwnProperty("typeName"))
                    object.typeName = message.typeName;
                if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
                    object.defaultValue = message.defaultValue;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.FieldOptions.toObject(message.options, options);
                if (message.oneofIndex != null && message.hasOwnProperty("oneofIndex"))
                    object.oneofIndex = message.oneofIndex;
                if (message.jsonName != null && message.hasOwnProperty("jsonName"))
                    object.jsonName = message.jsonName;
                return object;
            };

            /**
             * Converts this FieldDescriptorProto to JSON.
             * @function toJSON
             * @memberof google.protobuf.FieldDescriptorProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FieldDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Type enum.
             * @name google.protobuf.FieldDescriptorProto.Type
             * @enum {number}
             * @property {number} TYPE_DOUBLE=1 TYPE_DOUBLE value
             * @property {number} TYPE_FLOAT=2 TYPE_FLOAT value
             * @property {number} TYPE_INT64=3 TYPE_INT64 value
             * @property {number} TYPE_UINT64=4 TYPE_UINT64 value
             * @property {number} TYPE_INT32=5 TYPE_INT32 value
             * @property {number} TYPE_FIXED64=6 TYPE_FIXED64 value
             * @property {number} TYPE_FIXED32=7 TYPE_FIXED32 value
             * @property {number} TYPE_BOOL=8 TYPE_BOOL value
             * @property {number} TYPE_STRING=9 TYPE_STRING value
             * @property {number} TYPE_GROUP=10 TYPE_GROUP value
             * @property {number} TYPE_MESSAGE=11 TYPE_MESSAGE value
             * @property {number} TYPE_BYTES=12 TYPE_BYTES value
             * @property {number} TYPE_UINT32=13 TYPE_UINT32 value
             * @property {number} TYPE_ENUM=14 TYPE_ENUM value
             * @property {number} TYPE_SFIXED32=15 TYPE_SFIXED32 value
             * @property {number} TYPE_SFIXED64=16 TYPE_SFIXED64 value
             * @property {number} TYPE_SINT32=17 TYPE_SINT32 value
             * @property {number} TYPE_SINT64=18 TYPE_SINT64 value
             */
            FieldDescriptorProto.Type = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "TYPE_DOUBLE"] = 1;
                values[valuesById[2] = "TYPE_FLOAT"] = 2;
                values[valuesById[3] = "TYPE_INT64"] = 3;
                values[valuesById[4] = "TYPE_UINT64"] = 4;
                values[valuesById[5] = "TYPE_INT32"] = 5;
                values[valuesById[6] = "TYPE_FIXED64"] = 6;
                values[valuesById[7] = "TYPE_FIXED32"] = 7;
                values[valuesById[8] = "TYPE_BOOL"] = 8;
                values[valuesById[9] = "TYPE_STRING"] = 9;
                values[valuesById[10] = "TYPE_GROUP"] = 10;
                values[valuesById[11] = "TYPE_MESSAGE"] = 11;
                values[valuesById[12] = "TYPE_BYTES"] = 12;
                values[valuesById[13] = "TYPE_UINT32"] = 13;
                values[valuesById[14] = "TYPE_ENUM"] = 14;
                values[valuesById[15] = "TYPE_SFIXED32"] = 15;
                values[valuesById[16] = "TYPE_SFIXED64"] = 16;
                values[valuesById[17] = "TYPE_SINT32"] = 17;
                values[valuesById[18] = "TYPE_SINT64"] = 18;
                return values;
            })();

            /**
             * Label enum.
             * @name google.protobuf.FieldDescriptorProto.Label
             * @enum {number}
             * @property {number} LABEL_OPTIONAL=1 LABEL_OPTIONAL value
             * @property {number} LABEL_REQUIRED=2 LABEL_REQUIRED value
             * @property {number} LABEL_REPEATED=3 LABEL_REPEATED value
             */
            FieldDescriptorProto.Label = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "LABEL_OPTIONAL"] = 1;
                values[valuesById[2] = "LABEL_REQUIRED"] = 2;
                values[valuesById[3] = "LABEL_REPEATED"] = 3;
                return values;
            })();

            return FieldDescriptorProto;
        })();

        protobuf.OneofDescriptorProto = (function() {

            /**
             * Properties of an OneofDescriptorProto.
             * @memberof google.protobuf
             * @interface IOneofDescriptorProto
             * @property {string|null} [name] OneofDescriptorProto name
             * @property {google.protobuf.IOneofOptions|null} [options] OneofDescriptorProto options
             */

            /**
             * Constructs a new OneofDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an OneofDescriptorProto.
             * @implements IOneofDescriptorProto
             * @constructor
             * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
             */
            function OneofDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OneofDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.OneofDescriptorProto
             * @instance
             */
            OneofDescriptorProto.prototype.name = "";

            /**
             * OneofDescriptorProto options.
             * @member {google.protobuf.IOneofOptions|null|undefined} options
             * @memberof google.protobuf.OneofDescriptorProto
             * @instance
             */
            OneofDescriptorProto.prototype.options = null;

            /**
             * Creates a new OneofDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto instance
             */
            OneofDescriptorProto.create = function create(properties) {
                return new OneofDescriptorProto(properties);
            };

            /**
             * Encodes the specified OneofDescriptorProto message. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {google.protobuf.IOneofDescriptorProto} message OneofDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OneofDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.OneofOptions.encode(message.options, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OneofDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {google.protobuf.IOneofDescriptorProto} message OneofDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OneofDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OneofDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OneofDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.options = $root.google.protobuf.OneofOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OneofDescriptorProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OneofDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OneofDescriptorProto message.
             * @function verify
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OneofDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.OneofOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            /**
             * Creates an OneofDescriptorProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
             */
            OneofDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.OneofDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.OneofDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.OneofDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.OneofOptions.fromObject(object.options);
                }
                return message;
            };

            /**
             * Creates a plain object from an OneofDescriptorProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.OneofDescriptorProto
             * @static
             * @param {google.protobuf.OneofDescriptorProto} message OneofDescriptorProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OneofDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.OneofOptions.toObject(message.options, options);
                return object;
            };

            /**
             * Converts this OneofDescriptorProto to JSON.
             * @function toJSON
             * @memberof google.protobuf.OneofDescriptorProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OneofDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OneofDescriptorProto;
        })();

        protobuf.EnumDescriptorProto = (function() {

            /**
             * Properties of an EnumDescriptorProto.
             * @memberof google.protobuf
             * @interface IEnumDescriptorProto
             * @property {string|null} [name] EnumDescriptorProto name
             * @property {Array.<google.protobuf.IEnumValueDescriptorProto>|null} [value] EnumDescriptorProto value
             * @property {google.protobuf.IEnumOptions|null} [options] EnumDescriptorProto options
             */

            /**
             * Constructs a new EnumDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an EnumDescriptorProto.
             * @implements IEnumDescriptorProto
             * @constructor
             * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
             */
            function EnumDescriptorProto(properties) {
                this.value = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EnumDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.name = "";

            /**
             * EnumDescriptorProto value.
             * @member {Array.<google.protobuf.IEnumValueDescriptorProto>} value
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.value = $util.emptyArray;

            /**
             * EnumDescriptorProto options.
             * @member {google.protobuf.IEnumOptions|null|undefined} options
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             */
            EnumDescriptorProto.prototype.options = null;

            /**
             * Creates a new EnumDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto instance
             */
            EnumDescriptorProto.create = function create(properties) {
                return new EnumDescriptorProto(properties);
            };

            /**
             * Encodes the specified EnumDescriptorProto message. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {google.protobuf.IEnumDescriptorProto} message EnumDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.value != null && message.value.length)
                    for (var i = 0; i < message.value.length; ++i)
                        $root.google.protobuf.EnumValueDescriptorProto.encode(message.value[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.EnumOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified EnumDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {google.protobuf.IEnumDescriptorProto} message EnumDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EnumDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.value && message.value.length))
                            message.value = [];
                        message.value.push($root.google.protobuf.EnumValueDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.options = $root.google.protobuf.EnumOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EnumDescriptorProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EnumDescriptorProto message.
             * @function verify
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EnumDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.value != null && message.hasOwnProperty("value")) {
                    if (!Array.isArray(message.value))
                        return "value: array expected";
                    for (var i = 0; i < message.value.length; ++i) {
                        var error = $root.google.protobuf.EnumValueDescriptorProto.verify(message.value[i]);
                        if (error)
                            return "value." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.EnumOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            /**
             * Creates an EnumDescriptorProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
             */
            EnumDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.EnumDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.value) {
                    if (!Array.isArray(object.value))
                        throw TypeError(".google.protobuf.EnumDescriptorProto.value: array expected");
                    message.value = [];
                    for (var i = 0; i < object.value.length; ++i) {
                        if (typeof object.value[i] !== "object")
                            throw TypeError(".google.protobuf.EnumDescriptorProto.value: object expected");
                        message.value[i] = $root.google.protobuf.EnumValueDescriptorProto.fromObject(object.value[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.EnumDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.EnumOptions.fromObject(object.options);
                }
                return message;
            };

            /**
             * Creates a plain object from an EnumDescriptorProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.EnumDescriptorProto
             * @static
             * @param {google.protobuf.EnumDescriptorProto} message EnumDescriptorProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EnumDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.value = [];
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.value && message.value.length) {
                    object.value = [];
                    for (var j = 0; j < message.value.length; ++j)
                        object.value[j] = $root.google.protobuf.EnumValueDescriptorProto.toObject(message.value[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.EnumOptions.toObject(message.options, options);
                return object;
            };

            /**
             * Converts this EnumDescriptorProto to JSON.
             * @function toJSON
             * @memberof google.protobuf.EnumDescriptorProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EnumDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumDescriptorProto;
        })();

        protobuf.EnumValueDescriptorProto = (function() {

            /**
             * Properties of an EnumValueDescriptorProto.
             * @memberof google.protobuf
             * @interface IEnumValueDescriptorProto
             * @property {string|null} [name] EnumValueDescriptorProto name
             * @property {number|null} [number] EnumValueDescriptorProto number
             * @property {google.protobuf.IEnumValueOptions|null} [options] EnumValueDescriptorProto options
             */

            /**
             * Constructs a new EnumValueDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents an EnumValueDescriptorProto.
             * @implements IEnumValueDescriptorProto
             * @constructor
             * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
             */
            function EnumValueDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EnumValueDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.name = "";

            /**
             * EnumValueDescriptorProto number.
             * @member {number} number
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.number = 0;

            /**
             * EnumValueDescriptorProto options.
             * @member {google.protobuf.IEnumValueOptions|null|undefined} options
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             */
            EnumValueDescriptorProto.prototype.options = null;

            /**
             * Creates a new EnumValueDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto instance
             */
            EnumValueDescriptorProto.create = function create(properties) {
                return new EnumValueDescriptorProto(properties);
            };

            /**
             * Encodes the specified EnumValueDescriptorProto message. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {google.protobuf.IEnumValueDescriptorProto} message EnumValueDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumValueDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.number);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.EnumValueOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified EnumValueDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {google.protobuf.IEnumValueDescriptorProto} message EnumValueDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumValueDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EnumValueDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumValueDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.number = reader.int32();
                        break;
                    case 3:
                        message.options = $root.google.protobuf.EnumValueOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EnumValueDescriptorProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumValueDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EnumValueDescriptorProto message.
             * @function verify
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EnumValueDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.number != null && message.hasOwnProperty("number"))
                    if (!$util.isInteger(message.number))
                        return "number: integer expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.EnumValueOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            /**
             * Creates an EnumValueDescriptorProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
             */
            EnumValueDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumValueDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.EnumValueDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.number != null)
                    message.number = object.number | 0;
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.EnumValueDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.EnumValueOptions.fromObject(object.options);
                }
                return message;
            };

            /**
             * Creates a plain object from an EnumValueDescriptorProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @static
             * @param {google.protobuf.EnumValueDescriptorProto} message EnumValueDescriptorProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EnumValueDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.number = 0;
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.number != null && message.hasOwnProperty("number"))
                    object.number = message.number;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.EnumValueOptions.toObject(message.options, options);
                return object;
            };

            /**
             * Converts this EnumValueDescriptorProto to JSON.
             * @function toJSON
             * @memberof google.protobuf.EnumValueDescriptorProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EnumValueDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumValueDescriptorProto;
        })();

        protobuf.ServiceDescriptorProto = (function() {

            /**
             * Properties of a ServiceDescriptorProto.
             * @memberof google.protobuf
             * @interface IServiceDescriptorProto
             * @property {string|null} [name] ServiceDescriptorProto name
             * @property {Array.<google.protobuf.IMethodDescriptorProto>|null} [method] ServiceDescriptorProto method
             * @property {google.protobuf.IServiceOptions|null} [options] ServiceDescriptorProto options
             */

            /**
             * Constructs a new ServiceDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a ServiceDescriptorProto.
             * @implements IServiceDescriptorProto
             * @constructor
             * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
             */
            function ServiceDescriptorProto(properties) {
                this.method = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ServiceDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.name = "";

            /**
             * ServiceDescriptorProto method.
             * @member {Array.<google.protobuf.IMethodDescriptorProto>} method
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.method = $util.emptyArray;

            /**
             * ServiceDescriptorProto options.
             * @member {google.protobuf.IServiceOptions|null|undefined} options
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             */
            ServiceDescriptorProto.prototype.options = null;

            /**
             * Creates a new ServiceDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto instance
             */
            ServiceDescriptorProto.create = function create(properties) {
                return new ServiceDescriptorProto(properties);
            };

            /**
             * Encodes the specified ServiceDescriptorProto message. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {google.protobuf.IServiceDescriptorProto} message ServiceDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServiceDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.method != null && message.method.length)
                    for (var i = 0; i < message.method.length; ++i)
                        $root.google.protobuf.MethodDescriptorProto.encode(message.method[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.ServiceOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ServiceDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {google.protobuf.IServiceDescriptorProto} message ServiceDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServiceDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ServiceDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServiceDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        if (!(message.method && message.method.length))
                            message.method = [];
                        message.method.push($root.google.protobuf.MethodDescriptorProto.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.options = $root.google.protobuf.ServiceOptions.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ServiceDescriptorProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServiceDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ServiceDescriptorProto message.
             * @function verify
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ServiceDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.method != null && message.hasOwnProperty("method")) {
                    if (!Array.isArray(message.method))
                        return "method: array expected";
                    for (var i = 0; i < message.method.length; ++i) {
                        var error = $root.google.protobuf.MethodDescriptorProto.verify(message.method[i]);
                        if (error)
                            return "method." + error;
                    }
                }
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.ServiceOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                return null;
            };

            /**
             * Creates a ServiceDescriptorProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
             */
            ServiceDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ServiceDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.ServiceDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.method) {
                    if (!Array.isArray(object.method))
                        throw TypeError(".google.protobuf.ServiceDescriptorProto.method: array expected");
                    message.method = [];
                    for (var i = 0; i < object.method.length; ++i) {
                        if (typeof object.method[i] !== "object")
                            throw TypeError(".google.protobuf.ServiceDescriptorProto.method: object expected");
                        message.method[i] = $root.google.protobuf.MethodDescriptorProto.fromObject(object.method[i]);
                    }
                }
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.ServiceDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.ServiceOptions.fromObject(object.options);
                }
                return message;
            };

            /**
             * Creates a plain object from a ServiceDescriptorProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.ServiceDescriptorProto
             * @static
             * @param {google.protobuf.ServiceDescriptorProto} message ServiceDescriptorProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ServiceDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.method = [];
                if (options.defaults) {
                    object.name = "";
                    object.options = null;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.method && message.method.length) {
                    object.method = [];
                    for (var j = 0; j < message.method.length; ++j)
                        object.method[j] = $root.google.protobuf.MethodDescriptorProto.toObject(message.method[j], options);
                }
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.ServiceOptions.toObject(message.options, options);
                return object;
            };

            /**
             * Converts this ServiceDescriptorProto to JSON.
             * @function toJSON
             * @memberof google.protobuf.ServiceDescriptorProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ServiceDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ServiceDescriptorProto;
        })();

        protobuf.MethodDescriptorProto = (function() {

            /**
             * Properties of a MethodDescriptorProto.
             * @memberof google.protobuf
             * @interface IMethodDescriptorProto
             * @property {string|null} [name] MethodDescriptorProto name
             * @property {string|null} [inputType] MethodDescriptorProto inputType
             * @property {string|null} [outputType] MethodDescriptorProto outputType
             * @property {google.protobuf.IMethodOptions|null} [options] MethodDescriptorProto options
             * @property {boolean|null} [clientStreaming] MethodDescriptorProto clientStreaming
             * @property {boolean|null} [serverStreaming] MethodDescriptorProto serverStreaming
             */

            /**
             * Constructs a new MethodDescriptorProto.
             * @memberof google.protobuf
             * @classdesc Represents a MethodDescriptorProto.
             * @implements IMethodDescriptorProto
             * @constructor
             * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
             */
            function MethodDescriptorProto(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MethodDescriptorProto name.
             * @member {string} name
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.name = "";

            /**
             * MethodDescriptorProto inputType.
             * @member {string} inputType
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.inputType = "";

            /**
             * MethodDescriptorProto outputType.
             * @member {string} outputType
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.outputType = "";

            /**
             * MethodDescriptorProto options.
             * @member {google.protobuf.IMethodOptions|null|undefined} options
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.options = null;

            /**
             * MethodDescriptorProto clientStreaming.
             * @member {boolean} clientStreaming
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.clientStreaming = false;

            /**
             * MethodDescriptorProto serverStreaming.
             * @member {boolean} serverStreaming
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             */
            MethodDescriptorProto.prototype.serverStreaming = false;

            /**
             * Creates a new MethodDescriptorProto instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
             * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto instance
             */
            MethodDescriptorProto.create = function create(properties) {
                return new MethodDescriptorProto(properties);
            };

            /**
             * Encodes the specified MethodDescriptorProto message. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {google.protobuf.IMethodDescriptorProto} message MethodDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MethodDescriptorProto.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                if (message.inputType != null && Object.hasOwnProperty.call(message, "inputType"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.inputType);
                if (message.outputType != null && Object.hasOwnProperty.call(message, "outputType"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.outputType);
                if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                    $root.google.protobuf.MethodOptions.encode(message.options, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                if (message.clientStreaming != null && Object.hasOwnProperty.call(message, "clientStreaming"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.clientStreaming);
                if (message.serverStreaming != null && Object.hasOwnProperty.call(message, "serverStreaming"))
                    writer.uint32(/* id 6, wireType 0 =*/48).bool(message.serverStreaming);
                return writer;
            };

            /**
             * Encodes the specified MethodDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {google.protobuf.IMethodDescriptorProto} message MethodDescriptorProto message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MethodDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MethodDescriptorProto message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MethodDescriptorProto.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodDescriptorProto();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.name = reader.string();
                        break;
                    case 2:
                        message.inputType = reader.string();
                        break;
                    case 3:
                        message.outputType = reader.string();
                        break;
                    case 4:
                        message.options = $root.google.protobuf.MethodOptions.decode(reader, reader.uint32());
                        break;
                    case 5:
                        message.clientStreaming = reader.bool();
                        break;
                    case 6:
                        message.serverStreaming = reader.bool();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MethodDescriptorProto message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MethodDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MethodDescriptorProto message.
             * @function verify
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MethodDescriptorProto.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name"))
                    if (!$util.isString(message.name))
                        return "name: string expected";
                if (message.inputType != null && message.hasOwnProperty("inputType"))
                    if (!$util.isString(message.inputType))
                        return "inputType: string expected";
                if (message.outputType != null && message.hasOwnProperty("outputType"))
                    if (!$util.isString(message.outputType))
                        return "outputType: string expected";
                if (message.options != null && message.hasOwnProperty("options")) {
                    var error = $root.google.protobuf.MethodOptions.verify(message.options);
                    if (error)
                        return "options." + error;
                }
                if (message.clientStreaming != null && message.hasOwnProperty("clientStreaming"))
                    if (typeof message.clientStreaming !== "boolean")
                        return "clientStreaming: boolean expected";
                if (message.serverStreaming != null && message.hasOwnProperty("serverStreaming"))
                    if (typeof message.serverStreaming !== "boolean")
                        return "serverStreaming: boolean expected";
                return null;
            };

            /**
             * Creates a MethodDescriptorProto message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
             */
            MethodDescriptorProto.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MethodDescriptorProto)
                    return object;
                var message = new $root.google.protobuf.MethodDescriptorProto();
                if (object.name != null)
                    message.name = String(object.name);
                if (object.inputType != null)
                    message.inputType = String(object.inputType);
                if (object.outputType != null)
                    message.outputType = String(object.outputType);
                if (object.options != null) {
                    if (typeof object.options !== "object")
                        throw TypeError(".google.protobuf.MethodDescriptorProto.options: object expected");
                    message.options = $root.google.protobuf.MethodOptions.fromObject(object.options);
                }
                if (object.clientStreaming != null)
                    message.clientStreaming = Boolean(object.clientStreaming);
                if (object.serverStreaming != null)
                    message.serverStreaming = Boolean(object.serverStreaming);
                return message;
            };

            /**
             * Creates a plain object from a MethodDescriptorProto message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.MethodDescriptorProto
             * @static
             * @param {google.protobuf.MethodDescriptorProto} message MethodDescriptorProto
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MethodDescriptorProto.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.name = "";
                    object.inputType = "";
                    object.outputType = "";
                    object.options = null;
                    object.clientStreaming = false;
                    object.serverStreaming = false;
                }
                if (message.name != null && message.hasOwnProperty("name"))
                    object.name = message.name;
                if (message.inputType != null && message.hasOwnProperty("inputType"))
                    object.inputType = message.inputType;
                if (message.outputType != null && message.hasOwnProperty("outputType"))
                    object.outputType = message.outputType;
                if (message.options != null && message.hasOwnProperty("options"))
                    object.options = $root.google.protobuf.MethodOptions.toObject(message.options, options);
                if (message.clientStreaming != null && message.hasOwnProperty("clientStreaming"))
                    object.clientStreaming = message.clientStreaming;
                if (message.serverStreaming != null && message.hasOwnProperty("serverStreaming"))
                    object.serverStreaming = message.serverStreaming;
                return object;
            };

            /**
             * Converts this MethodDescriptorProto to JSON.
             * @function toJSON
             * @memberof google.protobuf.MethodDescriptorProto
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MethodDescriptorProto.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MethodDescriptorProto;
        })();

        protobuf.FileOptions = (function() {

            /**
             * Properties of a FileOptions.
             * @memberof google.protobuf
             * @interface IFileOptions
             * @property {string|null} [javaPackage] FileOptions javaPackage
             * @property {string|null} [javaOuterClassname] FileOptions javaOuterClassname
             * @property {boolean|null} [javaMultipleFiles] FileOptions javaMultipleFiles
             * @property {boolean|null} [javaGenerateEqualsAndHash] FileOptions javaGenerateEqualsAndHash
             * @property {boolean|null} [javaStringCheckUtf8] FileOptions javaStringCheckUtf8
             * @property {google.protobuf.FileOptions.OptimizeMode|null} [optimizeFor] FileOptions optimizeFor
             * @property {string|null} [goPackage] FileOptions goPackage
             * @property {boolean|null} [ccGenericServices] FileOptions ccGenericServices
             * @property {boolean|null} [javaGenericServices] FileOptions javaGenericServices
             * @property {boolean|null} [pyGenericServices] FileOptions pyGenericServices
             * @property {boolean|null} [deprecated] FileOptions deprecated
             * @property {boolean|null} [ccEnableArenas] FileOptions ccEnableArenas
             * @property {string|null} [objcClassPrefix] FileOptions objcClassPrefix
             * @property {string|null} [csharpNamespace] FileOptions csharpNamespace
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FileOptions uninterpretedOption
             */

            /**
             * Constructs a new FileOptions.
             * @memberof google.protobuf
             * @classdesc Represents a FileOptions.
             * @implements IFileOptions
             * @constructor
             * @param {google.protobuf.IFileOptions=} [properties] Properties to set
             */
            function FileOptions(properties) {
                this.uninterpretedOption = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FileOptions javaPackage.
             * @member {string} javaPackage
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaPackage = "";

            /**
             * FileOptions javaOuterClassname.
             * @member {string} javaOuterClassname
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaOuterClassname = "";

            /**
             * FileOptions javaMultipleFiles.
             * @member {boolean} javaMultipleFiles
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaMultipleFiles = false;

            /**
             * FileOptions javaGenerateEqualsAndHash.
             * @member {boolean} javaGenerateEqualsAndHash
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaGenerateEqualsAndHash = false;

            /**
             * FileOptions javaStringCheckUtf8.
             * @member {boolean} javaStringCheckUtf8
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaStringCheckUtf8 = false;

            /**
             * FileOptions optimizeFor.
             * @member {google.protobuf.FileOptions.OptimizeMode} optimizeFor
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.optimizeFor = 1;

            /**
             * FileOptions goPackage.
             * @member {string} goPackage
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.goPackage = "";

            /**
             * FileOptions ccGenericServices.
             * @member {boolean} ccGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.ccGenericServices = false;

            /**
             * FileOptions javaGenericServices.
             * @member {boolean} javaGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.javaGenericServices = false;

            /**
             * FileOptions pyGenericServices.
             * @member {boolean} pyGenericServices
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.pyGenericServices = false;

            /**
             * FileOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.deprecated = false;

            /**
             * FileOptions ccEnableArenas.
             * @member {boolean} ccEnableArenas
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.ccEnableArenas = false;

            /**
             * FileOptions objcClassPrefix.
             * @member {string} objcClassPrefix
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.objcClassPrefix = "";

            /**
             * FileOptions csharpNamespace.
             * @member {string} csharpNamespace
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.csharpNamespace = "";

            /**
             * FileOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.FileOptions
             * @instance
             */
            FileOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new FileOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {google.protobuf.IFileOptions=} [properties] Properties to set
             * @returns {google.protobuf.FileOptions} FileOptions instance
             */
            FileOptions.create = function create(properties) {
                return new FileOptions(properties);
            };

            /**
             * Encodes the specified FileOptions message. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {google.protobuf.IFileOptions} message FileOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.javaPackage != null && Object.hasOwnProperty.call(message, "javaPackage"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.javaPackage);
                if (message.javaOuterClassname != null && Object.hasOwnProperty.call(message, "javaOuterClassname"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.javaOuterClassname);
                if (message.optimizeFor != null && Object.hasOwnProperty.call(message, "optimizeFor"))
                    writer.uint32(/* id 9, wireType 0 =*/72).int32(message.optimizeFor);
                if (message.javaMultipleFiles != null && Object.hasOwnProperty.call(message, "javaMultipleFiles"))
                    writer.uint32(/* id 10, wireType 0 =*/80).bool(message.javaMultipleFiles);
                if (message.goPackage != null && Object.hasOwnProperty.call(message, "goPackage"))
                    writer.uint32(/* id 11, wireType 2 =*/90).string(message.goPackage);
                if (message.ccGenericServices != null && Object.hasOwnProperty.call(message, "ccGenericServices"))
                    writer.uint32(/* id 16, wireType 0 =*/128).bool(message.ccGenericServices);
                if (message.javaGenericServices != null && Object.hasOwnProperty.call(message, "javaGenericServices"))
                    writer.uint32(/* id 17, wireType 0 =*/136).bool(message.javaGenericServices);
                if (message.pyGenericServices != null && Object.hasOwnProperty.call(message, "pyGenericServices"))
                    writer.uint32(/* id 18, wireType 0 =*/144).bool(message.pyGenericServices);
                if (message.javaGenerateEqualsAndHash != null && Object.hasOwnProperty.call(message, "javaGenerateEqualsAndHash"))
                    writer.uint32(/* id 20, wireType 0 =*/160).bool(message.javaGenerateEqualsAndHash);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(/* id 23, wireType 0 =*/184).bool(message.deprecated);
                if (message.javaStringCheckUtf8 != null && Object.hasOwnProperty.call(message, "javaStringCheckUtf8"))
                    writer.uint32(/* id 27, wireType 0 =*/216).bool(message.javaStringCheckUtf8);
                if (message.ccEnableArenas != null && Object.hasOwnProperty.call(message, "ccEnableArenas"))
                    writer.uint32(/* id 31, wireType 0 =*/248).bool(message.ccEnableArenas);
                if (message.objcClassPrefix != null && Object.hasOwnProperty.call(message, "objcClassPrefix"))
                    writer.uint32(/* id 36, wireType 2 =*/290).string(message.objcClassPrefix);
                if (message.csharpNamespace != null && Object.hasOwnProperty.call(message, "csharpNamespace"))
                    writer.uint32(/* id 37, wireType 2 =*/298).string(message.csharpNamespace);
                if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                    for (var i = 0; i < message.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified FileOptions message, length delimited. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {google.protobuf.IFileOptions} message FileOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FileOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FileOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.FileOptions} FileOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.javaPackage = reader.string();
                        break;
                    case 8:
                        message.javaOuterClassname = reader.string();
                        break;
                    case 10:
                        message.javaMultipleFiles = reader.bool();
                        break;
                    case 20:
                        message.javaGenerateEqualsAndHash = reader.bool();
                        break;
                    case 27:
                        message.javaStringCheckUtf8 = reader.bool();
                        break;
                    case 9:
                        message.optimizeFor = reader.int32();
                        break;
                    case 11:
                        message.goPackage = reader.string();
                        break;
                    case 16:
                        message.ccGenericServices = reader.bool();
                        break;
                    case 17:
                        message.javaGenericServices = reader.bool();
                        break;
                    case 18:
                        message.pyGenericServices = reader.bool();
                        break;
                    case 23:
                        message.deprecated = reader.bool();
                        break;
                    case 31:
                        message.ccEnableArenas = reader.bool();
                        break;
                    case 36:
                        message.objcClassPrefix = reader.string();
                        break;
                    case 37:
                        message.csharpNamespace = reader.string();
                        break;
                    case 999:
                        if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                            message.uninterpretedOption = [];
                        message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FileOptions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.FileOptions} FileOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FileOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FileOptions message.
             * @function verify
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FileOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.javaPackage != null && message.hasOwnProperty("javaPackage"))
                    if (!$util.isString(message.javaPackage))
                        return "javaPackage: string expected";
                if (message.javaOuterClassname != null && message.hasOwnProperty("javaOuterClassname"))
                    if (!$util.isString(message.javaOuterClassname))
                        return "javaOuterClassname: string expected";
                if (message.javaMultipleFiles != null && message.hasOwnProperty("javaMultipleFiles"))
                    if (typeof message.javaMultipleFiles !== "boolean")
                        return "javaMultipleFiles: boolean expected";
                if (message.javaGenerateEqualsAndHash != null && message.hasOwnProperty("javaGenerateEqualsAndHash"))
                    if (typeof message.javaGenerateEqualsAndHash !== "boolean")
                        return "javaGenerateEqualsAndHash: boolean expected";
                if (message.javaStringCheckUtf8 != null && message.hasOwnProperty("javaStringCheckUtf8"))
                    if (typeof message.javaStringCheckUtf8 !== "boolean")
                        return "javaStringCheckUtf8: boolean expected";
                if (message.optimizeFor != null && message.hasOwnProperty("optimizeFor"))
                    switch (message.optimizeFor) {
                    default:
                        return "optimizeFor: enum value expected";
                    case 1:
                    case 2:
                    case 3:
                        break;
                    }
                if (message.goPackage != null && message.hasOwnProperty("goPackage"))
                    if (!$util.isString(message.goPackage))
                        return "goPackage: string expected";
                if (message.ccGenericServices != null && message.hasOwnProperty("ccGenericServices"))
                    if (typeof message.ccGenericServices !== "boolean")
                        return "ccGenericServices: boolean expected";
                if (message.javaGenericServices != null && message.hasOwnProperty("javaGenericServices"))
                    if (typeof message.javaGenericServices !== "boolean")
                        return "javaGenericServices: boolean expected";
                if (message.pyGenericServices != null && message.hasOwnProperty("pyGenericServices"))
                    if (typeof message.pyGenericServices !== "boolean")
                        return "pyGenericServices: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.ccEnableArenas != null && message.hasOwnProperty("ccEnableArenas"))
                    if (typeof message.ccEnableArenas !== "boolean")
                        return "ccEnableArenas: boolean expected";
                if (message.objcClassPrefix != null && message.hasOwnProperty("objcClassPrefix"))
                    if (!$util.isString(message.objcClassPrefix))
                        return "objcClassPrefix: string expected";
                if (message.csharpNamespace != null && message.hasOwnProperty("csharpNamespace"))
                    if (!$util.isString(message.csharpNamespace))
                        return "csharpNamespace: string expected";
                if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                    if (!Array.isArray(message.uninterpretedOption))
                        return "uninterpretedOption: array expected";
                    for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                        if (error)
                            return "uninterpretedOption." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a FileOptions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.FileOptions} FileOptions
             */
            FileOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FileOptions)
                    return object;
                var message = new $root.google.protobuf.FileOptions();
                if (object.javaPackage != null)
                    message.javaPackage = String(object.javaPackage);
                if (object.javaOuterClassname != null)
                    message.javaOuterClassname = String(object.javaOuterClassname);
                if (object.javaMultipleFiles != null)
                    message.javaMultipleFiles = Boolean(object.javaMultipleFiles);
                if (object.javaGenerateEqualsAndHash != null)
                    message.javaGenerateEqualsAndHash = Boolean(object.javaGenerateEqualsAndHash);
                if (object.javaStringCheckUtf8 != null)
                    message.javaStringCheckUtf8 = Boolean(object.javaStringCheckUtf8);
                switch (object.optimizeFor) {
                case "SPEED":
                case 1:
                    message.optimizeFor = 1;
                    break;
                case "CODE_SIZE":
                case 2:
                    message.optimizeFor = 2;
                    break;
                case "LITE_RUNTIME":
                case 3:
                    message.optimizeFor = 3;
                    break;
                }
                if (object.goPackage != null)
                    message.goPackage = String(object.goPackage);
                if (object.ccGenericServices != null)
                    message.ccGenericServices = Boolean(object.ccGenericServices);
                if (object.javaGenericServices != null)
                    message.javaGenericServices = Boolean(object.javaGenericServices);
                if (object.pyGenericServices != null)
                    message.pyGenericServices = Boolean(object.pyGenericServices);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.ccEnableArenas != null)
                    message.ccEnableArenas = Boolean(object.ccEnableArenas);
                if (object.objcClassPrefix != null)
                    message.objcClassPrefix = String(object.objcClassPrefix);
                if (object.csharpNamespace != null)
                    message.csharpNamespace = String(object.csharpNamespace);
                if (object.uninterpretedOption) {
                    if (!Array.isArray(object.uninterpretedOption))
                        throw TypeError(".google.protobuf.FileOptions.uninterpretedOption: array expected");
                    message.uninterpretedOption = [];
                    for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                        if (typeof object.uninterpretedOption[i] !== "object")
                            throw TypeError(".google.protobuf.FileOptions.uninterpretedOption: object expected");
                        message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a FileOptions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.FileOptions
             * @static
             * @param {google.protobuf.FileOptions} message FileOptions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FileOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpretedOption = [];
                if (options.defaults) {
                    object.javaPackage = "";
                    object.javaOuterClassname = "";
                    object.optimizeFor = options.enums === String ? "SPEED" : 1;
                    object.javaMultipleFiles = false;
                    object.goPackage = "";
                    object.ccGenericServices = false;
                    object.javaGenericServices = false;
                    object.pyGenericServices = false;
                    object.javaGenerateEqualsAndHash = false;
                    object.deprecated = false;
                    object.javaStringCheckUtf8 = false;
                    object.ccEnableArenas = false;
                    object.objcClassPrefix = "";
                    object.csharpNamespace = "";
                }
                if (message.javaPackage != null && message.hasOwnProperty("javaPackage"))
                    object.javaPackage = message.javaPackage;
                if (message.javaOuterClassname != null && message.hasOwnProperty("javaOuterClassname"))
                    object.javaOuterClassname = message.javaOuterClassname;
                if (message.optimizeFor != null && message.hasOwnProperty("optimizeFor"))
                    object.optimizeFor = options.enums === String ? $root.google.protobuf.FileOptions.OptimizeMode[message.optimizeFor] : message.optimizeFor;
                if (message.javaMultipleFiles != null && message.hasOwnProperty("javaMultipleFiles"))
                    object.javaMultipleFiles = message.javaMultipleFiles;
                if (message.goPackage != null && message.hasOwnProperty("goPackage"))
                    object.goPackage = message.goPackage;
                if (message.ccGenericServices != null && message.hasOwnProperty("ccGenericServices"))
                    object.ccGenericServices = message.ccGenericServices;
                if (message.javaGenericServices != null && message.hasOwnProperty("javaGenericServices"))
                    object.javaGenericServices = message.javaGenericServices;
                if (message.pyGenericServices != null && message.hasOwnProperty("pyGenericServices"))
                    object.pyGenericServices = message.pyGenericServices;
                if (message.javaGenerateEqualsAndHash != null && message.hasOwnProperty("javaGenerateEqualsAndHash"))
                    object.javaGenerateEqualsAndHash = message.javaGenerateEqualsAndHash;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.javaStringCheckUtf8 != null && message.hasOwnProperty("javaStringCheckUtf8"))
                    object.javaStringCheckUtf8 = message.javaStringCheckUtf8;
                if (message.ccEnableArenas != null && message.hasOwnProperty("ccEnableArenas"))
                    object.ccEnableArenas = message.ccEnableArenas;
                if (message.objcClassPrefix != null && message.hasOwnProperty("objcClassPrefix"))
                    object.objcClassPrefix = message.objcClassPrefix;
                if (message.csharpNamespace != null && message.hasOwnProperty("csharpNamespace"))
                    object.csharpNamespace = message.csharpNamespace;
                if (message.uninterpretedOption && message.uninterpretedOption.length) {
                    object.uninterpretedOption = [];
                    for (var j = 0; j < message.uninterpretedOption.length; ++j)
                        object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                }
                return object;
            };

            /**
             * Converts this FileOptions to JSON.
             * @function toJSON
             * @memberof google.protobuf.FileOptions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FileOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * OptimizeMode enum.
             * @name google.protobuf.FileOptions.OptimizeMode
             * @enum {number}
             * @property {number} SPEED=1 SPEED value
             * @property {number} CODE_SIZE=2 CODE_SIZE value
             * @property {number} LITE_RUNTIME=3 LITE_RUNTIME value
             */
            FileOptions.OptimizeMode = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[1] = "SPEED"] = 1;
                values[valuesById[2] = "CODE_SIZE"] = 2;
                values[valuesById[3] = "LITE_RUNTIME"] = 3;
                return values;
            })();

            return FileOptions;
        })();

        protobuf.MessageOptions = (function() {

            /**
             * Properties of a MessageOptions.
             * @memberof google.protobuf
             * @interface IMessageOptions
             * @property {boolean|null} [messageSetWireFormat] MessageOptions messageSetWireFormat
             * @property {boolean|null} [noStandardDescriptorAccessor] MessageOptions noStandardDescriptorAccessor
             * @property {boolean|null} [deprecated] MessageOptions deprecated
             * @property {boolean|null} [mapEntry] MessageOptions mapEntry
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MessageOptions uninterpretedOption
             */

            /**
             * Constructs a new MessageOptions.
             * @memberof google.protobuf
             * @classdesc Represents a MessageOptions.
             * @implements IMessageOptions
             * @constructor
             * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
             */
            function MessageOptions(properties) {
                this.uninterpretedOption = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MessageOptions messageSetWireFormat.
             * @member {boolean} messageSetWireFormat
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.messageSetWireFormat = false;

            /**
             * MessageOptions noStandardDescriptorAccessor.
             * @member {boolean} noStandardDescriptorAccessor
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.noStandardDescriptorAccessor = false;

            /**
             * MessageOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.deprecated = false;

            /**
             * MessageOptions mapEntry.
             * @member {boolean} mapEntry
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.mapEntry = false;

            /**
             * MessageOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.MessageOptions
             * @instance
             */
            MessageOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new MessageOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
             * @returns {google.protobuf.MessageOptions} MessageOptions instance
             */
            MessageOptions.create = function create(properties) {
                return new MessageOptions(properties);
            };

            /**
             * Encodes the specified MessageOptions message. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {google.protobuf.IMessageOptions} message MessageOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.messageSetWireFormat != null && Object.hasOwnProperty.call(message, "messageSetWireFormat"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.messageSetWireFormat);
                if (message.noStandardDescriptorAccessor != null && Object.hasOwnProperty.call(message, "noStandardDescriptorAccessor"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.noStandardDescriptorAccessor);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                if (message.mapEntry != null && Object.hasOwnProperty.call(message, "mapEntry"))
                    writer.uint32(/* id 7, wireType 0 =*/56).bool(message.mapEntry);
                if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                    for (var i = 0; i < message.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MessageOptions message, length delimited. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {google.protobuf.IMessageOptions} message MessageOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MessageOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MessageOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.MessageOptions} MessageOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MessageOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.messageSetWireFormat = reader.bool();
                        break;
                    case 2:
                        message.noStandardDescriptorAccessor = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 7:
                        message.mapEntry = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                            message.uninterpretedOption = [];
                        message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MessageOptions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.MessageOptions} MessageOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MessageOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MessageOptions message.
             * @function verify
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MessageOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.messageSetWireFormat != null && message.hasOwnProperty("messageSetWireFormat"))
                    if (typeof message.messageSetWireFormat !== "boolean")
                        return "messageSetWireFormat: boolean expected";
                if (message.noStandardDescriptorAccessor != null && message.hasOwnProperty("noStandardDescriptorAccessor"))
                    if (typeof message.noStandardDescriptorAccessor !== "boolean")
                        return "noStandardDescriptorAccessor: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.mapEntry != null && message.hasOwnProperty("mapEntry"))
                    if (typeof message.mapEntry !== "boolean")
                        return "mapEntry: boolean expected";
                if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                    if (!Array.isArray(message.uninterpretedOption))
                        return "uninterpretedOption: array expected";
                    for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                        if (error)
                            return "uninterpretedOption." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a MessageOptions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.MessageOptions} MessageOptions
             */
            MessageOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MessageOptions)
                    return object;
                var message = new $root.google.protobuf.MessageOptions();
                if (object.messageSetWireFormat != null)
                    message.messageSetWireFormat = Boolean(object.messageSetWireFormat);
                if (object.noStandardDescriptorAccessor != null)
                    message.noStandardDescriptorAccessor = Boolean(object.noStandardDescriptorAccessor);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.mapEntry != null)
                    message.mapEntry = Boolean(object.mapEntry);
                if (object.uninterpretedOption) {
                    if (!Array.isArray(object.uninterpretedOption))
                        throw TypeError(".google.protobuf.MessageOptions.uninterpretedOption: array expected");
                    message.uninterpretedOption = [];
                    for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                        if (typeof object.uninterpretedOption[i] !== "object")
                            throw TypeError(".google.protobuf.MessageOptions.uninterpretedOption: object expected");
                        message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a MessageOptions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.MessageOptions
             * @static
             * @param {google.protobuf.MessageOptions} message MessageOptions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MessageOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpretedOption = [];
                if (options.defaults) {
                    object.messageSetWireFormat = false;
                    object.noStandardDescriptorAccessor = false;
                    object.deprecated = false;
                    object.mapEntry = false;
                }
                if (message.messageSetWireFormat != null && message.hasOwnProperty("messageSetWireFormat"))
                    object.messageSetWireFormat = message.messageSetWireFormat;
                if (message.noStandardDescriptorAccessor != null && message.hasOwnProperty("noStandardDescriptorAccessor"))
                    object.noStandardDescriptorAccessor = message.noStandardDescriptorAccessor;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.mapEntry != null && message.hasOwnProperty("mapEntry"))
                    object.mapEntry = message.mapEntry;
                if (message.uninterpretedOption && message.uninterpretedOption.length) {
                    object.uninterpretedOption = [];
                    for (var j = 0; j < message.uninterpretedOption.length; ++j)
                        object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                }
                return object;
            };

            /**
             * Converts this MessageOptions to JSON.
             * @function toJSON
             * @memberof google.protobuf.MessageOptions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MessageOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MessageOptions;
        })();

        protobuf.FieldOptions = (function() {

            /**
             * Properties of a FieldOptions.
             * @memberof google.protobuf
             * @interface IFieldOptions
             * @property {google.protobuf.FieldOptions.CType|null} [ctype] FieldOptions ctype
             * @property {boolean|null} [packed] FieldOptions packed
             * @property {google.protobuf.FieldOptions.JSType|null} [jstype] FieldOptions jstype
             * @property {boolean|null} [lazy] FieldOptions lazy
             * @property {boolean|null} [deprecated] FieldOptions deprecated
             * @property {boolean|null} [weak] FieldOptions weak
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FieldOptions uninterpretedOption
             */

            /**
             * Constructs a new FieldOptions.
             * @memberof google.protobuf
             * @classdesc Represents a FieldOptions.
             * @implements IFieldOptions
             * @constructor
             * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
             */
            function FieldOptions(properties) {
                this.uninterpretedOption = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * FieldOptions ctype.
             * @member {google.protobuf.FieldOptions.CType} ctype
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.ctype = 0;

            /**
             * FieldOptions packed.
             * @member {boolean} packed
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.packed = false;

            /**
             * FieldOptions jstype.
             * @member {google.protobuf.FieldOptions.JSType} jstype
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.jstype = 0;

            /**
             * FieldOptions lazy.
             * @member {boolean} lazy
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.lazy = false;

            /**
             * FieldOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.deprecated = false;

            /**
             * FieldOptions weak.
             * @member {boolean} weak
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.weak = false;

            /**
             * FieldOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.FieldOptions
             * @instance
             */
            FieldOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new FieldOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
             * @returns {google.protobuf.FieldOptions} FieldOptions instance
             */
            FieldOptions.create = function create(properties) {
                return new FieldOptions(properties);
            };

            /**
             * Encodes the specified FieldOptions message. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {google.protobuf.IFieldOptions} message FieldOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.ctype != null && Object.hasOwnProperty.call(message, "ctype"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ctype);
                if (message.packed != null && Object.hasOwnProperty.call(message, "packed"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.packed);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                if (message.lazy != null && Object.hasOwnProperty.call(message, "lazy"))
                    writer.uint32(/* id 5, wireType 0 =*/40).bool(message.lazy);
                if (message.jstype != null && Object.hasOwnProperty.call(message, "jstype"))
                    writer.uint32(/* id 6, wireType 0 =*/48).int32(message.jstype);
                if (message.weak != null && Object.hasOwnProperty.call(message, "weak"))
                    writer.uint32(/* id 10, wireType 0 =*/80).bool(message.weak);
                if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                    for (var i = 0; i < message.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified FieldOptions message, length delimited. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {google.protobuf.IFieldOptions} message FieldOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            FieldOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a FieldOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.FieldOptions} FieldOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.ctype = reader.int32();
                        break;
                    case 2:
                        message.packed = reader.bool();
                        break;
                    case 6:
                        message.jstype = reader.int32();
                        break;
                    case 5:
                        message.lazy = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 10:
                        message.weak = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                            message.uninterpretedOption = [];
                        message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a FieldOptions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.FieldOptions} FieldOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            FieldOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a FieldOptions message.
             * @function verify
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            FieldOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.ctype != null && message.hasOwnProperty("ctype"))
                    switch (message.ctype) {
                    default:
                        return "ctype: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.packed != null && message.hasOwnProperty("packed"))
                    if (typeof message.packed !== "boolean")
                        return "packed: boolean expected";
                if (message.jstype != null && message.hasOwnProperty("jstype"))
                    switch (message.jstype) {
                    default:
                        return "jstype: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                        break;
                    }
                if (message.lazy != null && message.hasOwnProperty("lazy"))
                    if (typeof message.lazy !== "boolean")
                        return "lazy: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.weak != null && message.hasOwnProperty("weak"))
                    if (typeof message.weak !== "boolean")
                        return "weak: boolean expected";
                if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                    if (!Array.isArray(message.uninterpretedOption))
                        return "uninterpretedOption: array expected";
                    for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                        if (error)
                            return "uninterpretedOption." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a FieldOptions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.FieldOptions} FieldOptions
             */
            FieldOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.FieldOptions)
                    return object;
                var message = new $root.google.protobuf.FieldOptions();
                switch (object.ctype) {
                case "STRING":
                case 0:
                    message.ctype = 0;
                    break;
                case "CORD":
                case 1:
                    message.ctype = 1;
                    break;
                case "STRING_PIECE":
                case 2:
                    message.ctype = 2;
                    break;
                }
                if (object.packed != null)
                    message.packed = Boolean(object.packed);
                switch (object.jstype) {
                case "JS_NORMAL":
                case 0:
                    message.jstype = 0;
                    break;
                case "JS_STRING":
                case 1:
                    message.jstype = 1;
                    break;
                case "JS_NUMBER":
                case 2:
                    message.jstype = 2;
                    break;
                }
                if (object.lazy != null)
                    message.lazy = Boolean(object.lazy);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.weak != null)
                    message.weak = Boolean(object.weak);
                if (object.uninterpretedOption) {
                    if (!Array.isArray(object.uninterpretedOption))
                        throw TypeError(".google.protobuf.FieldOptions.uninterpretedOption: array expected");
                    message.uninterpretedOption = [];
                    for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                        if (typeof object.uninterpretedOption[i] !== "object")
                            throw TypeError(".google.protobuf.FieldOptions.uninterpretedOption: object expected");
                        message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a FieldOptions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.FieldOptions
             * @static
             * @param {google.protobuf.FieldOptions} message FieldOptions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            FieldOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpretedOption = [];
                if (options.defaults) {
                    object.ctype = options.enums === String ? "STRING" : 0;
                    object.packed = false;
                    object.deprecated = false;
                    object.lazy = false;
                    object.jstype = options.enums === String ? "JS_NORMAL" : 0;
                    object.weak = false;
                }
                if (message.ctype != null && message.hasOwnProperty("ctype"))
                    object.ctype = options.enums === String ? $root.google.protobuf.FieldOptions.CType[message.ctype] : message.ctype;
                if (message.packed != null && message.hasOwnProperty("packed"))
                    object.packed = message.packed;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.lazy != null && message.hasOwnProperty("lazy"))
                    object.lazy = message.lazy;
                if (message.jstype != null && message.hasOwnProperty("jstype"))
                    object.jstype = options.enums === String ? $root.google.protobuf.FieldOptions.JSType[message.jstype] : message.jstype;
                if (message.weak != null && message.hasOwnProperty("weak"))
                    object.weak = message.weak;
                if (message.uninterpretedOption && message.uninterpretedOption.length) {
                    object.uninterpretedOption = [];
                    for (var j = 0; j < message.uninterpretedOption.length; ++j)
                        object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                }
                return object;
            };

            /**
             * Converts this FieldOptions to JSON.
             * @function toJSON
             * @memberof google.protobuf.FieldOptions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            FieldOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * CType enum.
             * @name google.protobuf.FieldOptions.CType
             * @enum {number}
             * @property {number} STRING=0 STRING value
             * @property {number} CORD=1 CORD value
             * @property {number} STRING_PIECE=2 STRING_PIECE value
             */
            FieldOptions.CType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STRING"] = 0;
                values[valuesById[1] = "CORD"] = 1;
                values[valuesById[2] = "STRING_PIECE"] = 2;
                return values;
            })();

            /**
             * JSType enum.
             * @name google.protobuf.FieldOptions.JSType
             * @enum {number}
             * @property {number} JS_NORMAL=0 JS_NORMAL value
             * @property {number} JS_STRING=1 JS_STRING value
             * @property {number} JS_NUMBER=2 JS_NUMBER value
             */
            FieldOptions.JSType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "JS_NORMAL"] = 0;
                values[valuesById[1] = "JS_STRING"] = 1;
                values[valuesById[2] = "JS_NUMBER"] = 2;
                return values;
            })();

            return FieldOptions;
        })();

        protobuf.OneofOptions = (function() {

            /**
             * Properties of an OneofOptions.
             * @memberof google.protobuf
             * @interface IOneofOptions
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] OneofOptions uninterpretedOption
             */

            /**
             * Constructs a new OneofOptions.
             * @memberof google.protobuf
             * @classdesc Represents an OneofOptions.
             * @implements IOneofOptions
             * @constructor
             * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
             */
            function OneofOptions(properties) {
                this.uninterpretedOption = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * OneofOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.OneofOptions
             * @instance
             */
            OneofOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new OneofOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
             * @returns {google.protobuf.OneofOptions} OneofOptions instance
             */
            OneofOptions.create = function create(properties) {
                return new OneofOptions(properties);
            };

            /**
             * Encodes the specified OneofOptions message. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {google.protobuf.IOneofOptions} message OneofOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OneofOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                    for (var i = 0; i < message.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified OneofOptions message, length delimited. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {google.protobuf.IOneofOptions} message OneofOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            OneofOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an OneofOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.OneofOptions} OneofOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OneofOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 999:
                        if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                            message.uninterpretedOption = [];
                        message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an OneofOptions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.OneofOptions} OneofOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            OneofOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an OneofOptions message.
             * @function verify
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            OneofOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                    if (!Array.isArray(message.uninterpretedOption))
                        return "uninterpretedOption: array expected";
                    for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                        if (error)
                            return "uninterpretedOption." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an OneofOptions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.OneofOptions} OneofOptions
             */
            OneofOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.OneofOptions)
                    return object;
                var message = new $root.google.protobuf.OneofOptions();
                if (object.uninterpretedOption) {
                    if (!Array.isArray(object.uninterpretedOption))
                        throw TypeError(".google.protobuf.OneofOptions.uninterpretedOption: array expected");
                    message.uninterpretedOption = [];
                    for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                        if (typeof object.uninterpretedOption[i] !== "object")
                            throw TypeError(".google.protobuf.OneofOptions.uninterpretedOption: object expected");
                        message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an OneofOptions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.OneofOptions
             * @static
             * @param {google.protobuf.OneofOptions} message OneofOptions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            OneofOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpretedOption = [];
                if (message.uninterpretedOption && message.uninterpretedOption.length) {
                    object.uninterpretedOption = [];
                    for (var j = 0; j < message.uninterpretedOption.length; ++j)
                        object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                }
                return object;
            };

            /**
             * Converts this OneofOptions to JSON.
             * @function toJSON
             * @memberof google.protobuf.OneofOptions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            OneofOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return OneofOptions;
        })();

        protobuf.EnumOptions = (function() {

            /**
             * Properties of an EnumOptions.
             * @memberof google.protobuf
             * @interface IEnumOptions
             * @property {boolean|null} [allowAlias] EnumOptions allowAlias
             * @property {boolean|null} [deprecated] EnumOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumOptions uninterpretedOption
             */

            /**
             * Constructs a new EnumOptions.
             * @memberof google.protobuf
             * @classdesc Represents an EnumOptions.
             * @implements IEnumOptions
             * @constructor
             * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
             */
            function EnumOptions(properties) {
                this.uninterpretedOption = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EnumOptions allowAlias.
             * @member {boolean} allowAlias
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.allowAlias = false;

            /**
             * EnumOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.deprecated = false;

            /**
             * EnumOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.EnumOptions
             * @instance
             */
            EnumOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new EnumOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
             * @returns {google.protobuf.EnumOptions} EnumOptions instance
             */
            EnumOptions.create = function create(properties) {
                return new EnumOptions(properties);
            };

            /**
             * Encodes the specified EnumOptions message. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {google.protobuf.IEnumOptions} message EnumOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.allowAlias != null && Object.hasOwnProperty.call(message, "allowAlias"))
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.allowAlias);
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                    for (var i = 0; i < message.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified EnumOptions message, length delimited. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {google.protobuf.IEnumOptions} message EnumOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EnumOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.EnumOptions} EnumOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        message.allowAlias = reader.bool();
                        break;
                    case 3:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                            message.uninterpretedOption = [];
                        message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EnumOptions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.EnumOptions} EnumOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EnumOptions message.
             * @function verify
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EnumOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.allowAlias != null && message.hasOwnProperty("allowAlias"))
                    if (typeof message.allowAlias !== "boolean")
                        return "allowAlias: boolean expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                    if (!Array.isArray(message.uninterpretedOption))
                        return "uninterpretedOption: array expected";
                    for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                        if (error)
                            return "uninterpretedOption." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an EnumOptions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.EnumOptions} EnumOptions
             */
            EnumOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumOptions)
                    return object;
                var message = new $root.google.protobuf.EnumOptions();
                if (object.allowAlias != null)
                    message.allowAlias = Boolean(object.allowAlias);
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpretedOption) {
                    if (!Array.isArray(object.uninterpretedOption))
                        throw TypeError(".google.protobuf.EnumOptions.uninterpretedOption: array expected");
                    message.uninterpretedOption = [];
                    for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                        if (typeof object.uninterpretedOption[i] !== "object")
                            throw TypeError(".google.protobuf.EnumOptions.uninterpretedOption: object expected");
                        message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an EnumOptions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.EnumOptions
             * @static
             * @param {google.protobuf.EnumOptions} message EnumOptions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EnumOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpretedOption = [];
                if (options.defaults) {
                    object.allowAlias = false;
                    object.deprecated = false;
                }
                if (message.allowAlias != null && message.hasOwnProperty("allowAlias"))
                    object.allowAlias = message.allowAlias;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpretedOption && message.uninterpretedOption.length) {
                    object.uninterpretedOption = [];
                    for (var j = 0; j < message.uninterpretedOption.length; ++j)
                        object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                }
                return object;
            };

            /**
             * Converts this EnumOptions to JSON.
             * @function toJSON
             * @memberof google.protobuf.EnumOptions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EnumOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumOptions;
        })();

        protobuf.EnumValueOptions = (function() {

            /**
             * Properties of an EnumValueOptions.
             * @memberof google.protobuf
             * @interface IEnumValueOptions
             * @property {boolean|null} [deprecated] EnumValueOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumValueOptions uninterpretedOption
             */

            /**
             * Constructs a new EnumValueOptions.
             * @memberof google.protobuf
             * @classdesc Represents an EnumValueOptions.
             * @implements IEnumValueOptions
             * @constructor
             * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
             */
            function EnumValueOptions(properties) {
                this.uninterpretedOption = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * EnumValueOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.EnumValueOptions
             * @instance
             */
            EnumValueOptions.prototype.deprecated = false;

            /**
             * EnumValueOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.EnumValueOptions
             * @instance
             */
            EnumValueOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new EnumValueOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
             * @returns {google.protobuf.EnumValueOptions} EnumValueOptions instance
             */
            EnumValueOptions.create = function create(properties) {
                return new EnumValueOptions(properties);
            };

            /**
             * Encodes the specified EnumValueOptions message. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {google.protobuf.IEnumValueOptions} message EnumValueOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumValueOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(/* id 1, wireType 0 =*/8).bool(message.deprecated);
                if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                    for (var i = 0; i < message.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified EnumValueOptions message, length delimited. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {google.protobuf.IEnumValueOptions} message EnumValueOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            EnumValueOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an EnumValueOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumValueOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                            message.uninterpretedOption = [];
                        message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an EnumValueOptions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            EnumValueOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an EnumValueOptions message.
             * @function verify
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            EnumValueOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                    if (!Array.isArray(message.uninterpretedOption))
                        return "uninterpretedOption: array expected";
                    for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                        if (error)
                            return "uninterpretedOption." + error;
                    }
                }
                return null;
            };

            /**
             * Creates an EnumValueOptions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
             */
            EnumValueOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.EnumValueOptions)
                    return object;
                var message = new $root.google.protobuf.EnumValueOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpretedOption) {
                    if (!Array.isArray(object.uninterpretedOption))
                        throw TypeError(".google.protobuf.EnumValueOptions.uninterpretedOption: array expected");
                    message.uninterpretedOption = [];
                    for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                        if (typeof object.uninterpretedOption[i] !== "object")
                            throw TypeError(".google.protobuf.EnumValueOptions.uninterpretedOption: object expected");
                        message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from an EnumValueOptions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.EnumValueOptions
             * @static
             * @param {google.protobuf.EnumValueOptions} message EnumValueOptions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            EnumValueOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpretedOption = [];
                if (options.defaults)
                    object.deprecated = false;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpretedOption && message.uninterpretedOption.length) {
                    object.uninterpretedOption = [];
                    for (var j = 0; j < message.uninterpretedOption.length; ++j)
                        object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                }
                return object;
            };

            /**
             * Converts this EnumValueOptions to JSON.
             * @function toJSON
             * @memberof google.protobuf.EnumValueOptions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            EnumValueOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return EnumValueOptions;
        })();

        protobuf.ServiceOptions = (function() {

            /**
             * Properties of a ServiceOptions.
             * @memberof google.protobuf
             * @interface IServiceOptions
             * @property {boolean|null} [deprecated] ServiceOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] ServiceOptions uninterpretedOption
             */

            /**
             * Constructs a new ServiceOptions.
             * @memberof google.protobuf
             * @classdesc Represents a ServiceOptions.
             * @implements IServiceOptions
             * @constructor
             * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
             */
            function ServiceOptions(properties) {
                this.uninterpretedOption = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ServiceOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.ServiceOptions
             * @instance
             */
            ServiceOptions.prototype.deprecated = false;

            /**
             * ServiceOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.ServiceOptions
             * @instance
             */
            ServiceOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * Creates a new ServiceOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
             * @returns {google.protobuf.ServiceOptions} ServiceOptions instance
             */
            ServiceOptions.create = function create(properties) {
                return new ServiceOptions(properties);
            };

            /**
             * Encodes the specified ServiceOptions message. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {google.protobuf.IServiceOptions} message ServiceOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServiceOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(/* id 33, wireType 0 =*/264).bool(message.deprecated);
                if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                    for (var i = 0; i < message.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ServiceOptions message, length delimited. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {google.protobuf.IServiceOptions} message ServiceOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ServiceOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ServiceOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.ServiceOptions} ServiceOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServiceOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 33:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                            message.uninterpretedOption = [];
                        message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a ServiceOptions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.ServiceOptions} ServiceOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ServiceOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ServiceOptions message.
             * @function verify
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ServiceOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                    if (!Array.isArray(message.uninterpretedOption))
                        return "uninterpretedOption: array expected";
                    for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                        if (error)
                            return "uninterpretedOption." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a ServiceOptions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.ServiceOptions} ServiceOptions
             */
            ServiceOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.ServiceOptions)
                    return object;
                var message = new $root.google.protobuf.ServiceOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpretedOption) {
                    if (!Array.isArray(object.uninterpretedOption))
                        throw TypeError(".google.protobuf.ServiceOptions.uninterpretedOption: array expected");
                    message.uninterpretedOption = [];
                    for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                        if (typeof object.uninterpretedOption[i] !== "object")
                            throw TypeError(".google.protobuf.ServiceOptions.uninterpretedOption: object expected");
                        message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a ServiceOptions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.ServiceOptions
             * @static
             * @param {google.protobuf.ServiceOptions} message ServiceOptions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ServiceOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpretedOption = [];
                if (options.defaults)
                    object.deprecated = false;
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpretedOption && message.uninterpretedOption.length) {
                    object.uninterpretedOption = [];
                    for (var j = 0; j < message.uninterpretedOption.length; ++j)
                        object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                }
                return object;
            };

            /**
             * Converts this ServiceOptions to JSON.
             * @function toJSON
             * @memberof google.protobuf.ServiceOptions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ServiceOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ServiceOptions;
        })();

        protobuf.MethodOptions = (function() {

            /**
             * Properties of a MethodOptions.
             * @memberof google.protobuf
             * @interface IMethodOptions
             * @property {boolean|null} [deprecated] MethodOptions deprecated
             * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MethodOptions uninterpretedOption
             * @property {google.api.IHttpRule|null} [".google.api.http"] MethodOptions .google.api.http
             */

            /**
             * Constructs a new MethodOptions.
             * @memberof google.protobuf
             * @classdesc Represents a MethodOptions.
             * @implements IMethodOptions
             * @constructor
             * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
             */
            function MethodOptions(properties) {
                this.uninterpretedOption = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * MethodOptions deprecated.
             * @member {boolean} deprecated
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype.deprecated = false;

            /**
             * MethodOptions uninterpretedOption.
             * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype.uninterpretedOption = $util.emptyArray;

            /**
             * MethodOptions .google.api.http.
             * @member {google.api.IHttpRule|null|undefined} .google.api.http
             * @memberof google.protobuf.MethodOptions
             * @instance
             */
            MethodOptions.prototype[".google.api.http"] = null;

            /**
             * Creates a new MethodOptions instance using the specified properties.
             * @function create
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
             * @returns {google.protobuf.MethodOptions} MethodOptions instance
             */
            MethodOptions.create = function create(properties) {
                return new MethodOptions(properties);
            };

            /**
             * Encodes the specified MethodOptions message. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {google.protobuf.IMethodOptions} message MethodOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MethodOptions.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                    writer.uint32(/* id 33, wireType 0 =*/264).bool(message.deprecated);
                if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                    for (var i = 0; i < message.uninterpretedOption.length; ++i)
                        $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                if (message[".google.api.http"] != null && Object.hasOwnProperty.call(message, ".google.api.http"))
                    $root.google.api.HttpRule.encode(message[".google.api.http"], writer.uint32(/* id 72295728, wireType 2 =*/578365826).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified MethodOptions message, length delimited. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {google.protobuf.IMethodOptions} message MethodOptions message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            MethodOptions.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a MethodOptions message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.MethodOptions} MethodOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MethodOptions.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodOptions();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 33:
                        message.deprecated = reader.bool();
                        break;
                    case 999:
                        if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                            message.uninterpretedOption = [];
                        message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                        break;
                    case 72295728:
                        message[".google.api.http"] = $root.google.api.HttpRule.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a MethodOptions message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.MethodOptions} MethodOptions
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            MethodOptions.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a MethodOptions message.
             * @function verify
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            MethodOptions.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    if (typeof message.deprecated !== "boolean")
                        return "deprecated: boolean expected";
                if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                    if (!Array.isArray(message.uninterpretedOption))
                        return "uninterpretedOption: array expected";
                    for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                        if (error)
                            return "uninterpretedOption." + error;
                    }
                }
                if (message[".google.api.http"] != null && message.hasOwnProperty(".google.api.http")) {
                    var error = $root.google.api.HttpRule.verify(message[".google.api.http"]);
                    if (error)
                        return ".google.api.http." + error;
                }
                return null;
            };

            /**
             * Creates a MethodOptions message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.MethodOptions} MethodOptions
             */
            MethodOptions.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.MethodOptions)
                    return object;
                var message = new $root.google.protobuf.MethodOptions();
                if (object.deprecated != null)
                    message.deprecated = Boolean(object.deprecated);
                if (object.uninterpretedOption) {
                    if (!Array.isArray(object.uninterpretedOption))
                        throw TypeError(".google.protobuf.MethodOptions.uninterpretedOption: array expected");
                    message.uninterpretedOption = [];
                    for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                        if (typeof object.uninterpretedOption[i] !== "object")
                            throw TypeError(".google.protobuf.MethodOptions.uninterpretedOption: object expected");
                        message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                    }
                }
                if (object[".google.api.http"] != null) {
                    if (typeof object[".google.api.http"] !== "object")
                        throw TypeError(".google.protobuf.MethodOptions..google.api.http: object expected");
                    message[".google.api.http"] = $root.google.api.HttpRule.fromObject(object[".google.api.http"]);
                }
                return message;
            };

            /**
             * Creates a plain object from a MethodOptions message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.MethodOptions
             * @static
             * @param {google.protobuf.MethodOptions} message MethodOptions
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            MethodOptions.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.uninterpretedOption = [];
                if (options.defaults) {
                    object.deprecated = false;
                    object[".google.api.http"] = null;
                }
                if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                    object.deprecated = message.deprecated;
                if (message.uninterpretedOption && message.uninterpretedOption.length) {
                    object.uninterpretedOption = [];
                    for (var j = 0; j < message.uninterpretedOption.length; ++j)
                        object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                }
                if (message[".google.api.http"] != null && message.hasOwnProperty(".google.api.http"))
                    object[".google.api.http"] = $root.google.api.HttpRule.toObject(message[".google.api.http"], options);
                return object;
            };

            /**
             * Converts this MethodOptions to JSON.
             * @function toJSON
             * @memberof google.protobuf.MethodOptions
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            MethodOptions.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return MethodOptions;
        })();

        protobuf.UninterpretedOption = (function() {

            /**
             * Properties of an UninterpretedOption.
             * @memberof google.protobuf
             * @interface IUninterpretedOption
             * @property {Array.<google.protobuf.UninterpretedOption.INamePart>|null} [name] UninterpretedOption name
             * @property {string|null} [identifierValue] UninterpretedOption identifierValue
             * @property {number|Long|null} [positiveIntValue] UninterpretedOption positiveIntValue
             * @property {number|Long|null} [negativeIntValue] UninterpretedOption negativeIntValue
             * @property {number|null} [doubleValue] UninterpretedOption doubleValue
             * @property {Uint8Array|null} [stringValue] UninterpretedOption stringValue
             * @property {string|null} [aggregateValue] UninterpretedOption aggregateValue
             */

            /**
             * Constructs a new UninterpretedOption.
             * @memberof google.protobuf
             * @classdesc Represents an UninterpretedOption.
             * @implements IUninterpretedOption
             * @constructor
             * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
             */
            function UninterpretedOption(properties) {
                this.name = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * UninterpretedOption name.
             * @member {Array.<google.protobuf.UninterpretedOption.INamePart>} name
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.name = $util.emptyArray;

            /**
             * UninterpretedOption identifierValue.
             * @member {string} identifierValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.identifierValue = "";

            /**
             * UninterpretedOption positiveIntValue.
             * @member {number|Long} positiveIntValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.positiveIntValue = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            /**
             * UninterpretedOption negativeIntValue.
             * @member {number|Long} negativeIntValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.negativeIntValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * UninterpretedOption doubleValue.
             * @member {number} doubleValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.doubleValue = 0;

            /**
             * UninterpretedOption stringValue.
             * @member {Uint8Array} stringValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.stringValue = $util.newBuffer([]);

            /**
             * UninterpretedOption aggregateValue.
             * @member {string} aggregateValue
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             */
            UninterpretedOption.prototype.aggregateValue = "";

            /**
             * Creates a new UninterpretedOption instance using the specified properties.
             * @function create
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
             * @returns {google.protobuf.UninterpretedOption} UninterpretedOption instance
             */
            UninterpretedOption.create = function create(properties) {
                return new UninterpretedOption(properties);
            };

            /**
             * Encodes the specified UninterpretedOption message. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {google.protobuf.IUninterpretedOption} message UninterpretedOption message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UninterpretedOption.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.name != null && message.name.length)
                    for (var i = 0; i < message.name.length; ++i)
                        $root.google.protobuf.UninterpretedOption.NamePart.encode(message.name[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.identifierValue != null && Object.hasOwnProperty.call(message, "identifierValue"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.identifierValue);
                if (message.positiveIntValue != null && Object.hasOwnProperty.call(message, "positiveIntValue"))
                    writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.positiveIntValue);
                if (message.negativeIntValue != null && Object.hasOwnProperty.call(message, "negativeIntValue"))
                    writer.uint32(/* id 5, wireType 0 =*/40).int64(message.negativeIntValue);
                if (message.doubleValue != null && Object.hasOwnProperty.call(message, "doubleValue"))
                    writer.uint32(/* id 6, wireType 1 =*/49).double(message.doubleValue);
                if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                    writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.stringValue);
                if (message.aggregateValue != null && Object.hasOwnProperty.call(message, "aggregateValue"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.aggregateValue);
                return writer;
            };

            /**
             * Encodes the specified UninterpretedOption message, length delimited. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {google.protobuf.IUninterpretedOption} message UninterpretedOption message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            UninterpretedOption.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes an UninterpretedOption message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UninterpretedOption.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 2:
                        if (!(message.name && message.name.length))
                            message.name = [];
                        message.name.push($root.google.protobuf.UninterpretedOption.NamePart.decode(reader, reader.uint32()));
                        break;
                    case 3:
                        message.identifierValue = reader.string();
                        break;
                    case 4:
                        message.positiveIntValue = reader.uint64();
                        break;
                    case 5:
                        message.negativeIntValue = reader.int64();
                        break;
                    case 6:
                        message.doubleValue = reader.double();
                        break;
                    case 7:
                        message.stringValue = reader.bytes();
                        break;
                    case 8:
                        message.aggregateValue = reader.string();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes an UninterpretedOption message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            UninterpretedOption.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies an UninterpretedOption message.
             * @function verify
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            UninterpretedOption.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.name != null && message.hasOwnProperty("name")) {
                    if (!Array.isArray(message.name))
                        return "name: array expected";
                    for (var i = 0; i < message.name.length; ++i) {
                        var error = $root.google.protobuf.UninterpretedOption.NamePart.verify(message.name[i]);
                        if (error)
                            return "name." + error;
                    }
                }
                if (message.identifierValue != null && message.hasOwnProperty("identifierValue"))
                    if (!$util.isString(message.identifierValue))
                        return "identifierValue: string expected";
                if (message.positiveIntValue != null && message.hasOwnProperty("positiveIntValue"))
                    if (!$util.isInteger(message.positiveIntValue) && !(message.positiveIntValue && $util.isInteger(message.positiveIntValue.low) && $util.isInteger(message.positiveIntValue.high)))
                        return "positiveIntValue: integer|Long expected";
                if (message.negativeIntValue != null && message.hasOwnProperty("negativeIntValue"))
                    if (!$util.isInteger(message.negativeIntValue) && !(message.negativeIntValue && $util.isInteger(message.negativeIntValue.low) && $util.isInteger(message.negativeIntValue.high)))
                        return "negativeIntValue: integer|Long expected";
                if (message.doubleValue != null && message.hasOwnProperty("doubleValue"))
                    if (typeof message.doubleValue !== "number")
                        return "doubleValue: number expected";
                if (message.stringValue != null && message.hasOwnProperty("stringValue"))
                    if (!(message.stringValue && typeof message.stringValue.length === "number" || $util.isString(message.stringValue)))
                        return "stringValue: buffer expected";
                if (message.aggregateValue != null && message.hasOwnProperty("aggregateValue"))
                    if (!$util.isString(message.aggregateValue))
                        return "aggregateValue: string expected";
                return null;
            };

            /**
             * Creates an UninterpretedOption message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
             */
            UninterpretedOption.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.UninterpretedOption)
                    return object;
                var message = new $root.google.protobuf.UninterpretedOption();
                if (object.name) {
                    if (!Array.isArray(object.name))
                        throw TypeError(".google.protobuf.UninterpretedOption.name: array expected");
                    message.name = [];
                    for (var i = 0; i < object.name.length; ++i) {
                        if (typeof object.name[i] !== "object")
                            throw TypeError(".google.protobuf.UninterpretedOption.name: object expected");
                        message.name[i] = $root.google.protobuf.UninterpretedOption.NamePart.fromObject(object.name[i]);
                    }
                }
                if (object.identifierValue != null)
                    message.identifierValue = String(object.identifierValue);
                if (object.positiveIntValue != null)
                    if ($util.Long)
                        (message.positiveIntValue = $util.Long.fromValue(object.positiveIntValue)).unsigned = true;
                    else if (typeof object.positiveIntValue === "string")
                        message.positiveIntValue = parseInt(object.positiveIntValue, 10);
                    else if (typeof object.positiveIntValue === "number")
                        message.positiveIntValue = object.positiveIntValue;
                    else if (typeof object.positiveIntValue === "object")
                        message.positiveIntValue = new $util.LongBits(object.positiveIntValue.low >>> 0, object.positiveIntValue.high >>> 0).toNumber(true);
                if (object.negativeIntValue != null)
                    if ($util.Long)
                        (message.negativeIntValue = $util.Long.fromValue(object.negativeIntValue)).unsigned = false;
                    else if (typeof object.negativeIntValue === "string")
                        message.negativeIntValue = parseInt(object.negativeIntValue, 10);
                    else if (typeof object.negativeIntValue === "number")
                        message.negativeIntValue = object.negativeIntValue;
                    else if (typeof object.negativeIntValue === "object")
                        message.negativeIntValue = new $util.LongBits(object.negativeIntValue.low >>> 0, object.negativeIntValue.high >>> 0).toNumber();
                if (object.doubleValue != null)
                    message.doubleValue = Number(object.doubleValue);
                if (object.stringValue != null)
                    if (typeof object.stringValue === "string")
                        $util.base64.decode(object.stringValue, message.stringValue = $util.newBuffer($util.base64.length(object.stringValue)), 0);
                    else if (object.stringValue.length)
                        message.stringValue = object.stringValue;
                if (object.aggregateValue != null)
                    message.aggregateValue = String(object.aggregateValue);
                return message;
            };

            /**
             * Creates a plain object from an UninterpretedOption message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.UninterpretedOption
             * @static
             * @param {google.protobuf.UninterpretedOption} message UninterpretedOption
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            UninterpretedOption.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.name = [];
                if (options.defaults) {
                    object.identifierValue = "";
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, true);
                        object.positiveIntValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.positiveIntValue = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        var long = new $util.Long(0, 0, false);
                        object.negativeIntValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.negativeIntValue = options.longs === String ? "0" : 0;
                    object.doubleValue = 0;
                    if (options.bytes === String)
                        object.stringValue = "";
                    else {
                        object.stringValue = [];
                        if (options.bytes !== Array)
                            object.stringValue = $util.newBuffer(object.stringValue);
                    }
                    object.aggregateValue = "";
                }
                if (message.name && message.name.length) {
                    object.name = [];
                    for (var j = 0; j < message.name.length; ++j)
                        object.name[j] = $root.google.protobuf.UninterpretedOption.NamePart.toObject(message.name[j], options);
                }
                if (message.identifierValue != null && message.hasOwnProperty("identifierValue"))
                    object.identifierValue = message.identifierValue;
                if (message.positiveIntValue != null && message.hasOwnProperty("positiveIntValue"))
                    if (typeof message.positiveIntValue === "number")
                        object.positiveIntValue = options.longs === String ? String(message.positiveIntValue) : message.positiveIntValue;
                    else
                        object.positiveIntValue = options.longs === String ? $util.Long.prototype.toString.call(message.positiveIntValue) : options.longs === Number ? new $util.LongBits(message.positiveIntValue.low >>> 0, message.positiveIntValue.high >>> 0).toNumber(true) : message.positiveIntValue;
                if (message.negativeIntValue != null && message.hasOwnProperty("negativeIntValue"))
                    if (typeof message.negativeIntValue === "number")
                        object.negativeIntValue = options.longs === String ? String(message.negativeIntValue) : message.negativeIntValue;
                    else
                        object.negativeIntValue = options.longs === String ? $util.Long.prototype.toString.call(message.negativeIntValue) : options.longs === Number ? new $util.LongBits(message.negativeIntValue.low >>> 0, message.negativeIntValue.high >>> 0).toNumber() : message.negativeIntValue;
                if (message.doubleValue != null && message.hasOwnProperty("doubleValue"))
                    object.doubleValue = options.json && !isFinite(message.doubleValue) ? String(message.doubleValue) : message.doubleValue;
                if (message.stringValue != null && message.hasOwnProperty("stringValue"))
                    object.stringValue = options.bytes === String ? $util.base64.encode(message.stringValue, 0, message.stringValue.length) : options.bytes === Array ? Array.prototype.slice.call(message.stringValue) : message.stringValue;
                if (message.aggregateValue != null && message.hasOwnProperty("aggregateValue"))
                    object.aggregateValue = message.aggregateValue;
                return object;
            };

            /**
             * Converts this UninterpretedOption to JSON.
             * @function toJSON
             * @memberof google.protobuf.UninterpretedOption
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            UninterpretedOption.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            UninterpretedOption.NamePart = (function() {

                /**
                 * Properties of a NamePart.
                 * @memberof google.protobuf.UninterpretedOption
                 * @interface INamePart
                 * @property {string} namePart NamePart namePart
                 * @property {boolean} isExtension NamePart isExtension
                 */

                /**
                 * Constructs a new NamePart.
                 * @memberof google.protobuf.UninterpretedOption
                 * @classdesc Represents a NamePart.
                 * @implements INamePart
                 * @constructor
                 * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
                 */
                function NamePart(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * NamePart namePart.
                 * @member {string} namePart
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @instance
                 */
                NamePart.prototype.namePart = "";

                /**
                 * NamePart isExtension.
                 * @member {boolean} isExtension
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @instance
                 */
                NamePart.prototype.isExtension = false;

                /**
                 * Creates a new NamePart instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
                 * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart instance
                 */
                NamePart.create = function create(properties) {
                    return new NamePart(properties);
                };

                /**
                 * Encodes the specified NamePart message. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {google.protobuf.UninterpretedOption.INamePart} message NamePart message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NamePart.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.namePart);
                    writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isExtension);
                    return writer;
                };

                /**
                 * Encodes the specified NamePart message, length delimited. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {google.protobuf.UninterpretedOption.INamePart} message NamePart message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NamePart.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a NamePart message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NamePart.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption.NamePart();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.namePart = reader.string();
                            break;
                        case 2:
                            message.isExtension = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    if (!message.hasOwnProperty("namePart"))
                        throw $util.ProtocolError("missing required 'namePart'", { instance: message });
                    if (!message.hasOwnProperty("isExtension"))
                        throw $util.ProtocolError("missing required 'isExtension'", { instance: message });
                    return message;
                };

                /**
                 * Decodes a NamePart message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NamePart.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a NamePart message.
                 * @function verify
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NamePart.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (!$util.isString(message.namePart))
                        return "namePart: string expected";
                    if (typeof message.isExtension !== "boolean")
                        return "isExtension: boolean expected";
                    return null;
                };

                /**
                 * Creates a NamePart message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                 */
                NamePart.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.UninterpretedOption.NamePart)
                        return object;
                    var message = new $root.google.protobuf.UninterpretedOption.NamePart();
                    if (object.namePart != null)
                        message.namePart = String(object.namePart);
                    if (object.isExtension != null)
                        message.isExtension = Boolean(object.isExtension);
                    return message;
                };

                /**
                 * Creates a plain object from a NamePart message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @static
                 * @param {google.protobuf.UninterpretedOption.NamePart} message NamePart
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NamePart.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.namePart = "";
                        object.isExtension = false;
                    }
                    if (message.namePart != null && message.hasOwnProperty("namePart"))
                        object.namePart = message.namePart;
                    if (message.isExtension != null && message.hasOwnProperty("isExtension"))
                        object.isExtension = message.isExtension;
                    return object;
                };

                /**
                 * Converts this NamePart to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.UninterpretedOption.NamePart
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NamePart.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return NamePart;
            })();

            return UninterpretedOption;
        })();

        protobuf.SourceCodeInfo = (function() {

            /**
             * Properties of a SourceCodeInfo.
             * @memberof google.protobuf
             * @interface ISourceCodeInfo
             * @property {Array.<google.protobuf.SourceCodeInfo.ILocation>|null} [location] SourceCodeInfo location
             */

            /**
             * Constructs a new SourceCodeInfo.
             * @memberof google.protobuf
             * @classdesc Represents a SourceCodeInfo.
             * @implements ISourceCodeInfo
             * @constructor
             * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
             */
            function SourceCodeInfo(properties) {
                this.location = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * SourceCodeInfo location.
             * @member {Array.<google.protobuf.SourceCodeInfo.ILocation>} location
             * @memberof google.protobuf.SourceCodeInfo
             * @instance
             */
            SourceCodeInfo.prototype.location = $util.emptyArray;

            /**
             * Creates a new SourceCodeInfo instance using the specified properties.
             * @function create
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
             * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo instance
             */
            SourceCodeInfo.create = function create(properties) {
                return new SourceCodeInfo(properties);
            };

            /**
             * Encodes the specified SourceCodeInfo message. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {google.protobuf.ISourceCodeInfo} message SourceCodeInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SourceCodeInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.location != null && message.location.length)
                    for (var i = 0; i < message.location.length; ++i)
                        $root.google.protobuf.SourceCodeInfo.Location.encode(message.location[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified SourceCodeInfo message, length delimited. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {google.protobuf.ISourceCodeInfo} message SourceCodeInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            SourceCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a SourceCodeInfo message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SourceCodeInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.location && message.location.length))
                            message.location = [];
                        message.location.push($root.google.protobuf.SourceCodeInfo.Location.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a SourceCodeInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            SourceCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a SourceCodeInfo message.
             * @function verify
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            SourceCodeInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.location != null && message.hasOwnProperty("location")) {
                    if (!Array.isArray(message.location))
                        return "location: array expected";
                    for (var i = 0; i < message.location.length; ++i) {
                        var error = $root.google.protobuf.SourceCodeInfo.Location.verify(message.location[i]);
                        if (error)
                            return "location." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a SourceCodeInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
             */
            SourceCodeInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.SourceCodeInfo)
                    return object;
                var message = new $root.google.protobuf.SourceCodeInfo();
                if (object.location) {
                    if (!Array.isArray(object.location))
                        throw TypeError(".google.protobuf.SourceCodeInfo.location: array expected");
                    message.location = [];
                    for (var i = 0; i < object.location.length; ++i) {
                        if (typeof object.location[i] !== "object")
                            throw TypeError(".google.protobuf.SourceCodeInfo.location: object expected");
                        message.location[i] = $root.google.protobuf.SourceCodeInfo.Location.fromObject(object.location[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a SourceCodeInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.SourceCodeInfo
             * @static
             * @param {google.protobuf.SourceCodeInfo} message SourceCodeInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            SourceCodeInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.location = [];
                if (message.location && message.location.length) {
                    object.location = [];
                    for (var j = 0; j < message.location.length; ++j)
                        object.location[j] = $root.google.protobuf.SourceCodeInfo.Location.toObject(message.location[j], options);
                }
                return object;
            };

            /**
             * Converts this SourceCodeInfo to JSON.
             * @function toJSON
             * @memberof google.protobuf.SourceCodeInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            SourceCodeInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            SourceCodeInfo.Location = (function() {

                /**
                 * Properties of a Location.
                 * @memberof google.protobuf.SourceCodeInfo
                 * @interface ILocation
                 * @property {Array.<number>|null} [path] Location path
                 * @property {Array.<number>|null} [span] Location span
                 * @property {string|null} [leadingComments] Location leadingComments
                 * @property {string|null} [trailingComments] Location trailingComments
                 * @property {Array.<string>|null} [leadingDetachedComments] Location leadingDetachedComments
                 */

                /**
                 * Constructs a new Location.
                 * @memberof google.protobuf.SourceCodeInfo
                 * @classdesc Represents a Location.
                 * @implements ILocation
                 * @constructor
                 * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
                 */
                function Location(properties) {
                    this.path = [];
                    this.span = [];
                    this.leadingDetachedComments = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Location path.
                 * @member {Array.<number>} path
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.path = $util.emptyArray;

                /**
                 * Location span.
                 * @member {Array.<number>} span
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.span = $util.emptyArray;

                /**
                 * Location leadingComments.
                 * @member {string} leadingComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.leadingComments = "";

                /**
                 * Location trailingComments.
                 * @member {string} trailingComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.trailingComments = "";

                /**
                 * Location leadingDetachedComments.
                 * @member {Array.<string>} leadingDetachedComments
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 */
                Location.prototype.leadingDetachedComments = $util.emptyArray;

                /**
                 * Creates a new Location instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
                 * @returns {google.protobuf.SourceCodeInfo.Location} Location instance
                 */
                Location.create = function create(properties) {
                    return new Location(properties);
                };

                /**
                 * Encodes the specified Location message. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {google.protobuf.SourceCodeInfo.ILocation} message Location message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Location.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && message.path.length) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork();
                        for (var i = 0; i < message.path.length; ++i)
                            writer.int32(message.path[i]);
                        writer.ldelim();
                    }
                    if (message.span != null && message.span.length) {
                        writer.uint32(/* id 2, wireType 2 =*/18).fork();
                        for (var i = 0; i < message.span.length; ++i)
                            writer.int32(message.span[i]);
                        writer.ldelim();
                    }
                    if (message.leadingComments != null && Object.hasOwnProperty.call(message, "leadingComments"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.leadingComments);
                    if (message.trailingComments != null && Object.hasOwnProperty.call(message, "trailingComments"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.trailingComments);
                    if (message.leadingDetachedComments != null && message.leadingDetachedComments.length)
                        for (var i = 0; i < message.leadingDetachedComments.length; ++i)
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.leadingDetachedComments[i]);
                    return writer;
                };

                /**
                 * Encodes the specified Location message, length delimited. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {google.protobuf.SourceCodeInfo.ILocation} message Location message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Location.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes a Location message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.SourceCodeInfo.Location} Location
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Location.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo.Location();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.path && message.path.length))
                                message.path = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.path.push(reader.int32());
                            } else
                                message.path.push(reader.int32());
                            break;
                        case 2:
                            if (!(message.span && message.span.length))
                                message.span = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.span.push(reader.int32());
                            } else
                                message.span.push(reader.int32());
                            break;
                        case 3:
                            message.leadingComments = reader.string();
                            break;
                        case 4:
                            message.trailingComments = reader.string();
                            break;
                        case 6:
                            if (!(message.leadingDetachedComments && message.leadingDetachedComments.length))
                                message.leadingDetachedComments = [];
                            message.leadingDetachedComments.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes a Location message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.SourceCodeInfo.Location} Location
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Location.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies a Location message.
                 * @function verify
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Location.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path")) {
                        if (!Array.isArray(message.path))
                            return "path: array expected";
                        for (var i = 0; i < message.path.length; ++i)
                            if (!$util.isInteger(message.path[i]))
                                return "path: integer[] expected";
                    }
                    if (message.span != null && message.hasOwnProperty("span")) {
                        if (!Array.isArray(message.span))
                            return "span: array expected";
                        for (var i = 0; i < message.span.length; ++i)
                            if (!$util.isInteger(message.span[i]))
                                return "span: integer[] expected";
                    }
                    if (message.leadingComments != null && message.hasOwnProperty("leadingComments"))
                        if (!$util.isString(message.leadingComments))
                            return "leadingComments: string expected";
                    if (message.trailingComments != null && message.hasOwnProperty("trailingComments"))
                        if (!$util.isString(message.trailingComments))
                            return "trailingComments: string expected";
                    if (message.leadingDetachedComments != null && message.hasOwnProperty("leadingDetachedComments")) {
                        if (!Array.isArray(message.leadingDetachedComments))
                            return "leadingDetachedComments: array expected";
                        for (var i = 0; i < message.leadingDetachedComments.length; ++i)
                            if (!$util.isString(message.leadingDetachedComments[i]))
                                return "leadingDetachedComments: string[] expected";
                    }
                    return null;
                };

                /**
                 * Creates a Location message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.SourceCodeInfo.Location} Location
                 */
                Location.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.SourceCodeInfo.Location)
                        return object;
                    var message = new $root.google.protobuf.SourceCodeInfo.Location();
                    if (object.path) {
                        if (!Array.isArray(object.path))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.path: array expected");
                        message.path = [];
                        for (var i = 0; i < object.path.length; ++i)
                            message.path[i] = object.path[i] | 0;
                    }
                    if (object.span) {
                        if (!Array.isArray(object.span))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.span: array expected");
                        message.span = [];
                        for (var i = 0; i < object.span.length; ++i)
                            message.span[i] = object.span[i] | 0;
                    }
                    if (object.leadingComments != null)
                        message.leadingComments = String(object.leadingComments);
                    if (object.trailingComments != null)
                        message.trailingComments = String(object.trailingComments);
                    if (object.leadingDetachedComments) {
                        if (!Array.isArray(object.leadingDetachedComments))
                            throw TypeError(".google.protobuf.SourceCodeInfo.Location.leadingDetachedComments: array expected");
                        message.leadingDetachedComments = [];
                        for (var i = 0; i < object.leadingDetachedComments.length; ++i)
                            message.leadingDetachedComments[i] = String(object.leadingDetachedComments[i]);
                    }
                    return message;
                };

                /**
                 * Creates a plain object from a Location message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @static
                 * @param {google.protobuf.SourceCodeInfo.Location} message Location
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Location.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.path = [];
                        object.span = [];
                        object.leadingDetachedComments = [];
                    }
                    if (options.defaults) {
                        object.leadingComments = "";
                        object.trailingComments = "";
                    }
                    if (message.path && message.path.length) {
                        object.path = [];
                        for (var j = 0; j < message.path.length; ++j)
                            object.path[j] = message.path[j];
                    }
                    if (message.span && message.span.length) {
                        object.span = [];
                        for (var j = 0; j < message.span.length; ++j)
                            object.span[j] = message.span[j];
                    }
                    if (message.leadingComments != null && message.hasOwnProperty("leadingComments"))
                        object.leadingComments = message.leadingComments;
                    if (message.trailingComments != null && message.hasOwnProperty("trailingComments"))
                        object.trailingComments = message.trailingComments;
                    if (message.leadingDetachedComments && message.leadingDetachedComments.length) {
                        object.leadingDetachedComments = [];
                        for (var j = 0; j < message.leadingDetachedComments.length; ++j)
                            object.leadingDetachedComments[j] = message.leadingDetachedComments[j];
                    }
                    return object;
                };

                /**
                 * Converts this Location to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.SourceCodeInfo.Location
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Location.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Location;
            })();

            return SourceCodeInfo;
        })();

        protobuf.GeneratedCodeInfo = (function() {

            /**
             * Properties of a GeneratedCodeInfo.
             * @memberof google.protobuf
             * @interface IGeneratedCodeInfo
             * @property {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>|null} [annotation] GeneratedCodeInfo annotation
             */

            /**
             * Constructs a new GeneratedCodeInfo.
             * @memberof google.protobuf
             * @classdesc Represents a GeneratedCodeInfo.
             * @implements IGeneratedCodeInfo
             * @constructor
             * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
             */
            function GeneratedCodeInfo(properties) {
                this.annotation = [];
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * GeneratedCodeInfo annotation.
             * @member {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>} annotation
             * @memberof google.protobuf.GeneratedCodeInfo
             * @instance
             */
            GeneratedCodeInfo.prototype.annotation = $util.emptyArray;

            /**
             * Creates a new GeneratedCodeInfo instance using the specified properties.
             * @function create
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
             * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo instance
             */
            GeneratedCodeInfo.create = function create(properties) {
                return new GeneratedCodeInfo(properties);
            };

            /**
             * Encodes the specified GeneratedCodeInfo message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
             * @function encode
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {google.protobuf.IGeneratedCodeInfo} message GeneratedCodeInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeneratedCodeInfo.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.annotation != null && message.annotation.length)
                    for (var i = 0; i < message.annotation.length; ++i)
                        $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(message.annotation[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified GeneratedCodeInfo message, length delimited. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
             * @function encodeDelimited
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {google.protobuf.IGeneratedCodeInfo} message GeneratedCodeInfo message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            GeneratedCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a GeneratedCodeInfo message from the specified reader or buffer.
             * @function decode
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeneratedCodeInfo.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        if (!(message.annotation && message.annotation.length))
                            message.annotation = [];
                        message.annotation.push($root.google.protobuf.GeneratedCodeInfo.Annotation.decode(reader, reader.uint32()));
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a GeneratedCodeInfo message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            GeneratedCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a GeneratedCodeInfo message.
             * @function verify
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            GeneratedCodeInfo.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.annotation != null && message.hasOwnProperty("annotation")) {
                    if (!Array.isArray(message.annotation))
                        return "annotation: array expected";
                    for (var i = 0; i < message.annotation.length; ++i) {
                        var error = $root.google.protobuf.GeneratedCodeInfo.Annotation.verify(message.annotation[i]);
                        if (error)
                            return "annotation." + error;
                    }
                }
                return null;
            };

            /**
             * Creates a GeneratedCodeInfo message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
             */
            GeneratedCodeInfo.fromObject = function fromObject(object) {
                if (object instanceof $root.google.protobuf.GeneratedCodeInfo)
                    return object;
                var message = new $root.google.protobuf.GeneratedCodeInfo();
                if (object.annotation) {
                    if (!Array.isArray(object.annotation))
                        throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: array expected");
                    message.annotation = [];
                    for (var i = 0; i < object.annotation.length; ++i) {
                        if (typeof object.annotation[i] !== "object")
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: object expected");
                        message.annotation[i] = $root.google.protobuf.GeneratedCodeInfo.Annotation.fromObject(object.annotation[i]);
                    }
                }
                return message;
            };

            /**
             * Creates a plain object from a GeneratedCodeInfo message. Also converts values to other types if specified.
             * @function toObject
             * @memberof google.protobuf.GeneratedCodeInfo
             * @static
             * @param {google.protobuf.GeneratedCodeInfo} message GeneratedCodeInfo
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            GeneratedCodeInfo.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.arrays || options.defaults)
                    object.annotation = [];
                if (message.annotation && message.annotation.length) {
                    object.annotation = [];
                    for (var j = 0; j < message.annotation.length; ++j)
                        object.annotation[j] = $root.google.protobuf.GeneratedCodeInfo.Annotation.toObject(message.annotation[j], options);
                }
                return object;
            };

            /**
             * Converts this GeneratedCodeInfo to JSON.
             * @function toJSON
             * @memberof google.protobuf.GeneratedCodeInfo
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            GeneratedCodeInfo.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            GeneratedCodeInfo.Annotation = (function() {

                /**
                 * Properties of an Annotation.
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @interface IAnnotation
                 * @property {Array.<number>|null} [path] Annotation path
                 * @property {string|null} [sourceFile] Annotation sourceFile
                 * @property {number|null} [begin] Annotation begin
                 * @property {number|null} [end] Annotation end
                 */

                /**
                 * Constructs a new Annotation.
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @classdesc Represents an Annotation.
                 * @implements IAnnotation
                 * @constructor
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
                 */
                function Annotation(properties) {
                    this.path = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }

                /**
                 * Annotation path.
                 * @member {Array.<number>} path
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.path = $util.emptyArray;

                /**
                 * Annotation sourceFile.
                 * @member {string} sourceFile
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.sourceFile = "";

                /**
                 * Annotation begin.
                 * @member {number} begin
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.begin = 0;

                /**
                 * Annotation end.
                 * @member {number} end
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 */
                Annotation.prototype.end = 0;

                /**
                 * Creates a new Annotation instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
                 * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation instance
                 */
                Annotation.create = function create(properties) {
                    return new Annotation(properties);
                };

                /**
                 * Encodes the specified Annotation message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} message Annotation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Annotation.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.path != null && message.path.length) {
                        writer.uint32(/* id 1, wireType 2 =*/10).fork();
                        for (var i = 0; i < message.path.length; ++i)
                            writer.int32(message.path[i]);
                        writer.ldelim();
                    }
                    if (message.sourceFile != null && Object.hasOwnProperty.call(message, "sourceFile"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceFile);
                    if (message.begin != null && Object.hasOwnProperty.call(message, "begin"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.begin);
                    if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.end);
                    return writer;
                };

                /**
                 * Encodes the specified Annotation message, length delimited. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} message Annotation message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Annotation.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };

                /**
                 * Decodes an Annotation message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Annotation.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.path && message.path.length))
                                message.path = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.path.push(reader.int32());
                            } else
                                message.path.push(reader.int32());
                            break;
                        case 2:
                            message.sourceFile = reader.string();
                            break;
                        case 3:
                            message.begin = reader.int32();
                            break;
                        case 4:
                            message.end = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };

                /**
                 * Decodes an Annotation message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Annotation.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };

                /**
                 * Verifies an Annotation message.
                 * @function verify
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Annotation.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.path != null && message.hasOwnProperty("path")) {
                        if (!Array.isArray(message.path))
                            return "path: array expected";
                        for (var i = 0; i < message.path.length; ++i)
                            if (!$util.isInteger(message.path[i]))
                                return "path: integer[] expected";
                    }
                    if (message.sourceFile != null && message.hasOwnProperty("sourceFile"))
                        if (!$util.isString(message.sourceFile))
                            return "sourceFile: string expected";
                    if (message.begin != null && message.hasOwnProperty("begin"))
                        if (!$util.isInteger(message.begin))
                            return "begin: integer expected";
                    if (message.end != null && message.hasOwnProperty("end"))
                        if (!$util.isInteger(message.end))
                            return "end: integer expected";
                    return null;
                };

                /**
                 * Creates an Annotation message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                 */
                Annotation.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.GeneratedCodeInfo.Annotation)
                        return object;
                    var message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                    if (object.path) {
                        if (!Array.isArray(object.path))
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.Annotation.path: array expected");
                        message.path = [];
                        for (var i = 0; i < object.path.length; ++i)
                            message.path[i] = object.path[i] | 0;
                    }
                    if (object.sourceFile != null)
                        message.sourceFile = String(object.sourceFile);
                    if (object.begin != null)
                        message.begin = object.begin | 0;
                    if (object.end != null)
                        message.end = object.end | 0;
                    return message;
                };

                /**
                 * Creates a plain object from an Annotation message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo.Annotation} message Annotation
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Annotation.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.path = [];
                    if (options.defaults) {
                        object.sourceFile = "";
                        object.begin = 0;
                        object.end = 0;
                    }
                    if (message.path && message.path.length) {
                        object.path = [];
                        for (var j = 0; j < message.path.length; ++j)
                            object.path[j] = message.path[j];
                    }
                    if (message.sourceFile != null && message.hasOwnProperty("sourceFile"))
                        object.sourceFile = message.sourceFile;
                    if (message.begin != null && message.hasOwnProperty("begin"))
                        object.begin = message.begin;
                    if (message.end != null && message.hasOwnProperty("end"))
                        object.end = message.end;
                    return object;
                };

                /**
                 * Converts this Annotation to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Annotation.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Annotation;
            })();

            return GeneratedCodeInfo;
        })();

        return protobuf;
    })();

    return google;
})();

module.exports = $root;
